const LocationDataProvider = {
    GetData: function() {
        return [
  {
    postalCode: 200,
    city: "Australian National University",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2777,
    longitude: 149.1189,
    accuracy: 1
  },
  {
    postalCode: 221,
    city: "Barton",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3049,
    longitude: 149.1412,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Wreck Bay",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.1627,
    longitude: 150.6907,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Hmas Creswell",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.028,
    longitude: 150.5501,
    accuracy: 3
  },
  {
    postalCode: 2540,
    city: "Jervis Bay",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.1333,
    longitude: 150.7,
    accuracy: 4
  },
  {
    postalCode: 2600,
    city: "Deakin West",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3126,
    longitude: 149.1278,
    accuracy: 3
  },
  {
    postalCode: 2600,
    city: "Duntroon",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3,
    longitude: 149.1667,
    accuracy: 4
  },
  {
    postalCode: 2600,
    city: "Parliament House",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3126,
    longitude: 149.1278,
    accuracy: 3
  },
  {
    postalCode: 2600,
    city: "Yarralumla",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2998,
    longitude: 149.1058,
    accuracy: 4
  },
  {
    postalCode: 2600,
    city: "Russell",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2977,
    longitude: 149.151,
    accuracy: 4
  },
  {
    postalCode: 2600,
    city: "Barton",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3049,
    longitude: 149.1412,
    accuracy: 4
  },
  {
    postalCode: 2600,
    city: "Deakin",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3193,
    longitude: 149.1031,
    accuracy: 4
  },
  {
    postalCode: 2600,
    city: "Capital Hill",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3066,
    longitude: 149.1246,
    accuracy: 4
  },
  {
    postalCode: 2600,
    city: "Parkes",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3018,
    longitude: 149.1304,
    accuracy: 4
  },
  {
    postalCode: 2600,
    city: "Harman",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.35,
    longitude: 149.2,
    accuracy: 4
  },
  {
    postalCode: 2600,
    city: "Hmas Harman",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.31,
    longitude: 149.1385,
    accuracy: 3
  },
  {
    postalCode: 2600,
    city: "Canberra",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2835,
    longitude: 149.1281,
    accuracy: 4
  },
  {
    postalCode: 2601,
    city: "City",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2813,
    longitude: 149.1293,
    accuracy: 4
  },
  {
    postalCode: 2601,
    city: "Canberra",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2835,
    longitude: 149.1281,
    accuracy: 4
  },
  {
    postalCode: 2601,
    city: "Acton",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2777,
    longitude: 149.1183,
    accuracy: 4
  },
  {
    postalCode: 2601,
    city: "Black Mountain",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2772,
    longitude: 149.1054,
    accuracy: 3
  },
  {
    postalCode: 2602,
    city: "Downer",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2446,
    longitude: 149.1447,
    accuracy: 4
  },
  {
    postalCode: 2602,
    city: "Hackett",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2495,
    longitude: 149.1635,
    accuracy: 4
  },
  {
    postalCode: 2602,
    city: "Watson",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2381,
    longitude: 149.1527,
    accuracy: 4
  },
  {
    postalCode: 2602,
    city: "Lyneham",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2398,
    longitude: 149.1307,
    accuracy: 4
  },
  {
    postalCode: 2602,
    city: "O'Connor",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2564,
    longitude: 149.1125,
    accuracy: 4
  },
  {
    postalCode: 2602,
    city: "Ainslie",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2625,
    longitude: 149.1437,
    accuracy: 4
  },
  {
    postalCode: 2602,
    city: "Dickson",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2508,
    longitude: 149.1393,
    accuracy: 4
  },
  {
    postalCode: 2603,
    city: "Red Hill",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3262,
    longitude: 149.1191,
    accuracy: 4
  },
  {
    postalCode: 2603,
    city: "Manuka",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3126,
    longitude: 149.1278,
    accuracy: 3
  },
  {
    postalCode: 2603,
    city: "Griffith",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3253,
    longitude: 149.1371,
    accuracy: 4
  },
  {
    postalCode: 2603,
    city: "Forrest",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.315,
    longitude: 149.1286,
    accuracy: 4
  },
  {
    postalCode: 2604,
    city: "Narrabundah",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3357,
    longitude: 149.1492,
    accuracy: 4
  },
  {
    postalCode: 2604,
    city: "Causeway",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3151,
    longitude: 149.1512,
    accuracy: 4
  },
  {
    postalCode: 2604,
    city: "Kingston",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3152,
    longitude: 149.1466,
    accuracy: 4
  },
  {
    postalCode: 2605,
    city: "Hughes",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3327,
    longitude: 149.0949,
    accuracy: 4
  },
  {
    postalCode: 2605,
    city: "Garran",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3421,
    longitude: 149.1085,
    accuracy: 4
  },
  {
    postalCode: 2605,
    city: "Curtin",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3246,
    longitude: 149.0776,
    accuracy: 4
  },
  {
    postalCode: 2606,
    city: "O'Malley",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3525,
    longitude: 149.1128,
    accuracy: 4
  },
  {
    postalCode: 2606,
    city: "Lyons",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3406,
    longitude: 149.074,
    accuracy: 4
  },
  {
    postalCode: 2606,
    city: "Chifley",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3534,
    longitude: 149.0768,
    accuracy: 4
  },
  {
    postalCode: 2606,
    city: "Woden",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3481,
    longitude: 149.0905,
    accuracy: 3
  },
  {
    postalCode: 2606,
    city: "Phillip",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3503,
    longitude: 149.0915,
    accuracy: 4
  },
  {
    postalCode: 2606,
    city: "Swinger Hill",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3481,
    longitude: 149.0905,
    accuracy: 3
  },
  {
    postalCode: 2607,
    city: "Isaacs",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3686,
    longitude: 149.1156,
    accuracy: 4
  },
  {
    postalCode: 2607,
    city: "Torrens",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.372,
    longitude: 149.0877,
    accuracy: 4
  },
  {
    postalCode: 2607,
    city: "Mawson",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3634,
    longitude: 149.0986,
    accuracy: 4
  },
  {
    postalCode: 2607,
    city: "Farrer",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3767,
    longitude: 149.105,
    accuracy: 4
  },
  {
    postalCode: 2607,
    city: "Pearce",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3622,
    longitude: 149.0834,
    accuracy: 4
  },
  {
    postalCode: 2608,
    city: "Civic Square",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.31,
    longitude: 149.1933,
    accuracy: 1
  },
  {
    postalCode: 2609,
    city: "Pialligo",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3201,
    longitude: 149.207,
    accuracy: 4
  },
  {
    postalCode: 2609,
    city: "Canberra Airport",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3172,
    longitude: 149.1753,
    accuracy: 3
  },
  {
    postalCode: 2609,
    city: "Fyshwick",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3333,
    longitude: 149.1667,
    accuracy: 4
  },
  {
    postalCode: 2609,
    city: "Symonston",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3516,
    longitude: 149.1592,
    accuracy: 4
  },
  {
    postalCode: 2609,
    city: "Majura",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2667,
    longitude: 149.2,
    accuracy: 4
  },
  {
    postalCode: 2610,
    city: "Canberra Bc",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2778,
    longitude: 149.0111,
    accuracy: 1
  },
  {
    postalCode: 2610,
    city: "Canberra Mc",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2498,
    longitude: 149.0591,
    accuracy: 1
  },
  {
    postalCode: 2611,
    city: "Stirling",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3497,
    longitude: 149.0493,
    accuracy: 4
  },
  {
    postalCode: 2611,
    city: "Wright",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3224,
    longitude: 149.0346,
    accuracy: 4
  },
  {
    postalCode: 2611,
    city: "Coree",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2794,
    longitude: 148.9194,
    accuracy: 4
  },
  {
    postalCode: 2611,
    city: "Uriarra Village",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3503,
    longitude: 149.0155,
    accuracy: 3
  },
  {
    postalCode: 2611,
    city: "Holder",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3344,
    longitude: 149.0461,
    accuracy: 4
  },
  {
    postalCode: 2611,
    city: "Stromlo",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3255,
    longitude: 148.9993,
    accuracy: 4
  },
  {
    postalCode: 2611,
    city: "Waramanga",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.353,
    longitude: 149.0621,
    accuracy: 4
  },
  {
    postalCode: 2611,
    city: "Chapman",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3562,
    longitude: 149.0374,
    accuracy: 4
  },
  {
    postalCode: 2611,
    city: "Weston Creek",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3333,
    longitude: 149.05,
    accuracy: 4
  },
  {
    postalCode: 2611,
    city: "Mount Stromlo",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.4171,
    longitude: 148.7769,
    accuracy: 3
  },
  {
    postalCode: 2611,
    city: "Weston",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3358,
    longitude: 149.0593,
    accuracy: 4
  },
  {
    postalCode: 2611,
    city: "Coombs",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3163,
    longitude: 149.0394,
    accuracy: 4
  },
  {
    postalCode: 2611,
    city: "Uriarra",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.4171,
    longitude: 148.7769,
    accuracy: 3
  },
  {
    postalCode: 2611,
    city: "Duffy",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3346,
    longitude: 149.0319,
    accuracy: 4
  },
  {
    postalCode: 2611,
    city: "Fisher",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3613,
    longitude: 149.057,
    accuracy: 4
  },
  {
    postalCode: 2611,
    city: "Rivett",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3471,
    longitude: 149.0379,
    accuracy: 4
  },
  {
    postalCode: 2612,
    city: "Campbell",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2891,
    longitude: 149.1538,
    accuracy: 4
  },
  {
    postalCode: 2612,
    city: "Turner",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2688,
    longitude: 149.1247,
    accuracy: 4
  },
  {
    postalCode: 2612,
    city: "Reid",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2858,
    longitude: 149.1391,
    accuracy: 4
  },
  {
    postalCode: 2612,
    city: "Braddon",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2708,
    longitude: 149.1357,
    accuracy: 4
  },
  {
    postalCode: 2614,
    city: "Cook",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2601,
    longitude: 149.0657,
    accuracy: 4
  },
  {
    postalCode: 2614,
    city: "Aranda",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2582,
    longitude: 149.0804,
    accuracy: 4
  },
  {
    postalCode: 2614,
    city: "Page",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2386,
    longitude: 149.0499,
    accuracy: 4
  },
  {
    postalCode: 2614,
    city: "Hawker",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2471,
    longitude: 149.0367,
    accuracy: 4
  },
  {
    postalCode: 2614,
    city: "Scullin",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2346,
    longitude: 149.039,
    accuracy: 4
  },
  {
    postalCode: 2614,
    city: "Jamison Centre",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2498,
    longitude: 149.0591,
    accuracy: 3
  },
  {
    postalCode: 2614,
    city: "Weetangera",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2498,
    longitude: 149.0591,
    accuracy: 3
  },
  {
    postalCode: 2614,
    city: "Macquarie",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2513,
    longitude: 149.0636,
    accuracy: 4
  },
  {
    postalCode: 2615,
    city: "Fraser",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.1917,
    longitude: 149.0453,
    accuracy: 4
  },
  {
    postalCode: 2615,
    city: "Spence",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.1987,
    longitude: 149.0644,
    accuracy: 4
  },
  {
    postalCode: 2615,
    city: "Florey",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2259,
    longitude: 149.05,
    accuracy: 4
  },
  {
    postalCode: 2615,
    city: "Holt",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2244,
    longitude: 149.0119,
    accuracy: 4
  },
  {
    postalCode: 2615,
    city: "Charnwood",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2002,
    longitude: 149.0341,
    accuracy: 4
  },
  {
    postalCode: 2615,
    city: "Higgins",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2324,
    longitude: 149.0272,
    accuracy: 4
  },
  {
    postalCode: 2615,
    city: "Dunlop",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.194,
    longitude: 149.0198,
    accuracy: 4
  },
  {
    postalCode: 2615,
    city: "Kippax",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2101,
    longitude: 149.034,
    accuracy: 3
  },
  {
    postalCode: 2615,
    city: "Melba",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2102,
    longitude: 149.0541,
    accuracy: 4
  },
  {
    postalCode: 2615,
    city: "Flynn",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2059,
    longitude: 149.0439,
    accuracy: 4
  },
  {
    postalCode: 2615,
    city: "Latham",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2165,
    longitude: 149.0314,
    accuracy: 4
  },
  {
    postalCode: 2615,
    city: "Macgregor",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2098,
    longitude: 149.011,
    accuracy: 4
  },
  {
    postalCode: 2615,
    city: "Kippax Centre",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2101,
    longitude: 149.034,
    accuracy: 3
  },
  {
    postalCode: 2616,
    city: "Belconnen",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2167,
    longitude: 149.0833,
    accuracy: 4
  },
  {
    postalCode: 2617,
    city: "Mckellar",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2175,
    longitude: 149.077,
    accuracy: 4
  },
  {
    postalCode: 2617,
    city: "Belconnen",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2167,
    longitude: 149.0833,
    accuracy: 4
  },
  {
    postalCode: 2617,
    city: "Evatt",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2119,
    longitude: 149.0689,
    accuracy: 4
  },
  {
    postalCode: 2617,
    city: "Lawson",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2241,
    longitude: 149.0998,
    accuracy: 4
  },
  {
    postalCode: 2617,
    city: "Giralang",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2109,
    longitude: 149.096,
    accuracy: 4
  },
  {
    postalCode: 2617,
    city: "University Of Canberra",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2498,
    longitude: 149.0591,
    accuracy: 3
  },
  {
    postalCode: 2617,
    city: "Belconnen DC",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2199,
    longitude: 149.0869,
    accuracy: 3
  },
  {
    postalCode: 2617,
    city: "Kaleen",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2181,
    longitude: 149.1052,
    accuracy: 4
  },
  {
    postalCode: 2617,
    city: "Bruce",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2441,
    longitude: 149.0908,
    accuracy: 4
  },
  {
    postalCode: 2618,
    city: "Hall",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.1685,
    longitude: 149.0683,
    accuracy: 4
  },
  {
    postalCode: 2620,
    city: "Hume",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3855,
    longitude: 149.1658,
    accuracy: 4
  },
  {
    postalCode: 2620,
    city: "Paddys River",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3914,
    longitude: 149.2166,
    accuracy: 3
  },
  {
    postalCode: 2620,
    city: "Beard",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3422,
    longitude: 149.2101,
    accuracy: 4
  },
  {
    postalCode: 2620,
    city: "Oaks Estate",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3397,
    longitude: 149.2121,
    accuracy: 4
  },
  {
    postalCode: 2620,
    city: "Tharwa",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.5167,
    longitude: 149.0667,
    accuracy: 4
  },
  {
    postalCode: 2620,
    city: "Kowen",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3914,
    longitude: 149.2166,
    accuracy: 3
  },
  {
    postalCode: 2900,
    city: "Greenway",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.4183,
    longitude: 149.0666,
    accuracy: 4
  },
  {
    postalCode: 2900,
    city: "Tuggeranong",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.4158,
    longitude: 149.0649,
    accuracy: 3
  },
  {
    postalCode: 2901,
    city: "Tuggeranong Dc",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.4333,
    longitude: 149.15,
    accuracy: 1
  },
  {
    postalCode: 2902,
    city: "Kambah",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3862,
    longitude: 149.058,
    accuracy: 4
  },
  {
    postalCode: 2902,
    city: "Kambah Village",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3862,
    longitude: 149.058,
    accuracy: 3
  },
  {
    postalCode: 2903,
    city: "Erindale Centre",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3998,
    longitude: 149.0888,
    accuracy: 3
  },
  {
    postalCode: 2903,
    city: "Oxley",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.4095,
    longitude: 149.0786,
    accuracy: 4
  },
  {
    postalCode: 2903,
    city: "Wanniassa",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.3978,
    longitude: 149.0909,
    accuracy: 4
  },
  {
    postalCode: 2904,
    city: "Fadden",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.405,
    longitude: 149.1166,
    accuracy: 4
  },
  {
    postalCode: 2904,
    city: "Monash",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.4158,
    longitude: 149.0906,
    accuracy: 4
  },
  {
    postalCode: 2904,
    city: "Gowrie",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.4119,
    longitude: 149.109,
    accuracy: 4
  },
  {
    postalCode: 2904,
    city: "Macarthur",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.4089,
    longitude: 149.127,
    accuracy: 4
  },
  {
    postalCode: 2905,
    city: "Isabella Plains",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.4283,
    longitude: 149.088,
    accuracy: 4
  },
  {
    postalCode: 2905,
    city: "Theodore",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.4496,
    longitude: 149.1197,
    accuracy: 4
  },
  {
    postalCode: 2905,
    city: "Gilmore",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.4199,
    longitude: 149.1348,
    accuracy: 4
  },
  {
    postalCode: 2905,
    city: "Richardson",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.4279,
    longitude: 149.1138,
    accuracy: 4
  },
  {
    postalCode: 2905,
    city: "Calwell",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.4404,
    longitude: 149.1071,
    accuracy: 4
  },
  {
    postalCode: 2905,
    city: "Chisholm",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.4125,
    longitude: 149.1283,
    accuracy: 4
  },
  {
    postalCode: 2905,
    city: "Bonython",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.4333,
    longitude: 149.0782,
    accuracy: 4
  },
  {
    postalCode: 2906,
    city: "Conder",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.4593,
    longitude: 149.1042,
    accuracy: 4
  },
  {
    postalCode: 2906,
    city: "Gordon",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.4568,
    longitude: 149.085,
    accuracy: 4
  },
  {
    postalCode: 2906,
    city: "Banks",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.4719,
    longitude: 149.0997,
    accuracy: 4
  },
  {
    postalCode: 2911,
    city: "Mitchell",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2145,
    longitude: 149.1293,
    accuracy: 4
  },
  {
    postalCode: 2911,
    city: "Crace",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.2028,
    longitude: 149.1074,
    accuracy: 4
  },
  {
    postalCode: 2912,
    city: "Gungahlin",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.1867,
    longitude: 149.1362,
    accuracy: 4
  },
  {
    postalCode: 2913,
    city: "Casey",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.167,
    longitude: 149.0947,
    accuracy: 4
  },
  {
    postalCode: 2913,
    city: "Franklin",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.1995,
    longitude: 149.1433,
    accuracy: 4
  },
  {
    postalCode: 2913,
    city: "Taylor",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.1489,
    longitude: 149.1092,
    accuracy: 4
  },
  {
    postalCode: 2913,
    city: "Palmerston",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.1945,
    longitude: 149.1194,
    accuracy: 4
  },
  {
    postalCode: 2913,
    city: "Kinlyside",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.1754,
    longitude: 149.0798,
    accuracy: 4
  },
  {
    postalCode: 2913,
    city: "Nicholls",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.1873,
    longitude: 149.0965,
    accuracy: 4
  },
  {
    postalCode: 2913,
    city: "Ginninderra Village",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.1875,
    longitude: 149.1244,
    accuracy: 3
  },
  {
    postalCode: 2913,
    city: "Ngunnawal",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.1728,
    longitude: 149.1115,
    accuracy: 4
  },
  {
    postalCode: 2914,
    city: "Bonner",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.1623,
    longitude: 149.1386,
    accuracy: 4
  },
  {
    postalCode: 2914,
    city: "Forde",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.1682,
    longitude: 149.1461,
    accuracy: 4
  },
  {
    postalCode: 2914,
    city: "Harrison",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.1991,
    longitude: 149.1563,
    accuracy: 4
  },
  {
    postalCode: 2914,
    city: "Amaroo",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.1696,
    longitude: 149.128,
    accuracy: 4
  },
  {
    postalCode: 2914,
    city: "Moncrieff",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.1651,
    longitude: 149.1179,
    accuracy: 4
  },
  {
    postalCode: 2914,
    city: "Jacka",
    state_name: "Australian Capital Territory",
    state: "ACT",
    latitude: -35.1568,
    longitude: 149.1288,
    accuracy: 4
  },
  {
    postalCode: 1001,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1002,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1003,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1004,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1005,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1006,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1007,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1008,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1009,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1010,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1011,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1020,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1021,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1022,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1023,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1025,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1026,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1027,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1028,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1029,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1030,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1031,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1032,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1033,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1034,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1035,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1036,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1037,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1038,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1039,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1040,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1041,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1042,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1043,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1044,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1045,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1046,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1100,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1101,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1105,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1106,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1107,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1108,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1109,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1110,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1112,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1113,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1114,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1115,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1116,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1117,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1118,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1119,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1120,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1121,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1122,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1123,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1124,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1125,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1126,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1127,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1128,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1129,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1130,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1131,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1132,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1133,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1134,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1135,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1136,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1137,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1138,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1139,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1140,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1141,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1142,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1143,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1144,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1145,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1146,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1147,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1148,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1149,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1150,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1151,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1152,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1153,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1154,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1155,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1156,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1157,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1158,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1159,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1160,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1161,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1162,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1163,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1164,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1165,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1166,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1167,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1168,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1169,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1170,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1171,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1172,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1173,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1174,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1175,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1176,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1177,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1178,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1179,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1180,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1181,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1182,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1183,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1184,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1185,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1186,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1187,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1188,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1189,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1190,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1191,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1192,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1193,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1194,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1195,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1196,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1197,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1198,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1199,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1200,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1201,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1202,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1203,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1204,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1205,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1206,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1207,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1208,
    city: "Haymarket",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8787,
    longitude: 151.2053,
    accuracy: 4
  },
  {
    postalCode: 1209,
    city: "Australia Square",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8691,
    longitude: 151.2071,
    accuracy: 1
  },
  {
    postalCode: 1210,
    city: "Australia Square",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8707,
    longitude: 151.2068,
    accuracy: 1
  },
  {
    postalCode: 1211,
    city: "Australia Square",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8707,
    longitude: 151.2068,
    accuracy: 1
  },
  {
    postalCode: 1212,
    city: "Australia Square",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8707,
    longitude: 151.2068,
    accuracy: 1
  },
  {
    postalCode: 1213,
    city: "Australia Square",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8707,
    longitude: 151.2068,
    accuracy: 1
  },
  {
    postalCode: 1214,
    city: "Australia Square",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8707,
    longitude: 151.2068,
    accuracy: 1
  },
  {
    postalCode: 1215,
    city: "Australia Square",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8707,
    longitude: 151.2068,
    accuracy: 1
  },
  {
    postalCode: 1216,
    city: "Grosvenor Place",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8707,
    longitude: 151.2068,
    accuracy: 1
  },
  {
    postalCode: 1217,
    city: "Grosvenor Place",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8707,
    longitude: 151.2068,
    accuracy: 1
  },
  {
    postalCode: 1218,
    city: "Grosvenor Place",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8707,
    longitude: 151.2068,
    accuracy: 1
  },
  {
    postalCode: 1219,
    city: "Grosvenor Place",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8707,
    longitude: 151.2068,
    accuracy: 1
  },
  {
    postalCode: 1220,
    city: "Grosvenor Place",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8707,
    longitude: 151.2068,
    accuracy: 1
  },
  {
    postalCode: 1221,
    city: "Royal Exchange",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8707,
    longitude: 151.2068,
    accuracy: 1
  },
  {
    postalCode: 1222,
    city: "Royal Exchange",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8707,
    longitude: 151.2068,
    accuracy: 1
  },
  {
    postalCode: 1223,
    city: "Royal Exchange",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8707,
    longitude: 151.2068,
    accuracy: 1
  },
  {
    postalCode: 1224,
    city: "Royal Exchange",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8707,
    longitude: 151.2068,
    accuracy: 1
  },
  {
    postalCode: 1225,
    city: "Royal Exchange",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8707,
    longitude: 151.2068,
    accuracy: 1
  },
  {
    postalCode: 1226,
    city: "Queen Victoria Building",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8707,
    longitude: 151.2068,
    accuracy: 1
  },
  {
    postalCode: 1227,
    city: "Queen Victoria Building",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8707,
    longitude: 151.2068,
    accuracy: 1
  },
  {
    postalCode: 1228,
    city: "Queen Victoria Building",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8707,
    longitude: 151.2068,
    accuracy: 1
  },
  {
    postalCode: 1229,
    city: "Queen Victoria Building",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8707,
    longitude: 151.2068,
    accuracy: 1
  },
  {
    postalCode: 1230,
    city: "Queen Victoria Building",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8787,
    longitude: 151.2053,
    accuracy: 1
  },
  {
    postalCode: 1231,
    city: "Sydney South",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8787,
    longitude: 151.2053,
    accuracy: 1
  },
  {
    postalCode: 1232,
    city: "Sydney South",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8787,
    longitude: 151.2053,
    accuracy: 1
  },
  {
    postalCode: 1233,
    city: "Sydney South",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8787,
    longitude: 151.2053,
    accuracy: 1
  },
  {
    postalCode: 1234,
    city: "Sydney South",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8787,
    longitude: 151.2053,
    accuracy: 1
  },
  {
    postalCode: 1235,
    city: "Sydney South",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8787,
    longitude: 151.2053,
    accuracy: 1
  },
  {
    postalCode: 1236,
    city: "Haymarket",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8787,
    longitude: 151.2053,
    accuracy: 4
  },
  {
    postalCode: 1237,
    city: "Haymarket",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8787,
    longitude: 151.2053,
    accuracy: 4
  },
  {
    postalCode: 1238,
    city: "Haymarket",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8787,
    longitude: 151.2053,
    accuracy: 4
  },
  {
    postalCode: 1239,
    city: "Haymarket",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8787,
    longitude: 151.2053,
    accuracy: 4
  },
  {
    postalCode: 1240,
    city: "Haymarket",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8787,
    longitude: 151.2053,
    accuracy: 4
  },
  {
    postalCode: 1291,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1292,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1293,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1294,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1295,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1296,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1297,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1298,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1299,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 1300,
    city: "Darlinghurst",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8794,
    longitude: 151.2193,
    accuracy: 4
  },
  {
    postalCode: 1311,
    city: "Eastern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8784,
    longitude: 151.2313,
    accuracy: 1
  },
  {
    postalCode: 1312,
    city: "Eastern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8784,
    longitude: 151.2313,
    accuracy: 1
  },
  {
    postalCode: 1313,
    city: "Eastern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8784,
    longitude: 151.2313,
    accuracy: 1
  },
  {
    postalCode: 1314,
    city: "Eastern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8784,
    longitude: 151.2313,
    accuracy: 1
  },
  {
    postalCode: 1315,
    city: "Eastern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8784,
    longitude: 151.2313,
    accuracy: 1
  },
  {
    postalCode: 1316,
    city: "Eastern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8784,
    longitude: 151.2313,
    accuracy: 1
  },
  {
    postalCode: 1317,
    city: "Eastern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8784,
    longitude: 151.2313,
    accuracy: 1
  },
  {
    postalCode: 1318,
    city: "Eastern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8784,
    longitude: 151.2313,
    accuracy: 1
  },
  {
    postalCode: 1319,
    city: "Eastern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8784,
    longitude: 151.2313,
    accuracy: 1
  },
  {
    postalCode: 1320,
    city: "Eastern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8784,
    longitude: 151.2313,
    accuracy: 1
  },
  {
    postalCode: 1321,
    city: "Eastern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8784,
    longitude: 151.2313,
    accuracy: 1
  },
  {
    postalCode: 1322,
    city: "Eastern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8784,
    longitude: 151.2313,
    accuracy: 1
  },
  {
    postalCode: 1323,
    city: "Eastern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8784,
    longitude: 151.2313,
    accuracy: 1
  },
  {
    postalCode: 1324,
    city: "Eastern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8784,
    longitude: 151.2313,
    accuracy: 1
  },
  {
    postalCode: 1325,
    city: "Eastern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8784,
    longitude: 151.2313,
    accuracy: 1
  },
  {
    postalCode: 1326,
    city: "Eastern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8784,
    longitude: 151.2313,
    accuracy: 1
  },
  {
    postalCode: 1327,
    city: "Eastern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8784,
    longitude: 151.2313,
    accuracy: 1
  },
  {
    postalCode: 1328,
    city: "Eastern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8784,
    longitude: 151.2313,
    accuracy: 1
  },
  {
    postalCode: 1329,
    city: "Eastern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8784,
    longitude: 151.2313,
    accuracy: 1
  },
  {
    postalCode: 1330,
    city: "Eastern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8693,
    longitude: 151.2248,
    accuracy: 1
  },
  {
    postalCode: 1331,
    city: "Eastern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8693,
    longitude: 151.2248,
    accuracy: 1
  },
  {
    postalCode: 1332,
    city: "Eastern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8693,
    longitude: 151.2248,
    accuracy: 1
  },
  {
    postalCode: 1333,
    city: "Eastern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8693,
    longitude: 151.2248,
    accuracy: 1
  },
  {
    postalCode: 1334,
    city: "Eastern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8693,
    longitude: 151.2248,
    accuracy: 1
  },
  {
    postalCode: 1335,
    city: "Potts Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8713,
    longitude: 151.222,
    accuracy: 4
  },
  {
    postalCode: 1340,
    city: "Kings Cross",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.875,
    longitude: 151.2223,
    accuracy: 4
  },
  {
    postalCode: 1350,
    city: "Woollahra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8878,
    longitude: 151.2368,
    accuracy: 4
  },
  {
    postalCode: 1355,
    city: "Bondi Junction",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8928,
    longitude: 151.2472,
    accuracy: 4
  },
  {
    postalCode: 1360,
    city: "Double Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8778,
    longitude: 151.2435,
    accuracy: 4
  },
  {
    postalCode: 1363,
    city: "Moore Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9014,
    longitude: 151.2138,
    accuracy: 4
  },
  {
    postalCode: 1391,
    city: "Eastern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8784,
    longitude: 151.2313,
    accuracy: 1
  },
  {
    postalCode: 1401,
    city: "Broadway",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9475,
    longitude: 151.1522,
    accuracy: 1
  },
  {
    postalCode: 1416,
    city: "Southern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9475,
    longitude: 151.1522,
    accuracy: 1
  },
  {
    postalCode: 1419,
    city: "Southern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9475,
    longitude: 151.1522,
    accuracy: 1
  },
  {
    postalCode: 1420,
    city: "Strawberry Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9475,
    longitude: 151.1522,
    accuracy: 1
  },
  {
    postalCode: 1421,
    city: "Strawberry Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9475,
    longitude: 151.1522,
    accuracy: 1
  },
  {
    postalCode: 1422,
    city: "Strawberry Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9475,
    longitude: 151.1522,
    accuracy: 1
  },
  {
    postalCode: 1423,
    city: "Strawberry Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9475,
    longitude: 151.1522,
    accuracy: 1
  },
  {
    postalCode: 1424,
    city: "Strawberry Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9475,
    longitude: 151.1522,
    accuracy: 1
  },
  {
    postalCode: 1425,
    city: "Strawberry Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9475,
    longitude: 151.1522,
    accuracy: 1
  },
  {
    postalCode: 1426,
    city: "Strawberry Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9475,
    longitude: 151.1522,
    accuracy: 1
  },
  {
    postalCode: 1427,
    city: "Strawberry Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9475,
    longitude: 151.1522,
    accuracy: 1
  },
  {
    postalCode: 1428,
    city: "Strawberry Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9475,
    longitude: 151.1522,
    accuracy: 1
  },
  {
    postalCode: 1429,
    city: "Strawberry Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9475,
    longitude: 151.1522,
    accuracy: 1
  },
  {
    postalCode: 1430,
    city: "Eveleigh",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8956,
    longitude: 151.1924,
    accuracy: 4
  },
  {
    postalCode: 1435,
    city: "Alexandria",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9022,
    longitude: 151.2004,
    accuracy: 4
  },
  {
    postalCode: 1440,
    city: "Waterloo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9167,
    longitude: 151.2,
    accuracy: 4
  },
  {
    postalCode: 1445,
    city: "Rosebery",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9167,
    longitude: 151.2,
    accuracy: 4
  },
  {
    postalCode: 1450,
    city: "Camperdown",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8897,
    longitude: 151.1764,
    accuracy: 4
  },
  {
    postalCode: 1455,
    city: "Botany",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.946,
    longitude: 151.1959,
    accuracy: 4
  },
  {
    postalCode: 1460,
    city: "Mascot",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.926,
    longitude: 151.1935,
    accuracy: 4
  },
  {
    postalCode: 1465,
    city: "Kensington",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9202,
    longitude: 151.2224,
    accuracy: 4
  },
  {
    postalCode: 1466,
    city: "Unsw Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.925,
    longitude: 151.2083,
    accuracy: 1
  },
  {
    postalCode: 1470,
    city: "Drummoyne",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8524,
    longitude: 151.1549,
    accuracy: 4
  },
  {
    postalCode: 1475,
    city: "Marrickville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9032,
    longitude: 151.1518,
    accuracy: 4
  },
  {
    postalCode: 1480,
    city: "Kingsgrove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9393,
    longitude: 151.0993,
    accuracy: 4
  },
  {
    postalCode: 1481,
    city: "Hurstville Bc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9687,
    longitude: 151.1109,
    accuracy: 1
  },
  {
    postalCode: 1484,
    city: "Kingsgrove DC",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9687,
    longitude: 151.1109,
    accuracy: 1
  },
  {
    postalCode: 1485,
    city: "Kogarah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9833,
    longitude: 151.1167,
    accuracy: 4
  },
  {
    postalCode: 1487,
    city: "Kogarah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9833,
    longitude: 151.1167,
    accuracy: 4
  },
  {
    postalCode: 1490,
    city: "Miranda",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0386,
    longitude: 151.1001,
    accuracy: 4
  },
  {
    postalCode: 1493,
    city: "Hurstville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9799,
    longitude: 151.0903,
    accuracy: 4
  },
  {
    postalCode: 1495,
    city: "Caringbah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0473,
    longitude: 151.1205,
    accuracy: 4
  },
  {
    postalCode: 1499,
    city: "Sutherland",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.031,
    longitude: 151.0553,
    accuracy: 4
  },
  {
    postalCode: 1515,
    city: "West Chatswood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.794,
    longitude: 151.1649,
    accuracy: 4
  },
  {
    postalCode: 1560,
    city: "Northbridge",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8094,
    longitude: 151.2222,
    accuracy: 4
  },
  {
    postalCode: 1565,
    city: "Milsons Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.846,
    longitude: 151.2119,
    accuracy: 4
  },
  {
    postalCode: 1570,
    city: "Artarmon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8167,
    longitude: 151.1833,
    accuracy: 4
  },
  {
    postalCode: 1582,
    city: "Crows Nest",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8265,
    longitude: 151.2019,
    accuracy: 4
  },
  {
    postalCode: 1585,
    city: "Crows Nest",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8265,
    longitude: 151.2019,
    accuracy: 4
  },
  {
    postalCode: 1590,
    city: "St Leonards",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8234,
    longitude: 151.1984,
    accuracy: 4
  },
  {
    postalCode: 1595,
    city: "Lane Cove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8157,
    longitude: 151.1668,
    accuracy: 4
  },
  {
    postalCode: 1597,
    city: "Lane Cove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8157,
    longitude: 151.1668,
    accuracy: 4
  },
  {
    postalCode: 1602,
    city: "Lane Cove DC",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7554,
    longitude: 151.1998,
    accuracy: 1
  },
  {
    postalCode: 1630,
    city: "Hornsby",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7024,
    longitude: 151.0993,
    accuracy: 4
  },
  {
    postalCode: 1635,
    city: "Hornsby Westfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7,
    longitude: 151.1,
    accuracy: 1
  },
  {
    postalCode: 1639,
    city: "Frenchs Forest",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7482,
    longitude: 151.2232,
    accuracy: 4
  },
  {
    postalCode: 1640,
    city: "Frenchs Forest",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7482,
    longitude: 151.2232,
    accuracy: 4
  },
  {
    postalCode: 1655,
    city: "Manly",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.798,
    longitude: 151.2883,
    accuracy: 4
  },
  {
    postalCode: 1658,
    city: "Mona Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6776,
    longitude: 151.3031,
    accuracy: 4
  },
  {
    postalCode: 1660,
    city: "Mona Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6776,
    longitude: 151.3031,
    accuracy: 4
  },
  {
    postalCode: 1670,
    city: "North Ryde Bc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8151,
    longitude: 151.1288,
    accuracy: 1
  },
  {
    postalCode: 1671,
    city: "North Ryde",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7968,
    longitude: 151.1244,
    accuracy: 4
  },
  {
    postalCode: 1675,
    city: "Gladesville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8333,
    longitude: 151.1333,
    accuracy: 4
  },
  {
    postalCode: 1680,
    city: "Ryde",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8188,
    longitude: 151.1062,
    accuracy: 4
  },
  {
    postalCode: 1685,
    city: "West Ryde",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8054,
    longitude: 151.0739,
    accuracy: 4
  },
  {
    postalCode: 1690,
    city: "Northern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7554,
    longitude: 151.1998,
    accuracy: 1
  },
  {
    postalCode: 1691,
    city: "Northern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7554,
    longitude: 151.1998,
    accuracy: 1
  },
  {
    postalCode: 1692,
    city: "Northern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7554,
    longitude: 151.1998,
    accuracy: 1
  },
  {
    postalCode: 1693,
    city: "Northern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7554,
    longitude: 151.1998,
    accuracy: 1
  },
  {
    postalCode: 1694,
    city: "Northern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7554,
    longitude: 151.1998,
    accuracy: 1
  },
  {
    postalCode: 1695,
    city: "Northern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7554,
    longitude: 151.1998,
    accuracy: 1
  },
  {
    postalCode: 1696,
    city: "Northern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7554,
    longitude: 151.1998,
    accuracy: 1
  },
  {
    postalCode: 1697,
    city: "Northern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7554,
    longitude: 151.1998,
    accuracy: 1
  },
  {
    postalCode: 1698,
    city: "Northern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7554,
    longitude: 151.1998,
    accuracy: 1
  },
  {
    postalCode: 1699,
    city: "Northern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7554,
    longitude: 151.1998,
    accuracy: 1
  },
  {
    postalCode: 1700,
    city: "Ermington",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8148,
    longitude: 151.0547,
    accuracy: 4
  },
  {
    postalCode: 1701,
    city: "Rydalmere Bc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7613,
    longitude: 151.0294,
    accuracy: 1
  },
  {
    postalCode: 1710,
    city: "Epping",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7727,
    longitude: 151.0818,
    accuracy: 4
  },
  {
    postalCode: 1712,
    city: "Epping",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7727,
    longitude: 151.0818,
    accuracy: 4
  },
  {
    postalCode: 1715,
    city: "Pennant Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7378,
    longitude: 151.0722,
    accuracy: 4
  },
  {
    postalCode: 1730,
    city: "Seven Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7833,
    longitude: 150.9333,
    accuracy: 4
  },
  {
    postalCode: 1740,
    city: "Parramatta",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7613,
    longitude: 151.0294,
    accuracy: 1
  },
  {
    postalCode: 1741,
    city: "Parramatta",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7613,
    longitude: 151.0294,
    accuracy: 1
  },
  {
    postalCode: 1750,
    city: "North Parramatta",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7935,
    longitude: 151.0012,
    accuracy: 4
  },
  {
    postalCode: 1755,
    city: "Baulkham Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7588,
    longitude: 150.9929,
    accuracy: 4
  },
  {
    postalCode: 1765,
    city: "Castle Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7333,
    longitude: 151,
    accuracy: 4
  },
  {
    postalCode: 1771,
    city: "Pennant Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7378,
    longitude: 151.0722,
    accuracy: 4
  },
  {
    postalCode: 1781,
    city: "Seven Hills Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7613,
    longitude: 151.0294,
    accuracy: 1
  },
  {
    postalCode: 1790,
    city: "St Marys",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7613,
    longitude: 151.0294,
    accuracy: 1
  },
  {
    postalCode: 1797,
    city: "Penrith South DC",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7613,
    longitude: 151.0294,
    accuracy: 1
  },
  {
    postalCode: 1800,
    city: "Ashfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8883,
    longitude: 151.1227,
    accuracy: 4
  },
  {
    postalCode: 1805,
    city: "Burwood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8833,
    longitude: 151.1,
    accuracy: 4
  },
  {
    postalCode: 1811,
    city: "Silverwater",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8334,
    longitude: 151.0473,
    accuracy: 4
  },
  {
    postalCode: 1825,
    city: "Lidcombe",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8644,
    longitude: 151.0397,
    accuracy: 4
  },
  {
    postalCode: 1826,
    city: "Lidcombe",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8644,
    longitude: 151.0397,
    accuracy: 4
  },
  {
    postalCode: 1830,
    city: "Granville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8333,
    longitude: 151.0167,
    accuracy: 4
  },
  {
    postalCode: 1831,
    city: "Granville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8333,
    longitude: 151.0167,
    accuracy: 4
  },
  {
    postalCode: 1835,
    city: "Auburn",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.85,
    longitude: 151.0333,
    accuracy: 4
  },
  {
    postalCode: 1848,
    city: "Guildford",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8643,
    longitude: 150.9839,
    accuracy: 1
  },
  {
    postalCode: 1851,
    city: "Wetherill Park Dc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8872,
    longitude: 151.0086,
    accuracy: 1
  },
  {
    postalCode: 1860,
    city: "Fairfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8667,
    longitude: 150.95,
    accuracy: 4
  },
  {
    postalCode: 1871,
    city: "Liverpool",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9,
    longitude: 150.9333,
    accuracy: 4
  },
  {
    postalCode: 1875,
    city: "Moorebank",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9425,
    longitude: 150.9377,
    accuracy: 4
  },
  {
    postalCode: 1885,
    city: "Bankstown",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9167,
    longitude: 151.0333,
    accuracy: 4
  },
  {
    postalCode: 1888,
    city: "Bankstown",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9167,
    longitude: 151.0333,
    accuracy: 4
  },
  {
    postalCode: 1890,
    city: "Ingleburn",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34,
    longitude: 150.8667,
    accuracy: 4
  },
  {
    postalCode: 1891,
    city: "Milperra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9393,
    longitude: 150.9815,
    accuracy: 4
  },
  {
    postalCode: 1900,
    city: "Leightonfield Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8816,
    longitude: 150.9844,
    accuracy: null
  },
  {
    postalCode: 1902,
    city: "Leightonfield Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8816,
    longitude: 150.9844,
    accuracy: null
  },
  {
    postalCode: 2000,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 2000,
    city: "Dawes Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8561,
    longitude: 151.2077,
    accuracy: 4
  },
  {
    postalCode: 2000,
    city: "The Rocks",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8592,
    longitude: 151.2081,
    accuracy: 4
  },
  {
    postalCode: 2000,
    city: "Parliament House",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8651,
    longitude: 151.2053,
    accuracy: 3
  },
  {
    postalCode: 2000,
    city: "Sydney South",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8699,
    longitude: 151.2025,
    accuracy: 3
  },
  {
    postalCode: 2000,
    city: "Barangaroo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8603,
    longitude: 151.2016,
    accuracy: 4
  },
  {
    postalCode: 2000,
    city: "Millers Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8596,
    longitude: 151.2041,
    accuracy: 4
  },
  {
    postalCode: 2000,
    city: "Haymarket",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8787,
    longitude: 151.2053,
    accuracy: 4
  },
  {
    postalCode: 2001,
    city: "Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8678,
    longitude: 151.2073,
    accuracy: 4
  },
  {
    postalCode: 2002,
    city: "World Square",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8699,
    longitude: 151.2025,
    accuracy: 1
  },
  {
    postalCode: 2004,
    city: "Alexandria Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8699,
    longitude: 151.2025,
    accuracy: 1
  },
  {
    postalCode: 2004,
    city: "Eastern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8699,
    longitude: 151.2025,
    accuracy: 1
  },
  {
    postalCode: 2006,
    city: "The University Of Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8699,
    longitude: 151.2025,
    accuracy: 1
  },
  {
    postalCode: 2007,
    city: "Broadway",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8699,
    longitude: 151.2025,
    accuracy: 3
  },
  {
    postalCode: 2007,
    city: "Ultimo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8772,
    longitude: 151.1972,
    accuracy: 4
  },
  {
    postalCode: 2008,
    city: "Darlington",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.891,
    longitude: 151.1955,
    accuracy: 4
  },
  {
    postalCode: 2008,
    city: "Chippendale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8867,
    longitude: 151.1975,
    accuracy: 4
  },
  {
    postalCode: 2009,
    city: "Pyrmont",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8698,
    longitude: 151.194,
    accuracy: 4
  },
  {
    postalCode: 2010,
    city: "Darlinghurst",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8794,
    longitude: 151.2193,
    accuracy: 4
  },
  {
    postalCode: 2010,
    city: "Surry Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8837,
    longitude: 151.2128,
    accuracy: 4
  },
  {
    postalCode: 2011,
    city: "Kings Cross",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.875,
    longitude: 151.2223,
    accuracy: 4
  },
  {
    postalCode: 2011,
    city: "Potts Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8713,
    longitude: 151.222,
    accuracy: 4
  },
  {
    postalCode: 2011,
    city: "Rushcutters Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8748,
    longitude: 151.228,
    accuracy: 4
  },
  {
    postalCode: 2011,
    city: "Elizabeth Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8718,
    longitude: 151.2271,
    accuracy: 4
  },
  {
    postalCode: 2011,
    city: "Woolloomooloo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8704,
    longitude: 151.2197,
    accuracy: 4
  },
  {
    postalCode: 2012,
    city: "Strawberry Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9032,
    longitude: 150.9677,
    accuracy: 1
  },
  {
    postalCode: 2015,
    city: "Eveleigh",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8956,
    longitude: 151.1924,
    accuracy: 4
  },
  {
    postalCode: 2015,
    city: "Alexandria",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9022,
    longitude: 151.2004,
    accuracy: 4
  },
  {
    postalCode: 2015,
    city: "Beaconsfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9115,
    longitude: 151.2004,
    accuracy: 4
  },
  {
    postalCode: 2016,
    city: "Redfern",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8928,
    longitude: 151.2041,
    accuracy: 4
  },
  {
    postalCode: 2017,
    city: "Waterloo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9167,
    longitude: 151.2,
    accuracy: 4
  },
  {
    postalCode: 2017,
    city: "Zetland",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9075,
    longitude: 151.2086,
    accuracy: 4
  },
  {
    postalCode: 2018,
    city: "Rosebery",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9167,
    longitude: 151.2,
    accuracy: 4
  },
  {
    postalCode: 2018,
    city: "Eastlakes",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.932,
    longitude: 151.2121,
    accuracy: 4
  },
  {
    postalCode: 2019,
    city: "Botany",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.946,
    longitude: 151.1959,
    accuracy: 4
  },
  {
    postalCode: 2019,
    city: "Banksmeadow",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9566,
    longitude: 151.2096,
    accuracy: 4
  },
  {
    postalCode: 2020,
    city: "Sydney International Airport",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.939,
    longitude: 151.1862,
    accuracy: 3
  },
  {
    postalCode: 2020,
    city: "Mascot",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.926,
    longitude: 151.1935,
    accuracy: 4
  },
  {
    postalCode: 2020,
    city: "Sydney Domestic Airport",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.939,
    longitude: 151.1862,
    accuracy: 3
  },
  {
    postalCode: 2021,
    city: "Paddington",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8842,
    longitude: 151.2315,
    accuracy: 4
  },
  {
    postalCode: 2021,
    city: "Moore Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9014,
    longitude: 151.2138,
    accuracy: 4
  },
  {
    postalCode: 2021,
    city: "Centennial Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8979,
    longitude: 151.2336,
    accuracy: 4
  },
  {
    postalCode: 2022,
    city: "Queens Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8995,
    longitude: 151.2472,
    accuracy: 4
  },
  {
    postalCode: 2022,
    city: "Bondi Junction",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8928,
    longitude: 151.2472,
    accuracy: 4
  },
  {
    postalCode: 2023,
    city: "Bellevue Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.879,
    longitude: 151.251,
    accuracy: 4
  },
  {
    postalCode: 2024,
    city: "Bronte",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.902,
    longitude: 151.2656,
    accuracy: 4
  },
  {
    postalCode: 2024,
    city: "Waverley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8977,
    longitude: 151.2501,
    accuracy: 4
  },
  {
    postalCode: 2025,
    city: "Woollahra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8878,
    longitude: 151.2368,
    accuracy: 4
  },
  {
    postalCode: 2026,
    city: "Tamarama",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8984,
    longitude: 151.2706,
    accuracy: 4
  },
  {
    postalCode: 2026,
    city: "Bondi Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.891,
    longitude: 151.2716,
    accuracy: 4
  },
  {
    postalCode: 2026,
    city: "Bondi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8943,
    longitude: 151.2644,
    accuracy: 4
  },
  {
    postalCode: 2026,
    city: "North Bondi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8853,
    longitude: 151.2752,
    accuracy: 4
  },
  {
    postalCode: 2026,
    city: "Ben Buckler",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8904,
    longitude: 151.2475,
    accuracy: 3
  },
  {
    postalCode: 2027,
    city: "Darling Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8706,
    longitude: 151.2389,
    accuracy: 4
  },
  {
    postalCode: 2027,
    city: "Hmas Rushcutters",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8688,
    longitude: 151.2444,
    accuracy: 3
  },
  {
    postalCode: 2027,
    city: "Point Piper",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8667,
    longitude: 151.25,
    accuracy: 4
  },
  {
    postalCode: 2027,
    city: "Edgecliff",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8833,
    longitude: 151.25,
    accuracy: 4
  },
  {
    postalCode: 2028,
    city: "Double Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8778,
    longitude: 151.2435,
    accuracy: 4
  },
  {
    postalCode: 2029,
    city: "Rose Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8688,
    longitude: 151.2706,
    accuracy: 4
  },
  {
    postalCode: 2030,
    city: "Vaucluse",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8555,
    longitude: 151.2775,
    accuracy: 4
  },
  {
    postalCode: 2030,
    city: "Dover Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8708,
    longitude: 151.2792,
    accuracy: 4
  },
  {
    postalCode: 2030,
    city: "Watsons Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8439,
    longitude: 151.2829,
    accuracy: 4
  },
  {
    postalCode: 2030,
    city: "Hmas Watson",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8625,
    longitude: 151.2819,
    accuracy: 3
  },
  {
    postalCode: 2030,
    city: "Rose Bay North",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8572,
    longitude: 151.2784,
    accuracy: 3
  },
  {
    postalCode: 2031,
    city: "Clovelly",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9121,
    longitude: 151.2588,
    accuracy: 4
  },
  {
    postalCode: 2031,
    city: "Randwick",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9144,
    longitude: 151.2489,
    accuracy: 4
  },
  {
    postalCode: 2031,
    city: "St Pauls",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9251,
    longitude: 151.231,
    accuracy: 3
  },
  {
    postalCode: 2031,
    city: "Clovelly West",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9251,
    longitude: 151.231,
    accuracy: 3
  },
  {
    postalCode: 2032,
    city: "Kingsford",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.924,
    longitude: 151.2275,
    accuracy: 4
  },
  {
    postalCode: 2032,
    city: "Daceyville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9333,
    longitude: 151.2333,
    accuracy: 4
  },
  {
    postalCode: 2033,
    city: "Kensington",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9202,
    longitude: 151.2224,
    accuracy: 4
  },
  {
    postalCode: 2034,
    city: "South Coogee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9205,
    longitude: 151.2552,
    accuracy: 4
  },
  {
    postalCode: 2034,
    city: "Coogee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9205,
    longitude: 151.2552,
    accuracy: 4
  },
  {
    postalCode: 2035,
    city: "Maroubra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.95,
    longitude: 151.2333,
    accuracy: 4
  },
  {
    postalCode: 2035,
    city: "Pagewood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9414,
    longitude: 151.2109,
    accuracy: 4
  },
  {
    postalCode: 2035,
    city: "Maroubra South",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9445,
    longitude: 151.2265,
    accuracy: 3
  },
  {
    postalCode: 2036,
    city: "Phillip Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9816,
    longitude: 151.234,
    accuracy: 4
  },
  {
    postalCode: 2036,
    city: "Hillsdale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9515,
    longitude: 151.2278,
    accuracy: 4
  },
  {
    postalCode: 2036,
    city: "Port Botany",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9745,
    longitude: 151.2228,
    accuracy: 3
  },
  {
    postalCode: 2036,
    city: "Eastgardens",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9451,
    longitude: 151.2258,
    accuracy: 4
  },
  {
    postalCode: 2036,
    city: "Little Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.979,
    longitude: 151.243,
    accuracy: 4
  },
  {
    postalCode: 2036,
    city: "Malabar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9622,
    longitude: 151.248,
    accuracy: 4
  },
  {
    postalCode: 2036,
    city: "Chifley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.967,
    longitude: 151.2422,
    accuracy: 4
  },
  {
    postalCode: 2036,
    city: "La Perouse",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9872,
    longitude: 151.2317,
    accuracy: 4
  },
  {
    postalCode: 2036,
    city: "Matraville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.95,
    longitude: 151.2333,
    accuracy: 4
  },
  {
    postalCode: 2037,
    city: "Glebe",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8788,
    longitude: 151.1843,
    accuracy: 4
  },
  {
    postalCode: 2037,
    city: "Forest Lodge",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8814,
    longitude: 151.18,
    accuracy: 4
  },
  {
    postalCode: 2038,
    city: "Annandale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8833,
    longitude: 151.1667,
    accuracy: 4
  },
  {
    postalCode: 2039,
    city: "Rozelle",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8614,
    longitude: 151.1705,
    accuracy: 4
  },
  {
    postalCode: 2040,
    city: "Lilyfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.875,
    longitude: 151.1653,
    accuracy: 4
  },
  {
    postalCode: 2040,
    city: "Leichhardt",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8834,
    longitude: 151.1562,
    accuracy: 4
  },
  {
    postalCode: 2041,
    city: "Balmain",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8548,
    longitude: 151.1833,
    accuracy: 4
  },
  {
    postalCode: 2041,
    city: "Balmain East",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8571,
    longitude: 151.1928,
    accuracy: 4
  },
  {
    postalCode: 2041,
    city: "Birchgrove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8516,
    longitude: 151.1824,
    accuracy: 4
  },
  {
    postalCode: 2042,
    city: "Newtown",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8983,
    longitude: 151.1775,
    accuracy: 4
  },
  {
    postalCode: 2042,
    city: "Enmore",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.7333,
    longitude: 151.8,
    accuracy: 4
  },
  {
    postalCode: 2043,
    city: "Erskineville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9025,
    longitude: 151.1858,
    accuracy: 4
  },
  {
    postalCode: 2044,
    city: "St Peters",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9167,
    longitude: 151.1833,
    accuracy: 4
  },
  {
    postalCode: 2044,
    city: "Sydenham",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9167,
    longitude: 151.168,
    accuracy: 4
  },
  {
    postalCode: 2044,
    city: "Tempe",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9233,
    longitude: 151.1602,
    accuracy: 4
  },
  {
    postalCode: 2045,
    city: "Haberfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8833,
    longitude: 151.2,
    accuracy: 4
  },
  {
    postalCode: 2046,
    city: "Russell Lea",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8589,
    longitude: 151.1411,
    accuracy: 4
  },
  {
    postalCode: 2046,
    city: "Wareemba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8582,
    longitude: 151.1309,
    accuracy: 4
  },
  {
    postalCode: 2046,
    city: "Five Dock",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8674,
    longitude: 151.1291,
    accuracy: 4
  },
  {
    postalCode: 2046,
    city: "Chiswick",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.85,
    longitude: 151.1385,
    accuracy: 4
  },
  {
    postalCode: 2046,
    city: "Abbotsford",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8489,
    longitude: 151.128,
    accuracy: 4
  },
  {
    postalCode: 2046,
    city: "Canada Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.85,
    longitude: 151.15,
    accuracy: 4
  },
  {
    postalCode: 2046,
    city: "Rodd Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8666,
    longitude: 151.1399,
    accuracy: 4
  },
  {
    postalCode: 2047,
    city: "Drummoyne",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8524,
    longitude: 151.1549,
    accuracy: 4
  },
  {
    postalCode: 2048,
    city: "Westgate",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8798,
    longitude: 151.1623,
    accuracy: 3
  },
  {
    postalCode: 2048,
    city: "Stanmore",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8941,
    longitude: 151.1642,
    accuracy: 4
  },
  {
    postalCode: 2049,
    city: "Petersham North",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8946,
    longitude: 151.1549,
    accuracy: 3
  },
  {
    postalCode: 2049,
    city: "Petersham",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8946,
    longitude: 151.1549,
    accuracy: 4
  },
  {
    postalCode: 2049,
    city: "Lewisham",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8972,
    longitude: 151.1488,
    accuracy: 4
  },
  {
    postalCode: 2050,
    city: "Missenden Road",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8892,
    longitude: 151.1771,
    accuracy: 3
  },
  {
    postalCode: 2050,
    city: "Camperdown",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8897,
    longitude: 151.1764,
    accuracy: 4
  },
  {
    postalCode: 2052,
    city: "Unsw Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8427,
    longitude: 151.1936,
    accuracy: 1
  },
  {
    postalCode: 2055,
    city: "North Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.839,
    longitude: 151.2072,
    accuracy: 4
  },
  {
    postalCode: 2057,
    city: "Chatswood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8,
    longitude: 151.1833,
    accuracy: 4
  },
  {
    postalCode: 2058,
    city: "Northern Suburbs Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8427,
    longitude: 151.1936,
    accuracy: 1
  },
  {
    postalCode: 2059,
    city: "North Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.839,
    longitude: 151.2072,
    accuracy: 4
  },
  {
    postalCode: 2060,
    city: "Hmas Waterhen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.842,
    longitude: 151.2046,
    accuracy: 3
  },
  {
    postalCode: 2060,
    city: "Waverton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8386,
    longitude: 151.2005,
    accuracy: 4
  },
  {
    postalCode: 2060,
    city: "Hmas Platypus",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.842,
    longitude: 151.2046,
    accuracy: 3
  },
  {
    postalCode: 2060,
    city: "Mcmahons Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8449,
    longitude: 151.2031,
    accuracy: 4
  },
  {
    postalCode: 2060,
    city: "North Sydney Shoppingworld",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.822,
    longitude: 151.1962,
    accuracy: 3
  },
  {
    postalCode: 2060,
    city: "North Sydney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.839,
    longitude: 151.2072,
    accuracy: 4
  },
  {
    postalCode: 2060,
    city: "Lavender Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8437,
    longitude: 151.2075,
    accuracy: 4
  },
  {
    postalCode: 2061,
    city: "Milsons Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.846,
    longitude: 151.2119,
    accuracy: 4
  },
  {
    postalCode: 2061,
    city: "Kirribilli",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8487,
    longitude: 151.2162,
    accuracy: 4
  },
  {
    postalCode: 2062,
    city: "Cammeray",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8213,
    longitude: 151.2161,
    accuracy: 4
  },
  {
    postalCode: 2063,
    city: "Northbridge",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8094,
    longitude: 151.2222,
    accuracy: 4
  },
  {
    postalCode: 2064,
    city: "Artarmon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8167,
    longitude: 151.1833,
    accuracy: 4
  },
  {
    postalCode: 2065,
    city: "Greenwich",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8395,
    longitude: 151.183,
    accuracy: 4
  },
  {
    postalCode: 2065,
    city: "Crows Nest",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8265,
    longitude: 151.2019,
    accuracy: 4
  },
  {
    postalCode: 2065,
    city: "Gore Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8167,
    longitude: 151.1825,
    accuracy: 4
  },
  {
    postalCode: 2065,
    city: "Wollstonecraft",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8328,
    longitude: 151.1898,
    accuracy: 4
  },
  {
    postalCode: 2065,
    city: "St Leonards",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8234,
    longitude: 151.1984,
    accuracy: 4
  },
  {
    postalCode: 2065,
    city: "Naremburn",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.817,
    longitude: 151.2008,
    accuracy: 4
  },
  {
    postalCode: 2065,
    city: "Royal North Shore Hospital",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.822,
    longitude: 151.1962,
    accuracy: 3
  },
  {
    postalCode: 2066,
    city: "Northwood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8289,
    longitude: 151.1803,
    accuracy: 4
  },
  {
    postalCode: 2066,
    city: "Riverview",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.824,
    longitude: 151.1602,
    accuracy: 4
  },
  {
    postalCode: 2066,
    city: "Longueville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8312,
    longitude: 151.1662,
    accuracy: 4
  },
  {
    postalCode: 2066,
    city: "Lane Cove North",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8054,
    longitude: 151.1664,
    accuracy: 4
  },
  {
    postalCode: 2066,
    city: "Linley Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8266,
    longitude: 151.1502,
    accuracy: 4
  },
  {
    postalCode: 2066,
    city: "Lane Cove West",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8161,
    longitude: 151.1515,
    accuracy: 4
  },
  {
    postalCode: 2066,
    city: "Lane Cove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8157,
    longitude: 151.1668,
    accuracy: 4
  },
  {
    postalCode: 2067,
    city: "Chatswood West",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.794,
    longitude: 151.1649,
    accuracy: 4
  },
  {
    postalCode: 2067,
    city: "Chatswood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8,
    longitude: 151.1833,
    accuracy: 4
  },
  {
    postalCode: 2068,
    city: "Willoughby East",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7984,
    longitude: 151.2052,
    accuracy: 4
  },
  {
    postalCode: 2068,
    city: "Middle Cove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7928,
    longitude: 151.2125,
    accuracy: 4
  },
  {
    postalCode: 2068,
    city: "Willoughby North",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8094,
    longitude: 151.2222,
    accuracy: 3
  },
  {
    postalCode: 2068,
    city: "Castlecrag",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7999,
    longitude: 151.2231,
    accuracy: 4
  },
  {
    postalCode: 2068,
    city: "Willoughby",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8049,
    longitude: 151.1993,
    accuracy: 4
  },
  {
    postalCode: 2068,
    city: "North Willoughby",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7956,
    longitude: 151.2007,
    accuracy: 4
  },
  {
    postalCode: 2069,
    city: "Castle Cove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7865,
    longitude: 151.2092,
    accuracy: 4
  },
  {
    postalCode: 2069,
    city: "Roseville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7833,
    longitude: 151.1833,
    accuracy: 4
  },
  {
    postalCode: 2069,
    city: "Roseville Chase",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7785,
    longitude: 151.1968,
    accuracy: 4
  },
  {
    postalCode: 2070,
    city: "East Lindfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7666,
    longitude: 151.1868,
    accuracy: 4
  },
  {
    postalCode: 2070,
    city: "Lindfield West",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7766,
    longitude: 151.17,
    accuracy: 3
  },
  {
    postalCode: 2070,
    city: "Lindfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7833,
    longitude: 151.1667,
    accuracy: 4
  },
  {
    postalCode: 2071,
    city: "Killara",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.766,
    longitude: 151.1621,
    accuracy: 4
  },
  {
    postalCode: 2071,
    city: "East Killara",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7554,
    longitude: 151.1815,
    accuracy: 4
  },
  {
    postalCode: 2072,
    city: "Gordon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7553,
    longitude: 151.1512,
    accuracy: 4
  },
  {
    postalCode: 2073,
    city: "West Pymble",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7667,
    longitude: 151.1333,
    accuracy: 4
  },
  {
    postalCode: 2073,
    city: "Pymble",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7439,
    longitude: 151.1419,
    accuracy: 4
  },
  {
    postalCode: 2074,
    city: "South Turramurra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7494,
    longitude: 151.1126,
    accuracy: 4
  },
  {
    postalCode: 2074,
    city: "Warrawee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7288,
    longitude: 151.1205,
    accuracy: 4
  },
  {
    postalCode: 2074,
    city: "North Turramurra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7131,
    longitude: 151.1464,
    accuracy: 4
  },
  {
    postalCode: 2074,
    city: "Turramurra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7334,
    longitude: 151.1285,
    accuracy: 4
  },
  {
    postalCode: 2075,
    city: "St Ives Chase",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7038,
    longitude: 151.1646,
    accuracy: 4
  },
  {
    postalCode: 2075,
    city: "St Ives",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7209,
    longitude: 151.1708,
    accuracy: 3
  },
  {
    postalCode: 2076,
    city: "Wahroonga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7182,
    longitude: 151.1156,
    accuracy: 4
  },
  {
    postalCode: 2076,
    city: "North Wahroonga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7053,
    longitude: 151.1228,
    accuracy: 4
  },
  {
    postalCode: 2076,
    city: "Normanhurst",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7333,
    longitude: 151.1,
    accuracy: 4
  },
  {
    postalCode: 2077,
    city: "Waitara",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7109,
    longitude: 151.1033,
    accuracy: 4
  },
  {
    postalCode: 2077,
    city: "Hornsby",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7024,
    longitude: 151.0993,
    accuracy: 4
  },
  {
    postalCode: 2077,
    city: "Asquith",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6833,
    longitude: 151.1,
    accuracy: 4
  },
  {
    postalCode: 2077,
    city: "Hornsby Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6713,
    longitude: 151.0943,
    accuracy: 4
  },
  {
    postalCode: 2079,
    city: "Mount Colah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6833,
    longitude: 151.1167,
    accuracy: 4
  },
  {
    postalCode: 2080,
    city: "Mount Kuring-Gai",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.642,
    longitude: 151.1287,
    accuracy: 4
  },
  {
    postalCode: 2081,
    city: "Berowra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6208,
    longitude: 151.1509,
    accuracy: 4
  },
  {
    postalCode: 2081,
    city: "Cowan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5956,
    longitude: 151.1686,
    accuracy: 4
  },
  {
    postalCode: 2082,
    city: "Berowra Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5827,
    longitude: 151.1221,
    accuracy: 4
  },
  {
    postalCode: 2082,
    city: "Berowra Waters",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6009,
    longitude: 151.1264,
    accuracy: 4
  },
  {
    postalCode: 2082,
    city: "Berowra Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6121,
    longitude: 151.1375,
    accuracy: 4
  },
  {
    postalCode: 2083,
    city: "Cogra Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5198,
    longitude: 151.222,
    accuracy: 4
  },
  {
    postalCode: 2083,
    city: "Dangar Island",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5386,
    longitude: 151.2415,
    accuracy: 4
  },
  {
    postalCode: 2083,
    city: "Cheero Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5096,
    longitude: 151.1932,
    accuracy: 4
  },
  {
    postalCode: 2083,
    city: "Bar Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5122,
    longitude: 151.1622,
    accuracy: 4
  },
  {
    postalCode: 2083,
    city: "Brooklyn",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.549,
    longitude: 151.2249,
    accuracy: 4
  },
  {
    postalCode: 2083,
    city: "Milsons Passage",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5169,
    longitude: 151.1774,
    accuracy: 4
  },
  {
    postalCode: 2083,
    city: "Mooney Mooney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5243,
    longitude: 151.201,
    accuracy: 4
  },
  {
    postalCode: 2084,
    city: "Duffys Forest",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6705,
    longitude: 151.196,
    accuracy: 4
  },
  {
    postalCode: 2084,
    city: "Terrey Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6833,
    longitude: 151.2333,
    accuracy: 4
  },
  {
    postalCode: 2084,
    city: "Cottage Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6197,
    longitude: 151.2036,
    accuracy: 4
  },
  {
    postalCode: 2085,
    city: "Belrose West",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7173,
    longitude: 151.232,
    accuracy: 3
  },
  {
    postalCode: 2085,
    city: "Belrose",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7395,
    longitude: 151.2103,
    accuracy: 4
  },
  {
    postalCode: 2085,
    city: "Davidson",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.743,
    longitude: 151.2008,
    accuracy: 4
  },
  {
    postalCode: 2086,
    city: "Frenchs Forest East",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7482,
    longitude: 151.2232,
    accuracy: 3
  },
  {
    postalCode: 2086,
    city: "Frenchs Forest",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7482,
    longitude: 151.2232,
    accuracy: 4
  },
  {
    postalCode: 2087,
    city: "Killarney Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7745,
    longitude: 151.2203,
    accuracy: 4
  },
  {
    postalCode: 2087,
    city: "Forestville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7667,
    longitude: 151.2083,
    accuracy: 4
  },
  {
    postalCode: 2088,
    city: "Mosman",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.839,
    longitude: 151.2396,
    accuracy: 4
  },
  {
    postalCode: 2088,
    city: "Spit Junction",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8291,
    longitude: 151.2448,
    accuracy: 3
  },
  {
    postalCode: 2089,
    city: "Kurraba Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8424,
    longitude: 151.2226,
    accuracy: 4
  },
  {
    postalCode: 2089,
    city: "Neutral Bay Junction",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8358,
    longitude: 151.2183,
    accuracy: 3
  },
  {
    postalCode: 2089,
    city: "Neutral Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8378,
    longitude: 151.2175,
    accuracy: 4
  },
  {
    postalCode: 2090,
    city: "Cremorne Junction",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.83,
    longitude: 151.2267,
    accuracy: 3
  },
  {
    postalCode: 2090,
    city: "Cremorne Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8401,
    longitude: 151.227,
    accuracy: 4
  },
  {
    postalCode: 2090,
    city: "Cremorne",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8344,
    longitude: 151.2268,
    accuracy: 4
  },
  {
    postalCode: 2091,
    city: "Hmas Penguin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7787,
    longitude: 151.2745,
    accuracy: 1
  },
  {
    postalCode: 2092,
    city: "Seaforth",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8014,
    longitude: 151.2398,
    accuracy: 4
  },
  {
    postalCode: 2093,
    city: "Balgowlah Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8066,
    longitude: 151.2624,
    accuracy: 4
  },
  {
    postalCode: 2093,
    city: "North Balgowlah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7863,
    longitude: 151.248,
    accuracy: 4
  },
  {
    postalCode: 2093,
    city: "Balgowlah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7949,
    longitude: 151.2572,
    accuracy: 4
  },
  {
    postalCode: 2093,
    city: "Manly Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7787,
    longitude: 151.2745,
    accuracy: 3
  },
  {
    postalCode: 2093,
    city: "Clontarf",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8055,
    longitude: 151.2537,
    accuracy: 4
  },
  {
    postalCode: 2094,
    city: "Fairlight",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7957,
    longitude: 151.2735,
    accuracy: 4
  },
  {
    postalCode: 2095,
    city: "Manly",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.798,
    longitude: 151.2883,
    accuracy: 4
  },
  {
    postalCode: 2095,
    city: "Manly East",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.798,
    longitude: 151.2883,
    accuracy: 3
  },
  {
    postalCode: 2096,
    city: "Curl Curl",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7689,
    longitude: 151.2889,
    accuracy: 4
  },
  {
    postalCode: 2096,
    city: "Harbord",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7787,
    longitude: 151.2745,
    accuracy: 3
  },
  {
    postalCode: 2096,
    city: "Queenscliff",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7828,
    longitude: 151.285,
    accuracy: 4
  },
  {
    postalCode: 2096,
    city: "Freshwater",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7787,
    longitude: 151.2857,
    accuracy: 4
  },
  {
    postalCode: 2097,
    city: "Collaroy Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.732,
    longitude: 151.3012,
    accuracy: 4
  },
  {
    postalCode: 2097,
    city: "Wheeler Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7274,
    longitude: 151.2791,
    accuracy: 4
  },
  {
    postalCode: 2097,
    city: "Collaroy",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.732,
    longitude: 151.3012,
    accuracy: 4
  },
  {
    postalCode: 2097,
    city: "Collaroy Plateau",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7293,
    longitude: 151.2865,
    accuracy: 4
  },
  {
    postalCode: 2099,
    city: "Wingala",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7416,
    longitude: 151.2762,
    accuracy: 3
  },
  {
    postalCode: 2099,
    city: "Narraweena",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7552,
    longitude: 151.2766,
    accuracy: 4
  },
  {
    postalCode: 2099,
    city: "Cromer",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7312,
    longitude: 151.2679,
    accuracy: 4
  },
  {
    postalCode: 2099,
    city: "Dee Why",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.75,
    longitude: 151.3,
    accuracy: 4
  },
  {
    postalCode: 2099,
    city: "North Curl Curl",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7623,
    longitude: 151.2898,
    accuracy: 4
  },
  {
    postalCode: 2100,
    city: "Brookvale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7611,
    longitude: 151.2745,
    accuracy: 4
  },
  {
    postalCode: 2100,
    city: "Warringah Mall",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7646,
    longitude: 151.2561,
    accuracy: 3
  },
  {
    postalCode: 2100,
    city: "Beacon Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7528,
    longitude: 151.2586,
    accuracy: 4
  },
  {
    postalCode: 2100,
    city: "Oxford Falls",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.739,
    longitude: 151.2444,
    accuracy: 4
  },
  {
    postalCode: 2100,
    city: "Allambie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7666,
    longitude: 151.2498,
    accuracy: 4
  },
  {
    postalCode: 2100,
    city: "North Manly",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7756,
    longitude: 151.2692,
    accuracy: 4
  },
  {
    postalCode: 2100,
    city: "Allambie Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7666,
    longitude: 151.2498,
    accuracy: 4
  },
  {
    postalCode: 2101,
    city: "Elanora Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7016,
    longitude: 151.2797,
    accuracy: 4
  },
  {
    postalCode: 2101,
    city: "Narrabeen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7128,
    longitude: 151.2974,
    accuracy: 4
  },
  {
    postalCode: 2101,
    city: "North Narrabeen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7093,
    longitude: 151.2961,
    accuracy: 4
  },
  {
    postalCode: 2101,
    city: "Ingleside",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6846,
    longitude: 151.2635,
    accuracy: 4
  },
  {
    postalCode: 2102,
    city: "Warriewood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6886,
    longitude: 151.2953,
    accuracy: 4
  },
  {
    postalCode: 2102,
    city: "Warriewood Shopping Square",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6793,
    longitude: 151.2936,
    accuracy: 3
  },
  {
    postalCode: 2103,
    city: "Mona Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6776,
    longitude: 151.3031,
    accuracy: 4
  },
  {
    postalCode: 2104,
    city: "Bayview",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6598,
    longitude: 151.2988,
    accuracy: 4
  },
  {
    postalCode: 2105,
    city: "Church Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6451,
    longitude: 151.2837,
    accuracy: 4
  },
  {
    postalCode: 2105,
    city: "Morning Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.629,
    longitude: 151.2867,
    accuracy: 4
  },
  {
    postalCode: 2105,
    city: "Elvina Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6397,
    longitude: 151.2777,
    accuracy: 4
  },
  {
    postalCode: 2105,
    city: "Lovett Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6499,
    longitude: 151.283,
    accuracy: 3
  },
  {
    postalCode: 2105,
    city: "Scotland Island",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6407,
    longitude: 151.2875,
    accuracy: 4
  },
  {
    postalCode: 2105,
    city: "Mccarrs Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6344,
    longitude: 151.2889,
    accuracy: 3
  },
  {
    postalCode: 2106,
    city: "Newport",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6552,
    longitude: 151.3213,
    accuracy: 4
  },
  {
    postalCode: 2106,
    city: "Newport Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6569,
    longitude: 151.3155,
    accuracy: 3
  },
  {
    postalCode: 2107,
    city: "Clareville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6297,
    longitude: 151.3168,
    accuracy: 4
  },
  {
    postalCode: 2107,
    city: "Bilgola Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6449,
    longitude: 151.3243,
    accuracy: 4
  },
  {
    postalCode: 2107,
    city: "Whale Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6112,
    longitude: 151.3289,
    accuracy: 4
  },
  {
    postalCode: 2107,
    city: "Bilgola Plateau",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6478,
    longitude: 151.3121,
    accuracy: 4
  },
  {
    postalCode: 2107,
    city: "Careel Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6321,
    longitude: 151.3243,
    accuracy: 3
  },
  {
    postalCode: 2107,
    city: "Avalon Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6359,
    longitude: 151.329,
    accuracy: 4
  },
  {
    postalCode: 2107,
    city: "Bilgola",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6321,
    longitude: 151.3243,
    accuracy: 3
  },
  {
    postalCode: 2108,
    city: "Great Mackerel Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5961,
    longitude: 151.297,
    accuracy: 4
  },
  {
    postalCode: 2108,
    city: "Palm Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5966,
    longitude: 151.3238,
    accuracy: 4
  },
  {
    postalCode: 2108,
    city: "Currawong Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5968,
    longitude: 151.2972,
    accuracy: 4
  },
  {
    postalCode: 2108,
    city: "Coasters Retreat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6061,
    longitude: 151.298,
    accuracy: 4
  },
  {
    postalCode: 2108,
    city: "The Basin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6089,
    longitude: 151.2646,
    accuracy: 3
  },
  {
    postalCode: 2109,
    city: "Macquarie University",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7716,
    longitude: 151.1138,
    accuracy: 1
  },
  {
    postalCode: 2110,
    city: "Hunters Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8343,
    longitude: 151.1459,
    accuracy: 4
  },
  {
    postalCode: 2110,
    city: "Woolwich",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8402,
    longitude: 151.1694,
    accuracy: 4
  },
  {
    postalCode: 2111,
    city: "Henley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8434,
    longitude: 151.1356,
    accuracy: 4
  },
  {
    postalCode: 2111,
    city: "Gladesville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8333,
    longitude: 151.1333,
    accuracy: 4
  },
  {
    postalCode: 2111,
    city: "Huntleys Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8405,
    longitude: 151.1402,
    accuracy: 4
  },
  {
    postalCode: 2111,
    city: "Huntleys Cove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.838,
    longitude: 151.1379,
    accuracy: 4
  },
  {
    postalCode: 2111,
    city: "Tennyson Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8317,
    longitude: 151.1168,
    accuracy: 4
  },
  {
    postalCode: 2111,
    city: "Monash Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8295,
    longitude: 151.1275,
    accuracy: 3
  },
  {
    postalCode: 2111,
    city: "Boronia Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8344,
    longitude: 151.1293,
    accuracy: 3
  },
  {
    postalCode: 2112,
    city: "Ryde",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8188,
    longitude: 151.1062,
    accuracy: 4
  },
  {
    postalCode: 2112,
    city: "Putney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8261,
    longitude: 151.1063,
    accuracy: 4
  },
  {
    postalCode: 2112,
    city: "Denistone East",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.796,
    longitude: 151.0974,
    accuracy: 4
  },
  {
    postalCode: 2113,
    city: "Macquarie Centre",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7912,
    longitude: 151.1298,
    accuracy: 3
  },
  {
    postalCode: 2113,
    city: "East Ryde",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8103,
    longitude: 151.1315,
    accuracy: 4
  },
  {
    postalCode: 2113,
    city: "Macquarie Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.775,
    longitude: 151.1125,
    accuracy: 4
  },
  {
    postalCode: 2113,
    city: "North Ryde",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7968,
    longitude: 151.1244,
    accuracy: 4
  },
  {
    postalCode: 2113,
    city: "Blenheim Road",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7912,
    longitude: 151.1298,
    accuracy: 3
  },
  {
    postalCode: 2114,
    city: "Meadowbank",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8167,
    longitude: 151.0886,
    accuracy: 4
  },
  {
    postalCode: 2114,
    city: "West Ryde",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8054,
    longitude: 151.0739,
    accuracy: 4
  },
  {
    postalCode: 2114,
    city: "Denistone",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7983,
    longitude: 151.0905,
    accuracy: 4
  },
  {
    postalCode: 2114,
    city: "Denistone West",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8005,
    longitude: 151.0762,
    accuracy: 4
  },
  {
    postalCode: 2114,
    city: "Melrose Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8149,
    longitude: 151.0721,
    accuracy: 4
  },
  {
    postalCode: 2115,
    city: "Ermington",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8148,
    longitude: 151.0547,
    accuracy: 4
  },
  {
    postalCode: 2116,
    city: "Rydalmere",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8145,
    longitude: 151.0375,
    accuracy: 4
  },
  {
    postalCode: 2117,
    city: "Dundas",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8058,
    longitude: 151.0339,
    accuracy: 4
  },
  {
    postalCode: 2117,
    city: "Dundas Valley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7883,
    longitude: 151.0526,
    accuracy: 4
  },
  {
    postalCode: 2117,
    city: "Telopea",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7928,
    longitude: 151.0386,
    accuracy: 4
  },
  {
    postalCode: 2117,
    city: "Oatlands",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.796,
    longitude: 151.0271,
    accuracy: 4
  },
  {
    postalCode: 2118,
    city: "Carlingford",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7827,
    longitude: 151.0489,
    accuracy: 4
  },
  {
    postalCode: 2118,
    city: "Carlingford Court",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7776,
    longitude: 151.0418,
    accuracy: 3
  },
  {
    postalCode: 2118,
    city: "Carlingford North",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7722,
    longitude: 151.0172,
    accuracy: 4
  },
  {
    postalCode: 2118,
    city: "Kingsdene",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7776,
    longitude: 151.0418,
    accuracy: 3
  },
  {
    postalCode: 2119,
    city: "Beecroft",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7495,
    longitude: 151.0648,
    accuracy: 4
  },
  {
    postalCode: 2119,
    city: "Cheltenham",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7543,
    longitude: 151.065,
    accuracy: 3
  },
  {
    postalCode: 2120,
    city: "Pennant Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7378,
    longitude: 151.0722,
    accuracy: 4
  },
  {
    postalCode: 2120,
    city: "Thornleigh",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7323,
    longitude: 151.079,
    accuracy: 4
  },
  {
    postalCode: 2120,
    city: "Westleigh",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7118,
    longitude: 151.0714,
    accuracy: 4
  },
  {
    postalCode: 2121,
    city: "Epping",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7727,
    longitude: 151.0818,
    accuracy: 4
  },
  {
    postalCode: 2121,
    city: "North Epping",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7594,
    longitude: 151.0925,
    accuracy: 4
  },
  {
    postalCode: 2122,
    city: "Marsfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7778,
    longitude: 151.1057,
    accuracy: 4
  },
  {
    postalCode: 2122,
    city: "Eastwood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7918,
    longitude: 151.0806,
    accuracy: 4
  },
  {
    postalCode: 2123,
    city: "Parramatta",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8167,
    longitude: 151,
    accuracy: 1
  },
  {
    postalCode: 2124,
    city: "Parramatta",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8167,
    longitude: 151,
    accuracy: 1
  },
  {
    postalCode: 2125,
    city: "West Pennant Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7457,
    longitude: 151.0476,
    accuracy: 4
  },
  {
    postalCode: 2126,
    city: "Cherrybrook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.722,
    longitude: 151.0461,
    accuracy: 4
  },
  {
    postalCode: 2127,
    city: "Sydney Olympic Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8498,
    longitude: 151.0683,
    accuracy: 4
  },
  {
    postalCode: 2127,
    city: "Wentworth Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8308,
    longitude: 151.0744,
    accuracy: 4
  },
  {
    postalCode: 2127,
    city: "Homebush Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8626,
    longitude: 151.0913,
    accuracy: 4
  },
  {
    postalCode: 2127,
    city: "Newington",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8349,
    longitude: 151.057,
    accuracy: 4
  },
  {
    postalCode: 2128,
    city: "Silverwater",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8334,
    longitude: 151.0473,
    accuracy: 4
  },
  {
    postalCode: 2129,
    city: "Sydney Markets",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7838,
    longitude: 151.0564,
    accuracy: 1
  },
  {
    postalCode: 2130,
    city: "Summer Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8915,
    longitude: 151.1382,
    accuracy: 4
  },
  {
    postalCode: 2131,
    city: "Ashfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8883,
    longitude: 151.1227,
    accuracy: 4
  },
  {
    postalCode: 2132,
    city: "Croydon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8833,
    longitude: 151.1167,
    accuracy: 4
  },
  {
    postalCode: 2133,
    city: "Enfield South",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8972,
    longitude: 151.1032,
    accuracy: 1
  },
  {
    postalCode: 2133,
    city: "Croydon Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8972,
    longitude: 151.1032,
    accuracy: 1
  },
  {
    postalCode: 2134,
    city: "Burwood North",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8833,
    longitude: 151.1,
    accuracy: 3
  },
  {
    postalCode: 2134,
    city: "Burwood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8833,
    longitude: 151.1,
    accuracy: 4
  },
  {
    postalCode: 2135,
    city: "Strathfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.881,
    longitude: 151.0799,
    accuracy: 4
  },
  {
    postalCode: 2136,
    city: "Strathfield South",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8925,
    longitude: 151.0833,
    accuracy: 4
  },
  {
    postalCode: 2136,
    city: "Burwood Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8905,
    longitude: 151.1007,
    accuracy: 4
  },
  {
    postalCode: 2136,
    city: "Enfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8657,
    longitude: 151.1042,
    accuracy: 3
  },
  {
    postalCode: 2137,
    city: "Mortlake",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8422,
    longitude: 151.1072,
    accuracy: 4
  },
  {
    postalCode: 2137,
    city: "Breakfast Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8429,
    longitude: 151.1107,
    accuracy: 4
  },
  {
    postalCode: 2137,
    city: "Concord",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8472,
    longitude: 151.1038,
    accuracy: 4
  },
  {
    postalCode: 2137,
    city: "Cabarita",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8472,
    longitude: 151.1164,
    accuracy: 4
  },
  {
    postalCode: 2137,
    city: "North Strathfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8569,
    longitude: 151.0912,
    accuracy: 4
  },
  {
    postalCode: 2138,
    city: "Concord West",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8481,
    longitude: 151.0861,
    accuracy: 4
  },
  {
    postalCode: 2138,
    city: "Rhodes",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8266,
    longitude: 151.0881,
    accuracy: 4
  },
  {
    postalCode: 2138,
    city: "Liberty Grove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8409,
    longitude: 151.084,
    accuracy: 4
  },
  {
    postalCode: 2139,
    city: "Concord Repatriation Hospital",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8657,
    longitude: 151.1042,
    accuracy: 1
  },
  {
    postalCode: 2140,
    city: "Homebush",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8667,
    longitude: 151.0833,
    accuracy: 4
  },
  {
    postalCode: 2140,
    city: "Homebush South",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8667,
    longitude: 151.0833,
    accuracy: 3
  },
  {
    postalCode: 2140,
    city: "Homebush West",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8626,
    longitude: 151.0913,
    accuracy: 4
  },
  {
    postalCode: 2141,
    city: "Rookwood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8742,
    longitude: 151.0557,
    accuracy: 4
  },
  {
    postalCode: 2141,
    city: "Lidcombe North",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8693,
    longitude: 151.0477,
    accuracy: 3
  },
  {
    postalCode: 2141,
    city: "Berala",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.872,
    longitude: 151.0339,
    accuracy: 4
  },
  {
    postalCode: 2141,
    city: "Lidcombe",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8644,
    longitude: 151.0397,
    accuracy: 4
  },
  {
    postalCode: 2142,
    city: "Camellia",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8197,
    longitude: 151.0264,
    accuracy: 4
  },
  {
    postalCode: 2142,
    city: "Blaxcell",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8332,
    longitude: 151.0198,
    accuracy: 3
  },
  {
    postalCode: 2142,
    city: "Granville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8333,
    longitude: 151.0167,
    accuracy: 4
  },
  {
    postalCode: 2142,
    city: "South Granville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8333,
    longitude: 151.0167,
    accuracy: 4
  },
  {
    postalCode: 2142,
    city: "Rosehill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8201,
    longitude: 151.0245,
    accuracy: 4
  },
  {
    postalCode: 2142,
    city: "Clyde",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8333,
    longitude: 151.0167,
    accuracy: 4
  },
  {
    postalCode: 2142,
    city: "Holroyd",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8333,
    longitude: 150.95,
    accuracy: 4
  },
  {
    postalCode: 2143,
    city: "Birrong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8925,
    longitude: 151.0207,
    accuracy: 4
  },
  {
    postalCode: 2143,
    city: "Potts Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8931,
    longitude: 151.0337,
    accuracy: 4
  },
  {
    postalCode: 2143,
    city: "Regents Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8833,
    longitude: 151.0167,
    accuracy: 4
  },
  {
    postalCode: 2144,
    city: "Auburn",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.85,
    longitude: 151.0333,
    accuracy: 4
  },
  {
    postalCode: 2145,
    city: "Wentworthville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8167,
    longitude: 150.9667,
    accuracy: 4
  },
  {
    postalCode: 2145,
    city: "Girraween",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.799,
    longitude: 150.943,
    accuracy: 4
  },
  {
    postalCode: 2145,
    city: "Pemulwuy",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8227,
    longitude: 150.9239,
    accuracy: 4
  },
  {
    postalCode: 2145,
    city: "Westmead",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8038,
    longitude: 150.9877,
    accuracy: 4
  },
  {
    postalCode: 2145,
    city: "Greystanes",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8235,
    longitude: 150.9461,
    accuracy: 4
  },
  {
    postalCode: 2145,
    city: "Mays Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8203,
    longitude: 150.9943,
    accuracy: 4
  },
  {
    postalCode: 2145,
    city: "South Wentworthville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8185,
    longitude: 150.9634,
    accuracy: 4
  },
  {
    postalCode: 2145,
    city: "Pendle Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8,
    longitude: 150.95,
    accuracy: 4
  },
  {
    postalCode: 2145,
    city: "Constitution Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7926,
    longitude: 150.9763,
    accuracy: 4
  },
  {
    postalCode: 2146,
    city: "Toongabbie East",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7898,
    longitude: 150.9562,
    accuracy: 3
  },
  {
    postalCode: 2146,
    city: "Toongabbie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7833,
    longitude: 150.95,
    accuracy: 4
  },
  {
    postalCode: 2146,
    city: "Old Toongabbie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7876,
    longitude: 150.969,
    accuracy: 4
  },
  {
    postalCode: 2147,
    city: "Lalor Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7609,
    longitude: 150.9312,
    accuracy: 4
  },
  {
    postalCode: 2147,
    city: "Seven Hills West",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7684,
    longitude: 150.9365,
    accuracy: 3
  },
  {
    postalCode: 2147,
    city: "Seven Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7833,
    longitude: 150.9333,
    accuracy: 4
  },
  {
    postalCode: 2147,
    city: "Kings Langley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7501,
    longitude: 150.9354,
    accuracy: 4
  },
  {
    postalCode: 2148,
    city: "Prospect",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8015,
    longitude: 150.9136,
    accuracy: 4
  },
  {
    postalCode: 2148,
    city: "Kings Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7432,
    longitude: 150.9076,
    accuracy: 4
  },
  {
    postalCode: 2148,
    city: "Marayong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7482,
    longitude: 150.8927,
    accuracy: 4
  },
  {
    postalCode: 2148,
    city: "Huntingwood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7975,
    longitude: 150.8799,
    accuracy: 4
  },
  {
    postalCode: 2148,
    city: "Blacktown",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7667,
    longitude: 150.9167,
    accuracy: 4
  },
  {
    postalCode: 2148,
    city: "Blacktown Westpoint",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7896,
    longitude: 150.9,
    accuracy: 3
  },
  {
    postalCode: 2148,
    city: "Arndell Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7893,
    longitude: 150.8816,
    accuracy: 4
  },
  {
    postalCode: 2150,
    city: "Parramatta",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8197,
    longitude: 151.0067,
    accuracy: 3
  },
  {
    postalCode: 2150,
    city: "Harris Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8229,
    longitude: 151.0078,
    accuracy: 4
  },
  {
    postalCode: 2150,
    city: "Parramatta Westfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8197,
    longitude: 151.0067,
    accuracy: 3
  },
  {
    postalCode: 2151,
    city: "North Parramatta",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7935,
    longitude: 151.0012,
    accuracy: 4
  },
  {
    postalCode: 2151,
    city: "North Rocks",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7722,
    longitude: 151.0172,
    accuracy: 4
  },
  {
    postalCode: 2152,
    city: "Northmead",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7833,
    longitude: 150.9833,
    accuracy: 4
  },
  {
    postalCode: 2153,
    city: "Winston Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7764,
    longitude: 150.9805,
    accuracy: 4
  },
  {
    postalCode: 2153,
    city: "Bella Vista",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7413,
    longitude: 150.9546,
    accuracy: 4
  },
  {
    postalCode: 2153,
    city: "Baulkham Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7588,
    longitude: 150.9929,
    accuracy: 4
  },
  {
    postalCode: 2154,
    city: "Castle Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7333,
    longitude: 151,
    accuracy: 4
  },
  {
    postalCode: 2155,
    city: "Rouse Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6821,
    longitude: 150.9154,
    accuracy: 4
  },
  {
    postalCode: 2155,
    city: "Beaumont Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6999,
    longitude: 150.9411,
    accuracy: 4
  },
  {
    postalCode: 2155,
    city: "Kellyville Ridge",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7013,
    longitude: 150.9231,
    accuracy: 4
  },
  {
    postalCode: 2155,
    city: "Kellyville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6994,
    longitude: 150.9536,
    accuracy: 4
  },
  {
    postalCode: 2156,
    city: "Annangrove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6576,
    longitude: 150.9476,
    accuracy: 4
  },
  {
    postalCode: 2156,
    city: "Glenhaven",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7,
    longitude: 151,
    accuracy: 4
  },
  {
    postalCode: 2156,
    city: "Kenthurst",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6553,
    longitude: 151.005,
    accuracy: 4
  },
  {
    postalCode: 2157,
    city: "Glenorie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6018,
    longitude: 151.0089,
    accuracy: 4
  },
  {
    postalCode: 2157,
    city: "Forest Glen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5502,
    longitude: 151.0138,
    accuracy: 4
  },
  {
    postalCode: 2157,
    city: "Canoelands",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5,
    longitude: 151.0667,
    accuracy: 4
  },
  {
    postalCode: 2158,
    city: "Round Corner",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6771,
    longitude: 151.0339,
    accuracy: 3
  },
  {
    postalCode: 2158,
    city: "Dural",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6833,
    longitude: 151.0167,
    accuracy: 4
  },
  {
    postalCode: 2158,
    city: "Middle Dural",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.646,
    longitude: 151.0205,
    accuracy: 4
  },
  {
    postalCode: 2159,
    city: "Galston",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.653,
    longitude: 151.0471,
    accuracy: 4
  },
  {
    postalCode: 2159,
    city: "Arcadia",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6167,
    longitude: 151.0333,
    accuracy: 4
  },
  {
    postalCode: 2159,
    city: "Berrilee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6155,
    longitude: 151.0914,
    accuracy: 4
  },
  {
    postalCode: 2159,
    city: "Fiddletown",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6,
    longitude: 151.05,
    accuracy: 4
  },
  {
    postalCode: 2160,
    city: "Merrylands",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8333,
    longitude: 150.9833,
    accuracy: 4
  },
  {
    postalCode: 2160,
    city: "Merrylands West",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8327,
    longitude: 150.9691,
    accuracy: 4
  },
  {
    postalCode: 2161,
    city: "Guildford",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8643,
    longitude: 150.9839,
    accuracy: 3
  },
  {
    postalCode: 2161,
    city: "Old Guildford",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8643,
    longitude: 150.9839,
    accuracy: 4
  },
  {
    postalCode: 2161,
    city: "Yennora",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8617,
    longitude: 150.9686,
    accuracy: 4
  },
  {
    postalCode: 2161,
    city: "Guildford West",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8524,
    longitude: 150.974,
    accuracy: 4
  },
  {
    postalCode: 2162,
    city: "Chester Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.879,
    longitude: 150.9995,
    accuracy: 4
  },
  {
    postalCode: 2162,
    city: "Sefton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8877,
    longitude: 151.0105,
    accuracy: 4
  },
  {
    postalCode: 2163,
    city: "Lansdowne",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.896,
    longitude: 150.9756,
    accuracy: 4
  },
  {
    postalCode: 2163,
    city: "Carramar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8838,
    longitude: 150.9615,
    accuracy: 4
  },
  {
    postalCode: 2163,
    city: "Villawood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8833,
    longitude: 150.9667,
    accuracy: 4
  },
  {
    postalCode: 2164,
    city: "Smithfield West",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8667,
    longitude: 150.917,
    accuracy: 4
  },
  {
    postalCode: 2164,
    city: "Smithfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.85,
    longitude: 150.9333,
    accuracy: 4
  },
  {
    postalCode: 2164,
    city: "Woodpark",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8414,
    longitude: 150.9605,
    accuracy: 4
  },
  {
    postalCode: 2164,
    city: "Wetherill Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8428,
    longitude: 150.9006,
    accuracy: 4
  },
  {
    postalCode: 2165,
    city: "Fairfield West",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8667,
    longitude: 150.917,
    accuracy: 4
  },
  {
    postalCode: 2165,
    city: "Fairfield East",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8694,
    longitude: 150.9713,
    accuracy: 4
  },
  {
    postalCode: 2165,
    city: "Fairfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8667,
    longitude: 150.95,
    accuracy: 4
  },
  {
    postalCode: 2165,
    city: "Fairfield Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8644,
    longitude: 150.9388,
    accuracy: 4
  },
  {
    postalCode: 2166,
    city: "Canley Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8866,
    longitude: 150.948,
    accuracy: 4
  },
  {
    postalCode: 2166,
    city: "Cabramatta",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8974,
    longitude: 150.9345,
    accuracy: 4
  },
  {
    postalCode: 2166,
    city: "Cabramatta West",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8967,
    longitude: 150.9106,
    accuracy: 4
  },
  {
    postalCode: 2166,
    city: "Lansvale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9014,
    longitude: 150.9637,
    accuracy: 4
  },
  {
    postalCode: 2166,
    city: "Canley Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8826,
    longitude: 150.9241,
    accuracy: 4
  },
  {
    postalCode: 2167,
    city: "Glenfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9667,
    longitude: 150.9,
    accuracy: 4
  },
  {
    postalCode: 2168,
    city: "Green Valley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9029,
    longitude: 150.8671,
    accuracy: 4
  },
  {
    postalCode: 2168,
    city: "Ashcroft",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.916,
    longitude: 150.8999,
    accuracy: 4
  },
  {
    postalCode: 2168,
    city: "Heckenberg",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9083,
    longitude: 150.8898,
    accuracy: 4
  },
  {
    postalCode: 2168,
    city: "Busby",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9112,
    longitude: 150.8807,
    accuracy: 4
  },
  {
    postalCode: 2168,
    city: "Cartwright",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.925,
    longitude: 150.8895,
    accuracy: 4
  },
  {
    postalCode: 2168,
    city: "Miller",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9209,
    longitude: 150.8847,
    accuracy: 4
  },
  {
    postalCode: 2168,
    city: "Hinchinbrook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9188,
    longitude: 150.8631,
    accuracy: 4
  },
  {
    postalCode: 2168,
    city: "Sadleir",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9171,
    longitude: 150.8909,
    accuracy: 4
  },
  {
    postalCode: 2170,
    city: "Casula",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9522,
    longitude: 150.8995,
    accuracy: 4
  },
  {
    postalCode: 2170,
    city: "Lurnea",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9354,
    longitude: 150.8967,
    accuracy: 4
  },
  {
    postalCode: 2170,
    city: "Hammondville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9483,
    longitude: 150.9521,
    accuracy: 4
  },
  {
    postalCode: 2170,
    city: "Liverpool South",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9,
    longitude: 150.9333,
    accuracy: 3
  },
  {
    postalCode: 2170,
    city: "Chipping Norton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9,
    longitude: 150.95,
    accuracy: 4
  },
  {
    postalCode: 2170,
    city: "Casula Mall",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.934,
    longitude: 150.9122,
    accuracy: 3
  },
  {
    postalCode: 2170,
    city: "Mount Pritchard",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.903,
    longitude: 150.9046,
    accuracy: 4
  },
  {
    postalCode: 2170,
    city: "Liverpool",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9,
    longitude: 150.9333,
    accuracy: 4
  },
  {
    postalCode: 2170,
    city: "Moorebank",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9425,
    longitude: 150.9377,
    accuracy: 4
  },
  {
    postalCode: 2170,
    city: "Liverpool Westfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9239,
    longitude: 150.9224,
    accuracy: 3
  },
  {
    postalCode: 2170,
    city: "Prestons",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9419,
    longitude: 150.8717,
    accuracy: 4
  },
  {
    postalCode: 2170,
    city: "Warwick Farm",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9129,
    longitude: 150.937,
    accuracy: 4
  },
  {
    postalCode: 2171,
    city: "Hoxton Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9313,
    longitude: 150.8541,
    accuracy: 4
  },
  {
    postalCode: 2171,
    city: "Carnes Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9385,
    longitude: 150.8488,
    accuracy: 4
  },
  {
    postalCode: 2171,
    city: "Cecil Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8892,
    longitude: 150.8514,
    accuracy: 4
  },
  {
    postalCode: 2171,
    city: "West Hoxton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9167,
    longitude: 150.85,
    accuracy: 4
  },
  {
    postalCode: 2171,
    city: "Len Waters Estate",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9201,
    longitude: 150.8502,
    accuracy: 3
  },
  {
    postalCode: 2171,
    city: "Horningsea Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9434,
    longitude: 150.8453,
    accuracy: 4
  },
  {
    postalCode: 2171,
    city: "Elizabeth Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9201,
    longitude: 150.8502,
    accuracy: 3
  },
  {
    postalCode: 2171,
    city: "Middleton Grange",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.917,
    longitude: 150.8419,
    accuracy: 4
  },
  {
    postalCode: 2172,
    city: "Sandy Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0628,
    longitude: 149.8635,
    accuracy: 4
  },
  {
    postalCode: 2172,
    city: "Voyager Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9587,
    longitude: 150.9742,
    accuracy: 4
  },
  {
    postalCode: 2172,
    city: "Pleasure Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9699,
    longitude: 150.9839,
    accuracy: 4
  },
  {
    postalCode: 2173,
    city: "Holsworthy",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9833,
    longitude: 150.9667,
    accuracy: 4
  },
  {
    postalCode: 2173,
    city: "Wattle Grove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9544,
    longitude: 150.9445,
    accuracy: 4
  },
  {
    postalCode: 2174,
    city: "Edmondson Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9569,
    longitude: 150.8613,
    accuracy: 4
  },
  {
    postalCode: 2175,
    city: "Horsley Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8432,
    longitude: 150.8489,
    accuracy: 4
  },
  {
    postalCode: 2176,
    city: "Bossley Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8618,
    longitude: 150.8841,
    accuracy: 4
  },
  {
    postalCode: 2176,
    city: "Abbotsbury",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8701,
    longitude: 150.8612,
    accuracy: 4
  },
  {
    postalCode: 2176,
    city: "St Johns Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.883,
    longitude: 150.9018,
    accuracy: 4
  },
  {
    postalCode: 2176,
    city: "Greenfield Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8746,
    longitude: 150.8919,
    accuracy: 4
  },
  {
    postalCode: 2176,
    city: "Prairiewood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8632,
    longitude: 150.9052,
    accuracy: 4
  },
  {
    postalCode: 2176,
    city: "Wakeley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8743,
    longitude: 150.9098,
    accuracy: 4
  },
  {
    postalCode: 2176,
    city: "Edensor Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8797,
    longitude: 150.8778,
    accuracy: 4
  },
  {
    postalCode: 2177,
    city: "Bonnyrigg Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8912,
    longitude: 150.8699,
    accuracy: 4
  },
  {
    postalCode: 2177,
    city: "Bonnyrigg",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8936,
    longitude: 150.8891,
    accuracy: 4
  },
  {
    postalCode: 2178,
    city: "Kemps Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8806,
    longitude: 150.7876,
    accuracy: 4
  },
  {
    postalCode: 2178,
    city: "Mount Vernon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8604,
    longitude: 150.8101,
    accuracy: 4
  },
  {
    postalCode: 2178,
    city: "Cecil Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8743,
    longitude: 150.8418,
    accuracy: 4
  },
  {
    postalCode: 2179,
    city: "Austral",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9274,
    longitude: 150.8081,
    accuracy: 4
  },
  {
    postalCode: 2179,
    city: "Leppington",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9698,
    longitude: 150.7967,
    accuracy: 4
  },
  {
    postalCode: 2190,
    city: "Mount Lewis",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9175,
    longitude: 151.0483,
    accuracy: 4
  },
  {
    postalCode: 2190,
    city: "Greenacre",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9003,
    longitude: 151.0556,
    accuracy: 4
  },
  {
    postalCode: 2190,
    city: "Chullora",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9,
    longitude: 151.05,
    accuracy: 4
  },
  {
    postalCode: 2191,
    city: "Belfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9035,
    longitude: 151.0847,
    accuracy: 4
  },
  {
    postalCode: 2192,
    city: "Belmore",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.919,
    longitude: 151.0894,
    accuracy: 4
  },
  {
    postalCode: 2193,
    city: "Hurlstone Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9099,
    longitude: 151.1287,
    accuracy: 4
  },
  {
    postalCode: 2193,
    city: "Canterbury",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9119,
    longitude: 151.1186,
    accuracy: 4
  },
  {
    postalCode: 2193,
    city: "Ashbury",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8978,
    longitude: 151.1196,
    accuracy: 4
  },
  {
    postalCode: 2194,
    city: "Campsie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9125,
    longitude: 151.1028,
    accuracy: 4
  },
  {
    postalCode: 2195,
    city: "Wiley Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9242,
    longitude: 151.0674,
    accuracy: 4
  },
  {
    postalCode: 2195,
    city: "Lakemba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9197,
    longitude: 151.0759,
    accuracy: 4
  },
  {
    postalCode: 2196,
    city: "Roselands",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9332,
    longitude: 151.0732,
    accuracy: 4
  },
  {
    postalCode: 2196,
    city: "Punchbowl",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9289,
    longitude: 151.0511,
    accuracy: 4
  },
  {
    postalCode: 2197,
    city: "Bass Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8986,
    longitude: 150.9954,
    accuracy: 4
  },
  {
    postalCode: 2198,
    city: "Georges Hall",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9088,
    longitude: 150.9885,
    accuracy: 4
  },
  {
    postalCode: 2199,
    city: "Yagoona",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9049,
    longitude: 151.02,
    accuracy: 4
  },
  {
    postalCode: 2199,
    city: "Yagoona West",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9021,
    longitude: 151.0223,
    accuracy: 3
  },
  {
    postalCode: 2200,
    city: "Condell Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9246,
    longitude: 151.0109,
    accuracy: 4
  },
  {
    postalCode: 2200,
    city: "Mount Lewis",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9175,
    longitude: 151.0483,
    accuracy: 4
  },
  {
    postalCode: 2200,
    city: "Bankstown Square",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9224,
    longitude: 151.0231,
    accuracy: 3
  },
  {
    postalCode: 2200,
    city: "Bankstown Aerodrome",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9206,
    longitude: 151.0221,
    accuracy: 3
  },
  {
    postalCode: 2200,
    city: "Bankstown North",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9224,
    longitude: 151.0231,
    accuracy: 3
  },
  {
    postalCode: 2200,
    city: "Manahan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9224,
    longitude: 151.0231,
    accuracy: 3
  },
  {
    postalCode: 2200,
    city: "Bankstown",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9167,
    longitude: 151.0333,
    accuracy: 4
  },
  {
    postalCode: 2203,
    city: "Dulwich Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9041,
    longitude: 151.1394,
    accuracy: 4
  },
  {
    postalCode: 2204,
    city: "Marrickville Metro",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9112,
    longitude: 151.1557,
    accuracy: 3
  },
  {
    postalCode: 2204,
    city: "Marrickville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9032,
    longitude: 151.1518,
    accuracy: 4
  },
  {
    postalCode: 2204,
    city: "Marrickville South",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9032,
    longitude: 151.1518,
    accuracy: 3
  },
  {
    postalCode: 2205,
    city: "Turrella",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9303,
    longitude: 151.1421,
    accuracy: 4
  },
  {
    postalCode: 2205,
    city: "Wolli Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9313,
    longitude: 151.1522,
    accuracy: 4
  },
  {
    postalCode: 2205,
    city: "Arncliffe",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9363,
    longitude: 151.1482,
    accuracy: 4
  },
  {
    postalCode: 2206,
    city: "Earlwood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.95,
    longitude: 151.1,
    accuracy: 4
  },
  {
    postalCode: 2206,
    city: "Undercliffe",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9331,
    longitude: 151.1111,
    accuracy: 3
  },
  {
    postalCode: 2206,
    city: "Clemton Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9348,
    longitude: 151.0905,
    accuracy: 4
  },
  {
    postalCode: 2207,
    city: "Bexley South",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.95,
    longitude: 151.1167,
    accuracy: 3
  },
  {
    postalCode: 2207,
    city: "Bexley North",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9385,
    longitude: 151.1139,
    accuracy: 4
  },
  {
    postalCode: 2207,
    city: "Bexley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.95,
    longitude: 151.1167,
    accuracy: 4
  },
  {
    postalCode: 2207,
    city: "Bardwell Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9353,
    longitude: 151.1257,
    accuracy: 4
  },
  {
    postalCode: 2207,
    city: "Bardwell Valley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9334,
    longitude: 151.1367,
    accuracy: 4
  },
  {
    postalCode: 2208,
    city: "Kingsway West",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9331,
    longitude: 151.1111,
    accuracy: 3
  },
  {
    postalCode: 2208,
    city: "Kingsgrove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9393,
    longitude: 151.0993,
    accuracy: 4
  },
  {
    postalCode: 2209,
    city: "Beverly Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.948,
    longitude: 151.0798,
    accuracy: 4
  },
  {
    postalCode: 2209,
    city: "Narwee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9465,
    longitude: 151.0692,
    accuracy: 4
  },
  {
    postalCode: 2210,
    city: "Peakhurst",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9629,
    longitude: 151.0516,
    accuracy: 4
  },
  {
    postalCode: 2210,
    city: "Peakhurst Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9774,
    longitude: 151.0556,
    accuracy: 4
  },
  {
    postalCode: 2210,
    city: "Lugarno",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9827,
    longitude: 151.0418,
    accuracy: 4
  },
  {
    postalCode: 2210,
    city: "Riverwood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9473,
    longitude: 151.0497,
    accuracy: 4
  },
  {
    postalCode: 2211,
    city: "Padstow Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9674,
    longitude: 151.0399,
    accuracy: 4
  },
  {
    postalCode: 2211,
    city: "Padstow",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9569,
    longitude: 151.0319,
    accuracy: 4
  },
  {
    postalCode: 2212,
    city: "Revesby Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9671,
    longitude: 151.0184,
    accuracy: 4
  },
  {
    postalCode: 2212,
    city: "Revesby",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.95,
    longitude: 151.0167,
    accuracy: 4
  },
  {
    postalCode: 2212,
    city: "Revesby North",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9498,
    longitude: 151.0148,
    accuracy: 3
  },
  {
    postalCode: 2213,
    city: "Panania",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9537,
    longitude: 150.9973,
    accuracy: 4
  },
  {
    postalCode: 2213,
    city: "East Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9667,
    longitude: 150.9833,
    accuracy: 4
  },
  {
    postalCode: 2213,
    city: "Picnic Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9806,
    longitude: 150.9966,
    accuracy: 4
  },
  {
    postalCode: 2214,
    city: "Milperra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9393,
    longitude: 150.9815,
    accuracy: 4
  },
  {
    postalCode: 2216,
    city: "Rockdale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.95,
    longitude: 151.1333,
    accuracy: 4
  },
  {
    postalCode: 2216,
    city: "Kyeemagh",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9513,
    longitude: 151.162,
    accuracy: 4
  },
  {
    postalCode: 2216,
    city: "Brighton-Le-Sands",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9601,
    longitude: 151.1511,
    accuracy: 4
  },
  {
    postalCode: 2216,
    city: "Banksia",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.946,
    longitude: 151.143,
    accuracy: 4
  },
  {
    postalCode: 2217,
    city: "Beverley Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9736,
    longitude: 151.1373,
    accuracy: 3
  },
  {
    postalCode: 2217,
    city: "Ramsgate Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9852,
    longitude: 151.1463,
    accuracy: 4
  },
  {
    postalCode: 2217,
    city: "Kogarah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9833,
    longitude: 151.1167,
    accuracy: 4
  },
  {
    postalCode: 2217,
    city: "Kogarah Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9795,
    longitude: 151.1212,
    accuracy: 4
  },
  {
    postalCode: 2217,
    city: "Monterey",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9725,
    longitude: 151.1481,
    accuracy: 4
  },
  {
    postalCode: 2217,
    city: "Ramsgate",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9822,
    longitude: 151.14,
    accuracy: 4
  },
  {
    postalCode: 2218,
    city: "Allawah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9726,
    longitude: 151.1144,
    accuracy: 4
  },
  {
    postalCode: 2218,
    city: "Carlton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9711,
    longitude: 151.1214,
    accuracy: 4
  },
  {
    postalCode: 2219,
    city: "Dolls Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.995,
    longitude: 151.1455,
    accuracy: 4
  },
  {
    postalCode: 2219,
    city: "Sans Souci",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9979,
    longitude: 151.1293,
    accuracy: 4
  },
  {
    postalCode: 2219,
    city: "Sandringham",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9956,
    longitude: 151.14,
    accuracy: 4
  },
  {
    postalCode: 2220,
    city: "Hurstville Grove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9799,
    longitude: 151.0903,
    accuracy: 4
  },
  {
    postalCode: 2220,
    city: "Hurstville Westfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9642,
    longitude: 151.0991,
    accuracy: 3
  },
  {
    postalCode: 2220,
    city: "Hurstville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9799,
    longitude: 151.0903,
    accuracy: 4
  },
  {
    postalCode: 2221,
    city: "Blakehurst",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9915,
    longitude: 151.1088,
    accuracy: 4
  },
  {
    postalCode: 2221,
    city: "Kyle Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9879,
    longitude: 151.0994,
    accuracy: 4
  },
  {
    postalCode: 2221,
    city: "Carss Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9867,
    longitude: 151.1173,
    accuracy: 4
  },
  {
    postalCode: 2221,
    city: "South Hurstville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9776,
    longitude: 151.1055,
    accuracy: 4
  },
  {
    postalCode: 2221,
    city: "Connells Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9883,
    longitude: 151.0909,
    accuracy: 4
  },
  {
    postalCode: 2222,
    city: "Penshurst",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9667,
    longitude: 151.0833,
    accuracy: 4
  },
  {
    postalCode: 2223,
    city: "Mortdale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9667,
    longitude: 151.0833,
    accuracy: 4
  },
  {
    postalCode: 2223,
    city: "Oatley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.98,
    longitude: 151.072,
    accuracy: 4
  },
  {
    postalCode: 2224,
    city: "Kangaroo Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0026,
    longitude: 151.0959,
    accuracy: 4
  },
  {
    postalCode: 2224,
    city: "Sylvania",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0124,
    longitude: 151.0972,
    accuracy: 4
  },
  {
    postalCode: 2224,
    city: "Sylvania Southgate",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.01,
    longitude: 151.0947,
    accuracy: 3
  },
  {
    postalCode: 2224,
    city: "Sylvania Waters",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0184,
    longitude: 151.1056,
    accuracy: 4
  },
  {
    postalCode: 2225,
    city: "Oyster Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0041,
    longitude: 151.0759,
    accuracy: 4
  },
  {
    postalCode: 2226,
    city: "Jannali",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0164,
    longitude: 151.0607,
    accuracy: 4
  },
  {
    postalCode: 2226,
    city: "Como",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9994,
    longitude: 151.0639,
    accuracy: 4
  },
  {
    postalCode: 2226,
    city: "Bonnet Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0083,
    longitude: 151.0519,
    accuracy: 4
  },
  {
    postalCode: 2227,
    city: "Gymea Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0521,
    longitude: 151.088,
    accuracy: 4
  },
  {
    postalCode: 2227,
    city: "Gymea",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0364,
    longitude: 151.0853,
    accuracy: 4
  },
  {
    postalCode: 2228,
    city: "Miranda",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0386,
    longitude: 151.1001,
    accuracy: 4
  },
  {
    postalCode: 2228,
    city: "Yowie Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0512,
    longitude: 151.1023,
    accuracy: 4
  },
  {
    postalCode: 2229,
    city: "Taren Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0194,
    longitude: 151.1183,
    accuracy: 4
  },
  {
    postalCode: 2229,
    city: "Caringbah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0473,
    longitude: 151.1205,
    accuracy: 4
  },
  {
    postalCode: 2229,
    city: "Caringbah South",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0566,
    longitude: 151.1215,
    accuracy: 4
  },
  {
    postalCode: 2229,
    city: "Port Hacking",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0679,
    longitude: 151.1256,
    accuracy: 4
  },
  {
    postalCode: 2229,
    city: "Dolans Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0665,
    longitude: 151.1281,
    accuracy: 4
  },
  {
    postalCode: 2229,
    city: "Lilli Pilli",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0683,
    longitude: 151.1157,
    accuracy: 4
  },
  {
    postalCode: 2230,
    city: "Greenhills Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0328,
    longitude: 151.1762,
    accuracy: 4
  },
  {
    postalCode: 2230,
    city: "Burraneer",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0562,
    longitude: 151.1381,
    accuracy: 4
  },
  {
    postalCode: 2230,
    city: "Maianbar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0837,
    longitude: 151.1241,
    accuracy: 4
  },
  {
    postalCode: 2230,
    city: "Woolooware",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0458,
    longitude: 151.1431,
    accuracy: 4
  },
  {
    postalCode: 2230,
    city: "Bundeena",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0838,
    longitude: 151.1502,
    accuracy: 4
  },
  {
    postalCode: 2230,
    city: "Cronulla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0625,
    longitude: 151.1496,
    accuracy: 4
  },
  {
    postalCode: 2231,
    city: "Kurnell",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0109,
    longitude: 151.2051,
    accuracy: 4
  },
  {
    postalCode: 2232,
    city: "Audley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.106,
    longitude: 151.0832,
    accuracy: 3
  },
  {
    postalCode: 2232,
    city: "Sutherland",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.031,
    longitude: 151.0553,
    accuracy: 4
  },
  {
    postalCode: 2232,
    city: "Loftus",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0447,
    longitude: 151.0465,
    accuracy: 4
  },
  {
    postalCode: 2232,
    city: "Kirrawee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0383,
    longitude: 151.069,
    accuracy: 4
  },
  {
    postalCode: 2232,
    city: "Woronora",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0244,
    longitude: 151.0386,
    accuracy: 4
  },
  {
    postalCode: 2232,
    city: "Kareela",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0134,
    longitude: 151.0835,
    accuracy: 4
  },
  {
    postalCode: 2232,
    city: "Grays Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0587,
    longitude: 151.086,
    accuracy: 4
  },
  {
    postalCode: 2233,
    city: "Waterfall",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1357,
    longitude: 150.9923,
    accuracy: 4
  },
  {
    postalCode: 2233,
    city: "Woronora Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0356,
    longitude: 151.0273,
    accuracy: 4
  },
  {
    postalCode: 2233,
    city: "Heathcote",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0841,
    longitude: 151.013,
    accuracy: 4
  },
  {
    postalCode: 2233,
    city: "Yarrawarrah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0535,
    longitude: 151.0356,
    accuracy: 4
  },
  {
    postalCode: 2233,
    city: "Engadine",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0656,
    longitude: 151.0127,
    accuracy: 4
  },
  {
    postalCode: 2234,
    city: "Lucas Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.06,
    longitude: 150.9807,
    accuracy: 3
  },
  {
    postalCode: 2234,
    city: "Illawong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34,
    longitude: 151.0333,
    accuracy: 4
  },
  {
    postalCode: 2234,
    city: "Menai Central",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.06,
    longitude: 150.9807,
    accuracy: 3
  },
  {
    postalCode: 2234,
    city: "Menai",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0167,
    longitude: 151.0167,
    accuracy: 4
  },
  {
    postalCode: 2234,
    city: "Bangor",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0167,
    longitude: 151.0333,
    accuracy: 4
  },
  {
    postalCode: 2234,
    city: "Alfords Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9874,
    longitude: 151.0253,
    accuracy: 4
  },
  {
    postalCode: 2234,
    city: "Barden Ridge",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0341,
    longitude: 151.0119,
    accuracy: 4
  },
  {
    postalCode: 2250,
    city: "Wyoming",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4039,
    longitude: 151.3625,
    accuracy: 4
  },
  {
    postalCode: 2250,
    city: "Somersby",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3667,
    longitude: 151.2833,
    accuracy: 4
  },
  {
    postalCode: 2250,
    city: "West Gosford",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4258,
    longitude: 151.317,
    accuracy: 4
  },
  {
    postalCode: 2250,
    city: "Mount Elliot",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4009,
    longitude: 151.3879,
    accuracy: 4
  },
  {
    postalCode: 2250,
    city: "Erina",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4322,
    longitude: 151.3897,
    accuracy: 4
  },
  {
    postalCode: 2250,
    city: "Niagara Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3764,
    longitude: 151.3486,
    accuracy: 4
  },
  {
    postalCode: 2250,
    city: "Central Mangrove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.293,
    longitude: 151.2387,
    accuracy: 4
  },
  {
    postalCode: 2250,
    city: "Mangrove Mountain",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3,
    longitude: 151.2,
    accuracy: 4
  },
  {
    postalCode: 2250,
    city: "Glenworth Valley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4333,
    longitude: 151.1833,
    accuracy: 4
  },
  {
    postalCode: 2250,
    city: "Kariong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4397,
    longitude: 151.2945,
    accuracy: 4
  },
  {
    postalCode: 2250,
    city: "Narara",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4,
    longitude: 151.35,
    accuracy: 4
  },
  {
    postalCode: 2250,
    city: "Tascott",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4502,
    longitude: 151.3137,
    accuracy: 4
  },
  {
    postalCode: 2250,
    city: "Peats Ridge",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3167,
    longitude: 151.2333,
    accuracy: 4
  },
  {
    postalCode: 2250,
    city: "Mount White",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4532,
    longitude: 151.2004,
    accuracy: 4
  },
  {
    postalCode: 2250,
    city: "Kulnura",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.205,
    longitude: 151.1759,
    accuracy: 4
  },
  {
    postalCode: 2250,
    city: "Springfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4294,
    longitude: 151.3574,
    accuracy: 4
  },
  {
    postalCode: 2250,
    city: "Point Clare",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4438,
    longitude: 151.3273,
    accuracy: 4
  },
  {
    postalCode: 2250,
    city: "Mooney Mooney Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4826,
    longitude: 151.2275,
    accuracy: 4
  },
  {
    postalCode: 2250,
    city: "Lisarow",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3833,
    longitude: 151.3667,
    accuracy: 4
  },
  {
    postalCode: 2250,
    city: "Gosford",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4244,
    longitude: 151.344,
    accuracy: 4
  },
  {
    postalCode: 2250,
    city: "East Gosford",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4387,
    longitude: 151.3534,
    accuracy: 4
  },
  {
    postalCode: 2250,
    city: "Mangrove Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.35,
    longitude: 151.15,
    accuracy: 4
  },
  {
    postalCode: 2250,
    city: "Upper Mangrove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2833,
    longitude: 151.1167,
    accuracy: 4
  },
  {
    postalCode: 2250,
    city: "North Gosford",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.389,
    longitude: 151.2859,
    accuracy: 3
  },
  {
    postalCode: 2250,
    city: "Matcham",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4167,
    longitude: 151.4167,
    accuracy: 4
  },
  {
    postalCode: 2250,
    city: "Ten Mile Hollow",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.389,
    longitude: 151.2859,
    accuracy: 3
  },
  {
    postalCode: 2250,
    city: "Erina Fair",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3232,
    longitude: 151.2282,
    accuracy: 3
  },
  {
    postalCode: 2250,
    city: "Point Frederick",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4404,
    longitude: 151.3432,
    accuracy: 4
  },
  {
    postalCode: 2250,
    city: "Holgate",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4,
    longitude: 151.4167,
    accuracy: 4
  },
  {
    postalCode: 2250,
    city: "Bucketty",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.389,
    longitude: 151.2859,
    accuracy: 3
  },
  {
    postalCode: 2250,
    city: "Lower Mangrove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4,
    longitude: 151.15,
    accuracy: 4
  },
  {
    postalCode: 2250,
    city: "Wendoree Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4566,
    longitude: 151.1675,
    accuracy: 4
  },
  {
    postalCode: 2250,
    city: "Greengrove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3833,
    longitude: 151.15,
    accuracy: 4
  },
  {
    postalCode: 2250,
    city: "Calga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4312,
    longitude: 151.2275,
    accuracy: 4
  },
  {
    postalCode: 2251,
    city: "Picketts Valley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4553,
    longitude: 151.4109,
    accuracy: 4
  },
  {
    postalCode: 2251,
    city: "Bouddi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.518,
    longitude: 151.3858,
    accuracy: 4
  },
  {
    postalCode: 2251,
    city: "Davistown",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4856,
    longitude: 151.3615,
    accuracy: 4
  },
  {
    postalCode: 2251,
    city: "Copacabana",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4869,
    longitude: 151.4359,
    accuracy: 4
  },
  {
    postalCode: 2251,
    city: "Green Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.2493,
    longitude: 152.5176,
    accuracy: 4
  },
  {
    postalCode: 2251,
    city: "Yattalunga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4809,
    longitude: 151.3966,
    accuracy: 3
  },
  {
    postalCode: 2251,
    city: "Kincumber",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4674,
    longitude: 151.381,
    accuracy: 4
  },
  {
    postalCode: 2251,
    city: "Macmasters Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4966,
    longitude: 151.4221,
    accuracy: 4
  },
  {
    postalCode: 2251,
    city: "Avoca Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4682,
    longitude: 151.4339,
    accuracy: 4
  },
  {
    postalCode: 2251,
    city: "Saratoga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4756,
    longitude: 151.3521,
    accuracy: 4
  },
  {
    postalCode: 2251,
    city: "Bensville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4976,
    longitude: 151.3808,
    accuracy: 4
  },
  {
    postalCode: 2251,
    city: "Kincumber South",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4866,
    longitude: 151.377,
    accuracy: 4
  },
  {
    postalCode: 2252,
    city: "Central Coast Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.344,
    longitude: 151.382,
    accuracy: 1
  },
  {
    postalCode: 2256,
    city: "Horsfield Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4924,
    longitude: 151.301,
    accuracy: 4
  },
  {
    postalCode: 2256,
    city: "Phegans Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4878,
    longitude: 151.3082,
    accuracy: 4
  },
  {
    postalCode: 2256,
    city: "Woy Woy Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4834,
    longitude: 151.312,
    accuracy: 4
  },
  {
    postalCode: 2256,
    city: "Little Wobby",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5454,
    longitude: 151.2564,
    accuracy: 4
  },
  {
    postalCode: 2256,
    city: "Patonga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5486,
    longitude: 151.2719,
    accuracy: 4
  },
  {
    postalCode: 2256,
    city: "Koolewong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.465,
    longitude: 151.3157,
    accuracy: 4
  },
  {
    postalCode: 2256,
    city: "Pearl Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5444,
    longitude: 151.3034,
    accuracy: 4
  },
  {
    postalCode: 2256,
    city: "Blackwall",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5019,
    longitude: 151.3237,
    accuracy: 4
  },
  {
    postalCode: 2256,
    city: "Wondabyne",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4876,
    longitude: 151.262,
    accuracy: 4
  },
  {
    postalCode: 2256,
    city: "Woy Woy",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4843,
    longitude: 151.3247,
    accuracy: 4
  },
  {
    postalCode: 2257,
    city: "Killcare Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5239,
    longitude: 151.3682,
    accuracy: 4
  },
  {
    postalCode: 2257,
    city: "Booker Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5167,
    longitude: 151.35,
    accuracy: 4
  },
  {
    postalCode: 2257,
    city: "Daleys Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4969,
    longitude: 151.355,
    accuracy: 4
  },
  {
    postalCode: 2257,
    city: "Empire Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4939,
    longitude: 151.3629,
    accuracy: 4
  },
  {
    postalCode: 2257,
    city: "Hardys Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5247,
    longitude: 151.3617,
    accuracy: 4
  },
  {
    postalCode: 2257,
    city: "Pretty Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5167,
    longitude: 151.35,
    accuracy: 4
  },
  {
    postalCode: 2257,
    city: "Box Head",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5308,
    longitude: 151.355,
    accuracy: 4
  },
  {
    postalCode: 2257,
    city: "Killcare",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5167,
    longitude: 151.3667,
    accuracy: 4
  },
  {
    postalCode: 2257,
    city: "St Huberts Island",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4956,
    longitude: 151.3462,
    accuracy: 4
  },
  {
    postalCode: 2257,
    city: "Umina Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5231,
    longitude: 151.3132,
    accuracy: 4
  },
  {
    postalCode: 2257,
    city: "Ettalong Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5106,
    longitude: 151.3304,
    accuracy: 4
  },
  {
    postalCode: 2257,
    city: "Wagstaffe",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5236,
    longitude: 151.3409,
    accuracy: 4
  },
  {
    postalCode: 2258,
    city: "Palmdale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3333,
    longitude: 151.3667,
    accuracy: 4
  },
  {
    postalCode: 2258,
    city: "Palm Grove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3333,
    longitude: 151.3167,
    accuracy: 4
  },
  {
    postalCode: 2258,
    city: "Fountaindale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3477,
    longitude: 151.4011,
    accuracy: 4
  },
  {
    postalCode: 2258,
    city: "Kangy Angy",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3188,
    longitude: 151.3964,
    accuracy: 4
  },
  {
    postalCode: 2258,
    city: "Ourimbah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3667,
    longitude: 151.4333,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Wybung",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2192,
    longitude: 151.4569,
    accuracy: 3
  },
  {
    postalCode: 2259,
    city: "Yarramalong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2333,
    longitude: 151.2833,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Cedar Brush Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1667,
    longitude: 151.2833,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Kiar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2012,
    longitude: 151.4376,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Frazer Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2192,
    longitude: 151.4569,
    accuracy: 3
  },
  {
    postalCode: 2259,
    city: "Lake Munmorah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1972,
    longitude: 151.5824,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Dooralong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1833,
    longitude: 151.35,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Wadalba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2723,
    longitude: 151.4649,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Bushells Ridge",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.21,
    longitude: 151.4747,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Mardi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2937,
    longitude: 151.4015,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Little Jilliby",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2407,
    longitude: 151.3701,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Warnervale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2466,
    longitude: 151.4517,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Gwandalan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1354,
    longitude: 151.5829,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Alison",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2768,
    longitude: 151.4021,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Mannering Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1581,
    longitude: 151.5348,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Freemans",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2063,
    longitude: 151.6012,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Tacoma South",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.293,
    longitude: 151.4534,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Halloran",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2323,
    longitude: 151.4367,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Watanobbi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2677,
    longitude: 151.4225,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Jilliby",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2261,
    longitude: 151.4168,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Crangan Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1735,
    longitude: 151.5882,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Wyong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2825,
    longitude: 151.4233,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Durren Durren",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2,
    longitude: 151.4,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Point Wolstoncroft",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1203,
    longitude: 151.5844,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Moonee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2057,
    longitude: 153.1529,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Tacoma",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2855,
    longitude: 151.4537,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Kingfisher Shores",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1683,
    longitude: 151.5531,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Wyong Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2667,
    longitude: 151.3667,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Chain Valley Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1724,
    longitude: 151.5714,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Ravensdale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1744,
    longitude: 151.3007,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Rocky Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2934,
    longitude: 151.4699,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Wyee Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1278,
    longitude: 151.5131,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Lemon Tree",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1492,
    longitude: 151.3635,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Wyee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1825,
    longitude: 151.488,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Kanwal",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.253,
    longitude: 151.4911,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Wallarah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2291,
    longitude: 151.4547,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Tuggerah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3167,
    longitude: 151.4167,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Tuggerawong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2804,
    longitude: 151.4804,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Woongarrah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2413,
    longitude: 151.4756,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Summerland Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1409,
    longitude: 151.5656,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Wyongah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2747,
    longitude: 151.489,
    accuracy: 4
  },
  {
    postalCode: 2259,
    city: "Hamlyn Terrace",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2512,
    longitude: 151.4763,
    accuracy: 4
  },
  {
    postalCode: 2260,
    city: "Terrigal",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4482,
    longitude: 151.4467,
    accuracy: 4
  },
  {
    postalCode: 2260,
    city: "Wamberal",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4155,
    longitude: 151.4456,
    accuracy: 4
  },
  {
    postalCode: 2260,
    city: "Erina Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4252,
    longitude: 151.3995,
    accuracy: 4
  },
  {
    postalCode: 2260,
    city: "Forresters Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.407,
    longitude: 151.476,
    accuracy: 4
  },
  {
    postalCode: 2260,
    city: "North Avoca",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4561,
    longitude: 151.4351,
    accuracy: 4
  },
  {
    postalCode: 2261,
    city: "Blue Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3541,
    longitude: 151.5002,
    accuracy: 4
  },
  {
    postalCode: 2261,
    city: "Killarney Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3549,
    longitude: 151.4722,
    accuracy: 3
  },
  {
    postalCode: 2261,
    city: "Bateau Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3833,
    longitude: 151.4667,
    accuracy: 4
  },
  {
    postalCode: 2261,
    city: "Bay Village",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3549,
    longitude: 151.4722,
    accuracy: 3
  },
  {
    postalCode: 2261,
    city: "Tumbi Umbi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3667,
    longitude: 151.45,
    accuracy: 4
  },
  {
    postalCode: 2261,
    city: "Chittaway Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3236,
    longitude: 151.4419,
    accuracy: 4
  },
  {
    postalCode: 2261,
    city: "Long Jetty",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.358,
    longitude: 151.4814,
    accuracy: 4
  },
  {
    postalCode: 2261,
    city: "The Entrance North",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3357,
    longitude: 151.5034,
    accuracy: 4
  },
  {
    postalCode: 2261,
    city: "Magenta",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.292,
    longitude: 151.5469,
    accuracy: 4
  },
  {
    postalCode: 2261,
    city: "The Entrance",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3388,
    longitude: 151.4978,
    accuracy: 4
  },
  {
    postalCode: 2261,
    city: "Toowoon Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3581,
    longitude: 151.4971,
    accuracy: 4
  },
  {
    postalCode: 2261,
    city: "Berkeley Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.35,
    longitude: 151.4333,
    accuracy: 4
  },
  {
    postalCode: 2261,
    city: "Glenning Valley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3537,
    longitude: 151.4262,
    accuracy: 4
  },
  {
    postalCode: 2261,
    city: "Shelly Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.37,
    longitude: 151.4852,
    accuracy: 4
  },
  {
    postalCode: 2261,
    city: "Chittaway Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3277,
    longitude: 151.4297,
    accuracy: 4
  },
  {
    postalCode: 2262,
    city: "Colongra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2069,
    longitude: 151.5436,
    accuracy: 4
  },
  {
    postalCode: 2262,
    city: "Budgewoi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2339,
    longitude: 151.5541,
    accuracy: 4
  },
  {
    postalCode: 2262,
    city: "Halekulani",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2191,
    longitude: 151.5525,
    accuracy: 4
  },
  {
    postalCode: 2262,
    city: "Doyalson North",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1873,
    longitude: 151.5488,
    accuracy: 4
  },
  {
    postalCode: 2262,
    city: "San Remo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2147,
    longitude: 151.521,
    accuracy: 4
  },
  {
    postalCode: 2262,
    city: "Budgewoi Peninsula",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2106,
    longitude: 151.5855,
    accuracy: 4
  },
  {
    postalCode: 2262,
    city: "Buff Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2229,
    longitude: 151.5312,
    accuracy: 4
  },
  {
    postalCode: 2262,
    city: "Doyalson",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1963,
    longitude: 151.5128,
    accuracy: 4
  },
  {
    postalCode: 2262,
    city: "Blue Haven",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2111,
    longitude: 151.5035,
    accuracy: 4
  },
  {
    postalCode: 2263,
    city: "Charmhaven",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2267,
    longitude: 151.5028,
    accuracy: 4
  },
  {
    postalCode: 2263,
    city: "Gorokan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2576,
    longitude: 151.5097,
    accuracy: 4
  },
  {
    postalCode: 2263,
    city: "Norah Head",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2833,
    longitude: 151.5667,
    accuracy: 4
  },
  {
    postalCode: 2263,
    city: "Canton Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2744,
    longitude: 151.5461,
    accuracy: 4
  },
  {
    postalCode: 2263,
    city: "Toukley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2637,
    longitude: 151.5384,
    accuracy: 4
  },
  {
    postalCode: 2263,
    city: "Noraville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2679,
    longitude: 151.5535,
    accuracy: 4
  },
  {
    postalCode: 2263,
    city: "Lake Haven",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.243,
    longitude: 151.5043,
    accuracy: 4
  },
  {
    postalCode: 2264,
    city: "Yarrawonga Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0946,
    longitude: 151.5471,
    accuracy: 4
  },
  {
    postalCode: 2264,
    city: "Myuna Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.045,
    longitude: 151.5281,
    accuracy: 4
  },
  {
    postalCode: 2264,
    city: "Dora Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0814,
    longitude: 151.4968,
    accuracy: 4
  },
  {
    postalCode: 2264,
    city: "Silverwater",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.104,
    longitude: 151.5636,
    accuracy: 4
  },
  {
    postalCode: 2264,
    city: "Mirrabooka",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.111,
    longitude: 151.5543,
    accuracy: 4
  },
  {
    postalCode: 2264,
    city: "Mandalong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1333,
    longitude: 151.4333,
    accuracy: 4
  },
  {
    postalCode: 2264,
    city: "Balcolyn",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0957,
    longitude: 151.552,
    accuracy: 4
  },
  {
    postalCode: 2264,
    city: "Morisset",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.108,
    longitude: 151.4871,
    accuracy: 4
  },
  {
    postalCode: 2264,
    city: "Eraring",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0833,
    longitude: 151.5333,
    accuracy: 4
  },
  {
    postalCode: 2264,
    city: "Sunshine",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7454,
    longitude: 150.2079,
    accuracy: 4
  },
  {
    postalCode: 2264,
    city: "Windermere Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.121,
    longitude: 151.5307,
    accuracy: 4
  },
  {
    postalCode: 2264,
    city: "Morisset Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1198,
    longitude: 151.537,
    accuracy: 4
  },
  {
    postalCode: 2264,
    city: "Bonnells Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1097,
    longitude: 151.5323,
    accuracy: 4
  },
  {
    postalCode: 2264,
    city: "Brightwaters",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1136,
    longitude: 151.5447,
    accuracy: 4
  },
  {
    postalCode: 2265,
    city: "Cooranbong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0762,
    longitude: 151.4541,
    accuracy: 4
  },
  {
    postalCode: 2265,
    city: "Martinsville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0667,
    longitude: 151.4167,
    accuracy: 4
  },
  {
    postalCode: 2267,
    city: "Wangi Wangi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0718,
    longitude: 151.5984,
    accuracy: 4
  },
  {
    postalCode: 2278,
    city: "Barnsley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9333,
    longitude: 151.5833,
    accuracy: 4
  },
  {
    postalCode: 2278,
    city: "Killingworth",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9341,
    longitude: 151.556,
    accuracy: 4
  },
  {
    postalCode: 2278,
    city: "Wakefield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9682,
    longitude: 151.5609,
    accuracy: 4
  },
  {
    postalCode: 2280,
    city: "Croudace Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0048,
    longitude: 151.6482,
    accuracy: 4
  },
  {
    postalCode: 2280,
    city: "Marks Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0612,
    longitude: 151.6472,
    accuracy: 4
  },
  {
    postalCode: 2280,
    city: "Belmont South",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0493,
    longitude: 151.6569,
    accuracy: 4
  },
  {
    postalCode: 2280,
    city: "Jewells",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0139,
    longitude: 151.6831,
    accuracy: 4
  },
  {
    postalCode: 2280,
    city: "Belmont",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0274,
    longitude: 151.6601,
    accuracy: 4
  },
  {
    postalCode: 2280,
    city: "Valentine",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.015,
    longitude: 151.6429,
    accuracy: 4
  },
  {
    postalCode: 2280,
    city: "Floraville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0112,
    longitude: 151.6648,
    accuracy: 4
  },
  {
    postalCode: 2280,
    city: "Belmont North",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0208,
    longitude: 151.6685,
    accuracy: 4
  },
  {
    postalCode: 2281,
    city: "Blacksmiths",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0717,
    longitude: 151.6553,
    accuracy: 4
  },
  {
    postalCode: 2281,
    city: "Little Pelican",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0823,
    longitude: 151.6455,
    accuracy: 4
  },
  {
    postalCode: 2281,
    city: "Swansea",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0833,
    longitude: 151.6167,
    accuracy: 4
  },
  {
    postalCode: 2281,
    city: "Middle Camp",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.15,
    longitude: 151.6333,
    accuracy: 4
  },
  {
    postalCode: 2281,
    city: "Murrays Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1201,
    longitude: 151.6297,
    accuracy: 3
  },
  {
    postalCode: 2281,
    city: "Pinny Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1217,
    longitude: 151.639,
    accuracy: 4
  },
  {
    postalCode: 2281,
    city: "Pelican",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0684,
    longitude: 151.6446,
    accuracy: 4
  },
  {
    postalCode: 2281,
    city: "Swansea Heads",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0965,
    longitude: 151.655,
    accuracy: 4
  },
  {
    postalCode: 2281,
    city: "Caves Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1064,
    longitude: 151.644,
    accuracy: 4
  },
  {
    postalCode: 2281,
    city: "Cams Wharf",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1261,
    longitude: 151.6209,
    accuracy: 4
  },
  {
    postalCode: 2281,
    city: "Nords Wharf",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1313,
    longitude: 151.6073,
    accuracy: 4
  },
  {
    postalCode: 2281,
    city: "Catherine Hill Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1667,
    longitude: 151.6333,
    accuracy: 4
  },
  {
    postalCode: 2282,
    city: "Warners Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9725,
    longitude: 151.6527,
    accuracy: 4
  },
  {
    postalCode: 2282,
    city: "Lakelands",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9619,
    longitude: 151.6497,
    accuracy: 4
  },
  {
    postalCode: 2282,
    city: "Eleebana",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9896,
    longitude: 151.6364,
    accuracy: 4
  },
  {
    postalCode: 2283,
    city: "Buttaba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0533,
    longitude: 151.5787,
    accuracy: 4
  },
  {
    postalCode: 2283,
    city: "Balmoral",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0667,
    longitude: 151.5833,
    accuracy: 4
  },
  {
    postalCode: 2283,
    city: "Carey Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0266,
    longitude: 151.6057,
    accuracy: 4
  },
  {
    postalCode: 2283,
    city: "Coal Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0423,
    longitude: 151.6116,
    accuracy: 4
  },
  {
    postalCode: 2283,
    city: "Fishing Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0538,
    longitude: 151.5948,
    accuracy: 4
  },
  {
    postalCode: 2283,
    city: "Rathmines",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0377,
    longitude: 151.5844,
    accuracy: 4
  },
  {
    postalCode: 2283,
    city: "Fassifern",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9833,
    longitude: 151.5833,
    accuracy: 4
  },
  {
    postalCode: 2283,
    city: "Arcadia Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0605,
    longitude: 151.5841,
    accuracy: 4
  },
  {
    postalCode: 2283,
    city: "Kilaben Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.024,
    longitude: 151.592,
    accuracy: 4
  },
  {
    postalCode: 2283,
    city: "Ryhope",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9913,
    longitude: 151.522,
    accuracy: 4
  },
  {
    postalCode: 2283,
    city: "Bolton Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0018,
    longitude: 151.6101,
    accuracy: 4
  },
  {
    postalCode: 2283,
    city: "Toronto",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33,
    longitude: 151.6,
    accuracy: 4
  },
  {
    postalCode: 2283,
    city: "Blackalls Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9989,
    longitude: 151.5802,
    accuracy: 4
  },
  {
    postalCode: 2283,
    city: "Fennell Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9922,
    longitude: 151.6001,
    accuracy: 4
  },
  {
    postalCode: 2283,
    city: "Awaba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0082,
    longitude: 151.551,
    accuracy: 4
  },
  {
    postalCode: 2284,
    city: "Teralba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9667,
    longitude: 151.6,
    accuracy: 4
  },
  {
    postalCode: 2284,
    city: "Argenton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.935,
    longitude: 151.6306,
    accuracy: 4
  },
  {
    postalCode: 2284,
    city: "Marmong Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9806,
    longitude: 151.6184,
    accuracy: 4
  },
  {
    postalCode: 2284,
    city: "Boolaroo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.95,
    longitude: 151.6167,
    accuracy: 4
  },
  {
    postalCode: 2284,
    city: "Woodrising",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.986,
    longitude: 151.6066,
    accuracy: 4
  },
  {
    postalCode: 2284,
    city: "Speers Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9638,
    longitude: 151.6262,
    accuracy: 4
  },
  {
    postalCode: 2284,
    city: "Booragul",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9749,
    longitude: 151.6098,
    accuracy: 4
  },
  {
    postalCode: 2285,
    city: "Macquarie Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9511,
    longitude: 151.6446,
    accuracy: 4
  },
  {
    postalCode: 2285,
    city: "Cardiff South",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9547,
    longitude: 151.6645,
    accuracy: 4
  },
  {
    postalCode: 2285,
    city: "Cameron Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.907,
    longitude: 151.6053,
    accuracy: 4
  },
  {
    postalCode: 2285,
    city: "Edgeworth",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9251,
    longitude: 151.6161,
    accuracy: 4
  },
  {
    postalCode: 2285,
    city: "Cardiff",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.95,
    longitude: 151.6667,
    accuracy: 4
  },
  {
    postalCode: 2285,
    city: "Cardiff Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9363,
    longitude: 151.6723,
    accuracy: 4
  },
  {
    postalCode: 2285,
    city: "Glendale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9319,
    longitude: 151.641,
    accuracy: 4
  },
  {
    postalCode: 2286,
    city: "West Wallsend",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9,
    longitude: 151.5833,
    accuracy: 4
  },
  {
    postalCode: 2286,
    city: "Seahampton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8895,
    longitude: 151.5832,
    accuracy: 4
  },
  {
    postalCode: 2286,
    city: "Holmesville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9167,
    longitude: 151.5833,
    accuracy: 4
  },
  {
    postalCode: 2287,
    city: "Birmingham Gardens",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8937,
    longitude: 151.6901,
    accuracy: 4
  },
  {
    postalCode: 2287,
    city: "Rankin Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9252,
    longitude: 151.6802,
    accuracy: 4
  },
  {
    postalCode: 2287,
    city: "Elermore Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9162,
    longitude: 151.6766,
    accuracy: 4
  },
  {
    postalCode: 2287,
    city: "Minmi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8783,
    longitude: 151.6173,
    accuracy: 4
  },
  {
    postalCode: 2287,
    city: "Maryland",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8789,
    longitude: 151.6614,
    accuracy: 4
  },
  {
    postalCode: 2287,
    city: "Fletcher",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8723,
    longitude: 151.6401,
    accuracy: 4
  },
  {
    postalCode: 2287,
    city: "Wallsend South",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.897,
    longitude: 151.6562,
    accuracy: 3
  },
  {
    postalCode: 2287,
    city: "Wallsend",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9167,
    longitude: 151.6667,
    accuracy: 4
  },
  {
    postalCode: 2287,
    city: "Summer Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8915,
    longitude: 151.1382,
    accuracy: 4
  },
  {
    postalCode: 2289,
    city: "Highfields",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9533,
    longitude: 151.7123,
    accuracy: 4
  },
  {
    postalCode: 2289,
    city: "Kotara Fair",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9445,
    longitude: 151.7073,
    accuracy: 3
  },
  {
    postalCode: 2289,
    city: "Kotara",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.95,
    longitude: 151.6833,
    accuracy: 4
  },
  {
    postalCode: 2289,
    city: "Kotara South",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.95,
    longitude: 151.6833,
    accuracy: 4
  },
  {
    postalCode: 2289,
    city: "Adamstown Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9491,
    longitude: 151.7101,
    accuracy: 4
  },
  {
    postalCode: 2289,
    city: "Garden Suburb",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9437,
    longitude: 151.6808,
    accuracy: 4
  },
  {
    postalCode: 2289,
    city: "Adamstown",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9382,
    longitude: 151.7254,
    accuracy: 4
  },
  {
    postalCode: 2290,
    city: "Charlestown",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.95,
    longitude: 151.6667,
    accuracy: 4
  },
  {
    postalCode: 2290,
    city: "Dudley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9937,
    longitude: 151.722,
    accuracy: 4
  },
  {
    postalCode: 2290,
    city: "Whitebridge",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9833,
    longitude: 151.7167,
    accuracy: 4
  },
  {
    postalCode: 2290,
    city: "Bennetts Green",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9955,
    longitude: 151.6879,
    accuracy: 4
  },
  {
    postalCode: 2290,
    city: "Redhead",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0118,
    longitude: 151.7114,
    accuracy: 4
  },
  {
    postalCode: 2290,
    city: "Mount Hutton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9833,
    longitude: 151.6701,
    accuracy: 4
  },
  {
    postalCode: 2290,
    city: "Gateshead",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9821,
    longitude: 151.6919,
    accuracy: 4
  },
  {
    postalCode: 2290,
    city: "Kahibah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9667,
    longitude: 151.7167,
    accuracy: 4
  },
  {
    postalCode: 2290,
    city: "Hillsborough",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9655,
    longitude: 151.6724,
    accuracy: 4
  },
  {
    postalCode: 2290,
    city: "Tingira Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9973,
    longitude: 151.6702,
    accuracy: 4
  },
  {
    postalCode: 2291,
    city: "The Junction",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9382,
    longitude: 151.7591,
    accuracy: 4
  },
  {
    postalCode: 2291,
    city: "Merewether",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.948,
    longitude: 151.7433,
    accuracy: 4
  },
  {
    postalCode: 2291,
    city: "Merewether Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9473,
    longitude: 151.7356,
    accuracy: 4
  },
  {
    postalCode: 2292,
    city: "Hamilton North",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9119,
    longitude: 151.7368,
    accuracy: 4
  },
  {
    postalCode: 2292,
    city: "Broadmeadow",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9237,
    longitude: 151.7285,
    accuracy: 4
  },
  {
    postalCode: 2293,
    city: "Maryville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9112,
    longitude: 151.7554,
    accuracy: 4
  },
  {
    postalCode: 2293,
    city: "Wickham",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9192,
    longitude: 151.7569,
    accuracy: 4
  },
  {
    postalCode: 2294,
    city: "Carrington",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.915,
    longitude: 151.7644,
    accuracy: 4
  },
  {
    postalCode: 2295,
    city: "Fern Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8643,
    longitude: 151.8131,
    accuracy: 4
  },
  {
    postalCode: 2295,
    city: "Stockton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9091,
    longitude: 151.7836,
    accuracy: 4
  },
  {
    postalCode: 2296,
    city: "Islington",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9139,
    longitude: 151.7474,
    accuracy: 4
  },
  {
    postalCode: 2297,
    city: "Tighes Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9073,
    longitude: 151.7509,
    accuracy: 4
  },
  {
    postalCode: 2298,
    city: "Waratah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9067,
    longitude: 151.7265,
    accuracy: 4
  },
  {
    postalCode: 2298,
    city: "Georgetown",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9081,
    longitude: 151.7312,
    accuracy: 4
  },
  {
    postalCode: 2298,
    city: "Waratah West",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9,
    longitude: 151.7117,
    accuracy: 4
  },
  {
    postalCode: 2299,
    city: "Lambton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9167,
    longitude: 151.7,
    accuracy: 4
  },
  {
    postalCode: 2299,
    city: "Jesmond",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9028,
    longitude: 151.6907,
    accuracy: 4
  },
  {
    postalCode: 2299,
    city: "North Lambton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9061,
    longitude: 151.7057,
    accuracy: 4
  },
  {
    postalCode: 2300,
    city: "Newcastle",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9271,
    longitude: 151.7765,
    accuracy: 4
  },
  {
    postalCode: 2300,
    city: "The Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.931,
    longitude: 151.7754,
    accuracy: 3
  },
  {
    postalCode: 2300,
    city: "Cooks Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9324,
    longitude: 151.7711,
    accuracy: 4
  },
  {
    postalCode: 2300,
    city: "Newcastle East",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9277,
    longitude: 151.7884,
    accuracy: 4
  },
  {
    postalCode: 2300,
    city: "Bar Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9413,
    longitude: 151.7654,
    accuracy: 4
  },
  {
    postalCode: 2302,
    city: "Newcastle West",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9245,
    longitude: 151.7571,
    accuracy: 4
  },
  {
    postalCode: 2303,
    city: "Hamilton South",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9279,
    longitude: 151.7465,
    accuracy: 3
  },
  {
    postalCode: 2303,
    city: "Hamilton East",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9258,
    longitude: 151.7535,
    accuracy: 4
  },
  {
    postalCode: 2303,
    city: "Hamilton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9221,
    longitude: 151.7471,
    accuracy: 4
  },
  {
    postalCode: 2304,
    city: "Kooragang",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8843,
    longitude: 151.771,
    accuracy: 4
  },
  {
    postalCode: 2304,
    city: "Warabrook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8888,
    longitude: 151.7149,
    accuracy: 4
  },
  {
    postalCode: 2304,
    city: "Mayfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8979,
    longitude: 151.7361,
    accuracy: 4
  },
  {
    postalCode: 2304,
    city: "Mayfield West",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.892,
    longitude: 151.7271,
    accuracy: 4
  },
  {
    postalCode: 2304,
    city: "Sandgate",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8667,
    longitude: 151.7,
    accuracy: 4
  },
  {
    postalCode: 2304,
    city: "Mayfield East",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9003,
    longitude: 151.7497,
    accuracy: 4
  },
  {
    postalCode: 2304,
    city: "Mayfield North",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8928,
    longitude: 151.7482,
    accuracy: 4
  },
  {
    postalCode: 2305,
    city: "New Lambton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.95,
    longitude: 151.6833,
    accuracy: 4
  },
  {
    postalCode: 2305,
    city: "Kotara East",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.928,
    longitude: 151.7031,
    accuracy: 3
  },
  {
    postalCode: 2305,
    city: "New Lambton Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9247,
    longitude: 151.6936,
    accuracy: 4
  },
  {
    postalCode: 2306,
    city: "Windale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9928,
    longitude: 151.6817,
    accuracy: 4
  },
  {
    postalCode: 2307,
    city: "Shortland",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8788,
    longitude: 151.691,
    accuracy: 4
  },
  {
    postalCode: 2308,
    city: "Newcastle University",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.892,
    longitude: 151.7053,
    accuracy: 3
  },
  {
    postalCode: 2308,
    city: "Callaghan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.892,
    longitude: 151.7053,
    accuracy: 4
  },
  {
    postalCode: 2309,
    city: "Dangar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5386,
    longitude: 151.2415,
    accuracy: 4
  },
  {
    postalCode: 2310,
    city: "Hunter Region Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5879,
    longitude: 151.8955,
    accuracy: 1
  },
  {
    postalCode: 2311,
    city: "East Gresford",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4138,
    longitude: 151.5565,
    accuracy: 4
  },
  {
    postalCode: 2311,
    city: "Halton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3167,
    longitude: 151.5167,
    accuracy: 4
  },
  {
    postalCode: 2311,
    city: "Gresford",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4273,
    longitude: 151.5375,
    accuracy: 4
  },
  {
    postalCode: 2311,
    city: "Bingleburra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3529,
    longitude: 151.5156,
    accuracy: 3
  },
  {
    postalCode: 2311,
    city: "Mount Rivers",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3652,
    longitude: 151.4846,
    accuracy: 4
  },
  {
    postalCode: 2311,
    city: "Upper Allyn",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3529,
    longitude: 151.5156,
    accuracy: 3
  },
  {
    postalCode: 2311,
    city: "Lostock",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3333,
    longitude: 151.45,
    accuracy: 4
  },
  {
    postalCode: 2311,
    city: "Allynbrook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3614,
    longitude: 151.5364,
    accuracy: 4
  },
  {
    postalCode: 2311,
    city: "Eccleston",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.25,
    longitude: 151.5,
    accuracy: 4
  },
  {
    postalCode: 2311,
    city: "Carrabolla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3529,
    longitude: 151.5156,
    accuracy: 3
  },
  {
    postalCode: 2311,
    city: "Lewinsbrook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3529,
    longitude: 151.5156,
    accuracy: 3
  },
  {
    postalCode: 2312,
    city: "Minimbah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1577,
    longitude: 152.3748,
    accuracy: 4
  },
  {
    postalCode: 2312,
    city: "Nabiac",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.0984,
    longitude: 152.3763,
    accuracy: 4
  },
  {
    postalCode: 2314,
    city: "Williamtown Raaf",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5879,
    longitude: 151.8955,
    accuracy: 1
  },
  {
    postalCode: 2315,
    city: "Fingal Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7497,
    longitude: 152.171,
    accuracy: 4
  },
  {
    postalCode: 2315,
    city: "Corlette",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7201,
    longitude: 152.1085,
    accuracy: 4
  },
  {
    postalCode: 2315,
    city: "Shoal Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7223,
    longitude: 152.175,
    accuracy: 4
  },
  {
    postalCode: 2315,
    city: "Nelson Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7204,
    longitude: 152.144,
    accuracy: 4
  },
  {
    postalCode: 2316,
    city: "Taylors Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7488,
    longitude: 152.067,
    accuracy: 4
  },
  {
    postalCode: 2316,
    city: "Fishermans Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7858,
    longitude: 152.0896,
    accuracy: 4
  },
  {
    postalCode: 2316,
    city: "Boat Harbour",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7896,
    longitude: 152.1091,
    accuracy: 4
  },
  {
    postalCode: 2316,
    city: "Anna Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7813,
    longitude: 152.0859,
    accuracy: 4
  },
  {
    postalCode: 2316,
    city: "Bobs Farm",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7667,
    longitude: 152.0167,
    accuracy: 4
  },
  {
    postalCode: 2316,
    city: "One Mile",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.77,
    longitude: 152.07,
    accuracy: 3
  },
  {
    postalCode: 2317,
    city: "Soldiers Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7105,
    longitude: 152.0698,
    accuracy: 4
  },
  {
    postalCode: 2317,
    city: "Salamander Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7225,
    longitude: 152.0794,
    accuracy: 4
  },
  {
    postalCode: 2318,
    city: "Medowie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7415,
    longitude: 151.8676,
    accuracy: 4
  },
  {
    postalCode: 2318,
    city: "Salt Ash",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7833,
    longitude: 151.9167,
    accuracy: 4
  },
  {
    postalCode: 2318,
    city: "Ferodale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7333,
    longitude: 151.85,
    accuracy: 4
  },
  {
    postalCode: 2318,
    city: "Campvale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7726,
    longitude: 151.856,
    accuracy: 4
  },
  {
    postalCode: 2318,
    city: "Williamtown",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8064,
    longitude: 151.8436,
    accuracy: 4
  },
  {
    postalCode: 2318,
    city: "Oyster Cove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7387,
    longitude: 151.9564,
    accuracy: 4
  },
  {
    postalCode: 2318,
    city: "Fullerton Cove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8405,
    longitude: 151.8379,
    accuracy: 4
  },
  {
    postalCode: 2319,
    city: "Tilligerry Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7393,
    longitude: 152.0172,
    accuracy: 3
  },
  {
    postalCode: 2319,
    city: "Tanilba Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7471,
    longitude: 151.9971,
    accuracy: 4
  },
  {
    postalCode: 2319,
    city: "Mallabula",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7282,
    longitude: 152.0126,
    accuracy: 4
  },
  {
    postalCode: 2319,
    city: "Lemon Tree Passage",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7305,
    longitude: 152.0386,
    accuracy: 4
  },
  {
    postalCode: 2320,
    city: "Mindaribba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7331,
    longitude: 151.5279,
    accuracy: 3
  },
  {
    postalCode: 2320,
    city: "Bolwarra Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.701,
    longitude: 151.5854,
    accuracy: 4
  },
  {
    postalCode: 2320,
    city: "Keinbah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7331,
    longitude: 151.5279,
    accuracy: 3
  },
  {
    postalCode: 2320,
    city: "Allandale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7196,
    longitude: 151.4028,
    accuracy: 4
  },
  {
    postalCode: 2320,
    city: "Mount Dee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7331,
    longitude: 151.5279,
    accuracy: 3
  },
  {
    postalCode: 2320,
    city: "South Maitland",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7453,
    longitude: 151.5634,
    accuracy: 4
  },
  {
    postalCode: 2320,
    city: "Anambah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7331,
    longitude: 151.5279,
    accuracy: 3
  },
  {
    postalCode: 2320,
    city: "Louth Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7709,
    longitude: 151.5483,
    accuracy: 4
  },
  {
    postalCode: 2320,
    city: "Farley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7333,
    longitude: 151.5167,
    accuracy: 4
  },
  {
    postalCode: 2320,
    city: "Lorn",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7333,
    longitude: 151.5667,
    accuracy: 4
  },
  {
    postalCode: 2320,
    city: "Rutherford",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7167,
    longitude: 151.5333,
    accuracy: 4
  },
  {
    postalCode: 2320,
    city: "Largs",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7,
    longitude: 151.6,
    accuracy: 4
  },
  {
    postalCode: 2320,
    city: "Wallalong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6956,
    longitude: 151.6496,
    accuracy: 4
  },
  {
    postalCode: 2320,
    city: "Horseshoe Bend",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7353,
    longitude: 151.5683,
    accuracy: 4
  },
  {
    postalCode: 2320,
    city: "Maitland Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7331,
    longitude: 151.5279,
    accuracy: 3
  },
  {
    postalCode: 2320,
    city: "Windella",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7033,
    longitude: 151.4802,
    accuracy: 4
  },
  {
    postalCode: 2320,
    city: "Maitland",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7331,
    longitude: 151.5574,
    accuracy: 4
  },
  {
    postalCode: 2320,
    city: "Oakhampton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7,
    longitude: 151.5667,
    accuracy: 4
  },
  {
    postalCode: 2320,
    city: "Gosforth",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6667,
    longitude: 151.4833,
    accuracy: 4
  },
  {
    postalCode: 2320,
    city: "Telarah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7333,
    longitude: 151.5333,
    accuracy: 4
  },
  {
    postalCode: 2320,
    city: "Maitland North",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7164,
    longitude: 151.5373,
    accuracy: 3
  },
  {
    postalCode: 2320,
    city: "Bolwarra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7167,
    longitude: 151.5667,
    accuracy: 4
  },
  {
    postalCode: 2320,
    city: "Pokolbin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8,
    longitude: 151.2833,
    accuracy: 4
  },
  {
    postalCode: 2320,
    city: "Rosebrook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.65,
    longitude: 151.5167,
    accuracy: 4
  },
  {
    postalCode: 2320,
    city: "Rothbury",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7485,
    longitude: 151.3429,
    accuracy: 4
  },
  {
    postalCode: 2320,
    city: "Aberglasslyn",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7,
    longitude: 151.5333,
    accuracy: 4
  },
  {
    postalCode: 2320,
    city: "Oakhampton Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7331,
    longitude: 151.5279,
    accuracy: 3
  },
  {
    postalCode: 2320,
    city: "Hillsborough",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9655,
    longitude: 151.6724,
    accuracy: 4
  },
  {
    postalCode: 2320,
    city: "Glen Oak",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6167,
    longitude: 151.7167,
    accuracy: 4
  },
  {
    postalCode: 2320,
    city: "Melville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7331,
    longitude: 151.5279,
    accuracy: 3
  },
  {
    postalCode: 2321,
    city: "Butterwick",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6564,
    longitude: 151.6369,
    accuracy: 4
  },
  {
    postalCode: 2321,
    city: "Duns Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7353,
    longitude: 151.622,
    accuracy: 3
  },
  {
    postalCode: 2321,
    city: "Morpeth",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7333,
    longitude: 151.6333,
    accuracy: 4
  },
  {
    postalCode: 2321,
    city: "Woodville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6833,
    longitude: 151.6167,
    accuracy: 4
  },
  {
    postalCode: 2321,
    city: "Lochinvar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6987,
    longitude: 151.4552,
    accuracy: 4
  },
  {
    postalCode: 2321,
    city: "Duckenfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7333,
    longitude: 151.6833,
    accuracy: 4
  },
  {
    postalCode: 2321,
    city: "Luskintyre",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6834,
    longitude: 151.427,
    accuracy: 4
  },
  {
    postalCode: 2321,
    city: "Raworth",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7333,
    longitude: 151.6167,
    accuracy: 4
  },
  {
    postalCode: 2321,
    city: "Cliftleigh",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7353,
    longitude: 151.622,
    accuracy: 3
  },
  {
    postalCode: 2321,
    city: "Berry Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7333,
    longitude: 151.6667,
    accuracy: 4
  },
  {
    postalCode: 2321,
    city: "Clarence Town",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.584,
    longitude: 151.7776,
    accuracy: 4
  },
  {
    postalCode: 2321,
    city: "Glen William",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5333,
    longitude: 151.8,
    accuracy: 4
  },
  {
    postalCode: 2321,
    city: "Oswald",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7062,
    longitude: 151.4215,
    accuracy: 4
  },
  {
    postalCode: 2321,
    city: "Heddon Greta",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.802,
    longitude: 151.5133,
    accuracy: 4
  },
  {
    postalCode: 2321,
    city: "Glen Martin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7353,
    longitude: 151.622,
    accuracy: 3
  },
  {
    postalCode: 2321,
    city: "Gillieston Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7616,
    longitude: 151.5286,
    accuracy: 4
  },
  {
    postalCode: 2321,
    city: "Harpers Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7353,
    longitude: 151.622,
    accuracy: 3
  },
  {
    postalCode: 2321,
    city: "Windermere",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6897,
    longitude: 151.4474,
    accuracy: 4
  },
  {
    postalCode: 2321,
    city: "Phoenix Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7353,
    longitude: 151.622,
    accuracy: 3
  },
  {
    postalCode: 2321,
    city: "Hinton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7147,
    longitude: 151.649,
    accuracy: 4
  },
  {
    postalCode: 2322,
    city: "Hexham",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8293,
    longitude: 151.6844,
    accuracy: 4
  },
  {
    postalCode: 2322,
    city: "Stockrington",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8072,
    longitude: 151.6739,
    accuracy: 3
  },
  {
    postalCode: 2322,
    city: "Chisholm",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8072,
    longitude: 151.6739,
    accuracy: 3
  },
  {
    postalCode: 2322,
    city: "Lenaghan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8417,
    longitude: 151.6359,
    accuracy: 4
  },
  {
    postalCode: 2322,
    city: "Black Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8377,
    longitude: 151.6187,
    accuracy: 4
  },
  {
    postalCode: 2322,
    city: "Woodberry",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7931,
    longitude: 151.6769,
    accuracy: 4
  },
  {
    postalCode: 2322,
    city: "Tarro",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8,
    longitude: 151.6667,
    accuracy: 4
  },
  {
    postalCode: 2322,
    city: "Beresfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8,
    longitude: 151.65,
    accuracy: 4
  },
  {
    postalCode: 2322,
    city: "Thornton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7833,
    longitude: 151.6333,
    accuracy: 4
  },
  {
    postalCode: 2322,
    city: "Tomago",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.827,
    longitude: 151.7131,
    accuracy: 4
  },
  {
    postalCode: 2323,
    city: "East Maitland",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.75,
    longitude: 151.5833,
    accuracy: 4
  },
  {
    postalCode: 2323,
    city: "Mulbring",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9048,
    longitude: 151.4851,
    accuracy: 4
  },
  {
    postalCode: 2323,
    city: "Metford",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.765,
    longitude: 151.6094,
    accuracy: 4
  },
  {
    postalCode: 2323,
    city: "Ashtonfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7733,
    longitude: 151.6058,
    accuracy: 4
  },
  {
    postalCode: 2323,
    city: "Four Mile Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4318,
    longitude: 148.9512,
    accuracy: 4
  },
  {
    postalCode: 2323,
    city: "Buttai",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8219,
    longitude: 151.5609,
    accuracy: 4
  },
  {
    postalCode: 2323,
    city: "Brunkerville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9425,
    longitude: 151.4795,
    accuracy: 4
  },
  {
    postalCode: 2323,
    city: "Green Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9176,
    longitude: 149.5836,
    accuracy: 4
  },
  {
    postalCode: 2323,
    city: "Metford Dc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8708,
    longitude: 151.5188,
    accuracy: 3
  },
  {
    postalCode: 2323,
    city: "Pitnacree",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8048,
    longitude: 151.5627,
    accuracy: 3
  },
  {
    postalCode: 2323,
    city: "Freemans Waterhole",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9847,
    longitude: 151.4846,
    accuracy: 4
  },
  {
    postalCode: 2323,
    city: "Buchanan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8305,
    longitude: 151.5312,
    accuracy: 4
  },
  {
    postalCode: 2323,
    city: "Mount Vincent",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9174,
    longitude: 151.4774,
    accuracy: 3
  },
  {
    postalCode: 2323,
    city: "Tenambit",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7333,
    longitude: 151.6167,
    accuracy: 4
  },
  {
    postalCode: 2323,
    city: "Richmond Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8048,
    longitude: 151.5627,
    accuracy: 3
  },
  {
    postalCode: 2324,
    city: "Limeburners Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6167,
    longitude: 151.9167,
    accuracy: 4
  },
  {
    postalCode: 2324,
    city: "Twelve Mile Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6447,
    longitude: 151.865,
    accuracy: 4
  },
  {
    postalCode: 2324,
    city: "East Seaham",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6478,
    longitude: 151.7616,
    accuracy: 4
  },
  {
    postalCode: 2324,
    city: "Millers Forest",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.75,
    longitude: 151.7,
    accuracy: 4
  },
  {
    postalCode: 2324,
    city: "Seaham",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6622,
    longitude: 151.7266,
    accuracy: 4
  },
  {
    postalCode: 2324,
    city: "Tea Gardens",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6635,
    longitude: 152.154,
    accuracy: 4
  },
  {
    postalCode: 2324,
    city: "Eagleton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.707,
    longitude: 151.7553,
    accuracy: 4
  },
  {
    postalCode: 2324,
    city: "Cells River",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6462,
    longitude: 151.9955,
    accuracy: 3
  },
  {
    postalCode: 2324,
    city: "Tahlee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6667,
    longitude: 152,
    accuracy: 4
  },
  {
    postalCode: 2324,
    city: "Osterley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7245,
    longitude: 151.6998,
    accuracy: 4
  },
  {
    postalCode: 2324,
    city: "Brandy Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6893,
    longitude: 151.696,
    accuracy: 4
  },
  {
    postalCode: 2324,
    city: "Hawks Nest",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6675,
    longitude: 152.1783,
    accuracy: 4
  },
  {
    postalCode: 2324,
    city: "North Arm Cove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6706,
    longitude: 152.0448,
    accuracy: 4
  },
  {
    postalCode: 2324,
    city: "Raymond Terrace East",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6462,
    longitude: 151.9955,
    accuracy: 3
  },
  {
    postalCode: 2324,
    city: "Pindimar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6828,
    longitude: 152.0981,
    accuracy: 4
  },
  {
    postalCode: 2324,
    city: "Carrington",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.915,
    longitude: 151.7644,
    accuracy: 4
  },
  {
    postalCode: 2324,
    city: "Heatherbrae",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7889,
    longitude: 151.7354,
    accuracy: 4
  },
  {
    postalCode: 2324,
    city: "Bundabah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6462,
    longitude: 151.9955,
    accuracy: 3
  },
  {
    postalCode: 2324,
    city: "Nelsons Plains",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7205,
    longitude: 151.7173,
    accuracy: 4
  },
  {
    postalCode: 2324,
    city: "Swan Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6918,
    longitude: 151.9289,
    accuracy: 4
  },
  {
    postalCode: 2324,
    city: "Balickera",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6589,
    longitude: 151.8119,
    accuracy: 4
  },
  {
    postalCode: 2324,
    city: "Raymond Terrace",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.75,
    longitude: 151.75,
    accuracy: 4
  },
  {
    postalCode: 2324,
    city: "Karuah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6539,
    longitude: 151.9604,
    accuracy: 4
  },
  {
    postalCode: 2325,
    city: "Paxton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9061,
    longitude: 151.2849,
    accuracy: 4
  },
  {
    postalCode: 2325,
    city: "Quorrobolong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9225,
    longitude: 151.364,
    accuracy: 3
  },
  {
    postalCode: 2325,
    city: "Wollombi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9388,
    longitude: 151.1415,
    accuracy: 4
  },
  {
    postalCode: 2325,
    city: "Cessnock West",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9386,
    longitude: 151.2758,
    accuracy: 3
  },
  {
    postalCode: 2325,
    city: "Kearsley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8586,
    longitude: 151.3957,
    accuracy: 3
  },
  {
    postalCode: 2325,
    city: "Cessnock",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8321,
    longitude: 151.3562,
    accuracy: 4
  },
  {
    postalCode: 2325,
    city: "Kitchener",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8813,
    longitude: 151.3671,
    accuracy: 4
  },
  {
    postalCode: 2325,
    city: "Ellalong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9151,
    longitude: 151.3116,
    accuracy: 4
  },
  {
    postalCode: 2325,
    city: "Bellbird",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8599,
    longitude: 151.3187,
    accuracy: 4
  },
  {
    postalCode: 2325,
    city: "Mount View",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.85,
    longitude: 151.2833,
    accuracy: 4
  },
  {
    postalCode: 2325,
    city: "Elrington",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.531,
    longitude: 149.6453,
    accuracy: 4
  },
  {
    postalCode: 2325,
    city: "Pelton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8783,
    longitude: 151.3109,
    accuracy: 4
  },
  {
    postalCode: 2325,
    city: "Nulkaba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8103,
    longitude: 151.3483,
    accuracy: 4
  },
  {
    postalCode: 2325,
    city: "Lovedale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7705,
    longitude: 151.3648,
    accuracy: 4
  },
  {
    postalCode: 2325,
    city: "Laguna",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9902,
    longitude: 151.1346,
    accuracy: 4
  },
  {
    postalCode: 2325,
    city: "Abernethy",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9,
    longitude: 151.4,
    accuracy: 4
  },
  {
    postalCode: 2325,
    city: "Millfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8886,
    longitude: 151.2613,
    accuracy: 4
  },
  {
    postalCode: 2325,
    city: "Greta Main",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.88,
    longitude: 151.3082,
    accuracy: 3
  },
  {
    postalCode: 2325,
    city: "Sweetmans Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.88,
    longitude: 151.3082,
    accuracy: 3
  },
  {
    postalCode: 2325,
    city: "Olney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.88,
    longitude: 151.3082,
    accuracy: 3
  },
  {
    postalCode: 2325,
    city: "Paynes Crossing",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9386,
    longitude: 151.2758,
    accuracy: 3
  },
  {
    postalCode: 2325,
    city: "Cedar Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8552,
    longitude: 151.2186,
    accuracy: 4
  },
  {
    postalCode: 2325,
    city: "Congewai",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9386,
    longitude: 151.2758,
    accuracy: 3
  },
  {
    postalCode: 2325,
    city: "Moruben",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.88,
    longitude: 151.3082,
    accuracy: 3
  },
  {
    postalCode: 2325,
    city: "Corrabare",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.88,
    longitude: 151.3082,
    accuracy: 3
  },
  {
    postalCode: 2325,
    city: "Aberdare",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8333,
    longitude: 151.3667,
    accuracy: 4
  },
  {
    postalCode: 2325,
    city: "Bellbird Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8504,
    longitude: 151.329,
    accuracy: 4
  },
  {
    postalCode: 2326,
    city: "Neath",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8276,
    longitude: 151.4082,
    accuracy: 4
  },
  {
    postalCode: 2326,
    city: "Abermain",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8074,
    longitude: 151.4275,
    accuracy: 4
  },
  {
    postalCode: 2326,
    city: "Bishops Bridge",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7455,
    longitude: 151.4689,
    accuracy: 4
  },
  {
    postalCode: 2326,
    city: "Weston",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.811,
    longitude: 151.4366,
    accuracy: 4
  },
  {
    postalCode: 2326,
    city: "Loxford",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.791,
    longitude: 151.4554,
    accuracy: 3
  },
  {
    postalCode: 2326,
    city: "Sawyers Gully",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8002,
    longitude: 151.4368,
    accuracy: 3
  },
  {
    postalCode: 2327,
    city: "Stanford Merthyr",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8247,
    longitude: 151.4936,
    accuracy: 4
  },
  {
    postalCode: 2327,
    city: "Pelaw Main",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8378,
    longitude: 151.4815,
    accuracy: 4
  },
  {
    postalCode: 2327,
    city: "Kurri Kurri",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8193,
    longitude: 151.4791,
    accuracy: 4
  },
  {
    postalCode: 2328,
    city: "Denman",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3879,
    longitude: 150.6893,
    accuracy: 4
  },
  {
    postalCode: 2328,
    city: "Widden",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5167,
    longitude: 150.3667,
    accuracy: 4
  },
  {
    postalCode: 2328,
    city: "Kerrabee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4167,
    longitude: 150.3,
    accuracy: 4
  },
  {
    postalCode: 2328,
    city: "Martindale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4404,
    longitude: 150.452,
    accuracy: 3
  },
  {
    postalCode: 2328,
    city: "Bureen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4404,
    longitude: 150.452,
    accuracy: 3
  },
  {
    postalCode: 2328,
    city: "Hollydeen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5658,
    longitude: 150.5176,
    accuracy: 3
  },
  {
    postalCode: 2328,
    city: "Giants Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4404,
    longitude: 150.452,
    accuracy: 3
  },
  {
    postalCode: 2328,
    city: "Yarrawa",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4404,
    longitude: 150.452,
    accuracy: 3
  },
  {
    postalCode: 2328,
    city: "Dalswinton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4404,
    longitude: 150.452,
    accuracy: 3
  },
  {
    postalCode: 2328,
    city: "Mangoola",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4404,
    longitude: 150.452,
    accuracy: 3
  },
  {
    postalCode: 2329,
    city: "Cassilis",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32,
    longitude: 149.9833,
    accuracy: 4
  },
  {
    postalCode: 2329,
    city: "Borambil",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.0333,
    longitude: 150,
    accuracy: 4
  },
  {
    postalCode: 2329,
    city: "Uarbry",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.0485,
    longitude: 149.7679,
    accuracy: 4
  },
  {
    postalCode: 2329,
    city: "Merriwa",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1392,
    longitude: 150.3556,
    accuracy: 4
  },
  {
    postalCode: 2330,
    city: "Ravensworth",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.45,
    longitude: 151.0667,
    accuracy: 4
  },
  {
    postalCode: 2330,
    city: "Gowrie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.35,
    longitude: 150.85,
    accuracy: 4
  },
  {
    postalCode: 2330,
    city: "Glenridding",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6686,
    longitude: 151.0454,
    accuracy: 3
  },
  {
    postalCode: 2330,
    city: "Howick",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6686,
    longitude: 151.0454,
    accuracy: 3
  },
  {
    postalCode: 2330,
    city: "Warkworth",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5833,
    longitude: 151.0333,
    accuracy: 4
  },
  {
    postalCode: 2330,
    city: "Glendon Brook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5207,
    longitude: 151.3346,
    accuracy: 4
  },
  {
    postalCode: 2330,
    city: "Scotts Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6686,
    longitude: 151.0454,
    accuracy: 3
  },
  {
    postalCode: 2330,
    city: "Hunterview",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5434,
    longitude: 151.1772,
    accuracy: 4
  },
  {
    postalCode: 2330,
    city: "Putty",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9652,
    longitude: 150.6679,
    accuracy: 4
  },
  {
    postalCode: 2330,
    city: "Dunolly",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6686,
    longitude: 151.0454,
    accuracy: 3
  },
  {
    postalCode: 2330,
    city: "Gouldsville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6686,
    longitude: 151.0454,
    accuracy: 3
  },
  {
    postalCode: 2330,
    city: "Milbrodale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6686,
    longitude: 151.0454,
    accuracy: 3
  },
  {
    postalCode: 2330,
    city: "Long Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0167,
    longitude: 150.9,
    accuracy: 4
  },
  {
    postalCode: 2330,
    city: "Goorangoola",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6686,
    longitude: 151.0454,
    accuracy: 3
  },
  {
    postalCode: 2330,
    city: "Mitchells Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5485,
    longitude: 151.2846,
    accuracy: 4
  },
  {
    postalCode: 2330,
    city: "Redbournberry",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6686,
    longitude: 151.0454,
    accuracy: 3
  },
  {
    postalCode: 2330,
    city: "Whittingham",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6167,
    longitude: 151.2,
    accuracy: 4
  },
  {
    postalCode: 2330,
    city: "Big Ridge",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6686,
    longitude: 151.0454,
    accuracy: 3
  },
  {
    postalCode: 2330,
    city: "Doyles Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5485,
    longitude: 150.7846,
    accuracy: 4
  },
  {
    postalCode: 2330,
    city: "Mirannie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6993,
    longitude: 150.95,
    accuracy: 3
  },
  {
    postalCode: 2330,
    city: "Glendon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.5794,
    longitude: 150.4082,
    accuracy: 4
  },
  {
    postalCode: 2330,
    city: "Hebden",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3833,
    longitude: 151.0667,
    accuracy: 4
  },
  {
    postalCode: 2330,
    city: "Wollemi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.044,
    longitude: 150.6799,
    accuracy: 4
  },
  {
    postalCode: 2330,
    city: "Darlington",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.891,
    longitude: 151.1955,
    accuracy: 4
  },
  {
    postalCode: 2330,
    city: "Sedgefield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5402,
    longitude: 151.2512,
    accuracy: 4
  },
  {
    postalCode: 2330,
    city: "Mount Thorley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6686,
    longitude: 151.0454,
    accuracy: 3
  },
  {
    postalCode: 2330,
    city: "Bowmans Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.2652,
    longitude: 151.1346,
    accuracy: 4
  },
  {
    postalCode: 2330,
    city: "Mount Olive",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6993,
    longitude: 150.95,
    accuracy: 3
  },
  {
    postalCode: 2330,
    city: "Maison Dieu",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5378,
    longitude: 151.0902,
    accuracy: 4
  },
  {
    postalCode: 2330,
    city: "Appletree Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6686,
    longitude: 151.0454,
    accuracy: 3
  },
  {
    postalCode: 2330,
    city: "Camberwell",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4833,
    longitude: 151.0833,
    accuracy: 4
  },
  {
    postalCode: 2330,
    city: "Bridgman",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4543,
    longitude: 151.1882,
    accuracy: 4
  },
  {
    postalCode: 2330,
    city: "Singleton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5674,
    longitude: 151.166,
    accuracy: 4
  },
  {
    postalCode: 2330,
    city: "Combo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6686,
    longitude: 151.0454,
    accuracy: 3
  },
  {
    postalCode: 2330,
    city: "Middle Falbrook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6686,
    longitude: 151.0454,
    accuracy: 3
  },
  {
    postalCode: 2330,
    city: "Westbrook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6686,
    longitude: 151.0454,
    accuracy: 3
  },
  {
    postalCode: 2330,
    city: "Mount Royal",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.2075,
    longitude: 151.2993,
    accuracy: 4
  },
  {
    postalCode: 2330,
    city: "Obanvale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6686,
    longitude: 151.0454,
    accuracy: 3
  },
  {
    postalCode: 2330,
    city: "Reedy Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6993,
    longitude: 150.95,
    accuracy: 3
  },
  {
    postalCode: 2330,
    city: "Jerrys Plains",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5,
    longitude: 150.9167,
    accuracy: 4
  },
  {
    postalCode: 2330,
    city: "Big Yengo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8931,
    longitude: 150.8457,
    accuracy: 4
  },
  {
    postalCode: 2330,
    city: "Lemington",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6686,
    longitude: 151.0454,
    accuracy: 3
  },
  {
    postalCode: 2330,
    city: "Fern Gully",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6686,
    longitude: 151.0454,
    accuracy: 3
  },
  {
    postalCode: 2330,
    city: "Garland Valley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6686,
    longitude: 151.0454,
    accuracy: 3
  },
  {
    postalCode: 2330,
    city: "Fordwich",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6686,
    longitude: 151.0454,
    accuracy: 3
  },
  {
    postalCode: 2330,
    city: "Rixs Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6686,
    longitude: 151.0454,
    accuracy: 3
  },
  {
    postalCode: 2330,
    city: "Hambledon Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6686,
    longitude: 151.0454,
    accuracy: 3
  },
  {
    postalCode: 2330,
    city: "Howes Valley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8485,
    longitude: 150.8512,
    accuracy: 4
  },
  {
    postalCode: 2330,
    city: "St Clair",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7973,
    longitude: 150.7847,
    accuracy: 4
  },
  {
    postalCode: 2330,
    city: "Dyrring",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6686,
    longitude: 151.0454,
    accuracy: 3
  },
  {
    postalCode: 2330,
    city: "Clydesdale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6686,
    longitude: 151.0454,
    accuracy: 3
  },
  {
    postalCode: 2330,
    city: "Wattle Ponds",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6686,
    longitude: 151.0454,
    accuracy: 3
  },
  {
    postalCode: 2330,
    city: "Dural",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6833,
    longitude: 151.0167,
    accuracy: 4
  },
  {
    postalCode: 2330,
    city: "Roughit",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6686,
    longitude: 151.0454,
    accuracy: 3
  },
  {
    postalCode: 2330,
    city: "Falbrook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6686,
    longitude: 151.0454,
    accuracy: 3
  },
  {
    postalCode: 2330,
    city: "Wylies Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6686,
    longitude: 151.0454,
    accuracy: 3
  },
  {
    postalCode: 2330,
    city: "Bulga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6667,
    longitude: 151.0167,
    accuracy: 4
  },
  {
    postalCode: 2330,
    city: "Mcdougalls Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6686,
    longitude: 151.0454,
    accuracy: 3
  },
  {
    postalCode: 2330,
    city: "Broke",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7512,
    longitude: 151.1045,
    accuracy: 4
  },
  {
    postalCode: 2330,
    city: "Greenlands",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6993,
    longitude: 150.95,
    accuracy: 3
  },
  {
    postalCode: 2330,
    city: "Glennies Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.45,
    longitude: 151.1167,
    accuracy: 4
  },
  {
    postalCode: 2330,
    city: "Singleton Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6686,
    longitude: 151.0454,
    accuracy: 3
  },
  {
    postalCode: 2330,
    city: "Carrowbrook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6993,
    longitude: 150.95,
    accuracy: 3
  },
  {
    postalCode: 2331,
    city: "Singleton Milpo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6895,
    longitude: 151.1897,
    accuracy: 1
  },
  {
    postalCode: 2331,
    city: "Singleton Military Area",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3281,
    longitude: 150.986,
    accuracy: 1
  },
  {
    postalCode: 2333,
    city: "Baerami Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5,
    longitude: 150.4667,
    accuracy: 4
  },
  {
    postalCode: 2333,
    city: "Mccullys Gap",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.2966,
    longitude: 150.7584,
    accuracy: 3
  },
  {
    postalCode: 2333,
    city: "Liddell",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4167,
    longitude: 151.0333,
    accuracy: 4
  },
  {
    postalCode: 2333,
    city: "Edderton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.2966,
    longitude: 150.7584,
    accuracy: 3
  },
  {
    postalCode: 2333,
    city: "Sandy Hollow",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3333,
    longitude: 150.5667,
    accuracy: 4
  },
  {
    postalCode: 2333,
    city: "Castle Rock",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3306,
    longitude: 150.68,
    accuracy: 3
  },
  {
    postalCode: 2333,
    city: "Muscle Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.2704,
    longitude: 150.9978,
    accuracy: 3
  },
  {
    postalCode: 2333,
    city: "Gungal",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.2652,
    longitude: 150.4846,
    accuracy: 4
  },
  {
    postalCode: 2333,
    city: "Kayuga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.2,
    longitude: 150.8667,
    accuracy: 4
  },
  {
    postalCode: 2333,
    city: "Bengalla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3306,
    longitude: 150.68,
    accuracy: 3
  },
  {
    postalCode: 2333,
    city: "Baerami",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3818,
    longitude: 150.4679,
    accuracy: 4
  },
  {
    postalCode: 2333,
    city: "Manobalai",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1896,
    longitude: 150.676,
    accuracy: 4
  },
  {
    postalCode: 2333,
    city: "Muswellbrook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.2612,
    longitude: 150.8901,
    accuracy: 4
  },
  {
    postalCode: 2333,
    city: "Wybong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.2667,
    longitude: 150.6333,
    accuracy: 4
  },
  {
    postalCode: 2334,
    city: "Greta",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6778,
    longitude: 151.3892,
    accuracy: 4
  },
  {
    postalCode: 2335,
    city: "Leconfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0131,
    longitude: 151.1701,
    accuracy: 3
  },
  {
    postalCode: 2335,
    city: "Elderslie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.05,
    longitude: 150.7,
    accuracy: 4
  },
  {
    postalCode: 2335,
    city: "Stanhope",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7164,
    longitude: 150.9261,
    accuracy: 4
  },
  {
    postalCode: 2335,
    city: "North Rothbury",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6934,
    longitude: 151.3438,
    accuracy: 4
  },
  {
    postalCode: 2335,
    city: "Lower Belford",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0131,
    longitude: 151.1701,
    accuracy: 3
  },
  {
    postalCode: 2335,
    city: "East Branxton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0131,
    longitude: 151.1701,
    accuracy: 3
  },
  {
    postalCode: 2335,
    city: "Dalwood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6484,
    longitude: 151.3046,
    accuracy: 3
  },
  {
    postalCode: 2335,
    city: "Lambs Valley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0131,
    longitude: 151.1701,
    accuracy: 3
  },
  {
    postalCode: 2335,
    city: "Belford",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6667,
    longitude: 151.2833,
    accuracy: 4
  },
  {
    postalCode: 2335,
    city: "Branxton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6555,
    longitude: 151.3511,
    accuracy: 4
  },
  {
    postalCode: 2336,
    city: "Upper Rouchel",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1167,
    longitude: 151.0833,
    accuracy: 4
  },
  {
    postalCode: 2336,
    city: "Rouchel",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1167,
    longitude: 151.0833,
    accuracy: 4
  },
  {
    postalCode: 2336,
    city: "Dartbrook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1568,
    longitude: 150.8063,
    accuracy: 4
  },
  {
    postalCode: 2336,
    city: "Upper Dartbrook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1568,
    longitude: 150.8063,
    accuracy: 4
  },
  {
    postalCode: 2336,
    city: "Aberdeen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1659,
    longitude: 150.89,
    accuracy: 4
  },
  {
    postalCode: 2336,
    city: "Rouchel Brook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1254,
    longitude: 151.0481,
    accuracy: 3
  },
  {
    postalCode: 2336,
    city: "Davis Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1023,
    longitude: 151.1358,
    accuracy: 3
  },
  {
    postalCode: 2336,
    city: "Rossgole",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1254,
    longitude: 151.0481,
    accuracy: 3
  },
  {
    postalCode: 2337,
    city: "Stewarts Brook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9985,
    longitude: 151.3179,
    accuracy: 4
  },
  {
    postalCode: 2337,
    city: "Owens Gap",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.05,
    longitude: 150.7,
    accuracy: 4
  },
  {
    postalCode: 2337,
    city: "Moonan Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9167,
    longitude: 151.25,
    accuracy: 4
  },
  {
    postalCode: 2337,
    city: "Ellerston",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8167,
    longitude: 151.3167,
    accuracy: 4
  },
  {
    postalCode: 2337,
    city: "Satur",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.041,
    longitude: 150.8416,
    accuracy: 4
  },
  {
    postalCode: 2337,
    city: "Wingen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8833,
    longitude: 150.8833,
    accuracy: 4
  },
  {
    postalCode: 2337,
    city: "Moonan Brook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9415,
    longitude: 151.2792,
    accuracy: 4
  },
  {
    postalCode: 2337,
    city: "Moobi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9573,
    longitude: 151.0389,
    accuracy: 3
  },
  {
    postalCode: 2337,
    city: "Glenrock",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6652,
    longitude: 151.4179,
    accuracy: 4
  },
  {
    postalCode: 2337,
    city: "Segenhoe",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1167,
    longitude: 150.9167,
    accuracy: 4
  },
  {
    postalCode: 2337,
    city: "Scone",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.0501,
    longitude: 150.8689,
    accuracy: 4
  },
  {
    postalCode: 2337,
    city: "Glenbawn",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9573,
    longitude: 151.0389,
    accuracy: 3
  },
  {
    postalCode: 2337,
    city: "Tomalla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.85,
    longitude: 151.4667,
    accuracy: 4
  },
  {
    postalCode: 2337,
    city: "Gundy",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.0167,
    longitude: 151,
    accuracy: 4
  },
  {
    postalCode: 2337,
    city: "Belltrees",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9906,
    longitude: 151.1232,
    accuracy: 4
  },
  {
    postalCode: 2337,
    city: "Murulla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9573,
    longitude: 151.0389,
    accuracy: 3
  },
  {
    postalCode: 2337,
    city: "Bunnan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.05,
    longitude: 150.5833,
    accuracy: 4
  },
  {
    postalCode: 2337,
    city: "Kars Springs",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9,
    longitude: 150.5667,
    accuracy: 4
  },
  {
    postalCode: 2337,
    city: "Parkville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9809,
    longitude: 150.8628,
    accuracy: 4
  },
  {
    postalCode: 2337,
    city: "Middle Brook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9573,
    longitude: 151.0389,
    accuracy: 3
  },
  {
    postalCode: 2337,
    city: "Pages Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9573,
    longitude: 151.0389,
    accuracy: 3
  },
  {
    postalCode: 2337,
    city: "Woolooma",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32,
    longitude: 151.25,
    accuracy: 4
  },
  {
    postalCode: 2337,
    city: "Omadale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9573,
    longitude: 151.0389,
    accuracy: 3
  },
  {
    postalCode: 2337,
    city: "Waverly",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9573,
    longitude: 151.0389,
    accuracy: 3
  },
  {
    postalCode: 2337,
    city: "Brawboy",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9573,
    longitude: 151.0389,
    accuracy: 3
  },
  {
    postalCode: 2337,
    city: "Dry Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9573,
    longitude: 151.0389,
    accuracy: 3
  },
  {
    postalCode: 2338,
    city: "Timor",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.7833,
    longitude: 151.0833,
    accuracy: 4
  },
  {
    postalCode: 2338,
    city: "Ardglen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.7358,
    longitude: 150.7484,
    accuracy: 4
  },
  {
    postalCode: 2338,
    city: "Pages River",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.7744,
    longitude: 150.9006,
    accuracy: 3
  },
  {
    postalCode: 2338,
    city: "Murrurundi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.7642,
    longitude: 150.8358,
    accuracy: 4
  },
  {
    postalCode: 2338,
    city: "Green Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.7744,
    longitude: 150.9006,
    accuracy: 3
  },
  {
    postalCode: 2338,
    city: "Blandford",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.7849,
    longitude: 150.8935,
    accuracy: 4
  },
  {
    postalCode: 2338,
    city: "Crawney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.7744,
    longitude: 150.9006,
    accuracy: 3
  },
  {
    postalCode: 2338,
    city: "Sandy Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.7744,
    longitude: 150.9006,
    accuracy: 3
  },
  {
    postalCode: 2338,
    city: "Scotts Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.7744,
    longitude: 150.9006,
    accuracy: 3
  },
  {
    postalCode: 2339,
    city: "Warrah Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.7152,
    longitude: 150.6512,
    accuracy: 4
  },
  {
    postalCode: 2339,
    city: "Cattle Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6778,
    longitude: 150.6778,
    accuracy: 3
  },
  {
    postalCode: 2339,
    city: "Braefield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.5707,
    longitude: 150.7018,
    accuracy: 4
  },
  {
    postalCode: 2339,
    city: "Little Jacks Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6778,
    longitude: 150.6778,
    accuracy: 3
  },
  {
    postalCode: 2339,
    city: "Willow Tree",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6495,
    longitude: 150.7264,
    accuracy: 4
  },
  {
    postalCode: 2339,
    city: "Macdonalds Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6778,
    longitude: 150.6778,
    accuracy: 3
  },
  {
    postalCode: 2339,
    city: "Warrah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.65,
    longitude: 150.65,
    accuracy: 4
  },
  {
    postalCode: 2339,
    city: "Parraweena",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6778,
    longitude: 150.6778,
    accuracy: 3
  },
  {
    postalCode: 2339,
    city: "Big Jacks Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6778,
    longitude: 150.6778,
    accuracy: 3
  },
  {
    postalCode: 2339,
    city: "Chilcotts Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6778,
    longitude: 150.6778,
    accuracy: 3
  },
  {
    postalCode: 2340,
    city: "Loomberah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.1833,
    longitude: 151,
    accuracy: 4
  },
  {
    postalCode: 2340,
    city: "Daruka",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0373,
    longitude: 150.9707,
    accuracy: 4
  },
  {
    postalCode: 2340,
    city: "Somerton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.9411,
    longitude: 150.6383,
    accuracy: 4
  },
  {
    postalCode: 2340,
    city: "Hillvue",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.1276,
    longitude: 150.9071,
    accuracy: 4
  },
  {
    postalCode: 2340,
    city: "Moore Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.1512,
    longitude: 150.9383,
    accuracy: 3
  },
  {
    postalCode: 2340,
    city: "Garoo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.1512,
    longitude: 150.9383,
    accuracy: 3
  },
  {
    postalCode: 2340,
    city: "Hanging Rock",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4822,
    longitude: 151.1921,
    accuracy: 4
  },
  {
    postalCode: 2340,
    city: "Appleby",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.9667,
    longitude: 150.85,
    accuracy: 4
  },
  {
    postalCode: 2340,
    city: "Westdale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0905,
    longitude: 150.8568,
    accuracy: 4
  },
  {
    postalCode: 2340,
    city: "Gowrie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.35,
    longitude: 150.85,
    accuracy: 4
  },
  {
    postalCode: 2340,
    city: "Goonoo Goonoo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.3079,
    longitude: 150.9027,
    accuracy: 4
  },
  {
    postalCode: 2340,
    city: "South Tamworth",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.11,
    longitude: 150.9225,
    accuracy: 4
  },
  {
    postalCode: 2340,
    city: "Nundle",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.465,
    longitude: 151.1264,
    accuracy: 4
  },
  {
    postalCode: 2340,
    city: "Calala",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.1736,
    longitude: 150.9806,
    accuracy: 4
  },
  {
    postalCode: 2340,
    city: "Carroll",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.9894,
    longitude: 150.4442,
    accuracy: 4
  },
  {
    postalCode: 2340,
    city: "Bithramere",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.1357,
    longitude: 150.7811,
    accuracy: 4
  },
  {
    postalCode: 2340,
    city: "Woolomin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.305,
    longitude: 151.1502,
    accuracy: 4
  },
  {
    postalCode: 2340,
    city: "Tamworth South",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.2744,
    longitude: 151.0275,
    accuracy: 3
  },
  {
    postalCode: 2340,
    city: "Gidley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0119,
    longitude: 150.8387,
    accuracy: 4
  },
  {
    postalCode: 2340,
    city: "Keepit",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.8333,
    longitude: 150.5167,
    accuracy: 4
  },
  {
    postalCode: 2340,
    city: "Barry",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.5817,
    longitude: 151.3183,
    accuracy: 4
  },
  {
    postalCode: 2340,
    city: "Oxley Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0632,
    longitude: 150.9006,
    accuracy: 4
  },
  {
    postalCode: 2340,
    city: "Duncans Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.3667,
    longitude: 151.2,
    accuracy: 4
  },
  {
    postalCode: 2340,
    city: "Weabonga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.2167,
    longitude: 151.3167,
    accuracy: 4
  },
  {
    postalCode: 2340,
    city: "Warral",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.1637,
    longitude: 150.8567,
    accuracy: 4
  },
  {
    postalCode: 2340,
    city: "Ogunbil",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.1512,
    longitude: 150.9383,
    accuracy: 3
  },
  {
    postalCode: 2340,
    city: "North Tamworth",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0786,
    longitude: 150.9222,
    accuracy: 4
  },
  {
    postalCode: 2340,
    city: "Kingswood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.75,
    longitude: 150.75,
    accuracy: 4
  },
  {
    postalCode: 2340,
    city: "Dungowan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.2152,
    longitude: 151.1179,
    accuracy: 4
  },
  {
    postalCode: 2340,
    city: "Wallamore",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.1512,
    longitude: 150.9383,
    accuracy: 3
  },
  {
    postalCode: 2340,
    city: "Bective",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0042,
    longitude: 150.7269,
    accuracy: 4
  },
  {
    postalCode: 2340,
    city: "Hallsville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0112,
    longitude: 150.874,
    accuracy: 4
  },
  {
    postalCode: 2340,
    city: "Piallamore",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.1659,
    longitude: 151.0576,
    accuracy: 4
  },
  {
    postalCode: 2340,
    city: "Taminda",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0941,
    longitude: 150.8962,
    accuracy: 4
  },
  {
    postalCode: 2340,
    city: "West Tamworth",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.1024,
    longitude: 150.9145,
    accuracy: 4
  },
  {
    postalCode: 2340,
    city: "Nemingha",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.1237,
    longitude: 150.9892,
    accuracy: 4
  },
  {
    postalCode: 2340,
    city: "Timbumburi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.1512,
    longitude: 150.9383,
    accuracy: 3
  },
  {
    postalCode: 2340,
    city: "Bowling Alley Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.3956,
    longitude: 151.1397,
    accuracy: 4
  },
  {
    postalCode: 2340,
    city: "East Tamworth",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0855,
    longitude: 150.9372,
    accuracy: 4
  },
  {
    postalCode: 2340,
    city: "Tamworth",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0905,
    longitude: 150.929,
    accuracy: 4
  },
  {
    postalCode: 2341,
    city: "Werris Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.3491,
    longitude: 150.6487,
    accuracy: 4
  },
  {
    postalCode: 2342,
    city: "Piallaway",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.1667,
    longitude: 150.5833,
    accuracy: 4
  },
  {
    postalCode: 2342,
    city: "Currabubula",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.2667,
    longitude: 150.7333,
    accuracy: 4
  },
  {
    postalCode: 2343,
    city: "Coomoo Coomoo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.5553,
    longitude: 150.3414,
    accuracy: 3
  },
  {
    postalCode: 2343,
    city: "Warrah Ridge",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.5667,
    longitude: 150.55,
    accuracy: 4
  },
  {
    postalCode: 2343,
    city: "Spring Ridge",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4,
    longitude: 150.25,
    accuracy: 4
  },
  {
    postalCode: 2343,
    city: "Quirindi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.5076,
    longitude: 150.679,
    accuracy: 4
  },
  {
    postalCode: 2343,
    city: "Pine Ridge",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.499,
    longitude: 150.4539,
    accuracy: 4
  },
  {
    postalCode: 2343,
    city: "Blackville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6438,
    longitude: 150.2361,
    accuracy: 4
  },
  {
    postalCode: 2343,
    city: "Colly Blue",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4592,
    longitude: 150.1458,
    accuracy: 4
  },
  {
    postalCode: 2343,
    city: "Yarraman",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6167,
    longitude: 150.2,
    accuracy: 4
  },
  {
    postalCode: 2343,
    city: "Wallabadah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.5425,
    longitude: 150.8282,
    accuracy: 4
  },
  {
    postalCode: 2343,
    city: "Caroona",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4066,
    longitude: 150.4264,
    accuracy: 4
  },
  {
    postalCode: 2343,
    city: "Borambil",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.5071,
    longitude: 150.6419,
    accuracy: 4
  },
  {
    postalCode: 2343,
    city: "Bundella",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.5664,
    longitude: 149.9929,
    accuracy: 4
  },
  {
    postalCode: 2343,
    city: "Windy",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.5976,
    longitude: 150.3836,
    accuracy: 4
  },
  {
    postalCode: 2343,
    city: "Yannergee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4437,
    longitude: 150.0303,
    accuracy: 4
  },
  {
    postalCode: 2343,
    city: "Quipolly",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4284,
    longitude: 150.6564,
    accuracy: 4
  },
  {
    postalCode: 2344,
    city: "Duri",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.2141,
    longitude: 150.8219,
    accuracy: 4
  },
  {
    postalCode: 2344,
    city: "Winton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0818,
    longitude: 150.7179,
    accuracy: 4
  },
  {
    postalCode: 2345,
    city: "Garthowen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.8951,
    longitude: 150.7835,
    accuracy: 3
  },
  {
    postalCode: 2345,
    city: "Attunga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.9303,
    longitude: 150.8468,
    accuracy: 4
  },
  {
    postalCode: 2346,
    city: "Wongo Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.7,
    longitude: 150.5,
    accuracy: 4
  },
  {
    postalCode: 2346,
    city: "Borah Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.7295,
    longitude: 150.6539,
    accuracy: 3
  },
  {
    postalCode: 2346,
    city: "Manilla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.7475,
    longitude: 150.7197,
    accuracy: 4
  },
  {
    postalCode: 2346,
    city: "Halls Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.7295,
    longitude: 150.6539,
    accuracy: 3
  },
  {
    postalCode: 2346,
    city: "Klori",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.8318,
    longitude: 150.7679,
    accuracy: 4
  },
  {
    postalCode: 2346,
    city: "Namoi River",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.7295,
    longitude: 150.6539,
    accuracy: 3
  },
  {
    postalCode: 2346,
    city: "Upper Manilla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.6385,
    longitude: 150.6635,
    accuracy: 4
  },
  {
    postalCode: 2346,
    city: "Wimborne",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.7295,
    longitude: 150.6539,
    accuracy: 3
  },
  {
    postalCode: 2346,
    city: "New Mexico",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.7424,
    longitude: 150.6185,
    accuracy: 4
  },
  {
    postalCode: 2346,
    city: "Rushes Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.7295,
    longitude: 150.6539,
    accuracy: 3
  },
  {
    postalCode: 2346,
    city: "Warrabah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.7295,
    longitude: 150.6539,
    accuracy: 3
  },
  {
    postalCode: 2347,
    city: "Thirldene",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2297,
    longitude: 150.5773,
    accuracy: 3
  },
  {
    postalCode: 2347,
    city: "Woodsreef",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.3818,
    longitude: 150.7346,
    accuracy: 4
  },
  {
    postalCode: 2347,
    city: "Cobbadah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2286,
    longitude: 150.5823,
    accuracy: 4
  },
  {
    postalCode: 2347,
    city: "Banoon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2297,
    longitude: 150.5773,
    accuracy: 3
  },
  {
    postalCode: 2347,
    city: "Red Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0523,
    longitude: 149.1643,
    accuracy: 3
  },
  {
    postalCode: 2347,
    city: "Barraba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.3855,
    longitude: 150.609,
    accuracy: 4
  },
  {
    postalCode: 2347,
    city: "Gundamulda",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2297,
    longitude: 150.5773,
    accuracy: 3
  },
  {
    postalCode: 2347,
    city: "Gulf Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.1985,
    longitude: 150.7012,
    accuracy: 4
  },
  {
    postalCode: 2347,
    city: "Mayvale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2297,
    longitude: 150.5773,
    accuracy: 3
  },
  {
    postalCode: 2347,
    city: "Upper Horton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.1333,
    longitude: 150.4333,
    accuracy: 4
  },
  {
    postalCode: 2347,
    city: "Ironbark",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2297,
    longitude: 150.5773,
    accuracy: 3
  },
  {
    postalCode: 2347,
    city: "Lindesay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2297,
    longitude: 150.5773,
    accuracy: 3
  },
  {
    postalCode: 2347,
    city: "Longarm",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2297,
    longitude: 150.5773,
    accuracy: 3
  },
  {
    postalCode: 2348,
    city: "New England Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.191,
    longitude: 150.7174,
    accuracy: 1
  },
  {
    postalCode: 2350,
    city: "Hillgrove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.5712,
    longitude: 151.9045,
    accuracy: 4
  },
  {
    postalCode: 2350,
    city: "Tilbuster",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.4333,
    longitude: 151.6667,
    accuracy: 4
  },
  {
    postalCode: 2350,
    city: "Dangarsleigh",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.6055,
    longitude: 151.6898,
    accuracy: 4
  },
  {
    postalCode: 2350,
    city: "Lyndhurst",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.3167,
    longitude: 152.05,
    accuracy: 4
  },
  {
    postalCode: 2350,
    city: "Castle Doyle",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.6152,
    longitude: 151.7679,
    accuracy: 4
  },
  {
    postalCode: 2350,
    city: "Duval",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.461,
    longitude: 151.7789,
    accuracy: 3
  },
  {
    postalCode: 2350,
    city: "Wongwibinda",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2928,
    longitude: 152.1661,
    accuracy: 4
  },
  {
    postalCode: 2350,
    city: "Abington",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2833,
    longitude: 151.1833,
    accuracy: 4
  },
  {
    postalCode: 2350,
    city: "Dumaresq",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.4667,
    longitude: 151.5833,
    accuracy: 4
  },
  {
    postalCode: 2350,
    city: "Aberfoyle",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2667,
    longitude: 152.0167,
    accuracy: 4
  },
  {
    postalCode: 2350,
    city: "Saumarez",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.5546,
    longitude: 151.5837,
    accuracy: 4
  },
  {
    postalCode: 2350,
    city: "East Armidale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.506,
    longitude: 151.9832,
    accuracy: 3
  },
  {
    postalCode: 2350,
    city: "Boorolong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.3235,
    longitude: 151.5346,
    accuracy: 4
  },
  {
    postalCode: 2350,
    city: "Wollomombi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.5143,
    longitude: 152.0435,
    accuracy: 4
  },
  {
    postalCode: 2350,
    city: "Kellys Plains",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.5712,
    longitude: 151.6436,
    accuracy: 4
  },
  {
    postalCode: 2350,
    city: "Jeogla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.5765,
    longitude: 152.1184,
    accuracy: 4
  },
  {
    postalCode: 2350,
    city: "Enmore",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.7333,
    longitude: 151.8,
    accuracy: 4
  },
  {
    postalCode: 2350,
    city: "Wards Mistake",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.1318,
    longitude: 152.0096,
    accuracy: 4
  },
  {
    postalCode: 2350,
    city: "Armidale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.5083,
    longitude: 151.6712,
    accuracy: 4
  },
  {
    postalCode: 2350,
    city: "Saumarez Ponds",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.461,
    longitude: 151.7789,
    accuracy: 3
  },
  {
    postalCode: 2350,
    city: "Invergowrie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.512,
    longitude: 151.507,
    accuracy: 4
  },
  {
    postalCode: 2350,
    city: "Thalgarrah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.461,
    longitude: 151.7789,
    accuracy: 3
  },
  {
    postalCode: 2350,
    city: "West Armidale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.506,
    longitude: 151.9832,
    accuracy: 3
  },
  {
    postalCode: 2350,
    city: "Puddledock",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.3667,
    longitude: 151.7667,
    accuracy: 4
  },
  {
    postalCode: 2350,
    city: "Donald Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.461,
    longitude: 151.7789,
    accuracy: 3
  },
  {
    postalCode: 2350,
    city: "Argyle",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.461,
    longitude: 151.7789,
    accuracy: 3
  },
  {
    postalCode: 2350,
    city: "Metz",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.5785,
    longitude: 151.8735,
    accuracy: 4
  },
  {
    postalCode: 2351,
    city: "University Of New England",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.85,
    longitude: 151.0635,
    accuracy: 1
  },
  {
    postalCode: 2352,
    city: "Limbri",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0388,
    longitude: 151.1553,
    accuracy: 4
  },
  {
    postalCode: 2352,
    city: "Mulla Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0695,
    longitude: 151.0734,
    accuracy: 3
  },
  {
    postalCode: 2352,
    city: "Kootingal",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0586,
    longitude: 151.0535,
    accuracy: 4
  },
  {
    postalCode: 2352,
    city: "Tintinhull",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0925,
    longitude: 151.0202,
    accuracy: 4
  },
  {
    postalCode: 2353,
    city: "Moonbi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0177,
    longitude: 151.0706,
    accuracy: 4
  },
  {
    postalCode: 2354,
    city: "Woolbrook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.9652,
    longitude: 151.3512,
    accuracy: 4
  },
  {
    postalCode: 2354,
    city: "Niangala",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.3001,
    longitude: 151.4049,
    accuracy: 4
  },
  {
    postalCode: 2354,
    city: "Kentucky",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.7614,
    longitude: 151.4489,
    accuracy: 4
  },
  {
    postalCode: 2354,
    city: "Walcha",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.9849,
    longitude: 151.5934,
    accuracy: 4
  },
  {
    postalCode: 2354,
    city: "Nowendoc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.5175,
    longitude: 151.7148,
    accuracy: 4
  },
  {
    postalCode: 2354,
    city: "Wollun",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.8464,
    longitude: 151.4263,
    accuracy: 4
  },
  {
    postalCode: 2354,
    city: "Yarrowitch",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.2701,
    longitude: 151.971,
    accuracy: 4
  },
  {
    postalCode: 2354,
    city: "Walcha Road",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.9441,
    longitude: 151.4,
    accuracy: 4
  },
  {
    postalCode: 2354,
    city: "Kentucky South",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.7973,
    longitude: 151.4401,
    accuracy: 4
  },
  {
    postalCode: 2355,
    city: "Watsons Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.7384,
    longitude: 151.0513,
    accuracy: 4
  },
  {
    postalCode: 2355,
    city: "Retreat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.6068,
    longitude: 151.1068,
    accuracy: 4
  },
  {
    postalCode: 2355,
    city: "Bendemeer",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.8865,
    longitude: 151.1535,
    accuracy: 4
  },
  {
    postalCode: 2356,
    city: "Gwabegar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.6101,
    longitude: 148.9675,
    accuracy: 4
  },
  {
    postalCode: 2357,
    city: "Coonabarabran",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.2773,
    longitude: 149.279,
    accuracy: 4
  },
  {
    postalCode: 2357,
    city: "Ulamambri",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.328,
    longitude: 149.4007,
    accuracy: 4
  },
  {
    postalCode: 2357,
    city: "Gowang",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4235,
    longitude: 149.0846,
    accuracy: 4
  },
  {
    postalCode: 2357,
    city: "Wattle Springs",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.2332,
    longitude: 149.2463,
    accuracy: 3
  },
  {
    postalCode: 2357,
    city: "Purlewaugh",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.346,
    longitude: 149.5092,
    accuracy: 4
  },
  {
    postalCode: 2357,
    city: "Box Ridge",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.25,
    longitude: 148.8167,
    accuracy: 4
  },
  {
    postalCode: 2357,
    city: "Dandry",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0277,
    longitude: 149.4043,
    accuracy: 4
  },
  {
    postalCode: 2357,
    city: "Rocky Glen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.1167,
    longitude: 149.5667,
    accuracy: 4
  },
  {
    postalCode: 2357,
    city: "Tannabar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.2332,
    longitude: 149.2463,
    accuracy: 3
  },
  {
    postalCode: 2357,
    city: "Bugaldie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.1252,
    longitude: 149.1116,
    accuracy: 4
  },
  {
    postalCode: 2357,
    city: "Bomera",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.2332,
    longitude: 149.2463,
    accuracy: 3
  },
  {
    postalCode: 2358,
    city: "Gostwyck",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.6941,
    longitude: 151.5834,
    accuracy: 4
  },
  {
    postalCode: 2358,
    city: "Arding",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.5677,
    longitude: 151.5254,
    accuracy: 4
  },
  {
    postalCode: 2358,
    city: "Yarrowyck",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.4639,
    longitude: 151.3222,
    accuracy: 4
  },
  {
    postalCode: 2358,
    city: "Enmore",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.7333,
    longitude: 151.8,
    accuracy: 4
  },
  {
    postalCode: 2358,
    city: "Rocky River",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.6167,
    longitude: 151.5,
    accuracy: 4
  },
  {
    postalCode: 2358,
    city: "Torryburn",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.45,
    longitude: 151.2167,
    accuracy: 4
  },
  {
    postalCode: 2358,
    city: "Balala",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.6046,
    longitude: 151.4612,
    accuracy: 3
  },
  {
    postalCode: 2358,
    city: "Salisbury Plains",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.7667,
    longitude: 151.5333,
    accuracy: 4
  },
  {
    postalCode: 2358,
    city: "Mihi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.6046,
    longitude: 151.4612,
    accuracy: 3
  },
  {
    postalCode: 2358,
    city: "Kingstown",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.504,
    longitude: 151.1139,
    accuracy: 4
  },
  {
    postalCode: 2358,
    city: "Uralla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.6411,
    longitude: 151.5007,
    accuracy: 4
  },
  {
    postalCode: 2359,
    city: "Bakers Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2667,
    longitude: 151.0167,
    accuracy: 4
  },
  {
    postalCode: 2359,
    city: "Bundarra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.1721,
    longitude: 151.0762,
    accuracy: 4
  },
  {
    postalCode: 2359,
    city: "Aberdeen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1659,
    longitude: 150.89,
    accuracy: 4
  },
  {
    postalCode: 2359,
    city: "Camerons Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2194,
    longitude: 151.0464,
    accuracy: 3
  },
  {
    postalCode: 2360,
    city: "Wandera",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6833,
    longitude: 151.1667,
    accuracy: 4
  },
  {
    postalCode: 2360,
    city: "Copeton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.9167,
    longitude: 151.0167,
    accuracy: 4
  },
  {
    postalCode: 2360,
    city: "Mount Russell",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6772,
    longitude: 150.9286,
    accuracy: 4
  },
  {
    postalCode: 2360,
    city: "Little Plain",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7303,
    longitude: 150.955,
    accuracy: 4
  },
  {
    postalCode: 2360,
    city: "Auburn Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.821,
    longitude: 151.0454,
    accuracy: 4
  },
  {
    postalCode: 2360,
    city: "Rob Roy",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.75,
    longitude: 151.0167,
    accuracy: 4
  },
  {
    postalCode: 2360,
    city: "Cherry Tree Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.5368,
    longitude: 150.9946,
    accuracy: 4
  },
  {
    postalCode: 2360,
    city: "Stanborough",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.95,
    longitude: 151.15,
    accuracy: 4
  },
  {
    postalCode: 2360,
    city: "Sapphire",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6846,
    longitude: 151.3375,
    accuracy: 4
  },
  {
    postalCode: 2360,
    city: "Swanbrook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.718,
    longitude: 151.0965,
    accuracy: 3
  },
  {
    postalCode: 2360,
    city: "Inverell",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.774,
    longitude: 151.1117,
    accuracy: 4
  },
  {
    postalCode: 2360,
    city: "Bukkulla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.5045,
    longitude: 151.1293,
    accuracy: 4
  },
  {
    postalCode: 2360,
    city: "Howell",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.95,
    longitude: 151.0333,
    accuracy: 4
  },
  {
    postalCode: 2360,
    city: "Spring Mountain",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.718,
    longitude: 151.0965,
    accuracy: 3
  },
  {
    postalCode: 2360,
    city: "Gilgai",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.8527,
    longitude: 151.1181,
    accuracy: 4
  },
  {
    postalCode: 2360,
    city: "Nullamanna",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.65,
    longitude: 151.2167,
    accuracy: 4
  },
  {
    postalCode: 2360,
    city: "Brodies Plains",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.8094,
    longitude: 151.1956,
    accuracy: 4
  },
  {
    postalCode: 2360,
    city: "Long Plain",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.718,
    longitude: 151.0965,
    accuracy: 3
  },
  {
    postalCode: 2360,
    city: "Woodstock",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.718,
    longitude: 151.0965,
    accuracy: 3
  },
  {
    postalCode: 2360,
    city: "Wallangra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.2468,
    longitude: 150.8931,
    accuracy: 4
  },
  {
    postalCode: 2360,
    city: "Oakwood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6458,
    longitude: 151.0442,
    accuracy: 4
  },
  {
    postalCode: 2360,
    city: "Kings Plains",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.718,
    longitude: 151.0965,
    accuracy: 3
  },
  {
    postalCode: 2360,
    city: "Newstead",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.8333,
    longitude: 151.35,
    accuracy: 4
  },
  {
    postalCode: 2360,
    city: "Paradise",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.718,
    longitude: 151.0965,
    accuracy: 3
  },
  {
    postalCode: 2360,
    city: "Elsmore",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.8065,
    longitude: 151.2689,
    accuracy: 4
  },
  {
    postalCode: 2360,
    city: "Gum Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7943,
    longitude: 150.9296,
    accuracy: 3
  },
  {
    postalCode: 2360,
    city: "Graman",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4694,
    longitude: 150.9267,
    accuracy: 4
  },
  {
    postalCode: 2361,
    city: "Ashford",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.3219,
    longitude: 151.0931,
    accuracy: 4
  },
  {
    postalCode: 2361,
    city: "Atholwood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9985,
    longitude: 151.0512,
    accuracy: 4
  },
  {
    postalCode: 2361,
    city: "Limestone",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.1295,
    longitude: 151.1366,
    accuracy: 3
  },
  {
    postalCode: 2361,
    city: "Bonshaw",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0479,
    longitude: 151.2757,
    accuracy: 4
  },
  {
    postalCode: 2361,
    city: "Pindaroi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.1295,
    longitude: 151.1366,
    accuracy: 3
  },
  {
    postalCode: 2365,
    city: "Oban",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.1333,
    longitude: 151.8667,
    accuracy: 4
  },
  {
    postalCode: 2365,
    city: "Brushy Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.1052,
    longitude: 151.7015,
    accuracy: 3
  },
  {
    postalCode: 2365,
    city: "Tubbamurra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.1152,
    longitude: 151.7679,
    accuracy: 4
  },
  {
    postalCode: 2365,
    city: "Glencoe",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.9249,
    longitude: 151.7223,
    accuracy: 4
  },
  {
    postalCode: 2365,
    city: "Brockley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2833,
    longitude: 151.8167,
    accuracy: 4
  },
  {
    postalCode: 2365,
    city: "Ben Lomond",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.0167,
    longitude: 151.6667,
    accuracy: 4
  },
  {
    postalCode: 2365,
    city: "Georges Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.7461,
    longitude: 152.1945,
    accuracy: 4
  },
  {
    postalCode: 2365,
    city: "Guyra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2167,
    longitude: 151.6744,
    accuracy: 4
  },
  {
    postalCode: 2365,
    city: "The Gulf",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.3167,
    longitude: 151.4833,
    accuracy: 4
  },
  {
    postalCode: 2365,
    city: "Falconer",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.1052,
    longitude: 151.7015,
    accuracy: 3
  },
  {
    postalCode: 2365,
    city: "Llangothlin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.1372,
    longitude: 151.6843,
    accuracy: 4
  },
  {
    postalCode: 2365,
    city: "Black Mountain",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.3107,
    longitude: 151.6582,
    accuracy: 4
  },
  {
    postalCode: 2365,
    city: "Baldersleigh",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2555,
    longitude: 151.426,
    accuracy: 4
  },
  {
    postalCode: 2365,
    city: "Bald Blair",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.1052,
    longitude: 151.7015,
    accuracy: 3
  },
  {
    postalCode: 2365,
    city: "Mount Mitchell",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.0167,
    longitude: 151.85,
    accuracy: 4
  },
  {
    postalCode: 2365,
    city: "Wandsworth",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.0671,
    longitude: 151.52,
    accuracy: 4
  },
  {
    postalCode: 2365,
    city: "Maybole",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.8985,
    longitude: 151.5846,
    accuracy: 4
  },
  {
    postalCode: 2365,
    city: "South Guyra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.1052,
    longitude: 151.7015,
    accuracy: 3
  },
  {
    postalCode: 2365,
    city: "Backwater",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.0652,
    longitude: 151.8846,
    accuracy: 4
  },
  {
    postalCode: 2365,
    city: "Tenterden",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.1318,
    longitude: 151.4346,
    accuracy: 4
  },
  {
    postalCode: 2365,
    city: "Green Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9176,
    longitude: 149.5836,
    accuracy: 4
  },
  {
    postalCode: 2365,
    city: "Briarbrook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.1052,
    longitude: 151.7015,
    accuracy: 3
  },
  {
    postalCode: 2365,
    city: "Bassendean",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.1052,
    longitude: 151.7015,
    accuracy: 3
  },
  {
    postalCode: 2365,
    city: "Glen Nevis",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.1052,
    longitude: 151.7015,
    accuracy: 3
  },
  {
    postalCode: 2365,
    city: "The Basin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.1052,
    longitude: 151.7015,
    accuracy: 3
  },
  {
    postalCode: 2365,
    city: "New Valley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.1052,
    longitude: 151.7015,
    accuracy: 3
  },
  {
    postalCode: 2369,
    city: "Tingha",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.9559,
    longitude: 151.2125,
    accuracy: 4
  },
  {
    postalCode: 2369,
    city: "Old Mill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.9196,
    longitude: 151.2146,
    accuracy: 3
  },
  {
    postalCode: 2369,
    city: "Stannifer",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.8833,
    longitude: 151.2167,
    accuracy: 4
  },
  {
    postalCode: 2370,
    city: "Dundee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.5724,
    longitude: 151.8663,
    accuracy: 4
  },
  {
    postalCode: 2370,
    city: "Moggs Swamp",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7311,
    longitude: 151.8242,
    accuracy: 3
  },
  {
    postalCode: 2370,
    city: "Shannon Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6985,
    longitude: 151.8679,
    accuracy: 4
  },
  {
    postalCode: 2370,
    city: "Glen Innes",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7349,
    longitude: 151.7385,
    accuracy: 4
  },
  {
    postalCode: 2370,
    city: "Wellingrove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6334,
    longitude: 151.5692,
    accuracy: 4
  },
  {
    postalCode: 2370,
    city: "Morven",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7311,
    longitude: 151.8242,
    accuracy: 3
  },
  {
    postalCode: 2370,
    city: "Glen Elgin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.5833,
    longitude: 152.1167,
    accuracy: 4
  },
  {
    postalCode: 2370,
    city: "Kingsland",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7311,
    longitude: 151.8242,
    accuracy: 3
  },
  {
    postalCode: 2370,
    city: "Stonehenge",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.8164,
    longitude: 151.7351,
    accuracy: 4
  },
  {
    postalCode: 2370,
    city: "Diehard",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7311,
    longitude: 151.8242,
    accuracy: 3
  },
  {
    postalCode: 2370,
    city: "Reddestone",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7311,
    longitude: 151.8242,
    accuracy: 3
  },
  {
    postalCode: 2370,
    city: "Pinkett",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7311,
    longitude: 151.8242,
    accuracy: 3
  },
  {
    postalCode: 2370,
    city: "Matheson",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7383,
    longitude: 151.574,
    accuracy: 4
  },
  {
    postalCode: 2370,
    city: "Bald Nob",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7311,
    longitude: 151.8242,
    accuracy: 3
  },
  {
    postalCode: 2370,
    city: "Swan Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7833,
    longitude: 151.4333,
    accuracy: 4
  },
  {
    postalCode: 2370,
    city: "Gibraltar Range",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7311,
    longitude: 151.8242,
    accuracy: 3
  },
  {
    postalCode: 2370,
    city: "Newton Boyd",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7976,
    longitude: 152.2659,
    accuracy: 4
  },
  {
    postalCode: 2370,
    city: "Lambs Valley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7311,
    longitude: 151.8242,
    accuracy: 3
  },
  {
    postalCode: 2370,
    city: "Kookabookra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.0333,
    longitude: 152.0667,
    accuracy: 4
  },
  {
    postalCode: 2370,
    city: "Yarrowford",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7311,
    longitude: 151.8242,
    accuracy: 3
  },
  {
    postalCode: 2370,
    city: "Moogem",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7311,
    longitude: 151.8242,
    accuracy: 3
  },
  {
    postalCode: 2370,
    city: "Furracabad",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7818,
    longitude: 151.6679,
    accuracy: 4
  },
  {
    postalCode: 2370,
    city: "Kingsgate",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.8,
    longitude: 151.9833,
    accuracy: 4
  },
  {
    postalCode: 2370,
    city: "Red Range",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7757,
    longitude: 151.8966,
    accuracy: 4
  },
  {
    postalCode: 2370,
    city: "Rangers Valley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.5167,
    longitude: 151.75,
    accuracy: 4
  },
  {
    postalCode: 2371,
    city: "Rocky Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.3,
    longitude: 151.3667,
    accuracy: 4
  },
  {
    postalCode: 2371,
    city: "Yellow Dam",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.3724,
    longitude: 151.6768,
    accuracy: 3
  },
  {
    postalCode: 2371,
    city: "Capoompeta",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.3724,
    longitude: 151.6768,
    accuracy: 3
  },
  {
    postalCode: 2371,
    city: "Emmaville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4441,
    longitude: 151.5979,
    accuracy: 4
  },
  {
    postalCode: 2371,
    city: "Stannum",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.3279,
    longitude: 151.7869,
    accuracy: 4
  },
  {
    postalCode: 2371,
    city: "Deepwater",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4404,
    longitude: 151.8461,
    accuracy: 4
  },
  {
    postalCode: 2371,
    city: "Wellington Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4152,
    longitude: 151.7512,
    accuracy: 4
  },
  {
    postalCode: 2371,
    city: "Torrington",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.3152,
    longitude: 151.691,
    accuracy: 4
  },
  {
    postalCode: 2372,
    city: "Silent Grove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.1167,
    longitude: 151.6667,
    accuracy: 4
  },
  {
    postalCode: 2372,
    city: "Woodside",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.1538,
    longitude: 151.9669,
    accuracy: 3
  },
  {
    postalCode: 2372,
    city: "Liston",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.6492,
    longitude: 152.087,
    accuracy: 4
  },
  {
    postalCode: 2372,
    city: "Bolivia",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.3015,
    longitude: 151.9539,
    accuracy: 4
  },
  {
    postalCode: 2372,
    city: "Sandy Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9167,
    longitude: 152.25,
    accuracy: 4
  },
  {
    postalCode: 2372,
    city: "Back Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.1538,
    longitude: 151.9669,
    accuracy: 3
  },
  {
    postalCode: 2372,
    city: "Rocky River",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.6167,
    longitude: 151.5,
    accuracy: 4
  },
  {
    postalCode: 2372,
    city: "Tarban",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9818,
    longitude: 151.9012,
    accuracy: 4
  },
  {
    postalCode: 2372,
    city: "Black Swamp",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29,
    longitude: 152.15,
    accuracy: 4
  },
  {
    postalCode: 2372,
    city: "Boorook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.1538,
    longitude: 151.9669,
    accuracy: 3
  },
  {
    postalCode: 2372,
    city: "Sandy Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.2307,
    longitude: 152.0048,
    accuracy: 4
  },
  {
    postalCode: 2372,
    city: "Rivertree",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.1538,
    longitude: 151.9669,
    accuracy: 3
  },
  {
    postalCode: 2372,
    city: "Boonoo Boonoo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8777,
    longitude: 152.1012,
    accuracy: 4
  },
  {
    postalCode: 2372,
    city: "Dumaresq Valley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.1538,
    longitude: 151.9669,
    accuracy: 3
  },
  {
    postalCode: 2372,
    city: "Mole River",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.1167,
    longitude: 151.7667,
    accuracy: 4
  },
  {
    postalCode: 2372,
    city: "Wylie Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.5485,
    longitude: 152.1512,
    accuracy: 4
  },
  {
    postalCode: 2372,
    city: "Forest Land",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.1538,
    longitude: 151.9669,
    accuracy: 3
  },
  {
    postalCode: 2372,
    city: "Timbarra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0167,
    longitude: 152.1833,
    accuracy: 4
  },
  {
    postalCode: 2372,
    city: "Bookookoorara",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.1538,
    longitude: 151.9669,
    accuracy: 3
  },
  {
    postalCode: 2372,
    city: "Tenterfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0495,
    longitude: 152.0195,
    accuracy: 4
  },
  {
    postalCode: 2372,
    city: "Bungulla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.1333,
    longitude: 151.9833,
    accuracy: 4
  },
  {
    postalCode: 2372,
    city: "Carrolls Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8227,
    longitude: 152.103,
    accuracy: 4
  },
  {
    postalCode: 2372,
    city: "Willsons Downfall",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.1538,
    longitude: 151.9669,
    accuracy: 3
  },
  {
    postalCode: 2372,
    city: "Cullendore",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.1538,
    longitude: 151.9669,
    accuracy: 3
  },
  {
    postalCode: 2379,
    city: "Goolhi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.1,
    longitude: 149.9,
    accuracy: 3
  },
  {
    postalCode: 2379,
    city: "Mullaley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.1011,
    longitude: 149.9058,
    accuracy: 4
  },
  {
    postalCode: 2379,
    city: "Napier Lane",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.1,
    longitude: 149.9,
    accuracy: 3
  },
  {
    postalCode: 2379,
    city: "Nombi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.1,
    longitude: 149.9,
    accuracy: 3
  },
  {
    postalCode: 2380,
    city: "Coocooboonah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31,
    longitude: 150.1333,
    accuracy: 4
  },
  {
    postalCode: 2380,
    city: "Ghoolendaadi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.9702,
    longitude: 150.1854,
    accuracy: 3
  },
  {
    postalCode: 2380,
    city: "Kelvin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.8152,
    longitude: 150.3512,
    accuracy: 4
  },
  {
    postalCode: 2380,
    city: "Rangari",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.9702,
    longitude: 150.1854,
    accuracy: 3
  },
  {
    postalCode: 2380,
    city: "Orange Grove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.0473,
    longitude: 146.6726,
    accuracy: 4
  },
  {
    postalCode: 2380,
    city: "Milroy",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.15,
    longitude: 150.05,
    accuracy: 4
  },
  {
    postalCode: 2380,
    city: "Emerald Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.8833,
    longitude: 150.0833,
    accuracy: 4
  },
  {
    postalCode: 2380,
    city: "Marys Mount",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7549,
    longitude: 150.7844,
    accuracy: 4
  },
  {
    postalCode: 2380,
    city: "Gunnedah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.9807,
    longitude: 150.2584,
    accuracy: 4
  },
  {
    postalCode: 2380,
    city: "Burburgate",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.9908,
    longitude: 150.2538,
    accuracy: 3
  },
  {
    postalCode: 2380,
    city: "Blue Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.9702,
    longitude: 150.1854,
    accuracy: 3
  },
  {
    postalCode: 2381,
    city: "Curlewis",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.1167,
    longitude: 150.2675,
    accuracy: 4
  },
  {
    postalCode: 2381,
    city: "Pullaming",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.2415,
    longitude: 150.4857,
    accuracy: 3
  },
  {
    postalCode: 2381,
    city: "Breeza",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.2497,
    longitude: 150.4629,
    accuracy: 4
  },
  {
    postalCode: 2381,
    city: "Tambar Springs",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.3495,
    longitude: 149.83,
    accuracy: 4
  },
  {
    postalCode: 2381,
    city: "Premer",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4567,
    longitude: 149.909,
    accuracy: 4
  },
  {
    postalCode: 2382,
    city: "Maules Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.7365,
    longitude: 150.0637,
    accuracy: 3
  },
  {
    postalCode: 2382,
    city: "Willala",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.8152,
    longitude: 149.8679,
    accuracy: 4
  },
  {
    postalCode: 2382,
    city: "Wean",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.7,
    longitude: 150.2833,
    accuracy: 4
  },
  {
    postalCode: 2382,
    city: "Boggabri",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.7095,
    longitude: 150.0412,
    accuracy: 4
  },
  {
    postalCode: 2386,
    city: "Drildool",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.1167,
    longitude: 148.9667,
    accuracy: 3
  },
  {
    postalCode: 2386,
    city: "Burren Junction",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.0985,
    longitude: 148.9679,
    accuracy: 4
  },
  {
    postalCode: 2386,
    city: "Nowley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.1167,
    longitude: 148.9667,
    accuracy: 3
  },
  {
    postalCode: 2387,
    city: "Rowena",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.8169,
    longitude: 148.909,
    accuracy: 4
  },
  {
    postalCode: 2387,
    city: "Bulyeroi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.8,
    longitude: 148.9167,
    accuracy: 3
  },
  {
    postalCode: 2388,
    city: "Merah North",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.1831,
    longitude: 149.2951,
    accuracy: 4
  },
  {
    postalCode: 2388,
    city: "Cuttabri",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2785,
    longitude: 149.2051,
    accuracy: 3
  },
  {
    postalCode: 2388,
    city: "Yarrie Lake",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.35,
    longitude: 149.5167,
    accuracy: 4
  },
  {
    postalCode: 2388,
    city: "Spring Plains",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4,
    longitude: 150.25,
    accuracy: 4
  },
  {
    postalCode: 2388,
    city: "Boolcarroll",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.502,
    longitude: 149.4814,
    accuracy: 3
  },
  {
    postalCode: 2388,
    city: "Pilliga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.3558,
    longitude: 148.8879,
    accuracy: 4
  },
  {
    postalCode: 2388,
    city: "The Pilliga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.502,
    longitude: 149.4814,
    accuracy: 3
  },
  {
    postalCode: 2388,
    city: "Wee Waa",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2266,
    longitude: 149.4404,
    accuracy: 4
  },
  {
    postalCode: 2390,
    city: "Jacks Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.4977,
    longitude: 149.7394,
    accuracy: 4
  },
  {
    postalCode: 2390,
    city: "Kaputar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2941,
    longitude: 150.1447,
    accuracy: 4
  },
  {
    postalCode: 2390,
    city: "Turrawan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.4642,
    longitude: 149.8849,
    accuracy: 4
  },
  {
    postalCode: 2390,
    city: "Eulah Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.364,
    longitude: 149.8906,
    accuracy: 3
  },
  {
    postalCode: 2390,
    city: "Edgeroi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.1221,
    longitude: 149.8012,
    accuracy: 4
  },
  {
    postalCode: 2390,
    city: "Harparary",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.5333,
    longitude: 150.0167,
    accuracy: 4
  },
  {
    postalCode: 2390,
    city: "Narrabri West",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.3333,
    longitude: 149.75,
    accuracy: 4
  },
  {
    postalCode: 2390,
    city: "Berrigal",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.364,
    longitude: 149.8906,
    accuracy: 3
  },
  {
    postalCode: 2390,
    city: "Rocky Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.0333,
    longitude: 150.2667,
    accuracy: 4
  },
  {
    postalCode: 2390,
    city: "Baan Baa",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.5978,
    longitude: 149.9496,
    accuracy: 4
  },
  {
    postalCode: 2390,
    city: "Bullawa Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.3068,
    longitude: 150.0012,
    accuracy: 4
  },
  {
    postalCode: 2390,
    city: "Couradda",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.364,
    longitude: 149.8906,
    accuracy: 3
  },
  {
    postalCode: 2390,
    city: "Back Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.364,
    longitude: 149.8906,
    accuracy: 3
  },
  {
    postalCode: 2390,
    city: "Narrabri",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.3261,
    longitude: 149.7837,
    accuracy: 4
  },
  {
    postalCode: 2390,
    city: "Tarriaro",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.364,
    longitude: 149.8906,
    accuracy: 3
  },
  {
    postalCode: 2390,
    city: "Bohena Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.4167,
    longitude: 149.7,
    accuracy: 4
  },
  {
    postalCode: 2395,
    city: "Ropers Road",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.5928,
    longitude: 149.481,
    accuracy: 3
  },
  {
    postalCode: 2395,
    city: "Binnaway",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.5523,
    longitude: 149.3787,
    accuracy: 4
  },
  {
    postalCode: 2395,
    city: "Weetaliba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.644,
    longitude: 149.5845,
    accuracy: 4
  },
  {
    postalCode: 2396,
    city: "Barwon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.9329,
    longitude: 149.0119,
    accuracy: 3
  },
  {
    postalCode: 2396,
    city: "Goorianawa",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0833,
    longitude: 148.9333,
    accuracy: 4
  },
  {
    postalCode: 2396,
    city: "Kenebri",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.7751,
    longitude: 149.0236,
    accuracy: 4
  },
  {
    postalCode: 2396,
    city: "Baradine",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.9487,
    longitude: 149.0692,
    accuracy: 4
  },
  {
    postalCode: 2397,
    city: "Millie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.8152,
    longitude: 149.5679,
    accuracy: 4
  },
  {
    postalCode: 2397,
    city: "Bellata",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.9191,
    longitude: 149.7889,
    accuracy: 4
  },
  {
    postalCode: 2397,
    city: "Jews Lagoon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.8667,
    longitude: 149.675,
    accuracy: 3
  },
  {
    postalCode: 2398,
    city: "Gurley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7333,
    longitude: 149.8,
    accuracy: 4
  },
  {
    postalCode: 2399,
    city: "Biniguy",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.5435,
    longitude: 150.2033,
    accuracy: 4
  },
  {
    postalCode: 2399,
    city: "Pallamallawa",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4741,
    longitude: 150.134,
    accuracy: 4
  },
  {
    postalCode: 2400,
    city: "Bullarah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4657,
    longitude: 150.0146,
    accuracy: 3
  },
  {
    postalCode: 2400,
    city: "Terry Hie Hie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7968,
    longitude: 150.148,
    accuracy: 4
  },
  {
    postalCode: 2400,
    city: "Moree East",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4657,
    longitude: 150.0146,
    accuracy: 3
  },
  {
    postalCode: 2400,
    city: "Moree",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4628,
    longitude: 149.8416,
    accuracy: 4
  },
  {
    postalCode: 2400,
    city: "Crooble",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.2659,
    longitude: 150.2555,
    accuracy: 4
  },
  {
    postalCode: 2400,
    city: "Tulloona",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4657,
    longitude: 150.0146,
    accuracy: 3
  },
  {
    postalCode: 2400,
    city: "Mallowa",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4657,
    longitude: 150.0146,
    accuracy: 3
  },
  {
    postalCode: 2400,
    city: "Ashley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.3136,
    longitude: 149.8081,
    accuracy: 4
  },
  {
    postalCode: 2401,
    city: "Gravesend",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.5833,
    longitude: 150.3331,
    accuracy: 4
  },
  {
    postalCode: 2402,
    city: "Coolatai",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.2571,
    longitude: 150.7473,
    accuracy: 4
  },
  {
    postalCode: 2402,
    city: "Warialda",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.5435,
    longitude: 150.5754,
    accuracy: 4
  },
  {
    postalCode: 2402,
    city: "Warialda Rail",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.5766,
    longitude: 150.5319,
    accuracy: 4
  },
  {
    postalCode: 2403,
    city: "Delungra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.654,
    longitude: 150.83,
    accuracy: 4
  },
  {
    postalCode: 2403,
    city: "Myall Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.75,
    longitude: 150.7667,
    accuracy: 4
  },
  {
    postalCode: 2403,
    city: "Koloona",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.626,
    longitude: 150.7333,
    accuracy: 4
  },
  {
    postalCode: 2403,
    city: "Gragin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6791,
    longitude: 150.7711,
    accuracy: 3
  },
  {
    postalCode: 2403,
    city: "Balfours Peak",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6791,
    longitude: 150.7711,
    accuracy: 3
  },
  {
    postalCode: 2404,
    city: "Bingara",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.8693,
    longitude: 150.572,
    accuracy: 4
  },
  {
    postalCode: 2404,
    city: "Elcombe",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7667,
    longitude: 150.3833,
    accuracy: 4
  },
  {
    postalCode: 2404,
    city: "Keera",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.9818,
    longitude: 150.7679,
    accuracy: 4
  },
  {
    postalCode: 2404,
    city: "Gineroi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7667,
    longitude: 150.5,
    accuracy: 4
  },
  {
    postalCode: 2404,
    city: "Bangheet",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.8782,
    longitude: 150.537,
    accuracy: 3
  },
  {
    postalCode: 2404,
    city: "Pallal",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.9167,
    longitude: 150.3833,
    accuracy: 4
  },
  {
    postalCode: 2404,
    city: "Riverview",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.824,
    longitude: 151.1602,
    accuracy: 4
  },
  {
    postalCode: 2404,
    city: "Dinoga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.9667,
    longitude: 150.6,
    accuracy: 4
  },
  {
    postalCode: 2404,
    city: "Upper Bingara",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.05,
    longitude: 150.65,
    accuracy: 4
  },
  {
    postalCode: 2405,
    city: "Boomi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7233,
    longitude: 149.5794,
    accuracy: 4
  },
  {
    postalCode: 2405,
    city: "Garah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0759,
    longitude: 149.6377,
    accuracy: 4
  },
  {
    postalCode: 2406,
    city: "Weemelah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0185,
    longitude: 149.2548,
    accuracy: 4
  },
  {
    postalCode: 2406,
    city: "Mungindi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9767,
    longitude: 148.9881,
    accuracy: 4
  },
  {
    postalCode: 2408,
    city: "North Star",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9348,
    longitude: 150.3896,
    accuracy: 4
  },
  {
    postalCode: 2408,
    city: "Blue Nobby",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0246,
    longitude: 150.4374,
    accuracy: 3
  },
  {
    postalCode: 2408,
    city: "Yallaroi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.1167,
    longitude: 150.4833,
    accuracy: 4
  },
  {
    postalCode: 2409,
    city: "Boggabilla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.6048,
    longitude: 150.3593,
    accuracy: 4
  },
  {
    postalCode: 2409,
    city: "Boonal",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.6048,
    longitude: 150.3593,
    accuracy: 3
  },
  {
    postalCode: 2410,
    city: "Yetman",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9043,
    longitude: 150.7769,
    accuracy: 4
  },
  {
    postalCode: 2410,
    city: "Twin Rivers",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9,
    longitude: 150.7833,
    accuracy: 3
  },
  {
    postalCode: 2411,
    city: "Croppa Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.1331,
    longitude: 150.3014,
    accuracy: 4
  },
  {
    postalCode: 2415,
    city: "Monkerai",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.2915,
    longitude: 151.8602,
    accuracy: 4
  },
  {
    postalCode: 2415,
    city: "Nooroo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3207,
    longitude: 151.8968,
    accuracy: 3
  },
  {
    postalCode: 2415,
    city: "Stroud Road",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.35,
    longitude: 151.9333,
    accuracy: 4
  },
  {
    postalCode: 2415,
    city: "Upper Karuah River",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3207,
    longitude: 151.8968,
    accuracy: 3
  },
  {
    postalCode: 2415,
    city: "Weismantels",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.2608,
    longitude: 151.9427,
    accuracy: 4
  },
  {
    postalCode: 2420,
    city: "Fosterton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3474,
    longitude: 151.7612,
    accuracy: 4
  },
  {
    postalCode: 2420,
    city: "Wallarobba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5046,
    longitude: 151.7007,
    accuracy: 4
  },
  {
    postalCode: 2420,
    city: "Underbank",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3982,
    longitude: 151.6842,
    accuracy: 3
  },
  {
    postalCode: 2420,
    city: "Dungog",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4003,
    longitude: 151.7576,
    accuracy: 4
  },
  {
    postalCode: 2420,
    city: "Stroud Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3982,
    longitude: 151.6842,
    accuracy: 3
  },
  {
    postalCode: 2420,
    city: "Bendolba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3518,
    longitude: 151.7301,
    accuracy: 4
  },
  {
    postalCode: 2420,
    city: "Main Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3982,
    longitude: 151.6842,
    accuracy: 3
  },
  {
    postalCode: 2420,
    city: "Wirragulla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4596,
    longitude: 151.746,
    accuracy: 4
  },
  {
    postalCode: 2420,
    city: "Sugarloaf",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3982,
    longitude: 151.6842,
    accuracy: 3
  },
  {
    postalCode: 2420,
    city: "Brookfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4985,
    longitude: 151.7679,
    accuracy: 4
  },
  {
    postalCode: 2420,
    city: "Bandon Grove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.2999,
    longitude: 151.7159,
    accuracy: 3
  },
  {
    postalCode: 2420,
    city: "Salisbury",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.25,
    longitude: 151.5667,
    accuracy: 4
  },
  {
    postalCode: 2420,
    city: "Hanleys Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3982,
    longitude: 151.6842,
    accuracy: 3
  },
  {
    postalCode: 2420,
    city: "Marshdale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3707,
    longitude: 151.7022,
    accuracy: 3
  },
  {
    postalCode: 2420,
    city: "Munni",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3982,
    longitude: 151.6842,
    accuracy: 3
  },
  {
    postalCode: 2420,
    city: "Flat Tops",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3982,
    longitude: 151.6842,
    accuracy: 3
  },
  {
    postalCode: 2420,
    city: "Wallaringa",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3982,
    longitude: 151.6842,
    accuracy: 3
  },
  {
    postalCode: 2420,
    city: "Cambra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3982,
    longitude: 151.6842,
    accuracy: 3
  },
  {
    postalCode: 2420,
    city: "Tabbil Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3982,
    longitude: 151.6842,
    accuracy: 3
  },
  {
    postalCode: 2420,
    city: "Hilldale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5,
    longitude: 151.65,
    accuracy: 4
  },
  {
    postalCode: 2420,
    city: "Alison",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2768,
    longitude: 151.4021,
    accuracy: 4
  },
  {
    postalCode: 2420,
    city: "Chichester",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.2,
    longitude: 151.6167,
    accuracy: 4
  },
  {
    postalCode: 2420,
    city: "Martins Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.55,
    longitude: 151.6167,
    accuracy: 4
  },
  {
    postalCode: 2421,
    city: "Webbers Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6061,
    longitude: 151.6159,
    accuracy: 3
  },
  {
    postalCode: 2421,
    city: "Tocal",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.633,
    longitude: 151.5913,
    accuracy: 4
  },
  {
    postalCode: 2421,
    city: "Fishers Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6061,
    longitude: 151.6159,
    accuracy: 3
  },
  {
    postalCode: 2421,
    city: "Trevallyn",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5432,
    longitude: 151.5372,
    accuracy: 3
  },
  {
    postalCode: 2421,
    city: "Vacy",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5316,
    longitude: 151.569,
    accuracy: 4
  },
  {
    postalCode: 2421,
    city: "Paterson",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6061,
    longitude: 151.6159,
    accuracy: 4
  },
  {
    postalCode: 2421,
    city: "Torryburn",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.45,
    longitude: 151.2167,
    accuracy: 4
  },
  {
    postalCode: 2421,
    city: "Summer Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8915,
    longitude: 151.1382,
    accuracy: 4
  },
  {
    postalCode: 2422,
    city: "Gloucester Tops",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9223,
    longitude: 151.5346,
    accuracy: 4
  },
  {
    postalCode: 2422,
    city: "Belbora",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.0333,
    longitude: 152.1833,
    accuracy: 4
  },
  {
    postalCode: 2422,
    city: "Barrington",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9726,
    longitude: 151.9031,
    accuracy: 4
  },
  {
    postalCode: 2422,
    city: "Bulliac",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9167,
    longitude: 152.0333,
    accuracy: 4
  },
  {
    postalCode: 2422,
    city: "Stratford",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1167,
    longitude: 151.9333,
    accuracy: 4
  },
  {
    postalCode: 2422,
    city: "Cobark",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9485,
    longitude: 151.7096,
    accuracy: 4
  },
  {
    postalCode: 2422,
    city: "Rawdon Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9833,
    longitude: 151.7,
    accuracy: 4
  },
  {
    postalCode: 2422,
    city: "Gangat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.0235,
    longitude: 152.0846,
    accuracy: 4
  },
  {
    postalCode: 2422,
    city: "Gloucester",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.0077,
    longitude: 151.9633,
    accuracy: 4
  },
  {
    postalCode: 2422,
    city: "Craven",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1485,
    longitude: 151.9512,
    accuracy: 4
  },
  {
    postalCode: 2422,
    city: "Copeland",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32,
    longitude: 151.8333,
    accuracy: 4
  },
  {
    postalCode: 2422,
    city: "Giro",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.7152,
    longitude: 151.8096,
    accuracy: 4
  },
  {
    postalCode: 2422,
    city: "Bundook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8906,
    longitude: 152.1219,
    accuracy: 4
  },
  {
    postalCode: 2422,
    city: "Wards River",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.2166,
    longitude: 151.9423,
    accuracy: 4
  },
  {
    postalCode: 2422,
    city: "Forbesdale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9758,
    longitude: 151.9086,
    accuracy: 3
  },
  {
    postalCode: 2422,
    city: "Rookhurst",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8833,
    longitude: 151.8833,
    accuracy: 4
  },
  {
    postalCode: 2422,
    city: "Dewitt",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9758,
    longitude: 151.9086,
    accuracy: 3
  },
  {
    postalCode: 2422,
    city: "Curricabark",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.7447,
    longitude: 151.6389,
    accuracy: 4
  },
  {
    postalCode: 2422,
    city: "Callaghans Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9758,
    longitude: 151.9086,
    accuracy: 3
  },
  {
    postalCode: 2422,
    city: "Bowman",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9223,
    longitude: 151.7831,
    accuracy: 4
  },
  {
    postalCode: 2422,
    city: "Faulkland",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9758,
    longitude: 151.9086,
    accuracy: 3
  },
  {
    postalCode: 2422,
    city: "Mograni",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.0333,
    longitude: 152.0333,
    accuracy: 4
  },
  {
    postalCode: 2422,
    city: "Bindera",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9758,
    longitude: 151.9086,
    accuracy: 3
  },
  {
    postalCode: 2422,
    city: "Upper Bowman",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9223,
    longitude: 151.7831,
    accuracy: 4
  },
  {
    postalCode: 2422,
    city: "Titaatee Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9758,
    longitude: 151.9086,
    accuracy: 3
  },
  {
    postalCode: 2422,
    city: "Baxters Ridge",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9758,
    longitude: 151.9086,
    accuracy: 3
  },
  {
    postalCode: 2422,
    city: "Barrington Tops",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9223,
    longitude: 151.5346,
    accuracy: 4
  },
  {
    postalCode: 2422,
    city: "Coneac",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9758,
    longitude: 151.9086,
    accuracy: 3
  },
  {
    postalCode: 2422,
    city: "Terreel",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9758,
    longitude: 151.9086,
    accuracy: 3
  },
  {
    postalCode: 2422,
    city: "Bretti",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9362,
    longitude: 151.7966,
    accuracy: 3
  },
  {
    postalCode: 2422,
    city: "Craven Plateau",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9758,
    longitude: 151.9086,
    accuracy: 3
  },
  {
    postalCode: 2422,
    city: "Tugrabakh",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9758,
    longitude: 151.9086,
    accuracy: 3
  },
  {
    postalCode: 2422,
    city: "Invergordon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9758,
    longitude: 151.9086,
    accuracy: 3
  },
  {
    postalCode: 2422,
    city: "Glen Ward",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9758,
    longitude: 151.9086,
    accuracy: 3
  },
  {
    postalCode: 2422,
    city: "Bowman Farm",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9758,
    longitude: 151.9086,
    accuracy: 3
  },
  {
    postalCode: 2422,
    city: "Kia Ora",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9758,
    longitude: 151.9086,
    accuracy: 3
  },
  {
    postalCode: 2422,
    city: "Back Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9758,
    longitude: 151.9086,
    accuracy: 3
  },
  {
    postalCode: 2422,
    city: "Waukivory",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1167,
    longitude: 152.05,
    accuracy: 4
  },
  {
    postalCode: 2422,
    city: "Tibbuc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9758,
    longitude: 151.9086,
    accuracy: 3
  },
  {
    postalCode: 2422,
    city: "Woko",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9758,
    longitude: 151.9086,
    accuracy: 3
  },
  {
    postalCode: 2422,
    city: "Berrico",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9758,
    longitude: 151.9086,
    accuracy: 3
  },
  {
    postalCode: 2422,
    city: "Mernot",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9758,
    longitude: 151.9086,
    accuracy: 3
  },
  {
    postalCode: 2422,
    city: "Wallanbah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9758,
    longitude: 151.9086,
    accuracy: 3
  },
  {
    postalCode: 2422,
    city: "Moppy",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9758,
    longitude: 151.9086,
    accuracy: 3
  },
  {
    postalCode: 2422,
    city: "Mares Run",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9758,
    longitude: 151.9086,
    accuracy: 3
  },
  {
    postalCode: 2422,
    city: "Bakers Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2667,
    longitude: 151.0167,
    accuracy: 4
  },
  {
    postalCode: 2423,
    city: "Upper Myall",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3,
    longitude: 152.1667,
    accuracy: 4
  },
  {
    postalCode: 2423,
    city: "Bungwahl",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3931,
    longitude: 152.4487,
    accuracy: 4
  },
  {
    postalCode: 2423,
    city: "Crawford River",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.45,
    longitude: 152.1333,
    accuracy: 4
  },
  {
    postalCode: 2423,
    city: "Violet Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3182,
    longitude: 152.2701,
    accuracy: 3
  },
  {
    postalCode: 2423,
    city: "Wang Wauk",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1667,
    longitude: 152.3333,
    accuracy: 4
  },
  {
    postalCode: 2423,
    city: "Mayers Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.388,
    longitude: 152.3318,
    accuracy: 4
  },
  {
    postalCode: 2423,
    city: "Wootton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3021,
    longitude: 152.3171,
    accuracy: 4
  },
  {
    postalCode: 2423,
    city: "Boolambayte",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3982,
    longitude: 152.2696,
    accuracy: 4
  },
  {
    postalCode: 2423,
    city: "Topi Topi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3667,
    longitude: 152.3833,
    accuracy: 4
  },
  {
    postalCode: 2423,
    city: "Bulahdelah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.407,
    longitude: 152.2119,
    accuracy: 4
  },
  {
    postalCode: 2423,
    city: "Markwell",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3333,
    longitude: 152.1833,
    accuracy: 4
  },
  {
    postalCode: 2423,
    city: "Mungo Brush",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3182,
    longitude: 152.2701,
    accuracy: 3
  },
  {
    postalCode: 2423,
    city: "Warranulla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1963,
    longitude: 152.1354,
    accuracy: 4
  },
  {
    postalCode: 2423,
    city: "Myall Lake",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3182,
    longitude: 152.2701,
    accuracy: 3
  },
  {
    postalCode: 2423,
    city: "Nerong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5235,
    longitude: 152.1982,
    accuracy: 3
  },
  {
    postalCode: 2423,
    city: "Bombah Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3182,
    longitude: 152.2701,
    accuracy: 3
  },
  {
    postalCode: 2423,
    city: "Coolongolook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.2174,
    longitude: 152.3221,
    accuracy: 4
  },
  {
    postalCode: 2423,
    city: "Yagon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3182,
    longitude: 152.2701,
    accuracy: 3
  },
  {
    postalCode: 2423,
    city: "Willina",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1766,
    longitude: 152.2712,
    accuracy: 4
  },
  {
    postalCode: 2423,
    city: "Seal Rocks",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4399,
    longitude: 152.5317,
    accuracy: 4
  },
  {
    postalCode: 2424,
    city: "Knorrit Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8414,
    longitude: 152.112,
    accuracy: 4
  },
  {
    postalCode: 2424,
    city: "Mount George",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8884,
    longitude: 152.1854,
    accuracy: 4
  },
  {
    postalCode: 2424,
    city: "Cells River",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8167,
    longitude: 152.0792,
    accuracy: 3
  },
  {
    postalCode: 2424,
    city: "Cundle Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8167,
    longitude: 151.9833,
    accuracy: 4
  },
  {
    postalCode: 2424,
    city: "Caffreys Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8167,
    longitude: 152.0792,
    accuracy: 3
  },
  {
    postalCode: 2424,
    city: "Number One",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.738,
    longitude: 152.0665,
    accuracy: 4
  },
  {
    postalCode: 2424,
    city: "Tiri",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8167,
    longitude: 152.0792,
    accuracy: 3
  },
  {
    postalCode: 2424,
    city: "Cooplacurripa",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8167,
    longitude: 152.0792,
    accuracy: 3
  },
  {
    postalCode: 2424,
    city: "Knorrit Forest",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8167,
    longitude: 152.0792,
    accuracy: 3
  },
  {
    postalCode: 2425,
    city: "Allworth",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5368,
    longitude: 151.9418,
    accuracy: 4
  },
  {
    postalCode: 2425,
    city: "Washpool",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.395,
    longitude: 152.0141,
    accuracy: 3
  },
  {
    postalCode: 2425,
    city: "Stroud",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4037,
    longitude: 151.967,
    accuracy: 4
  },
  {
    postalCode: 2425,
    city: "The Branch",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5333,
    longitude: 152.0167,
    accuracy: 4
  },
  {
    postalCode: 2425,
    city: "Girvan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4777,
    longitude: 152.0651,
    accuracy: 4
  },
  {
    postalCode: 2425,
    city: "Booral",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4685,
    longitude: 151.986,
    accuracy: 4
  },
  {
    postalCode: 2426,
    city: "Moto",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8127,
    longitude: 152.589,
    accuracy: 3
  },
  {
    postalCode: 2426,
    city: "Coopernook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8254,
    longitude: 152.6114,
    accuracy: 4
  },
  {
    postalCode: 2426,
    city: "Langley Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8,
    longitude: 152.5667,
    accuracy: 4
  },
  {
    postalCode: 2427,
    city: "Harrington",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8723,
    longitude: 152.6917,
    accuracy: 4
  },
  {
    postalCode: 2427,
    city: "Crowdy Head",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8448,
    longitude: 152.7389,
    accuracy: 3
  },
  {
    postalCode: 2428,
    city: "Whoota",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3157,
    longitude: 152.4818,
    accuracy: 4
  },
  {
    postalCode: 2428,
    city: "Coomba Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.28,
    longitude: 152.5039,
    accuracy: 3
  },
  {
    postalCode: 2428,
    city: "Coomba Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.2377,
    longitude: 152.4571,
    accuracy: 4
  },
  {
    postalCode: 2428,
    city: "Elizabeth Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3195,
    longitude: 152.5275,
    accuracy: 4
  },
  {
    postalCode: 2428,
    city: "Blueys Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3472,
    longitude: 152.5357,
    accuracy: 4
  },
  {
    postalCode: 2428,
    city: "Smiths Lake",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3824,
    longitude: 152.5018,
    accuracy: 4
  },
  {
    postalCode: 2428,
    city: "Booti Booti",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3168,
    longitude: 152.5221,
    accuracy: 4
  },
  {
    postalCode: 2428,
    city: "Tiona",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.28,
    longitude: 152.5039,
    accuracy: 3
  },
  {
    postalCode: 2428,
    city: "Forster",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1814,
    longitude: 152.5172,
    accuracy: 4
  },
  {
    postalCode: 2428,
    city: "Shallow Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.28,
    longitude: 152.5039,
    accuracy: 3
  },
  {
    postalCode: 2428,
    city: "Green Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.2493,
    longitude: 152.5176,
    accuracy: 4
  },
  {
    postalCode: 2428,
    city: "Forster Shopping Village",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.2335,
    longitude: 152.4559,
    accuracy: 3
  },
  {
    postalCode: 2428,
    city: "Tuncurry",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1744,
    longitude: 152.4988,
    accuracy: 4
  },
  {
    postalCode: 2428,
    city: "Wallingat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.28,
    longitude: 152.5039,
    accuracy: 3
  },
  {
    postalCode: 2428,
    city: "Charlotte Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.351,
    longitude: 152.5079,
    accuracy: 4
  },
  {
    postalCode: 2428,
    city: "Tarbuck Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3645,
    longitude: 152.4779,
    accuracy: 4
  },
  {
    postalCode: 2428,
    city: "Darawank",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1333,
    longitude: 152.4833,
    accuracy: 4
  },
  {
    postalCode: 2428,
    city: "Sandbar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.28,
    longitude: 152.5039,
    accuracy: 3
  },
  {
    postalCode: 2428,
    city: "Pacific Palms",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.2335,
    longitude: 152.4559,
    accuracy: 3
  },
  {
    postalCode: 2428,
    city: "Wallis Lake",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.28,
    longitude: 152.5039,
    accuracy: 3
  },
  {
    postalCode: 2428,
    city: "Boomerang Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.28,
    longitude: 152.5039,
    accuracy: 3
  },
  {
    postalCode: 2429,
    city: "Bobin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.7167,
    longitude: 152.2833,
    accuracy: 4
  },
  {
    postalCode: 2429,
    city: "Kimbriki",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9252,
    longitude: 152.2107,
    accuracy: 4
  },
  {
    postalCode: 2429,
    city: "Cedar Party",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8,
    longitude: 152.3833,
    accuracy: 4
  },
  {
    postalCode: 2429,
    city: "Bucca Wauka",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1,
    longitude: 152.1667,
    accuracy: 4
  },
  {
    postalCode: 2429,
    city: "Burrell Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9333,
    longitude: 152.3,
    accuracy: 4
  },
  {
    postalCode: 2429,
    city: "Krambach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.05,
    longitude: 152.2667,
    accuracy: 4
  },
  {
    postalCode: 2429,
    city: "Dyers Crossing",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1,
    longitude: 152.3,
    accuracy: 4
  },
  {
    postalCode: 2429,
    city: "Yarratt Forest",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8738,
    longitude: 152.2973,
    accuracy: 3
  },
  {
    postalCode: 2429,
    city: "Killawarra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9049,
    longitude: 152.2872,
    accuracy: 4
  },
  {
    postalCode: 2429,
    city: "Killabakh",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.7333,
    longitude: 152.4,
    accuracy: 4
  },
  {
    postalCode: 2429,
    city: "Wingham",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8668,
    longitude: 152.3699,
    accuracy: 4
  },
  {
    postalCode: 2429,
    city: "Innes View",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8738,
    longitude: 152.2973,
    accuracy: 3
  },
  {
    postalCode: 2429,
    city: "Comboyne",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6092,
    longitude: 152.4742,
    accuracy: 4
  },
  {
    postalCode: 2429,
    city: "Kundibakh",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9833,
    longitude: 152.25,
    accuracy: 4
  },
  {
    postalCode: 2429,
    city: "Elands",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6385,
    longitude: 152.2981,
    accuracy: 4
  },
  {
    postalCode: 2429,
    city: "Bulga Forest",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8738,
    longitude: 152.2973,
    accuracy: 3
  },
  {
    postalCode: 2429,
    city: "Wherrol Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.7816,
    longitude: 152.2269,
    accuracy: 4
  },
  {
    postalCode: 2429,
    city: "Khatambuhl",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8738,
    longitude: 152.2973,
    accuracy: 3
  },
  {
    postalCode: 2429,
    city: "Marlee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8014,
    longitude: 152.3157,
    accuracy: 4
  },
  {
    postalCode: 2429,
    city: "Dollys Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8738,
    longitude: 152.2973,
    accuracy: 3
  },
  {
    postalCode: 2429,
    city: "Mooral Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.7248,
    longitude: 152.355,
    accuracy: 4
  },
  {
    postalCode: 2429,
    city: "Strathcedar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8738,
    longitude: 152.2973,
    accuracy: 3
  },
  {
    postalCode: 2429,
    city: "Bunyah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1667,
    longitude: 152.2167,
    accuracy: 4
  },
  {
    postalCode: 2429,
    city: "The Bight",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8738,
    longitude: 152.2973,
    accuracy: 3
  },
  {
    postalCode: 2429,
    city: "Warriwillah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.7783,
    longitude: 152.2596,
    accuracy: 3
  },
  {
    postalCode: 2429,
    city: "Tipperary",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8738,
    longitude: 152.2973,
    accuracy: 3
  },
  {
    postalCode: 2429,
    city: "Caparra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.7783,
    longitude: 152.2596,
    accuracy: 3
  },
  {
    postalCode: 2429,
    city: "Boorganna",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8738,
    longitude: 152.2973,
    accuracy: 3
  },
  {
    postalCode: 2429,
    city: "Firefly",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.0826,
    longitude: 152.2449,
    accuracy: 3
  },
  {
    postalCode: 2429,
    city: "Kippaxs",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8738,
    longitude: 152.2973,
    accuracy: 3
  },
  {
    postalCode: 2429,
    city: "Dingo Forest",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8738,
    longitude: 152.2973,
    accuracy: 3
  },
  {
    postalCode: 2429,
    city: "Karaak Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8738,
    longitude: 152.2973,
    accuracy: 3
  },
  {
    postalCode: 2430,
    city: "Purfleet",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9428,
    longitude: 152.4673,
    accuracy: 4
  },
  {
    postalCode: 2430,
    city: "Cundletown",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8941,
    longitude: 152.5214,
    accuracy: 4
  },
  {
    postalCode: 2430,
    city: "Bohnock",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.95,
    longitude: 152.5667,
    accuracy: 4
  },
  {
    postalCode: 2430,
    city: "Rainbow Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.0333,
    longitude: 152.4833,
    accuracy: 4
  },
  {
    postalCode: 2430,
    city: "Taree",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.911,
    longitude: 152.4539,
    accuracy: 4
  },
  {
    postalCode: 2430,
    city: "Brimbin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9412,
    longitude: 152.5161,
    accuracy: 3
  },
  {
    postalCode: 2430,
    city: "Cabbage Tree Island",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9804,
    longitude: 153.4567,
    accuracy: 4
  },
  {
    postalCode: 2430,
    city: "Kundle Kundle",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9412,
    longitude: 152.5161,
    accuracy: 3
  },
  {
    postalCode: 2430,
    city: "Glenthorne",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9279,
    longitude: 152.4788,
    accuracy: 4
  },
  {
    postalCode: 2430,
    city: "Black Head",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9412,
    longitude: 152.5161,
    accuracy: 3
  },
  {
    postalCode: 2430,
    city: "Oxley Island",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9167,
    longitude: 152.5667,
    accuracy: 4
  },
  {
    postalCode: 2430,
    city: "Dumaresq Island",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9412,
    longitude: 152.5161,
    accuracy: 3
  },
  {
    postalCode: 2430,
    city: "Chatham",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9,
    longitude: 152.4833,
    accuracy: 4
  },
  {
    postalCode: 2430,
    city: "Ghinni Ghinni",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8833,
    longitude: 152.5667,
    accuracy: 4
  },
  {
    postalCode: 2430,
    city: "Old Bar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9694,
    longitude: 152.5881,
    accuracy: 4
  },
  {
    postalCode: 2430,
    city: "Lansdowne",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.7849,
    longitude: 152.5192,
    accuracy: 4
  },
  {
    postalCode: 2430,
    city: "Mitchells Island",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9,
    longitude: 152.6167,
    accuracy: 4
  },
  {
    postalCode: 2430,
    city: "Hallidays Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.0713,
    longitude: 152.5445,
    accuracy: 4
  },
  {
    postalCode: 2430,
    city: "Possum Brush",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.0651,
    longitude: 152.4382,
    accuracy: 4
  },
  {
    postalCode: 2430,
    city: "Lansdowne Forest",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.7469,
    longitude: 152.5757,
    accuracy: 4
  },
  {
    postalCode: 2430,
    city: "Koorainghat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.986,
    longitude: 152.4799,
    accuracy: 4
  },
  {
    postalCode: 2430,
    city: "Diamond Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.0435,
    longitude: 152.5346,
    accuracy: 4
  },
  {
    postalCode: 2430,
    city: "Kolodong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8833,
    longitude: 152.4333,
    accuracy: 4
  },
  {
    postalCode: 2430,
    city: "Tallwoods Village",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.0554,
    longitude: 152.5104,
    accuracy: 4
  },
  {
    postalCode: 2430,
    city: "Failford",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.0918,
    longitude: 152.446,
    accuracy: 4
  },
  {
    postalCode: 2430,
    city: "Bootawa",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9412,
    longitude: 152.5161,
    accuracy: 3
  },
  {
    postalCode: 2430,
    city: "Upper Lansdowne",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.7108,
    longitude: 152.4658,
    accuracy: 4
  },
  {
    postalCode: 2430,
    city: "Hillville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9833,
    longitude: 152.3667,
    accuracy: 4
  },
  {
    postalCode: 2430,
    city: "Red Head",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.057,
    longitude: 152.5357,
    accuracy: 4
  },
  {
    postalCode: 2430,
    city: "Kiwarrak",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9412,
    longitude: 152.5161,
    accuracy: 3
  },
  {
    postalCode: 2430,
    city: "Croki",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8733,
    longitude: 152.5926,
    accuracy: 4
  },
  {
    postalCode: 2430,
    city: "Tinonee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9363,
    longitude: 152.4142,
    accuracy: 4
  },
  {
    postalCode: 2430,
    city: "Jones Island",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9412,
    longitude: 152.5161,
    accuracy: 3
  },
  {
    postalCode: 2430,
    city: "Wallabi Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9951,
    longitude: 152.5685,
    accuracy: 4
  },
  {
    postalCode: 2430,
    city: "Saltwater",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9412,
    longitude: 152.5161,
    accuracy: 3
  },
  {
    postalCode: 2430,
    city: "Manning Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8963,
    longitude: 152.6617,
    accuracy: 4
  },
  {
    postalCode: 2430,
    city: "Pampoolah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9333,
    longitude: 152.5333,
    accuracy: 4
  },
  {
    postalCode: 2430,
    city: "Mondrook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9412,
    longitude: 152.5161,
    accuracy: 3
  },
  {
    postalCode: 2430,
    city: "Taree South",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9412,
    longitude: 152.5161,
    accuracy: 3
  },
  {
    postalCode: 2430,
    city: "Melinga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9412,
    longitude: 152.5161,
    accuracy: 3
  },
  {
    postalCode: 2431,
    city: "South West Rocks",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.8855,
    longitude: 153.0413,
    accuracy: 4
  },
  {
    postalCode: 2431,
    city: "Arakoon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.8875,
    longitude: 153.0721,
    accuracy: 4
  },
  {
    postalCode: 2431,
    city: "Jerseyville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.9167,
    longitude: 153.0333,
    accuracy: 4
  },
  {
    postalCode: 2439,
    city: "Kerewong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6466,
    longitude: 152.6875,
    accuracy: 3
  },
  {
    postalCode: 2439,
    city: "Lorne",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6612,
    longitude: 152.6117,
    accuracy: 4
  },
  {
    postalCode: 2439,
    city: "Black Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6466,
    longitude: 152.6875,
    accuracy: 3
  },
  {
    postalCode: 2439,
    city: "Rossglen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6658,
    longitude: 152.7251,
    accuracy: 4
  },
  {
    postalCode: 2439,
    city: "Batar Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6466,
    longitude: 152.6875,
    accuracy: 3
  },
  {
    postalCode: 2439,
    city: "Upsalls Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6333,
    longitude: 152.6667,
    accuracy: 4
  },
  {
    postalCode: 2439,
    city: "Kew",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.636,
    longitude: 152.7266,
    accuracy: 4
  },
  {
    postalCode: 2439,
    city: "Logans Crossing",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6466,
    longitude: 152.6875,
    accuracy: 3
  },
  {
    postalCode: 2439,
    city: "Kendall",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.633,
    longitude: 152.7039,
    accuracy: 4
  },
  {
    postalCode: 2439,
    city: "Swans Crossing",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6466,
    longitude: 152.6875,
    accuracy: 3
  },
  {
    postalCode: 2440,
    city: "West Kempsey",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.8855,
    longitude: 153.0413,
    accuracy: 4
  },
  {
    postalCode: 2440,
    city: "Yarravel",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.043,
    longitude: 152.7619,
    accuracy: 4
  },
  {
    postalCode: 2440,
    city: "Dondingalong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.1332,
    longitude: 152.7514,
    accuracy: 4
  },
  {
    postalCode: 2440,
    city: "East Kempsey",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0123,
    longitude: 152.7651,
    accuracy: 3
  },
  {
    postalCode: 2440,
    city: "Lower Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.7342,
    longitude: 152.2575,
    accuracy: 4
  },
  {
    postalCode: 2440,
    city: "Old Station",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0123,
    longitude: 152.7651,
    accuracy: 3
  },
  {
    postalCode: 2440,
    city: "Frederickton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0375,
    longitude: 152.8753,
    accuracy: 4
  },
  {
    postalCode: 2440,
    city: "Temagog",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0123,
    longitude: 152.7651,
    accuracy: 3
  },
  {
    postalCode: 2440,
    city: "Comara",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.78,
    longitude: 152.3772,
    accuracy: 4
  },
  {
    postalCode: 2440,
    city: "Rainbow Reach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0123,
    longitude: 152.7651,
    accuracy: 3
  },
  {
    postalCode: 2440,
    city: "Kinchela",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.9939,
    longitude: 152.9914,
    accuracy: 4
  },
  {
    postalCode: 2440,
    city: "Yessabah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0123,
    longitude: 152.7651,
    accuracy: 3
  },
  {
    postalCode: 2440,
    city: "South Kempsey",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.079,
    longitude: 152.8309,
    accuracy: 3
  },
  {
    postalCode: 2440,
    city: "Wittitrin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.1333,
    longitude: 152.6667,
    accuracy: 4
  },
  {
    postalCode: 2440,
    city: "Skillion Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0099,
    longitude: 152.7329,
    accuracy: 4
  },
  {
    postalCode: 2440,
    city: "Toorooka",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.9307,
    longitude: 152.6368,
    accuracy: 3
  },
  {
    postalCode: 2440,
    city: "Sherwood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0649,
    longitude: 152.7288,
    accuracy: 4
  },
  {
    postalCode: 2440,
    city: "Hampden Hall",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0123,
    longitude: 152.7651,
    accuracy: 3
  },
  {
    postalCode: 2440,
    city: "Willi Willi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.9333,
    longitude: 152.45,
    accuracy: 4
  },
  {
    postalCode: 2440,
    city: "Bellimbopinni",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0167,
    longitude: 152.9167,
    accuracy: 4
  },
  {
    postalCode: 2440,
    city: "Willawarrin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.9288,
    longitude: 152.6253,
    accuracy: 4
  },
  {
    postalCode: 2440,
    city: "Belmore River",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.1167,
    longitude: 152.9833,
    accuracy: 4
  },
  {
    postalCode: 2440,
    city: "Kempsey",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.079,
    longitude: 152.8309,
    accuracy: 4
  },
  {
    postalCode: 2440,
    city: "Greenhill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.059,
    longitude: 152.8017,
    accuracy: 4
  },
  {
    postalCode: 2440,
    city: "Aldavilla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0818,
    longitude: 152.7679,
    accuracy: 4
  },
  {
    postalCode: 2440,
    city: "Carrai",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.9307,
    longitude: 152.6368,
    accuracy: 3
  },
  {
    postalCode: 2440,
    city: "Hickeys Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.8985,
    longitude: 152.6179,
    accuracy: 4
  },
  {
    postalCode: 2440,
    city: "Gladstone",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0288,
    longitude: 152.9476,
    accuracy: 4
  },
  {
    postalCode: 2440,
    city: "Millbank",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.8612,
    longitude: 152.6357,
    accuracy: 4
  },
  {
    postalCode: 2440,
    city: "Pola Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0123,
    longitude: 152.7651,
    accuracy: 3
  },
  {
    postalCode: 2440,
    city: "Austral Eden",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0333,
    longitude: 152.9167,
    accuracy: 4
  },
  {
    postalCode: 2440,
    city: "Hat Head",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0555,
    longitude: 153.0472,
    accuracy: 4
  },
  {
    postalCode: 2440,
    city: "Euroka",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.077,
    longitude: 152.8005,
    accuracy: 4
  },
  {
    postalCode: 2440,
    city: "Deep Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.3667,
    longitude: 149.8333,
    accuracy: 4
  },
  {
    postalCode: 2440,
    city: "Clybucca",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.9377,
    longitude: 152.9413,
    accuracy: 4
  },
  {
    postalCode: 2440,
    city: "Seven Oaks",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0123,
    longitude: 152.7651,
    accuracy: 3
  },
  {
    postalCode: 2440,
    city: "Mooneba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0402,
    longitude: 152.6846,
    accuracy: 4
  },
  {
    postalCode: 2440,
    city: "Turners Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0152,
    longitude: 152.7012,
    accuracy: 4
  },
  {
    postalCode: 2440,
    city: "Crescent Head",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.1887,
    longitude: 152.973,
    accuracy: 4
  },
  {
    postalCode: 2440,
    city: "Moparrabah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0123,
    longitude: 152.7651,
    accuracy: 3
  },
  {
    postalCode: 2440,
    city: "Smithtown",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0186,
    longitude: 152.9503,
    accuracy: 4
  },
  {
    postalCode: 2440,
    city: "Collombatti",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.9812,
    longitude: 152.8251,
    accuracy: 4
  },
  {
    postalCode: 2440,
    city: "Burnt Bridge",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.108,
    longitude: 152.8062,
    accuracy: 4
  },
  {
    postalCode: 2440,
    city: "Summer Island",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0123,
    longitude: 152.7651,
    accuracy: 3
  },
  {
    postalCode: 2440,
    city: "Bellbrook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.8199,
    longitude: 152.5102,
    accuracy: 4
  },
  {
    postalCode: 2440,
    city: "Mungay Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0123,
    longitude: 152.7651,
    accuracy: 3
  },
  {
    postalCode: 2440,
    city: "Corangula",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0123,
    longitude: 152.7651,
    accuracy: 3
  },
  {
    postalCode: 2440,
    city: "Verges Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0878,
    longitude: 152.8997,
    accuracy: 3
  },
  {
    postalCode: 2441,
    city: "Eungai Rail",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.8463,
    longitude: 152.9006,
    accuracy: 3
  },
  {
    postalCode: 2441,
    city: "Yarrahapinni",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.8281,
    longitude: 152.9538,
    accuracy: 4
  },
  {
    postalCode: 2441,
    city: "Kundabung",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.2094,
    longitude: 152.8316,
    accuracy: 4
  },
  {
    postalCode: 2441,
    city: "Bril Bril",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0274,
    longitude: 152.8364,
    accuracy: 3
  },
  {
    postalCode: 2441,
    city: "Upper Rollands Plains",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.2434,
    longitude: 152.6205,
    accuracy: 4
  },
  {
    postalCode: 2441,
    city: "Cooperabung",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.3,
    longitude: 152.8,
    accuracy: 4
  },
  {
    postalCode: 2441,
    city: "Eungai Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.8333,
    longitude: 152.8833,
    accuracy: 4
  },
  {
    postalCode: 2441,
    city: "Stuarts Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.8208,
    longitude: 152.9933,
    accuracy: 4
  },
  {
    postalCode: 2441,
    city: "Tamban",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.8827,
    longitude: 152.826,
    accuracy: 4
  },
  {
    postalCode: 2441,
    city: "Crossmaglen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.1374,
    longitude: 152.7419,
    accuracy: 3
  },
  {
    postalCode: 2441,
    city: "Telegraph Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.3247,
    longitude: 152.8005,
    accuracy: 4
  },
  {
    postalCode: 2441,
    city: "Fishermans Reach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0274,
    longitude: 152.8364,
    accuracy: 3
  },
  {
    postalCode: 2441,
    city: "Allgomera",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.8182,
    longitude: 152.7955,
    accuracy: 4
  },
  {
    postalCode: 2441,
    city: "Grassy Head",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.1374,
    longitude: 152.7419,
    accuracy: 3
  },
  {
    postalCode: 2441,
    city: "Ballengarra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.3167,
    longitude: 152.75,
    accuracy: 4
  },
  {
    postalCode: 2441,
    city: "Gum Scrub",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.3,
    longitude: 152.7333,
    accuracy: 4
  },
  {
    postalCode: 2441,
    city: "Barraganyatti",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.8568,
    longitude: 152.9346,
    accuracy: 4
  },
  {
    postalCode: 2441,
    city: "Marlo Merrican",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0274,
    longitude: 152.8364,
    accuracy: 3
  },
  {
    postalCode: 2441,
    city: "Kippara",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.2209,
    longitude: 152.5225,
    accuracy: 4
  },
  {
    postalCode: 2441,
    city: "Bonville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.3828,
    longitude: 153.0596,
    accuracy: 4
  },
  {
    postalCode: 2441,
    city: "Rollands Plains",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.2818,
    longitude: 152.6846,
    accuracy: 4
  },
  {
    postalCode: 2441,
    city: "Hacks Ferry",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0274,
    longitude: 152.8364,
    accuracy: 3
  },
  {
    postalCode: 2442,
    city: "Mid North Coast Msc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.1374,
    longitude: 152.7419,
    accuracy: 1
  },
  {
    postalCode: 2442,
    city: "Mid North Coast Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.1374,
    longitude: 152.7419,
    accuracy: 1
  },
  {
    postalCode: 2443,
    city: "Diamond Head",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.057,
    longitude: 152.5357,
    accuracy: 4
  },
  {
    postalCode: 2443,
    city: "Laurieton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6448,
    longitude: 152.7946,
    accuracy: 4
  },
  {
    postalCode: 2443,
    city: "Coralville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6915,
    longitude: 152.7267,
    accuracy: 3
  },
  {
    postalCode: 2443,
    city: "Waitui",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6915,
    longitude: 152.7267,
    accuracy: 3
  },
  {
    postalCode: 2443,
    city: "Bobs Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6915,
    longitude: 152.7267,
    accuracy: 3
  },
  {
    postalCode: 2443,
    city: "North Haven",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6368,
    longitude: 152.8136,
    accuracy: 4
  },
  {
    postalCode: 2443,
    city: "Deauville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6915,
    longitude: 152.7267,
    accuracy: 3
  },
  {
    postalCode: 2443,
    city: "Middle Brother",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6915,
    longitude: 152.7267,
    accuracy: 3
  },
  {
    postalCode: 2443,
    city: "Stewarts River",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.7333,
    longitude: 152.65,
    accuracy: 4
  },
  {
    postalCode: 2443,
    city: "Dunbogan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.65,
    longitude: 152.8167,
    accuracy: 4
  },
  {
    postalCode: 2443,
    city: "Lakewood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6321,
    longitude: 152.7582,
    accuracy: 4
  },
  {
    postalCode: 2443,
    city: "North Brother",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6915,
    longitude: 152.7267,
    accuracy: 3
  },
  {
    postalCode: 2443,
    city: "Camden Head",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6469,
    longitude: 152.8346,
    accuracy: 3
  },
  {
    postalCode: 2443,
    city: "Moorland",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.7929,
    longitude: 152.6518,
    accuracy: 4
  },
  {
    postalCode: 2443,
    city: "Hannam Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.7167,
    longitude: 152.6,
    accuracy: 4
  },
  {
    postalCode: 2443,
    city: "Crowdy Bay National Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.788,
    longitude: 152.7311,
    accuracy: 4
  },
  {
    postalCode: 2443,
    city: "West Haven",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6344,
    longitude: 152.7825,
    accuracy: 3
  },
  {
    postalCode: 2443,
    city: "Herons Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.5918,
    longitude: 152.7274,
    accuracy: 4
  },
  {
    postalCode: 2443,
    city: "Johns River",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.7339,
    longitude: 152.6965,
    accuracy: 4
  },
  {
    postalCode: 2444,
    city: "Riverside",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.7083,
    longitude: 152.6444,
    accuracy: 3
  },
  {
    postalCode: 2444,
    city: "Limeburners Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6167,
    longitude: 151.9167,
    accuracy: 4
  },
  {
    postalCode: 2444,
    city: "Blackmans Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.3906,
    longitude: 152.8314,
    accuracy: 4
  },
  {
    postalCode: 2444,
    city: "Fernbank Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4212,
    longitude: 152.8404,
    accuracy: 4
  },
  {
    postalCode: 2444,
    city: "Port Macquarie Bc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.3892,
    longitude: 152.8614,
    accuracy: 3
  },
  {
    postalCode: 2444,
    city: "North Shore",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4024,
    longitude: 152.9019,
    accuracy: 4
  },
  {
    postalCode: 2444,
    city: "The Hatch",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.7083,
    longitude: 152.6444,
    accuracy: 3
  },
  {
    postalCode: 2444,
    city: "Flynns Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.3892,
    longitude: 152.8614,
    accuracy: 3
  },
  {
    postalCode: 2444,
    city: "Port Macquarie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4308,
    longitude: 152.9089,
    accuracy: 4
  },
  {
    postalCode: 2444,
    city: "Thrumster",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.7083,
    longitude: 152.6444,
    accuracy: 3
  },
  {
    postalCode: 2444,
    city: "Settlement City",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.7083,
    longitude: 152.6444,
    accuracy: 3
  },
  {
    postalCode: 2444,
    city: "Lighthouse Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.7083,
    longitude: 152.6444,
    accuracy: 3
  },
  {
    postalCode: 2445,
    city: "Bonny Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.5906,
    longitude: 152.8391,
    accuracy: 4
  },
  {
    postalCode: 2445,
    city: "Lake Cathie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.5518,
    longitude: 152.8546,
    accuracy: 4
  },
  {
    postalCode: 2445,
    city: "Grants Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.5712,
    longitude: 152.8469,
    accuracy: 3
  },
  {
    postalCode: 2445,
    city: "Jolly Nose",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.5712,
    longitude: 152.8469,
    accuracy: 3
  },
  {
    postalCode: 2446,
    city: "Wauchope",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4579,
    longitude: 152.7262,
    accuracy: 4
  },
  {
    postalCode: 2446,
    city: "Hartys Plains",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4343,
    longitude: 152.6221,
    accuracy: 3
  },
  {
    postalCode: 2446,
    city: "Banda Banda",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.2157,
    longitude: 152.4566,
    accuracy: 4
  },
  {
    postalCode: 2446,
    city: "Yippin Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4343,
    longitude: 152.6221,
    accuracy: 3
  },
  {
    postalCode: 2446,
    city: "Redbank",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4242,
    longitude: 152.7393,
    accuracy: 4
  },
  {
    postalCode: 2446,
    city: "Long Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4395,
    longitude: 152.4925,
    accuracy: 4
  },
  {
    postalCode: 2446,
    city: "Pembrooke",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.3935,
    longitude: 152.7508,
    accuracy: 4
  },
  {
    postalCode: 2446,
    city: "Bago",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4343,
    longitude: 152.6221,
    accuracy: 3
  },
  {
    postalCode: 2446,
    city: "Ellenborough",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.45,
    longitude: 152.4667,
    accuracy: 4
  },
  {
    postalCode: 2446,
    city: "Birdwood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.3485,
    longitude: 152.3346,
    accuracy: 4
  },
  {
    postalCode: 2446,
    city: "Bellangry",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.3284,
    longitude: 152.6077,
    accuracy: 4
  },
  {
    postalCode: 2446,
    city: "Lower Pappinbarra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4343,
    longitude: 152.6221,
    accuracy: 3
  },
  {
    postalCode: 2446,
    city: "Forbes River",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.3667,
    longitude: 152.3167,
    accuracy: 4
  },
  {
    postalCode: 2446,
    city: "Hollisdale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4,
    longitude: 152.5333,
    accuracy: 4
  },
  {
    postalCode: 2446,
    city: "Sancrox",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4318,
    longitude: 152.8012,
    accuracy: 4
  },
  {
    postalCode: 2446,
    city: "Toms Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.3861,
    longitude: 152.4402,
    accuracy: 3
  },
  {
    postalCode: 2446,
    city: "Rawdon Island",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4333,
    longitude: 152.7667,
    accuracy: 4
  },
  {
    postalCode: 2446,
    city: "King Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4924,
    longitude: 152.7566,
    accuracy: 4
  },
  {
    postalCode: 2446,
    city: "Brombin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4578,
    longitude: 152.6315,
    accuracy: 4
  },
  {
    postalCode: 2446,
    city: "Rosewood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4343,
    longitude: 152.6221,
    accuracy: 3
  },
  {
    postalCode: 2446,
    city: "Beechwood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4365,
    longitude: 152.6768,
    accuracy: 4
  },
  {
    postalCode: 2446,
    city: "Pappinbarra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.3666,
    longitude: 152.4943,
    accuracy: 4
  },
  {
    postalCode: 2446,
    city: "Yarras",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4189,
    longitude: 152.3198,
    accuracy: 4
  },
  {
    postalCode: 2446,
    city: "Cairncross",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4343,
    longitude: 152.6221,
    accuracy: 3
  },
  {
    postalCode: 2446,
    city: "Byabarra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.523,
    longitude: 152.546,
    accuracy: 4
  },
  {
    postalCode: 2446,
    city: "Huntingdon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4639,
    longitude: 152.6521,
    accuracy: 4
  },
  {
    postalCode: 2446,
    city: "Mount Seaview",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.3966,
    longitude: 152.0798,
    accuracy: 4
  },
  {
    postalCode: 2446,
    city: "Kindee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4343,
    longitude: 152.6221,
    accuracy: 3
  },
  {
    postalCode: 2446,
    city: "Mortons Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.3829,
    longitude: 152.6427,
    accuracy: 4
  },
  {
    postalCode: 2446,
    city: "Doyles River",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4343,
    longitude: 152.6221,
    accuracy: 3
  },
  {
    postalCode: 2446,
    city: "Gearys Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4343,
    longitude: 152.6221,
    accuracy: 3
  },
  {
    postalCode: 2446,
    city: "Upper Pappinbarra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4343,
    longitude: 152.6221,
    accuracy: 3
  },
  {
    postalCode: 2446,
    city: "Werrikimbe",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4343,
    longitude: 152.6221,
    accuracy: 3
  },
  {
    postalCode: 2446,
    city: "Frazers Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4343,
    longitude: 152.6221,
    accuracy: 3
  },
  {
    postalCode: 2446,
    city: "Bagnoo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4652,
    longitude: 152.5346,
    accuracy: 4
  },
  {
    postalCode: 2446,
    city: "Debenham",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4343,
    longitude: 152.6221,
    accuracy: 3
  },
  {
    postalCode: 2446,
    city: "Lake Innes",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.5038,
    longitude: 152.8165,
    accuracy: 4
  },
  {
    postalCode: 2446,
    city: "Kings Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.3861,
    longitude: 152.4402,
    accuracy: 3
  },
  {
    postalCode: 2446,
    city: "Crosslands",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4393,
    longitude: 152.7154,
    accuracy: 4
  },
  {
    postalCode: 2446,
    city: "Hyndmans Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4343,
    longitude: 152.6221,
    accuracy: 3
  },
  {
    postalCode: 2446,
    city: "Pipeclay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4343,
    longitude: 152.6221,
    accuracy: 3
  },
  {
    postalCode: 2447,
    city: "Gumma",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.7172,
    longitude: 152.9694,
    accuracy: 4
  },
  {
    postalCode: 2447,
    city: "Taylors Arm",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.7833,
    longitude: 152.7,
    accuracy: 4
  },
  {
    postalCode: 2447,
    city: "Wirrimbi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.6667,
    longitude: 152.9333,
    accuracy: 4
  },
  {
    postalCode: 2447,
    city: "Congarinni",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.6867,
    longitude: 152.7061,
    accuracy: 3
  },
  {
    postalCode: 2447,
    city: "Scotts Head",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.7477,
    longitude: 152.9961,
    accuracy: 4
  },
  {
    postalCode: 2447,
    city: "Newee Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.6316,
    longitude: 152.9275,
    accuracy: 4
  },
  {
    postalCode: 2447,
    city: "Warrell Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.7718,
    longitude: 152.8924,
    accuracy: 4
  },
  {
    postalCode: 2447,
    city: "Upper Taylors Arm",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.6867,
    longitude: 152.7061,
    accuracy: 3
  },
  {
    postalCode: 2447,
    city: "Thumb Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.683,
    longitude: 152.6154,
    accuracy: 4
  },
  {
    postalCode: 2447,
    city: "Talarm",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.7016,
    longitude: 152.8501,
    accuracy: 4
  },
  {
    postalCode: 2447,
    city: "Macksville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.7078,
    longitude: 152.9203,
    accuracy: 4
  },
  {
    postalCode: 2447,
    city: "Congarinni North",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.6867,
    longitude: 152.7061,
    accuracy: 3
  },
  {
    postalCode: 2447,
    city: "Burrapine",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.7176,
    longitude: 152.6371,
    accuracy: 4
  },
  {
    postalCode: 2447,
    city: "Donnellyville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.7554,
    longitude: 152.9155,
    accuracy: 4
  },
  {
    postalCode: 2447,
    city: "Yarranbella",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.6867,
    longitude: 152.7061,
    accuracy: 3
  },
  {
    postalCode: 2447,
    city: "Bakers Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2667,
    longitude: 151.0167,
    accuracy: 4
  },
  {
    postalCode: 2447,
    city: "Way Way",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.6867,
    longitude: 152.7061,
    accuracy: 3
  },
  {
    postalCode: 2447,
    city: "Utungun",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.7427,
    longitude: 152.8276,
    accuracy: 4
  },
  {
    postalCode: 2447,
    city: "North Macksville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.6867,
    longitude: 152.7061,
    accuracy: 3
  },
  {
    postalCode: 2448,
    city: "Hyland Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.6124,
    longitude: 153.0001,
    accuracy: 4
  },
  {
    postalCode: 2448,
    city: "Valla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.5926,
    longitude: 153.0113,
    accuracy: 4
  },
  {
    postalCode: 2448,
    city: "Valla Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.5926,
    longitude: 153.0113,
    accuracy: 4
  },
  {
    postalCode: 2448,
    city: "Nambucca Heads",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.6432,
    longitude: 153.0088,
    accuracy: 4
  },
  {
    postalCode: 2449,
    city: "South Arm",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.6888,
    longitude: 152.7396,
    accuracy: 4
  },
  {
    postalCode: 2449,
    city: "Missabotti",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.5747,
    longitude: 152.8158,
    accuracy: 4
  },
  {
    postalCode: 2449,
    city: "Bowraville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.65,
    longitude: 152.8515,
    accuracy: 4
  },
  {
    postalCode: 2449,
    city: "Buckra Bendinni",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.6389,
    longitude: 152.7853,
    accuracy: 3
  },
  {
    postalCode: 2449,
    city: "Killiekrankie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.6389,
    longitude: 152.7853,
    accuracy: 3
  },
  {
    postalCode: 2449,
    city: "Tewinga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.6389,
    longitude: 152.7853,
    accuracy: 3
  },
  {
    postalCode: 2449,
    city: "Girralong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.5696,
    longitude: 152.6554,
    accuracy: 4
  },
  {
    postalCode: 2449,
    city: "Argents Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.6415,
    longitude: 152.7491,
    accuracy: 4
  },
  {
    postalCode: 2449,
    city: "Kennaicle Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.6389,
    longitude: 152.7853,
    accuracy: 3
  },
  {
    postalCode: 2450,
    city: "Upper Orara",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2833,
    longitude: 153,
    accuracy: 4
  },
  {
    postalCode: 2450,
    city: "Coffs Harbour",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2963,
    longitude: 153.1135,
    accuracy: 4
  },
  {
    postalCode: 2450,
    city: "Coffs Harbour Plaza",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.0947,
    longitude: 152.6671,
    accuracy: 3
  },
  {
    postalCode: 2450,
    city: "Moonee Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2057,
    longitude: 153.1529,
    accuracy: 4
  },
  {
    postalCode: 2450,
    city: "Nana Glen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.1333,
    longitude: 153.0167,
    accuracy: 4
  },
  {
    postalCode: 2450,
    city: "Bonville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.3828,
    longitude: 153.0596,
    accuracy: 4
  },
  {
    postalCode: 2450,
    city: "Sapphire Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2325,
    longitude: 153.1483,
    accuracy: 4
  },
  {
    postalCode: 2450,
    city: "Brooklana",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2488,
    longitude: 152.8432,
    accuracy: 4
  },
  {
    postalCode: 2450,
    city: "Ulong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2384,
    longitude: 152.8799,
    accuracy: 4
  },
  {
    postalCode: 2450,
    city: "Korora",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.259,
    longitude: 153.1306,
    accuracy: 4
  },
  {
    postalCode: 2450,
    city: "Lower Bucca",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.15,
    longitude: 153.0833,
    accuracy: 4
  },
  {
    postalCode: 2450,
    city: "Glenreagh",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.0534,
    longitude: 152.9786,
    accuracy: 4
  },
  {
    postalCode: 2450,
    city: "Coffs Harbour Jetty",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.0947,
    longitude: 152.6671,
    accuracy: 3
  },
  {
    postalCode: 2450,
    city: "Sherwood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0649,
    longitude: 152.7288,
    accuracy: 4
  },
  {
    postalCode: 2450,
    city: "Lowanna",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2167,
    longitude: 152.9,
    accuracy: 4
  },
  {
    postalCode: 2450,
    city: "North Boambee Valley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2807,
    longitude: 153.0196,
    accuracy: 3
  },
  {
    postalCode: 2450,
    city: "Bucca",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.1574,
    longitude: 153.0958,
    accuracy: 4
  },
  {
    postalCode: 2450,
    city: "Coramba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2202,
    longitude: 153.0134,
    accuracy: 4
  },
  {
    postalCode: 2450,
    city: "Boambee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.3398,
    longitude: 153.0678,
    accuracy: 4
  },
  {
    postalCode: 2450,
    city: "Karangi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2667,
    longitude: 153.05,
    accuracy: 4
  },
  {
    postalCode: 2452,
    city: "Sawtell",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.3646,
    longitude: 153.1014,
    accuracy: 4
  },
  {
    postalCode: 2452,
    city: "Boambee East",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.3466,
    longitude: 153.0732,
    accuracy: 4
  },
  {
    postalCode: 2452,
    city: "Toormina",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.3538,
    longitude: 153.0884,
    accuracy: 4
  },
  {
    postalCode: 2453,
    city: "Never Never",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.282,
    longitude: 152.61,
    accuracy: 3
  },
  {
    postalCode: 2453,
    city: "Deer Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.3485,
    longitude: 152.5512,
    accuracy: 4
  },
  {
    postalCode: 2453,
    city: "Billys Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.1674,
    longitude: 152.5747,
    accuracy: 4
  },
  {
    postalCode: 2453,
    city: "North Dorrigo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2955,
    longitude: 152.6862,
    accuracy: 4
  },
  {
    postalCode: 2453,
    city: "Ebor",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.4018,
    longitude: 152.349,
    accuracy: 4
  },
  {
    postalCode: 2453,
    city: "Marengo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.1725,
    longitude: 152.3615,
    accuracy: 4
  },
  {
    postalCode: 2453,
    city: "Dundurrabin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.1919,
    longitude: 152.5513,
    accuracy: 4
  },
  {
    postalCode: 2453,
    city: "Clouds Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.1019,
    longitude: 152.6498,
    accuracy: 4
  },
  {
    postalCode: 2453,
    city: "Tallowwood Ridge",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.282,
    longitude: 152.61,
    accuracy: 3
  },
  {
    postalCode: 2453,
    city: "Cascade",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2317,
    longitude: 152.7898,
    accuracy: 4
  },
  {
    postalCode: 2453,
    city: "Bielsdown Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.282,
    longitude: 152.61,
    accuracy: 3
  },
  {
    postalCode: 2453,
    city: "Tyringham",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2149,
    longitude: 152.5434,
    accuracy: 4
  },
  {
    postalCode: 2453,
    city: "Bostobrick",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2771,
    longitude: 152.6293,
    accuracy: 4
  },
  {
    postalCode: 2453,
    city: "Megan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2857,
    longitude: 152.7691,
    accuracy: 4
  },
  {
    postalCode: 2453,
    city: "Hernani",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2969,
    longitude: 152.4208,
    accuracy: 4
  },
  {
    postalCode: 2453,
    city: "Dorrigo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.3411,
    longitude: 152.7139,
    accuracy: 4
  },
  {
    postalCode: 2453,
    city: "Fernbrook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.282,
    longitude: 152.61,
    accuracy: 3
  },
  {
    postalCode: 2453,
    city: "Briggsvale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.2497,
    longitude: 152.7784,
    accuracy: 4
  },
  {
    postalCode: 2453,
    city: "Dorrigo Mountain",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.282,
    longitude: 152.61,
    accuracy: 3
  },
  {
    postalCode: 2453,
    city: "Wild Cattle Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.282,
    longitude: 152.61,
    accuracy: 3
  },
  {
    postalCode: 2453,
    city: "Moonpar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.282,
    longitude: 152.61,
    accuracy: 3
  },
  {
    postalCode: 2454,
    city: "Mylestom",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.4649,
    longitude: 153.0432,
    accuracy: 4
  },
  {
    postalCode: 2454,
    city: "Fernmount",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.4667,
    longitude: 152.9333,
    accuracy: 4
  },
  {
    postalCode: 2454,
    city: "Valery",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.4055,
    longitude: 152.9515,
    accuracy: 4
  },
  {
    postalCode: 2454,
    city: "Raleigh",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.4396,
    longitude: 152.9712,
    accuracy: 4
  },
  {
    postalCode: 2454,
    city: "Thora",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.4397,
    longitude: 152.7868,
    accuracy: 4
  },
  {
    postalCode: 2454,
    city: "Spicketts Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.441,
    longitude: 152.9121,
    accuracy: 3
  },
  {
    postalCode: 2454,
    city: "Brinerville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.441,
    longitude: 152.9121,
    accuracy: 3
  },
  {
    postalCode: 2454,
    city: "Kalang",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.5083,
    longitude: 152.7742,
    accuracy: 3
  },
  {
    postalCode: 2454,
    city: "Sunny Corner",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.4511,
    longitude: 152.743,
    accuracy: 3
  },
  {
    postalCode: 2454,
    city: "Repton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.45,
    longitude: 153.0167,
    accuracy: 4
  },
  {
    postalCode: 2454,
    city: "Brierfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.5,
    longitude: 152.9,
    accuracy: 4
  },
  {
    postalCode: 2454,
    city: "Bundagen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.4132,
    longitude: 153.0584,
    accuracy: 4
  },
  {
    postalCode: 2454,
    city: "Darkwood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.4535,
    longitude: 152.5487,
    accuracy: 4
  },
  {
    postalCode: 2454,
    city: "Gleniffer",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.3885,
    longitude: 152.8871,
    accuracy: 4
  },
  {
    postalCode: 2454,
    city: "Bellingen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.4529,
    longitude: 152.8991,
    accuracy: 4
  },
  {
    postalCode: 2455,
    city: "Urunga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.497,
    longitude: 153.0142,
    accuracy: 4
  },
  {
    postalCode: 2456,
    city: "Mullaway",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.0804,
    longitude: 153.1959,
    accuracy: 4
  },
  {
    postalCode: 2456,
    city: "Emerald Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.1639,
    longitude: 153.1819,
    accuracy: 4
  },
  {
    postalCode: 2456,
    city: "Upper Corindi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.0388,
    longitude: 153.1131,
    accuracy: 4
  },
  {
    postalCode: 2456,
    city: "Corindi Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.0295,
    longitude: 153.1595,
    accuracy: 3
  },
  {
    postalCode: 2456,
    city: "Red Rock",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.9845,
    longitude: 153.2262,
    accuracy: 4
  },
  {
    postalCode: 2456,
    city: "Arrawarra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.0606,
    longitude: 153.1907,
    accuracy: 4
  },
  {
    postalCode: 2456,
    city: "Arrawarra Headland",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.0598,
    longitude: 153.2027,
    accuracy: 3
  },
  {
    postalCode: 2456,
    city: "Safety Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.0968,
    longitude: 153.1877,
    accuracy: 4
  },
  {
    postalCode: 2456,
    city: "Dirty Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.0867,
    longitude: 153.1898,
    accuracy: 3
  },
  {
    postalCode: 2456,
    city: "Woolgoolga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.1106,
    longitude: 153.2007,
    accuracy: 4
  },
  {
    postalCode: 2456,
    city: "Sandy Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.1468,
    longitude: 153.1924,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Smiths Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.4277,
    longitude: 153.378,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Halfway Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.9318,
    longitude: 153.0679,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Gurranang",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4676,
    longitude: 152.9929,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Eatonsville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6333,
    longitude: 152.8333,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Braunstone",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.8027,
    longitude: 152.9581,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Buccarumbi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.8318,
    longitude: 152.5846,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Kungala",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.9535,
    longitude: 153.0086,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Clifden",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.5667,
    longitude: 152.9167,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Lanitza",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.8868,
    longitude: 153.0017,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Whiteman Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.5833,
    longitude: 152.8833,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Banyabba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.342,
    longitude: 153.0165,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Fine Flower",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.3833,
    longitude: 152.6667,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Carrs Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6488,
    longitude: 152.9284,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Coutts Crossing",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.8262,
    longitude: 152.8916,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Tyndale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.5167,
    longitude: 153.2,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Baryulgil",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.2216,
    longitude: 152.605,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Collum Collum",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Bookram",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Waterview",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6652,
    longitude: 152.8679,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Eighteen Mile",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Brushgrove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.5663,
    longitude: 153.0785,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Jackadgery",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.5863,
    longitude: 152.5635,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Mountain View",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.41,
    longitude: 149.1625,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Fortis Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Alumy Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6485,
    longitude: 152.9512,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Grafton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6901,
    longitude: 152.9334,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Lionsville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.1919,
    longitude: 152.4907,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Lilydale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Dalmorton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.8631,
    longitude: 152.4629,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Kangaroo Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.8667,
    longitude: 152.9333,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Lower Southgate",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.55,
    longitude: 153.0833,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Great Marlow",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Seelands",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6152,
    longitude: 152.9179,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Chambigne",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7333,
    longitude: 152.7833,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "South Grafton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7076,
    longitude: 152.9263,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Grafton West",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.624,
    longitude: 152.7585,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Junction Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6411,
    longitude: 152.9249,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Copmanhurst",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.5852,
    longitude: 152.779,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Dilkoon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4985,
    longitude: 153.0012,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Levenstrath",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "South Arm",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.6888,
    longitude: 152.7396,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Bom Bom",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Ramornie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.65,
    longitude: 152.7833,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Upper Copmanhurst",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Stockyard Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Coaldale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.3943,
    longitude: 152.8089,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Cowper",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.5796,
    longitude: 153.0761,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Heifer Station",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "The Pinnacles",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Cangai",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4985,
    longitude: 152.4679,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Southgate",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.5833,
    longitude: 153.0333,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Wells Crossing",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Elland",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Clarenza",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7037,
    longitude: 153.0006,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Waterview Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6652,
    longitude: 152.8679,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Newbold",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Deep Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.3667,
    longitude: 149.8333,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Punchbowl",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Koolkhan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Washpool",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Carnham",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Trenayr",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "The Whiteman",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Wombat Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Moleville Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Mylneford",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Upper Fine Flower",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Glenugie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Dumbudgery",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Chaelundi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Kyarran",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.5808,
    longitude: 152.9743,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Pulganbar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Winegrove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.624,
    longitude: 152.7585,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Towallum",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Crowther Island",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Nymboida",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.926,
    longitude: 152.7479,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Southampton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Sandy Crossing",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Calamia",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Blaxlands Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Barcoongere",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Warragai Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Coombadjha",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Rushforth",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Malabugilmah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Barretts Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Lawrence",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4921,
    longitude: 153.0969,
    accuracy: 4
  },
  {
    postalCode: 2460,
    city: "Kremnos",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Shannondale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Carrs Island",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2460,
    city: "Carrs Peninsular",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6305,
    longitude: 152.875,
    accuracy: 3
  },
  {
    postalCode: 2462,
    city: "Wooli",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.8616,
    longitude: 153.2677,
    accuracy: 4
  },
  {
    postalCode: 2462,
    city: "Lavadia",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7667,
    longitude: 153.1,
    accuracy: 4
  },
  {
    postalCode: 2462,
    city: "Ulmarra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6313,
    longitude: 153.0299,
    accuracy: 4
  },
  {
    postalCode: 2462,
    city: "Swan Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7122,
    longitude: 153.1253,
    accuracy: 3
  },
  {
    postalCode: 2462,
    city: "Pillar Valley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7558,
    longitude: 153.1112,
    accuracy: 4
  },
  {
    postalCode: 2462,
    city: "Gilletts Ridge",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7122,
    longitude: 153.1253,
    accuracy: 3
  },
  {
    postalCode: 2462,
    city: "Minnie Water",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7759,
    longitude: 153.2973,
    accuracy: 4
  },
  {
    postalCode: 2462,
    city: "Lake Hiawatha",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7122,
    longitude: 153.1253,
    accuracy: 3
  },
  {
    postalCode: 2462,
    city: "Diggers Camp",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.8141,
    longitude: 153.2853,
    accuracy: 4
  },
  {
    postalCode: 2462,
    city: "Calliope",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7122,
    longitude: 153.1253,
    accuracy: 3
  },
  {
    postalCode: 2462,
    city: "Tucabia",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6636,
    longitude: 153.1043,
    accuracy: 4
  },
  {
    postalCode: 2462,
    city: "Coldstream",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.5833,
    longitude: 153.1333,
    accuracy: 4
  },
  {
    postalCode: 2463,
    city: "Maclean",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4581,
    longitude: 153.1975,
    accuracy: 4
  },
  {
    postalCode: 2463,
    city: "Palmers Island",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4167,
    longitude: 153.2833,
    accuracy: 4
  },
  {
    postalCode: 2463,
    city: "Townsend",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4662,
    longitude: 153.2207,
    accuracy: 4
  },
  {
    postalCode: 2463,
    city: "The Sandon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4726,
    longitude: 153.2191,
    accuracy: 3
  },
  {
    postalCode: 2463,
    city: "Shark Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.5167,
    longitude: 153.2,
    accuracy: 4
  },
  {
    postalCode: 2463,
    city: "Palmers Channel",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4726,
    longitude: 153.2191,
    accuracy: 3
  },
  {
    postalCode: 2463,
    city: "Ashby",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4318,
    longitude: 153.1929,
    accuracy: 4
  },
  {
    postalCode: 2463,
    city: "Ashby Island",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4726,
    longitude: 153.2191,
    accuracy: 3
  },
  {
    postalCode: 2463,
    city: "Gulmarrad",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.487,
    longitude: 153.2334,
    accuracy: 4
  },
  {
    postalCode: 2463,
    city: "Woodford Island",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4726,
    longitude: 153.2191,
    accuracy: 3
  },
  {
    postalCode: 2463,
    city: "Ilarwill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4818,
    longitude: 153.1846,
    accuracy: 4
  },
  {
    postalCode: 2463,
    city: "James Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4726,
    longitude: 153.2191,
    accuracy: 3
  },
  {
    postalCode: 2463,
    city: "Tullymorgan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.3735,
    longitude: 153.1179,
    accuracy: 4
  },
  {
    postalCode: 2463,
    city: "Jacky Bulbin Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4726,
    longitude: 153.2191,
    accuracy: 3
  },
  {
    postalCode: 2463,
    city: "Brooms Head",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6089,
    longitude: 153.3365,
    accuracy: 4
  },
  {
    postalCode: 2463,
    city: "Sandon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4726,
    longitude: 153.2191,
    accuracy: 3
  },
  {
    postalCode: 2463,
    city: "Taloumbi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4726,
    longitude: 153.2191,
    accuracy: 3
  },
  {
    postalCode: 2463,
    city: "Woodford",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.5433,
    longitude: 153.2368,
    accuracy: 3
  },
  {
    postalCode: 2463,
    city: "Ashby Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4726,
    longitude: 153.2191,
    accuracy: 3
  },
  {
    postalCode: 2464,
    city: "Freeburn Island",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4042,
    longitude: 153.3322,
    accuracy: 4
  },
  {
    postalCode: 2464,
    city: "Angourie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4763,
    longitude: 153.3588,
    accuracy: 4
  },
  {
    postalCode: 2464,
    city: "Micalo Island",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4927,
    longitude: 153.3425,
    accuracy: 3
  },
  {
    postalCode: 2464,
    city: "Yuraygir",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.5765,
    longitude: 153.307,
    accuracy: 4
  },
  {
    postalCode: 2464,
    city: "Yamba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4375,
    longitude: 153.3591,
    accuracy: 4
  },
  {
    postalCode: 2464,
    city: "Wooloweyah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4809,
    longitude: 153.3428,
    accuracy: 4
  },
  {
    postalCode: 2465,
    city: "Harwood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4258,
    longitude: 153.2418,
    accuracy: 4
  },
  {
    postalCode: 2466,
    city: "Woody Head",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4067,
    longitude: 153.3524,
    accuracy: 3
  },
  {
    postalCode: 2466,
    city: "Iluka",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4076,
    longitude: 153.3495,
    accuracy: 4
  },
  {
    postalCode: 2466,
    city: "The Freshwater",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4067,
    longitude: 153.3524,
    accuracy: 3
  },
  {
    postalCode: 2469,
    city: "Haystack",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0454,
    longitude: 152.8384,
    accuracy: 3
  },
  {
    postalCode: 2469,
    city: "Lower Duck Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0454,
    longitude: 152.8384,
    accuracy: 3
  },
  {
    postalCode: 2469,
    city: "Paddys Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7152,
    longitude: 152.4179,
    accuracy: 4
  },
  {
    postalCode: 2469,
    city: "Bonalbo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7371,
    longitude: 152.6239,
    accuracy: 4
  },
  {
    postalCode: 2469,
    city: "Ewingar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0454,
    longitude: 152.8384,
    accuracy: 3
  },
  {
    postalCode: 2469,
    city: "Rappville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0867,
    longitude: 152.9528,
    accuracy: 4
  },
  {
    postalCode: 2469,
    city: "Theresa Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0454,
    longitude: 152.8384,
    accuracy: 3
  },
  {
    postalCode: 2469,
    city: "Gorge Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0454,
    longitude: 152.8384,
    accuracy: 3
  },
  {
    postalCode: 2469,
    city: "Goodwood Island",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.3792,
    longitude: 153.3012,
    accuracy: 4
  },
  {
    postalCode: 2469,
    city: "Pikapene",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0454,
    longitude: 152.8384,
    accuracy: 3
  },
  {
    postalCode: 2469,
    city: "Camira",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.2538,
    longitude: 152.9636,
    accuracy: 4
  },
  {
    postalCode: 2469,
    city: "Tabulam",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8928,
    longitude: 152.5652,
    accuracy: 4
  },
  {
    postalCode: 2469,
    city: "Mallanganee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9076,
    longitude: 152.7196,
    accuracy: 4
  },
  {
    postalCode: 2469,
    city: "Chatsworth",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.3921,
    longitude: 153.2341,
    accuracy: 4
  },
  {
    postalCode: 2469,
    city: "Drake",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9283,
    longitude: 152.3723,
    accuracy: 4
  },
  {
    postalCode: 2469,
    city: "Kippenduff",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0454,
    longitude: 152.8384,
    accuracy: 3
  },
  {
    postalCode: 2469,
    city: "Old Bonalbo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.6569,
    longitude: 152.5974,
    accuracy: 4
  },
  {
    postalCode: 2469,
    city: "Pagans Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0454,
    longitude: 152.8384,
    accuracy: 3
  },
  {
    postalCode: 2469,
    city: "Bottle Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7888,
    longitude: 152.6521,
    accuracy: 4
  },
  {
    postalCode: 2469,
    city: "Duck Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0454,
    longitude: 152.8384,
    accuracy: 3
  },
  {
    postalCode: 2469,
    city: "Mummulgum",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8496,
    longitude: 152.8048,
    accuracy: 4
  },
  {
    postalCode: 2469,
    city: "Mount Marsh",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0454,
    longitude: 152.8384,
    accuracy: 3
  },
  {
    postalCode: 2469,
    city: "Alice",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0555,
    longitude: 152.5879,
    accuracy: 4
  },
  {
    postalCode: 2469,
    city: "Capeen Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0454,
    longitude: 152.8384,
    accuracy: 3
  },
  {
    postalCode: 2469,
    city: "Myrtle Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.1122,
    longitude: 152.9448,
    accuracy: 4
  },
  {
    postalCode: 2469,
    city: "Drake Village",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0454,
    longitude: 152.8384,
    accuracy: 3
  },
  {
    postalCode: 2469,
    city: "Mororo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.3333,
    longitude: 153.25,
    accuracy: 4
  },
  {
    postalCode: 2469,
    city: "Lower Bottle Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0454,
    longitude: 152.8384,
    accuracy: 3
  },
  {
    postalCode: 2469,
    city: "Whiporie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.2879,
    longitude: 152.9926,
    accuracy: 4
  },
  {
    postalCode: 2469,
    city: "Deep Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.3667,
    longitude: 149.8333,
    accuracy: 4
  },
  {
    postalCode: 2469,
    city: "Gibberagee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.2318,
    longitude: 153.1012,
    accuracy: 4
  },
  {
    postalCode: 2469,
    city: "Jacksons Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0454,
    longitude: 152.8384,
    accuracy: 3
  },
  {
    postalCode: 2469,
    city: "Clearfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.1445,
    longitude: 152.936,
    accuracy: 4
  },
  {
    postalCode: 2469,
    city: "Joes Box",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0454,
    longitude: 152.8384,
    accuracy: 3
  },
  {
    postalCode: 2469,
    city: "Six Mile Swamp",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0454,
    longitude: 152.8384,
    accuracy: 3
  },
  {
    postalCode: 2469,
    city: "Louisa Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0454,
    longitude: 152.8384,
    accuracy: 3
  },
  {
    postalCode: 2469,
    city: "Bean Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0454,
    longitude: 152.8384,
    accuracy: 3
  },
  {
    postalCode: 2469,
    city: "Keybarbin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.15,
    longitude: 152.6,
    accuracy: 4
  },
  {
    postalCode: 2469,
    city: "Tunglebung",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0454,
    longitude: 152.8384,
    accuracy: 3
  },
  {
    postalCode: 2469,
    city: "Wyan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0667,
    longitude: 152.8667,
    accuracy: 4
  },
  {
    postalCode: 2469,
    city: "Peacock Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0454,
    longitude: 152.8384,
    accuracy: 3
  },
  {
    postalCode: 2469,
    city: "Woombah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.3667,
    longitude: 153.2833,
    accuracy: 4
  },
  {
    postalCode: 2469,
    city: "Lower Peacock",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0454,
    longitude: 152.8384,
    accuracy: 3
  },
  {
    postalCode: 2469,
    city: "Bungawalbin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0333,
    longitude: 153.2833,
    accuracy: 4
  },
  {
    postalCode: 2469,
    city: "Hogarth Range",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0454,
    longitude: 152.8384,
    accuracy: 3
  },
  {
    postalCode: 2469,
    city: "Busbys Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0485,
    longitude: 152.8012,
    accuracy: 4
  },
  {
    postalCode: 2469,
    city: "Warregah Island",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0454,
    longitude: 152.8384,
    accuracy: 3
  },
  {
    postalCode: 2469,
    city: "Mookima Wybra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0454,
    longitude: 152.8384,
    accuracy: 3
  },
  {
    postalCode: 2469,
    city: "Bingeebeebra Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0454,
    longitude: 152.8384,
    accuracy: 3
  },
  {
    postalCode: 2469,
    city: "Cambridge Plateau",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0454,
    longitude: 152.8384,
    accuracy: 3
  },
  {
    postalCode: 2469,
    city: "Coongbar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0454,
    longitude: 152.8384,
    accuracy: 3
  },
  {
    postalCode: 2469,
    city: "Yabbra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0454,
    longitude: 152.8384,
    accuracy: 3
  },
  {
    postalCode: 2469,
    city: "Culmaran Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0454,
    longitude: 152.8384,
    accuracy: 3
  },
  {
    postalCode: 2469,
    city: "Sandilands",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0454,
    longitude: 152.8384,
    accuracy: 3
  },
  {
    postalCode: 2469,
    city: "Simpkins Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0454,
    longitude: 152.8384,
    accuracy: 3
  },
  {
    postalCode: 2469,
    city: "Upper Duck Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0454,
    longitude: 152.8384,
    accuracy: 3
  },
  {
    postalCode: 2469,
    city: "Bulldog",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0454,
    longitude: 152.8384,
    accuracy: 3
  },
  {
    postalCode: 2470,
    city: "Ellangowan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0333,
    longitude: 153.0667,
    accuracy: 4
  },
  {
    postalCode: 2470,
    city: "Sextonville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8492,
    longitude: 152.9372,
    accuracy: 3
  },
  {
    postalCode: 2470,
    city: "Yorklea",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9481,
    longitude: 153.0584,
    accuracy: 4
  },
  {
    postalCode: 2470,
    city: "Irvington",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8492,
    longitude: 152.9372,
    accuracy: 3
  },
  {
    postalCode: 2470,
    city: "Fairy Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7667,
    longitude: 153.0167,
    accuracy: 4
  },
  {
    postalCode: 2470,
    city: "Babyl Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8732,
    longitude: 152.9852,
    accuracy: 3
  },
  {
    postalCode: 2470,
    city: "Dobies Bight",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8016,
    longitude: 152.9368,
    accuracy: 4
  },
  {
    postalCode: 2470,
    city: "Dyraaba Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8492,
    longitude: 152.9372,
    accuracy: 3
  },
  {
    postalCode: 2470,
    city: "Shannon Brook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9167,
    longitude: 152.9667,
    accuracy: 4
  },
  {
    postalCode: 2470,
    city: "Stratheden",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7505,
    longitude: 152.9468,
    accuracy: 4
  },
  {
    postalCode: 2470,
    city: "Dyraaba Central",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7161,
    longitude: 152.8628,
    accuracy: 4
  },
  {
    postalCode: 2470,
    city: "Baraimal",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8492,
    longitude: 152.9372,
    accuracy: 3
  },
  {
    postalCode: 2470,
    city: "Spring Grove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8331,
    longitude: 153.1557,
    accuracy: 3
  },
  {
    postalCode: 2470,
    city: "Leeville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.95,
    longitude: 153,
    accuracy: 4
  },
  {
    postalCode: 2470,
    city: "Dyraaba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7161,
    longitude: 152.8628,
    accuracy: 4
  },
  {
    postalCode: 2470,
    city: "Coombell",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0157,
    longitude: 152.9732,
    accuracy: 4
  },
  {
    postalCode: 2470,
    city: "Doubtful Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7538,
    longitude: 152.9205,
    accuracy: 4
  },
  {
    postalCode: 2470,
    city: "Naughtons Gap",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8047,
    longitude: 153.089,
    accuracy: 4
  },
  {
    postalCode: 2470,
    city: "Casino",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8582,
    longitude: 153.0475,
    accuracy: 4
  },
  {
    postalCode: 2470,
    city: "Backmede",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.75,
    longitude: 153.0167,
    accuracy: 4
  },
  {
    postalCode: 2470,
    city: "Tomki",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8618,
    longitude: 153.1323,
    accuracy: 4
  },
  {
    postalCode: 2470,
    city: "Woodview",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8667,
    longitude: 152.9667,
    accuracy: 4
  },
  {
    postalCode: 2470,
    city: "Upper Mongogarie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9833,
    longitude: 152.85,
    accuracy: 4
  },
  {
    postalCode: 2470,
    city: "Lower Dyraaba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8732,
    longitude: 152.9852,
    accuracy: 3
  },
  {
    postalCode: 2470,
    city: "Woolners Arm",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.6849,
    longitude: 152.8415,
    accuracy: 4
  },
  {
    postalCode: 2470,
    city: "North Casino",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8732,
    longitude: 152.9852,
    accuracy: 3
  },
  {
    postalCode: 2470,
    city: "Piora",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8549,
    longitude: 152.8879,
    accuracy: 4
  },
  {
    postalCode: 2470,
    city: "Mongogarie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.95,
    longitude: 152.9333,
    accuracy: 4
  },
  {
    postalCode: 2471,
    city: "Codrington",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9494,
    longitude: 153.2418,
    accuracy: 4
  },
  {
    postalCode: 2471,
    city: "Bora Ridge",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9775,
    longitude: 153.2497,
    accuracy: 3
  },
  {
    postalCode: 2471,
    city: "Tatham",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9282,
    longitude: 153.1552,
    accuracy: 4
  },
  {
    postalCode: 2471,
    city: "Coraki",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9933,
    longitude: 153.2821,
    accuracy: 4
  },
  {
    postalCode: 2471,
    city: "North Woodburn",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9775,
    longitude: 153.2497,
    accuracy: 3
  },
  {
    postalCode: 2471,
    city: "Swan Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.05,
    longitude: 153.3167,
    accuracy: 4
  },
  {
    postalCode: 2471,
    city: "Greenridge",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9775,
    longitude: 153.2497,
    accuracy: 3
  },
  {
    postalCode: 2471,
    city: "East Coraki",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9775,
    longitude: 153.2497,
    accuracy: 3
  },
  {
    postalCode: 2471,
    city: "West Coraki",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9775,
    longitude: 153.2497,
    accuracy: 3
  },
  {
    postalCode: 2471,
    city: "West Bungawalbin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9775,
    longitude: 153.2497,
    accuracy: 3
  },
  {
    postalCode: 2471,
    city: "Green Forest",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9775,
    longitude: 153.2497,
    accuracy: 3
  },
  {
    postalCode: 2472,
    city: "Rileys Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0167,
    longitude: 153.4,
    accuracy: 4
  },
  {
    postalCode: 2472,
    city: "Broadwater",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0111,
    longitude: 153.4356,
    accuracy: 4
  },
  {
    postalCode: 2472,
    city: "Buckendoon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0485,
    longitude: 153.3512,
    accuracy: 4
  },
  {
    postalCode: 2472,
    city: "Esk",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0832,
    longitude: 153.3442,
    accuracy: 3
  },
  {
    postalCode: 2472,
    city: "Woodburn",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0716,
    longitude: 153.3461,
    accuracy: 4
  },
  {
    postalCode: 2472,
    city: "Tabbimoble",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.1985,
    longitude: 153.2679,
    accuracy: 4
  },
  {
    postalCode: 2472,
    city: "New Italy",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.1318,
    longitude: 153.2679,
    accuracy: 4
  },
  {
    postalCode: 2472,
    city: "Trustums Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0832,
    longitude: 153.3442,
    accuracy: 3
  },
  {
    postalCode: 2472,
    city: "The Gap",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0832,
    longitude: 153.3442,
    accuracy: 3
  },
  {
    postalCode: 2472,
    city: "Kilgin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0832,
    longitude: 153.3442,
    accuracy: 3
  },
  {
    postalCode: 2472,
    city: "Moonem",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0832,
    longitude: 153.3442,
    accuracy: 3
  },
  {
    postalCode: 2473,
    city: "Evans Head",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.1178,
    longitude: 153.4307,
    accuracy: 4
  },
  {
    postalCode: 2473,
    city: "South Evans Head",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.1178,
    longitude: 153.4307,
    accuracy: 4
  },
  {
    postalCode: 2473,
    city: "Bundjalung",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.1178,
    longitude: 153.4307,
    accuracy: 3
  },
  {
    postalCode: 2473,
    city: "Iron Gates",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.1178,
    longitude: 153.4307,
    accuracy: 3
  },
  {
    postalCode: 2473,
    city: "Doonbah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.1178,
    longitude: 153.4307,
    accuracy: 3
  },
  {
    postalCode: 2474,
    city: "Cawongla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.6013,
    longitude: 153.0974,
    accuracy: 4
  },
  {
    postalCode: 2474,
    city: "Findon Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.536,
    longitude: 152.9961,
    accuracy: 3
  },
  {
    postalCode: 2474,
    city: "Loadstone",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3907,
    longitude: 152.9904,
    accuracy: 4
  },
  {
    postalCode: 2474,
    city: "Rukenvale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.4787,
    longitude: 152.9119,
    accuracy: 3
  },
  {
    postalCode: 2474,
    city: "Green Pigeon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.4806,
    longitude: 153.0856,
    accuracy: 4
  },
  {
    postalCode: 2474,
    city: "Roseberry Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.536,
    longitude: 152.9961,
    accuracy: 3
  },
  {
    postalCode: 2474,
    city: "Cedar Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.6843,
    longitude: 153.0021,
    accuracy: 4
  },
  {
    postalCode: 2474,
    city: "Sawpit Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.536,
    longitude: 152.9961,
    accuracy: 3
  },
  {
    postalCode: 2474,
    city: "Horseshoe Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.5352,
    longitude: 153.0376,
    accuracy: 4
  },
  {
    postalCode: 2474,
    city: "Border Ranges",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.536,
    longitude: 152.9961,
    accuracy: 3
  },
  {
    postalCode: 2474,
    city: "Barkers Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.5366,
    longitude: 153.1207,
    accuracy: 4
  },
  {
    postalCode: 2474,
    city: "Eden Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.536,
    longitude: 152.9961,
    accuracy: 3
  },
  {
    postalCode: 2474,
    city: "Roseberry",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.4888,
    longitude: 152.909,
    accuracy: 4
  },
  {
    postalCode: 2474,
    city: "Upper Eden Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.536,
    longitude: 152.9961,
    accuracy: 3
  },
  {
    postalCode: 2474,
    city: "Wadeville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.5607,
    longitude: 153.1354,
    accuracy: 4
  },
  {
    postalCode: 2474,
    city: "Kilgra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.536,
    longitude: 152.9961,
    accuracy: 3
  },
  {
    postalCode: 2474,
    city: "Homeleigh",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.5685,
    longitude: 153.0643,
    accuracy: 4
  },
  {
    postalCode: 2474,
    city: "Kyogle",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.6208,
    longitude: 153.0048,
    accuracy: 4
  },
  {
    postalCode: 2474,
    city: "The Risk",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.4825,
    longitude: 152.9398,
    accuracy: 4
  },
  {
    postalCode: 2474,
    city: "Edenville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.536,
    longitude: 152.9961,
    accuracy: 3
  },
  {
    postalCode: 2474,
    city: "Upper Horseshoe Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.5387,
    longitude: 153.0651,
    accuracy: 4
  },
  {
    postalCode: 2474,
    city: "Wiangaree",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.5148,
    longitude: 152.961,
    accuracy: 4
  },
  {
    postalCode: 2474,
    city: "Afterlee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.5741,
    longitude: 152.8287,
    accuracy: 4
  },
  {
    postalCode: 2474,
    city: "Toonumbar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.5807,
    longitude: 152.7629,
    accuracy: 4
  },
  {
    postalCode: 2474,
    city: "Sherwood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0649,
    longitude: 152.7288,
    accuracy: 4
  },
  {
    postalCode: 2474,
    city: "Gradys Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.536,
    longitude: 152.9961,
    accuracy: 3
  },
  {
    postalCode: 2474,
    city: "Cougal",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3667,
    longitude: 152.9667,
    accuracy: 4
  },
  {
    postalCode: 2474,
    city: "Wyneden",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.536,
    longitude: 152.9961,
    accuracy: 3
  },
  {
    postalCode: 2474,
    city: "Geneva",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.6219,
    longitude: 152.989,
    accuracy: 4
  },
  {
    postalCode: 2474,
    city: "Ettrick",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.6637,
    longitude: 152.9125,
    accuracy: 4
  },
  {
    postalCode: 2474,
    city: "Dairy Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.536,
    longitude: 152.9961,
    accuracy: 3
  },
  {
    postalCode: 2474,
    city: "New Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.536,
    longitude: 152.9961,
    accuracy: 3
  },
  {
    postalCode: 2474,
    city: "Smiths Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.4277,
    longitude: 153.378,
    accuracy: 4
  },
  {
    postalCode: 2474,
    city: "Little Back Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.536,
    longitude: 152.9961,
    accuracy: 3
  },
  {
    postalCode: 2474,
    city: "West Wiangaree",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.536,
    longitude: 152.9961,
    accuracy: 3
  },
  {
    postalCode: 2474,
    city: "Grevillia",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.4431,
    longitude: 152.8332,
    accuracy: 4
  },
  {
    postalCode: 2474,
    city: "Warrazambil Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.536,
    longitude: 152.9961,
    accuracy: 3
  },
  {
    postalCode: 2474,
    city: "Fawcetts Plain",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.536,
    longitude: 152.9961,
    accuracy: 3
  },
  {
    postalCode: 2474,
    city: "Unumgar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.4096,
    longitude: 152.7429,
    accuracy: 4
  },
  {
    postalCode: 2474,
    city: "Iron Pot Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.536,
    longitude: 152.9961,
    accuracy: 3
  },
  {
    postalCode: 2474,
    city: "Ghinni Ghi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.536,
    longitude: 152.9961,
    accuracy: 3
  },
  {
    postalCode: 2474,
    city: "Horse Station Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.536,
    longitude: 152.9961,
    accuracy: 3
  },
  {
    postalCode: 2474,
    city: "Terrace Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.536,
    longitude: 152.9961,
    accuracy: 3
  },
  {
    postalCode: 2474,
    city: "Lynchs Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.45,
    longitude: 153,
    accuracy: 4
  },
  {
    postalCode: 2474,
    city: "Old Grevillia",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.536,
    longitude: 152.9961,
    accuracy: 3
  },
  {
    postalCode: 2474,
    city: "Collins Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.536,
    longitude: 152.9961,
    accuracy: 3
  },
  {
    postalCode: 2475,
    city: "Upper Tooloom",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.545,
    longitude: 152.483,
    accuracy: 3
  },
  {
    postalCode: 2475,
    city: "Tooloom",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.6167,
    longitude: 152.4167,
    accuracy: 4
  },
  {
    postalCode: 2475,
    city: "Urbenville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.4732,
    longitude: 152.5494,
    accuracy: 4
  },
  {
    postalCode: 2476,
    city: "Koreelah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.4799,
    longitude: 152.3275,
    accuracy: 4
  },
  {
    postalCode: 2476,
    city: "Old Koreelah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.4,
    longitude: 152.4167,
    accuracy: 4
  },
  {
    postalCode: 2476,
    city: "Legume",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.4081,
    longitude: 152.3095,
    accuracy: 4
  },
  {
    postalCode: 2476,
    city: "Muli Muli",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.4182,
    longitude: 152.5834,
    accuracy: 4
  },
  {
    postalCode: 2476,
    city: "The Glen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1145,
    longitude: 148.2097,
    accuracy: 3
  },
  {
    postalCode: 2476,
    city: "Lindesay Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.4177,
    longitude: 152.3993,
    accuracy: 3
  },
  {
    postalCode: 2476,
    city: "Acacia Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3652,
    longitude: 152.3179,
    accuracy: 4
  },
  {
    postalCode: 2476,
    city: "Acacia Plateau",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.4516,
    longitude: 152.3925,
    accuracy: 3
  },
  {
    postalCode: 2476,
    city: "Lower Acacia Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.4318,
    longitude: 152.2346,
    accuracy: 4
  },
  {
    postalCode: 2476,
    city: "Brumby Plains",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.4177,
    longitude: 152.3993,
    accuracy: 3
  },
  {
    postalCode: 2476,
    city: "Woodenbong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3892,
    longitude: 152.6115,
    accuracy: 4
  },
  {
    postalCode: 2476,
    city: "Boomi Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.4177,
    longitude: 152.3993,
    accuracy: 3
  },
  {
    postalCode: 2477,
    city: "Lynwood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.872,
    longitude: 153.4425,
    accuracy: 4
  },
  {
    postalCode: 2477,
    city: "Wardell",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9489,
    longitude: 153.4651,
    accuracy: 4
  },
  {
    postalCode: 2477,
    city: "Rous",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8764,
    longitude: 153.3918,
    accuracy: 4
  },
  {
    postalCode: 2477,
    city: "Alstonvale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8949,
    longitude: 153.4304,
    accuracy: 3
  },
  {
    postalCode: 2477,
    city: "Rous Mill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8764,
    longitude: 153.3918,
    accuracy: 4
  },
  {
    postalCode: 2477,
    city: "Tuckombil",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8143,
    longitude: 153.468,
    accuracy: 4
  },
  {
    postalCode: 2477,
    city: "Bagotville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9828,
    longitude: 153.4212,
    accuracy: 4
  },
  {
    postalCode: 2477,
    city: "Pearces Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8949,
    longitude: 153.4304,
    accuracy: 3
  },
  {
    postalCode: 2477,
    city: "Meerschaum Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9167,
    longitude: 153.4333,
    accuracy: 4
  },
  {
    postalCode: 2477,
    city: "Cabbage Tree Island",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9804,
    longitude: 153.4567,
    accuracy: 4
  },
  {
    postalCode: 2477,
    city: "East Wardell",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8949,
    longitude: 153.4304,
    accuracy: 3
  },
  {
    postalCode: 2477,
    city: "Wollongbar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8251,
    longitude: 153.4148,
    accuracy: 4
  },
  {
    postalCode: 2477,
    city: "Goat Island",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8949,
    longitude: 153.4304,
    accuracy: 3
  },
  {
    postalCode: 2477,
    city: "Alstonville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8419,
    longitude: 153.4402,
    accuracy: 4
  },
  {
    postalCode: 2477,
    city: "Dalwood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8923,
    longitude: 153.4314,
    accuracy: 3
  },
  {
    postalCode: 2477,
    city: "Uralba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8736,
    longitude: 153.4713,
    accuracy: 3
  },
  {
    postalCode: 2478,
    city: "Empire Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9163,
    longitude: 153.5135,
    accuracy: 4
  },
  {
    postalCode: 2478,
    city: "East Ballina",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8667,
    longitude: 153.5833,
    accuracy: 4
  },
  {
    postalCode: 2478,
    city: "Ballina",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8641,
    longitude: 153.5654,
    accuracy: 4
  },
  {
    postalCode: 2478,
    city: "South Ballina",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8555,
    longitude: 153.5391,
    accuracy: 3
  },
  {
    postalCode: 2478,
    city: "Cumbalum",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8167,
    longitude: 153.5333,
    accuracy: 4
  },
  {
    postalCode: 2478,
    city: "Patchs Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8555,
    longitude: 153.5391,
    accuracy: 3
  },
  {
    postalCode: 2478,
    city: "Lennox Head",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7931,
    longitude: 153.5939,
    accuracy: 4
  },
  {
    postalCode: 2478,
    city: "Pimlico Island",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8555,
    longitude: 153.5391,
    accuracy: 3
  },
  {
    postalCode: 2478,
    city: "Pimlico",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9152,
    longitude: 153.4846,
    accuracy: 4
  },
  {
    postalCode: 2478,
    city: "Keith Hall",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8763,
    longitude: 153.5346,
    accuracy: 4
  },
  {
    postalCode: 2478,
    city: "Skennars Head",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8555,
    longitude: 153.5391,
    accuracy: 3
  },
  {
    postalCode: 2478,
    city: "Tintenbar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8,
    longitude: 153.5167,
    accuracy: 4
  },
  {
    postalCode: 2478,
    city: "Coolgardie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8555,
    longitude: 153.5391,
    accuracy: 3
  },
  {
    postalCode: 2478,
    city: "West Ballina",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8641,
    longitude: 153.5654,
    accuracy: 4
  },
  {
    postalCode: 2478,
    city: "Teven",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8167,
    longitude: 153.5,
    accuracy: 4
  },
  {
    postalCode: 2479,
    city: "Bangalow",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.6867,
    longitude: 153.5239,
    accuracy: 4
  },
  {
    postalCode: 2479,
    city: "Brooklet",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7465,
    longitude: 153.5087,
    accuracy: 4
  },
  {
    postalCode: 2479,
    city: "Binna Burra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7,
    longitude: 153.5,
    accuracy: 4
  },
  {
    postalCode: 2479,
    city: "Knockrow",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7667,
    longitude: 153.5333,
    accuracy: 4
  },
  {
    postalCode: 2479,
    city: "Coopers Shoot",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.6833,
    longitude: 153.5833,
    accuracy: 4
  },
  {
    postalCode: 2479,
    city: "Coorabell",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.6333,
    longitude: 153.4833,
    accuracy: 4
  },
  {
    postalCode: 2479,
    city: "Newrybar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7167,
    longitude: 153.5333,
    accuracy: 4
  },
  {
    postalCode: 2479,
    city: "Mcleods Shoot",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7133,
    longitude: 153.5156,
    accuracy: 3
  },
  {
    postalCode: 2479,
    city: "Nashua",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7286,
    longitude: 153.4646,
    accuracy: 4
  },
  {
    postalCode: 2479,
    city: "Possum Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7133,
    longitude: 153.5156,
    accuracy: 3
  },
  {
    postalCode: 2479,
    city: "Fernleigh",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7667,
    longitude: 153.5,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Tucki Tucki",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9333,
    longitude: 153.3167,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Marom Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9041,
    longitude: 153.3699,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "East Lismore",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8193,
    longitude: 153.2874,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Mcleans Ridges",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8,
    longitude: 153.3833,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Lismore",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8135,
    longitude: 153.2773,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Bentley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7667,
    longitude: 153.1167,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "South Gundurimba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.85,
    longitude: 153.2667,
    accuracy: 3
  },
  {
    postalCode: 2480,
    city: "Blue Knob",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.5,
    longitude: 153.1833,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Blakebrook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7667,
    longitude: 153.2333,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Eltham",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7596,
    longitude: 153.4084,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Rosebank",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.6667,
    longitude: 153.4,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Goonellabah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8167,
    longitude: 153.3167,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Bexhill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7667,
    longitude: 153.35,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Clovass",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8667,
    longitude: 153.15,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "South Lismore",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7522,
    longitude: 153.2836,
    accuracy: 3
  },
  {
    postalCode: 2480,
    city: "The Channon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.6667,
    longitude: 153.2833,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Tregeagle",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.85,
    longitude: 153.3667,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Jiggi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.677,
    longitude: 153.1843,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Chilcotts Grass",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7522,
    longitude: 153.2836,
    accuracy: 3
  },
  {
    postalCode: 2480,
    city: "Nimbin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.5973,
    longitude: 153.2225,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Modanville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7219,
    longitude: 153.2956,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Fernside",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7818,
    longitude: 153.1679,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Keerrong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7522,
    longitude: 153.2836,
    accuracy: 3
  },
  {
    postalCode: 2480,
    city: "Bungabbee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7828,
    longitude: 153.1472,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Wyrallah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9,
    longitude: 153.3,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Koonorigan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.6833,
    longitude: 153.2333,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Lismore Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7522,
    longitude: 153.2836,
    accuracy: 3
  },
  {
    postalCode: 2480,
    city: "Booyong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7484,
    longitude: 153.4494,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Eureka",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.6818,
    longitude: 153.4346,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Lillian Rock",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.5349,
    longitude: 153.1585,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Repentance Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7522,
    longitude: 153.2836,
    accuracy: 3
  },
  {
    postalCode: 2480,
    city: "Goolmangar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.75,
    longitude: 153.2167,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Tuncester",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8,
    longitude: 153.2167,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Whian Whian",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.6396,
    longitude: 153.3145,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Dorroughby",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.6667,
    longitude: 153.35,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Rock Valley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7485,
    longitude: 153.1679,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Corndale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.6985,
    longitude: 153.3679,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Tullera",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7652,
    longitude: 153.3012,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Clunes",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7281,
    longitude: 153.4075,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "North Lismore",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.788,
    longitude: 153.2772,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Caniaba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8302,
    longitude: 153.2036,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Numulgi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7485,
    longitude: 153.3346,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Richmond Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7221,
    longitude: 153.2565,
    accuracy: 3
  },
  {
    postalCode: 2480,
    city: "Larnook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.6516,
    longitude: 153.1108,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Coffee Camp",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.6569,
    longitude: 153.2281,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Leycester",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7833,
    longitude: 153.2,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Stony Chute",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7522,
    longitude: 153.2836,
    accuracy: 3
  },
  {
    postalCode: 2480,
    city: "Monaltrie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8521,
    longitude: 153.2906,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Nightcap",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7522,
    longitude: 153.2836,
    accuracy: 3
  },
  {
    postalCode: 2480,
    city: "Girards Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8177,
    longitude: 153.2787,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Mountain Top",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7522,
    longitude: 153.2836,
    accuracy: 3
  },
  {
    postalCode: 2480,
    city: "Federal",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.6485,
    longitude: 153.4512,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Tuntable Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7522,
    longitude: 153.2836,
    accuracy: 3
  },
  {
    postalCode: 2480,
    city: "Georgica",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.6606,
    longitude: 153.1724,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Booerie Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7522,
    longitude: 153.2836,
    accuracy: 3
  },
  {
    postalCode: 2480,
    city: "Dungarubba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9833,
    longitude: 153.3833,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Boorabee Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7522,
    longitude: 153.2836,
    accuracy: 3
  },
  {
    postalCode: 2480,
    city: "Mckees Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.8833,
    longitude: 153.2,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Terania Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7522,
    longitude: 153.2836,
    accuracy: 3
  },
  {
    postalCode: 2480,
    city: "Ruthven",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9333,
    longitude: 153.2833,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Lindendale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7522,
    longitude: 153.2836,
    accuracy: 3
  },
  {
    postalCode: 2480,
    city: "Dunoon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.6823,
    longitude: 153.3175,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Loftville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7522,
    longitude: 153.2836,
    accuracy: 3
  },
  {
    postalCode: 2480,
    city: "Tuckurimba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9667,
    longitude: 153.3167,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Howards Grass",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7522,
    longitude: 153.2836,
    accuracy: 3
  },
  {
    postalCode: 2480,
    city: "Boat Harbour",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3167,
    longitude: 153.35,
    accuracy: 4
  },
  {
    postalCode: 2480,
    city: "Lagoon Grass",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7522,
    longitude: 153.2836,
    accuracy: 3
  },
  {
    postalCode: 2480,
    city: "Woodlawn",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7522,
    longitude: 153.2836,
    accuracy: 3
  },
  {
    postalCode: 2481,
    city: "Hayters Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.6309,
    longitude: 153.5669,
    accuracy: 3
  },
  {
    postalCode: 2481,
    city: "Broken Head",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7172,
    longitude: 153.5923,
    accuracy: 3
  },
  {
    postalCode: 2481,
    city: "Suffolk Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.6881,
    longitude: 153.6098,
    accuracy: 4
  },
  {
    postalCode: 2481,
    city: "Talofa",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.6309,
    longitude: 153.5669,
    accuracy: 3
  },
  {
    postalCode: 2481,
    city: "Ewingsdale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.6333,
    longitude: 153.55,
    accuracy: 4
  },
  {
    postalCode: 2481,
    city: "Tyagarah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.6,
    longitude: 153.55,
    accuracy: 4
  },
  {
    postalCode: 2481,
    city: "Byron Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.642,
    longitude: 153.6119,
    accuracy: 4
  },
  {
    postalCode: 2481,
    city: "Skinners Shoot",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.6309,
    longitude: 153.5669,
    accuracy: 3
  },
  {
    postalCode: 2481,
    city: "Myocum",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.596,
    longitude: 153.5061,
    accuracy: 4
  },
  {
    postalCode: 2482,
    city: "Upper Wilsons Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.5657,
    longitude: 153.4396,
    accuracy: 3
  },
  {
    postalCode: 2482,
    city: "Main Arm",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.5657,
    longitude: 153.4396,
    accuracy: 3
  },
  {
    postalCode: 2482,
    city: "Upper Coopers Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.5657,
    longitude: 153.4396,
    accuracy: 3
  },
  {
    postalCode: 2482,
    city: "Goonengerry",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.6107,
    longitude: 153.44,
    accuracy: 4
  },
  {
    postalCode: 2482,
    city: "Montecollum",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.5657,
    longitude: 153.4396,
    accuracy: 3
  },
  {
    postalCode: 2482,
    city: "Huonbrook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.5485,
    longitude: 153.3846,
    accuracy: 4
  },
  {
    postalCode: 2482,
    city: "Mullumbimby",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.5524,
    longitude: 153.4996,
    accuracy: 4
  },
  {
    postalCode: 2482,
    city: "Mullumbimby Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.5657,
    longitude: 153.4396,
    accuracy: 3
  },
  {
    postalCode: 2482,
    city: "Upper Main Arm",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.5657,
    longitude: 153.4396,
    accuracy: 3
  },
  {
    postalCode: 2482,
    city: "Koonyum Range",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.5657,
    longitude: 153.4396,
    accuracy: 3
  },
  {
    postalCode: 2482,
    city: "Wanganui",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.5657,
    longitude: 153.4396,
    accuracy: 3
  },
  {
    postalCode: 2482,
    city: "Palmwoods",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.5657,
    longitude: 153.4396,
    accuracy: 3
  },
  {
    postalCode: 2482,
    city: "Wilsons Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.5606,
    longitude: 153.4255,
    accuracy: 4
  },
  {
    postalCode: 2483,
    city: "Sleepy Hollow",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.4177,
    longitude: 153.5198,
    accuracy: 4
  },
  {
    postalCode: 2483,
    city: "Middle Pocket",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.4833,
    longitude: 153.5111,
    accuracy: 3
  },
  {
    postalCode: 2483,
    city: "Crabbes Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.461,
    longitude: 153.4823,
    accuracy: 4
  },
  {
    postalCode: 2483,
    city: "Burringbar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.4358,
    longitude: 153.4732,
    accuracy: 4
  },
  {
    postalCode: 2483,
    city: "Upper Burringbar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.45,
    longitude: 153.45,
    accuracy: 4
  },
  {
    postalCode: 2483,
    city: "Wooyung",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.4833,
    longitude: 153.5111,
    accuracy: 3
  },
  {
    postalCode: 2483,
    city: "Ocean Shores",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.5093,
    longitude: 153.5376,
    accuracy: 4
  },
  {
    postalCode: 2483,
    city: "Mooball",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.45,
    longitude: 153.4833,
    accuracy: 4
  },
  {
    postalCode: 2483,
    city: "Yelgun",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.48,
    longitude: 153.4949,
    accuracy: 4
  },
  {
    postalCode: 2483,
    city: "The Pocket",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.5167,
    longitude: 153.4833,
    accuracy: 4
  },
  {
    postalCode: 2483,
    city: "Brunswick Heads",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.5415,
    longitude: 153.5481,
    accuracy: 4
  },
  {
    postalCode: 2483,
    city: "New Brighton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.5123,
    longitude: 153.5491,
    accuracy: 4
  },
  {
    postalCode: 2483,
    city: "Billinudgel",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.5,
    longitude: 153.5333,
    accuracy: 4
  },
  {
    postalCode: 2483,
    city: "South Golden Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.498,
    longitude: 153.547,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Dum Dum",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3833,
    longitude: 153.3333,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Condong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3188,
    longitude: 153.4378,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Pumpenbil",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3784,
    longitude: 153.1461,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Kielvale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3333,
    longitude: 153.4338,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Chillingham",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3135,
    longitude: 153.2752,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Crystal Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3143,
    longitude: 153.3151,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Reserve Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3503,
    longitude: 153.4924,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Murwillumbah South",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3273,
    longitude: 153.3934,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Murwillumbah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3273,
    longitude: 153.3934,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Kunghur",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.4714,
    longitude: 153.252,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Terragon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.4355,
    longitude: 153.263,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Mebbin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3665,
    longitude: 153.3497,
    accuracy: 3
  },
  {
    postalCode: 2484,
    city: "Round Mountain",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3549,
    longitude: 153.5443,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Fernvale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3652,
    longitude: 153.419,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Dunbible",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3884,
    longitude: 153.4205,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Uki",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.4141,
    longitude: 153.3366,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Dungay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.2724,
    longitude: 153.3585,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Mount Burrell",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.5,
    longitude: 153.2167,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Clothiers Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3302,
    longitude: 153.496,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Rowlands Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3665,
    longitude: 153.3497,
    accuracy: 3
  },
  {
    postalCode: 2484,
    city: "Zara",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3163,
    longitude: 153.2585,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Dulguigan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3665,
    longitude: 153.3497,
    accuracy: 3
  },
  {
    postalCode: 2484,
    city: "Cudgera Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3833,
    longitude: 153.5167,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Tyalgum Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3665,
    longitude: 153.3497,
    accuracy: 3
  },
  {
    postalCode: 2484,
    city: "Limpinwood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3076,
    longitude: 153.2173,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Doon Doon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.5167,
    longitude: 153.3,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Stokers Siding",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.4085,
    longitude: 153.4143,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Farrants Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3665,
    longitude: 153.3497,
    accuracy: 3
  },
  {
    postalCode: 2484,
    city: "Eungella",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3534,
    longitude: 153.3161,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Urliup",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3665,
    longitude: 153.3497,
    accuracy: 3
  },
  {
    postalCode: 2484,
    city: "Tomewin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.2446,
    longitude: 153.3779,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Chowan Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3665,
    longitude: 153.3497,
    accuracy: 3
  },
  {
    postalCode: 2484,
    city: "Nobbys Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.2943,
    longitude: 153.3376,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Smiths Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.4277,
    longitude: 153.378,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Commissioners Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.4985,
    longitude: 153.3321,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Hopkins Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3665,
    longitude: 153.3497,
    accuracy: 3
  },
  {
    postalCode: 2484,
    city: "Byangum",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.35,
    longitude: 153.3667,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "North Arm",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3665,
    longitude: 153.3497,
    accuracy: 3
  },
  {
    postalCode: 2484,
    city: "South Murwillumbah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3273,
    longitude: 153.3934,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Back Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3665,
    longitude: 153.3497,
    accuracy: 3
  },
  {
    postalCode: 2484,
    city: "Palmvale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3667,
    longitude: 153.4833,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Kunghur Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3665,
    longitude: 153.3497,
    accuracy: 3
  },
  {
    postalCode: 2484,
    city: "Numinbah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.2833,
    longitude: 153.25,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Cedar Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3665,
    longitude: 153.3497,
    accuracy: 3
  },
  {
    postalCode: 2484,
    city: "Eviron",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3665,
    longitude: 153.3497,
    accuracy: 3
  },
  {
    postalCode: 2484,
    city: "Byrrill Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3665,
    longitude: 153.3497,
    accuracy: 3
  },
  {
    postalCode: 2484,
    city: "Upper Crystal Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.2997,
    longitude: 153.3014,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Mount Warning",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3665,
    longitude: 153.3497,
    accuracy: 3
  },
  {
    postalCode: 2484,
    city: "Bray Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3414,
    longitude: 153.3761,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Kynnumboon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3665,
    longitude: 153.3497,
    accuracy: 3
  },
  {
    postalCode: 2484,
    city: "Nunderi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3221,
    longitude: 153.4597,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Tygalgah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3665,
    longitude: 153.3497,
    accuracy: 3
  },
  {
    postalCode: 2484,
    city: "Brays Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.4,
    longitude: 153.2,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Wardrop Valley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3665,
    longitude: 153.3497,
    accuracy: 3
  },
  {
    postalCode: 2484,
    city: "Midginbil",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.4971,
    longitude: 153.2596,
    accuracy: 4
  },
  {
    postalCode: 2484,
    city: "Tyalgum",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3567,
    longitude: 153.2058,
    accuracy: 4
  },
  {
    postalCode: 2485,
    city: "Tweed Heads West",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.1874,
    longitude: 153.5228,
    accuracy: 4
  },
  {
    postalCode: 2485,
    city: "Tweed Heads",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.1756,
    longitude: 153.542,
    accuracy: 4
  },
  {
    postalCode: 2486,
    city: "Piggabeen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.1909,
    longitude: 153.4504,
    accuracy: 4
  },
  {
    postalCode: 2486,
    city: "Carool",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.2333,
    longitude: 153.4167,
    accuracy: 4
  },
  {
    postalCode: 2486,
    city: "Bilambil Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.2161,
    longitude: 153.4841,
    accuracy: 4
  },
  {
    postalCode: 2486,
    city: "Tweed Heads South",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.1756,
    longitude: 153.542,
    accuracy: 3
  },
  {
    postalCode: 2486,
    city: "Cobaki",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.1985,
    longitude: 153.4644,
    accuracy: 4
  },
  {
    postalCode: 2486,
    city: "Banora Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.213,
    longitude: 153.5363,
    accuracy: 4
  },
  {
    postalCode: 2486,
    city: "Upper Duroby",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.2621,
    longitude: 153.4718,
    accuracy: 4
  },
  {
    postalCode: 2486,
    city: "Glengarrie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.2173,
    longitude: 153.4848,
    accuracy: 3
  },
  {
    postalCode: 2486,
    city: "Duroby",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.2621,
    longitude: 153.4718,
    accuracy: 4
  },
  {
    postalCode: 2486,
    city: "Terranora",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.2383,
    longitude: 153.5008,
    accuracy: 4
  },
  {
    postalCode: 2486,
    city: "Bilambil",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.2266,
    longitude: 153.4676,
    accuracy: 4
  },
  {
    postalCode: 2486,
    city: "Cobaki Lakes",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.2173,
    longitude: 153.4848,
    accuracy: 3
  },
  {
    postalCode: 2486,
    city: "Bungalora",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.2173,
    longitude: 153.4848,
    accuracy: 3
  },
  {
    postalCode: 2487,
    city: "Duranbah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3167,
    longitude: 153.5333,
    accuracy: 4
  },
  {
    postalCode: 2487,
    city: "Cudgen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.2667,
    longitude: 153.55,
    accuracy: 4
  },
  {
    postalCode: 2487,
    city: "Kingscliff",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.2598,
    longitude: 153.5782,
    accuracy: 4
  },
  {
    postalCode: 2487,
    city: "Kings Forest",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.2646,
    longitude: 153.5474,
    accuracy: 3
  },
  {
    postalCode: 2487,
    city: "Fingal Head",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.2018,
    longitude: 153.5652,
    accuracy: 4
  },
  {
    postalCode: 2487,
    city: "Casuarina",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3004,
    longitude: 153.5706,
    accuracy: 4
  },
  {
    postalCode: 2487,
    city: "Stotts Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.2821,
    longitude: 153.509,
    accuracy: 4
  },
  {
    postalCode: 2487,
    city: "Chinderah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.2333,
    longitude: 153.55,
    accuracy: 4
  },
  {
    postalCode: 2488,
    city: "Bogangar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3294,
    longitude: 153.5686,
    accuracy: 4
  },
  {
    postalCode: 2488,
    city: "Tanglewood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3376,
    longitude: 153.5335,
    accuracy: 4
  },
  {
    postalCode: 2488,
    city: "Cabarita Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3336,
    longitude: 153.5666,
    accuracy: 4
  },
  {
    postalCode: 2489,
    city: "Pottsville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3885,
    longitude: 153.5656,
    accuracy: 4
  },
  {
    postalCode: 2489,
    city: "Pottsville Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3885,
    longitude: 153.5656,
    accuracy: 4
  },
  {
    postalCode: 2489,
    city: "Hastings Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.3641,
    longitude: 153.5748,
    accuracy: 4
  },
  {
    postalCode: 2490,
    city: "North Tumbulgum",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.2621,
    longitude: 153.4718,
    accuracy: 4
  },
  {
    postalCode: 2490,
    city: "Tumbulgum",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.2752,
    longitude: 153.4628,
    accuracy: 4
  },
  {
    postalCode: 2500,
    city: "Wollongong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.424,
    longitude: 150.8934,
    accuracy: 4
  },
  {
    postalCode: 2500,
    city: "Wollongong DC",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4295,
    longitude: 150.8756,
    accuracy: 3
  },
  {
    postalCode: 2500,
    city: "Keiraville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4167,
    longitude: 150.8667,
    accuracy: 4
  },
  {
    postalCode: 2500,
    city: "Mount Keira",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4189,
    longitude: 150.8542,
    accuracy: 4
  },
  {
    postalCode: 2500,
    city: "Gwynneville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4167,
    longitude: 150.8875,
    accuracy: 4
  },
  {
    postalCode: 2500,
    city: "Wollongong West",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4248,
    longitude: 150.8642,
    accuracy: 4
  },
  {
    postalCode: 2500,
    city: "Mangerton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4367,
    longitude: 150.8717,
    accuracy: 4
  },
  {
    postalCode: 2500,
    city: "Spring Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3988,
    longitude: 149.1525,
    accuracy: 4
  },
  {
    postalCode: 2500,
    city: "North Wollongong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4151,
    longitude: 150.8986,
    accuracy: 4
  },
  {
    postalCode: 2500,
    city: "Coniston",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.45,
    longitude: 150.8833,
    accuracy: 4
  },
  {
    postalCode: 2500,
    city: "Mount Saint Thomas",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4433,
    longitude: 150.8722,
    accuracy: 4
  },
  {
    postalCode: 2500,
    city: "West Wollongong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4248,
    longitude: 150.8642,
    accuracy: 4
  },
  {
    postalCode: 2502,
    city: "Primbee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5036,
    longitude: 150.8795,
    accuracy: 4
  },
  {
    postalCode: 2502,
    city: "Cringila",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4667,
    longitude: 150.8833,
    accuracy: 4
  },
  {
    postalCode: 2502,
    city: "Warrawong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.485,
    longitude: 150.8883,
    accuracy: 4
  },
  {
    postalCode: 2502,
    city: "Lake Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4867,
    longitude: 150.875,
    accuracy: 4
  },
  {
    postalCode: 2505,
    city: "Kemblawarra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4944,
    longitude: 150.89,
    accuracy: 4
  },
  {
    postalCode: 2505,
    city: "Port Kembla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4818,
    longitude: 150.9012,
    accuracy: 4
  },
  {
    postalCode: 2506,
    city: "Berkeley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4833,
    longitude: 150.85,
    accuracy: 4
  },
  {
    postalCode: 2508,
    city: "Maddens Plains",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2005,
    longitude: 150.9802,
    accuracy: 3
  },
  {
    postalCode: 2508,
    city: "Coalcliff",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2457,
    longitude: 150.9682,
    accuracy: 4
  },
  {
    postalCode: 2508,
    city: "Helensburgh",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1784,
    longitude: 150.9952,
    accuracy: 4
  },
  {
    postalCode: 2508,
    city: "Otford",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2129,
    longitude: 150.9982,
    accuracy: 4
  },
  {
    postalCode: 2508,
    city: "Woronora Dam",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1167,
    longitude: 150.9333,
    accuracy: 4
  },
  {
    postalCode: 2508,
    city: "Darkes Forest",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2377,
    longitude: 150.9195,
    accuracy: 4
  },
  {
    postalCode: 2508,
    city: "Stanwell Tops",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2193,
    longitude: 150.9764,
    accuracy: 4
  },
  {
    postalCode: 2508,
    city: "Stanwell Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2261,
    longitude: 150.9858,
    accuracy: 4
  },
  {
    postalCode: 2508,
    city: "Lilyvale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1861,
    longitude: 151.0165,
    accuracy: 4
  },
  {
    postalCode: 2515,
    city: "Coledale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.291,
    longitude: 150.9447,
    accuracy: 4
  },
  {
    postalCode: 2515,
    city: "Thirroul",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.316,
    longitude: 150.9214,
    accuracy: 4
  },
  {
    postalCode: 2515,
    city: "Clifton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.25,
    longitude: 150.9667,
    accuracy: 4
  },
  {
    postalCode: 2515,
    city: "Wombarra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2833,
    longitude: 150.95,
    accuracy: 4
  },
  {
    postalCode: 2515,
    city: "Scarborough",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2732,
    longitude: 150.9541,
    accuracy: 4
  },
  {
    postalCode: 2515,
    city: "Austinmer",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3052,
    longitude: 150.9334,
    accuracy: 4
  },
  {
    postalCode: 2516,
    city: "Bulli",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3383,
    longitude: 150.9135,
    accuracy: 4
  },
  {
    postalCode: 2517,
    city: "Woonona",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3493,
    longitude: 150.9144,
    accuracy: 4
  },
  {
    postalCode: 2517,
    city: "Woonona East",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3524,
    longitude: 150.9044,
    accuracy: 3
  },
  {
    postalCode: 2517,
    city: "Russell Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3554,
    longitude: 150.8943,
    accuracy: 4
  },
  {
    postalCode: 2518,
    city: "Bellambi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3667,
    longitude: 150.9167,
    accuracy: 4
  },
  {
    postalCode: 2518,
    city: "Corrimal East",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3761,
    longitude: 150.9108,
    accuracy: 4
  },
  {
    postalCode: 2518,
    city: "East Corrimal",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3761,
    longitude: 150.9108,
    accuracy: 4
  },
  {
    postalCode: 2518,
    city: "Tarrawanna",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3815,
    longitude: 150.888,
    accuracy: 4
  },
  {
    postalCode: 2518,
    city: "Corrimal",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3786,
    longitude: 150.9036,
    accuracy: 4
  },
  {
    postalCode: 2518,
    city: "Towradgi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3867,
    longitude: 150.9028,
    accuracy: 4
  },
  {
    postalCode: 2519,
    city: "Balgownie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3951,
    longitude: 150.8805,
    accuracy: 4
  },
  {
    postalCode: 2519,
    city: "Fernhill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.17,
    longitude: 151.0052,
    accuracy: 3
  },
  {
    postalCode: 2519,
    city: "Mount Ousley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4021,
    longitude: 150.8879,
    accuracy: 4
  },
  {
    postalCode: 2519,
    city: "Fairy Meadow",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.393,
    longitude: 150.8928,
    accuracy: 4
  },
  {
    postalCode: 2519,
    city: "Mount Pleasant",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3953,
    longitude: 150.8666,
    accuracy: 4
  },
  {
    postalCode: 2520,
    city: "Wollongong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.424,
    longitude: 150.8934,
    accuracy: 4
  },
  {
    postalCode: 2521,
    city: "South Coast Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5262,
    longitude: 150.8534,
    accuracy: 1
  },
  {
    postalCode: 2522,
    city: "University Of Wollongong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5262,
    longitude: 150.8534,
    accuracy: 1
  },
  {
    postalCode: 2525,
    city: "Figtree",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4356,
    longitude: 150.8583,
    accuracy: 4
  },
  {
    postalCode: 2526,
    city: "Cordeaux",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4404,
    longitude: 150.8375,
    accuracy: 4
  },
  {
    postalCode: 2526,
    city: "Cordeaux Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4404,
    longitude: 150.8375,
    accuracy: 4
  },
  {
    postalCode: 2526,
    city: "Kembla Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4305,
    longitude: 150.8069,
    accuracy: 4
  },
  {
    postalCode: 2526,
    city: "Kembla Grange",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4663,
    longitude: 150.8067,
    accuracy: 4
  },
  {
    postalCode: 2526,
    city: "Mount Kembla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4328,
    longitude: 150.8205,
    accuracy: 3
  },
  {
    postalCode: 2526,
    city: "Farmborough Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.455,
    longitude: 150.8131,
    accuracy: 4
  },
  {
    postalCode: 2526,
    city: "Unanderra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4531,
    longitude: 150.8475,
    accuracy: 4
  },
  {
    postalCode: 2527,
    city: "Tullimbar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5833,
    longitude: 150.75,
    accuracy: 4
  },
  {
    postalCode: 2527,
    city: "Tongarra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5833,
    longitude: 150.6833,
    accuracy: 4
  },
  {
    postalCode: 2527,
    city: "Calderwood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5505,
    longitude: 150.7113,
    accuracy: 4
  },
  {
    postalCode: 2527,
    city: "Yellow Rock",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6,
    longitude: 150.7333,
    accuracy: 4
  },
  {
    postalCode: 2527,
    city: "Albion Park Rail",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5612,
    longitude: 150.7968,
    accuracy: 4
  },
  {
    postalCode: 2527,
    city: "North Macquarie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5845,
    longitude: 150.7356,
    accuracy: 3
  },
  {
    postalCode: 2527,
    city: "Albion Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5713,
    longitude: 150.7757,
    accuracy: 4
  },
  {
    postalCode: 2527,
    city: "Croom",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5943,
    longitude: 150.8413,
    accuracy: 4
  },
  {
    postalCode: 2528,
    city: "Warilla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5519,
    longitude: 150.8583,
    accuracy: 4
  },
  {
    postalCode: 2528,
    city: "Lake Illawarra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5466,
    longitude: 150.8564,
    accuracy: 4
  },
  {
    postalCode: 2528,
    city: "Windang",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5333,
    longitude: 150.8667,
    accuracy: 4
  },
  {
    postalCode: 2528,
    city: "Barrack Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.566,
    longitude: 150.8552,
    accuracy: 4
  },
  {
    postalCode: 2528,
    city: "Mount Warrigal",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.548,
    longitude: 150.8375,
    accuracy: 4
  },
  {
    postalCode: 2528,
    city: "Barrack Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5628,
    longitude: 150.8668,
    accuracy: 4
  },
  {
    postalCode: 2529,
    city: "Shell Cove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5887,
    longitude: 150.8725,
    accuracy: 4
  },
  {
    postalCode: 2529,
    city: "Shellharbour City Centre",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5636,
    longitude: 150.8383,
    accuracy: 4
  },
  {
    postalCode: 2529,
    city: "Blackbutt",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5706,
    longitude: 150.8396,
    accuracy: 4
  },
  {
    postalCode: 2529,
    city: "Oak Flats",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5623,
    longitude: 150.8219,
    accuracy: 4
  },
  {
    postalCode: 2529,
    city: "Flinders",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5833,
    longitude: 150.8552,
    accuracy: 4
  },
  {
    postalCode: 2529,
    city: "Shellharbour Square",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5753,
    longitude: 150.8442,
    accuracy: 3
  },
  {
    postalCode: 2529,
    city: "Dunmore",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6,
    longitude: 150.85,
    accuracy: 4
  },
  {
    postalCode: 2529,
    city: "Shellharbour",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5833,
    longitude: 150.8667,
    accuracy: 4
  },
  {
    postalCode: 2529,
    city: "Oak Flats Dc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5753,
    longitude: 150.8442,
    accuracy: 3
  },
  {
    postalCode: 2530,
    city: "Penrose",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6707,
    longitude: 150.2137,
    accuracy: 4
  },
  {
    postalCode: 2530,
    city: "Yallah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5369,
    longitude: 150.7852,
    accuracy: 4
  },
  {
    postalCode: 2530,
    city: "Koonawarra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5021,
    longitude: 150.8085,
    accuracy: 4
  },
  {
    postalCode: 2530,
    city: "Dombarton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4586,
    longitude: 150.7718,
    accuracy: 4
  },
  {
    postalCode: 2530,
    city: "Huntley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4976,
    longitude: 150.7421,
    accuracy: 4
  },
  {
    postalCode: 2530,
    city: "Brownsville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4833,
    longitude: 150.8,
    accuracy: 4
  },
  {
    postalCode: 2530,
    city: "Haywards Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5339,
    longitude: 150.7916,
    accuracy: 4
  },
  {
    postalCode: 2530,
    city: "Cleveland",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5492,
    longitude: 150.4827,
    accuracy: 3
  },
  {
    postalCode: 2530,
    city: "Kanahooka",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4933,
    longitude: 150.8188,
    accuracy: 4
  },
  {
    postalCode: 2530,
    city: "Dapto",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5,
    longitude: 150.7833,
    accuracy: 4
  },
  {
    postalCode: 2530,
    city: "Marshall Mount",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.55,
    longitude: 150.75,
    accuracy: 4
  },
  {
    postalCode: 2530,
    city: "Wongawilli",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4775,
    longitude: 150.7568,
    accuracy: 4
  },
  {
    postalCode: 2530,
    city: "Avondale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5175,
    longitude: 150.7501,
    accuracy: 4
  },
  {
    postalCode: 2530,
    city: "Horsley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4876,
    longitude: 150.778,
    accuracy: 4
  },
  {
    postalCode: 2533,
    city: "Jerrara",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6701,
    longitude: 150.8231,
    accuracy: 4
  },
  {
    postalCode: 2533,
    city: "Kiama",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6683,
    longitude: 150.8522,
    accuracy: 4
  },
  {
    postalCode: 2533,
    city: "Jamberoo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6474,
    longitude: 150.7746,
    accuracy: 4
  },
  {
    postalCode: 2533,
    city: "Curramore",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6234,
    longitude: 150.7607,
    accuracy: 4
  },
  {
    postalCode: 2533,
    city: "Bombo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6521,
    longitude: 150.8596,
    accuracy: 4
  },
  {
    postalCode: 2533,
    city: "Kiama Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6497,
    longitude: 150.8256,
    accuracy: 3
  },
  {
    postalCode: 2533,
    city: "Minnamurra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6333,
    longitude: 150.85,
    accuracy: 4
  },
  {
    postalCode: 2533,
    city: "Kiama Downs",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6334,
    longitude: 150.8546,
    accuracy: 4
  },
  {
    postalCode: 2533,
    city: "Saddleback Mountain",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6961,
    longitude: 150.8169,
    accuracy: 4
  },
  {
    postalCode: 2534,
    city: "Broughton Village",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7667,
    longitude: 150.75,
    accuracy: 4
  },
  {
    postalCode: 2534,
    city: "Willow Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7381,
    longitude: 150.7998,
    accuracy: 4
  },
  {
    postalCode: 2534,
    city: "Werri Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7368,
    longitude: 150.8309,
    accuracy: 4
  },
  {
    postalCode: 2534,
    city: "Toolijooa",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7649,
    longitude: 150.7831,
    accuracy: 4
  },
  {
    postalCode: 2534,
    city: "Gerringong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.747,
    longitude: 150.8281,
    accuracy: 4
  },
  {
    postalCode: 2534,
    city: "Rose Valley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7235,
    longitude: 150.8096,
    accuracy: 4
  },
  {
    postalCode: 2534,
    city: "Gerroa",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7691,
    longitude: 150.8101,
    accuracy: 4
  },
  {
    postalCode: 2534,
    city: "Foxground",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7152,
    longitude: 150.7679,
    accuracy: 4
  },
  {
    postalCode: 2535,
    city: "Coolangatta",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8528,
    longitude: 150.7262,
    accuracy: 4
  },
  {
    postalCode: 2535,
    city: "Broughton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.75,
    longitude: 150.7667,
    accuracy: 4
  },
  {
    postalCode: 2535,
    city: "Jaspers Brush",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8167,
    longitude: 150.6667,
    accuracy: 4
  },
  {
    postalCode: 2535,
    city: "Far Meadow",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.781,
    longitude: 150.705,
    accuracy: 3
  },
  {
    postalCode: 2535,
    city: "Wattamolla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7333,
    longitude: 150.65,
    accuracy: 4
  },
  {
    postalCode: 2535,
    city: "Bellawongarah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7667,
    longitude: 150.6333,
    accuracy: 4
  },
  {
    postalCode: 2535,
    city: "Woodhill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7333,
    longitude: 150.7,
    accuracy: 4
  },
  {
    postalCode: 2535,
    city: "Budderoo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7819,
    longitude: 150.68,
    accuracy: 3
  },
  {
    postalCode: 2535,
    city: "Shoalhaven Heads",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8509,
    longitude: 150.7451,
    accuracy: 4
  },
  {
    postalCode: 2535,
    city: "Berry Mountain",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.781,
    longitude: 150.705,
    accuracy: 3
  },
  {
    postalCode: 2535,
    city: "Broughton Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.75,
    longitude: 150.7667,
    accuracy: 4
  },
  {
    postalCode: 2535,
    city: "Brogers Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.781,
    longitude: 150.705,
    accuracy: 3
  },
  {
    postalCode: 2535,
    city: "Berry",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7751,
    longitude: 150.6944,
    accuracy: 4
  },
  {
    postalCode: 2535,
    city: "Bundewallah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.781,
    longitude: 150.705,
    accuracy: 3
  },
  {
    postalCode: 2535,
    city: "Back Forest",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.781,
    longitude: 150.705,
    accuracy: 3
  },
  {
    postalCode: 2536,
    city: "South Durras",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.6513,
    longitude: 150.2952,
    accuracy: 4
  },
  {
    postalCode: 2536,
    city: "Guerilla Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.6319,
    longitude: 150.1637,
    accuracy: 3
  },
  {
    postalCode: 2536,
    city: "Catalina",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.73,
    longitude: 150.1849,
    accuracy: 4
  },
  {
    postalCode: 2536,
    city: "Denhams Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7509,
    longitude: 150.2114,
    accuracy: 4
  },
  {
    postalCode: 2536,
    city: "Maloneys Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7059,
    longitude: 150.248,
    accuracy: 3
  },
  {
    postalCode: 2536,
    city: "North Batemans Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7003,
    longitude: 150.1832,
    accuracy: 3
  },
  {
    postalCode: 2536,
    city: "Jeremadra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8091,
    longitude: 150.1366,
    accuracy: 3
  },
  {
    postalCode: 2536,
    city: "Pebbly Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.64,
    longitude: 150.1533,
    accuracy: 3
  },
  {
    postalCode: 2536,
    city: "Surfside",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.6953,
    longitude: 150.1995,
    accuracy: 4
  },
  {
    postalCode: 2536,
    city: "Bimbimbie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.6319,
    longitude: 150.1637,
    accuracy: 3
  },
  {
    postalCode: 2536,
    city: "Benandarah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.6333,
    longitude: 150.25,
    accuracy: 4
  },
  {
    postalCode: 2536,
    city: "Buckenbowra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7333,
    longitude: 150.0667,
    accuracy: 4
  },
  {
    postalCode: 2536,
    city: "Long Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7083,
    longitude: 150.2448,
    accuracy: 4
  },
  {
    postalCode: 2536,
    city: "Surf Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.6319,
    longitude: 150.1637,
    accuracy: 3
  },
  {
    postalCode: 2536,
    city: "Mogo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7848,
    longitude: 150.1417,
    accuracy: 4
  },
  {
    postalCode: 2536,
    city: "Depot Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.64,
    longitude: 150.1533,
    accuracy: 3
  },
  {
    postalCode: 2536,
    city: "Lilli Pilli",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7759,
    longitude: 150.228,
    accuracy: 4
  },
  {
    postalCode: 2536,
    city: "Runnyford",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.6319,
    longitude: 150.1637,
    accuracy: 3
  },
  {
    postalCode: 2536,
    city: "Batemans Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7066,
    longitude: 150.1754,
    accuracy: 4
  },
  {
    postalCode: 2536,
    city: "Sunshine Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7454,
    longitude: 150.2079,
    accuracy: 4
  },
  {
    postalCode: 2536,
    city: "Malua Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7938,
    longitude: 150.2283,
    accuracy: 4
  },
  {
    postalCode: 2536,
    city: "Batehaven",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7376,
    longitude: 150.1984,
    accuracy: 4
  },
  {
    postalCode: 2536,
    city: "Nelligen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.6467,
    longitude: 150.1362,
    accuracy: 4
  },
  {
    postalCode: 2536,
    city: "Woodlands",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3166,
    longitude: 149.8863,
    accuracy: 4
  },
  {
    postalCode: 2536,
    city: "Rosedale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.816,
    longitude: 150.2225,
    accuracy: 4
  },
  {
    postalCode: 2536,
    city: "East Lynne",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.59,
    longitude: 150.2927,
    accuracy: 4
  },
  {
    postalCode: 2536,
    city: "Currowan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.5833,
    longitude: 150.1667,
    accuracy: 4
  },
  {
    postalCode: 2536,
    city: "Durras North",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.6319,
    longitude: 150.1637,
    accuracy: 3
  },
  {
    postalCode: 2537,
    city: "Congo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.9552,
    longitude: 150.1575,
    accuracy: 4
  },
  {
    postalCode: 2537,
    city: "Meringo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8613,
    longitude: 149.9495,
    accuracy: 3
  },
  {
    postalCode: 2537,
    city: "Mossy Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8398,
    longitude: 150.1804,
    accuracy: 4
  },
  {
    postalCode: 2537,
    city: "Moruya Heads",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.9177,
    longitude: 150.1537,
    accuracy: 4
  },
  {
    postalCode: 2537,
    city: "Bergalia",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.9818,
    longitude: 150.1012,
    accuracy: 4
  },
  {
    postalCode: 2537,
    city: "Deua",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8613,
    longitude: 149.9495,
    accuracy: 3
  },
  {
    postalCode: 2537,
    city: "Bingie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0105,
    longitude: 150.1483,
    accuracy: 4
  },
  {
    postalCode: 2537,
    city: "Moruya",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.9125,
    longitude: 150.0814,
    accuracy: 4
  },
  {
    postalCode: 2537,
    city: "Mogendoura",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8652,
    longitude: 150.0512,
    accuracy: 4
  },
  {
    postalCode: 2537,
    city: "Wamban",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.9334,
    longitude: 150.1203,
    accuracy: 3
  },
  {
    postalCode: 2537,
    city: "Broulee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8547,
    longitude: 150.1739,
    accuracy: 4
  },
  {
    postalCode: 2537,
    city: "Coila",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0068,
    longitude: 150.0965,
    accuracy: 4
  },
  {
    postalCode: 2537,
    city: "Tuross Head",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0533,
    longitude: 150.1332,
    accuracy: 4
  },
  {
    postalCode: 2537,
    city: "Deua River Valley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8613,
    longitude: 149.9495,
    accuracy: 3
  },
  {
    postalCode: 2537,
    city: "Tomakin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8233,
    longitude: 150.1879,
    accuracy: 4
  },
  {
    postalCode: 2537,
    city: "Kiora",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.9333,
    longitude: 150.0333,
    accuracy: 4
  },
  {
    postalCode: 2537,
    city: "Turlinjah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0333,
    longitude: 150.1,
    accuracy: 4
  },
  {
    postalCode: 2538,
    city: "Mogood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4918,
    longitude: 150.1905,
    accuracy: 4
  },
  {
    postalCode: 2538,
    city: "Little Forest",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4271,
    longitude: 150.3108,
    accuracy: 3
  },
  {
    postalCode: 2538,
    city: "Brooman",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.5,
    longitude: 150.25,
    accuracy: 4
  },
  {
    postalCode: 2538,
    city: "Woodstock",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7446,
    longitude: 148.8489,
    accuracy: 4
  },
  {
    postalCode: 2538,
    city: "Milton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3164,
    longitude: 150.4361,
    accuracy: 4
  },
  {
    postalCode: 2538,
    city: "Porters Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4271,
    longitude: 150.3108,
    accuracy: 3
  },
  {
    postalCode: 2538,
    city: "Morton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4,
    longitude: 150.3667,
    accuracy: 4
  },
  {
    postalCode: 2538,
    city: "Woodburn",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4271,
    longitude: 150.3108,
    accuracy: 3
  },
  {
    postalCode: 2539,
    city: "Conjola",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2167,
    longitude: 150.45,
    accuracy: 4
  },
  {
    postalCode: 2539,
    city: "Croobyar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3549,
    longitude: 150.447,
    accuracy: 3
  },
  {
    postalCode: 2539,
    city: "Bawley Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.5078,
    longitude: 150.3892,
    accuracy: 4
  },
  {
    postalCode: 2539,
    city: "Yatte Yattah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2588,
    longitude: 150.4258,
    accuracy: 4
  },
  {
    postalCode: 2539,
    city: "Burrill Lake",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3872,
    longitude: 150.4495,
    accuracy: 4
  },
  {
    postalCode: 2539,
    city: "Kioloa",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.5542,
    longitude: 150.3789,
    accuracy: 4
  },
  {
    postalCode: 2539,
    city: "Fishermans Paradise",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2296,
    longitude: 150.4449,
    accuracy: 4
  },
  {
    postalCode: 2539,
    city: "Berringer Lake",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2533,
    longitude: 150.498,
    accuracy: 4
  },
  {
    postalCode: 2539,
    city: "Cunjurong Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2598,
    longitude: 150.5049,
    accuracy: 3
  },
  {
    postalCode: 2539,
    city: "Pretty Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5167,
    longitude: 151.35,
    accuracy: 4
  },
  {
    postalCode: 2539,
    city: "Mollymook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3297,
    longitude: 150.4717,
    accuracy: 4
  },
  {
    postalCode: 2539,
    city: "Lake Tabourie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4392,
    longitude: 150.3983,
    accuracy: 4
  },
  {
    postalCode: 2539,
    city: "Bendalong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2467,
    longitude: 150.5284,
    accuracy: 4
  },
  {
    postalCode: 2539,
    city: "Cockwhy",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3549,
    longitude: 150.447,
    accuracy: 3
  },
  {
    postalCode: 2539,
    city: "Conjola Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2631,
    longitude: 150.4398,
    accuracy: 4
  },
  {
    postalCode: 2539,
    city: "Yadboro",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3549,
    longitude: 150.447,
    accuracy: 3
  },
  {
    postalCode: 2539,
    city: "Ulladulla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3591,
    longitude: 150.4725,
    accuracy: 4
  },
  {
    postalCode: 2539,
    city: "Mollymook Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3297,
    longitude: 150.4717,
    accuracy: 4
  },
  {
    postalCode: 2539,
    city: "Termeil",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4667,
    longitude: 150.35,
    accuracy: 4
  },
  {
    postalCode: 2539,
    city: "Pointer Mountain",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3549,
    longitude: 150.447,
    accuracy: 3
  },
  {
    postalCode: 2539,
    city: "Manyana",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2551,
    longitude: 150.5137,
    accuracy: 4
  },
  {
    postalCode: 2539,
    city: "Narrawallee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3124,
    longitude: 150.4635,
    accuracy: 4
  },
  {
    postalCode: 2539,
    city: "Lake Conjola",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2681,
    longitude: 150.4908,
    accuracy: 4
  },
  {
    postalCode: 2539,
    city: "Kings Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3702,
    longitude: 150.4341,
    accuracy: 4
  },
  {
    postalCode: 2539,
    city: "Dolphin Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4018,
    longitude: 150.4436,
    accuracy: 4
  },
  {
    postalCode: 2539,
    city: "Mount Kingiman",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3549,
    longitude: 150.447,
    accuracy: 3
  },
  {
    postalCode: 2540,
    city: "Culburra Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.9303,
    longitude: 150.7587,
    accuracy: 3
  },
  {
    postalCode: 2540,
    city: "Tomerong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0523,
    longitude: 150.5865,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Sussex Inlet",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1567,
    longitude: 150.5853,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Currarong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0151,
    longitude: 150.8269,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Worrigee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8904,
    longitude: 150.6261,
    accuracy: 3
  },
  {
    postalCode: 2540,
    city: "Cambewarra Village",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0169,
    longitude: 150.6319,
    accuracy: 3
  },
  {
    postalCode: 2540,
    city: "Cudmirrah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.198,
    longitude: 150.5562,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Terara",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8833,
    longitude: 150.6333,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Meroo Meadow",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8099,
    longitude: 150.6184,
    accuracy: 3
  },
  {
    postalCode: 2540,
    city: "Browns Mountain",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0169,
    longitude: 150.6319,
    accuracy: 3
  },
  {
    postalCode: 2540,
    city: "Illaroo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0169,
    longitude: 150.6319,
    accuracy: 3
  },
  {
    postalCode: 2540,
    city: "Old Erowal Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0846,
    longitude: 150.6457,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Worrowing Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.077,
    longitude: 150.6406,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Twelve Mile Peg",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0169,
    longitude: 150.6319,
    accuracy: 3
  },
  {
    postalCode: 2540,
    city: "Hyams Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1014,
    longitude: 150.6924,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Brundee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.9,
    longitude: 150.6833,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Nowra Naval Po",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0169,
    longitude: 150.6319,
    accuracy: 3
  },
  {
    postalCode: 2540,
    city: "Nowra Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0169,
    longitude: 150.6319,
    accuracy: 3
  },
  {
    postalCode: 2540,
    city: "Sanctuary Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1036,
    longitude: 150.6267,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "St Georges Basin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0908,
    longitude: 150.5978,
    accuracy: 3
  },
  {
    postalCode: 2540,
    city: "Pyree",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.9167,
    longitude: 150.7,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Moollattoo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0169,
    longitude: 150.6319,
    accuracy: 3
  },
  {
    postalCode: 2540,
    city: "Callala Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0056,
    longitude: 150.6958,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Myola",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0231,
    longitude: 150.6758,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Orient Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.9091,
    longitude: 150.7497,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Wrights Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.028,
    longitude: 150.5501,
    accuracy: 3
  },
  {
    postalCode: 2540,
    city: "Mundamia",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0169,
    longitude: 150.6319,
    accuracy: 3
  },
  {
    postalCode: 2540,
    city: "Tullarwalla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0169,
    longitude: 150.6319,
    accuracy: 3
  },
  {
    postalCode: 2540,
    city: "Tallowal",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0169,
    longitude: 150.6319,
    accuracy: 3
  },
  {
    postalCode: 2540,
    city: "Bream Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0169,
    longitude: 150.6319,
    accuracy: 3
  },
  {
    postalCode: 2540,
    city: "Callala Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.9967,
    longitude: 150.7228,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Yalwal",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.9333,
    longitude: 150.4,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Boolijah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0169,
    longitude: 150.6319,
    accuracy: 3
  },
  {
    postalCode: 2540,
    city: "Yerriyong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0169,
    longitude: 150.6319,
    accuracy: 3
  },
  {
    postalCode: 2540,
    city: "Berrara",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.205,
    longitude: 150.5525,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Vincentia",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0682,
    longitude: 150.6748,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Greenwell Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.9075,
    longitude: 150.7311,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Mondayong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0169,
    longitude: 150.6319,
    accuracy: 3
  },
  {
    postalCode: 2540,
    city: "Kinghorne",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.9896,
    longitude: 150.7837,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Wandandian",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1,
    longitude: 150.5,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Falls Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.9667,
    longitude: 150.6,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Ettrema",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0169,
    longitude: 150.6319,
    accuracy: 3
  },
  {
    postalCode: 2540,
    city: "Woollamia",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0167,
    longitude: 150.65,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Beecroft Peninsula",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0431,
    longitude: 150.8071,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Wollumboola",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.9884,
    longitude: 150.7436,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Bewong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0169,
    longitude: 150.6319,
    accuracy: 3
  },
  {
    postalCode: 2540,
    city: "Erowal Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0999,
    longitude: 150.6505,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Burrier",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8833,
    longitude: 150.4667,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Comerong Island",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8654,
    longitude: 150.7365,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Swanhaven",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.028,
    longitude: 150.5501,
    accuracy: 3
  },
  {
    postalCode: 2540,
    city: "Basin View",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0883,
    longitude: 150.5553,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Bamarang",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.028,
    longitude: 150.5501,
    accuracy: 3
  },
  {
    postalCode: 2540,
    city: "Bolong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.85,
    longitude: 150.6667,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Numbaa",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.028,
    longitude: 150.5501,
    accuracy: 3
  },
  {
    postalCode: 2540,
    city: "Hmas Albatross",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.028,
    longitude: 150.5501,
    accuracy: 3
  },
  {
    postalCode: 2540,
    city: "Buangla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0169,
    longitude: 150.6319,
    accuracy: 3
  },
  {
    postalCode: 2540,
    city: "Barringella",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0169,
    longitude: 150.6319,
    accuracy: 3
  },
  {
    postalCode: 2540,
    city: "Comberton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0169,
    longitude: 150.6319,
    accuracy: 3
  },
  {
    postalCode: 2540,
    city: "Longreach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0169,
    longitude: 150.6319,
    accuracy: 3
  },
  {
    postalCode: 2540,
    city: "Cambewarra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8233,
    longitude: 150.5594,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Jerrawangala",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1167,
    longitude: 150.4833,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Watersleigh",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0169,
    longitude: 150.6319,
    accuracy: 3
  },
  {
    postalCode: 2540,
    city: "Huskisson",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0401,
    longitude: 150.668,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Parma",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0169,
    longitude: 150.6319,
    accuracy: 3
  },
  {
    postalCode: 2540,
    city: "Tapitallee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8298,
    longitude: 150.5397,
    accuracy: 4
  },
  {
    postalCode: 2540,
    city: "Mayfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8979,
    longitude: 151.7361,
    accuracy: 4
  },
  {
    postalCode: 2541,
    city: "Nowra Dc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8545,
    longitude: 150.6167,
    accuracy: 3
  },
  {
    postalCode: 2541,
    city: "Bomaderry",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8497,
    longitude: 150.6109,
    accuracy: 4
  },
  {
    postalCode: 2541,
    city: "Nowra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8842,
    longitude: 150.6004,
    accuracy: 4
  },
  {
    postalCode: 2541,
    city: "West Nowra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8727,
    longitude: 150.6039,
    accuracy: 3
  },
  {
    postalCode: 2541,
    city: "South Nowra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8842,
    longitude: 150.6004,
    accuracy: 4
  },
  {
    postalCode: 2541,
    city: "Nowra East",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8727,
    longitude: 150.6039,
    accuracy: 3
  },
  {
    postalCode: 2541,
    city: "North Nowra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8727,
    longitude: 150.6039,
    accuracy: 3
  },
  {
    postalCode: 2541,
    city: "Nowra North",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8727,
    longitude: 150.6039,
    accuracy: 3
  },
  {
    postalCode: 2541,
    city: "Bangalee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8545,
    longitude: 150.6167,
    accuracy: 3
  },
  {
    postalCode: 2545,
    city: "Belowra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.199,
    longitude: 149.7088,
    accuracy: 4
  },
  {
    postalCode: 2545,
    city: "Bodalla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0912,
    longitude: 150.0506,
    accuracy: 4
  },
  {
    postalCode: 2545,
    city: "Eurobodalla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.1485,
    longitude: 149.9679,
    accuracy: 4
  },
  {
    postalCode: 2545,
    city: "Potato Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.138,
    longitude: 149.9085,
    accuracy: 3
  },
  {
    postalCode: 2545,
    city: "Cadgee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.1582,
    longitude: 149.8996,
    accuracy: 4
  },
  {
    postalCode: 2545,
    city: "Nerrigundah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.1167,
    longitude: 149.9,
    accuracy: 4
  },
  {
    postalCode: 2546,
    city: "Wallaga Lake Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.3684,
    longitude: 150.0718,
    accuracy: 4
  },
  {
    postalCode: 2546,
    city: "Murrah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.5,
    longitude: 150.0167,
    accuracy: 4
  },
  {
    postalCode: 2546,
    city: "Narooma",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.2178,
    longitude: 150.1325,
    accuracy: 4
  },
  {
    postalCode: 2546,
    city: "Tinpot",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.2167,
    longitude: 149.8667,
    accuracy: 4
  },
  {
    postalCode: 2546,
    city: "Akolele",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.3555,
    longitude: 150.0772,
    accuracy: 4
  },
  {
    postalCode: 2546,
    city: "Bermagui",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.419,
    longitude: 150.0636,
    accuracy: 4
  },
  {
    postalCode: 2546,
    city: "Corunna",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.2818,
    longitude: 150.1012,
    accuracy: 4
  },
  {
    postalCode: 2546,
    city: "Kianga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.1945,
    longitude: 150.1268,
    accuracy: 4
  },
  {
    postalCode: 2546,
    city: "Central Tilba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.3131,
    longitude: 150.0731,
    accuracy: 4
  },
  {
    postalCode: 2546,
    city: "Tilba Tilba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.3247,
    longitude: 150.0599,
    accuracy: 4
  },
  {
    postalCode: 2546,
    city: "Dalmeny",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.1661,
    longitude: 150.1291,
    accuracy: 4
  },
  {
    postalCode: 2546,
    city: "Beauty Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.2614,
    longitude: 150.0075,
    accuracy: 3
  },
  {
    postalCode: 2546,
    city: "Wallaga Lake",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.3684,
    longitude: 150.0718,
    accuracy: 4
  },
  {
    postalCode: 2546,
    city: "Cuttagee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.2614,
    longitude: 150.0075,
    accuracy: 3
  },
  {
    postalCode: 2546,
    city: "Dignams Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.3485,
    longitude: 149.9846,
    accuracy: 4
  },
  {
    postalCode: 2546,
    city: "Barragga Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.2614,
    longitude: 150.0075,
    accuracy: 3
  },
  {
    postalCode: 2546,
    city: "Wadbilliga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.2555,
    longitude: 149.6512,
    accuracy: 4
  },
  {
    postalCode: 2546,
    city: "Mystery Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.3073,
    longitude: 150.0259,
    accuracy: 3
  },
  {
    postalCode: 2546,
    city: "North Narooma",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.2027,
    longitude: 150.1191,
    accuracy: 3
  },
  {
    postalCode: 2548,
    city: "Bournda",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.8763,
    longitude: 149.9199,
    accuracy: 3
  },
  {
    postalCode: 2548,
    city: "Tura Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.8636,
    longitude: 149.9303,
    accuracy: 4
  },
  {
    postalCode: 2548,
    city: "Merimbula",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.889,
    longitude: 149.9096,
    accuracy: 4
  },
  {
    postalCode: 2548,
    city: "Berrambool",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.8911,
    longitude: 149.9075,
    accuracy: 3
  },
  {
    postalCode: 2548,
    city: "Mirador",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.8763,
    longitude: 149.9199,
    accuracy: 3
  },
  {
    postalCode: 2548,
    city: "Yellow Pinch",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.8763,
    longitude: 149.9199,
    accuracy: 3
  },
  {
    postalCode: 2549,
    city: "Nethercote",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -37.0152,
    longitude: 149.8346,
    accuracy: 4
  },
  {
    postalCode: 2549,
    city: "Broadwater",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.9354,
    longitude: 149.8338,
    accuracy: 3
  },
  {
    postalCode: 2549,
    city: "Pambula Beach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.9417,
    longitude: 149.9034,
    accuracy: 4
  },
  {
    postalCode: 2549,
    city: "Pambula",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.9301,
    longitude: 149.8745,
    accuracy: 4
  },
  {
    postalCode: 2549,
    city: "Greigs Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.9652,
    longitude: 149.8679,
    accuracy: 4
  },
  {
    postalCode: 2549,
    city: "Millingandi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.8667,
    longitude: 149.8333,
    accuracy: 4
  },
  {
    postalCode: 2549,
    city: "Lochiel",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.9485,
    longitude: 149.8179,
    accuracy: 4
  },
  {
    postalCode: 2549,
    city: "Bald Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.9117,
    longitude: 149.8428,
    accuracy: 4
  },
  {
    postalCode: 2549,
    city: "South Pambula",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.9301,
    longitude: 149.8745,
    accuracy: 3
  },
  {
    postalCode: 2550,
    city: "Wog Wog",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.714,
    longitude: 149.7654,
    accuracy: 3
  },
  {
    postalCode: 2550,
    city: "Jellat Jellat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.7167,
    longitude: 149.8833,
    accuracy: 4
  },
  {
    postalCode: 2550,
    city: "Nelson",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6462,
    longitude: 150.9214,
    accuracy: 4
  },
  {
    postalCode: 2550,
    city: "Bournda",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.8368,
    longitude: 149.913,
    accuracy: 3
  },
  {
    postalCode: 2550,
    city: "Mumbulla Mountain",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.7267,
    longitude: 149.6829,
    accuracy: 3
  },
  {
    postalCode: 2550,
    city: "Burragate",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -37,
    longitude: 149.6167,
    accuracy: 4
  },
  {
    postalCode: 2550,
    city: "Coolangubra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.714,
    longitude: 149.7654,
    accuracy: 3
  },
  {
    postalCode: 2550,
    city: "Wandella",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9137,
    longitude: 146.0441,
    accuracy: 3
  },
  {
    postalCode: 2550,
    city: "Doctor George Mountain",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.7267,
    longitude: 149.6829,
    accuracy: 3
  },
  {
    postalCode: 2550,
    city: "Quaama",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.4667,
    longitude: 149.8667,
    accuracy: 4
  },
  {
    postalCode: 2550,
    city: "Greendale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.4255,
    longitude: 149.9534,
    accuracy: 4
  },
  {
    postalCode: 2550,
    city: "Mogilla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.6985,
    longitude: 149.5846,
    accuracy: 4
  },
  {
    postalCode: 2550,
    city: "Devils Hole",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.714,
    longitude: 149.7654,
    accuracy: 3
  },
  {
    postalCode: 2550,
    city: "Mogareeka",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.6984,
    longitude: 149.976,
    accuracy: 3
  },
  {
    postalCode: 2550,
    city: "Verona",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.4667,
    longitude: 149.8167,
    accuracy: 4
  },
  {
    postalCode: 2550,
    city: "Towamba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -37.0833,
    longitude: 149.6833,
    accuracy: 4
  },
  {
    postalCode: 2550,
    city: "Reedy Swamp",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.714,
    longitude: 149.7654,
    accuracy: 3
  },
  {
    postalCode: 2550,
    city: "Cobargo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.3879,
    longitude: 149.8863,
    accuracy: 4
  },
  {
    postalCode: 2550,
    city: "Stony Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.714,
    longitude: 149.7654,
    accuracy: 3
  },
  {
    postalCode: 2550,
    city: "Kalaru",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.7312,
    longitude: 149.9294,
    accuracy: 4
  },
  {
    postalCode: 2550,
    city: "Myrtle Mountain",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.714,
    longitude: 149.7654,
    accuracy: 3
  },
  {
    postalCode: 2550,
    city: "Numbugga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.6333,
    longitude: 149.75,
    accuracy: 4
  },
  {
    postalCode: 2550,
    city: "Yambulla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -37.2167,
    longitude: 149.55,
    accuracy: 4
  },
  {
    postalCode: 2550,
    city: "Kameruka",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.7318,
    longitude: 149.7012,
    accuracy: 4
  },
  {
    postalCode: 2550,
    city: "Candelo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.7677,
    longitude: 149.6947,
    accuracy: 4
  },
  {
    postalCode: 2550,
    city: "Bemboka",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.6289,
    longitude: 149.5718,
    accuracy: 4
  },
  {
    postalCode: 2550,
    city: "Tarraganda",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.6609,
    longitude: 149.8662,
    accuracy: 4
  },
  {
    postalCode: 2550,
    city: "Angledale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.6318,
    longitude: 149.8846,
    accuracy: 4
  },
  {
    postalCode: 2550,
    city: "Rocky Hall",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.9318,
    longitude: 149.5096,
    accuracy: 4
  },
  {
    postalCode: 2550,
    city: "South Wolumla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.8152,
    longitude: 149.7512,
    accuracy: 4
  },
  {
    postalCode: 2550,
    city: "Wapengo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.5985,
    longitude: 149.9846,
    accuracy: 4
  },
  {
    postalCode: 2550,
    city: "Bega",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.6739,
    longitude: 149.8418,
    accuracy: 4
  },
  {
    postalCode: 2550,
    city: "Black Range",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.714,
    longitude: 149.7654,
    accuracy: 3
  },
  {
    postalCode: 2550,
    city: "Tanja",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.6,
    longitude: 149.9833,
    accuracy: 4
  },
  {
    postalCode: 2550,
    city: "Pericoe",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -37.1167,
    longitude: 149.6167,
    accuracy: 4
  },
  {
    postalCode: 2550,
    city: "Morans Crossing",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.6667,
    longitude: 149.65,
    accuracy: 4
  },
  {
    postalCode: 2550,
    city: "Tathra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.7313,
    longitude: 149.9833,
    accuracy: 4
  },
  {
    postalCode: 2550,
    city: "Wolumla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.8308,
    longitude: 149.8131,
    accuracy: 4
  },
  {
    postalCode: 2550,
    city: "Wallagoot",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.714,
    longitude: 149.7654,
    accuracy: 3
  },
  {
    postalCode: 2550,
    city: "Brogo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.5333,
    longitude: 149.8333,
    accuracy: 4
  },
  {
    postalCode: 2550,
    city: "Tantawangalo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.714,
    longitude: 149.7654,
    accuracy: 3
  },
  {
    postalCode: 2550,
    city: "Chinnock",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.714,
    longitude: 149.7654,
    accuracy: 3
  },
  {
    postalCode: 2550,
    city: "Kanoona",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.714,
    longitude: 149.7654,
    accuracy: 3
  },
  {
    postalCode: 2550,
    city: "New Buildings",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.714,
    longitude: 149.7654,
    accuracy: 3
  },
  {
    postalCode: 2550,
    city: "Frogs Hollow",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.714,
    longitude: 149.7654,
    accuracy: 3
  },
  {
    postalCode: 2550,
    city: "Buckajo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.7167,
    longitude: 149.7167,
    accuracy: 4
  },
  {
    postalCode: 2550,
    city: "Wyndham",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.9318,
    longitude: 149.6512,
    accuracy: 4
  },
  {
    postalCode: 2550,
    city: "Yowrie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.3,
    longitude: 149.7167,
    accuracy: 4
  },
  {
    postalCode: 2550,
    city: "Coolagolite",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.714,
    longitude: 149.7654,
    accuracy: 3
  },
  {
    postalCode: 2550,
    city: "Toothdale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.7818,
    longitude: 149.7512,
    accuracy: 4
  },
  {
    postalCode: 2550,
    city: "Yankees Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.714,
    longitude: 149.7654,
    accuracy: 3
  },
  {
    postalCode: 2550,
    city: "Kingswood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.75,
    longitude: 150.75,
    accuracy: 4
  },
  {
    postalCode: 2550,
    city: "Coopers Gully",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.714,
    longitude: 149.7654,
    accuracy: 3
  },
  {
    postalCode: 2551,
    city: "Boydtown",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -37.0833,
    longitude: 149.9167,
    accuracy: 4
  },
  {
    postalCode: 2551,
    city: "Green Cape",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -37.2032,
    longitude: 149.7397,
    accuracy: 3
  },
  {
    postalCode: 2551,
    city: "Wonboyn",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -37.2505,
    longitude: 149.9382,
    accuracy: 4
  },
  {
    postalCode: 2551,
    city: "Kiah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -37.15,
    longitude: 149.8667,
    accuracy: 4
  },
  {
    postalCode: 2551,
    city: "Eden",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -37.0632,
    longitude: 149.904,
    accuracy: 4
  },
  {
    postalCode: 2551,
    city: "Wonboyn North",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -37.2032,
    longitude: 149.7397,
    accuracy: 3
  },
  {
    postalCode: 2551,
    city: "Timbillica",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -37.3652,
    longitude: 149.7012,
    accuracy: 4
  },
  {
    postalCode: 2551,
    city: "Wonboyn Lake",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -37.219,
    longitude: 149.83,
    accuracy: 3
  },
  {
    postalCode: 2551,
    city: "Nungatta South",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -37.2152,
    longitude: 149.4012,
    accuracy: 4
  },
  {
    postalCode: 2551,
    city: "Edrom",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -37.2032,
    longitude: 149.7397,
    accuracy: 3
  },
  {
    postalCode: 2551,
    city: "Nungatta",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -37.2152,
    longitude: 149.4012,
    accuracy: 4
  },
  {
    postalCode: 2551,
    city: "Nadgee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -37.2032,
    longitude: 149.7397,
    accuracy: 3
  },
  {
    postalCode: 2551,
    city: "Narrabarba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -37.2568,
    longitude: 149.8179,
    accuracy: 4
  },
  {
    postalCode: 2551,
    city: "Nullica",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -37.2032,
    longitude: 149.7397,
    accuracy: 3
  },
  {
    postalCode: 2555,
    city: "Badgerys Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8907,
    longitude: 150.7427,
    accuracy: 4
  },
  {
    postalCode: 2556,
    city: "Bringelly",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9333,
    longitude: 150.7333,
    accuracy: 4
  },
  {
    postalCode: 2557,
    city: "Rossmore",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9748,
    longitude: 150.7634,
    accuracy: 3
  },
  {
    postalCode: 2557,
    city: "Catherine Field",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0044,
    longitude: 150.7725,
    accuracy: 4
  },
  {
    postalCode: 2557,
    city: "Gregory Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0267,
    longitude: 150.7707,
    accuracy: 4
  },
  {
    postalCode: 2557,
    city: "Gledswood Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0158,
    longitude: 150.7651,
    accuracy: 4
  },
  {
    postalCode: 2558,
    city: "Eschol Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0298,
    longitude: 150.8096,
    accuracy: 4
  },
  {
    postalCode: 2558,
    city: "Kearns",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0219,
    longitude: 150.8008,
    accuracy: 4
  },
  {
    postalCode: 2558,
    city: "Eagle Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0375,
    longitude: 150.8136,
    accuracy: 4
  },
  {
    postalCode: 2559,
    city: "Claymore",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0465,
    longitude: 150.8111,
    accuracy: 4
  },
  {
    postalCode: 2559,
    city: "Blairmount",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0508,
    longitude: 150.7924,
    accuracy: 4
  },
  {
    postalCode: 2560,
    city: "Leumeah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.05,
    longitude: 150.8333,
    accuracy: 4
  },
  {
    postalCode: 2560,
    city: "Englorie Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0804,
    longitude: 150.7961,
    accuracy: 4
  },
  {
    postalCode: 2560,
    city: "Woodbine",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0459,
    longitude: 150.8215,
    accuracy: 4
  },
  {
    postalCode: 2560,
    city: "Glen Alpine",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.086,
    longitude: 150.7851,
    accuracy: 4
  },
  {
    postalCode: 2560,
    city: "Kentlyn",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0604,
    longitude: 150.8654,
    accuracy: 4
  },
  {
    postalCode: 2560,
    city: "Wedderburn",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1333,
    longitude: 150.8167,
    accuracy: 4
  },
  {
    postalCode: 2560,
    city: "Macarthur Square",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0887,
    longitude: 150.8165,
    accuracy: 3
  },
  {
    postalCode: 2560,
    city: "Blair Athol",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0621,
    longitude: 150.8014,
    accuracy: 4
  },
  {
    postalCode: 2560,
    city: "Appin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2035,
    longitude: 150.7864,
    accuracy: 4
  },
  {
    postalCode: 2560,
    city: "Gilead",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1057,
    longitude: 150.764,
    accuracy: 4
  },
  {
    postalCode: 2560,
    city: "Rosemeadow",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1041,
    longitude: 150.7928,
    accuracy: 4
  },
  {
    postalCode: 2560,
    city: "Airds",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.086,
    longitude: 150.8332,
    accuracy: 4
  },
  {
    postalCode: 2560,
    city: "Campbelltown North",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0887,
    longitude: 150.8165,
    accuracy: 3
  },
  {
    postalCode: 2560,
    city: "Ruse",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0698,
    longitude: 150.8417,
    accuracy: 4
  },
  {
    postalCode: 2560,
    city: "Cataract",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0887,
    longitude: 150.8165,
    accuracy: 3
  },
  {
    postalCode: 2560,
    city: "Bradbury",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0854,
    longitude: 150.8154,
    accuracy: 4
  },
  {
    postalCode: 2560,
    city: "St Helens Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1047,
    longitude: 150.8137,
    accuracy: 4
  },
  {
    postalCode: 2560,
    city: "Campbelltown",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0667,
    longitude: 150.8167,
    accuracy: 4
  },
  {
    postalCode: 2560,
    city: "Ambarvale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0894,
    longitude: 150.7966,
    accuracy: 4
  },
  {
    postalCode: 2563,
    city: "Menangle Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1044,
    longitude: 150.7507,
    accuracy: 4
  },
  {
    postalCode: 2564,
    city: "Long Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0167,
    longitude: 150.9,
    accuracy: 4
  },
  {
    postalCode: 2564,
    city: "Macquarie Fields",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9921,
    longitude: 150.8931,
    accuracy: 4
  },
  {
    postalCode: 2564,
    city: "Glenquarie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0044,
    longitude: 150.8965,
    accuracy: 3
  },
  {
    postalCode: 2565,
    city: "Ingleburn",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34,
    longitude: 150.8667,
    accuracy: 4
  },
  {
    postalCode: 2565,
    city: "Macquarie Links",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9845,
    longitude: 150.8703,
    accuracy: 4
  },
  {
    postalCode: 2565,
    city: "Denham Court",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9831,
    longitude: 150.8461,
    accuracy: 4
  },
  {
    postalCode: 2565,
    city: "Bardia",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34,
    longitude: 150.8667,
    accuracy: 3
  },
  {
    postalCode: 2566,
    city: "Minto Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0532,
    longitude: 150.844,
    accuracy: 4
  },
  {
    postalCode: 2566,
    city: "Minto DC",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0188,
    longitude: 150.8297,
    accuracy: 3
  },
  {
    postalCode: 2566,
    city: "St Andrews",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0224,
    longitude: 150.8296,
    accuracy: 4
  },
  {
    postalCode: 2566,
    city: "Bow Bowing",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0165,
    longitude: 150.8403,
    accuracy: 4
  },
  {
    postalCode: 2566,
    city: "Raby",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0185,
    longitude: 150.8176,
    accuracy: 4
  },
  {
    postalCode: 2566,
    city: "Varroville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0032,
    longitude: 150.8111,
    accuracy: 4
  },
  {
    postalCode: 2566,
    city: "Minto",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0333,
    longitude: 150.85,
    accuracy: 4
  },
  {
    postalCode: 2567,
    city: "Narellan Dc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0474,
    longitude: 150.7534,
    accuracy: 3
  },
  {
    postalCode: 2567,
    city: "Smeaton Grange",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0371,
    longitude: 150.7577,
    accuracy: 4
  },
  {
    postalCode: 2567,
    city: "Harrington Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.024,
    longitude: 150.735,
    accuracy: 4
  },
  {
    postalCode: 2567,
    city: "Narellan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0333,
    longitude: 150.7333,
    accuracy: 4
  },
  {
    postalCode: 2567,
    city: "Currans Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0431,
    longitude: 150.773,
    accuracy: 4
  },
  {
    postalCode: 2567,
    city: "Mount Annan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0529,
    longitude: 150.7598,
    accuracy: 4
  },
  {
    postalCode: 2567,
    city: "Narellan Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0497,
    longitude: 150.7439,
    accuracy: 4
  },
  {
    postalCode: 2568,
    city: "Menangle",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1268,
    longitude: 150.7387,
    accuracy: 4
  },
  {
    postalCode: 2569,
    city: "Douglas Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.185,
    longitude: 150.7145,
    accuracy: 4
  },
  {
    postalCode: 2570,
    city: "Glenmore",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7907,
    longitude: 150.6693,
    accuracy: 3
  },
  {
    postalCode: 2570,
    city: "Werombi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9833,
    longitude: 150.5833,
    accuracy: 4
  },
  {
    postalCode: 2570,
    city: "Orangeville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0311,
    longitude: 150.6018,
    accuracy: 4
  },
  {
    postalCode: 2570,
    city: "Grasmere",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0539,
    longitude: 150.666,
    accuracy: 4
  },
  {
    postalCode: 2570,
    city: "Camden Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1241,
    longitude: 150.4295,
    accuracy: 3
  },
  {
    postalCode: 2570,
    city: "Brownlow Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0333,
    longitude: 150.6667,
    accuracy: 4
  },
  {
    postalCode: 2570,
    city: "Mount Hunter",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0717,
    longitude: 150.6378,
    accuracy: 4
  },
  {
    postalCode: 2570,
    city: "Oakdale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0793,
    longitude: 150.5132,
    accuracy: 4
  },
  {
    postalCode: 2570,
    city: "Camden South",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0831,
    longitude: 150.6949,
    accuracy: 4
  },
  {
    postalCode: 2570,
    city: "Spring Farm",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0685,
    longitude: 150.7118,
    accuracy: 4
  },
  {
    postalCode: 2570,
    city: "Theresa Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0068,
    longitude: 150.6346,
    accuracy: 4
  },
  {
    postalCode: 2570,
    city: "Bickley Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0733,
    longitude: 150.6644,
    accuracy: 4
  },
  {
    postalCode: 2570,
    city: "Nattai",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1241,
    longitude: 150.4295,
    accuracy: 3
  },
  {
    postalCode: 2570,
    city: "Oran Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0056,
    longitude: 150.7403,
    accuracy: 4
  },
  {
    postalCode: 2570,
    city: "Cawdor",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1,
    longitude: 150.6667,
    accuracy: 4
  },
  {
    postalCode: 2570,
    city: "Cobbitty",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0159,
    longitude: 150.6785,
    accuracy: 4
  },
  {
    postalCode: 2570,
    city: "Belimbla Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0841,
    longitude: 150.5398,
    accuracy: 4
  },
  {
    postalCode: 2570,
    city: "Ellis Lane",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0329,
    longitude: 150.6782,
    accuracy: 4
  },
  {
    postalCode: 2570,
    city: "Elderslie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.05,
    longitude: 150.7,
    accuracy: 4
  },
  {
    postalCode: 2570,
    city: "Camden",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.054,
    longitude: 150.6962,
    accuracy: 4
  },
  {
    postalCode: 2570,
    city: "The Oaks",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0799,
    longitude: 150.57,
    accuracy: 4
  },
  {
    postalCode: 2570,
    city: "Kirkham",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0388,
    longitude: 150.7111,
    accuracy: 4
  },
  {
    postalCode: 2571,
    city: "Balmoral Village",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3149,
    longitude: 150.5165,
    accuracy: 4
  },
  {
    postalCode: 2571,
    city: "Balmoral",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3077,
    longitude: 150.521,
    accuracy: 4
  },
  {
    postalCode: 2571,
    city: "Maldon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2,
    longitude: 150.6333,
    accuracy: 4
  },
  {
    postalCode: 2571,
    city: "Wilton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2405,
    longitude: 150.6977,
    accuracy: 4
  },
  {
    postalCode: 2571,
    city: "Couridjah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2336,
    longitude: 150.5513,
    accuracy: 4
  },
  {
    postalCode: 2571,
    city: "Razorback",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1524,
    longitude: 150.6531,
    accuracy: 4
  },
  {
    postalCode: 2571,
    city: "Picton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1699,
    longitude: 150.6117,
    accuracy: 4
  },
  {
    postalCode: 2571,
    city: "Buxton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2602,
    longitude: 150.5329,
    accuracy: 4
  },
  {
    postalCode: 2571,
    city: "Mowbray Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.15,
    longitude: 150.55,
    accuracy: 4
  },
  {
    postalCode: 2572,
    city: "Thirlmere",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2046,
    longitude: 150.5677,
    accuracy: 4
  },
  {
    postalCode: 2572,
    city: "Lakesland",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1652,
    longitude: 150.5346,
    accuracy: 4
  },
  {
    postalCode: 2573,
    city: "Tahmoor",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2225,
    longitude: 150.5947,
    accuracy: 4
  },
  {
    postalCode: 2574,
    city: "Pheasants Nest",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2558,
    longitude: 150.634,
    accuracy: 4
  },
  {
    postalCode: 2574,
    city: "Avon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4271,
    longitude: 150.7012,
    accuracy: 4
  },
  {
    postalCode: 2574,
    city: "Bargo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.293,
    longitude: 150.5781,
    accuracy: 4
  },
  {
    postalCode: 2574,
    city: "Yanderra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3196,
    longitude: 150.5753,
    accuracy: 4
  },
  {
    postalCode: 2575,
    city: "Yerrinbool",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3688,
    longitude: 150.5385,
    accuracy: 4
  },
  {
    postalCode: 2575,
    city: "Mount Lindsey",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4137,
    longitude: 150.4398,
    accuracy: 3
  },
  {
    postalCode: 2575,
    city: "High Range",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3652,
    longitude: 150.3012,
    accuracy: 4
  },
  {
    postalCode: 2575,
    city: "Mittagong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.45,
    longitude: 150.4457,
    accuracy: 4
  },
  {
    postalCode: 2575,
    city: "Alpine",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4093,
    longitude: 150.5296,
    accuracy: 4
  },
  {
    postalCode: 2575,
    city: "Willow Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4351,
    longitude: 150.47,
    accuracy: 4
  },
  {
    postalCode: 2575,
    city: "Colo Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.401,
    longitude: 150.4857,
    accuracy: 4
  },
  {
    postalCode: 2575,
    city: "Mandemar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4332,
    longitude: 150.3026,
    accuracy: 4
  },
  {
    postalCode: 2575,
    city: "Aylmerton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.421,
    longitude: 150.4973,
    accuracy: 4
  },
  {
    postalCode: 2575,
    city: "Wattle Ridge",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4137,
    longitude: 150.4398,
    accuracy: 3
  },
  {
    postalCode: 2575,
    city: "Woodlands",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4057,
    longitude: 150.3943,
    accuracy: 4
  },
  {
    postalCode: 2575,
    city: "Goodmans Ford",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4137,
    longitude: 150.4398,
    accuracy: 3
  },
  {
    postalCode: 2575,
    city: "Renwick",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4137,
    longitude: 150.4398,
    accuracy: 3
  },
  {
    postalCode: 2575,
    city: "Bullio",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4137,
    longitude: 150.4398,
    accuracy: 3
  },
  {
    postalCode: 2575,
    city: "Braemar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4274,
    longitude: 150.484,
    accuracy: 4
  },
  {
    postalCode: 2575,
    city: "Welby",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4393,
    longitude: 150.4306,
    accuracy: 4
  },
  {
    postalCode: 2575,
    city: "Balaclava",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4137,
    longitude: 150.4398,
    accuracy: 3
  },
  {
    postalCode: 2575,
    city: "Joadja",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4167,
    longitude: 150.2167,
    accuracy: 4
  },
  {
    postalCode: 2575,
    city: "Hill Top",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3479,
    longitude: 150.4955,
    accuracy: 4
  },
  {
    postalCode: 2576,
    city: "East Bowral",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5255,
    longitude: 150.4874,
    accuracy: 3
  },
  {
    postalCode: 2576,
    city: "Burradoo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5032,
    longitude: 150.409,
    accuracy: 4
  },
  {
    postalCode: 2576,
    city: "Bowral",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4775,
    longitude: 150.4204,
    accuracy: 4
  },
  {
    postalCode: 2576,
    city: "East Kangaloon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5667,
    longitude: 150.5833,
    accuracy: 4
  },
  {
    postalCode: 2576,
    city: "Glenquarry",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5263,
    longitude: 150.4846,
    accuracy: 4
  },
  {
    postalCode: 2576,
    city: "Kangaloon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.546,
    longitude: 150.544,
    accuracy: 4
  },
  {
    postalCode: 2577,
    city: "Paddys River",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.764,
    longitude: 148.1853,
    accuracy: 4
  },
  {
    postalCode: 2577,
    city: "Kangaroo Valley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7381,
    longitude: 150.5366,
    accuracy: 4
  },
  {
    postalCode: 2577,
    city: "Burrawang",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5853,
    longitude: 150.5115,
    accuracy: 4
  },
  {
    postalCode: 2577,
    city: "Medway",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4916,
    longitude: 150.2823,
    accuracy: 4
  },
  {
    postalCode: 2577,
    city: "Budgong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6192,
    longitude: 150.3835,
    accuracy: 3
  },
  {
    postalCode: 2577,
    city: "Berrima",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4877,
    longitude: 150.339,
    accuracy: 4
  },
  {
    postalCode: 2577,
    city: "New Berrima",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4877,
    longitude: 150.339,
    accuracy: 4
  },
  {
    postalCode: 2577,
    city: "Upper Kangaroo River",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.694,
    longitude: 150.5986,
    accuracy: 4
  },
  {
    postalCode: 2577,
    city: "Yarrunga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7227,
    longitude: 150.3099,
    accuracy: 3
  },
  {
    postalCode: 2577,
    city: "Sutton Forest",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5833,
    longitude: 150.3167,
    accuracy: 4
  },
  {
    postalCode: 2577,
    city: "Carrington Falls",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6192,
    longitude: 150.3835,
    accuracy: 3
  },
  {
    postalCode: 2577,
    city: "Barrengarry",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6833,
    longitude: 150.5167,
    accuracy: 4
  },
  {
    postalCode: 2577,
    city: "Macquarie Pass",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6192,
    longitude: 150.3835,
    accuracy: 3
  },
  {
    postalCode: 2577,
    city: "Belanglo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6192,
    longitude: 150.3835,
    accuracy: 3
  },
  {
    postalCode: 2577,
    city: "Meryla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6192,
    longitude: 150.3835,
    accuracy: 3
  },
  {
    postalCode: 2577,
    city: "Beaumont",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7833,
    longitude: 150.5667,
    accuracy: 4
  },
  {
    postalCode: 2577,
    city: "Werai",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6192,
    longitude: 150.3835,
    accuracy: 3
  },
  {
    postalCode: 2577,
    city: "Canyonleigh",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6192,
    longitude: 150.3835,
    accuracy: 3
  },
  {
    postalCode: 2577,
    city: "Knights Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6192,
    longitude: 150.3835,
    accuracy: 3
  },
  {
    postalCode: 2577,
    city: "Robertson",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5874,
    longitude: 150.5912,
    accuracy: 4
  },
  {
    postalCode: 2577,
    city: "Wildes Meadow",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.623,
    longitude: 150.5262,
    accuracy: 4
  },
  {
    postalCode: 2577,
    city: "Avoca",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5953,
    longitude: 149.2917,
    accuracy: 4
  },
  {
    postalCode: 2577,
    city: "Moss Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5537,
    longitude: 150.3712,
    accuracy: 4
  },
  {
    postalCode: 2577,
    city: "Barren Grounds",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6192,
    longitude: 150.3835,
    accuracy: 3
  },
  {
    postalCode: 2577,
    city: "Mount Murray",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6192,
    longitude: 150.3835,
    accuracy: 3
  },
  {
    postalCode: 2577,
    city: "Red Rocks",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6192,
    longitude: 150.3835,
    accuracy: 3
  },
  {
    postalCode: 2577,
    city: "Fitzroy Falls",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.65,
    longitude: 150.4833,
    accuracy: 4
  },
  {
    postalCode: 2577,
    city: "Manchester Square",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6192,
    longitude: 150.3835,
    accuracy: 3
  },
  {
    postalCode: 2577,
    city: "Upper Kangaroo Valley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.694,
    longitude: 150.5986,
    accuracy: 4
  },
  {
    postalCode: 2578,
    city: "Bundanoon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6566,
    longitude: 150.2962,
    accuracy: 4
  },
  {
    postalCode: 2579,
    city: "Brayton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6487,
    longitude: 150.2702,
    accuracy: 3
  },
  {
    postalCode: 2579,
    city: "Exeter",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6128,
    longitude: 150.3208,
    accuracy: 4
  },
  {
    postalCode: 2579,
    city: "Marulan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7084,
    longitude: 150.0097,
    accuracy: 4
  },
  {
    postalCode: 2579,
    city: "Tallong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7167,
    longitude: 150.0833,
    accuracy: 4
  },
  {
    postalCode: 2579,
    city: "Wingello",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6948,
    longitude: 150.1582,
    accuracy: 4
  },
  {
    postalCode: 2579,
    city: "Penrose",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5107,
    longitude: 150.7791,
    accuracy: 4
  },
  {
    postalCode: 2579,
    city: "Big Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6487,
    longitude: 150.2702,
    accuracy: 3
  },
  {
    postalCode: 2580,
    city: "Carrick",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7,
    longitude: 149.8833,
    accuracy: 4
  },
  {
    postalCode: 2580,
    city: "Bannaby",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.45,
    longitude: 149.9833,
    accuracy: 4
  },
  {
    postalCode: 2580,
    city: "Richlands",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3167,
    longitude: 149.8167,
    accuracy: 4
  },
  {
    postalCode: 2580,
    city: "Mayfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8979,
    longitude: 151.7361,
    accuracy: 4
  },
  {
    postalCode: 2580,
    city: "Chatsbury",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5485,
    longitude: 149.8179,
    accuracy: 4
  },
  {
    postalCode: 2580,
    city: "Middle Arm",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7108,
    longitude: 149.7312,
    accuracy: 3
  },
  {
    postalCode: 2580,
    city: "Wayo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.599,
    longitude: 149.6377,
    accuracy: 4
  },
  {
    postalCode: 2580,
    city: "Towrang",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7,
    longitude: 149.85,
    accuracy: 4
  },
  {
    postalCode: 2580,
    city: "Gundary",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8318,
    longitude: 149.7512,
    accuracy: 4
  },
  {
    postalCode: 2580,
    city: "Curraweela",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7108,
    longitude: 149.7312,
    accuracy: 3
  },
  {
    postalCode: 2580,
    city: "Myrtleville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4818,
    longitude: 149.8179,
    accuracy: 4
  },
  {
    postalCode: 2580,
    city: "Taralga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.404,
    longitude: 149.8196,
    accuracy: 4
  },
  {
    postalCode: 2580,
    city: "Currawang",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.9833,
    longitude: 149.5167,
    accuracy: 4
  },
  {
    postalCode: 2580,
    city: "Goulburn North",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7108,
    longitude: 149.7312,
    accuracy: 3
  },
  {
    postalCode: 2580,
    city: "Yarra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7833,
    longitude: 149.6333,
    accuracy: 4
  },
  {
    postalCode: 2580,
    city: "Quialigo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.9281,
    longitude: 149.7431,
    accuracy: 4
  },
  {
    postalCode: 2580,
    city: "Windellama",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.022,
    longitude: 149.8728,
    accuracy: 4
  },
  {
    postalCode: 2580,
    city: "Kingsdale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6535,
    longitude: 149.7676,
    accuracy: 3
  },
  {
    postalCode: 2580,
    city: "Yalbraith",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3,
    longitude: 149.75,
    accuracy: 4
  },
  {
    postalCode: 2580,
    city: "Baw Baw",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.75,
    longitude: 149.6667,
    accuracy: 4
  },
  {
    postalCode: 2580,
    city: "Tarlo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6,
    longitude: 149.8,
    accuracy: 4
  },
  {
    postalCode: 2580,
    city: "Stonequarry",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7108,
    longitude: 149.7312,
    accuracy: 3
  },
  {
    postalCode: 2580,
    city: "Bungonia",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8485,
    longitude: 149.9512,
    accuracy: 4
  },
  {
    postalCode: 2580,
    city: "Mount Fairy",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1833,
    longitude: 149.6,
    accuracy: 4
  },
  {
    postalCode: 2580,
    city: "Goulburn",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7515,
    longitude: 149.7209,
    accuracy: 4
  },
  {
    postalCode: 2580,
    city: "Wombeyan Caves",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3296,
    longitude: 150.0227,
    accuracy: 3
  },
  {
    postalCode: 2580,
    city: "Pomeroy",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6568,
    longitude: 149.5012,
    accuracy: 4
  },
  {
    postalCode: 2580,
    city: "Run-O-Waters",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7665,
    longitude: 149.6702,
    accuracy: 4
  },
  {
    postalCode: 2580,
    city: "Goulburn DC",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7108,
    longitude: 149.7312,
    accuracy: 3
  },
  {
    postalCode: 2580,
    city: "Tarago",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0978,
    longitude: 149.526,
    accuracy: 4
  },
  {
    postalCode: 2580,
    city: "Golspie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2985,
    longitude: 149.6679,
    accuracy: 4
  },
  {
    postalCode: 2580,
    city: "Lower Boro",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1667,
    longitude: 149.7667,
    accuracy: 4
  },
  {
    postalCode: 2580,
    city: "Woodhouselee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.55,
    longitude: 149.6333,
    accuracy: 4
  },
  {
    postalCode: 2580,
    city: "Tirrannaville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8167,
    longitude: 149.6833,
    accuracy: 4
  },
  {
    postalCode: 2580,
    city: "Bannister",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5985,
    longitude: 149.4929,
    accuracy: 4
  },
  {
    postalCode: 2580,
    city: "Roslyn",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.6776,
    longitude: 149.0173,
    accuracy: 4
  },
  {
    postalCode: 2580,
    city: "Paling Yards",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7108,
    longitude: 149.7312,
    accuracy: 3
  },
  {
    postalCode: 2580,
    city: "Greenwich Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5818,
    longitude: 149.9346,
    accuracy: 4
  },
  {
    postalCode: 2580,
    city: "Jerrong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7108,
    longitude: 149.7312,
    accuracy: 3
  },
  {
    postalCode: 2580,
    city: "Mummel",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7108,
    longitude: 149.7312,
    accuracy: 3
  },
  {
    postalCode: 2580,
    city: "Lake Bathurst",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0167,
    longitude: 149.65,
    accuracy: 4
  },
  {
    postalCode: 2580,
    city: "Parkesbourne",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7108,
    longitude: 149.7312,
    accuracy: 3
  },
  {
    postalCode: 2580,
    city: "Brisbane Grove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7108,
    longitude: 149.7312,
    accuracy: 3
  },
  {
    postalCode: 2580,
    city: "Boxers Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7108,
    longitude: 149.7312,
    accuracy: 3
  },
  {
    postalCode: 2580,
    city: "Wiarborough",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7108,
    longitude: 149.7312,
    accuracy: 3
  },
  {
    postalCode: 2581,
    city: "Dalton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.718,
    longitude: 149.1932,
    accuracy: 4
  },
  {
    postalCode: 2581,
    city: "Broadway",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7466,
    longitude: 149.305,
    accuracy: 3
  },
  {
    postalCode: 2581,
    city: "Gurrundah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.661,
    longitude: 149.4068,
    accuracy: 4
  },
  {
    postalCode: 2581,
    city: "Lake George",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1452,
    longitude: 149.4752,
    accuracy: 4
  },
  {
    postalCode: 2581,
    city: "Blakney Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.633,
    longitude: 149.0212,
    accuracy: 4
  },
  {
    postalCode: 2581,
    city: "Merrill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7466,
    longitude: 149.305,
    accuracy: 3
  },
  {
    postalCode: 2581,
    city: "Biala",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5946,
    longitude: 149.2626,
    accuracy: 4
  },
  {
    postalCode: 2581,
    city: "Bellmount Forest",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7466,
    longitude: 149.305,
    accuracy: 3
  },
  {
    postalCode: 2581,
    city: "Oolong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7907,
    longitude: 149.179,
    accuracy: 4
  },
  {
    postalCode: 2581,
    city: "Wollogorang",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7466,
    longitude: 149.305,
    accuracy: 3
  },
  {
    postalCode: 2581,
    city: "Breadalbane",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8,
    longitude: 149.4833,
    accuracy: 4
  },
  {
    postalCode: 2581,
    city: "Bevendale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5333,
    longitude: 149.1167,
    accuracy: 4
  },
  {
    postalCode: 2581,
    city: "Collector",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.9167,
    longitude: 149.4333,
    accuracy: 4
  },
  {
    postalCode: 2581,
    city: "Lade Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7466,
    longitude: 149.305,
    accuracy: 3
  },
  {
    postalCode: 2581,
    city: "Gunning",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7825,
    longitude: 149.2662,
    accuracy: 4
  },
  {
    postalCode: 2581,
    city: "Lerida",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8833,
    longitude: 149.3333,
    accuracy: 4
  },
  {
    postalCode: 2581,
    city: "Cullerin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7833,
    longitude: 149.4167,
    accuracy: 4
  },
  {
    postalCode: 2582,
    city: "Mullion",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1252,
    longitude: 149.1276,
    accuracy: 4
  },
  {
    postalCode: 2582,
    city: "Jeir",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0563,
    longitude: 148.9719,
    accuracy: 4
  },
  {
    postalCode: 2582,
    city: "Yass",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8404,
    longitude: 148.9099,
    accuracy: 4
  },
  {
    postalCode: 2582,
    city: "Jerrawa",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7788,
    longitude: 149.0748,
    accuracy: 4
  },
  {
    postalCode: 2582,
    city: "Cavan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0129,
    longitude: 148.7983,
    accuracy: 4
  },
  {
    postalCode: 2582,
    city: "Good Hope",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.9167,
    longitude: 148.8167,
    accuracy: 4
  },
  {
    postalCode: 2582,
    city: "Wee Jasper",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.15,
    longitude: 148.7,
    accuracy: 4
  },
  {
    postalCode: 2582,
    city: "Bango",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7363,
    longitude: 148.8274,
    accuracy: 3
  },
  {
    postalCode: 2582,
    city: "Bowning",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7449,
    longitude: 148.809,
    accuracy: 4
  },
  {
    postalCode: 2582,
    city: "Manton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7363,
    longitude: 148.8274,
    accuracy: 3
  },
  {
    postalCode: 2582,
    city: "Bookham",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8126,
    longitude: 148.6396,
    accuracy: 4
  },
  {
    postalCode: 2582,
    city: "Boambolo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7363,
    longitude: 148.8274,
    accuracy: 3
  },
  {
    postalCode: 2582,
    city: "Kangiara",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5985,
    longitude: 148.7512,
    accuracy: 4
  },
  {
    postalCode: 2582,
    city: "Yass River",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7363,
    longitude: 148.8274,
    accuracy: 3
  },
  {
    postalCode: 2582,
    city: "Laverstock",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7363,
    longitude: 148.8274,
    accuracy: 3
  },
  {
    postalCode: 2582,
    city: "Marchmont",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7363,
    longitude: 148.8274,
    accuracy: 3
  },
  {
    postalCode: 2582,
    city: "Murrumbateman",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.972,
    longitude: 149.0298,
    accuracy: 4
  },
  {
    postalCode: 2582,
    city: "Burrinjuck",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35,
    longitude: 148.6,
    accuracy: 4
  },
  {
    postalCode: 2582,
    city: "Berremangra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8,
    longitude: 148.4833,
    accuracy: 4
  },
  {
    postalCode: 2582,
    city: "Woolgarlo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7363,
    longitude: 148.8274,
    accuracy: 3
  },
  {
    postalCode: 2582,
    city: "Narrangullen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7363,
    longitude: 148.8274,
    accuracy: 3
  },
  {
    postalCode: 2583,
    city: "Binda",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3333,
    longitude: 149.3667,
    accuracy: 4
  },
  {
    postalCode: 2583,
    city: "Laggan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4167,
    longitude: 149.5333,
    accuracy: 4
  },
  {
    postalCode: 2583,
    city: "Narrawa",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4152,
    longitude: 149.0846,
    accuracy: 4
  },
  {
    postalCode: 2583,
    city: "Limerick",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1929,
    longitude: 149.2818,
    accuracy: 3
  },
  {
    postalCode: 2583,
    city: "Grabben Gullen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5402,
    longitude: 149.4012,
    accuracy: 4
  },
  {
    postalCode: 2583,
    city: "Crookwell",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4593,
    longitude: 149.4714,
    accuracy: 4
  },
  {
    postalCode: 2583,
    city: "Pejar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5833,
    longitude: 149.5833,
    accuracy: 4
  },
  {
    postalCode: 2583,
    city: "Rugby",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3833,
    longitude: 149.0167,
    accuracy: 4
  },
  {
    postalCode: 2583,
    city: "Tuena",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0235,
    longitude: 149.3262,
    accuracy: 4
  },
  {
    postalCode: 2583,
    city: "Lost River",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3411,
    longitude: 149.348,
    accuracy: 3
  },
  {
    postalCode: 2583,
    city: "Bigga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0833,
    longitude: 149.15,
    accuracy: 4
  },
  {
    postalCode: 2583,
    city: "Crooked Corner",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1929,
    longitude: 149.2818,
    accuracy: 3
  },
  {
    postalCode: 2583,
    city: "Wheeo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5,
    longitude: 149.2833,
    accuracy: 4
  },
  {
    postalCode: 2583,
    city: "Blanket Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.15,
    longitude: 149.2167,
    accuracy: 4
  },
  {
    postalCode: 2583,
    city: "Kialla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5333,
    longitude: 149.45,
    accuracy: 4
  },
  {
    postalCode: 2583,
    city: "Peelwood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1068,
    longitude: 149.4346,
    accuracy: 4
  },
  {
    postalCode: 2583,
    city: "Fullerton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2333,
    longitude: 149.55,
    accuracy: 4
  },
  {
    postalCode: 2584,
    city: "Binalong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6717,
    longitude: 148.6348,
    accuracy: 4
  },
  {
    postalCode: 2585,
    city: "Galong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6,
    longitude: 148.55,
    accuracy: 4
  },
  {
    postalCode: 2586,
    city: "Boorowa",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4366,
    longitude: 148.7163,
    accuracy: 4
  },
  {
    postalCode: 2586,
    city: "Frogmore",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2667,
    longitude: 148.85,
    accuracy: 4
  },
  {
    postalCode: 2586,
    city: "Murringo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3,
    longitude: 148.5167,
    accuracy: 4
  },
  {
    postalCode: 2586,
    city: "Godfreys Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1485,
    longitude: 148.7012,
    accuracy: 4
  },
  {
    postalCode: 2586,
    city: "Taylors Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2735,
    longitude: 149.0179,
    accuracy: 4
  },
  {
    postalCode: 2586,
    city: "Rye Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5152,
    longitude: 148.9179,
    accuracy: 4
  },
  {
    postalCode: 2586,
    city: "Reids Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1223,
    longitude: 149.0785,
    accuracy: 4
  },
  {
    postalCode: 2587,
    city: "Wombat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4167,
    longitude: 148.25,
    accuracy: 4
  },
  {
    postalCode: 2587,
    city: "Cunningar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5607,
    longitude: 148.4393,
    accuracy: 4
  },
  {
    postalCode: 2587,
    city: "Murrumburrah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5541,
    longitude: 148.3676,
    accuracy: 4
  },
  {
    postalCode: 2587,
    city: "Nubba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5329,
    longitude: 148.2352,
    accuracy: 4
  },
  {
    postalCode: 2587,
    city: "Beggan Beggan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6818,
    longitude: 148.2679,
    accuracy: 4
  },
  {
    postalCode: 2587,
    city: "Kingsvale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4333,
    longitude: 148.3167,
    accuracy: 4
  },
  {
    postalCode: 2587,
    city: "Harden",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5541,
    longitude: 148.3676,
    accuracy: 4
  },
  {
    postalCode: 2587,
    city: "Mcmahons Reef",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6667,
    longitude: 148.45,
    accuracy: 4
  },
  {
    postalCode: 2588,
    city: "Wallendbeen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5333,
    longitude: 148.15,
    accuracy: 4
  },
  {
    postalCode: 2590,
    city: "Bethungra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.761,
    longitude: 147.8554,
    accuracy: 4
  },
  {
    postalCode: 2590,
    city: "Cootamundra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6409,
    longitude: 148.0284,
    accuracy: 4
  },
  {
    postalCode: 2590,
    city: "Illabo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8318,
    longitude: 147.7537,
    accuracy: 4
  },
  {
    postalCode: 2594,
    city: "Burrangong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2916,
    longitude: 148.2481,
    accuracy: 4
  },
  {
    postalCode: 2594,
    city: "Young",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3135,
    longitude: 148.3011,
    accuracy: 4
  },
  {
    postalCode: 2594,
    city: "Bulla Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2339,
    longitude: 148.1092,
    accuracy: 3
  },
  {
    postalCode: 2594,
    city: "Milvale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3167,
    longitude: 147.9167,
    accuracy: 4
  },
  {
    postalCode: 2594,
    city: "Monteagle",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1833,
    longitude: 148.35,
    accuracy: 4
  },
  {
    postalCode: 2594,
    city: "Maimuru",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2667,
    longitude: 148.2667,
    accuracy: 4
  },
  {
    postalCode: 2594,
    city: "Barwang",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2339,
    longitude: 148.1092,
    accuracy: 3
  },
  {
    postalCode: 2594,
    city: "Tubbul",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2652,
    longitude: 148.0012,
    accuracy: 4
  },
  {
    postalCode: 2594,
    city: "Kikiamah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2339,
    longitude: 148.1092,
    accuracy: 3
  },
  {
    postalCode: 2594,
    city: "Weedallion",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1985,
    longitude: 147.9512,
    accuracy: 4
  },
  {
    postalCode: 2594,
    city: "Memagong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2339,
    longitude: 148.1092,
    accuracy: 3
  },
  {
    postalCode: 2594,
    city: "Bribbaree",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1199,
    longitude: 147.8792,
    accuracy: 4
  },
  {
    postalCode: 2594,
    city: "Berthong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2339,
    longitude: 148.1092,
    accuracy: 3
  },
  {
    postalCode: 2594,
    city: "Thuddungra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.15,
    longitude: 148.1167,
    accuracy: 4
  },
  {
    postalCode: 2611,
    city: "Bimberi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3503,
    longitude: 149.0155,
    accuracy: 3
  },
  {
    postalCode: 2611,
    city: "Brindabella",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4,
    longitude: 148.7333,
    accuracy: 4
  },
  {
    postalCode: 2611,
    city: "Cooleman",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3503,
    longitude: 149.0155,
    accuracy: 3
  },
  {
    postalCode: 2618,
    city: "Springrange",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.076,
    longitude: 149.0889,
    accuracy: 4
  },
  {
    postalCode: 2618,
    city: "Nanima",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0129,
    longitude: 149.1277,
    accuracy: 4
  },
  {
    postalCode: 2618,
    city: "Wallaroo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1468,
    longitude: 149.0128,
    accuracy: 4
  },
  {
    postalCode: 2619,
    city: "Jerrabomberra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3844,
    longitude: 149.2025,
    accuracy: 4
  },
  {
    postalCode: 2620,
    city: "Queanbeyan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3549,
    longitude: 149.232,
    accuracy: 4
  },
  {
    postalCode: 2620,
    city: "Yarrow",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3914,
    longitude: 149.2166,
    accuracy: 3
  },
  {
    postalCode: 2620,
    city: "Tinderry",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7348,
    longitude: 149.34,
    accuracy: 4
  },
  {
    postalCode: 2620,
    city: "Queanbeyan East",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3428,
    longitude: 149.2444,
    accuracy: 3
  },
  {
    postalCode: 2620,
    city: "The Ridgeway",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3389,
    longitude: 149.2609,
    accuracy: 4
  },
  {
    postalCode: 2620,
    city: "Sutton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1667,
    longitude: 149.25,
    accuracy: 4
  },
  {
    postalCode: 2620,
    city: "Williamsdale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.5667,
    longitude: 149.1333,
    accuracy: 4
  },
  {
    postalCode: 2620,
    city: "Queanbeyan West",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3914,
    longitude: 149.2166,
    accuracy: 3
  },
  {
    postalCode: 2620,
    city: "Karabar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.376,
    longitude: 149.2328,
    accuracy: 4
  },
  {
    postalCode: 2620,
    city: "Burra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.5594,
    longitude: 149.2235,
    accuracy: 4
  },
  {
    postalCode: 2620,
    city: "Michelago",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7167,
    longitude: 149.1667,
    accuracy: 4
  },
  {
    postalCode: 2620,
    city: "Tralee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3914,
    longitude: 149.2166,
    accuracy: 3
  },
  {
    postalCode: 2620,
    city: "Royalla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.5167,
    longitude: 149.15,
    accuracy: 4
  },
  {
    postalCode: 2620,
    city: "Crestwood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3484,
    longitude: 149.2176,
    accuracy: 4
  },
  {
    postalCode: 2620,
    city: "Urila",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3914,
    longitude: 149.2166,
    accuracy: 3
  },
  {
    postalCode: 2620,
    city: "Gundaroo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0333,
    longitude: 149.25,
    accuracy: 4
  },
  {
    postalCode: 2620,
    city: "Clear Range",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3914,
    longitude: 149.2166,
    accuracy: 3
  },
  {
    postalCode: 2620,
    city: "Carwoola",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3784,
    longitude: 149.3215,
    accuracy: 4
  },
  {
    postalCode: 2620,
    city: "The Angle",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3914,
    longitude: 149.2166,
    accuracy: 3
  },
  {
    postalCode: 2620,
    city: "Wamboin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2507,
    longitude: 149.3328,
    accuracy: 4
  },
  {
    postalCode: 2620,
    city: "Environa",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3914,
    longitude: 149.2166,
    accuracy: 3
  },
  {
    postalCode: 2620,
    city: "Greenleigh",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3667,
    longitude: 149.2528,
    accuracy: 4
  },
  {
    postalCode: 2620,
    city: "Queanbeyan DC",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3914,
    longitude: 149.2166,
    accuracy: 3
  },
  {
    postalCode: 2620,
    city: "Googong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4387,
    longitude: 149.2131,
    accuracy: 4
  },
  {
    postalCode: 2621,
    city: "Bungendore",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2538,
    longitude: 149.4401,
    accuracy: 4
  },
  {
    postalCode: 2621,
    city: "Anembo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3262,
    longitude: 149.4297,
    accuracy: 3
  },
  {
    postalCode: 2621,
    city: "Bywong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1648,
    longitude: 149.3289,
    accuracy: 4
  },
  {
    postalCode: 2621,
    city: "Forbes Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3262,
    longitude: 149.4297,
    accuracy: 3
  },
  {
    postalCode: 2621,
    city: "Hoskinstown",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4167,
    longitude: 149.45,
    accuracy: 4
  },
  {
    postalCode: 2621,
    city: "Primrose Valley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3262,
    longitude: 149.4297,
    accuracy: 3
  },
  {
    postalCode: 2621,
    city: "Rossi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4667,
    longitude: 149.5,
    accuracy: 4
  },
  {
    postalCode: 2622,
    city: "Bendoura",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.5167,
    longitude: 149.7,
    accuracy: 4
  },
  {
    postalCode: 2622,
    city: "Corang",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2,
    longitude: 150.0167,
    accuracy: 4
  },
  {
    postalCode: 2622,
    city: "Braidwood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4415,
    longitude: 149.7998,
    accuracy: 4
  },
  {
    postalCode: 2622,
    city: "Ballalaba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4771,
    longitude: 149.7702,
    accuracy: 3
  },
  {
    postalCode: 2622,
    city: "Nerriga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1167,
    longitude: 150.0833,
    accuracy: 4
  },
  {
    postalCode: 2622,
    city: "Warri",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.5617,
    longitude: 149.2356,
    accuracy: 4
  },
  {
    postalCode: 2622,
    city: "Araluen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.6459,
    longitude: 149.8174,
    accuracy: 4
  },
  {
    postalCode: 2622,
    city: "Jinden",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4068,
    longitude: 149.8505,
    accuracy: 3
  },
  {
    postalCode: 2622,
    city: "Reidsdale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.5818,
    longitude: 149.8512,
    accuracy: 4
  },
  {
    postalCode: 2622,
    city: "Mulloon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2982,
    longitude: 149.6088,
    accuracy: 4
  },
  {
    postalCode: 2622,
    city: "Boro",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.15,
    longitude: 149.6667,
    accuracy: 4
  },
  {
    postalCode: 2622,
    city: "Charleys Forest",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4068,
    longitude: 149.8505,
    accuracy: 3
  },
  {
    postalCode: 2622,
    city: "Endrick",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4068,
    longitude: 149.8505,
    accuracy: 3
  },
  {
    postalCode: 2622,
    city: "Back Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4068,
    longitude: 149.8505,
    accuracy: 3
  },
  {
    postalCode: 2622,
    city: "Oallen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1665,
    longitude: 149.9622,
    accuracy: 4
  },
  {
    postalCode: 2622,
    city: "Oranmeir",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4771,
    longitude: 149.7702,
    accuracy: 3
  },
  {
    postalCode: 2622,
    city: "Krawarree",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8152,
    longitude: 149.6346,
    accuracy: 4
  },
  {
    postalCode: 2622,
    city: "Snowball",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.9333,
    longitude: 149.5833,
    accuracy: 4
  },
  {
    postalCode: 2622,
    city: "Larbert",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2985,
    longitude: 149.7679,
    accuracy: 4
  },
  {
    postalCode: 2622,
    city: "Palerang",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4068,
    longitude: 149.8505,
    accuracy: 3
  },
  {
    postalCode: 2622,
    city: "Merricumbene",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7335,
    longitude: 149.896,
    accuracy: 4
  },
  {
    postalCode: 2622,
    city: "Wog Wog",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4068,
    longitude: 149.8505,
    accuracy: 3
  },
  {
    postalCode: 2622,
    city: "Touga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.9546,
    longitude: 150.0911,
    accuracy: 4
  },
  {
    postalCode: 2622,
    city: "St George",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4068,
    longitude: 149.8505,
    accuracy: 3
  },
  {
    postalCode: 2622,
    city: "Coolumburra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4068,
    longitude: 149.8505,
    accuracy: 3
  },
  {
    postalCode: 2622,
    city: "Gundillion",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4771,
    longitude: 149.7702,
    accuracy: 3
  },
  {
    postalCode: 2622,
    city: "Manar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3,
    longitude: 149.7,
    accuracy: 4
  },
  {
    postalCode: 2622,
    city: "Mayfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8979,
    longitude: 151.7361,
    accuracy: 4
  },
  {
    postalCode: 2622,
    city: "Northangera",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4068,
    longitude: 149.8505,
    accuracy: 3
  },
  {
    postalCode: 2622,
    city: "Jembaicumbene",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4771,
    longitude: 149.7702,
    accuracy: 3
  },
  {
    postalCode: 2622,
    city: "Jerrabattgulla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4068,
    longitude: 149.8505,
    accuracy: 3
  },
  {
    postalCode: 2622,
    city: "Farringdon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4068,
    longitude: 149.8505,
    accuracy: 3
  },
  {
    postalCode: 2622,
    city: "Tomboye",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4068,
    longitude: 149.8505,
    accuracy: 3
  },
  {
    postalCode: 2622,
    city: "Wyanbene",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4068,
    longitude: 149.8505,
    accuracy: 3
  },
  {
    postalCode: 2622,
    city: "Durran Durra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4068,
    longitude: 149.8505,
    accuracy: 3
  },
  {
    postalCode: 2622,
    city: "Quiera",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4068,
    longitude: 149.8505,
    accuracy: 3
  },
  {
    postalCode: 2622,
    city: "Monga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.5755,
    longitude: 149.9204,
    accuracy: 4
  },
  {
    postalCode: 2622,
    city: "Tolwong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4068,
    longitude: 149.8505,
    accuracy: 3
  },
  {
    postalCode: 2622,
    city: "Hereford Hall",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4068,
    longitude: 149.8505,
    accuracy: 3
  },
  {
    postalCode: 2622,
    city: "Budawang",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4068,
    longitude: 149.8505,
    accuracy: 3
  },
  {
    postalCode: 2622,
    city: "Jingera",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4068,
    longitude: 149.8505,
    accuracy: 3
  },
  {
    postalCode: 2622,
    city: "Kindervale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4068,
    longitude: 149.8505,
    accuracy: 3
  },
  {
    postalCode: 2622,
    city: "Murrengenburg",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4068,
    longitude: 149.8505,
    accuracy: 3
  },
  {
    postalCode: 2622,
    city: "Majors Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.5689,
    longitude: 149.7455,
    accuracy: 4
  },
  {
    postalCode: 2622,
    city: "Sassafras",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1,
    longitude: 150.25,
    accuracy: 4
  },
  {
    postalCode: 2622,
    city: "Marlowe",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3,
    longitude: 149.8833,
    accuracy: 4
  },
  {
    postalCode: 2622,
    city: "Harolds Cross",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4068,
    longitude: 149.8505,
    accuracy: 3
  },
  {
    postalCode: 2622,
    city: "Neringla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4068,
    longitude: 149.8505,
    accuracy: 3
  },
  {
    postalCode: 2622,
    city: "Bulee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4068,
    longitude: 149.8505,
    accuracy: 3
  },
  {
    postalCode: 2622,
    city: "Mongarlowe",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4333,
    longitude: 149.9333,
    accuracy: 4
  },
  {
    postalCode: 2622,
    city: "Berlang",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4068,
    longitude: 149.8505,
    accuracy: 3
  },
  {
    postalCode: 2622,
    city: "Tianjara",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1167,
    longitude: 150.3333,
    accuracy: 4
  },
  {
    postalCode: 2622,
    city: "Bombay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4068,
    longitude: 149.8505,
    accuracy: 3
  },
  {
    postalCode: 2623,
    city: "Captains Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.5911,
    longitude: 149.4452,
    accuracy: 4
  },
  {
    postalCode: 2624,
    city: "Charlottes Pass",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.6077,
    longitude: 148.3881,
    accuracy: 3
  },
  {
    postalCode: 2624,
    city: "Smiggin Holes",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.3932,
    longitude: 148.4337,
    accuracy: 4
  },
  {
    postalCode: 2624,
    city: "Perisher Valley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.406,
    longitude: 148.4117,
    accuracy: 4
  },
  {
    postalCode: 2625,
    city: "Thredbo Village",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.5052,
    longitude: 148.3076,
    accuracy: 4
  },
  {
    postalCode: 2625,
    city: "Thredbo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.5052,
    longitude: 148.3076,
    accuracy: 4
  },
  {
    postalCode: 2626,
    city: "Bredbo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.95,
    longitude: 149.15,
    accuracy: 4
  },
  {
    postalCode: 2626,
    city: "Bumbalong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.9083,
    longitude: 149.1583,
    accuracy: 3
  },
  {
    postalCode: 2626,
    city: "Colinton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8667,
    longitude: 149.1667,
    accuracy: 4
  },
  {
    postalCode: 2627,
    city: "Kosciuszko National Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.2644,
    longitude: 148.4818,
    accuracy: 4
  },
  {
    postalCode: 2627,
    city: "Ingebirah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.65,
    longitude: 148.5,
    accuracy: 4
  },
  {
    postalCode: 2627,
    city: "Jindabyne",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.4162,
    longitude: 148.625,
    accuracy: 4
  },
  {
    postalCode: 2627,
    city: "Pilot Wilderness",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.4102,
    longitude: 148.5365,
    accuracy: 3
  },
  {
    postalCode: 2627,
    city: "Grosses Plain",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.4102,
    longitude: 148.5365,
    accuracy: 3
  },
  {
    postalCode: 2627,
    city: "Crackenback",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.4429,
    longitude: 148.5001,
    accuracy: 4
  },
  {
    postalCode: 2627,
    city: "East Jindabyne",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.4102,
    longitude: 148.5365,
    accuracy: 3
  },
  {
    postalCode: 2627,
    city: "Kalkite",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.3318,
    longitude: 148.6429,
    accuracy: 4
  },
  {
    postalCode: 2627,
    city: "Kosciuszko",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.2644,
    longitude: 148.4818,
    accuracy: 4
  },
  {
    postalCode: 2627,
    city: "Moonbah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.4818,
    longitude: 148.5512,
    accuracy: 4
  },
  {
    postalCode: 2628,
    city: "Beloka",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.5333,
    longitude: 148.7333,
    accuracy: 4
  },
  {
    postalCode: 2628,
    city: "Eucumbene",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.1383,
    longitude: 148.6349,
    accuracy: 4
  },
  {
    postalCode: 2628,
    city: "Hill Top",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3479,
    longitude: 150.4955,
    accuracy: 4
  },
  {
    postalCode: 2628,
    city: "Snowy Plain",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.1167,
    longitude: 148.8667,
    accuracy: 4
  },
  {
    postalCode: 2628,
    city: "Nimmo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.3943,
    longitude: 148.7809,
    accuracy: 3
  },
  {
    postalCode: 2628,
    city: "Dalgety",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.5,
    longitude: 148.8333,
    accuracy: 4
  },
  {
    postalCode: 2628,
    city: "Berridale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.3657,
    longitude: 148.8268,
    accuracy: 4
  },
  {
    postalCode: 2628,
    city: "Paupong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.5833,
    longitude: 148.6833,
    accuracy: 4
  },
  {
    postalCode: 2628,
    city: "Byadbo Wilderness",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.3943,
    longitude: 148.7809,
    accuracy: 3
  },
  {
    postalCode: 2628,
    city: "Braemar Bay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.3943,
    longitude: 148.7809,
    accuracy: 3
  },
  {
    postalCode: 2628,
    city: "Avonside",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.3943,
    longitude: 148.7809,
    accuracy: 3
  },
  {
    postalCode: 2628,
    city: "Rocky Plain",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.3943,
    longitude: 148.7809,
    accuracy: 3
  },
  {
    postalCode: 2628,
    city: "Cootralantra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.2652,
    longitude: 148.8679,
    accuracy: 4
  },
  {
    postalCode: 2628,
    city: "Numbla Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.65,
    longitude: 148.8,
    accuracy: 4
  },
  {
    postalCode: 2629,
    city: "Tantangara",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8167,
    longitude: 148.5667,
    accuracy: 4
  },
  {
    postalCode: 2629,
    city: "Cabramurra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.9357,
    longitude: 148.3839,
    accuracy: 4
  },
  {
    postalCode: 2629,
    city: "Anglers Reach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0167,
    longitude: 148.6667,
    accuracy: 4
  },
  {
    postalCode: 2629,
    city: "Adaminaby",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.9969,
    longitude: 148.7697,
    accuracy: 4
  },
  {
    postalCode: 2629,
    city: "Old Adaminaby",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0349,
    longitude: 148.7016,
    accuracy: 4
  },
  {
    postalCode: 2629,
    city: "Long Plain",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.9287,
    longitude: 148.6269,
    accuracy: 3
  },
  {
    postalCode: 2629,
    city: "Kiandra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8833,
    longitude: 148.5,
    accuracy: 4
  },
  {
    postalCode: 2629,
    city: "Bolaro",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.9287,
    longitude: 148.6269,
    accuracy: 3
  },
  {
    postalCode: 2629,
    city: "Yaouk",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8152,
    longitude: 148.8012,
    accuracy: 4
  },
  {
    postalCode: 2629,
    city: "Providence Portal",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.9287,
    longitude: 148.6269,
    accuracy: 3
  },
  {
    postalCode: 2630,
    city: "Rhine Falls",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.1667,
    longitude: 148.8667,
    accuracy: 4
  },
  {
    postalCode: 2630,
    city: "Bungarby",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.2254,
    longitude: 148.9852,
    accuracy: 3
  },
  {
    postalCode: 2630,
    city: "Bunyan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.1696,
    longitude: 149.1538,
    accuracy: 3
  },
  {
    postalCode: 2630,
    city: "Cooma",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.2352,
    longitude: 149.1241,
    accuracy: 4
  },
  {
    postalCode: 2630,
    city: "Jerangle",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8667,
    longitude: 149.3667,
    accuracy: 4
  },
  {
    postalCode: 2630,
    city: "Billilingra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0398,
    longitude: 149.249,
    accuracy: 3
  },
  {
    postalCode: 2630,
    city: "Maffra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.5318,
    longitude: 148.9679,
    accuracy: 4
  },
  {
    postalCode: 2630,
    city: "Bobundara",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.5167,
    longitude: 148.9333,
    accuracy: 4
  },
  {
    postalCode: 2630,
    city: "Coolringdon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.2833,
    longitude: 148.9833,
    accuracy: 4
  },
  {
    postalCode: 2630,
    city: "Frying Pan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0398,
    longitude: 149.249,
    accuracy: 3
  },
  {
    postalCode: 2630,
    city: "Badja",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0527,
    longitude: 149.5498,
    accuracy: 4
  },
  {
    postalCode: 2630,
    city: "Middle Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0398,
    longitude: 149.249,
    accuracy: 3
  },
  {
    postalCode: 2630,
    city: "Numeralla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.1667,
    longitude: 149.3333,
    accuracy: 4
  },
  {
    postalCode: 2630,
    city: "Peak View",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.2254,
    longitude: 148.9852,
    accuracy: 3
  },
  {
    postalCode: 2630,
    city: "Rock Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.35,
    longitude: 149.2,
    accuracy: 4
  },
  {
    postalCode: 2630,
    city: "Binjura",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0398,
    longitude: 149.249,
    accuracy: 3
  },
  {
    postalCode: 2630,
    city: "Dairymans Plains",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0398,
    longitude: 149.249,
    accuracy: 3
  },
  {
    postalCode: 2630,
    city: "The Brothers",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0398,
    longitude: 149.249,
    accuracy: 3
  },
  {
    postalCode: 2630,
    city: "Glen Fergus",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0398,
    longitude: 149.249,
    accuracy: 3
  },
  {
    postalCode: 2630,
    city: "Dry Plain",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.1167,
    longitude: 148.8667,
    accuracy: 4
  },
  {
    postalCode: 2630,
    city: "Dangelong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0398,
    longitude: 149.249,
    accuracy: 3
  },
  {
    postalCode: 2630,
    city: "Springfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3433,
    longitude: 149.2635,
    accuracy: 4
  },
  {
    postalCode: 2630,
    city: "Cooma North",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0398,
    longitude: 149.249,
    accuracy: 3
  },
  {
    postalCode: 2630,
    city: "Countegany",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.1833,
    longitude: 149.45,
    accuracy: 4
  },
  {
    postalCode: 2630,
    city: "Middlingbank",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.2167,
    longitude: 148.8333,
    accuracy: 4
  },
  {
    postalCode: 2630,
    city: "Wambrook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0398,
    longitude: 149.249,
    accuracy: 3
  },
  {
    postalCode: 2630,
    city: "Buckenderra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0398,
    longitude: 149.249,
    accuracy: 3
  },
  {
    postalCode: 2630,
    city: "Murrumbucca",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0985,
    longitude: 149.0512,
    accuracy: 4
  },
  {
    postalCode: 2630,
    city: "Polo Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.2315,
    longitude: 149.151,
    accuracy: 4
  },
  {
    postalCode: 2630,
    city: "Pine Valley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0398,
    longitude: 149.249,
    accuracy: 3
  },
  {
    postalCode: 2630,
    city: "Rose Valley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7235,
    longitude: 150.8096,
    accuracy: 4
  },
  {
    postalCode: 2630,
    city: "Myalla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.4167,
    longitude: 149.1167,
    accuracy: 4
  },
  {
    postalCode: 2630,
    city: "Tuross",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0533,
    longitude: 150.1332,
    accuracy: 4
  },
  {
    postalCode: 2630,
    city: "Shannons Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0398,
    longitude: 149.249,
    accuracy: 3
  },
  {
    postalCode: 2630,
    city: "Carlaminda",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.2601,
    longitude: 149.3051,
    accuracy: 4
  },
  {
    postalCode: 2630,
    city: "Chakola",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0985,
    longitude: 149.1679,
    accuracy: 4
  },
  {
    postalCode: 2630,
    city: "Ironmungy",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.5833,
    longitude: 148.9333,
    accuracy: 4
  },
  {
    postalCode: 2630,
    city: "Jimenbuen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0398,
    longitude: 149.249,
    accuracy: 3
  },
  {
    postalCode: 2630,
    city: "Arable",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.35,
    longitude: 149.0333,
    accuracy: 4
  },
  {
    postalCode: 2631,
    city: "Holts Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.6667,
    longitude: 149.2833,
    accuracy: 4
  },
  {
    postalCode: 2631,
    city: "Winifred",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.6223,
    longitude: 149.3001,
    accuracy: 3
  },
  {
    postalCode: 2631,
    city: "Jincumbilly",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.7167,
    longitude: 149.2167,
    accuracy: 4
  },
  {
    postalCode: 2631,
    city: "Glen Allen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.6985,
    longitude: 149.3679,
    accuracy: 4
  },
  {
    postalCode: 2631,
    city: "Mount Cooper",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.6833,
    longitude: 149.2167,
    accuracy: 4
  },
  {
    postalCode: 2631,
    city: "Greenlands",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.6223,
    longitude: 149.3001,
    accuracy: 3
  },
  {
    postalCode: 2631,
    city: "Steeple Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.5485,
    longitude: 149.3846,
    accuracy: 4
  },
  {
    postalCode: 2631,
    city: "Nimmitabel",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.5119,
    longitude: 149.2838,
    accuracy: 4
  },
  {
    postalCode: 2631,
    city: "Boco",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.6223,
    longitude: 149.3001,
    accuracy: 3
  },
  {
    postalCode: 2631,
    city: "Ando",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.7167,
    longitude: 149.25,
    accuracy: 4
  },
  {
    postalCode: 2631,
    city: "Creewah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.75,
    longitude: 149.3667,
    accuracy: 4
  },
  {
    postalCode: 2631,
    city: "Kybeyan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.3485,
    longitude: 149.4179,
    accuracy: 4
  },
  {
    postalCode: 2632,
    city: "Cathcart",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.8333,
    longitude: 149.3667,
    accuracy: 4
  },
  {
    postalCode: 2632,
    city: "Paddys Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.9232,
    longitude: 149.2451,
    accuracy: 3
  },
  {
    postalCode: 2632,
    city: "Rockton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -37.1318,
    longitude: 149.3179,
    accuracy: 4
  },
  {
    postalCode: 2632,
    city: "Palarang",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.9232,
    longitude: 149.2451,
    accuracy: 3
  },
  {
    postalCode: 2632,
    city: "Bukalong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.7985,
    longitude: 149.2012,
    accuracy: 4
  },
  {
    postalCode: 2632,
    city: "Lords Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.9232,
    longitude: 149.2451,
    accuracy: 3
  },
  {
    postalCode: 2632,
    city: "Mount Darragh",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.8485,
    longitude: 149.5179,
    accuracy: 4
  },
  {
    postalCode: 2632,
    city: "Gunningrah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.9232,
    longitude: 149.2451,
    accuracy: 3
  },
  {
    postalCode: 2632,
    city: "Mila",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -37.0485,
    longitude: 149.1679,
    accuracy: 4
  },
  {
    postalCode: 2632,
    city: "Merriangaah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.9232,
    longitude: 149.2451,
    accuracy: 3
  },
  {
    postalCode: 2632,
    city: "Cambalong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.8167,
    longitude: 149.0833,
    accuracy: 4
  },
  {
    postalCode: 2632,
    city: "Rosemeath",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.9232,
    longitude: 149.2451,
    accuracy: 3
  },
  {
    postalCode: 2632,
    city: "Bombala",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.9121,
    longitude: 149.2367,
    accuracy: 4
  },
  {
    postalCode: 2632,
    city: "Coolumbooka",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.9232,
    longitude: 149.2451,
    accuracy: 3
  },
  {
    postalCode: 2632,
    city: "Bondi Forest",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.9232,
    longitude: 149.2451,
    accuracy: 3
  },
  {
    postalCode: 2632,
    city: "Bibbenluke",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.8134,
    longitude: 149.2863,
    accuracy: 4
  },
  {
    postalCode: 2632,
    city: "Craigie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -37.0833,
    longitude: 149.05,
    accuracy: 4
  },
  {
    postalCode: 2632,
    city: "Quidong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.9232,
    longitude: 149.2451,
    accuracy: 3
  },
  {
    postalCode: 2633,
    city: "Corrowong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.9802,
    longitude: 148.9291,
    accuracy: 3
  },
  {
    postalCode: 2633,
    city: "Tombong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.9,
    longitude: 148.9319,
    accuracy: 4
  },
  {
    postalCode: 2633,
    city: "Delegate",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -37.0438,
    longitude: 148.9415,
    accuracy: 4
  },
  {
    postalCode: 2640,
    city: "Talmalmo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.9318,
    longitude: 147.5012,
    accuracy: 4
  },
  {
    postalCode: 2640,
    city: "Table Top",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.9667,
    longitude: 147,
    accuracy: 4
  },
  {
    postalCode: 2640,
    city: "North Albury",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0575,
    longitude: 146.9299,
    accuracy: 4
  },
  {
    postalCode: 2640,
    city: "Ournie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.9318,
    longitude: 147.8512,
    accuracy: 4
  },
  {
    postalCode: 2640,
    city: "Moorwatha",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.9833,
    longitude: 146.7,
    accuracy: 4
  },
  {
    postalCode: 2640,
    city: "Thurgoona",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0363,
    longitude: 146.9961,
    accuracy: 4
  },
  {
    postalCode: 2640,
    city: "Lavington Dc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0351,
    longitude: 147.0025,
    accuracy: 3
  },
  {
    postalCode: 2640,
    city: "Bungowannah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0056,
    longitude: 146.7702,
    accuracy: 4
  },
  {
    postalCode: 2640,
    city: "East Albury",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0814,
    longitude: 146.9299,
    accuracy: 4
  },
  {
    postalCode: 2640,
    city: "Wymah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0139,
    longitude: 147.0421,
    accuracy: 3
  },
  {
    postalCode: 2640,
    city: "South Albury",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0865,
    longitude: 146.9091,
    accuracy: 4
  },
  {
    postalCode: 2640,
    city: "West Albury",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0798,
    longitude: 146.8923,
    accuracy: 4
  },
  {
    postalCode: 2640,
    city: "Wirlinga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0139,
    longitude: 147.0421,
    accuracy: 3
  },
  {
    postalCode: 2640,
    city: "Glenroy",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0502,
    longitude: 146.9106,
    accuracy: 4
  },
  {
    postalCode: 2640,
    city: "Ettamogah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0139,
    longitude: 147.0421,
    accuracy: 3
  },
  {
    postalCode: 2640,
    city: "Splitters Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.053,
    longitude: 146.85,
    accuracy: 4
  },
  {
    postalCode: 2640,
    city: "Albury",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0748,
    longitude: 146.924,
    accuracy: 4
  },
  {
    postalCode: 2641,
    city: "Lavington",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0398,
    longitude: 146.9396,
    accuracy: 4
  },
  {
    postalCode: 2641,
    city: "Hamilton Valley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0379,
    longitude: 146.9177,
    accuracy: 4
  },
  {
    postalCode: 2641,
    city: "Springdale Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.031,
    longitude: 146.9478,
    accuracy: 4
  },
  {
    postalCode: 2642,
    city: "Jagumba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8945,
    longitude: 147.3359,
    accuracy: 3
  },
  {
    postalCode: 2642,
    city: "Tooma",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.9667,
    longitude: 148.0667,
    accuracy: 4
  },
  {
    postalCode: 2642,
    city: "Burrumbuttock",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8375,
    longitude: 146.8023,
    accuracy: 4
  },
  {
    postalCode: 2642,
    city: "Welaregang",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.998,
    longitude: 147.9637,
    accuracy: 4
  },
  {
    postalCode: 2642,
    city: "Bidgeemia",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8945,
    longitude: 147.3359,
    accuracy: 3
  },
  {
    postalCode: 2642,
    city: "Rand",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.5929,
    longitude: 146.5811,
    accuracy: 4
  },
  {
    postalCode: 2642,
    city: "Brocklesby",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8249,
    longitude: 146.6751,
    accuracy: 4
  },
  {
    postalCode: 2642,
    city: "Walbundrie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.6985,
    longitude: 146.7179,
    accuracy: 4
  },
  {
    postalCode: 2642,
    city: "Jagungal Wilderness",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8945,
    longitude: 147.3359,
    accuracy: 3
  },
  {
    postalCode: 2642,
    city: "Greg Greg",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0485,
    longitude: 148.0512,
    accuracy: 4
  },
  {
    postalCode: 2642,
    city: "Glenellen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.9152,
    longitude: 146.9179,
    accuracy: 4
  },
  {
    postalCode: 2642,
    city: "Jingellic",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.9152,
    longitude: 147.6846,
    accuracy: 4
  },
  {
    postalCode: 2642,
    city: "Wrathall",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8945,
    longitude: 147.3359,
    accuracy: 3
  },
  {
    postalCode: 2642,
    city: "Yerong Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3868,
    longitude: 147.0608,
    accuracy: 4
  },
  {
    postalCode: 2642,
    city: "Murray Gorge",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8945,
    longitude: 147.3359,
    accuracy: 3
  },
  {
    postalCode: 2642,
    city: "Gerogery",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8344,
    longitude: 146.9928,
    accuracy: 4
  },
  {
    postalCode: 2642,
    city: "Geehi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.3667,
    longitude: 148.1667,
    accuracy: 4
  },
  {
    postalCode: 2642,
    city: "Khancoban",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.2181,
    longitude: 148.1305,
    accuracy: 4
  },
  {
    postalCode: 2642,
    city: "Indi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0333,
    longitude: 149.4167,
    accuracy: 4
  },
  {
    postalCode: 2642,
    city: "Jindera",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.9547,
    longitude: 146.8885,
    accuracy: 4
  },
  {
    postalCode: 2643,
    city: "Howlong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.982,
    longitude: 146.6325,
    accuracy: 4
  },
  {
    postalCode: 2644,
    city: "Little Billabong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.5818,
    longitude: 147.5346,
    accuracy: 4
  },
  {
    postalCode: 2644,
    city: "Bowna",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7649,
    longitude: 147.4557,
    accuracy: 3
  },
  {
    postalCode: 2644,
    city: "Mountain Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7652,
    longitude: 147.1346,
    accuracy: 4
  },
  {
    postalCode: 2644,
    city: "Woomargama",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8333,
    longitude: 147.25,
    accuracy: 4
  },
  {
    postalCode: 2644,
    city: "Lankeys Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8152,
    longitude: 147.6512,
    accuracy: 4
  },
  {
    postalCode: 2644,
    city: "Holbrook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7219,
    longitude: 147.3139,
    accuracy: 4
  },
  {
    postalCode: 2644,
    city: "Yarara",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7648,
    longitude: 147.3468,
    accuracy: 3
  },
  {
    postalCode: 2644,
    city: "Mullengandra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8833,
    longitude: 147.1667,
    accuracy: 4
  },
  {
    postalCode: 2644,
    city: "Wantagong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7648,
    longitude: 147.3468,
    accuracy: 3
  },
  {
    postalCode: 2644,
    city: "Coppabella",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7648,
    longitude: 147.3468,
    accuracy: 3
  },
  {
    postalCode: 2645,
    city: "Urana",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3293,
    longitude: 146.2666,
    accuracy: 4
  },
  {
    postalCode: 2645,
    city: "Cullivel",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2627,
    longitude: 146.382,
    accuracy: 4
  },
  {
    postalCode: 2646,
    city: "Daysdale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.6436,
    longitude: 146.302,
    accuracy: 4
  },
  {
    postalCode: 2646,
    city: "Rennie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.809,
    longitude: 146.1362,
    accuracy: 4
  },
  {
    postalCode: 2646,
    city: "Oaklands",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.5576,
    longitude: 146.163,
    accuracy: 4
  },
  {
    postalCode: 2646,
    city: "Balldale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8466,
    longitude: 146.5197,
    accuracy: 4
  },
  {
    postalCode: 2646,
    city: "Coreen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7667,
    longitude: 146.35,
    accuracy: 4
  },
  {
    postalCode: 2646,
    city: "Savernake",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7345,
    longitude: 146.051,
    accuracy: 4
  },
  {
    postalCode: 2646,
    city: "Corowa",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.997,
    longitude: 146.3855,
    accuracy: 4
  },
  {
    postalCode: 2646,
    city: "Goombargana",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7924,
    longitude: 146.2899,
    accuracy: 3
  },
  {
    postalCode: 2646,
    city: "Lowesdale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8318,
    longitude: 146.3512,
    accuracy: 4
  },
  {
    postalCode: 2646,
    city: "Sanger",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7924,
    longitude: 146.2899,
    accuracy: 3
  },
  {
    postalCode: 2646,
    city: "Ringwood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8,
    longitude: 146.2,
    accuracy: 3
  },
  {
    postalCode: 2646,
    city: "Hopefield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8824,
    longitude: 146.4377,
    accuracy: 4
  },
  {
    postalCode: 2646,
    city: "Redlands",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7924,
    longitude: 146.2899,
    accuracy: 3
  },
  {
    postalCode: 2646,
    city: "Nyora",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7924,
    longitude: 146.2899,
    accuracy: 3
  },
  {
    postalCode: 2646,
    city: "Collendina",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7924,
    longitude: 146.2899,
    accuracy: 3
  },
  {
    postalCode: 2647,
    city: "Mulwala",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.9854,
    longitude: 146.0053,
    accuracy: 4
  },
  {
    postalCode: 2648,
    city: "Mourquong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4923,
    longitude: 142.2143,
    accuracy: 3
  },
  {
    postalCode: 2648,
    city: "Ellerslie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3103,
    longitude: 147.2462,
    accuracy: 3
  },
  {
    postalCode: 2648,
    city: "Anabranch North",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8604,
    longitude: 146.9648,
    accuracy: 3
  },
  {
    postalCode: 2648,
    city: "Palinyewah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4923,
    longitude: 142.2143,
    accuracy: 3
  },
  {
    postalCode: 2648,
    city: "Rufus",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8604,
    longitude: 146.9648,
    accuracy: 3
  },
  {
    postalCode: 2648,
    city: "Pomona",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.023,
    longitude: 141.8896,
    accuracy: 4
  },
  {
    postalCode: 2648,
    city: "Wentworth",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1073,
    longitude: 141.9131,
    accuracy: 4
  },
  {
    postalCode: 2648,
    city: "Rufus River",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4923,
    longitude: 142.2143,
    accuracy: 3
  },
  {
    postalCode: 2648,
    city: "Pooncarie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3853,
    longitude: 142.5699,
    accuracy: 4
  },
  {
    postalCode: 2648,
    city: "Moorara",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8604,
    longitude: 146.9648,
    accuracy: 3
  },
  {
    postalCode: 2648,
    city: "Cal Lal",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0452,
    longitude: 141.0884,
    accuracy: 4
  },
  {
    postalCode: 2648,
    city: "Para",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8604,
    longitude: 146.9648,
    accuracy: 3
  },
  {
    postalCode: 2648,
    city: "Scotia",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8604,
    longitude: 146.9648,
    accuracy: 3
  },
  {
    postalCode: 2648,
    city: "Pan Ban",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8604,
    longitude: 146.9648,
    accuracy: 3
  },
  {
    postalCode: 2648,
    city: "Anabranch South",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8604,
    longitude: 146.9648,
    accuracy: 3
  },
  {
    postalCode: 2648,
    city: "Pine Camp",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8604,
    longitude: 146.9648,
    accuracy: 3
  },
  {
    postalCode: 2648,
    city: "Curlwaa",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1077,
    longitude: 141.9669,
    accuracy: 4
  },
  {
    postalCode: 2649,
    city: "Laurel Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.6167,
    longitude: 148.0833,
    accuracy: 4
  },
  {
    postalCode: 2649,
    city: "Nurenmerenmong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.6167,
    longitude: 148.0833,
    accuracy: 3
  },
  {
    postalCode: 2650,
    city: "Tolland",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1452,
    longitude: 147.3516,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Burrandana",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.153,
    longitude: 147.3705,
    accuracy: 3
  },
  {
    postalCode: 2650,
    city: "Bomen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0667,
    longitude: 147.4167,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Pulletop",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.153,
    longitude: 147.3705,
    accuracy: 3
  },
  {
    postalCode: 2650,
    city: "East Wagga Wagga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1276,
    longitude: 147.407,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Estella",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0725,
    longitude: 147.3575,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Glenfield Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1373,
    longitude: 147.3328,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Yathella",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.153,
    longitude: 147.3705,
    accuracy: 3
  },
  {
    postalCode: 2650,
    city: "Wagga Wagga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1258,
    longitude: 147.3537,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Wantabadgery",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.05,
    longitude: 147.7333,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Mount Austin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1368,
    longitude: 147.353,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Eunanoreenya",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.153,
    longitude: 147.3705,
    accuracy: 3
  },
  {
    postalCode: 2650,
    city: "Oura",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1167,
    longitude: 147.5333,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Oberne Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4,
    longitude: 147.8333,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Galore",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.998,
    longitude: 146.8128,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Maxwell",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.153,
    longitude: 147.3705,
    accuracy: 3
  },
  {
    postalCode: 2650,
    city: "Lake Albert",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1667,
    longitude: 147.3833,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Ashmont",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1249,
    longitude: 147.3317,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Gregadoo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2333,
    longitude: 147.4333,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Wallacetown",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.153,
    longitude: 147.3705,
    accuracy: 3
  },
  {
    postalCode: 2650,
    city: "Boorooma",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0744,
    longitude: 147.3646,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Kyeamba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4333,
    longitude: 147.6167,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Currawarna",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0167,
    longitude: 147.0833,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Belfrayden",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.153,
    longitude: 147.3705,
    accuracy: 3
  },
  {
    postalCode: 2650,
    city: "Cookardinia",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.5667,
    longitude: 147.2167,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Tatton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1599,
    longitude: 147.3587,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Cartwrights Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0748,
    longitude: 147.392,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Big Springs",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.153,
    longitude: 147.3705,
    accuracy: 3
  },
  {
    postalCode: 2650,
    city: "Brucedale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0333,
    longitude: 147.4167,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Moorong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1119,
    longitude: 147.3125,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "San Isidore",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1248,
    longitude: 147.2894,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Wagga Wagga South",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1127,
    longitude: 147.4103,
    accuracy: 3
  },
  {
    postalCode: 2650,
    city: "Bourkelands",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1559,
    longitude: 147.347,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Gobbagombalin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0592,
    longitude: 147.3436,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Carabost",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.5985,
    longitude: 147.7179,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Downside",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35,
    longitude: 147.35,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Turvey Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1285,
    longitude: 147.3626,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Springvale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1669,
    longitude: 147.3306,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Yarragundry",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1167,
    longitude: 147.2333,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Book Book",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3693,
    longitude: 147.5624,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Harefield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.9667,
    longitude: 147.5333,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Borambola",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2,
    longitude: 147.6667,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Alfredtown",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1667,
    longitude: 147.5167,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Hillgrove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.153,
    longitude: 147.3705,
    accuracy: 3
  },
  {
    postalCode: 2650,
    city: "Bulgary",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0772,
    longitude: 146.9725,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Wagga Wagga BC",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.153,
    longitude: 147.3705,
    accuracy: 3
  },
  {
    postalCode: 2650,
    city: "Rowan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2,
    longitude: 147.3333,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Lloyd",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1507,
    longitude: 147.3371,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Kooringal",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1407,
    longitude: 147.3768,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "The Gap",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.153,
    longitude: 147.3705,
    accuracy: 3
  },
  {
    postalCode: 2650,
    city: "North Wagga Wagga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1,
    longitude: 147.3833,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Collingullie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0833,
    longitude: 147.1167,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Euberta",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0667,
    longitude: 147.2167,
    accuracy: 4
  },
  {
    postalCode: 2650,
    city: "Gelston Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.153,
    longitude: 147.3705,
    accuracy: 3
  },
  {
    postalCode: 2651,
    city: "Forest Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1481,
    longitude: 147.4671,
    accuracy: 4
  },
  {
    postalCode: 2651,
    city: "Wagga Wagga Raaf",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1588,
    longitude: 147.4662,
    accuracy: 3
  },
  {
    postalCode: 2652,
    city: "Boree Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1066,
    longitude: 146.6085,
    accuracy: 4
  },
  {
    postalCode: 2652,
    city: "Boorga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0326,
    longitude: 146.021,
    accuracy: 4
  },
  {
    postalCode: 2652,
    city: "Humula",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4833,
    longitude: 147.75,
    accuracy: 4
  },
  {
    postalCode: 2652,
    city: "Galore",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.998,
    longitude: 146.8128,
    accuracy: 4
  },
  {
    postalCode: 2652,
    city: "Marrar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8333,
    longitude: 147.3667,
    accuracy: 4
  },
  {
    postalCode: 2652,
    city: "Gumly Gumly",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1273,
    longitude: 147.4335,
    accuracy: 4
  },
  {
    postalCode: 2652,
    city: "Tarcutta",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2774,
    longitude: 147.7359,
    accuracy: 4
  },
  {
    postalCode: 2652,
    city: "Tabbita",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1071,
    longitude: 145.8463,
    accuracy: 4
  },
  {
    postalCode: 2652,
    city: "Uranquinty",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1935,
    longitude: 147.246,
    accuracy: 4
  },
  {
    postalCode: 2652,
    city: "Landervale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5454,
    longitude: 146.8317,
    accuracy: 4
  },
  {
    postalCode: 2652,
    city: "Ladysmith",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2095,
    longitude: 147.5118,
    accuracy: 4
  },
  {
    postalCode: 2652,
    city: "Grong Grong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7368,
    longitude: 146.7822,
    accuracy: 4
  },
  {
    postalCode: 2652,
    city: "Rosewood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7,
    longitude: 147.8667,
    accuracy: 4
  },
  {
    postalCode: 2652,
    city: "Matong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7671,
    longitude: 146.9239,
    accuracy: 4
  },
  {
    postalCode: 2652,
    city: "Cowabbie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5815,
    longitude: 146.9698,
    accuracy: 4
  },
  {
    postalCode: 2652,
    city: "Old Junee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8333,
    longitude: 147.5333,
    accuracy: 4
  },
  {
    postalCode: 2652,
    city: "Merriwagga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8333,
    longitude: 145.6167,
    accuracy: 4
  },
  {
    postalCode: 2652,
    city: "Mangoplah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3833,
    longitude: 147.25,
    accuracy: 4
  },
  {
    postalCode: 2652,
    city: "Murrulebale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8864,
    longitude: 146.9996,
    accuracy: 3
  },
  {
    postalCode: 2652,
    city: "Goolgowi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9781,
    longitude: 145.7087,
    accuracy: 4
  },
  {
    postalCode: 2653,
    city: "Burra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.5594,
    longitude: 149.2235,
    accuracy: 4
  },
  {
    postalCode: 2653,
    city: "Courabyra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7,
    longitude: 148.0333,
    accuracy: 4
  },
  {
    postalCode: 2653,
    city: "Glenroy",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.0502,
    longitude: 146.9106,
    accuracy: 4
  },
  {
    postalCode: 2653,
    city: "Paddys River",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.764,
    longitude: 148.1853,
    accuracy: 4
  },
  {
    postalCode: 2653,
    city: "Mannus",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8,
    longitude: 147.95,
    accuracy: 4
  },
  {
    postalCode: 2653,
    city: "Taradale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7893,
    longitude: 147.9991,
    accuracy: 3
  },
  {
    postalCode: 2653,
    city: "Willigobung",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7893,
    longitude: 147.9991,
    accuracy: 3
  },
  {
    postalCode: 2653,
    city: "Munderoo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8318,
    longitude: 147.8679,
    accuracy: 4
  },
  {
    postalCode: 2653,
    city: "Westdale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7893,
    longitude: 147.9991,
    accuracy: 3
  },
  {
    postalCode: 2653,
    city: "Tumbarumba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7762,
    longitude: 148.0105,
    accuracy: 4
  },
  {
    postalCode: 2653,
    city: "Maragle",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7893,
    longitude: 147.9991,
    accuracy: 3
  },
  {
    postalCode: 2655,
    city: "The Rock",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.268,
    longitude: 147.1142,
    accuracy: 4
  },
  {
    postalCode: 2655,
    city: "Tootool",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.263,
    longitude: 146.9936,
    accuracy: 4
  },
  {
    postalCode: 2655,
    city: "French Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2623,
    longitude: 146.927,
    accuracy: 4
  },
  {
    postalCode: 2656,
    city: "Osborne",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3545,
    longitude: 146.7228,
    accuracy: 4
  },
  {
    postalCode: 2656,
    city: "Urangeline East",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4874,
    longitude: 146.7,
    accuracy: 4
  },
  {
    postalCode: 2656,
    city: "Brookong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1844,
    longitude: 146.6364,
    accuracy: 4
  },
  {
    postalCode: 2656,
    city: "Fargunyah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3398,
    longitude: 146.7235,
    accuracy: 3
  },
  {
    postalCode: 2656,
    city: "Urangeline",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4874,
    longitude: 146.7,
    accuracy: 4
  },
  {
    postalCode: 2656,
    city: "Lockhart",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2233,
    longitude: 146.7182,
    accuracy: 4
  },
  {
    postalCode: 2656,
    city: "Brookdale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3398,
    longitude: 146.7235,
    accuracy: 3
  },
  {
    postalCode: 2656,
    city: "Milbrulong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2532,
    longitude: 146.8428,
    accuracy: 4
  },
  {
    postalCode: 2658,
    city: "Pleasant Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4622,
    longitude: 146.7978,
    accuracy: 4
  },
  {
    postalCode: 2658,
    city: "Henty",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.5207,
    longitude: 147.0349,
    accuracy: 4
  },
  {
    postalCode: 2658,
    city: "Ryan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.5564,
    longitude: 146.8684,
    accuracy: 4
  },
  {
    postalCode: 2658,
    city: "Munyabla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4963,
    longitude: 146.8718,
    accuracy: 4
  },
  {
    postalCode: 2659,
    city: "Alma Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7568,
    longitude: 146.9108,
    accuracy: 3
  },
  {
    postalCode: 2659,
    city: "Walla Walla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7622,
    longitude: 146.9011,
    accuracy: 4
  },
  {
    postalCode: 2660,
    city: "Morven",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.65,
    longitude: 147.1,
    accuracy: 4
  },
  {
    postalCode: 2660,
    city: "Culcairn",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.6667,
    longitude: 147.0385,
    accuracy: 4
  },
  {
    postalCode: 2661,
    city: "Kapooka",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1569,
    longitude: 147.2844,
    accuracy: 4
  },
  {
    postalCode: 2663,
    city: "Erin Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.9061,
    longitude: 147.672,
    accuracy: 3
  },
  {
    postalCode: 2663,
    city: "Eurongilly",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.95,
    longitude: 147.7667,
    accuracy: 4
  },
  {
    postalCode: 2663,
    city: "Wantiool",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.9,
    longitude: 147.6667,
    accuracy: 4
  },
  {
    postalCode: 2663,
    city: "Marinna",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.9061,
    longitude: 147.672,
    accuracy: 3
  },
  {
    postalCode: 2663,
    city: "Junee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8682,
    longitude: 147.5827,
    accuracy: 4
  },
  {
    postalCode: 2665,
    city: "Mirrool",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3167,
    longitude: 147.1,
    accuracy: 4
  },
  {
    postalCode: 2665,
    city: "Barellan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2849,
    longitude: 146.5722,
    accuracy: 4
  },
  {
    postalCode: 2665,
    city: "Tara",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5,
    longitude: 147.1667,
    accuracy: 4
  },
  {
    postalCode: 2665,
    city: "Bectric",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3391,
    longitude: 146.9046,
    accuracy: 3
  },
  {
    postalCode: 2665,
    city: "Kamarah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3255,
    longitude: 146.7831,
    accuracy: 4
  },
  {
    postalCode: 2665,
    city: "Moombooldool",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3,
    longitude: 146.6833,
    accuracy: 4
  },
  {
    postalCode: 2665,
    city: "Beckom",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3152,
    longitude: 146.9679,
    accuracy: 4
  },
  {
    postalCode: 2665,
    city: "Binya",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2333,
    longitude: 146.35,
    accuracy: 4
  },
  {
    postalCode: 2665,
    city: "Walleroobie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3391,
    longitude: 146.9046,
    accuracy: 3
  },
  {
    postalCode: 2665,
    city: "Ariah Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3493,
    longitude: 147.2218,
    accuracy: 4
  },
  {
    postalCode: 2665,
    city: "Quandary",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3833,
    longitude: 147.3167,
    accuracy: 4
  },
  {
    postalCode: 2665,
    city: "Ardlethan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3569,
    longitude: 146.9018,
    accuracy: 4
  },
  {
    postalCode: 2666,
    city: "Grogan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3167,
    longitude: 147.8,
    accuracy: 4
  },
  {
    postalCode: 2666,
    city: "Reefton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.25,
    longitude: 147.4333,
    accuracy: 4
  },
  {
    postalCode: 2666,
    city: "Dirnaseer",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.414,
    longitude: 147.5797,
    accuracy: 3
  },
  {
    postalCode: 2666,
    city: "Junee Reefs",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7318,
    longitude: 147.6179,
    accuracy: 4
  },
  {
    postalCode: 2666,
    city: "Morangarell",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.15,
    longitude: 147.7,
    accuracy: 4
  },
  {
    postalCode: 2666,
    city: "Mimosa",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6,
    longitude: 147.45,
    accuracy: 4
  },
  {
    postalCode: 2666,
    city: "Combaning",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.45,
    longitude: 147.6833,
    accuracy: 4
  },
  {
    postalCode: 2666,
    city: "Pucawan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4152,
    longitude: 147.3512,
    accuracy: 4
  },
  {
    postalCode: 2666,
    city: "Sebastopol",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5833,
    longitude: 147.5333,
    accuracy: 4
  },
  {
    postalCode: 2666,
    city: "Temora",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4483,
    longitude: 147.5356,
    accuracy: 4
  },
  {
    postalCode: 2666,
    city: "Gidginbung",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3333,
    longitude: 147.4667,
    accuracy: 4
  },
  {
    postalCode: 2666,
    city: "Trungley Hall",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2985,
    longitude: 147.5679,
    accuracy: 4
  },
  {
    postalCode: 2666,
    city: "Narraburra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3318,
    longitude: 147.6512,
    accuracy: 4
  },
  {
    postalCode: 2666,
    city: "Springdale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4667,
    longitude: 147.7333,
    accuracy: 4
  },
  {
    postalCode: 2668,
    city: "Barmedman",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1449,
    longitude: 147.3873,
    accuracy: 4
  },
  {
    postalCode: 2669,
    city: "Rankins Springs",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8318,
    longitude: 146.2512,
    accuracy: 4
  },
  {
    postalCode: 2669,
    city: "Melbergen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7,
    longitude: 146.05,
    accuracy: 4
  },
  {
    postalCode: 2669,
    city: "Tallimba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9935,
    longitude: 146.8796,
    accuracy: 4
  },
  {
    postalCode: 2669,
    city: "Erigolia",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8546,
    longitude: 146.3733,
    accuracy: 4
  },
  {
    postalCode: 2669,
    city: "Gubbata",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.778,
    longitude: 146.5263,
    accuracy: 3
  },
  {
    postalCode: 2669,
    city: "Tullibigeal",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4167,
    longitude: 146.7333,
    accuracy: 4
  },
  {
    postalCode: 2669,
    city: "Naradhan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6152,
    longitude: 146.3179,
    accuracy: 4
  },
  {
    postalCode: 2669,
    city: "Girral",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7058,
    longitude: 147.0758,
    accuracy: 4
  },
  {
    postalCode: 2669,
    city: "Weethalle",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8818,
    longitude: 146.6346,
    accuracy: 4
  },
  {
    postalCode: 2669,
    city: "Bygalorie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4667,
    longitude: 146.8,
    accuracy: 4
  },
  {
    postalCode: 2669,
    city: "Ungarie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6318,
    longitude: 146.9679,
    accuracy: 4
  },
  {
    postalCode: 2669,
    city: "Kikoira",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6496,
    longitude: 146.6615,
    accuracy: 4
  },
  {
    postalCode: 2671,
    city: "West Wyalong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9237,
    longitude: 147.2047,
    accuracy: 4
  },
  {
    postalCode: 2671,
    city: "North Yalgogrin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.85,
    longitude: 146.8333,
    accuracy: 3
  },
  {
    postalCode: 2671,
    city: "Wyalong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9333,
    longitude: 147.25,
    accuracy: 4
  },
  {
    postalCode: 2671,
    city: "Alleena",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0688,
    longitude: 147.1392,
    accuracy: 4
  },
  {
    postalCode: 2671,
    city: "Lake Cowal",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6877,
    longitude: 147.3586,
    accuracy: 4
  },
  {
    postalCode: 2671,
    city: "Back Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8345,
    longitude: 147.173,
    accuracy: 3
  },
  {
    postalCode: 2671,
    city: "Burcher",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5141,
    longitude: 147.2532,
    accuracy: 4
  },
  {
    postalCode: 2672,
    city: "Lake Cargelligo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2987,
    longitude: 146.3739,
    accuracy: 4
  },
  {
    postalCode: 2672,
    city: "Curlew Waters",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2963,
    longitude: 146.4428,
    accuracy: 3
  },
  {
    postalCode: 2672,
    city: "Murrin Bridge",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2068,
    longitude: 146.3711,
    accuracy: 4
  },
  {
    postalCode: 2672,
    city: "Burgooney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3861,
    longitude: 146.5752,
    accuracy: 4
  },
  {
    postalCode: 2675,
    city: "Hillston",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4877,
    longitude: 145.5403,
    accuracy: 4
  },
  {
    postalCode: 2675,
    city: "Wallanthery",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2655,
    longitude: 145.5005,
    accuracy: 3
  },
  {
    postalCode: 2675,
    city: "Lake Brewster",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2655,
    longitude: 145.5005,
    accuracy: 3
  },
  {
    postalCode: 2675,
    city: "Monia Gap",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2655,
    longitude: 145.5005,
    accuracy: 3
  },
  {
    postalCode: 2675,
    city: "Roto",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.05,
    longitude: 145.4667,
    accuracy: 4
  },
  {
    postalCode: 2678,
    city: "Riverina Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5843,
    longitude: 146.6698,
    accuracy: 1
  },
  {
    postalCode: 2678,
    city: "Charles Sturt University",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0593,
    longitude: 147.352,
    accuracy: 1
  },
  {
    postalCode: 2680,
    city: "Beelbangera",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2553,
    longitude: 146.0985,
    accuracy: 4
  },
  {
    postalCode: 2680,
    city: "Nericon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1781,
    longitude: 146.0355,
    accuracy: 4
  },
  {
    postalCode: 2680,
    city: "Bilbul",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2718,
    longitude: 146.1405,
    accuracy: 4
  },
  {
    postalCode: 2680,
    city: "Griffith East",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2768,
    longitude: 146.0447,
    accuracy: 3
  },
  {
    postalCode: 2680,
    city: "Yoogali",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.3,
    longitude: 146.0833,
    accuracy: 4
  },
  {
    postalCode: 2680,
    city: "Willbriggie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.466,
    longitude: 146.0149,
    accuracy: 4
  },
  {
    postalCode: 2680,
    city: "Warburn",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1858,
    longitude: 145.9442,
    accuracy: 4
  },
  {
    postalCode: 2680,
    city: "Warrawidgee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2768,
    longitude: 146.0447,
    accuracy: 3
  },
  {
    postalCode: 2680,
    city: "Hanwood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.331,
    longitude: 146.0414,
    accuracy: 4
  },
  {
    postalCode: 2680,
    city: "Kooba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2768,
    longitude: 146.0447,
    accuracy: 3
  },
  {
    postalCode: 2680,
    city: "Griffith",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2885,
    longitude: 146.0509,
    accuracy: 4
  },
  {
    postalCode: 2680,
    city: "Griffith DC",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2768,
    longitude: 146.0447,
    accuracy: 3
  },
  {
    postalCode: 2680,
    city: "Lake Wyangan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.232,
    longitude: 146.0208,
    accuracy: 4
  },
  {
    postalCode: 2680,
    city: "Tharbogang",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.299,
    longitude: 145.826,
    accuracy: 3
  },
  {
    postalCode: 2680,
    city: "Widgelli",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.299,
    longitude: 145.826,
    accuracy: 3
  },
  {
    postalCode: 2680,
    city: "Benerembah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.299,
    longitude: 145.826,
    accuracy: 3
  },
  {
    postalCode: 2681,
    city: "Yenda",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2501,
    longitude: 146.199,
    accuracy: 4
  },
  {
    postalCode: 2681,
    city: "Myall Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2501,
    longitude: 146.199,
    accuracy: 3
  },
  {
    postalCode: 2700,
    city: "Sandigo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.9214,
    longitude: 146.6613,
    accuracy: 4
  },
  {
    postalCode: 2700,
    city: "Morundah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.9333,
    longitude: 146.3,
    accuracy: 4
  },
  {
    postalCode: 2700,
    city: "Narrandera",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7475,
    longitude: 146.551,
    accuracy: 4
  },
  {
    postalCode: 2700,
    city: "Gillenbah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8246,
    longitude: 146.4029,
    accuracy: 3
  },
  {
    postalCode: 2700,
    city: "Colinroobie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.454,
    longitude: 146.6034,
    accuracy: 4
  },
  {
    postalCode: 2700,
    city: "Bundure",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1708,
    longitude: 146.0078,
    accuracy: 4
  },
  {
    postalCode: 2700,
    city: "Cudgel",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8246,
    longitude: 146.4029,
    accuracy: 3
  },
  {
    postalCode: 2700,
    city: "Euroley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7167,
    longitude: 146.35,
    accuracy: 4
  },
  {
    postalCode: 2700,
    city: "Corobimilla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.9139,
    longitude: 146.1765,
    accuracy: 3
  },
  {
    postalCode: 2701,
    city: "Methul",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5985,
    longitude: 147.1512,
    accuracy: 4
  },
  {
    postalCode: 2701,
    city: "Berry Jerry",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6893,
    longitude: 147.2003,
    accuracy: 3
  },
  {
    postalCode: 2701,
    city: "Coolamon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8164,
    longitude: 147.1958,
    accuracy: 4
  },
  {
    postalCode: 2701,
    city: "Rannock",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6485,
    longitude: 147.2512,
    accuracy: 4
  },
  {
    postalCode: 2702,
    city: "Ganmain",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7932,
    longitude: 147.0391,
    accuracy: 4
  },
  {
    postalCode: 2703,
    city: "Yanco",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5985,
    longitude: 146.4095,
    accuracy: 4
  },
  {
    postalCode: 2705,
    city: "Corbie Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.563,
    longitude: 146.4833,
    accuracy: 4
  },
  {
    postalCode: 2705,
    city: "Whitton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5187,
    longitude: 146.1851,
    accuracy: 4
  },
  {
    postalCode: 2705,
    city: "Wamoon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5358,
    longitude: 146.3366,
    accuracy: 4
  },
  {
    postalCode: 2705,
    city: "Merungle Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.615,
    longitude: 146.4652,
    accuracy: 4
  },
  {
    postalCode: 2705,
    city: "Murrami",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4231,
    longitude: 146.3057,
    accuracy: 4
  },
  {
    postalCode: 2705,
    city: "Leeton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.551,
    longitude: 146.4048,
    accuracy: 4
  },
  {
    postalCode: 2705,
    city: "Stanbridge",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5152,
    longitude: 146.2346,
    accuracy: 4
  },
  {
    postalCode: 2705,
    city: "Brobenah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.531,
    longitude: 146.3361,
    accuracy: 3
  },
  {
    postalCode: 2705,
    city: "Gogeldrie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5485,
    longitude: 146.3012,
    accuracy: 4
  },
  {
    postalCode: 2706,
    city: "Darlington Point",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5694,
    longitude: 145.9987,
    accuracy: 4
  },
  {
    postalCode: 2707,
    city: "Coleambally",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8039,
    longitude: 145.8804,
    accuracy: 4
  },
  {
    postalCode: 2707,
    city: "Argoon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.9477,
    longitude: 145.7211,
    accuracy: 4
  },
  {
    postalCode: 2708,
    city: "Murray Region Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6742,
    longitude: 146.3985,
    accuracy: 1
  },
  {
    postalCode: 2710,
    city: "Pretty Pine",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4152,
    longitude: 144.8846,
    accuracy: 4
  },
  {
    postalCode: 2710,
    city: "Mathoura",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8152,
    longitude: 144.9012,
    accuracy: 4
  },
  {
    postalCode: 2710,
    city: "Wakool",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4706,
    longitude: 144.3957,
    accuracy: 3
  },
  {
    postalCode: 2710,
    city: "Wandook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4621,
    longitude: 144.9959,
    accuracy: 4
  },
  {
    postalCode: 2710,
    city: "Birganbigil",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3667,
    longitude: 145.4667,
    accuracy: 3
  },
  {
    postalCode: 2710,
    city: "Caldwell",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.6318,
    longitude: 144.5096,
    accuracy: 4
  },
  {
    postalCode: 2710,
    city: "Moonbria",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3667,
    longitude: 145.4667,
    accuracy: 3
  },
  {
    postalCode: 2710,
    city: "Deniliquin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.5324,
    longitude: 144.9536,
    accuracy: 4
  },
  {
    postalCode: 2710,
    city: "Stud Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3667,
    longitude: 145.4667,
    accuracy: 3
  },
  {
    postalCode: 2710,
    city: "Conargo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3035,
    longitude: 145.1801,
    accuracy: 4
  },
  {
    postalCode: 2710,
    city: "Steam Plains",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3667,
    longitude: 145.4667,
    accuracy: 3
  },
  {
    postalCode: 2710,
    city: "Calimo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4152,
    longitude: 144.5846,
    accuracy: 4
  },
  {
    postalCode: 2710,
    city: "Gulpa",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7,
    longitude: 144.8833,
    accuracy: 4
  },
  {
    postalCode: 2710,
    city: "Wanganella",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2121,
    longitude: 144.8194,
    accuracy: 4
  },
  {
    postalCode: 2710,
    city: "Booroorban",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.9325,
    longitude: 144.7619,
    accuracy: 4
  },
  {
    postalCode: 2710,
    city: "Lindifferon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3667,
    longitude: 145.4667,
    accuracy: 3
  },
  {
    postalCode: 2710,
    city: "Barratta",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2955,
    longitude: 144.5737,
    accuracy: 4
  },
  {
    postalCode: 2710,
    city: "Coree",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3454,
    longitude: 145.4289,
    accuracy: 4
  },
  {
    postalCode: 2710,
    city: "Moira",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.9318,
    longitude: 144.8346,
    accuracy: 4
  },
  {
    postalCode: 2710,
    city: "Hartwood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3667,
    longitude: 145.4667,
    accuracy: 3
  },
  {
    postalCode: 2710,
    city: "Morago",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3718,
    longitude: 144.6606,
    accuracy: 4
  },
  {
    postalCode: 2710,
    city: "Bullatale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3667,
    longitude: 145.4667,
    accuracy: 3
  },
  {
    postalCode: 2710,
    city: "Mayrung",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3251,
    longitude: 144.8201,
    accuracy: 3
  },
  {
    postalCode: 2710,
    city: "Willurah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3667,
    longitude: 145.4667,
    accuracy: 3
  },
  {
    postalCode: 2710,
    city: "Warragoon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3667,
    longitude: 145.4667,
    accuracy: 3
  },
  {
    postalCode: 2711,
    city: "Oxley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1936,
    longitude: 144.1024,
    accuracy: 4
  },
  {
    postalCode: 2711,
    city: "Carrathool",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4075,
    longitude: 145.4358,
    accuracy: 4
  },
  {
    postalCode: 2711,
    city: "Maude",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4739,
    longitude: 144.3003,
    accuracy: 4
  },
  {
    postalCode: 2711,
    city: "Yanga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2167,
    longitude: 145.425,
    accuracy: 3
  },
  {
    postalCode: 2711,
    city: "Gunbar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0444,
    longitude: 145.4043,
    accuracy: 4
  },
  {
    postalCode: 2711,
    city: "Keri Keri",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2167,
    longitude: 145.425,
    accuracy: 3
  },
  {
    postalCode: 2711,
    city: "Corrong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2176,
    longitude: 144.4683,
    accuracy: 4
  },
  {
    postalCode: 2711,
    city: "Waugorah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2167,
    longitude: 145.425,
    accuracy: 3
  },
  {
    postalCode: 2711,
    city: "Booligal",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1481,
    longitude: 144.6732,
    accuracy: 3
  },
  {
    postalCode: 2711,
    city: "Hay South",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2167,
    longitude: 145.425,
    accuracy: 3
  },
  {
    postalCode: 2711,
    city: "One Tree",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1889,
    longitude: 144.7172,
    accuracy: 4
  },
  {
    postalCode: 2711,
    city: "Clare",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4,
    longitude: 143.9303,
    accuracy: 4
  },
  {
    postalCode: 2711,
    city: "Hay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.509,
    longitude: 144.8431,
    accuracy: 4
  },
  {
    postalCode: 2712,
    city: "Berrigan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.6588,
    longitude: 145.8114,
    accuracy: 4
  },
  {
    postalCode: 2712,
    city: "Boomanoomana",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8831,
    longitude: 145.7929,
    accuracy: 4
  },
  {
    postalCode: 2713,
    city: "Myrtle Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.649,
    longitude: 145.577,
    accuracy: 3
  },
  {
    postalCode: 2713,
    city: "Blighty",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.5883,
    longitude: 145.2859,
    accuracy: 4
  },
  {
    postalCode: 2713,
    city: "Logie Brae",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.649,
    longitude: 145.577,
    accuracy: 3
  },
  {
    postalCode: 2713,
    city: "Finley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.655,
    longitude: 145.5711,
    accuracy: 4
  },
  {
    postalCode: 2714,
    city: "Tuppal",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.6818,
    longitude: 145.2512,
    accuracy: 4
  },
  {
    postalCode: 2714,
    city: "Tocumwal",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8115,
    longitude: 145.5692,
    accuracy: 4
  },
  {
    postalCode: 2714,
    city: "Aratula",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.231,
    longitude: 145.6188,
    accuracy: 3
  },
  {
    postalCode: 2714,
    city: "Pine Lodge",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.231,
    longitude: 145.6188,
    accuracy: 3
  },
  {
    postalCode: 2715,
    city: "Hatfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8665,
    longitude: 143.738,
    accuracy: 4
  },
  {
    postalCode: 2715,
    city: "Mungo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.231,
    longitude: 145.6188,
    accuracy: 3
  },
  {
    postalCode: 2715,
    city: "Balranald",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.6365,
    longitude: 143.5614,
    accuracy: 4
  },
  {
    postalCode: 2715,
    city: "Kyalite",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.9532,
    longitude: 143.4775,
    accuracy: 4
  },
  {
    postalCode: 2715,
    city: "Arumpo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.231,
    longitude: 145.6188,
    accuracy: 3
  },
  {
    postalCode: 2716,
    city: "Four Corners",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.136,
    longitude: 146.3019,
    accuracy: 4
  },
  {
    postalCode: 2716,
    city: "Mairjimmy",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4932,
    longitude: 145.7475,
    accuracy: 4
  },
  {
    postalCode: 2716,
    city: "Gala Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4283,
    longitude: 145.7311,
    accuracy: 3
  },
  {
    postalCode: 2716,
    city: "Mabins Well",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.247,
    longitude: 145.5718,
    accuracy: 3
  },
  {
    postalCode: 2716,
    city: "Jerilderie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3576,
    longitude: 145.7296,
    accuracy: 4
  },
  {
    postalCode: 2717,
    city: "Dareton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0947,
    longitude: 142.0397,
    accuracy: 4
  },
  {
    postalCode: 2717,
    city: "Coomealla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0981,
    longitude: 142.0925,
    accuracy: 4
  },
  {
    postalCode: 2720,
    city: "Bombowlee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2628,
    longitude: 148.2449,
    accuracy: 4
  },
  {
    postalCode: 2720,
    city: "Pinbeyan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3366,
    longitude: 148.2926,
    accuracy: 3
  },
  {
    postalCode: 2720,
    city: "Lacmalac",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3167,
    longitude: 148.3167,
    accuracy: 4
  },
  {
    postalCode: 2720,
    city: "Blowering",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.5117,
    longitude: 148.2658,
    accuracy: 4
  },
  {
    postalCode: 2720,
    city: "Talbingo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.581,
    longitude: 148.2948,
    accuracy: 4
  },
  {
    postalCode: 2720,
    city: "Gadara",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3366,
    longitude: 148.2926,
    accuracy: 3
  },
  {
    postalCode: 2720,
    city: "Red Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0523,
    longitude: 149.1643,
    accuracy: 4
  },
  {
    postalCode: 2720,
    city: "Tumut",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3002,
    longitude: 148.2251,
    accuracy: 4
  },
  {
    postalCode: 2720,
    city: "Minjary",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1999,
    longitude: 148.1346,
    accuracy: 4
  },
  {
    postalCode: 2720,
    city: "Mundongo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2907,
    longitude: 148.2805,
    accuracy: 4
  },
  {
    postalCode: 2720,
    city: "Tumorrama",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1667,
    longitude: 148.4333,
    accuracy: 4
  },
  {
    postalCode: 2720,
    city: "Argalong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3,
    longitude: 148.4333,
    accuracy: 4
  },
  {
    postalCode: 2720,
    city: "Yarrangobilly",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.65,
    longitude: 148.4833,
    accuracy: 4
  },
  {
    postalCode: 2720,
    city: "Couragago",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3366,
    longitude: 148.2926,
    accuracy: 3
  },
  {
    postalCode: 2720,
    city: "Gocup",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2333,
    longitude: 148.2,
    accuracy: 4
  },
  {
    postalCode: 2720,
    city: "Gilmore",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3333,
    longitude: 148.1833,
    accuracy: 4
  },
  {
    postalCode: 2720,
    city: "Killimicat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3366,
    longitude: 148.2926,
    accuracy: 3
  },
  {
    postalCode: 2720,
    city: "Little River",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3366,
    longitude: 148.2926,
    accuracy: 3
  },
  {
    postalCode: 2720,
    city: "Goobarragandra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3366,
    longitude: 148.2926,
    accuracy: 3
  },
  {
    postalCode: 2720,
    city: "Jones Bridge",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3366,
    longitude: 148.2926,
    accuracy: 3
  },
  {
    postalCode: 2720,
    city: "Bombowlee Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3366,
    longitude: 148.2926,
    accuracy: 3
  },
  {
    postalCode: 2720,
    city: "Wyangle",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2333,
    longitude: 148.3,
    accuracy: 4
  },
  {
    postalCode: 2720,
    city: "Buddong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3366,
    longitude: 148.2926,
    accuracy: 3
  },
  {
    postalCode: 2720,
    city: "Windowie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3366,
    longitude: 148.2926,
    accuracy: 3
  },
  {
    postalCode: 2720,
    city: "Tumut Plains",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3366,
    longitude: 148.2926,
    accuracy: 3
  },
  {
    postalCode: 2720,
    city: "Bogong Peaks Wilderness",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3366,
    longitude: 148.2926,
    accuracy: 3
  },
  {
    postalCode: 2720,
    city: "Wereboldera",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3366,
    longitude: 148.2926,
    accuracy: 3
  },
  {
    postalCode: 2720,
    city: "Wermatong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3366,
    longitude: 148.2926,
    accuracy: 3
  },
  {
    postalCode: 2721,
    city: "Quandialla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0124,
    longitude: 147.7876,
    accuracy: 4
  },
  {
    postalCode: 2721,
    city: "Bland",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9833,
    longitude: 147.6833,
    accuracy: 4
  },
  {
    postalCode: 2722,
    city: "Gundagai",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0652,
    longitude: 148.108,
    accuracy: 4
  },
  {
    postalCode: 2722,
    city: "Darbalara",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0167,
    longitude: 148.2,
    accuracy: 4
  },
  {
    postalCode: 2722,
    city: "South Gundagai",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0833,
    longitude: 148.1,
    accuracy: 4
  },
  {
    postalCode: 2722,
    city: "Brungle Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0275,
    longitude: 148.1097,
    accuracy: 3
  },
  {
    postalCode: 2722,
    city: "Brungle",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.15,
    longitude: 148.2333,
    accuracy: 4
  },
  {
    postalCode: 2722,
    city: "Jones Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0275,
    longitude: 148.1097,
    accuracy: 3
  },
  {
    postalCode: 2722,
    city: "Muttama",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.7985,
    longitude: 148.1179,
    accuracy: 4
  },
  {
    postalCode: 2722,
    city: "Burra Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0275,
    longitude: 148.1097,
    accuracy: 3
  },
  {
    postalCode: 2722,
    city: "Nangus",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.05,
    longitude: 147.9,
    accuracy: 4
  },
  {
    postalCode: 2725,
    city: "Stockinbingal",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4989,
    longitude: 147.882,
    accuracy: 4
  },
  {
    postalCode: 2726,
    city: "Cooneys Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8333,
    longitude: 148.3333,
    accuracy: 3
  },
  {
    postalCode: 2726,
    city: "Jugiong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8333,
    longitude: 148.3333,
    accuracy: 4
  },
  {
    postalCode: 2727,
    city: "Coolac",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.9285,
    longitude: 148.1651,
    accuracy: 4
  },
  {
    postalCode: 2727,
    city: "Gobarralong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.9902,
    longitude: 148.2512,
    accuracy: 4
  },
  {
    postalCode: 2727,
    city: "Adjungbilly",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0873,
    longitude: 148.4185,
    accuracy: 4
  },
  {
    postalCode: 2729,
    city: "Westwood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2452,
    longitude: 147.9929,
    accuracy: 3
  },
  {
    postalCode: 2729,
    city: "Mount Horeb",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2167,
    longitude: 148.0333,
    accuracy: 4
  },
  {
    postalCode: 2729,
    city: "Sandy Gully",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2452,
    longitude: 147.9929,
    accuracy: 3
  },
  {
    postalCode: 2729,
    city: "Cooleys Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2633,
    longitude: 148.0041,
    accuracy: 3
  },
  {
    postalCode: 2729,
    city: "Califat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2452,
    longitude: 147.9929,
    accuracy: 3
  },
  {
    postalCode: 2729,
    city: "Black Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2452,
    longitude: 147.9929,
    accuracy: 3
  },
  {
    postalCode: 2729,
    city: "Adelong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.3049,
    longitude: 148.069,
    accuracy: 4
  },
  {
    postalCode: 2729,
    city: "Tumblong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.15,
    longitude: 148,
    accuracy: 4
  },
  {
    postalCode: 2729,
    city: "Grahamstown",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2667,
    longitude: 148.0333,
    accuracy: 4
  },
  {
    postalCode: 2729,
    city: "Darlow",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2452,
    longitude: 147.9929,
    accuracy: 3
  },
  {
    postalCode: 2729,
    city: "Sharps Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2452,
    longitude: 147.9929,
    accuracy: 3
  },
  {
    postalCode: 2729,
    city: "Mundarlo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1333,
    longitude: 147.8167,
    accuracy: 4
  },
  {
    postalCode: 2729,
    city: "Yaven Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2452,
    longitude: 147.9929,
    accuracy: 3
  },
  {
    postalCode: 2729,
    city: "Bangadang",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2452,
    longitude: 147.9929,
    accuracy: 3
  },
  {
    postalCode: 2729,
    city: "Ellerslie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3103,
    longitude: 147.2462,
    accuracy: 4
  },
  {
    postalCode: 2729,
    city: "Mount Adrah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.2167,
    longitude: 147.9,
    accuracy: 4
  },
  {
    postalCode: 2729,
    city: "Wondalga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.4167,
    longitude: 148.1167,
    accuracy: 4
  },
  {
    postalCode: 2730,
    city: "Green Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9176,
    longitude: 149.5836,
    accuracy: 4
  },
  {
    postalCode: 2730,
    city: "Kunama",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.5494,
    longitude: 148.0982,
    accuracy: 4
  },
  {
    postalCode: 2730,
    city: "Lower Bago",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.524,
    longitude: 148.0994,
    accuracy: 3
  },
  {
    postalCode: 2730,
    city: "Batlow",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.5191,
    longitude: 148.146,
    accuracy: 4
  },
  {
    postalCode: 2731,
    city: "Bunnaloo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7869,
    longitude: 144.5977,
    accuracy: 4
  },
  {
    postalCode: 2731,
    city: "Tantonan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1588,
    longitude: 146.0447,
    accuracy: 3
  },
  {
    postalCode: 2731,
    city: "Womboota",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.9073,
    longitude: 144.6,
    accuracy: 4
  },
  {
    postalCode: 2731,
    city: "Thyra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.8401,
    longitude: 144.6356,
    accuracy: 4
  },
  {
    postalCode: 2731,
    city: "Moama",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.1041,
    longitude: 144.7608,
    accuracy: 4
  },
  {
    postalCode: 2732,
    city: "Burraboi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.393,
    longitude: 144.3159,
    accuracy: 4
  },
  {
    postalCode: 2732,
    city: "Gonn",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1588,
    longitude: 146.0447,
    accuracy: 3
  },
  {
    postalCode: 2732,
    city: "Cobramunga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1588,
    longitude: 146.0447,
    accuracy: 3
  },
  {
    postalCode: 2732,
    city: "Tullakool",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1588,
    longitude: 146.0447,
    accuracy: 3
  },
  {
    postalCode: 2732,
    city: "Thule",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1588,
    longitude: 146.0447,
    accuracy: 3
  },
  {
    postalCode: 2732,
    city: "Barham",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.6265,
    longitude: 144.129,
    accuracy: 4
  },
  {
    postalCode: 2732,
    city: "Noorong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1588,
    longitude: 146.0447,
    accuracy: 3
  },
  {
    postalCode: 2733,
    city: "Dhuragoon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1588,
    longitude: 146.0447,
    accuracy: 3
  },
  {
    postalCode: 2733,
    city: "Niemur",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1588,
    longitude: 146.0447,
    accuracy: 3
  },
  {
    postalCode: 2733,
    city: "Moulamein",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0906,
    longitude: 144.0363,
    accuracy: 4
  },
  {
    postalCode: 2734,
    city: "Dilpurra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1652,
    longitude: 143.6846,
    accuracy: 4
  },
  {
    postalCode: 2734,
    city: "Stony Crossing",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0813,
    longitude: 143.5498,
    accuracy: 4
  },
  {
    postalCode: 2734,
    city: "Cunninyeuk",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1588,
    longitude: 146.0447,
    accuracy: 3
  },
  {
    postalCode: 2734,
    city: "Kyalite",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.9532,
    longitude: 143.4775,
    accuracy: 4
  },
  {
    postalCode: 2734,
    city: "Mallan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1588,
    longitude: 146.0447,
    accuracy: 3
  },
  {
    postalCode: 2734,
    city: "Wetuppa",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1588,
    longitude: 146.0447,
    accuracy: 3
  },
  {
    postalCode: 2734,
    city: "Tooranie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1588,
    longitude: 146.0447,
    accuracy: 3
  },
  {
    postalCode: 2734,
    city: "Murray Downs",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1588,
    longitude: 146.0447,
    accuracy: 3
  },
  {
    postalCode: 2734,
    city: "Mellool",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1588,
    longitude: 146.0447,
    accuracy: 3
  },
  {
    postalCode: 2734,
    city: "Moolpa",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1588,
    longitude: 146.0447,
    accuracy: 3
  },
  {
    postalCode: 2735,
    city: "Koraleigh",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1286,
    longitude: 143.4404,
    accuracy: 4
  },
  {
    postalCode: 2735,
    city: "Speewa",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1588,
    longitude: 146.0447,
    accuracy: 3
  },
  {
    postalCode: 2736,
    city: "Goodnight",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.959,
    longitude: 143.3395,
    accuracy: 4
  },
  {
    postalCode: 2736,
    city: "Tooleybuc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0318,
    longitude: 143.3346,
    accuracy: 4
  },
  {
    postalCode: 2737,
    city: "Euston",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.5744,
    longitude: 142.7448,
    accuracy: 4
  },
  {
    postalCode: 2738,
    city: "Paringi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2366,
    longitude: 142.5301,
    accuracy: 3
  },
  {
    postalCode: 2738,
    city: "Gol Gol",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1739,
    longitude: 142.2219,
    accuracy: 4
  },
  {
    postalCode: 2738,
    city: "Trentham Cliffs",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2366,
    longitude: 142.5301,
    accuracy: 3
  },
  {
    postalCode: 2738,
    city: "Mallee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2366,
    longitude: 142.5301,
    accuracy: 3
  },
  {
    postalCode: 2738,
    city: "Monak",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.2818,
    longitude: 142.2679,
    accuracy: 4
  },
  {
    postalCode: 2739,
    city: "Mourquong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1588,
    longitude: 146.0447,
    accuracy: 3
  },
  {
    postalCode: 2739,
    city: "Boeill Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1432,
    longitude: 142.1201,
    accuracy: 4
  },
  {
    postalCode: 2739,
    city: "Buronga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1707,
    longitude: 142.1735,
    accuracy: 4
  },
  {
    postalCode: 2745,
    city: "Mulgoa",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.838,
    longitude: 150.6496,
    accuracy: 4
  },
  {
    postalCode: 2745,
    city: "Glenmore Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7907,
    longitude: 150.6693,
    accuracy: 4
  },
  {
    postalCode: 2745,
    city: "Greendale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9274,
    longitude: 150.663,
    accuracy: 4
  },
  {
    postalCode: 2745,
    city: "Luddenham",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8785,
    longitude: 150.6886,
    accuracy: 4
  },
  {
    postalCode: 2745,
    city: "Regentville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7752,
    longitude: 150.6655,
    accuracy: 4
  },
  {
    postalCode: 2745,
    city: "Wallacia",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8658,
    longitude: 150.6402,
    accuracy: 4
  },
  {
    postalCode: 2747,
    city: "Claremont Meadows",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7759,
    longitude: 150.7519,
    accuracy: 4
  },
  {
    postalCode: 2747,
    city: "Kingswood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.75,
    longitude: 150.75,
    accuracy: 4
  },
  {
    postalCode: 2747,
    city: "Shanes Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7033,
    longitude: 150.783,
    accuracy: 4
  },
  {
    postalCode: 2747,
    city: "Cambridge Gardens",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.738,
    longitude: 150.7207,
    accuracy: 4
  },
  {
    postalCode: 2747,
    city: "Caddens",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7472,
    longitude: 150.7444,
    accuracy: 3
  },
  {
    postalCode: 2747,
    city: "Werrington",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7592,
    longitude: 150.7527,
    accuracy: 4
  },
  {
    postalCode: 2747,
    city: "Cambridge Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7478,
    longitude: 150.7221,
    accuracy: 4
  },
  {
    postalCode: 2747,
    city: "Werrington County",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7465,
    longitude: 150.7393,
    accuracy: 4
  },
  {
    postalCode: 2747,
    city: "Llandilo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7129,
    longitude: 150.7465,
    accuracy: 4
  },
  {
    postalCode: 2747,
    city: "Werrington Downs",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7421,
    longitude: 150.7278,
    accuracy: 4
  },
  {
    postalCode: 2747,
    city: "Jordan Springs",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7472,
    longitude: 150.7444,
    accuracy: 3
  },
  {
    postalCode: 2748,
    city: "Orchard Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7823,
    longitude: 150.7109,
    accuracy: 4
  },
  {
    postalCode: 2749,
    city: "Castlereagh",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6898,
    longitude: 150.6789,
    accuracy: 4
  },
  {
    postalCode: 2749,
    city: "Cranebrook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7061,
    longitude: 150.7094,
    accuracy: 4
  },
  {
    postalCode: 2750,
    city: "Penrith",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.75,
    longitude: 150.7,
    accuracy: 4
  },
  {
    postalCode: 2750,
    city: "Leonay",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7654,
    longitude: 150.6481,
    accuracy: 4
  },
  {
    postalCode: 2750,
    city: "Jamisontown",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.768,
    longitude: 150.6768,
    accuracy: 4
  },
  {
    postalCode: 2750,
    city: "Emu Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7345,
    longitude: 150.6487,
    accuracy: 4
  },
  {
    postalCode: 2750,
    city: "South Penrith",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7735,
    longitude: 150.6947,
    accuracy: 4
  },
  {
    postalCode: 2750,
    city: "Emu Plains",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.75,
    longitude: 150.6667,
    accuracy: 4
  },
  {
    postalCode: 2750,
    city: "Penrith Plaza",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7583,
    longitude: 150.6729,
    accuracy: 3
  },
  {
    postalCode: 2750,
    city: "Penrith South",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7583,
    longitude: 150.6729,
    accuracy: 3
  },
  {
    postalCode: 2751,
    city: "Penrith",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.75,
    longitude: 150.7,
    accuracy: 4
  },
  {
    postalCode: 2752,
    city: "Warragamba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8919,
    longitude: 150.6046,
    accuracy: 4
  },
  {
    postalCode: 2752,
    city: "Silverdale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9152,
    longitude: 150.6096,
    accuracy: 4
  },
  {
    postalCode: 2753,
    city: "Londonderry",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6466,
    longitude: 150.7352,
    accuracy: 4
  },
  {
    postalCode: 2753,
    city: "Agnes Banks",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6094,
    longitude: 150.7167,
    accuracy: 4
  },
  {
    postalCode: 2753,
    city: "Grose Wold",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6075,
    longitude: 150.6945,
    accuracy: 3
  },
  {
    postalCode: 2753,
    city: "Hobartville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6044,
    longitude: 150.743,
    accuracy: 4
  },
  {
    postalCode: 2753,
    city: "Bowen Mountain",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5719,
    longitude: 150.6256,
    accuracy: 4
  },
  {
    postalCode: 2753,
    city: "Yarramundi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6194,
    longitude: 150.6748,
    accuracy: 4
  },
  {
    postalCode: 2753,
    city: "Grose Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5871,
    longitude: 150.6556,
    accuracy: 4
  },
  {
    postalCode: 2753,
    city: "Richmond",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5996,
    longitude: 150.7514,
    accuracy: 4
  },
  {
    postalCode: 2753,
    city: "Richmond Lowlands",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.608,
    longitude: 150.6988,
    accuracy: 3
  },
  {
    postalCode: 2754,
    city: "The Slopes",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5324,
    longitude: 150.7056,
    accuracy: 4
  },
  {
    postalCode: 2754,
    city: "North Richmond",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5812,
    longitude: 150.7194,
    accuracy: 4
  },
  {
    postalCode: 2754,
    city: "Tennyson",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.533,
    longitude: 150.7375,
    accuracy: 4
  },
  {
    postalCode: 2755,
    city: "Richmond Raaf",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5971,
    longitude: 150.7584,
    accuracy: 3
  },
  {
    postalCode: 2755,
    city: "Richmond",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5996,
    longitude: 150.7514,
    accuracy: 4
  },
  {
    postalCode: 2756,
    city: "Bligh Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6398,
    longitude: 150.8025,
    accuracy: 4
  },
  {
    postalCode: 2756,
    city: "Cornwallis",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5006,
    longitude: 150.8816,
    accuracy: 3
  },
  {
    postalCode: 2756,
    city: "Colo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4333,
    longitude: 150.8333,
    accuracy: 4
  },
  {
    postalCode: 2756,
    city: "Mellong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.146,
    longitude: 150.6847,
    accuracy: 4
  },
  {
    postalCode: 2756,
    city: "Ebenezer",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5198,
    longitude: 150.8863,
    accuracy: 4
  },
  {
    postalCode: 2756,
    city: "Freemans Reach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5579,
    longitude: 150.7955,
    accuracy: 4
  },
  {
    postalCode: 2756,
    city: "Cumberland Reach",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4648,
    longitude: 150.895,
    accuracy: 4
  },
  {
    postalCode: 2756,
    city: "Colo Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3685,
    longitude: 150.7208,
    accuracy: 4
  },
  {
    postalCode: 2756,
    city: "Glossodia",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5362,
    longitude: 150.7739,
    accuracy: 4
  },
  {
    postalCode: 2756,
    city: "Sackville North",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4841,
    longitude: 150.888,
    accuracy: 4
  },
  {
    postalCode: 2756,
    city: "Cattai",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5457,
    longitude: 150.9143,
    accuracy: 4
  },
  {
    postalCode: 2756,
    city: "Upper Colo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4215,
    longitude: 150.7264,
    accuracy: 4
  },
  {
    postalCode: 2756,
    city: "Pitt Town",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5872,
    longitude: 150.8586,
    accuracy: 4
  },
  {
    postalCode: 2756,
    city: "Mulgrave",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5006,
    longitude: 150.8816,
    accuracy: 3
  },
  {
    postalCode: 2756,
    city: "Mcgraths Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6155,
    longitude: 150.8337,
    accuracy: 4
  },
  {
    postalCode: 2756,
    city: "Pitt Town Bottoms",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5274,
    longitude: 150.8499,
    accuracy: 3
  },
  {
    postalCode: 2756,
    city: "South Maroota",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.504,
    longitude: 150.9568,
    accuracy: 4
  },
  {
    postalCode: 2756,
    city: "Sackville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4833,
    longitude: 150.9,
    accuracy: 4
  },
  {
    postalCode: 2756,
    city: "Maroota",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4833,
    longitude: 150.95,
    accuracy: 4
  },
  {
    postalCode: 2756,
    city: "Windsor Downs",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6677,
    longitude: 150.8026,
    accuracy: 4
  },
  {
    postalCode: 2756,
    city: "Central Colo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4333,
    longitude: 150.8333,
    accuracy: 4
  },
  {
    postalCode: 2756,
    city: "Windsor",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6131,
    longitude: 150.8142,
    accuracy: 4
  },
  {
    postalCode: 2756,
    city: "Womerah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5274,
    longitude: 150.8499,
    accuracy: 3
  },
  {
    postalCode: 2756,
    city: "Scheyville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6045,
    longitude: 150.8831,
    accuracy: 4
  },
  {
    postalCode: 2756,
    city: "South Windsor",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6181,
    longitude: 150.8044,
    accuracy: 4
  },
  {
    postalCode: 2756,
    city: "Wilberforce",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5626,
    longitude: 150.8378,
    accuracy: 4
  },
  {
    postalCode: 2756,
    city: "Lower Portland",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.45,
    longitude: 150.8833,
    accuracy: 4
  },
  {
    postalCode: 2756,
    city: "Clarendon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6096,
    longitude: 150.7867,
    accuracy: 4
  },
  {
    postalCode: 2757,
    city: "Kurmond",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5533,
    longitude: 150.6947,
    accuracy: 4
  },
  {
    postalCode: 2758,
    city: "Blaxlands Ridge",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4733,
    longitude: 150.7981,
    accuracy: 4
  },
  {
    postalCode: 2758,
    city: "Wheeny Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5068,
    longitude: 150.6768,
    accuracy: 3
  },
  {
    postalCode: 2758,
    city: "Mountain Lagoon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5068,
    longitude: 150.6768,
    accuracy: 3
  },
  {
    postalCode: 2758,
    city: "Bilpin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5,
    longitude: 150.5333,
    accuracy: 4
  },
  {
    postalCode: 2758,
    city: "Mount Tomah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5466,
    longitude: 150.4223,
    accuracy: 4
  },
  {
    postalCode: 2758,
    city: "Kurrajong Hills",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5068,
    longitude: 150.6768,
    accuracy: 3
  },
  {
    postalCode: 2758,
    city: "East Kurrajong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5055,
    longitude: 150.7943,
    accuracy: 4
  },
  {
    postalCode: 2758,
    city: "Berambing",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5326,
    longitude: 150.4439,
    accuracy: 4
  },
  {
    postalCode: 2758,
    city: "Kurrajong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5277,
    longitude: 150.6291,
    accuracy: 4
  },
  {
    postalCode: 2758,
    city: "The Devils Wilderness",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5068,
    longitude: 150.6768,
    accuracy: 3
  },
  {
    postalCode: 2758,
    city: "Kurrajong Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5277,
    longitude: 150.6291,
    accuracy: 4
  },
  {
    postalCode: 2759,
    city: "St Clair",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7973,
    longitude: 150.7847,
    accuracy: 4
  },
  {
    postalCode: 2759,
    city: "Erskine Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.813,
    longitude: 150.7977,
    accuracy: 4
  },
  {
    postalCode: 2760,
    city: "Colyton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7828,
    longitude: 150.7968,
    accuracy: 4
  },
  {
    postalCode: 2760,
    city: "St Marys East",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7593,
    longitude: 150.7883,
    accuracy: 3
  },
  {
    postalCode: 2760,
    city: "North St Marys",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7549,
    longitude: 150.7844,
    accuracy: 4
  },
  {
    postalCode: 2760,
    city: "Ropes Crossing",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7288,
    longitude: 150.777,
    accuracy: 4
  },
  {
    postalCode: 2760,
    city: "Oxley Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7707,
    longitude: 150.795,
    accuracy: 4
  },
  {
    postalCode: 2760,
    city: "St Marys",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.744,
    longitude: 150.783,
    accuracy: 3
  },
  {
    postalCode: 2760,
    city: "St Marys South",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7593,
    longitude: 150.7883,
    accuracy: 3
  },
  {
    postalCode: 2761,
    city: "Plumpton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7518,
    longitude: 150.8369,
    accuracy: 4
  },
  {
    postalCode: 2761,
    city: "Hassall Grove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7335,
    longitude: 150.8354,
    accuracy: 4
  },
  {
    postalCode: 2761,
    city: "Dean Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7354,
    longitude: 150.8596,
    accuracy: 4
  },
  {
    postalCode: 2761,
    city: "Oakhurst",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7388,
    longitude: 150.8384,
    accuracy: 4
  },
  {
    postalCode: 2761,
    city: "Colebee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7277,
    longitude: 150.8474,
    accuracy: 4
  },
  {
    postalCode: 2761,
    city: "Glendenning",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7483,
    longitude: 150.8541,
    accuracy: 4
  },
  {
    postalCode: 2762,
    city: "Schofields",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7167,
    longitude: 150.8667,
    accuracy: 4
  },
  {
    postalCode: 2763,
    city: "Quakers Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7333,
    longitude: 150.8833,
    accuracy: 4
  },
  {
    postalCode: 2763,
    city: "Acacia Gardens",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7334,
    longitude: 150.9139,
    accuracy: 4
  },
  {
    postalCode: 2765,
    city: "Box Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6441,
    longitude: 150.8684,
    accuracy: 3
  },
  {
    postalCode: 2765,
    city: "Vineyard",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6499,
    longitude: 150.8526,
    accuracy: 4
  },
  {
    postalCode: 2765,
    city: "Nelson",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6462,
    longitude: 150.9214,
    accuracy: 4
  },
  {
    postalCode: 2765,
    city: "Oakville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6156,
    longitude: 150.8801,
    accuracy: 4
  },
  {
    postalCode: 2765,
    city: "Riverstone",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6833,
    longitude: 150.8667,
    accuracy: 4
  },
  {
    postalCode: 2765,
    city: "Marsden Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.692,
    longitude: 150.8373,
    accuracy: 4
  },
  {
    postalCode: 2765,
    city: "Maraylya",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5922,
    longitude: 150.9198,
    accuracy: 4
  },
  {
    postalCode: 2765,
    city: "Berkshire Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6728,
    longitude: 150.7752,
    accuracy: 4
  },
  {
    postalCode: 2766,
    city: "Eastern Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8063,
    longitude: 150.8612,
    accuracy: 4
  },
  {
    postalCode: 2766,
    city: "Rooty Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7667,
    longitude: 150.8333,
    accuracy: 4
  },
  {
    postalCode: 2767,
    city: "Bungarribee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7615,
    longitude: 150.8737,
    accuracy: 3
  },
  {
    postalCode: 2767,
    city: "Woodcroft",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7564,
    longitude: 150.8807,
    accuracy: 4
  },
  {
    postalCode: 2767,
    city: "Doonside",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7667,
    longitude: 150.8667,
    accuracy: 4
  },
  {
    postalCode: 2768,
    city: "Parklea",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7244,
    longitude: 150.9182,
    accuracy: 4
  },
  {
    postalCode: 2768,
    city: "Stanhope Gardens",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7164,
    longitude: 150.9261,
    accuracy: 4
  },
  {
    postalCode: 2768,
    city: "Glenwood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7357,
    longitude: 150.9348,
    accuracy: 4
  },
  {
    postalCode: 2769,
    city: "The Ponds",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7061,
    longitude: 150.9088,
    accuracy: 4
  },
  {
    postalCode: 2770,
    city: "Lethbridge Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7372,
    longitude: 150.8004,
    accuracy: 4
  },
  {
    postalCode: 2770,
    city: "Tregear",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7456,
    longitude: 150.7929,
    accuracy: 4
  },
  {
    postalCode: 2770,
    city: "Bidwill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7301,
    longitude: 150.8222,
    accuracy: 4
  },
  {
    postalCode: 2770,
    city: "Dharruk",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7481,
    longitude: 150.8156,
    accuracy: 4
  },
  {
    postalCode: 2770,
    city: "Hebersham",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7458,
    longitude: 150.8239,
    accuracy: 4
  },
  {
    postalCode: 2770,
    city: "Whalan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.757,
    longitude: 150.804,
    accuracy: 4
  },
  {
    postalCode: 2770,
    city: "Willmot",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7241,
    longitude: 150.7928,
    accuracy: 4
  },
  {
    postalCode: 2770,
    city: "Minchinbury",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7872,
    longitude: 150.8296,
    accuracy: 4
  },
  {
    postalCode: 2770,
    city: "Emerton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7441,
    longitude: 150.8064,
    accuracy: 4
  },
  {
    postalCode: 2770,
    city: "Mount Druitt Village",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7467,
    longitude: 150.8101,
    accuracy: 3
  },
  {
    postalCode: 2770,
    city: "Mount Druitt",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7667,
    longitude: 150.8167,
    accuracy: 4
  },
  {
    postalCode: 2770,
    city: "Shalvey",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7276,
    longitude: 150.8066,
    accuracy: 4
  },
  {
    postalCode: 2770,
    city: "Blackett",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7379,
    longitude: 150.8181,
    accuracy: 4
  },
  {
    postalCode: 2773,
    city: "Lapstone",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7742,
    longitude: 150.6357,
    accuracy: 4
  },
  {
    postalCode: 2773,
    city: "Glenbrook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7667,
    longitude: 150.6167,
    accuracy: 4
  },
  {
    postalCode: 2774,
    city: "Mount Riverview",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7307,
    longitude: 150.6353,
    accuracy: 4
  },
  {
    postalCode: 2774,
    city: "Blaxland East",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7325,
    longitude: 150.6118,
    accuracy: 3
  },
  {
    postalCode: 2774,
    city: "Blaxland",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.75,
    longitude: 150.6,
    accuracy: 4
  },
  {
    postalCode: 2774,
    city: "Warrimoo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7167,
    longitude: 150.6,
    accuracy: 4
  },
  {
    postalCode: 2775,
    city: "Wisemans Ferry",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3833,
    longitude: 150.9833,
    accuracy: 4
  },
  {
    postalCode: 2775,
    city: "Spencer",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4593,
    longitude: 151.1447,
    accuracy: 4
  },
  {
    postalCode: 2775,
    city: "Marlow",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4639,
    longitude: 151.166,
    accuracy: 4
  },
  {
    postalCode: 2775,
    city: "St Albans",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2833,
    longitude: 150.9833,
    accuracy: 4
  },
  {
    postalCode: 2775,
    city: "Higher Macdonald",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3998,
    longitude: 151.0311,
    accuracy: 3
  },
  {
    postalCode: 2775,
    city: "Singletons Mill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3998,
    longitude: 151.0311,
    accuracy: 3
  },
  {
    postalCode: 2775,
    city: "Perrys Crossing",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3998,
    longitude: 151.0311,
    accuracy: 3
  },
  {
    postalCode: 2775,
    city: "Lower Macdonald",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3653,
    longitude: 150.9511,
    accuracy: 4
  },
  {
    postalCode: 2775,
    city: "Central Macdonald",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2453,
    longitude: 150.8513,
    accuracy: 3
  },
  {
    postalCode: 2775,
    city: "Webbs Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3998,
    longitude: 151.0311,
    accuracy: 3
  },
  {
    postalCode: 2775,
    city: "Leets Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3998,
    longitude: 151.0311,
    accuracy: 3
  },
  {
    postalCode: 2775,
    city: "Fernances",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3998,
    longitude: 151.0311,
    accuracy: 3
  },
  {
    postalCode: 2775,
    city: "Wrights Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3998,
    longitude: 151.0311,
    accuracy: 3
  },
  {
    postalCode: 2775,
    city: "Upper Macdonald",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3998,
    longitude: 151.0311,
    accuracy: 3
  },
  {
    postalCode: 2775,
    city: "Laughtondale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4167,
    longitude: 151.0333,
    accuracy: 4
  },
  {
    postalCode: 2775,
    city: "Gunderman",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.45,
    longitude: 151.0667,
    accuracy: 4
  },
  {
    postalCode: 2775,
    city: "Mogo Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3998,
    longitude: 151.0311,
    accuracy: 3
  },
  {
    postalCode: 2775,
    city: "Lower Hawkesbury",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.45,
    longitude: 151.05,
    accuracy: 4
  },
  {
    postalCode: 2776,
    city: "Faulconbridge",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7,
    longitude: 150.5333,
    accuracy: 4
  },
  {
    postalCode: 2777,
    city: "Hawkesbury Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6657,
    longitude: 150.6426,
    accuracy: 4
  },
  {
    postalCode: 2777,
    city: "Sun Valley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7088,
    longitude: 150.5937,
    accuracy: 4
  },
  {
    postalCode: 2777,
    city: "Winmalee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6785,
    longitude: 150.6121,
    accuracy: 4
  },
  {
    postalCode: 2777,
    city: "Yellow Rock",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6985,
    longitude: 150.6346,
    accuracy: 4
  },
  {
    postalCode: 2777,
    city: "Springwood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7,
    longitude: 150.55,
    accuracy: 4
  },
  {
    postalCode: 2777,
    city: "Valley Heights",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7,
    longitude: 150.5833,
    accuracy: 4
  },
  {
    postalCode: 2778,
    city: "Linden",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7167,
    longitude: 150.5,
    accuracy: 4
  },
  {
    postalCode: 2778,
    city: "Woodford",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7333,
    longitude: 150.4833,
    accuracy: 4
  },
  {
    postalCode: 2779,
    city: "Hazelbrook",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7245,
    longitude: 150.4584,
    accuracy: 4
  },
  {
    postalCode: 2780,
    city: "Katoomba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7198,
    longitude: 150.3074,
    accuracy: 4
  },
  {
    postalCode: 2780,
    city: "Katoomba DC",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7053,
    longitude: 150.3076,
    accuracy: 3
  },
  {
    postalCode: 2780,
    city: "Medlow Bath",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6746,
    longitude: 150.2788,
    accuracy: 4
  },
  {
    postalCode: 2780,
    city: "Leura",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7167,
    longitude: 150.3333,
    accuracy: 4
  },
  {
    postalCode: 2782,
    city: "Wentworth Falls",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7103,
    longitude: 150.3753,
    accuracy: 4
  },
  {
    postalCode: 2783,
    city: "Lawson",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7206,
    longitude: 150.4297,
    accuracy: 4
  },
  {
    postalCode: 2784,
    city: "Bullaburra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7292,
    longitude: 150.4177,
    accuracy: 4
  },
  {
    postalCode: 2785,
    city: "Megalong Valley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6835,
    longitude: 150.2679,
    accuracy: 3
  },
  {
    postalCode: 2785,
    city: "Blackheath",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6357,
    longitude: 150.2832,
    accuracy: 4
  },
  {
    postalCode: 2785,
    city: "Megalong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7333,
    longitude: 150.25,
    accuracy: 4
  },
  {
    postalCode: 2786,
    city: "Mount Irvine",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4849,
    longitude: 150.4612,
    accuracy: 4
  },
  {
    postalCode: 2786,
    city: "Mount Victoria",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.591,
    longitude: 150.2554,
    accuracy: 4
  },
  {
    postalCode: 2786,
    city: "Bell",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5167,
    longitude: 150.2,
    accuracy: 4
  },
  {
    postalCode: 2786,
    city: "Mount Wilson",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5035,
    longitude: 150.3749,
    accuracy: 4
  },
  {
    postalCode: 2786,
    city: "Dargan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4896,
    longitude: 150.2504,
    accuracy: 4
  },
  {
    postalCode: 2787,
    city: "Duckmaloi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6799,
    longitude: 149.9642,
    accuracy: 3
  },
  {
    postalCode: 2787,
    city: "Essington",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7,
    longitude: 149.7167,
    accuracy: 4
  },
  {
    postalCode: 2787,
    city: "Oberon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.704,
    longitude: 149.8591,
    accuracy: 4
  },
  {
    postalCode: 2787,
    city: "Edith",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8,
    longitude: 149.9167,
    accuracy: 4
  },
  {
    postalCode: 2787,
    city: "Shooters Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9167,
    longitude: 149.8667,
    accuracy: 4
  },
  {
    postalCode: 2787,
    city: "Black Springs",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8667,
    longitude: 149.7167,
    accuracy: 4
  },
  {
    postalCode: 2787,
    city: "Mount Werong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7787,
    longitude: 149.8476,
    accuracy: 3
  },
  {
    postalCode: 2787,
    city: "Mayfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8979,
    longitude: 151.7361,
    accuracy: 4
  },
  {
    postalCode: 2787,
    city: "Gurnang",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7787,
    longitude: 149.8476,
    accuracy: 3
  },
  {
    postalCode: 2787,
    city: "Tarana",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5167,
    longitude: 149.9167,
    accuracy: 4
  },
  {
    postalCode: 2787,
    city: "Hazelgrove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.65,
    longitude: 149.8667,
    accuracy: 4
  },
  {
    postalCode: 2787,
    city: "Porters Retreat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34,
    longitude: 149.8167,
    accuracy: 4
  },
  {
    postalCode: 2787,
    city: "Gingkin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8667,
    longitude: 149.9333,
    accuracy: 4
  },
  {
    postalCode: 2787,
    city: "Chatham Valley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7787,
    longitude: 149.8476,
    accuracy: 3
  },
  {
    postalCode: 2787,
    city: "Mozart",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7787,
    longitude: 149.8476,
    accuracy: 3
  },
  {
    postalCode: 2787,
    city: "Norway",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7667,
    longitude: 149.8667,
    accuracy: 4
  },
  {
    postalCode: 2787,
    city: "The Meadows",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7787,
    longitude: 149.8476,
    accuracy: 3
  },
  {
    postalCode: 2787,
    city: "Jaunter",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7787,
    longitude: 149.8476,
    accuracy: 3
  },
  {
    postalCode: 2787,
    city: "Kanangra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7787,
    longitude: 149.8476,
    accuracy: 3
  },
  {
    postalCode: 2787,
    city: "Mount Olive",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7787,
    longitude: 149.8476,
    accuracy: 3
  },
  {
    postalCode: 2790,
    city: "Springvale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8595,
    longitude: 149.8401,
    accuracy: 4
  },
  {
    postalCode: 2790,
    city: "Littleton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5006,
    longitude: 150.1373,
    accuracy: 4
  },
  {
    postalCode: 2790,
    city: "Little Hartley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5717,
    longitude: 150.2086,
    accuracy: 3
  },
  {
    postalCode: 2790,
    city: "Oaky Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4643,
    longitude: 150.1829,
    accuracy: 4
  },
  {
    postalCode: 2790,
    city: "Hartley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5465,
    longitude: 150.1757,
    accuracy: 4
  },
  {
    postalCode: 2790,
    city: "Hermitage Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4768,
    longitude: 150.1432,
    accuracy: 4
  },
  {
    postalCode: 2790,
    city: "Hartley Vale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5333,
    longitude: 150.2333,
    accuracy: 4
  },
  {
    postalCode: 2790,
    city: "Good Forest",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4245,
    longitude: 150.1024,
    accuracy: 3
  },
  {
    postalCode: 2790,
    city: "Bowenfels",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5167,
    longitude: 150.1167,
    accuracy: 4
  },
  {
    postalCode: 2790,
    city: "Clarence",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4723,
    longitude: 150.222,
    accuracy: 4
  },
  {
    postalCode: 2790,
    city: "Lidsdale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4,
    longitude: 150.0833,
    accuracy: 4
  },
  {
    postalCode: 2790,
    city: "Kanimbla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4245,
    longitude: 150.1024,
    accuracy: 3
  },
  {
    postalCode: 2790,
    city: "Jenolan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8167,
    longitude: 150.0333,
    accuracy: 4
  },
  {
    postalCode: 2790,
    city: "South Littleton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5006,
    longitude: 150.1373,
    accuracy: 4
  },
  {
    postalCode: 2790,
    city: "Blackmans Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3656,
    longitude: 150.0651,
    accuracy: 4
  },
  {
    postalCode: 2790,
    city: "Hassans Walls",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4245,
    longitude: 150.1024,
    accuracy: 3
  },
  {
    postalCode: 2790,
    city: "Rydal",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4833,
    longitude: 150.0333,
    accuracy: 4
  },
  {
    postalCode: 2790,
    city: "Hampton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.65,
    longitude: 150.05,
    accuracy: 4
  },
  {
    postalCode: 2790,
    city: "Pottery Estate",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4245,
    longitude: 150.1024,
    accuracy: 3
  },
  {
    postalCode: 2790,
    city: "Wollangambe",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4245,
    longitude: 150.1024,
    accuracy: 3
  },
  {
    postalCode: 2790,
    city: "Cullen Bullen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2989,
    longitude: 150.0328,
    accuracy: 4
  },
  {
    postalCode: 2790,
    city: "South Bowenfels",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5167,
    longitude: 150.1167,
    accuracy: 4
  },
  {
    postalCode: 2790,
    city: "Morts Estate",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4583,
    longitude: 150.1731,
    accuracy: 4
  },
  {
    postalCode: 2790,
    city: "Newnes Plateau",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4245,
    longitude: 150.1024,
    accuracy: 3
  },
  {
    postalCode: 2790,
    city: "Lowther",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6167,
    longitude: 150.1,
    accuracy: 4
  },
  {
    postalCode: 2790,
    city: "Lithgow",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4825,
    longitude: 150.1363,
    accuracy: 4
  },
  {
    postalCode: 2790,
    city: "Sodwalls",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5167,
    longitude: 149.9833,
    accuracy: 4
  },
  {
    postalCode: 2790,
    city: "State Mine Gully",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4245,
    longitude: 150.1024,
    accuracy: 3
  },
  {
    postalCode: 2790,
    city: "Newnes",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1833,
    longitude: 150.25,
    accuracy: 4
  },
  {
    postalCode: 2790,
    city: "Mount Lambie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4245,
    longitude: 150.1024,
    accuracy: 3
  },
  {
    postalCode: 2790,
    city: "Ben Bullen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2167,
    longitude: 150.0333,
    accuracy: 4
  },
  {
    postalCode: 2790,
    city: "Doctors Gap",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4245,
    longitude: 150.1024,
    accuracy: 3
  },
  {
    postalCode: 2790,
    city: "Ganbenang",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4245,
    longitude: 150.1024,
    accuracy: 3
  },
  {
    postalCode: 2790,
    city: "Wolgan Valley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4245,
    longitude: 150.1024,
    accuracy: 3
  },
  {
    postalCode: 2790,
    city: "Vale Of Clwydd",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4245,
    longitude: 150.1024,
    accuracy: 3
  },
  {
    postalCode: 2790,
    city: "Corney Town",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4245,
    longitude: 150.1024,
    accuracy: 3
  },
  {
    postalCode: 2790,
    city: "Mckellars Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4245,
    longitude: 150.1024,
    accuracy: 3
  },
  {
    postalCode: 2790,
    city: "Sheedys Gully",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4245,
    longitude: 150.1024,
    accuracy: 3
  },
  {
    postalCode: 2790,
    city: "Jenolan Caves",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8167,
    longitude: 150.0333,
    accuracy: 4
  },
  {
    postalCode: 2790,
    city: "Marrangaroo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4333,
    longitude: 150.1167,
    accuracy: 4
  },
  {
    postalCode: 2790,
    city: "Cobar Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4228,
    longitude: 150.258,
    accuracy: 3
  },
  {
    postalCode: 2791,
    city: "Carcoar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6,
    longitude: 149.1333,
    accuracy: 4
  },
  {
    postalCode: 2791,
    city: "Errowanbang",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6,
    longitude: 149.1333,
    accuracy: 3
  },
  {
    postalCode: 2792,
    city: "Mandurama",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.65,
    longitude: 149.0833,
    accuracy: 4
  },
  {
    postalCode: 2792,
    city: "Burnt Yards",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5833,
    longitude: 149.0167,
    accuracy: 4
  },
  {
    postalCode: 2793,
    city: "Darbys Falls",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9024,
    longitude: 148.856,
    accuracy: 4
  },
  {
    postalCode: 2793,
    city: "Roseberg",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8378,
    longitude: 148.854,
    accuracy: 3
  },
  {
    postalCode: 2793,
    city: "Woodstock",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7446,
    longitude: 148.8489,
    accuracy: 4
  },
  {
    postalCode: 2794,
    city: "Noonbinna",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8834,
    longitude: 148.6441,
    accuracy: 4
  },
  {
    postalCode: 2794,
    city: "Westville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7667,
    longitude: 148.8,
    accuracy: 4
  },
  {
    postalCode: 2794,
    city: "Wattamondara",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9406,
    longitude: 148.6067,
    accuracy: 4
  },
  {
    postalCode: 2794,
    city: "Cowra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8355,
    longitude: 148.6966,
    accuracy: 4
  },
  {
    postalCode: 2794,
    city: "Hovells Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0485,
    longitude: 148.8846,
    accuracy: 4
  },
  {
    postalCode: 2794,
    city: "Mount Collins",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8976,
    longitude: 148.6717,
    accuracy: 3
  },
  {
    postalCode: 2794,
    city: "Bumbaldry",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.9,
    longitude: 148.4667,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Locksley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5142,
    longitude: 149.7982,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Fosters Valley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Georges Plains",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5,
    longitude: 149.5333,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Triangle Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.75,
    longitude: 149.5,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Wimbledon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5333,
    longitude: 149.4333,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Laffing Waters",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Windradyne",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4054,
    longitude: 149.5451,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Mitchell",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4273,
    longitude: 149.5567,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Sunny Corner",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3833,
    longitude: 149.9,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Billywillinga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Meadow Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4333,
    longitude: 149.9333,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Copperhannia",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Robin Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4229,
    longitude: 149.5328,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Kirkconnell",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Peel",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3167,
    longitude: 149.6333,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Dunkeld",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4106,
    longitude: 149.4808,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "West Bathurst",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4127,
    longitude: 149.5648,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Jeremy",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Glanmire",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4167,
    longitude: 149.7167,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Mount David",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8167,
    longitude: 149.5833,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Crudine",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9667,
    longitude: 149.7,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Fitzgeralds Valley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Yetholme",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.45,
    longitude: 149.8333,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Raglan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4167,
    longitude: 149.6667,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Gowan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1833,
    longitude: 149.3667,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Cow Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Burraga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.95,
    longitude: 149.5333,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Wisemans Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4708,
    longitude: 149.6033,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Arkell",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7284,
    longitude: 149.3909,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Clear Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "O'Connell",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5333,
    longitude: 149.7333,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Colo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4333,
    longitude: 150.8333,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Hobbys Yards",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6941,
    longitude: 149.3274,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Forest Grove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Trunkey Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8167,
    longitude: 149.3333,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Wiagdon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Llanarth",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3969,
    longitude: 149.551,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Gemalla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5333,
    longitude: 149.8333,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Caloola",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6,
    longitude: 149.4333,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Abercrombie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3887,
    longitude: 149.5458,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Palmers Oaky",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2,
    longitude: 149.8667,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Yarras",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4189,
    longitude: 152.3198,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Dog Rocks",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Wattle Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.15,
    longitude: 149.7,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Stewarts Mount",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Perthville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4874,
    longitude: 149.5464,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Walang",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "The Lagoon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.55,
    longitude: 149.6167,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Arkstone",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Isabella",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.95,
    longitude: 149.6667,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Bathurst West",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Kelso",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4167,
    longitude: 149.6,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Twenty Forests",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Paling Yards",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Ballyroe",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4708,
    longitude: 149.6033,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Mount Rankin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2956,
    longitude: 149.4837,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Moorilda",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Gilmandyke",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Milkers Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Eglinton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3773,
    longitude: 149.5465,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Millah Murrah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Mount Panorama",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Killongbutta",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Bathurst",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4166,
    longitude: 149.5806,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Watton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Charles Sturt University",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Abercrombie River",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Dark Corner",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3333,
    longitude: 149.8667,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Evans Plains",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Charlton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Limekilns",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Turondale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0833,
    longitude: 149.6167,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "South Bathurst",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Rockley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7,
    longitude: 149.5667,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Gormans Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Brewongle",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4833,
    longitude: 149.7167,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "White Rock",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Winburndale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Tannas Mount",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Sofala",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0833,
    longitude: 149.7,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Freemantle",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4708,
    longitude: 149.6033,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Orton Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4667,
    longitude: 149.5667,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "The Rocks",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8592,
    longitude: 151.2081,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Upper Turon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1,
    longitude: 149.7667,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Judds Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4708,
    longitude: 149.6033,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Bruinbun",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Bald Ridge",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4708,
    longitude: 149.6033,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Napoleon Reef",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Bathampton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Newbridge",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5833,
    longitude: 149.3833,
    accuracy: 4
  },
  {
    postalCode: 2795,
    city: "Rock Forest",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Wambool",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4708,
    longitude: 149.6033,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Duramana",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4708,
    longitude: 149.6033,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Curragh",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2795,
    city: "Rockley Mount",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4549,
    longitude: 149.6841,
    accuracy: 3
  },
  {
    postalCode: 2797,
    city: "Garland",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7167,
    longitude: 149.0333,
    accuracy: 4
  },
  {
    postalCode: 2797,
    city: "Lyndhurst",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6733,
    longitude: 149.0477,
    accuracy: 4
  },
  {
    postalCode: 2798,
    city: "Forest Reefs",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4645,
    longitude: 149.079,
    accuracy: 4
  },
  {
    postalCode: 2798,
    city: "Tallwood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4894,
    longitude: 149.084,
    accuracy: 3
  },
  {
    postalCode: 2798,
    city: "Spring Terrace",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4,
    longitude: 149.1167,
    accuracy: 4
  },
  {
    postalCode: 2798,
    city: "Guyong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4368,
    longitude: 149.127,
    accuracy: 3
  },
  {
    postalCode: 2798,
    city: "Millthorpe",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.446,
    longitude: 149.1854,
    accuracy: 4
  },
  {
    postalCode: 2799,
    city: "Neville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7118,
    longitude: 149.2182,
    accuracy: 4
  },
  {
    postalCode: 2799,
    city: "Kings Plains",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5,
    longitude: 149.3333,
    accuracy: 4
  },
  {
    postalCode: 2799,
    city: "Barry",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6484,
    longitude: 149.2743,
    accuracy: 4
  },
  {
    postalCode: 2799,
    city: "Blayney",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5323,
    longitude: 149.2537,
    accuracy: 4
  },
  {
    postalCode: 2799,
    city: "Vittoria",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5868,
    longitude: 149.2635,
    accuracy: 3
  },
  {
    postalCode: 2799,
    city: "Fitzgeralds Mount",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5997,
    longitude: 149.2467,
    accuracy: 3
  },
  {
    postalCode: 2799,
    city: "Browns Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5868,
    longitude: 149.2635,
    accuracy: 3
  },
  {
    postalCode: 2800,
    city: "Lucknow",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.346,
    longitude: 149.1621,
    accuracy: 4
  },
  {
    postalCode: 2800,
    city: "Nashdale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2833,
    longitude: 149.0333,
    accuracy: 4
  },
  {
    postalCode: 2800,
    city: "Summer Hill Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2968,
    longitude: 149.174,
    accuracy: 3
  },
  {
    postalCode: 2800,
    city: "Huntley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3695,
    longitude: 149.1343,
    accuracy: 4
  },
  {
    postalCode: 2800,
    city: "Canobolas",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3,
    longitude: 149.0667,
    accuracy: 4
  },
  {
    postalCode: 2800,
    city: "Borenore",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2346,
    longitude: 148.9815,
    accuracy: 4
  },
  {
    postalCode: 2800,
    city: "Ophir",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1667,
    longitude: 149.2333,
    accuracy: 4
  },
  {
    postalCode: 2800,
    city: "March",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2789,
    longitude: 149.0298,
    accuracy: 3
  },
  {
    postalCode: 2800,
    city: "Spring Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3988,
    longitude: 149.1525,
    accuracy: 4
  },
  {
    postalCode: 2800,
    city: "Clergate",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1833,
    longitude: 149.1333,
    accuracy: 4
  },
  {
    postalCode: 2800,
    city: "Clifton Grove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2547,
    longitude: 149.156,
    accuracy: 4
  },
  {
    postalCode: 2800,
    city: "Spring Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2968,
    longitude: 149.174,
    accuracy: 3
  },
  {
    postalCode: 2800,
    city: "Lidster",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2833,
    longitude: 149.0167,
    accuracy: 4
  },
  {
    postalCode: 2800,
    city: "Bowen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2789,
    longitude: 149.0298,
    accuracy: 3
  },
  {
    postalCode: 2800,
    city: "Lewis Ponds",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2667,
    longitude: 149.2667,
    accuracy: 4
  },
  {
    postalCode: 2800,
    city: "Windera",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2968,
    longitude: 149.174,
    accuracy: 3
  },
  {
    postalCode: 2800,
    city: "Byng",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3476,
    longitude: 149.2551,
    accuracy: 4
  },
  {
    postalCode: 2800,
    city: "Lower Lewis Ponds",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2,
    longitude: 149.25,
    accuracy: 4
  },
  {
    postalCode: 2800,
    city: "Cadia",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4485,
    longitude: 148.9846,
    accuracy: 4
  },
  {
    postalCode: 2800,
    city: "Waldegrave",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2968,
    longitude: 149.174,
    accuracy: 3
  },
  {
    postalCode: 2800,
    city: "Mullion Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1252,
    longitude: 149.1276,
    accuracy: 4
  },
  {
    postalCode: 2800,
    city: "Orange",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.284,
    longitude: 149.1002,
    accuracy: 4
  },
  {
    postalCode: 2800,
    city: "Shadforth",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4,
    longitude: 149.2333,
    accuracy: 4
  },
  {
    postalCode: 2800,
    city: "Orange East",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2968,
    longitude: 149.174,
    accuracy: 3
  },
  {
    postalCode: 2800,
    city: "Four Mile Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4318,
    longitude: 148.9512,
    accuracy: 4
  },
  {
    postalCode: 2800,
    city: "Kerrs Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0505,
    longitude: 149.1004,
    accuracy: 4
  },
  {
    postalCode: 2800,
    city: "Belgravia",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1152,
    longitude: 149.0346,
    accuracy: 4
  },
  {
    postalCode: 2800,
    city: "Narrambla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2789,
    longitude: 149.0298,
    accuracy: 3
  },
  {
    postalCode: 2800,
    city: "Emu Swamp",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2968,
    longitude: 149.174,
    accuracy: 3
  },
  {
    postalCode: 2800,
    city: "Kangaroobie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2968,
    longitude: 149.174,
    accuracy: 3
  },
  {
    postalCode: 2800,
    city: "Springside",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2968,
    longitude: 149.174,
    accuracy: 3
  },
  {
    postalCode: 2800,
    city: "Panuara",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2968,
    longitude: 149.174,
    accuracy: 3
  },
  {
    postalCode: 2800,
    city: "Cargo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4241,
    longitude: 148.809,
    accuracy: 4
  },
  {
    postalCode: 2800,
    city: "Orange DC",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2968,
    longitude: 149.174,
    accuracy: 3
  },
  {
    postalCode: 2800,
    city: "Boree",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.1066,
    longitude: 146.6085,
    accuracy: 4
  },
  {
    postalCode: 2803,
    city: "Crowther",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1167,
    longitude: 148.4833,
    accuracy: 4
  },
  {
    postalCode: 2803,
    city: "Wirrimah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1471,
    longitude: 148.5206,
    accuracy: 3
  },
  {
    postalCode: 2803,
    city: "Bendick Murrell",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1667,
    longitude: 148.4333,
    accuracy: 4
  },
  {
    postalCode: 2804,
    city: "Nyrang Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5333,
    longitude: 148.55,
    accuracy: 4
  },
  {
    postalCode: 2804,
    city: "Moorbel",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.593,
    longitude: 148.6103,
    accuracy: 3
  },
  {
    postalCode: 2804,
    city: "Canowindra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.5625,
    longitude: 148.6643,
    accuracy: 4
  },
  {
    postalCode: 2804,
    city: "Billimari",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6741,
    longitude: 148.6196,
    accuracy: 4
  },
  {
    postalCode: 2805,
    city: "Gooloogong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6241,
    longitude: 148.409,
    accuracy: 4
  },
  {
    postalCode: 2806,
    city: "Eugowra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4273,
    longitude: 148.3714,
    accuracy: 4
  },
  {
    postalCode: 2807,
    city: "Koorawatha",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.0378,
    longitude: 148.5561,
    accuracy: 4
  },
  {
    postalCode: 2808,
    city: "Wyangala",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.968,
    longitude: 148.9482,
    accuracy: 4
  },
  {
    postalCode: 2809,
    city: "Greenethorpe",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34,
    longitude: 148.4,
    accuracy: 4
  },
  {
    postalCode: 2810,
    city: "Pinnacle",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8576,
    longitude: 147.9607,
    accuracy: 3
  },
  {
    postalCode: 2810,
    city: "Piney Range",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.85,
    longitude: 147.9167,
    accuracy: 4
  },
  {
    postalCode: 2810,
    city: "Warraderry",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7667,
    longitude: 148.2167,
    accuracy: 4
  },
  {
    postalCode: 2810,
    city: "Pullabooka",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7452,
    longitude: 147.7893,
    accuracy: 4
  },
  {
    postalCode: 2810,
    city: "Glenelg",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8576,
    longitude: 147.9607,
    accuracy: 3
  },
  {
    postalCode: 2810,
    city: "Caragabal",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8333,
    longitude: 147.75,
    accuracy: 4
  },
  {
    postalCode: 2810,
    city: "Bimbi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.05,
    longitude: 147.95,
    accuracy: 4
  },
  {
    postalCode: 2810,
    city: "Grenfell",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.8955,
    longitude: 148.1644,
    accuracy: 4
  },
  {
    postalCode: 2818,
    city: "Terrabella",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4318,
    longitude: 148.7429,
    accuracy: 4
  },
  {
    postalCode: 2818,
    city: "Benolong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4006,
    longitude: 148.8303,
    accuracy: 3
  },
  {
    postalCode: 2818,
    city: "Ponto",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4006,
    longitude: 148.8303,
    accuracy: 3
  },
  {
    postalCode: 2818,
    city: "Geurie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4006,
    longitude: 148.8303,
    accuracy: 4
  },
  {
    postalCode: 2820,
    city: "Medway",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.4916,
    longitude: 150.2823,
    accuracy: 4
  },
  {
    postalCode: 2820,
    city: "Apsley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5985,
    longitude: 148.9679,
    accuracy: 4
  },
  {
    postalCode: 2820,
    city: "Walmer",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6667,
    longitude: 148.75,
    accuracy: 4
  },
  {
    postalCode: 2820,
    city: "Gollan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.2667,
    longitude: 149.0833,
    accuracy: 4
  },
  {
    postalCode: 2820,
    city: "Bakers Swamp",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.781,
    longitude: 148.9153,
    accuracy: 4
  },
  {
    postalCode: 2820,
    city: "Stuart Town",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8,
    longitude: 149.0833,
    accuracy: 4
  },
  {
    postalCode: 2820,
    city: "Maryvale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4735,
    longitude: 148.9012,
    accuracy: 4
  },
  {
    postalCode: 2820,
    city: "Curra Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6985,
    longitude: 148.8179,
    accuracy: 4
  },
  {
    postalCode: 2820,
    city: "Arthurville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5667,
    longitude: 148.75,
    accuracy: 4
  },
  {
    postalCode: 2820,
    city: "Montefiores",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5333,
    longitude: 148.9333,
    accuracy: 4
  },
  {
    postalCode: 2820,
    city: "Bodangora",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.45,
    longitude: 149,
    accuracy: 4
  },
  {
    postalCode: 2820,
    city: "Neurea",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.69,
    longitude: 148.9489,
    accuracy: 4
  },
  {
    postalCode: 2820,
    city: "Dripstone",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.65,
    longitude: 149,
    accuracy: 4
  },
  {
    postalCode: 2820,
    city: "Mount Arthur",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6003,
    longitude: 148.9534,
    accuracy: 3
  },
  {
    postalCode: 2820,
    city: "Mumbil",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7167,
    longitude: 149.05,
    accuracy: 4
  },
  {
    postalCode: 2820,
    city: "Wuuluman",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.55,
    longitude: 149.0833,
    accuracy: 4
  },
  {
    postalCode: 2820,
    city: "Wellington",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5559,
    longitude: 148.9451,
    accuracy: 4
  },
  {
    postalCode: 2820,
    city: "Spicers Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3958,
    longitude: 149.143,
    accuracy: 3
  },
  {
    postalCode: 2820,
    city: "Farnham",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.85,
    longitude: 149.0833,
    accuracy: 4
  },
  {
    postalCode: 2820,
    city: "Suntop",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5652,
    longitude: 148.8346,
    accuracy: 4
  },
  {
    postalCode: 2820,
    city: "Comobella",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4,
    longitude: 148.9667,
    accuracy: 4
  },
  {
    postalCode: 2820,
    city: "Lake Burrendong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6003,
    longitude: 148.9534,
    accuracy: 3
  },
  {
    postalCode: 2820,
    city: "Mount Aquila",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6003,
    longitude: 148.9534,
    accuracy: 3
  },
  {
    postalCode: 2820,
    city: "Mookerawa",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6003,
    longitude: 148.9534,
    accuracy: 3
  },
  {
    postalCode: 2820,
    city: "Yarragal",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6003,
    longitude: 148.9534,
    accuracy: 3
  },
  {
    postalCode: 2821,
    city: "Narromine",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.2312,
    longitude: 148.2405,
    accuracy: 4
  },
  {
    postalCode: 2821,
    city: "Burroway",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.2312,
    longitude: 148.2405,
    accuracy: 3
  },
  {
    postalCode: 2823,
    city: "Trangie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.0315,
    longitude: 147.9834,
    accuracy: 4
  },
  {
    postalCode: 2823,
    city: "Cathundral",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9167,
    longitude: 147.8333,
    accuracy: 4
  },
  {
    postalCode: 2823,
    city: "Dandaloo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.2833,
    longitude: 147.6333,
    accuracy: 4
  },
  {
    postalCode: 2823,
    city: "Gin Gin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9116,
    longitude: 148.0898,
    accuracy: 4
  },
  {
    postalCode: 2823,
    city: "Bundemar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.0772,
    longitude: 147.8167,
    accuracy: 3
  },
  {
    postalCode: 2824,
    city: "Mount Foster",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6887,
    longitude: 147.8413,
    accuracy: 3
  },
  {
    postalCode: 2824,
    city: "Warren",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.7022,
    longitude: 147.8339,
    accuracy: 4
  },
  {
    postalCode: 2824,
    city: "Mount Harris",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6887,
    longitude: 147.8413,
    accuracy: 3
  },
  {
    postalCode: 2824,
    city: "Snakes Plain",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6887,
    longitude: 147.8413,
    accuracy: 3
  },
  {
    postalCode: 2824,
    city: "Eenaweena",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6887,
    longitude: 147.8413,
    accuracy: 3
  },
  {
    postalCode: 2824,
    city: "Tenandra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6887,
    longitude: 147.8413,
    accuracy: 3
  },
  {
    postalCode: 2824,
    city: "Marthaguy",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6887,
    longitude: 147.8413,
    accuracy: 3
  },
  {
    postalCode: 2824,
    city: "Ravenswood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6971,
    longitude: 147.84,
    accuracy: 4
  },
  {
    postalCode: 2824,
    city: "Red Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.0523,
    longitude: 149.1643,
    accuracy: 4
  },
  {
    postalCode: 2824,
    city: "Beemunnel",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6624,
    longitude: 147.8596,
    accuracy: 4
  },
  {
    postalCode: 2824,
    city: "Bullagreen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6887,
    longitude: 147.8413,
    accuracy: 3
  },
  {
    postalCode: 2824,
    city: "Pine Clump",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6887,
    longitude: 147.8413,
    accuracy: 3
  },
  {
    postalCode: 2824,
    city: "Pigeonbah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6887,
    longitude: 147.8413,
    accuracy: 3
  },
  {
    postalCode: 2824,
    city: "Mumblebone Plain",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6887,
    longitude: 147.8413,
    accuracy: 3
  },
  {
    postalCode: 2824,
    city: "Oxley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6887,
    longitude: 147.8413,
    accuracy: 3
  },
  {
    postalCode: 2825,
    city: "Nyngan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.5609,
    longitude: 147.1882,
    accuracy: 4
  },
  {
    postalCode: 2825,
    city: "Mulla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.608,
    longitude: 147.1822,
    accuracy: 3
  },
  {
    postalCode: 2825,
    city: "Miandetta",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.5833,
    longitude: 146.9667,
    accuracy: 4
  },
  {
    postalCode: 2825,
    city: "Bogan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6046,
    longitude: 147.1405,
    accuracy: 3
  },
  {
    postalCode: 2825,
    city: "Mullengudgery",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6985,
    longitude: 147.4179,
    accuracy: 4
  },
  {
    postalCode: 2825,
    city: "Honeybugle",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.608,
    longitude: 147.1822,
    accuracy: 3
  },
  {
    postalCode: 2825,
    city: "Canonba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.3447,
    longitude: 147.3473,
    accuracy: 4
  },
  {
    postalCode: 2825,
    city: "Pangee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.608,
    longitude: 147.1822,
    accuracy: 3
  },
  {
    postalCode: 2825,
    city: "Murrawombie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.608,
    longitude: 147.1822,
    accuracy: 3
  },
  {
    postalCode: 2825,
    city: "Babinda",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.608,
    longitude: 147.1822,
    accuracy: 3
  },
  {
    postalCode: 2825,
    city: "Buddabadah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.608,
    longitude: 147.1822,
    accuracy: 3
  },
  {
    postalCode: 2826,
    city: "Nevertire",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8478,
    longitude: 147.7215,
    accuracy: 4
  },
  {
    postalCode: 2826,
    city: "Bogan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.85,
    longitude: 147.7167,
    accuracy: 3
  },
  {
    postalCode: 2827,
    city: "Biddon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.5602,
    longitude: 148.8023,
    accuracy: 4
  },
  {
    postalCode: 2827,
    city: "Collie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.6667,
    longitude: 148.3,
    accuracy: 4
  },
  {
    postalCode: 2827,
    city: "Gilgandra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.7117,
    longitude: 148.6625,
    accuracy: 4
  },
  {
    postalCode: 2827,
    city: "Curban",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.5418,
    longitude: 148.5887,
    accuracy: 4
  },
  {
    postalCode: 2827,
    city: "Bearbong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.659,
    longitude: 148.6258,
    accuracy: 3
  },
  {
    postalCode: 2827,
    city: "Breelong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8152,
    longitude: 148.8012,
    accuracy: 4
  },
  {
    postalCode: 2827,
    city: "Merrigal",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.659,
    longitude: 148.6258,
    accuracy: 3
  },
  {
    postalCode: 2828,
    city: "Armatree",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.446,
    longitude: 148.4748,
    accuracy: 4
  },
  {
    postalCode: 2828,
    city: "Tonderburine",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.3843,
    longitude: 148.4696,
    accuracy: 3
  },
  {
    postalCode: 2828,
    city: "Black Hollow",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.3843,
    longitude: 148.4696,
    accuracy: 3
  },
  {
    postalCode: 2828,
    city: "Bourbah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.3843,
    longitude: 148.4696,
    accuracy: 3
  },
  {
    postalCode: 2828,
    city: "Warrumbungle",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.3178,
    longitude: 148.6229,
    accuracy: 3
  },
  {
    postalCode: 2828,
    city: "Gulargambone",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.3353,
    longitude: 148.4725,
    accuracy: 4
  },
  {
    postalCode: 2828,
    city: "Quanda",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.3843,
    longitude: 148.4696,
    accuracy: 3
  },
  {
    postalCode: 2828,
    city: "Mount Tenandra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.3843,
    longitude: 148.4696,
    accuracy: 3
  },
  {
    postalCode: 2829,
    city: "Gilgooma",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.7557,
    longitude: 148.5391,
    accuracy: 4
  },
  {
    postalCode: 2829,
    city: "Gungalman",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.8774,
    longitude: 148.5111,
    accuracy: 3
  },
  {
    postalCode: 2829,
    city: "Pine Grove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.8774,
    longitude: 148.5111,
    accuracy: 3
  },
  {
    postalCode: 2829,
    city: "Combara",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.1168,
    longitude: 148.3705,
    accuracy: 4
  },
  {
    postalCode: 2829,
    city: "Nebea",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.8774,
    longitude: 148.5111,
    accuracy: 3
  },
  {
    postalCode: 2829,
    city: "Teridgerie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.8667,
    longitude: 148.8333,
    accuracy: 4
  },
  {
    postalCode: 2829,
    city: "Billeroy",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.7,
    longitude: 148.45,
    accuracy: 4
  },
  {
    postalCode: 2829,
    city: "Tooloon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.8774,
    longitude: 148.5111,
    accuracy: 3
  },
  {
    postalCode: 2829,
    city: "Magometon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.8774,
    longitude: 148.5111,
    accuracy: 3
  },
  {
    postalCode: 2829,
    city: "Conimbia",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.8774,
    longitude: 148.5111,
    accuracy: 3
  },
  {
    postalCode: 2829,
    city: "Coonamble",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.9539,
    longitude: 148.3888,
    accuracy: 4
  },
  {
    postalCode: 2829,
    city: "Urawilkie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.8774,
    longitude: 148.5111,
    accuracy: 3
  },
  {
    postalCode: 2829,
    city: "Wingadee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.8774,
    longitude: 148.5111,
    accuracy: 3
  },
  {
    postalCode: 2830,
    city: "Dubbo West",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1582,
    longitude: 148.6012,
    accuracy: 3
  },
  {
    postalCode: 2830,
    city: "Minore",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.25,
    longitude: 148.4667,
    accuracy: 4
  },
  {
    postalCode: 2830,
    city: "Mogriguy",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.0667,
    longitude: 148.6833,
    accuracy: 4
  },
  {
    postalCode: 2830,
    city: "Brocklehurst",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1806,
    longitude: 148.6229,
    accuracy: 4
  },
  {
    postalCode: 2830,
    city: "Ballimore",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.2,
    longitude: 148.9,
    accuracy: 4
  },
  {
    postalCode: 2830,
    city: "Muronbung",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1639,
    longitude: 148.642,
    accuracy: 3
  },
  {
    postalCode: 2830,
    city: "Terramungamine",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.0667,
    longitude: 148.55,
    accuracy: 4
  },
  {
    postalCode: 2830,
    city: "Goonoo Forest",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1582,
    longitude: 148.6012,
    accuracy: 3
  },
  {
    postalCode: 2830,
    city: "Rawsonville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1667,
    longitude: 148.5,
    accuracy: 4
  },
  {
    postalCode: 2830,
    city: "Dubbo Grove",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1582,
    longitude: 148.6012,
    accuracy: 3
  },
  {
    postalCode: 2830,
    city: "Dubbo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.243,
    longitude: 148.6048,
    accuracy: 4
  },
  {
    postalCode: 2830,
    city: "Dubbo East",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1582,
    longitude: 148.6012,
    accuracy: 3
  },
  {
    postalCode: 2830,
    city: "Kickabil",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8,
    longitude: 148.4833,
    accuracy: 4
  },
  {
    postalCode: 2830,
    city: "Dubbo DC",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1582,
    longitude: 148.6012,
    accuracy: 3
  },
  {
    postalCode: 2830,
    city: "Toongi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.45,
    longitude: 148.6,
    accuracy: 4
  },
  {
    postalCode: 2830,
    city: "Wambangalang",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1582,
    longitude: 148.6012,
    accuracy: 3
  },
  {
    postalCode: 2831,
    city: "Wongarbon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3328,
    longitude: 148.7593,
    accuracy: 4
  },
  {
    postalCode: 2831,
    city: "Goodooga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.1131,
    longitude: 147.4525,
    accuracy: 4
  },
  {
    postalCode: 2831,
    city: "Neilrex",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.7226,
    longitude: 149.3043,
    accuracy: 4
  },
  {
    postalCode: 2831,
    city: "Girilambone",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4472,
    longitude: 146.3418,
    accuracy: 3
  },
  {
    postalCode: 2831,
    city: "Quambone",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.9331,
    longitude: 147.8722,
    accuracy: 4
  },
  {
    postalCode: 2831,
    city: "The Marra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.5488,
    longitude: 148.1209,
    accuracy: 3
  },
  {
    postalCode: 2831,
    city: "Merrygoen",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8279,
    longitude: 149.2326,
    accuracy: 4
  },
  {
    postalCode: 2831,
    city: "Hermidale",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4472,
    longitude: 146.3418,
    accuracy: 3
  },
  {
    postalCode: 2831,
    city: "Armatree",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.446,
    longitude: 148.4748,
    accuracy: 4
  },
  {
    postalCode: 2831,
    city: "Nevertire",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8478,
    longitude: 147.7215,
    accuracy: 4
  },
  {
    postalCode: 2831,
    city: "Elong Elong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1235,
    longitude: 149.0262,
    accuracy: 4
  },
  {
    postalCode: 2831,
    city: "Macquarie Marshes",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.5488,
    longitude: 148.1209,
    accuracy: 3
  },
  {
    postalCode: 2831,
    city: "Balladoran",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.865,
    longitude: 148.6521,
    accuracy: 4
  },
  {
    postalCode: 2831,
    city: "Tooraweenah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4333,
    longitude: 148.9,
    accuracy: 4
  },
  {
    postalCode: 2831,
    city: "Nymagee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.0667,
    longitude: 146.3333,
    accuracy: 4
  },
  {
    postalCode: 2831,
    city: "Carinda",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.4667,
    longitude: 147.6833,
    accuracy: 4
  },
  {
    postalCode: 2831,
    city: "Eumungerie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.95,
    longitude: 148.6215,
    accuracy: 4
  },
  {
    postalCode: 2831,
    city: "Byrock",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.6606,
    longitude: 146.4012,
    accuracy: 4
  },
  {
    postalCode: 2831,
    city: "Coolabah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.0295,
    longitude: 146.7149,
    accuracy: 4
  },
  {
    postalCode: 2832,
    city: "Come By Chance",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.3726,
    longitude: 148.4874,
    accuracy: 4
  },
  {
    postalCode: 2832,
    city: "Cryon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.0086,
    longitude: 148.6135,
    accuracy: 4
  },
  {
    postalCode: 2832,
    city: "Cumborah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7469,
    longitude: 147.7664,
    accuracy: 4
  },
  {
    postalCode: 2832,
    city: "Walgett",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.0246,
    longitude: 148.1157,
    accuracy: 4
  },
  {
    postalCode: 2833,
    city: "Collarenebri",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.5438,
    longitude: 148.5759,
    accuracy: 4
  },
  {
    postalCode: 2834,
    city: "Angledool",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.1102,
    longitude: 147.9097,
    accuracy: 4
  },
  {
    postalCode: 2834,
    city: "Lightning Ridge",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4274,
    longitude: 147.9787,
    accuracy: 4
  },
  {
    postalCode: 2835,
    city: "Cobar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.4987,
    longitude: 145.8418,
    accuracy: 4
  },
  {
    postalCode: 2835,
    city: "Bulla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8274,
    longitude: 146.0639,
    accuracy: 3
  },
  {
    postalCode: 2835,
    city: "Irymple",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4905,
    longitude: 145.6074,
    accuracy: 4
  },
  {
    postalCode: 2835,
    city: "Gilgunnia",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4134,
    longitude: 146.0379,
    accuracy: 4
  },
  {
    postalCode: 2835,
    city: "Canbelego",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.5577,
    longitude: 146.3216,
    accuracy: 4
  },
  {
    postalCode: 2835,
    city: "Kerrigundi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8274,
    longitude: 146.0639,
    accuracy: 3
  },
  {
    postalCode: 2835,
    city: "Tindarey",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8274,
    longitude: 146.0639,
    accuracy: 3
  },
  {
    postalCode: 2835,
    city: "Noona",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8274,
    longitude: 146.0639,
    accuracy: 3
  },
  {
    postalCode: 2835,
    city: "Cubba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8274,
    longitude: 146.0639,
    accuracy: 3
  },
  {
    postalCode: 2835,
    city: "Kulwin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8274,
    longitude: 146.0639,
    accuracy: 3
  },
  {
    postalCode: 2835,
    city: "Sandy Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8274,
    longitude: 146.0639,
    accuracy: 3
  },
  {
    postalCode: 2836,
    city: "White Cliffs",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.8521,
    longitude: 143.0886,
    accuracy: 4
  },
  {
    postalCode: 2836,
    city: "Wilcannia",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.5588,
    longitude: 143.3769,
    accuracy: 4
  },
  {
    postalCode: 2838,
    city: "Goodooga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.1131,
    longitude: 147.4525,
    accuracy: 4
  },
  {
    postalCode: 2839,
    city: "Narran Lake",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.998,
    longitude: 146.8033,
    accuracy: 3
  },
  {
    postalCode: 2839,
    city: "Collerina",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.6915,
    longitude: 146.6479,
    accuracy: 4
  },
  {
    postalCode: 2839,
    city: "Talawanta",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.998,
    longitude: 146.8033,
    accuracy: 3
  },
  {
    postalCode: 2839,
    city: "Gongolgon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.3488,
    longitude: 146.8979,
    accuracy: 4
  },
  {
    postalCode: 2839,
    city: "Weilmoringle",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.2428,
    longitude: 146.9219,
    accuracy: 4
  },
  {
    postalCode: 2839,
    city: "Brewarrina",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.9607,
    longitude: 146.8599,
    accuracy: 4
  },
  {
    postalCode: 2840,
    city: "Enngonia",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.3223,
    longitude: 145.8471,
    accuracy: 4
  },
  {
    postalCode: 2840,
    city: "Hungerford",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.482,
    longitude: 150.4871,
    accuracy: 3
  },
  {
    postalCode: 2840,
    city: "Louth",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.5388,
    longitude: 145.116,
    accuracy: 4
  },
  {
    postalCode: 2840,
    city: "Bourke",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.0901,
    longitude: 145.9365,
    accuracy: 4
  },
  {
    postalCode: 2840,
    city: "Yantabulla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.3457,
    longitude: 145.0012,
    accuracy: 4
  },
  {
    postalCode: 2840,
    city: "Barringun",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.0141,
    longitude: 145.7159,
    accuracy: 4
  },
  {
    postalCode: 2840,
    city: "Fords Bridge",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7515,
    longitude: 145.4273,
    accuracy: 4
  },
  {
    postalCode: 2840,
    city: "North Bourke",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.0523,
    longitude: 145.9489,
    accuracy: 4
  },
  {
    postalCode: 2840,
    city: "Wanaaring",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7027,
    longitude: 144.1235,
    accuracy: 4
  },
  {
    postalCode: 2840,
    city: "Urisino",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7252,
    longitude: 143.7619,
    accuracy: 4
  },
  {
    postalCode: 2840,
    city: "Gunderbooka",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.07,
    longitude: 145.9477,
    accuracy: 3
  },
  {
    postalCode: 2840,
    city: "Tilpa",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.9356,
    longitude: 144.4165,
    accuracy: 4
  },
  {
    postalCode: 2840,
    city: "Gumbalie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -30.07,
    longitude: 145.9477,
    accuracy: 3
  },
  {
    postalCode: 2842,
    city: "Mendooran",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8226,
    longitude: 149.1164,
    accuracy: 4
  },
  {
    postalCode: 2842,
    city: "Yarragrin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8226,
    longitude: 149.1164,
    accuracy: 3
  },
  {
    postalCode: 2842,
    city: "New Mollyan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8262,
    longitude: 149.1256,
    accuracy: 3
  },
  {
    postalCode: 2842,
    city: "Mollyan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8226,
    longitude: 149.1164,
    accuracy: 3
  },
  {
    postalCode: 2843,
    city: "Coolah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.8279,
    longitude: 149.7156,
    accuracy: 4
  },
  {
    postalCode: 2844,
    city: "Leadville",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32,
    longitude: 149.55,
    accuracy: 4
  },
  {
    postalCode: 2844,
    city: "Birriwa",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1167,
    longitude: 149.4667,
    accuracy: 4
  },
  {
    postalCode: 2844,
    city: "Cobbora",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.0667,
    longitude: 149.25,
    accuracy: 4
  },
  {
    postalCode: 2844,
    city: "Dunedoo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.0163,
    longitude: 149.3871,
    accuracy: 4
  },
  {
    postalCode: 2845,
    city: "Wallerawang",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.411,
    longitude: 150.0646,
    accuracy: 4
  },
  {
    postalCode: 2846,
    city: "Glen Davis",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1167,
    longitude: 150.2833,
    accuracy: 4
  },
  {
    postalCode: 2846,
    city: "Round Swamp",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0735,
    longitude: 149.9429,
    accuracy: 4
  },
  {
    postalCode: 2846,
    city: "Capertee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.15,
    longitude: 149.9833,
    accuracy: 4
  },
  {
    postalCode: 2847,
    city: "Pipers Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4436,
    longitude: 149.9763,
    accuracy: 3
  },
  {
    postalCode: 2847,
    city: "Portland",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3571,
    longitude: 149.9815,
    accuracy: 4
  },
  {
    postalCode: 2848,
    city: "Clandulla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8833,
    longitude: 149.9667,
    accuracy: 4
  },
  {
    postalCode: 2848,
    city: "Brogans Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33,
    longitude: 149.9333,
    accuracy: 4
  },
  {
    postalCode: 2848,
    city: "Kandos",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8577,
    longitude: 149.9683,
    accuracy: 4
  },
  {
    postalCode: 2848,
    city: "Charbon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8839,
    longitude: 149.9701,
    accuracy: 4
  },
  {
    postalCode: 2849,
    city: "Upper Bylong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4119,
    longitude: 150.1201,
    accuracy: 4
  },
  {
    postalCode: 2849,
    city: "Bylong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4119,
    longitude: 150.1201,
    accuracy: 4
  },
  {
    postalCode: 2849,
    city: "Budden",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5152,
    longitude: 150.0679,
    accuracy: 4
  },
  {
    postalCode: 2849,
    city: "Lee Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6562,
    longitude: 150.0774,
    accuracy: 3
  },
  {
    postalCode: 2849,
    city: "Ginghi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5818,
    longitude: 150.0846,
    accuracy: 4
  },
  {
    postalCode: 2849,
    city: "Coggan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6562,
    longitude: 150.0774,
    accuracy: 3
  },
  {
    postalCode: 2849,
    city: "Bogee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9488,
    longitude: 150.0938,
    accuracy: 4
  },
  {
    postalCode: 2849,
    city: "Dungeree",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6562,
    longitude: 150.0774,
    accuracy: 3
  },
  {
    postalCode: 2849,
    city: "Camboon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6985,
    longitude: 149.9512,
    accuracy: 4
  },
  {
    postalCode: 2849,
    city: "Wirraba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6562,
    longitude: 150.0774,
    accuracy: 3
  },
  {
    postalCode: 2849,
    city: "Breakfast Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6818,
    longitude: 150.0012,
    accuracy: 4
  },
  {
    postalCode: 2849,
    city: "Mount Marsden",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6562,
    longitude: 150.0774,
    accuracy: 3
  },
  {
    postalCode: 2849,
    city: "Rylstone",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7995,
    longitude: 149.9694,
    accuracy: 4
  },
  {
    postalCode: 2849,
    city: "Upper Nile",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6562,
    longitude: 150.0774,
    accuracy: 3
  },
  {
    postalCode: 2849,
    city: "Olinda",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8333,
    longitude: 150.1333,
    accuracy: 4
  },
  {
    postalCode: 2849,
    city: "Kelgoola",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6562,
    longitude: 150.0774,
    accuracy: 3
  },
  {
    postalCode: 2849,
    city: "Pinnacle Swamp",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6562,
    longitude: 150.0774,
    accuracy: 3
  },
  {
    postalCode: 2849,
    city: "Coxs Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6562,
    longitude: 150.0774,
    accuracy: 3
  },
  {
    postalCode: 2849,
    city: "Dunville Loop",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6562,
    longitude: 150.0774,
    accuracy: 3
  },
  {
    postalCode: 2849,
    city: "Coxs Crown",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6562,
    longitude: 150.0774,
    accuracy: 3
  },
  {
    postalCode: 2849,
    city: "Murrumbo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6562,
    longitude: 150.0774,
    accuracy: 3
  },
  {
    postalCode: 2849,
    city: "Dabee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6562,
    longitude: 150.0774,
    accuracy: 3
  },
  {
    postalCode: 2849,
    city: "Growee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6562,
    longitude: 150.0774,
    accuracy: 3
  },
  {
    postalCode: 2849,
    city: "Pyangle",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6562,
    longitude: 150.0774,
    accuracy: 3
  },
  {
    postalCode: 2849,
    city: "Glen Alice",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.05,
    longitude: 150.2167,
    accuracy: 4
  },
  {
    postalCode: 2849,
    city: "Reedy Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6562,
    longitude: 150.0774,
    accuracy: 3
  },
  {
    postalCode: 2849,
    city: "Nullo Mountain",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6562,
    longitude: 150.0774,
    accuracy: 3
  },
  {
    postalCode: 2849,
    city: "Upper Growee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6562,
    longitude: 150.0774,
    accuracy: 3
  },
  {
    postalCode: 2849,
    city: "Carwell",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6562,
    longitude: 150.0774,
    accuracy: 3
  },
  {
    postalCode: 2850,
    city: "Mogo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.7848,
    longitude: 150.1417,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Turill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.1152,
    longitude: 149.8429,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Lue",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6667,
    longitude: 149.85,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Wilbetree",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6849,
    longitude: 149.8056,
    accuracy: 3
  },
  {
    postalCode: 2850,
    city: "Bombira",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5719,
    longitude: 149.6058,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Stony Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4735,
    longitude: 149.7346,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Apple Tree Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6818,
    longitude: 149.7012,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Ulan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.2833,
    longitude: 149.7333,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Wollar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.35,
    longitude: 149.95,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Twelve Mile",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5,
    longitude: 149.2667,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Bara",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6278,
    longitude: 149.652,
    accuracy: 3
  },
  {
    postalCode: 2850,
    city: "Hayes Gap",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6278,
    longitude: 149.652,
    accuracy: 3
  },
  {
    postalCode: 2850,
    city: "Mudgee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5943,
    longitude: 149.5871,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Windeyer",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7667,
    longitude: 149.55,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Pyramul",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8833,
    longitude: 149.6167,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Cross Roads",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6278,
    longitude: 149.652,
    accuracy: 3
  },
  {
    postalCode: 2850,
    city: "Cooyal",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4485,
    longitude: 149.7596,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Running Stream",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0318,
    longitude: 149.9096,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Caerleon",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6278,
    longitude: 149.652,
    accuracy: 3
  },
  {
    postalCode: 2850,
    city: "Home Rule",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4167,
    longitude: 149.6333,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Collingwood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6278,
    longitude: 149.652,
    accuracy: 3
  },
  {
    postalCode: 2850,
    city: "Sallys Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33,
    longitude: 149.5833,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Aarons Pass",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6278,
    longitude: 149.652,
    accuracy: 3
  },
  {
    postalCode: 2850,
    city: "Ullamalla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6278,
    longitude: 149.652,
    accuracy: 3
  },
  {
    postalCode: 2850,
    city: "Avisford",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7318,
    longitude: 149.4846,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Ilford",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9667,
    longitude: 149.8667,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Putta Bucca",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5753,
    longitude: 149.5848,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Mullamuddy",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6278,
    longitude: 149.652,
    accuracy: 3
  },
  {
    postalCode: 2850,
    city: "Budgee Budgee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5318,
    longitude: 149.6679,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Erudgere",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6278,
    longitude: 149.652,
    accuracy: 3
  },
  {
    postalCode: 2850,
    city: "Hargraves",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7866,
    longitude: 149.4579,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Maitland Bar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6278,
    longitude: 149.652,
    accuracy: 3
  },
  {
    postalCode: 2850,
    city: "Barigan",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6278,
    longitude: 149.652,
    accuracy: 3
  },
  {
    postalCode: 2850,
    city: "Piambong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4985,
    longitude: 149.3846,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Menah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5494,
    longitude: 149.5432,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Milroy",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.15,
    longitude: 150.05,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Mount Frome",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6,
    longitude: 149.6333,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Munghorn",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.45,
    longitude: 149.8,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Yarrawonga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4514,
    longitude: 150.5858,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Canadian Lead",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6278,
    longitude: 149.652,
    accuracy: 3
  },
  {
    postalCode: 2850,
    city: "Tambaroora",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33,
    longitude: 149.4333,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Meroo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.8333,
    longitude: 150.6167,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Cullenbone",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5,
    longitude: 149.5167,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Eurunderee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6278,
    longitude: 149.652,
    accuracy: 3
  },
  {
    postalCode: 2850,
    city: "Buckaroo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.55,
    longitude: 149.6333,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Triamble",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8833,
    longitude: 149.3,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Grattai",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6833,
    longitude: 149.4833,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Monivae",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6278,
    longitude: 149.652,
    accuracy: 3
  },
  {
    postalCode: 2850,
    city: "Bocoble",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6278,
    longitude: 149.652,
    accuracy: 3
  },
  {
    postalCode: 2850,
    city: "Spring Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6278,
    longitude: 149.652,
    accuracy: 3
  },
  {
    postalCode: 2850,
    city: "Linburn",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4235,
    longitude: 149.7179,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Worlds End",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6278,
    longitude: 149.652,
    accuracy: 3
  },
  {
    postalCode: 2850,
    city: "Kains Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6278,
    longitude: 149.652,
    accuracy: 3
  },
  {
    postalCode: 2850,
    city: "Tichular",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6278,
    longitude: 149.652,
    accuracy: 3
  },
  {
    postalCode: 2850,
    city: "Yarrabin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6278,
    longitude: 149.652,
    accuracy: 3
  },
  {
    postalCode: 2850,
    city: "Galambine",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6278,
    longitude: 149.652,
    accuracy: 3
  },
  {
    postalCode: 2850,
    city: "Cudgegong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8,
    longitude: 149.8167,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "St Fillans",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6278,
    longitude: 149.652,
    accuracy: 3
  },
  {
    postalCode: 2850,
    city: "Mount Knowles",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6152,
    longitude: 149.7179,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Carcalgong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6278,
    longitude: 149.652,
    accuracy: 3
  },
  {
    postalCode: 2850,
    city: "Hill End",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0333,
    longitude: 149.4167,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Cumbo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6278,
    longitude: 149.652,
    accuracy: 3
  },
  {
    postalCode: 2850,
    city: "Moolarben",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3485,
    longitude: 149.7762,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Green Gully",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6278,
    longitude: 149.652,
    accuracy: 3
  },
  {
    postalCode: 2850,
    city: "Havilah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6187,
    longitude: 149.765,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Queens Pinch",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6278,
    longitude: 149.652,
    accuracy: 3
  },
  {
    postalCode: 2850,
    city: "Riverlea",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6278,
    longitude: 149.652,
    accuracy: 3
  },
  {
    postalCode: 2850,
    city: "Frog Rock",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6278,
    longitude: 149.652,
    accuracy: 3
  },
  {
    postalCode: 2850,
    city: "Wilpinjong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3318,
    longitude: 149.8846,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Botobolar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5167,
    longitude: 149.7833,
    accuracy: 4
  },
  {
    postalCode: 2850,
    city: "Burrundulla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6278,
    longitude: 149.652,
    accuracy: 3
  },
  {
    postalCode: 2850,
    city: "Totnes Valley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6278,
    longitude: 149.652,
    accuracy: 3
  },
  {
    postalCode: 2850,
    city: "Cooks Gap",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3557,
    longitude: 149.7117,
    accuracy: 4
  },
  {
    postalCode: 2852,
    city: "Stubbo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3,
    longitude: 149.5333,
    accuracy: 4
  },
  {
    postalCode: 2852,
    city: "Bungaba",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3453,
    longitude: 149.4269,
    accuracy: 3
  },
  {
    postalCode: 2852,
    city: "Guntawang",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3985,
    longitude: 149.4846,
    accuracy: 4
  },
  {
    postalCode: 2852,
    city: "Two Mile Flat",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.4068,
    longitude: 149.3596,
    accuracy: 4
  },
  {
    postalCode: 2852,
    city: "Beryl",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3485,
    longitude: 149.4429,
    accuracy: 4
  },
  {
    postalCode: 2852,
    city: "Barneys Reef",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3453,
    longitude: 149.4269,
    accuracy: 3
  },
  {
    postalCode: 2852,
    city: "Mebul",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3485,
    longitude: 149.3346,
    accuracy: 4
  },
  {
    postalCode: 2852,
    city: "Gulgong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3625,
    longitude: 149.532,
    accuracy: 4
  },
  {
    postalCode: 2852,
    city: "Tallawang",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.2,
    longitude: 149.45,
    accuracy: 4
  },
  {
    postalCode: 2852,
    city: "Cope",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3453,
    longitude: 149.4269,
    accuracy: 3
  },
  {
    postalCode: 2852,
    city: "Goolma",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3818,
    longitude: 149.2762,
    accuracy: 4
  },
  {
    postalCode: 2852,
    city: "Cumbandry",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3453,
    longitude: 149.4269,
    accuracy: 3
  },
  {
    postalCode: 2852,
    city: "Merotherie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3453,
    longitude: 149.4269,
    accuracy: 3
  },
  {
    postalCode: 2864,
    city: "Murga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3688,
    longitude: 148.5511,
    accuracy: 4
  },
  {
    postalCode: 2864,
    city: "Cudal",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2856,
    longitude: 148.7407,
    accuracy: 4
  },
  {
    postalCode: 2864,
    city: "Bowan Park",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3,
    longitude: 148.8167,
    accuracy: 4
  },
  {
    postalCode: 2864,
    city: "Toogong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3333,
    longitude: 148.6333,
    accuracy: 4
  },
  {
    postalCode: 2865,
    city: "Gumble",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0818,
    longitude: 148.6512,
    accuracy: 4
  },
  {
    postalCode: 2865,
    city: "Bocobra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1329,
    longitude: 148.6695,
    accuracy: 3
  },
  {
    postalCode: 2865,
    city: "Manildra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1825,
    longitude: 148.6891,
    accuracy: 4
  },
  {
    postalCode: 2866,
    city: "Amaroo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1833,
    longitude: 148.9333,
    accuracy: 4
  },
  {
    postalCode: 2866,
    city: "Boomey",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0618,
    longitude: 148.9073,
    accuracy: 3
  },
  {
    postalCode: 2866,
    city: "Molong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0923,
    longitude: 148.87,
    accuracy: 4
  },
  {
    postalCode: 2866,
    city: "Euchareena",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9167,
    longitude: 149.1167,
    accuracy: 4
  },
  {
    postalCode: 2866,
    city: "Garra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1167,
    longitude: 148.7667,
    accuracy: 4
  },
  {
    postalCode: 2866,
    city: "Larras Lee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33,
    longitude: 148.85,
    accuracy: 4
  },
  {
    postalCode: 2866,
    city: "Cundumbul",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0618,
    longitude: 148.9073,
    accuracy: 3
  },
  {
    postalCode: 2867,
    city: "Baldry",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8667,
    longitude: 148.5,
    accuracy: 4
  },
  {
    postalCode: 2867,
    city: "Loombah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.888,
    longitude: 148.7016,
    accuracy: 3
  },
  {
    postalCode: 2867,
    city: "Cumnock",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9306,
    longitude: 148.7549,
    accuracy: 4
  },
  {
    postalCode: 2867,
    city: "Yullundry",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.888,
    longitude: 148.7016,
    accuracy: 3
  },
  {
    postalCode: 2867,
    city: "Eurimbla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8463,
    longitude: 148.8435,
    accuracy: 4
  },
  {
    postalCode: 2868,
    city: "Obley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7,
    longitude: 148.5667,
    accuracy: 4
  },
  {
    postalCode: 2868,
    city: "North Yeoval",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7271,
    longitude: 148.6074,
    accuracy: 3
  },
  {
    postalCode: 2868,
    city: "Yeoval",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7542,
    longitude: 148.6481,
    accuracy: 4
  },
  {
    postalCode: 2868,
    city: "Bournewood",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7271,
    longitude: 148.6074,
    accuracy: 3
  },
  {
    postalCode: 2869,
    city: "Trewilga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7866,
    longitude: 148.2298,
    accuracy: 4
  },
  {
    postalCode: 2869,
    city: "Tomingley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5667,
    longitude: 148.2333,
    accuracy: 4
  },
  {
    postalCode: 2869,
    city: "Peak Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7239,
    longitude: 148.1905,
    accuracy: 4
  },
  {
    postalCode: 2870,
    city: "Goonumbla",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33,
    longitude: 148.1333,
    accuracy: 4
  },
  {
    postalCode: 2870,
    city: "Cooks Myalls",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1546,
    longitude: 148.2428,
    accuracy: 3
  },
  {
    postalCode: 2870,
    city: "Cookamidgera",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2,
    longitude: 148.3,
    accuracy: 4
  },
  {
    postalCode: 2870,
    city: "Alectown",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9333,
    longitude: 148.25,
    accuracy: 4
  },
  {
    postalCode: 2870,
    city: "Mandagery",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2167,
    longitude: 148.4167,
    accuracy: 4
  },
  {
    postalCode: 2870,
    city: "Daroobalgie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3333,
    longitude: 148.0667,
    accuracy: 4
  },
  {
    postalCode: 2870,
    city: "Parkes",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1372,
    longitude: 148.1759,
    accuracy: 4
  },
  {
    postalCode: 2870,
    city: "Bumberry",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2,
    longitude: 148.4833,
    accuracy: 4
  },
  {
    postalCode: 2870,
    city: "Tichborne",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2167,
    longitude: 148.1167,
    accuracy: 4
  },
  {
    postalCode: 2871,
    city: "Bedgerebong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.35,
    longitude: 147.7,
    accuracy: 4
  },
  {
    postalCode: 2871,
    city: "Forbes",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3844,
    longitude: 148.0076,
    accuracy: 4
  },
  {
    postalCode: 2871,
    city: "Ooma",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.7233,
    longitude: 148.0891,
    accuracy: 4
  },
  {
    postalCode: 2871,
    city: "Bedgerabong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4692,
    longitude: 147.7868,
    accuracy: 3
  },
  {
    postalCode: 2871,
    city: "Fairholme",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2652,
    longitude: 147.3846,
    accuracy: 4
  },
  {
    postalCode: 2871,
    city: "Warroo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.3333,
    longitude: 147.5833,
    accuracy: 4
  },
  {
    postalCode: 2871,
    city: "Paytens Bridge",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4692,
    longitude: 147.7868,
    accuracy: 3
  },
  {
    postalCode: 2871,
    city: "Gunning Gap",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4692,
    longitude: 147.7868,
    accuracy: 3
  },
  {
    postalCode: 2871,
    city: "Wirrinya",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.6667,
    longitude: 147.8167,
    accuracy: 4
  },
  {
    postalCode: 2871,
    city: "Corinella",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4692,
    longitude: 147.7868,
    accuracy: 3
  },
  {
    postalCode: 2871,
    city: "Jemalong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4692,
    longitude: 147.7868,
    accuracy: 3
  },
  {
    postalCode: 2871,
    city: "Mulyandry",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.4692,
    longitude: 147.7868,
    accuracy: 3
  },
  {
    postalCode: 2871,
    city: "Garema",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.55,
    longitude: 147.9333,
    accuracy: 4
  },
  {
    postalCode: 2873,
    city: "Albert",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.35,
    longitude: 147.5,
    accuracy: 4
  },
  {
    postalCode: 2873,
    city: "Tottenham",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.2431,
    longitude: 147.3559,
    accuracy: 4
  },
  {
    postalCode: 2873,
    city: "Miamley",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.2966,
    longitude: 147.428,
    accuracy: 3
  },
  {
    postalCode: 2873,
    city: "Five Ways",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.2966,
    longitude: 147.428,
    accuracy: 3
  },
  {
    postalCode: 2874,
    city: "Tullamore",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6311,
    longitude: 147.5661,
    accuracy: 4
  },
  {
    postalCode: 2875,
    city: "Bruie Plains",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7833,
    longitude: 147.85,
    accuracy: 4
  },
  {
    postalCode: 2875,
    city: "Trundle",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9248,
    longitude: 147.7105,
    accuracy: 4
  },
  {
    postalCode: 2875,
    city: "Yarrabandai",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.128,
    longitude: 147.579,
    accuracy: 4
  },
  {
    postalCode: 2875,
    city: "Ootha",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1167,
    longitude: 147.45,
    accuracy: 4
  },
  {
    postalCode: 2875,
    city: "Fifield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.7954,
    longitude: 147.4656,
    accuracy: 4
  },
  {
    postalCode: 2876,
    city: "Bogan Gate",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1167,
    longitude: 147.8167,
    accuracy: 4
  },
  {
    postalCode: 2876,
    city: "Nelungaloo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1333,
    longitude: 148,
    accuracy: 4
  },
  {
    postalCode: 2876,
    city: "Gunningbland",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.1193,
    longitude: 147.9146,
    accuracy: 4
  },
  {
    postalCode: 2877,
    city: "Bobadah",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.519,
    longitude: 146.7503,
    accuracy: 4
  },
  {
    postalCode: 2877,
    city: "Euabalong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0574,
    longitude: 146.3957,
    accuracy: 4
  },
  {
    postalCode: 2877,
    city: "Eremerang",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8447,
    longitude: 146.7229,
    accuracy: 3
  },
  {
    postalCode: 2877,
    city: "Condobolin",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0881,
    longitude: 147.1451,
    accuracy: 4
  },
  {
    postalCode: 2877,
    city: "Mulguthrie",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.8447,
    longitude: 146.7229,
    accuracy: 3
  },
  {
    postalCode: 2877,
    city: "Boona Mount",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6333,
    longitude: 147.1667,
    accuracy: 4
  },
  {
    postalCode: 2877,
    city: "Mount Hope",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.839,
    longitude: 145.8806,
    accuracy: 4
  },
  {
    postalCode: 2877,
    city: "Euabalong West",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0574,
    longitude: 146.3957,
    accuracy: 4
  },
  {
    postalCode: 2877,
    city: "Derriwong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0985,
    longitude: 147.3346,
    accuracy: 4
  },
  {
    postalCode: 2877,
    city: "Kiacatoo",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0652,
    longitude: 146.8179,
    accuracy: 4
  },
  {
    postalCode: 2878,
    city: "Ivanhoe",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.9004,
    longitude: 144.3015,
    accuracy: 4
  },
  {
    postalCode: 2878,
    city: "Trida",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.0185,
    longitude: 145.0086,
    accuracy: 4
  },
  {
    postalCode: 2878,
    city: "Mossgiel",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -33.2495,
    longitude: 144.5657,
    accuracy: 4
  },
  {
    postalCode: 2878,
    city: "Conoble",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.6986,
    longitude: 144.1619,
    accuracy: 3
  },
  {
    postalCode: 2879,
    city: "Menindee",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.3929,
    longitude: 142.4182,
    accuracy: 4
  },
  {
    postalCode: 2879,
    city: "Sunset Strip",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.2652,
    longitude: 142.3012,
    accuracy: 4
  },
  {
    postalCode: 2880,
    city: "Broken Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9652,
    longitude: 141.4512,
    accuracy: 4
  },
  {
    postalCode: 2880,
    city: "Broken Hill West",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5166,
    longitude: 148.6724,
    accuracy: 3
  },
  {
    postalCode: 2880,
    city: "Milparinka",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.7345,
    longitude: 141.8849,
    accuracy: 4
  },
  {
    postalCode: 2880,
    city: "Broken Hill North",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5166,
    longitude: 148.6724,
    accuracy: 3
  },
  {
    postalCode: 2880,
    city: "South Broken Hill",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.9652,
    longitude: 141.4512,
    accuracy: 4
  },
  {
    postalCode: 2880,
    city: "Silverton",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.884,
    longitude: 141.2233,
    accuracy: 4
  },
  {
    postalCode: 2880,
    city: "Packsaddle",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5166,
    longitude: 148.6724,
    accuracy: 3
  },
  {
    postalCode: 2880,
    city: "Broughams Gate",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5166,
    longitude: 148.6724,
    accuracy: 3
  },
  {
    postalCode: 2880,
    city: "Mutawintji",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5166,
    longitude: 148.6724,
    accuracy: 3
  },
  {
    postalCode: 2880,
    city: "Tibooburra",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -29.4339,
    longitude: 142.0102,
    accuracy: 4
  },
  {
    postalCode: 2880,
    city: "Little Topar",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5166,
    longitude: 148.6724,
    accuracy: 3
  },
  {
    postalCode: 2880,
    city: "Fowlers Gap",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5166,
    longitude: 148.6724,
    accuracy: 3
  },
  {
    postalCode: 2890,
    city: "Australian Defence Forces",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.309,
    longitude: 148.084,
    accuracy: 1
  },
  {
    postalCode: 2891,
    city: "International Mc",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.5166,
    longitude: 148.6724,
    accuracy: 1
  },
  {
    postalCode: 2898,
    city: "Lord Howe Island",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -31.5526,
    longitude: 159.0768,
    accuracy: 1
  },
  {
    postalCode: 2899,
    city: "Norfolk Island",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -32.309,
    longitude: 148.084,
    accuracy: 1
  },
  {
    postalCode: 3500,
    city: "Paringi",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -34.1979,
    longitude: 142.1515,
    accuracy: 3
  },
  {
    postalCode: 3644,
    city: "Barooga",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.906,
    longitude: 145.6958,
    accuracy: 4
  },
  {
    postalCode: 3644,
    city: "Lalalty",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -35.9503,
    longitude: 145.6546,
    accuracy: 3
  },
  {
    postalCode: 3691,
    city: "Lake Hume Village",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.2843,
    longitude: 147.0692,
    accuracy: 3
  },
  {
    postalCode: 3707,
    city: "Bringenbrong",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -36.4104,
    longitude: 147.9589,
    accuracy: 3
  },
  {
    postalCode: 4377,
    city: "Maryland",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.55,
    longitude: 152,
    accuracy: 4
  },
  {
    postalCode: 4380,
    city: "Mingoola",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9833,
    longitude: 151.5167,
    accuracy: 4
  },
  {
    postalCode: 4380,
    city: "Amosfield",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.6667,
    longitude: 152.073,
    accuracy: 4
  },
  {
    postalCode: 4380,
    city: "Ruby Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7241,
    longitude: 151.825,
    accuracy: 3
  },
  {
    postalCode: 4380,
    city: "Undercliffe",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.7241,
    longitude: 151.825,
    accuracy: 3
  },
  {
    postalCode: 4383,
    city: "Jennings",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.9307,
    longitude: 151.9382,
    accuracy: 4
  },
  {
    postalCode: 4385,
    city: "Camp Creek",
    state_name: "New South Wales",
    state: "NSW",
    latitude: -28.85,
    longitude: 151.0333,
    accuracy: 4
  },
  {
    postalCode: 800,
    city: "Darwin",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4611,
    longitude: 130.8418,
    accuracy: 4
  },
  {
    postalCode: 801,
    city: "Darwin",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4611,
    longitude: 130.8418,
    accuracy: 4
  },
  {
    postalCode: 803,
    city: "Wagait Beach",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4348,
    longitude: 130.7443,
    accuracy: 4
  },
  {
    postalCode: 804,
    city: "Parap",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4305,
    longitude: 130.8414,
    accuracy: 4
  },
  {
    postalCode: 810,
    city: "Casuarina",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.374,
    longitude: 130.8822,
    accuracy: 4
  },
  {
    postalCode: 810,
    city: "Tiwi",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.3588,
    longitude: 130.878,
    accuracy: 4
  },
  {
    postalCode: 810,
    city: "Lyons",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.3591,
    longitude: 130.8885,
    accuracy: 4
  },
  {
    postalCode: 810,
    city: "Nightcliff",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.383,
    longitude: 130.8517,
    accuracy: 4
  },
  {
    postalCode: 810,
    city: "Brinkin",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.3706,
    longitude: 130.868,
    accuracy: 4
  },
  {
    postalCode: 810,
    city: "Moil",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.3885,
    longitude: 130.8809,
    accuracy: 4
  },
  {
    postalCode: 810,
    city: "Millner",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.3919,
    longitude: 130.8625,
    accuracy: 4
  },
  {
    postalCode: 810,
    city: "Jingili",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.3889,
    longitude: 130.8728,
    accuracy: 4
  },
  {
    postalCode: 810,
    city: "Rapid Creek",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.3804,
    longitude: 130.8592,
    accuracy: 4
  },
  {
    postalCode: 810,
    city: "Alawa",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.3795,
    longitude: 130.8732,
    accuracy: 4
  },
  {
    postalCode: 810,
    city: "Muirhead",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.3586,
    longitude: 130.8935,
    accuracy: 4
  },
  {
    postalCode: 810,
    city: "Nakara",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.3705,
    longitude: 130.8773,
    accuracy: 4
  },
  {
    postalCode: 810,
    city: "Wagaman",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.3807,
    longitude: 130.8854,
    accuracy: 4
  },
  {
    postalCode: 810,
    city: "Coconut Grove",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.396,
    longitude: 130.8519,
    accuracy: 4
  },
  {
    postalCode: 810,
    city: "Wanguri",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.3713,
    longitude: 130.8881,
    accuracy: 4
  },
  {
    postalCode: 810,
    city: "Lee Point",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.3415,
    longitude: 130.8895,
    accuracy: 4
  },
  {
    postalCode: 811,
    city: "Casuarina",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.374,
    longitude: 130.8822,
    accuracy: 4
  },
  {
    postalCode: 812,
    city: "Sanderson",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.3792,
    longitude: 130.8784,
    accuracy: 3
  },
  {
    postalCode: 812,
    city: "Marrara",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4004,
    longitude: 130.8929,
    accuracy: 4
  },
  {
    postalCode: 812,
    city: "Leanyer",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.3667,
    longitude: 130.9,
    accuracy: 4
  },
  {
    postalCode: 812,
    city: "Anula",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.3912,
    longitude: 130.8905,
    accuracy: 4
  },
  {
    postalCode: 812,
    city: "Woodleigh Gardens",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.3792,
    longitude: 130.8784,
    accuracy: 3
  },
  {
    postalCode: 812,
    city: "Malak",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.3929,
    longitude: 130.904,
    accuracy: 4
  },
  {
    postalCode: 812,
    city: "Buffalo Creek",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.3368,
    longitude: 130.9054,
    accuracy: 4
  },
  {
    postalCode: 812,
    city: "Holmes",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -37.814,
    longitude: 144.9633,
    accuracy: 3
  },
  {
    postalCode: 812,
    city: "Karama",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4022,
    longitude: 130.916,
    accuracy: 4
  },
  {
    postalCode: 812,
    city: "Wulagi",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.3834,
    longitude: 130.8954,
    accuracy: 4
  },
  {
    postalCode: 813,
    city: "Sanderson",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.3792,
    longitude: 130.8784,
    accuracy: 3
  },
  {
    postalCode: 813,
    city: "Karama",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4022,
    longitude: 130.916,
    accuracy: 4
  },
  {
    postalCode: 814,
    city: "Nightcliff",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.383,
    longitude: 130.8517,
    accuracy: 4
  },
  {
    postalCode: 815,
    city: "Charles Darwin University",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.3792,
    longitude: 130.8784,
    accuracy: 1
  },
  {
    postalCode: 820,
    city: "Winnellie",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4292,
    longitude: 130.8859,
    accuracy: 4
  },
  {
    postalCode: 820,
    city: "East Point",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4078,
    longitude: 130.8194,
    accuracy: 4
  },
  {
    postalCode: 820,
    city: "Bagot",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4153,
    longitude: 130.8568,
    accuracy: 4
  },
  {
    postalCode: 820,
    city: "Charles Darwin",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4338,
    longitude: 130.8737,
    accuracy: 4
  },
  {
    postalCode: 820,
    city: "Darwin DC",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4252,
    longitude: 130.8697,
    accuracy: 3
  },
  {
    postalCode: 820,
    city: "Coonawarra",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4341,
    longitude: 130.9098,
    accuracy: 4
  },
  {
    postalCode: 820,
    city: "Stuart Park",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.445,
    longitude: 130.843,
    accuracy: 4
  },
  {
    postalCode: 820,
    city: "Ludmilla",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4203,
    longitude: 130.8551,
    accuracy: 4
  },
  {
    postalCode: 820,
    city: "Darwin International Airport",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4252,
    longitude: 130.8697,
    accuracy: 3
  },
  {
    postalCode: 820,
    city: "Fannie Bay",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4227,
    longitude: 130.8363,
    accuracy: 4
  },
  {
    postalCode: 820,
    city: "The Gardens",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.449,
    longitude: 130.8316,
    accuracy: 4
  },
  {
    postalCode: 820,
    city: "Larrakeyah",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4553,
    longitude: 130.8317,
    accuracy: 4
  },
  {
    postalCode: 820,
    city: "Eaton",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4124,
    longitude: 130.8807,
    accuracy: 4
  },
  {
    postalCode: 820,
    city: "Bayview",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4336,
    longitude: 130.857,
    accuracy: 4
  },
  {
    postalCode: 820,
    city: "Woolner",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4354,
    longitude: 130.8479,
    accuracy: 4
  },
  {
    postalCode: 820,
    city: "Parap",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4305,
    longitude: 130.8414,
    accuracy: 4
  },
  {
    postalCode: 820,
    city: "The Narrows",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4264,
    longitude: 130.8595,
    accuracy: 4
  },
  {
    postalCode: 821,
    city: "Winnellie",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4292,
    longitude: 130.8859,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Milyakburra",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -13.7794,
    longitude: 136.2019,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Blackmore",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.7593,
    longitude: 130.9382,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Murrumujuk",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.2609,
    longitude: 131.0717,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Maningrida",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.0674,
    longitude: 134.0866,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Nganmarriyanga",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -14.335,
    longitude: 129.8835,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Gunbalanya",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.3247,
    longitude: 133.0509,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Tiwi Islands",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -11.5602,
    longitude: 130.8174,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Coomalie Creek",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Darwin River Dam",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Acacia Hills",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.7941,
    longitude: 131.1254,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Charles Darwin",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4338,
    longitude: 130.8737,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Anindilyakwa",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Daly River",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -13.7654,
    longitude: 130.7123,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Lloyd Creek",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6767,
    longitude: 131.1338,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Mandorah",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4457,
    longitude: 130.7574,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Thamarrurr",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -14.2032,
    longitude: 129.7052,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "East Arnhem",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Wickham",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.5539,
    longitude: 130.9223,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Numbulwar",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -14.2761,
    longitude: 135.7372,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Darwin Mc",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -13.0616,
    longitude: 132.8034,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Nauiyu",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -13.7425,
    longitude: 130.6956,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Tumbling Waters",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.7685,
    longitude: 130.95,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Kakadu",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.8685,
    longitude: 132.474,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Bathurst Island",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Wadeye",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -14.2383,
    longitude: 129.5218,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Hughes",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.7007,
    longitude: 131.0981,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Marrakai",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.7505,
    longitude: 131.4806,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Delissaville",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -13.0616,
    longitude: 132.8034,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Pularumpi",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -11.4049,
    longitude: 130.4156,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Pirlangimpi",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -11.403,
    longitude: 130.429,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Croker Island",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -13.0616,
    longitude: 132.8034,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Peppimenarti",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -14.1555,
    longitude: 130.0815,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Douglas-Daly",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Numburindi",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -13.9293,
    longitude: 135.704,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Litchfield Park",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Wurrumiyanga",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -11.7608,
    longitude: 130.6256,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Nemarluk",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -14.2768,
    longitude: 130.3759,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "West Arnhem",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.2352,
    longitude: 134.0603,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Umbakumba",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -13.0616,
    longitude: 132.8034,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Charlotte",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Hidden Valley",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4424,
    longitude: 130.9094,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Southport",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.7218,
    longitude: 130.9514,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Bynoe Harbour",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Warruwi",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -11.6457,
    longitude: 133.3884,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Angurugu",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -13.0616,
    longitude: 132.8034,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Cox Peninsula",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4268,
    longitude: 130.6408,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Bynoe",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Black Jungle",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.5138,
    longitude: 131.2193,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Weddell",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Fly Creek",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.776,
    longitude: 131.0445,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Claravale",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Goulburn Island",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -11.65,
    longitude: 133.3883,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Mcminns Lagoon",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.554,
    longitude: 131.1116,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Lambells Lagoon",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.5845,
    longitude: 131.2503,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "East Arm",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Bees Creek",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.5795,
    longitude: 131.0593,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Finniss Valley",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Livingstone",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6814,
    longitude: 131.0741,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Tipperary",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Annie River",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Tortilla Flats",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Burrundie",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Tivendale",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Nguiu",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -11.7604,
    longitude: 130.636,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Vernon Islands",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Minjilang",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -11.1584,
    longitude: 132.5453,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Stapleton",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Oenpelli",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.3237,
    longitude: 133.0576,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Rakula",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Galiwinku",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.0281,
    longitude: 135.5649,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Robin Falls",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Channel Island",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.5533,
    longitude: 130.8685,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Wak Wak",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Milingimbi",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.1019,
    longitude: 134.919,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Glyde Point",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Camp Creek",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Eva Valley",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Winnellie",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4292,
    longitude: 130.8859,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Daly",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Hotham",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Hayes Creek",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Ramingining",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -13.0616,
    longitude: 132.8034,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Mapuru",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Freds Pass",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.5394,
    longitude: 131.0569,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Middle Point",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Koolpinyah",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Wagait Beach",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4348,
    longitude: 130.7443,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Mickett Creek",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Point Stephens",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Belyuen",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.5381,
    longitude: 130.6982,
    accuracy: 4
  },
  {
    postalCode: 822,
    city: "Margaret River",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Woolaning",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Wishart",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Collett Creek",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Maranunga",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Milikapiti",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -11.4255,
    longitude: 130.6748,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Lake Bennett",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Cobourg",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Fleming",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Sandpalms Roadhouse",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Gunn Point",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Point Stuart",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Mount Bundey",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Rum Jungle",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6978,
    longitude: 130.8459,
    accuracy: 3
  },
  {
    postalCode: 822,
    city: "Elrundie",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4789,
    longitude: 130.9599,
    accuracy: 4
  },
  {
    postalCode: 828,
    city: "Berrimah",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4351,
    longitude: 130.9261,
    accuracy: 4
  },
  {
    postalCode: 828,
    city: "Knuckey Lagoon",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4266,
    longitude: 130.9457,
    accuracy: 4
  },
  {
    postalCode: 829,
    city: "Pinelands",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4576,
    longitude: 130.9598,
    accuracy: 4
  },
  {
    postalCode: 829,
    city: "Holtze",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4485,
    longitude: 131.0056,
    accuracy: 4
  },
  {
    postalCode: 830,
    city: "Driver",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.486,
    longitude: 130.9754,
    accuracy: 4
  },
  {
    postalCode: 830,
    city: "Archer",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.5144,
    longitude: 130.9688,
    accuracy: 4
  },
  {
    postalCode: 830,
    city: "Shoal Bay",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4731,
    longitude: 130.9721,
    accuracy: 3
  },
  {
    postalCode: 830,
    city: "Marlow Lagoon",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4913,
    longitude: 130.9641,
    accuracy: 4
  },
  {
    postalCode: 830,
    city: "Farrar",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4803,
    longitude: 130.9982,
    accuracy: 4
  },
  {
    postalCode: 830,
    city: "Durack",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4731,
    longitude: 130.9721,
    accuracy: 4
  },
  {
    postalCode: 830,
    city: "Palmerston",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.486,
    longitude: 130.9833,
    accuracy: 4
  },
  {
    postalCode: 830,
    city: "Gray",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4904,
    longitude: 130.9823,
    accuracy: 4
  },
  {
    postalCode: 830,
    city: "Woodroffe",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.5017,
    longitude: 130.9802,
    accuracy: 4
  },
  {
    postalCode: 830,
    city: "Moulden",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.5056,
    longitude: 130.9731,
    accuracy: 4
  },
  {
    postalCode: 830,
    city: "Yarrawonga",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4725,
    longitude: 130.9884,
    accuracy: 4
  },
  {
    postalCode: 831,
    city: "Palmerston",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.486,
    longitude: 130.9833,
    accuracy: 4
  },
  {
    postalCode: 832,
    city: "Zuccoli",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4876,
    longitude: 131.0117,
    accuracy: 3
  },
  {
    postalCode: 832,
    city: "Bakewell",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4968,
    longitude: 130.9934,
    accuracy: 4
  },
  {
    postalCode: 832,
    city: "Johnston",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4876,
    longitude: 131.0117,
    accuracy: 4
  },
  {
    postalCode: 832,
    city: "Gunn",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4876,
    longitude: 130.9932,
    accuracy: 4
  },
  {
    postalCode: 832,
    city: "Rosebery",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.5105,
    longitude: 130.9878,
    accuracy: 4
  },
  {
    postalCode: 832,
    city: "Mitchell",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4986,
    longitude: 130.9984,
    accuracy: 3
  },
  {
    postalCode: 832,
    city: "Rosebery Heights",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4876,
    longitude: 131.0117,
    accuracy: 3
  },
  {
    postalCode: 832,
    city: "Bellamack",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.5171,
    longitude: 130.9836,
    accuracy: 4
  },
  {
    postalCode: 834,
    city: "Virginia",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.519,
    longitude: 131.0284,
    accuracy: 4
  },
  {
    postalCode: 835,
    city: "Coolalinga",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.5231,
    longitude: 131.0415,
    accuracy: 4
  },
  {
    postalCode: 835,
    city: "Howard Springs",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4958,
    longitude: 131.0445,
    accuracy: 4
  },
  {
    postalCode: 835,
    city: "Virginia",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.519,
    longitude: 131.0284,
    accuracy: 4
  },
  {
    postalCode: 836,
    city: "Girraween",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.5253,
    longitude: 131.0957,
    accuracy: 4
  },
  {
    postalCode: 836,
    city: "Humpty Doo",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.5841,
    longitude: 131.1367,
    accuracy: 4
  },
  {
    postalCode: 836,
    city: "Herbert",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.5341,
    longitude: 131.162,
    accuracy: 4
  },
  {
    postalCode: 837,
    city: "Manton",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.8937,
    longitude: 131.1132,
    accuracy: 4
  },
  {
    postalCode: 837,
    city: "Noonamah",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6312,
    longitude: 131.0799,
    accuracy: 4
  },
  {
    postalCode: 838,
    city: "Berry Springs",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6968,
    longitude: 131.01,
    accuracy: 4
  },
  {
    postalCode: 839,
    city: "Coolalinga",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.5231,
    longitude: 131.0415,
    accuracy: 4
  },
  {
    postalCode: 840,
    city: "Dundee Beach",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.7176,
    longitude: 130.3513,
    accuracy: 1
  },
  {
    postalCode: 840,
    city: "Dundee Downs",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.7522,
    longitude: 130.5154,
    accuracy: 1
  },
  {
    postalCode: 840,
    city: "Dundee Forest",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.7168,
    longitude: 130.4475,
    accuracy: 1
  },
  {
    postalCode: 841,
    city: "Darwin River",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.8193,
    longitude: 130.9697,
    accuracy: 4
  },
  {
    postalCode: 845,
    city: "Batchelor",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -13.0505,
    longitude: 131.0307,
    accuracy: 4
  },
  {
    postalCode: 846,
    city: "Adelaide River",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -13.2379,
    longitude: 131.1056,
    accuracy: 4
  },
  {
    postalCode: 847,
    city: "Pine Creek",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -13.8208,
    longitude: 131.8329,
    accuracy: 4
  },
  {
    postalCode: 850,
    city: "Cossack",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -14.4555,
    longitude: 132.1748,
    accuracy: 4
  },
  {
    postalCode: 850,
    city: "Katherine",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -14.4652,
    longitude: 132.2635,
    accuracy: 4
  },
  {
    postalCode: 850,
    city: "Katherine South",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -14.4435,
    longitude: 132.2814,
    accuracy: 3
  },
  {
    postalCode: 850,
    city: "Lansdowne",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -14.4314,
    longitude: 132.3879,
    accuracy: 4
  },
  {
    postalCode: 850,
    city: "Emungalan",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -14.4435,
    longitude: 132.2814,
    accuracy: 3
  },
  {
    postalCode: 850,
    city: "Katherine East",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -14.4435,
    longitude: 132.2814,
    accuracy: 3
  },
  {
    postalCode: 851,
    city: "Katherine",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -14.4652,
    longitude: 132.2635,
    accuracy: 4
  },
  {
    postalCode: 852,
    city: "Yarralin",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -16.4526,
    longitude: 130.8419,
    accuracy: 4
  },
  {
    postalCode: 852,
    city: "Beswick",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -14.558,
    longitude: 133.1151,
    accuracy: 4
  },
  {
    postalCode: 852,
    city: "Barunga",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -14.5196,
    longitude: 132.8644,
    accuracy: 4
  },
  {
    postalCode: 852,
    city: "Wave Hill",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -17.4476,
    longitude: 130.8344,
    accuracy: 4
  },
  {
    postalCode: 852,
    city: "Jilkminggan",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -14.9615,
    longitude: 133.2928,
    accuracy: 4
  },
  {
    postalCode: 852,
    city: "Maranboy",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -14.5333,
    longitude: 132.7833,
    accuracy: 4
  },
  {
    postalCode: 852,
    city: "Daguragu",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -17.4193,
    longitude: 130.8021,
    accuracy: 4
  },
  {
    postalCode: 852,
    city: "Wilton",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -15.0045,
    longitude: 133.3768,
    accuracy: 3
  },
  {
    postalCode: 852,
    city: "Numbulwar",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -14.2761,
    longitude: 135.7372,
    accuracy: 4
  },
  {
    postalCode: 852,
    city: "Ngukurr",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -14.7308,
    longitude: 134.731,
    accuracy: 4
  },
  {
    postalCode: 852,
    city: "Baines",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -15.9828,
    longitude: 129.4996,
    accuracy: 4
  },
  {
    postalCode: 852,
    city: "Uralla",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -14.4911,
    longitude: 132.2983,
    accuracy: 4
  },
  {
    postalCode: 852,
    city: "Gregory",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -15.0045,
    longitude: 133.3768,
    accuracy: 3
  },
  {
    postalCode: 852,
    city: "Victoria River Downs",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -16.0432,
    longitude: 132.4219,
    accuracy: 3
  },
  {
    postalCode: 852,
    city: "Venn",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -15.0045,
    longitude: 133.3768,
    accuracy: 3
  },
  {
    postalCode: 852,
    city: "Timber Creek",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -15.6625,
    longitude: 130.4804,
    accuracy: 4
  },
  {
    postalCode: 852,
    city: "Edith",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -15.0045,
    longitude: 133.3768,
    accuracy: 3
  },
  {
    postalCode: 852,
    city: "Binjari",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -14.5501,
    longitude: 132.1842,
    accuracy: 4
  },
  {
    postalCode: 852,
    city: "Manbulloo",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -15.0045,
    longitude: 133.3768,
    accuracy: 3
  },
  {
    postalCode: 852,
    city: "Top Springs",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -16.5438,
    longitude: 131.7977,
    accuracy: 4
  },
  {
    postalCode: 852,
    city: "Gurindji",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -15.0045,
    longitude: 133.3768,
    accuracy: 3
  },
  {
    postalCode: 852,
    city: "Bulman Weemol",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -15.0045,
    longitude: 133.3768,
    accuracy: 3
  },
  {
    postalCode: 852,
    city: "Kalkarindji",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -17.4476,
    longitude: 130.8344,
    accuracy: 4
  },
  {
    postalCode: 852,
    city: "Limmen",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -15.5241,
    longitude: 134.8004,
    accuracy: 4
  },
  {
    postalCode: 852,
    city: "Birdum",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -15.65,
    longitude: 133.2167,
    accuracy: 4
  },
  {
    postalCode: 852,
    city: "Arnold",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -15.0045,
    longitude: 133.3768,
    accuracy: 3
  },
  {
    postalCode: 852,
    city: "Elsey",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -15.0045,
    longitude: 133.3768,
    accuracy: 3
  },
  {
    postalCode: 852,
    city: "Bradshaw",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -15.0045,
    longitude: 133.3768,
    accuracy: 3
  },
  {
    postalCode: 852,
    city: "Creswell",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -15.0045,
    longitude: 133.3768,
    accuracy: 3
  },
  {
    postalCode: 852,
    city: "Tanami East",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -15.0045,
    longitude: 133.3768,
    accuracy: 3
  },
  {
    postalCode: 852,
    city: "Delamere",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -15.0045,
    longitude: 133.3768,
    accuracy: 3
  },
  {
    postalCode: 852,
    city: "Lajamanu",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -16.0432,
    longitude: 132.4219,
    accuracy: 3
  },
  {
    postalCode: 852,
    city: "Flying Fox",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -15.0045,
    longitude: 133.3768,
    accuracy: 3
  },
  {
    postalCode: 852,
    city: "Beswick Creek",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -15.0045,
    longitude: 133.3768,
    accuracy: 3
  },
  {
    postalCode: 852,
    city: "Victoria River",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -15.0045,
    longitude: 133.3768,
    accuracy: 3
  },
  {
    postalCode: 852,
    city: "Pellew Islands",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -15.0045,
    longitude: 133.3768,
    accuracy: 3
  },
  {
    postalCode: 852,
    city: "Florina",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -15.0045,
    longitude: 133.3768,
    accuracy: 3
  },
  {
    postalCode: 852,
    city: "Robinson River",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -15.0045,
    longitude: 133.3768,
    accuracy: 3
  },
  {
    postalCode: 852,
    city: "Daly Waters",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -16.2533,
    longitude: 133.3693,
    accuracy: 4
  },
  {
    postalCode: 852,
    city: "Larrimah",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -16.0432,
    longitude: 132.4219,
    accuracy: 3
  },
  {
    postalCode: 852,
    city: "Gulung Mardrulk",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -15.0045,
    longitude: 133.3768,
    accuracy: 3
  },
  {
    postalCode: 852,
    city: "Pigeon Hole",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -15.0045,
    longitude: 133.3768,
    accuracy: 3
  },
  {
    postalCode: 852,
    city: "Miniyeri",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -15.2255,
    longitude: 134.0798,
    accuracy: 4
  },
  {
    postalCode: 852,
    city: "Katherine",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -14.4652,
    longitude: 132.2635,
    accuracy: 4
  },
  {
    postalCode: 852,
    city: "Mataranka",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -14.9213,
    longitude: 133.065,
    accuracy: 4
  },
  {
    postalCode: 852,
    city: "Helen Springs Station",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -15.0045,
    longitude: 133.3768,
    accuracy: 3
  },
  {
    postalCode: 852,
    city: "Mcarthur",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -15.0045,
    longitude: 133.3768,
    accuracy: 3
  },
  {
    postalCode: 852,
    city: "Buchanan",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -15.0045,
    longitude: 133.3768,
    accuracy: 3
  },
  {
    postalCode: 852,
    city: "Sturt Plateau",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -15.0045,
    longitude: 133.3768,
    accuracy: 3
  },
  {
    postalCode: 852,
    city: "Warumungu",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -15.0045,
    longitude: 133.3768,
    accuracy: 3
  },
  {
    postalCode: 852,
    city: "Nitmiluk",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -15.0045,
    longitude: 133.3768,
    accuracy: 3
  },
  {
    postalCode: 853,
    city: "Tindal",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -14.5312,
    longitude: 132.3793,
    accuracy: 4
  },
  {
    postalCode: 853,
    city: "Tindal Raaf",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -14.5733,
    longitude: 132.54,
    accuracy: 3
  },
  {
    postalCode: 854,
    city: "King Ash Bay",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -14.8923,
    longitude: 133.1577,
    accuracy: 1
  },
  {
    postalCode: 854,
    city: "Borroloola",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -16.0703,
    longitude: 136.3087,
    accuracy: 1
  },
  {
    postalCode: 860,
    city: "Tennant Creek",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -19.6548,
    longitude: 134.1871,
    accuracy: 1
  },
  {
    postalCode: 861,
    city: "Tennant Creek",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.7,
    longitude: 133.8833,
    accuracy: 1
  },
  {
    postalCode: 862,
    city: "Warrego",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -19.4362,
    longitude: 133.8208,
    accuracy: 4
  },
  {
    postalCode: 862,
    city: "Tennant Creek",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -19.6497,
    longitude: 134.1915,
    accuracy: 4
  },
  {
    postalCode: 862,
    city: "Newcastle Waters",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -18.9889,
    longitude: 135.0004,
    accuracy: 3
  },
  {
    postalCode: 862,
    city: "Renner Springs",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -37.8421,
    longitude: 145.0694,
    accuracy: 3
  },
  {
    postalCode: 862,
    city: "Calvert",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -16.9206,
    longitude: 137.2034,
    accuracy: 4
  },
  {
    postalCode: 862,
    city: "Tablelands",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -37.8421,
    longitude: 145.0694,
    accuracy: 3
  },
  {
    postalCode: 862,
    city: "Nicholson",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -37.8421,
    longitude: 145.0694,
    accuracy: 3
  },
  {
    postalCode: 862,
    city: "Pamayu",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -37.8421,
    longitude: 145.0694,
    accuracy: 3
  },
  {
    postalCode: 862,
    city: "Elliott",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -17.5507,
    longitude: 133.5407,
    accuracy: 4
  },
  {
    postalCode: 870,
    city: "Stuart",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.6975,
    longitude: 133.8836,
    accuracy: 1
  },
  {
    postalCode: 870,
    city: "Ross",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.7442,
    longitude: 133.9036,
    accuracy: 1
  },
  {
    postalCode: 870,
    city: "Larapinta",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.6803,
    longitude: 133.8311,
    accuracy: 1
  },
  {
    postalCode: 870,
    city: "Araluen",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.696,
    longitude: 133.854,
    accuracy: 1
  },
  {
    postalCode: 870,
    city: "Mount Johns",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.7232,
    longitude: 133.913,
    accuracy: 1
  },
  {
    postalCode: 870,
    city: "Flynn",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.7135,
    longitude: 133.8356,
    accuracy: 1
  },
  {
    postalCode: 870,
    city: "The Gap",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.7133,
    longitude: 133.8739,
    accuracy: 1
  },
  {
    postalCode: 870,
    city: "Sadadeen",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.704,
    longitude: 133.9004,
    accuracy: 1
  },
  {
    postalCode: 870,
    city: "East Side",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.692,
    longitude: 133.8932,
    accuracy: 1
  },
  {
    postalCode: 870,
    city: "Arumbera",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.7,
    longitude: 133.874,
    accuracy: 1
  },
  {
    postalCode: 870,
    city: "Connellan",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.7,
    longitude: 133.874,
    accuracy: 1
  },
  {
    postalCode: 870,
    city: "Alice Springs",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.735,
    longitude: 133.8548,
    accuracy: 1
  },
  {
    postalCode: 870,
    city: "Irlpme",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.6469,
    longitude: 133.8648,
    accuracy: 1
  },
  {
    postalCode: 870,
    city: "Ilparpa",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.7,
    longitude: 133.874,
    accuracy: 1
  },
  {
    postalCode: 870,
    city: "Undoolya",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.7,
    longitude: 133.874,
    accuracy: 1
  },
  {
    postalCode: 870,
    city: "Gillen",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.7092,
    longitude: 133.866,
    accuracy: 1
  },
  {
    postalCode: 870,
    city: "Ciccone",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.7,
    longitude: 133.874,
    accuracy: 1
  },
  {
    postalCode: 870,
    city: "White Gums",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.7,
    longitude: 133.874,
    accuracy: 1
  },
  {
    postalCode: 870,
    city: "Braitling",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.68,
    longitude: 133.8688,
    accuracy: 1
  },
  {
    postalCode: 870,
    city: "Desert Springs",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.7,
    longitude: 133.874,
    accuracy: 1
  },
  {
    postalCode: 871,
    city: "Alice Springs",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.7,
    longitude: 133.8833,
    accuracy: 1
  },
  {
    postalCode: 872,
    city: "Ampilatwatja",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -21.657,
    longitude: 135.2259,
    accuracy: 4
  },
  {
    postalCode: 872,
    city: "Wilora",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -21.7443,
    longitude: 133.7265,
    accuracy: 4
  },
  {
    postalCode: 872,
    city: "Barrow Creek",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -21.55,
    longitude: 133.8833,
    accuracy: 4
  },
  {
    postalCode: 872,
    city: "Hale",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Laramba",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -22.5434,
    longitude: 132.7624,
    accuracy: 4
  },
  {
    postalCode: 872,
    city: "Ali Curung",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -21.0199,
    longitude: 134.3249,
    accuracy: 4
  },
  {
    postalCode: 872,
    city: "Wallace Rockhole",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -24.1242,
    longitude: 133.091,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Yuendumu",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -22.2667,
    longitude: 131.8167,
    accuracy: 4
  },
  {
    postalCode: 872,
    city: "Papunya",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.2045,
    longitude: 131.9122,
    accuracy: 4
  },
  {
    postalCode: 872,
    city: "Tara",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -21.4833,
    longitude: 133.9992,
    accuracy: 4
  },
  {
    postalCode: 872,
    city: "Davenport",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Kulgera",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Anmatjere",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Wutunugurra",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -20.4623,
    longitude: 135.2505,
    accuracy: 4
  },
  {
    postalCode: 872,
    city: "Namatjira",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Canteen Creek",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -20.6403,
    longitude: 135.5865,
    accuracy: 4
  },
  {
    postalCode: 872,
    city: "Hart",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Burt Plain",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Napperby Station",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Engawala",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -22.8031,
    longitude: 134.4564,
    accuracy: 4
  },
  {
    postalCode: 872,
    city: "Atitjere",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Nyirripi",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -22.6492,
    longitude: 130.5639,
    accuracy: 4
  },
  {
    postalCode: 872,
    city: "Imanpa",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -25.1176,
    longitude: 132.5688,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Sandover",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -21.9596,
    longitude: 135.5128,
    accuracy: 4
  },
  {
    postalCode: 872,
    city: "Finke",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -25.698,
    longitude: 134.3397,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Tanami",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Santa Teresa",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -24.7306,
    longitude: 135.3322,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Mutitjulu",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Anatye",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Costello",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -14.5655,
    longitude: 134.8794,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Erldunda",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Chilla Well",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Alice Springs",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.7917,
    longitude: 132.6818,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Titjikala",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -24.6802,
    longitude: 134.0751,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Areyonga",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -24.1669,
    longitude: 132.2868,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Willowra",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -21.2632,
    longitude: 132.6191,
    accuracy: 4
  },
  {
    postalCode: 872,
    city: "Hart Range",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Yuelamu",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -22.2617,
    longitude: 132.1994,
    accuracy: 4
  },
  {
    postalCode: 872,
    city: "Ti Tree",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -22.1338,
    longitude: 133.4139,
    accuracy: 4
  },
  {
    postalCode: 872,
    city: "Yulara",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -25.242,
    longitude: 130.9856,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Haasts Bluff",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.5093,
    longitude: 132.1852,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Mereenie",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Mount Zeil",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Kaltukatjara",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.7917,
    longitude: 132.6818,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Hermannsburg",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.7917,
    longitude: 132.6818,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Kings Creek Station",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Kintore",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.7917,
    longitude: 132.6818,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Hugh",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Telegraph Station",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Lake Mackay",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Ininti Store",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Macdonnell Range",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Simpson",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Mount Liebig",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Ghan",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Kunparrka",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.3611,
    longitude: 131.6665,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Amoonguna",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.7709,
    longitude: 133.9365,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Petermann",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 873,
    city: "Heavitree Gap Cpa",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -23.5298,
    longitude: 133.5021,
    accuracy: 1
  },
  {
    postalCode: 880,
    city: "Nhulunbuy",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.1816,
    longitude: 136.7784,
    accuracy: 4
  },
  {
    postalCode: 880,
    city: "Yirrkala",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.2549,
    longitude: 136.8899,
    accuracy: 4
  },
  {
    postalCode: 880,
    city: "Gapuwiyak",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.5031,
    longitude: 135.8105,
    accuracy: 4
  },
  {
    postalCode: 880,
    city: "Gunyangara",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.2165,
    longitude: 136.7054,
    accuracy: 4
  },
  {
    postalCode: 881,
    city: "Nhulunbuy",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.1816,
    longitude: 136.7784,
    accuracy: 4
  },
  {
    postalCode: 885,
    city: "Alyangula",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -13.8541,
    longitude: 136.4213,
    accuracy: 4
  },
  {
    postalCode: 886,
    city: "Jabiru",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.6705,
    longitude: 132.836,
    accuracy: 4
  },
  {
    postalCode: 906,
    city: "Winnellie",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4292,
    longitude: 130.8859,
    accuracy: 4
  },
  {
    postalCode: 907,
    city: "Winnellie",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.4292,
    longitude: 130.8859,
    accuracy: 4
  },
  {
    postalCode: 909,
    city: "Charles Darwin University",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -12.3731,
    longitude: 130.8681,
    accuracy: 1
  },
  {
    postalCode: 4825,
    city: "Alpurrurulam",
    state_name: "Northern Territory",
    state: "NT",
    latitude: -20.1386,
    longitude: 145.8436,
    accuracy: 3
  },
  {
    postalCode: 4000,
    city: "Brisbane City",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4679,
    longitude: 153.0281,
    accuracy: 4
  },
  {
    postalCode: 4000,
    city: "Brisbane Adelaide Street",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.454,
    longitude: 153.0426,
    accuracy: 3
  },
  {
    postalCode: 4000,
    city: "Brisbane",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4679,
    longitude: 153.0281,
    accuracy: 4
  },
  {
    postalCode: 4000,
    city: "Petrie Terrace",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.463,
    longitude: 153.0131,
    accuracy: 4
  },
  {
    postalCode: 4000,
    city: "Spring Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4614,
    longitude: 153.0231,
    accuracy: 4
  },
  {
    postalCode: 4000,
    city: "Brisbane GPO",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4651,
    longitude: 153.0231,
    accuracy: 3
  },
  {
    postalCode: 4001,
    city: "Brisbane",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4679,
    longitude: 153.0281,
    accuracy: 4
  },
  {
    postalCode: 4001,
    city: "Central Plaza",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5,
    longitude: 153.0167,
    accuracy: 3
  },
  {
    postalCode: 4001,
    city: "Riverside Centre",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5,
    longitude: 153.0167,
    accuracy: 3
  },
  {
    postalCode: 4001,
    city: "Waterfront Place",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5,
    longitude: 153.0167,
    accuracy: 3
  },
  {
    postalCode: 4002,
    city: "City East",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.454,
    longitude: 153.0426,
    accuracy: 1
  },
  {
    postalCode: 4002,
    city: "Wintergarden",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.454,
    longitude: 153.0426,
    accuracy: 1
  },
  {
    postalCode: 4003,
    city: "George Street",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.454,
    longitude: 153.0426,
    accuracy: 1
  },
  {
    postalCode: 4004,
    city: "Spring Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4614,
    longitude: 153.0231,
    accuracy: 4
  },
  {
    postalCode: 4005,
    city: "New Farm",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4667,
    longitude: 153.05,
    accuracy: 4
  },
  {
    postalCode: 4005,
    city: "Teneriffe",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4559,
    longitude: 153.047,
    accuracy: 4
  },
  {
    postalCode: 4006,
    city: "Newstead",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4436,
    longitude: 153.0443,
    accuracy: 4
  },
  {
    postalCode: 4006,
    city: "Fortitude Valley BC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4473,
    longitude: 153.032,
    accuracy: 3
  },
  {
    postalCode: 4006,
    city: "Bowen Hills",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4432,
    longitude: 153.0302,
    accuracy: 4
  },
  {
    postalCode: 4006,
    city: "Herston",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4445,
    longitude: 153.0185,
    accuracy: 4
  },
  {
    postalCode: 4006,
    city: "Fortitude Valley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4571,
    longitude: 153.0318,
    accuracy: 4
  },
  {
    postalCode: 4007,
    city: "Hamilton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.439,
    longitude: 153.0629,
    accuracy: 4
  },
  {
    postalCode: 4007,
    city: "Ascot",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4315,
    longitude: 153.058,
    accuracy: 4
  },
  {
    postalCode: 4007,
    city: "Hamilton Central",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4417,
    longitude: 153.0667,
    accuracy: 3
  },
  {
    postalCode: 4008,
    city: "Pinkenba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.428,
    longitude: 153.1167,
    accuracy: 4
  },
  {
    postalCode: 4008,
    city: "Brisbane Airport",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3947,
    longitude: 153.114,
    accuracy: 4
  },
  {
    postalCode: 4009,
    city: "Eagle Farm BC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4306,
    longitude: 153.0906,
    accuracy: 3
  },
  {
    postalCode: 4009,
    city: "Eagle Farm",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4333,
    longitude: 153.0833,
    accuracy: 4
  },
  {
    postalCode: 4010,
    city: "Albion DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4301,
    longitude: 153.0379,
    accuracy: 3
  },
  {
    postalCode: 4010,
    city: "Albion",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4301,
    longitude: 153.0379,
    accuracy: 4
  },
  {
    postalCode: 4010,
    city: "Albion BC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4301,
    longitude: 153.0379,
    accuracy: 3
  },
  {
    postalCode: 4011,
    city: "Clayfield",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4189,
    longitude: 153.0582,
    accuracy: 4
  },
  {
    postalCode: 4011,
    city: "Hendra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4177,
    longitude: 153.0703,
    accuracy: 4
  },
  {
    postalCode: 4012,
    city: "Nundah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4025,
    longitude: 153.0617,
    accuracy: 4
  },
  {
    postalCode: 4012,
    city: "Wavell Heights",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3938,
    longitude: 153.047,
    accuracy: 4
  },
  {
    postalCode: 4012,
    city: "Toombul",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4096,
    longitude: 153.0584,
    accuracy: 4
  },
  {
    postalCode: 4012,
    city: "Wavell Heights North",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3974,
    longitude: 153.0546,
    accuracy: 3
  },
  {
    postalCode: 4013,
    city: "Northgate",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4,
    longitude: 153.0667,
    accuracy: 4
  },
  {
    postalCode: 4014,
    city: "Nudgee Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3462,
    longitude: 153.1037,
    accuracy: 4
  },
  {
    postalCode: 4014,
    city: "Banyo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3824,
    longitude: 153.079,
    accuracy: 4
  },
  {
    postalCode: 4014,
    city: "Virginia",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3833,
    longitude: 153.0667,
    accuracy: 4
  },
  {
    postalCode: 4014,
    city: "Virginia BC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3783,
    longitude: 153.0768,
    accuracy: 3
  },
  {
    postalCode: 4014,
    city: "Nudgee",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3691,
    longitude: 153.0847,
    accuracy: 4
  },
  {
    postalCode: 4014,
    city: "Virginia DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3783,
    longitude: 153.0768,
    accuracy: 3
  },
  {
    postalCode: 4017,
    city: "Brighton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2958,
    longitude: 153.0572,
    accuracy: 4
  },
  {
    postalCode: 4017,
    city: "Brighton Nathan Street",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3192,
    longitude: 153.0612,
    accuracy: 3
  },
  {
    postalCode: 4017,
    city: "Deagon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3333,
    longitude: 153.0667,
    accuracy: 4
  },
  {
    postalCode: 4017,
    city: "Sandgate",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.322,
    longitude: 153.0695,
    accuracy: 4
  },
  {
    postalCode: 4017,
    city: "Shorncliffe",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3276,
    longitude: 153.0816,
    accuracy: 4
  },
  {
    postalCode: 4017,
    city: "Brighton Eventide",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3192,
    longitude: 153.0612,
    accuracy: 3
  },
  {
    postalCode: 4017,
    city: "Bracken Ridge",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3171,
    longitude: 153.031,
    accuracy: 4
  },
  {
    postalCode: 4017,
    city: "Sandgate DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3192,
    longitude: 153.0612,
    accuracy: 3
  },
  {
    postalCode: 4018,
    city: "Taigum",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3426,
    longitude: 153.0444,
    accuracy: 4
  },
  {
    postalCode: 4018,
    city: "Fitzgibbon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3397,
    longitude: 153.0292,
    accuracy: 4
  },
  {
    postalCode: 4019,
    city: "Woody Point",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2561,
    longitude: 153.1043,
    accuracy: 4
  },
  {
    postalCode: 4019,
    city: "Margate",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2476,
    longitude: 153.0981,
    accuracy: 4
  },
  {
    postalCode: 4019,
    city: "Margate Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2473,
    longitude: 153.0905,
    accuracy: 3
  },
  {
    postalCode: 4019,
    city: "Clontarf",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2534,
    longitude: 153.0783,
    accuracy: 4
  },
  {
    postalCode: 4019,
    city: "Clontarf DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2524,
    longitude: 153.0936,
    accuracy: 3
  },
  {
    postalCode: 4019,
    city: "Clontarf Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2524,
    longitude: 153.0936,
    accuracy: 3
  },
  {
    postalCode: 4020,
    city: "Newport",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2073,
    longitude: 153.1013,
    accuracy: 4
  },
  {
    postalCode: 4020,
    city: "Redcliffe North",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.213,
    longitude: 153.103,
    accuracy: 3
  },
  {
    postalCode: 4020,
    city: "Scarborough",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2012,
    longitude: 153.1094,
    accuracy: 4
  },
  {
    postalCode: 4020,
    city: "Redcliffe",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2307,
    longitude: 153.0973,
    accuracy: 4
  },
  {
    postalCode: 4021,
    city: "Kippa-Ring",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2259,
    longitude: 153.0835,
    accuracy: 4
  },
  {
    postalCode: 4022,
    city: "Rothwell",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2143,
    longitude: 153.0468,
    accuracy: 4
  },
  {
    postalCode: 4025,
    city: "Tangalooma",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1794,
    longitude: 153.3743,
    accuracy: 4
  },
  {
    postalCode: 4025,
    city: "Cape Moreton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0282,
    longitude: 153.4674,
    accuracy: 4
  },
  {
    postalCode: 4025,
    city: "Cowan Cowan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1259,
    longitude: 153.3661,
    accuracy: 4
  },
  {
    postalCode: 4025,
    city: "Bulwer",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0787,
    longitude: 153.3697,
    accuracy: 4
  },
  {
    postalCode: 4025,
    city: "Kooringal",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3536,
    longitude: 153.4247,
    accuracy: 4
  },
  {
    postalCode: 4029,
    city: "Royal Brisbane Hospital",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1962,
    longitude: 153.2931,
    accuracy: 1
  },
  {
    postalCode: 4030,
    city: "Wooloowin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4224,
    longitude: 153.042,
    accuracy: 4
  },
  {
    postalCode: 4030,
    city: "Lutwyche",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4227,
    longitude: 153.0335,
    accuracy: 4
  },
  {
    postalCode: 4030,
    city: "Windsor",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4363,
    longitude: 153.0288,
    accuracy: 4
  },
  {
    postalCode: 4031,
    city: "Kedron",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4029,
    longitude: 153.0297,
    accuracy: 4
  },
  {
    postalCode: 4031,
    city: "Gordon Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.419,
    longitude: 153.0255,
    accuracy: 4
  },
  {
    postalCode: 4032,
    city: "Chermside West",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3838,
    longitude: 153.0159,
    accuracy: 4
  },
  {
    postalCode: 4032,
    city: "Chermside",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3847,
    longitude: 153.0306,
    accuracy: 4
  },
  {
    postalCode: 4032,
    city: "Chermside Centre",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3847,
    longitude: 153.0306,
    accuracy: 3
  },
  {
    postalCode: 4032,
    city: "Chermside South",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3847,
    longitude: 153.0306,
    accuracy: 3
  },
  {
    postalCode: 4034,
    city: "Carseldine",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3475,
    longitude: 153.0231,
    accuracy: 4
  },
  {
    postalCode: 4034,
    city: "Boondall",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3532,
    longitude: 153.0609,
    accuracy: 4
  },
  {
    postalCode: 4034,
    city: "Aspley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3667,
    longitude: 153.0167,
    accuracy: 4
  },
  {
    postalCode: 4034,
    city: "Zillmere",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3559,
    longitude: 153.0445,
    accuracy: 4
  },
  {
    postalCode: 4034,
    city: "Geebung",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3725,
    longitude: 153.0471,
    accuracy: 4
  },
  {
    postalCode: 4035,
    city: "Albany Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.35,
    longitude: 152.9833,
    accuracy: 4
  },
  {
    postalCode: 4035,
    city: "Bridgeman Downs",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.353,
    longitude: 152.9817,
    accuracy: 3
  },
  {
    postalCode: 4036,
    city: "Bald Hills",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3211,
    longitude: 153.0086,
    accuracy: 4
  },
  {
    postalCode: 4037,
    city: "Eatons Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3392,
    longitude: 152.9599,
    accuracy: 4
  },
  {
    postalCode: 4051,
    city: "Enoggera",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4283,
    longitude: 152.9747,
    accuracy: 4
  },
  {
    postalCode: 4051,
    city: "Grange",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4225,
    longitude: 153.0153,
    accuracy: 4
  },
  {
    postalCode: 4051,
    city: "Newmarket",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4333,
    longitude: 153.0167,
    accuracy: 4
  },
  {
    postalCode: 4051,
    city: "Gaythorne",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4167,
    longitude: 152.9833,
    accuracy: 4
  },
  {
    postalCode: 4051,
    city: "Alderley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4255,
    longitude: 153.001,
    accuracy: 4
  },
  {
    postalCode: 4051,
    city: "Wilston",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4322,
    longitude: 153.019,
    accuracy: 4
  },
  {
    postalCode: 4053,
    city: "Everton Hills",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3891,
    longitude: 152.9713,
    accuracy: 4
  },
  {
    postalCode: 4053,
    city: "Brookside Centre",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4155,
    longitude: 152.9766,
    accuracy: 3
  },
  {
    postalCode: 4053,
    city: "Mitchelton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4167,
    longitude: 152.9667,
    accuracy: 4
  },
  {
    postalCode: 4053,
    city: "Stafford DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3961,
    longitude: 152.9766,
    accuracy: 3
  },
  {
    postalCode: 4053,
    city: "Mcdowall",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3827,
    longitude: 152.9919,
    accuracy: 4
  },
  {
    postalCode: 4053,
    city: "Stafford Heights",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3935,
    longitude: 153.0105,
    accuracy: 4
  },
  {
    postalCode: 4053,
    city: "Stafford",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4104,
    longitude: 153.0111,
    accuracy: 4
  },
  {
    postalCode: 4053,
    city: "Everton Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4073,
    longitude: 152.9884,
    accuracy: 4
  },
  {
    postalCode: 4054,
    city: "Arana Hills",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3981,
    longitude: 152.958,
    accuracy: 4
  },
  {
    postalCode: 4054,
    city: "Keperra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4138,
    longitude: 152.947,
    accuracy: 4
  },
  {
    postalCode: 4055,
    city: "Ferny Grove",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4008,
    longitude: 152.9348,
    accuracy: 4
  },
  {
    postalCode: 4055,
    city: "Bunya",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3694,
    longitude: 152.9433,
    accuracy: 4
  },
  {
    postalCode: 4055,
    city: "Ferny Hills",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3959,
    longitude: 152.9374,
    accuracy: 4
  },
  {
    postalCode: 4055,
    city: "Ferny Hills DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3963,
    longitude: 152.9319,
    accuracy: 3
  },
  {
    postalCode: 4055,
    city: "Upper Kedron",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4188,
    longitude: 152.9178,
    accuracy: 4
  },
  {
    postalCode: 4059,
    city: "Red Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4525,
    longitude: 153.0021,
    accuracy: 4
  },
  {
    postalCode: 4059,
    city: "Kelvin Grove Bc",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4507,
    longitude: 153.007,
    accuracy: 3
  },
  {
    postalCode: 4059,
    city: "Kelvin Grove",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4482,
    longitude: 153.0134,
    accuracy: 4
  },
  {
    postalCode: 4059,
    city: "Kelvin Grove Dc",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4507,
    longitude: 153.007,
    accuracy: 3
  },
  {
    postalCode: 4060,
    city: "Ashgrove",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4455,
    longitude: 152.992,
    accuracy: 4
  },
  {
    postalCode: 4060,
    city: "Ashgrove East",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4455,
    longitude: 152.992,
    accuracy: 3
  },
  {
    postalCode: 4060,
    city: "Dorrington",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4425,
    longitude: 152.9864,
    accuracy: 3
  },
  {
    postalCode: 4061,
    city: "The Gap",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4419,
    longitude: 152.9386,
    accuracy: 4
  },
  {
    postalCode: 4064,
    city: "Milton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4704,
    longitude: 153.0031,
    accuracy: 4
  },
  {
    postalCode: 4064,
    city: "Milton BC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4649,
    longitude: 152.9991,
    accuracy: 3
  },
  {
    postalCode: 4064,
    city: "Paddington",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4594,
    longitude: 152.9951,
    accuracy: 4
  },
  {
    postalCode: 4065,
    city: "Bardon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.461,
    longitude: 152.9792,
    accuracy: 4
  },
  {
    postalCode: 4066,
    city: "Toowong",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4833,
    longitude: 152.9833,
    accuracy: 4
  },
  {
    postalCode: 4066,
    city: "Toowong DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.48,
    longitude: 152.993,
    accuracy: 3
  },
  {
    postalCode: 4066,
    city: "Toowong BC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.48,
    longitude: 152.993,
    accuracy: 3
  },
  {
    postalCode: 4066,
    city: "Mount Coot-Tha",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4868,
    longitude: 152.9592,
    accuracy: 3
  },
  {
    postalCode: 4066,
    city: "Auchenflower",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4765,
    longitude: 152.9966,
    accuracy: 4
  },
  {
    postalCode: 4067,
    city: "St Lucia",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4982,
    longitude: 153.0004,
    accuracy: 1
  },
  {
    postalCode: 4067,
    city: "St Lucia South",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4868,
    longitude: 152.9592,
    accuracy: 1
  },
  {
    postalCode: 4068,
    city: "Chelmer",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5133,
    longitude: 152.9752,
    accuracy: 4
  },
  {
    postalCode: 4068,
    city: "Indooroopilly",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.503,
    longitude: 152.9752,
    accuracy: 4
  },
  {
    postalCode: 4068,
    city: "Indooroopilly Centre",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5023,
    longitude: 152.9763,
    accuracy: 3
  },
  {
    postalCode: 4068,
    city: "Taringa",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4906,
    longitude: 152.9786,
    accuracy: 4
  },
  {
    postalCode: 4069,
    city: "Upper Brookfield",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4667,
    longitude: 152.8667,
    accuracy: 4
  },
  {
    postalCode: 4069,
    city: "Pullenvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5228,
    longitude: 152.8865,
    accuracy: 4
  },
  {
    postalCode: 4069,
    city: "Brookfield",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5,
    longitude: 152.9,
    accuracy: 4
  },
  {
    postalCode: 4069,
    city: "Kenmore DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5072,
    longitude: 152.9208,
    accuracy: 3
  },
  {
    postalCode: 4069,
    city: "Chapel Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5026,
    longitude: 152.9501,
    accuracy: 4
  },
  {
    postalCode: 4069,
    city: "Fig Tree Pocket",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5278,
    longitude: 152.9619,
    accuracy: 4
  },
  {
    postalCode: 4069,
    city: "Kenmore",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5076,
    longitude: 152.9388,
    accuracy: 4
  },
  {
    postalCode: 4069,
    city: "Pinjarra Hills",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5383,
    longitude: 152.9074,
    accuracy: 4
  },
  {
    postalCode: 4069,
    city: "Kenmore East",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5072,
    longitude: 152.9208,
    accuracy: 3
  },
  {
    postalCode: 4069,
    city: "Kenmore Hills",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5042,
    longitude: 152.9318,
    accuracy: 4
  },
  {
    postalCode: 4070,
    city: "Anstead",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5378,
    longitude: 152.8619,
    accuracy: 4
  },
  {
    postalCode: 4070,
    city: "Moggill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5833,
    longitude: 152.8667,
    accuracy: 4
  },
  {
    postalCode: 4070,
    city: "Bellbowrie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5594,
    longitude: 152.8828,
    accuracy: 4
  },
  {
    postalCode: 4072,
    city: "University Of Queensland",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4978,
    longitude: 153.0135,
    accuracy: 1
  },
  {
    postalCode: 4073,
    city: "Seventeen Mile Rocks",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5507,
    longitude: 152.959,
    accuracy: 4
  },
  {
    postalCode: 4073,
    city: "Sinnamon Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5444,
    longitude: 152.9489,
    accuracy: 4
  },
  {
    postalCode: 4074,
    city: "Sumner",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5655,
    longitude: 152.9334,
    accuracy: 4
  },
  {
    postalCode: 4074,
    city: "Riverhills",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5593,
    longitude: 152.9111,
    accuracy: 4
  },
  {
    postalCode: 4074,
    city: "Mount Ommaney",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5354,
    longitude: 152.9382,
    accuracy: 4
  },
  {
    postalCode: 4074,
    city: "Jindalee",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5345,
    longitude: 152.9384,
    accuracy: 4
  },
  {
    postalCode: 4074,
    city: "Westlake",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5486,
    longitude: 152.9128,
    accuracy: 4
  },
  {
    postalCode: 4074,
    city: "Jamboree Heights",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5563,
    longitude: 152.934,
    accuracy: 4
  },
  {
    postalCode: 4074,
    city: "Sumner Park Bc",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5608,
    longitude: 152.9429,
    accuracy: 3
  },
  {
    postalCode: 4074,
    city: "Middle Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.556,
    longitude: 152.9222,
    accuracy: 4
  },
  {
    postalCode: 4075,
    city: "Sherwood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5247,
    longitude: 152.9807,
    accuracy: 4
  },
  {
    postalCode: 4075,
    city: "Graceville East",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5473,
    longitude: 152.9791,
    accuracy: 3
  },
  {
    postalCode: 4075,
    city: "Corinda",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5333,
    longitude: 152.9833,
    accuracy: 4
  },
  {
    postalCode: 4075,
    city: "Graceville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.522,
    longitude: 152.9822,
    accuracy: 4
  },
  {
    postalCode: 4075,
    city: "Oxley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.55,
    longitude: 152.9833,
    accuracy: 4
  },
  {
    postalCode: 4076,
    city: "Darra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5667,
    longitude: 152.9667,
    accuracy: 4
  },
  {
    postalCode: 4076,
    city: "Wacol",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5833,
    longitude: 152.9333,
    accuracy: 4
  },
  {
    postalCode: 4077,
    city: "Inala Heights",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6,
    longitude: 152.9819,
    accuracy: 3
  },
  {
    postalCode: 4077,
    city: "Richlands",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5962,
    longitude: 152.9532,
    accuracy: 4
  },
  {
    postalCode: 4077,
    city: "Durack",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5895,
    longitude: 152.9858,
    accuracy: 4
  },
  {
    postalCode: 4077,
    city: "Inala East",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6,
    longitude: 152.9819,
    accuracy: 3
  },
  {
    postalCode: 4077,
    city: "Doolandella",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6133,
    longitude: 152.9855,
    accuracy: 4
  },
  {
    postalCode: 4077,
    city: "Inala",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5972,
    longitude: 152.9743,
    accuracy: 4
  },
  {
    postalCode: 4078,
    city: "Ellen Grove",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6153,
    longitude: 152.9439,
    accuracy: 4
  },
  {
    postalCode: 4078,
    city: "Forest Lake",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6256,
    longitude: 152.9688,
    accuracy: 4
  },
  {
    postalCode: 4101,
    city: "South Brisbane",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4803,
    longitude: 153.0205,
    accuracy: 4
  },
  {
    postalCode: 4101,
    city: "West End",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4833,
    longitude: 153,
    accuracy: 4
  },
  {
    postalCode: 4101,
    city: "Highgate Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4891,
    longitude: 153.0188,
    accuracy: 4
  },
  {
    postalCode: 4101,
    city: "South Brisbane BC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4839,
    longitude: 153.015,
    accuracy: 3
  },
  {
    postalCode: 4102,
    city: "Woolloongabba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4886,
    longitude: 153.0365,
    accuracy: 4
  },
  {
    postalCode: 4102,
    city: "Dutton Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4966,
    longitude: 153.028,
    accuracy: 4
  },
  {
    postalCode: 4102,
    city: "Buranda",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5202,
    longitude: 153.0278,
    accuracy: 3
  },
  {
    postalCode: 4103,
    city: "Fairfield Gardens",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5094,
    longitude: 153.0286,
    accuracy: 3
  },
  {
    postalCode: 4103,
    city: "Fairfield",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5064,
    longitude: 153.0248,
    accuracy: 4
  },
  {
    postalCode: 4103,
    city: "Annerley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5123,
    longitude: 153.0325,
    accuracy: 4
  },
  {
    postalCode: 4104,
    city: "Yeronga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5157,
    longitude: 153.0164,
    accuracy: 4
  },
  {
    postalCode: 4105,
    city: "Tennyson",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5333,
    longitude: 153.0167,
    accuracy: 4
  },
  {
    postalCode: 4105,
    city: "Moorooka",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5344,
    longitude: 153.0246,
    accuracy: 4
  },
  {
    postalCode: 4105,
    city: "Yeerongpilly",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5215,
    longitude: 153.0123,
    accuracy: 4
  },
  {
    postalCode: 4106,
    city: "Brisbane Market",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.547,
    longitude: 153.0022,
    accuracy: 3
  },
  {
    postalCode: 4106,
    city: "Rocklea",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5392,
    longitude: 153.004,
    accuracy: 4
  },
  {
    postalCode: 4106,
    city: "Rocklea Dc",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.547,
    longitude: 153.0022,
    accuracy: 3
  },
  {
    postalCode: 4107,
    city: "Salisbury",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5514,
    longitude: 153.0325,
    accuracy: 4
  },
  {
    postalCode: 4107,
    city: "Salisbury East",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5514,
    longitude: 153.0325,
    accuracy: 3
  },
  {
    postalCode: 4108,
    city: "Archerfield BC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5202,
    longitude: 153.0278,
    accuracy: 3
  },
  {
    postalCode: 4108,
    city: "Archerfield",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5671,
    longitude: 153.0145,
    accuracy: 4
  },
  {
    postalCode: 4108,
    city: "Coopers Plains",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5646,
    longitude: 153.0407,
    accuracy: 4
  },
  {
    postalCode: 4109,
    city: "Macgregor",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5649,
    longitude: 153.0665,
    accuracy: 4
  },
  {
    postalCode: 4109,
    city: "Robertson",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5658,
    longitude: 153.0574,
    accuracy: 4
  },
  {
    postalCode: 4109,
    city: "Sunnybank",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5833,
    longitude: 153.05,
    accuracy: 4
  },
  {
    postalCode: 4109,
    city: "Sunnybank Hills",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6103,
    longitude: 153.0539,
    accuracy: 4
  },
  {
    postalCode: 4109,
    city: "Sunnybank South",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5741,
    longitude: 153.0583,
    accuracy: 3
  },
  {
    postalCode: 4110,
    city: "Willawong",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5972,
    longitude: 153.0074,
    accuracy: 4
  },
  {
    postalCode: 4110,
    city: "Larapinta",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6426,
    longitude: 153.0052,
    accuracy: 4
  },
  {
    postalCode: 4110,
    city: "Heathwood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6362,
    longitude: 152.9843,
    accuracy: 4
  },
  {
    postalCode: 4110,
    city: "Acacia Ridge Dc",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6116,
    longitude: 153.0092,
    accuracy: 3
  },
  {
    postalCode: 4110,
    city: "Acacia Ridge",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5833,
    longitude: 153.0333,
    accuracy: 4
  },
  {
    postalCode: 4110,
    city: "Heathwood Df",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.616,
    longitude: 153.0072,
    accuracy: 3
  },
  {
    postalCode: 4110,
    city: "Pallara",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6208,
    longitude: 153.0058,
    accuracy: 4
  },
  {
    postalCode: 4111,
    city: "Nathan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5589,
    longitude: 153.0623,
    accuracy: 4
  },
  {
    postalCode: 4112,
    city: "Kuraby",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6068,
    longitude: 153.0937,
    accuracy: 4
  },
  {
    postalCode: 4113,
    city: "Eight Mile Plains",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5833,
    longitude: 153.1,
    accuracy: 4
  },
  {
    postalCode: 4113,
    city: "Runcorn",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5976,
    longitude: 153.077,
    accuracy: 4
  },
  {
    postalCode: 4114,
    city: "Logan City Dc",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6463,
    longitude: 153.1111,
    accuracy: 3
  },
  {
    postalCode: 4114,
    city: "Kingston",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6667,
    longitude: 153.1167,
    accuracy: 4
  },
  {
    postalCode: 4114,
    city: "Woodridge",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6333,
    longitude: 153.1,
    accuracy: 4
  },
  {
    postalCode: 4114,
    city: "Logan Central",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6438,
    longitude: 153.1073,
    accuracy: 4
  },
  {
    postalCode: 4115,
    city: "Algester",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6128,
    longitude: 153.0324,
    accuracy: 4
  },
  {
    postalCode: 4115,
    city: "Parkinson",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6434,
    longitude: 153.0298,
    accuracy: 4
  },
  {
    postalCode: 4116,
    city: "Stretton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6221,
    longitude: 153.0661,
    accuracy: 4
  },
  {
    postalCode: 4116,
    city: "Calamvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6233,
    longitude: 153.0479,
    accuracy: 4
  },
  {
    postalCode: 4116,
    city: "Drewvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6477,
    longitude: 153.0546,
    accuracy: 4
  },
  {
    postalCode: 4117,
    city: "Berrinba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6585,
    longitude: 153.0789,
    accuracy: 4
  },
  {
    postalCode: 4117,
    city: "Karawatha",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6199,
    longitude: 153.091,
    accuracy: 4
  },
  {
    postalCode: 4118,
    city: "Forestdale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6633,
    longitude: 153.0038,
    accuracy: 4
  },
  {
    postalCode: 4118,
    city: "Browns Plains",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.65,
    longitude: 153.0333,
    accuracy: 4
  },
  {
    postalCode: 4118,
    city: "Regents Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6766,
    longitude: 153.0417,
    accuracy: 4
  },
  {
    postalCode: 4118,
    city: "Heritage Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6827,
    longitude: 153.0608,
    accuracy: 4
  },
  {
    postalCode: 4118,
    city: "Hillcrest",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6686,
    longitude: 153.0261,
    accuracy: 4
  },
  {
    postalCode: 4119,
    city: "Underwood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6089,
    longitude: 153.1113,
    accuracy: 4
  },
  {
    postalCode: 4120,
    city: "Greenslopes",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5082,
    longitude: 153.0495,
    accuracy: 4
  },
  {
    postalCode: 4120,
    city: "Stones Corner",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5071,
    longitude: 153.0477,
    accuracy: 3
  },
  {
    postalCode: 4121,
    city: "Holland Park West",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5262,
    longitude: 153.0605,
    accuracy: 4
  },
  {
    postalCode: 4121,
    city: "Holland Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5262,
    longitude: 153.0605,
    accuracy: 4
  },
  {
    postalCode: 4121,
    city: "Tarragindi",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5333,
    longitude: 153.0333,
    accuracy: 4
  },
  {
    postalCode: 4121,
    city: "Holland Park East",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5298,
    longitude: 153.0511,
    accuracy: 3
  },
  {
    postalCode: 4121,
    city: "Wellers Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5333,
    longitude: 153.05,
    accuracy: 4
  },
  {
    postalCode: 4122,
    city: "Upper Mount Gravatt",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5613,
    longitude: 153.0845,
    accuracy: 4
  },
  {
    postalCode: 4122,
    city: "Mansfield DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5439,
    longitude: 153.0922,
    accuracy: 3
  },
  {
    postalCode: 4122,
    city: "Mansfield",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5393,
    longitude: 153.099,
    accuracy: 4
  },
  {
    postalCode: 4122,
    city: "Mount Gravatt",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5333,
    longitude: 153.0833,
    accuracy: 4
  },
  {
    postalCode: 4122,
    city: "Wishart",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5545,
    longitude: 153.1011,
    accuracy: 4
  },
  {
    postalCode: 4122,
    city: "Upper Mount Gravatt BC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5439,
    longitude: 153.0922,
    accuracy: 3
  },
  {
    postalCode: 4122,
    city: "Mount Gravatt East",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5405,
    longitude: 153.0822,
    accuracy: 4
  },
  {
    postalCode: 4122,
    city: "Mansfield BC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5439,
    longitude: 153.0922,
    accuracy: 3
  },
  {
    postalCode: 4123,
    city: "Rochedale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5667,
    longitude: 153.1333,
    accuracy: 4
  },
  {
    postalCode: 4123,
    city: "Rochedale South",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5952,
    longitude: 153.1233,
    accuracy: 4
  },
  {
    postalCode: 4124,
    city: "New Beith",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7936,
    longitude: 152.8844,
    accuracy: 4
  },
  {
    postalCode: 4124,
    city: "Lyons",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7335,
    longitude: 152.8523,
    accuracy: 4
  },
  {
    postalCode: 4124,
    city: "Greenbank",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7167,
    longitude: 152.9833,
    accuracy: 4
  },
  {
    postalCode: 4124,
    city: "Boronia Heights",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6885,
    longitude: 153.0196,
    accuracy: 4
  },
  {
    postalCode: 4124,
    city: "Spring Mountain",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6892,
    longitude: 152.8954,
    accuracy: 4
  },
  {
    postalCode: 4125,
    city: "Park Ridge South",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7271,
    longitude: 153.0332,
    accuracy: 4
  },
  {
    postalCode: 4125,
    city: "Munruben",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7463,
    longitude: 153.0312,
    accuracy: 4
  },
  {
    postalCode: 4125,
    city: "Park Ridge",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7167,
    longitude: 153.0333,
    accuracy: 4
  },
  {
    postalCode: 4127,
    city: "Springwood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6118,
    longitude: 153.129,
    accuracy: 4
  },
  {
    postalCode: 4127,
    city: "Daisy Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6303,
    longitude: 153.1578,
    accuracy: 4
  },
  {
    postalCode: 4127,
    city: "Slacks Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.65,
    longitude: 153.15,
    accuracy: 4
  },
  {
    postalCode: 4127,
    city: "Priestdale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6,
    longitude: 153.1333,
    accuracy: 4
  },
  {
    postalCode: 4128,
    city: "Shailer Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6498,
    longitude: 153.1775,
    accuracy: 4
  },
  {
    postalCode: 4128,
    city: "Tanah Merah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6715,
    longitude: 153.1702,
    accuracy: 4
  },
  {
    postalCode: 4129,
    city: "Loganholme",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7,
    longitude: 153.2,
    accuracy: 4
  },
  {
    postalCode: 4129,
    city: "Loganholme DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7,
    longitude: 153.2,
    accuracy: 3
  },
  {
    postalCode: 4129,
    city: "Loganholme BC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7,
    longitude: 153.2,
    accuracy: 3
  },
  {
    postalCode: 4130,
    city: "Cornubia",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6667,
    longitude: 153.2167,
    accuracy: 4
  },
  {
    postalCode: 4130,
    city: "Carbrook",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6833,
    longitude: 153.25,
    accuracy: 4
  },
  {
    postalCode: 4131,
    city: "Loganlea",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6667,
    longitude: 153.1333,
    accuracy: 4
  },
  {
    postalCode: 4131,
    city: "Meadowbrook",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.664,
    longitude: 153.1447,
    accuracy: 4
  },
  {
    postalCode: 4132,
    city: "Marsden",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6734,
    longitude: 153.0973,
    accuracy: 4
  },
  {
    postalCode: 4132,
    city: "Crestmead",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6876,
    longitude: 153.0844,
    accuracy: 4
  },
  {
    postalCode: 4133,
    city: "Waterford West",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6906,
    longitude: 153.1332,
    accuracy: 4
  },
  {
    postalCode: 4133,
    city: "Waterford",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7,
    longitude: 153.15,
    accuracy: 4
  },
  {
    postalCode: 4133,
    city: "Chambers Flat",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7481,
    longitude: 153.0776,
    accuracy: 4
  },
  {
    postalCode: 4133,
    city: "Logan Reserve",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7241,
    longitude: 153.09,
    accuracy: 4
  },
  {
    postalCode: 4151,
    city: "Coorparoo DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4932,
    longitude: 153.0583,
    accuracy: 3
  },
  {
    postalCode: 4151,
    city: "Coorparoo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4932,
    longitude: 153.0583,
    accuracy: 4
  },
  {
    postalCode: 4152,
    city: "Carindale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5058,
    longitude: 153.1024,
    accuracy: 4
  },
  {
    postalCode: 4152,
    city: "Carina",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5072,
    longitude: 153.0913,
    accuracy: 4
  },
  {
    postalCode: 4152,
    city: "Carina Heights",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5072,
    longitude: 153.0913,
    accuracy: 4
  },
  {
    postalCode: 4152,
    city: "Camp Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4935,
    longitude: 153.0763,
    accuracy: 4
  },
  {
    postalCode: 4153,
    city: "Belmont",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5,
    longitude: 153.1167,
    accuracy: 4
  },
  {
    postalCode: 4154,
    city: "Ransome",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4881,
    longitude: 153.1793,
    accuracy: 4
  },
  {
    postalCode: 4154,
    city: "Wakerley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.483,
    longitude: 153.1559,
    accuracy: 4
  },
  {
    postalCode: 4154,
    city: "Gumdale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4919,
    longitude: 153.1532,
    accuracy: 4
  },
  {
    postalCode: 4155,
    city: "Chandler",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.514,
    longitude: 153.1491,
    accuracy: 4
  },
  {
    postalCode: 4156,
    city: "Mackenzie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5435,
    longitude: 153.1206,
    accuracy: 4
  },
  {
    postalCode: 4156,
    city: "Burbank",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5558,
    longitude: 153.147,
    accuracy: 4
  },
  {
    postalCode: 4157,
    city: "Sheldon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5844,
    longitude: 153.2004,
    accuracy: 4
  },
  {
    postalCode: 4157,
    city: "Capalaba West",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.56,
    longitude: 153.1993,
    accuracy: 3
  },
  {
    postalCode: 4157,
    city: "Capalaba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5167,
    longitude: 153.1833,
    accuracy: 4
  },
  {
    postalCode: 4157,
    city: "Capalaba DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5505,
    longitude: 153.1919,
    accuracy: 3
  },
  {
    postalCode: 4157,
    city: "Capalaba BC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5505,
    longitude: 153.1919,
    accuracy: 3
  },
  {
    postalCode: 4158,
    city: "Thorneside",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4878,
    longitude: 153.1982,
    accuracy: 4
  },
  {
    postalCode: 4159,
    city: "Birkdale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4833,
    longitude: 153.2167,
    accuracy: 4
  },
  {
    postalCode: 4160,
    city: "Wellington Point",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4833,
    longitude: 153.25,
    accuracy: 4
  },
  {
    postalCode: 4160,
    city: "Ormiston",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5167,
    longitude: 153.25,
    accuracy: 4
  },
  {
    postalCode: 4161,
    city: "Alexandra Hills",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5322,
    longitude: 153.2289,
    accuracy: 4
  },
  {
    postalCode: 4163,
    city: "Cleveland",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5268,
    longitude: 153.2652,
    accuracy: 4
  },
  {
    postalCode: 4163,
    city: "Cleveland DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5333,
    longitude: 153.2667,
    accuracy: 3
  },
  {
    postalCode: 4164,
    city: "Thornlands",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5575,
    longitude: 153.2648,
    accuracy: 4
  },
  {
    postalCode: 4165,
    city: "Mount Cotton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6333,
    longitude: 153.2333,
    accuracy: 4
  },
  {
    postalCode: 4165,
    city: "Redland Bay",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6113,
    longitude: 153.3002,
    accuracy: 4
  },
  {
    postalCode: 4165,
    city: "Victoria Point West",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.61,
    longitude: 153.2825,
    accuracy: 3
  },
  {
    postalCode: 4165,
    city: "Victoria Point",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5833,
    longitude: 153.3117,
    accuracy: 4
  },
  {
    postalCode: 4169,
    city: "East Brisbane",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.481,
    longitude: 153.044,
    accuracy: 4
  },
  {
    postalCode: 4169,
    city: "Kangaroo Point",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4768,
    longitude: 153.0367,
    accuracy: 4
  },
  {
    postalCode: 4170,
    city: "Norman Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4792,
    longitude: 153.0625,
    accuracy: 4
  },
  {
    postalCode: 4170,
    city: "Seven Hills",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4834,
    longitude: 153.0747,
    accuracy: 4
  },
  {
    postalCode: 4170,
    city: "Cannon Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4724,
    longitude: 153.0947,
    accuracy: 4
  },
  {
    postalCode: 4170,
    city: "Morningside",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4673,
    longitude: 153.0732,
    accuracy: 4
  },
  {
    postalCode: 4171,
    city: "Balmoral",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4595,
    longitude: 153.0638,
    accuracy: 4
  },
  {
    postalCode: 4171,
    city: "Bulimba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.45,
    longitude: 153.0667,
    accuracy: 4
  },
  {
    postalCode: 4171,
    city: "Hawthorne",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4633,
    longitude: 153.0595,
    accuracy: 4
  },
  {
    postalCode: 4172,
    city: "Murarrie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4629,
    longitude: 153.0981,
    accuracy: 4
  },
  {
    postalCode: 4173,
    city: "Tingalpa",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4736,
    longitude: 153.127,
    accuracy: 4
  },
  {
    postalCode: 4173,
    city: "Tingalpa Bc",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4594,
    longitude: 153.1211,
    accuracy: 3
  },
  {
    postalCode: 4173,
    city: "Tingalpa Dc",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4594,
    longitude: 153.1211,
    accuracy: 3
  },
  {
    postalCode: 4174,
    city: "Hemmant",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4478,
    longitude: 153.1317,
    accuracy: 4
  },
  {
    postalCode: 4178,
    city: "Wynnum North",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4191,
    longitude: 153.1677,
    accuracy: 3
  },
  {
    postalCode: 4178,
    city: "Wynnum Plaza",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4333,
    longitude: 153.1667,
    accuracy: 3
  },
  {
    postalCode: 4178,
    city: "Wynnum",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4453,
    longitude: 153.1581,
    accuracy: 4
  },
  {
    postalCode: 4178,
    city: "Port Of Brisbane",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3903,
    longitude: 153.1772,
    accuracy: 4
  },
  {
    postalCode: 4178,
    city: "Lytton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.423,
    longitude: 153.1511,
    accuracy: 4
  },
  {
    postalCode: 4178,
    city: "Wynnum West",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4582,
    longitude: 153.1532,
    accuracy: 4
  },
  {
    postalCode: 4179,
    city: "Lota",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4692,
    longitude: 153.1858,
    accuracy: 4
  },
  {
    postalCode: 4179,
    city: "Manly",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4667,
    longitude: 153.1833,
    accuracy: 4
  },
  {
    postalCode: 4179,
    city: "Manly West",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4738,
    longitude: 153.1664,
    accuracy: 4
  },
  {
    postalCode: 4183,
    city: "North Stradbroke Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4332,
    longitude: 153.4627,
    accuracy: 4
  },
  {
    postalCode: 4183,
    city: "Point Lookout",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4273,
    longitude: 153.5366,
    accuracy: 4
  },
  {
    postalCode: 4183,
    city: "Amity Point",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3982,
    longitude: 153.438,
    accuracy: 4
  },
  {
    postalCode: 4183,
    city: "Amity",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3982,
    longitude: 153.438,
    accuracy: 4
  },
  {
    postalCode: 4183,
    city: "Dunwich",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4984,
    longitude: 153.402,
    accuracy: 4
  },
  {
    postalCode: 4184,
    city: "Peel Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.651,
    longitude: 153.363,
    accuracy: 3
  },
  {
    postalCode: 4184,
    city: "Lamb Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6248,
    longitude: 153.3802,
    accuracy: 4
  },
  {
    postalCode: 4184,
    city: "Perulpa Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6019,
    longitude: 153.3569,
    accuracy: 3
  },
  {
    postalCode: 4184,
    city: "Macleay Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6109,
    longitude: 153.36,
    accuracy: 4
  },
  {
    postalCode: 4184,
    city: "Karragarra Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6368,
    longitude: 153.3681,
    accuracy: 4
  },
  {
    postalCode: 4184,
    city: "Coochiemudlo Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5736,
    longitude: 153.3302,
    accuracy: 4
  },
  {
    postalCode: 4184,
    city: "Russell Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6487,
    longitude: 153.3812,
    accuracy: 4
  },
  {
    postalCode: 4205,
    city: "Bethania",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6833,
    longitude: 153.1667,
    accuracy: 4
  },
  {
    postalCode: 4207,
    city: "Cedar Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8618,
    longitude: 153.1999,
    accuracy: 4
  },
  {
    postalCode: 4207,
    city: "Yarrabilba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8234,
    longitude: 153.0965,
    accuracy: 4
  },
  {
    postalCode: 4207,
    city: "Eagleby",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6833,
    longitude: 153.2167,
    accuracy: 4
  },
  {
    postalCode: 4207,
    city: "Alberton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7,
    longitude: 153.25,
    accuracy: 4
  },
  {
    postalCode: 4207,
    city: "Bahrs Scrub",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7333,
    longitude: 153.1667,
    accuracy: 4
  },
  {
    postalCode: 4207,
    city: "Buccan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.75,
    longitude: 153.1333,
    accuracy: 4
  },
  {
    postalCode: 4207,
    city: "Mount Warren Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7311,
    longitude: 153.2055,
    accuracy: 4
  },
  {
    postalCode: 4207,
    city: "Bannockburn",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7599,
    longitude: 153.1922,
    accuracy: 4
  },
  {
    postalCode: 4207,
    city: "Wolffdene",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7833,
    longitude: 153.1833,
    accuracy: 4
  },
  {
    postalCode: 4207,
    city: "Belivah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7582,
    longitude: 153.175,
    accuracy: 4
  },
  {
    postalCode: 4207,
    city: "Holmview",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7163,
    longitude: 153.1705,
    accuracy: 4
  },
  {
    postalCode: 4207,
    city: "Steiglitz",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.75,
    longitude: 153.35,
    accuracy: 4
  },
  {
    postalCode: 4207,
    city: "Logan Village",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7683,
    longitude: 153.1076,
    accuracy: 4
  },
  {
    postalCode: 4207,
    city: "Windaroo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7333,
    longitude: 153.2,
    accuracy: 4
  },
  {
    postalCode: 4207,
    city: "Yatala",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7167,
    longitude: 153.2167,
    accuracy: 4
  },
  {
    postalCode: 4207,
    city: "Woongoolba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.75,
    longitude: 153.3333,
    accuracy: 4
  },
  {
    postalCode: 4207,
    city: "Edens Landing",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7027,
    longitude: 153.1694,
    accuracy: 4
  },
  {
    postalCode: 4207,
    city: "Stapylton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7333,
    longitude: 153.2333,
    accuracy: 4
  },
  {
    postalCode: 4207,
    city: "Luscombe",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7755,
    longitude: 153.2064,
    accuracy: 4
  },
  {
    postalCode: 4207,
    city: "Yatala DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7079,
    longitude: 153.1842,
    accuracy: 3
  },
  {
    postalCode: 4207,
    city: "Beenleigh",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7114,
    longitude: 153.2029,
    accuracy: 4
  },
  {
    postalCode: 4208,
    city: "Ormeau Hills",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7965,
    longitude: 153.2567,
    accuracy: 4
  },
  {
    postalCode: 4208,
    city: "Norwell",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7833,
    longitude: 153.3167,
    accuracy: 4
  },
  {
    postalCode: 4208,
    city: "Gilberton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7333,
    longitude: 153.2833,
    accuracy: 4
  },
  {
    postalCode: 4208,
    city: "Ormeau",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7679,
    longitude: 153.2428,
    accuracy: 4
  },
  {
    postalCode: 4208,
    city: "Jacobs Well",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7799,
    longitude: 153.3615,
    accuracy: 4
  },
  {
    postalCode: 4208,
    city: "Kingsholme",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8254,
    longitude: 153.2335,
    accuracy: 4
  },
  {
    postalCode: 4209,
    city: "Willow Vale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.845,
    longitude: 153.2631,
    accuracy: 4
  },
  {
    postalCode: 4209,
    city: "Pimpama",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8167,
    longitude: 153.3,
    accuracy: 4
  },
  {
    postalCode: 4209,
    city: "Coomera",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8833,
    longitude: 153.3,
    accuracy: 4
  },
  {
    postalCode: 4209,
    city: "Upper Coomera",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9,
    longitude: 153.3,
    accuracy: 4
  },
  {
    postalCode: 4210,
    city: "Wongawallan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8755,
    longitude: 153.2287,
    accuracy: 4
  },
  {
    postalCode: 4210,
    city: "Studio Village",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9079,
    longitude: 153.2566,
    accuracy: 3
  },
  {
    postalCode: 4210,
    city: "Guanaba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9381,
    longitude: 153.2393,
    accuracy: 4
  },
  {
    postalCode: 4210,
    city: "Oxenford",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8903,
    longitude: 153.3131,
    accuracy: 4
  },
  {
    postalCode: 4210,
    city: "Maudsland",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.95,
    longitude: 153.2667,
    accuracy: 4
  },
  {
    postalCode: 4211,
    city: "Beechmont",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1214,
    longitude: 153.192,
    accuracy: 4
  },
  {
    postalCode: 4211,
    city: "Gaven",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9565,
    longitude: 153.3345,
    accuracy: 4
  },
  {
    postalCode: 4211,
    city: "Southern Lamington",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0195,
    longitude: 153.2946,
    accuracy: 3
  },
  {
    postalCode: 4211,
    city: "Highland Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0139,
    longitude: 153.3331,
    accuracy: 4
  },
  {
    postalCode: 4211,
    city: "Nerang",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9894,
    longitude: 153.3363,
    accuracy: 4
  },
  {
    postalCode: 4211,
    city: "Gilston",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0333,
    longitude: 153.3,
    accuracy: 4
  },
  {
    postalCode: 4211,
    city: "Clagiraba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9939,
    longitude: 153.2424,
    accuracy: 4
  },
  {
    postalCode: 4211,
    city: "Numinbah Valley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1417,
    longitude: 153.2231,
    accuracy: 4
  },
  {
    postalCode: 4211,
    city: "Nerang BC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0195,
    longitude: 153.2946,
    accuracy: 3
  },
  {
    postalCode: 4211,
    city: "Mount Nathan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9643,
    longitude: 153.272,
    accuracy: 4
  },
  {
    postalCode: 4211,
    city: "Binna Burra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0195,
    longitude: 153.2946,
    accuracy: 3
  },
  {
    postalCode: 4211,
    city: "Advancetown",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0667,
    longitude: 153.2667,
    accuracy: 4
  },
  {
    postalCode: 4211,
    city: "Natural Bridge",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.2212,
    longitude: 153.236,
    accuracy: 4
  },
  {
    postalCode: 4211,
    city: "Pacific Pines",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9399,
    longitude: 153.3144,
    accuracy: 4
  },
  {
    postalCode: 4211,
    city: "Lower Beechmont",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0475,
    longitude: 153.2457,
    accuracy: 4
  },
  {
    postalCode: 4211,
    city: "Nerang DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0195,
    longitude: 153.2946,
    accuracy: 3
  },
  {
    postalCode: 4211,
    city: "Carrara",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0215,
    longitude: 153.3664,
    accuracy: 4
  },
  {
    postalCode: 4212,
    city: "Helensvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9183,
    longitude: 153.3327,
    accuracy: 4
  },
  {
    postalCode: 4212,
    city: "Sanctuary Cove",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.86,
    longitude: 153.3719,
    accuracy: 4
  },
  {
    postalCode: 4212,
    city: "Helensvale Town Centre",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8875,
    longitude: 153.3463,
    accuracy: 3
  },
  {
    postalCode: 4212,
    city: "Hope Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8704,
    longitude: 153.3516,
    accuracy: 4
  },
  {
    postalCode: 4213,
    city: "Worongary",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.05,
    longitude: 153.35,
    accuracy: 4
  },
  {
    postalCode: 4213,
    city: "Austinville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1545,
    longitude: 153.3092,
    accuracy: 4
  },
  {
    postalCode: 4213,
    city: "Neranwood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1248,
    longitude: 153.2983,
    accuracy: 4
  },
  {
    postalCode: 4213,
    city: "Tallai",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0641,
    longitude: 153.3259,
    accuracy: 4
  },
  {
    postalCode: 4213,
    city: "Springbrook",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1917,
    longitude: 153.263,
    accuracy: 4
  },
  {
    postalCode: 4213,
    city: "Mudgeeraba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0833,
    longitude: 153.3667,
    accuracy: 4
  },
  {
    postalCode: 4213,
    city: "Bonogin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1393,
    longitude: 153.353,
    accuracy: 4
  },
  {
    postalCode: 4214,
    city: "Molendinar",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9741,
    longitude: 153.3607,
    accuracy: 4
  },
  {
    postalCode: 4214,
    city: "Ashmore City",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9638,
    longitude: 153.3658,
    accuracy: 3
  },
  {
    postalCode: 4214,
    city: "Parkwood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9546,
    longitude: 153.363,
    accuracy: 4
  },
  {
    postalCode: 4214,
    city: "Ashmore",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9888,
    longitude: 153.3765,
    accuracy: 4
  },
  {
    postalCode: 4214,
    city: "Arundel",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9377,
    longitude: 153.363,
    accuracy: 4
  },
  {
    postalCode: 4214,
    city: "Arundel Bc",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9631,
    longitude: 153.3656,
    accuracy: 3
  },
  {
    postalCode: 4214,
    city: "Arundel Dc",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9631,
    longitude: 153.3656,
    accuracy: 3
  },
  {
    postalCode: 4215,
    city: "Southport",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9672,
    longitude: 153.398,
    accuracy: 4
  },
  {
    postalCode: 4215,
    city: "Labrador",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.944,
    longitude: 153.3982,
    accuracy: 4
  },
  {
    postalCode: 4215,
    city: "Australia Fair",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9553,
    longitude: 153.3991,
    accuracy: 3
  },
  {
    postalCode: 4215,
    city: "Southport BC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9553,
    longitude: 153.3991,
    accuracy: 3
  },
  {
    postalCode: 4215,
    city: "Southport Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9553,
    longitude: 153.3991,
    accuracy: 3
  },
  {
    postalCode: 4215,
    city: "Chirn Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9553,
    longitude: 153.3991,
    accuracy: 3
  },
  {
    postalCode: 4216,
    city: "South Stradbroke",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8329,
    longitude: 153.4207,
    accuracy: 4
  },
  {
    postalCode: 4216,
    city: "Runaway Bay",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9139,
    longitude: 153.3977,
    accuracy: 4
  },
  {
    postalCode: 4216,
    city: "Paradise Point",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8866,
    longitude: 153.3933,
    accuracy: 4
  },
  {
    postalCode: 4216,
    city: "Biggera Waters",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9324,
    longitude: 153.4002,
    accuracy: 4
  },
  {
    postalCode: 4216,
    city: "Coombabah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9107,
    longitude: 153.3709,
    accuracy: 4
  },
  {
    postalCode: 4216,
    city: "Hollywell",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9008,
    longitude: 153.3961,
    accuracy: 4
  },
  {
    postalCode: 4217,
    city: "Main Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9788,
    longitude: 153.4266,
    accuracy: 4
  },
  {
    postalCode: 4217,
    city: "Surfers Paradise",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0027,
    longitude: 153.43,
    accuracy: 4
  },
  {
    postalCode: 4217,
    city: "Bundall",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0111,
    longitude: 153.4048,
    accuracy: 4
  },
  {
    postalCode: 4217,
    city: "Benowa",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0167,
    longitude: 153.4,
    accuracy: 4
  },
  {
    postalCode: 4217,
    city: "Isle Of Capri",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9996,
    longitude: 153.4093,
    accuracy: 3
  },
  {
    postalCode: 4217,
    city: "Bundall BC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0023,
    longitude: 153.4153,
    accuracy: 3
  },
  {
    postalCode: 4217,
    city: "Bundall DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0023,
    longitude: 153.4153,
    accuracy: 3
  },
  {
    postalCode: 4217,
    city: "Gold Coast Mc",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0023,
    longitude: 153.4153,
    accuracy: 3
  },
  {
    postalCode: 4217,
    city: "Chevron Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9996,
    longitude: 153.4093,
    accuracy: 3
  },
  {
    postalCode: 4218,
    city: "Broadbeach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0278,
    longitude: 153.4334,
    accuracy: 4
  },
  {
    postalCode: 4218,
    city: "Mermaid Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0441,
    longitude: 153.4347,
    accuracy: 4
  },
  {
    postalCode: 4218,
    city: "Mermaid Waters",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0491,
    longitude: 153.4308,
    accuracy: 4
  },
  {
    postalCode: 4218,
    city: "Broadbeach Waters",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.035,
    longitude: 153.425,
    accuracy: 4
  },
  {
    postalCode: 4218,
    city: "Nobby Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0396,
    longitude: 153.4217,
    accuracy: 3
  },
  {
    postalCode: 4218,
    city: "Q Supercentre",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0396,
    longitude: 153.4217,
    accuracy: 3
  },
  {
    postalCode: 4218,
    city: "Pacific Fair",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0396,
    longitude: 153.4217,
    accuracy: 3
  },
  {
    postalCode: 4219,
    city: "West Burleigh",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1167,
    longitude: 153.4333,
    accuracy: 4
  },
  {
    postalCode: 4220,
    city: "Miami",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0717,
    longitude: 153.4416,
    accuracy: 4
  },
  {
    postalCode: 4220,
    city: "Burleigh Town",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0895,
    longitude: 153.4341,
    accuracy: 3
  },
  {
    postalCode: 4220,
    city: "Burleigh Heads",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1,
    longitude: 153.45,
    accuracy: 4
  },
  {
    postalCode: 4220,
    city: "Burleigh Waters",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0998,
    longitude: 153.4246,
    accuracy: 4
  },
  {
    postalCode: 4220,
    city: "Burleigh DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0859,
    longitude: 153.4458,
    accuracy: 3
  },
  {
    postalCode: 4221,
    city: "Elanora",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1358,
    longitude: 153.4493,
    accuracy: 4
  },
  {
    postalCode: 4221,
    city: "Palm Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1169,
    longitude: 153.4658,
    accuracy: 4
  },
  {
    postalCode: 4222,
    city: "Griffith University",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1235,
    longitude: 153.4442,
    accuracy: 1
  },
  {
    postalCode: 4223,
    city: "Currumbin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1407,
    longitude: 153.45,
    accuracy: 4
  },
  {
    postalCode: 4223,
    city: "Currumbin Waters",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1544,
    longitude: 153.4728,
    accuracy: 4
  },
  {
    postalCode: 4223,
    city: "Currumbin Dc",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1947,
    longitude: 153.4129,
    accuracy: 3
  },
  {
    postalCode: 4223,
    city: "Currumbin Valley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.2081,
    longitude: 153.3942,
    accuracy: 4
  },
  {
    postalCode: 4224,
    city: "Tugun",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.15,
    longitude: 153.5,
    accuracy: 4
  },
  {
    postalCode: 4225,
    city: "Coolangatta",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1694,
    longitude: 153.5347,
    accuracy: 4
  },
  {
    postalCode: 4225,
    city: "Bilinga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1667,
    longitude: 153.5167,
    accuracy: 4
  },
  {
    postalCode: 4226,
    city: "Robina",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0707,
    longitude: 153.3933,
    accuracy: 4
  },
  {
    postalCode: 4226,
    city: "Clear Island Waters",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0531,
    longitude: 153.3981,
    accuracy: 4
  },
  {
    postalCode: 4226,
    city: "Robina DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0642,
    longitude: 153.3794,
    accuracy: 3
  },
  {
    postalCode: 4226,
    city: "Merrimac",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0509,
    longitude: 153.3731,
    accuracy: 4
  },
  {
    postalCode: 4227,
    city: "Reedy Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1124,
    longitude: 153.3964,
    accuracy: 4
  },
  {
    postalCode: 4227,
    city: "Varsity Lakes",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0894,
    longitude: 153.4122,
    accuracy: 4
  },
  {
    postalCode: 4228,
    city: "Tallebudgera",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.15,
    longitude: 153.4333,
    accuracy: 4
  },
  {
    postalCode: 4228,
    city: "Tallebudgera Valley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1927,
    longitude: 153.3549,
    accuracy: 4
  },
  {
    postalCode: 4229,
    city: "Bond University",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0779,
    longitude: 153.4123,
    accuracy: 1
  },
  {
    postalCode: 4230,
    city: "Robina Town Centre",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0757,
    longitude: 153.3842,
    accuracy: 1
  },
  {
    postalCode: 4270,
    city: "Tamborine",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8833,
    longitude: 153.1333,
    accuracy: 4
  },
  {
    postalCode: 4271,
    city: "Eagle Heights",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9193,
    longitude: 153.1994,
    accuracy: 4
  },
  {
    postalCode: 4272,
    city: "Mount Tamborine",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9695,
    longitude: 153.1994,
    accuracy: 4
  },
  {
    postalCode: 4272,
    city: "Tamborine Mountain",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9695,
    longitude: 153.1994,
    accuracy: 4
  },
  {
    postalCode: 4272,
    city: "North Tamborine",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9276,
    longitude: 153.1848,
    accuracy: 4
  },
  {
    postalCode: 4275,
    city: "Sarabah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9973,
    longitude: 153.1642,
    accuracy: 3
  },
  {
    postalCode: 4275,
    city: "Witheren",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0392,
    longitude: 153.1916,
    accuracy: 4
  },
  {
    postalCode: 4275,
    city: "Boyland",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.95,
    longitude: 153.1333,
    accuracy: 4
  },
  {
    postalCode: 4275,
    city: "Benobble",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9833,
    longitude: 153.1667,
    accuracy: 4
  },
  {
    postalCode: 4275,
    city: "Wonglepong",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9618,
    longitude: 153.1749,
    accuracy: 3
  },
  {
    postalCode: 4275,
    city: "Canungra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0169,
    longitude: 153.1653,
    accuracy: 4
  },
  {
    postalCode: 4275,
    city: "Lamington National Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1139,
    longitude: 153.134,
    accuracy: 3
  },
  {
    postalCode: 4275,
    city: "Ferny Glen",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9973,
    longitude: 153.1642,
    accuracy: 3
  },
  {
    postalCode: 4275,
    city: "Flying Fox",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9973,
    longitude: 153.1642,
    accuracy: 3
  },
  {
    postalCode: 4275,
    city: "Illinbah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9973,
    longitude: 153.1642,
    accuracy: 3
  },
  {
    postalCode: 4275,
    city: "Biddaddaba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9973,
    longitude: 153.1642,
    accuracy: 3
  },
  {
    postalCode: 4280,
    city: "Jimboomba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8312,
    longitude: 153.0274,
    accuracy: 4
  },
  {
    postalCode: 4280,
    city: "South Maclean",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7924,
    longitude: 153.016,
    accuracy: 4
  },
  {
    postalCode: 4280,
    city: "North Maclean",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7676,
    longitude: 153.0165,
    accuracy: 4
  },
  {
    postalCode: 4280,
    city: "Stockleigh",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7667,
    longitude: 153.0667,
    accuracy: 4
  },
  {
    postalCode: 4285,
    city: "Veresdale Scrub",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8916,
    longitude: 152.9977,
    accuracy: 4
  },
  {
    postalCode: 4285,
    city: "Darlington",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.239,
    longitude: 153.067,
    accuracy: 4
  },
  {
    postalCode: 4285,
    city: "Beaudesert",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9869,
    longitude: 152.9966,
    accuracy: 4
  },
  {
    postalCode: 4285,
    city: "Veresdale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9167,
    longitude: 152.9833,
    accuracy: 4
  },
  {
    postalCode: 4285,
    city: "Birnam",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4833,
    longitude: 151.9167,
    accuracy: 4
  },
  {
    postalCode: 4285,
    city: "Kerry",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1,
    longitude: 153.0167,
    accuracy: 4
  },
  {
    postalCode: 4285,
    city: "Lamington",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.245,
    longitude: 152.9933,
    accuracy: 4
  },
  {
    postalCode: 4285,
    city: "Laravale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0833,
    longitude: 152.9333,
    accuracy: 4
  },
  {
    postalCode: 4285,
    city: "Cedar Vale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8892,
    longitude: 153.0289,
    accuracy: 4
  },
  {
    postalCode: 4285,
    city: "Oaky Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0067,
    longitude: 152.9125,
    accuracy: 3
  },
  {
    postalCode: 4285,
    city: "Tabooba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1333,
    longitude: 152.95,
    accuracy: 4
  },
  {
    postalCode: 4285,
    city: "Mount Gipps",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0067,
    longitude: 152.9125,
    accuracy: 3
  },
  {
    postalCode: 4285,
    city: "Kagaru",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8657,
    longitude: 152.9238,
    accuracy: 4
  },
  {
    postalCode: 4285,
    city: "Bromelton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9833,
    longitude: 152.9333,
    accuracy: 4
  },
  {
    postalCode: 4285,
    city: "Josephville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0305,
    longitude: 152.9438,
    accuracy: 4
  },
  {
    postalCode: 4285,
    city: "Kooralbyn",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0796,
    longitude: 152.8397,
    accuracy: 4
  },
  {
    postalCode: 4285,
    city: "Tamrookum",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1242,
    longitude: 152.9159,
    accuracy: 4
  },
  {
    postalCode: 4285,
    city: "Cryna",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0067,
    longitude: 152.9125,
    accuracy: 3
  },
  {
    postalCode: 4285,
    city: "Hillview",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.2137,
    longitude: 153.0123,
    accuracy: 4
  },
  {
    postalCode: 4285,
    city: "Chinghee Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0067,
    longitude: 152.9125,
    accuracy: 3
  },
  {
    postalCode: 4285,
    city: "Cedar Grove",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8667,
    longitude: 152.9833,
    accuracy: 4
  },
  {
    postalCode: 4285,
    city: "Allenview",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0067,
    longitude: 152.9125,
    accuracy: 3
  },
  {
    postalCode: 4285,
    city: "Mundoolun",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8994,
    longitude: 153.0715,
    accuracy: 4
  },
  {
    postalCode: 4285,
    city: "Christmas Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0067,
    longitude: 152.9125,
    accuracy: 3
  },
  {
    postalCode: 4285,
    city: "Cainbable",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0067,
    longitude: 152.9125,
    accuracy: 3
  },
  {
    postalCode: 4285,
    city: "Nindooinbah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0067,
    longitude: 152.9125,
    accuracy: 3
  },
  {
    postalCode: 4285,
    city: "Woodhill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9,
    longitude: 152.9667,
    accuracy: 4
  },
  {
    postalCode: 4285,
    city: "Knapp Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0067,
    longitude: 152.9125,
    accuracy: 3
  },
  {
    postalCode: 4285,
    city: "Tamrookum Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0067,
    longitude: 152.9125,
    accuracy: 3
  },
  {
    postalCode: 4285,
    city: "Tabragalba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0067,
    longitude: 152.9125,
    accuracy: 3
  },
  {
    postalCode: 4285,
    city: "Innisplain",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1667,
    longitude: 152.9,
    accuracy: 4
  },
  {
    postalCode: 4285,
    city: "Gleneagle",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9333,
    longitude: 152.9833,
    accuracy: 4
  },
  {
    postalCode: 4285,
    city: "Undullah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8088,
    longitude: 152.9491,
    accuracy: 4
  },
  {
    postalCode: 4287,
    city: "Rathdowney",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.2108,
    longitude: 152.8641,
    accuracy: 4
  },
  {
    postalCode: 4287,
    city: "Barney View",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.2333,
    longitude: 152.7833,
    accuracy: 4
  },
  {
    postalCode: 4287,
    city: "Running Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -14.3097,
    longitude: 143.7279,
    accuracy: 3
  },
  {
    postalCode: 4287,
    city: "Mount Barney",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.2369,
    longitude: 152.8158,
    accuracy: 3
  },
  {
    postalCode: 4287,
    city: "Palen Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.2667,
    longitude: 152.8,
    accuracy: 4
  },
  {
    postalCode: 4287,
    city: "Mount Lindesay",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.2369,
    longitude: 152.8158,
    accuracy: 3
  },
  {
    postalCode: 4300,
    city: "Gailes",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6113,
    longitude: 152.9132,
    accuracy: 4
  },
  {
    postalCode: 4300,
    city: "Springfield Lakes",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6676,
    longitude: 152.9249,
    accuracy: 4
  },
  {
    postalCode: 4300,
    city: "Goodna",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6105,
    longitude: 152.899,
    accuracy: 4
  },
  {
    postalCode: 4300,
    city: "Springfield Central",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6805,
    longitude: 152.9042,
    accuracy: 4
  },
  {
    postalCode: 4300,
    city: "Camira",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6346,
    longitude: 152.9209,
    accuracy: 4
  },
  {
    postalCode: 4300,
    city: "Bellbird Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6367,
    longitude: 152.8866,
    accuracy: 4
  },
  {
    postalCode: 4300,
    city: "Springfield",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6536,
    longitude: 152.9172,
    accuracy: 4
  },
  {
    postalCode: 4300,
    city: "Augustine Heights",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6605,
    longitude: 152.879,
    accuracy: 4
  },
  {
    postalCode: 4300,
    city: "Carole Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6172,
    longitude: 152.9316,
    accuracy: 4
  },
  {
    postalCode: 4300,
    city: "Brookwater",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6613,
    longitude: 152.8967,
    accuracy: 4
  },
  {
    postalCode: 4301,
    city: "Redbank Plains",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6461,
    longitude: 152.8596,
    accuracy: 4
  },
  {
    postalCode: 4301,
    city: "Collingwood Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6128,
    longitude: 152.8601,
    accuracy: 4
  },
  {
    postalCode: 4301,
    city: "Redbank",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6,
    longitude: 152.8667,
    accuracy: 4
  },
  {
    postalCode: 4303,
    city: "Dinmore",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6,
    longitude: 152.8333,
    accuracy: 4
  },
  {
    postalCode: 4303,
    city: "Riverview",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6,
    longitude: 152.85,
    accuracy: 4
  },
  {
    postalCode: 4303,
    city: "New Chum",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.618,
    longitude: 152.8326,
    accuracy: 4
  },
  {
    postalCode: 4304,
    city: "North Booval",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6039,
    longitude: 152.7948,
    accuracy: 4
  },
  {
    postalCode: 4304,
    city: "Booval Fair",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6122,
    longitude: 152.8014,
    accuracy: 3
  },
  {
    postalCode: 4304,
    city: "Silkstone",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6213,
    longitude: 152.7877,
    accuracy: 4
  },
  {
    postalCode: 4304,
    city: "Blackstone",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6251,
    longitude: 152.8084,
    accuracy: 4
  },
  {
    postalCode: 4304,
    city: "Booval",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6133,
    longitude: 152.7894,
    accuracy: 4
  },
  {
    postalCode: 4304,
    city: "Bundamba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6095,
    longitude: 152.8113,
    accuracy: 4
  },
  {
    postalCode: 4304,
    city: "Ebbw Vale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6,
    longitude: 152.8167,
    accuracy: 4
  },
  {
    postalCode: 4305,
    city: "Limestone Ridges",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8365,
    longitude: 152.726,
    accuracy: 4
  },
  {
    postalCode: 4305,
    city: "North Ipswich",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6029,
    longitude: 152.7615,
    accuracy: 4
  },
  {
    postalCode: 4305,
    city: "Brassall",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5975,
    longitude: 152.7476,
    accuracy: 4
  },
  {
    postalCode: 4305,
    city: "Coalfalls",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6084,
    longitude: 152.7468,
    accuracy: 4
  },
  {
    postalCode: 4305,
    city: "Basin Pocket",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5999,
    longitude: 152.7713,
    accuracy: 4
  },
  {
    postalCode: 4305,
    city: "Yamanto",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6603,
    longitude: 152.7386,
    accuracy: 4
  },
  {
    postalCode: 4305,
    city: "Bremer",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6204,
    longitude: 152.7567,
    accuracy: 3
  },
  {
    postalCode: 4305,
    city: "East Ipswich",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6064,
    longitude: 152.7723,
    accuracy: 4
  },
  {
    postalCode: 4305,
    city: "West Ipswich",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6213,
    longitude: 152.7482,
    accuracy: 4
  },
  {
    postalCode: 4305,
    city: "Wulkuraka",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6181,
    longitude: 152.7144,
    accuracy: 4
  },
  {
    postalCode: 4305,
    city: "Moores Pocket",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5978,
    longitude: 152.7773,
    accuracy: 4
  },
  {
    postalCode: 4305,
    city: "Leichhardt",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6228,
    longitude: 152.7337,
    accuracy: 4
  },
  {
    postalCode: 4305,
    city: "Raceview",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6347,
    longitude: 152.7752,
    accuracy: 4
  },
  {
    postalCode: 4305,
    city: "Newtown",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6163,
    longitude: 152.7768,
    accuracy: 4
  },
  {
    postalCode: 4305,
    city: "Woodend",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6055,
    longitude: 152.7531,
    accuracy: 4
  },
  {
    postalCode: 4305,
    city: "Ipswich",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6118,
    longitude: 152.7682,
    accuracy: 4
  },
  {
    postalCode: 4305,
    city: "North Tivoli",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5761,
    longitude: 152.7877,
    accuracy: 4
  },
  {
    postalCode: 4305,
    city: "One Mile",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.629,
    longitude: 152.7377,
    accuracy: 4
  },
  {
    postalCode: 4305,
    city: "Sadliers Crossing",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6125,
    longitude: 152.7458,
    accuracy: 4
  },
  {
    postalCode: 4305,
    city: "Eastern Heights",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6285,
    longitude: 152.7783,
    accuracy: 4
  },
  {
    postalCode: 4305,
    city: "Flinders View",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6505,
    longitude: 152.7745,
    accuracy: 4
  },
  {
    postalCode: 4305,
    city: "Churchill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6423,
    longitude: 152.7502,
    accuracy: 4
  },
  {
    postalCode: 4305,
    city: "Tivoli",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5928,
    longitude: 152.768,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "England Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3362,
    longitude: 152.7616,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Fernvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4548,
    longitude: 152.6532,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "South Ripley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7174,
    longitude: 152.8164,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Blacksoil",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.577,
    longitude: 152.7052,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Karrabin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6,
    longitude: 152.7167,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Goolman",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7333,
    longitude: 152.75,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Wanora",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5167,
    longitude: 152.6667,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Muirlea",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5667,
    longitude: 152.7167,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Harlin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.9803,
    longitude: 152.358,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Blackbutt",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.8863,
    longitude: 152.1017,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Moore",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.9005,
    longitude: 152.2934,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Nukku",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.8833,
    longitude: 152.0667,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Purga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6592,
    longitude: 152.7158,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Pine Mountain",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.55,
    longitude: 152.7,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Peak Crossing",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7837,
    longitude: 152.726,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Ironbark",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5564,
    longitude: 152.6716,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Dundas",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3,
    longitude: 152.6167,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Thagoona",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6333,
    longitude: 152.6333,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Mount Binga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1074,
    longitude: 152.4405,
    accuracy: 3
  },
  {
    postalCode: 4306,
    city: "Fairney View",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4833,
    longitude: 152.6667,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Mount Crosby",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5395,
    longitude: 152.8058,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Swanbank",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6569,
    longitude: 152.8072,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Split Yard Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4218,
    longitude: 152.5998,
    accuracy: 3
  },
  {
    postalCode: 4306,
    city: "Borallon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5333,
    longitude: 152.6833,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Deebing Heights",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6672,
    longitude: 152.7487,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Linville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.8443,
    longitude: 152.276,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Benarkin North",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.8572,
    longitude: 152.1501,
    accuracy: 3
  },
  {
    postalCode: 4306,
    city: "Banks Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4131,
    longitude: 152.7237,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Colinton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.9333,
    longitude: 152.3167,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Teelah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1074,
    longitude: 152.4405,
    accuracy: 3
  },
  {
    postalCode: 4306,
    city: "Ripley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7167,
    longitude: 152.8333,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Blackbutt North",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.8643,
    longitude: 152.1129,
    accuracy: 3
  },
  {
    postalCode: 4306,
    city: "Blackbutt South",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.8863,
    longitude: 152.1017,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Avoca Vale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1074,
    longitude: 152.4405,
    accuracy: 3
  },
  {
    postalCode: 4306,
    city: "Walloon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6055,
    longitude: 152.6643,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Lake Manchester",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1074,
    longitude: 152.4405,
    accuracy: 3
  },
  {
    postalCode: 4306,
    city: "Karana Downs",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5486,
    longitude: 152.8073,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Washpool",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4218,
    longitude: 152.5998,
    accuracy: 3
  },
  {
    postalCode: 4306,
    city: "Willowbank",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6821,
    longitude: 152.6741,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Cherry Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1074,
    longitude: 152.4405,
    accuracy: 3
  },
  {
    postalCode: 4306,
    city: "Chuwar",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5662,
    longitude: 152.7784,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Glamorgan Vale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5167,
    longitude: 152.6333,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Vernor",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4667,
    longitude: 152.6167,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Googa Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1074,
    longitude: 152.4405,
    accuracy: 3
  },
  {
    postalCode: 4306,
    city: "Amberley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6333,
    longitude: 152.7,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Mount Stanley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1074,
    longitude: 152.4405,
    accuracy: 3
  },
  {
    postalCode: 4306,
    city: "Lark Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5265,
    longitude: 152.6031,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "White Rock",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4218,
    longitude: 152.5998,
    accuracy: 3
  },
  {
    postalCode: 4306,
    city: "Barellan Point",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.572,
    longitude: 152.8438,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Wivenhoe Pocket",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4219,
    longitude: 152.6217,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Haigslea",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5725,
    longitude: 152.6294,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Taromeo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4218,
    longitude: 152.5998,
    accuracy: 3
  },
  {
    postalCode: 4306,
    city: "Benarkin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.8918,
    longitude: 152.1394,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Mount Marrow",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6039,
    longitude: 152.6209,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Kholo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4958,
    longitude: 152.7608,
    accuracy: 4
  },
  {
    postalCode: 4306,
    city: "Karalee",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5648,
    longitude: 152.8245,
    accuracy: 4
  },
  {
    postalCode: 4307,
    city: "Mutdapilly",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7667,
    longitude: 152.65,
    accuracy: 4
  },
  {
    postalCode: 4307,
    city: "Warrill View",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8241,
    longitude: 152.6137,
    accuracy: 4
  },
  {
    postalCode: 4307,
    city: "Silverdale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8993,
    longitude: 152.6048,
    accuracy: 4
  },
  {
    postalCode: 4307,
    city: "Coleyville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.809,
    longitude: 152.5668,
    accuracy: 4
  },
  {
    postalCode: 4307,
    city: "Radford",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8522,
    longitude: 152.6295,
    accuracy: 4
  },
  {
    postalCode: 4307,
    city: "Wilsons Plains",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8409,
    longitude: 152.6528,
    accuracy: 4
  },
  {
    postalCode: 4307,
    city: "Harrisville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.811,
    longitude: 152.6646,
    accuracy: 4
  },
  {
    postalCode: 4309,
    city: "Charlwood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0167,
    longitude: 152.5667,
    accuracy: 4
  },
  {
    postalCode: 4309,
    city: "Mount Edwards",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0167,
    longitude: 152.5167,
    accuracy: 4
  },
  {
    postalCode: 4309,
    city: "Frazerview",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.023,
    longitude: 152.5304,
    accuracy: 3
  },
  {
    postalCode: 4309,
    city: "Teviotville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.95,
    longitude: 152.6833,
    accuracy: 4
  },
  {
    postalCode: 4309,
    city: "Fassifern",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9667,
    longitude: 152.6,
    accuracy: 4
  },
  {
    postalCode: 4309,
    city: "Kulgun",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9333,
    longitude: 152.6833,
    accuracy: 4
  },
  {
    postalCode: 4309,
    city: "Aratula",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9833,
    longitude: 152.5333,
    accuracy: 4
  },
  {
    postalCode: 4309,
    city: "Obum Obum",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9158,
    longitude: 152.652,
    accuracy: 4
  },
  {
    postalCode: 4309,
    city: "Kalbar",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9417,
    longitude: 152.6237,
    accuracy: 4
  },
  {
    postalCode: 4309,
    city: "Kents Lagoon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8987,
    longitude: 152.6186,
    accuracy: 4
  },
  {
    postalCode: 4309,
    city: "Washpool",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.023,
    longitude: 152.5304,
    accuracy: 3
  },
  {
    postalCode: 4309,
    city: "Morwincha",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9833,
    longitude: 152.5833,
    accuracy: 4
  },
  {
    postalCode: 4309,
    city: "Fassifern Valley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9667,
    longitude: 152.6,
    accuracy: 4
  },
  {
    postalCode: 4309,
    city: "Milora",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8319,
    longitude: 152.693,
    accuracy: 4
  },
  {
    postalCode: 4309,
    city: "Clumber",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0667,
    longitude: 152.4667,
    accuracy: 4
  },
  {
    postalCode: 4309,
    city: "Munbilla",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8751,
    longitude: 152.6592,
    accuracy: 4
  },
  {
    postalCode: 4309,
    city: "Moogerah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0886,
    longitude: 152.5223,
    accuracy: 4
  },
  {
    postalCode: 4309,
    city: "Tarome",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9764,
    longitude: 152.591,
    accuracy: 3
  },
  {
    postalCode: 4310,
    city: "Mount Alford",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0707,
    longitude: 152.5944,
    accuracy: 4
  },
  {
    postalCode: 4310,
    city: "Boonah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9972,
    longitude: 152.6811,
    accuracy: 4
  },
  {
    postalCode: 4310,
    city: "Maroon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1773,
    longitude: 152.7178,
    accuracy: 4
  },
  {
    postalCode: 4310,
    city: "Burnett Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0242,
    longitude: 152.668,
    accuracy: 3
  },
  {
    postalCode: 4310,
    city: "Bunburra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0667,
    longitude: 152.6833,
    accuracy: 4
  },
  {
    postalCode: 4310,
    city: "Anthony",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8779,
    longitude: 152.6828,
    accuracy: 4
  },
  {
    postalCode: 4310,
    city: "Hoya",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9667,
    longitude: 152.6833,
    accuracy: 4
  },
  {
    postalCode: 4310,
    city: "Milford",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0333,
    longitude: 152.7167,
    accuracy: 4
  },
  {
    postalCode: 4310,
    city: "Frenches Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.019,
    longitude: 152.6327,
    accuracy: 4
  },
  {
    postalCode: 4310,
    city: "Coulson",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0242,
    longitude: 152.668,
    accuracy: 3
  },
  {
    postalCode: 4310,
    city: "Cannon Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0627,
    longitude: 152.7241,
    accuracy: 4
  },
  {
    postalCode: 4310,
    city: "Wallaces Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0705,
    longitude: 152.6535,
    accuracy: 4
  },
  {
    postalCode: 4310,
    city: "Blantyre",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9039,
    longitude: 152.678,
    accuracy: 4
  },
  {
    postalCode: 4310,
    city: "Dugandan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0211,
    longitude: 152.6714,
    accuracy: 4
  },
  {
    postalCode: 4310,
    city: "Allandale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0121,
    longitude: 152.7482,
    accuracy: 4
  },
  {
    postalCode: 4310,
    city: "Templin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9714,
    longitude: 152.6478,
    accuracy: 4
  },
  {
    postalCode: 4310,
    city: "Roadvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9177,
    longitude: 152.6882,
    accuracy: 4
  },
  {
    postalCode: 4310,
    city: "Mount French",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0242,
    longitude: 152.668,
    accuracy: 3
  },
  {
    postalCode: 4310,
    city: "Kents Pocket",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9891,
    longitude: 152.6561,
    accuracy: 4
  },
  {
    postalCode: 4310,
    city: "Croftby",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1333,
    longitude: 152.5667,
    accuracy: 4
  },
  {
    postalCode: 4310,
    city: "Wyaralong",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0242,
    longitude: 152.668,
    accuracy: 3
  },
  {
    postalCode: 4310,
    city: "Coochin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0989,
    longitude: 152.643,
    accuracy: 4
  },
  {
    postalCode: 4310,
    city: "Milbong",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0242,
    longitude: 152.668,
    accuracy: 3
  },
  {
    postalCode: 4310,
    city: "Carneys Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0242,
    longitude: 152.668,
    accuracy: 3
  },
  {
    postalCode: 4310,
    city: "Woolooman",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0242,
    longitude: 152.668,
    accuracy: 3
  },
  {
    postalCode: 4310,
    city: "Bunjurgen",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0412,
    longitude: 152.6236,
    accuracy: 4
  },
  {
    postalCode: 4311,
    city: "Lowood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4655,
    longitude: 152.5762,
    accuracy: 4
  },
  {
    postalCode: 4311,
    city: "Coolana",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5333,
    longitude: 152.55,
    accuracy: 4
  },
  {
    postalCode: 4311,
    city: "Atkinsons Dam",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4214,
    longitude: 152.4339,
    accuracy: 4
  },
  {
    postalCode: 4311,
    city: "Mount Tarampa",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4609,
    longitude: 152.4899,
    accuracy: 3
  },
  {
    postalCode: 4311,
    city: "Tarampa",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4833,
    longitude: 152.55,
    accuracy: 4
  },
  {
    postalCode: 4311,
    city: "Minden",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5596,
    longitude: 152.5449,
    accuracy: 4
  },
  {
    postalCode: 4311,
    city: "Buaraba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3667,
    longitude: 152.3167,
    accuracy: 4
  },
  {
    postalCode: 4311,
    city: "Buaraba South",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4291,
    longitude: 152.4881,
    accuracy: 3
  },
  {
    postalCode: 4311,
    city: "Rifle Range",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4595,
    longitude: 152.5312,
    accuracy: 4
  },
  {
    postalCode: 4311,
    city: "Coominya",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3901,
    longitude: 152.5006,
    accuracy: 4
  },
  {
    postalCode: 4311,
    city: "Churchable",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4259,
    longitude: 152.3698,
    accuracy: 4
  },
  {
    postalCode: 4311,
    city: "Wivenhoe Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4291,
    longitude: 152.4881,
    accuracy: 3
  },
  {
    postalCode: 4311,
    city: "Patrick Estate",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4185,
    longitude: 152.5819,
    accuracy: 4
  },
  {
    postalCode: 4311,
    city: "Lockyer Waters",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4539,
    longitude: 152.4058,
    accuracy: 4
  },
  {
    postalCode: 4311,
    city: "Brightview",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5,
    longitude: 152.4833,
    accuracy: 4
  },
  {
    postalCode: 4311,
    city: "Prenzlau",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5333,
    longitude: 152.5167,
    accuracy: 4
  },
  {
    postalCode: 4311,
    city: "Clarendon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4167,
    longitude: 152.5333,
    accuracy: 4
  },
  {
    postalCode: 4312,
    city: "Somerset Dam",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1214,
    longitude: 152.5497,
    accuracy: 4
  },
  {
    postalCode: 4312,
    city: "Esk",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.239,
    longitude: 152.4222,
    accuracy: 4
  },
  {
    postalCode: 4312,
    city: "Redbank Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2862,
    longitude: 152.3039,
    accuracy: 3
  },
  {
    postalCode: 4312,
    city: "Bryden",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2692,
    longitude: 152.5813,
    accuracy: 4
  },
  {
    postalCode: 4312,
    city: "Mount Hallen",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3167,
    longitude: 152.4167,
    accuracy: 4
  },
  {
    postalCode: 4312,
    city: "Caboonbah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.15,
    longitude: 152.4833,
    accuracy: 4
  },
  {
    postalCode: 4312,
    city: "Murrumba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2,
    longitude: 152.5,
    accuracy: 4
  },
  {
    postalCode: 4312,
    city: "Moombra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.229,
    longitude: 152.4719,
    accuracy: 3
  },
  {
    postalCode: 4312,
    city: "Mount Byron",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.229,
    longitude: 152.4719,
    accuracy: 3
  },
  {
    postalCode: 4312,
    city: "Glen Esk",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.229,
    longitude: 152.4719,
    accuracy: 3
  },
  {
    postalCode: 4312,
    city: "Crossdale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.229,
    longitude: 152.4719,
    accuracy: 3
  },
  {
    postalCode: 4312,
    city: "Coal Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2148,
    longitude: 152.4932,
    accuracy: 3
  },
  {
    postalCode: 4312,
    city: "Eskdale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2148,
    longitude: 152.4932,
    accuracy: 3
  },
  {
    postalCode: 4313,
    city: "Cressbrook",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0833,
    longitude: 152.4833,
    accuracy: 3
  },
  {
    postalCode: 4313,
    city: "Yimbun",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0333,
    longitude: 152.3667,
    accuracy: 4
  },
  {
    postalCode: 4313,
    city: "Fulham",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0667,
    longitude: 152.45,
    accuracy: 4
  },
  {
    postalCode: 4313,
    city: "Cooeeimbardi",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1009,
    longitude: 152.3312,
    accuracy: 3
  },
  {
    postalCode: 4313,
    city: "Toogoolawah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0866,
    longitude: 152.3764,
    accuracy: 4
  },
  {
    postalCode: 4313,
    city: "Braemore",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1009,
    longitude: 152.3312,
    accuracy: 3
  },
  {
    postalCode: 4313,
    city: "Lower Cressbrook",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0833,
    longitude: 152.4833,
    accuracy: 4
  },
  {
    postalCode: 4313,
    city: "Scrub Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1009,
    longitude: 152.3312,
    accuracy: 3
  },
  {
    postalCode: 4313,
    city: "Mount Beppo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0839,
    longitude: 152.4238,
    accuracy: 3
  },
  {
    postalCode: 4313,
    city: "Ottaba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.15,
    longitude: 152.3833,
    accuracy: 4
  },
  {
    postalCode: 4313,
    city: "Biarra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0839,
    longitude: 152.4238,
    accuracy: 3
  },
  {
    postalCode: 4313,
    city: "Gregors Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0839,
    longitude: 152.4238,
    accuracy: 3
  },
  {
    postalCode: 4313,
    city: "Ivory Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0839,
    longitude: 152.4238,
    accuracy: 3
  },
  {
    postalCode: 4340,
    city: "Rosewood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6335,
    longitude: 152.5895,
    accuracy: 4
  },
  {
    postalCode: 4340,
    city: "Jeebropilly",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6461,
    longitude: 152.6586,
    accuracy: 4
  },
  {
    postalCode: 4340,
    city: "Tallegalla",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6,
    longitude: 152.5667,
    accuracy: 4
  },
  {
    postalCode: 4340,
    city: "Lanefield",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.65,
    longitude: 152.55,
    accuracy: 4
  },
  {
    postalCode: 4340,
    city: "The Bluff",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6235,
    longitude: 152.5355,
    accuracy: 4
  },
  {
    postalCode: 4340,
    city: "Mount Walker",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7833,
    longitude: 152.5333,
    accuracy: 4
  },
  {
    postalCode: 4340,
    city: "Grandchester",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.664,
    longitude: 152.462,
    accuracy: 4
  },
  {
    postalCode: 4340,
    city: "Woolshed",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7448,
    longitude: 152.5241,
    accuracy: 3
  },
  {
    postalCode: 4340,
    city: "Calvert",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6667,
    longitude: 152.5167,
    accuracy: 4
  },
  {
    postalCode: 4340,
    city: "Lower Mount Walker",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7609,
    longitude: 152.5176,
    accuracy: 3
  },
  {
    postalCode: 4340,
    city: "Rosevale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8701,
    longitude: 152.4852,
    accuracy: 4
  },
  {
    postalCode: 4340,
    city: "Ebenezer",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6833,
    longitude: 152.6333,
    accuracy: 4
  },
  {
    postalCode: 4340,
    city: "Mount Mort",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8167,
    longitude: 152.4167,
    accuracy: 4
  },
  {
    postalCode: 4340,
    city: "Mount Walker West",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7609,
    longitude: 152.5176,
    accuracy: 3
  },
  {
    postalCode: 4340,
    city: "Ashwell",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6299,
    longitude: 152.5586,
    accuracy: 4
  },
  {
    postalCode: 4340,
    city: "Merryvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7925,
    longitude: 152.4928,
    accuracy: 4
  },
  {
    postalCode: 4340,
    city: "Mount Forbes",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7333,
    longitude: 152.6167,
    accuracy: 4
  },
  {
    postalCode: 4340,
    city: "Moorang",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9167,
    longitude: 152.4667,
    accuracy: 4
  },
  {
    postalCode: 4341,
    city: "Kentville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4833,
    longitude: 152.4333,
    accuracy: 4
  },
  {
    postalCode: 4341,
    city: "Kensington Grove",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5328,
    longitude: 152.4721,
    accuracy: 4
  },
  {
    postalCode: 4341,
    city: "Mulgowie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7333,
    longitude: 152.3667,
    accuracy: 4
  },
  {
    postalCode: 4341,
    city: "Thornton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8167,
    longitude: 152.3833,
    accuracy: 4
  },
  {
    postalCode: 4341,
    city: "Regency Downs",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5336,
    longitude: 152.4405,
    accuracy: 4
  },
  {
    postalCode: 4341,
    city: "Blenheim",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6667,
    longitude: 152.3167,
    accuracy: 4
  },
  {
    postalCode: 4341,
    city: "Plainland",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5667,
    longitude: 152.4167,
    accuracy: 4
  },
  {
    postalCode: 4341,
    city: "Mount Berryman",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7167,
    longitude: 152.3333,
    accuracy: 4
  },
  {
    postalCode: 4341,
    city: "Laidley South",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6458,
    longitude: 152.4032,
    accuracy: 3
  },
  {
    postalCode: 4341,
    city: "Hatton Vale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5667,
    longitude: 152.4667,
    accuracy: 4
  },
  {
    postalCode: 4341,
    city: "Laidley Creek West",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7125,
    longitude: 152.3775,
    accuracy: 3
  },
  {
    postalCode: 4341,
    city: "Laidley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6328,
    longitude: 152.3929,
    accuracy: 4
  },
  {
    postalCode: 4341,
    city: "Laidley North",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7125,
    longitude: 152.3775,
    accuracy: 3
  },
  {
    postalCode: 4341,
    city: "Townson",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8833,
    longitude: 152.3667,
    accuracy: 4
  },
  {
    postalCode: 4341,
    city: "Laidley Heights",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6246,
    longitude: 152.3776,
    accuracy: 3
  },
  {
    postalCode: 4341,
    city: "Summerholm",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6167,
    longitude: 152.45,
    accuracy: 4
  },
  {
    postalCode: 4342,
    city: "Glenore Grove",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5333,
    longitude: 152.4,
    accuracy: 4
  },
  {
    postalCode: 4342,
    city: "Lynford",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5371,
    longitude: 152.4037,
    accuracy: 3
  },
  {
    postalCode: 4342,
    city: "Forest Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5926,
    longitude: 152.3557,
    accuracy: 4
  },
  {
    postalCode: 4342,
    city: "Glen Cairn",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5371,
    longitude: 152.4037,
    accuracy: 3
  },
  {
    postalCode: 4342,
    city: "Crowley Vale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5383,
    longitude: 152.4052,
    accuracy: 3
  },
  {
    postalCode: 4342,
    city: "Lockrose",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.489,
    longitude: 152.46,
    accuracy: 4
  },
  {
    postalCode: 4343,
    city: "Morton Vale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4869,
    longitude: 152.3892,
    accuracy: 3
  },
  {
    postalCode: 4343,
    city: "Spring Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4532,
    longitude: 152.332,
    accuracy: 4
  },
  {
    postalCode: 4343,
    city: "Placid Hills",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5613,
    longitude: 152.2325,
    accuracy: 4
  },
  {
    postalCode: 4343,
    city: "College View",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6758,
    longitude: 152.2491,
    accuracy: 3
  },
  {
    postalCode: 4343,
    city: "Caffey",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6997,
    longitude: 152.2199,
    accuracy: 4
  },
  {
    postalCode: 4343,
    city: "Fordsdale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7094,
    longitude: 152.1277,
    accuracy: 4
  },
  {
    postalCode: 4343,
    city: "Lower Tenthill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.612,
    longitude: 152.2315,
    accuracy: 3
  },
  {
    postalCode: 4343,
    city: "East Haldon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6758,
    longitude: 152.2491,
    accuracy: 3
  },
  {
    postalCode: 4343,
    city: "Black Duck Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8333,
    longitude: 152.1833,
    accuracy: 4
  },
  {
    postalCode: 4343,
    city: "Woodlands",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6758,
    longitude: 152.2491,
    accuracy: 3
  },
  {
    postalCode: 4343,
    city: "Adare",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5127,
    longitude: 152.2954,
    accuracy: 4
  },
  {
    postalCode: 4343,
    city: "Ingoldsby",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6758,
    longitude: 152.2491,
    accuracy: 3
  },
  {
    postalCode: 4343,
    city: "Woodbine",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7833,
    longitude: 152.1833,
    accuracy: 4
  },
  {
    postalCode: 4343,
    city: "Ropeley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6667,
    longitude: 152.2667,
    accuracy: 4
  },
  {
    postalCode: 4343,
    city: "Junction View",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8,
    longitude: 152.1833,
    accuracy: 4
  },
  {
    postalCode: 4343,
    city: "Gatton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5587,
    longitude: 152.2762,
    accuracy: 4
  },
  {
    postalCode: 4343,
    city: "Vinegar Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6758,
    longitude: 152.2491,
    accuracy: 3
  },
  {
    postalCode: 4343,
    city: "Mount Sylvia",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7253,
    longitude: 152.2222,
    accuracy: 4
  },
  {
    postalCode: 4343,
    city: "Upper Tenthill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6758,
    longitude: 152.2491,
    accuracy: 3
  },
  {
    postalCode: 4343,
    city: "Lawes",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6758,
    longitude: 152.2491,
    accuracy: 3
  },
  {
    postalCode: 4343,
    city: "Rockside",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6758,
    longitude: 152.2491,
    accuracy: 3
  },
  {
    postalCode: 4343,
    city: "Ringwood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6758,
    longitude: 152.2491,
    accuracy: 3
  },
  {
    postalCode: 4343,
    city: "Lefthand Branch",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6758,
    longitude: 152.2491,
    accuracy: 3
  },
  {
    postalCode: 4343,
    city: "Lake Clarendon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5167,
    longitude: 152.3667,
    accuracy: 4
  },
  {
    postalCode: 4344,
    city: "Seventeen Mile",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5507,
    longitude: 152.959,
    accuracy: 4
  },
  {
    postalCode: 4344,
    city: "Egypt",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5987,
    longitude: 152.0996,
    accuracy: 3
  },
  {
    postalCode: 4344,
    city: "Helidon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5532,
    longitude: 152.124,
    accuracy: 4
  },
  {
    postalCode: 4344,
    city: "Lockyer",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5135,
    longitude: 152.0822,
    accuracy: 4
  },
  {
    postalCode: 4344,
    city: "Carpendale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5891,
    longitude: 152.1533,
    accuracy: 3
  },
  {
    postalCode: 4344,
    city: "Helidon Spa",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5987,
    longitude: 152.0996,
    accuracy: 3
  },
  {
    postalCode: 4344,
    city: "Rockmount",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6833,
    longitude: 152.0333,
    accuracy: 4
  },
  {
    postalCode: 4344,
    city: "Lilydale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6074,
    longitude: 152.1308,
    accuracy: 4
  },
  {
    postalCode: 4344,
    city: "Iredale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6003,
    longitude: 152.0873,
    accuracy: 3
  },
  {
    postalCode: 4344,
    city: "Stockyard",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6333,
    longitude: 152.0667,
    accuracy: 4
  },
  {
    postalCode: 4344,
    city: "Upper Flagstone",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5987,
    longitude: 152.0996,
    accuracy: 3
  },
  {
    postalCode: 4344,
    city: "Flagstone Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6167,
    longitude: 152.1167,
    accuracy: 4
  },
  {
    postalCode: 4344,
    city: "Silver Ridge",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5987,
    longitude: 152.0996,
    accuracy: 3
  },
  {
    postalCode: 4345,
    city: "Gatton College",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5546,
    longitude: 152.337,
    accuracy: 1
  },
  {
    postalCode: 4346,
    city: "Marburg",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5661,
    longitude: 152.597,
    accuracy: 4
  },
  {
    postalCode: 4347,
    city: "Veradilla",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5934,
    longitude: 152.2167,
    accuracy: 3
  },
  {
    postalCode: 4347,
    city: "Winwill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6,
    longitude: 152.2167,
    accuracy: 4
  },
  {
    postalCode: 4347,
    city: "Ma Ma Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6323,
    longitude: 152.187,
    accuracy: 4
  },
  {
    postalCode: 4347,
    city: "Mount Whitestone",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6667,
    longitude: 152.1667,
    accuracy: 4
  },
  {
    postalCode: 4347,
    city: "Grantham",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5792,
    longitude: 152.2017,
    accuracy: 4
  },
  {
    postalCode: 4350,
    city: "Athol",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6081,
    longitude: 151.7545,
    accuracy: 4
  },
  {
    postalCode: 4350,
    city: "Southtown",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5717,
    longitude: 151.8559,
    accuracy: 3
  },
  {
    postalCode: 4350,
    city: "Westbrook",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6167,
    longitude: 151.8667,
    accuracy: 4
  },
  {
    postalCode: 4350,
    city: "Toowoomba Village Fair",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6284,
    longitude: 151.8604,
    accuracy: 3
  },
  {
    postalCode: 4350,
    city: "Harristown",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5833,
    longitude: 151.9333,
    accuracy: 4
  },
  {
    postalCode: 4350,
    city: "Toowoomba City",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5802,
    longitude: 151.9439,
    accuracy: 3
  },
  {
    postalCode: 4350,
    city: "Mount Rascal",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.635,
    longitude: 151.9143,
    accuracy: 4
  },
  {
    postalCode: 4350,
    city: "Toowoomba West",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7858,
    longitude: 151.9008,
    accuracy: 4
  },
  {
    postalCode: 4350,
    city: "Prince Henry Heights",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5511,
    longitude: 151.991,
    accuracy: 4
  },
  {
    postalCode: 4350,
    city: "Rangeville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5832,
    longitude: 151.98,
    accuracy: 4
  },
  {
    postalCode: 4350,
    city: "Rockville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5361,
    longitude: 151.938,
    accuracy: 4
  },
  {
    postalCode: 4350,
    city: "Clifford Gardens",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6284,
    longitude: 151.8604,
    accuracy: 3
  },
  {
    postalCode: 4350,
    city: "Cranley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5167,
    longitude: 151.95,
    accuracy: 4
  },
  {
    postalCode: 4350,
    city: "East Toowoomba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5709,
    longitude: 151.9742,
    accuracy: 4
  },
  {
    postalCode: 4350,
    city: "Harlaxton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5333,
    longitude: 151.9667,
    accuracy: 4
  },
  {
    postalCode: 4350,
    city: "Wellcamp",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.55,
    longitude: 151.8667,
    accuracy: 4
  },
  {
    postalCode: 4350,
    city: "Drayton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5833,
    longitude: 151.9167,
    accuracy: 4
  },
  {
    postalCode: 4350,
    city: "Drayton North",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6284,
    longitude: 151.8604,
    accuracy: 3
  },
  {
    postalCode: 4350,
    city: "North Toowoomba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5441,
    longitude: 151.9612,
    accuracy: 4
  },
  {
    postalCode: 4350,
    city: "Toowoomba DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6284,
    longitude: 151.8604,
    accuracy: 3
  },
  {
    postalCode: 4350,
    city: "Cotswold Hills",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5224,
    longitude: 151.8952,
    accuracy: 4
  },
  {
    postalCode: 4350,
    city: "Northlands",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5717,
    longitude: 151.8559,
    accuracy: 3
  },
  {
    postalCode: 4350,
    city: "Blue Mountain Heights",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5049,
    longitude: 151.9559,
    accuracy: 4
  },
  {
    postalCode: 4350,
    city: "Centenary Heights",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5868,
    longitude: 151.9625,
    accuracy: 4
  },
  {
    postalCode: 4350,
    city: "Glenvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5682,
    longitude: 151.8934,
    accuracy: 4
  },
  {
    postalCode: 4350,
    city: "Toowoomba South",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5717,
    longitude: 151.8559,
    accuracy: 3
  },
  {
    postalCode: 4350,
    city: "Wilsonton Heights",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5323,
    longitude: 151.9244,
    accuracy: 4
  },
  {
    postalCode: 4350,
    city: "Toowoomba BC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6284,
    longitude: 151.8604,
    accuracy: 3
  },
  {
    postalCode: 4350,
    city: "Toowoomba East",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5717,
    longitude: 151.8559,
    accuracy: 3
  },
  {
    postalCode: 4350,
    city: "Finnie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6167,
    longitude: 151.9,
    accuracy: 4
  },
  {
    postalCode: 4350,
    city: "Gowrie Mountain",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6284,
    longitude: 151.8604,
    accuracy: 3
  },
  {
    postalCode: 4350,
    city: "Top Camp",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6358,
    longitude: 151.9392,
    accuracy: 4
  },
  {
    postalCode: 4350,
    city: "Darling Heights",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5966,
    longitude: 151.9305,
    accuracy: 4
  },
  {
    postalCode: 4350,
    city: "Mount Lofty",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5463,
    longitude: 151.9722,
    accuracy: 4
  },
  {
    postalCode: 4350,
    city: "Newtown",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.556,
    longitude: 151.9325,
    accuracy: 4
  },
  {
    postalCode: 4350,
    city: "Charlton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5333,
    longitude: 151.8667,
    accuracy: 4
  },
  {
    postalCode: 4350,
    city: "Wilsonton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5431,
    longitude: 151.9168,
    accuracy: 4
  },
  {
    postalCode: 4350,
    city: "Middle Ridge",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6071,
    longitude: 151.9669,
    accuracy: 4
  },
  {
    postalCode: 4350,
    city: "Torrington",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5424,
    longitude: 151.8879,
    accuracy: 4
  },
  {
    postalCode: 4350,
    city: "Mount Kynoch",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5107,
    longitude: 151.9481,
    accuracy: 4
  },
  {
    postalCode: 4350,
    city: "Wyalla Plaza",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5717,
    longitude: 151.8559,
    accuracy: 3
  },
  {
    postalCode: 4350,
    city: "Kearneys Spring",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6049,
    longitude: 151.941,
    accuracy: 4
  },
  {
    postalCode: 4350,
    city: "South Toowoomba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.571,
    longitude: 151.9465,
    accuracy: 4
  },
  {
    postalCode: 4350,
    city: "Toowoomba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5606,
    longitude: 151.9539,
    accuracy: 4
  },
  {
    postalCode: 4350,
    city: "Redwood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5648,
    longitude: 151.9791,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Umbiram",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6692,
    longitude: 151.7663,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Cement Mills",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.3333,
    longitude: 151.5,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Meringandan West",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4258,
    longitude: 151.9007,
    accuracy: 3
  },
  {
    postalCode: 4352,
    city: "Spring Bluff",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4625,
    longitude: 151.9698,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Kulpi",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1901,
    longitude: 151.6984,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Ballard",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7753,
    longitude: 151.6342,
    accuracy: 3
  },
  {
    postalCode: 4352,
    city: "Cabarlah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4333,
    longitude: 152,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Highgrove",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1333,
    longitude: 151.7667,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Wyreema",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6558,
    longitude: 151.8553,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Fifteen Mile",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7753,
    longitude: 151.6342,
    accuracy: 3
  },
  {
    postalCode: 4352,
    city: "Groomsville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3136,
    longitude: 151.9654,
    accuracy: 3
  },
  {
    postalCode: 4352,
    city: "Highfields",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4634,
    longitude: 151.9539,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Yalangur",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4167,
    longitude: 151.8333,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Hodgson Vale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6652,
    longitude: 151.9325,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Karara",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.2085,
    longitude: 151.5647,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Hampton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.35,
    longitude: 152.0833,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Pampas",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7929,
    longitude: 151.4161,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Coalbank",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1167,
    longitude: 151.85,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Maclagan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0867,
    longitude: 151.6318,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Perseverance",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3667,
    longitude: 152.1333,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Kleinton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4333,
    longitude: 151.95,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Ravensbourne",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3667,
    longitude: 152.1667,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Meringandan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4301,
    longitude: 151.9136,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Glencoe",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5997,
    longitude: 151.838,
    accuracy: 3
  },
  {
    postalCode: 4352,
    city: "Peranga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1469,
    longitude: 151.6939,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Djuan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1167,
    longitude: 151.9833,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Muniganeen",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7753,
    longitude: 151.6342,
    accuracy: 3
  },
  {
    postalCode: 4352,
    city: "Pechey",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3,
    longitude: 152.05,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Tummaville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8754,
    longitude: 151.5056,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Branchview",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7753,
    longitude: 151.6342,
    accuracy: 3
  },
  {
    postalCode: 4352,
    city: "Geham",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4,
    longitude: 152.0167,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Evergreen",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.15,
    longitude: 151.7333,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Upper Lockyer",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6667,
    longitude: 152.2333,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Blanchview",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5667,
    longitude: 152.0333,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Cutella",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.45,
    longitude: 151.8167,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Nutgrove",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.05,
    longitude: 151.7667,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Gore",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.2833,
    longitude: 151.4833,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Merritts Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7753,
    longitude: 151.6342,
    accuracy: 3
  },
  {
    postalCode: 4352,
    city: "Severnlea",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.7023,
    longitude: 151.9027,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Narko",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7753,
    longitude: 151.6342,
    accuracy: 3
  },
  {
    postalCode: 4352,
    city: "Oman Ama",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.4,
    longitude: 151.3,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Derrymore",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7753,
    longitude: 151.6342,
    accuracy: 3
  },
  {
    postalCode: 4352,
    city: "Birnam",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4833,
    longitude: 151.9167,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Mount Luke",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4,
    longitude: 150.0333,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Silver Ridge",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5997,
    longitude: 151.838,
    accuracy: 3
  },
  {
    postalCode: 4352,
    city: "Condamine Plains",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7753,
    longitude: 151.6342,
    accuracy: 3
  },
  {
    postalCode: 4352,
    city: "Wutul",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0333,
    longitude: 151.8,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Malling",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0709,
    longitude: 151.5901,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Woolmer",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.45,
    longitude: 151.9167,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Doctor Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7753,
    longitude: 151.6342,
    accuracy: 3
  },
  {
    postalCode: 4352,
    city: "Murphys Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4637,
    longitude: 152.0549,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Lyra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.829,
    longitude: 151.8552,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Vale View",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6619,
    longitude: 151.899,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Thornville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7753,
    longitude: 151.6342,
    accuracy: 3
  },
  {
    postalCode: 4352,
    city: "Ramsay",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7232,
    longitude: 151.9886,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Yandilla",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.85,
    longitude: 151.3667,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Preston",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6604,
    longitude: 151.9866,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Toowoomba Mc",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7753,
    longitude: 151.6342,
    accuracy: 3
  },
  {
    postalCode: 4352,
    city: "Amiens",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.588,
    longitude: 151.8074,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "St Aubyn",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0833,
    longitude: 151.9167,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Bapaume",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.5699,
    longitude: 151.8438,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Palmtree",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7753,
    longitude: 151.6342,
    accuracy: 3
  },
  {
    postalCode: 4352,
    city: "Gowrie Junction",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4833,
    longitude: 151.8833,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Lilyvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7753,
    longitude: 151.6342,
    accuracy: 3
  },
  {
    postalCode: 4352,
    city: "Woodleigh",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7753,
    longitude: 151.6342,
    accuracy: 3
  },
  {
    postalCode: 4352,
    city: "Gowrie Little Plain",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7753,
    longitude: 151.6342,
    accuracy: 3
  },
  {
    postalCode: 4352,
    city: "Grapetree",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7753,
    longitude: 151.6342,
    accuracy: 3
  },
  {
    postalCode: 4352,
    city: "Withcott",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5541,
    longitude: 152.0243,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "White Mountain",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7753,
    longitude: 151.6342,
    accuracy: 3
  },
  {
    postalCode: 4352,
    city: "Kurrowah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7753,
    longitude: 151.6342,
    accuracy: 3
  },
  {
    postalCode: 4352,
    city: "Whichello",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7753,
    longitude: 151.6342,
    accuracy: 3
  },
  {
    postalCode: 4352,
    city: "Iredale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7753,
    longitude: 151.6342,
    accuracy: 3
  },
  {
    postalCode: 4352,
    city: "Rangemore",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7753,
    longitude: 151.6342,
    accuracy: 3
  },
  {
    postalCode: 4352,
    city: "Postmans Ridge",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5309,
    longitude: 152.0528,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "North Maclagan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7753,
    longitude: 151.6342,
    accuracy: 3
  },
  {
    postalCode: 4352,
    city: "Pozieres",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.5269,
    longitude: 151.8829,
    accuracy: 4
  },
  {
    postalCode: 4352,
    city: "Cawdor",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4667,
    longitude: 151.9,
    accuracy: 4
  },
  {
    postalCode: 4353,
    city: "Bergen",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2167,
    longitude: 151.8833,
    accuracy: 3
  },
  {
    postalCode: 4353,
    city: "East Cooyar",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2167,
    longitude: 151.8833,
    accuracy: 3
  },
  {
    postalCode: 4353,
    city: "Haden",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2266,
    longitude: 151.8858,
    accuracy: 4
  },
  {
    postalCode: 4354,
    city: "Kilbirnie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2167,
    longitude: 151.85,
    accuracy: 4
  },
  {
    postalCode: 4354,
    city: "Goombungee",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3167,
    longitude: 151.7,
    accuracy: 4
  },
  {
    postalCode: 4354,
    city: "Douglas",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3175,
    longitude: 151.8788,
    accuracy: 3
  },
  {
    postalCode: 4355,
    city: "The Bluff",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6235,
    longitude: 152.5355,
    accuracy: 4
  },
  {
    postalCode: 4355,
    city: "Mountain Camp",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4,
    longitude: 152.8833,
    accuracy: 4
  },
  {
    postalCode: 4355,
    city: "Pinelands",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.27,
    longitude: 152.345,
    accuracy: 3
  },
  {
    postalCode: 4355,
    city: "Crows Nest",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2599,
    longitude: 152.0516,
    accuracy: 4
  },
  {
    postalCode: 4355,
    city: "Anduramba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.15,
    longitude: 152.1,
    accuracy: 4
  },
  {
    postalCode: 4355,
    city: "Pierces Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2077,
    longitude: 152.0273,
    accuracy: 3
  },
  {
    postalCode: 4355,
    city: "Cressbrook Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.27,
    longitude: 152.345,
    accuracy: 3
  },
  {
    postalCode: 4355,
    city: "Jones Gully",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.27,
    longitude: 152.345,
    accuracy: 3
  },
  {
    postalCode: 4355,
    city: "Glenaven",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2077,
    longitude: 152.0273,
    accuracy: 3
  },
  {
    postalCode: 4355,
    city: "Upper Pinelands",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.27,
    longitude: 152.345,
    accuracy: 3
  },
  {
    postalCode: 4355,
    city: "Plainby",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.27,
    longitude: 152.345,
    accuracy: 3
  },
  {
    postalCode: 4355,
    city: "Emu Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.27,
    longitude: 152.345,
    accuracy: 3
  },
  {
    postalCode: 4356,
    city: "Mount Tyson",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5833,
    longitude: 151.5667,
    accuracy: 4
  },
  {
    postalCode: 4356,
    city: "Linthorpe",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5976,
    longitude: 151.6262,
    accuracy: 3
  },
  {
    postalCode: 4356,
    city: "Yarranlea",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7283,
    longitude: 151.5257,
    accuracy: 4
  },
  {
    postalCode: 4356,
    city: "Purrawunda",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7002,
    longitude: 151.5413,
    accuracy: 3
  },
  {
    postalCode: 4356,
    city: "Bongeen",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5667,
    longitude: 151.45,
    accuracy: 4
  },
  {
    postalCode: 4356,
    city: "North Branch",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0368,
    longitude: 152.3298,
    accuracy: 4
  },
  {
    postalCode: 4356,
    city: "Motley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.55,
    longitude: 151.6167,
    accuracy: 4
  },
  {
    postalCode: 4356,
    city: "Irongate",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7002,
    longitude: 151.5413,
    accuracy: 3
  },
  {
    postalCode: 4356,
    city: "Stoneleigh",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5766,
    longitude: 151.3706,
    accuracy: 4
  },
  {
    postalCode: 4356,
    city: "Broxburn",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7,
    longitude: 151.6667,
    accuracy: 4
  },
  {
    postalCode: 4356,
    city: "Norwin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5667,
    longitude: 151.3833,
    accuracy: 4
  },
  {
    postalCode: 4356,
    city: "Pittsworth",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7164,
    longitude: 151.634,
    accuracy: 4
  },
  {
    postalCode: 4356,
    city: "Springside",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6744,
    longitude: 151.5921,
    accuracy: 4
  },
  {
    postalCode: 4356,
    city: "Evanslea",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7002,
    longitude: 151.5413,
    accuracy: 3
  },
  {
    postalCode: 4356,
    city: "Kincora",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7002,
    longitude: 151.5413,
    accuracy: 3
  },
  {
    postalCode: 4356,
    city: "Scrubby Mountain",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7692,
    longitude: 151.585,
    accuracy: 3
  },
  {
    postalCode: 4356,
    city: "Rossvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7002,
    longitude: 151.5413,
    accuracy: 3
  },
  {
    postalCode: 4356,
    city: "St Helens",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7002,
    longitude: 151.5413,
    accuracy: 3
  },
  {
    postalCode: 4357,
    city: "Captains Mountain",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9222,
    longitude: 151.1706,
    accuracy: 3
  },
  {
    postalCode: 4357,
    city: "Kooroongarra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1032,
    longitude: 151.2586,
    accuracy: 4
  },
  {
    postalCode: 4357,
    city: "Cypress Gardens",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8684,
    longitude: 151.0835,
    accuracy: 3
  },
  {
    postalCode: 4357,
    city: "Turallin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8333,
    longitude: 151.2167,
    accuracy: 4
  },
  {
    postalCode: 4357,
    city: "Bringalily",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8684,
    longitude: 151.0835,
    accuracy: 3
  },
  {
    postalCode: 4357,
    city: "Millmerran Woods",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8684,
    longitude: 151.0835,
    accuracy: 3
  },
  {
    postalCode: 4357,
    city: "Bulli Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8684,
    longitude: 151.0835,
    accuracy: 3
  },
  {
    postalCode: 4357,
    city: "Clontarf",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9667,
    longitude: 151.2167,
    accuracy: 4
  },
  {
    postalCode: 4357,
    city: "Condamine Farms",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8684,
    longitude: 151.0835,
    accuracy: 3
  },
  {
    postalCode: 4357,
    city: "Lavelle",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8684,
    longitude: 151.0835,
    accuracy: 3
  },
  {
    postalCode: 4357,
    city: "Western Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5167,
    longitude: 149.9333,
    accuracy: 4
  },
  {
    postalCode: 4357,
    city: "Rocky Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0167,
    longitude: 151.35,
    accuracy: 4
  },
  {
    postalCode: 4357,
    city: "The Pines",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8684,
    longitude: 151.0835,
    accuracy: 3
  },
  {
    postalCode: 4357,
    city: "Mount Emlyn",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0397,
    longitude: 151.3342,
    accuracy: 4
  },
  {
    postalCode: 4357,
    city: "Forest Ridge",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8684,
    longitude: 151.0835,
    accuracy: 3
  },
  {
    postalCode: 4357,
    city: "Millmerran",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8791,
    longitude: 151.2706,
    accuracy: 4
  },
  {
    postalCode: 4357,
    city: "Domville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8684,
    longitude: 151.0835,
    accuracy: 3
  },
  {
    postalCode: 4357,
    city: "Stonehenge",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8684,
    longitude: 151.0835,
    accuracy: 3
  },
  {
    postalCode: 4357,
    city: "Canning Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8684,
    longitude: 151.0835,
    accuracy: 3
  },
  {
    postalCode: 4357,
    city: "Millmerran Downs",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8684,
    longitude: 151.0835,
    accuracy: 3
  },
  {
    postalCode: 4357,
    city: "Millwood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8684,
    longitude: 151.0835,
    accuracy: 3
  },
  {
    postalCode: 4357,
    city: "Wattle Ridge",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8684,
    longitude: 151.0835,
    accuracy: 3
  },
  {
    postalCode: 4357,
    city: "Lemontree",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8684,
    longitude: 151.0835,
    accuracy: 3
  },
  {
    postalCode: 4357,
    city: "Grays Gate",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8684,
    longitude: 151.0835,
    accuracy: 3
  },
  {
    postalCode: 4357,
    city: "Woondul",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8684,
    longitude: 151.0835,
    accuracy: 3
  },
  {
    postalCode: 4357,
    city: "Punchs Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8684,
    longitude: 151.0835,
    accuracy: 3
  },
  {
    postalCode: 4358,
    city: "Cambooya",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7145,
    longitude: 151.8603,
    accuracy: 4
  },
  {
    postalCode: 4358,
    city: "Vale View",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6619,
    longitude: 151.899,
    accuracy: 4
  },
  {
    postalCode: 4358,
    city: "Ramsay",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7232,
    longitude: 151.9886,
    accuracy: 4
  },
  {
    postalCode: 4358,
    city: "Felton South",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7484,
    longitude: 151.8971,
    accuracy: 3
  },
  {
    postalCode: 4358,
    city: "Felton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8022,
    longitude: 151.7693,
    accuracy: 4
  },
  {
    postalCode: 4359,
    city: "Hirstglen",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8333,
    longitude: 152.1,
    accuracy: 4
  },
  {
    postalCode: 4359,
    city: "Greenmount East",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7976,
    longitude: 152.0087,
    accuracy: 3
  },
  {
    postalCode: 4359,
    city: "Ascot",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4315,
    longitude: 153.058,
    accuracy: 4
  },
  {
    postalCode: 4359,
    city: "East Greenmount",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8104,
    longitude: 152.0021,
    accuracy: 3
  },
  {
    postalCode: 4359,
    city: "West Haldon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7976,
    longitude: 152.0087,
    accuracy: 3
  },
  {
    postalCode: 4359,
    city: "Greenmount",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7858,
    longitude: 151.9008,
    accuracy: 4
  },
  {
    postalCode: 4359,
    city: "Budgee",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7976,
    longitude: 152.0087,
    accuracy: 3
  },
  {
    postalCode: 4360,
    city: "Nobby",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8616,
    longitude: 151.9011,
    accuracy: 4
  },
  {
    postalCode: 4361,
    city: "Pilton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8701,
    longitude: 152.0458,
    accuracy: 4
  },
  {
    postalCode: 4361,
    city: "Manapouri",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9373,
    longitude: 151.9367,
    accuracy: 3
  },
  {
    postalCode: 4361,
    city: "Upper Pilton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8701,
    longitude: 152.0458,
    accuracy: 4
  },
  {
    postalCode: 4361,
    city: "Ryeford",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9373,
    longitude: 151.9367,
    accuracy: 3
  },
  {
    postalCode: 4361,
    city: "Elphinstone",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.973,
    longitude: 151.9023,
    accuracy: 4
  },
  {
    postalCode: 4361,
    city: "Missen Flat",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9373,
    longitude: 151.9367,
    accuracy: 3
  },
  {
    postalCode: 4361,
    city: "Back Plains",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9,
    longitude: 151.7833,
    accuracy: 4
  },
  {
    postalCode: 4361,
    city: "Mount Molar",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8816,
    longitude: 151.8517,
    accuracy: 4
  },
  {
    postalCode: 4361,
    city: "Kings Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9,
    longitude: 151.9167,
    accuracy: 4
  },
  {
    postalCode: 4361,
    city: "Victoria Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9373,
    longitude: 151.9367,
    accuracy: 3
  },
  {
    postalCode: 4361,
    city: "Spring Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9333,
    longitude: 151.9833,
    accuracy: 4
  },
  {
    postalCode: 4361,
    city: "Nevilton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9373,
    longitude: 151.9367,
    accuracy: 3
  },
  {
    postalCode: 4361,
    city: "Ellangowan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9415,
    longitude: 151.7273,
    accuracy: 4
  },
  {
    postalCode: 4361,
    city: "Sandy Camp",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9373,
    longitude: 151.9367,
    accuracy: 3
  },
  {
    postalCode: 4361,
    city: "Clifton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9337,
    longitude: 151.9066,
    accuracy: 4
  },
  {
    postalCode: 4361,
    city: "Headington Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9373,
    longitude: 151.9367,
    accuracy: 3
  },
  {
    postalCode: 4362,
    city: "Berat",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.05,
    longitude: 152.05,
    accuracy: 4
  },
  {
    postalCode: 4362,
    city: "Mount Marshall",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0833,
    longitude: 152.0333,
    accuracy: 4
  },
  {
    postalCode: 4362,
    city: "Allora",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0348,
    longitude: 151.9806,
    accuracy: 4
  },
  {
    postalCode: 4362,
    city: "Ellinthorp",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0512,
    longitude: 151.9221,
    accuracy: 4
  },
  {
    postalCode: 4362,
    city: "Deuchar",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1176,
    longitude: 151.9575,
    accuracy: 4
  },
  {
    postalCode: 4362,
    city: "Talgai",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9864,
    longitude: 151.7704,
    accuracy: 4
  },
  {
    postalCode: 4362,
    city: "Goomburra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.05,
    longitude: 152.1333,
    accuracy: 4
  },
  {
    postalCode: 4362,
    city: "Hendon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0772,
    longitude: 151.9492,
    accuracy: 4
  },
  {
    postalCode: 4363,
    city: "Southbrook",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6833,
    longitude: 151.7167,
    accuracy: 4
  },
  {
    postalCode: 4364,
    city: "Brookstead",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7607,
    longitude: 151.4456,
    accuracy: 4
  },
  {
    postalCode: 4365,
    city: "Leyburn",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.011,
    longitude: 151.5821,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "Morgan Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.2562,
    longitude: 152.0454,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "Wildash",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1853,
    longitude: 152.02,
    accuracy: 3
  },
  {
    postalCode: 4370,
    city: "Thanes Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1167,
    longitude: 151.6833,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "Mount Tabor",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1853,
    longitude: 152.02,
    accuracy: 3
  },
  {
    postalCode: 4370,
    city: "Massie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1478,
    longitude: 151.9556,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "Clintonvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1,
    longitude: 152.1167,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "Cunningham",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1613,
    longitude: 151.8421,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "Danderoo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.25,
    longitude: 152.2333,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "Pratten",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0892,
    longitude: 151.7827,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "Elbow Valley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.3833,
    longitude: 152.1333,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "Allan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.2017,
    longitude: 151.9512,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "Leslie Dam",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1853,
    longitude: 152.02,
    accuracy: 3
  },
  {
    postalCode: 4370,
    city: "Leslie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1787,
    longitude: 151.9217,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "Swan Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.2,
    longitude: 152.1333,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "Thane",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1621,
    longitude: 151.7012,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "Wiyarra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.2667,
    longitude: 152.2333,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "North Branch",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0368,
    longitude: 152.3298,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "Sladevale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1667,
    longitude: 152.0667,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "Montrose",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1817,
    longitude: 151.7933,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "Murrays Bridge",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1853,
    longitude: 152.02,
    accuracy: 3
  },
  {
    postalCode: 4370,
    city: "Cherry Gully",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.4331,
    longitude: 152.0321,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "Canningvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.2441,
    longitude: 152.0564,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "Loch Lomond",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.3167,
    longitude: 152.2,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "Wheatvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1667,
    longitude: 151.8833,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "Bony Mountain",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1333,
    longitude: 151.8333,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "Rodgers Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1853,
    longitude: 152.02,
    accuracy: 3
  },
  {
    postalCode: 4370,
    city: "Warwick",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.219,
    longitude: 152.0344,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "Rosenthal Heights",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.2401,
    longitude: 152.0133,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "Mount Sturt",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.2,
    longitude: 152.1833,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "Rosehill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1833,
    longitude: 152,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "Womina",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1833,
    longitude: 152.05,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "The Hermitage",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1853,
    longitude: 152.02,
    accuracy: 3
  },
  {
    postalCode: 4370,
    city: "Junabee",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.25,
    longitude: 152.1333,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "Glengallan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1853,
    longitude: 152.02,
    accuracy: 3
  },
  {
    postalCode: 4370,
    city: "Greymare",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1667,
    longitude: 151.7667,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "Warwick DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1853,
    longitude: 152.02,
    accuracy: 3
  },
  {
    postalCode: 4370,
    city: "Upper Freestone",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1333,
    longitude: 152.2,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "Tregony",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1853,
    longitude: 152.02,
    accuracy: 3
  },
  {
    postalCode: 4370,
    city: "Mount Colliery",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.2503,
    longitude: 152.3738,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "Willowvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1853,
    longitude: 152.02,
    accuracy: 3
  },
  {
    postalCode: 4370,
    city: "Freestone",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1333,
    longitude: 152.1333,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "Silverwood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.3239,
    longitude: 152.0051,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "Upper Wheatvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1853,
    longitude: 152.02,
    accuracy: 3
  },
  {
    postalCode: 4370,
    city: "The Glen",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.3574,
    longitude: 151.9244,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "Toolburra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1667,
    longitude: 151.9667,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "Maryvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0687,
    longitude: 152.2436,
    accuracy: 4
  },
  {
    postalCode: 4370,
    city: "Gladfield",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1853,
    longitude: 152.02,
    accuracy: 3
  },
  {
    postalCode: 4371,
    city: "Emu Vale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.2241,
    longitude: 152.2467,
    accuracy: 4
  },
  {
    postalCode: 4371,
    city: "Swanfels",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.2141,
    longitude: 152.2288,
    accuracy: 3
  },
  {
    postalCode: 4371,
    city: "Yangan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1949,
    longitude: 152.2075,
    accuracy: 4
  },
  {
    postalCode: 4372,
    city: "Tannymorel",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.2927,
    longitude: 152.2472,
    accuracy: 4
  },
  {
    postalCode: 4373,
    city: "The Head",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.2833,
    longitude: 152.4167,
    accuracy: 4
  },
  {
    postalCode: 4373,
    city: "Killarney",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.3327,
    longitude: 152.2942,
    accuracy: 4
  },
  {
    postalCode: 4373,
    city: "The Falls",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.311,
    longitude: 152.3559,
    accuracy: 3
  },
  {
    postalCode: 4374,
    city: "Dalveen",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.4871,
    longitude: 151.9674,
    accuracy: 4
  },
  {
    postalCode: 4375,
    city: "Fleurbaix",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.5333,
    longitude: 151.9167,
    accuracy: 4
  },
  {
    postalCode: 4375,
    city: "Cottonvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7167,
    longitude: 152.4667,
    accuracy: 4
  },
  {
    postalCode: 4376,
    city: "Thulimbah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.5506,
    longitude: 151.9486,
    accuracy: 4
  },
  {
    postalCode: 4377,
    city: "Glen Niven",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.6,
    longitude: 151.9667,
    accuracy: 4
  },
  {
    postalCode: 4377,
    city: "The Summit",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.5805,
    longitude: 151.9533,
    accuracy: 4
  },
  {
    postalCode: 4378,
    city: "Applethorpe",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.6193,
    longitude: 151.9601,
    accuracy: 4
  },
  {
    postalCode: 4380,
    city: "Severnlea",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.7023,
    longitude: 151.9027,
    accuracy: 4
  },
  {
    postalCode: 4380,
    city: "Springdale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.7241,
    longitude: 151.825,
    accuracy: 3
  },
  {
    postalCode: 4380,
    city: "Stanthorpe",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.6543,
    longitude: 151.9339,
    accuracy: 4
  },
  {
    postalCode: 4380,
    city: "Glenlyon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.7241,
    longitude: 151.825,
    accuracy: 3
  },
  {
    postalCode: 4380,
    city: "Thorndale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.7241,
    longitude: 151.825,
    accuracy: 3
  },
  {
    postalCode: 4380,
    city: "Pikedale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.65,
    longitude: 151.6333,
    accuracy: 4
  },
  {
    postalCode: 4380,
    city: "Amiens",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.588,
    longitude: 151.8074,
    accuracy: 4
  },
  {
    postalCode: 4380,
    city: "Sugarloaf",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.7241,
    longitude: 151.825,
    accuracy: 3
  },
  {
    postalCode: 4380,
    city: "Pikes Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.7241,
    longitude: 151.825,
    accuracy: 3
  },
  {
    postalCode: 4380,
    city: "Broadwater",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.7241,
    longitude: 151.825,
    accuracy: 3
  },
  {
    postalCode: 4380,
    city: "Eukey",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.7667,
    longitude: 151.9833,
    accuracy: 4
  },
  {
    postalCode: 4380,
    city: "Nundubbermere",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.7241,
    longitude: 151.825,
    accuracy: 3
  },
  {
    postalCode: 4380,
    city: "Greenlands",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.7241,
    longitude: 151.825,
    accuracy: 3
  },
  {
    postalCode: 4380,
    city: "Mingoola",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.9833,
    longitude: 151.5167,
    accuracy: 4
  },
  {
    postalCode: 4380,
    city: "Kyoomba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.6833,
    longitude: 152,
    accuracy: 4
  },
  {
    postalCode: 4380,
    city: "Dalcouth",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.7241,
    longitude: 151.825,
    accuracy: 3
  },
  {
    postalCode: 4380,
    city: "Storm King",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.7241,
    longitude: 151.825,
    accuracy: 3
  },
  {
    postalCode: 4380,
    city: "Mount Tully",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.7646,
    longitude: 151.9481,
    accuracy: 4
  },
  {
    postalCode: 4380,
    city: "Cannon Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.6036,
    longitude: 151.8722,
    accuracy: 4
  },
  {
    postalCode: 4381,
    city: "Fletcher",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.774,
    longitude: 151.8637,
    accuracy: 4
  },
  {
    postalCode: 4381,
    city: "Glen Aplin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.7338,
    longitude: 151.8797,
    accuracy: 4
  },
  {
    postalCode: 4382,
    city: "Lyra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.829,
    longitude: 151.8552,
    accuracy: 4
  },
  {
    postalCode: 4382,
    city: "Girraween",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.8278,
    longitude: 151.8556,
    accuracy: 3
  },
  {
    postalCode: 4382,
    city: "Wyberba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.8619,
    longitude: 151.8646,
    accuracy: 4
  },
  {
    postalCode: 4382,
    city: "Ballandean",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.798,
    longitude: 151.8401,
    accuracy: 4
  },
  {
    postalCode: 4382,
    city: "Somme",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.8278,
    longitude: 151.8556,
    accuracy: 3
  },
  {
    postalCode: 4383,
    city: "Wallangarra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.9239,
    longitude: 151.9282,
    accuracy: 4
  },
  {
    postalCode: 4384,
    city: "Limevale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.721,
    longitude: 151.1824,
    accuracy: 4
  },
  {
    postalCode: 4385,
    city: "Texas",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.8542,
    longitude: 151.165,
    accuracy: 4
  },
  {
    postalCode: 4385,
    city: "Smithlea",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.7884,
    longitude: 151.01,
    accuracy: 3
  },
  {
    postalCode: 4385,
    city: "Glenarbon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.6835,
    longitude: 150.8928,
    accuracy: 4
  },
  {
    postalCode: 4385,
    city: "Riverton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.7884,
    longitude: 151.01,
    accuracy: 3
  },
  {
    postalCode: 4385,
    city: "Beebo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.7239,
    longitude: 150.966,
    accuracy: 4
  },
  {
    postalCode: 4385,
    city: "Watsons Crossing",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.7884,
    longitude: 151.01,
    accuracy: 3
  },
  {
    postalCode: 4385,
    city: "Bonshaw",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.7884,
    longitude: 151.01,
    accuracy: 3
  },
  {
    postalCode: 4385,
    city: "Maidenhead",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.7884,
    longitude: 151.01,
    accuracy: 3
  },
  {
    postalCode: 4385,
    city: "Silver Spur",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.7884,
    longitude: 151.01,
    accuracy: 3
  },
  {
    postalCode: 4387,
    city: "Whetstone",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.5,
    longitude: 150.9333,
    accuracy: 4
  },
  {
    postalCode: 4387,
    city: "Inglewood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.4159,
    longitude: 151.0807,
    accuracy: 4
  },
  {
    postalCode: 4387,
    city: "Coolmunda",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.4171,
    longitude: 151.1449,
    accuracy: 4
  },
  {
    postalCode: 4387,
    city: "Warroo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.4789,
    longitude: 151.1134,
    accuracy: 3
  },
  {
    postalCode: 4387,
    city: "Terrica",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.5219,
    longitude: 151.4786,
    accuracy: 4
  },
  {
    postalCode: 4387,
    city: "Bybera",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.4789,
    longitude: 151.1134,
    accuracy: 3
  },
  {
    postalCode: 4387,
    city: "Greenup",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.4789,
    longitude: 151.1134,
    accuracy: 3
  },
  {
    postalCode: 4387,
    city: "Brush Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.4789,
    longitude: 151.1134,
    accuracy: 3
  },
  {
    postalCode: 4387,
    city: "Mosquito Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.4789,
    longitude: 151.1134,
    accuracy: 3
  },
  {
    postalCode: 4388,
    city: "Yelarbon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.5725,
    longitude: 150.7513,
    accuracy: 4
  },
  {
    postalCode: 4388,
    city: "Kurumbul",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.6167,
    longitude: 150.55,
    accuracy: 4
  },
  {
    postalCode: 4390,
    city: "Callandoon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.4958,
    longitude: 150.1831,
    accuracy: 4
  },
  {
    postalCode: 4390,
    city: "Calingunee",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.194,
    longitude: 150.3565,
    accuracy: 3
  },
  {
    postalCode: 4390,
    city: "Goondiwindi",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.5471,
    longitude: 150.3055,
    accuracy: 4
  },
  {
    postalCode: 4390,
    city: "Kindon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.194,
    longitude: 150.3565,
    accuracy: 3
  },
  {
    postalCode: 4390,
    city: "Wondalli",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.194,
    longitude: 150.3565,
    accuracy: 3
  },
  {
    postalCode: 4390,
    city: "Lundavra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.194,
    longitude: 150.3565,
    accuracy: 3
  },
  {
    postalCode: 4390,
    city: "Yagaburne",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.194,
    longitude: 150.3565,
    accuracy: 3
  },
  {
    postalCode: 4390,
    city: "Wyaga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.194,
    longitude: 150.3565,
    accuracy: 3
  },
  {
    postalCode: 4390,
    city: "Goodar",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.194,
    longitude: 150.3565,
    accuracy: 3
  },
  {
    postalCode: 4390,
    city: "Billa Billa",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.194,
    longitude: 150.3565,
    accuracy: 3
  },
  {
    postalCode: 4400,
    city: "Kingsthorpe",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4756,
    longitude: 151.8141,
    accuracy: 4
  },
  {
    postalCode: 4401,
    city: "Sabine",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.35,
    longitude: 151.7167,
    accuracy: 4
  },
  {
    postalCode: 4401,
    city: "Highland Plains",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4617,
    longitude: 151.6957,
    accuracy: 3
  },
  {
    postalCode: 4401,
    city: "Muldu",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2667,
    longitude: 151.6833,
    accuracy: 4
  },
  {
    postalCode: 4401,
    city: "Aubigny",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5234,
    longitude: 151.6348,
    accuracy: 4
  },
  {
    postalCode: 4401,
    city: "Boodua",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3833,
    longitude: 151.8333,
    accuracy: 4
  },
  {
    postalCode: 4401,
    city: "Devon Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4617,
    longitude: 151.6957,
    accuracy: 3
  },
  {
    postalCode: 4401,
    city: "Rosalie Plains",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2167,
    longitude: 151.7,
    accuracy: 4
  },
  {
    postalCode: 4401,
    city: "Acland",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3086,
    longitude: 151.6898,
    accuracy: 4
  },
  {
    postalCode: 4401,
    city: "Biddeston",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5592,
    longitude: 151.718,
    accuracy: 4
  },
  {
    postalCode: 4401,
    city: "Greenwood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4617,
    longitude: 151.6957,
    accuracy: 3
  },
  {
    postalCode: 4401,
    city: "Oakey",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4331,
    longitude: 151.7206,
    accuracy: 4
  },
  {
    postalCode: 4401,
    city: "Silverleigh",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4617,
    longitude: 151.6957,
    accuracy: 3
  },
  {
    postalCode: 4401,
    city: "Balgowan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4617,
    longitude: 151.6957,
    accuracy: 3
  },
  {
    postalCode: 4401,
    city: "Kelvinhaugh",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4617,
    longitude: 151.6957,
    accuracy: 3
  },
  {
    postalCode: 4401,
    city: "Mount Irving",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4617,
    longitude: 151.6957,
    accuracy: 3
  },
  {
    postalCode: 4401,
    city: "Yargullen",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5,
    longitude: 151.65,
    accuracy: 4
  },
  {
    postalCode: 4402,
    city: "Kooralgin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.9333,
    longitude: 151.95,
    accuracy: 4
  },
  {
    postalCode: 4402,
    city: "Upper Cooyar Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.9583,
    longitude: 151.8917,
    accuracy: 3
  },
  {
    postalCode: 4402,
    city: "Cooyar",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.9844,
    longitude: 151.8297,
    accuracy: 4
  },
  {
    postalCode: 4403,
    city: "Brymaroo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2835,
    longitude: 151.6046,
    accuracy: 3
  },
  {
    postalCode: 4403,
    city: "Quinalow",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1123,
    longitude: 151.6209,
    accuracy: 4
  },
  {
    postalCode: 4403,
    city: "West Prairie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2835,
    longitude: 151.6046,
    accuracy: 3
  },
  {
    postalCode: 4403,
    city: "Malu",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.35,
    longitude: 151.5667,
    accuracy: 4
  },
  {
    postalCode: 4403,
    city: "Jondaryan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3703,
    longitude: 151.5904,
    accuracy: 4
  },
  {
    postalCode: 4403,
    city: "Mount Moriah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2835,
    longitude: 151.6046,
    accuracy: 3
  },
  {
    postalCode: 4404,
    city: "Formartin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3959,
    longitude: 151.4118,
    accuracy: 4
  },
  {
    postalCode: 4404,
    city: "Irvingdale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3495,
    longitude: 151.4651,
    accuracy: 3
  },
  {
    postalCode: 4404,
    city: "Bowenville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3055,
    longitude: 151.4899,
    accuracy: 4
  },
  {
    postalCode: 4404,
    city: "Wainui",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3495,
    longitude: 151.4651,
    accuracy: 3
  },
  {
    postalCode: 4405,
    city: "Ducklo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2552,
    longitude: 151.011,
    accuracy: 4
  },
  {
    postalCode: 4405,
    city: "Dalby",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1817,
    longitude: 151.2621,
    accuracy: 4
  },
  {
    postalCode: 4405,
    city: "Blaxland",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1987,
    longitude: 151.3211,
    accuracy: 4
  },
  {
    postalCode: 4405,
    city: "Bunya Mountains",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.236,
    longitude: 151.1628,
    accuracy: 3
  },
  {
    postalCode: 4405,
    city: "Weranga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3051,
    longitude: 150.7262,
    accuracy: 4
  },
  {
    postalCode: 4405,
    city: "Grassdale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.236,
    longitude: 151.1628,
    accuracy: 3
  },
  {
    postalCode: 4405,
    city: "Tipton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3892,
    longitude: 151.2704,
    accuracy: 4
  },
  {
    postalCode: 4405,
    city: "St Ruth",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2763,
    longitude: 151.1157,
    accuracy: 3
  },
  {
    postalCode: 4405,
    city: "Ranges Bridge",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2763,
    longitude: 151.1157,
    accuracy: 3
  },
  {
    postalCode: 4405,
    city: "Marmadua",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2763,
    longitude: 151.1157,
    accuracy: 3
  },
  {
    postalCode: 4405,
    city: "Pirrinuan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2763,
    longitude: 151.1157,
    accuracy: 3
  },
  {
    postalCode: 4406,
    city: "Kaimkillenbun",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0627,
    longitude: 151.4362,
    accuracy: 4
  },
  {
    postalCode: 4406,
    city: "Weir River",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1306,
    longitude: 150.7917,
    accuracy: 3
  },
  {
    postalCode: 4406,
    city: "The Gums",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3333,
    longitude: 150.1833,
    accuracy: 4
  },
  {
    postalCode: 4406,
    city: "Boondandilla",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1306,
    longitude: 150.7917,
    accuracy: 3
  },
  {
    postalCode: 4406,
    city: "Moonie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7184,
    longitude: 150.3697,
    accuracy: 4
  },
  {
    postalCode: 4406,
    city: "Macalister",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0457,
    longitude: 151.081,
    accuracy: 4
  },
  {
    postalCode: 4406,
    city: "Hannaford",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3296,
    longitude: 150.0631,
    accuracy: 4
  },
  {
    postalCode: 4406,
    city: "Jimbour",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.9627,
    longitude: 151.2145,
    accuracy: 4
  },
  {
    postalCode: 4406,
    city: "Southwood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.7683,
    longitude: 150.0713,
    accuracy: 4
  },
  {
    postalCode: 4406,
    city: "Kogan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0333,
    longitude: 150.7667,
    accuracy: 4
  },
  {
    postalCode: 4407,
    city: "Cattle Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -13.1617,
    longitude: 143.0534,
    accuracy: 3
  },
  {
    postalCode: 4407,
    city: "Cecil Plains",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.5332,
    longitude: 151.1962,
    accuracy: 4
  },
  {
    postalCode: 4407,
    city: "Dunmore",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6386,
    longitude: 151.2709,
    accuracy: 3
  },
  {
    postalCode: 4407,
    city: "Nangwee",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.55,
    longitude: 151.3,
    accuracy: 4
  },
  {
    postalCode: 4408,
    city: "Bell",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.9354,
    longitude: 151.451,
    accuracy: 4
  },
  {
    postalCode: 4410,
    city: "Jandowae",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7841,
    longitude: 151.1124,
    accuracy: 4
  },
  {
    postalCode: 4411,
    city: "Warra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.9323,
    longitude: 150.9229,
    accuracy: 4
  },
  {
    postalCode: 4412,
    city: "Brigalow",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.8452,
    longitude: 150.7916,
    accuracy: 4
  },
  {
    postalCode: 4413,
    city: "Durah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7809,
    longitude: 150.6226,
    accuracy: 3
  },
  {
    postalCode: 4413,
    city: "Boonarga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7957,
    longitude: 150.7172,
    accuracy: 4
  },
  {
    postalCode: 4413,
    city: "Hopeland",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3471,
    longitude: 150.6717,
    accuracy: 3
  },
  {
    postalCode: 4413,
    city: "Montrose",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1817,
    longitude: 151.7933,
    accuracy: 4
  },
  {
    postalCode: 4413,
    city: "Canaga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7809,
    longitude: 150.6226,
    accuracy: 3
  },
  {
    postalCode: 4413,
    city: "Baking Board",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7078,
    longitude: 150.5455,
    accuracy: 4
  },
  {
    postalCode: 4413,
    city: "Burncluith",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6333,
    longitude: 150.7167,
    accuracy: 4
  },
  {
    postalCode: 4413,
    city: "Wieambilla",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0167,
    longitude: 150.5,
    accuracy: 4
  },
  {
    postalCode: 4413,
    city: "Chances Plain",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7809,
    longitude: 150.6226,
    accuracy: 3
  },
  {
    postalCode: 4413,
    city: "Chinchilla",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7379,
    longitude: 150.6297,
    accuracy: 4
  },
  {
    postalCode: 4415,
    city: "Dalwogon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5727,
    longitude: 150.1489,
    accuracy: 4
  },
  {
    postalCode: 4415,
    city: "Hookswood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5532,
    longitude: 150.2053,
    accuracy: 3
  },
  {
    postalCode: 4415,
    city: "Columboola",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6727,
    longitude: 150.3432,
    accuracy: 4
  },
  {
    postalCode: 4415,
    city: "Myall Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5532,
    longitude: 150.2053,
    accuracy: 3
  },
  {
    postalCode: 4415,
    city: "Miles",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6584,
    longitude: 150.1882,
    accuracy: 4
  },
  {
    postalCode: 4415,
    city: "Pelham",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5532,
    longitude: 150.2053,
    accuracy: 3
  },
  {
    postalCode: 4415,
    city: "Gurulmundi",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4172,
    longitude: 150.0574,
    accuracy: 4
  },
  {
    postalCode: 4415,
    city: "Kowguran",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4953,
    longitude: 150.1036,
    accuracy: 4
  },
  {
    postalCode: 4416,
    city: "Yulabilla",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.9843,
    longitude: 150.0054,
    accuracy: 3
  },
  {
    postalCode: 4416,
    city: "Condamine",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.9286,
    longitude: 150.1404,
    accuracy: 4
  },
  {
    postalCode: 4416,
    city: "Pine Hills",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.9843,
    longitude: 150.0054,
    accuracy: 3
  },
  {
    postalCode: 4416,
    city: "Moraby",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.9843,
    longitude: 150.0054,
    accuracy: 3
  },
  {
    postalCode: 4416,
    city: "Nangram",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.9843,
    longitude: 150.0054,
    accuracy: 3
  },
  {
    postalCode: 4416,
    city: "Barramornie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.9843,
    longitude: 150.0054,
    accuracy: 3
  },
  {
    postalCode: 4416,
    city: "Sunnyside",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.9843,
    longitude: 150.0054,
    accuracy: 3
  },
  {
    postalCode: 4417,
    city: "Wellesley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.631,
    longitude: 150.4009,
    accuracy: 3
  },
  {
    postalCode: 4417,
    city: "Parknook",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.631,
    longitude: 150.4009,
    accuracy: 3
  },
  {
    postalCode: 4417,
    city: "Surat",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1529,
    longitude: 149.0681,
    accuracy: 4
  },
  {
    postalCode: 4417,
    city: "Warkon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.631,
    longitude: 150.4009,
    accuracy: 3
  },
  {
    postalCode: 4417,
    city: "Oberina",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.631,
    longitude: 150.4009,
    accuracy: 3
  },
  {
    postalCode: 4417,
    city: "Noorindoo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.631,
    longitude: 150.4009,
    accuracy: 3
  },
  {
    postalCode: 4417,
    city: "Weribone",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.631,
    longitude: 150.4009,
    accuracy: 3
  },
  {
    postalCode: 4418,
    city: "Guluguba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2593,
    longitude: 150.0493,
    accuracy: 4
  },
  {
    postalCode: 4419,
    city: "Cockatoo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -14.9895,
    longitude: 142.77,
    accuracy: 3
  },
  {
    postalCode: 4419,
    city: "Wandoan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1228,
    longitude: 149.9603,
    accuracy: 4
  },
  {
    postalCode: 4419,
    city: "Grosmont",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.9419,
    longitude: 149.9011,
    accuracy: 3
  },
  {
    postalCode: 4420,
    city: "Spring Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9333,
    longitude: 151.9833,
    accuracy: 4
  },
  {
    postalCode: 4420,
    city: "Coorada",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.4868,
    longitude: 149.6225,
    accuracy: 3
  },
  {
    postalCode: 4420,
    city: "Ghinghinda",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.4868,
    longitude: 149.6225,
    accuracy: 3
  },
  {
    postalCode: 4420,
    city: "Peek-A-Doo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.4868,
    longitude: 149.6225,
    accuracy: 3
  },
  {
    postalCode: 4420,
    city: "Taroom",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6393,
    longitude: 149.7998,
    accuracy: 4
  },
  {
    postalCode: 4420,
    city: "Gwambegwine",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.4868,
    longitude: 149.6225,
    accuracy: 3
  },
  {
    postalCode: 4420,
    city: "Hornet Bank",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.4868,
    longitude: 149.6225,
    accuracy: 3
  },
  {
    postalCode: 4420,
    city: "Glenhaughton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.4868,
    longitude: 149.6225,
    accuracy: 3
  },
  {
    postalCode: 4420,
    city: "Broadmere",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.4868,
    longitude: 149.6225,
    accuracy: 3
  },
  {
    postalCode: 4421,
    city: "Tara",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2761,
    longitude: 150.4568,
    accuracy: 4
  },
  {
    postalCode: 4421,
    city: "Goranba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2879,
    longitude: 150.6003,
    accuracy: 4
  },
  {
    postalCode: 4422,
    city: "Flinton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.8833,
    longitude: 149.5667,
    accuracy: 4
  },
  {
    postalCode: 4422,
    city: "Inglestone",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6083,
    longitude: 149.725,
    accuracy: 3
  },
  {
    postalCode: 4422,
    city: "Meandarra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3228,
    longitude: 149.8825,
    accuracy: 4
  },
  {
    postalCode: 4422,
    city: "Coomrith",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6083,
    longitude: 149.725,
    accuracy: 3
  },
  {
    postalCode: 4422,
    city: "Westmar",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6083,
    longitude: 149.725,
    accuracy: 3
  },
  {
    postalCode: 4423,
    city: "Glenmorgan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.254,
    longitude: 149.681,
    accuracy: 4
  },
  {
    postalCode: 4423,
    city: "Teelba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.25,
    longitude: 149.6833,
    accuracy: 3
  },
  {
    postalCode: 4424,
    city: "Drillham",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6431,
    longitude: 149.9762,
    accuracy: 4
  },
  {
    postalCode: 4424,
    city: "Drillham South",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7755,
    longitude: 149.8266,
    accuracy: 3
  },
  {
    postalCode: 4424,
    city: "Glenaubyn",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7755,
    longitude: 149.8266,
    accuracy: 3
  },
  {
    postalCode: 4425,
    city: "Dulacca",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6452,
    longitude: 149.7612,
    accuracy: 4
  },
  {
    postalCode: 4425,
    city: "Bogandilla",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5,
    longitude: 149.8,
    accuracy: 4
  },
  {
    postalCode: 4426,
    city: "Jackson",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6452,
    longitude: 149.626,
    accuracy: 4
  },
  {
    postalCode: 4426,
    city: "Jackson North",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5332,
    longitude: 149.5778,
    accuracy: 3
  },
  {
    postalCode: 4426,
    city: "Jackson South",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5332,
    longitude: 149.5778,
    accuracy: 3
  },
  {
    postalCode: 4427,
    city: "Yuleba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6115,
    longitude: 149.3821,
    accuracy: 4
  },
  {
    postalCode: 4427,
    city: "Clifford",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6115,
    longitude: 149.3821,
    accuracy: 3
  },
  {
    postalCode: 4427,
    city: "Yuleba South",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6171,
    longitude: 149.3784,
    accuracy: 3
  },
  {
    postalCode: 4427,
    city: "Yuleba North",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6171,
    longitude: 149.3784,
    accuracy: 3
  },
  {
    postalCode: 4428,
    city: "Wallumbilla South",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6506,
    longitude: 149.2272,
    accuracy: 3
  },
  {
    postalCode: 4428,
    city: "Wallumbilla North",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3092,
    longitude: 149.2359,
    accuracy: 3
  },
  {
    postalCode: 4428,
    city: "Wallumbilla",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5827,
    longitude: 149.1871,
    accuracy: 4
  },
  {
    postalCode: 4428,
    city: "Pickanjinnie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5831,
    longitude: 149.1133,
    accuracy: 4
  },
  {
    postalCode: 4454,
    city: "Durham Downs",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5572,
    longitude: 148.1783,
    accuracy: 3
  },
  {
    postalCode: 4454,
    city: "Injune",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.8411,
    longitude: 148.5665,
    accuracy: 4
  },
  {
    postalCode: 4454,
    city: "Baffle West",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5572,
    longitude: 148.1783,
    accuracy: 3
  },
  {
    postalCode: 4454,
    city: "Highland Plains",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5572,
    longitude: 148.1783,
    accuracy: 3
  },
  {
    postalCode: 4454,
    city: "Hutton Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5572,
    longitude: 148.1783,
    accuracy: 3
  },
  {
    postalCode: 4454,
    city: "Beilba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5572,
    longitude: 148.1783,
    accuracy: 3
  },
  {
    postalCode: 4454,
    city: "Simmie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5572,
    longitude: 148.1783,
    accuracy: 3
  },
  {
    postalCode: 4454,
    city: "Westgrove",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5572,
    longitude: 148.1783,
    accuracy: 3
  },
  {
    postalCode: 4454,
    city: "Upper Dawson",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5572,
    longitude: 148.1783,
    accuracy: 3
  },
  {
    postalCode: 4454,
    city: "Mount Hutton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5572,
    longitude: 148.1783,
    accuracy: 3
  },
  {
    postalCode: 4454,
    city: "Pony Hills",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5572,
    longitude: 148.1783,
    accuracy: 3
  },
  {
    postalCode: 4455,
    city: "Orallo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.276,
    longitude: 148.5434,
    accuracy: 4
  },
  {
    postalCode: 4455,
    city: "Roma",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5674,
    longitude: 148.7875,
    accuracy: 4
  },
  {
    postalCode: 4455,
    city: "Dargal Road",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5495,
    longitude: 148.7172,
    accuracy: 3
  },
  {
    postalCode: 4455,
    city: "Wycombe",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3605,
    longitude: 148.7068,
    accuracy: 3
  },
  {
    postalCode: 4455,
    city: "Euthulla",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4913,
    longitude: 148.6656,
    accuracy: 3
  },
  {
    postalCode: 4455,
    city: "Mooga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2667,
    longitude: 148.9333,
    accuracy: 4
  },
  {
    postalCode: 4455,
    city: "Tingun",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.744,
    longitude: 148.9144,
    accuracy: 3
  },
  {
    postalCode: 4455,
    city: "Cornwall",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7779,
    longitude: 148.6938,
    accuracy: 3
  },
  {
    postalCode: 4455,
    city: "Ballaroo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3605,
    longitude: 148.7068,
    accuracy: 3
  },
  {
    postalCode: 4455,
    city: "Mount Abundance",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7779,
    longitude: 148.6938,
    accuracy: 3
  },
  {
    postalCode: 4455,
    city: "Bymount",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.0667,
    longitude: 148.5333,
    accuracy: 4
  },
  {
    postalCode: 4455,
    city: "Eumamurrin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1565,
    longitude: 148.6575,
    accuracy: 3
  },
  {
    postalCode: 4455,
    city: "Blythdale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.581,
    longitude: 148.9559,
    accuracy: 4
  },
  {
    postalCode: 4455,
    city: "Orange Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7779,
    longitude: 148.6938,
    accuracy: 3
  },
  {
    postalCode: 4455,
    city: "Hodgson",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5667,
    longitude: 148.6167,
    accuracy: 4
  },
  {
    postalCode: 4455,
    city: "Mount Bindango",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7779,
    longitude: 148.6938,
    accuracy: 3
  },
  {
    postalCode: 4455,
    city: "Gunnewin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.9884,
    longitude: 148.5586,
    accuracy: 4
  },
  {
    postalCode: 4455,
    city: "Bungil",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7779,
    longitude: 148.6938,
    accuracy: 3
  },
  {
    postalCode: 4455,
    city: "Bungeworgorai",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5798,
    longitude: 148.7197,
    accuracy: 4
  },
  {
    postalCode: 4461,
    city: "Muckadilla",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5896,
    longitude: 148.3919,
    accuracy: 4
  },
  {
    postalCode: 4462,
    city: "Amby",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.55,
    longitude: 148.1833,
    accuracy: 4
  },
  {
    postalCode: 4465,
    city: "Forestvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4924,
    longitude: 147.9038,
    accuracy: 3
  },
  {
    postalCode: 4465,
    city: "Womalilla",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5,
    longitude: 147.8333,
    accuracy: 4
  },
  {
    postalCode: 4465,
    city: "Dunkeld",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4924,
    longitude: 147.9038,
    accuracy: 3
  },
  {
    postalCode: 4465,
    city: "V Gate",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4924,
    longitude: 147.9038,
    accuracy: 3
  },
  {
    postalCode: 4465,
    city: "Mitchell",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4849,
    longitude: 147.9742,
    accuracy: 4
  },
  {
    postalCode: 4467,
    city: "Mungallala",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4491,
    longitude: 147.5418,
    accuracy: 4
  },
  {
    postalCode: 4467,
    city: "Tyrconnel",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.45,
    longitude: 147.5333,
    accuracy: 3
  },
  {
    postalCode: 4467,
    city: "Redford",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.45,
    longitude: 147.5333,
    accuracy: 3
  },
  {
    postalCode: 4468,
    city: "Clara Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4167,
    longitude: 147.1167,
    accuracy: 3
  },
  {
    postalCode: 4468,
    city: "Morven",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4177,
    longitude: 147.1139,
    accuracy: 4
  },
  {
    postalCode: 4470,
    city: "Riversleigh",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2694,
    longitude: 145.9547,
    accuracy: 3
  },
  {
    postalCode: 4470,
    city: "Charleville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4054,
    longitude: 146.2427,
    accuracy: 4
  },
  {
    postalCode: 4470,
    city: "Bakers Bend",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2694,
    longitude: 145.9547,
    accuracy: 3
  },
  {
    postalCode: 4470,
    city: "Langlo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1333,
    longitude: 145.6667,
    accuracy: 4
  },
  {
    postalCode: 4470,
    city: "Murweh",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2694,
    longitude: 145.9547,
    accuracy: 3
  },
  {
    postalCode: 4470,
    city: "Gowrie Station",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2694,
    longitude: 145.9547,
    accuracy: 3
  },
  {
    postalCode: 4471,
    city: "Claverton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3726,
    longitude: 145.9577,
    accuracy: 4
  },
  {
    postalCode: 4472,
    city: "Blackall",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.4233,
    longitude: 145.463,
    accuracy: 4
  },
  {
    postalCode: 4472,
    city: "Mount Enniskillen",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.587,
    longitude: 145.403,
    accuracy: 3
  },
  {
    postalCode: 4474,
    city: "Adavale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.9073,
    longitude: 144.6008,
    accuracy: 4
  },
  {
    postalCode: 4475,
    city: "Cheepie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6333,
    longitude: 145.0167,
    accuracy: 4
  },
  {
    postalCode: 4477,
    city: "Augathella",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.7962,
    longitude: 146.5845,
    accuracy: 4
  },
  {
    postalCode: 4477,
    city: "Upper Warrego",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6351,
    longitude: 145.9587,
    accuracy: 3
  },
  {
    postalCode: 4478,
    city: "Tambo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8819,
    longitude: 146.2575,
    accuracy: 4
  },
  {
    postalCode: 4478,
    city: "Lumeah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0182,
    longitude: 146.2489,
    accuracy: 3
  },
  {
    postalCode: 4478,
    city: "Caldervale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0182,
    longitude: 146.2489,
    accuracy: 3
  },
  {
    postalCode: 4478,
    city: "Macfarlane",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0182,
    longitude: 146.2489,
    accuracy: 3
  },
  {
    postalCode: 4478,
    city: "Minnie Downs",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0182,
    longitude: 146.2489,
    accuracy: 3
  },
  {
    postalCode: 4478,
    city: "Bayrick",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0182,
    longitude: 146.2489,
    accuracy: 3
  },
  {
    postalCode: 4478,
    city: "Windeyer",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0182,
    longitude: 146.2489,
    accuracy: 3
  },
  {
    postalCode: 4478,
    city: "Yandarlo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0182,
    longitude: 146.2489,
    accuracy: 3
  },
  {
    postalCode: 4478,
    city: "Lansdowne",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0182,
    longitude: 146.2489,
    accuracy: 3
  },
  {
    postalCode: 4478,
    city: "Scrubby Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0182,
    longitude: 146.2489,
    accuracy: 3
  },
  {
    postalCode: 4479,
    city: "Cooladdi",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6426,
    longitude: 145.4644,
    accuracy: 4
  },
  {
    postalCode: 4480,
    city: "Quilpie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6135,
    longitude: 144.2695,
    accuracy: 4
  },
  {
    postalCode: 4480,
    city: "Eromanga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6706,
    longitude: 143.2664,
    accuracy: 4
  },
  {
    postalCode: 4481,
    city: "Tanbar",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.4211,
    longitude: 141.8981,
    accuracy: 3
  },
  {
    postalCode: 4481,
    city: "Windorah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.4222,
    longitude: 142.6566,
    accuracy: 4
  },
  {
    postalCode: 4481,
    city: "Farrars Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1566,
    longitude: 147.6171,
    accuracy: 3
  },
  {
    postalCode: 4482,
    city: "Birdsville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.592,
    longitude: 140.1157,
    accuracy: 1
  },
  {
    postalCode: 4486,
    city: "Hebel",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.9733,
    longitude: 147.7948,
    accuracy: 4
  },
  {
    postalCode: 4486,
    city: "Dirranbandi",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.5854,
    longitude: 148.2255,
    accuracy: 4
  },
  {
    postalCode: 4487,
    city: "St George",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9476,
    longitude: 148.6099,
    accuracy: 4
  },
  {
    postalCode: 4487,
    city: "Begonia",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9476,
    longitude: 148.6099,
    accuracy: 3
  },
  {
    postalCode: 4488,
    city: "Nebine",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.2776,
    longitude: 147.4572,
    accuracy: 3
  },
  {
    postalCode: 4488,
    city: "Bollon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0333,
    longitude: 147.4833,
    accuracy: 4
  },
  {
    postalCode: 4489,
    city: "Wyandra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2478,
    longitude: 145.9805,
    accuracy: 4
  },
  {
    postalCode: 4490,
    city: "Cunnamulla",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0677,
    longitude: 145.6844,
    accuracy: 4
  },
  {
    postalCode: 4490,
    city: "Tuen",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.5667,
    longitude: 145.7167,
    accuracy: 4
  },
  {
    postalCode: 4490,
    city: "Widgeegoara",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.2377,
    longitude: 145.9073,
    accuracy: 3
  },
  {
    postalCode: 4490,
    city: "Barringun",
    state_name: "Queensland",
    state: "QLD",
    latitude: -29.0141,
    longitude: 145.7159,
    accuracy: 4
  },
  {
    postalCode: 4490,
    city: "Coongoola",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.6536,
    longitude: 145.9022,
    accuracy: 4
  },
  {
    postalCode: 4490,
    city: "Yowah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.9683,
    longitude: 144.6362,
    accuracy: 3
  },
  {
    postalCode: 4490,
    city: "Noorama",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.2377,
    longitude: 145.9073,
    accuracy: 3
  },
  {
    postalCode: 4490,
    city: "Cuttaburra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.2377,
    longitude: 145.9073,
    accuracy: 3
  },
  {
    postalCode: 4490,
    city: "Humeburn",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.2377,
    longitude: 145.9073,
    accuracy: 3
  },
  {
    postalCode: 4490,
    city: "Linden",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.2377,
    longitude: 145.9073,
    accuracy: 3
  },
  {
    postalCode: 4490,
    city: "Jobs Gate",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.2377,
    longitude: 145.9073,
    accuracy: 3
  },
  {
    postalCode: 4491,
    city: "Eulo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.1599,
    longitude: 145.0471,
    accuracy: 4
  },
  {
    postalCode: 4492,
    city: "Dynevor",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.375,
    longitude: 148.7972,
    accuracy: 3
  },
  {
    postalCode: 4492,
    city: "Nockatunga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.375,
    longitude: 148.7972,
    accuracy: 3
  },
  {
    postalCode: 4492,
    city: "Bullawarra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.375,
    longitude: 148.7972,
    accuracy: 3
  },
  {
    postalCode: 4492,
    city: "Norley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.375,
    longitude: 148.7972,
    accuracy: 3
  },
  {
    postalCode: 4492,
    city: "Bulloo Downs",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.375,
    longitude: 148.7972,
    accuracy: 3
  },
  {
    postalCode: 4492,
    city: "Thargomindah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.995,
    longitude: 143.8239,
    accuracy: 4
  },
  {
    postalCode: 4493,
    city: "Hungerford",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.9963,
    longitude: 144.407,
    accuracy: 4
  },
  {
    postalCode: 4494,
    city: "Bungunya",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.4294,
    longitude: 149.6555,
    accuracy: 4
  },
  {
    postalCode: 4494,
    city: "North Bungunya",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.2718,
    longitude: 149.8403,
    accuracy: 3
  },
  {
    postalCode: 4494,
    city: "Tarawera",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.2718,
    longitude: 149.8403,
    accuracy: 3
  },
  {
    postalCode: 4496,
    city: "Talwood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.4858,
    longitude: 149.4681,
    accuracy: 4
  },
  {
    postalCode: 4496,
    city: "South Talwood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.3773,
    longitude: 149.1424,
    accuracy: 3
  },
  {
    postalCode: 4496,
    city: "North Talwood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.3773,
    longitude: 149.1424,
    accuracy: 3
  },
  {
    postalCode: 4497,
    city: "Thallon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.6379,
    longitude: 148.8683,
    accuracy: 4
  },
  {
    postalCode: 4497,
    city: "Weengallon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.5021,
    longitude: 148.8399,
    accuracy: 3
  },
  {
    postalCode: 4497,
    city: "Daymar",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.6043,
    longitude: 148.9792,
    accuracy: 4
  },
  {
    postalCode: 4498,
    city: "Kioma",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.332,
    longitude: 149.5801,
    accuracy: 3
  },
  {
    postalCode: 4498,
    city: "Toobeah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.4206,
    longitude: 149.8662,
    accuracy: 4
  },
  {
    postalCode: 4500,
    city: "Brendale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3211,
    longitude: 152.9839,
    accuracy: 4
  },
  {
    postalCode: 4500,
    city: "Warner",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3122,
    longitude: 152.9498,
    accuracy: 4
  },
  {
    postalCode: 4500,
    city: "Brendale BC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3006,
    longitude: 152.9571,
    accuracy: 3
  },
  {
    postalCode: 4500,
    city: "Clear Mountain",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3052,
    longitude: 152.883,
    accuracy: 4
  },
  {
    postalCode: 4500,
    city: "Strathpine Centre",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3006,
    longitude: 152.9571,
    accuracy: 3
  },
  {
    postalCode: 4500,
    city: "Joyner",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2761,
    longitude: 152.9447,
    accuracy: 4
  },
  {
    postalCode: 4500,
    city: "Brendale DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3006,
    longitude: 152.9571,
    accuracy: 3
  },
  {
    postalCode: 4500,
    city: "Strathpine",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3041,
    longitude: 152.9898,
    accuracy: 4
  },
  {
    postalCode: 4500,
    city: "Cashmere",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2977,
    longitude: 152.9066,
    accuracy: 4
  },
  {
    postalCode: 4500,
    city: "Bray Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2925,
    longitude: 152.9678,
    accuracy: 4
  },
  {
    postalCode: 4501,
    city: "Lawnton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2833,
    longitude: 152.9833,
    accuracy: 4
  },
  {
    postalCode: 4502,
    city: "Petrie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2667,
    longitude: 152.9833,
    accuracy: 4
  },
  {
    postalCode: 4503,
    city: "Murrumba Downs",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2673,
    longitude: 153.0105,
    accuracy: 4
  },
  {
    postalCode: 4503,
    city: "Kallangur",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.252,
    longitude: 152.9923,
    accuracy: 4
  },
  {
    postalCode: 4503,
    city: "Griffin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2715,
    longitude: 153.0394,
    accuracy: 4
  },
  {
    postalCode: 4503,
    city: "Kurwongbah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2325,
    longitude: 152.9762,
    accuracy: 4
  },
  {
    postalCode: 4503,
    city: "Dakabin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2259,
    longitude: 152.991,
    accuracy: 4
  },
  {
    postalCode: 4503,
    city: "Whiteside",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2571,
    longitude: 152.9116,
    accuracy: 4
  },
  {
    postalCode: 4504,
    city: "Narangba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2034,
    longitude: 152.9592,
    accuracy: 4
  },
  {
    postalCode: 4505,
    city: "Burpengary",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1575,
    longitude: 152.9576,
    accuracy: 4
  },
  {
    postalCode: 4505,
    city: "Burpengary DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1575,
    longitude: 152.9576,
    accuracy: 3
  },
  {
    postalCode: 4505,
    city: "Burpengary East",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1575,
    longitude: 152.9576,
    accuracy: 3
  },
  {
    postalCode: 4506,
    city: "Moorina",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1491,
    longitude: 152.873,
    accuracy: 4
  },
  {
    postalCode: 4506,
    city: "Morayfield",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1088,
    longitude: 152.9491,
    accuracy: 4
  },
  {
    postalCode: 4507,
    city: "Bongaree",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0837,
    longitude: 153.1594,
    accuracy: 4
  },
  {
    postalCode: 4507,
    city: "Bellara",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0639,
    longitude: 153.1496,
    accuracy: 4
  },
  {
    postalCode: 4507,
    city: "Banksia Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0403,
    longitude: 153.1439,
    accuracy: 4
  },
  {
    postalCode: 4507,
    city: "Woorim",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0693,
    longitude: 153.2043,
    accuracy: 4
  },
  {
    postalCode: 4507,
    city: "Bribie Island North",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0149,
    longitude: 153.1446,
    accuracy: 3
  },
  {
    postalCode: 4507,
    city: "White Patch",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0307,
    longitude: 153.1282,
    accuracy: 4
  },
  {
    postalCode: 4507,
    city: "Bribie Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0149,
    longitude: 153.1446,
    accuracy: 3
  },
  {
    postalCode: 4507,
    city: "Welsby",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.9714,
    longitude: 153.1292,
    accuracy: 4
  },
  {
    postalCode: 4508,
    city: "Deception Bay",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1935,
    longitude: 153.0263,
    accuracy: 4
  },
  {
    postalCode: 4509,
    city: "North Lakes",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2243,
    longitude: 153.0208,
    accuracy: 4
  },
  {
    postalCode: 4509,
    city: "Mango Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2435,
    longitude: 153.0238,
    accuracy: 4
  },
  {
    postalCode: 4510,
    city: "Caboolture",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0846,
    longitude: 152.9511,
    accuracy: 4
  },
  {
    postalCode: 4510,
    city: "Rocksberg",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1,
    longitude: 152.8333,
    accuracy: 4
  },
  {
    postalCode: 4510,
    city: "Upper Caboolture",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1167,
    longitude: 152.8833,
    accuracy: 4
  },
  {
    postalCode: 4510,
    city: "Caboolture BC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0772,
    longitude: 152.9595,
    accuracy: 3
  },
  {
    postalCode: 4510,
    city: "Caboolture South",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0939,
    longitude: 152.9487,
    accuracy: 4
  },
  {
    postalCode: 4510,
    city: "Donnybrook",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.005,
    longitude: 153.0673,
    accuracy: 4
  },
  {
    postalCode: 4510,
    city: "Moodlu",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0667,
    longitude: 152.9,
    accuracy: 4
  },
  {
    postalCode: 4510,
    city: "Toorbul",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0322,
    longitude: 153.0983,
    accuracy: 4
  },
  {
    postalCode: 4510,
    city: "Bellmere",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0844,
    longitude: 152.89,
    accuracy: 4
  },
  {
    postalCode: 4510,
    city: "Meldale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0323,
    longitude: 153.0724,
    accuracy: 4
  },
  {
    postalCode: 4510,
    city: "Beachmere",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1281,
    longitude: 153.0524,
    accuracy: 4
  },
  {
    postalCode: 4511,
    city: "Godwin Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0861,
    longitude: 153.0986,
    accuracy: 4
  },
  {
    postalCode: 4511,
    city: "Sandstone Point",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0837,
    longitude: 153.1324,
    accuracy: 4
  },
  {
    postalCode: 4511,
    city: "Ningi",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0611,
    longitude: 153.0788,
    accuracy: 4
  },
  {
    postalCode: 4512,
    city: "Wamuran",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0391,
    longitude: 152.8654,
    accuracy: 4
  },
  {
    postalCode: 4512,
    city: "Wamuran Basin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0475,
    longitude: 152.8262,
    accuracy: 4
  },
  {
    postalCode: 4512,
    city: "Bracalba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0167,
    longitude: 152.85,
    accuracy: 4
  },
  {
    postalCode: 4514,
    city: "D'Aguilar",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.9833,
    longitude: 152.8,
    accuracy: 4
  },
  {
    postalCode: 4514,
    city: "Woodford",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.9529,
    longitude: 152.7775,
    accuracy: 4
  },
  {
    postalCode: 4514,
    city: "Mount Delaney",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0147,
    longitude: 152.7148,
    accuracy: 4
  },
  {
    postalCode: 4514,
    city: "Villeneuve",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.9667,
    longitude: 152.6333,
    accuracy: 4
  },
  {
    postalCode: 4514,
    city: "Neurum",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.9667,
    longitude: 152.7,
    accuracy: 4
  },
  {
    postalCode: 4514,
    city: "Bellthorpe",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.8554,
    longitude: 152.7609,
    accuracy: 4
  },
  {
    postalCode: 4514,
    city: "Stony Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.9272,
    longitude: 152.7124,
    accuracy: 4
  },
  {
    postalCode: 4514,
    city: "Stanmore",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.8814,
    longitude: 152.788,
    accuracy: 4
  },
  {
    postalCode: 4514,
    city: "Cedarton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.85,
    longitude: 152.8167,
    accuracy: 4
  },
  {
    postalCode: 4514,
    city: "Delaneys Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0002,
    longitude: 152.7955,
    accuracy: 4
  },
  {
    postalCode: 4514,
    city: "Mount Archer",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.9307,
    longitude: 152.7552,
    accuracy: 3
  },
  {
    postalCode: 4514,
    city: "Commissioners Flat",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.9307,
    longitude: 152.7552,
    accuracy: 3
  },
  {
    postalCode: 4515,
    city: "Hazeldean",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0321,
    longitude: 152.5404,
    accuracy: 4
  },
  {
    postalCode: 4515,
    city: "Jimna",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6676,
    longitude: 152.4633,
    accuracy: 4
  },
  {
    postalCode: 4515,
    city: "Royston",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.95,
    longitude: 152.65,
    accuracy: 4
  },
  {
    postalCode: 4515,
    city: "Kilcoy",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.943,
    longitude: 152.5654,
    accuracy: 4
  },
  {
    postalCode: 4515,
    city: "Sandy Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.8506,
    longitude: 152.6377,
    accuracy: 4
  },
  {
    postalCode: 4515,
    city: "Woolmar",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.8907,
    longitude: 152.577,
    accuracy: 3
  },
  {
    postalCode: 4515,
    city: "Winya",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.8907,
    longitude: 152.577,
    accuracy: 3
  },
  {
    postalCode: 4515,
    city: "Sheep Station Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.8907,
    longitude: 152.577,
    accuracy: 3
  },
  {
    postalCode: 4515,
    city: "Mount Kilcoy",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.8426,
    longitude: 152.5787,
    accuracy: 4
  },
  {
    postalCode: 4515,
    city: "Hazledean",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7416,
    longitude: 152.4735,
    accuracy: 3
  },
  {
    postalCode: 4515,
    city: "Glenfern",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.95,
    longitude: 152.6,
    accuracy: 4
  },
  {
    postalCode: 4515,
    city: "Monsildale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7416,
    longitude: 152.4735,
    accuracy: 3
  },
  {
    postalCode: 4515,
    city: "Kingaham",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.8907,
    longitude: 152.577,
    accuracy: 3
  },
  {
    postalCode: 4516,
    city: "Elimbah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0167,
    longitude: 152.95,
    accuracy: 4
  },
  {
    postalCode: 4517,
    city: "Beerburrum",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.957,
    longitude: 152.9554,
    accuracy: 4
  },
  {
    postalCode: 4518,
    city: "Glass House Mountains",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.8976,
    longitude: 152.9532,
    accuracy: 4
  },
  {
    postalCode: 4519,
    city: "Beerwah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.8588,
    longitude: 152.9614,
    accuracy: 4
  },
  {
    postalCode: 4519,
    city: "Crohamhurst",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.807,
    longitude: 152.8617,
    accuracy: 4
  },
  {
    postalCode: 4519,
    city: "Peachester",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.8455,
    longitude: 152.884,
    accuracy: 4
  },
  {
    postalCode: 4519,
    city: "Coochin Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.9051,
    longitude: 153.0749,
    accuracy: 4
  },
  {
    postalCode: 4520,
    city: "Mount Samson",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3,
    longitude: 152.85,
    accuracy: 4
  },
  {
    postalCode: 4520,
    city: "Samford Valley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3727,
    longitude: 152.867,
    accuracy: 4
  },
  {
    postalCode: 4520,
    city: "Mount Nebo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3974,
    longitude: 152.7845,
    accuracy: 4
  },
  {
    postalCode: 4520,
    city: "Kobble Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.25,
    longitude: 152.8333,
    accuracy: 4
  },
  {
    postalCode: 4520,
    city: "Cedar Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3335,
    longitude: 152.8187,
    accuracy: 4
  },
  {
    postalCode: 4520,
    city: "Yugar",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3457,
    longitude: 152.8718,
    accuracy: 4
  },
  {
    postalCode: 4520,
    city: "Highvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3723,
    longitude: 152.802,
    accuracy: 4
  },
  {
    postalCode: 4520,
    city: "Mount Glorious",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3339,
    longitude: 152.7668,
    accuracy: 4
  },
  {
    postalCode: 4520,
    city: "Samford Village",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3727,
    longitude: 152.8866,
    accuracy: 4
  },
  {
    postalCode: 4520,
    city: "Wights Mountain",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3933,
    longitude: 152.8554,
    accuracy: 4
  },
  {
    postalCode: 4520,
    city: "Closeburn",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3333,
    longitude: 152.8333,
    accuracy: 4
  },
  {
    postalCode: 4520,
    city: "Samford",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3727,
    longitude: 152.8866,
    accuracy: 4
  },
  {
    postalCode: 4520,
    city: "Draper",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.3526,
    longitude: 152.9065,
    accuracy: 4
  },
  {
    postalCode: 4520,
    city: "Jollys Lookout",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4001,
    longitude: 152.8073,
    accuracy: 4
  },
  {
    postalCode: 4520,
    city: "Armstrong Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2167,
    longitude: 152.8333,
    accuracy: 4
  },
  {
    postalCode: 4520,
    city: "Enoggera Reservoir",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4335,
    longitude: 152.8705,
    accuracy: 4
  },
  {
    postalCode: 4520,
    city: "Samsonvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2667,
    longitude: 152.85,
    accuracy: 4
  },
  {
    postalCode: 4520,
    city: "Camp Mountain",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4,
    longitude: 152.8833,
    accuracy: 4
  },
  {
    postalCode: 4521,
    city: "Campbells Pocket",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0767,
    longitude: 152.805,
    accuracy: 4
  },
  {
    postalCode: 4521,
    city: "Dayboro",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1963,
    longitude: 152.8225,
    accuracy: 4
  },
  {
    postalCode: 4521,
    city: "Ocean View",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1271,
    longitude: 152.8053,
    accuracy: 4
  },
  {
    postalCode: 4521,
    city: "Mount Pleasant",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1489,
    longitude: 152.7636,
    accuracy: 4
  },
  {
    postalCode: 4521,
    city: "Mount Mee",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.0806,
    longitude: 152.7702,
    accuracy: 4
  },
  {
    postalCode: 4521,
    city: "Rush Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2086,
    longitude: 152.8642,
    accuracy: 4
  },
  {
    postalCode: 4521,
    city: "Laceys Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.2319,
    longitude: 152.7313,
    accuracy: 4
  },
  {
    postalCode: 4521,
    city: "King Scrub",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.1732,
    longitude: 152.8215,
    accuracy: 4
  },
  {
    postalCode: 4550,
    city: "Landsborough",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.8067,
    longitude: 152.961,
    accuracy: 4
  },
  {
    postalCode: 4550,
    city: "Mount Mellum",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.816,
    longitude: 152.9335,
    accuracy: 4
  },
  {
    postalCode: 4551,
    city: "Kings Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.8017,
    longitude: 153.1426,
    accuracy: 4
  },
  {
    postalCode: 4551,
    city: "Shelly Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7965,
    longitude: 153.1458,
    accuracy: 4
  },
  {
    postalCode: 4551,
    city: "Aroona",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7817,
    longitude: 153.1165,
    accuracy: 4
  },
  {
    postalCode: 4551,
    city: "Little Mountain",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7844,
    longitude: 153.0922,
    accuracy: 4
  },
  {
    postalCode: 4551,
    city: "Caloundra BC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7961,
    longitude: 153.1229,
    accuracy: 3
  },
  {
    postalCode: 4551,
    city: "Bells Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7836,
    longitude: 153.0605,
    accuracy: 4
  },
  {
    postalCode: 4551,
    city: "Golden Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.8218,
    longitude: 153.1197,
    accuracy: 4
  },
  {
    postalCode: 4551,
    city: "Currimundi",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7693,
    longitude: 153.1224,
    accuracy: 4
  },
  {
    postalCode: 4551,
    city: "Battery Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7788,
    longitude: 153.1289,
    accuracy: 4
  },
  {
    postalCode: 4551,
    city: "Pelican Waters",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.8335,
    longitude: 153.1001,
    accuracy: 4
  },
  {
    postalCode: 4551,
    city: "Caloundra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.8035,
    longitude: 153.1219,
    accuracy: 4
  },
  {
    postalCode: 4551,
    city: "Moffat Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7905,
    longitude: 153.14,
    accuracy: 4
  },
  {
    postalCode: 4551,
    city: "Caloundra DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7961,
    longitude: 153.1229,
    accuracy: 3
  },
  {
    postalCode: 4551,
    city: "Caloundra West",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7985,
    longitude: 153.114,
    accuracy: 4
  },
  {
    postalCode: 4551,
    city: "Meridan Plains",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7735,
    longitude: 153.0619,
    accuracy: 4
  },
  {
    postalCode: 4551,
    city: "Dicky Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7836,
    longitude: 153.1377,
    accuracy: 4
  },
  {
    postalCode: 4552,
    city: "Booroobin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.8224,
    longitude: 152.7666,
    accuracy: 4
  },
  {
    postalCode: 4552,
    city: "Maleny",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.76,
    longitude: 152.8493,
    accuracy: 4
  },
  {
    postalCode: 4552,
    city: "North Maleny",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7521,
    longitude: 152.8583,
    accuracy: 4
  },
  {
    postalCode: 4552,
    city: "Curramore",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6937,
    longitude: 152.803,
    accuracy: 4
  },
  {
    postalCode: 4552,
    city: "Cambroon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6394,
    longitude: 152.6853,
    accuracy: 4
  },
  {
    postalCode: 4552,
    city: "Reesville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7595,
    longitude: 152.7879,
    accuracy: 4
  },
  {
    postalCode: 4552,
    city: "Bald Knob",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.779,
    longitude: 152.9118,
    accuracy: 4
  },
  {
    postalCode: 4552,
    city: "Elaman Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7374,
    longitude: 152.7524,
    accuracy: 4
  },
  {
    postalCode: 4552,
    city: "Conondale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7364,
    longitude: 152.7199,
    accuracy: 4
  },
  {
    postalCode: 4552,
    city: "Balmoral Ridge",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7445,
    longitude: 152.8922,
    accuracy: 4
  },
  {
    postalCode: 4552,
    city: "Crystal Waters",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7395,
    longitude: 152.8249,
    accuracy: 3
  },
  {
    postalCode: 4552,
    city: "Wootha",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7882,
    longitude: 152.8009,
    accuracy: 4
  },
  {
    postalCode: 4552,
    city: "Witta",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7,
    longitude: 152.8167,
    accuracy: 4
  },
  {
    postalCode: 4552,
    city: "Harper Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7623,
    longitude: 152.7117,
    accuracy: 4
  },
  {
    postalCode: 4553,
    city: "Glenview",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7667,
    longitude: 153.0167,
    accuracy: 4
  },
  {
    postalCode: 4553,
    city: "Mooloolah Valley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7655,
    longitude: 152.9587,
    accuracy: 4
  },
  {
    postalCode: 4553,
    city: "Mooloolah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7655,
    longitude: 152.9587,
    accuracy: 4
  },
  {
    postalCode: 4553,
    city: "Diamond Valley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7552,
    longitude: 152.9293,
    accuracy: 4
  },
  {
    postalCode: 4553,
    city: "Palmview",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.746,
    longitude: 153.0599,
    accuracy: 4
  },
  {
    postalCode: 4554,
    city: "Ilkley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.731,
    longitude: 152.9977,
    accuracy: 4
  },
  {
    postalCode: 4554,
    city: "Eudlo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7296,
    longitude: 152.954,
    accuracy: 4
  },
  {
    postalCode: 4555,
    city: "Chevallum",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7007,
    longitude: 152.9935,
    accuracy: 4
  },
  {
    postalCode: 4555,
    city: "Palmwoods",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6858,
    longitude: 152.9613,
    accuracy: 4
  },
  {
    postalCode: 4555,
    city: "Hunchy",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6799,
    longitude: 152.9109,
    accuracy: 4
  },
  {
    postalCode: 4555,
    city: "Landers Shoot",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7134,
    longitude: 152.9267,
    accuracy: 4
  },
  {
    postalCode: 4556,
    city: "Mons",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6916,
    longitude: 153.025,
    accuracy: 4
  },
  {
    postalCode: 4556,
    city: "Forest Glen",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6886,
    longitude: 153.0045,
    accuracy: 4
  },
  {
    postalCode: 4556,
    city: "Sippy Downs",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7179,
    longitude: 153.0547,
    accuracy: 4
  },
  {
    postalCode: 4556,
    city: "Buderim",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6844,
    longitude: 153.0571,
    accuracy: 4
  },
  {
    postalCode: 4556,
    city: "Kunda Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6643,
    longitude: 153.0354,
    accuracy: 4
  },
  {
    postalCode: 4556,
    city: "Tanawha",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7198,
    longitude: 153.0302,
    accuracy: 4
  },
  {
    postalCode: 4557,
    city: "Mountain Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7028,
    longitude: 153.1013,
    accuracy: 4
  },
  {
    postalCode: 4557,
    city: "Mooloolaba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6816,
    longitude: 153.1192,
    accuracy: 4
  },
  {
    postalCode: 4558,
    city: "Maroochydore DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6589,
    longitude: 153.0778,
    accuracy: 3
  },
  {
    postalCode: 4558,
    city: "Sunshine Plaza",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6546,
    longitude: 153.0777,
    accuracy: 3
  },
  {
    postalCode: 4558,
    city: "Maroochydore Bc",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6546,
    longitude: 153.0777,
    accuracy: 3
  },
  {
    postalCode: 4558,
    city: "Maroochydore",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6601,
    longitude: 153.0995,
    accuracy: 4
  },
  {
    postalCode: 4558,
    city: "Kuluin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6578,
    longitude: 153.0561,
    accuracy: 4
  },
  {
    postalCode: 4558,
    city: "Cotton Tree",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6535,
    longitude: 153.1012,
    accuracy: 4
  },
  {
    postalCode: 4559,
    city: "Woombye",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6605,
    longitude: 152.9695,
    accuracy: 4
  },
  {
    postalCode: 4559,
    city: "Diddillibah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6417,
    longitude: 153.0496,
    accuracy: 4
  },
  {
    postalCode: 4559,
    city: "Kiels Mountain",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6565,
    longitude: 153.0081,
    accuracy: 4
  },
  {
    postalCode: 4559,
    city: "West Woombye",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6664,
    longitude: 152.9256,
    accuracy: 4
  },
  {
    postalCode: 4560,
    city: "Parklands",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5955,
    longitude: 152.9789,
    accuracy: 4
  },
  {
    postalCode: 4560,
    city: "Nambour BC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6218,
    longitude: 152.9337,
    accuracy: 3
  },
  {
    postalCode: 4560,
    city: "Burnside",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6325,
    longitude: 152.9406,
    accuracy: 4
  },
  {
    postalCode: 4560,
    city: "Towen Mountain",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6468,
    longitude: 152.9284,
    accuracy: 4
  },
  {
    postalCode: 4560,
    city: "Rosemount",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6303,
    longitude: 152.9997,
    accuracy: 4
  },
  {
    postalCode: 4560,
    city: "Kiamba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5727,
    longitude: 152.9241,
    accuracy: 4
  },
  {
    postalCode: 4560,
    city: "Kulangoor",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5833,
    longitude: 152.9667,
    accuracy: 4
  },
  {
    postalCode: 4560,
    city: "Nambour",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6261,
    longitude: 152.9594,
    accuracy: 4
  },
  {
    postalCode: 4560,
    city: "Dulong",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6339,
    longitude: 152.9062,
    accuracy: 4
  },
  {
    postalCode: 4560,
    city: "Image Flat",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.601,
    longitude: 152.933,
    accuracy: 4
  },
  {
    postalCode: 4560,
    city: "Mapleton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6243,
    longitude: 152.8678,
    accuracy: 4
  },
  {
    postalCode: 4560,
    city: "Highworth",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6174,
    longitude: 152.9344,
    accuracy: 4
  },
  {
    postalCode: 4560,
    city: "Perwillowen",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6333,
    longitude: 152.9167,
    accuracy: 4
  },
  {
    postalCode: 4560,
    city: "Coes Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6472,
    longitude: 152.9494,
    accuracy: 4
  },
  {
    postalCode: 4560,
    city: "Montville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6833,
    longitude: 152.8833,
    accuracy: 4
  },
  {
    postalCode: 4560,
    city: "Nambour DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6218,
    longitude: 152.9337,
    accuracy: 3
  },
  {
    postalCode: 4560,
    city: "Cooloolabin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.55,
    longitude: 152.8833,
    accuracy: 4
  },
  {
    postalCode: 4560,
    city: "Sunshine Coast Mc",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6218,
    longitude: 152.9337,
    accuracy: 3
  },
  {
    postalCode: 4560,
    city: "Nambour West",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6218,
    longitude: 152.9337,
    accuracy: 3
  },
  {
    postalCode: 4560,
    city: "Kureelpa",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6067,
    longitude: 152.891,
    accuracy: 4
  },
  {
    postalCode: 4560,
    city: "Flaxton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6571,
    longitude: 152.8641,
    accuracy: 4
  },
  {
    postalCode: 4560,
    city: "Bli Bli",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6172,
    longitude: 153.0367,
    accuracy: 4
  },
  {
    postalCode: 4561,
    city: "Yandina",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5616,
    longitude: 152.9559,
    accuracy: 4
  },
  {
    postalCode: 4561,
    city: "Valdora",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5459,
    longitude: 153.0068,
    accuracy: 4
  },
  {
    postalCode: 4561,
    city: "Yandina Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5387,
    longitude: 153.0389,
    accuracy: 4
  },
  {
    postalCode: 4561,
    city: "Maroochy River",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5777,
    longitude: 153.0188,
    accuracy: 4
  },
  {
    postalCode: 4561,
    city: "Ninderry",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5409,
    longitude: 152.9752,
    accuracy: 4
  },
  {
    postalCode: 4561,
    city: "Bridges",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5333,
    longitude: 152.95,
    accuracy: 4
  },
  {
    postalCode: 4561,
    city: "North Arm",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5248,
    longitude: 152.9552,
    accuracy: 4
  },
  {
    postalCode: 4562,
    city: "Belli Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5085,
    longitude: 152.8212,
    accuracy: 4
  },
  {
    postalCode: 4562,
    city: "Doonan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4396,
    longitude: 152.992,
    accuracy: 4
  },
  {
    postalCode: 4562,
    city: "Verrierdale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4821,
    longitude: 152.9986,
    accuracy: 4
  },
  {
    postalCode: 4562,
    city: "Weyba Downs",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4495,
    longitude: 153.0472,
    accuracy: 4
  },
  {
    postalCode: 4562,
    city: "Eumundi",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4774,
    longitude: 152.9512,
    accuracy: 4
  },
  {
    postalCode: 4562,
    city: "Eerwah Vale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4794,
    longitude: 152.9112,
    accuracy: 4
  },
  {
    postalCode: 4563,
    city: "Carters Ridge",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4525,
    longitude: 152.772,
    accuracy: 4
  },
  {
    postalCode: 4563,
    city: "Black Mountain",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3989,
    longitude: 152.8756,
    accuracy: 4
  },
  {
    postalCode: 4563,
    city: "Cooroy Mountain",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4252,
    longitude: 152.9541,
    accuracy: 4
  },
  {
    postalCode: 4563,
    city: "Tinbeerwah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4044,
    longitude: 152.9826,
    accuracy: 4
  },
  {
    postalCode: 4563,
    city: "Cooroy",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4178,
    longitude: 152.9115,
    accuracy: 4
  },
  {
    postalCode: 4563,
    city: "Ridgewood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4605,
    longitude: 152.7991,
    accuracy: 4
  },
  {
    postalCode: 4563,
    city: "Lake Macdonald",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3848,
    longitude: 152.9321,
    accuracy: 4
  },
  {
    postalCode: 4564,
    city: "Pacific Paradise",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6181,
    longitude: 153.0778,
    accuracy: 4
  },
  {
    postalCode: 4564,
    city: "Marcoola",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5845,
    longitude: 153.0947,
    accuracy: 4
  },
  {
    postalCode: 4564,
    city: "Mudjimba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.615,
    longitude: 153.0989,
    accuracy: 4
  },
  {
    postalCode: 4564,
    city: "Twin Waters",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.61,
    longitude: 153,
    accuracy: 4
  },
  {
    postalCode: 4565,
    city: "Ringtail Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3439,
    longitude: 152.9668,
    accuracy: 4
  },
  {
    postalCode: 4565,
    city: "Cootharaba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2667,
    longitude: 152.9667,
    accuracy: 4
  },
  {
    postalCode: 4565,
    city: "Boreen Point",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2861,
    longitude: 152.9882,
    accuracy: 4
  },
  {
    postalCode: 4565,
    city: "Noosa North Shore",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3704,
    longitude: 153.0404,
    accuracy: 4
  },
  {
    postalCode: 4565,
    city: "Cooroibah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3632,
    longitude: 152.986,
    accuracy: 4
  },
  {
    postalCode: 4565,
    city: "Tewantin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.391,
    longitude: 153.0343,
    accuracy: 4
  },
  {
    postalCode: 4565,
    city: "North Shore",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3704,
    longitude: 153.0404,
    accuracy: 4
  },
  {
    postalCode: 4566,
    city: "Noosaville DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4,
    longitude: 153.0667,
    accuracy: 3
  },
  {
    postalCode: 4566,
    city: "Noosaville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4,
    longitude: 153.0667,
    accuracy: 4
  },
  {
    postalCode: 4567,
    city: "Castaways Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4299,
    longitude: 153.0979,
    accuracy: 4
  },
  {
    postalCode: 4567,
    city: "Sunshine Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.403,
    longitude: 153.0963,
    accuracy: 3
  },
  {
    postalCode: 4567,
    city: "Sunrise Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4165,
    longitude: 153.103,
    accuracy: 4
  },
  {
    postalCode: 4567,
    city: "Noosa Heads",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3943,
    longitude: 153.0901,
    accuracy: 4
  },
  {
    postalCode: 4568,
    city: "Pinbarren",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3333,
    longitude: 152.85,
    accuracy: 4
  },
  {
    postalCode: 4568,
    city: "Federal",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3942,
    longitude: 152.8076,
    accuracy: 4
  },
  {
    postalCode: 4568,
    city: "Pomona",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3668,
    longitude: 152.8557,
    accuracy: 4
  },
  {
    postalCode: 4569,
    city: "Cooran",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3369,
    longitude: 152.8225,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Bollier",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4368,
    longitude: 152.7333,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Chatsworth",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.144,
    longitude: 152.615,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Widgee",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2203,
    longitude: 152.4079,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Gympie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1898,
    longitude: 152.665,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Theebine",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.9505,
    longitude: 152.5409,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Calgoa",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1931,
    longitude: 152.5564,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Nahrunda",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2026,
    longitude: 152.6246,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Traveston",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3167,
    longitude: 152.7833,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Lagoon Pocket",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2667,
    longitude: 152.6667,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Veteran",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.159,
    longitude: 152.6898,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Gunalda",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.9987,
    longitude: 152.562,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Southside",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.21,
    longitude: 152.6472,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Tamaree",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1346,
    longitude: 152.6636,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Kia Ora",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1931,
    longitude: 152.5564,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Langshaw",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3,
    longitude: 152.5667,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Imbil",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4596,
    longitude: 152.6781,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Dagun",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3167,
    longitude: 152.6833,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Banks Pocket",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1931,
    longitude: 152.5564,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Kandanga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3927,
    longitude: 152.6767,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "East Deep Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1976,
    longitude: 152.7175,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Amamoor",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3492,
    longitude: 152.6793,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Mooloo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1931,
    longitude: 152.5564,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Wallu",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2008,
    longitude: 152.6451,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Victory Heights",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1723,
    longitude: 152.6895,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Bells Bridge",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1258,
    longitude: 152.5387,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Canina",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.144,
    longitude: 152.7405,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Pie Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2008,
    longitude: 152.6451,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Upper Kandanga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4167,
    longitude: 152.5833,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Woondum",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.25,
    longitude: 152.7333,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Kanigan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.9309,
    longitude: 152.5983,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Gympie DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2008,
    longitude: 152.6451,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Gilldora",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3,
    longitude: 152.6667,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Glanmire",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2294,
    longitude: 152.6964,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Glenwood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1931,
    longitude: 152.5564,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Cedar Pocket",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2008,
    longitude: 152.6451,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Curra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.0667,
    longitude: 152.5833,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Kybong",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3167,
    longitude: 152.7167,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Coles Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1931,
    longitude: 152.5564,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Toolara Forest",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.9966,
    longitude: 152.8371,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Paterson",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.8908,
    longitude: 152.5438,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Monkland",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2119,
    longitude: 152.6824,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Fishermans Pocket",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1931,
    longitude: 152.5564,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Mothar Mountain",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2499,
    longitude: 152.7737,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Widgee Crossing South",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1931,
    longitude: 152.5564,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Tandur",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2833,
    longitude: 152.75,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Glen Echo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1931,
    longitude: 152.5564,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Goomboorian",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.081,
    longitude: 152.7912,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Greens Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1705,
    longitude: 152.7536,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Wilsons Pocket",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1231,
    longitude: 152.7999,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Lake Borumba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1931,
    longitude: 152.5564,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Araluen",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1571,
    longitude: 152.6522,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Corella",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1,
    longitude: 152.6333,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Jones Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2292,
    longitude: 152.6688,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Neusa Vale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1931,
    longitude: 152.5564,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Lower Wonga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2008,
    longitude: 152.6451,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Calico Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2008,
    longitude: 152.6451,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Two Mile",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1689,
    longitude: 152.641,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Neerdie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2008,
    longitude: 152.6451,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Miva",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.9606,
    longitude: 152.4913,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Beenaam Valley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1931,
    longitude: 152.5564,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Downsfield",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.0667,
    longitude: 152.7333,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Bella Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1931,
    longitude: 152.5564,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Woolooga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.055,
    longitude: 152.3951,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Long Flat",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1931,
    longitude: 152.5564,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "The Palms",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.205,
    longitude: 152.5865,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Scrubby Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1931,
    longitude: 152.5564,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Wolvi",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1667,
    longitude: 152.8333,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Marodian",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1931,
    longitude: 152.5564,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Melawondi",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4167,
    longitude: 152.6667,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Munna Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1931,
    longitude: 152.5564,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Brooloo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5,
    longitude: 152.7,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Tuchekoi",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2008,
    longitude: 152.6451,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Sexton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26,
    longitude: 152.4333,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Kandanga Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3878,
    longitude: 152.6474,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Glastonbury",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2167,
    longitude: 152.5167,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Anderleigh",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1931,
    longitude: 152.5564,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Upper Glastonbury",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.25,
    longitude: 152.5,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Marys Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1931,
    longitude: 152.5564,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "The Dawn",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2418,
    longitude: 152.6792,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "Mcintosh Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1931,
    longitude: 152.5564,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Coondoo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1667,
    longitude: 152.8833,
    accuracy: 4
  },
  {
    postalCode: 4570,
    city: "North Deep Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1365,
    longitude: 152.6811,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Ross Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1931,
    longitude: 152.5564,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Scotchy Pocket",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1931,
    longitude: 152.5564,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Widgee Crossing North",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1931,
    longitude: 152.5564,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "Amamoor Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1931,
    longitude: 152.5564,
    accuracy: 3
  },
  {
    postalCode: 4570,
    city: "St Mary",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1931,
    longitude: 152.5564,
    accuracy: 3
  },
  {
    postalCode: 4571,
    city: "Kin Kin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2709,
    longitude: 152.8773,
    accuracy: 4
  },
  {
    postalCode: 4571,
    city: "Como",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2045,
    longitude: 152.9656,
    accuracy: 4
  },
  {
    postalCode: 4572,
    city: "Alexandra Headland",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.672,
    longitude: 153.1079,
    accuracy: 4
  },
  {
    postalCode: 4573,
    city: "Mount Coolum",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5658,
    longitude: 153.0914,
    accuracy: 4
  },
  {
    postalCode: 4573,
    city: "Peregian Springs",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.488,
    longitude: 153.0758,
    accuracy: 4
  },
  {
    postalCode: 4573,
    city: "Yaroomba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5513,
    longitude: 153.097,
    accuracy: 4
  },
  {
    postalCode: 4573,
    city: "Coolum Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5283,
    longitude: 153.0881,
    accuracy: 4
  },
  {
    postalCode: 4573,
    city: "Point Arkwright",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5461,
    longitude: 153.1006,
    accuracy: 4
  },
  {
    postalCode: 4573,
    city: "Marcus Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4531,
    longitude: 153.1006,
    accuracy: 4
  },
  {
    postalCode: 4573,
    city: "Peregian Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.481,
    longitude: 153.096,
    accuracy: 4
  },
  {
    postalCode: 4574,
    city: "Kenilworth",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5966,
    longitude: 152.7281,
    accuracy: 4
  },
  {
    postalCode: 4574,
    city: "Moy Pocket",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6155,
    longitude: 152.7203,
    accuracy: 3
  },
  {
    postalCode: 4574,
    city: "Kidaman Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6312,
    longitude: 152.7675,
    accuracy: 4
  },
  {
    postalCode: 4574,
    city: "Obi Obi",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.65,
    longitude: 152.8,
    accuracy: 4
  },
  {
    postalCode: 4574,
    city: "Coolabine",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5933,
    longitude: 152.764,
    accuracy: 4
  },
  {
    postalCode: 4574,
    city: "Gheerulla",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5667,
    longitude: 152.7667,
    accuracy: 4
  },
  {
    postalCode: 4575,
    city: "Bokarina",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7384,
    longitude: 153.1305,
    accuracy: 4
  },
  {
    postalCode: 4575,
    city: "Minyama",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6957,
    longitude: 153.1235,
    accuracy: 4
  },
  {
    postalCode: 4575,
    city: "Birtinya",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7432,
    longitude: 153.1191,
    accuracy: 4
  },
  {
    postalCode: 4575,
    city: "Parrearra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7115,
    longitude: 153.122,
    accuracy: 4
  },
  {
    postalCode: 4575,
    city: "Wurtulla",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7565,
    longitude: 153.128,
    accuracy: 4
  },
  {
    postalCode: 4575,
    city: "Warana",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7227,
    longitude: 153.1269,
    accuracy: 4
  },
  {
    postalCode: 4575,
    city: "Buddina",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6956,
    longitude: 153.133,
    accuracy: 4
  },
  {
    postalCode: 4580,
    city: "Tin Can Bay",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.9133,
    longitude: 153.0058,
    accuracy: 4
  },
  {
    postalCode: 4580,
    city: "Cooloola Cove",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.9864,
    longitude: 152.9935,
    accuracy: 4
  },
  {
    postalCode: 4580,
    city: "Cooloola",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.9864,
    longitude: 152.9935,
    accuracy: 4
  },
  {
    postalCode: 4581,
    city: "Fraser Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.9673,
    longitude: 153.3144,
    accuracy: 4
  },
  {
    postalCode: 4581,
    city: "Inskip",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.8283,
    longitude: 153.0675,
    accuracy: 4
  },
  {
    postalCode: 4581,
    city: "Eurong",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5092,
    longitude: 153.125,
    accuracy: 4
  },
  {
    postalCode: 4581,
    city: "Orchid Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.9673,
    longitude: 153.3144,
    accuracy: 4
  },
  {
    postalCode: 4581,
    city: "Rainbow Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.9043,
    longitude: 153.0917,
    accuracy: 4
  },
  {
    postalCode: 4600,
    city: "Oakview",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.0833,
    longitude: 152.3333,
    accuracy: 4
  },
  {
    postalCode: 4600,
    city: "Kilkivan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.0869,
    longitude: 152.234,
    accuracy: 4
  },
  {
    postalCode: 4600,
    city: "Mudlo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1644,
    longitude: 152.2093,
    accuracy: 3
  },
  {
    postalCode: 4600,
    city: "Cinnabar",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1224,
    longitude: 152.1854,
    accuracy: 4
  },
  {
    postalCode: 4600,
    city: "Black Snake",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1644,
    longitude: 152.2093,
    accuracy: 3
  },
  {
    postalCode: 4601,
    city: "Boonara",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.0802,
    longitude: 152.0546,
    accuracy: 4
  },
  {
    postalCode: 4601,
    city: "Goomeribong",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1146,
    longitude: 152.0795,
    accuracy: 3
  },
  {
    postalCode: 4601,
    city: "Tansey",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.0467,
    longitude: 152.0514,
    accuracy: 4
  },
  {
    postalCode: 4601,
    city: "Wrattens Forest",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1146,
    longitude: 152.0795,
    accuracy: 3
  },
  {
    postalCode: 4601,
    city: "Manyung",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2,
    longitude: 152.0333,
    accuracy: 4
  },
  {
    postalCode: 4601,
    city: "Barambah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1146,
    longitude: 152.0795,
    accuracy: 3
  },
  {
    postalCode: 4601,
    city: "Goomeri",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1838,
    longitude: 152.0687,
    accuracy: 4
  },
  {
    postalCode: 4601,
    city: "Kinbombi",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1981,
    longitude: 152.1221,
    accuracy: 4
  },
  {
    postalCode: 4601,
    city: "Manumbar",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4,
    longitude: 152.2833,
    accuracy: 4
  },
  {
    postalCode: 4601,
    city: "Booubyjan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1146,
    longitude: 152.0795,
    accuracy: 3
  },
  {
    postalCode: 4605,
    city: "Manyung",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2,
    longitude: 152.0333,
    accuracy: 4
  },
  {
    postalCode: 4605,
    city: "Kitoba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1525,
    longitude: 151.893,
    accuracy: 3
  },
  {
    postalCode: 4605,
    city: "Windera",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.05,
    longitude: 151.8333,
    accuracy: 4
  },
  {
    postalCode: 4605,
    city: "Warnung",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1525,
    longitude: 151.893,
    accuracy: 3
  },
  {
    postalCode: 4605,
    city: "Byee",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1833,
    longitude: 151.85,
    accuracy: 4
  },
  {
    postalCode: 4605,
    city: "Redgate",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1525,
    longitude: 151.893,
    accuracy: 3
  },
  {
    postalCode: 4605,
    city: "Moffatdale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3079,
    longitude: 152.0125,
    accuracy: 4
  },
  {
    postalCode: 4605,
    city: "Oakdale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1525,
    longitude: 151.893,
    accuracy: 3
  },
  {
    postalCode: 4605,
    city: "Barlil",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2,
    longitude: 151.8833,
    accuracy: 4
  },
  {
    postalCode: 4605,
    city: "Cherbourg",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2919,
    longitude: 151.9521,
    accuracy: 4
  },
  {
    postalCode: 4605,
    city: "Moondooner",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2333,
    longitude: 152,
    accuracy: 4
  },
  {
    postalCode: 4605,
    city: "Crownthorpe",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1896,
    longitude: 151.9157,
    accuracy: 3
  },
  {
    postalCode: 4605,
    city: "Cloyna",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1112,
    longitude: 151.8459,
    accuracy: 4
  },
  {
    postalCode: 4605,
    city: "Wooroonden",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1525,
    longitude: 151.893,
    accuracy: 3
  },
  {
    postalCode: 4605,
    city: "Silverleaf",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1525,
    longitude: 151.893,
    accuracy: 3
  },
  {
    postalCode: 4605,
    city: "Murgon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2417,
    longitude: 151.9405,
    accuracy: 4
  },
  {
    postalCode: 4605,
    city: "Cobbs Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1525,
    longitude: 151.893,
    accuracy: 3
  },
  {
    postalCode: 4605,
    city: "Glenrock",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1525,
    longitude: 151.893,
    accuracy: 3
  },
  {
    postalCode: 4605,
    city: "Merlwood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1525,
    longitude: 151.893,
    accuracy: 3
  },
  {
    postalCode: 4605,
    city: "Sunny Nook",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1525,
    longitude: 151.893,
    accuracy: 3
  },
  {
    postalCode: 4605,
    city: "Tablelands",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1525,
    longitude: 151.893,
    accuracy: 3
  },
  {
    postalCode: 4606,
    city: "Wondai",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3177,
    longitude: 151.8724,
    accuracy: 4
  },
  {
    postalCode: 4606,
    city: "Fairdale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2833,
    longitude: 151.7833,
    accuracy: 4
  },
  {
    postalCode: 4606,
    city: "Wheatlands",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2762,
    longitude: 151.8292,
    accuracy: 3
  },
  {
    postalCode: 4606,
    city: "Leafdale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2762,
    longitude: 151.8292,
    accuracy: 3
  },
  {
    postalCode: 4606,
    city: "Mp Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2762,
    longitude: 151.8292,
    accuracy: 3
  },
  {
    postalCode: 4606,
    city: "Mount Mceuen",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2762,
    longitude: 151.8292,
    accuracy: 3
  },
  {
    postalCode: 4606,
    city: "Chelmsford",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2762,
    longitude: 151.8292,
    accuracy: 3
  },
  {
    postalCode: 4606,
    city: "Greenview",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3005,
    longitude: 151.8279,
    accuracy: 3
  },
  {
    postalCode: 4606,
    city: "Ficks Crossing",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3005,
    longitude: 151.8279,
    accuracy: 3
  },
  {
    postalCode: 4608,
    city: "Tingoora",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3667,
    longitude: 151.8167,
    accuracy: 4
  },
  {
    postalCode: 4608,
    city: "Cushnie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3833,
    longitude: 151.7611,
    accuracy: 3
  },
  {
    postalCode: 4608,
    city: "Wooroolin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4167,
    longitude: 151.8167,
    accuracy: 4
  },
  {
    postalCode: 4608,
    city: "Charlestown",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3093,
    longitude: 151.7816,
    accuracy: 3
  },
  {
    postalCode: 4608,
    city: "Wilkesdale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3667,
    longitude: 151.65,
    accuracy: 4
  },
  {
    postalCode: 4610,
    city: "Haly Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6833,
    longitude: 151.75,
    accuracy: 4
  },
  {
    postalCode: 4610,
    city: "Ballogie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3565,
    longitude: 151.5347,
    accuracy: 3
  },
  {
    postalCode: 4610,
    city: "Mannuem",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5796,
    longitude: 151.5673,
    accuracy: 3
  },
  {
    postalCode: 4610,
    city: "Boyneside",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7167,
    longitude: 151.55,
    accuracy: 4
  },
  {
    postalCode: 4610,
    city: "Dangore",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.45,
    longitude: 151.5833,
    accuracy: 4
  },
  {
    postalCode: 4610,
    city: "Booie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5368,
    longitude: 151.9418,
    accuracy: 4
  },
  {
    postalCode: 4610,
    city: "Wattle Grove",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5796,
    longitude: 151.5673,
    accuracy: 3
  },
  {
    postalCode: 4610,
    city: "Kumbia",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6947,
    longitude: 151.6551,
    accuracy: 4
  },
  {
    postalCode: 4610,
    city: "Coolabunia",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6,
    longitude: 151.9,
    accuracy: 4
  },
  {
    postalCode: 4610,
    city: "Memerambi",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4623,
    longitude: 151.8219,
    accuracy: 4
  },
  {
    postalCode: 4610,
    city: "Inverlaw",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5948,
    longitude: 151.7663,
    accuracy: 3
  },
  {
    postalCode: 4610,
    city: "Durong",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3333,
    longitude: 151.25,
    accuracy: 4
  },
  {
    postalCode: 4610,
    city: "Hodgleigh",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6333,
    longitude: 151.9333,
    accuracy: 4
  },
  {
    postalCode: 4610,
    city: "Ellesmere",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5519,
    longitude: 151.7104,
    accuracy: 3
  },
  {
    postalCode: 4610,
    city: "Durong South",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3333,
    longitude: 151.25,
    accuracy: 4
  },
  {
    postalCode: 4610,
    city: "Ironpot",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5796,
    longitude: 151.5673,
    accuracy: 3
  },
  {
    postalCode: 4610,
    city: "Goodger",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6667,
    longitude: 151.8167,
    accuracy: 4
  },
  {
    postalCode: 4610,
    city: "Benair",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5796,
    longitude: 151.5673,
    accuracy: 3
  },
  {
    postalCode: 4610,
    city: "Taabinga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5833,
    longitude: 151.8333,
    accuracy: 4
  },
  {
    postalCode: 4610,
    city: "Corndale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5796,
    longitude: 151.5673,
    accuracy: 3
  },
  {
    postalCode: 4610,
    city: "Crawford",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5,
    longitude: 151.8167,
    accuracy: 4
  },
  {
    postalCode: 4610,
    city: "Kingaroy",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5399,
    longitude: 151.8373,
    accuracy: 4
  },
  {
    postalCode: 4610,
    city: "Chahpingah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5796,
    longitude: 151.5673,
    accuracy: 3
  },
  {
    postalCode: 4610,
    city: "Gordonbrook",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4263,
    longitude: 151.6484,
    accuracy: 3
  },
  {
    postalCode: 4610,
    city: "Alice Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5796,
    longitude: 151.5673,
    accuracy: 3
  },
  {
    postalCode: 4610,
    city: "Kingaroy DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.5519,
    longitude: 151.7104,
    accuracy: 3
  },
  {
    postalCode: 4611,
    city: "Marshlands",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1833,
    longitude: 151.7667,
    accuracy: 3
  },
  {
    postalCode: 4611,
    city: "Mondure",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1837,
    longitude: 151.7724,
    accuracy: 4
  },
  {
    postalCode: 4612,
    city: "Kawl Kawl",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1833,
    longitude: 151.7333,
    accuracy: 4
  },
  {
    postalCode: 4612,
    city: "Hivesville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1807,
    longitude: 151.6907,
    accuracy: 4
  },
  {
    postalCode: 4612,
    city: "Wigton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.0475,
    longitude: 151.624,
    accuracy: 3
  },
  {
    postalCode: 4612,
    city: "Stonelands",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.0475,
    longitude: 151.624,
    accuracy: 3
  },
  {
    postalCode: 4612,
    city: "Keysland",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.0475,
    longitude: 151.624,
    accuracy: 3
  },
  {
    postalCode: 4613,
    city: "Abbeywood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1139,
    longitude: 151.6294,
    accuracy: 4
  },
  {
    postalCode: 4613,
    city: "Stalworth",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1951,
    longitude: 151.4567,
    accuracy: 3
  },
  {
    postalCode: 4613,
    city: "Brigooda",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2534,
    longitude: 151.4158,
    accuracy: 4
  },
  {
    postalCode: 4613,
    city: "Okeden",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2365,
    longitude: 151.2929,
    accuracy: 3
  },
  {
    postalCode: 4613,
    city: "Boondooma",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.3036,
    longitude: 151.262,
    accuracy: 4
  },
  {
    postalCode: 4613,
    city: "Melrose",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2365,
    longitude: 151.2929,
    accuracy: 3
  },
  {
    postalCode: 4613,
    city: "Kinleymore",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1833,
    longitude: 151.65,
    accuracy: 4
  },
  {
    postalCode: 4613,
    city: "Coverty",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.2365,
    longitude: 151.2929,
    accuracy: 3
  },
  {
    postalCode: 4613,
    city: "Proston",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1607,
    longitude: 151.6004,
    accuracy: 4
  },
  {
    postalCode: 4613,
    city: "Speedwell",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1951,
    longitude: 151.4567,
    accuracy: 3
  },
  {
    postalCode: 4614,
    city: "Yarraman",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.8417,
    longitude: 151.9814,
    accuracy: 4
  },
  {
    postalCode: 4614,
    city: "Upper Yarraman",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.8431,
    longitude: 151.9858,
    accuracy: 3
  },
  {
    postalCode: 4614,
    city: "Neumgna",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.8431,
    longitude: 151.9858,
    accuracy: 3
  },
  {
    postalCode: 4615,
    city: "Wengenville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.8333,
    longitude: 151.7,
    accuracy: 4
  },
  {
    postalCode: 4615,
    city: "Glan Devon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6,
    longitude: 152.0167,
    accuracy: 4
  },
  {
    postalCode: 4615,
    city: "South Nanango",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.75,
    longitude: 151.9667,
    accuracy: 4
  },
  {
    postalCode: 4615,
    city: "Nanango",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6716,
    longitude: 152.0021,
    accuracy: 4
  },
  {
    postalCode: 4615,
    city: "Wyalla",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6526,
    longitude: 151.9716,
    accuracy: 3
  },
  {
    postalCode: 4615,
    city: "Tarong",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7667,
    longitude: 151.85,
    accuracy: 4
  },
  {
    postalCode: 4615,
    city: "Maidenwell",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.85,
    longitude: 151.8,
    accuracy: 4
  },
  {
    postalCode: 4615,
    city: "Brooklands",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7041,
    longitude: 151.8997,
    accuracy: 3
  },
  {
    postalCode: 4615,
    city: "Elgin Vale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.7041,
    longitude: 151.8997,
    accuracy: 3
  },
  {
    postalCode: 4615,
    city: "Wattle Camp",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.4572,
    longitude: 151.9623,
    accuracy: 4
  },
  {
    postalCode: 4615,
    city: "Johnstown",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6526,
    longitude: 151.9716,
    accuracy: 3
  },
  {
    postalCode: 4615,
    city: "Bullcamp",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6526,
    longitude: 151.9716,
    accuracy: 3
  },
  {
    postalCode: 4615,
    city: "Barker Creek Flat",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6526,
    longitude: 151.9716,
    accuracy: 3
  },
  {
    postalCode: 4615,
    city: "East Nanango",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6943,
    longitude: 152.0413,
    accuracy: 3
  },
  {
    postalCode: 4615,
    city: "Kunioon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6526,
    longitude: 151.9716,
    accuracy: 3
  },
  {
    postalCode: 4615,
    city: "Pimpimbudgee",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6526,
    longitude: 151.9716,
    accuracy: 3
  },
  {
    postalCode: 4615,
    city: "Runnymede",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6526,
    longitude: 151.9716,
    accuracy: 3
  },
  {
    postalCode: 4615,
    city: "Sandy Ridges",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.6526,
    longitude: 151.9716,
    accuracy: 3
  },
  {
    postalCode: 4615,
    city: "South East Nanango",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.695,
    longitude: 152.0264,
    accuracy: 3
  },
  {
    postalCode: 4620,
    city: "Aramara",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6095,
    longitude: 152.322,
    accuracy: 4
  },
  {
    postalCode: 4620,
    city: "Brooweena",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6059,
    longitude: 152.2611,
    accuracy: 4
  },
  {
    postalCode: 4620,
    city: "Gungaloon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5188,
    longitude: 152.3157,
    accuracy: 3
  },
  {
    postalCode: 4620,
    city: "Teebar",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5188,
    longitude: 152.3157,
    accuracy: 3
  },
  {
    postalCode: 4620,
    city: "Glenbar",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5188,
    longitude: 152.3157,
    accuracy: 3
  },
  {
    postalCode: 4620,
    city: "Gigoomgan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5188,
    longitude: 152.3157,
    accuracy: 3
  },
  {
    postalCode: 4620,
    city: "Woocoo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5188,
    longitude: 152.3157,
    accuracy: 3
  },
  {
    postalCode: 4620,
    city: "Malarga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5188,
    longitude: 152.3157,
    accuracy: 3
  },
  {
    postalCode: 4620,
    city: "North Aramara",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5188,
    longitude: 152.3157,
    accuracy: 3
  },
  {
    postalCode: 4620,
    city: "Doongul",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5188,
    longitude: 152.3157,
    accuracy: 3
  },
  {
    postalCode: 4621,
    city: "Lakeside",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5783,
    longitude: 152.1251,
    accuracy: 4
  },
  {
    postalCode: 4621,
    city: "Degilbo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.4833,
    longitude: 152,
    accuracy: 4
  },
  {
    postalCode: 4621,
    city: "Coalstoun Lakes",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6181,
    longitude: 151.8937,
    accuracy: 4
  },
  {
    postalCode: 4621,
    city: "Woowoonga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.632,
    longitude: 152.0448,
    accuracy: 3
  },
  {
    postalCode: 4621,
    city: "Biggenden",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5086,
    longitude: 152.0448,
    accuracy: 4
  },
  {
    postalCode: 4621,
    city: "Dallarnil",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.4,
    longitude: 152.05,
    accuracy: 4
  },
  {
    postalCode: 4621,
    city: "Coringa",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.632,
    longitude: 152.0448,
    accuracy: 3
  },
  {
    postalCode: 4621,
    city: "Boompa",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5911,
    longitude: 152.1861,
    accuracy: 4
  },
  {
    postalCode: 4621,
    city: "Wateranga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.632,
    longitude: 152.0448,
    accuracy: 3
  },
  {
    postalCode: 4621,
    city: "Didcot",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.4756,
    longitude: 151.868,
    accuracy: 4
  },
  {
    postalCode: 4621,
    city: "Golden Fleece",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.632,
    longitude: 152.0448,
    accuracy: 3
  },
  {
    postalCode: 4625,
    city: "Wetheron",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5457,
    longitude: 151.7187,
    accuracy: 4
  },
  {
    postalCode: 4625,
    city: "Toondahra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5553,
    longitude: 151.5923,
    accuracy: 3
  },
  {
    postalCode: 4625,
    city: "Dirnbir",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5553,
    longitude: 151.5923,
    accuracy: 3
  },
  {
    postalCode: 4625,
    city: "Bon Accord",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5553,
    longitude: 151.5923,
    accuracy: 3
  },
  {
    postalCode: 4625,
    city: "Ideraway",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5778,
    longitude: 151.6178,
    accuracy: 4
  },
  {
    postalCode: 4625,
    city: "Mount Steadman",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6269,
    longitude: 151.7478,
    accuracy: 3
  },
  {
    postalCode: 4625,
    city: "Yenda",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.4531,
    longitude: 151.659,
    accuracy: 4
  },
  {
    postalCode: 4625,
    city: "Dundarrah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.65,
    longitude: 151.8833,
    accuracy: 4
  },
  {
    postalCode: 4625,
    city: "Byrnestown",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5254,
    longitude: 151.761,
    accuracy: 4
  },
  {
    postalCode: 4625,
    city: "Mount Lawless",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5395,
    longitude: 151.6533,
    accuracy: 4
  },
  {
    postalCode: 4625,
    city: "Gooroolba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5139,
    longitude: 151.8083,
    accuracy: 4
  },
  {
    postalCode: 4625,
    city: "Stockhaven",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5553,
    longitude: 151.5923,
    accuracy: 3
  },
  {
    postalCode: 4625,
    city: "Aranbanga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5553,
    longitude: 151.5923,
    accuracy: 3
  },
  {
    postalCode: 4625,
    city: "Gayndah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6252,
    longitude: 151.6114,
    accuracy: 4
  },
  {
    postalCode: 4625,
    city: "Deep Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.1976,
    longitude: 152.7175,
    accuracy: 4
  },
  {
    postalCode: 4625,
    city: "Reids Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5553,
    longitude: 151.5923,
    accuracy: 3
  },
  {
    postalCode: 4625,
    city: "Wahoon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5553,
    longitude: 151.5923,
    accuracy: 3
  },
  {
    postalCode: 4625,
    city: "Humphery",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6033,
    longitude: 151.4803,
    accuracy: 4
  },
  {
    postalCode: 4625,
    city: "Binjour",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5151,
    longitude: 151.4562,
    accuracy: 4
  },
  {
    postalCode: 4625,
    city: "Wilson Valley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5553,
    longitude: 151.5923,
    accuracy: 3
  },
  {
    postalCode: 4625,
    city: "Mount Debateable",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5553,
    longitude: 151.5923,
    accuracy: 3
  },
  {
    postalCode: 4625,
    city: "Penwhaupell",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5553,
    longitude: 151.5923,
    accuracy: 3
  },
  {
    postalCode: 4625,
    city: "Ban Ban",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5553,
    longitude: 151.5923,
    accuracy: 3
  },
  {
    postalCode: 4625,
    city: "Blairmore",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5553,
    longitude: 151.5923,
    accuracy: 3
  },
  {
    postalCode: 4625,
    city: "Mingo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5553,
    longitude: 151.5923,
    accuracy: 3
  },
  {
    postalCode: 4625,
    city: "Barlyne",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5553,
    longitude: 151.5923,
    accuracy: 3
  },
  {
    postalCode: 4625,
    city: "Ginoondan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5553,
    longitude: 151.5923,
    accuracy: 3
  },
  {
    postalCode: 4625,
    city: "Campbell Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5553,
    longitude: 151.5923,
    accuracy: 3
  },
  {
    postalCode: 4625,
    city: "Pile Gully",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5553,
    longitude: 151.5923,
    accuracy: 3
  },
  {
    postalCode: 4625,
    city: "The Limits",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5553,
    longitude: 151.5923,
    accuracy: 3
  },
  {
    postalCode: 4625,
    city: "Woodmillar",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5553,
    longitude: 151.5923,
    accuracy: 3
  },
  {
    postalCode: 4625,
    city: "Branch Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5553,
    longitude: 151.5923,
    accuracy: 3
  },
  {
    postalCode: 4625,
    city: "Harriet",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5553,
    longitude: 151.5923,
    accuracy: 3
  },
  {
    postalCode: 4625,
    city: "Ban Ban Springs",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5553,
    longitude: 151.5923,
    accuracy: 3
  },
  {
    postalCode: 4626,
    city: "Riverleigh",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5766,
    longitude: 151.2001,
    accuracy: 4
  },
  {
    postalCode: 4626,
    city: "Obil Bil",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5193,
    longitude: 151.2187,
    accuracy: 4
  },
  {
    postalCode: 4626,
    city: "Mundubbera",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5927,
    longitude: 151.3022,
    accuracy: 4
  },
  {
    postalCode: 4626,
    city: "Brovinia",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.7889,
    longitude: 151.1136,
    accuracy: 3
  },
  {
    postalCode: 4626,
    city: "Mundowran",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5206,
    longitude: 151.3438,
    accuracy: 3
  },
  {
    postalCode: 4626,
    city: "Hawkwood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.7761,
    longitude: 150.8109,
    accuracy: 4
  },
  {
    postalCode: 4626,
    city: "Monogorilby",
    state_name: "Queensland",
    state: "QLD",
    latitude: -26.0585,
    longitude: 151.0135,
    accuracy: 4
  },
  {
    postalCode: 4626,
    city: "Glenrae",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.7889,
    longitude: 151.1136,
    accuracy: 3
  },
  {
    postalCode: 4626,
    city: "O'Bil Bil",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5193,
    longitude: 151.2187,
    accuracy: 4
  },
  {
    postalCode: 4626,
    city: "Old Cooranga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.7889,
    longitude: 151.1136,
    accuracy: 3
  },
  {
    postalCode: 4626,
    city: "Derri Derra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.7889,
    longitude: 151.1136,
    accuracy: 3
  },
  {
    postalCode: 4626,
    city: "Philpott",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6,
    longitude: 151.3667,
    accuracy: 4
  },
  {
    postalCode: 4626,
    city: "Coonambula",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.7889,
    longitude: 151.1136,
    accuracy: 3
  },
  {
    postalCode: 4626,
    city: "Dykehead",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.7889,
    longitude: 151.1136,
    accuracy: 3
  },
  {
    postalCode: 4626,
    city: "Cattle Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -13.1617,
    longitude: 143.0534,
    accuracy: 3
  },
  {
    postalCode: 4626,
    city: "Gurgeena",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6463,
    longitude: 151.1704,
    accuracy: 3
  },
  {
    postalCode: 4626,
    city: "Beeron",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.7889,
    longitude: 151.1136,
    accuracy: 3
  },
  {
    postalCode: 4626,
    city: "Boynewood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.633,
    longitude: 151.2793,
    accuracy: 3
  },
  {
    postalCode: 4627,
    city: "Eidsvold",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.3717,
    longitude: 151.1215,
    accuracy: 4
  },
  {
    postalCode: 4627,
    city: "Ceratodus",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.2916,
    longitude: 151.1395,
    accuracy: 4
  },
  {
    postalCode: 4627,
    city: "Malmoe",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.4774,
    longitude: 151.2019,
    accuracy: 4
  },
  {
    postalCode: 4627,
    city: "Wuruma Dam",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.3644,
    longitude: 150.8345,
    accuracy: 3
  },
  {
    postalCode: 4627,
    city: "Grosvenor",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.4292,
    longitude: 151.1738,
    accuracy: 4
  },
  {
    postalCode: 4627,
    city: "Abercorn",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.1347,
    longitude: 151.1294,
    accuracy: 4
  },
  {
    postalCode: 4627,
    city: "Cynthia",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.2123,
    longitude: 151.1287,
    accuracy: 4
  },
  {
    postalCode: 4627,
    city: "Eidsvold West",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.3644,
    longitude: 150.8345,
    accuracy: 3
  },
  {
    postalCode: 4627,
    city: "Cheltenham",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.3644,
    longitude: 150.8345,
    accuracy: 3
  },
  {
    postalCode: 4627,
    city: "Eidsvold East",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.3644,
    longitude: 150.8345,
    accuracy: 3
  },
  {
    postalCode: 4630,
    city: "Tellebang",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0667,
    longitude: 151.2333,
    accuracy: 4
  },
  {
    postalCode: 4630,
    city: "Kalpowar",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.7,
    longitude: 151.3,
    accuracy: 4
  },
  {
    postalCode: 4630,
    city: "Bancroft",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.7833,
    longitude: 151.2333,
    accuracy: 4
  },
  {
    postalCode: 4630,
    city: "Harrami",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8332,
    longitude: 150.9872,
    accuracy: 3
  },
  {
    postalCode: 4630,
    city: "Monto",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8648,
    longitude: 151.122,
    accuracy: 4
  },
  {
    postalCode: 4630,
    city: "Selene",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0167,
    longitude: 151.15,
    accuracy: 4
  },
  {
    postalCode: 4630,
    city: "Yarrol",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.1301,
    longitude: 151.3521,
    accuracy: 3
  },
  {
    postalCode: 4630,
    city: "Cannindah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8332,
    longitude: 150.9872,
    accuracy: 3
  },
  {
    postalCode: 4630,
    city: "Kapaldo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0425,
    longitude: 151.1353,
    accuracy: 4
  },
  {
    postalCode: 4630,
    city: "Cania",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.6333,
    longitude: 150.9667,
    accuracy: 4
  },
  {
    postalCode: 4630,
    city: "Three Moon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.9111,
    longitude: 151.1265,
    accuracy: 4
  },
  {
    postalCode: 4630,
    city: "Ventnor",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8332,
    longitude: 150.9872,
    accuracy: 3
  },
  {
    postalCode: 4630,
    city: "Mungungo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.7658,
    longitude: 151.1633,
    accuracy: 4
  },
  {
    postalCode: 4630,
    city: "Mulgildie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.9605,
    longitude: 151.1319,
    accuracy: 4
  },
  {
    postalCode: 4630,
    city: "Rawbelle",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0232,
    longitude: 150.8271,
    accuracy: 4
  },
  {
    postalCode: 4630,
    city: "Bukali",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8332,
    longitude: 150.9872,
    accuracy: 3
  },
  {
    postalCode: 4630,
    city: "Coominglah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.7532,
    longitude: 150.8356,
    accuracy: 4
  },
  {
    postalCode: 4630,
    city: "Splinter Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8332,
    longitude: 150.9872,
    accuracy: 3
  },
  {
    postalCode: 4630,
    city: "Moonford",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.7667,
    longitude: 151.0333,
    accuracy: 4
  },
  {
    postalCode: 4630,
    city: "Glenleigh",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8332,
    longitude: 150.9872,
    accuracy: 3
  },
  {
    postalCode: 4630,
    city: "Langley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.45,
    longitude: 150.4333,
    accuracy: 4
  },
  {
    postalCode: 4630,
    city: "Monal",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8332,
    longitude: 150.9872,
    accuracy: 3
  },
  {
    postalCode: 4630,
    city: "Dalga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.7691,
    longitude: 151.0402,
    accuracy: 3
  },
  {
    postalCode: 4630,
    city: "Coominglah Forest",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8332,
    longitude: 150.9872,
    accuracy: 3
  },
  {
    postalCode: 4650,
    city: "Maryborough",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5407,
    longitude: 152.7049,
    accuracy: 4
  },
  {
    postalCode: 4650,
    city: "Thinoomba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6025,
    longitude: 152.4537,
    accuracy: 4
  },
  {
    postalCode: 4650,
    city: "Dundathu",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.4632,
    longitude: 152.7174,
    accuracy: 3
  },
  {
    postalCode: 4650,
    city: "The Dimonds",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6657,
    longitude: 152.6858,
    accuracy: 3
  },
  {
    postalCode: 4650,
    city: "Maryborough DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6401,
    longitude: 152.6462,
    accuracy: 3
  },
  {
    postalCode: 4650,
    city: "Gootchie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.8548,
    longitude: 152.5544,
    accuracy: 4
  },
  {
    postalCode: 4650,
    city: "Boonooroo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6729,
    longitude: 152.9026,
    accuracy: 4
  },
  {
    postalCode: 4650,
    city: "Tinana South",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5822,
    longitude: 152.6513,
    accuracy: 3
  },
  {
    postalCode: 4650,
    city: "Antigua",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6381,
    longitude: 152.5989,
    accuracy: 4
  },
  {
    postalCode: 4650,
    city: "Grahams Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5667,
    longitude: 152.6,
    accuracy: 4
  },
  {
    postalCode: 4650,
    city: "Yengarie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5562,
    longitude: 152.6082,
    accuracy: 4
  },
  {
    postalCode: 4650,
    city: "Mount Urah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6657,
    longitude: 152.6858,
    accuracy: 3
  },
  {
    postalCode: 4650,
    city: "Owanyilla",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6674,
    longitude: 152.6028,
    accuracy: 4
  },
  {
    postalCode: 4650,
    city: "Maaroom",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6112,
    longitude: 152.8718,
    accuracy: 4
  },
  {
    postalCode: 4650,
    city: "Yerra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.61,
    longitude: 152.5356,
    accuracy: 4
  },
  {
    postalCode: 4650,
    city: "Tandora",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6657,
    longitude: 152.6858,
    accuracy: 3
  },
  {
    postalCode: 4650,
    city: "Bauple",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.8121,
    longitude: 152.6213,
    accuracy: 4
  },
  {
    postalCode: 4650,
    city: "Pilerwa",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6069,
    longitude: 152.5653,
    accuracy: 4
  },
  {
    postalCode: 4650,
    city: "Mungar",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6053,
    longitude: 152.5923,
    accuracy: 4
  },
  {
    postalCode: 4650,
    city: "Tinnanbar",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6401,
    longitude: 152.6462,
    accuracy: 3
  },
  {
    postalCode: 4650,
    city: "Tuan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6811,
    longitude: 152.8735,
    accuracy: 4
  },
  {
    postalCode: 4650,
    city: "Oakhurst",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5125,
    longitude: 152.6358,
    accuracy: 4
  },
  {
    postalCode: 4650,
    city: "Granville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.5449,
    longitude: 152.7335,
    accuracy: 4
  },
  {
    postalCode: 4650,
    city: "Mount Steadman",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6657,
    longitude: 152.6858,
    accuracy: 3
  },
  {
    postalCode: 4650,
    city: "Tiaro",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.7261,
    longitude: 152.5827,
    accuracy: 4
  },
  {
    postalCode: 4650,
    city: "Pallas Street Maryborough",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6401,
    longitude: 152.6462,
    accuracy: 3
  },
  {
    postalCode: 4650,
    city: "Poona",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.7154,
    longitude: 152.9096,
    accuracy: 4
  },
  {
    postalCode: 4650,
    city: "Tuan Forest",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6657,
    longitude: 152.6858,
    accuracy: 3
  },
  {
    postalCode: 4650,
    city: "Aldershot",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.4631,
    longitude: 152.6635,
    accuracy: 4
  },
  {
    postalCode: 4650,
    city: "Bidwill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6077,
    longitude: 152.7144,
    accuracy: 4
  },
  {
    postalCode: 4650,
    city: "Netherby",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.7752,
    longitude: 152.5434,
    accuracy: 4
  },
  {
    postalCode: 4650,
    city: "Talegalla Weir",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6657,
    longitude: 152.6858,
    accuracy: 3
  },
  {
    postalCode: 4650,
    city: "Tinana",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.552,
    longitude: 152.6659,
    accuracy: 4
  },
  {
    postalCode: 4650,
    city: "Prawle",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6401,
    longitude: 152.6462,
    accuracy: 3
  },
  {
    postalCode: 4650,
    city: "Maryborough West",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6401,
    longitude: 152.6462,
    accuracy: 3
  },
  {
    postalCode: 4650,
    city: "Boonooroo Plains",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6657,
    longitude: 152.6858,
    accuracy: 3
  },
  {
    postalCode: 4650,
    city: "Bauple Forest",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.878,
    longitude: 152.6551,
    accuracy: 3
  },
  {
    postalCode: 4650,
    city: "Pioneers Rest",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6657,
    longitude: 152.6858,
    accuracy: 3
  },
  {
    postalCode: 4650,
    city: "St Helens",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6657,
    longitude: 152.6858,
    accuracy: 3
  },
  {
    postalCode: 4650,
    city: "Magnolia",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6401,
    longitude: 152.6462,
    accuracy: 3
  },
  {
    postalCode: 4650,
    city: "Dunmora",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6657,
    longitude: 152.6858,
    accuracy: 3
  },
  {
    postalCode: 4650,
    city: "Ferney",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6657,
    longitude: 152.6858,
    accuracy: 3
  },
  {
    postalCode: 4650,
    city: "Gundiah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.8335,
    longitude: 152.5405,
    accuracy: 4
  },
  {
    postalCode: 4650,
    city: "St Mary",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6401,
    longitude: 152.6462,
    accuracy: 3
  },
  {
    postalCode: 4650,
    city: "Duckinwilla",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.4126,
    longitude: 152.4375,
    accuracy: 3
  },
  {
    postalCode: 4650,
    city: "Walkers Point",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6657,
    longitude: 152.6858,
    accuracy: 3
  },
  {
    postalCode: 4650,
    city: "Glenorchy",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6657,
    longitude: 152.6858,
    accuracy: 3
  },
  {
    postalCode: 4650,
    city: "Teddington",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6657,
    longitude: 152.6858,
    accuracy: 3
  },
  {
    postalCode: 4650,
    city: "Beaver Rock",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6657,
    longitude: 152.6858,
    accuracy: 3
  },
  {
    postalCode: 4650,
    city: "Island Plantation",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.6401,
    longitude: 152.6462,
    accuracy: 3
  },
  {
    postalCode: 4655,
    city: "River Heads",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.4155,
    longitude: 152.9131,
    accuracy: 4
  },
  {
    postalCode: 4655,
    city: "Hervey Bay",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.2894,
    longitude: 152.8288,
    accuracy: 4
  },
  {
    postalCode: 4655,
    city: "Kingfisher Bay",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.3914,
    longitude: 153.0294,
    accuracy: 4
  },
  {
    postalCode: 4655,
    city: "Walliebum",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.3305,
    longitude: 152.8062,
    accuracy: 3
  },
  {
    postalCode: 4655,
    city: "Wondunna",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.3176,
    longitude: 152.8591,
    accuracy: 4
  },
  {
    postalCode: 4655,
    city: "Sunshine Acres",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.3581,
    longitude: 152.7877,
    accuracy: 4
  },
  {
    postalCode: 4655,
    city: "Scarness",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.2841,
    longitude: 152.856,
    accuracy: 4
  },
  {
    postalCode: 4655,
    city: "Susan River",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.3305,
    longitude: 152.8062,
    accuracy: 3
  },
  {
    postalCode: 4655,
    city: "Booral",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.3605,
    longitude: 152.9081,
    accuracy: 4
  },
  {
    postalCode: 4655,
    city: "Toogoom",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.2564,
    longitude: 152.6902,
    accuracy: 4
  },
  {
    postalCode: 4655,
    city: "Nikenbah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.3194,
    longitude: 152.8041,
    accuracy: 4
  },
  {
    postalCode: 4655,
    city: "Hervey Bay Dc",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.3305,
    longitude: 152.8062,
    accuracy: 3
  },
  {
    postalCode: 4655,
    city: "Kawungan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.3,
    longitude: 152.8333,
    accuracy: 4
  },
  {
    postalCode: 4655,
    city: "Kingfisher Bay Resort",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.3074,
    longitude: 152.8123,
    accuracy: 3
  },
  {
    postalCode: 4655,
    city: "Pialba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.287,
    longitude: 152.8437,
    accuracy: 4
  },
  {
    postalCode: 4655,
    city: "Great Sandy Strait",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.3305,
    longitude: 152.8062,
    accuracy: 3
  },
  {
    postalCode: 4655,
    city: "Craignish",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.2826,
    longitude: 152.7243,
    accuracy: 4
  },
  {
    postalCode: 4655,
    city: "Happy Valley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.3376,
    longitude: 153.2005,
    accuracy: 4
  },
  {
    postalCode: 4655,
    city: "Urangan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.2921,
    longitude: 152.9053,
    accuracy: 4
  },
  {
    postalCode: 4655,
    city: "Bunya Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.3305,
    longitude: 152.8062,
    accuracy: 3
  },
  {
    postalCode: 4655,
    city: "Torquay",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.285,
    longitude: 152.8789,
    accuracy: 4
  },
  {
    postalCode: 4655,
    city: "Walligan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.3471,
    longitude: 152.7599,
    accuracy: 4
  },
  {
    postalCode: 4655,
    city: "Eli Waters",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.2865,
    longitude: 152.815,
    accuracy: 4
  },
  {
    postalCode: 4655,
    city: "Point Vernon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.2663,
    longitude: 152.8257,
    accuracy: 4
  },
  {
    postalCode: 4655,
    city: "Dundowran",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.2891,
    longitude: 152.7646,
    accuracy: 4
  },
  {
    postalCode: 4655,
    city: "Takura",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.3571,
    longitude: 152.7482,
    accuracy: 4
  },
  {
    postalCode: 4655,
    city: "Urraween",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.2879,
    longitude: 152.8345,
    accuracy: 4
  },
  {
    postalCode: 4655,
    city: "Dundowran Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.2756,
    longitude: 152.7676,
    accuracy: 4
  },
  {
    postalCode: 4659,
    city: "Beelbi Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.3432,
    longitude: 152.5402,
    accuracy: 3
  },
  {
    postalCode: 4659,
    city: "Pacific Haven",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.2658,
    longitude: 152.5521,
    accuracy: 4
  },
  {
    postalCode: 4659,
    city: "Burrum Heads",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.1846,
    longitude: 152.6126,
    accuracy: 4
  },
  {
    postalCode: 4659,
    city: "Burgowan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.3432,
    longitude: 152.5402,
    accuracy: 3
  },
  {
    postalCode: 4659,
    city: "Howard",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.3193,
    longitude: 152.5599,
    accuracy: 4
  },
  {
    postalCode: 4659,
    city: "Burrum Town",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.3432,
    longitude: 152.5402,
    accuracy: 3
  },
  {
    postalCode: 4659,
    city: "Burrum River",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.2734,
    longitude: 152.5807,
    accuracy: 3
  },
  {
    postalCode: 4660,
    city: "Woodgate",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.1083,
    longitude: 152.5625,
    accuracy: 4
  },
  {
    postalCode: 4660,
    city: "Apple Tree Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.2167,
    longitude: 152.2333,
    accuracy: 4
  },
  {
    postalCode: 4660,
    city: "Cordalba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.1606,
    longitude: 152.2119,
    accuracy: 4
  },
  {
    postalCode: 4660,
    city: "Abington",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.2112,
    longitude: 152.3091,
    accuracy: 3
  },
  {
    postalCode: 4660,
    city: "North Isis",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.177,
    longitude: 152.2643,
    accuracy: 4
  },
  {
    postalCode: 4660,
    city: "Doolbi",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.2333,
    longitude: 152.3,
    accuracy: 4
  },
  {
    postalCode: 4660,
    city: "Redridge",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.1699,
    longitude: 152.3613,
    accuracy: 4
  },
  {
    postalCode: 4660,
    city: "Goodwood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.1457,
    longitude: 152.4103,
    accuracy: 4
  },
  {
    postalCode: 4660,
    city: "Buxton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.1989,
    longitude: 152.5422,
    accuracy: 4
  },
  {
    postalCode: 4660,
    city: "Horton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.2333,
    longitude: 152.3167,
    accuracy: 4
  },
  {
    postalCode: 4660,
    city: "Childers",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.2371,
    longitude: 152.2788,
    accuracy: 4
  },
  {
    postalCode: 4660,
    city: "Cherwell",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.2112,
    longitude: 152.3091,
    accuracy: 3
  },
  {
    postalCode: 4660,
    city: "South Isis",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.1878,
    longitude: 152.3466,
    accuracy: 3
  },
  {
    postalCode: 4660,
    city: "Gregory River",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.2112,
    longitude: 152.3091,
    accuracy: 3
  },
  {
    postalCode: 4660,
    city: "Eureka",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.2112,
    longitude: 152.3091,
    accuracy: 3
  },
  {
    postalCode: 4660,
    city: "Isis Central",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.1946,
    longitude: 152.1876,
    accuracy: 3
  },
  {
    postalCode: 4660,
    city: "Kullogum",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.328,
    longitude: 152.2665,
    accuracy: 3
  },
  {
    postalCode: 4660,
    city: "Farnsfield",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.1878,
    longitude: 152.3466,
    accuracy: 3
  },
  {
    postalCode: 4660,
    city: "Promisedland",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.2112,
    longitude: 152.3091,
    accuracy: 3
  },
  {
    postalCode: 4660,
    city: "Isis River",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.2112,
    longitude: 152.3091,
    accuracy: 3
  },
  {
    postalCode: 4660,
    city: "North Gregory",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.2112,
    longitude: 152.3091,
    accuracy: 3
  },
  {
    postalCode: 4662,
    city: "Torbanlea",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.3453,
    longitude: 152.5938,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Bundaberg North",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.177,
    longitude: 152.2643,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Kepnock",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8761,
    longitude: 152.3752,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Moore Park Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.7204,
    longitude: 152.2638,
    accuracy: 3
  },
  {
    postalCode: 4670,
    city: "Bundaberg",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8662,
    longitude: 152.3479,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Gooburrum",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.85,
    longitude: 152.3167,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Bucca",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8667,
    longitude: 152.1,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Bundaberg Dc",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8542,
    longitude: 152.2352,
    accuracy: 3
  },
  {
    postalCode: 4670,
    city: "Moorland",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.7513,
    longitude: 152.1886,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Elliott",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0063,
    longitude: 152.2758,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Rubyanna",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8158,
    longitude: 152.3916,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Svensson Heights",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8863,
    longitude: 152.3357,
    accuracy: 3
  },
  {
    postalCode: 4670,
    city: "Kalkie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8443,
    longitude: 152.3853,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Bargara",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8148,
    longitude: 152.4626,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Watalgan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.65,
    longitude: 152.0333,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Mullett Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8542,
    longitude: 152.2352,
    accuracy: 3
  },
  {
    postalCode: 4670,
    city: "Fairymead",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.7833,
    longitude: 152.3667,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Avenell Heights",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8896,
    longitude: 152.3679,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Walkervale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8827,
    longitude: 152.3589,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Bundaberg South",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8739,
    longitude: 152.3626,
    accuracy: 3
  },
  {
    postalCode: 4670,
    city: "Avoca",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8782,
    longitude: 152.3079,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Calavos",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.9364,
    longitude: 152.4347,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Oakwood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8667,
    longitude: 152.3,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Burnett Heads",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.7647,
    longitude: 152.4127,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Millbank",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8754,
    longitude: 152.3222,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Meadowvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8161,
    longitude: 152.2771,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Elliott Heads",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.9162,
    longitude: 152.4899,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Welcome Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.7645,
    longitude: 152.276,
    accuracy: 3
  },
  {
    postalCode: 4670,
    city: "Sharon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8759,
    longitude: 152.2699,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Avondale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.7383,
    longitude: 152.1582,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Thabeban",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.9,
    longitude: 152.35,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Winfield",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8801,
    longitude: 152.3305,
    accuracy: 3
  },
  {
    postalCode: 4670,
    city: "South Kolan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.932,
    longitude: 152.1679,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Norville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8931,
    longitude: 152.3409,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Kensington",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.9171,
    longitude: 152.3182,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Abbotsford",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8542,
    longitude: 152.2352,
    accuracy: 3
  },
  {
    postalCode: 4670,
    city: "Kinkuna",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0303,
    longitude: 152.3933,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Alloway",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.9568,
    longitude: 152.3598,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Qunaba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.831,
    longitude: 152.4279,
    accuracy: 3
  },
  {
    postalCode: 4670,
    city: "Branyan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.9135,
    longitude: 152.2725,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Woongarra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8801,
    longitude: 152.3305,
    accuracy: 3
  },
  {
    postalCode: 4670,
    city: "Innes Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8683,
    longitude: 152.4799,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Bundaberg West",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8711,
    longitude: 152.3355,
    accuracy: 3
  },
  {
    postalCode: 4670,
    city: "Coonarr",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.9699,
    longitude: 152.4723,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Bundaberg Central",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.9125,
    longitude: 152.3672,
    accuracy: 3
  },
  {
    postalCode: 4670,
    city: "South Bingera",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.9673,
    longitude: 152.223,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Bundaberg East",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8534,
    longitude: 152.3801,
    accuracy: 3
  },
  {
    postalCode: 4670,
    city: "Ashfield",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8726,
    longitude: 152.3954,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Electra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.9753,
    longitude: 152.1163,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Mon Repos",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8801,
    longitude: 152.3305,
    accuracy: 3
  },
  {
    postalCode: 4670,
    city: "Givelda",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.9908,
    longitude: 152.1516,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Windermere",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.85,
    longitude: 152.45,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Pine Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.011,
    longitude: 152.1697,
    accuracy: 4
  },
  {
    postalCode: 4670,
    city: "Coral Cove",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8831,
    longitude: 152.4827,
    accuracy: 4
  },
  {
    postalCode: 4671,
    city: "Mount Perry",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.1792,
    longitude: 151.6471,
    accuracy: 4
  },
  {
    postalCode: 4671,
    city: "Redhill Farms",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0574,
    longitude: 151.6613,
    accuracy: 3
  },
  {
    postalCode: 4671,
    city: "Bungadoo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.9833,
    longitude: 152.0709,
    accuracy: 4
  },
  {
    postalCode: 4671,
    city: "Monduran",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0574,
    longitude: 151.6613,
    accuracy: 3
  },
  {
    postalCode: 4671,
    city: "Wallaville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0765,
    longitude: 151.9952,
    accuracy: 4
  },
  {
    postalCode: 4671,
    city: "Skyring Reserve",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0574,
    longitude: 151.6613,
    accuracy: 3
  },
  {
    postalCode: 4671,
    city: "Booyal",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.2164,
    longitude: 152.0399,
    accuracy: 4
  },
  {
    postalCode: 4671,
    city: "Molangul",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.75,
    longitude: 151.55,
    accuracy: 4
  },
  {
    postalCode: 4671,
    city: "Boolboonda",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0833,
    longitude: 151.6833,
    accuracy: 4
  },
  {
    postalCode: 4671,
    city: "Doughboy",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0574,
    longitude: 151.6613,
    accuracy: 3
  },
  {
    postalCode: 4671,
    city: "Gin Gin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.9936,
    longitude: 151.9581,
    accuracy: 4
  },
  {
    postalCode: 4671,
    city: "Drinan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.05,
    longitude: 152.0167,
    accuracy: 4
  },
  {
    postalCode: 4671,
    city: "Tirroan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0167,
    longitude: 151.9333,
    accuracy: 4
  },
  {
    postalCode: 4671,
    city: "Duingal",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0574,
    longitude: 151.6613,
    accuracy: 3
  },
  {
    postalCode: 4671,
    city: "Dalysford",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0167,
    longitude: 151.8833,
    accuracy: 4
  },
  {
    postalCode: 4671,
    city: "Maroondan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.9667,
    longitude: 152.0167,
    accuracy: 4
  },
  {
    postalCode: 4671,
    city: "Delan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0171,
    longitude: 152.0505,
    accuracy: 4
  },
  {
    postalCode: 4671,
    city: "Good Night",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0574,
    longitude: 151.6613,
    accuracy: 3
  },
  {
    postalCode: 4671,
    city: "Wonbah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.1,
    longitude: 151.65,
    accuracy: 4
  },
  {
    postalCode: 4671,
    city: "Lake Monduran",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0574,
    longitude: 151.6613,
    accuracy: 3
  },
  {
    postalCode: 4671,
    city: "Kolonga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0574,
    longitude: 151.6613,
    accuracy: 3
  },
  {
    postalCode: 4671,
    city: "Mungy",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0574,
    longitude: 151.6613,
    accuracy: 3
  },
  {
    postalCode: 4671,
    city: "St Agnes",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0574,
    longitude: 151.6613,
    accuracy: 3
  },
  {
    postalCode: 4671,
    city: "Gaeta",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8333,
    longitude: 151.6,
    accuracy: 4
  },
  {
    postalCode: 4671,
    city: "Moolboolaman",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0167,
    longitude: 151.8167,
    accuracy: 4
  },
  {
    postalCode: 4671,
    city: "Bullyard",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.95,
    longitude: 152.0667,
    accuracy: 4
  },
  {
    postalCode: 4671,
    city: "Damascus",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0574,
    longitude: 151.6613,
    accuracy: 3
  },
  {
    postalCode: 4671,
    city: "Mcilwraith",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.9833,
    longitude: 152,
    accuracy: 4
  },
  {
    postalCode: 4671,
    city: "Morganville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.1731,
    longitude: 151.9704,
    accuracy: 3
  },
  {
    postalCode: 4671,
    city: "Horse Camp",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.066,
    longitude: 151.8924,
    accuracy: 3
  },
  {
    postalCode: 4671,
    city: "Wonbah Forest",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0574,
    longitude: 151.6613,
    accuracy: 3
  },
  {
    postalCode: 4671,
    city: "New Moonta",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0574,
    longitude: 151.6613,
    accuracy: 3
  },
  {
    postalCode: 4671,
    city: "Nearum",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0574,
    longitude: 151.6613,
    accuracy: 3
  },
  {
    postalCode: 4671,
    city: "Takilberan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0574,
    longitude: 151.6613,
    accuracy: 3
  },
  {
    postalCode: 4671,
    city: "St Kilda",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0574,
    longitude: 151.6613,
    accuracy: 3
  },
  {
    postalCode: 4673,
    city: "Yandaran",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.7217,
    longitude: 152.114,
    accuracy: 4
  },
  {
    postalCode: 4673,
    city: "Waterloo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.7241,
    longitude: 152.0437,
    accuracy: 3
  },
  {
    postalCode: 4673,
    city: "Littabella",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.6857,
    longitude: 152.0781,
    accuracy: 4
  },
  {
    postalCode: 4673,
    city: "Miara",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.7241,
    longitude: 152.0437,
    accuracy: 3
  },
  {
    postalCode: 4674,
    city: "Berajondo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.6171,
    longitude: 151.8441,
    accuracy: 4
  },
  {
    postalCode: 4674,
    city: "Euleilah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.45,
    longitude: 151.8667,
    accuracy: 4
  },
  {
    postalCode: 4674,
    city: "Oyster Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.6184,
    longitude: 151.8492,
    accuracy: 3
  },
  {
    postalCode: 4674,
    city: "Baffle Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.5,
    longitude: 151.9333,
    accuracy: 4
  },
  {
    postalCode: 4674,
    city: "Deepwater",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.6184,
    longitude: 151.8492,
    accuracy: 3
  },
  {
    postalCode: 4674,
    city: "Taunton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.4205,
    longitude: 151.8218,
    accuracy: 4
  },
  {
    postalCode: 4674,
    city: "Rules Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.6184,
    longitude: 151.8492,
    accuracy: 3
  },
  {
    postalCode: 4674,
    city: "Mount Maria",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.6184,
    longitude: 151.8492,
    accuracy: 3
  },
  {
    postalCode: 4674,
    city: "Rosedale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.629,
    longitude: 151.9189,
    accuracy: 4
  },
  {
    postalCode: 4676,
    city: "Gindoran",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.6263,
    longitude: 151.5919,
    accuracy: 3
  },
  {
    postalCode: 4676,
    city: "Lowmead",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.5295,
    longitude: 151.7532,
    accuracy: 4
  },
  {
    postalCode: 4677,
    city: "Miriam Vale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.3321,
    longitude: 151.5629,
    accuracy: 4
  },
  {
    postalCode: 4677,
    city: "Eurimbula",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.1047,
    longitude: 151.7138,
    accuracy: 3
  },
  {
    postalCode: 4677,
    city: "Colosseum",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.3902,
    longitude: 151.6121,
    accuracy: 4
  },
  {
    postalCode: 4677,
    city: "Agnes Water",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.2119,
    longitude: 151.9035,
    accuracy: 4
  },
  {
    postalCode: 4677,
    city: "Seventeen Seventy",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.1687,
    longitude: 151.8839,
    accuracy: 4
  },
  {
    postalCode: 4677,
    city: "Mount Tom",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.364,
    longitude: 151.6458,
    accuracy: 3
  },
  {
    postalCode: 4677,
    city: "Round Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.364,
    longitude: 151.6458,
    accuracy: 3
  },
  {
    postalCode: 4677,
    city: "Captain Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.364,
    longitude: 151.6458,
    accuracy: 3
  },
  {
    postalCode: 4678,
    city: "Rodds Bay",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.0633,
    longitude: 151.3874,
    accuracy: 4
  },
  {
    postalCode: 4678,
    city: "Foreshores",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.1383,
    longitude: 151.5912,
    accuracy: 3
  },
  {
    postalCode: 4678,
    city: "Turkey Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.1942,
    longitude: 151.5456,
    accuracy: 3
  },
  {
    postalCode: 4678,
    city: "Bororen",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.2406,
    longitude: 151.496,
    accuracy: 4
  },
  {
    postalCode: 4680,
    city: "Glen Eden",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8974,
    longitude: 151.2713,
    accuracy: 4
  },
  {
    postalCode: 4680,
    city: "Gladstone",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8485,
    longitude: 151.2577,
    accuracy: 4
  },
  {
    postalCode: 4680,
    city: "Beecher",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.9,
    longitude: 151.2,
    accuracy: 4
  },
  {
    postalCode: 4680,
    city: "Callemondah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8493,
    longitude: 151.2312,
    accuracy: 3
  },
  {
    postalCode: 4680,
    city: "Byellee",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.874,
    longitude: 151.1946,
    accuracy: 4
  },
  {
    postalCode: 4680,
    city: "Tannum Sands",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.9475,
    longitude: 151.3675,
    accuracy: 4
  },
  {
    postalCode: 4680,
    city: "Heron Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.4418,
    longitude: 151.9125,
    accuracy: 4
  },
  {
    postalCode: 4680,
    city: "Burua",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.95,
    longitude: 151.2167,
    accuracy: 4
  },
  {
    postalCode: 4680,
    city: "Benaraby",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.0042,
    longitude: 151.3341,
    accuracy: 4
  },
  {
    postalCode: 4680,
    city: "Boyne Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.9483,
    longitude: 151.3534,
    accuracy: 4
  },
  {
    postalCode: 4680,
    city: "Kirkwood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.9033,
    longitude: 151.2354,
    accuracy: 4
  },
  {
    postalCode: 4680,
    city: "South End",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.9766,
    longitude: 151.2768,
    accuracy: 3
  },
  {
    postalCode: 4680,
    city: "Kin Kora",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.877,
    longitude: 151.2472,
    accuracy: 4
  },
  {
    postalCode: 4680,
    city: "Gladstone BC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.9766,
    longitude: 151.2768,
    accuracy: 3
  },
  {
    postalCode: 4680,
    city: "West Stowe",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.9123,
    longitude: 151.1302,
    accuracy: 4
  },
  {
    postalCode: 4680,
    city: "Telina",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8883,
    longitude: 151.2538,
    accuracy: 4
  },
  {
    postalCode: 4680,
    city: "Wooderson",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.1333,
    longitude: 151.1365,
    accuracy: 3
  },
  {
    postalCode: 4680,
    city: "Builyan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.525,
    longitude: 151.3848,
    accuracy: 4
  },
  {
    postalCode: 4680,
    city: "Gladstone Central",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.9766,
    longitude: 151.2768,
    accuracy: 3
  },
  {
    postalCode: 4680,
    city: "Boynedale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.2144,
    longitude: 151.245,
    accuracy: 4
  },
  {
    postalCode: 4680,
    city: "Barney Point",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8568,
    longitude: 151.2713,
    accuracy: 3
  },
  {
    postalCode: 4680,
    city: "Iveragh",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.1333,
    longitude: 151.45,
    accuracy: 4
  },
  {
    postalCode: 4680,
    city: "River Ranch",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.982,
    longitude: 151.1583,
    accuracy: 4
  },
  {
    postalCode: 4680,
    city: "South Gladstone",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.869,
    longitude: 151.2783,
    accuracy: 4
  },
  {
    postalCode: 4680,
    city: "Boyne Valley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.3873,
    longitude: 151.1936,
    accuracy: 3
  },
  {
    postalCode: 4680,
    city: "Wurdong Heights",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.9766,
    longitude: 151.2768,
    accuracy: 3
  },
  {
    postalCode: 4680,
    city: "Tablelands",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.1333,
    longitude: 151.1365,
    accuracy: 3
  },
  {
    postalCode: 4680,
    city: "Clinton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8752,
    longitude: 151.2179,
    accuracy: 4
  },
  {
    postalCode: 4680,
    city: "O'Connell",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.1333,
    longitude: 151.1365,
    accuracy: 3
  },
  {
    postalCode: 4680,
    city: "West Gladstone",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.9123,
    longitude: 151.1302,
    accuracy: 4
  },
  {
    postalCode: 4680,
    city: "Taragoola",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.1003,
    longitude: 151.2196,
    accuracy: 4
  },
  {
    postalCode: 4680,
    city: "Gladstone DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.9766,
    longitude: 151.2768,
    accuracy: 3
  },
  {
    postalCode: 4680,
    city: "South Trees",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.869,
    longitude: 151.2783,
    accuracy: 4
  },
  {
    postalCode: 4680,
    city: "New Auckland",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8836,
    longitude: 151.2356,
    accuracy: 4
  },
  {
    postalCode: 4680,
    city: "Toolooa",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.9333,
    longitude: 151.2833,
    accuracy: 4
  },
  {
    postalCode: 4680,
    city: "Diglum",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.1333,
    longitude: 151.1365,
    accuracy: 3
  },
  {
    postalCode: 4680,
    city: "Calliope",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.007,
    longitude: 151.2003,
    accuracy: 4
  },
  {
    postalCode: 4680,
    city: "Sun Valley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8752,
    longitude: 151.2575,
    accuracy: 4
  },
  {
    postalCode: 4680,
    city: "Curtis Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.9766,
    longitude: 151.2768,
    accuracy: 3
  },
  {
    postalCode: 4680,
    city: "Gladstone Harbour",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.9766,
    longitude: 151.2768,
    accuracy: 3
  },
  {
    postalCode: 4680,
    city: "Ubobo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.4046,
    longitude: 151.3234,
    accuracy: 4
  },
  {
    postalCode: 4680,
    city: "Mount Alma",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.0312,
    longitude: 150.8779,
    accuracy: 4
  },
  {
    postalCode: 4694,
    city: "Targinnie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8,
    longitude: 151.1,
    accuracy: 4
  },
  {
    postalCode: 4694,
    city: "Aldoga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.7602,
    longitude: 151.0899,
    accuracy: 3
  },
  {
    postalCode: 4694,
    city: "Targinie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8,
    longitude: 151.1,
    accuracy: 4
  },
  {
    postalCode: 4694,
    city: "Yarwun",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.85,
    longitude: 151.1167,
    accuracy: 4
  },
  {
    postalCode: 4695,
    city: "Bracewell",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.9,
    longitude: 150.9,
    accuracy: 4
  },
  {
    postalCode: 4695,
    city: "The Narrows",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.7923,
    longitude: 150.8651,
    accuracy: 3
  },
  {
    postalCode: 4695,
    city: "Ambrose",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8,
    longitude: 150.9333,
    accuracy: 4
  },
  {
    postalCode: 4695,
    city: "Darts Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.7923,
    longitude: 150.8651,
    accuracy: 3
  },
  {
    postalCode: 4695,
    city: "Mount Larcom",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8121,
    longitude: 150.9789,
    accuracy: 4
  },
  {
    postalCode: 4695,
    city: "Machine Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.7923,
    longitude: 150.8651,
    accuracy: 3
  },
  {
    postalCode: 4695,
    city: "East End",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.7923,
    longitude: 150.8651,
    accuracy: 3
  },
  {
    postalCode: 4697,
    city: "Raglan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.7167,
    longitude: 150.8167,
    accuracy: 4
  },
  {
    postalCode: 4699,
    city: "Port Alma",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.5831,
    longitude: 150.8608,
    accuracy: 4
  },
  {
    postalCode: 4699,
    city: "Bajool",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6667,
    longitude: 150.65,
    accuracy: 4
  },
  {
    postalCode: 4700,
    city: "Fairy Bower",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.4053,
    longitude: 150.4654,
    accuracy: 4
  },
  {
    postalCode: 4700,
    city: "Rockhampton City",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.3772,
    longitude: 150.5099,
    accuracy: 3
  },
  {
    postalCode: 4700,
    city: "Wandal",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.3688,
    longitude: 150.4938,
    accuracy: 4
  },
  {
    postalCode: 4700,
    city: "West Rockhampton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.3794,
    longitude: 150.4818,
    accuracy: 4
  },
  {
    postalCode: 4700,
    city: "Great Keppel Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.2698,
    longitude: 150.718,
    accuracy: 3
  },
  {
    postalCode: 4700,
    city: "The Range",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.392,
    longitude: 150.4962,
    accuracy: 4
  },
  {
    postalCode: 4700,
    city: "Rockhampton Hospital",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.3636,
    longitude: 150.559,
    accuracy: 3
  },
  {
    postalCode: 4700,
    city: "Rockhampton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.3803,
    longitude: 150.506,
    accuracy: 4
  },
  {
    postalCode: 4700,
    city: "The Keppels",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.0695,
    longitude: 150.8913,
    accuracy: 4
  },
  {
    postalCode: 4700,
    city: "Allenstown",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.394,
    longitude: 150.5039,
    accuracy: 4
  },
  {
    postalCode: 4700,
    city: "Depot Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.3902,
    longitude: 150.521,
    accuracy: 4
  },
  {
    postalCode: 4700,
    city: "Port Curtis",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.4117,
    longitude: 150.5098,
    accuracy: 4
  },
  {
    postalCode: 4701,
    city: "Nerimbera",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.4,
    longitude: 150.5833,
    accuracy: 4
  },
  {
    postalCode: 4701,
    city: "Central Queensland University",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.3815,
    longitude: 150.6125,
    accuracy: 3
  },
  {
    postalCode: 4701,
    city: "Koongal",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.3689,
    longitude: 150.5492,
    accuracy: 4
  },
  {
    postalCode: 4701,
    city: "Nankin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.3833,
    longitude: 150.6333,
    accuracy: 4
  },
  {
    postalCode: 4701,
    city: "Red Hill Rockhampton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.3656,
    longitude: 150.5483,
    accuracy: 3
  },
  {
    postalCode: 4701,
    city: "The Common",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.3815,
    longitude: 150.5334,
    accuracy: 4
  },
  {
    postalCode: 4701,
    city: "Rockyview",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.2364,
    longitude: 150.5196,
    accuracy: 3
  },
  {
    postalCode: 4701,
    city: "Kawana",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.3393,
    longitude: 150.5049,
    accuracy: 4
  },
  {
    postalCode: 4701,
    city: "North Rockhampton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.3815,
    longitude: 150.6125,
    accuracy: 3
  },
  {
    postalCode: 4701,
    city: "Berserker",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.3582,
    longitude: 150.5204,
    accuracy: 4
  },
  {
    postalCode: 4701,
    city: "Sandringham",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.3815,
    longitude: 150.6125,
    accuracy: 3
  },
  {
    postalCode: 4701,
    city: "Lakes Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.3833,
    longitude: 150.5667,
    accuracy: 4
  },
  {
    postalCode: 4701,
    city: "Ironpot",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.3656,
    longitude: 150.5483,
    accuracy: 3
  },
  {
    postalCode: 4701,
    city: "Frenchville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.3476,
    longitude: 150.5445,
    accuracy: 4
  },
  {
    postalCode: 4701,
    city: "Mount Archer",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.3815,
    longitude: 150.6125,
    accuracy: 3
  },
  {
    postalCode: 4701,
    city: "Park Avenue",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.3533,
    longitude: 150.5189,
    accuracy: 4
  },
  {
    postalCode: 4701,
    city: "Greenlake",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.3815,
    longitude: 150.6125,
    accuracy: 3
  },
  {
    postalCode: 4701,
    city: "Norman Gardens",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.3304,
    longitude: 150.5275,
    accuracy: 4
  },
  {
    postalCode: 4701,
    city: "Limestone Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.2868,
    longitude: 150.5677,
    accuracy: 3
  },
  {
    postalCode: 4701,
    city: "Rockhampton DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.3656,
    longitude: 150.5483,
    accuracy: 3
  },
  {
    postalCode: 4702,
    city: "Rolleston",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.4645,
    longitude: 148.6226,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Westwood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.5969,
    longitude: 150.1675,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Smoky Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.1376,
    longitude: 150.3786,
    accuracy: 3
  },
  {
    postalCode: 4702,
    city: "Yaraka",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8842,
    longitude: 144.08,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Cawarral",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.2667,
    longitude: 150.6667,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "South Yaamba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8022,
    longitude: 148.7101,
    accuracy: 3
  },
  {
    postalCode: 4702,
    city: "Milman",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.1333,
    longitude: 150.4,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Garnant",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8022,
    longitude: 148.7101,
    accuracy: 3
  },
  {
    postalCode: 4702,
    city: "Stanwell",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.4833,
    longitude: 150.3167,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Anakie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.55,
    longitude: 147.75,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Morinish",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.25,
    longitude: 150.15,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Goomally",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8022,
    longitude: 148.7101,
    accuracy: 3
  },
  {
    postalCode: 4702,
    city: "Alton Downs",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.3,
    longitude: 150.35,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Plum Tree",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.5089,
    longitude: 150.1078,
    accuracy: 3
  },
  {
    postalCode: 4702,
    city: "Banana",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.4688,
    longitude: 150.1349,
    accuracy: 3
  },
  {
    postalCode: 4702,
    city: "Mimosa",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8022,
    longitude: 148.7101,
    accuracy: 3
  },
  {
    postalCode: 4702,
    city: "Willows",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.7436,
    longitude: 147.5425,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Willows Gemfields",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.7436,
    longitude: 147.5425,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Kunwarara",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.9167,
    longitude: 150.1333,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Joskeleigh",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.3801,
    longitude: 150.7786,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Bluff",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.5805,
    longitude: 149.0685,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Rossmoya",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.0333,
    longitude: 150.4833,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Gracemere",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.4379,
    longitude: 150.4575,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Canal Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8022,
    longitude: 148.7101,
    accuracy: 3
  },
  {
    postalCode: 4702,
    city: "Jambin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.1948,
    longitude: 150.3706,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Canoona",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.0833,
    longitude: 150.2667,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Goovigen",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.1459,
    longitude: 150.2853,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Dumpy Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8022,
    longitude: 148.7101,
    accuracy: 3
  },
  {
    postalCode: 4702,
    city: "Coowonga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.2833,
    longitude: 150.7167,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Comet",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6,
    longitude: 148.55,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Mount Chalmers",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.3,
    longitude: 150.65,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Gainsford",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8022,
    longitude: 148.7101,
    accuracy: 3
  },
  {
    postalCode: 4702,
    city: "Gindie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.7333,
    longitude: 148.1333,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Dalma",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.35,
    longitude: 150.25,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Pink Lily",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.35,
    longitude: 150.4667,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Stanage",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.1613,
    longitude: 150.0676,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "The Caves",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.1833,
    longitude: 150.4667,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Dululu",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.85,
    longitude: 150.25,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Bushley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.5333,
    longitude: 150.25,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Jardine",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8022,
    longitude: 148.7101,
    accuracy: 3
  },
  {
    postalCode: 4702,
    city: "Keppel Sands",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.3259,
    longitude: 150.7873,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Kalapa",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.5167,
    longitude: 150.2667,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Argoon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.2527,
    longitude: 150.4359,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Kokotungo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8022,
    longitude: 148.7101,
    accuracy: 3
  },
  {
    postalCode: 4702,
    city: "Wowan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.9167,
    longitude: 150.1833,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Shoalwater",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8022,
    longitude: 148.7101,
    accuracy: 3
  },
  {
    postalCode: 4702,
    city: "Tungamull",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.3167,
    longitude: 150.6833,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Woolein",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8022,
    longitude: 148.7101,
    accuracy: 3
  },
  {
    postalCode: 4702,
    city: "Dingo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.65,
    longitude: 149.3333,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Rubyvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.4182,
    longitude: 147.6991,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Etna Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.2167,
    longitude: 150.4667,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Bingegang",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8022,
    longitude: 148.7101,
    accuracy: 3
  },
  {
    postalCode: 4702,
    city: "Baralaba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.1745,
    longitude: 149.8156,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Alsace",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.2806,
    longitude: 149.3524,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Ulogie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8022,
    longitude: 148.7101,
    accuracy: 3
  },
  {
    postalCode: 4702,
    city: "Alberta",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8022,
    longitude: 148.7101,
    accuracy: 3
  },
  {
    postalCode: 4702,
    city: "Coorumbene",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.5089,
    longitude: 150.1078,
    accuracy: 3
  },
  {
    postalCode: 4702,
    city: "Marmor",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6833,
    longitude: 150.7167,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Blackdown",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8022,
    longitude: 148.7101,
    accuracy: 3
  },
  {
    postalCode: 4702,
    city: "Coorooman",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.2667,
    longitude: 150.7333,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Wooroona",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8022,
    longitude: 148.7101,
    accuracy: 3
  },
  {
    postalCode: 4702,
    city: "Wycarbah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.55,
    longitude: 150.2167,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Mackenzie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8022,
    longitude: 148.7101,
    accuracy: 3
  },
  {
    postalCode: 4702,
    city: "Wallaroo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.7,
    longitude: 149.5667,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Kabra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.4667,
    longitude: 150.4,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Boolburra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.7333,
    longitude: 149.7667,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Yalleroi",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.0682,
    longitude: 145.7578,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Bouldercombe",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.5705,
    longitude: 150.4695,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Thompson Point",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8022,
    longitude: 148.7101,
    accuracy: 3
  },
  {
    postalCode: 4702,
    city: "Dixalea",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.9333,
    longitude: 150.2833,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Jellinbah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8022,
    longitude: 148.7101,
    accuracy: 3
  },
  {
    postalCode: 4702,
    city: "Goowarra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6667,
    longitude: 149.4167,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Stewarton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8022,
    longitude: 148.7101,
    accuracy: 3
  },
  {
    postalCode: 4702,
    city: "Midgee",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.5167,
    longitude: 150.55,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Lowesby",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.5089,
    longitude: 150.1078,
    accuracy: 3
  },
  {
    postalCode: 4702,
    city: "Sapphire",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.4573,
    longitude: 147.7244,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Central Queensland Mc",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8022,
    longitude: 148.7101,
    accuracy: 3
  },
  {
    postalCode: 4702,
    city: "Gogango",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6667,
    longitude: 150.0333,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Balcomba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8022,
    longitude: 148.7101,
    accuracy: 3
  },
  {
    postalCode: 4702,
    city: "Parkhurst",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.3,
    longitude: 150.5167,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Barnard",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8022,
    longitude: 148.7101,
    accuracy: 3
  },
  {
    postalCode: 4702,
    city: "Nine Mile",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8022,
    longitude: 148.7101,
    accuracy: 3
  },
  {
    postalCode: 4702,
    city: "Ridgelands",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.25,
    longitude: 150.2833,
    accuracy: 4
  },
  {
    postalCode: 4702,
    city: "Consuelo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.5089,
    longitude: 150.1078,
    accuracy: 3
  },
  {
    postalCode: 4702,
    city: "Glenroy",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.7953,
    longitude: 151.9335,
    accuracy: 3
  },
  {
    postalCode: 4702,
    city: "Coomoo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8022,
    longitude: 148.7101,
    accuracy: 3
  },
  {
    postalCode: 4702,
    city: "Morinish South",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8022,
    longitude: 148.7101,
    accuracy: 3
  },
  {
    postalCode: 4702,
    city: "Pheasant Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8022,
    longitude: 148.7101,
    accuracy: 3
  },
  {
    postalCode: 4703,
    city: "Byfield",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.8476,
    longitude: 150.6502,
    accuracy: 4
  },
  {
    postalCode: 4703,
    city: "Bungundarra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.049,
    longitude: 150.6384,
    accuracy: 4
  },
  {
    postalCode: 4703,
    city: "Adelaide Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.0968,
    longitude: 150.6957,
    accuracy: 4
  },
  {
    postalCode: 4703,
    city: "Hidden Valley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.9308,
    longitude: 150.6842,
    accuracy: 3
  },
  {
    postalCode: 4703,
    city: "Yeppoon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.1268,
    longitude: 150.7441,
    accuracy: 4
  },
  {
    postalCode: 4703,
    city: "Maryvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -28.0687,
    longitude: 152.2436,
    accuracy: 4
  },
  {
    postalCode: 4703,
    city: "Bangalee",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.075,
    longitude: 150.7622,
    accuracy: 4
  },
  {
    postalCode: 4703,
    city: "Lake Mary",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.1144,
    longitude: 150.585,
    accuracy: 3
  },
  {
    postalCode: 4703,
    city: "Mulambin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.1876,
    longitude: 150.7893,
    accuracy: 4
  },
  {
    postalCode: 4703,
    city: "Causeway Lake",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.1978,
    longitude: 150.7876,
    accuracy: 4
  },
  {
    postalCode: 4703,
    city: "Inverness",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.1158,
    longitude: 150.7231,
    accuracy: 4
  },
  {
    postalCode: 4703,
    city: "Mulara",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.9308,
    longitude: 150.6842,
    accuracy: 3
  },
  {
    postalCode: 4703,
    city: "Cooee Bay",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.1443,
    longitude: 150.7611,
    accuracy: 4
  },
  {
    postalCode: 4703,
    city: "Stockyard",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.8801,
    longitude: 150.7321,
    accuracy: 4
  },
  {
    postalCode: 4703,
    city: "Tanby",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.2333,
    longitude: 150.75,
    accuracy: 4
  },
  {
    postalCode: 4703,
    city: "Cobraball",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.9308,
    longitude: 150.6842,
    accuracy: 3
  },
  {
    postalCode: 4703,
    city: "Barmoya",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.1465,
    longitude: 150.5467,
    accuracy: 4
  },
  {
    postalCode: 4703,
    city: "Farnborough",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.0912,
    longitude: 150.7415,
    accuracy: 4
  },
  {
    postalCode: 4703,
    city: "Taranganba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.1443,
    longitude: 150.7514,
    accuracy: 4
  },
  {
    postalCode: 4703,
    city: "Taroomball",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.1727,
    longitude: 150.7422,
    accuracy: 3
  },
  {
    postalCode: 4703,
    city: "Bondoola",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.1667,
    longitude: 150.6833,
    accuracy: 4
  },
  {
    postalCode: 4703,
    city: "Kinka Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.2247,
    longitude: 150.7968,
    accuracy: 4
  },
  {
    postalCode: 4703,
    city: "Weerriba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.9308,
    longitude: 150.6842,
    accuracy: 3
  },
  {
    postalCode: 4703,
    city: "Rosslyn",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.1661,
    longitude: 150.7783,
    accuracy: 4
  },
  {
    postalCode: 4703,
    city: "Meikleville Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.1131,
    longitude: 150.7447,
    accuracy: 4
  },
  {
    postalCode: 4703,
    city: "Pacific Heights",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.0981,
    longitude: 150.7386,
    accuracy: 4
  },
  {
    postalCode: 4703,
    city: "Barlows Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.1076,
    longitude: 150.7451,
    accuracy: 4
  },
  {
    postalCode: 4703,
    city: "Lammermoor",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.1608,
    longitude: 150.7608,
    accuracy: 4
  },
  {
    postalCode: 4703,
    city: "Barmaryee",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.1333,
    longitude: 150.7167,
    accuracy: 4
  },
  {
    postalCode: 4703,
    city: "Woodbury",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.9788,
    longitude: 150.7052,
    accuracy: 4
  },
  {
    postalCode: 4704,
    city: "Wattlebank",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.1333,
    longitude: 150.3667,
    accuracy: 3
  },
  {
    postalCode: 4704,
    city: "Yaamba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.1333,
    longitude: 150.3667,
    accuracy: 4
  },
  {
    postalCode: 4705,
    city: "Mackenzie River",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.9527,
    longitude: 148.9351,
    accuracy: 3
  },
  {
    postalCode: 4705,
    city: "Lotus Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.5566,
    longitude: 149.6096,
    accuracy: 3
  },
  {
    postalCode: 4705,
    city: "Marlborough",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.8167,
    longitude: 149.8833,
    accuracy: 4
  },
  {
    postalCode: 4705,
    city: "Mount Gardiner",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.5566,
    longitude: 149.6096,
    accuracy: 3
  },
  {
    postalCode: 4705,
    city: "Clarke Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.5566,
    longitude: 149.6096,
    accuracy: 3
  },
  {
    postalCode: 4706,
    city: "Ogmore",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.6167,
    longitude: 149.65,
    accuracy: 4
  },
  {
    postalCode: 4707,
    city: "St Lawrence",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.3456,
    longitude: 149.5353,
    accuracy: 4
  },
  {
    postalCode: 4707,
    city: "The Percy Group",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.6123,
    longitude: 149.2367,
    accuracy: 3
  },
  {
    postalCode: 4707,
    city: "Collaroy",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.6123,
    longitude: 149.2367,
    accuracy: 3
  },
  {
    postalCode: 4709,
    city: "Tieri",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.0383,
    longitude: 148.3446,
    accuracy: 4
  },
  {
    postalCode: 4710,
    city: "Emu Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.2568,
    longitude: 150.8268,
    accuracy: 4
  },
  {
    postalCode: 4710,
    city: "Zilzie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.273,
    longitude: 150.8183,
    accuracy: 4
  },
  {
    postalCode: 4711,
    city: "Glendale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.2569,
    longitude: 150.4849,
    accuracy: 1
  },
  {
    postalCode: 4711,
    city: "Glenlee",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.2569,
    longitude: 150.4849,
    accuracy: 1
  },
  {
    postalCode: 4712,
    city: "Duaringa",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.7158,
    longitude: 149.6701,
    accuracy: 4
  },
  {
    postalCode: 4713,
    city: "Woorabinda",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.1306,
    longitude: 149.4566,
    accuracy: 4
  },
  {
    postalCode: 4714,
    city: "Hamilton Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6989,
    longitude: 150.3337,
    accuracy: 3
  },
  {
    postalCode: 4714,
    city: "Baree",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6167,
    longitude: 150.4,
    accuracy: 4
  },
  {
    postalCode: 4714,
    city: "Wura",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.8167,
    longitude: 150.3333,
    accuracy: 4
  },
  {
    postalCode: 4714,
    city: "Walterhall",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6333,
    longitude: 150.4,
    accuracy: 4
  },
  {
    postalCode: 4714,
    city: "Struck Oil",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6714,
    longitude: 150.3843,
    accuracy: 3
  },
  {
    postalCode: 4714,
    city: "Mount Morgan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6453,
    longitude: 150.389,
    accuracy: 4
  },
  {
    postalCode: 4714,
    city: "Trotter Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6989,
    longitude: 150.3337,
    accuracy: 3
  },
  {
    postalCode: 4714,
    city: "Moongan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6,
    longitude: 150.4,
    accuracy: 4
  },
  {
    postalCode: 4714,
    city: "Nine Mile Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6989,
    longitude: 150.3337,
    accuracy: 3
  },
  {
    postalCode: 4714,
    city: "Horse Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6989,
    longitude: 150.3337,
    accuracy: 3
  },
  {
    postalCode: 4714,
    city: "Leydens Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6989,
    longitude: 150.3337,
    accuracy: 3
  },
  {
    postalCode: 4714,
    city: "Fletcher Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6989,
    longitude: 150.3337,
    accuracy: 3
  },
  {
    postalCode: 4714,
    city: "Walmul",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.7167,
    longitude: 150.3833,
    accuracy: 4
  },
  {
    postalCode: 4714,
    city: "Boulder Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6989,
    longitude: 150.3337,
    accuracy: 3
  },
  {
    postalCode: 4714,
    city: "The Mine",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6296,
    longitude: 150.3747,
    accuracy: 3
  },
  {
    postalCode: 4714,
    city: "Limestone",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6989,
    longitude: 150.3337,
    accuracy: 3
  },
  {
    postalCode: 4714,
    city: "Oakey Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6989,
    longitude: 150.3337,
    accuracy: 3
  },
  {
    postalCode: 4714,
    city: "Johnsons Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6989,
    longitude: 150.3337,
    accuracy: 3
  },
  {
    postalCode: 4715,
    city: "Biloela",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.3959,
    longitude: 150.515,
    accuracy: 4
  },
  {
    postalCode: 4715,
    city: "Tarramba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.3982,
    longitude: 150.5467,
    accuracy: 3
  },
  {
    postalCode: 4715,
    city: "Prospect",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.5117,
    longitude: 150.4189,
    accuracy: 4
  },
  {
    postalCode: 4715,
    city: "Greycliffe",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.3982,
    longitude: 150.5467,
    accuracy: 3
  },
  {
    postalCode: 4715,
    city: "Valentine Plains",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.4167,
    longitude: 150.5833,
    accuracy: 4
  },
  {
    postalCode: 4715,
    city: "Mount Murchison",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.412,
    longitude: 150.5031,
    accuracy: 3
  },
  {
    postalCode: 4715,
    city: "Callide",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.3004,
    longitude: 150.4656,
    accuracy: 4
  },
  {
    postalCode: 4715,
    city: "Dumgree",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.3982,
    longitude: 150.5467,
    accuracy: 3
  },
  {
    postalCode: 4715,
    city: "Dakenba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.3485,
    longitude: 150.4976,
    accuracy: 4
  },
  {
    postalCode: 4715,
    city: "Castle Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.3982,
    longitude: 150.5467,
    accuracy: 3
  },
  {
    postalCode: 4715,
    city: "Orange Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.3582,
    longitude: 150.3213,
    accuracy: 3
  },
  {
    postalCode: 4716,
    city: "Thangool",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.4863,
    longitude: 150.5736,
    accuracy: 4
  },
  {
    postalCode: 4716,
    city: "Lawgi Dawes",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.6038,
    longitude: 150.781,
    accuracy: 4
  },
  {
    postalCode: 4717,
    city: "Blackwater",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.5835,
    longitude: 148.8791,
    accuracy: 4
  },
  {
    postalCode: 4718,
    city: "Roundstone",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.4746,
    longitude: 149.4083,
    accuracy: 3
  },
  {
    postalCode: 4718,
    city: "Kianga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.6936,
    longitude: 150.0128,
    accuracy: 4
  },
  {
    postalCode: 4718,
    city: "Bauhinia",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.4746,
    longitude: 149.4083,
    accuracy: 3
  },
  {
    postalCode: 4718,
    city: "Moura",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.5722,
    longitude: 149.9673,
    accuracy: 4
  },
  {
    postalCode: 4718,
    city: "Mungabunda",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.4746,
    longitude: 149.4083,
    accuracy: 3
  },
  {
    postalCode: 4718,
    city: "Oombabeer",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.4746,
    longitude: 149.4083,
    accuracy: 3
  },
  {
    postalCode: 4718,
    city: "Dromedary",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.4746,
    longitude: 149.4083,
    accuracy: 3
  },
  {
    postalCode: 4718,
    city: "Rhydding",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.4746,
    longitude: 149.4083,
    accuracy: 3
  },
  {
    postalCode: 4718,
    city: "Warnoah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.4746,
    longitude: 149.4083,
    accuracy: 3
  },
  {
    postalCode: 4719,
    city: "Theodore",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.946,
    longitude: 150.0742,
    accuracy: 4
  },
  {
    postalCode: 4719,
    city: "Glenmoral",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.9541,
    longitude: 150.1128,
    accuracy: 3
  },
  {
    postalCode: 4719,
    city: "Camboon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.0306,
    longitude: 150.4376,
    accuracy: 4
  },
  {
    postalCode: 4719,
    city: "Lonesome Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.9541,
    longitude: 150.1128,
    accuracy: 3
  },
  {
    postalCode: 4719,
    city: "Isla",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.1307,
    longitude: 150.0515,
    accuracy: 3
  },
  {
    postalCode: 4719,
    city: "Cracow",
    state_name: "Queensland",
    state: "QLD",
    latitude: -25.2989,
    longitude: 150.309,
    accuracy: 4
  },
  {
    postalCode: 4720,
    city: "Emerald",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.523,
    longitude: 148.1578,
    accuracy: 4
  },
  {
    postalCode: 4720,
    city: "Yamala",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.5833,
    longitude: 148.3667,
    accuracy: 4
  },
  {
    postalCode: 4721,
    city: "Winchester",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.1309,
    longitude: 148.1868,
    accuracy: 4
  },
  {
    postalCode: 4721,
    city: "Theresa Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.2273,
    longitude: 147.794,
    accuracy: 3
  },
  {
    postalCode: 4721,
    city: "Clermont",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.8241,
    longitude: 147.6364,
    accuracy: 4
  },
  {
    postalCode: 4721,
    city: "Elgin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.2273,
    longitude: 147.794,
    accuracy: 3
  },
  {
    postalCode: 4721,
    city: "Laglan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.2273,
    longitude: 147.794,
    accuracy: 3
  },
  {
    postalCode: 4721,
    city: "Gemini Mountains",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.2273,
    longitude: 147.794,
    accuracy: 3
  },
  {
    postalCode: 4721,
    city: "Pasha",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.727,
    longitude: 147.5588,
    accuracy: 4
  },
  {
    postalCode: 4721,
    city: "Kilcummin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.2273,
    longitude: 147.794,
    accuracy: 3
  },
  {
    postalCode: 4721,
    city: "Wolfang",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.2273,
    longitude: 147.794,
    accuracy: 3
  },
  {
    postalCode: 4721,
    city: "Frankfield",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.2273,
    longitude: 147.794,
    accuracy: 3
  },
  {
    postalCode: 4721,
    city: "Argyll",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.2977,
    longitude: 147.0586,
    accuracy: 3
  },
  {
    postalCode: 4721,
    city: "Mistake Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.2273,
    longitude: 147.794,
    accuracy: 3
  },
  {
    postalCode: 4722,
    city: "Springsure",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.1148,
    longitude: 148.0885,
    accuracy: 4
  },
  {
    postalCode: 4722,
    city: "Orion",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.1148,
    longitude: 148.0885,
    accuracy: 3
  },
  {
    postalCode: 4722,
    city: "Cona Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.1148,
    longitude: 148.0885,
    accuracy: 3
  },
  {
    postalCode: 4722,
    city: "Buckland",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.1148,
    longitude: 148.0885,
    accuracy: 3
  },
  {
    postalCode: 4722,
    city: "Cairdbeign",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.1148,
    longitude: 148.0885,
    accuracy: 3
  },
  {
    postalCode: 4722,
    city: "Nandowrie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.1148,
    longitude: 148.0885,
    accuracy: 3
  },
  {
    postalCode: 4722,
    city: "Wealwandangie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.1148,
    longitude: 148.0885,
    accuracy: 3
  },
  {
    postalCode: 4723,
    city: "Capella",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.0859,
    longitude: 148.0221,
    accuracy: 4
  },
  {
    postalCode: 4723,
    city: "Retro",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.0167,
    longitude: 147.9,
    accuracy: 4
  },
  {
    postalCode: 4723,
    city: "Belcong",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.086,
    longitude: 147.9895,
    accuracy: 3
  },
  {
    postalCode: 4723,
    city: "Lowestoff",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.086,
    longitude: 147.9895,
    accuracy: 3
  },
  {
    postalCode: 4723,
    city: "Crinum",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.086,
    longitude: 147.9895,
    accuracy: 3
  },
  {
    postalCode: 4723,
    city: "Chirnside",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.1381,
    longitude: 148.0463,
    accuracy: 4
  },
  {
    postalCode: 4723,
    city: "Khosh Bulduk",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.086,
    longitude: 147.9895,
    accuracy: 3
  },
  {
    postalCode: 4723,
    city: "Carbine Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.086,
    longitude: 147.9895,
    accuracy: 3
  },
  {
    postalCode: 4723,
    city: "Hibernia",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.086,
    longitude: 147.9895,
    accuracy: 3
  },
  {
    postalCode: 4723,
    city: "Lilyvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.086,
    longitude: 147.9895,
    accuracy: 3
  },
  {
    postalCode: 4723,
    city: "Mount Macarthur",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.086,
    longitude: 147.9895,
    accuracy: 3
  },
  {
    postalCode: 4724,
    city: "Alpha",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6492,
    longitude: 146.6398,
    accuracy: 4
  },
  {
    postalCode: 4724,
    city: "Pine Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.65,
    longitude: 146.9667,
    accuracy: 4
  },
  {
    postalCode: 4724,
    city: "Sedgeford",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6501,
    longitude: 146.8326,
    accuracy: 3
  },
  {
    postalCode: 4724,
    city: "Hobartville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6501,
    longitude: 146.8326,
    accuracy: 3
  },
  {
    postalCode: 4724,
    city: "Port Wine",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6501,
    longitude: 146.8326,
    accuracy: 3
  },
  {
    postalCode: 4724,
    city: "Beaufort",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6511,
    longitude: 146.8914,
    accuracy: 4
  },
  {
    postalCode: 4724,
    city: "Surbiton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6501,
    longitude: 146.8326,
    accuracy: 3
  },
  {
    postalCode: 4724,
    city: "Drummondslope",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6501,
    longitude: 146.8326,
    accuracy: 3
  },
  {
    postalCode: 4725,
    city: "Barcaldine Downs",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.2086,
    longitude: 147.5842,
    accuracy: 3
  },
  {
    postalCode: 4725,
    city: "Barcaldine",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.5535,
    longitude: 145.2854,
    accuracy: 4
  },
  {
    postalCode: 4725,
    city: "Tara Station",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.2086,
    longitude: 147.5842,
    accuracy: 3
  },
  {
    postalCode: 4725,
    city: "Patrick",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.2086,
    longitude: 147.5842,
    accuracy: 3
  },
  {
    postalCode: 4726,
    city: "Galilee",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.2086,
    longitude: 147.5842,
    accuracy: 3
  },
  {
    postalCode: 4726,
    city: "Pelican Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.2086,
    longitude: 147.5842,
    accuracy: 3
  },
  {
    postalCode: 4726,
    city: "Aramac",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.9683,
    longitude: 145.245,
    accuracy: 4
  },
  {
    postalCode: 4727,
    city: "Ilfracombe",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.5,
    longitude: 144.5,
    accuracy: 4
  },
  {
    postalCode: 4728,
    city: "Jericho",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6,
    longitude: 146.1333,
    accuracy: 4
  },
  {
    postalCode: 4728,
    city: "Mexico",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6,
    longitude: 146.1333,
    accuracy: 3
  },
  {
    postalCode: 4728,
    city: "Dunrobin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6,
    longitude: 146.1333,
    accuracy: 3
  },
  {
    postalCode: 4728,
    city: "Garfield",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6,
    longitude: 146.1333,
    accuracy: 3
  },
  {
    postalCode: 4730,
    city: "Chorregon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.6785,
    longitude: 143.5619,
    accuracy: 4
  },
  {
    postalCode: 4730,
    city: "Morella",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.9667,
    longitude: 143.8667,
    accuracy: 4
  },
  {
    postalCode: 4730,
    city: "Stonehenge",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.3546,
    longitude: 143.2873,
    accuracy: 4
  },
  {
    postalCode: 4730,
    city: "Ernestina",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6006,
    longitude: 143.3629,
    accuracy: 3
  },
  {
    postalCode: 4730,
    city: "Longreach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.9833,
    longitude: 144.4833,
    accuracy: 4
  },
  {
    postalCode: 4730,
    city: "Maneroo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6006,
    longitude: 143.3629,
    accuracy: 3
  },
  {
    postalCode: 4730,
    city: "Camoola",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.9833,
    longitude: 144.4833,
    accuracy: 4
  },
  {
    postalCode: 4730,
    city: "Tocal",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6006,
    longitude: 143.3629,
    accuracy: 3
  },
  {
    postalCode: 4730,
    city: "Vergemont",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.6006,
    longitude: 143.3629,
    accuracy: 3
  },
  {
    postalCode: 4731,
    city: "Isisford",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.2597,
    longitude: 144.4393,
    accuracy: 4
  },
  {
    postalCode: 4732,
    city: "Muttaburra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.6,
    longitude: 144.55,
    accuracy: 4
  },
  {
    postalCode: 4732,
    city: "Tablederry",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.5243,
    longitude: 149.2101,
    accuracy: 3
  },
  {
    postalCode: 4733,
    city: "Corfield",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.7167,
    longitude: 143.3667,
    accuracy: 4
  },
  {
    postalCode: 4735,
    city: "Middleton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.3514,
    longitude: 141.5517,
    accuracy: 4
  },
  {
    postalCode: 4735,
    city: "Diamantina Lakes",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.0459,
    longitude: 141.9408,
    accuracy: 3
  },
  {
    postalCode: 4735,
    city: "Winton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.3818,
    longitude: 143.0424,
    accuracy: 4
  },
  {
    postalCode: 4735,
    city: "Opalton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -23.25,
    longitude: 142.7667,
    accuracy: 4
  },
  {
    postalCode: 4736,
    city: "Jundah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.8331,
    longitude: 143.0616,
    accuracy: 4
  },
  {
    postalCode: 4737,
    city: "Blue Mountain",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.5833,
    longitude: 149.0333,
    accuracy: 4
  },
  {
    postalCode: 4737,
    city: "Campwin Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.3742,
    longitude: 149.3145,
    accuracy: 4
  },
  {
    postalCode: 4737,
    city: "Sarina",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.4191,
    longitude: 149.2168,
    accuracy: 4
  },
  {
    postalCode: 4737,
    city: "Sunnyside",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1667,
    longitude: 148.8833,
    accuracy: 4
  },
  {
    postalCode: 4737,
    city: "Freshwater Point",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.4172,
    longitude: 149.3265,
    accuracy: 3
  },
  {
    postalCode: 4737,
    city: "Sarina Range",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.5533,
    longitude: 149.1175,
    accuracy: 4
  },
  {
    postalCode: 4737,
    city: "Armstrong Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.4549,
    longitude: 149.2896,
    accuracy: 3
  },
  {
    postalCode: 4737,
    city: "Sarina Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.3884,
    longitude: 149.3086,
    accuracy: 4
  },
  {
    postalCode: 4738,
    city: "Ilbilbie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.7,
    longitude: 149.35,
    accuracy: 4
  },
  {
    postalCode: 4738,
    city: "Koumala",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.6167,
    longitude: 149.25,
    accuracy: 4
  },
  {
    postalCode: 4739,
    city: "Carmila",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.9167,
    longitude: 149.4167,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "The Leap",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.0833,
    longitude: 149.0167,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Mackay DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1774,
    longitude: 149.1268,
    accuracy: 3
  },
  {
    postalCode: 4740,
    city: "Mount Pleasant",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1181,
    longitude: 149.1596,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Bakers Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.2199,
    longitude: 149.1468,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Rural View",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.0645,
    longitude: 149.1646,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Blacks Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.0547,
    longitude: 149.1897,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Alligator Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.3333,
    longitude: 149.2,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "West Mackay",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1547,
    longitude: 149.1618,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Cremorne",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1333,
    longitude: 149.2,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Beaconsfield",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.0912,
    longitude: 149.1654,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Dumbleton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1333,
    longitude: 149.1,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Munbura",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.3333,
    longitude: 149.15,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Mackay West",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.15,
    longitude: 148.85,
    accuracy: 3
  },
  {
    postalCode: 4740,
    city: "Erakala",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1282,
    longitude: 149.1171,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Mackay Caneland",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1774,
    longitude: 149.1268,
    accuracy: 3
  },
  {
    postalCode: 4740,
    city: "Dolphin Heads",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.0406,
    longitude: 149.1849,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Belmunda",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.2395,
    longitude: 149.0527,
    accuracy: 3
  },
  {
    postalCode: 4740,
    city: "Eimeo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.0377,
    longitude: 149.1763,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Balnagowan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1175,
    longitude: 149.0085,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Glenella",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1177,
    longitude: 149.1445,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "East Mackay",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1498,
    longitude: 149.1964,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Homebush",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.2833,
    longitude: 149.05,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Racecourse",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1665,
    longitude: 149.1345,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "North Mackay",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1201,
    longitude: 149.1794,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Paget",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1868,
    longitude: 149.1722,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Grasstree Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.364,
    longitude: 149.3061,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Slade Point",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.075,
    longitude: 149.225,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Mackay South",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.65,
    longitude: 149.2333,
    accuracy: 3
  },
  {
    postalCode: 4740,
    city: "Planland",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.2395,
    longitude: 149.0527,
    accuracy: 3
  },
  {
    postalCode: 4740,
    city: "Andergrove",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.0833,
    longitude: 149.1833,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Dunnrock",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.2618,
    longitude: 149.1686,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Habana",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.0333,
    longitude: 149.0833,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Mackay North",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1774,
    longitude: 149.1268,
    accuracy: 3
  },
  {
    postalCode: 4740,
    city: "Balberra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.3,
    longitude: 149.1167,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Alexandra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1667,
    longitude: 149.1,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Mcewens Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.2395,
    longitude: 149.0527,
    accuracy: 3
  },
  {
    postalCode: 4740,
    city: "Coningsby",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1,
    longitude: 149.0667,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Cape Hillsborough",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.2395,
    longitude: 149.0527,
    accuracy: 3
  },
  {
    postalCode: 4740,
    city: "Rosella",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.2365,
    longitude: 149.1459,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Ooralea",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1739,
    longitude: 149.148,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Nindaroo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.0833,
    longitude: 149.15,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Dundula",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.2395,
    longitude: 149.0527,
    accuracy: 3
  },
  {
    postalCode: 4740,
    city: "Mount Jukes",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.0167,
    longitude: 148.95,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Haliday Bay",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.2395,
    longitude: 149.0527,
    accuracy: 3
  },
  {
    postalCode: 4740,
    city: "Te Kowai",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1667,
    longitude: 149.1167,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Richmond",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.2395,
    longitude: 149.0527,
    accuracy: 3
  },
  {
    postalCode: 4740,
    city: "South Mackay",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1629,
    longitude: 149.1775,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Foulden",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1346,
    longitude: 149.1369,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Sandiford",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.25,
    longitude: 149.1,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Hay Point",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.2833,
    longitude: 149.3,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Mackay Harbour",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1088,
    longitude: 149.2113,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Mackay",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1534,
    longitude: 149.1655,
    accuracy: 4
  },
  {
    postalCode: 4740,
    city: "Chelona",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.2595,
    longitude: 149.1424,
    accuracy: 4
  },
  {
    postalCode: 4741,
    city: "Kuttabul",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.0333,
    longitude: 148.9,
    accuracy: 4
  },
  {
    postalCode: 4741,
    city: "Ball Bay",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.2351,
    longitude: 148.9113,
    accuracy: 3
  },
  {
    postalCode: 4741,
    city: "Oakenden",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.3,
    longitude: 149.0167,
    accuracy: 4
  },
  {
    postalCode: 4741,
    city: "Pinnacle",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.15,
    longitude: 148.7167,
    accuracy: 4
  },
  {
    postalCode: 4741,
    city: "Eton North",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.2333,
    longitude: 148.9667,
    accuracy: 4
  },
  {
    postalCode: 4741,
    city: "South Molle",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.3252,
    longitude: 149.0031,
    accuracy: 3
  },
  {
    postalCode: 4741,
    city: "Coppabella",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.9471,
    longitude: 148.3005,
    accuracy: 4
  },
  {
    postalCode: 4741,
    city: "Eungella Hinterland",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.3252,
    longitude: 149.0031,
    accuracy: 3
  },
  {
    postalCode: 4741,
    city: "Yalboroo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.8333,
    longitude: 148.65,
    accuracy: 4
  },
  {
    postalCode: 4741,
    city: "Epsom",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.3252,
    longitude: 149.0031,
    accuracy: 3
  },
  {
    postalCode: 4741,
    city: "Farleigh",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1057,
    longitude: 149.1024,
    accuracy: 4
  },
  {
    postalCode: 4741,
    city: "Pleystowe",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.15,
    longitude: 149.0333,
    accuracy: 4
  },
  {
    postalCode: 4741,
    city: "Mackay Mc",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.3252,
    longitude: 149.0031,
    accuracy: 3
  },
  {
    postalCode: 4741,
    city: "Daydream Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.3252,
    longitude: 149.0031,
    accuracy: 3
  },
  {
    postalCode: 4741,
    city: "Lindeman Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.4483,
    longitude: 149.039,
    accuracy: 4
  },
  {
    postalCode: 4741,
    city: "Owens Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.0833,
    longitude: 148.7167,
    accuracy: 4
  },
  {
    postalCode: 4741,
    city: "Gargett",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1667,
    longitude: 148.75,
    accuracy: 4
  },
  {
    postalCode: 4741,
    city: "Brightly",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.2351,
    longitude: 148.9113,
    accuracy: 3
  },
  {
    postalCode: 4741,
    city: "Clairview",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.1175,
    longitude: 149.5347,
    accuracy: 4
  },
  {
    postalCode: 4741,
    city: "Brampton Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.3252,
    longitude: 149.0031,
    accuracy: 3
  },
  {
    postalCode: 4741,
    city: "Long Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.3252,
    longitude: 149.0031,
    accuracy: 3
  },
  {
    postalCode: 4741,
    city: "Mount Pelion",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.9333,
    longitude: 148.8167,
    accuracy: 4
  },
  {
    postalCode: 4741,
    city: "Kinchant Dam",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.3252,
    longitude: 149.0031,
    accuracy: 3
  },
  {
    postalCode: 4741,
    city: "Seaforth",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.9004,
    longitude: 148.9679,
    accuracy: 4
  },
  {
    postalCode: 4741,
    city: "North Eton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.2333,
    longitude: 148.9667,
    accuracy: 4
  },
  {
    postalCode: 4741,
    city: "Hazledean",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.3833,
    longitude: 148.95,
    accuracy: 4
  },
  {
    postalCode: 4741,
    city: "Eton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.2647,
    longitude: 148.9724,
    accuracy: 4
  },
  {
    postalCode: 4741,
    city: "Orkabie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.8167,
    longitude: 149.3667,
    accuracy: 4
  },
  {
    postalCode: 4741,
    city: "Mount Ossa",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.9667,
    longitude: 148.8333,
    accuracy: 4
  },
  {
    postalCode: 4741,
    city: "Hampden",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.0667,
    longitude: 148.9333,
    accuracy: 4
  },
  {
    postalCode: 4741,
    city: "Mount Charlton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.0167,
    longitude: 148.7333,
    accuracy: 4
  },
  {
    postalCode: 4742,
    city: "Strathfield",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.746,
    longitude: 148.4967,
    accuracy: 4
  },
  {
    postalCode: 4742,
    city: "Oxford",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.7372,
    longitude: 148.4658,
    accuracy: 3
  },
  {
    postalCode: 4742,
    city: "Elphinstone",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.5,
    longitude: 148.2333,
    accuracy: 4
  },
  {
    postalCode: 4742,
    city: "Eaglefield",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.7372,
    longitude: 148.4658,
    accuracy: 3
  },
  {
    postalCode: 4742,
    city: "Turrawulla",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.7372,
    longitude: 148.4658,
    accuracy: 3
  },
  {
    postalCode: 4742,
    city: "Mount Britton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.6431,
    longitude: 148.4711,
    accuracy: 3
  },
  {
    postalCode: 4742,
    city: "Mt Britton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.7372,
    longitude: 148.4658,
    accuracy: 3
  },
  {
    postalCode: 4742,
    city: "Valkyrie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.0745,
    longitude: 148.6408,
    accuracy: 3
  },
  {
    postalCode: 4742,
    city: "Kemmis",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.7372,
    longitude: 148.4658,
    accuracy: 3
  },
  {
    postalCode: 4742,
    city: "Burton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.7372,
    longitude: 148.4658,
    accuracy: 3
  },
  {
    postalCode: 4742,
    city: "Hail Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.7372,
    longitude: 148.4658,
    accuracy: 3
  },
  {
    postalCode: 4742,
    city: "Nebo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.6833,
    longitude: 148.6833,
    accuracy: 4
  },
  {
    postalCode: 4743,
    city: "Glenden",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.3544,
    longitude: 148.1149,
    accuracy: 4
  },
  {
    postalCode: 4743,
    city: "Suttor",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.3476,
    longitude: 148.1158,
    accuracy: 3
  },
  {
    postalCode: 4744,
    city: "Moranbah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.0016,
    longitude: 148.0466,
    accuracy: 4
  },
  {
    postalCode: 4745,
    city: "Dysart",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.5882,
    longitude: 148.3492,
    accuracy: 4
  },
  {
    postalCode: 4746,
    city: "Middlemount",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.8123,
    longitude: 148.6993,
    accuracy: 4
  },
  {
    postalCode: 4746,
    city: "May Downs",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.7863,
    longitude: 148.5777,
    accuracy: 3
  },
  {
    postalCode: 4750,
    city: "Bucasia",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.0349,
    longitude: 149.1573,
    accuracy: 4
  },
  {
    postalCode: 4750,
    city: "Shoal Point",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.0048,
    longitude: 149.1527,
    accuracy: 4
  },
  {
    postalCode: 4751,
    city: "Victoria Plains",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.2174,
    longitude: 149.0122,
    accuracy: 3
  },
  {
    postalCode: 4751,
    city: "Walkerston",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.161,
    longitude: 149.0581,
    accuracy: 4
  },
  {
    postalCode: 4751,
    city: "Palmyra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1724,
    longitude: 149.0462,
    accuracy: 3
  },
  {
    postalCode: 4751,
    city: "Greenmount",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1839,
    longitude: 149.0342,
    accuracy: 4
  },
  {
    postalCode: 4753,
    city: "Devereux Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1167,
    longitude: 148.9167,
    accuracy: 4
  },
  {
    postalCode: 4753,
    city: "Marian",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1439,
    longitude: 148.9421,
    accuracy: 4
  },
  {
    postalCode: 4754,
    city: "Mount Martin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1167,
    longitude: 148.8167,
    accuracy: 4
  },
  {
    postalCode: 4754,
    city: "Mia Mia",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1881,
    longitude: 148.8079,
    accuracy: 3
  },
  {
    postalCode: 4754,
    city: "Benholme",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1667,
    longitude: 148.8167,
    accuracy: 4
  },
  {
    postalCode: 4754,
    city: "Pinevale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1881,
    longitude: 148.8079,
    accuracy: 3
  },
  {
    postalCode: 4754,
    city: "Mirani",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1573,
    longitude: 148.8622,
    accuracy: 4
  },
  {
    postalCode: 4754,
    city: "Dows Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1,
    longitude: 148.7833,
    accuracy: 4
  },
  {
    postalCode: 4754,
    city: "Septimus",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.2333,
    longitude: 148.7667,
    accuracy: 4
  },
  {
    postalCode: 4756,
    city: "Netherdale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.15,
    longitude: 148.5333,
    accuracy: 4
  },
  {
    postalCode: 4756,
    city: "Finch Hatton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1404,
    longitude: 148.6288,
    accuracy: 4
  },
  {
    postalCode: 4757,
    city: "Crediton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.203,
    longitude: 148.5171,
    accuracy: 4
  },
  {
    postalCode: 4757,
    city: "Broken River",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.0003,
    longitude: 148.4112,
    accuracy: 3
  },
  {
    postalCode: 4757,
    city: "Dalrymple Heights",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1,
    longitude: 148.5167,
    accuracy: 4
  },
  {
    postalCode: 4757,
    city: "Eungella Dam",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.0003,
    longitude: 148.4112,
    accuracy: 3
  },
  {
    postalCode: 4757,
    city: "Eungella",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1333,
    longitude: 148.4833,
    accuracy: 4
  },
  {
    postalCode: 4798,
    city: "Pindi Pindi",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.8667,
    longitude: 148.7333,
    accuracy: 4
  },
  {
    postalCode: 4798,
    city: "Mentmore",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.8742,
    longitude: 148.728,
    accuracy: 3
  },
  {
    postalCode: 4798,
    city: "Calen",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.8975,
    longitude: 148.7711,
    accuracy: 4
  },
  {
    postalCode: 4798,
    city: "St Helens Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.8821,
    longitude: 148.7522,
    accuracy: 3
  },
  {
    postalCode: 4799,
    city: "Bloomsbury",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.7167,
    longitude: 148.6,
    accuracy: 4
  },
  {
    postalCode: 4799,
    city: "Midge Point",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.7167,
    longitude: 148.6,
    accuracy: 3
  },
  {
    postalCode: 4800,
    city: "Palm Grove",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.3927,
    longitude: 148.7007,
    accuracy: 4
  },
  {
    postalCode: 4800,
    city: "Dittmer",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.45,
    longitude: 148.4,
    accuracy: 4
  },
  {
    postalCode: 4800,
    city: "Mount Julian",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.3833,
    longitude: 148.6167,
    accuracy: 4
  },
  {
    postalCode: 4800,
    city: "Breadalbane",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.4057,
    longitude: 148.4881,
    accuracy: 3
  },
  {
    postalCode: 4800,
    city: "Cannon Valley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.2833,
    longitude: 148.6833,
    accuracy: 4
  },
  {
    postalCode: 4800,
    city: "Lethebrook",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.4057,
    longitude: 148.4881,
    accuracy: 3
  },
  {
    postalCode: 4800,
    city: "Strathdickie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.3333,
    longitude: 148.6167,
    accuracy: 4
  },
  {
    postalCode: 4800,
    city: "Hamilton Plains",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.3823,
    longitude: 148.5875,
    accuracy: 3
  },
  {
    postalCode: 4800,
    city: "Mount Marlow",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.3667,
    longitude: 148.6167,
    accuracy: 4
  },
  {
    postalCode: 4800,
    city: "Gunyarra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.5167,
    longitude: 148.5667,
    accuracy: 4
  },
  {
    postalCode: 4800,
    city: "Thoopara",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.55,
    longitude: 148.5667,
    accuracy: 4
  },
  {
    postalCode: 4800,
    city: "Preston",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.4057,
    longitude: 148.4881,
    accuracy: 3
  },
  {
    postalCode: 4800,
    city: "Riordanvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.828,
    longitude: 147.5322,
    accuracy: 3
  },
  {
    postalCode: 4800,
    city: "Foxdale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.3667,
    longitude: 148.55,
    accuracy: 4
  },
  {
    postalCode: 4800,
    city: "Crystal Brook",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.3484,
    longitude: 148.485,
    accuracy: 4
  },
  {
    postalCode: 4800,
    city: "Laguna Quays",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.6543,
    longitude: 148.6667,
    accuracy: 3
  },
  {
    postalCode: 4800,
    city: "Kelsey Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.4333,
    longitude: 148.45,
    accuracy: 4
  },
  {
    postalCode: 4800,
    city: "Dingo Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.0904,
    longitude: 148.4959,
    accuracy: 4
  },
  {
    postalCode: 4800,
    city: "Cape Gloucester",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.1101,
    longitude: 148.5024,
    accuracy: 4
  },
  {
    postalCode: 4800,
    city: "Glen Isla",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.4089,
    longitude: 148.62,
    accuracy: 3
  },
  {
    postalCode: 4800,
    city: "Proserpine",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.4011,
    longitude: 148.5802,
    accuracy: 4
  },
  {
    postalCode: 4800,
    city: "Conway",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.4167,
    longitude: 148.7,
    accuracy: 4
  },
  {
    postalCode: 4800,
    city: "Sugarloaf",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.4057,
    longitude: 148.4881,
    accuracy: 3
  },
  {
    postalCode: 4800,
    city: "Gregory River",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.4057,
    longitude: 148.4881,
    accuracy: 3
  },
  {
    postalCode: 4800,
    city: "Wilson Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.4057,
    longitude: 148.4881,
    accuracy: 3
  },
  {
    postalCode: 4800,
    city: "Andromache",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.4057,
    longitude: 148.4881,
    accuracy: 3
  },
  {
    postalCode: 4800,
    city: "Silver Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.4057,
    longitude: 148.4881,
    accuracy: 3
  },
  {
    postalCode: 4800,
    city: "Goorganga Plains",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.4057,
    longitude: 148.4881,
    accuracy: 3
  },
  {
    postalCode: 4800,
    city: "Lake Proserpine",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.4057,
    longitude: 148.4881,
    accuracy: 3
  },
  {
    postalCode: 4800,
    city: "Conway Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.4057,
    longitude: 148.4881,
    accuracy: 3
  },
  {
    postalCode: 4800,
    city: "Mount Pluto",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.4057,
    longitude: 148.4881,
    accuracy: 3
  },
  {
    postalCode: 4800,
    city: "Goorganga Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.4057,
    longitude: 148.4881,
    accuracy: 3
  },
  {
    postalCode: 4800,
    city: "Brandy Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.4057,
    longitude: 148.4881,
    accuracy: 3
  },
  {
    postalCode: 4800,
    city: "Cape Conway",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.2981,
    longitude: 148.747,
    accuracy: 3
  },
  {
    postalCode: 4800,
    city: "Myrtlevale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.4057,
    longitude: 148.4881,
    accuracy: 3
  },
  {
    postalCode: 4800,
    city: "Hideaway Bay",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.074,
    longitude: 148.4752,
    accuracy: 4
  },
  {
    postalCode: 4800,
    city: "Pauls Pocket",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.4057,
    longitude: 148.4881,
    accuracy: 3
  },
  {
    postalCode: 4801,
    city: "Hayman Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.0511,
    longitude: 148.8849,
    accuracy: 4
  },
  {
    postalCode: 4802,
    city: "Cannonvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.2768,
    longitude: 148.6976,
    accuracy: 4
  },
  {
    postalCode: 4802,
    city: "Flametree",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.27,
    longitude: 148.7497,
    accuracy: 4
  },
  {
    postalCode: 4802,
    city: "Airlie Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.2675,
    longitude: 148.7147,
    accuracy: 4
  },
  {
    postalCode: 4802,
    city: "Mount Rooper",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.2873,
    longitude: 148.7783,
    accuracy: 3
  },
  {
    postalCode: 4802,
    city: "Woodwark",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.2358,
    longitude: 148.6533,
    accuracy: 4
  },
  {
    postalCode: 4802,
    city: "Whitsundays",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.2318,
    longitude: 148.952,
    accuracy: 4
  },
  {
    postalCode: 4802,
    city: "Jubilee Pocket",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.2881,
    longitude: 148.7294,
    accuracy: 4
  },
  {
    postalCode: 4802,
    city: "Shute Harbour",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.2913,
    longitude: 148.7858,
    accuracy: 4
  },
  {
    postalCode: 4802,
    city: "Mandalay",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.27,
    longitude: 148.7389,
    accuracy: 4
  },
  {
    postalCode: 4803,
    city: "Hamilton Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.346,
    longitude: 148.9519,
    accuracy: 4
  },
  {
    postalCode: 4804,
    city: "Mount Coolon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.3833,
    longitude: 147.3333,
    accuracy: 4
  },
  {
    postalCode: 4804,
    city: "Collinsville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.5522,
    longitude: 147.844,
    accuracy: 4
  },
  {
    postalCode: 4804,
    city: "Springlands",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.9844,
    longitude: 147.5398,
    accuracy: 3
  },
  {
    postalCode: 4804,
    city: "Scottville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.5667,
    longitude: 147.8167,
    accuracy: 4
  },
  {
    postalCode: 4804,
    city: "Newlands",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.9844,
    longitude: 147.5398,
    accuracy: 3
  },
  {
    postalCode: 4804,
    city: "Mount Wyatt",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.9844,
    longitude: 147.5398,
    accuracy: 3
  },
  {
    postalCode: 4805,
    city: "Gumlu",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.8833,
    longitude: 147.6833,
    accuracy: 4
  },
  {
    postalCode: 4805,
    city: "Bogie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.1665,
    longitude: 147.8081,
    accuracy: 3
  },
  {
    postalCode: 4805,
    city: "Bowen",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.0137,
    longitude: 148.2475,
    accuracy: 4
  },
  {
    postalCode: 4805,
    city: "Merinda",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.0169,
    longitude: 148.1634,
    accuracy: 4
  },
  {
    postalCode: 4805,
    city: "Guthalungra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.9167,
    longitude: 147.8333,
    accuracy: 4
  },
  {
    postalCode: 4805,
    city: "Queens Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.9667,
    longitude: 148.25,
    accuracy: 4
  },
  {
    postalCode: 4806,
    city: "Carstairs",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.65,
    longitude: 147.4,
    accuracy: 4
  },
  {
    postalCode: 4806,
    city: "Home Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.6592,
    longitude: 147.4123,
    accuracy: 4
  },
  {
    postalCode: 4806,
    city: "Wangaratta",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.8433,
    longitude: 147.4016,
    accuracy: 3
  },
  {
    postalCode: 4806,
    city: "Inkerman",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.8433,
    longitude: 147.4016,
    accuracy: 3
  },
  {
    postalCode: 4806,
    city: "Rangemore",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.8433,
    longitude: 147.4016,
    accuracy: 3
  },
  {
    postalCode: 4806,
    city: "Wunjunga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.8433,
    longitude: 147.4016,
    accuracy: 3
  },
  {
    postalCode: 4806,
    city: "Kirknie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.8433,
    longitude: 147.4016,
    accuracy: 3
  },
  {
    postalCode: 4806,
    city: "Osborne",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.8433,
    longitude: 147.4016,
    accuracy: 3
  },
  {
    postalCode: 4806,
    city: "Fredericksfield",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.8433,
    longitude: 147.4016,
    accuracy: 3
  },
  {
    postalCode: 4807,
    city: "Jarvisfield",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.6167,
    longitude: 147.4667,
    accuracy: 4
  },
  {
    postalCode: 4807,
    city: "Mcdesme",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.8733,
    longitude: 147.2013,
    accuracy: 3
  },
  {
    postalCode: 4807,
    city: "Mount Kelly",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.6685,
    longitude: 147.3153,
    accuracy: 3
  },
  {
    postalCode: 4807,
    city: "Ayr",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.5739,
    longitude: 147.4067,
    accuracy: 4
  },
  {
    postalCode: 4807,
    city: "Dalbeg",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.274,
    longitude: 147.3036,
    accuracy: 4
  },
  {
    postalCode: 4807,
    city: "Swans Lagoon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.8733,
    longitude: 147.2013,
    accuracy: 3
  },
  {
    postalCode: 4807,
    city: "Alva",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.45,
    longitude: 147.4833,
    accuracy: 4
  },
  {
    postalCode: 4807,
    city: "Airville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.6309,
    longitude: 147.3455,
    accuracy: 4
  },
  {
    postalCode: 4807,
    city: "Clare",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.7833,
    longitude: 147.2333,
    accuracy: 4
  },
  {
    postalCode: 4807,
    city: "Mona Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.8733,
    longitude: 147.2013,
    accuracy: 3
  },
  {
    postalCode: 4807,
    city: "Rita Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.6167,
    longitude: 147.5333,
    accuracy: 4
  },
  {
    postalCode: 4807,
    city: "Mulgrave",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.8733,
    longitude: 147.2013,
    accuracy: 3
  },
  {
    postalCode: 4807,
    city: "Millaroo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.0601,
    longitude: 147.28,
    accuracy: 4
  },
  {
    postalCode: 4807,
    city: "Airdmillan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.8733,
    longitude: 147.2013,
    accuracy: 3
  },
  {
    postalCode: 4807,
    city: "Eight Mile Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.8733,
    longitude: 147.2013,
    accuracy: 3
  },
  {
    postalCode: 4807,
    city: "Rite Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.8733,
    longitude: 147.2013,
    accuracy: 3
  },
  {
    postalCode: 4807,
    city: "Claredale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.7507,
    longitude: 147.3816,
    accuracy: 3
  },
  {
    postalCode: 4807,
    city: "Parkside",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.8733,
    longitude: 147.2013,
    accuracy: 3
  },
  {
    postalCode: 4808,
    city: "Brandon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.5539,
    longitude: 147.353,
    accuracy: 4
  },
  {
    postalCode: 4808,
    city: "Colevale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.5557,
    longitude: 147.3568,
    accuracy: 3
  },
  {
    postalCode: 4809,
    city: "Cromarty",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.4667,
    longitude: 147.05,
    accuracy: 4
  },
  {
    postalCode: 4809,
    city: "Horseshoe Lagoon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.5649,
    longitude: 147.1252,
    accuracy: 3
  },
  {
    postalCode: 4809,
    city: "Upper Haughton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.5649,
    longitude: 147.1252,
    accuracy: 3
  },
  {
    postalCode: 4809,
    city: "Giru",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.517,
    longitude: 147.1026,
    accuracy: 4
  },
  {
    postalCode: 4809,
    city: "Mount Surround",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.5649,
    longitude: 147.1252,
    accuracy: 3
  },
  {
    postalCode: 4809,
    city: "Jerona",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.5649,
    longitude: 147.1252,
    accuracy: 3
  },
  {
    postalCode: 4809,
    city: "Shirbourne",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.5649,
    longitude: 147.1252,
    accuracy: 3
  },
  {
    postalCode: 4809,
    city: "Barratta",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.5311,
    longitude: 147.2132,
    accuracy: 4
  },
  {
    postalCode: 4810,
    city: "Pallarenda",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.201,
    longitude: 146.7734,
    accuracy: 4
  },
  {
    postalCode: 4810,
    city: "Townsville Mc",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2599,
    longitude: 146.8266,
    accuracy: 3
  },
  {
    postalCode: 4810,
    city: "North Ward",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2474,
    longitude: 146.8055,
    accuracy: 4
  },
  {
    postalCode: 4810,
    city: "Town Common",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2183,
    longitude: 146.7552,
    accuracy: 4
  },
  {
    postalCode: 4810,
    city: "Rowes Bay",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2401,
    longitude: 146.7892,
    accuracy: 4
  },
  {
    postalCode: 4810,
    city: "South Townsville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2603,
    longitude: 146.8277,
    accuracy: 4
  },
  {
    postalCode: 4810,
    city: "Townsville DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2599,
    longitude: 146.8266,
    accuracy: 3
  },
  {
    postalCode: 4810,
    city: "Railway Estate",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2757,
    longitude: 146.8196,
    accuracy: 4
  },
  {
    postalCode: 4810,
    city: "Castle Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2283,
    longitude: 146.7706,
    accuracy: 3
  },
  {
    postalCode: 4810,
    city: "Shelly Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2283,
    longitude: 146.7706,
    accuracy: 3
  },
  {
    postalCode: 4810,
    city: "Townsville City",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2283,
    longitude: 146.7706,
    accuracy: 3
  },
  {
    postalCode: 4810,
    city: "Townsville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2664,
    longitude: 146.8057,
    accuracy: 4
  },
  {
    postalCode: 4810,
    city: "Belgian Gardens",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2451,
    longitude: 146.7945,
    accuracy: 4
  },
  {
    postalCode: 4810,
    city: "West End",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2653,
    longitude: 146.794,
    accuracy: 4
  },
  {
    postalCode: 4810,
    city: "Cape Cleveland",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.3328,
    longitude: 147.0248,
    accuracy: 4
  },
  {
    postalCode: 4811,
    city: "Cluden",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.3173,
    longitude: 146.8249,
    accuracy: 4
  },
  {
    postalCode: 4811,
    city: "James Cook University",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.3511,
    longitude: 146.8368,
    accuracy: 3
  },
  {
    postalCode: 4811,
    city: "Idalia",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.3068,
    longitude: 146.8139,
    accuracy: 4
  },
  {
    postalCode: 4811,
    city: "Stuart",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.347,
    longitude: 146.8438,
    accuracy: 4
  },
  {
    postalCode: 4811,
    city: "Oonoonba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.3,
    longitude: 146.8167,
    accuracy: 4
  },
  {
    postalCode: 4811,
    city: "Oak Valley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.4083,
    longitude: 146.8213,
    accuracy: 4
  },
  {
    postalCode: 4811,
    city: "Roseneath",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.3555,
    longitude: 146.8351,
    accuracy: 4
  },
  {
    postalCode: 4811,
    city: "Mount Stuart",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.3722,
    longitude: 146.743,
    accuracy: 4
  },
  {
    postalCode: 4811,
    city: "Wulguru",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.3285,
    longitude: 146.8184,
    accuracy: 4
  },
  {
    postalCode: 4812,
    city: "Pimlico",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2817,
    longitude: 146.788,
    accuracy: 4
  },
  {
    postalCode: 4812,
    city: "Hyde Park Castletown",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2855,
    longitude: 146.7904,
    accuracy: 3
  },
  {
    postalCode: 4812,
    city: "Mundingburra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2965,
    longitude: 146.7851,
    accuracy: 4
  },
  {
    postalCode: 4812,
    city: "Currajong",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2757,
    longitude: 146.7792,
    accuracy: 4
  },
  {
    postalCode: 4812,
    city: "Hermit Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2831,
    longitude: 146.8036,
    accuracy: 4
  },
  {
    postalCode: 4812,
    city: "Mysterton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2872,
    longitude: 146.7936,
    accuracy: 4
  },
  {
    postalCode: 4812,
    city: "Hyde Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2769,
    longitude: 146.7965,
    accuracy: 4
  },
  {
    postalCode: 4812,
    city: "Gulliver",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2851,
    longitude: 146.7745,
    accuracy: 4
  },
  {
    postalCode: 4812,
    city: "Rosslea",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.298,
    longitude: 146.8027,
    accuracy: 4
  },
  {
    postalCode: 4813,
    city: "Townsville Milpo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.3366,
    longitude: 146.7836,
    accuracy: 1
  },
  {
    postalCode: 4814,
    city: "Garbutt",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2566,
    longitude: 146.7658,
    accuracy: 4
  },
  {
    postalCode: 4814,
    city: "Garbutt East",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2983,
    longitude: 146.7711,
    accuracy: 3
  },
  {
    postalCode: 4814,
    city: "Murray",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.3323,
    longitude: 146.7917,
    accuracy: 4
  },
  {
    postalCode: 4814,
    city: "Mount Louisa",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.274,
    longitude: 146.7509,
    accuracy: 4
  },
  {
    postalCode: 4814,
    city: "Douglas",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.3239,
    longitude: 146.7523,
    accuracy: 4
  },
  {
    postalCode: 4814,
    city: "Heatley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2904,
    longitude: 146.7536,
    accuracy: 4
  },
  {
    postalCode: 4814,
    city: "Aitkenvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2833,
    longitude: 146.8,
    accuracy: 4
  },
  {
    postalCode: 4814,
    city: "Vincent",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2834,
    longitude: 146.7646,
    accuracy: 4
  },
  {
    postalCode: 4814,
    city: "Annandale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.3111,
    longitude: 146.7876,
    accuracy: 4
  },
  {
    postalCode: 4814,
    city: "Cranbrook",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.3055,
    longitude: 146.7529,
    accuracy: 4
  },
  {
    postalCode: 4814,
    city: "Thuringowa DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2983,
    longitude: 146.7711,
    accuracy: 3
  },
  {
    postalCode: 4815,
    city: "Condon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.3297,
    longitude: 146.7166,
    accuracy: 4
  },
  {
    postalCode: 4815,
    city: "Gumlow",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.3528,
    longitude: 146.6849,
    accuracy: 4
  },
  {
    postalCode: 4815,
    city: "Rasmussen",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.3524,
    longitude: 146.7228,
    accuracy: 4
  },
  {
    postalCode: 4815,
    city: "Pinnacles",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.4415,
    longitude: 146.6751,
    accuracy: 4
  },
  {
    postalCode: 4815,
    city: "Kelso",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.3893,
    longitude: 146.7191,
    accuracy: 4
  },
  {
    postalCode: 4815,
    city: "Granite Vale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.5988,
    longitude: 146.5943,
    accuracy: 4
  },
  {
    postalCode: 4816,
    city: "Nome",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.3833,
    longitude: 146.9167,
    accuracy: 4
  },
  {
    postalCode: 4816,
    city: "Hidden Valley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.5619,
    longitude: 144.8924,
    accuracy: 3
  },
  {
    postalCode: 4816,
    city: "Alligator Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.3918,
    longitude: 146.9378,
    accuracy: 4
  },
  {
    postalCode: 4816,
    city: "Mutarnee",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.95,
    longitude: 146.3,
    accuracy: 4
  },
  {
    postalCode: 4816,
    city: "Julago",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.3695,
    longitude: 146.8872,
    accuracy: 4
  },
  {
    postalCode: 4816,
    city: "Mount Elliot",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.5652,
    longitude: 146.3947,
    accuracy: 3
  },
  {
    postalCode: 4816,
    city: "Torrens Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.7667,
    longitude: 145.0167,
    accuracy: 4
  },
  {
    postalCode: 4816,
    city: "The Cape",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.4592,
    longitude: 145.1686,
    accuracy: 4
  },
  {
    postalCode: 4816,
    city: "Homestead",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.3667,
    longitude: 145.6667,
    accuracy: 4
  },
  {
    postalCode: 4816,
    city: "Greenvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.5619,
    longitude: 144.8924,
    accuracy: 3
  },
  {
    postalCode: 4816,
    city: "Crystal Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.0029,
    longitude: 146.2689,
    accuracy: 4
  },
  {
    postalCode: 4816,
    city: "Rollingstone",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.05,
    longitude: 146.3833,
    accuracy: 4
  },
  {
    postalCode: 4816,
    city: "Crimea",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.7307,
    longitude: 146.8048,
    accuracy: 4
  },
  {
    postalCode: 4816,
    city: "Buchanan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.5652,
    longitude: 146.3947,
    accuracy: 3
  },
  {
    postalCode: 4816,
    city: "Ross River",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.3167,
    longitude: 146.7333,
    accuracy: 4
  },
  {
    postalCode: 4816,
    city: "Savannah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.5652,
    longitude: 146.3947,
    accuracy: 3
  },
  {
    postalCode: 4816,
    city: "Barringha",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.55,
    longitude: 146.8333,
    accuracy: 4
  },
  {
    postalCode: 4816,
    city: "Malpas-Trenton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.5652,
    longitude: 146.3947,
    accuracy: 3
  },
  {
    postalCode: 4816,
    city: "Balgal Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.0163,
    longitude: 146.4083,
    accuracy: 4
  },
  {
    postalCode: 4816,
    city: "Carruchan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.2167,
    longitude: 145.9167,
    accuracy: 4
  },
  {
    postalCode: 4816,
    city: "Toonpan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.5,
    longitude: 146.8333,
    accuracy: 4
  },
  {
    postalCode: 4816,
    city: "Kennedy",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.2048,
    longitude: 145.9546,
    accuracy: 4
  },
  {
    postalCode: 4816,
    city: "Brookhill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.3833,
    longitude: 146.8333,
    accuracy: 4
  },
  {
    postalCode: 4816,
    city: "Majors Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.6338,
    longitude: 147.0081,
    accuracy: 4
  },
  {
    postalCode: 4816,
    city: "Paluma",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.0098,
    longitude: 146.2086,
    accuracy: 4
  },
  {
    postalCode: 4816,
    city: "Ellerbeck",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.5652,
    longitude: 146.3947,
    accuracy: 3
  },
  {
    postalCode: 4816,
    city: "Woodstock",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.6,
    longitude: 146.8333,
    accuracy: 4
  },
  {
    postalCode: 4816,
    city: "Prairie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.8833,
    longitude: 144.6,
    accuracy: 4
  },
  {
    postalCode: 4816,
    city: "Reid River",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.7667,
    longitude: 146.8333,
    accuracy: 4
  },
  {
    postalCode: 4816,
    city: "Clemant",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.092,
    longitude: 146.4733,
    accuracy: 4
  },
  {
    postalCode: 4816,
    city: "Macrossan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20,
    longitude: 146.4667,
    accuracy: 4
  },
  {
    postalCode: 4816,
    city: "Nelia",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.5619,
    longitude: 144.8924,
    accuracy: 3
  },
  {
    postalCode: 4816,
    city: "Sellheim",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.0167,
    longitude: 146.4167,
    accuracy: 4
  },
  {
    postalCode: 4816,
    city: "Calcium",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.6395,
    longitude: 146.8198,
    accuracy: 4
  },
  {
    postalCode: 4816,
    city: "Cungulla",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.3921,
    longitude: 147.1083,
    accuracy: 4
  },
  {
    postalCode: 4816,
    city: "Toomulla",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.0828,
    longitude: 146.4749,
    accuracy: 4
  },
  {
    postalCode: 4816,
    city: "Mingela",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.8833,
    longitude: 146.6333,
    accuracy: 4
  },
  {
    postalCode: 4816,
    city: "Palm Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.7356,
    longitude: 146.5779,
    accuracy: 4
  },
  {
    postalCode: 4816,
    city: "Pentland",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.5236,
    longitude: 145.3969,
    accuracy: 4
  },
  {
    postalCode: 4816,
    city: "Ravenswood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.1,
    longitude: 146.8833,
    accuracy: 4
  },
  {
    postalCode: 4817,
    city: "Kirwan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.3032,
    longitude: 146.7253,
    accuracy: 4
  },
  {
    postalCode: 4817,
    city: "Thuringowa Central",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.3167,
    longitude: 146.7289,
    accuracy: 4
  },
  {
    postalCode: 4817,
    city: "Bohle Plains",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.3137,
    longitude: 146.6919,
    accuracy: 4
  },
  {
    postalCode: 4817,
    city: "Alice River",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.3344,
    longitude: 146.6139,
    accuracy: 4
  },
  {
    postalCode: 4817,
    city: "Rangewood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.3114,
    longitude: 146.6388,
    accuracy: 4
  },
  {
    postalCode: 4817,
    city: "Hervey Range",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.4857,
    longitude: 146.6606,
    accuracy: 4
  },
  {
    postalCode: 4818,
    city: "Lynam",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2751,
    longitude: 146.5469,
    accuracy: 4
  },
  {
    postalCode: 4818,
    city: "Beach Holm",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2107,
    longitude: 146.6499,
    accuracy: 4
  },
  {
    postalCode: 4818,
    city: "Yabulu",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.201,
    longitude: 146.5888,
    accuracy: 4
  },
  {
    postalCode: 4818,
    city: "Mount St John",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2568,
    longitude: 146.7448,
    accuracy: 4
  },
  {
    postalCode: 4818,
    city: "Burdell",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2506,
    longitude: 146.6988,
    accuracy: 4
  },
  {
    postalCode: 4818,
    city: "Blue Hills",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.5329,
    longitude: 150.9193,
    accuracy: 3
  },
  {
    postalCode: 4818,
    city: "Bushland Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.1913,
    longitude: 146.6768,
    accuracy: 4
  },
  {
    postalCode: 4818,
    city: "Mount Low",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2321,
    longitude: 146.6695,
    accuracy: 4
  },
  {
    postalCode: 4818,
    city: "Jensen",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2457,
    longitude: 146.6529,
    accuracy: 4
  },
  {
    postalCode: 4818,
    city: "Bohle",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2625,
    longitude: 146.7156,
    accuracy: 4
  },
  {
    postalCode: 4818,
    city: "Saunders Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.1579,
    longitude: 146.6032,
    accuracy: 4
  },
  {
    postalCode: 4818,
    city: "Bluewater Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.205,
    longitude: 146.5134,
    accuracy: 4
  },
  {
    postalCode: 4818,
    city: "Bluewater",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.1816,
    longitude: 146.5582,
    accuracy: 4
  },
  {
    postalCode: 4818,
    city: "Deeragun",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2474,
    longitude: 146.6757,
    accuracy: 4
  },
  {
    postalCode: 4818,
    city: "Toolakea",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.1476,
    longitude: 146.5863,
    accuracy: 4
  },
  {
    postalCode: 4818,
    city: "Shaw",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2626,
    longitude: 146.7033,
    accuracy: 4
  },
  {
    postalCode: 4818,
    city: "Cosgrove",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2154,
    longitude: 146.6304,
    accuracy: 3
  },
  {
    postalCode: 4818,
    city: "Black River",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.2252,
    longitude: 146.6179,
    accuracy: 4
  },
  {
    postalCode: 4819,
    city: "West Point",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.1409,
    longitude: 146.8244,
    accuracy: 4
  },
  {
    postalCode: 4819,
    city: "Florence Bay",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.1167,
    longitude: 146.8705,
    accuracy: 4
  },
  {
    postalCode: 4819,
    city: "Horseshoe Bay",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.1176,
    longitude: 146.8605,
    accuracy: 4
  },
  {
    postalCode: 4819,
    city: "Picnic Bay",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.1746,
    longitude: 146.8376,
    accuracy: 4
  },
  {
    postalCode: 4819,
    city: "Nelly Bay",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.1578,
    longitude: 146.8498,
    accuracy: 4
  },
  {
    postalCode: 4819,
    city: "Magnetic Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.1551,
    longitude: 146.8485,
    accuracy: 4
  },
  {
    postalCode: 4819,
    city: "Arcadia",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.1494,
    longitude: 146.8667,
    accuracy: 4
  },
  {
    postalCode: 4820,
    city: "Broughton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.1167,
    longitude: 146.4333,
    accuracy: 4
  },
  {
    postalCode: 4820,
    city: "Columbia",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.0041,
    longitude: 145.9004,
    accuracy: 3
  },
  {
    postalCode: 4820,
    city: "Breddan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.9804,
    longitude: 146.2904,
    accuracy: 4
  },
  {
    postalCode: 4820,
    city: "Black Jack",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.108,
    longitude: 146.1939,
    accuracy: 3
  },
  {
    postalCode: 4820,
    city: "Lissner",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.0776,
    longitude: 146.2582,
    accuracy: 4
  },
  {
    postalCode: 4820,
    city: "Richmond Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.0041,
    longitude: 145.9004,
    accuracy: 3
  },
  {
    postalCode: 4820,
    city: "Towers Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.0906,
    longitude: 146.2503,
    accuracy: 4
  },
  {
    postalCode: 4820,
    city: "Balfes Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.2167,
    longitude: 145.9167,
    accuracy: 4
  },
  {
    postalCode: 4820,
    city: "Alabama Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.0823,
    longitude: 146.2484,
    accuracy: 4
  },
  {
    postalCode: 4820,
    city: "Millchester",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.0953,
    longitude: 146.276,
    accuracy: 3
  },
  {
    postalCode: 4820,
    city: "Charters Towers",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.0767,
    longitude: 146.2635,
    accuracy: 4
  },
  {
    postalCode: 4820,
    city: "Mosman Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.0987,
    longitude: 146.2603,
    accuracy: 4
  },
  {
    postalCode: 4820,
    city: "Grand Secret",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.0761,
    longitude: 146.2449,
    accuracy: 3
  },
  {
    postalCode: 4820,
    city: "Campaspe",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.108,
    longitude: 146.1939,
    accuracy: 3
  },
  {
    postalCode: 4820,
    city: "Llanarth",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.108,
    longitude: 146.1939,
    accuracy: 3
  },
  {
    postalCode: 4820,
    city: "Southern Cross",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.1333,
    longitude: 146.1167,
    accuracy: 4
  },
  {
    postalCode: 4820,
    city: "Toll",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.0506,
    longitude: 146.2556,
    accuracy: 3
  },
  {
    postalCode: 4820,
    city: "Seventy Mile",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.597,
    longitude: 146.6175,
    accuracy: 4
  },
  {
    postalCode: 4820,
    city: "Queenton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.0745,
    longitude: 146.2817,
    accuracy: 4
  },
  {
    postalCode: 4820,
    city: "Dotswood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.108,
    longitude: 146.1939,
    accuracy: 3
  },
  {
    postalCode: 4820,
    city: "Basalt",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.7516,
    longitude: 145.3892,
    accuracy: 4
  },
  {
    postalCode: 4820,
    city: "Charters Towers City",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.108,
    longitude: 146.1939,
    accuracy: 3
  },
  {
    postalCode: 4821,
    city: "Tangorin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.75,
    longitude: 144.2333,
    accuracy: 4
  },
  {
    postalCode: 4821,
    city: "Stamford",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.2667,
    longitude: 143.8167,
    accuracy: 4
  },
  {
    postalCode: 4821,
    city: "Porcupine",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.844,
    longitude: 144.2003,
    accuracy: 3
  },
  {
    postalCode: 4821,
    city: "Dutton River",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.844,
    longitude: 144.2003,
    accuracy: 3
  },
  {
    postalCode: 4821,
    city: "Hughenden",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.844,
    longitude: 144.2003,
    accuracy: 4
  },
  {
    postalCode: 4822,
    city: "Albion",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.8,
    longitude: 143.2833,
    accuracy: 3
  },
  {
    postalCode: 4822,
    city: "Cambridge",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.8,
    longitude: 143.2833,
    accuracy: 3
  },
  {
    postalCode: 4822,
    city: "Bellfield",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.8,
    longitude: 143.2833,
    accuracy: 3
  },
  {
    postalCode: 4822,
    city: "Richmond",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.7324,
    longitude: 143.1436,
    accuracy: 4
  },
  {
    postalCode: 4822,
    city: "Maxwelton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.7167,
    longitude: 142.6833,
    accuracy: 4
  },
  {
    postalCode: 4822,
    city: "Victoria Vale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.8,
    longitude: 143.2833,
    accuracy: 3
  },
  {
    postalCode: 4822,
    city: "Saxby",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.8,
    longitude: 143.2833,
    accuracy: 3
  },
  {
    postalCode: 4822,
    city: "Burleigh",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.8,
    longitude: 143.2833,
    accuracy: 3
  },
  {
    postalCode: 4822,
    city: "Woolgar",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.8,
    longitude: 143.2833,
    accuracy: 4
  },
  {
    postalCode: 4823,
    city: "Julia Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.6558,
    longitude: 141.7413,
    accuracy: 4
  },
  {
    postalCode: 4823,
    city: "Mckinlay",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.5833,
    longitude: 141.9,
    accuracy: 4
  },
  {
    postalCode: 4823,
    city: "Carpentaria",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.1386,
    longitude: 145.8436,
    accuracy: 3
  },
  {
    postalCode: 4823,
    city: "Kynuna",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.5833,
    longitude: 141.9,
    accuracy: 4
  },
  {
    postalCode: 4823,
    city: "Taldora",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.1386,
    longitude: 145.8436,
    accuracy: 3
  },
  {
    postalCode: 4823,
    city: "Warburton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.5351,
    longitude: 141.5871,
    accuracy: 3
  },
  {
    postalCode: 4823,
    city: "Stokes",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.1386,
    longitude: 145.8436,
    accuracy: 3
  },
  {
    postalCode: 4824,
    city: "Kuridala",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.2833,
    longitude: 140.5,
    accuracy: 4
  },
  {
    postalCode: 4824,
    city: "Four Ways",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.1386,
    longitude: 145.8436,
    accuracy: 3
  },
  {
    postalCode: 4824,
    city: "Oorindi",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.6833,
    longitude: 141.0667,
    accuracy: 4
  },
  {
    postalCode: 4824,
    city: "Gidya",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.1386,
    longitude: 145.8436,
    accuracy: 3
  },
  {
    postalCode: 4824,
    city: "Cloncurry",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.7072,
    longitude: 140.513,
    accuracy: 4
  },
  {
    postalCode: 4824,
    city: "Three Rivers",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.1386,
    longitude: 145.8436,
    accuracy: 3
  },
  {
    postalCode: 4825,
    city: "Mount Isa DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.1386,
    longitude: 145.8436,
    accuracy: 3
  },
  {
    postalCode: 4825,
    city: "Mount Isa",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.7252,
    longitude: 139.4973,
    accuracy: 4
  },
  {
    postalCode: 4825,
    city: "Winston",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.7037,
    longitude: 139.4991,
    accuracy: 4
  },
  {
    postalCode: 4825,
    city: "Menzies",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.7181,
    longitude: 139.4972,
    accuracy: 4
  },
  {
    postalCode: 4825,
    city: "Sunset",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.7103,
    longitude: 139.5082,
    accuracy: 4
  },
  {
    postalCode: 4825,
    city: "Happy Valley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.7479,
    longitude: 139.4906,
    accuracy: 4
  },
  {
    postalCode: 4825,
    city: "Soldiers Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.7053,
    longitude: 139.4899,
    accuracy: 4
  },
  {
    postalCode: 4825,
    city: "Waverley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.2234,
    longitude: 138.7211,
    accuracy: 3
  },
  {
    postalCode: 4825,
    city: "Townview",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.7319,
    longitude: 139.5077,
    accuracy: 3
  },
  {
    postalCode: 4825,
    city: "Spreadborough",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.1386,
    longitude: 145.8436,
    accuracy: 3
  },
  {
    postalCode: 4825,
    city: "Duchess",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.3667,
    longitude: 139.85,
    accuracy: 4
  },
  {
    postalCode: 4825,
    city: "Parkside",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.7377,
    longitude: 139.4886,
    accuracy: 4
  },
  {
    postalCode: 4825,
    city: "Miles End",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.7241,
    longitude: 139.4867,
    accuracy: 3
  },
  {
    postalCode: 4825,
    city: "Mount Isa East",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.1386,
    longitude: 145.8436,
    accuracy: 3
  },
  {
    postalCode: 4825,
    city: "Healy",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.7418,
    longitude: 139.5014,
    accuracy: 3
  },
  {
    postalCode: 4825,
    city: "The Monument",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.2234,
    longitude: 138.7211,
    accuracy: 3
  },
  {
    postalCode: 4825,
    city: "Gunpowder",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.7103,
    longitude: 139.3839,
    accuracy: 4
  },
  {
    postalCode: 4825,
    city: "The Gap",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.2234,
    longitude: 138.7211,
    accuracy: 3
  },
  {
    postalCode: 4825,
    city: "Pioneer",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.7203,
    longitude: 139.5081,
    accuracy: 4
  },
  {
    postalCode: 4825,
    city: "Ryan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.2234,
    longitude: 138.7211,
    accuracy: 3
  },
  {
    postalCode: 4825,
    city: "Dajarra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.6959,
    longitude: 139.5163,
    accuracy: 4
  },
  {
    postalCode: 4825,
    city: "Breakaway",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.2234,
    longitude: 138.7211,
    accuracy: 3
  },
  {
    postalCode: 4825,
    city: "Buckingham",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.2234,
    longitude: 138.7211,
    accuracy: 3
  },
  {
    postalCode: 4825,
    city: "Georgina",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.2234,
    longitude: 138.7211,
    accuracy: 3
  },
  {
    postalCode: 4825,
    city: "Mount Isa City",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.1386,
    longitude: 145.8436,
    accuracy: 3
  },
  {
    postalCode: 4825,
    city: "Piturie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.2234,
    longitude: 138.7211,
    accuracy: 3
  },
  {
    postalCode: 4825,
    city: "Mica Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.7668,
    longitude: 139.4913,
    accuracy: 3
  },
  {
    postalCode: 4825,
    city: "Carrandotta",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.2234,
    longitude: 138.7211,
    accuracy: 3
  },
  {
    postalCode: 4825,
    city: "Fisher",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.2234,
    longitude: 138.7211,
    accuracy: 3
  },
  {
    postalCode: 4825,
    city: "Kalkadoon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.1386,
    longitude: 145.8436,
    accuracy: 3
  },
  {
    postalCode: 4825,
    city: "Lanskey",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.1386,
    longitude: 145.8436,
    accuracy: 3
  },
  {
    postalCode: 4825,
    city: "Lawn Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.1386,
    longitude: 145.8436,
    accuracy: 3
  },
  {
    postalCode: 4825,
    city: "Mornington",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.7342,
    longitude: 139.4959,
    accuracy: 4
  },
  {
    postalCode: 4825,
    city: "Fielding",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.1386,
    longitude: 145.8436,
    accuracy: 3
  },
  {
    postalCode: 4825,
    city: "Barkly",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.1386,
    longitude: 145.8436,
    accuracy: 3
  },
  {
    postalCode: 4828,
    city: "Camooweal",
    state_name: "Queensland",
    state: "QLD",
    latitude: -19.9215,
    longitude: 138.1201,
    accuracy: 4
  },
  {
    postalCode: 4829,
    city: "Boulia",
    state_name: "Queensland",
    state: "QLD",
    latitude: -22.9114,
    longitude: 139.9093,
    accuracy: 4
  },
  {
    postalCode: 4829,
    city: "Toko",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.6177,
    longitude: 139.1149,
    accuracy: 3
  },
  {
    postalCode: 4829,
    city: "Bedourie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.6177,
    longitude: 139.1149,
    accuracy: 3
  },
  {
    postalCode: 4829,
    city: "Wills",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.6177,
    longitude: 139.1149,
    accuracy: 3
  },
  {
    postalCode: 4829,
    city: "Amaroo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.6177,
    longitude: 139.1149,
    accuracy: 3
  },
  {
    postalCode: 4829,
    city: "Warenda",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.6177,
    longitude: 139.1149,
    accuracy: 3
  },
  {
    postalCode: 4829,
    city: "Sturt",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.6177,
    longitude: 139.1149,
    accuracy: 3
  },
  {
    postalCode: 4829,
    city: "Min Min",
    state_name: "Queensland",
    state: "QLD",
    latitude: -24.6177,
    longitude: 139.1149,
    accuracy: 3
  },
  {
    postalCode: 4830,
    city: "Nicholson",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.1224,
    longitude: 146.0477,
    accuracy: 3
  },
  {
    postalCode: 4830,
    city: "Burketown",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.7411,
    longitude: 139.5477,
    accuracy: 4
  },
  {
    postalCode: 4830,
    city: "Gregory",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.1224,
    longitude: 146.0477,
    accuracy: 3
  },
  {
    postalCode: 4830,
    city: "Doomadgee",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.9435,
    longitude: 138.8272,
    accuracy: 4
  },
  {
    postalCode: 4849,
    city: "Cardwell",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.2669,
    longitude: 146.028,
    accuracy: 4
  },
  {
    postalCode: 4849,
    city: "Rungoo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.3072,
    longitude: 146.1291,
    accuracy: 3
  },
  {
    postalCode: 4849,
    city: "Lumholtz",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.3072,
    longitude: 146.1291,
    accuracy: 3
  },
  {
    postalCode: 4849,
    city: "Hinchinbrook",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.3511,
    longitude: 146.2352,
    accuracy: 4
  },
  {
    postalCode: 4849,
    city: "Damper Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.3072,
    longitude: 146.1291,
    accuracy: 3
  },
  {
    postalCode: 4850,
    city: "Ingham",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.6455,
    longitude: 146.1625,
    accuracy: 4
  },
  {
    postalCode: 4850,
    city: "Yuruga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.8333,
    longitude: 146.1667,
    accuracy: 4
  },
  {
    postalCode: 4850,
    city: "Toobanna",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.7,
    longitude: 146.15,
    accuracy: 4
  },
  {
    postalCode: 4850,
    city: "Peacock Siding",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.6833,
    longitude: 146,
    accuracy: 4
  },
  {
    postalCode: 4850,
    city: "Bemerside",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.5667,
    longitude: 146.2333,
    accuracy: 4
  },
  {
    postalCode: 4850,
    city: "Macknade",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.5873,
    longitude: 146.2559,
    accuracy: 4
  },
  {
    postalCode: 4850,
    city: "Lucinda",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.5278,
    longitude: 146.3313,
    accuracy: 4
  },
  {
    postalCode: 4850,
    city: "Abergowrie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.4382,
    longitude: 145.9313,
    accuracy: 4
  },
  {
    postalCode: 4850,
    city: "Halifax",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.5827,
    longitude: 146.2855,
    accuracy: 4
  },
  {
    postalCode: 4850,
    city: "Valley Of Lagoons",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.661,
    longitude: 146.1506,
    accuracy: 3
  },
  {
    postalCode: 4850,
    city: "Blackrock",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.7085,
    longitude: 146.2121,
    accuracy: 4
  },
  {
    postalCode: 4850,
    city: "Trebonne",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.6254,
    longitude: 146.0792,
    accuracy: 4
  },
  {
    postalCode: 4850,
    city: "Victoria Estate",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.65,
    longitude: 146.2,
    accuracy: 4
  },
  {
    postalCode: 4850,
    city: "Victoria Plantation",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.6466,
    longitude: 146.2019,
    accuracy: 3
  },
  {
    postalCode: 4850,
    city: "Hawkins Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.6,
    longitude: 146.1,
    accuracy: 4
  },
  {
    postalCode: 4850,
    city: "Coolbie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.9167,
    longitude: 146.2667,
    accuracy: 4
  },
  {
    postalCode: 4850,
    city: "Long Pocket",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.5167,
    longitude: 146.0333,
    accuracy: 4
  },
  {
    postalCode: 4850,
    city: "Allingham",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.6667,
    longitude: 146.25,
    accuracy: 4
  },
  {
    postalCode: 4850,
    city: "Braemeadows",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.661,
    longitude: 146.1506,
    accuracy: 3
  },
  {
    postalCode: 4850,
    city: "Dalrymple Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.661,
    longitude: 146.1506,
    accuracy: 3
  },
  {
    postalCode: 4850,
    city: "Bambaroo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.8667,
    longitude: 146.2,
    accuracy: 4
  },
  {
    postalCode: 4850,
    city: "Orient",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.661,
    longitude: 146.1506,
    accuracy: 3
  },
  {
    postalCode: 4850,
    city: "Lannercost",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.5833,
    longitude: 146.05,
    accuracy: 4
  },
  {
    postalCode: 4850,
    city: "Wharps",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.661,
    longitude: 146.1506,
    accuracy: 3
  },
  {
    postalCode: 4850,
    city: "Helens Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.7667,
    longitude: 146.1667,
    accuracy: 4
  },
  {
    postalCode: 4850,
    city: "Garrawalt",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.661,
    longitude: 146.1506,
    accuracy: 3
  },
  {
    postalCode: 4850,
    city: "Cordelia",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.5833,
    longitude: 146.25,
    accuracy: 4
  },
  {
    postalCode: 4850,
    city: "Wallaman",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.661,
    longitude: 146.1506,
    accuracy: 3
  },
  {
    postalCode: 4850,
    city: "Taylors Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.6327,
    longitude: 146.3245,
    accuracy: 4
  },
  {
    postalCode: 4850,
    city: "Foresthome",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.661,
    longitude: 146.1506,
    accuracy: 3
  },
  {
    postalCode: 4850,
    city: "Mount Fox",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.8167,
    longitude: 145.8333,
    accuracy: 4
  },
  {
    postalCode: 4850,
    city: "Forrest Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.661,
    longitude: 146.1506,
    accuracy: 3
  },
  {
    postalCode: 4850,
    city: "Upper Stone",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.7333,
    longitude: 145.9667,
    accuracy: 4
  },
  {
    postalCode: 4850,
    city: "Gairloch",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.6333,
    longitude: 146.1667,
    accuracy: 4
  },
  {
    postalCode: 4852,
    city: "Tam O'Shanter",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.941,
    longitude: 146.0235,
    accuracy: 4
  },
  {
    postalCode: 4852,
    city: "Djiru",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.8466,
    longitude: 146.0534,
    accuracy: 3
  },
  {
    postalCode: 4852,
    city: "Dunk",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.9518,
    longitude: 146.1557,
    accuracy: 4
  },
  {
    postalCode: 4852,
    city: "Garners Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.8163,
    longitude: 146.0977,
    accuracy: 4
  },
  {
    postalCode: 4852,
    city: "Bingil Bay",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.8295,
    longitude: 146.0965,
    accuracy: 4
  },
  {
    postalCode: 4852,
    city: "Carmoo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.9473,
    longitude: 146.0457,
    accuracy: 4
  },
  {
    postalCode: 4852,
    city: "Wongaling Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.9133,
    longitude: 146.0961,
    accuracy: 4
  },
  {
    postalCode: 4852,
    city: "Midgeree Bar",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.8008,
    longitude: 146.0801,
    accuracy: 4
  },
  {
    postalCode: 4852,
    city: "South Mission Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.95,
    longitude: 146.0833,
    accuracy: 4
  },
  {
    postalCode: 4852,
    city: "Mission Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.8688,
    longitude: 146.1039,
    accuracy: 4
  },
  {
    postalCode: 4854,
    city: "Birkalla",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.921,
    longitude: 145.9401,
    accuracy: 4
  },
  {
    postalCode: 4854,
    city: "Midgenoo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.9,
    longitude: 145.9667,
    accuracy: 4
  },
  {
    postalCode: 4854,
    city: "Murray Upper",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.1,
    longitude: 145.85,
    accuracy: 4
  },
  {
    postalCode: 4854,
    city: "East Feluga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.9573,
    longitude: 145.9256,
    accuracy: 3
  },
  {
    postalCode: 4854,
    city: "Tully Heads",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.0232,
    longitude: 146.0558,
    accuracy: 4
  },
  {
    postalCode: 4854,
    city: "Bilyana",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.1092,
    longitude: 145.9267,
    accuracy: 4
  },
  {
    postalCode: 4854,
    city: "Silky Oak",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.9673,
    longitude: 145.9392,
    accuracy: 4
  },
  {
    postalCode: 4854,
    city: "Lower Tully",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.9846,
    longitude: 146.0144,
    accuracy: 4
  },
  {
    postalCode: 4854,
    city: "Bulgun",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.8996,
    longitude: 145.9282,
    accuracy: 4
  },
  {
    postalCode: 4854,
    city: "Hull Heads",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.9573,
    longitude: 145.9256,
    accuracy: 3
  },
  {
    postalCode: 4854,
    city: "Cardstone",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.7509,
    longitude: 145.5993,
    accuracy: 4
  },
  {
    postalCode: 4854,
    city: "Rockingham",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.0275,
    longitude: 145.9746,
    accuracy: 4
  },
  {
    postalCode: 4854,
    city: "Djarawong",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.8667,
    longitude: 145.9833,
    accuracy: 4
  },
  {
    postalCode: 4854,
    city: "Dingo Pocket",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.9573,
    longitude: 145.9256,
    accuracy: 3
  },
  {
    postalCode: 4854,
    city: "Murrigal",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.0478,
    longitude: 145.9116,
    accuracy: 4
  },
  {
    postalCode: 4854,
    city: "Tully",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.9326,
    longitude: 145.9228,
    accuracy: 4
  },
  {
    postalCode: 4854,
    city: "Feluga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.8795,
    longitude: 145.9516,
    accuracy: 4
  },
  {
    postalCode: 4854,
    city: "Kooroomool",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.9573,
    longitude: 145.9256,
    accuracy: 3
  },
  {
    postalCode: 4854,
    city: "Warrami",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.9573,
    longitude: 145.9256,
    accuracy: 3
  },
  {
    postalCode: 4854,
    city: "Mount Mackay",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.9573,
    longitude: 145.9256,
    accuracy: 3
  },
  {
    postalCode: 4854,
    city: "Euramo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18,
    longitude: 145.9333,
    accuracy: 4
  },
  {
    postalCode: 4854,
    city: "Munro Plains",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.9573,
    longitude: 145.9256,
    accuracy: 3
  },
  {
    postalCode: 4854,
    city: "Jarra Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.9573,
    longitude: 145.9256,
    accuracy: 3
  },
  {
    postalCode: 4854,
    city: "Merryburn",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.9573,
    longitude: 145.9256,
    accuracy: 3
  },
  {
    postalCode: 4854,
    city: "Walter Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.9573,
    longitude: 145.9256,
    accuracy: 3
  },
  {
    postalCode: 4855,
    city: "El Arish",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.8075,
    longitude: 146.0072,
    accuracy: 4
  },
  {
    postalCode: 4855,
    city: "Jaffa",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.7833,
    longitude: 146.0167,
    accuracy: 4
  },
  {
    postalCode: 4855,
    city: "Maadi",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.8333,
    longitude: 146,
    accuracy: 4
  },
  {
    postalCode: 4855,
    city: "Granadilla",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.8057,
    longitude: 146.0047,
    accuracy: 3
  },
  {
    postalCode: 4855,
    city: "Shell Pocket",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.8057,
    longitude: 146.0047,
    accuracy: 3
  },
  {
    postalCode: 4855,
    city: "Maria Creeks",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.8057,
    longitude: 146.0047,
    accuracy: 3
  },
  {
    postalCode: 4855,
    city: "Daveson",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.8057,
    longitude: 146.0047,
    accuracy: 3
  },
  {
    postalCode: 4855,
    city: "Friday Pocket",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.8057,
    longitude: 146.0047,
    accuracy: 3
  },
  {
    postalCode: 4856,
    city: "Silkwood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.7446,
    longitude: 146.0171,
    accuracy: 4
  },
  {
    postalCode: 4856,
    city: "Goolboo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.7104,
    longitude: 146.0345,
    accuracy: 4
  },
  {
    postalCode: 4856,
    city: "Japoonvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.7167,
    longitude: 145.9333,
    accuracy: 4
  },
  {
    postalCode: 4856,
    city: "Walter Lever Estate",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.7786,
    longitude: 145.9193,
    accuracy: 3
  },
  {
    postalCode: 4856,
    city: "No. 4 Branch",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.7786,
    longitude: 145.9193,
    accuracy: 3
  },
  {
    postalCode: 4856,
    city: "No. 5 Branch",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.7786,
    longitude: 145.9193,
    accuracy: 3
  },
  {
    postalCode: 4856,
    city: "Mccutcheon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.7786,
    longitude: 145.9193,
    accuracy: 3
  },
  {
    postalCode: 4857,
    city: "Silkwood East",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.7435,
    longitude: 146.0097,
    accuracy: 1
  },
  {
    postalCode: 4858,
    city: "Comoon Loop",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5607,
    longitude: 146.0337,
    accuracy: 4
  },
  {
    postalCode: 4858,
    city: "Etty Bay",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.6009,
    longitude: 146.0708,
    accuracy: 3
  },
  {
    postalCode: 4858,
    city: "Mourilyan Harbour",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.6002,
    longitude: 146.1251,
    accuracy: 4
  },
  {
    postalCode: 4858,
    city: "Mourilyan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5826,
    longitude: 146.0435,
    accuracy: 4
  },
  {
    postalCode: 4858,
    city: "New Harbourline",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.614,
    longitude: 146.0637,
    accuracy: 4
  },
  {
    postalCode: 4858,
    city: "Martyville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.6175,
    longitude: 146.036,
    accuracy: 4
  },
  {
    postalCode: 4859,
    city: "No. 6 Branch",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5983,
    longitude: 145.9944,
    accuracy: 3
  },
  {
    postalCode: 4859,
    city: "South Johnstone",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5972,
    longitude: 145.9945,
    accuracy: 4
  },
  {
    postalCode: 4860,
    city: "Coorumba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5563,
    longitude: 145.9143,
    accuracy: 3
  },
  {
    postalCode: 4860,
    city: "Innisfail Estate",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.519,
    longitude: 146.0393,
    accuracy: 3
  },
  {
    postalCode: 4860,
    city: "Hudson",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5256,
    longitude: 146.0031,
    accuracy: 4
  },
  {
    postalCode: 4860,
    city: "East Palmerston",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.6062,
    longitude: 145.8486,
    accuracy: 4
  },
  {
    postalCode: 4860,
    city: "Eubenangee",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.455,
    longitude: 145.9768,
    accuracy: 4
  },
  {
    postalCode: 4860,
    city: "Cooroo Lands",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5305,
    longitude: 145.8932,
    accuracy: 3
  },
  {
    postalCode: 4860,
    city: "Cullinane",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5152,
    longitude: 146.026,
    accuracy: 3
  },
  {
    postalCode: 4860,
    city: "Garradunga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.4667,
    longitude: 146,
    accuracy: 4
  },
  {
    postalCode: 4860,
    city: "Belvedere",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5208,
    longitude: 145.9892,
    accuracy: 4
  },
  {
    postalCode: 4860,
    city: "Nerada",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5305,
    longitude: 145.8932,
    accuracy: 3
  },
  {
    postalCode: 4860,
    city: "South Innisfail",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5449,
    longitude: 146.0296,
    accuracy: 4
  },
  {
    postalCode: 4860,
    city: "Sundown",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4654,
    longitude: 151.3113,
    accuracy: 3
  },
  {
    postalCode: 4860,
    city: "Goondi",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5167,
    longitude: 146,
    accuracy: 4
  },
  {
    postalCode: 4860,
    city: "Palmerston",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5305,
    longitude: 145.8932,
    accuracy: 3
  },
  {
    postalCode: 4860,
    city: "Daradgee",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.4833,
    longitude: 146,
    accuracy: 4
  },
  {
    postalCode: 4860,
    city: "Innisfail",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5221,
    longitude: 146.031,
    accuracy: 4
  },
  {
    postalCode: 4860,
    city: "East Innisfail",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5342,
    longitude: 146.0328,
    accuracy: 4
  },
  {
    postalCode: 4860,
    city: "Stoters Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5305,
    longitude: 145.8932,
    accuracy: 3
  },
  {
    postalCode: 4860,
    city: "Mighell",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5329,
    longitude: 146.024,
    accuracy: 4
  },
  {
    postalCode: 4860,
    city: "Goondi Bend",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5192,
    longitude: 146.0107,
    accuracy: 3
  },
  {
    postalCode: 4860,
    city: "Wooroonooran",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.3807,
    longitude: 145.8007,
    accuracy: 4
  },
  {
    postalCode: 4860,
    city: "Coquette Point",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5305,
    longitude: 145.8932,
    accuracy: 3
  },
  {
    postalCode: 4860,
    city: "Flying Fish Point",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.4967,
    longitude: 146.076,
    accuracy: 4
  },
  {
    postalCode: 4860,
    city: "Fitzgerald Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5305,
    longitude: 145.8932,
    accuracy: 3
  },
  {
    postalCode: 4860,
    city: "Eaton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5305,
    longitude: 145.8932,
    accuracy: 3
  },
  {
    postalCode: 4860,
    city: "Coconuts",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5059,
    longitude: 146.0645,
    accuracy: 3
  },
  {
    postalCode: 4860,
    city: "Njatjan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5305,
    longitude: 145.8932,
    accuracy: 3
  },
  {
    postalCode: 4860,
    city: "Ngatjan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5156,
    longitude: 145.9646,
    accuracy: 3
  },
  {
    postalCode: 4860,
    city: "Bamboo Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5305,
    longitude: 145.8932,
    accuracy: 3
  },
  {
    postalCode: 4860,
    city: "O'Briens Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5305,
    longitude: 145.8932,
    accuracy: 3
  },
  {
    postalCode: 4860,
    city: "Pin Gin Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5305,
    longitude: 145.8932,
    accuracy: 3
  },
  {
    postalCode: 4860,
    city: "Vasa Views",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.4685,
    longitude: 145.9656,
    accuracy: 3
  },
  {
    postalCode: 4860,
    city: "Jubilee Heights",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5305,
    longitude: 145.8932,
    accuracy: 3
  },
  {
    postalCode: 4860,
    city: "Webb",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5298,
    longitude: 146.0435,
    accuracy: 3
  },
  {
    postalCode: 4860,
    city: "Upper Daradgee",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5305,
    longitude: 145.8932,
    accuracy: 3
  },
  {
    postalCode: 4860,
    city: "Wanjuru",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5305,
    longitude: 145.8932,
    accuracy: 3
  },
  {
    postalCode: 4860,
    city: "Goondi Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5246,
    longitude: 146.0171,
    accuracy: 3
  },
  {
    postalCode: 4860,
    city: "Mundoo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5626,
    longitude: 146.0166,
    accuracy: 4
  },
  {
    postalCode: 4861,
    city: "Bartle Frere",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.45,
    longitude: 145.8833,
    accuracy: 4
  },
  {
    postalCode: 4861,
    city: "East Russell",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.3577,
    longitude: 145.9755,
    accuracy: 3
  },
  {
    postalCode: 4861,
    city: "Babinda",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.3439,
    longitude: 145.9227,
    accuracy: 4
  },
  {
    postalCode: 4865,
    city: "Gordonvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.0996,
    longitude: 145.7804,
    accuracy: 4
  },
  {
    postalCode: 4865,
    city: "Packers Camp",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.1114,
    longitude: 145.754,
    accuracy: 3
  },
  {
    postalCode: 4865,
    city: "Green Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.1114,
    longitude: 145.754,
    accuracy: 3
  },
  {
    postalCode: 4865,
    city: "Kamma",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.05,
    longitude: 145.7667,
    accuracy: 4
  },
  {
    postalCode: 4865,
    city: "Little Mulgrave",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.15,
    longitude: 145.7167,
    accuracy: 4
  },
  {
    postalCode: 4865,
    city: "Goldsborough",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.146,
    longitude: 145.7524,
    accuracy: 4
  },
  {
    postalCode: 4868,
    city: "Bayview Heights",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.9623,
    longitude: 145.7258,
    accuracy: 4
  },
  {
    postalCode: 4868,
    city: "White Rock",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.9833,
    longitude: 145.75,
    accuracy: 4
  },
  {
    postalCode: 4868,
    city: "Woree",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.95,
    longitude: 145.75,
    accuracy: 4
  },
  {
    postalCode: 4868,
    city: "Mount Sheridan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.9889,
    longitude: 145.7322,
    accuracy: 4
  },
  {
    postalCode: 4869,
    city: "Bentley Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.0083,
    longitude: 145.7221,
    accuracy: 4
  },
  {
    postalCode: 4869,
    city: "Mount Peter",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.0177,
    longitude: 145.7305,
    accuracy: 3
  },
  {
    postalCode: 4869,
    city: "Edmonton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.019,
    longitude: 145.7444,
    accuracy: 4
  },
  {
    postalCode: 4869,
    city: "Wrights Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.0177,
    longitude: 145.7305,
    accuracy: 3
  },
  {
    postalCode: 4870,
    city: "Cairns",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.923,
    longitude: 145.7663,
    accuracy: 4
  },
  {
    postalCode: 4870,
    city: "Westcourt",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.9304,
    longitude: 145.753,
    accuracy: 4
  },
  {
    postalCode: 4870,
    city: "Edge Hill",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.9,
    longitude: 145.75,
    accuracy: 4
  },
  {
    postalCode: 4870,
    city: "Cairns North",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.9066,
    longitude: 145.7597,
    accuracy: 3
  },
  {
    postalCode: 4870,
    city: "Bungalow",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.9373,
    longitude: 145.757,
    accuracy: 4
  },
  {
    postalCode: 4870,
    city: "Cairns Central",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.9071,
    longitude: 145.7325,
    accuracy: 3
  },
  {
    postalCode: 4870,
    city: "Manunda",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.9172,
    longitude: 145.7492,
    accuracy: 4
  },
  {
    postalCode: 4870,
    city: "Cairns City",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.9078,
    longitude: 145.7329,
    accuracy: 3
  },
  {
    postalCode: 4870,
    city: "Parramatta Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.9245,
    longitude: 145.7626,
    accuracy: 4
  },
  {
    postalCode: 4870,
    city: "Mooroobool",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.9356,
    longitude: 145.7296,
    accuracy: 4
  },
  {
    postalCode: 4870,
    city: "Whitfield",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.8951,
    longitude: 145.7333,
    accuracy: 4
  },
  {
    postalCode: 4870,
    city: "Cairns Orchid Plaza",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.9078,
    longitude: 145.7329,
    accuracy: 3
  },
  {
    postalCode: 4870,
    city: "Kanimbla",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.9217,
    longitude: 145.7222,
    accuracy: 4
  },
  {
    postalCode: 4870,
    city: "Cairns DC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.9071,
    longitude: 145.7325,
    accuracy: 3
  },
  {
    postalCode: 4870,
    city: "Aeroglen",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.8806,
    longitude: 145.745,
    accuracy: 4
  },
  {
    postalCode: 4870,
    city: "Martynvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.9078,
    longitude: 145.7329,
    accuracy: 3
  },
  {
    postalCode: 4870,
    city: "Redlynch",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.8833,
    longitude: 145.7,
    accuracy: 4
  },
  {
    postalCode: 4870,
    city: "Portsmith",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.9071,
    longitude: 145.7325,
    accuracy: 3
  },
  {
    postalCode: 4870,
    city: "Brinsmead",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.8992,
    longitude: 145.7155,
    accuracy: 4
  },
  {
    postalCode: 4870,
    city: "North Cairns",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.9071,
    longitude: 145.7325,
    accuracy: 3
  },
  {
    postalCode: 4870,
    city: "Manoora",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.9171,
    longitude: 145.7367,
    accuracy: 4
  },
  {
    postalCode: 4870,
    city: "Barron Gorge",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.8802,
    longitude: 145.6692,
    accuracy: 4
  },
  {
    postalCode: 4870,
    city: "Earlville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.9471,
    longitude: 145.7315,
    accuracy: 4
  },
  {
    postalCode: 4870,
    city: "Lamb Range",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.9071,
    longitude: 145.7325,
    accuracy: 3
  },
  {
    postalCode: 4870,
    city: "Kamerunga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.8732,
    longitude: 145.7013,
    accuracy: 4
  },
  {
    postalCode: 4870,
    city: "Stratford",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.8833,
    longitude: 145.7333,
    accuracy: 4
  },
  {
    postalCode: 4870,
    city: "Freshwater",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.8833,
    longitude: 145.7167,
    accuracy: 4
  },
  {
    postalCode: 4870,
    city: "Earlville BC",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.9071,
    longitude: 145.7325,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Coen",
    state_name: "Queensland",
    state: "QLD",
    latitude: -13.9456,
    longitude: 143.199,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Stockton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5811,
    longitude: 146.0141,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Cowley Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.6953,
    longitude: 146.1073,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Einasleigh",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.5167,
    longitude: 144.1,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Gilbert River",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.15,
    longitude: 142.8667,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Cowley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.6833,
    longitude: 146.05,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Bellenden Ker",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2667,
    longitude: 145.9167,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Georgetown",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.292,
    longitude: 143.5458,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Basilisk",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.6602,
    longitude: 145.992,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Moresby",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.6333,
    longitude: 146.0333,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "East Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2018,
    longitude: 145.1662,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Mena Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.65,
    longitude: 145.9667,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Mount Surprise",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.1466,
    longitude: 144.319,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "East Trinity",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.8932,
    longitude: 145.8267,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Karron",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2018,
    longitude: 145.1662,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Strathmore",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2018,
    longitude: 145.1662,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Mount Molloy",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.6734,
    longitude: 145.3272,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Lower Cowley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.1048,
    longitude: 143.1125,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Lyndhurst",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2018,
    longitude: 145.1662,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Desailly",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2018,
    longitude: 145.1662,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Mount Mulligan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.85,
    longitude: 144.8667,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Julatten",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.6072,
    longitude: 145.3412,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Springfield",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2018,
    longitude: 145.1662,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Yarrabah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.9203,
    longitude: 145.8715,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Lakeland Downs",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.8585,
    longitude: 144.8546,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Lockhart",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.1048,
    longitude: 143.1125,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Aloomba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.1099,
    longitude: 145.8334,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Chillagoe",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.1539,
    longitude: 144.5227,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Boogan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.6111,
    longitude: 146.0133,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Utchee Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.1048,
    longitude: 143.1125,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Miriwinni",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.4,
    longitude: 145.9167,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Talaroo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2018,
    longitude: 145.1662,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Laura",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.5691,
    longitude: 144.4702,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Currajah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.1048,
    longitude: 143.1125,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Kurrimine Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.7765,
    longitude: 146.1066,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Forsayth",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.5833,
    longitude: 143.6167,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Aurukun",
    state_name: "Queensland",
    state: "QLD",
    latitude: -13.6029,
    longitude: 141.8162,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Camp Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.1048,
    longitude: 143.1125,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Kowanyama",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.4736,
    longitude: 141.7457,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Petford",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.35,
    longitude: 144.9333,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Hurricane",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2018,
    longitude: 145.1662,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Green Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.1048,
    longitude: 143.1125,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Gununa",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.6657,
    longitude: 139.1801,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Croydon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -18.2043,
    longitude: 142.2446,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Crystalbrook",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2018,
    longitude: 145.1662,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Portland Roads",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2018,
    longitude: 145.1662,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Claraville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2018,
    longitude: 145.1662,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Esmeralda",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2018,
    longitude: 145.1662,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Coralie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2018,
    longitude: 145.1662,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Bombeeta",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.6833,
    longitude: 145.9667,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Woopen Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2018,
    longitude: 145.1662,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Deeral",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2167,
    longitude: 145.9167,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Glen Boughton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.1048,
    longitude: 143.1125,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Mount Carbine",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.5333,
    longitude: 145.1333,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Amber",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2018,
    longitude: 145.1662,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Macalister Range",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.7755,
    longitude: 145.6551,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Bolwarra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2018,
    longitude: 145.1662,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Mirriwinni",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2018,
    longitude: 145.1662,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Blackbull",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2018,
    longitude: 145.1662,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Fishery Falls",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.1833,
    longitude: 145.8833,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Sandy Pocket",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.1048,
    longitude: 143.1125,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Fitzroy Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2018,
    longitude: 145.1662,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Cowley Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.1048,
    longitude: 143.1125,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Wangan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5775,
    longitude: 146.0067,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Fossilbrook",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2018,
    longitude: 145.1662,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Northhead",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2018,
    longitude: 145.1662,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Germantown",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.1048,
    longitude: 143.1125,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Lakeland",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.9707,
    longitude: 144.8036,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Edward River",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.1048,
    longitude: 143.1125,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Thornborough",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2018,
    longitude: 145.1662,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Conjuboy",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2018,
    longitude: 145.1662,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Southedge",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2018,
    longitude: 145.1662,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Bulleringa",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2018,
    longitude: 145.1662,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Waugh Pocket",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2018,
    longitude: 145.1662,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Pormpuraaw",
    state_name: "Queensland",
    state: "QLD",
    latitude: -14.6611,
    longitude: 141.835,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Bramston Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.3518,
    longitude: 146.0231,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Almaden",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.3382,
    longitude: 144.6771,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Rookwood",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2018,
    longitude: 145.1662,
    accuracy: 3
  },
  {
    postalCode: 4871,
    city: "Warrubullen",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.6913,
    longitude: 146.0167,
    accuracy: 4
  },
  {
    postalCode: 4871,
    city: "Nychum",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2018,
    longitude: 145.1662,
    accuracy: 3
  },
  {
    postalCode: 4872,
    city: "Kairi",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2144,
    longitude: 145.544,
    accuracy: 4
  },
  {
    postalCode: 4872,
    city: "Silver Valley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.9971,
    longitude: 145.26,
    accuracy: 3
  },
  {
    postalCode: 4872,
    city: "Mutchilba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.1333,
    longitude: 145.2167,
    accuracy: 4
  },
  {
    postalCode: 4872,
    city: "Barrine",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2,
    longitude: 145.6333,
    accuracy: 4
  },
  {
    postalCode: 4872,
    city: "Innot Hot Springs",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.6667,
    longitude: 145.25,
    accuracy: 4
  },
  {
    postalCode: 4872,
    city: "Wairuna",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.9971,
    longitude: 145.26,
    accuracy: 3
  },
  {
    postalCode: 4872,
    city: "Mount Garnet",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.6766,
    longitude: 145.1143,
    accuracy: 4
  },
  {
    postalCode: 4872,
    city: "Kowrowa",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.8167,
    longitude: 145.5833,
    accuracy: 4
  },
  {
    postalCode: 4872,
    city: "Danbulla",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.15,
    longitude: 145.6167,
    accuracy: 4
  },
  {
    postalCode: 4872,
    city: "Munderra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2313,
    longitude: 145.4035,
    accuracy: 3
  },
  {
    postalCode: 4872,
    city: "Dimbulah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.1475,
    longitude: 145.1097,
    accuracy: 4
  },
  {
    postalCode: 4872,
    city: "Barwidgi",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2313,
    longitude: 145.4035,
    accuracy: 3
  },
  {
    postalCode: 4872,
    city: "Tinaroo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.1712,
    longitude: 145.5494,
    accuracy: 4
  },
  {
    postalCode: 4872,
    city: "Cairns Mc",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2313,
    longitude: 145.4035,
    accuracy: 3
  },
  {
    postalCode: 4872,
    city: "Walkamin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.1368,
    longitude: 145.4172,
    accuracy: 4
  },
  {
    postalCode: 4872,
    city: "Koombooloomba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.9971,
    longitude: 145.26,
    accuracy: 3
  },
  {
    postalCode: 4872,
    city: "Forty Mile",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2313,
    longitude: 145.4035,
    accuracy: 3
  },
  {
    postalCode: 4872,
    city: "Lake Tinaroo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.9971,
    longitude: 145.26,
    accuracy: 3
  },
  {
    postalCode: 4872,
    city: "Minnamoolka",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.9971,
    longitude: 145.26,
    accuracy: 3
  },
  {
    postalCode: 4872,
    city: "Glen Ruth",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.9971,
    longitude: 145.26,
    accuracy: 3
  },
  {
    postalCode: 4872,
    city: "Gunnawarra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.9971,
    longitude: 145.26,
    accuracy: 3
  },
  {
    postalCode: 4872,
    city: "Kirrama",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.9971,
    longitude: 145.26,
    accuracy: 3
  },
  {
    postalCode: 4873,
    city: "Cow Bay",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.2254,
    longitude: 145.4286,
    accuracy: 4
  },
  {
    postalCode: 4873,
    city: "Forest Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.2374,
    longitude: 145.3658,
    accuracy: 4
  },
  {
    postalCode: 4873,
    city: "Syndicate",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.3447,
    longitude: 145.3956,
    accuracy: 3
  },
  {
    postalCode: 4873,
    city: "Dagmar",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.3447,
    longitude: 145.3956,
    accuracy: 3
  },
  {
    postalCode: 4873,
    city: "Bamboo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -14.6417,
    longitude: 143.4742,
    accuracy: 4
  },
  {
    postalCode: 4873,
    city: "Kimberley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.2562,
    longitude: 145.4387,
    accuracy: 4
  },
  {
    postalCode: 4873,
    city: "Daintree",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.25,
    longitude: 145.3193,
    accuracy: 4
  },
  {
    postalCode: 4873,
    city: "Dedin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.3447,
    longitude: 145.3956,
    accuracy: 3
  },
  {
    postalCode: 4873,
    city: "Whyanbeel",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.3642,
    longitude: 145.3597,
    accuracy: 4
  },
  {
    postalCode: 4873,
    city: "Shannonvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.4901,
    longitude: 145.3775,
    accuracy: 4
  },
  {
    postalCode: 4873,
    city: "Diwan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.1902,
    longitude: 145.415,
    accuracy: 4
  },
  {
    postalCode: 4873,
    city: "Low Isles",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.3447,
    longitude: 145.3956,
    accuracy: 3
  },
  {
    postalCode: 4873,
    city: "Cassowary",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.516,
    longitude: 145.4123,
    accuracy: 4
  },
  {
    postalCode: 4873,
    city: "Rocky Point",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.3907,
    longitude: 145.4056,
    accuracy: 4
  },
  {
    postalCode: 4873,
    city: "Miallo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.3997,
    longitude: 145.3803,
    accuracy: 4
  },
  {
    postalCode: 4873,
    city: "Noah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.3447,
    longitude: 145.3956,
    accuracy: 3
  },
  {
    postalCode: 4873,
    city: "Finlayvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.4666,
    longitude: 145.3451,
    accuracy: 4
  },
  {
    postalCode: 4873,
    city: "Bonnie Doon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.4491,
    longitude: 145.3806,
    accuracy: 4
  },
  {
    postalCode: 4873,
    city: "Mossman",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.4605,
    longitude: 145.3719,
    accuracy: 4
  },
  {
    postalCode: 4873,
    city: "Upper Daintree",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.239,
    longitude: 145.3059,
    accuracy: 4
  },
  {
    postalCode: 4873,
    city: "Newell",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.4264,
    longitude: 145.406,
    accuracy: 4
  },
  {
    postalCode: 4873,
    city: "Spurgeon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.3447,
    longitude: 145.3956,
    accuracy: 3
  },
  {
    postalCode: 4873,
    city: "Stewart Creek Valley",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.298,
    longitude: 145.3151,
    accuracy: 4
  },
  {
    postalCode: 4873,
    city: "Cape Tribulation",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.0867,
    longitude: 145.4618,
    accuracy: 4
  },
  {
    postalCode: 4873,
    city: "Mossman Gorge",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.4663,
    longitude: 145.3633,
    accuracy: 4
  },
  {
    postalCode: 4873,
    city: "Cooya Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.4481,
    longitude: 145.4057,
    accuracy: 4
  },
  {
    postalCode: 4873,
    city: "Wonga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.346,
    longitude: 145.412,
    accuracy: 4
  },
  {
    postalCode: 4873,
    city: "Thornton Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.3447,
    longitude: 145.3956,
    accuracy: 3
  },
  {
    postalCode: 4873,
    city: "Lower Daintree",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.276,
    longitude: 145.3821,
    accuracy: 4
  },
  {
    postalCode: 4874,
    city: "Nanum",
    state_name: "Queensland",
    state: "QLD",
    latitude: -12.6401,
    longitude: 141.8636,
    accuracy: 3
  },
  {
    postalCode: 4874,
    city: "Weipa",
    state_name: "Queensland",
    state: "QLD",
    latitude: -12.6235,
    longitude: 141.8788,
    accuracy: 4
  },
  {
    postalCode: 4874,
    city: "Mapoon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -12.019,
    longitude: 141.9006,
    accuracy: 4
  },
  {
    postalCode: 4874,
    city: "Napranum",
    state_name: "Queensland",
    state: "QLD",
    latitude: -12.6832,
    longitude: 141.89,
    accuracy: 4
  },
  {
    postalCode: 4874,
    city: "Evans Landing",
    state_name: "Queensland",
    state: "QLD",
    latitude: -12.6623,
    longitude: 141.8526,
    accuracy: 4
  },
  {
    postalCode: 4874,
    city: "Rocky Point",
    state_name: "Queensland",
    state: "QLD",
    latitude: -12.5776,
    longitude: 141.9603,
    accuracy: 3
  },
  {
    postalCode: 4874,
    city: "Wenlock",
    state_name: "Queensland",
    state: "QLD",
    latitude: -13.0876,
    longitude: 142.9476,
    accuracy: 4
  },
  {
    postalCode: 4874,
    city: "Trunding",
    state_name: "Queensland",
    state: "QLD",
    latitude: -12.6341,
    longitude: 141.871,
    accuracy: 3
  },
  {
    postalCode: 4874,
    city: "Weipa Airport",
    state_name: "Queensland",
    state: "QLD",
    latitude: -12.5776,
    longitude: 141.9603,
    accuracy: 3
  },
  {
    postalCode: 4874,
    city: "Jardine River",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.913,
    longitude: 145.4479,
    accuracy: 3
  },
  {
    postalCode: 4874,
    city: "Mission River",
    state_name: "Queensland",
    state: "QLD",
    latitude: -12.5951,
    longitude: 141.9576,
    accuracy: 4
  },
  {
    postalCode: 4874,
    city: "Shelburne",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.913,
    longitude: 145.4479,
    accuracy: 3
  },
  {
    postalCode: 4875,
    city: "Prince Of Wales",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.913,
    longitude: 145.4479,
    accuracy: 1
  },
  {
    postalCode: 4875,
    city: "Murray Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.913,
    longitude: 145.4479,
    accuracy: 1
  },
  {
    postalCode: 4875,
    city: "Boigu Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.913,
    longitude: 145.4479,
    accuracy: 1
  },
  {
    postalCode: 4875,
    city: "Badu Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -10.1201,
    longitude: 142.1394,
    accuracy: 1
  },
  {
    postalCode: 4875,
    city: "Dauan Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.913,
    longitude: 145.4479,
    accuracy: 1
  },
  {
    postalCode: 4875,
    city: "Thursday Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -10.5838,
    longitude: 142.2206,
    accuracy: 1
  },
  {
    postalCode: 4875,
    city: "Erub",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.913,
    longitude: 145.4479,
    accuracy: 1
  },
  {
    postalCode: 4875,
    city: "Coconut Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.913,
    longitude: 145.4479,
    accuracy: 1
  },
  {
    postalCode: 4875,
    city: "Yorke Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.913,
    longitude: 145.4479,
    accuracy: 1
  },
  {
    postalCode: 4875,
    city: "Stephens Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.913,
    longitude: 145.4479,
    accuracy: 1
  },
  {
    postalCode: 4875,
    city: "Kubin Village",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.913,
    longitude: 145.4479,
    accuracy: 1
  },
  {
    postalCode: 4875,
    city: "Warraber Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.913,
    longitude: 145.4479,
    accuracy: 1
  },
  {
    postalCode: 4875,
    city: "Horn Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.913,
    longitude: 145.4479,
    accuracy: 1
  },
  {
    postalCode: 4875,
    city: "Saibai Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.913,
    longitude: 145.4479,
    accuracy: 1
  },
  {
    postalCode: 4875,
    city: "Mabuiag Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.913,
    longitude: 145.4479,
    accuracy: 1
  },
  {
    postalCode: 4875,
    city: "Moa Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.913,
    longitude: 145.4479,
    accuracy: 1
  },
  {
    postalCode: 4875,
    city: "Yam Island",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.913,
    longitude: 145.4479,
    accuracy: 1
  },
  {
    postalCode: 4876,
    city: "Umagico",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.913,
    longitude: 145.4479,
    accuracy: 1
  },
  {
    postalCode: 4876,
    city: "New Mapoon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.913,
    longitude: 145.4479,
    accuracy: 1
  },
  {
    postalCode: 4876,
    city: "Seisia",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.913,
    longitude: 145.4479,
    accuracy: 1
  },
  {
    postalCode: 4876,
    city: "Injinoo",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.913,
    longitude: 145.4479,
    accuracy: 1
  },
  {
    postalCode: 4876,
    city: "Bamaga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -10.8517,
    longitude: 142.427,
    accuracy: 1
  },
  {
    postalCode: 4877,
    city: "Oak Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.5976,
    longitude: 145.515,
    accuracy: 4
  },
  {
    postalCode: 4877,
    city: "Mowbray",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.5602,
    longitude: 145.4794,
    accuracy: 4
  },
  {
    postalCode: 4877,
    city: "Craiglie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.5379,
    longitude: 145.4696,
    accuracy: 4
  },
  {
    postalCode: 4877,
    city: "Killaloe",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.4918,
    longitude: 145.4206,
    accuracy: 4
  },
  {
    postalCode: 4877,
    city: "Wangetti",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.6593,
    longitude: 145.5664,
    accuracy: 4
  },
  {
    postalCode: 4877,
    city: "Port Douglas",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.4838,
    longitude: 145.4673,
    accuracy: 4
  },
  {
    postalCode: 4878,
    city: "Machans Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.8585,
    longitude: 145.7447,
    accuracy: 4
  },
  {
    postalCode: 4878,
    city: "Caravonica",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.8666,
    longitude: 145.6784,
    accuracy: 4
  },
  {
    postalCode: 4878,
    city: "Yorkeys Knob",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.8028,
    longitude: 145.7208,
    accuracy: 4
  },
  {
    postalCode: 4878,
    city: "Holloways Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.8421,
    longitude: 145.7392,
    accuracy: 4
  },
  {
    postalCode: 4878,
    city: "Smithfield",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.825,
    longitude: 145.6917,
    accuracy: 4
  },
  {
    postalCode: 4878,
    city: "Barron",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.8367,
    longitude: 145.7022,
    accuracy: 3
  },
  {
    postalCode: 4879,
    city: "Kewarra Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.7822,
    longitude: 145.6845,
    accuracy: 4
  },
  {
    postalCode: 4879,
    city: "Clifton Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.7631,
    longitude: 145.6717,
    accuracy: 4
  },
  {
    postalCode: 4879,
    city: "Ellis Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.7284,
    longitude: 145.6642,
    accuracy: 4
  },
  {
    postalCode: 4879,
    city: "Trinity Beach",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.7888,
    longitude: 145.6968,
    accuracy: 4
  },
  {
    postalCode: 4879,
    city: "Palm Cove",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.75,
    longitude: 145.6667,
    accuracy: 4
  },
  {
    postalCode: 4879,
    city: "Trinity Park",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.8057,
    longitude: 145.7008,
    accuracy: 3
  },
  {
    postalCode: 4880,
    city: "Chewko",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.0667,
    longitude: 145.3833,
    accuracy: 4
  },
  {
    postalCode: 4880,
    city: "Mareeba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.995,
    longitude: 145.4232,
    accuracy: 4
  },
  {
    postalCode: 4880,
    city: "Biboohra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.9333,
    longitude: 145.4167,
    accuracy: 4
  },
  {
    postalCode: 4880,
    city: "Glen Russell",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.9781,
    longitude: 145.3764,
    accuracy: 3
  },
  {
    postalCode: 4880,
    city: "Paddys Green",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.9176,
    longitude: 145.2825,
    accuracy: 4
  },
  {
    postalCode: 4880,
    city: "Arriga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.9781,
    longitude: 145.3764,
    accuracy: 3
  },
  {
    postalCode: 4881,
    city: "Speewah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.8908,
    longitude: 145.6257,
    accuracy: 4
  },
  {
    postalCode: 4881,
    city: "Koah",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.8333,
    longitude: 145.5167,
    accuracy: 4
  },
  {
    postalCode: 4881,
    city: "Kuranda",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.8198,
    longitude: 145.6382,
    accuracy: 4
  },
  {
    postalCode: 4881,
    city: "Mona Mona",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.7126,
    longitude: 145.5368,
    accuracy: 4
  },
  {
    postalCode: 4882,
    city: "Tolga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2333,
    longitude: 145.4833,
    accuracy: 4
  },
  {
    postalCode: 4883,
    city: "Carrington",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.3435,
    longitude: 145.496,
    accuracy: 3
  },
  {
    postalCode: 4883,
    city: "Atherton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2686,
    longitude: 145.4752,
    accuracy: 4
  },
  {
    postalCode: 4883,
    city: "Upper Barron",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.3833,
    longitude: 145.0167,
    accuracy: 4
  },
  {
    postalCode: 4883,
    city: "East Barron",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.3167,
    longitude: 145.5333,
    accuracy: 4
  },
  {
    postalCode: 4883,
    city: "Wongabel",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.3167,
    longitude: 145.4833,
    accuracy: 4
  },
  {
    postalCode: 4884,
    city: "Lake Eacham",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2998,
    longitude: 145.6284,
    accuracy: 4
  },
  {
    postalCode: 4884,
    city: "Yungaburra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2717,
    longitude: 145.5855,
    accuracy: 4
  },
  {
    postalCode: 4884,
    city: "Lake Barrine",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2836,
    longitude: 145.6165,
    accuracy: 3
  },
  {
    postalCode: 4884,
    city: "Gadgarra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.2836,
    longitude: 145.6165,
    accuracy: 3
  },
  {
    postalCode: 4885,
    city: "Peeramon",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.3167,
    longitude: 145.6167,
    accuracy: 4
  },
  {
    postalCode: 4885,
    city: "Topaz",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.4167,
    longitude: 145.7167,
    accuracy: 4
  },
  {
    postalCode: 4885,
    city: "North Johnstone",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.3262,
    longitude: 145.6611,
    accuracy: 4
  },
  {
    postalCode: 4885,
    city: "Malanda",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.3523,
    longitude: 145.5953,
    accuracy: 4
  },
  {
    postalCode: 4885,
    city: "Kureen",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.3333,
    longitude: 145.6,
    accuracy: 4
  },
  {
    postalCode: 4885,
    city: "Glen Allyn",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.3646,
    longitude: 145.631,
    accuracy: 3
  },
  {
    postalCode: 4885,
    city: "Butchers Creek",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.3241,
    longitude: 145.6895,
    accuracy: 4
  },
  {
    postalCode: 4885,
    city: "Tarzali",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.4333,
    longitude: 145.6,
    accuracy: 4
  },
  {
    postalCode: 4885,
    city: "Jaggan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.4,
    longitude: 145.6,
    accuracy: 4
  },
  {
    postalCode: 4886,
    city: "Beatrice",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.4991,
    longitude: 145.5987,
    accuracy: 3
  },
  {
    postalCode: 4886,
    city: "Mungalli",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.4991,
    longitude: 145.5987,
    accuracy: 3
  },
  {
    postalCode: 4886,
    city: "Millaa Millaa",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5139,
    longitude: 145.6129,
    accuracy: 4
  },
  {
    postalCode: 4886,
    city: "Minbun",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.4833,
    longitude: 145.5833,
    accuracy: 4
  },
  {
    postalCode: 4886,
    city: "Moregatta",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5,
    longitude: 145.6,
    accuracy: 4
  },
  {
    postalCode: 4886,
    city: "Maalan",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.4991,
    longitude: 145.5987,
    accuracy: 3
  },
  {
    postalCode: 4886,
    city: "Ellinjaa",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.4991,
    longitude: 145.5987,
    accuracy: 3
  },
  {
    postalCode: 4886,
    city: "Middlebrook",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.4991,
    longitude: 145.5987,
    accuracy: 3
  },
  {
    postalCode: 4887,
    city: "Wondecla",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.4167,
    longitude: 145.4,
    accuracy: 4
  },
  {
    postalCode: 4887,
    city: "Irvinebank",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.4333,
    longitude: 145.2167,
    accuracy: 4
  },
  {
    postalCode: 4887,
    city: "Herberton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.3784,
    longitude: 145.3837,
    accuracy: 4
  },
  {
    postalCode: 4887,
    city: "Watsonville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.3833,
    longitude: 145.3167,
    accuracy: 4
  },
  {
    postalCode: 4887,
    city: "Kalunga",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.45,
    longitude: 145.3833,
    accuracy: 4
  },
  {
    postalCode: 4887,
    city: "Moomin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.3818,
    longitude: 145.2063,
    accuracy: 3
  },
  {
    postalCode: 4888,
    city: "Tumoulin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5667,
    longitude: 145.4667,
    accuracy: 4
  },
  {
    postalCode: 4888,
    city: "Millstream",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.6267,
    longitude: 145.3756,
    accuracy: 4
  },
  {
    postalCode: 4888,
    city: "Ravenshoe",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.6076,
    longitude: 145.4809,
    accuracy: 4
  },
  {
    postalCode: 4888,
    city: "Kaban",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5167,
    longitude: 145.4167,
    accuracy: 4
  },
  {
    postalCode: 4888,
    city: "Evelyn",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.5167,
    longitude: 145.5167,
    accuracy: 4
  },
  {
    postalCode: 4890,
    city: "Normanton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.6718,
    longitude: 141.0772,
    accuracy: 4
  },
  {
    postalCode: 4890,
    city: "Howitt",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.461,
    longitude: 141.1801,
    accuracy: 4
  },
  {
    postalCode: 4891,
    city: "Karumba",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.4869,
    longitude: 140.8426,
    accuracy: 4
  },
  {
    postalCode: 4892,
    city: "Archer River",
    state_name: "Queensland",
    state: "QLD",
    latitude: -13.4384,
    longitude: 142.9403,
    accuracy: 4
  },
  {
    postalCode: 4892,
    city: "Lyndside",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.7071,
    longitude: 145.2665,
    accuracy: 3
  },
  {
    postalCode: 4892,
    city: "Aurukun",
    state_name: "Queensland",
    state: "QLD",
    latitude: -13.6057,
    longitude: 141.8279,
    accuracy: 4
  },
  {
    postalCode: 4892,
    city: "Coen",
    state_name: "Queensland",
    state: "QLD",
    latitude: -13.9456,
    longitude: 143.199,
    accuracy: 4
  },
  {
    postalCode: 4892,
    city: "Wrotham",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.7071,
    longitude: 145.2665,
    accuracy: 3
  },
  {
    postalCode: 4892,
    city: "Lakefield",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.7071,
    longitude: 145.2665,
    accuracy: 3
  },
  {
    postalCode: 4892,
    city: "West Wellesley Islands",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.7071,
    longitude: 145.2665,
    accuracy: 3
  },
  {
    postalCode: 4892,
    city: "Bellevue",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.7071,
    longitude: 145.2665,
    accuracy: 3
  },
  {
    postalCode: 4892,
    city: "Staaten",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.7071,
    longitude: 145.2665,
    accuracy: 3
  },
  {
    postalCode: 4892,
    city: "Highbury",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.7071,
    longitude: 145.2665,
    accuracy: 3
  },
  {
    postalCode: 4892,
    city: "Yagoonya",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.7071,
    longitude: 145.2665,
    accuracy: 3
  },
  {
    postalCode: 4892,
    city: "Lizard",
    state_name: "Queensland",
    state: "QLD",
    latitude: -14.6641,
    longitude: 145.464,
    accuracy: 4
  },
  {
    postalCode: 4892,
    city: "Ravensworth",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.7071,
    longitude: 145.2665,
    accuracy: 3
  },
  {
    postalCode: 4892,
    city: "Yarraden",
    state_name: "Queensland",
    state: "QLD",
    latitude: -14.3019,
    longitude: 143.3133,
    accuracy: 4
  },
  {
    postalCode: 4892,
    city: "Lockhart River",
    state_name: "Queensland",
    state: "QLD",
    latitude: -12.7872,
    longitude: 143.3435,
    accuracy: 4
  },
  {
    postalCode: 4892,
    city: "South Wellesley Islands",
    state_name: "Queensland",
    state: "QLD",
    latitude: -17.0909,
    longitude: 139.5656,
    accuracy: 4
  },
  {
    postalCode: 4892,
    city: "Groganville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.7071,
    longitude: 145.2665,
    accuracy: 3
  },
  {
    postalCode: 4892,
    city: "Mount Mulgrave",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.7071,
    longitude: 145.2665,
    accuracy: 3
  },
  {
    postalCode: 4892,
    city: "Laura",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.5691,
    longitude: 144.4702,
    accuracy: 4
  },
  {
    postalCode: 4892,
    city: "Dixie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.1139,
    longitude: 143.3136,
    accuracy: 4
  },
  {
    postalCode: 4892,
    city: "Kowanyama",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.4736,
    longitude: 141.7457,
    accuracy: 4
  },
  {
    postalCode: 4892,
    city: "Palmer",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.7071,
    longitude: 145.2665,
    accuracy: 3
  },
  {
    postalCode: 4892,
    city: "Wellesley Islands",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.6318,
    longitude: 139.4014,
    accuracy: 4
  },
  {
    postalCode: 4892,
    city: "Gununa",
    state_name: "Queensland",
    state: "QLD",
    latitude: -16.6657,
    longitude: 139.1801,
    accuracy: 4
  },
  {
    postalCode: 4892,
    city: "Pormpuraaw",
    state_name: "Queensland",
    state: "QLD",
    latitude: -14.8988,
    longitude: 141.6212,
    accuracy: 4
  },
  {
    postalCode: 4892,
    city: "Lockhart",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.7071,
    longitude: 145.2665,
    accuracy: 3
  },
  {
    postalCode: 4892,
    city: "Holroyd River",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.7071,
    longitude: 145.2665,
    accuracy: 3
  },
  {
    postalCode: 4892,
    city: "Arbouin",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.7071,
    longitude: 145.2665,
    accuracy: 3
  },
  {
    postalCode: 4892,
    city: "Red River",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.7071,
    longitude: 145.2665,
    accuracy: 3
  },
  {
    postalCode: 4892,
    city: "Maramie",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.7071,
    longitude: 145.2665,
    accuracy: 3
  },
  {
    postalCode: 4892,
    city: "Edward River",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.7071,
    longitude: 145.2665,
    accuracy: 3
  },
  {
    postalCode: 4892,
    city: "Gamboola",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.7071,
    longitude: 145.2665,
    accuracy: 3
  },
  {
    postalCode: 4892,
    city: "Abingdon Downs",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.7071,
    longitude: 145.2665,
    accuracy: 3
  },
  {
    postalCode: 4895,
    city: "Degarra",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.9522,
    longitude: 145.3473,
    accuracy: 4
  },
  {
    postalCode: 4895,
    city: "Hope Vale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.2956,
    longitude: 145.1113,
    accuracy: 4
  },
  {
    postalCode: 4895,
    city: "Wujal Wujal",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.9456,
    longitude: 145.3185,
    accuracy: 4
  },
  {
    postalCode: 4895,
    city: "Cooktown",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.4678,
    longitude: 145.2487,
    accuracy: 4
  },
  {
    postalCode: 4895,
    city: "Ayton",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.9216,
    longitude: 145.3525,
    accuracy: 4
  },
  {
    postalCode: 4895,
    city: "Starcke",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.7071,
    longitude: 145.2665,
    accuracy: 3
  },
  {
    postalCode: 4895,
    city: "Rossville",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.6667,
    longitude: 145.2667,
    accuracy: 4
  },
  {
    postalCode: 4895,
    city: "Bloomfield",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.9333,
    longitude: 145.3333,
    accuracy: 4
  },
  {
    postalCode: 4895,
    city: "Helenvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -15.7167,
    longitude: 145.2333,
    accuracy: 4
  },
  {
    postalCode: 9000,
    city: "Brisbane",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4679,
    longitude: 153.0281,
    accuracy: 4
  },
  {
    postalCode: 9001,
    city: "Brisbane",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4679,
    longitude: 153.0281,
    accuracy: 4
  },
  {
    postalCode: 9002,
    city: "Brisbane",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4679,
    longitude: 153.0281,
    accuracy: 4
  },
  {
    postalCode: 9005,
    city: "Brisbane",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4679,
    longitude: 153.0281,
    accuracy: 4
  },
  {
    postalCode: 9007,
    city: "Brisbane",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4679,
    longitude: 153.0281,
    accuracy: 4
  },
  {
    postalCode: 9008,
    city: "Brisbane",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4679,
    longitude: 153.0281,
    accuracy: 4
  },
  {
    postalCode: 9009,
    city: "Brisbane",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4679,
    longitude: 153.0281,
    accuracy: 4
  },
  {
    postalCode: 9010,
    city: "Brisbane",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4679,
    longitude: 153.0281,
    accuracy: 4
  },
  {
    postalCode: 9013,
    city: "Brisbane",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4679,
    longitude: 153.0281,
    accuracy: 4
  },
  {
    postalCode: 9015,
    city: "Brisbane",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4679,
    longitude: 153.0281,
    accuracy: 4
  },
  {
    postalCode: 9016,
    city: "Brisbane GPO Boxes",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4679,
    longitude: 153.0281,
    accuracy: 1
  },
  {
    postalCode: 9017,
    city: "Brisbane GPO Boxes",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4679,
    longitude: 153.0281,
    accuracy: 1
  },
  {
    postalCode: 9018,
    city: "Brisbane GPO Boxes",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4679,
    longitude: 153.0281,
    accuracy: 1
  },
  {
    postalCode: 9019,
    city: "Brisbane GPO Boxes",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4679,
    longitude: 153.0281,
    accuracy: 1
  },
  {
    postalCode: 9020,
    city: "Brisbane",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4679,
    longitude: 153.0281,
    accuracy: 4
  },
  {
    postalCode: 9021,
    city: "Brisbane GPO Boxes",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4679,
    longitude: 153.0281,
    accuracy: 1
  },
  {
    postalCode: 9022,
    city: "Brisbane GPO Boxes",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4679,
    longitude: 153.0281,
    accuracy: 1
  },
  {
    postalCode: 9023,
    city: "Brisbane GPO Boxes",
    state_name: "Queensland",
    state: "QLD",
    latitude: -27.4679,
    longitude: 153.0281,
    accuracy: 1
  },
  {
    postalCode: 9464,
    city: "Northgate Mc",
    state_name: "Queensland",
    state: "QLD",
    latitude: -33.8816,
    longitude: 150.9844,
    accuracy: null
  },
  {
    postalCode: 9726,
    city: "Gold Coast Mc",
    state_name: "Queensland",
    state: "QLD",
    latitude: -33.8816,
    longitude: 150.9844,
    accuracy: null
  },
  {
    postalCode: 9943,
    city: "Mackay",
    state_name: "Queensland",
    state: "QLD",
    latitude: -21.1534,
    longitude: 149.1655,
    accuracy: 4
  },
  {
    postalCode: 9944,
    city: "Cannonvale",
    state_name: "Queensland",
    state: "QLD",
    latitude: -20.2768,
    longitude: 148.6976,
    accuracy: 4
  },
  {
    postalCode: 872,
    city: "Nyapari",
    state_name: "South Australia",
    state: "SA",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Fregon",
    state_name: "South Australia",
    state: "SA",
    latitude: -26.7639,
    longitude: 132.0277,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Mimili",
    state_name: "South Australia",
    state: "SA",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Indulkana",
    state_name: "South Australia",
    state: "SA",
    latitude: -26.96,
    longitude: 133.3058,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Ernabella",
    state_name: "South Australia",
    state: "SA",
    latitude: -23.7917,
    longitude: 132.6818,
    accuracy: 3
  },
  {
    postalCode: 5000,
    city: "Adelaide",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 4
  },
  {
    postalCode: 5000,
    city: "Rundle Mall",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9286,
    longitude: 138.6007,
    accuracy: 3
  },
  {
    postalCode: 5000,
    city: "Hutt Street",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9286,
    longitude: 138.6007,
    accuracy: 3
  },
  {
    postalCode: 5000,
    city: "Halifax Street",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9286,
    longitude: 138.6007,
    accuracy: 3
  },
  {
    postalCode: 5000,
    city: "Station Arcade",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9286,
    longitude: 138.6007,
    accuracy: 3
  },
  {
    postalCode: 5000,
    city: "Adelaide Bc",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9286,
    longitude: 138.6007,
    accuracy: 3
  },
  {
    postalCode: 5000,
    city: "City West Campus",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 3
  },
  {
    postalCode: 5000,
    city: "Sturt Street",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 3
  },
  {
    postalCode: 5001,
    city: "Adelaide",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 4
  },
  {
    postalCode: 5005,
    city: "University Of Adelaide",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9006,
    longitude: 138.5702,
    accuracy: 1
  },
  {
    postalCode: 5005,
    city: "The University Of Adelaide",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9006,
    longitude: 138.5702,
    accuracy: 1
  },
  {
    postalCode: 5005,
    city: "Adelaide University",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9006,
    longitude: 138.5702,
    accuracy: 1
  },
  {
    postalCode: 5006,
    city: "North Adelaide",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9073,
    longitude: 138.5914,
    accuracy: 4
  },
  {
    postalCode: 5006,
    city: "North Adelaide Melbourne St",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9006,
    longitude: 138.5702,
    accuracy: 3
  },
  {
    postalCode: 5007,
    city: "Welland",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9,
    longitude: 138.5333,
    accuracy: 4
  },
  {
    postalCode: 5007,
    city: "West Hindmarsh",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9079,
    longitude: 138.5641,
    accuracy: 4
  },
  {
    postalCode: 5007,
    city: "Hindmarsh",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9014,
    longitude: 138.575,
    accuracy: 4
  },
  {
    postalCode: 5007,
    city: "Brompton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8944,
    longitude: 138.5782,
    accuracy: 4
  },
  {
    postalCode: 5007,
    city: "Bowden",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9026,
    longitude: 138.5791,
    accuracy: 4
  },
  {
    postalCode: 5008,
    city: "Dudley Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8756,
    longitude: 138.5773,
    accuracy: 4
  },
  {
    postalCode: 5008,
    city: "West Croydon",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8945,
    longitude: 138.5593,
    accuracy: 4
  },
  {
    postalCode: 5008,
    city: "Croydon",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9006,
    longitude: 138.5702,
    accuracy: 3
  },
  {
    postalCode: 5008,
    city: "Devon Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8865,
    longitude: 138.5823,
    accuracy: 4
  },
  {
    postalCode: 5008,
    city: "Renown Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8917,
    longitude: 138.5773,
    accuracy: 4
  },
  {
    postalCode: 5008,
    city: "Ridleyton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8928,
    longitude: 138.5716,
    accuracy: 4
  },
  {
    postalCode: 5008,
    city: "Croydon Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8803,
    longitude: 138.5678,
    accuracy: 4
  },
  {
    postalCode: 5009,
    city: "Kilkenny",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8791,
    longitude: 138.5529,
    accuracy: 4
  },
  {
    postalCode: 5009,
    city: "Beverley",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8951,
    longitude: 138.5463,
    accuracy: 4
  },
  {
    postalCode: 5009,
    city: "Allenby Gardens",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8977,
    longitude: 138.5542,
    accuracy: 4
  },
  {
    postalCode: 5010,
    city: "Regency Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8626,
    longitude: 138.5724,
    accuracy: 4
  },
  {
    postalCode: 5010,
    city: "Regency Park Bc",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8626,
    longitude: 138.5678,
    accuracy: 3
  },
  {
    postalCode: 5010,
    city: "Ferryden Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8662,
    longitude: 138.5618,
    accuracy: 4
  },
  {
    postalCode: 5010,
    city: "Angle Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8599,
    longitude: 138.558,
    accuracy: 4
  },
  {
    postalCode: 5011,
    city: "Woodville Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.887,
    longitude: 138.5465,
    accuracy: 4
  },
  {
    postalCode: 5011,
    city: "St Clair",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8833,
    longitude: 138.55,
    accuracy: 3
  },
  {
    postalCode: 5011,
    city: "Woodville South",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8819,
    longitude: 138.5348,
    accuracy: 4
  },
  {
    postalCode: 5011,
    city: "Woodville West",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8864,
    longitude: 138.5309,
    accuracy: 4
  },
  {
    postalCode: 5011,
    city: "Woodville",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8833,
    longitude: 138.55,
    accuracy: 4
  },
  {
    postalCode: 5012,
    city: "Woodville Gardens",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8679,
    longitude: 138.548,
    accuracy: 4
  },
  {
    postalCode: 5012,
    city: "Mansfield Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8566,
    longitude: 138.5519,
    accuracy: 4
  },
  {
    postalCode: 5012,
    city: "Woodville North",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.872,
    longitude: 138.5431,
    accuracy: 4
  },
  {
    postalCode: 5012,
    city: "Athol Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8561,
    longitude: 138.5428,
    accuracy: 4
  },
  {
    postalCode: 5013,
    city: "Rosewater East",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8391,
    longitude: 138.5496,
    accuracy: 3
  },
  {
    postalCode: 5013,
    city: "Gillman",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8409,
    longitude: 138.5282,
    accuracy: 4
  },
  {
    postalCode: 5013,
    city: "Ottoway",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8476,
    longitude: 138.5357,
    accuracy: 4
  },
  {
    postalCode: 5013,
    city: "Pennington",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8576,
    longitude: 138.5316,
    accuracy: 4
  },
  {
    postalCode: 5013,
    city: "Rosewater",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.852,
    longitude: 138.5216,
    accuracy: 4
  },
  {
    postalCode: 5013,
    city: "Wingfield",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8498,
    longitude: 138.5674,
    accuracy: 4
  },
  {
    postalCode: 5014,
    city: "Cheltenham",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8667,
    longitude: 138.5167,
    accuracy: 4
  },
  {
    postalCode: 5014,
    city: "Queenstown",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8609,
    longitude: 138.5105,
    accuracy: 4
  },
  {
    postalCode: 5014,
    city: "Hendon",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9,
    longitude: 138.5167,
    accuracy: 4
  },
  {
    postalCode: 5014,
    city: "Royal Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8742,
    longitude: 138.5119,
    accuracy: 4
  },
  {
    postalCode: 5014,
    city: "Albert Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.872,
    longitude: 138.5197,
    accuracy: 4
  },
  {
    postalCode: 5014,
    city: "Alberton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8593,
    longitude: 138.5214,
    accuracy: 4
  },
  {
    postalCode: 5015,
    city: "Port Adelaide",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.85,
    longitude: 138.4667,
    accuracy: 4
  },
  {
    postalCode: 5015,
    city: "Ethelton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8487,
    longitude: 138.491,
    accuracy: 4
  },
  {
    postalCode: 5015,
    city: "Glanville",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8462,
    longitude: 138.4898,
    accuracy: 4
  },
  {
    postalCode: 5015,
    city: "New Port",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8417,
    longitude: 138.4833,
    accuracy: 3
  },
  {
    postalCode: 5015,
    city: "Birkenhead",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8368,
    longitude: 138.4979,
    accuracy: 4
  },
  {
    postalCode: 5015,
    city: "Port Adelaide DC",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8417,
    longitude: 138.4833,
    accuracy: 3
  },
  {
    postalCode: 5016,
    city: "Peterhead",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8336,
    longitude: 138.491,
    accuracy: 4
  },
  {
    postalCode: 5016,
    city: "Largs North",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8205,
    longitude: 138.4924,
    accuracy: 4
  },
  {
    postalCode: 5016,
    city: "Largs Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8258,
    longitude: 138.4862,
    accuracy: 4
  },
  {
    postalCode: 5017,
    city: "Osborne",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.798,
    longitude: 138.498,
    accuracy: 4
  },
  {
    postalCode: 5017,
    city: "Taperoo",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8043,
    longitude: 138.4959,
    accuracy: 4
  },
  {
    postalCode: 5018,
    city: "Outer Harbor",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7766,
    longitude: 138.4874,
    accuracy: 4
  },
  {
    postalCode: 5018,
    city: "North Haven",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7883,
    longitude: 138.4916,
    accuracy: 4
  },
  {
    postalCode: 5019,
    city: "Semaphore",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8393,
    longitude: 138.4823,
    accuracy: 4
  },
  {
    postalCode: 5019,
    city: "Semaphore Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8507,
    longitude: 138.4789,
    accuracy: 4
  },
  {
    postalCode: 5019,
    city: "Semaphore South",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8498,
    longitude: 138.4795,
    accuracy: 4
  },
  {
    postalCode: 5019,
    city: "Exeter",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8399,
    longitude: 138.489,
    accuracy: 4
  },
  {
    postalCode: 5020,
    city: "West Lakes Shore",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8601,
    longitude: 138.4897,
    accuracy: 4
  },
  {
    postalCode: 5021,
    city: "West Lakes",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.873,
    longitude: 138.4946,
    accuracy: 4
  },
  {
    postalCode: 5022,
    city: "Henley Beach South",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9259,
    longitude: 138.4955,
    accuracy: 4
  },
  {
    postalCode: 5022,
    city: "Henley Beach",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9203,
    longitude: 138.4944,
    accuracy: 4
  },
  {
    postalCode: 5022,
    city: "Tennyson",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.886,
    longitude: 138.4859,
    accuracy: 4
  },
  {
    postalCode: 5022,
    city: "Grange",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9022,
    longitude: 138.4902,
    accuracy: 4
  },
  {
    postalCode: 5023,
    city: "Seaton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9,
    longitude: 138.5167,
    accuracy: 4
  },
  {
    postalCode: 5023,
    city: "Findon",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9,
    longitude: 138.5333,
    accuracy: 4
  },
  {
    postalCode: 5024,
    city: "West Beach",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.946,
    longitude: 138.5093,
    accuracy: 4
  },
  {
    postalCode: 5024,
    city: "Fulham",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9274,
    longitude: 138.5137,
    accuracy: 4
  },
  {
    postalCode: 5024,
    city: "Fulham Gardens",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9148,
    longitude: 138.5132,
    accuracy: 4
  },
  {
    postalCode: 5025,
    city: "Flinders Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9103,
    longitude: 138.5432,
    accuracy: 4
  },
  {
    postalCode: 5025,
    city: "Kidman Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9122,
    longitude: 138.5269,
    accuracy: 4
  },
  {
    postalCode: 5031,
    city: "Torrensville Plaza",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9441,
    longitude: 138.5648,
    accuracy: 3
  },
  {
    postalCode: 5031,
    city: "Mile End",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9265,
    longitude: 138.5703,
    accuracy: 4
  },
  {
    postalCode: 5031,
    city: "Torrensville",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9106,
    longitude: 138.5605,
    accuracy: 4
  },
  {
    postalCode: 5031,
    city: "Mile End South",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9378,
    longitude: 138.5704,
    accuracy: 4
  },
  {
    postalCode: 5031,
    city: "Thebarton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9167,
    longitude: 138.5667,
    accuracy: 4
  },
  {
    postalCode: 5032,
    city: "Lockleys",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9259,
    longitude: 138.528,
    accuracy: 4
  },
  {
    postalCode: 5032,
    city: "Brooklyn Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9285,
    longitude: 138.5363,
    accuracy: 4
  },
  {
    postalCode: 5032,
    city: "Underdale",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.918,
    longitude: 138.547,
    accuracy: 4
  },
  {
    postalCode: 5033,
    city: "Marleston",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9476,
    longitude: 138.5596,
    accuracy: 4
  },
  {
    postalCode: 5033,
    city: "Hilton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.932,
    longitude: 138.5643,
    accuracy: 4
  },
  {
    postalCode: 5033,
    city: "Marleston DC",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9355,
    longitude: 138.5617,
    accuracy: 3
  },
  {
    postalCode: 5033,
    city: "Cowandilla",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9322,
    longitude: 138.5593,
    accuracy: 4
  },
  {
    postalCode: 5033,
    city: "West Richmond",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9387,
    longitude: 138.5521,
    accuracy: 4
  },
  {
    postalCode: 5033,
    city: "Hilton Plaza",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9441,
    longitude: 138.5648,
    accuracy: 3
  },
  {
    postalCode: 5033,
    city: "Richmond",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.942,
    longitude: 138.5632,
    accuracy: 4
  },
  {
    postalCode: 5034,
    city: "Wayville",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.95,
    longitude: 138.5833,
    accuracy: 4
  },
  {
    postalCode: 5034,
    city: "Millswood",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.955,
    longitude: 138.5889,
    accuracy: 4
  },
  {
    postalCode: 5034,
    city: "Goodwood",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9509,
    longitude: 138.5923,
    accuracy: 4
  },
  {
    postalCode: 5034,
    city: "Kings Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9638,
    longitude: 138.5909,
    accuracy: 4
  },
  {
    postalCode: 5034,
    city: "Clarence Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9642,
    longitude: 138.5806,
    accuracy: 4
  },
  {
    postalCode: 5035,
    city: "Black Forest",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9603,
    longitude: 138.5767,
    accuracy: 4
  },
  {
    postalCode: 5035,
    city: "Keswick",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9418,
    longitude: 138.5746,
    accuracy: 4
  },
  {
    postalCode: 5035,
    city: "Forestville",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9495,
    longitude: 138.5785,
    accuracy: 4
  },
  {
    postalCode: 5035,
    city: "Ashford",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9486,
    longitude: 138.5746,
    accuracy: 4
  },
  {
    postalCode: 5035,
    city: "Everard Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.952,
    longitude: 138.5748,
    accuracy: 4
  },
  {
    postalCode: 5035,
    city: "Keswick Terminal",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9411,
    longitude: 138.5804,
    accuracy: 4
  },
  {
    postalCode: 5037,
    city: "Kurralta Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9514,
    longitude: 138.567,
    accuracy: 4
  },
  {
    postalCode: 5037,
    city: "North Plympton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9577,
    longitude: 138.5534,
    accuracy: 4
  },
  {
    postalCode: 5037,
    city: "Netley",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9489,
    longitude: 138.5498,
    accuracy: 4
  },
  {
    postalCode: 5037,
    city: "Glandore",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9615,
    longitude: 138.5683,
    accuracy: 4
  },
  {
    postalCode: 5038,
    city: "Camden Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9686,
    longitude: 138.5396,
    accuracy: 4
  },
  {
    postalCode: 5038,
    city: "Plympton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.95,
    longitude: 138.55,
    accuracy: 4
  },
  {
    postalCode: 5038,
    city: "Plympton Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9809,
    longitude: 138.547,
    accuracy: 4
  },
  {
    postalCode: 5038,
    city: "South Plympton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9768,
    longitude: 138.5559,
    accuracy: 4
  },
  {
    postalCode: 5039,
    city: "Melrose Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9833,
    longitude: 138.5754,
    accuracy: 4
  },
  {
    postalCode: 5039,
    city: "Clarence Gardens",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9754,
    longitude: 138.5798,
    accuracy: 4
  },
  {
    postalCode: 5039,
    city: "Edwardstown",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9802,
    longitude: 138.5694,
    accuracy: 4
  },
  {
    postalCode: 5039,
    city: "Melrose Park DC",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9827,
    longitude: 138.5741,
    accuracy: 3
  },
  {
    postalCode: 5040,
    city: "Novar Gardens",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9733,
    longitude: 138.5383,
    accuracy: 4
  },
  {
    postalCode: 5041,
    city: "Cumberland Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.972,
    longitude: 138.5867,
    accuracy: 4
  },
  {
    postalCode: 5041,
    city: "Westbourne Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9716,
    longitude: 138.5952,
    accuracy: 4
  },
  {
    postalCode: 5041,
    city: "Daw Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9898,
    longitude: 138.5841,
    accuracy: 4
  },
  {
    postalCode: 5041,
    city: "Panorama",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9908,
    longitude: 138.5995,
    accuracy: 4
  },
  {
    postalCode: 5041,
    city: "Colonel Light Gardens",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9863,
    longitude: 138.5975,
    accuracy: 4
  },
  {
    postalCode: 5042,
    city: "St Marys",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0042,
    longitude: 138.5798,
    accuracy: 4
  },
  {
    postalCode: 5042,
    city: "Bedford Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0333,
    longitude: 138.5667,
    accuracy: 4
  },
  {
    postalCode: 5042,
    city: "Pasadena",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0027,
    longitude: 138.5886,
    accuracy: 4
  },
  {
    postalCode: 5042,
    city: "Clovelly Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9995,
    longitude: 138.5708,
    accuracy: 4
  },
  {
    postalCode: 5042,
    city: "Flinders University",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0069,
    longitude: 138.5513,
    accuracy: 3
  },
  {
    postalCode: 5043,
    city: "Morphettville",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9871,
    longitude: 138.544,
    accuracy: 4
  },
  {
    postalCode: 5043,
    city: "Marion",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0167,
    longitude: 138.5667,
    accuracy: 4
  },
  {
    postalCode: 5043,
    city: "Mitchell Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0051,
    longitude: 138.5623,
    accuracy: 4
  },
  {
    postalCode: 5043,
    city: "Park Holme",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9888,
    longitude: 138.552,
    accuracy: 4
  },
  {
    postalCode: 5043,
    city: "Ascot Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9881,
    longitude: 138.561,
    accuracy: 4
  },
  {
    postalCode: 5044,
    city: "Somerton Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9971,
    longitude: 138.5215,
    accuracy: 4
  },
  {
    postalCode: 5044,
    city: "Glengowrie",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9871,
    longitude: 138.5367,
    accuracy: 4
  },
  {
    postalCode: 5045,
    city: "Glenelg Jetty Road",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9833,
    longitude: 138.5167,
    accuracy: 3
  },
  {
    postalCode: 5045,
    city: "Glenelg East",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9764,
    longitude: 138.5296,
    accuracy: 4
  },
  {
    postalCode: 5045,
    city: "Glenelg North",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9679,
    longitude: 138.5175,
    accuracy: 4
  },
  {
    postalCode: 5045,
    city: "Glenelg South",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9808,
    longitude: 138.515,
    accuracy: 3
  },
  {
    postalCode: 5045,
    city: "Glenelg",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9808,
    longitude: 138.515,
    accuracy: 4
  },
  {
    postalCode: 5046,
    city: "Oaklands Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0141,
    longitude: 138.5384,
    accuracy: 4
  },
  {
    postalCode: 5046,
    city: "Warradale North",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0069,
    longitude: 138.5513,
    accuracy: 3
  },
  {
    postalCode: 5046,
    city: "Warradale",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0074,
    longitude: 138.5356,
    accuracy: 4
  },
  {
    postalCode: 5047,
    city: "Seacombe Heights",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0326,
    longitude: 138.5458,
    accuracy: 4
  },
  {
    postalCode: 5047,
    city: "Seacombe Gardens",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0234,
    longitude: 138.5458,
    accuracy: 4
  },
  {
    postalCode: 5047,
    city: "Darlington",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0333,
    longitude: 138.5667,
    accuracy: 4
  },
  {
    postalCode: 5047,
    city: "Sturt",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0167,
    longitude: 138.55,
    accuracy: 4
  },
  {
    postalCode: 5048,
    city: "South Brighton",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0277,
    longitude: 138.528,
    accuracy: 4
  },
  {
    postalCode: 5048,
    city: "North Brighton",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0037,
    longitude: 138.5218,
    accuracy: 4
  },
  {
    postalCode: 5048,
    city: "Brighton",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0182,
    longitude: 138.5235,
    accuracy: 4
  },
  {
    postalCode: 5048,
    city: "Hove",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0112,
    longitude: 138.523,
    accuracy: 4
  },
  {
    postalCode: 5048,
    city: "Dover Gardens",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.024,
    longitude: 138.537,
    accuracy: 4
  },
  {
    postalCode: 5049,
    city: "Seacliff Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0298,
    longitude: 138.5313,
    accuracy: 4
  },
  {
    postalCode: 5049,
    city: "Seaview Downs",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.037,
    longitude: 138.538,
    accuracy: 4
  },
  {
    postalCode: 5049,
    city: "Kingston Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0382,
    longitude: 138.5163,
    accuracy: 4
  },
  {
    postalCode: 5049,
    city: "Marino",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0447,
    longitude: 138.5124,
    accuracy: 4
  },
  {
    postalCode: 5049,
    city: "Seacliff",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0347,
    longitude: 138.5229,
    accuracy: 4
  },
  {
    postalCode: 5050,
    city: "Eden Hills",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0211,
    longitude: 138.5957,
    accuracy: 4
  },
  {
    postalCode: 5050,
    city: "Bellevue Heights",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0302,
    longitude: 138.5831,
    accuracy: 4
  },
  {
    postalCode: 5051,
    city: "Blackwood",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0214,
    longitude: 138.6143,
    accuracy: 4
  },
  {
    postalCode: 5051,
    city: "Coromandel Valley",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.05,
    longitude: 138.6167,
    accuracy: 4
  },
  {
    postalCode: 5051,
    city: "Hawthorndene",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0223,
    longitude: 138.6304,
    accuracy: 4
  },
  {
    postalCode: 5051,
    city: "Craigburn Farm",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.05,
    longitude: 138.6167,
    accuracy: 4
  },
  {
    postalCode: 5052,
    city: "Belair",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9977,
    longitude: 138.6208,
    accuracy: 4
  },
  {
    postalCode: 5052,
    city: "Glenalta",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0079,
    longitude: 138.6259,
    accuracy: 4
  },
  {
    postalCode: 5061,
    city: "Malvern",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9592,
    longitude: 138.6125,
    accuracy: 4
  },
  {
    postalCode: 5061,
    city: "Unley DC",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9546,
    longitude: 138.6063,
    accuracy: 3
  },
  {
    postalCode: 5061,
    city: "Unley Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9639,
    longitude: 138.6078,
    accuracy: 4
  },
  {
    postalCode: 5061,
    city: "Unley BC",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9546,
    longitude: 138.6063,
    accuracy: 3
  },
  {
    postalCode: 5061,
    city: "Unley",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.95,
    longitude: 138.6,
    accuracy: 4
  },
  {
    postalCode: 5061,
    city: "Hyde Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9547,
    longitude: 138.6011,
    accuracy: 4
  },
  {
    postalCode: 5062,
    city: "Kingswood",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9671,
    longitude: 138.6077,
    accuracy: 4
  },
  {
    postalCode: 5062,
    city: "Hawthorn",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9738,
    longitude: 138.6074,
    accuracy: 4
  },
  {
    postalCode: 5062,
    city: "Netherby",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9705,
    longitude: 138.625,
    accuracy: 4
  },
  {
    postalCode: 5062,
    city: "Brown Hill Creek",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9868,
    longitude: 138.6421,
    accuracy: 4
  },
  {
    postalCode: 5062,
    city: "Springfield",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9782,
    longitude: 138.6325,
    accuracy: 4
  },
  {
    postalCode: 5062,
    city: "Lower Mitcham",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9773,
    longitude: 138.6049,
    accuracy: 4
  },
  {
    postalCode: 5062,
    city: "Mitcham",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9789,
    longitude: 138.6218,
    accuracy: 4
  },
  {
    postalCode: 5062,
    city: "Torrens Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9761,
    longitude: 138.6103,
    accuracy: 4
  },
  {
    postalCode: 5062,
    city: "Clapham",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9899,
    longitude: 138.6016,
    accuracy: 4
  },
  {
    postalCode: 5062,
    city: "Mitcham Shopping Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9788,
    longitude: 138.6166,
    accuracy: 3
  },
  {
    postalCode: 5062,
    city: "Lynton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9973,
    longitude: 138.6074,
    accuracy: 4
  },
  {
    postalCode: 5063,
    city: "Parkside",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9451,
    longitude: 138.613,
    accuracy: 4
  },
  {
    postalCode: 5063,
    city: "Frewville",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9476,
    longitude: 138.6306,
    accuracy: 4
  },
  {
    postalCode: 5063,
    city: "Eastwood",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9423,
    longitude: 138.6218,
    accuracy: 4
  },
  {
    postalCode: 5063,
    city: "Fullarton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.951,
    longitude: 138.629,
    accuracy: 4
  },
  {
    postalCode: 5063,
    city: "Highgate",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9618,
    longitude: 138.6218,
    accuracy: 4
  },
  {
    postalCode: 5064,
    city: "Mount Osmond",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9629,
    longitude: 138.6566,
    accuracy: 4
  },
  {
    postalCode: 5064,
    city: "Urrbrae",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9663,
    longitude: 138.6422,
    accuracy: 4
  },
  {
    postalCode: 5064,
    city: "Glen Osmond",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9596,
    longitude: 138.6487,
    accuracy: 4
  },
  {
    postalCode: 5064,
    city: "Myrtle Bank",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9606,
    longitude: 138.6338,
    accuracy: 4
  },
  {
    postalCode: 5064,
    city: "St Georges",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.952,
    longitude: 138.6479,
    accuracy: 4
  },
  {
    postalCode: 5064,
    city: "Glenunga",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9501,
    longitude: 138.6384,
    accuracy: 4
  },
  {
    postalCode: 5065,
    city: "Linden Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9473,
    longitude: 138.6529,
    accuracy: 4
  },
  {
    postalCode: 5065,
    city: "Tusmore",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9389,
    longitude: 138.6506,
    accuracy: 4
  },
  {
    postalCode: 5065,
    city: "Dulwich",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9365,
    longitude: 138.6272,
    accuracy: 4
  },
  {
    postalCode: 5065,
    city: "Glenside",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9427,
    longitude: 138.6338,
    accuracy: 4
  },
  {
    postalCode: 5065,
    city: "Toorak Gardens",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9348,
    longitude: 138.6364,
    accuracy: 4
  },
  {
    postalCode: 5066,
    city: "Stonyfell",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9342,
    longitude: 138.6767,
    accuracy: 4
  },
  {
    postalCode: 5066,
    city: "Burnside",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9383,
    longitude: 138.6673,
    accuracy: 3
  },
  {
    postalCode: 5066,
    city: "Erindale",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9278,
    longitude: 138.6631,
    accuracy: 4
  },
  {
    postalCode: 5066,
    city: "Beaumont",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.949,
    longitude: 138.6619,
    accuracy: 4
  },
  {
    postalCode: 5066,
    city: "Waterfall Gully",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9667,
    longitude: 138.679,
    accuracy: 4
  },
  {
    postalCode: 5066,
    city: "Wattle Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9252,
    longitude: 138.675,
    accuracy: 4
  },
  {
    postalCode: 5066,
    city: "Hazelwood Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9395,
    longitude: 138.6588,
    accuracy: 4
  },
  {
    postalCode: 5067,
    city: "Beulah Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9177,
    longitude: 138.6452,
    accuracy: 4
  },
  {
    postalCode: 5067,
    city: "Rose Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9276,
    longitude: 138.626,
    accuracy: 4
  },
  {
    postalCode: 5067,
    city: "Norwood",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9273,
    longitude: 138.6285,
    accuracy: 4
  },
  {
    postalCode: 5067,
    city: "Kent Town",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9216,
    longitude: 138.6201,
    accuracy: 4
  },
  {
    postalCode: 5067,
    city: "Norwood South",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9167,
    longitude: 138.65,
    accuracy: 3
  },
  {
    postalCode: 5068,
    city: "Kensington Gardens",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9258,
    longitude: 138.6615,
    accuracy: 4
  },
  {
    postalCode: 5068,
    city: "Heathpool",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9314,
    longitude: 138.6463,
    accuracy: 4
  },
  {
    postalCode: 5068,
    city: "Marryatville",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9284,
    longitude: 138.646,
    accuracy: 4
  },
  {
    postalCode: 5068,
    city: "Leabrook",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9298,
    longitude: 138.6586,
    accuracy: 4
  },
  {
    postalCode: 5068,
    city: "Kensington Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9202,
    longitude: 138.6543,
    accuracy: 4
  },
  {
    postalCode: 5068,
    city: "Trinity Gardens",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9144,
    longitude: 138.6414,
    accuracy: 4
  },
  {
    postalCode: 5068,
    city: "St Morris",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9111,
    longitude: 138.6536,
    accuracy: 4
  },
  {
    postalCode: 5068,
    city: "Kensington",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9167,
    longitude: 138.65,
    accuracy: 4
  },
  {
    postalCode: 5069,
    city: "Stepney",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9123,
    longitude: 138.6292,
    accuracy: 4
  },
  {
    postalCode: 5069,
    city: "College Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9117,
    longitude: 138.6198,
    accuracy: 4
  },
  {
    postalCode: 5069,
    city: "St Peters",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.905,
    longitude: 138.6225,
    accuracy: 4
  },
  {
    postalCode: 5069,
    city: "Hackney",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9139,
    longitude: 138.6164,
    accuracy: 4
  },
  {
    postalCode: 5069,
    city: "Evandale",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9055,
    longitude: 138.6354,
    accuracy: 4
  },
  {
    postalCode: 5069,
    city: "Maylands",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9113,
    longitude: 138.6367,
    accuracy: 4
  },
  {
    postalCode: 5070,
    city: "Payneham",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8972,
    longitude: 138.6406,
    accuracy: 4
  },
  {
    postalCode: 5070,
    city: "Glynde DC",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8988,
    longitude: 138.6447,
    accuracy: 3
  },
  {
    postalCode: 5070,
    city: "Royston Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9004,
    longitude: 138.6361,
    accuracy: 4
  },
  {
    postalCode: 5070,
    city: "Glynde Plaza",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8994,
    longitude: 138.6696,
    accuracy: 3
  },
  {
    postalCode: 5070,
    city: "Felixstow",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.889,
    longitude: 138.647,
    accuracy: 4
  },
  {
    postalCode: 5070,
    city: "Joslin",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8997,
    longitude: 138.6265,
    accuracy: 4
  },
  {
    postalCode: 5070,
    city: "Glynde",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.896,
    longitude: 138.6525,
    accuracy: 4
  },
  {
    postalCode: 5070,
    city: "Firle",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9046,
    longitude: 138.6532,
    accuracy: 4
  },
  {
    postalCode: 5070,
    city: "Marden",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8957,
    longitude: 138.6378,
    accuracy: 4
  },
  {
    postalCode: 5070,
    city: "Payneham South",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9048,
    longitude: 138.6445,
    accuracy: 4
  },
  {
    postalCode: 5071,
    city: "Kent Town DC",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9216,
    longitude: 138.6201,
    accuracy: 3
  },
  {
    postalCode: 5071,
    city: "Kent Town",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9216,
    longitude: 138.6201,
    accuracy: 4
  },
  {
    postalCode: 5072,
    city: "Magill South",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9091,
    longitude: 138.675,
    accuracy: 4
  },
  {
    postalCode: 5072,
    city: "Rosslyn Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9219,
    longitude: 138.6755,
    accuracy: 4
  },
  {
    postalCode: 5072,
    city: "Skye",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9245,
    longitude: 138.6928,
    accuracy: 4
  },
  {
    postalCode: 5072,
    city: "Magill",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9091,
    longitude: 138.675,
    accuracy: 4
  },
  {
    postalCode: 5072,
    city: "Auldana",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.918,
    longitude: 138.6869,
    accuracy: 4
  },
  {
    postalCode: 5072,
    city: "Woodforde",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9051,
    longitude: 138.6896,
    accuracy: 4
  },
  {
    postalCode: 5072,
    city: "Magill North",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8994,
    longitude: 138.6696,
    accuracy: 3
  },
  {
    postalCode: 5072,
    city: "Teringie",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9143,
    longitude: 138.7023,
    accuracy: 4
  },
  {
    postalCode: 5073,
    city: "Tranmere",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9055,
    longitude: 138.6621,
    accuracy: 4
  },
  {
    postalCode: 5073,
    city: "Tranmere North",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8994,
    longitude: 138.6696,
    accuracy: 3
  },
  {
    postalCode: 5073,
    city: "Rostrevor",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8939,
    longitude: 138.6918,
    accuracy: 4
  },
  {
    postalCode: 5073,
    city: "Hectorville",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8916,
    longitude: 138.6589,
    accuracy: 4
  },
  {
    postalCode: 5074,
    city: "Newton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8821,
    longitude: 138.6825,
    accuracy: 4
  },
  {
    postalCode: 5074,
    city: "Campbelltown",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8833,
    longitude: 138.6667,
    accuracy: 4
  },
  {
    postalCode: 5075,
    city: "Paradise",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8736,
    longitude: 138.669,
    accuracy: 4
  },
  {
    postalCode: 5075,
    city: "Dernancourt",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.862,
    longitude: 138.6766,
    accuracy: 4
  },
  {
    postalCode: 5076,
    city: "Athelstone",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8702,
    longitude: 138.6999,
    accuracy: 4
  },
  {
    postalCode: 5076,
    city: "Castambul",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8715,
    longitude: 138.7055,
    accuracy: 3
  },
  {
    postalCode: 5081,
    city: "Gilberton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9005,
    longitude: 138.6126,
    accuracy: 4
  },
  {
    postalCode: 5081,
    city: "Vale Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.886,
    longitude: 138.6271,
    accuracy: 4
  },
  {
    postalCode: 5081,
    city: "Medindie",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.896,
    longitude: 138.605,
    accuracy: 4
  },
  {
    postalCode: 5081,
    city: "Walkerville",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8711,
    longitude: 138.6232,
    accuracy: 3
  },
  {
    postalCode: 5081,
    city: "Collinswood",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8873,
    longitude: 138.6122,
    accuracy: 4
  },
  {
    postalCode: 5081,
    city: "Medindie Gardens",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8909,
    longitude: 138.6039,
    accuracy: 4
  },
  {
    postalCode: 5082,
    city: "Fitzroy",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8968,
    longitude: 138.5914,
    accuracy: 4
  },
  {
    postalCode: 5082,
    city: "Prospect East",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8845,
    longitude: 138.5925,
    accuracy: 3
  },
  {
    postalCode: 5082,
    city: "Ovingham",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8986,
    longitude: 138.5852,
    accuracy: 4
  },
  {
    postalCode: 5082,
    city: "Thorngate",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8978,
    longitude: 138.5983,
    accuracy: 4
  },
  {
    postalCode: 5082,
    city: "Prospect",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8824,
    longitude: 138.5933,
    accuracy: 4
  },
  {
    postalCode: 5083,
    city: "Broadview",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8759,
    longitude: 138.615,
    accuracy: 4
  },
  {
    postalCode: 5083,
    city: "Sefton Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.874,
    longitude: 138.6034,
    accuracy: 4
  },
  {
    postalCode: 5083,
    city: "Nailsworth",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8844,
    longitude: 138.6062,
    accuracy: 4
  },
  {
    postalCode: 5084,
    city: "Kilburn North",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8595,
    longitude: 138.59,
    accuracy: 3
  },
  {
    postalCode: 5084,
    city: "Kilburn",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8597,
    longitude: 138.5856,
    accuracy: 4
  },
  {
    postalCode: 5084,
    city: "Blair Athol",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8589,
    longitude: 138.5966,
    accuracy: 4
  },
  {
    postalCode: 5085,
    city: "Northgate",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8578,
    longitude: 138.6291,
    accuracy: 4
  },
  {
    postalCode: 5085,
    city: "Northfield",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.85,
    longitude: 138.6333,
    accuracy: 4
  },
  {
    postalCode: 5085,
    city: "Clearview",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8573,
    longitude: 138.6133,
    accuracy: 4
  },
  {
    postalCode: 5085,
    city: "Enfield",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8526,
    longitude: 138.6026,
    accuracy: 4
  },
  {
    postalCode: 5085,
    city: "Enfield Plaza",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8711,
    longitude: 138.6232,
    accuracy: 3
  },
  {
    postalCode: 5086,
    city: "Oakden",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8528,
    longitude: 138.6433,
    accuracy: 4
  },
  {
    postalCode: 5086,
    city: "Manningham",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8711,
    longitude: 138.6232,
    accuracy: 3
  },
  {
    postalCode: 5086,
    city: "Gilles Plains",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.85,
    longitude: 138.65,
    accuracy: 4
  },
  {
    postalCode: 5086,
    city: "Greenacres",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8685,
    longitude: 138.628,
    accuracy: 4
  },
  {
    postalCode: 5086,
    city: "Hillcrest",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8625,
    longitude: 138.6431,
    accuracy: 4
  },
  {
    postalCode: 5086,
    city: "Hampstead Gardens",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8745,
    longitude: 138.6288,
    accuracy: 4
  },
  {
    postalCode: 5087,
    city: "Windsor Gardens",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8654,
    longitude: 138.647,
    accuracy: 4
  },
  {
    postalCode: 5087,
    city: "Klemzig",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8793,
    longitude: 138.6356,
    accuracy: 4
  },
  {
    postalCode: 5088,
    city: "Holden Hill",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8516,
    longitude: 138.6723,
    accuracy: 4
  },
  {
    postalCode: 5089,
    city: "Highbury",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8529,
    longitude: 138.6975,
    accuracy: 4
  },
  {
    postalCode: 5090,
    city: "Hope Valley",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8333,
    longitude: 138.7,
    accuracy: 4
  },
  {
    postalCode: 5091,
    city: "Tea Tree Gully",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8216,
    longitude: 138.7353,
    accuracy: 3
  },
  {
    postalCode: 5091,
    city: "Vista",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8355,
    longitude: 138.7232,
    accuracy: 4
  },
  {
    postalCode: 5091,
    city: "Banksia Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8102,
    longitude: 138.7357,
    accuracy: 4
  },
  {
    postalCode: 5092,
    city: "Modbury North DC",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8333,
    longitude: 138.6833,
    accuracy: 3
  },
  {
    postalCode: 5092,
    city: "Modbury",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8333,
    longitude: 138.6833,
    accuracy: 4
  },
  {
    postalCode: 5092,
    city: "Modbury North",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8285,
    longitude: 138.6739,
    accuracy: 4
  },
  {
    postalCode: 5092,
    city: "Modbury Heights",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8097,
    longitude: 138.6854,
    accuracy: 4
  },
  {
    postalCode: 5093,
    city: "Valley View",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8399,
    longitude: 138.6607,
    accuracy: 4
  },
  {
    postalCode: 5093,
    city: "Para Vista",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8209,
    longitude: 138.6611,
    accuracy: 4
  },
  {
    postalCode: 5094,
    city: "Gepps Cross",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8415,
    longitude: 138.5956,
    accuracy: 4
  },
  {
    postalCode: 5094,
    city: "Dry Creek",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8281,
    longitude: 138.5547,
    accuracy: 4
  },
  {
    postalCode: 5094,
    city: "Cavan",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8291,
    longitude: 138.5985,
    accuracy: 4
  },
  {
    postalCode: 5095,
    city: "Pooraka",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8247,
    longitude: 138.6264,
    accuracy: 4
  },
  {
    postalCode: 5095,
    city: "The Levels",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8149,
    longitude: 138.6162,
    accuracy: 3
  },
  {
    postalCode: 5095,
    city: "Mawson Lakes",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8159,
    longitude: 138.6081,
    accuracy: 4
  },
  {
    postalCode: 5096,
    city: "Para Hills West",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8047,
    longitude: 138.6428,
    accuracy: 4
  },
  {
    postalCode: 5096,
    city: "Para Hills",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8121,
    longitude: 138.658,
    accuracy: 4
  },
  {
    postalCode: 5096,
    city: "Gulfview Heights",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7955,
    longitude: 138.6694,
    accuracy: 4
  },
  {
    postalCode: 5097,
    city: "Redwood Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8116,
    longitude: 138.7069,
    accuracy: 4
  },
  {
    postalCode: 5097,
    city: "St Agnes",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8308,
    longitude: 138.7107,
    accuracy: 4
  },
  {
    postalCode: 5097,
    city: "Ridgehaven",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8213,
    longitude: 138.7047,
    accuracy: 4
  },
  {
    postalCode: 5098,
    city: "Ingle Farm",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8333,
    longitude: 138.6333,
    accuracy: 4
  },
  {
    postalCode: 5098,
    city: "Walkley Heights",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8367,
    longitude: 138.6437,
    accuracy: 4
  },
  {
    postalCode: 5106,
    city: "Parafield",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.789,
    longitude: 138.6374,
    accuracy: 4
  },
  {
    postalCode: 5106,
    city: "Salisbury South DC",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7746,
    longitude: 138.6221,
    accuracy: 3
  },
  {
    postalCode: 5106,
    city: "Salisbury South",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7805,
    longitude: 138.648,
    accuracy: 4
  },
  {
    postalCode: 5106,
    city: "Salisbury South BC",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7746,
    longitude: 138.6221,
    accuracy: 3
  },
  {
    postalCode: 5107,
    city: "Parafield Gardens",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7825,
    longitude: 138.6108,
    accuracy: 4
  },
  {
    postalCode: 5107,
    city: "Green Fields",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8006,
    longitude: 138.6067,
    accuracy: 4
  },
  {
    postalCode: 5108,
    city: "Salisbury",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7667,
    longitude: 138.6333,
    accuracy: 4
  },
  {
    postalCode: 5108,
    city: "Salisbury North Whites Road",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7619,
    longitude: 138.6208,
    accuracy: 3
  },
  {
    postalCode: 5108,
    city: "Paralowie",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7571,
    longitude: 138.6082,
    accuracy: 4
  },
  {
    postalCode: 5108,
    city: "Salisbury Downs",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7677,
    longitude: 138.6221,
    accuracy: 4
  },
  {
    postalCode: 5108,
    city: "Salisbury North",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7496,
    longitude: 138.6206,
    accuracy: 4
  },
  {
    postalCode: 5109,
    city: "Salisbury East Northbri Ave",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7874,
    longitude: 138.6417,
    accuracy: 3
  },
  {
    postalCode: 5109,
    city: "Salisbury Plain",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7726,
    longitude: 138.6633,
    accuracy: 4
  },
  {
    postalCode: 5109,
    city: "Salisbury East",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7905,
    longitude: 138.6545,
    accuracy: 4
  },
  {
    postalCode: 5109,
    city: "Salisbury Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7615,
    longitude: 138.6703,
    accuracy: 4
  },
  {
    postalCode: 5109,
    city: "Salisbury Heights",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7631,
    longitude: 138.6759,
    accuracy: 4
  },
  {
    postalCode: 5109,
    city: "Brahma Lodge",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.776,
    longitude: 138.6531,
    accuracy: 4
  },
  {
    postalCode: 5110,
    city: "Direk",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7216,
    longitude: 138.6015,
    accuracy: 4
  },
  {
    postalCode: 5110,
    city: "Globe Derby Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7876,
    longitude: 138.5898,
    accuracy: 4
  },
  {
    postalCode: 5110,
    city: "Waterloo Corner",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7167,
    longitude: 138.5833,
    accuracy: 4
  },
  {
    postalCode: 5110,
    city: "St Kilda",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7556,
    longitude: 138.5696,
    accuracy: 3
  },
  {
    postalCode: 5110,
    city: "Bolivar",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7667,
    longitude: 138.6,
    accuracy: 4
  },
  {
    postalCode: 5110,
    city: "Burton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7334,
    longitude: 138.6025,
    accuracy: 4
  },
  {
    postalCode: 5111,
    city: "Edinburgh",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7462,
    longitude: 138.6375,
    accuracy: 4
  },
  {
    postalCode: 5111,
    city: "Edinburgh Raaf",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6697,
    longitude: 138.6878,
    accuracy: 3
  },
  {
    postalCode: 5112,
    city: "Elizabeth Vale",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7486,
    longitude: 138.6682,
    accuracy: 4
  },
  {
    postalCode: 5112,
    city: "Hillbank",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7359,
    longitude: 138.6872,
    accuracy: 4
  },
  {
    postalCode: 5112,
    city: "Elizabeth South",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7318,
    longitude: 138.6619,
    accuracy: 4
  },
  {
    postalCode: 5112,
    city: "Elizabeth Grove",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7353,
    longitude: 138.6689,
    accuracy: 4
  },
  {
    postalCode: 5112,
    city: "Elizabeth",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7194,
    longitude: 138.6771,
    accuracy: 4
  },
  {
    postalCode: 5112,
    city: "Elizabeth East",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7251,
    longitude: 138.6821,
    accuracy: 4
  },
  {
    postalCode: 5113,
    city: "Elizabeth Downs",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6998,
    longitude: 138.6913,
    accuracy: 4
  },
  {
    postalCode: 5113,
    city: "Davoren Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6906,
    longitude: 138.6686,
    accuracy: 4
  },
  {
    postalCode: 5113,
    city: "Elizabeth West",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7009,
    longitude: 138.678,
    accuracy: 3
  },
  {
    postalCode: 5113,
    city: "Davoren Park South",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6906,
    longitude: 138.6686,
    accuracy: 4
  },
  {
    postalCode: 5113,
    city: "Elizabeth Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7097,
    longitude: 138.686,
    accuracy: 4
  },
  {
    postalCode: 5113,
    city: "Elizabeth North",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7068,
    longitude: 138.6761,
    accuracy: 4
  },
  {
    postalCode: 5113,
    city: "Elizabeth West DC",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6906,
    longitude: 138.6686,
    accuracy: 3
  },
  {
    postalCode: 5113,
    city: "Edinburgh North",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6906,
    longitude: 138.6686,
    accuracy: 3
  },
  {
    postalCode: 5114,
    city: "One Tree Hill",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7,
    longitude: 138.7667,
    accuracy: 4
  },
  {
    postalCode: 5114,
    city: "Smithfield",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6833,
    longitude: 138.6833,
    accuracy: 4
  },
  {
    postalCode: 5114,
    city: "Smithfield West",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6646,
    longitude: 138.6807,
    accuracy: 4
  },
  {
    postalCode: 5114,
    city: "Sampson Flat",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7287,
    longitude: 138.7801,
    accuracy: 4
  },
  {
    postalCode: 5114,
    city: "Uleybury",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6763,
    longitude: 138.7459,
    accuracy: 4
  },
  {
    postalCode: 5114,
    city: "Gould Creek",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7424,
    longitude: 138.7087,
    accuracy: 4
  },
  {
    postalCode: 5114,
    city: "Andrews Farm",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6763,
    longitude: 138.662,
    accuracy: 4
  },
  {
    postalCode: 5114,
    city: "Humbug Scrub",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7409,
    longitude: 138.8116,
    accuracy: 4
  },
  {
    postalCode: 5114,
    city: "Smithfield Plains",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6764,
    longitude: 138.6779,
    accuracy: 4
  },
  {
    postalCode: 5114,
    city: "Yattalunga",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6847,
    longitude: 138.8037,
    accuracy: 4
  },
  {
    postalCode: 5114,
    city: "Blakeview",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6757,
    longitude: 138.7101,
    accuracy: 4
  },
  {
    postalCode: 5114,
    city: "Craigmore",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7006,
    longitude: 138.7096,
    accuracy: 4
  },
  {
    postalCode: 5115,
    city: "Munno Para",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6679,
    longitude: 138.7015,
    accuracy: 4
  },
  {
    postalCode: 5115,
    city: "Kudla",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6423,
    longitude: 138.7018,
    accuracy: 4
  },
  {
    postalCode: 5115,
    city: "Munno Para West",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6646,
    longitude: 138.6807,
    accuracy: 4
  },
  {
    postalCode: 5115,
    city: "Munno Para Downs",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6557,
    longitude: 138.6812,
    accuracy: 4
  },
  {
    postalCode: 5116,
    city: "Evanston",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6166,
    longitude: 138.7337,
    accuracy: 4
  },
  {
    postalCode: 5116,
    city: "Evanston Gardens",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6232,
    longitude: 138.7217,
    accuracy: 4
  },
  {
    postalCode: 5116,
    city: "Hillier",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6309,
    longitude: 138.6682,
    accuracy: 4
  },
  {
    postalCode: 5116,
    city: "Evanston Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6228,
    longitude: 138.7412,
    accuracy: 4
  },
  {
    postalCode: 5116,
    city: "Evanston South",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6483,
    longitude: 138.7178,
    accuracy: 4
  },
  {
    postalCode: 5117,
    city: "Angle Vale",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.641,
    longitude: 138.6461,
    accuracy: 4
  },
  {
    postalCode: 5118,
    city: "Kingsford",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5862,
    longitude: 138.7137,
    accuracy: 3
  },
  {
    postalCode: 5118,
    city: "Gawler",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6025,
    longitude: 138.749,
    accuracy: 4
  },
  {
    postalCode: 5118,
    city: "Kalbeeba",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.625,
    longitude: 138.7928,
    accuracy: 4
  },
  {
    postalCode: 5118,
    city: "Concordia",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5748,
    longitude: 138.8051,
    accuracy: 4
  },
  {
    postalCode: 5118,
    city: "Gawler East",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5989,
    longitude: 138.7632,
    accuracy: 4
  },
  {
    postalCode: 5118,
    city: "Willaston",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5833,
    longitude: 138.75,
    accuracy: 4
  },
  {
    postalCode: 5118,
    city: "Hewett",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.578,
    longitude: 138.7524,
    accuracy: 4
  },
  {
    postalCode: 5118,
    city: "Gawler River",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6144,
    longitude: 138.6564,
    accuracy: 4
  },
  {
    postalCode: 5118,
    city: "Reid",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5913,
    longitude: 138.7397,
    accuracy: 3
  },
  {
    postalCode: 5118,
    city: "Gawler West",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6044,
    longitude: 138.7325,
    accuracy: 4
  },
  {
    postalCode: 5118,
    city: "Gawler South",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6071,
    longitude: 138.7445,
    accuracy: 4
  },
  {
    postalCode: 5118,
    city: "Kangaroo Flat",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.55,
    longitude: 138.7,
    accuracy: 4
  },
  {
    postalCode: 5118,
    city: "Bibaringa",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6337,
    longitude: 138.766,
    accuracy: 4
  },
  {
    postalCode: 5118,
    city: "Ward Belt",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5789,
    longitude: 138.6683,
    accuracy: 4
  },
  {
    postalCode: 5118,
    city: "Gawler Belt",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5862,
    longitude: 138.7137,
    accuracy: 3
  },
  {
    postalCode: 5118,
    city: "Buchfelde",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5862,
    longitude: 138.7137,
    accuracy: 3
  },
  {
    postalCode: 5120,
    city: "Virginia",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6663,
    longitude: 138.5603,
    accuracy: 4
  },
  {
    postalCode: 5120,
    city: "Buckland Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6853,
    longitude: 138.5417,
    accuracy: 4
  },
  {
    postalCode: 5121,
    city: "Penfield",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7,
    longitude: 138.6333,
    accuracy: 4
  },
  {
    postalCode: 5121,
    city: "Penfield Gardens",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6522,
    longitude: 138.6329,
    accuracy: 4
  },
  {
    postalCode: 5121,
    city: "Macdonald Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6584,
    longitude: 138.6439,
    accuracy: 4
  },
  {
    postalCode: 5125,
    city: "Golden Grove",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7833,
    longitude: 138.7333,
    accuracy: 4
  },
  {
    postalCode: 5125,
    city: "Golden Grove Village",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7689,
    longitude: 138.735,
    accuracy: 3
  },
  {
    postalCode: 5125,
    city: "Greenwith",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7657,
    longitude: 138.7138,
    accuracy: 4
  },
  {
    postalCode: 5126,
    city: "Fairview Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8,
    longitude: 138.7286,
    accuracy: 4
  },
  {
    postalCode: 5126,
    city: "Yatala Vale",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7945,
    longitude: 138.7303,
    accuracy: 4
  },
  {
    postalCode: 5126,
    city: "Surrey Downs",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7995,
    longitude: 138.7115,
    accuracy: 4
  },
  {
    postalCode: 5127,
    city: "Wynn Vale",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7994,
    longitude: 138.6871,
    accuracy: 4
  },
  {
    postalCode: 5131,
    city: "Houghton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8287,
    longitude: 138.7615,
    accuracy: 4
  },
  {
    postalCode: 5131,
    city: "Upper Hermitage",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7964,
    longitude: 138.7589,
    accuracy: 4
  },
  {
    postalCode: 5131,
    city: "Lower Hermitage",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7942,
    longitude: 138.7798,
    accuracy: 3
  },
  {
    postalCode: 5132,
    city: "Paracombe",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8488,
    longitude: 138.78,
    accuracy: 4
  },
  {
    postalCode: 5133,
    city: "Inglewood",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.824,
    longitude: 138.7739,
    accuracy: 4
  },
  {
    postalCode: 5134,
    city: "Montacute",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.888,
    longitude: 138.7491,
    accuracy: 4
  },
  {
    postalCode: 5134,
    city: "Cherryville",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.912,
    longitude: 138.7657,
    accuracy: 4
  },
  {
    postalCode: 5136,
    city: "Norton Summit",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9229,
    longitude: 138.7249,
    accuracy: 4
  },
  {
    postalCode: 5137,
    city: "Ashton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9395,
    longitude: 138.7371,
    accuracy: 4
  },
  {
    postalCode: 5137,
    city: "Marble Hill",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9395,
    longitude: 138.7371,
    accuracy: 3
  },
  {
    postalCode: 5138,
    city: "Basket Range",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9398,
    longitude: 138.765,
    accuracy: 4
  },
  {
    postalCode: 5139,
    city: "Forest Range",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.928,
    longitude: 138.807,
    accuracy: 4
  },
  {
    postalCode: 5140,
    city: "Greenhill",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9499,
    longitude: 138.6917,
    accuracy: 4
  },
  {
    postalCode: 5141,
    city: "Summertown",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9595,
    longitude: 138.7313,
    accuracy: 4
  },
  {
    postalCode: 5141,
    city: "Horsnell Gully",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9351,
    longitude: 138.7044,
    accuracy: 4
  },
  {
    postalCode: 5142,
    city: "Uraidla",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.956,
    longitude: 138.7444,
    accuracy: 4
  },
  {
    postalCode: 5144,
    city: "Carey Gully",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9647,
    longitude: 138.7618,
    accuracy: 4
  },
  {
    postalCode: 5150,
    city: "Leawood Gardens",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9741,
    longitude: 138.6734,
    accuracy: 4
  },
  {
    postalCode: 5150,
    city: "Eagle On The Hill",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0887,
    longitude: 138.6997,
    accuracy: 3
  },
  {
    postalCode: 5151,
    city: "Piccadilly",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9778,
    longitude: 138.7302,
    accuracy: 4
  },
  {
    postalCode: 5152,
    city: "Stirling",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0152,
    longitude: 138.7364,
    accuracy: 4
  },
  {
    postalCode: 5152,
    city: "Crafers",
    state_name: "South Australia",
    state: "SA",
    latitude: -35,
    longitude: 138.7,
    accuracy: 4
  },
  {
    postalCode: 5152,
    city: "Cleland",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0076,
    longitude: 138.7182,
    accuracy: 3
  },
  {
    postalCode: 5152,
    city: "Crafers West",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9914,
    longitude: 138.6821,
    accuracy: 4
  },
  {
    postalCode: 5153,
    city: "Longwood",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.05,
    longitude: 138.7167,
    accuracy: 4
  },
  {
    postalCode: 5153,
    city: "Scott Creek",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0575,
    longitude: 138.7052,
    accuracy: 4
  },
  {
    postalCode: 5153,
    city: "Jupiter Creek",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1379,
    longitude: 138.758,
    accuracy: 4
  },
  {
    postalCode: 5153,
    city: "Bradbury",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0608,
    longitude: 138.7251,
    accuracy: 4
  },
  {
    postalCode: 5153,
    city: "Macclesfield",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1718,
    longitude: 138.8359,
    accuracy: 4
  },
  {
    postalCode: 5153,
    city: "Echunga",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1035,
    longitude: 138.7959,
    accuracy: 4
  },
  {
    postalCode: 5153,
    city: "Mylor",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.043,
    longitude: 138.759,
    accuracy: 4
  },
  {
    postalCode: 5153,
    city: "Biggs Flat",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0667,
    longitude: 138.7833,
    accuracy: 4
  },
  {
    postalCode: 5153,
    city: "Chapel Hill",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0842,
    longitude: 138.7582,
    accuracy: 3
  },
  {
    postalCode: 5153,
    city: "Ironbank",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.05,
    longitude: 138.6833,
    accuracy: 4
  },
  {
    postalCode: 5153,
    city: "Heathfield",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0167,
    longitude: 138.7167,
    accuracy: 4
  },
  {
    postalCode: 5153,
    city: "Flaxley",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1333,
    longitude: 138.8167,
    accuracy: 4
  },
  {
    postalCode: 5153,
    city: "Green Hills Range",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0842,
    longitude: 138.7582,
    accuracy: 3
  },
  {
    postalCode: 5154,
    city: "Aldgate",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0167,
    longitude: 138.7333,
    accuracy: 4
  },
  {
    postalCode: 5155,
    city: "Mount George",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0037,
    longitude: 138.7637,
    accuracy: 3
  },
  {
    postalCode: 5155,
    city: "Bridgewater",
    state_name: "South Australia",
    state: "SA",
    latitude: -35,
    longitude: 138.75,
    accuracy: 4
  },
  {
    postalCode: 5156,
    city: "Upper Sturt",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0167,
    longitude: 138.6833,
    accuracy: 4
  },
  {
    postalCode: 5157,
    city: "Dorset Vale",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0873,
    longitude: 138.6764,
    accuracy: 4
  },
  {
    postalCode: 5157,
    city: "Clarendon",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1167,
    longitude: 138.6333,
    accuracy: 4
  },
  {
    postalCode: 5157,
    city: "Cherry Gardens",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0634,
    longitude: 138.6629,
    accuracy: 4
  },
  {
    postalCode: 5157,
    city: "Kangarilla",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1488,
    longitude: 138.6604,
    accuracy: 4
  },
  {
    postalCode: 5157,
    city: "Bull Creek",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2333,
    longitude: 138.75,
    accuracy: 4
  },
  {
    postalCode: 5157,
    city: "Ashbourne",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2873,
    longitude: 138.7668,
    accuracy: 4
  },
  {
    postalCode: 5157,
    city: "Coromandel East",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0477,
    longitude: 138.6419,
    accuracy: 4
  },
  {
    postalCode: 5157,
    city: "Mcharg Creek",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.273,
    longitude: 138.7361,
    accuracy: 4
  },
  {
    postalCode: 5158,
    city: "Sheidow Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0793,
    longitude: 138.5274,
    accuracy: 4
  },
  {
    postalCode: 5158,
    city: "O'Halloran Hill DC",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.073,
    longitude: 138.5387,
    accuracy: 3
  },
  {
    postalCode: 5158,
    city: "Hallett Cove",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0792,
    longitude: 138.5146,
    accuracy: 4
  },
  {
    postalCode: 5158,
    city: "O'Halloran Hill",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0667,
    longitude: 138.55,
    accuracy: 4
  },
  {
    postalCode: 5158,
    city: "Trott Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0758,
    longitude: 138.5419,
    accuracy: 4
  },
  {
    postalCode: 5159,
    city: "Happy Valley",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0833,
    longitude: 138.5333,
    accuracy: 4
  },
  {
    postalCode: 5159,
    city: "Chandlers Hill",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0865,
    longitude: 138.6169,
    accuracy: 4
  },
  {
    postalCode: 5159,
    city: "Flagstaff Hill",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0486,
    longitude: 138.5828,
    accuracy: 4
  },
  {
    postalCode: 5159,
    city: "Aberfoyle Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0768,
    longitude: 138.5916,
    accuracy: 4
  },
  {
    postalCode: 5160,
    city: "Lonsdale DC",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1068,
    longitude: 138.4929,
    accuracy: 3
  },
  {
    postalCode: 5160,
    city: "Lonsdale",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1068,
    longitude: 138.4929,
    accuracy: 4
  },
  {
    postalCode: 5161,
    city: "Reynella",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0937,
    longitude: 138.5308,
    accuracy: 4
  },
  {
    postalCode: 5161,
    city: "Reynella East",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.092,
    longitude: 138.5574,
    accuracy: 4
  },
  {
    postalCode: 5161,
    city: "Old Reynella",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1035,
    longitude: 138.5336,
    accuracy: 4
  },
  {
    postalCode: 5162,
    city: "Morphett Vale",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1333,
    longitude: 138.5167,
    accuracy: 4
  },
  {
    postalCode: 5162,
    city: "Woodcroft",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1024,
    longitude: 138.5629,
    accuracy: 4
  },
  {
    postalCode: 5163,
    city: "Huntfield Heights",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1545,
    longitude: 138.5142,
    accuracy: 4
  },
  {
    postalCode: 5163,
    city: "Onkaparinga Hills",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1351,
    longitude: 138.567,
    accuracy: 4
  },
  {
    postalCode: 5163,
    city: "Hackham West",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1431,
    longitude: 138.5144,
    accuracy: 4
  },
  {
    postalCode: 5163,
    city: "Hackham",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.15,
    longitude: 138.5167,
    accuracy: 4
  },
  {
    postalCode: 5164,
    city: "Christie Downs",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.13,
    longitude: 138.4963,
    accuracy: 4
  },
  {
    postalCode: 5165,
    city: "Christies Beach",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1388,
    longitude: 138.4723,
    accuracy: 4
  },
  {
    postalCode: 5165,
    city: "Christies Beach North",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1451,
    longitude: 138.5038,
    accuracy: 3
  },
  {
    postalCode: 5166,
    city: "O'Sullivan Beach",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1188,
    longitude: 138.4734,
    accuracy: 4
  },
  {
    postalCode: 5167,
    city: "Port Noarlunga",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.148,
    longitude: 138.471,
    accuracy: 4
  },
  {
    postalCode: 5167,
    city: "Port Noarlunga South",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.174,
    longitude: 138.4686,
    accuracy: 4
  },
  {
    postalCode: 5168,
    city: "Old Noarlunga",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1821,
    longitude: 138.5014,
    accuracy: 4
  },
  {
    postalCode: 5168,
    city: "Noarlunga Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1821,
    longitude: 138.5014,
    accuracy: 4
  },
  {
    postalCode: 5168,
    city: "Noarlunga Downs",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1504,
    longitude: 138.504,
    accuracy: 4
  },
  {
    postalCode: 5169,
    city: "Seaford Heights",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1988,
    longitude: 138.4909,
    accuracy: 4
  },
  {
    postalCode: 5169,
    city: "Moana",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1939,
    longitude: 138.4761,
    accuracy: 4
  },
  {
    postalCode: 5169,
    city: "Seaford Meadows",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1728,
    longitude: 138.4879,
    accuracy: 4
  },
  {
    postalCode: 5169,
    city: "Seaford",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1898,
    longitude: 138.4759,
    accuracy: 4
  },
  {
    postalCode: 5169,
    city: "Seaford Rise",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.193,
    longitude: 138.4817,
    accuracy: 4
  },
  {
    postalCode: 5170,
    city: "Maslin Beach",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2259,
    longitude: 138.4798,
    accuracy: 4
  },
  {
    postalCode: 5171,
    city: "Blewitt Springs",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2178,
    longitude: 138.5633,
    accuracy: 3
  },
  {
    postalCode: 5171,
    city: "Mclaren Vale",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2189,
    longitude: 138.5433,
    accuracy: 4
  },
  {
    postalCode: 5171,
    city: "Tatachilla",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2369,
    longitude: 138.5071,
    accuracy: 4
  },
  {
    postalCode: 5171,
    city: "Mclaren Flat",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2167,
    longitude: 138.5833,
    accuracy: 4
  },
  {
    postalCode: 5171,
    city: "Pedler Creek",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.202,
    longitude: 138.566,
    accuracy: 3
  },
  {
    postalCode: 5172,
    city: "Hope Forest",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2833,
    longitude: 138.6167,
    accuracy: 4
  },
  {
    postalCode: 5172,
    city: "Willunga",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2713,
    longitude: 138.5542,
    accuracy: 4
  },
  {
    postalCode: 5172,
    city: "Yundi",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.3167,
    longitude: 138.6333,
    accuracy: 4
  },
  {
    postalCode: 5172,
    city: "Willunga Hill",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2751,
    longitude: 138.6196,
    accuracy: 3
  },
  {
    postalCode: 5172,
    city: "Dingabledinga",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2672,
    longitude: 138.6291,
    accuracy: 4
  },
  {
    postalCode: 5172,
    city: "Willunga South",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2838,
    longitude: 138.5548,
    accuracy: 4
  },
  {
    postalCode: 5172,
    city: "The Range",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2463,
    longitude: 138.6228,
    accuracy: 4
  },
  {
    postalCode: 5172,
    city: "Pages Flat",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2751,
    longitude: 138.6196,
    accuracy: 3
  },
  {
    postalCode: 5172,
    city: "Kuitpo Colony",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2876,
    longitude: 138.6963,
    accuracy: 4
  },
  {
    postalCode: 5172,
    city: "Montarra",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2667,
    longitude: 138.6167,
    accuracy: 4
  },
  {
    postalCode: 5172,
    city: "Kyeema",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2763,
    longitude: 138.6731,
    accuracy: 4
  },
  {
    postalCode: 5172,
    city: "Whites Valley",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2711,
    longitude: 138.5221,
    accuracy: 4
  },
  {
    postalCode: 5173,
    city: "Port Willunga",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2779,
    longitude: 138.4523,
    accuracy: 4
  },
  {
    postalCode: 5173,
    city: "Aldinga",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2833,
    longitude: 138.4833,
    accuracy: 4
  },
  {
    postalCode: 5173,
    city: "Aldinga Beach",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2783,
    longitude: 138.458,
    accuracy: 4
  },
  {
    postalCode: 5174,
    city: "Sellicks Hill",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.3296,
    longitude: 138.4742,
    accuracy: 4
  },
  {
    postalCode: 5174,
    city: "Sellicks Beach",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.3387,
    longitude: 138.4473,
    accuracy: 4
  },
  {
    postalCode: 5201,
    city: "Kuitpo",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2266,
    longitude: 138.6861,
    accuracy: 4
  },
  {
    postalCode: 5201,
    city: "Meadows",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1802,
    longitude: 138.7625,
    accuracy: 4
  },
  {
    postalCode: 5201,
    city: "Prospect Hill",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2333,
    longitude: 138.7167,
    accuracy: 4
  },
  {
    postalCode: 5201,
    city: "Blackfellows Creek",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2159,
    longitude: 138.7406,
    accuracy: 3
  },
  {
    postalCode: 5201,
    city: "Paris Creek",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2094,
    longitude: 138.7955,
    accuracy: 4
  },
  {
    postalCode: 5202,
    city: "Hindmarsh Tiers",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.4,
    longitude: 138.45,
    accuracy: 3
  },
  {
    postalCode: 5202,
    city: "Myponga",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.404,
    longitude: 138.4712,
    accuracy: 4
  },
  {
    postalCode: 5202,
    city: "Myponga Beach",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.3738,
    longitude: 138.387,
    accuracy: 4
  },
  {
    postalCode: 5203,
    city: "Bald Hills",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.5167,
    longitude: 138.4167,
    accuracy: 4
  },
  {
    postalCode: 5203,
    city: "Yankalilla",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.4571,
    longitude: 138.3498,
    accuracy: 4
  },
  {
    postalCode: 5203,
    city: "Wattle Flat",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.428,
    longitude: 138.3897,
    accuracy: 4
  },
  {
    postalCode: 5203,
    city: "Parawa",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.4851,
    longitude: 138.3791,
    accuracy: 3
  },
  {
    postalCode: 5203,
    city: "Tunkalilla",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.4851,
    longitude: 138.3791,
    accuracy: 3
  },
  {
    postalCode: 5203,
    city: "Torrens Vale",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.5167,
    longitude: 138.3667,
    accuracy: 4
  },
  {
    postalCode: 5204,
    city: "Normanville",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.4477,
    longitude: 138.317,
    accuracy: 4
  },
  {
    postalCode: 5204,
    city: "Rapid Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.5251,
    longitude: 138.1893,
    accuracy: 4
  },
  {
    postalCode: 5204,
    city: "Second Valley",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.5311,
    longitude: 138.2269,
    accuracy: 4
  },
  {
    postalCode: 5204,
    city: "Wirrina Cove",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.5225,
    longitude: 138.232,
    accuracy: 3
  },
  {
    postalCode: 5204,
    city: "Delamere",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.5833,
    longitude: 138.1833,
    accuracy: 4
  },
  {
    postalCode: 5204,
    city: "Hay Flat",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.5225,
    longitude: 138.232,
    accuracy: 3
  },
  {
    postalCode: 5204,
    city: "Carrickalinga",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.4275,
    longitude: 138.3244,
    accuracy: 4
  },
  {
    postalCode: 5204,
    city: "Silverton",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.5225,
    longitude: 138.232,
    accuracy: 3
  },
  {
    postalCode: 5204,
    city: "Cape Jervis",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.6034,
    longitude: 138.1032,
    accuracy: 4
  },
  {
    postalCode: 5204,
    city: "Deep Creek",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.5225,
    longitude: 138.232,
    accuracy: 3
  },
  {
    postalCode: 5210,
    city: "Mount Compass",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.3469,
    longitude: 138.6203,
    accuracy: 4
  },
  {
    postalCode: 5210,
    city: "Mount Magnificent",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.3484,
    longitude: 138.6518,
    accuracy: 3
  },
  {
    postalCode: 5210,
    city: "Nangkita",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.3455,
    longitude: 138.6865,
    accuracy: 4
  },
  {
    postalCode: 5211,
    city: "Lower Inman Valley",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.516,
    longitude: 138.5679,
    accuracy: 4
  },
  {
    postalCode: 5211,
    city: "Inman Valley",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.4938,
    longitude: 138.4563,
    accuracy: 4
  },
  {
    postalCode: 5211,
    city: "Waitpinga",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.5744,
    longitude: 138.5826,
    accuracy: 4
  },
  {
    postalCode: 5211,
    city: "Encounter Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.5742,
    longitude: 138.6005,
    accuracy: 4
  },
  {
    postalCode: 5211,
    city: "Hayborough",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.5313,
    longitude: 138.6504,
    accuracy: 4
  },
  {
    postalCode: 5211,
    city: "Back Valley",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.5453,
    longitude: 138.5896,
    accuracy: 4
  },
  {
    postalCode: 5211,
    city: "Willow Creek",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.5417,
    longitude: 138.5839,
    accuracy: 3
  },
  {
    postalCode: 5211,
    city: "Hindmarsh Valley",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.5167,
    longitude: 138.6167,
    accuracy: 4
  },
  {
    postalCode: 5211,
    city: "Mount Jagged",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.5417,
    longitude: 138.5839,
    accuracy: 3
  },
  {
    postalCode: 5211,
    city: "Mccracken",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.5358,
    longitude: 138.6312,
    accuracy: 4
  },
  {
    postalCode: 5211,
    city: "Victor Harbor",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.5504,
    longitude: 138.6215,
    accuracy: 4
  },
  {
    postalCode: 5212,
    city: "Port Elliot",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.5302,
    longitude: 138.6792,
    accuracy: 4
  },
  {
    postalCode: 5213,
    city: "Middleton",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.5105,
    longitude: 138.7038,
    accuracy: 4
  },
  {
    postalCode: 5214,
    city: "Hindmarsh Island",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.5101,
    longitude: 138.8676,
    accuracy: 4
  },
  {
    postalCode: 5214,
    city: "Mosquito Hill",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.502,
    longitude: 138.7849,
    accuracy: 3
  },
  {
    postalCode: 5214,
    city: "Goolwa Beach",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.5047,
    longitude: 138.7732,
    accuracy: 4
  },
  {
    postalCode: 5214,
    city: "Currency Creek",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.45,
    longitude: 138.7667,
    accuracy: 4
  },
  {
    postalCode: 5214,
    city: "Goolwa",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.5016,
    longitude: 138.7819,
    accuracy: 4
  },
  {
    postalCode: 5214,
    city: "Mundoo Island",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.5509,
    longitude: 138.9148,
    accuracy: 4
  },
  {
    postalCode: 5214,
    city: "Goolwa South",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.5148,
    longitude: 138.7813,
    accuracy: 4
  },
  {
    postalCode: 5214,
    city: "Goolwa North",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.4912,
    longitude: 138.8126,
    accuracy: 4
  },
  {
    postalCode: 5220,
    city: "Parndana",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.7853,
    longitude: 137.2571,
    accuracy: 4
  },
  {
    postalCode: 5221,
    city: "American River",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.7725,
    longitude: 137.7783,
    accuracy: 4
  },
  {
    postalCode: 5221,
    city: "Ballast Head",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.7717,
    longitude: 137.7804,
    accuracy: 4
  },
  {
    postalCode: 5221,
    city: "Muston",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.7897,
    longitude: 137.757,
    accuracy: 4
  },
  {
    postalCode: 5222,
    city: "Kangaroo Head",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.7717,
    longitude: 137.7804,
    accuracy: 4
  },
  {
    postalCode: 5222,
    city: "Island Beach",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.7975,
    longitude: 137.7987,
    accuracy: 4
  },
  {
    postalCode: 5222,
    city: "Penneshaw",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.7333,
    longitude: 137.9333,
    accuracy: 4
  },
  {
    postalCode: 5222,
    city: "Pelican Lagoon",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.807,
    longitude: 137.8039,
    accuracy: 4
  },
  {
    postalCode: 5222,
    city: "Brown Beach",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.7984,
    longitude: 137.8378,
    accuracy: 4
  },
  {
    postalCode: 5222,
    city: "Sapphiretown",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.7907,
    longitude: 137.781,
    accuracy: 4
  },
  {
    postalCode: 5222,
    city: "Baudin Beach",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.7765,
    longitude: 137.8729,
    accuracy: 4
  },
  {
    postalCode: 5222,
    city: "Dudley West",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.7661,
    longitude: 137.8681,
    accuracy: 3
  },
  {
    postalCode: 5222,
    city: "Ironstone",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.7661,
    longitude: 137.8681,
    accuracy: 3
  },
  {
    postalCode: 5222,
    city: "Antechamber Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.7661,
    longitude: 137.8681,
    accuracy: 3
  },
  {
    postalCode: 5222,
    city: "Cuttlefish Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.7661,
    longitude: 137.8681,
    accuracy: 3
  },
  {
    postalCode: 5222,
    city: "Dudley East",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.7661,
    longitude: 137.8681,
    accuracy: 3
  },
  {
    postalCode: 5222,
    city: "Willson River",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.7661,
    longitude: 137.8681,
    accuracy: 3
  },
  {
    postalCode: 5222,
    city: "American Beach",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.7661,
    longitude: 137.8681,
    accuracy: 3
  },
  {
    postalCode: 5222,
    city: "Porky Flat",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.7661,
    longitude: 137.8681,
    accuracy: 3
  },
  {
    postalCode: 5222,
    city: "Willoughby",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.7661,
    longitude: 137.8681,
    accuracy: 3
  },
  {
    postalCode: 5223,
    city: "North Cape",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.5808,
    longitude: 137.595,
    accuracy: 4
  },
  {
    postalCode: 5223,
    city: "D'Estrees Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.928,
    longitude: 137.5742,
    accuracy: 4
  },
  {
    postalCode: 5223,
    city: "Kingscote",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.6559,
    longitude: 137.6393,
    accuracy: 4
  },
  {
    postalCode: 5223,
    city: "Newland",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.8717,
    longitude: 137.1212,
    accuracy: 4
  },
  {
    postalCode: 5223,
    city: "Seddon",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.8359,
    longitude: 137.2923,
    accuracy: 4
  },
  {
    postalCode: 5223,
    city: "Emu Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.5984,
    longitude: 137.5059,
    accuracy: 4
  },
  {
    postalCode: 5223,
    city: "Vivonne Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.9826,
    longitude: 137.1771,
    accuracy: 4
  },
  {
    postalCode: 5223,
    city: "Kohinoor",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.6801,
    longitude: 137.5345,
    accuracy: 3
  },
  {
    postalCode: 5223,
    city: "Brownlow Ki",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.6714,
    longitude: 137.6071,
    accuracy: 4
  },
  {
    postalCode: 5223,
    city: "Bay Of Shoals",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.6801,
    longitude: 137.5345,
    accuracy: 3
  },
  {
    postalCode: 5223,
    city: "Wisanger",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.6333,
    longitude: 137.4667,
    accuracy: 4
  },
  {
    postalCode: 5223,
    city: "Karatta",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.9284,
    longitude: 136.8972,
    accuracy: 4
  },
  {
    postalCode: 5223,
    city: "Cygnet River",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.7,
    longitude: 137.5167,
    accuracy: 4
  },
  {
    postalCode: 5223,
    city: "Cape Borda",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.6801,
    longitude: 137.5345,
    accuracy: 3
  },
  {
    postalCode: 5223,
    city: "Stokes Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.6294,
    longitude: 137.2034,
    accuracy: 4
  },
  {
    postalCode: 5223,
    city: "Haines",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.6801,
    longitude: 137.5345,
    accuracy: 3
  },
  {
    postalCode: 5223,
    city: "De Mole River",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.6801,
    longitude: 137.5345,
    accuracy: 3
  },
  {
    postalCode: 5223,
    city: "Gosse",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.6801,
    longitude: 137.5345,
    accuracy: 3
  },
  {
    postalCode: 5223,
    city: "Birchmore",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.6801,
    longitude: 137.5345,
    accuracy: 3
  },
  {
    postalCode: 5223,
    city: "Nepean Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.6801,
    longitude: 137.5345,
    accuracy: 3
  },
  {
    postalCode: 5223,
    city: "Macgillivray",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.6801,
    longitude: 137.5345,
    accuracy: 3
  },
  {
    postalCode: 5223,
    city: "Menzies",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.6801,
    longitude: 137.5345,
    accuracy: 3
  },
  {
    postalCode: 5223,
    city: "Flinders Chase",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.6801,
    longitude: 137.5345,
    accuracy: 3
  },
  {
    postalCode: 5223,
    city: "Cassini",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.6801,
    longitude: 137.5345,
    accuracy: 3
  },
  {
    postalCode: 5223,
    city: "Stun'Sail Boom",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.6801,
    longitude: 137.5345,
    accuracy: 3
  },
  {
    postalCode: 5223,
    city: "Seal Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.6801,
    longitude: 137.5345,
    accuracy: 3
  },
  {
    postalCode: 5223,
    city: "Middle River",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.6801,
    longitude: 137.5345,
    accuracy: 3
  },
  {
    postalCode: 5223,
    city: "Western River",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.6801,
    longitude: 137.5345,
    accuracy: 3
  },
  {
    postalCode: 5223,
    city: "Duncan",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.6801,
    longitude: 137.5345,
    accuracy: 3
  },
  {
    postalCode: 5231,
    city: "Chain Of Ponds",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8225,
    longitude: 138.8335,
    accuracy: 4
  },
  {
    postalCode: 5231,
    city: "Kersbrook",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7831,
    longitude: 138.8509,
    accuracy: 4
  },
  {
    postalCode: 5231,
    city: "Millbrook",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7999,
    longitude: 138.8421,
    accuracy: 3
  },
  {
    postalCode: 5232,
    city: "Cudlee Creek",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8409,
    longitude: 138.8284,
    accuracy: 4
  },
  {
    postalCode: 5233,
    city: "Gumeracha",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8239,
    longitude: 138.8847,
    accuracy: 4
  },
  {
    postalCode: 5233,
    city: "Forreston",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7814,
    longitude: 138.9181,
    accuracy: 4
  },
  {
    postalCode: 5234,
    city: "Birdwood",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8183,
    longitude: 138.9648,
    accuracy: 4
  },
  {
    postalCode: 5235,
    city: "Flaxman Valley",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7247,
    longitude: 139.0596,
    accuracy: 3
  },
  {
    postalCode: 5235,
    city: "Springton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7074,
    longitude: 139.0893,
    accuracy: 4
  },
  {
    postalCode: 5235,
    city: "Taunton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7247,
    longitude: 139.0596,
    accuracy: 3
  },
  {
    postalCode: 5235,
    city: "Mount Pleasant",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7749,
    longitude: 139.0491,
    accuracy: 4
  },
  {
    postalCode: 5235,
    city: "Cromer",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7627,
    longitude: 138.9901,
    accuracy: 4
  },
  {
    postalCode: 5235,
    city: "Eden Valley",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.65,
    longitude: 139.1,
    accuracy: 4
  },
  {
    postalCode: 5236,
    city: "Tungkillo",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8167,
    longitude: 139.0667,
    accuracy: 4
  },
  {
    postalCode: 5237,
    city: "Sanderston",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7554,
    longitude: 139.2219,
    accuracy: 4
  },
  {
    postalCode: 5237,
    city: "Milendella",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8167,
    longitude: 139.2,
    accuracy: 4
  },
  {
    postalCode: 5237,
    city: "Palmer",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.85,
    longitude: 139.1667,
    accuracy: 4
  },
  {
    postalCode: 5237,
    city: "Apamurra",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8056,
    longitude: 139.1944,
    accuracy: 3
  },
  {
    postalCode: 5238,
    city: "Bowhill",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9,
    longitude: 139.6167,
    accuracy: 4
  },
  {
    postalCode: 5238,
    city: "Ponde",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.95,
    longitude: 139.3167,
    accuracy: 4
  },
  {
    postalCode: 5238,
    city: "Purnong",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8667,
    longitude: 139.6167,
    accuracy: 4
  },
  {
    postalCode: 5238,
    city: "Frayville",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8411,
    longitude: 139.4865,
    accuracy: 3
  },
  {
    postalCode: 5238,
    city: "Caurnamont",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8431,
    longitude: 139.5874,
    accuracy: 4
  },
  {
    postalCode: 5238,
    city: "Nildottie",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6764,
    longitude: 139.6517,
    accuracy: 4
  },
  {
    postalCode: 5238,
    city: "Purnong Landing",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8667,
    longitude: 139.6167,
    accuracy: 4
  },
  {
    postalCode: 5238,
    city: "Five Miles",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8411,
    longitude: 139.4865,
    accuracy: 3
  },
  {
    postalCode: 5238,
    city: "Younghusband Holdings",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8411,
    longitude: 139.4865,
    accuracy: 3
  },
  {
    postalCode: 5238,
    city: "Angas Valley",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7667,
    longitude: 139.3,
    accuracy: 4
  },
  {
    postalCode: 5238,
    city: "Teal Flat",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8936,
    longitude: 139.5564,
    accuracy: 4
  },
  {
    postalCode: 5238,
    city: "Julanka Holdings",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8411,
    longitude: 139.4865,
    accuracy: 3
  },
  {
    postalCode: 5238,
    city: "Walker Flat",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7526,
    longitude: 139.5565,
    accuracy: 4
  },
  {
    postalCode: 5238,
    city: "Pompoota",
    state_name: "South Australia",
    state: "SA",
    latitude: -35,
    longitude: 139.3333,
    accuracy: 4
  },
  {
    postalCode: 5238,
    city: "Wongulla",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7049,
    longitude: 139.5659,
    accuracy: 4
  },
  {
    postalCode: 5238,
    city: "Frahns",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8411,
    longitude: 139.4865,
    accuracy: 3
  },
  {
    postalCode: 5238,
    city: "Rocky Point",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8411,
    longitude: 139.4865,
    accuracy: 3
  },
  {
    postalCode: 5238,
    city: "Younghusband",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8411,
    longitude: 139.4865,
    accuracy: 3
  },
  {
    postalCode: 5238,
    city: "Forster",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7334,
    longitude: 139.5548,
    accuracy: 4
  },
  {
    postalCode: 5238,
    city: "Port Mannum",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8411,
    longitude: 139.4865,
    accuracy: 3
  },
  {
    postalCode: 5238,
    city: "Mannum",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9153,
    longitude: 139.3033,
    accuracy: 4
  },
  {
    postalCode: 5238,
    city: "Bolto",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8411,
    longitude: 139.4865,
    accuracy: 3
  },
  {
    postalCode: 5238,
    city: "Old Teal Flat",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8411,
    longitude: 139.4865,
    accuracy: 3
  },
  {
    postalCode: 5238,
    city: "Big Bend",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8411,
    longitude: 139.4865,
    accuracy: 3
  },
  {
    postalCode: 5238,
    city: "Punthari",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8167,
    longitude: 139.3167,
    accuracy: 4
  },
  {
    postalCode: 5238,
    city: "Cowirra",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9,
    longitude: 139.3333,
    accuracy: 4
  },
  {
    postalCode: 5238,
    city: "Pellaring Flat",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.862,
    longitude: 139.3899,
    accuracy: 4
  },
  {
    postalCode: 5238,
    city: "Lake Carlet",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8411,
    longitude: 139.4865,
    accuracy: 3
  },
  {
    postalCode: 5238,
    city: "Claypans",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8167,
    longitude: 139.6667,
    accuracy: 4
  },
  {
    postalCode: 5240,
    city: "Lenswood",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9182,
    longitude: 138.8326,
    accuracy: 4
  },
  {
    postalCode: 5241,
    city: "Lobethal",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9045,
    longitude: 138.8748,
    accuracy: 4
  },
  {
    postalCode: 5242,
    city: "Balhannah",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9909,
    longitude: 138.8257,
    accuracy: 4
  },
  {
    postalCode: 5243,
    city: "Oakbank",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9834,
    longitude: 138.8453,
    accuracy: 4
  },
  {
    postalCode: 5244,
    city: "Inverbrackie",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9734,
    longitude: 138.8917,
    accuracy: 4
  },
  {
    postalCode: 5244,
    city: "Charleston",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9167,
    longitude: 138.9,
    accuracy: 4
  },
  {
    postalCode: 5244,
    city: "Mount Torrens",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8755,
    longitude: 138.9586,
    accuracy: 4
  },
  {
    postalCode: 5244,
    city: "Woodside",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9543,
    longitude: 138.879,
    accuracy: 4
  },
  {
    postalCode: 5244,
    city: "Harrogate",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.95,
    longitude: 139.0167,
    accuracy: 4
  },
  {
    postalCode: 5245,
    city: "Paechtown",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.049,
    longitude: 138.8089,
    accuracy: 4
  },
  {
    postalCode: 5245,
    city: "Hahndorf",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0286,
    longitude: 138.8078,
    accuracy: 4
  },
  {
    postalCode: 5245,
    city: "Verdun",
    state_name: "South Australia",
    state: "SA",
    latitude: -35,
    longitude: 138.7833,
    accuracy: 4
  },
  {
    postalCode: 5246,
    city: "Woodhouse",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9614,
    longitude: 138.8661,
    accuracy: 1
  },
  {
    postalCode: 5250,
    city: "Littlehampton",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.05,
    longitude: 138.85,
    accuracy: 4
  },
  {
    postalCode: 5250,
    city: "Blakiston",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0421,
    longitude: 138.8815,
    accuracy: 4
  },
  {
    postalCode: 5250,
    city: "Totness",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.05,
    longitude: 138.8667,
    accuracy: 3
  },
  {
    postalCode: 5251,
    city: "Mount Barker Junction",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0253,
    longitude: 138.8683,
    accuracy: 4
  },
  {
    postalCode: 5251,
    city: "Mount Barker Springs",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.079,
    longitude: 138.8637,
    accuracy: 3
  },
  {
    postalCode: 5251,
    city: "Bugle Ranges",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1327,
    longitude: 138.8716,
    accuracy: 4
  },
  {
    postalCode: 5251,
    city: "Mount Barker Summit",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.079,
    longitude: 138.8637,
    accuracy: 3
  },
  {
    postalCode: 5251,
    city: "Mount Barker",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0667,
    longitude: 138.8667,
    accuracy: 4
  },
  {
    postalCode: 5251,
    city: "Wistow",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1,
    longitude: 138.8667,
    accuracy: 4
  },
  {
    postalCode: 5252,
    city: "Nairne",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0345,
    longitude: 138.9115,
    accuracy: 4
  },
  {
    postalCode: 5252,
    city: "Brukunga",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0029,
    longitude: 138.9425,
    accuracy: 4
  },
  {
    postalCode: 5252,
    city: "Dawesley",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0419,
    longitude: 138.9535,
    accuracy: 4
  },
  {
    postalCode: 5252,
    city: "Kanmantoo",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0701,
    longitude: 139.0127,
    accuracy: 4
  },
  {
    postalCode: 5252,
    city: "St Ives",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0367,
    longitude: 138.9559,
    accuracy: 3
  },
  {
    postalCode: 5252,
    city: "Hay Valley",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0367,
    longitude: 138.9559,
    accuracy: 3
  },
  {
    postalCode: 5253,
    city: "Brinkley",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.23,
    longitude: 139.2221,
    accuracy: 4
  },
  {
    postalCode: 5253,
    city: "Riverglen",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.17,
    longitude: 139.3085,
    accuracy: 4
  },
  {
    postalCode: 5253,
    city: "Ettrick",
    state_name: "South Australia",
    state: "SA",
    latitude: -35,
    longitude: 139.5667,
    accuracy: 4
  },
  {
    postalCode: 5253,
    city: "Murray Bridge East",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1339,
    longitude: 139.3678,
    accuracy: 3
  },
  {
    postalCode: 5253,
    city: "White Sands",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1339,
    longitude: 139.3678,
    accuracy: 3
  },
  {
    postalCode: 5253,
    city: "Northern Heights",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1339,
    longitude: 139.3678,
    accuracy: 3
  },
  {
    postalCode: 5253,
    city: "Swanport",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.15,
    longitude: 139.3,
    accuracy: 4
  },
  {
    postalCode: 5253,
    city: "Murray Bridge",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1199,
    longitude: 139.2735,
    accuracy: 4
  },
  {
    postalCode: 5253,
    city: "Chapman Bore",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1275,
    longitude: 139.5517,
    accuracy: 4
  },
  {
    postalCode: 5253,
    city: "Murrawong",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1339,
    longitude: 139.3678,
    accuracy: 3
  },
  {
    postalCode: 5253,
    city: "Monteith",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1667,
    longitude: 139.3,
    accuracy: 4
  },
  {
    postalCode: 5253,
    city: "Mobilong",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1339,
    longitude: 139.3678,
    accuracy: 3
  },
  {
    postalCode: 5253,
    city: "Sunnyside",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1339,
    longitude: 139.3678,
    accuracy: 3
  },
  {
    postalCode: 5253,
    city: "Willow Banks",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1339,
    longitude: 139.3678,
    accuracy: 3
  },
  {
    postalCode: 5253,
    city: "Riverglades",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1339,
    longitude: 139.3678,
    accuracy: 3
  },
  {
    postalCode: 5253,
    city: "Murray Bridge North",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1339,
    longitude: 139.3678,
    accuracy: 3
  },
  {
    postalCode: 5253,
    city: "Toora",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1339,
    longitude: 139.3678,
    accuracy: 3
  },
  {
    postalCode: 5253,
    city: "Murray Bridge South",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1339,
    longitude: 139.3678,
    accuracy: 3
  },
  {
    postalCode: 5253,
    city: "Long Flat",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1339,
    longitude: 139.3678,
    accuracy: 3
  },
  {
    postalCode: 5253,
    city: "Gifford Hill",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1339,
    longitude: 139.3678,
    accuracy: 3
  },
  {
    postalCode: 5253,
    city: "Greenbanks",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1339,
    longitude: 139.3678,
    accuracy: 3
  },
  {
    postalCode: 5253,
    city: "Avoca Dell",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1339,
    longitude: 139.3678,
    accuracy: 3
  },
  {
    postalCode: 5253,
    city: "Burdett",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1339,
    longitude: 139.3678,
    accuracy: 3
  },
  {
    postalCode: 5253,
    city: "Woods Point",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1339,
    longitude: 139.3678,
    accuracy: 3
  },
  {
    postalCode: 5254,
    city: "Murray Bridge",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1199,
    longitude: 139.2735,
    accuracy: 4
  },
  {
    postalCode: 5254,
    city: "Wall Flat",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9667,
    longitude: 139.3167,
    accuracy: 4
  },
  {
    postalCode: 5254,
    city: "Caloote",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9642,
    longitude: 139.2622,
    accuracy: 4
  },
  {
    postalCode: 5254,
    city: "White Hill",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0406,
    longitude: 139.1998,
    accuracy: 3
  },
  {
    postalCode: 5254,
    city: "Monarto South",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.122,
    longitude: 139.129,
    accuracy: 4
  },
  {
    postalCode: 5254,
    city: "Mypolonga",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.05,
    longitude: 139.35,
    accuracy: 4
  },
  {
    postalCode: 5254,
    city: "Pallamana",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0344,
    longitude: 139.2059,
    accuracy: 4
  },
  {
    postalCode: 5254,
    city: "Woodlane",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0406,
    longitude: 139.1998,
    accuracy: 3
  },
  {
    postalCode: 5254,
    city: "Monarto",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.05,
    longitude: 139.1333,
    accuracy: 4
  },
  {
    postalCode: 5254,
    city: "Rocky Gully",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0406,
    longitude: 139.1998,
    accuracy: 3
  },
  {
    postalCode: 5254,
    city: "Tepko",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.969,
    longitude: 139.1878,
    accuracy: 4
  },
  {
    postalCode: 5254,
    city: "Petwood",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0406,
    longitude: 139.1998,
    accuracy: 3
  },
  {
    postalCode: 5254,
    city: "Callington",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1198,
    longitude: 139.0414,
    accuracy: 4
  },
  {
    postalCode: 5254,
    city: "Zadows Landing",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0406,
    longitude: 139.1998,
    accuracy: 3
  },
  {
    postalCode: 5254,
    city: "Rockleigh",
    state_name: "South Australia",
    state: "SA",
    latitude: -35,
    longitude: 139.1167,
    accuracy: 4
  },
  {
    postalCode: 5255,
    city: "Woodchester",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2167,
    longitude: 138.95,
    accuracy: 4
  },
  {
    postalCode: 5255,
    city: "Tooperang",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.3833,
    longitude: 138.7333,
    accuracy: 4
  },
  {
    postalCode: 5255,
    city: "Mount Observation",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2918,
    longitude: 138.9315,
    accuracy: 3
  },
  {
    postalCode: 5255,
    city: "Finniss",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.4,
    longitude: 138.8167,
    accuracy: 4
  },
  {
    postalCode: 5255,
    city: "Mulgundawa",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2918,
    longitude: 138.9315,
    accuracy: 3
  },
  {
    postalCode: 5255,
    city: "Belvidere",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2914,
    longitude: 138.9474,
    accuracy: 4
  },
  {
    postalCode: 5255,
    city: "Gemmells",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2918,
    longitude: 138.9315,
    accuracy: 3
  },
  {
    postalCode: 5255,
    city: "Lake Plains",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.3704,
    longitude: 139.0417,
    accuracy: 4
  },
  {
    postalCode: 5255,
    city: "Langhorne Creek",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.296,
    longitude: 139.0359,
    accuracy: 4
  },
  {
    postalCode: 5255,
    city: "Red Creek",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1587,
    longitude: 138.9757,
    accuracy: 4
  },
  {
    postalCode: 5255,
    city: "Salem",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2918,
    longitude: 138.9315,
    accuracy: 3
  },
  {
    postalCode: 5255,
    city: "Bletchley",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2408,
    longitude: 138.9855,
    accuracy: 4
  },
  {
    postalCode: 5255,
    city: "Strathalbyn",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2598,
    longitude: 138.8925,
    accuracy: 4
  },
  {
    postalCode: 5255,
    city: "Sandergrove",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.3333,
    longitude: 138.8333,
    accuracy: 4
  },
  {
    postalCode: 5255,
    city: "Nalpa",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2918,
    longitude: 138.9315,
    accuracy: 3
  },
  {
    postalCode: 5255,
    city: "Angas Plains",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.35,
    longitude: 139,
    accuracy: 4
  },
  {
    postalCode: 5255,
    city: "Highland Valley",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2918,
    longitude: 138.9315,
    accuracy: 3
  },
  {
    postalCode: 5255,
    city: "Hartley",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2,
    longitude: 139,
    accuracy: 4
  },
  {
    postalCode: 5255,
    city: "Willyaroo",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2667,
    longitude: 138.9167,
    accuracy: 4
  },
  {
    postalCode: 5256,
    city: "Clayton Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.4905,
    longitude: 138.9207,
    accuracy: 4
  },
  {
    postalCode: 5256,
    city: "Tolderol",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.4768,
    longitude: 138.9608,
    accuracy: 3
  },
  {
    postalCode: 5256,
    city: "Point Sturt",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.5167,
    longitude: 139.0333,
    accuracy: 4
  },
  {
    postalCode: 5256,
    city: "Clayton",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.4905,
    longitude: 138.9207,
    accuracy: 4
  },
  {
    postalCode: 5256,
    city: "Milang",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.4078,
    longitude: 138.9712,
    accuracy: 4
  },
  {
    postalCode: 5256,
    city: "Nurragi",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.4768,
    longitude: 138.9608,
    accuracy: 3
  },
  {
    postalCode: 5259,
    city: "Tailem Bend",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2523,
    longitude: 139.4555,
    accuracy: 4
  },
  {
    postalCode: 5259,
    city: "Wellington",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.35,
    longitude: 139.3833,
    accuracy: 4
  },
  {
    postalCode: 5259,
    city: "Narrung",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.5122,
    longitude: 139.1685,
    accuracy: 4
  },
  {
    postalCode: 5259,
    city: "Wellington East",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.3333,
    longitude: 139.4,
    accuracy: 4
  },
  {
    postalCode: 5259,
    city: "Ashville",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.5106,
    longitude: 139.3656,
    accuracy: 4
  },
  {
    postalCode: 5259,
    city: "Kepa",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.3711,
    longitude: 139.3611,
    accuracy: 3
  },
  {
    postalCode: 5259,
    city: "Jervois",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2667,
    longitude: 139.4333,
    accuracy: 4
  },
  {
    postalCode: 5259,
    city: "Point Mcleay",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.5333,
    longitude: 139.1,
    accuracy: 4
  },
  {
    postalCode: 5259,
    city: "Naturi",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1973,
    longitude: 139.5846,
    accuracy: 4
  },
  {
    postalCode: 5259,
    city: "Raukkan",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.4358,
    longitude: 139.2417,
    accuracy: 3
  },
  {
    postalCode: 5259,
    city: "Poltalloch",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.3711,
    longitude: 139.3611,
    accuracy: 3
  },
  {
    postalCode: 5259,
    city: "Malinong",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.3711,
    longitude: 139.3611,
    accuracy: 3
  },
  {
    postalCode: 5260,
    city: "Tailem Bend",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2523,
    longitude: 139.4555,
    accuracy: 4
  },
  {
    postalCode: 5260,
    city: "Elwomple",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2523,
    longitude: 139.4555,
    accuracy: 3
  },
  {
    postalCode: 5261,
    city: "Yumali",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.5084,
    longitude: 139.7578,
    accuracy: 4
  },
  {
    postalCode: 5261,
    city: "Ki Ki",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.5833,
    longitude: 139.8,
    accuracy: 4
  },
  {
    postalCode: 5261,
    city: "Culburra",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.8134,
    longitude: 139.9649,
    accuracy: 4
  },
  {
    postalCode: 5261,
    city: "Cooke Plains",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.3797,
    longitude: 139.5617,
    accuracy: 4
  },
  {
    postalCode: 5261,
    city: "Coomandook",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.4735,
    longitude: 139.6963,
    accuracy: 4
  },
  {
    postalCode: 5262,
    city: "Binnum",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.7951,
    longitude: 140.9375,
    accuracy: 4
  },
  {
    postalCode: 5262,
    city: "Frances",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.7167,
    longitude: 140.9667,
    accuracy: 4
  },
  {
    postalCode: 5262,
    city: "Kybybolite",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.8833,
    longitude: 140.9167,
    accuracy: 4
  },
  {
    postalCode: 5262,
    city: "Hynam",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.95,
    longitude: 140.85,
    accuracy: 4
  },
  {
    postalCode: 5263,
    city: "Coonawarra",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.2906,
    longitude: 140.8344,
    accuracy: 4
  },
  {
    postalCode: 5264,
    city: "Meningie East",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.8184,
    longitude: 139.4684,
    accuracy: 3
  },
  {
    postalCode: 5264,
    city: "Meningie",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.6864,
    longitude: 139.3401,
    accuracy: 4
  },
  {
    postalCode: 5264,
    city: "Coorong",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.8184,
    longitude: 139.4684,
    accuracy: 3
  },
  {
    postalCode: 5264,
    city: "Waltowa",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.624,
    longitude: 139.4327,
    accuracy: 4
  },
  {
    postalCode: 5264,
    city: "Meningie West",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.8184,
    longitude: 139.4684,
    accuracy: 3
  },
  {
    postalCode: 5264,
    city: "Salt Creek",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.15,
    longitude: 139.6333,
    accuracy: 4
  },
  {
    postalCode: 5265,
    city: "Field",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.8224,
    longitude: 139.6652,
    accuracy: 4
  },
  {
    postalCode: 5265,
    city: "Coonalpyn",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.6942,
    longitude: 139.8578,
    accuracy: 4
  },
  {
    postalCode: 5266,
    city: "Deepwater",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.8871,
    longitude: 140.0565,
    accuracy: 3
  },
  {
    postalCode: 5266,
    city: "Tintinara",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.8871,
    longitude: 140.0565,
    accuracy: 4
  },
  {
    postalCode: 5266,
    city: "Bunbury",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.8871,
    longitude: 140.0565,
    accuracy: 3
  },
  {
    postalCode: 5266,
    city: "Colebatch",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.8871,
    longitude: 140.0565,
    accuracy: 3
  },
  {
    postalCode: 5267,
    city: "Coombe",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.962,
    longitude: 140.2192,
    accuracy: 4
  },
  {
    postalCode: 5267,
    city: "Mount Charles",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.1495,
    longitude: 140.4682,
    accuracy: 3
  },
  {
    postalCode: 5267,
    city: "Petherick",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.1495,
    longitude: 140.4682,
    accuracy: 3
  },
  {
    postalCode: 5267,
    city: "Wirrega",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.2064,
    longitude: 140.5831,
    accuracy: 4
  },
  {
    postalCode: 5267,
    city: "Sherwood",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.1495,
    longitude: 140.4682,
    accuracy: 3
  },
  {
    postalCode: 5267,
    city: "Keith",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.0991,
    longitude: 140.3531,
    accuracy: 4
  },
  {
    postalCode: 5267,
    city: "Shaugh",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.1495,
    longitude: 140.4682,
    accuracy: 3
  },
  {
    postalCode: 5267,
    city: "Mccallum",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.1495,
    longitude: 140.4682,
    accuracy: 3
  },
  {
    postalCode: 5267,
    city: "Brimbago",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.1495,
    longitude: 140.4682,
    accuracy: 3
  },
  {
    postalCode: 5267,
    city: "Laffer",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.1495,
    longitude: 140.4682,
    accuracy: 3
  },
  {
    postalCode: 5267,
    city: "Willalooka",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.3935,
    longitude: 140.3081,
    accuracy: 4
  },
  {
    postalCode: 5267,
    city: "Makin",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.1495,
    longitude: 140.4682,
    accuracy: 3
  },
  {
    postalCode: 5268,
    city: "Lowan Vale",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.1788,
    longitude: 140.6703,
    accuracy: 4
  },
  {
    postalCode: 5268,
    city: "Western Flat",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.2959,
    longitude: 140.7423,
    accuracy: 3
  },
  {
    postalCode: 5268,
    city: "Cannawigara",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.25,
    longitude: 140.6667,
    accuracy: 4
  },
  {
    postalCode: 5268,
    city: "Bordertown South",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.3077,
    longitude: 140.7717,
    accuracy: 4
  },
  {
    postalCode: 5268,
    city: "Senior",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.2959,
    longitude: 140.7423,
    accuracy: 3
  },
  {
    postalCode: 5268,
    city: "Bordertown",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.3077,
    longitude: 140.7717,
    accuracy: 4
  },
  {
    postalCode: 5268,
    city: "Pooginagoric",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.4333,
    longitude: 140.8333,
    accuracy: 4
  },
  {
    postalCode: 5268,
    city: "Bangham",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.2959,
    longitude: 140.7423,
    accuracy: 3
  },
  {
    postalCode: 5269,
    city: "Pine Hill",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.1717,
    longitude: 133.7971,
    accuracy: 3
  },
  {
    postalCode: 5269,
    city: "Wolseley",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.3667,
    longitude: 140.9,
    accuracy: 4
  },
  {
    postalCode: 5269,
    city: "Custon",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.45,
    longitude: 140.9167,
    accuracy: 4
  },
  {
    postalCode: 5270,
    city: "Buckingham",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.3444,
    longitude: 140.5818,
    accuracy: 4
  },
  {
    postalCode: 5270,
    city: "Kongal",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.3167,
    longitude: 140.5167,
    accuracy: 4
  },
  {
    postalCode: 5270,
    city: "Carew",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.3444,
    longitude: 140.5944,
    accuracy: 3
  },
  {
    postalCode: 5270,
    city: "Mundulla",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.3667,
    longitude: 140.6833,
    accuracy: 4
  },
  {
    postalCode: 5270,
    city: "Mundulla West",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.3444,
    longitude: 140.5944,
    accuracy: 3
  },
  {
    postalCode: 5270,
    city: "Swede Flat",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.3444,
    longitude: 140.5944,
    accuracy: 3
  },
  {
    postalCode: 5271,
    city: "Bool Lagoon",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.1392,
    longitude: 140.7218,
    accuracy: 4
  },
  {
    postalCode: 5271,
    city: "Laurie Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.9763,
    longitude: 140.6925,
    accuracy: 3
  },
  {
    postalCode: 5271,
    city: "Keppoch",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.7,
    longitude: 140.5667,
    accuracy: 4
  },
  {
    postalCode: 5271,
    city: "Moyhall",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.9763,
    longitude: 140.6925,
    accuracy: 3
  },
  {
    postalCode: 5271,
    city: "Naracoorte",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.9578,
    longitude: 140.7383,
    accuracy: 4
  },
  {
    postalCode: 5271,
    city: "Struan",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.0945,
    longitude: 140.791,
    accuracy: 4
  },
  {
    postalCode: 5271,
    city: "Padthaway",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.5963,
    longitude: 140.4996,
    accuracy: 4
  },
  {
    postalCode: 5271,
    city: "Koppamurra",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.9763,
    longitude: 140.6925,
    accuracy: 3
  },
  {
    postalCode: 5271,
    city: "Joanna",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.1,
    longitude: 140.8333,
    accuracy: 4
  },
  {
    postalCode: 5271,
    city: "Lochaber",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.8333,
    longitude: 140.5167,
    accuracy: 4
  },
  {
    postalCode: 5271,
    city: "Cadgee",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.9763,
    longitude: 140.6925,
    accuracy: 3
  },
  {
    postalCode: 5271,
    city: "Wrattonbully",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.9763,
    longitude: 140.6925,
    accuracy: 3
  },
  {
    postalCode: 5271,
    city: "Spence",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.9763,
    longitude: 140.6925,
    accuracy: 3
  },
  {
    postalCode: 5271,
    city: "Mount Light",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.9763,
    longitude: 140.6925,
    accuracy: 3
  },
  {
    postalCode: 5271,
    city: "Wild Dog Valley",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.9763,
    longitude: 140.6925,
    accuracy: 3
  },
  {
    postalCode: 5271,
    city: "Marcollat",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.9763,
    longitude: 140.6925,
    accuracy: 3
  },
  {
    postalCode: 5271,
    city: "The Gap",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.9763,
    longitude: 140.6925,
    accuracy: 3
  },
  {
    postalCode: 5271,
    city: "Stewart Range",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.9763,
    longitude: 140.6925,
    accuracy: 3
  },
  {
    postalCode: 5272,
    city: "Lucindale",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.9727,
    longitude: 140.3701,
    accuracy: 4
  },
  {
    postalCode: 5272,
    city: "Woolumbool",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.0906,
    longitude: 140.3179,
    accuracy: 3
  },
  {
    postalCode: 5272,
    city: "Conmurra",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.15,
    longitude: 140.2833,
    accuracy: 4
  },
  {
    postalCode: 5272,
    city: "Coles",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.0906,
    longitude: 140.3179,
    accuracy: 3
  },
  {
    postalCode: 5272,
    city: "Fox",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.5964,
    longitude: 135.7086,
    accuracy: 4
  },
  {
    postalCode: 5272,
    city: "Greenways",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6586,
    longitude: 139.6446,
    accuracy: 4
  },
  {
    postalCode: 5273,
    city: "Avenue Range",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.9667,
    longitude: 140.2333,
    accuracy: 4
  },
  {
    postalCode: 5275,
    city: "Rosetown",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.8333,
    longitude: 139.85,
    accuracy: 4
  },
  {
    postalCode: 5275,
    city: "Pinks Beach",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.0028,
    longitude: 140.0667,
    accuracy: 3
  },
  {
    postalCode: 5275,
    city: "Boatswain Point",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.0028,
    longitude: 140.0667,
    accuracy: 3
  },
  {
    postalCode: 5275,
    city: "Keilira",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.7167,
    longitude: 140.15,
    accuracy: 4
  },
  {
    postalCode: 5275,
    city: "West Range",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.6667,
    longitude: 140.5833,
    accuracy: 4
  },
  {
    postalCode: 5275,
    city: "Kingston Se",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.0028,
    longitude: 140.0667,
    accuracy: 3
  },
  {
    postalCode: 5275,
    city: "Blackford",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.7667,
    longitude: 140.0167,
    accuracy: 4
  },
  {
    postalCode: 5275,
    city: "Taratap",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.0028,
    longitude: 140.0667,
    accuracy: 3
  },
  {
    postalCode: 5275,
    city: "Tilley Swamp",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.0028,
    longitude: 140.0667,
    accuracy: 3
  },
  {
    postalCode: 5275,
    city: "Kingston S.E.",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.5102,
    longitude: 139.9281,
    accuracy: 3
  },
  {
    postalCode: 5275,
    city: "Wangolina",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.0028,
    longitude: 140.0667,
    accuracy: 3
  },
  {
    postalCode: 5275,
    city: "Mount Benson",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.0833,
    longitude: 139.7833,
    accuracy: 4
  },
  {
    postalCode: 5275,
    city: "Reedy Creek",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.95,
    longitude: 140.0167,
    accuracy: 4
  },
  {
    postalCode: 5275,
    city: "Sandy Grove",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.0028,
    longitude: 140.0667,
    accuracy: 3
  },
  {
    postalCode: 5275,
    city: "Cape Jaffa",
    state_name: "South Australia",
    state: "SA",
    latitude: -36.9455,
    longitude: 139.6982,
    accuracy: 4
  },
  {
    postalCode: 5275,
    city: "Wyomi",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.0028,
    longitude: 140.0667,
    accuracy: 3
  },
  {
    postalCode: 5276,
    city: "Nora Creina",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.3256,
    longitude: 139.8523,
    accuracy: 4
  },
  {
    postalCode: 5276,
    city: "Robe",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.1639,
    longitude: 139.7603,
    accuracy: 4
  },
  {
    postalCode: 5276,
    city: "Bray",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.2461,
    longitude: 139.8082,
    accuracy: 3
  },
  {
    postalCode: 5277,
    city: "Pleasant Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.4131,
    longitude: 140.8494,
    accuracy: 3
  },
  {
    postalCode: 5277,
    city: "Glenroy",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.25,
    longitude: 140.85,
    accuracy: 4
  },
  {
    postalCode: 5277,
    city: "Penola",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.3752,
    longitude: 140.8368,
    accuracy: 4
  },
  {
    postalCode: 5277,
    city: "Comaum",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.2667,
    longitude: 140.95,
    accuracy: 4
  },
  {
    postalCode: 5277,
    city: "Maaoupe",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.4131,
    longitude: 140.8494,
    accuracy: 3
  },
  {
    postalCode: 5277,
    city: "Tarpeena",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.6277,
    longitude: 140.7959,
    accuracy: 4
  },
  {
    postalCode: 5277,
    city: "Monbulla",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.4131,
    longitude: 140.8494,
    accuracy: 3
  },
  {
    postalCode: 5277,
    city: "Nangwarry",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.546,
    longitude: 140.8145,
    accuracy: 4
  },
  {
    postalCode: 5278,
    city: "Kalangadoo",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.5648,
    longitude: 140.6992,
    accuracy: 4
  },
  {
    postalCode: 5278,
    city: "Wepar",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.6083,
    longitude: 140.7077,
    accuracy: 4
  },
  {
    postalCode: 5278,
    city: "Krongart",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.5908,
    longitude: 140.6996,
    accuracy: 3
  },
  {
    postalCode: 5278,
    city: "Moerlong",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.5908,
    longitude: 140.6996,
    accuracy: 3
  },
  {
    postalCode: 5279,
    city: "Mount Burr",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.542,
    longitude: 140.4555,
    accuracy: 4
  },
  {
    postalCode: 5279,
    city: "Trihi",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.5436,
    longitude: 140.4452,
    accuracy: 3
  },
  {
    postalCode: 5279,
    city: "Wattle Range East",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.546,
    longitude: 140.5028,
    accuracy: 3
  },
  {
    postalCode: 5279,
    city: "Short",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.546,
    longitude: 140.5028,
    accuracy: 3
  },
  {
    postalCode: 5279,
    city: "Mount Mcintyre",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.5608,
    longitude: 140.5373,
    accuracy: 4
  },
  {
    postalCode: 5279,
    city: "Koorine",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.546,
    longitude: 140.5028,
    accuracy: 3
  },
  {
    postalCode: 5280,
    city: "Beachport",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.4802,
    longitude: 140.0107,
    accuracy: 4
  },
  {
    postalCode: 5280,
    city: "Millicent",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.5939,
    longitude: 140.3495,
    accuracy: 4
  },
  {
    postalCode: 5280,
    city: "Tantanoola",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.6966,
    longitude: 140.4575,
    accuracy: 4
  },
  {
    postalCode: 5280,
    city: "Clay Wells",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.5441,
    longitude: 140.251,
    accuracy: 3
  },
  {
    postalCode: 5280,
    city: "Furner",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.4167,
    longitude: 140.3333,
    accuracy: 4
  },
  {
    postalCode: 5280,
    city: "Sebastopol",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.5441,
    longitude: 140.251,
    accuracy: 3
  },
  {
    postalCode: 5280,
    city: "Rendelsham",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.55,
    longitude: 140.2167,
    accuracy: 4
  },
  {
    postalCode: 5280,
    city: "German Flat",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.5441,
    longitude: 140.251,
    accuracy: 3
  },
  {
    postalCode: 5280,
    city: "Southend",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.5678,
    longitude: 140.1287,
    accuracy: 4
  },
  {
    postalCode: 5280,
    city: "Thornlea",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.5441,
    longitude: 140.251,
    accuracy: 3
  },
  {
    postalCode: 5280,
    city: "Hatherleigh",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.5,
    longitude: 140.2667,
    accuracy: 4
  },
  {
    postalCode: 5280,
    city: "Canunda",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.5441,
    longitude: 140.251,
    accuracy: 3
  },
  {
    postalCode: 5280,
    city: "Wattle Range",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.5441,
    longitude: 140.251,
    accuracy: 3
  },
  {
    postalCode: 5280,
    city: "Kangaroo Inn",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.5441,
    longitude: 140.251,
    accuracy: 3
  },
  {
    postalCode: 5280,
    city: "Magarey",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.5441,
    longitude: 140.251,
    accuracy: 3
  },
  {
    postalCode: 5280,
    city: "Rocky Camp",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.5441,
    longitude: 140.251,
    accuracy: 3
  },
  {
    postalCode: 5290,
    city: "Mount Gambier",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.8318,
    longitude: 140.7792,
    accuracy: 4
  },
  {
    postalCode: 5291,
    city: "Glencoe West",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.6667,
    longitude: 140.5833,
    accuracy: 4
  },
  {
    postalCode: 5291,
    city: "German Creek",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.8571,
    longitude: 140.6831,
    accuracy: 3
  },
  {
    postalCode: 5291,
    city: "Caveton",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.8571,
    longitude: 140.6831,
    accuracy: 3
  },
  {
    postalCode: 5291,
    city: "Allendale East",
    state_name: "South Australia",
    state: "SA",
    latitude: -38.0037,
    longitude: 140.7092,
    accuracy: 4
  },
  {
    postalCode: 5291,
    city: "Worrolong",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.8062,
    longitude: 140.848,
    accuracy: 4
  },
  {
    postalCode: 5291,
    city: "Compton",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.7667,
    longitude: 140.6833,
    accuracy: 4
  },
  {
    postalCode: 5291,
    city: "Eight Mile Creek",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.8571,
    longitude: 140.6831,
    accuracy: 3
  },
  {
    postalCode: 5291,
    city: "Yahl",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.8667,
    longitude: 140.8,
    accuracy: 4
  },
  {
    postalCode: 5291,
    city: "Mount Gambier",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.8318,
    longitude: 140.7792,
    accuracy: 4
  },
  {
    postalCode: 5291,
    city: "Nene Valley",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.9895,
    longitude: 140.5204,
    accuracy: 4
  },
  {
    postalCode: 5291,
    city: "Pelican Point",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.8571,
    longitude: 140.6831,
    accuracy: 3
  },
  {
    postalCode: 5291,
    city: "Mount Schank",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.9399,
    longitude: 140.7241,
    accuracy: 4
  },
  {
    postalCode: 5291,
    city: "Glencoe",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.7,
    longitude: 140.6167,
    accuracy: 4
  },
  {
    postalCode: 5291,
    city: "Kongorong",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.9,
    longitude: 140.55,
    accuracy: 4
  },
  {
    postalCode: 5291,
    city: "Square Mile",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.8571,
    longitude: 140.6831,
    accuracy: 3
  },
  {
    postalCode: 5291,
    city: "Wandilo",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.7259,
    longitude: 140.7257,
    accuracy: 4
  },
  {
    postalCode: 5291,
    city: "Mil-Lel",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.7833,
    longitude: 140.8167,
    accuracy: 4
  },
  {
    postalCode: 5291,
    city: "Carpenter Rocks",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.9102,
    longitude: 140.3956,
    accuracy: 4
  },
  {
    postalCode: 5291,
    city: "Suttontown",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.8571,
    longitude: 140.6831,
    accuracy: 3
  },
  {
    postalCode: 5291,
    city: "Caroline",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.8969,
    longitude: 140.9214,
    accuracy: 4
  },
  {
    postalCode: 5291,
    city: "O.B. Flat",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.8265,
    longitude: 140.7066,
    accuracy: 3
  },
  {
    postalCode: 5291,
    city: "Burrungule",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.7809,
    longitude: 140.574,
    accuracy: 4
  },
  {
    postalCode: 5291,
    city: "Mingbool",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.8571,
    longitude: 140.6831,
    accuracy: 3
  },
  {
    postalCode: 5291,
    city: "Port Macdonnell",
    state_name: "South Australia",
    state: "SA",
    latitude: -38.0531,
    longitude: 140.6996,
    accuracy: 4
  },
  {
    postalCode: 5291,
    city: "Donovans",
    state_name: "South Australia",
    state: "SA",
    latitude: -38.0135,
    longitude: 140.9621,
    accuracy: 3
  },
  {
    postalCode: 5291,
    city: "Glenburnie",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.8394,
    longitude: 140.8588,
    accuracy: 4
  },
  {
    postalCode: 5291,
    city: "Moorak",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.8641,
    longitude: 140.7375,
    accuracy: 3
  },
  {
    postalCode: 5291,
    city: "Blackfellows Caves",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.9467,
    longitude: 140.4685,
    accuracy: 4
  },
  {
    postalCode: 5291,
    city: "Dismal Swamp",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.8571,
    longitude: 140.6831,
    accuracy: 3
  },
  {
    postalCode: 5291,
    city: "Mount Gambier West",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.8265,
    longitude: 140.7066,
    accuracy: 3
  },
  {
    postalCode: 5291,
    city: "Mount Gambier East",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.8265,
    longitude: 140.7066,
    accuracy: 3
  },
  {
    postalCode: 5291,
    city: "Cape Douglas",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.8571,
    longitude: 140.6831,
    accuracy: 3
  },
  {
    postalCode: 5291,
    city: "Racecourse Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.8571,
    longitude: 140.6831,
    accuracy: 3
  },
  {
    postalCode: 5291,
    city: "Ob Flat",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.8571,
    longitude: 140.6831,
    accuracy: 3
  },
  {
    postalCode: 5291,
    city: "Wye",
    state_name: "South Australia",
    state: "SA",
    latitude: -37.8571,
    longitude: 140.6831,
    accuracy: 3
  },
  {
    postalCode: 5301,
    city: "Moorlands",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2899,
    longitude: 139.6455,
    accuracy: 4
  },
  {
    postalCode: 5301,
    city: "Sherlock",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.3167,
    longitude: 139.8167,
    accuracy: 4
  },
  {
    postalCode: 5301,
    city: "Wilkawatt",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.3673,
    longitude: 140.3601,
    accuracy: 4
  },
  {
    postalCode: 5301,
    city: "Carcuma",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.3771,
    longitude: 140.0271,
    accuracy: 3
  },
  {
    postalCode: 5301,
    city: "Parrakie",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.3833,
    longitude: 140.25,
    accuracy: 4
  },
  {
    postalCode: 5301,
    city: "Jabuk",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.4,
    longitude: 140.0667,
    accuracy: 4
  },
  {
    postalCode: 5301,
    city: "Peake",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.3667,
    longitude: 139.95,
    accuracy: 4
  },
  {
    postalCode: 5301,
    city: "Geranium",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.3833,
    longitude: 140.1667,
    accuracy: 4
  },
  {
    postalCode: 5301,
    city: "Netherton",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.4751,
    longitude: 139.9474,
    accuracy: 4
  },
  {
    postalCode: 5302,
    city: "Ngarkat",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.329,
    longitude: 140.5167,
    accuracy: 3
  },
  {
    postalCode: 5302,
    city: "Lameroo",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.329,
    longitude: 140.5167,
    accuracy: 4
  },
  {
    postalCode: 5303,
    city: "Parilla",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.3,
    longitude: 140.6667,
    accuracy: 4
  },
  {
    postalCode: 5304,
    city: "Pinnaroo",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2616,
    longitude: 140.912,
    accuracy: 4
  },
  {
    postalCode: 5304,
    city: "Karte",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0667,
    longitude: 140.7,
    accuracy: 4
  },
  {
    postalCode: 5304,
    city: "Kringin",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9833,
    longitude: 140.7833,
    accuracy: 4
  },
  {
    postalCode: 5304,
    city: "Peebinga",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9333,
    longitude: 140.9167,
    accuracy: 4
  },
  {
    postalCode: 5306,
    city: "Wynarka",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1333,
    longitude: 139.7333,
    accuracy: 4
  },
  {
    postalCode: 5307,
    city: "Karoonda",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0945,
    longitude: 139.8934,
    accuracy: 4
  },
  {
    postalCode: 5307,
    city: "Marama",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1833,
    longitude: 140.1833,
    accuracy: 4
  },
  {
    postalCode: 5308,
    city: "Galga",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6994,
    longitude: 139.9646,
    accuracy: 4
  },
  {
    postalCode: 5308,
    city: "Copeville",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7973,
    longitude: 139.8431,
    accuracy: 4
  },
  {
    postalCode: 5308,
    city: "Perponda",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9875,
    longitude: 139.8122,
    accuracy: 4
  },
  {
    postalCode: 5308,
    city: "Mantung",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6,
    longitude: 140.0667,
    accuracy: 4
  },
  {
    postalCode: 5308,
    city: "Mercunda",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.65,
    longitude: 140.0167,
    accuracy: 4
  },
  {
    postalCode: 5309,
    city: "Mindarie",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8167,
    longitude: 140.2167,
    accuracy: 4
  },
  {
    postalCode: 5309,
    city: "Halidon",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8833,
    longitude: 140.1667,
    accuracy: 4
  },
  {
    postalCode: 5309,
    city: "Sandalwood",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.95,
    longitude: 140.1333,
    accuracy: 4
  },
  {
    postalCode: 5309,
    city: "Borrika",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0167,
    longitude: 140.05,
    accuracy: 4
  },
  {
    postalCode: 5310,
    city: "Caliph",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6667,
    longitude: 140.2833,
    accuracy: 4
  },
  {
    postalCode: 5310,
    city: "Wanbi",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7667,
    longitude: 140.3167,
    accuracy: 4
  },
  {
    postalCode: 5311,
    city: "Taplan",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5444,
    longitude: 140.8801,
    accuracy: 4
  },
  {
    postalCode: 5311,
    city: "Malpas",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7167,
    longitude: 140.6167,
    accuracy: 4
  },
  {
    postalCode: 5311,
    city: "Bugle Hut",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3774,
    longitude: 140.783,
    accuracy: 4
  },
  {
    postalCode: 5311,
    city: "Maggea",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4833,
    longitude: 140.0667,
    accuracy: 4
  },
  {
    postalCode: 5311,
    city: "Veitch",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6667,
    longitude: 140.5167,
    accuracy: 4
  },
  {
    postalCode: 5311,
    city: "Woodleigh",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5682,
    longitude: 140.7151,
    accuracy: 4
  },
  {
    postalCode: 5311,
    city: "Meribah",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7034,
    longitude: 140.8542,
    accuracy: 4
  },
  {
    postalCode: 5311,
    city: "Taldra",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4228,
    longitude: 140.8887,
    accuracy: 4
  },
  {
    postalCode: 5311,
    city: "Alawoona",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7333,
    longitude: 140.5167,
    accuracy: 4
  },
  {
    postalCode: 5311,
    city: "Wunkar",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5,
    longitude: 140.3,
    accuracy: 4
  },
  {
    postalCode: 5311,
    city: "Schell Well",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6058,
    longitude: 140.6087,
    accuracy: 3
  },
  {
    postalCode: 5311,
    city: "Paruna",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7167,
    longitude: 140.7333,
    accuracy: 4
  },
  {
    postalCode: 5311,
    city: "Billiatt",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6058,
    longitude: 140.6087,
    accuracy: 3
  },
  {
    postalCode: 5312,
    city: "Veitch",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6667,
    longitude: 140.5167,
    accuracy: 4
  },
  {
    postalCode: 5320,
    city: "Stuart",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.0249,
    longitude: 137.5247,
    accuracy: 4
  },
  {
    postalCode: 5320,
    city: "Eba",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0669,
    longitude: 139.579,
    accuracy: 4
  },
  {
    postalCode: 5320,
    city: "Beatty",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0991,
    longitude: 139.659,
    accuracy: 3
  },
  {
    postalCode: 5320,
    city: "Murbko",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1631,
    longitude: 139.6629,
    accuracy: 4
  },
  {
    postalCode: 5320,
    city: "Morgan",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0315,
    longitude: 139.668,
    accuracy: 4
  },
  {
    postalCode: 5320,
    city: "Beaumonts",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0991,
    longitude: 139.659,
    accuracy: 3
  },
  {
    postalCode: 5320,
    city: "Wombats Rest",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0991,
    longitude: 139.659,
    accuracy: 3
  },
  {
    postalCode: 5320,
    city: "North West Bend",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0991,
    longitude: 139.659,
    accuracy: 3
  },
  {
    postalCode: 5320,
    city: "Morphetts Flat",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0991,
    longitude: 139.659,
    accuracy: 3
  },
  {
    postalCode: 5320,
    city: "Brenda Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0991,
    longitude: 139.659,
    accuracy: 3
  },
  {
    postalCode: 5320,
    city: "Bundey",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0991,
    longitude: 139.659,
    accuracy: 3
  },
  {
    postalCode: 5320,
    city: "Maude",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0991,
    longitude: 139.659,
    accuracy: 3
  },
  {
    postalCode: 5320,
    city: "Lindley",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0991,
    longitude: 139.659,
    accuracy: 3
  },
  {
    postalCode: 5321,
    city: "Cadell",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0388,
    longitude: 139.7639,
    accuracy: 4
  },
  {
    postalCode: 5321,
    city: "Cadell Lagoon",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0333,
    longitude: 139.75,
    accuracy: 3
  },
  {
    postalCode: 5322,
    city: "Golden Heights",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1417,
    longitude: 139.9,
    accuracy: 3
  },
  {
    postalCode: 5322,
    city: "Sunlands",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1417,
    longitude: 139.9,
    accuracy: 3
  },
  {
    postalCode: 5322,
    city: "Ramco Heights",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1417,
    longitude: 139.9,
    accuracy: 3
  },
  {
    postalCode: 5322,
    city: "Ramco",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1667,
    longitude: 139.9333,
    accuracy: 4
  },
  {
    postalCode: 5322,
    city: "Qualco",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1103,
    longitude: 139.8933,
    accuracy: 4
  },
  {
    postalCode: 5330,
    city: "Wigley Flat",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1621,
    longitude: 140.0839,
    accuracy: 3
  },
  {
    postalCode: 5330,
    city: "Boolgun",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4173,
    longitude: 140.04,
    accuracy: 4
  },
  {
    postalCode: 5330,
    city: "Kanni",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1621,
    longitude: 140.0839,
    accuracy: 3
  },
  {
    postalCode: 5330,
    city: "Waikerie",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1818,
    longitude: 139.9855,
    accuracy: 4
  },
  {
    postalCode: 5330,
    city: "Devlins Pound",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1621,
    longitude: 140.0839,
    accuracy: 3
  },
  {
    postalCode: 5330,
    city: "Taylorville",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0989,
    longitude: 139.9731,
    accuracy: 4
  },
  {
    postalCode: 5330,
    city: "Pooginook",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1621,
    longitude: 140.0839,
    accuracy: 3
  },
  {
    postalCode: 5330,
    city: "Overland Corner",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1458,
    longitude: 140.3343,
    accuracy: 4
  },
  {
    postalCode: 5330,
    city: "Stockyard Plain",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1621,
    longitude: 140.0839,
    accuracy: 3
  },
  {
    postalCode: 5330,
    city: "Holder",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3267,
    longitude: 140.0174,
    accuracy: 4
  },
  {
    postalCode: 5330,
    city: "Markaranka",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1621,
    longitude: 140.0839,
    accuracy: 3
  },
  {
    postalCode: 5330,
    city: "Good Hope Landing",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1621,
    longitude: 140.0839,
    accuracy: 3
  },
  {
    postalCode: 5330,
    city: "Holder Siding",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1621,
    longitude: 140.0839,
    accuracy: 3
  },
  {
    postalCode: 5330,
    city: "Woolpunda",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1621,
    longitude: 140.0839,
    accuracy: 3
  },
  {
    postalCode: 5330,
    city: "Lowbank",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1943,
    longitude: 140.0852,
    accuracy: 4
  },
  {
    postalCode: 5331,
    city: "Kingston On Murray",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.325,
    longitude: 140.3517,
    accuracy: 1
  },
  {
    postalCode: 5331,
    city: "Kingston-On-Murray",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.2207,
    longitude: 140.34,
    accuracy: 1
  },
  {
    postalCode: 5332,
    city: "Moorook South",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.2663,
    longitude: 140.3566,
    accuracy: 4
  },
  {
    postalCode: 5332,
    city: "Yinkanie",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3333,
    longitude: 140.3167,
    accuracy: 4
  },
  {
    postalCode: 5332,
    city: "Wappilka",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.2886,
    longitude: 140.3433,
    accuracy: 3
  },
  {
    postalCode: 5332,
    city: "Moorook",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.2663,
    longitude: 140.3566,
    accuracy: 4
  },
  {
    postalCode: 5333,
    city: "Pyap",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4353,
    longitude: 140.4932,
    accuracy: 4
  },
  {
    postalCode: 5333,
    city: "Bookpurnong",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4771,
    longitude: 140.571,
    accuracy: 3
  },
  {
    postalCode: 5333,
    city: "New Residence",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3787,
    longitude: 140.4026,
    accuracy: 4
  },
  {
    postalCode: 5333,
    city: "Pyap West",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4771,
    longitude: 140.571,
    accuracy: 3
  },
  {
    postalCode: 5333,
    city: "Taplan",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5444,
    longitude: 140.8801,
    accuracy: 4
  },
  {
    postalCode: 5333,
    city: "Loxton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4502,
    longitude: 140.5691,
    accuracy: 4
  },
  {
    postalCode: 5333,
    city: "Pata",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5667,
    longitude: 140.5167,
    accuracy: 4
  },
  {
    postalCode: 5333,
    city: "Loxton North",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4183,
    longitude: 140.6266,
    accuracy: 3
  },
  {
    postalCode: 5340,
    city: "Wonuarra",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.2156,
    longitude: 140.8435,
    accuracy: 4
  },
  {
    postalCode: 5340,
    city: "Paringa",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1764,
    longitude: 140.7858,
    accuracy: 4
  },
  {
    postalCode: 5340,
    city: "Yamba",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.2623,
    longitude: 140.8589,
    accuracy: 4
  },
  {
    postalCode: 5340,
    city: "Murtho",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1764,
    longitude: 140.7858,
    accuracy: 3
  },
  {
    postalCode: 5340,
    city: "Pike River",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1764,
    longitude: 140.7858,
    accuracy: 3
  },
  {
    postalCode: 5340,
    city: "Mundic Creek",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1764,
    longitude: 140.7858,
    accuracy: 3
  },
  {
    postalCode: 5341,
    city: "Cooltong",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1006,
    longitude: 140.6737,
    accuracy: 4
  },
  {
    postalCode: 5341,
    city: "Renmark South",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.2016,
    longitude: 140.7106,
    accuracy: 3
  },
  {
    postalCode: 5341,
    city: "Renmark West",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1653,
    longitude: 140.7097,
    accuracy: 4
  },
  {
    postalCode: 5341,
    city: "Renmark",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.177,
    longitude: 140.747,
    accuracy: 4
  },
  {
    postalCode: 5341,
    city: "Crescent",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1481,
    longitude: 140.704,
    accuracy: 3
  },
  {
    postalCode: 5341,
    city: "Chaffey",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0934,
    longitude: 140.7065,
    accuracy: 4
  },
  {
    postalCode: 5341,
    city: "Renmark North",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1255,
    longitude: 140.7127,
    accuracy: 4
  },
  {
    postalCode: 5341,
    city: "Old Calperum",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.2178,
    longitude: 140.6803,
    accuracy: 4
  },
  {
    postalCode: 5342,
    city: "Monash",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.2384,
    longitude: 140.5613,
    accuracy: 4
  },
  {
    postalCode: 5343,
    city: "Lyrup",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.2579,
    longitude: 140.6482,
    accuracy: 4
  },
  {
    postalCode: 5343,
    city: "Winkie",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3,
    longitude: 140.5333,
    accuracy: 4
  },
  {
    postalCode: 5343,
    city: "Berri",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.2811,
    longitude: 140.5996,
    accuracy: 4
  },
  {
    postalCode: 5343,
    city: "Katarapko",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4424,
    longitude: 140.559,
    accuracy: 4
  },
  {
    postalCode: 5343,
    city: "Gerard",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.2826,
    longitude: 140.5943,
    accuracy: 3
  },
  {
    postalCode: 5343,
    city: "Gurra Gurra",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.2826,
    longitude: 140.5943,
    accuracy: 3
  },
  {
    postalCode: 5344,
    city: "Glossop",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.2769,
    longitude: 140.541,
    accuracy: 4
  },
  {
    postalCode: 5345,
    city: "Spectacle Lake",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.2695,
    longitude: 140.4474,
    accuracy: 3
  },
  {
    postalCode: 5345,
    city: "Barmera",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.2556,
    longitude: 140.4615,
    accuracy: 4
  },
  {
    postalCode: 5345,
    city: "Loveday",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.2833,
    longitude: 140.4333,
    accuracy: 4
  },
  {
    postalCode: 5346,
    city: "Cobdogla",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.2438,
    longitude: 140.4043,
    accuracy: 4
  },
  {
    postalCode: 5350,
    city: "Sandy Creek",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5848,
    longitude: 138.8205,
    accuracy: 3
  },
  {
    postalCode: 5350,
    city: "Rosedale",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.55,
    longitude: 138.85,
    accuracy: 4
  },
  {
    postalCode: 5351,
    city: "Cockatoo Valley",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6248,
    longitude: 138.8365,
    accuracy: 4
  },
  {
    postalCode: 5351,
    city: "Pewsey Vale",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6313,
    longitude: 138.8964,
    accuracy: 3
  },
  {
    postalCode: 5351,
    city: "Williamstown",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6721,
    longitude: 138.8911,
    accuracy: 4
  },
  {
    postalCode: 5351,
    city: "Lyndoch",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6012,
    longitude: 138.8909,
    accuracy: 4
  },
  {
    postalCode: 5351,
    city: "Altona",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5962,
    longitude: 138.914,
    accuracy: 4
  },
  {
    postalCode: 5351,
    city: "Barossa Goldfields",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6516,
    longitude: 138.8354,
    accuracy: 4
  },
  {
    postalCode: 5351,
    city: "Mount Crawford",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6667,
    longitude: 138.95,
    accuracy: 4
  },
  {
    postalCode: 5352,
    city: "Vine Vale",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5145,
    longitude: 139.0054,
    accuracy: 4
  },
  {
    postalCode: 5352,
    city: "Krondorf",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5413,
    longitude: 138.9486,
    accuracy: 3
  },
  {
    postalCode: 5352,
    city: "Rowland Flat",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5833,
    longitude: 138.9333,
    accuracy: 4
  },
  {
    postalCode: 5352,
    city: "Stone Well",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5358,
    longitude: 138.8762,
    accuracy: 3
  },
  {
    postalCode: 5352,
    city: "Tanunda",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5234,
    longitude: 138.9598,
    accuracy: 4
  },
  {
    postalCode: 5352,
    city: "Bethany",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5333,
    longitude: 138.9667,
    accuracy: 4
  },
  {
    postalCode: 5352,
    city: "Gomersal",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.55,
    longitude: 138.8833,
    accuracy: 4
  },
  {
    postalCode: 5353,
    city: "Angaston",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5013,
    longitude: 139.0462,
    accuracy: 4
  },
  {
    postalCode: 5353,
    city: "Langs Landing",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5798,
    longitude: 139.2255,
    accuracy: 3
  },
  {
    postalCode: 5353,
    city: "Kongolia",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.65,
    longitude: 139.3667,
    accuracy: 4
  },
  {
    postalCode: 5353,
    city: "Black Hill",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7027,
    longitude: 139.4575,
    accuracy: 4
  },
  {
    postalCode: 5353,
    city: "Towitta",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5333,
    longitude: 139.25,
    accuracy: 4
  },
  {
    postalCode: 5353,
    city: "Sunnydale",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5798,
    longitude: 139.2255,
    accuracy: 3
  },
  {
    postalCode: 5353,
    city: "Moculta",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4687,
    longitude: 139.1186,
    accuracy: 4
  },
  {
    postalCode: 5353,
    city: "Cambrai",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.65,
    longitude: 139.2833,
    accuracy: 4
  },
  {
    postalCode: 5353,
    city: "Keyneton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5542,
    longitude: 139.1349,
    accuracy: 4
  },
  {
    postalCode: 5353,
    city: "Marks Landing",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5798,
    longitude: 139.2255,
    accuracy: 3
  },
  {
    postalCode: 5353,
    city: "Mount Mckenzie",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.565,
    longitude: 139.0884,
    accuracy: 4
  },
  {
    postalCode: 5353,
    city: "Sedan",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5833,
    longitude: 139.3,
    accuracy: 4
  },
  {
    postalCode: 5353,
    city: "Punyelroo",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5798,
    longitude: 139.2255,
    accuracy: 3
  },
  {
    postalCode: 5353,
    city: "Penrice",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5798,
    longitude: 139.2255,
    accuracy: 3
  },
  {
    postalCode: 5354,
    city: "Bakara",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6635,
    longitude: 139.7823,
    accuracy: 4
  },
  {
    postalCode: 5354,
    city: "Swan Reach",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5666,
    longitude: 139.5975,
    accuracy: 4
  },
  {
    postalCode: 5354,
    city: "Naidia",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5167,
    longitude: 139.8167,
    accuracy: 4
  },
  {
    postalCode: 5354,
    city: "Fisher",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5833,
    longitude: 139.7269,
    accuracy: 3
  },
  {
    postalCode: 5354,
    city: "Bakara Well",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5833,
    longitude: 139.7269,
    accuracy: 3
  },
  {
    postalCode: 5355,
    city: "Light Pass",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4716,
    longitude: 139.0229,
    accuracy: 4
  },
  {
    postalCode: 5355,
    city: "Moppa",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4167,
    longitude: 139.95,
    accuracy: 4
  },
  {
    postalCode: 5355,
    city: "Daveyston",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4692,
    longitude: 138.8815,
    accuracy: 4
  },
  {
    postalCode: 5355,
    city: "Ebenezer",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4537,
    longitude: 139.1629,
    accuracy: 3
  },
  {
    postalCode: 5355,
    city: "Marananga",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4856,
    longitude: 138.9398,
    accuracy: 4
  },
  {
    postalCode: 5355,
    city: "Nuriootpa",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4682,
    longitude: 138.9977,
    accuracy: 4
  },
  {
    postalCode: 5355,
    city: "Stockwell",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4346,
    longitude: 139.0536,
    accuracy: 4
  },
  {
    postalCode: 5355,
    city: "Seppeltsfield",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4617,
    longitude: 138.9575,
    accuracy: 3
  },
  {
    postalCode: 5356,
    city: "Annadale",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3914,
    longitude: 139.3489,
    accuracy: 4
  },
  {
    postalCode: 5356,
    city: "Truro",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4087,
    longitude: 139.1274,
    accuracy: 4
  },
  {
    postalCode: 5356,
    city: "Dutton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3667,
    longitude: 139.1333,
    accuracy: 4
  },
  {
    postalCode: 5356,
    city: "Dutton East",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4033,
    longitude: 139.24,
    accuracy: 3
  },
  {
    postalCode: 5356,
    city: "Steinfeld",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4033,
    longitude: 139.24,
    accuracy: 3
  },
  {
    postalCode: 5356,
    city: "St Kitts",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4033,
    longitude: 139.24,
    accuracy: 3
  },
  {
    postalCode: 5356,
    city: "Stonefield",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3667,
    longitude: 139.2833,
    accuracy: 4
  },
  {
    postalCode: 5356,
    city: "Sandleton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4667,
    longitude: 139.3333,
    accuracy: 4
  },
  {
    postalCode: 5357,
    city: "Notts Well",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4159,
    longitude: 139.7875,
    accuracy: 4
  },
  {
    postalCode: 5357,
    city: "Paisley",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3844,
    longitude: 139.7604,
    accuracy: 3
  },
  {
    postalCode: 5357,
    city: "Blanchetown",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3531,
    longitude: 139.6145,
    accuracy: 4
  },
  {
    postalCode: 5357,
    city: "Mcbean Pound",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3844,
    longitude: 139.7604,
    accuracy: 3
  },
  {
    postalCode: 5357,
    city: "New Well",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3874,
    longitude: 139.9239,
    accuracy: 4
  },
  {
    postalCode: 5360,
    city: "Greenock",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.457,
    longitude: 138.9272,
    accuracy: 4
  },
  {
    postalCode: 5360,
    city: "Nain",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.457,
    longitude: 138.9272,
    accuracy: 3
  },
  {
    postalCode: 5371,
    city: "Roseworthy",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.534,
    longitude: 138.7502,
    accuracy: 4
  },
  {
    postalCode: 5371,
    city: "Shea-Oak Log",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5167,
    longitude: 138.8167,
    accuracy: 4
  },
  {
    postalCode: 5371,
    city: "Morn Hill",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5058,
    longitude: 138.7723,
    accuracy: 3
  },
  {
    postalCode: 5371,
    city: "Templers",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4684,
    longitude: 138.7468,
    accuracy: 4
  },
  {
    postalCode: 5372,
    city: "Freeling",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4541,
    longitude: 138.8087,
    accuracy: 4
  },
  {
    postalCode: 5373,
    city: "Fords",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3853,
    longitude: 138.8749,
    accuracy: 4
  },
  {
    postalCode: 5373,
    city: "Bethel",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3278,
    longitude: 138.8376,
    accuracy: 4
  },
  {
    postalCode: 5373,
    city: "Hamilton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.2167,
    longitude: 138.8667,
    accuracy: 4
  },
  {
    postalCode: 5373,
    city: "Allendale North",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3011,
    longitude: 138.9147,
    accuracy: 4
  },
  {
    postalCode: 5373,
    city: "St Johns",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3259,
    longitude: 138.9,
    accuracy: 3
  },
  {
    postalCode: 5373,
    city: "Koonunga",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3804,
    longitude: 138.9902,
    accuracy: 4
  },
  {
    postalCode: 5373,
    city: "Kapunda",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3387,
    longitude: 138.9164,
    accuracy: 4
  },
  {
    postalCode: 5373,
    city: "Bagot Well",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3259,
    longitude: 138.9,
    accuracy: 3
  },
  {
    postalCode: 5374,
    city: "Hampden",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.15,
    longitude: 139.05,
    accuracy: 4
  },
  {
    postalCode: 5374,
    city: "Mount Mary",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1,
    longitude: 139.4333,
    accuracy: 4
  },
  {
    postalCode: 5374,
    city: "Frankton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.29,
    longitude: 139.2054,
    accuracy: 4
  },
  {
    postalCode: 5374,
    city: "Buchanan",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1453,
    longitude: 139.1626,
    accuracy: 3
  },
  {
    postalCode: 5374,
    city: "Julia",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1077,
    longitude: 139.0204,
    accuracy: 4
  },
  {
    postalCode: 5374,
    city: "Bower",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1241,
    longitude: 139.3512,
    accuracy: 4
  },
  {
    postalCode: 5374,
    city: "Brownlow",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.2454,
    longitude: 139.2693,
    accuracy: 4
  },
  {
    postalCode: 5374,
    city: "Sutherlands",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1544,
    longitude: 139.2223,
    accuracy: 4
  },
  {
    postalCode: 5374,
    city: "Point Pass",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0757,
    longitude: 139.0506,
    accuracy: 4
  },
  {
    postalCode: 5374,
    city: "Eudunda",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.177,
    longitude: 139.0841,
    accuracy: 4
  },
  {
    postalCode: 5374,
    city: "Australia Plains",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.097,
    longitude: 139.1562,
    accuracy: 4
  },
  {
    postalCode: 5374,
    city: "Neales Flat",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1453,
    longitude: 139.1626,
    accuracy: 3
  },
  {
    postalCode: 5374,
    city: "Ngapala",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0714,
    longitude: 138.9917,
    accuracy: 4
  },
  {
    postalCode: 5374,
    city: "Peep Hill",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1459,
    longitude: 139.1544,
    accuracy: 4
  },
  {
    postalCode: 5374,
    city: "Hansborough",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1453,
    longitude: 139.1626,
    accuracy: 3
  },
  {
    postalCode: 5381,
    city: "Brady Creek",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.9739,
    longitude: 138.9816,
    accuracy: 4
  },
  {
    postalCode: 5381,
    city: "Robertstown",
    state_name: "South Australia",
    state: "SA",
    latitude: -34,
    longitude: 139.0667,
    accuracy: 4
  },
  {
    postalCode: 5381,
    city: "Rocky Plain",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.9277,
    longitude: 139.0539,
    accuracy: 3
  },
  {
    postalCode: 5381,
    city: "Worlds End",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.8327,
    longitude: 139.0567,
    accuracy: 4
  },
  {
    postalCode: 5381,
    city: "Hallelujah Hills",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.9277,
    longitude: 139.0539,
    accuracy: 3
  },
  {
    postalCode: 5381,
    city: "Geranium Plains",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.9667,
    longitude: 139.1667,
    accuracy: 4
  },
  {
    postalCode: 5381,
    city: "Emu Downs",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.9,
    longitude: 138.9667,
    accuracy: 4
  },
  {
    postalCode: 5381,
    city: "Bright",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.9,
    longitude: 139.0667,
    accuracy: 4
  },
  {
    postalCode: 5400,
    city: "Magdala",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4699,
    longitude: 138.6856,
    accuracy: 3
  },
  {
    postalCode: 5400,
    city: "Pinkerton Plains",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4485,
    longitude: 138.6731,
    accuracy: 3
  },
  {
    postalCode: 5400,
    city: "Woolsheds",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4699,
    longitude: 138.6856,
    accuracy: 3
  },
  {
    postalCode: 5400,
    city: "Wasleys",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4699,
    longitude: 138.6856,
    accuracy: 4
  },
  {
    postalCode: 5401,
    city: "Alma",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.2668,
    longitude: 138.6304,
    accuracy: 4
  },
  {
    postalCode: 5401,
    city: "Hamley Bridge",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3576,
    longitude: 138.6807,
    accuracy: 4
  },
  {
    postalCode: 5401,
    city: "Salter Springs",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1843,
    longitude: 138.6347,
    accuracy: 4
  },
  {
    postalCode: 5410,
    city: "Linwood",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3603,
    longitude: 138.7679,
    accuracy: 4
  },
  {
    postalCode: 5410,
    city: "Stockport",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.334,
    longitude: 138.732,
    accuracy: 4
  },
  {
    postalCode: 5411,
    city: "Tarlee",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.2716,
    longitude: 138.7713,
    accuracy: 4
  },
  {
    postalCode: 5411,
    city: "Giles Corner",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.223,
    longitude: 138.729,
    accuracy: 4
  },
  {
    postalCode: 5412,
    city: "Woolshed Flat",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1442,
    longitude: 138.7241,
    accuracy: 3
  },
  {
    postalCode: 5412,
    city: "Riverton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1551,
    longitude: 138.7482,
    accuracy: 4
  },
  {
    postalCode: 5412,
    city: "Navan",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1442,
    longitude: 138.7241,
    accuracy: 3
  },
  {
    postalCode: 5412,
    city: "Rhynie",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1483,
    longitude: 138.6895,
    accuracy: 4
  },
  {
    postalCode: 5413,
    city: "Marrabel",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.15,
    longitude: 138.8667,
    accuracy: 4
  },
  {
    postalCode: 5413,
    city: "Waterloo",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.9833,
    longitude: 138.8667,
    accuracy: 4
  },
  {
    postalCode: 5413,
    city: "Tothill Belt",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0457,
    longitude: 138.8872,
    accuracy: 3
  },
  {
    postalCode: 5413,
    city: "Apoinga",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.9279,
    longitude: 138.939,
    accuracy: 4
  },
  {
    postalCode: 5413,
    city: "Black Springs",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.9,
    longitude: 138.9,
    accuracy: 4
  },
  {
    postalCode: 5413,
    city: "Tarnma",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.15,
    longitude: 138.95,
    accuracy: 4
  },
  {
    postalCode: 5413,
    city: "Saddleworth",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0826,
    longitude: 138.7806,
    accuracy: 4
  },
  {
    postalCode: 5413,
    city: "Steelton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.05,
    longitude: 138.8833,
    accuracy: 4
  },
  {
    postalCode: 5413,
    city: "Tothill Creek",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1,
    longitude: 138.9167,
    accuracy: 4
  },
  {
    postalCode: 5414,
    city: "Manoora",
    state_name: "South Australia",
    state: "SA",
    latitude: -34,
    longitude: 138.8167,
    accuracy: 4
  },
  {
    postalCode: 5415,
    city: "Stanley",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.9167,
    longitude: 138.7167,
    accuracy: 3
  },
  {
    postalCode: 5415,
    city: "Mintaro",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.9173,
    longitude: 138.7215,
    accuracy: 4
  },
  {
    postalCode: 5416,
    city: "Farrell Flat",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.8295,
    longitude: 138.7927,
    accuracy: 1
  },
  {
    postalCode: 5416,
    city: "Porter Lagoon",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.8857,
    longitude: 138.8563,
    accuracy: 1
  },
  {
    postalCode: 5417,
    city: "Mongolata",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.5667,
    longitude: 139.1,
    accuracy: 4
  },
  {
    postalCode: 5417,
    city: "Burra",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.6717,
    longitude: 138.9283,
    accuracy: 4
  },
  {
    postalCode: 5417,
    city: "Leighton",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.65,
    longitude: 138.75,
    accuracy: 4
  },
  {
    postalCode: 5417,
    city: "Koonoona",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.6138,
    longitude: 138.8821,
    accuracy: 3
  },
  {
    postalCode: 5417,
    city: "Booborowie",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.5667,
    longitude: 138.75,
    accuracy: 4
  },
  {
    postalCode: 5417,
    city: "Gum Creek",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.6138,
    longitude: 138.8821,
    accuracy: 3
  },
  {
    postalCode: 5417,
    city: "Baldina",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.6138,
    longitude: 138.8821,
    accuracy: 3
  },
  {
    postalCode: 5417,
    city: "Hanson",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.6138,
    longitude: 138.8821,
    accuracy: 3
  },
  {
    postalCode: 5417,
    city: "North Booborowie",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.6138,
    longitude: 138.8821,
    accuracy: 3
  },
  {
    postalCode: 5417,
    city: "Burra Eastern Districts",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.6138,
    longitude: 138.8821,
    accuracy: 3
  },
  {
    postalCode: 5418,
    city: "Mount Bryan",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.4047,
    longitude: 139.0184,
    accuracy: 4
  },
  {
    postalCode: 5418,
    city: "Collinsville",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.3333,
    longitude: 139.15,
    accuracy: 4
  },
  {
    postalCode: 5419,
    city: "Hallett",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.4,
    longitude: 138.8833,
    accuracy: 4
  },
  {
    postalCode: 5419,
    city: "Canowie",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.4,
    longitude: 138.75,
    accuracy: 4
  },
  {
    postalCode: 5419,
    city: "Mount Bryan East",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.4047,
    longitude: 139.0184,
    accuracy: 4
  },
  {
    postalCode: 5419,
    city: "Wonna",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.4,
    longitude: 138.8833,
    accuracy: 3
  },
  {
    postalCode: 5419,
    city: "Willalo",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.4,
    longitude: 138.8833,
    accuracy: 3
  },
  {
    postalCode: 5419,
    city: "Pine Creek",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.4,
    longitude: 138.8833,
    accuracy: 3
  },
  {
    postalCode: 5419,
    city: "Ulooloo",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.4,
    longitude: 138.8833,
    accuracy: 3
  },
  {
    postalCode: 5420,
    city: "Canowie Belt",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.1826,
    longitude: 138.7625,
    accuracy: 4
  },
  {
    postalCode: 5420,
    city: "Whyte Yarcowie",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.2047,
    longitude: 139.0367,
    accuracy: 3
  },
  {
    postalCode: 5421,
    city: "Franklyn",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.1352,
    longitude: 139.0737,
    accuracy: 4
  },
  {
    postalCode: 5421,
    city: "Terowie",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.1667,
    longitude: 138.9,
    accuracy: 4
  },
  {
    postalCode: 5422,
    city: "Ucolta",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.95,
    longitude: 138.9667,
    accuracy: 4
  },
  {
    postalCode: 5422,
    city: "Yatina",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.9333,
    longitude: 138.6667,
    accuracy: 4
  },
  {
    postalCode: 5422,
    city: "Peterborough",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.9721,
    longitude: 138.8407,
    accuracy: 4
  },
  {
    postalCode: 5422,
    city: "Erskine",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.7333,
    longitude: 138.85,
    accuracy: 4
  },
  {
    postalCode: 5422,
    city: "Mannanarie",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.0443,
    longitude: 138.6185,
    accuracy: 4
  },
  {
    postalCode: 5422,
    city: "Hardy",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.8905,
    longitude: 138.9224,
    accuracy: 3
  },
  {
    postalCode: 5422,
    city: "Paratoo",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.7326,
    longitude: 139.3366,
    accuracy: 4
  },
  {
    postalCode: 5422,
    city: "Minvalara",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.9,
    longitude: 138.75,
    accuracy: 4
  },
  {
    postalCode: 5422,
    city: "Parnaroo",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.9786,
    longitude: 139.1553,
    accuracy: 4
  },
  {
    postalCode: 5422,
    city: "Oodla Wirra",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.8833,
    longitude: 139.0667,
    accuracy: 4
  },
  {
    postalCode: 5422,
    city: "Dawson",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.8,
    longitude: 138.9667,
    accuracy: 4
  },
  {
    postalCode: 5422,
    city: "Cavenagh",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.8905,
    longitude: 138.9224,
    accuracy: 3
  },
  {
    postalCode: 5422,
    city: "Sunnybrae",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.8905,
    longitude: 138.9224,
    accuracy: 3
  },
  {
    postalCode: 5431,
    city: "Orroroo",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.7344,
    longitude: 138.6139,
    accuracy: 4
  },
  {
    postalCode: 5431,
    city: "Black Rock",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.8333,
    longitude: 138.7,
    accuracy: 4
  },
  {
    postalCode: 5431,
    city: "Amyton",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.6,
    longitude: 138.3333,
    accuracy: 4
  },
  {
    postalCode: 5431,
    city: "Minburra",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.6695,
    longitude: 138.5539,
    accuracy: 3
  },
  {
    postalCode: 5431,
    city: "Walloway",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.6333,
    longitude: 138.5833,
    accuracy: 4
  },
  {
    postalCode: 5431,
    city: "Willowie",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.6833,
    longitude: 138.3333,
    accuracy: 4
  },
  {
    postalCode: 5431,
    city: "Johnburgh",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.45,
    longitude: 138.7,
    accuracy: 4
  },
  {
    postalCode: 5431,
    city: "Coomooroo",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.6695,
    longitude: 138.5539,
    accuracy: 3
  },
  {
    postalCode: 5431,
    city: "Hammond",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.5167,
    longitude: 138.3167,
    accuracy: 4
  },
  {
    postalCode: 5431,
    city: "Eurelia",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.55,
    longitude: 138.5667,
    accuracy: 4
  },
  {
    postalCode: 5431,
    city: "Pekina",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.8333,
    longitude: 138.55,
    accuracy: 4
  },
  {
    postalCode: 5431,
    city: "Yalpara",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.5333,
    longitude: 138.9333,
    accuracy: 4
  },
  {
    postalCode: 5431,
    city: "Tarcowie",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.95,
    longitude: 138.5167,
    accuracy: 4
  },
  {
    postalCode: 5431,
    city: "Morchard",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.7167,
    longitude: 138.5,
    accuracy: 4
  },
  {
    postalCode: 5432,
    city: "Yanyarrie",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.3042,
    longitude: 138.5417,
    accuracy: 3
  },
  {
    postalCode: 5432,
    city: "Carrieton",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.4333,
    longitude: 138.5333,
    accuracy: 4
  },
  {
    postalCode: 5432,
    city: "Belton",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.2333,
    longitude: 138.7,
    accuracy: 4
  },
  {
    postalCode: 5432,
    city: "Cradock",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.0833,
    longitude: 138.5,
    accuracy: 4
  },
  {
    postalCode: 5432,
    city: "Moockra",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.4667,
    longitude: 138.4333,
    accuracy: 4
  },
  {
    postalCode: 5433,
    city: "Quorn",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.3468,
    longitude: 138.0418,
    accuracy: 4
  },
  {
    postalCode: 5433,
    city: "Stephenston",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.3489,
    longitude: 138.125,
    accuracy: 3
  },
  {
    postalCode: 5433,
    city: "Willochra",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.2333,
    longitude: 138.1333,
    accuracy: 4
  },
  {
    postalCode: 5433,
    city: "Yarrah",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.3489,
    longitude: 138.125,
    accuracy: 3
  },
  {
    postalCode: 5433,
    city: "Bruce",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.4667,
    longitude: 138.2,
    accuracy: 4
  },
  {
    postalCode: 5433,
    city: "Saltia",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.3489,
    longitude: 138.125,
    accuracy: 3
  },
  {
    postalCode: 5434,
    city: "Hawker",
    state_name: "South Australia",
    state: "SA",
    latitude: -31.8892,
    longitude: 138.42,
    accuracy: 4
  },
  {
    postalCode: 5434,
    city: "Barndioota",
    state_name: "South Australia",
    state: "SA",
    latitude: -31.8892,
    longitude: 138.42,
    accuracy: 3
  },
  {
    postalCode: 5434,
    city: "Kanyaka",
    state_name: "South Australia",
    state: "SA",
    latitude: -31.8892,
    longitude: 138.42,
    accuracy: 3
  },
  {
    postalCode: 5440,
    city: "Waukaringa",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.3,
    longitude: 139.4333,
    accuracy: 4
  },
  {
    postalCode: 5440,
    city: "Yunta",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.5833,
    longitude: 139.55,
    accuracy: 4
  },
  {
    postalCode: 5440,
    city: "Nackara",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.8,
    longitude: 139.2333,
    accuracy: 4
  },
  {
    postalCode: 5440,
    city: "Mingary",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.1355,
    longitude: 140.7367,
    accuracy: 4
  },
  {
    postalCode: 5440,
    city: "Olary",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.2829,
    longitude: 140.3311,
    accuracy: 4
  },
  {
    postalCode: 5440,
    city: "Cockburn",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.0762,
    longitude: 140.9902,
    accuracy: 4
  },
  {
    postalCode: 5440,
    city: "Manna Hill",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.433,
    longitude: 139.9903,
    accuracy: 4
  },
  {
    postalCode: 5451,
    city: "Auburn",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0269,
    longitude: 138.6852,
    accuracy: 4
  },
  {
    postalCode: 5451,
    city: "Undalya",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0667,
    longitude: 138.6833,
    accuracy: 4
  },
  {
    postalCode: 5452,
    city: "Watervale",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.9942,
    longitude: 138.6248,
    accuracy: 1
  },
  {
    postalCode: 5452,
    city: "Leasingham",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.9942,
    longitude: 138.6248,
    accuracy: 1
  },
  {
    postalCode: 5453,
    city: "Armagh",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.825,
    longitude: 138.5748,
    accuracy: 4
  },
  {
    postalCode: 5453,
    city: "Hill River",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.8972,
    longitude: 138.5785,
    accuracy: 3
  },
  {
    postalCode: 5453,
    city: "Clare",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.8332,
    longitude: 138.6106,
    accuracy: 4
  },
  {
    postalCode: 5453,
    city: "Spring Farm",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.8972,
    longitude: 138.5785,
    accuracy: 3
  },
  {
    postalCode: 5453,
    city: "Hoyleton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0333,
    longitude: 138.55,
    accuracy: 4
  },
  {
    postalCode: 5453,
    city: "Stanley Flat",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.8972,
    longitude: 138.5785,
    accuracy: 3
  },
  {
    postalCode: 5453,
    city: "Barinia",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.8972,
    longitude: 138.5785,
    accuracy: 3
  },
  {
    postalCode: 5453,
    city: "Sevenhill",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.8972,
    longitude: 138.5785,
    accuracy: 3
  },
  {
    postalCode: 5453,
    city: "Boconnoc Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.8972,
    longitude: 138.5785,
    accuracy: 3
  },
  {
    postalCode: 5453,
    city: "Kybunga",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.8972,
    longitude: 138.5785,
    accuracy: 3
  },
  {
    postalCode: 5453,
    city: "Penwortham",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.8972,
    longitude: 138.5785,
    accuracy: 3
  },
  {
    postalCode: 5453,
    city: "Emu Flat",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.8972,
    longitude: 138.5785,
    accuracy: 3
  },
  {
    postalCode: 5453,
    city: "Spring Gully",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.8972,
    longitude: 138.5785,
    accuracy: 3
  },
  {
    postalCode: 5453,
    city: "Benbournie",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.8972,
    longitude: 138.5785,
    accuracy: 3
  },
  {
    postalCode: 5453,
    city: "Gillentown",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.8972,
    longitude: 138.5785,
    accuracy: 3
  },
  {
    postalCode: 5453,
    city: "Polish Hill River",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.8972,
    longitude: 138.5785,
    accuracy: 3
  },
  {
    postalCode: 5454,
    city: "Spalding",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.4979,
    longitude: 138.6075,
    accuracy: 4
  },
  {
    postalCode: 5454,
    city: "Mayfield",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0871,
    longitude: 138.6347,
    accuracy: 3
  },
  {
    postalCode: 5454,
    city: "Andrews",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6763,
    longitude: 138.662,
    accuracy: 4
  },
  {
    postalCode: 5454,
    city: "Hacklins Corner",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0871,
    longitude: 138.6347,
    accuracy: 3
  },
  {
    postalCode: 5454,
    city: "Washpool",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0871,
    longitude: 138.6347,
    accuracy: 3
  },
  {
    postalCode: 5454,
    city: "Euromina",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0871,
    longitude: 138.6347,
    accuracy: 3
  },
  {
    postalCode: 5454,
    city: "Broughton River Valley",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0871,
    longitude: 138.6347,
    accuracy: 3
  },
  {
    postalCode: 5455,
    city: "Hilltown",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.8458,
    longitude: 138.6125,
    accuracy: 1
  },
  {
    postalCode: 5460,
    city: "Pinery",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3,
    longitude: 138.45,
    accuracy: 4
  },
  {
    postalCode: 5460,
    city: "Owen",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.272,
    longitude: 138.5444,
    accuracy: 4
  },
  {
    postalCode: 5460,
    city: "Barabba",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.345,
    longitude: 138.5899,
    accuracy: 4
  },
  {
    postalCode: 5460,
    city: "Stockyard Creek",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3003,
    longitude: 138.5852,
    accuracy: 4
  },
  {
    postalCode: 5461,
    city: "Goyder",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0851,
    longitude: 138.3993,
    accuracy: 3
  },
  {
    postalCode: 5461,
    city: "Stow",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.9833,
    longitude: 138.3667,
    accuracy: 4
  },
  {
    postalCode: 5461,
    city: "Whitwarta",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1,
    longitude: 138.3333,
    accuracy: 4
  },
  {
    postalCode: 5461,
    city: "Saints",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.15,
    longitude: 138.3167,
    accuracy: 4
  },
  {
    postalCode: 5461,
    city: "Hoskin Corner",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0851,
    longitude: 138.3993,
    accuracy: 3
  },
  {
    postalCode: 5461,
    city: "Bowillia",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.95,
    longitude: 138.4,
    accuracy: 4
  },
  {
    postalCode: 5461,
    city: "Halbury",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0833,
    longitude: 138.5167,
    accuracy: 4
  },
  {
    postalCode: 5461,
    city: "Erith",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0851,
    longitude: 138.3993,
    accuracy: 3
  },
  {
    postalCode: 5461,
    city: "Dalkey",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1868,
    longitude: 138.4384,
    accuracy: 4
  },
  {
    postalCode: 5461,
    city: "Mount Templeton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0851,
    longitude: 138.3993,
    accuracy: 3
  },
  {
    postalCode: 5461,
    city: "Balaklava",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1454,
    longitude: 138.4115,
    accuracy: 4
  },
  {
    postalCode: 5461,
    city: "Watchman",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0851,
    longitude: 138.3993,
    accuracy: 3
  },
  {
    postalCode: 5461,
    city: "Everard Central",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0851,
    longitude: 138.3993,
    accuracy: 3
  },
  {
    postalCode: 5462,
    city: "Blyth",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.8486,
    longitude: 138.4893,
    accuracy: 4
  },
  {
    postalCode: 5464,
    city: "Anama",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.7,
    longitude: 138.4167,
    accuracy: 3
  },
  {
    postalCode: 5464,
    city: "Condowie",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.7667,
    longitude: 138.3,
    accuracy: 4
  },
  {
    postalCode: 5464,
    city: "Hart",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.7,
    longitude: 138.4167,
    accuracy: 3
  },
  {
    postalCode: 5464,
    city: "Rochester",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.6952,
    longitude: 138.4853,
    accuracy: 4
  },
  {
    postalCode: 5464,
    city: "Koolunga",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.5833,
    longitude: 138.3333,
    accuracy: 4
  },
  {
    postalCode: 5464,
    city: "Bungaree",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.7443,
    longitude: 138.5609,
    accuracy: 4
  },
  {
    postalCode: 5464,
    city: "Marola",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.7,
    longitude: 138.4167,
    accuracy: 3
  },
  {
    postalCode: 5464,
    city: "Brinkworth",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.6954,
    longitude: 138.4035,
    accuracy: 4
  },
  {
    postalCode: 5470,
    city: "Yacka",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.5514,
    longitude: 138.4805,
    accuracy: 1
  },
  {
    postalCode: 5471,
    city: "Gulnare",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.4672,
    longitude: 138.443,
    accuracy: 4
  },
  {
    postalCode: 5472,
    city: "Georgetown",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.3667,
    longitude: 138.4,
    accuracy: 4
  },
  {
    postalCode: 5473,
    city: "Gladstone",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.2669,
    longitude: 138.3566,
    accuracy: 4
  },
  {
    postalCode: 5480,
    city: "Stone Hut",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.1176,
    longitude: 138.3595,
    accuracy: 3
  },
  {
    postalCode: 5480,
    city: "Appila",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.05,
    longitude: 138.4167,
    accuracy: 4
  },
  {
    postalCode: 5480,
    city: "Laura",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.1852,
    longitude: 138.3023,
    accuracy: 4
  },
  {
    postalCode: 5481,
    city: "Wirrabara",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.0338,
    longitude: 138.2692,
    accuracy: 4
  },
  {
    postalCode: 5481,
    city: "Wongyarra",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.9779,
    longitude: 138.2175,
    accuracy: 3
  },
  {
    postalCode: 5481,
    city: "Murray Town",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.9333,
    longitude: 138.2333,
    accuracy: 4
  },
  {
    postalCode: 5481,
    city: "Bangor",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.9667,
    longitude: 138.15,
    accuracy: 4
  },
  {
    postalCode: 5482,
    city: "Wepowie",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.8333,
    longitude: 138.4833,
    accuracy: 4
  },
  {
    postalCode: 5482,
    city: "Booleroo Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.8799,
    longitude: 138.3507,
    accuracy: 4
  },
  {
    postalCode: 5483,
    city: "Melrose",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.8253,
    longitude: 138.1863,
    accuracy: 4
  },
  {
    postalCode: 5485,
    city: "Wilmington",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.6499,
    longitude: 138.0981,
    accuracy: 4
  },
  {
    postalCode: 5490,
    city: "Caltowie North",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.1833,
    longitude: 138.4833,
    accuracy: 3
  },
  {
    postalCode: 5490,
    city: "Caltowie",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.1833,
    longitude: 138.4833,
    accuracy: 4
  },
  {
    postalCode: 5490,
    city: "Caltowie West",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.1833,
    longitude: 138.4833,
    accuracy: 3
  },
  {
    postalCode: 5491,
    city: "Hornsdale",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.0681,
    longitude: 138.5217,
    accuracy: 4
  },
  {
    postalCode: 5491,
    city: "Bundaleer North",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.136,
    longitude: 138.5608,
    accuracy: 3
  },
  {
    postalCode: 5491,
    city: "Jamestown",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.2053,
    longitude: 138.605,
    accuracy: 4
  },
  {
    postalCode: 5491,
    city: "Bundaleer Gardens",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.136,
    longitude: 138.5608,
    accuracy: 3
  },
  {
    postalCode: 5491,
    city: "Belalie North",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.136,
    longitude: 138.5608,
    accuracy: 3
  },
  {
    postalCode: 5491,
    city: "West Bundaleer",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.136,
    longitude: 138.5608,
    accuracy: 3
  },
  {
    postalCode: 5491,
    city: "Belalie East",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.136,
    longitude: 138.5608,
    accuracy: 3
  },
  {
    postalCode: 5493,
    city: "Yongala",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9167,
    longitude: 137.55,
    accuracy: 4
  },
  {
    postalCode: 5495,
    city: "Baroota",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.85,
    longitude: 138.0333,
    accuracy: 4
  },
  {
    postalCode: 5495,
    city: "Port Germein",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.0216,
    longitude: 138.0013,
    accuracy: 4
  },
  {
    postalCode: 5495,
    city: "Mambray Creek",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.8,
    longitude: 137.9833,
    accuracy: 4
  },
  {
    postalCode: 5495,
    city: "Nectar Brook",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.7333,
    longitude: 137.9333,
    accuracy: 4
  },
  {
    postalCode: 5495,
    city: "Port Flinders",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.1014,
    longitude: 138.0357,
    accuracy: 3
  },
  {
    postalCode: 5495,
    city: "Germein Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.8512,
    longitude: 137.9878,
    accuracy: 3
  },
  {
    postalCode: 5501,
    city: "Parham",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4333,
    longitude: 138.2667,
    accuracy: 4
  },
  {
    postalCode: 5501,
    city: "Webb Beach",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4493,
    longitude: 138.3886,
    accuracy: 3
  },
  {
    postalCode: 5501,
    city: "Dublin",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.45,
    longitude: 138.35,
    accuracy: 4
  },
  {
    postalCode: 5501,
    city: "Calomba",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4493,
    longitude: 138.3886,
    accuracy: 3
  },
  {
    postalCode: 5501,
    city: "Wild Horse Plains",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3601,
    longitude: 138.2933,
    accuracy: 4
  },
  {
    postalCode: 5501,
    city: "Port Gawler",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.504,
    longitude: 138.4302,
    accuracy: 3
  },
  {
    postalCode: 5501,
    city: "Lower Light",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5326,
    longitude: 138.437,
    accuracy: 4
  },
  {
    postalCode: 5501,
    city: "Middle Beach",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.504,
    longitude: 138.4302,
    accuracy: 3
  },
  {
    postalCode: 5501,
    city: "Lewiston",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6045,
    longitude: 138.5913,
    accuracy: 4
  },
  {
    postalCode: 5501,
    city: "Thompson Beach",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4493,
    longitude: 138.3886,
    accuracy: 3
  },
  {
    postalCode: 5501,
    city: "Long Plains",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.359,
    longitude: 138.3783,
    accuracy: 4
  },
  {
    postalCode: 5501,
    city: "Windsor",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4219,
    longitude: 138.3308,
    accuracy: 4
  },
  {
    postalCode: 5501,
    city: "Avon",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.2839,
    longitude: 138.336,
    accuracy: 4
  },
  {
    postalCode: 5501,
    city: "Two Wells",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5933,
    longitude: 138.5137,
    accuracy: 4
  },
  {
    postalCode: 5502,
    city: "Mallala",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4374,
    longitude: 138.5099,
    accuracy: 4
  },
  {
    postalCode: 5502,
    city: "Korunye",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5124,
    longitude: 138.5102,
    accuracy: 4
  },
  {
    postalCode: 5502,
    city: "Grace Plains",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4902,
    longitude: 138.5422,
    accuracy: 3
  },
  {
    postalCode: 5502,
    city: "Reeves Plains",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5167,
    longitude: 138.6,
    accuracy: 4
  },
  {
    postalCode: 5502,
    city: "Redbanks",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4902,
    longitude: 138.5422,
    accuracy: 3
  },
  {
    postalCode: 5502,
    city: "Fischer",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4902,
    longitude: 138.5422,
    accuracy: 3
  },
  {
    postalCode: 5510,
    city: "Lochiel",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.9333,
    longitude: 138.1667,
    accuracy: 4
  },
  {
    postalCode: 5520,
    city: "Bumbunga",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.9167,
    longitude: 138.2333,
    accuracy: 4
  },
  {
    postalCode: 5520,
    city: "Burnsfield",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.7327,
    longitude: 138.1419,
    accuracy: 3
  },
  {
    postalCode: 5520,
    city: "Wokurna",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.7167,
    longitude: 138.05,
    accuracy: 4
  },
  {
    postalCode: 5520,
    city: "Barunga Gap",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.5241,
    longitude: 138.0404,
    accuracy: 4
  },
  {
    postalCode: 5520,
    city: "Snowtown",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.7808,
    longitude: 138.2175,
    accuracy: 4
  },
  {
    postalCode: 5521,
    city: "Redhill",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.5333,
    longitude: 138.2333,
    accuracy: 4
  },
  {
    postalCode: 5522,
    city: "Fisherman Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.5594,
    longitude: 137.9429,
    accuracy: 4
  },
  {
    postalCode: 5522,
    city: "Ward Hill",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.5801,
    longitude: 137.9394,
    accuracy: 3
  },
  {
    postalCode: 5522,
    city: "Port Broughton",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.6007,
    longitude: 137.936,
    accuracy: 4
  },
  {
    postalCode: 5523,
    city: "Wandearah West",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.3927,
    longitude: 137.9731,
    accuracy: 4
  },
  {
    postalCode: 5523,
    city: "Merriton",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.45,
    longitude: 138.15,
    accuracy: 4
  },
  {
    postalCode: 5523,
    city: "Crystal Brook",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.3526,
    longitude: 138.2095,
    accuracy: 4
  },
  {
    postalCode: 5523,
    city: "Clements Gap",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.5241,
    longitude: 138.0404,
    accuracy: 4
  },
  {
    postalCode: 5523,
    city: "Beetaloo",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.2333,
    longitude: 138.2333,
    accuracy: 4
  },
  {
    postalCode: 5523,
    city: "Narridy",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.4333,
    longitude: 138.3,
    accuracy: 4
  },
  {
    postalCode: 5523,
    city: "Huddleston",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.3949,
    longitude: 138.171,
    accuracy: 3
  },
  {
    postalCode: 5523,
    city: "Wandearah East",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.3833,
    longitude: 138.0667,
    accuracy: 4
  },
  {
    postalCode: 5523,
    city: "Nurom",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.3949,
    longitude: 138.171,
    accuracy: 3
  },
  {
    postalCode: 5523,
    city: "Wandearah",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.3949,
    longitude: 138.171,
    accuracy: 3
  },
  {
    postalCode: 5540,
    city: "Bungama",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.189,
    longitude: 138.0451,
    accuracy: 3
  },
  {
    postalCode: 5540,
    city: "Pirie East",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.3833,
    longitude: 138.0667,
    accuracy: 4
  },
  {
    postalCode: 5540,
    city: "Risdon Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.1966,
    longitude: 137.994,
    accuracy: 4
  },
  {
    postalCode: 5540,
    city: "Port Davis",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.2667,
    longitude: 137.8541,
    accuracy: 4
  },
  {
    postalCode: 5540,
    city: "Port Pirie South",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.1918,
    longitude: 138.0175,
    accuracy: 3
  },
  {
    postalCode: 5540,
    city: "Coonamia",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.189,
    longitude: 138.0451,
    accuracy: 3
  },
  {
    postalCode: 5540,
    city: "Nelshaby",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.1261,
    longitude: 138.1105,
    accuracy: 4
  },
  {
    postalCode: 5540,
    city: "Port Pirie West",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.3927,
    longitude: 137.9731,
    accuracy: 4
  },
  {
    postalCode: 5540,
    city: "Port Pirie",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.1918,
    longitude: 138.0175,
    accuracy: 4
  },
  {
    postalCode: 5540,
    city: "Risdon Park South",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.1966,
    longitude: 137.994,
    accuracy: 4
  },
  {
    postalCode: 5540,
    city: "Solomontown",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.2,
    longitude: 138.0333,
    accuracy: 4
  },
  {
    postalCode: 5540,
    city: "Warnertown",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.189,
    longitude: 138.0451,
    accuracy: 3
  },
  {
    postalCode: 5540,
    city: "Telowie",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.0549,
    longitude: 138.0684,
    accuracy: 4
  },
  {
    postalCode: 5540,
    city: "Lower Broughton",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.189,
    longitude: 138.0451,
    accuracy: 3
  },
  {
    postalCode: 5540,
    city: "Napperby",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.1574,
    longitude: 138.1164,
    accuracy: 4
  },
  {
    postalCode: 5550,
    city: "Inkerman",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.2799,
    longitude: 138.2378,
    accuracy: 4
  },
  {
    postalCode: 5550,
    city: "Beaufort",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0833,
    longitude: 138.2,
    accuracy: 4
  },
  {
    postalCode: 5550,
    city: "Bowmans",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1589,
    longitude: 138.2594,
    accuracy: 4
  },
  {
    postalCode: 5550,
    city: "Nantawarra",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0167,
    longitude: 138.2333,
    accuracy: 4
  },
  {
    postalCode: 5550,
    city: "Port Wakefield",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1848,
    longitude: 138.1453,
    accuracy: 4
  },
  {
    postalCode: 5550,
    city: "Kallora",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1505,
    longitude: 138.2203,
    accuracy: 3
  },
  {
    postalCode: 5550,
    city: "Proof Range",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1505,
    longitude: 138.2203,
    accuracy: 3
  },
  {
    postalCode: 5550,
    city: "South Hummocks",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1505,
    longitude: 138.2203,
    accuracy: 3
  },
  {
    postalCode: 5552,
    city: "Paskeville",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0333,
    longitude: 137.9,
    accuracy: 4
  },
  {
    postalCode: 5552,
    city: "Melton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0722,
    longitude: 137.9444,
    accuracy: 3
  },
  {
    postalCode: 5552,
    city: "Thrington",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0131,
    longitude: 137.8294,
    accuracy: 4
  },
  {
    postalCode: 5552,
    city: "Sunnyvale",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0722,
    longitude: 137.9444,
    accuracy: 3
  },
  {
    postalCode: 5552,
    city: "Kainton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1233,
    longitude: 137.9028,
    accuracy: 4
  },
  {
    postalCode: 5552,
    city: "Port Arthur",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0722,
    longitude: 137.9444,
    accuracy: 3
  },
  {
    postalCode: 5552,
    city: "Kulpara",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0667,
    longitude: 138.0333,
    accuracy: 4
  },
  {
    postalCode: 5554,
    city: "Matta Flat",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.9199,
    longitude: 137.6638,
    accuracy: 3
  },
  {
    postalCode: 5554,
    city: "Wallaroo Mines",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.9725,
    longitude: 137.6939,
    accuracy: 4
  },
  {
    postalCode: 5554,
    city: "Jerusalem",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.9735,
    longitude: 137.711,
    accuracy: 3
  },
  {
    postalCode: 5554,
    city: "Kadina",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.965,
    longitude: 137.7163,
    accuracy: 4
  },
  {
    postalCode: 5554,
    city: "Willamulka",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.005,
    longitude: 137.711,
    accuracy: 3
  },
  {
    postalCode: 5554,
    city: "Thomas Plain",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.9637,
    longitude: 137.9278,
    accuracy: 4
  },
  {
    postalCode: 5554,
    city: "Boors Plain",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.005,
    longitude: 137.711,
    accuracy: 3
  },
  {
    postalCode: 5554,
    city: "Cunliffe",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0833,
    longitude: 137.7333,
    accuracy: 4
  },
  {
    postalCode: 5554,
    city: "New Town",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.9199,
    longitude: 137.6638,
    accuracy: 3
  },
  {
    postalCode: 5554,
    city: "Jericho",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.9199,
    longitude: 137.6638,
    accuracy: 3
  },
  {
    postalCode: 5555,
    city: "Tickera",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.7833,
    longitude: 137.7,
    accuracy: 4
  },
  {
    postalCode: 5555,
    city: "Mundoora",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.6,
    longitude: 138.0833,
    accuracy: 4
  },
  {
    postalCode: 5555,
    city: "Alford",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.8167,
    longitude: 137.8167,
    accuracy: 4
  },
  {
    postalCode: 5555,
    city: "Collinsfield",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.7333,
    longitude: 137.8667,
    accuracy: 3
  },
  {
    postalCode: 5555,
    city: "Lake View",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.8287,
    longitude: 138.0507,
    accuracy: 3
  },
  {
    postalCode: 5555,
    city: "Hope Gap",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.7333,
    longitude: 137.8667,
    accuracy: 3
  },
  {
    postalCode: 5556,
    city: "North Beach",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.9029,
    longitude: 137.6329,
    accuracy: 4
  },
  {
    postalCode: 5556,
    city: "Warburto",
    state_name: "South Australia",
    state: "SA",
    latitude: -34,
    longitude: 137.6167,
    accuracy: 4
  },
  {
    postalCode: 5556,
    city: "Wallaroo Plain",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.9472,
    longitude: 137.6277,
    accuracy: 3
  },
  {
    postalCode: 5556,
    city: "Wallaroo",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.9388,
    longitude: 137.6337,
    accuracy: 4
  },
  {
    postalCode: 5558,
    city: "Moonta Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.05,
    longitude: 137.5667,
    accuracy: 4
  },
  {
    postalCode: 5558,
    city: "Moonta Mines",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0779,
    longitude: 137.6086,
    accuracy: 3
  },
  {
    postalCode: 5558,
    city: "Moonta",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0684,
    longitude: 137.5908,
    accuracy: 4
  },
  {
    postalCode: 5558,
    city: "Hamley",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3576,
    longitude: 138.6807,
    accuracy: 4
  },
  {
    postalCode: 5558,
    city: "Paramatta",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1174,
    longitude: 137.769,
    accuracy: 3
  },
  {
    postalCode: 5558,
    city: "East Moonta",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1127,
    longitude: 137.6609,
    accuracy: 3
  },
  {
    postalCode: 5558,
    city: "Agery",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1568,
    longitude: 137.7429,
    accuracy: 4
  },
  {
    postalCode: 5558,
    city: "Kooroona",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1127,
    longitude: 137.6609,
    accuracy: 3
  },
  {
    postalCode: 5558,
    city: "Port Hughes",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0833,
    longitude: 137.55,
    accuracy: 4
  },
  {
    postalCode: 5558,
    city: "Nalyappa",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1127,
    longitude: 137.6609,
    accuracy: 3
  },
  {
    postalCode: 5558,
    city: "North Yelta",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0616,
    longitude: 137.6321,
    accuracy: 4
  },
  {
    postalCode: 5558,
    city: "North Moonta",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0528,
    longitude: 137.5931,
    accuracy: 3
  },
  {
    postalCode: 5558,
    city: "Yelta",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0616,
    longitude: 137.6321,
    accuracy: 4
  },
  {
    postalCode: 5558,
    city: "Cross Roads",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1127,
    longitude: 137.6609,
    accuracy: 3
  },
  {
    postalCode: 5560,
    city: "Bute",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.8656,
    longitude: 138.0066,
    accuracy: 4
  },
  {
    postalCode: 5560,
    city: "Ninnes",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.8656,
    longitude: 138.0066,
    accuracy: 3
  },
  {
    postalCode: 5570,
    city: "Winulta",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.2763,
    longitude: 137.8728,
    accuracy: 4
  },
  {
    postalCode: 5570,
    city: "Port Clinton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.2243,
    longitude: 138.0206,
    accuracy: 4
  },
  {
    postalCode: 5570,
    city: "Price",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.2864,
    longitude: 137.9943,
    accuracy: 4
  },
  {
    postalCode: 5570,
    city: "Clinton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.183,
    longitude: 137.9648,
    accuracy: 3
  },
  {
    postalCode: 5570,
    city: "Clinton Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.2333,
    longitude: 137.9167,
    accuracy: 4
  },
  {
    postalCode: 5571,
    city: "Ardrossan",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4222,
    longitude: 137.9191,
    accuracy: 4
  },
  {
    postalCode: 5571,
    city: "Pine Point",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5667,
    longitude: 137.8667,
    accuracy: 4
  },
  {
    postalCode: 5571,
    city: "Tiddy Widdy Beach",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4014,
    longitude: 137.9402,
    accuracy: 4
  },
  {
    postalCode: 5571,
    city: "Black Point",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4481,
    longitude: 137.8819,
    accuracy: 3
  },
  {
    postalCode: 5571,
    city: "Sandilands",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5138,
    longitude: 137.7932,
    accuracy: 4
  },
  {
    postalCode: 5571,
    city: "Petersville",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4481,
    longitude: 137.8819,
    accuracy: 3
  },
  {
    postalCode: 5571,
    city: "Dowlingville",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.327,
    longitude: 137.9193,
    accuracy: 4
  },
  {
    postalCode: 5571,
    city: "Rogues Point",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4481,
    longitude: 137.8819,
    accuracy: 3
  },
  {
    postalCode: 5571,
    city: "Cunningham",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4148,
    longitude: 137.7995,
    accuracy: 4
  },
  {
    postalCode: 5571,
    city: "James Well",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4481,
    longitude: 137.8819,
    accuracy: 3
  },
  {
    postalCode: 5572,
    city: "Arthurton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.2667,
    longitude: 137.75,
    accuracy: 4
  },
  {
    postalCode: 5573,
    city: "Yorke Valley",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1494,
    longitude: 137.1512,
    accuracy: 4
  },
  {
    postalCode: 5573,
    city: "Point Pearce",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4174,
    longitude: 137.5005,
    accuracy: 3
  },
  {
    postalCode: 5573,
    city: "South Kilkerran",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4333,
    longitude: 137.6,
    accuracy: 4
  },
  {
    postalCode: 5573,
    city: "Chinaman Wells",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3811,
    longitude: 137.4805,
    accuracy: 4
  },
  {
    postalCode: 5573,
    city: "Weetulta",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.25,
    longitude: 137.6333,
    accuracy: 4
  },
  {
    postalCode: 5573,
    city: "Balgowan",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3333,
    longitude: 137.4833,
    accuracy: 4
  },
  {
    postalCode: 5573,
    city: "Port Victoria",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4972,
    longitude: 137.4853,
    accuracy: 4
  },
  {
    postalCode: 5573,
    city: "Maitland",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3739,
    longitude: 137.6733,
    accuracy: 4
  },
  {
    postalCode: 5573,
    city: "Urania",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.511,
    longitude: 137.6064,
    accuracy: 4
  },
  {
    postalCode: 5573,
    city: "Wauraltee",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5833,
    longitude: 137.55,
    accuracy: 4
  },
  {
    postalCode: 5575,
    city: "Hardwicke Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8888,
    longitude: 137.458,
    accuracy: 4
  },
  {
    postalCode: 5575,
    city: "Bluff Beach",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7325,
    longitude: 137.4807,
    accuracy: 4
  },
  {
    postalCode: 5575,
    city: "Point Turton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9523,
    longitude: 137.3565,
    accuracy: 4
  },
  {
    postalCode: 5575,
    city: "Stenhouse Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2833,
    longitude: 136.9333,
    accuracy: 4
  },
  {
    postalCode: 5575,
    city: "Port Rickaby",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6833,
    longitude: 137.5,
    accuracy: 4
  },
  {
    postalCode: 5575,
    city: "Wool Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9911,
    longitude: 137.7567,
    accuracy: 4
  },
  {
    postalCode: 5575,
    city: "Brentwood",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8667,
    longitude: 137.5,
    accuracy: 4
  },
  {
    postalCode: 5575,
    city: "White Hut",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9243,
    longitude: 137.3787,
    accuracy: 3
  },
  {
    postalCode: 5575,
    city: "Koolywurtie",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.65,
    longitude: 137.6333,
    accuracy: 4
  },
  {
    postalCode: 5575,
    city: "Minlaton",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.771,
    longitude: 137.5958,
    accuracy: 4
  },
  {
    postalCode: 5575,
    city: "Corny Point",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9249,
    longitude: 137.0812,
    accuracy: 4
  },
  {
    postalCode: 5575,
    city: "Ramsay",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9243,
    longitude: 137.3787,
    accuracy: 3
  },
  {
    postalCode: 5575,
    city: "Marion Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.2333,
    longitude: 137.0167,
    accuracy: 4
  },
  {
    postalCode: 5576,
    city: "Honiton",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1167,
    longitude: 137.65,
    accuracy: 4
  },
  {
    postalCode: 5576,
    city: "Port Moorowie",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1167,
    longitude: 137.5167,
    accuracy: 4
  },
  {
    postalCode: 5576,
    city: "Yorketown",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0185,
    longitude: 137.6049,
    accuracy: 4
  },
  {
    postalCode: 5577,
    city: "Inneston",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.275,
    longitude: 136.8917,
    accuracy: 4
  },
  {
    postalCode: 5577,
    city: "Couch Beach",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9095,
    longitude: 137.1769,
    accuracy: 4
  },
  {
    postalCode: 5577,
    city: "The Pines",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9165,
    longitude: 137.1605,
    accuracy: 4
  },
  {
    postalCode: 5577,
    city: "Point Souttar",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1327,
    longitude: 137.1464,
    accuracy: 3
  },
  {
    postalCode: 5577,
    city: "Warooka",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9903,
    longitude: 137.4012,
    accuracy: 4
  },
  {
    postalCode: 5577,
    city: "Foul Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.1327,
    longitude: 137.1464,
    accuracy: 3
  },
  {
    postalCode: 5580,
    city: "Port Julia",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6667,
    longitude: 137.8667,
    accuracy: 4
  },
  {
    postalCode: 5580,
    city: "Curramulka",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7,
    longitude: 137.7,
    accuracy: 4
  },
  {
    postalCode: 5581,
    city: "Sheaoak Flat",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.778,
    longitude: 137.8608,
    accuracy: 3
  },
  {
    postalCode: 5581,
    city: "Port Vincent",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7798,
    longitude: 137.8593,
    accuracy: 4
  },
  {
    postalCode: 5582,
    city: "Stansbury",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9111,
    longitude: 137.799,
    accuracy: 4
  },
  {
    postalCode: 5582,
    city: "Port Giles",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9111,
    longitude: 137.799,
    accuracy: 3
  },
  {
    postalCode: 5583,
    city: "Coobowie",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.044,
    longitude: 137.7311,
    accuracy: 4
  },
  {
    postalCode: 5583,
    city: "Sultana Point",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0671,
    longitude: 137.7309,
    accuracy: 3
  },
  {
    postalCode: 5583,
    city: "Edithburgh",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0846,
    longitude: 137.744,
    accuracy: 4
  },
  {
    postalCode: 5600,
    city: "Whyalla",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.0327,
    longitude: 137.5648,
    accuracy: 4
  },
  {
    postalCode: 5600,
    city: "Whyalla Playford",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.0279,
    longitude: 137.562,
    accuracy: 4
  },
  {
    postalCode: 5600,
    city: "Whyalla DC",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.0303,
    longitude: 137.5634,
    accuracy: 3
  },
  {
    postalCode: 5601,
    city: "Iron Baron",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.9951,
    longitude: 137.1686,
    accuracy: 4
  },
  {
    postalCode: 5601,
    city: "Point Lowly North",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.864,
    longitude: 137.1598,
    accuracy: 3
  },
  {
    postalCode: 5601,
    city: "Backy Point",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.864,
    longitude: 137.1598,
    accuracy: 3
  },
  {
    postalCode: 5601,
    city: "Murninnie Beach",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.864,
    longitude: 137.1598,
    accuracy: 3
  },
  {
    postalCode: 5601,
    city: "Port Bonython",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.9907,
    longitude: 137.7754,
    accuracy: 4
  },
  {
    postalCode: 5601,
    city: "Iron Knob",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.733,
    longitude: 137.151,
    accuracy: 4
  },
  {
    postalCode: 5601,
    city: "Point Lowly",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.864,
    longitude: 137.1598,
    accuracy: 3
  },
  {
    postalCode: 5601,
    city: "Douglas Point South",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.864,
    longitude: 137.1598,
    accuracy: 3
  },
  {
    postalCode: 5601,
    city: "Whyalla Barson",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.864,
    longitude: 137.1598,
    accuracy: 3
  },
  {
    postalCode: 5601,
    city: "Cultana",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.864,
    longitude: 137.1598,
    accuracy: 3
  },
  {
    postalCode: 5601,
    city: "Cowleds Landing",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.864,
    longitude: 137.1598,
    accuracy: 3
  },
  {
    postalCode: 5601,
    city: "Douglas Point",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.864,
    longitude: 137.1598,
    accuracy: 3
  },
  {
    postalCode: 5601,
    city: "Mullaquana",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.2118,
    longitude: 137.3627,
    accuracy: 4
  },
  {
    postalCode: 5601,
    city: "False Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.864,
    longitude: 137.1598,
    accuracy: 3
  },
  {
    postalCode: 5601,
    city: "Fitzgerald Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.864,
    longitude: 137.1598,
    accuracy: 3
  },
  {
    postalCode: 5602,
    city: "Miltalie",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.5833,
    longitude: 136.8333,
    accuracy: 4
  },
  {
    postalCode: 5602,
    city: "Lucky Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.6165,
    longitude: 136.8785,
    accuracy: 3
  },
  {
    postalCode: 5602,
    city: "Cowell",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.6823,
    longitude: 136.9212,
    accuracy: 4
  },
  {
    postalCode: 5602,
    city: "Port Gibbon",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.7972,
    longitude: 136.8028,
    accuracy: 4
  },
  {
    postalCode: 5602,
    city: "Minbrie",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.5,
    longitude: 136.9667,
    accuracy: 4
  },
  {
    postalCode: 5602,
    city: "Midgee",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.4209,
    longitude: 137.1546,
    accuracy: 4
  },
  {
    postalCode: 5602,
    city: "Mitchellville",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.6167,
    longitude: 137.15,
    accuracy: 4
  },
  {
    postalCode: 5602,
    city: "Mangalo",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.5341,
    longitude: 136.6208,
    accuracy: 4
  },
  {
    postalCode: 5603,
    city: "Verran",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.925,
    longitude: 136.4,
    accuracy: 3
  },
  {
    postalCode: 5603,
    city: "Arno Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.9,
    longitude: 136.5667,
    accuracy: 4
  },
  {
    postalCode: 5603,
    city: "Wharminda",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.9538,
    longitude: 136.2458,
    accuracy: 4
  },
  {
    postalCode: 5603,
    city: "Hincks",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.925,
    longitude: 136.4,
    accuracy: 3
  },
  {
    postalCode: 5604,
    city: "Port Neill",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1188,
    longitude: 136.3483,
    accuracy: 4
  },
  {
    postalCode: 5605,
    city: "Butler",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1167,
    longitude: 136.1,
    accuracy: 4
  },
  {
    postalCode: 5605,
    city: "Tumby Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3751,
    longitude: 136.1033,
    accuracy: 4
  },
  {
    postalCode: 5606,
    city: "Port Lincoln",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7263,
    longitude: 135.8744,
    accuracy: 4
  },
  {
    postalCode: 5607,
    city: "Koppio",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4167,
    longitude: 135.85,
    accuracy: 4
  },
  {
    postalCode: 5607,
    city: "Little Douglas",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3251,
    longitude: 135.6717,
    accuracy: 3
  },
  {
    postalCode: 5607,
    city: "Fountain",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6,
    longitude: 135.6333,
    accuracy: 4
  },
  {
    postalCode: 5607,
    city: "Coomunga",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6437,
    longitude: 135.7074,
    accuracy: 4
  },
  {
    postalCode: 5607,
    city: "Louth Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.55,
    longitude: 135.9,
    accuracy: 4
  },
  {
    postalCode: 5607,
    city: "Point Boston",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3251,
    longitude: 135.6717,
    accuracy: 3
  },
  {
    postalCode: 5607,
    city: "Boston",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6906,
    longitude: 135.9165,
    accuracy: 4
  },
  {
    postalCode: 5607,
    city: "Wanilla",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5,
    longitude: 135.6833,
    accuracy: 4
  },
  {
    postalCode: 5607,
    city: "Poonindie",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5813,
    longitude: 135.881,
    accuracy: 4
  },
  {
    postalCode: 5607,
    city: "Green Patch",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3251,
    longitude: 135.6717,
    accuracy: 3
  },
  {
    postalCode: 5607,
    city: "Yallunda Flat",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3475,
    longitude: 135.8787,
    accuracy: 4
  },
  {
    postalCode: 5607,
    city: "Coulta",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3833,
    longitude: 135.4667,
    accuracy: 4
  },
  {
    postalCode: 5607,
    city: "Wangary",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.55,
    longitude: 135.4833,
    accuracy: 4
  },
  {
    postalCode: 5607,
    city: "Whites River",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3251,
    longitude: 135.6717,
    accuracy: 3
  },
  {
    postalCode: 5607,
    city: "Mount Hope",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1167,
    longitude: 135.3833,
    accuracy: 4
  },
  {
    postalCode: 5607,
    city: "Ungarra",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1801,
    longitude: 136.0481,
    accuracy: 4
  },
  {
    postalCode: 5607,
    city: "Sleaford",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8144,
    longitude: 135.7438,
    accuracy: 4
  },
  {
    postalCode: 5607,
    city: "Duck Ponds",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7333,
    longitude: 135.7833,
    accuracy: 4
  },
  {
    postalCode: 5607,
    city: "Murdinga",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.7167,
    longitude: 135.7167,
    accuracy: 4
  },
  {
    postalCode: 5607,
    city: "Port Lincoln",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7263,
    longitude: 135.8744,
    accuracy: 4
  },
  {
    postalCode: 5607,
    city: "Mount Drummond",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.218,
    longitude: 135.4092,
    accuracy: 4
  },
  {
    postalCode: 5607,
    city: "Tootenilla",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3251,
    longitude: 135.6717,
    accuracy: 3
  },
  {
    postalCode: 5607,
    city: "Charlton Gully",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.55,
    longitude: 135.8035,
    accuracy: 4
  },
  {
    postalCode: 5607,
    city: "Warrachie",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.65,
    longitude: 135.7167,
    accuracy: 4
  },
  {
    postalCode: 5607,
    city: "Pearlah",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5934,
    longitude: 135.6761,
    accuracy: 4
  },
  {
    postalCode: 5607,
    city: "Lincoln National Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8341,
    longitude: 135.856,
    accuracy: 4
  },
  {
    postalCode: 5607,
    city: "Lipson",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3,
    longitude: 136.1333,
    accuracy: 4
  },
  {
    postalCode: 5607,
    city: "Venus Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.2333,
    longitude: 134.6833,
    accuracy: 4
  },
  {
    postalCode: 5607,
    city: "Coffin Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6167,
    longitude: 135.4667,
    accuracy: 4
  },
  {
    postalCode: 5607,
    city: "Hawson",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3251,
    longitude: 135.6717,
    accuracy: 3
  },
  {
    postalCode: 5607,
    city: "Tiatukia",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3251,
    longitude: 135.6717,
    accuracy: 3
  },
  {
    postalCode: 5607,
    city: "Kiana",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3251,
    longitude: 135.6717,
    accuracy: 3
  },
  {
    postalCode: 5607,
    city: "Sheringa",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.8443,
    longitude: 135.2321,
    accuracy: 4
  },
  {
    postalCode: 5607,
    city: "Uley",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3251,
    longitude: 135.6717,
    accuracy: 3
  },
  {
    postalCode: 5607,
    city: "Brooker",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1,
    longitude: 135.9,
    accuracy: 4
  },
  {
    postalCode: 5607,
    city: "North Shields",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.6286,
    longitude: 135.8622,
    accuracy: 4
  },
  {
    postalCode: 5607,
    city: "Tulka",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.7942,
    longitude: 135.7999,
    accuracy: 4
  },
  {
    postalCode: 5607,
    city: "Kellidie Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3251,
    longitude: 135.6717,
    accuracy: 3
  },
  {
    postalCode: 5607,
    city: "Tooligie",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.85,
    longitude: 135.7,
    accuracy: 4
  },
  {
    postalCode: 5607,
    city: "Moody",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3251,
    longitude: 135.6717,
    accuracy: 3
  },
  {
    postalCode: 5607,
    city: "Warrow",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3333,
    longitude: 135.4667,
    accuracy: 4
  },
  {
    postalCode: 5607,
    city: "Whites Flat",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.5122,
    longitude: 135.8532,
    accuracy: 4
  },
  {
    postalCode: 5607,
    city: "Farm Beach",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3251,
    longitude: 135.6717,
    accuracy: 3
  },
  {
    postalCode: 5607,
    city: "Mount Dutton Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.3251,
    longitude: 135.6717,
    accuracy: 3
  },
  {
    postalCode: 5608,
    city: "Whyalla Norrie",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.029,
    longitude: 137.5392,
    accuracy: 4
  },
  {
    postalCode: 5608,
    city: "Whyalla Norrie East",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.027,
    longitude: 137.532,
    accuracy: 3
  },
  {
    postalCode: 5608,
    city: "Whyalla Stuart",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.0249,
    longitude: 137.5247,
    accuracy: 4
  },
  {
    postalCode: 5608,
    city: "Whyalla Norrie North",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.027,
    longitude: 137.532,
    accuracy: 3
  },
  {
    postalCode: 5609,
    city: "Whyalla Jenkins",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.0221,
    longitude: 137.5127,
    accuracy: 4
  },
  {
    postalCode: 5630,
    city: "Edillilie",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.4118,
    longitude: 135.7063,
    accuracy: 4
  },
  {
    postalCode: 5631,
    city: "Cockaleechie",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.2601,
    longitude: 135.7273,
    accuracy: 3
  },
  {
    postalCode: 5631,
    city: "Cummins",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.264,
    longitude: 135.726,
    accuracy: 4
  },
  {
    postalCode: 5632,
    city: "Karkoo",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.0328,
    longitude: 135.7293,
    accuracy: 4
  },
  {
    postalCode: 5632,
    city: "Mitchell",
    state_name: "South Australia",
    state: "SA",
    latitude: -35.0051,
    longitude: 138.5623,
    accuracy: 4
  },
  {
    postalCode: 5632,
    city: "Yeelanna",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.1408,
    longitude: 135.7294,
    accuracy: 4
  },
  {
    postalCode: 5632,
    city: "Kapinnie",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.138,
    longitude: 135.4976,
    accuracy: 4
  },
  {
    postalCode: 5633,
    city: "Boonerdo",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.5667,
    longitude: 135.7667,
    accuracy: 3
  },
  {
    postalCode: 5633,
    city: "Lock",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.568,
    longitude: 135.7565,
    accuracy: 4
  },
  {
    postalCode: 5640,
    city: "Waddikee",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.3131,
    longitude: 136.2551,
    accuracy: 4
  },
  {
    postalCode: 5640,
    city: "Jamieson",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.5083,
    longitude: 136.3583,
    accuracy: 3
  },
  {
    postalCode: 5640,
    city: "Cleve",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.7,
    longitude: 136.5,
    accuracy: 4
  },
  {
    postalCode: 5640,
    city: "Campoona",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.5083,
    longitude: 136.3583,
    accuracy: 3
  },
  {
    postalCode: 5641,
    city: "Moseley",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.0833,
    longitude: 136.5167,
    accuracy: 4
  },
  {
    postalCode: 5641,
    city: "Pinkawillinie",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.105,
    longitude: 136.3337,
    accuracy: 3
  },
  {
    postalCode: 5641,
    city: "Buckleboo",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.9167,
    longitude: 136.2,
    accuracy: 4
  },
  {
    postalCode: 5641,
    city: "Wilcherry",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.105,
    longitude: 136.3337,
    accuracy: 3
  },
  {
    postalCode: 5641,
    city: "Cortlinye",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.0167,
    longitude: 136.3333,
    accuracy: 4
  },
  {
    postalCode: 5641,
    city: "Yalanda",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.105,
    longitude: 136.3337,
    accuracy: 3
  },
  {
    postalCode: 5641,
    city: "Caralue",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.3667,
    longitude: 136.2,
    accuracy: 4
  },
  {
    postalCode: 5641,
    city: "Panitya",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.105,
    longitude: 136.3337,
    accuracy: 3
  },
  {
    postalCode: 5641,
    city: "Kimba",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.1416,
    longitude: 136.4187,
    accuracy: 4
  },
  {
    postalCode: 5641,
    city: "Kelly",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.105,
    longitude: 136.3337,
    accuracy: 3
  },
  {
    postalCode: 5641,
    city: "Cunyarie",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.105,
    longitude: 136.3337,
    accuracy: 3
  },
  {
    postalCode: 5641,
    city: "Solomon",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.105,
    longitude: 136.3337,
    accuracy: 3
  },
  {
    postalCode: 5641,
    city: "Barna",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.105,
    longitude: 136.3337,
    accuracy: 3
  },
  {
    postalCode: 5642,
    city: "Rudall",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.6833,
    longitude: 136.2667,
    accuracy: 4
  },
  {
    postalCode: 5642,
    city: "Darke Peak",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.4667,
    longitude: 136.2,
    accuracy: 4
  },
  {
    postalCode: 5642,
    city: "Murlong",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.5778,
    longitude: 136.2278,
    accuracy: 3
  },
  {
    postalCode: 5642,
    city: "Kielpa",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.5833,
    longitude: 136.2167,
    accuracy: 4
  },
  {
    postalCode: 5642,
    city: "Hambidge",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.5778,
    longitude: 136.2278,
    accuracy: 3
  },
  {
    postalCode: 5650,
    city: "Koongawa",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.1667,
    longitude: 135.8833,
    accuracy: 4
  },
  {
    postalCode: 5650,
    city: "Warramboo",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.2333,
    longitude: 135.6,
    accuracy: 4
  },
  {
    postalCode: 5650,
    city: "Cootra",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.25,
    longitude: 135.8667,
    accuracy: 4
  },
  {
    postalCode: 5651,
    city: "Kyancutta",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.1333,
    longitude: 135.5667,
    accuracy: 4
  },
  {
    postalCode: 5652,
    city: "Paney",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.0334,
    longitude: 135.4402,
    accuracy: 3
  },
  {
    postalCode: 5652,
    city: "Pygery",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.0167,
    longitude: 135.4167,
    accuracy: 4
  },
  {
    postalCode: 5652,
    city: "Wudinna",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.0501,
    longitude: 135.4638,
    accuracy: 4
  },
  {
    postalCode: 5653,
    city: "Yaninee",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.9462,
    longitude: 135.2737,
    accuracy: 4
  },
  {
    postalCode: 5654,
    city: "Mount Damper",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.1167,
    longitude: 135.1,
    accuracy: 4
  },
  {
    postalCode: 5654,
    city: "Karcultaby",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.7667,
    longitude: 134.9667,
    accuracy: 4
  },
  {
    postalCode: 5654,
    city: "Minnipa",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.85,
    longitude: 135.15,
    accuracy: 4
  },
  {
    postalCode: 5654,
    city: "Cocata",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.9111,
    longitude: 135.0722,
    accuracy: 3
  },
  {
    postalCode: 5655,
    city: "Poochera",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.7167,
    longitude: 134.85,
    accuracy: 4
  },
  {
    postalCode: 5655,
    city: "Kaldoonera",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.7167,
    longitude: 134.85,
    accuracy: 3
  },
  {
    postalCode: 5655,
    city: "Bockelberg",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.7167,
    longitude: 134.85,
    accuracy: 3
  },
  {
    postalCode: 5660,
    city: "Cungena",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.5833,
    longitude: 134.7167,
    accuracy: 4
  },
  {
    postalCode: 5660,
    city: "Chilpenunda",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.5833,
    longitude: 134.7167,
    accuracy: 3
  },
  {
    postalCode: 5661,
    city: "Wirrulla",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.4,
    longitude: 134.5167,
    accuracy: 4
  },
  {
    postalCode: 5661,
    city: "Koolgera",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.4,
    longitude: 134.5278,
    accuracy: 3
  },
  {
    postalCode: 5661,
    city: "Yantanabie",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.4833,
    longitude: 134.6363,
    accuracy: 4
  },
  {
    postalCode: 5661,
    city: "Wallala",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.4,
    longitude: 134.5278,
    accuracy: 3
  },
  {
    postalCode: 5661,
    city: "Pimbaacla",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.3241,
    longitude: 134.4495,
    accuracy: 4
  },
  {
    postalCode: 5670,
    city: "Kappawanta",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.5096,
    longitude: 134.9778,
    accuracy: 3
  },
  {
    postalCode: 5670,
    city: "Colton",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.4833,
    longitude: 134.9333,
    accuracy: 4
  },
  {
    postalCode: 5670,
    city: "Ulyerra",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.5096,
    longitude: 134.9778,
    accuracy: 3
  },
  {
    postalCode: 5670,
    city: "Bramfield",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.6167,
    longitude: 135.0167,
    accuracy: 4
  },
  {
    postalCode: 5670,
    city: "Coolillie",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.5096,
    longitude: 134.9778,
    accuracy: 3
  },
  {
    postalCode: 5670,
    city: "Mount Wedge",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.4665,
    longitude: 135.1566,
    accuracy: 4
  },
  {
    postalCode: 5670,
    city: "Elliston",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.6479,
    longitude: 134.8889,
    accuracy: 4
  },
  {
    postalCode: 5670,
    city: "Palkagee",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.4141,
    longitude: 135.5029,
    accuracy: 4
  },
  {
    postalCode: 5670,
    city: "Talia",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.3167,
    longitude: 134.8833,
    accuracy: 4
  },
  {
    postalCode: 5670,
    city: "Mount Joy",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.5291,
    longitude: 135.1062,
    accuracy: 4
  },
  {
    postalCode: 5670,
    city: "Polda",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.5281,
    longitude: 135.4578,
    accuracy: 4
  },
  {
    postalCode: 5671,
    city: "Mortana",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.0279,
    longitude: 134.4531,
    accuracy: 4
  },
  {
    postalCode: 5671,
    city: "Port Kenny",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.1667,
    longitude: 134.7,
    accuracy: 4
  },
  {
    postalCode: 5671,
    city: "Calca",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.0833,
    longitude: 134.35,
    accuracy: 4
  },
  {
    postalCode: 5671,
    city: "Tyringa",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.0917,
    longitude: 134.55,
    accuracy: 3
  },
  {
    postalCode: 5671,
    city: "Baird Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.0917,
    longitude: 134.55,
    accuracy: 3
  },
  {
    postalCode: 5671,
    city: "Mount Cooper",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.0833,
    longitude: 134.7,
    accuracy: 4
  },
  {
    postalCode: 5671,
    city: "Witera",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.0917,
    longitude: 134.55,
    accuracy: 3
  },
  {
    postalCode: 5671,
    city: "Colley",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.0917,
    longitude: 134.55,
    accuracy: 3
  },
  {
    postalCode: 5680,
    city: "Chinbingina",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.2167,
    longitude: 134.2,
    accuracy: 4
  },
  {
    postalCode: 5680,
    city: "Sceale Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -33.0167,
    longitude: 134.2,
    accuracy: 4
  },
  {
    postalCode: 5680,
    city: "Streaky Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.7955,
    longitude: 134.2093,
    accuracy: 4
  },
  {
    postalCode: 5680,
    city: "Piednippie",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.473,
    longitude: 134.2278,
    accuracy: 3
  },
  {
    postalCode: 5680,
    city: "Petina",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.4765,
    longitude: 134.3969,
    accuracy: 4
  },
  {
    postalCode: 5680,
    city: "Perlubie",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.473,
    longitude: 134.2278,
    accuracy: 3
  },
  {
    postalCode: 5680,
    city: "Nunjikompita",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.2691,
    longitude: 134.3383,
    accuracy: 4
  },
  {
    postalCode: 5680,
    city: "Westall",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.473,
    longitude: 134.2278,
    accuracy: 3
  },
  {
    postalCode: 5680,
    city: "Haslam",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.5,
    longitude: 134.2,
    accuracy: 4
  },
  {
    postalCode: 5680,
    city: "Pureba",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.473,
    longitude: 134.2278,
    accuracy: 3
  },
  {
    postalCode: 5680,
    city: "Carawa",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.3833,
    longitude: 134.2,
    accuracy: 4
  },
  {
    postalCode: 5680,
    city: "Maryvale",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.473,
    longitude: 134.2278,
    accuracy: 3
  },
  {
    postalCode: 5680,
    city: "Chandada",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.7548,
    longitude: 134.6731,
    accuracy: 4
  },
  {
    postalCode: 5680,
    city: "Yanerbie",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.473,
    longitude: 134.2278,
    accuracy: 3
  },
  {
    postalCode: 5680,
    city: "Puntabie",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.2036,
    longitude: 134.1281,
    accuracy: 4
  },
  {
    postalCode: 5680,
    city: "Laura Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.2167,
    longitude: 133.8333,
    accuracy: 4
  },
  {
    postalCode: 5680,
    city: "Mudamuckla",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.1584,
    longitude: 134.0438,
    accuracy: 4
  },
  {
    postalCode: 5680,
    city: "Eba Anchorage",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.473,
    longitude: 134.2278,
    accuracy: 3
  },
  {
    postalCode: 5680,
    city: "Smoky Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.3784,
    longitude: 133.934,
    accuracy: 4
  },
  {
    postalCode: 5680,
    city: "Inkster",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.8167,
    longitude: 134.6833,
    accuracy: 4
  },
  {
    postalCode: 5690,
    city: "Nadia",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.077,
    longitude: 133.4841,
    accuracy: 4
  },
  {
    postalCode: 5690,
    city: "Denial Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.1006,
    longitude: 133.5768,
    accuracy: 4
  },
  {
    postalCode: 5690,
    city: "Ceduna",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.1266,
    longitude: 133.6727,
    accuracy: 4
  },
  {
    postalCode: 5690,
    city: "Koonibba",
    state_name: "South Australia",
    state: "SA",
    latitude: -31.9044,
    longitude: 133.431,
    accuracy: 4
  },
  {
    postalCode: 5690,
    city: "Thevenard",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.1458,
    longitude: 133.6485,
    accuracy: 4
  },
  {
    postalCode: 5690,
    city: "Charra",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.0833,
    longitude: 133.3333,
    accuracy: 3
  },
  {
    postalCode: 5690,
    city: "Kalanbi",
    state_name: "South Australia",
    state: "SA",
    latitude: -31.9513,
    longitude: 133.6311,
    accuracy: 4
  },
  {
    postalCode: 5690,
    city: "Wandana",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.0129,
    longitude: 133.2552,
    accuracy: 3
  },
  {
    postalCode: 5690,
    city: "Bookabie",
    state_name: "South Australia",
    state: "SA",
    latitude: -31.8384,
    longitude: 132.6899,
    accuracy: 4
  },
  {
    postalCode: 5690,
    city: "Maltee",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.0833,
    longitude: 133.9,
    accuracy: 4
  },
  {
    postalCode: 5690,
    city: "Uworra",
    state_name: "South Australia",
    state: "SA",
    latitude: -31.965,
    longitude: 133.327,
    accuracy: 4
  },
  {
    postalCode: 5690,
    city: "Coorabie",
    state_name: "South Australia",
    state: "SA",
    latitude: -31.8998,
    longitude: 132.2953,
    accuracy: 4
  },
  {
    postalCode: 5690,
    city: "Penong",
    state_name: "South Australia",
    state: "SA",
    latitude: -31.9303,
    longitude: 133.0107,
    accuracy: 4
  },
  {
    postalCode: 5690,
    city: "Merghiny",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.1167,
    longitude: 133.8333,
    accuracy: 4
  },
  {
    postalCode: 5690,
    city: "Watraba",
    state_name: "South Australia",
    state: "SA",
    latitude: -31.9734,
    longitude: 133.2119,
    accuracy: 4
  },
  {
    postalCode: 5690,
    city: "White Well Corner",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.0129,
    longitude: 133.2552,
    accuracy: 3
  },
  {
    postalCode: 5690,
    city: "Fowlers Bay",
    state_name: "South Australia",
    state: "SA",
    latitude: -31.9865,
    longitude: 132.4349,
    accuracy: 4
  },
  {
    postalCode: 5690,
    city: "Yalata",
    state_name: "South Australia",
    state: "SA",
    latitude: -31.4802,
    longitude: 131.8424,
    accuracy: 4
  },
  {
    postalCode: 5700,
    city: "Winninowie",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.5369,
    longitude: 137.8122,
    accuracy: 3
  },
  {
    postalCode: 5700,
    city: "Port Augusta North",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.6049,
    longitude: 137.6894,
    accuracy: 3
  },
  {
    postalCode: 5700,
    city: "Port Paterson",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.5543,
    longitude: 137.8309,
    accuracy: 4
  },
  {
    postalCode: 5700,
    city: "Port Augusta",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.496,
    longitude: 137.7728,
    accuracy: 4
  },
  {
    postalCode: 5700,
    city: "Commissariat Point",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.5369,
    longitude: 137.8122,
    accuracy: 3
  },
  {
    postalCode: 5700,
    city: "Miranda",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.6139,
    longitude: 137.8949,
    accuracy: 4
  },
  {
    postalCode: 5700,
    city: "Blanche Harbor",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.5369,
    longitude: 137.8122,
    accuracy: 3
  },
  {
    postalCode: 5700,
    city: "Port Augusta West",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.4861,
    longitude: 137.7583,
    accuracy: 4
  },
  {
    postalCode: 5700,
    city: "Wami Kata",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.5369,
    longitude: 137.8122,
    accuracy: 3
  },
  {
    postalCode: 5700,
    city: "Mundallio",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.4678,
    longitude: 137.8842,
    accuracy: 4
  },
  {
    postalCode: 5701,
    city: "Tarcoola",
    state_name: "South Australia",
    state: "SA",
    latitude: -30.7101,
    longitude: 134.5707,
    accuracy: 4
  },
  {
    postalCode: 5701,
    city: "Arkaroola Village",
    state_name: "South Australia",
    state: "SA",
    latitude: -30.3116,
    longitude: 139.3356,
    accuracy: 4
  },
  {
    postalCode: 5701,
    city: "Glendambo",
    state_name: "South Australia",
    state: "SA",
    latitude: -30.9683,
    longitude: 135.7502,
    accuracy: 4
  },
  {
    postalCode: 5701,
    city: "Woolundunga",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.5374,
    longitude: 137.9454,
    accuracy: 4
  },
  {
    postalCode: 5701,
    city: "Cook",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.5369,
    longitude: 137.8122,
    accuracy: 3
  },
  {
    postalCode: 5701,
    city: "Kingoonya",
    state_name: "South Australia",
    state: "SA",
    latitude: -30.9107,
    longitude: 135.3105,
    accuracy: 4
  },
  {
    postalCode: 5701,
    city: "Port Augusta",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.496,
    longitude: 137.7728,
    accuracy: 4
  },
  {
    postalCode: 5710,
    city: "Kingoonya",
    state_name: "South Australia",
    state: "SA",
    latitude: -30.9107,
    longitude: 135.3105,
    accuracy: 4
  },
  {
    postalCode: 5710,
    city: "Cook",
    state_name: "South Australia",
    state: "SA",
    latitude: -29.3441,
    longitude: 134.786,
    accuracy: 3
  },
  {
    postalCode: 5710,
    city: "Nonning",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.5,
    longitude: 136.5,
    accuracy: 4
  },
  {
    postalCode: 5710,
    city: "Stirling North",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.4799,
    longitude: 137.838,
    accuracy: 4
  },
  {
    postalCode: 5710,
    city: "Tarcoola",
    state_name: "South Australia",
    state: "SA",
    latitude: -30.7101,
    longitude: 134.5707,
    accuracy: 4
  },
  {
    postalCode: 5710,
    city: "Port Augusta",
    state_name: "South Australia",
    state: "SA",
    latitude: -32.496,
    longitude: 137.7728,
    accuracy: 4
  },
  {
    postalCode: 5720,
    city: "Pimba",
    state_name: "South Australia",
    state: "SA",
    latitude: -31.2521,
    longitude: 136.8048,
    accuracy: 4
  },
  {
    postalCode: 5720,
    city: "Woomera",
    state_name: "South Australia",
    state: "SA",
    latitude: -31.1998,
    longitude: 136.8326,
    accuracy: 4
  },
  {
    postalCode: 5722,
    city: "Andamooka",
    state_name: "South Australia",
    state: "SA",
    latitude: -30.4481,
    longitude: 137.1656,
    accuracy: 4
  },
  {
    postalCode: 5723,
    city: "Coober Pedy",
    state_name: "South Australia",
    state: "SA",
    latitude: -29.0141,
    longitude: 134.755,
    accuracy: 4
  },
  {
    postalCode: 5724,
    city: "Mintabie",
    state_name: "South Australia",
    state: "SA",
    latitude: -27.3103,
    longitude: 133.2966,
    accuracy: 4
  },
  {
    postalCode: 5724,
    city: "Marla",
    state_name: "South Australia",
    state: "SA",
    latitude: -27.2997,
    longitude: 133.6225,
    accuracy: 4
  },
  {
    postalCode: 5725,
    city: "Olympic Dam",
    state_name: "South Australia",
    state: "SA",
    latitude: -30.4468,
    longitude: 136.8668,
    accuracy: 4
  },
  {
    postalCode: 5725,
    city: "Roxby Downs",
    state_name: "South Australia",
    state: "SA",
    latitude: -30.5631,
    longitude: 136.8955,
    accuracy: 4
  },
  {
    postalCode: 5730,
    city: "Blinman",
    state_name: "South Australia",
    state: "SA",
    latitude: -31.1174,
    longitude: 138.6896,
    accuracy: 4
  },
  {
    postalCode: 5730,
    city: "Beltana",
    state_name: "South Australia",
    state: "SA",
    latitude: -30.8143,
    longitude: 138.4152,
    accuracy: 4
  },
  {
    postalCode: 5730,
    city: "Parachilna",
    state_name: "South Australia",
    state: "SA",
    latitude: -31.1322,
    longitude: 138.395,
    accuracy: 4
  },
  {
    postalCode: 5731,
    city: "Leigh Creek",
    state_name: "South Australia",
    state: "SA",
    latitude: -30.5931,
    longitude: 138.4003,
    accuracy: 4
  },
  {
    postalCode: 5731,
    city: "Innamincka",
    state_name: "South Australia",
    state: "SA",
    latitude: -27.7073,
    longitude: 140.737,
    accuracy: 4
  },
  {
    postalCode: 5731,
    city: "Lyndhurst",
    state_name: "South Australia",
    state: "SA",
    latitude: -30.2879,
    longitude: 138.3493,
    accuracy: 4
  },
  {
    postalCode: 5731,
    city: "Cordillo Downs",
    state_name: "South Australia",
    state: "SA",
    latitude: -30.4405,
    longitude: 138.3748,
    accuracy: 3
  },
  {
    postalCode: 5731,
    city: "Coopers Creek",
    state_name: "South Australia",
    state: "SA",
    latitude: -30.4405,
    longitude: 138.3748,
    accuracy: 3
  },
  {
    postalCode: 5732,
    city: "Copley",
    state_name: "South Australia",
    state: "SA",
    latitude: -30.5599,
    longitude: 138.4213,
    accuracy: 4
  },
  {
    postalCode: 5732,
    city: "Nepabunna",
    state_name: "South Australia",
    state: "SA",
    latitude: -30.5635,
    longitude: 138.967,
    accuracy: 4
  },
  {
    postalCode: 5733,
    city: "Farina",
    state_name: "South Australia",
    state: "SA",
    latitude: -30.0665,
    longitude: 138.2847,
    accuracy: 4
  },
  {
    postalCode: 5733,
    city: "Marree",
    state_name: "South Australia",
    state: "SA",
    latitude: -29.6512,
    longitude: 138.071,
    accuracy: 4
  },
  {
    postalCode: 5734,
    city: "Oodnadatta",
    state_name: "South Australia",
    state: "SA",
    latitude: -27.5514,
    longitude: 135.4491,
    accuracy: 4
  },
  {
    postalCode: 5800,
    city: "Adelaide",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 4
  },
  {
    postalCode: 5810,
    city: "Adelaide",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 4
  },
  {
    postalCode: 5839,
    city: "Adelaide",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 4
  },
  {
    postalCode: 5860,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5861,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5862,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5863,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5864,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5865,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5866,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5867,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5868,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5869,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5870,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5871,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5872,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5873,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5874,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5875,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5876,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5877,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5878,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5879,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5880,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5881,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5882,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5883,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5884,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5885,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5886,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5887,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5888,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5889,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5890,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5891,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5892,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5893,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5894,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5895,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5896,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5897,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5898,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5899,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 1
  },
  {
    postalCode: 5900,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8956,
    longitude: 138.5855,
    accuracy: 1
  },
  {
    postalCode: 5901,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8956,
    longitude: 138.5855,
    accuracy: 1
  },
  {
    postalCode: 5902,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8956,
    longitude: 138.5855,
    accuracy: 1
  },
  {
    postalCode: 5903,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8956,
    longitude: 138.5855,
    accuracy: 1
  },
  {
    postalCode: 5904,
    city: "Adelaide Mail Centre",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8956,
    longitude: 138.5855,
    accuracy: 1
  },
  {
    postalCode: 5920,
    city: "Adelaide",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9287,
    longitude: 138.5986,
    accuracy: 4
  },
  {
    postalCode: 5942,
    city: "Regency Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8626,
    longitude: 138.5724,
    accuracy: 4
  },
  {
    postalCode: 5950,
    city: "Export Park",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9461,
    longitude: 138.5302,
    accuracy: 3
  },
  {
    postalCode: 5950,
    city: "Adelaide Airport",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.9391,
    longitude: 138.5341,
    accuracy: 4
  },
  {
    postalCode: 5960,
    city: "Torrens Island",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8956,
    longitude: 138.5855,
    accuracy: 1
  },
  {
    postalCode: 5960,
    city: "Garden Island",
    state_name: "South Australia",
    state: "SA",
    latitude: -34.8956,
    longitude: 138.5855,
    accuracy: 1
  },
  {
    postalCode: 7000,
    city: "Mount Stuart",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8716,
    longitude: 147.3016,
    accuracy: 4
  },
  {
    postalCode: 7000,
    city: "North Hobart",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8741,
    longitude: 147.316,
    accuracy: 4
  },
  {
    postalCode: 7000,
    city: "Queens Domain",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.877,
    longitude: 147.3288,
    accuracy: 3
  },
  {
    postalCode: 7000,
    city: "West Hobart",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8766,
    longitude: 147.3069,
    accuracy: 4
  },
  {
    postalCode: 7000,
    city: "Glebe",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8747,
    longitude: 147.3281,
    accuracy: 4
  },
  {
    postalCode: 7000,
    city: "Hobart",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8794,
    longitude: 147.3294,
    accuracy: 4
  },
  {
    postalCode: 7001,
    city: "Hobart",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8794,
    longitude: 147.3294,
    accuracy: 4
  },
  {
    postalCode: 7002,
    city: "North Hobart",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8741,
    longitude: 147.316,
    accuracy: 4
  },
  {
    postalCode: 7004,
    city: "South Hobart",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8946,
    longitude: 147.3092,
    accuracy: 4
  },
  {
    postalCode: 7004,
    city: "Battery Point",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8899,
    longitude: 147.3332,
    accuracy: 4
  },
  {
    postalCode: 7005,
    city: "Sandy Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8945,
    longitude: 147.3244,
    accuracy: 4
  },
  {
    postalCode: 7005,
    city: "Dynnyrne",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.9054,
    longitude: 147.3158,
    accuracy: 4
  },
  {
    postalCode: 7005,
    city: "Lower Sandy Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.913,
    longitude: 147.3532,
    accuracy: 3
  },
  {
    postalCode: 7005,
    city: "University Of Tasmania",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.9107,
    longitude: 147.3357,
    accuracy: 3
  },
  {
    postalCode: 7006,
    city: "Sandy Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8945,
    longitude: 147.3244,
    accuracy: 4
  },
  {
    postalCode: 7007,
    city: "Tolmans Hill",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.914,
    longitude: 147.3071,
    accuracy: 4
  },
  {
    postalCode: 7007,
    city: "Mount Nelson",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.9207,
    longitude: 147.3207,
    accuracy: 4
  },
  {
    postalCode: 7008,
    city: "New Town",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8576,
    longitude: 147.3087,
    accuracy: 4
  },
  {
    postalCode: 7008,
    city: "Lenah Valley",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8715,
    longitude: 147.2751,
    accuracy: 4
  },
  {
    postalCode: 7009,
    city: "West Moonah",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.85,
    longitude: 147.2818,
    accuracy: 4
  },
  {
    postalCode: 7009,
    city: "Moonah",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8462,
    longitude: 147.3023,
    accuracy: 4
  },
  {
    postalCode: 7009,
    city: "Derwent Park",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8351,
    longitude: 147.2949,
    accuracy: 4
  },
  {
    postalCode: 7009,
    city: "Lutana",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8347,
    longitude: 147.3115,
    accuracy: 4
  },
  {
    postalCode: 7010,
    city: "Rosetta",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.821,
    longitude: 147.2526,
    accuracy: 4
  },
  {
    postalCode: 7010,
    city: "Montrose",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.829,
    longitude: 147.2473,
    accuracy: 4
  },
  {
    postalCode: 7010,
    city: "Dowsing Point",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8208,
    longitude: 147.3022,
    accuracy: 4
  },
  {
    postalCode: 7010,
    city: "Goodwood",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8282,
    longitude: 147.293,
    accuracy: 4
  },
  {
    postalCode: 7010,
    city: "Elwick",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8355,
    longitude: 147.2646,
    accuracy: 3
  },
  {
    postalCode: 7010,
    city: "Glenorchy",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8334,
    longitude: 147.2759,
    accuracy: 4
  },
  {
    postalCode: 7011,
    city: "Berriedale",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8167,
    longitude: 147.25,
    accuracy: 4
  },
  {
    postalCode: 7011,
    city: "Chigwell",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8091,
    longitude: 147.2448,
    accuracy: 4
  },
  {
    postalCode: 7011,
    city: "Claremont",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7833,
    longitude: 147.25,
    accuracy: 4
  },
  {
    postalCode: 7011,
    city: "Austins Ferry",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7667,
    longitude: 147.25,
    accuracy: 4
  },
  {
    postalCode: 7012,
    city: "Collinsvale",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8417,
    longitude: 147.1961,
    accuracy: 4
  },
  {
    postalCode: 7012,
    city: "Glenlusk",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8167,
    longitude: 147.2,
    accuracy: 4
  },
  {
    postalCode: 7015,
    city: "Geilston Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8296,
    longitude: 147.3463,
    accuracy: 4
  },
  {
    postalCode: 7015,
    city: "Lindisfarne",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8484,
    longitude: 147.3619,
    accuracy: 4
  },
  {
    postalCode: 7015,
    city: "Rose Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.832,
    longitude: 147.3227,
    accuracy: 3
  },
  {
    postalCode: 7016,
    city: "Risdon Vale",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8124,
    longitude: 147.3565,
    accuracy: 4
  },
  {
    postalCode: 7017,
    city: "Honeywood",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7261,
    longitude: 147.2802,
    accuracy: 4
  },
  {
    postalCode: 7017,
    city: "Grasstree Hill",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.782,
    longitude: 147.3613,
    accuracy: 3
  },
  {
    postalCode: 7017,
    city: "Risdon",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8,
    longitude: 147.3333,
    accuracy: 4
  },
  {
    postalCode: 7017,
    city: "Old Beach",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7776,
    longitude: 147.2666,
    accuracy: 4
  },
  {
    postalCode: 7017,
    city: "Otago",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8088,
    longitude: 147.2984,
    accuracy: 4
  },
  {
    postalCode: 7017,
    city: "Tea Tree",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.6833,
    longitude: 147.3167,
    accuracy: 4
  },
  {
    postalCode: 7018,
    city: "Rosny",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8707,
    longitude: 147.357,
    accuracy: 4
  },
  {
    postalCode: 7018,
    city: "Bellerive",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8755,
    longitude: 147.3703,
    accuracy: 4
  },
  {
    postalCode: 7018,
    city: "Montagu Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8626,
    longitude: 147.3533,
    accuracy: 4
  },
  {
    postalCode: 7018,
    city: "Rosny Park",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8661,
    longitude: 147.3677,
    accuracy: 4
  },
  {
    postalCode: 7018,
    city: "Tranmere",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.9218,
    longitude: 147.417,
    accuracy: 4
  },
  {
    postalCode: 7018,
    city: "Warrane",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8555,
    longitude: 147.383,
    accuracy: 4
  },
  {
    postalCode: 7018,
    city: "Mornington",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8627,
    longitude: 147.3982,
    accuracy: 4
  },
  {
    postalCode: 7018,
    city: "Howrah",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8873,
    longitude: 147.4055,
    accuracy: 4
  },
  {
    postalCode: 7019,
    city: "Oakdowns",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.9018,
    longitude: 147.4559,
    accuracy: 4
  },
  {
    postalCode: 7019,
    city: "Clarendon Vale",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8899,
    longitude: 147.4437,
    accuracy: 4
  },
  {
    postalCode: 7019,
    city: "Rokeby",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8987,
    longitude: 147.4492,
    accuracy: 4
  },
  {
    postalCode: 7020,
    city: "Sandford",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.9333,
    longitude: 147.5,
    accuracy: 4
  },
  {
    postalCode: 7020,
    city: "Clifton Beach",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.9853,
    longitude: 147.5211,
    accuracy: 4
  },
  {
    postalCode: 7021,
    city: "Lauderdale",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.9136,
    longitude: 147.4875,
    accuracy: 4
  },
  {
    postalCode: 7022,
    city: "South Arm",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.0247,
    longitude: 147.4149,
    accuracy: 4
  },
  {
    postalCode: 7023,
    city: "Opossum Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.9954,
    longitude: 147.4038,
    accuracy: 4
  },
  {
    postalCode: 7024,
    city: "Cremorne",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.9578,
    longitude: 147.5315,
    accuracy: 4
  },
  {
    postalCode: 7025,
    city: "Richmond",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7355,
    longitude: 147.4383,
    accuracy: 4
  },
  {
    postalCode: 7025,
    city: "Dulcot",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7883,
    longitude: 147.4014,
    accuracy: 4
  },
  {
    postalCode: 7026,
    city: "Campania",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.6648,
    longitude: 147.4232,
    accuracy: 4
  },
  {
    postalCode: 7027,
    city: "Colebrook",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.5333,
    longitude: 147.3667,
    accuracy: 4
  },
  {
    postalCode: 7030,
    city: "Steppes",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.1104,
    longitude: 146.8924,
    accuracy: 4
  },
  {
    postalCode: 7030,
    city: "Flintstone",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.5042,
    longitude: 147.1203,
    accuracy: 3
  },
  {
    postalCode: 7030,
    city: "Bothwell",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.3848,
    longitude: 147.0083,
    accuracy: 4
  },
  {
    postalCode: 7030,
    city: "Pontville",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.687,
    longitude: 147.2686,
    accuracy: 4
  },
  {
    postalCode: 7030,
    city: "Hermitage",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.25,
    longitude: 146.8833,
    accuracy: 4
  },
  {
    postalCode: 7030,
    city: "Tods Corner",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.5042,
    longitude: 147.1203,
    accuracy: 3
  },
  {
    postalCode: 7030,
    city: "Apsley",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.4365,
    longitude: 147.1466,
    accuracy: 4
  },
  {
    postalCode: 7030,
    city: "Broadmarsh",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.65,
    longitude: 147.1167,
    accuracy: 4
  },
  {
    postalCode: 7030,
    city: "Miena",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.9817,
    longitude: 146.7232,
    accuracy: 4
  },
  {
    postalCode: 7030,
    city: "Morass Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.5042,
    longitude: 147.1203,
    accuracy: 3
  },
  {
    postalCode: 7030,
    city: "Kempton",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.5359,
    longitude: 147.2052,
    accuracy: 4
  },
  {
    postalCode: 7030,
    city: "Pelham",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.5833,
    longitude: 147,
    accuracy: 4
  },
  {
    postalCode: 7030,
    city: "Gagebrook",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7477,
    longitude: 147.2698,
    accuracy: 4
  },
  {
    postalCode: 7030,
    city: "Lower Marshes",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.238,
    longitude: 147.01,
    accuracy: 3
  },
  {
    postalCode: 7030,
    city: "Waddamana",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.1271,
    longitude: 146.7476,
    accuracy: 4
  },
  {
    postalCode: 7030,
    city: "Elderslie",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.6,
    longitude: 147.0667,
    accuracy: 4
  },
  {
    postalCode: 7030,
    city: "Shannon",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.238,
    longitude: 147.01,
    accuracy: 3
  },
  {
    postalCode: 7030,
    city: "Bagdad",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.6297,
    longitude: 147.2234,
    accuracy: 4
  },
  {
    postalCode: 7030,
    city: "Jericho",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.3833,
    longitude: 147.2833,
    accuracy: 4
  },
  {
    postalCode: 7030,
    city: "Interlaken",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.15,
    longitude: 147.1833,
    accuracy: 4
  },
  {
    postalCode: 7030,
    city: "Melton Mowbray",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.4667,
    longitude: 147.1833,
    accuracy: 4
  },
  {
    postalCode: 7030,
    city: "Bagdad North",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.5042,
    longitude: 147.1203,
    accuracy: 3
  },
  {
    postalCode: 7030,
    city: "Herdsmans Cove",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7507,
    longitude: 147.2648,
    accuracy: 4
  },
  {
    postalCode: 7030,
    city: "Dysart",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.5667,
    longitude: 147.2,
    accuracy: 4
  },
  {
    postalCode: 7030,
    city: "Granton",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7515,
    longitude: 147.228,
    accuracy: 4
  },
  {
    postalCode: 7030,
    city: "Arthurs Lake",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.5042,
    longitude: 147.1203,
    accuracy: 3
  },
  {
    postalCode: 7030,
    city: "Brighton",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.6981,
    longitude: 147.2449,
    accuracy: 4
  },
  {
    postalCode: 7030,
    city: "Mangalore",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.65,
    longitude: 147.2333,
    accuracy: 4
  },
  {
    postalCode: 7030,
    city: "Millers Bluff",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.5042,
    longitude: 147.1203,
    accuracy: 3
  },
  {
    postalCode: 7030,
    city: "Bridgewater",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7372,
    longitude: 147.2278,
    accuracy: 4
  },
  {
    postalCode: 7030,
    city: "Lake Sorell",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.5042,
    longitude: 147.1203,
    accuracy: 3
  },
  {
    postalCode: 7030,
    city: "Dromedary",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7333,
    longitude: 147.1667,
    accuracy: 4
  },
  {
    postalCode: 7030,
    city: "Cramps Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.5042,
    longitude: 147.1203,
    accuracy: 3
  },
  {
    postalCode: 7030,
    city: "Wilburville",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.5042,
    longitude: 147.1203,
    accuracy: 3
  },
  {
    postalCode: 7030,
    city: "Liawenee",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.5042,
    longitude: 147.1203,
    accuracy: 3
  },
  {
    postalCode: 7050,
    city: "Kingston Beach",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.9802,
    longitude: 147.3194,
    accuracy: 4
  },
  {
    postalCode: 7050,
    city: "Kingston",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.9764,
    longitude: 147.3035,
    accuracy: 4
  },
  {
    postalCode: 7051,
    city: "Kingston",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.9764,
    longitude: 147.3035,
    accuracy: 4
  },
  {
    postalCode: 7052,
    city: "Blackmans Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.0031,
    longitude: 147.3169,
    accuracy: 4
  },
  {
    postalCode: 7053,
    city: "Bonnet Hill",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.968,
    longitude: 147.3319,
    accuracy: 4
  },
  {
    postalCode: 7053,
    city: "Taroona",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.9452,
    longitude: 147.3484,
    accuracy: 4
  },
  {
    postalCode: 7054,
    city: "Coningham",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.0767,
    longitude: 147.2756,
    accuracy: 4
  },
  {
    postalCode: 7054,
    city: "Wellington Park",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.0081,
    longitude: 147.2655,
    accuracy: 3
  },
  {
    postalCode: 7054,
    city: "Margate",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.0281,
    longitude: 147.2626,
    accuracy: 4
  },
  {
    postalCode: 7054,
    city: "Tinderbox",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.0362,
    longitude: 147.3203,
    accuracy: 4
  },
  {
    postalCode: 7054,
    city: "Neika",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.95,
    longitude: 147.2333,
    accuracy: 4
  },
  {
    postalCode: 7054,
    city: "Lower Snug",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.0081,
    longitude: 147.2655,
    accuracy: 3
  },
  {
    postalCode: 7054,
    city: "Electrona",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.0577,
    longitude: 147.2607,
    accuracy: 4
  },
  {
    postalCode: 7054,
    city: "Barretta",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.0339,
    longitude: 147.2463,
    accuracy: 3
  },
  {
    postalCode: 7054,
    city: "Snug",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.0667,
    longitude: 147.2547,
    accuracy: 4
  },
  {
    postalCode: 7054,
    city: "Fern Tree",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.921,
    longitude: 147.2633,
    accuracy: 4
  },
  {
    postalCode: 7054,
    city: "Ridgeway",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.928,
    longitude: 147.289,
    accuracy: 4
  },
  {
    postalCode: 7054,
    city: "Leslie Vale",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.9743,
    longitude: 147.2295,
    accuracy: 4
  },
  {
    postalCode: 7054,
    city: "Howden",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.0254,
    longitude: 147.2937,
    accuracy: 4
  },
  {
    postalCode: 7055,
    city: "Huntingfield",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.0016,
    longitude: 147.2957,
    accuracy: 4
  },
  {
    postalCode: 7109,
    city: "Wattle Grove",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.1673,
    longitude: 146.9986,
    accuracy: 4
  },
  {
    postalCode: 7109,
    city: "Huonville",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.0312,
    longitude: 147.0481,
    accuracy: 4
  },
  {
    postalCode: 7109,
    city: "Raminea",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.2109,
    longitude: 146.8676,
    accuracy: 3
  },
  {
    postalCode: 7109,
    city: "Glen Huon",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.0333,
    longitude: 146.9667,
    accuracy: 4
  },
  {
    postalCode: 7109,
    city: "Glendevie",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.2392,
    longitude: 146.9953,
    accuracy: 4
  },
  {
    postalCode: 7109,
    city: "Hastings",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.4089,
    longitude: 146.9195,
    accuracy: 4
  },
  {
    postalCode: 7109,
    city: "Southport",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.2109,
    longitude: 146.8676,
    accuracy: 3
  },
  {
    postalCode: 7109,
    city: "Cradoc",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.0991,
    longitude: 147.0285,
    accuracy: 4
  },
  {
    postalCode: 7109,
    city: "Grove",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.9833,
    longitude: 147.1,
    accuracy: 4
  },
  {
    postalCode: 7109,
    city: "Lymington",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.1984,
    longitude: 147.0727,
    accuracy: 4
  },
  {
    postalCode: 7109,
    city: "Petcheys Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.2109,
    longitude: 146.8676,
    accuracy: 3
  },
  {
    postalCode: 7109,
    city: "Woodstock",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.0736,
    longitude: 147.0376,
    accuracy: 4
  },
  {
    postalCode: 7109,
    city: "Glaziers Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.1333,
    longitude: 147.05,
    accuracy: 4
  },
  {
    postalCode: 7109,
    city: "Judbury",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.9924,
    longitude: 146.9326,
    accuracy: 4
  },
  {
    postalCode: 7109,
    city: "Lune River",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.4295,
    longitude: 146.9009,
    accuracy: 4
  },
  {
    postalCode: 7109,
    city: "Ranelagh",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.0098,
    longitude: 147.0376,
    accuracy: 4
  },
  {
    postalCode: 7109,
    city: "Crabtree",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.9329,
    longitude: 147.0489,
    accuracy: 4
  },
  {
    postalCode: 7109,
    city: "Lower Longley",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.9791,
    longitude: 147.1444,
    accuracy: 4
  },
  {
    postalCode: 7109,
    city: "Waterloo",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.2109,
    longitude: 146.8676,
    accuracy: 3
  },
  {
    postalCode: 7109,
    city: "Lucaston",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.9833,
    longitude: 147.05,
    accuracy: 4
  },
  {
    postalCode: 7109,
    city: "Strathblane",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.3341,
    longitude: 146.9705,
    accuracy: 4
  },
  {
    postalCode: 7109,
    city: "Lonnavale",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.9754,
    longitude: 146.8397,
    accuracy: 3
  },
  {
    postalCode: 7109,
    city: "Ida Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.1269,
    longitude: 147.0275,
    accuracy: 3
  },
  {
    postalCode: 7109,
    city: "Mountain River",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.945,
    longitude: 147.1257,
    accuracy: 3
  },
  {
    postalCode: 7109,
    city: "Recherche",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.1269,
    longitude: 147.0275,
    accuracy: 3
  },
  {
    postalCode: 7109,
    city: "Southport Lagoon",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.1269,
    longitude: 147.0275,
    accuracy: 3
  },
  {
    postalCode: 7109,
    city: "Lower Wattle Grove",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.1269,
    longitude: 147.0275,
    accuracy: 3
  },
  {
    postalCode: 7109,
    city: "Catamaran",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.5583,
    longitude: 146.8911,
    accuracy: 4
  },
  {
    postalCode: 7112,
    city: "Nicholls Rivulet",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.1585,
    longitude: 147.1447,
    accuracy: 4
  },
  {
    postalCode: 7112,
    city: "Randalls Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.2434,
    longitude: 147.128,
    accuracy: 4
  },
  {
    postalCode: 7112,
    city: "Deep Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.2082,
    longitude: 147.134,
    accuracy: 4
  },
  {
    postalCode: 7112,
    city: "Verona Sands",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.1696,
    longitude: 147.1296,
    accuracy: 3
  },
  {
    postalCode: 7112,
    city: "Garden Island Creek",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.25,
    longitude: 147.1667,
    accuracy: 4
  },
  {
    postalCode: 7112,
    city: "Eggs And Bacon Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.2455,
    longitude: 147.1047,
    accuracy: 3
  },
  {
    postalCode: 7112,
    city: "Cygnet",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.1533,
    longitude: 147.0725,
    accuracy: 4
  },
  {
    postalCode: 7112,
    city: "Charlotte Cove",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.189,
    longitude: 147.148,
    accuracy: 3
  },
  {
    postalCode: 7112,
    city: "Abels Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.1696,
    longitude: 147.1296,
    accuracy: 3
  },
  {
    postalCode: 7112,
    city: "Gardners Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.1757,
    longitude: 147.1323,
    accuracy: 4
  },
  {
    postalCode: 7113,
    city: "Franklin",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.0888,
    longitude: 147.0091,
    accuracy: 4
  },
  {
    postalCode: 7116,
    city: "Castle Forbes Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.1323,
    longitude: 146.9763,
    accuracy: 4
  },
  {
    postalCode: 7116,
    city: "Brooks Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.1708,
    longitude: 146.9784,
    accuracy: 3
  },
  {
    postalCode: 7116,
    city: "Surges Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.2188,
    longitude: 146.9926,
    accuracy: 4
  },
  {
    postalCode: 7116,
    city: "Cairns Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.2775,
    longitude: 146.4256,
    accuracy: 3
  },
  {
    postalCode: 7116,
    city: "Police Point",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.2406,
    longitude: 147.0419,
    accuracy: 4
  },
  {
    postalCode: 7116,
    city: "Surveyors Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.1708,
    longitude: 146.9784,
    accuracy: 3
  },
  {
    postalCode: 7116,
    city: "Port Huon",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.1564,
    longitude: 146.9638,
    accuracy: 4
  },
  {
    postalCode: 7116,
    city: "Geeveston",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.1634,
    longitude: 146.9255,
    accuracy: 4
  },
  {
    postalCode: 7117,
    city: "Dover",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.3142,
    longitude: 147.0149,
    accuracy: 4
  },
  {
    postalCode: 7119,
    city: "Stonor",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.4,
    longitude: 147.3833,
    accuracy: 4
  },
  {
    postalCode: 7120,
    city: "Swanston",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.3482,
    longitude: 147.4726,
    accuracy: 3
  },
  {
    postalCode: 7120,
    city: "Baden",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.4333,
    longitude: 147.4667,
    accuracy: 4
  },
  {
    postalCode: 7120,
    city: "Levendale",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.5333,
    longitude: 147.5667,
    accuracy: 4
  },
  {
    postalCode: 7120,
    city: "Lemont",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.2974,
    longitude: 147.6081,
    accuracy: 4
  },
  {
    postalCode: 7120,
    city: "Tiberias",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.3482,
    longitude: 147.4726,
    accuracy: 3
  },
  {
    postalCode: 7120,
    city: "Andover",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.3333,
    longitude: 147.45,
    accuracy: 4
  },
  {
    postalCode: 7120,
    city: "Mount Seymour",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.4,
    longitude: 147.45,
    accuracy: 4
  },
  {
    postalCode: 7120,
    city: "Parattah",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.35,
    longitude: 147.4,
    accuracy: 4
  },
  {
    postalCode: 7120,
    city: "Oatlands",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.303,
    longitude: 147.3672,
    accuracy: 4
  },
  {
    postalCode: 7120,
    city: "Antill Ponds",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.2089,
    longitude: 147.4018,
    accuracy: 4
  },
  {
    postalCode: 7120,
    city: "Whitefoord",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.4243,
    longitude: 147.5097,
    accuracy: 4
  },
  {
    postalCode: 7120,
    city: "Woodbury",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.1794,
    longitude: 147.3889,
    accuracy: 4
  },
  {
    postalCode: 7120,
    city: "York Plains",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.2792,
    longitude: 147.4456,
    accuracy: 4
  },
  {
    postalCode: 7120,
    city: "Woodsdale",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.4849,
    longitude: 147.5631,
    accuracy: 4
  },
  {
    postalCode: 7120,
    city: "Tunbridge",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.1327,
    longitude: 147.4292,
    accuracy: 4
  },
  {
    postalCode: 7120,
    city: "Pawtella",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.2905,
    longitude: 147.504,
    accuracy: 4
  },
  {
    postalCode: 7120,
    city: "Rhyndaston",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.4789,
    longitude: 147.3837,
    accuracy: 4
  },
  {
    postalCode: 7120,
    city: "Tunnack",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.4519,
    longitude: 147.4618,
    accuracy: 4
  },
  {
    postalCode: 7120,
    city: "Stonehenge",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.4,
    longitude: 147.6333,
    accuracy: 4
  },
  {
    postalCode: 7139,
    city: "Strathgordon",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7665,
    longitude: 146.0521,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Macquarie Plains",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7119,
    longitude: 146.9131,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Plenty",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7419,
    longitude: 146.9554,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Victoria Valley",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.3167,
    longitude: 146.7333,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Sorell Creek",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8133,
    longitude: 147.8342,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Fitzgerald",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7496,
    longitude: 146.6424,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Magra",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.75,
    longitude: 147.0667,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Fentonbury",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.65,
    longitude: 146.7667,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Karanja",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.5434,
    longitude: 146.4477,
    accuracy: 3
  },
  {
    postalCode: 7140,
    city: "Hollow Tree",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.5333,
    longitude: 146.9333,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Maydena",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7548,
    longitude: 146.6256,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Bronte Park",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.136,
    longitude: 146.4932,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Lachlan",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8333,
    longitude: 147.05,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Malbina",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8,
    longitude: 147.1333,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Ouse",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.4862,
    longitude: 146.7126,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Gretna",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.6809,
    longitude: 146.9365,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Glenora",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.6833,
    longitude: 146.8667,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Bushy Park",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7,
    longitude: 146.9,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Hayes",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.76,
    longitude: 147.0124,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Black Hills",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7167,
    longitude: 147.0333,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Hamilton",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.5536,
    longitude: 146.8453,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Mount Field",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.5434,
    longitude: 146.4477,
    accuracy: 3
  },
  {
    postalCode: 7140,
    city: "Mount Lloyd",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8167,
    longitude: 146.95,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Lawitta",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7682,
    longitude: 147.0359,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Osterley",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.35,
    longitude: 146.75,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Bradys Lake",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.5434,
    longitude: 146.4477,
    accuracy: 3
  },
  {
    postalCode: 7140,
    city: "Moogara",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7833,
    longitude: 146.9167,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Wayatinah",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.3769,
    longitude: 146.5085,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Butlers Gorge",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.279,
    longitude: 146.2777,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Lake St Clair",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.5434,
    longitude: 146.4477,
    accuracy: 3
  },
  {
    postalCode: 7140,
    city: "Westerway",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.6833,
    longitude: 146.7833,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Ellendale",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.6167,
    longitude: 146.7167,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "National Park",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.6805,
    longitude: 146.7277,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Molesworth",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.5434,
    longitude: 146.4477,
    accuracy: 3
  },
  {
    postalCode: 7140,
    city: "Tarraleah",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.3015,
    longitude: 146.4492,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Strickland",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.3667,
    longitude: 146.6667,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "New Norfolk",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7826,
    longitude: 147.0587,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Styx",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.618,
    longitude: 146.8279,
    accuracy: 3
  },
  {
    postalCode: 7140,
    city: "Uxbridge",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.773,
    longitude: 146.8686,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Derwent Bridge",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.1394,
    longitude: 146.2314,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Little Pine Lagoon",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.618,
    longitude: 146.8279,
    accuracy: 3
  },
  {
    postalCode: 7140,
    city: "Tyenna",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7287,
    longitude: 146.6665,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Boyer",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7823,
    longitude: 147.1062,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Dee",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.2833,
    longitude: 146.6167,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Glenfern",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8167,
    longitude: 147,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Rosegarland",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7,
    longitude: 146.9489,
    accuracy: 4
  },
  {
    postalCode: 7140,
    city: "Meadowbank",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.618,
    longitude: 146.8279,
    accuracy: 3
  },
  {
    postalCode: 7140,
    city: "Florentine",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.618,
    longitude: 146.8279,
    accuracy: 3
  },
  {
    postalCode: 7140,
    city: "London Lakes",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.618,
    longitude: 146.8279,
    accuracy: 3
  },
  {
    postalCode: 7150,
    city: "Allens Rivulet",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.0151,
    longitude: 147.2014,
    accuracy: 4
  },
  {
    postalCode: 7150,
    city: "Upper Woodstock",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.2345,
    longitude: 147.2537,
    accuracy: 3
  },
  {
    postalCode: 7150,
    city: "South Bruny",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.4386,
    longitude: 147.2462,
    accuracy: 4
  },
  {
    postalCode: 7150,
    city: "Barnes Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.1216,
    longitude: 147.368,
    accuracy: 4
  },
  {
    postalCode: 7150,
    city: "Pelverata",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.0462,
    longitude: 147.1127,
    accuracy: 4
  },
  {
    postalCode: 7150,
    city: "Killora",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.2345,
    longitude: 147.2537,
    accuracy: 3
  },
  {
    postalCode: 7150,
    city: "Oyster Cove",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.1052,
    longitude: 147.2436,
    accuracy: 4
  },
  {
    postalCode: 7150,
    city: "Lunawanna",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.3666,
    longitude: 147.2432,
    accuracy: 4
  },
  {
    postalCode: 7150,
    city: "Simpsons Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.278,
    longitude: 147.2997,
    accuracy: 4
  },
  {
    postalCode: 7150,
    city: "North Bruny",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.1287,
    longitude: 147.2464,
    accuracy: 3
  },
  {
    postalCode: 7150,
    city: "Gordon",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.262,
    longitude: 147.2395,
    accuracy: 4
  },
  {
    postalCode: 7150,
    city: "Apollo Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.1287,
    longitude: 147.2464,
    accuracy: 3
  },
  {
    postalCode: 7150,
    city: "Dennes Point",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.0628,
    longitude: 147.3528,
    accuracy: 4
  },
  {
    postalCode: 7150,
    city: "Great Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.2345,
    longitude: 147.2537,
    accuracy: 3
  },
  {
    postalCode: 7150,
    city: "Adventure Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.3602,
    longitude: 147.3214,
    accuracy: 4
  },
  {
    postalCode: 7150,
    city: "Alonnah",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.315,
    longitude: 147.2443,
    accuracy: 4
  },
  {
    postalCode: 7150,
    city: "Longley",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.9708,
    longitude: 147.1947,
    accuracy: 4
  },
  {
    postalCode: 7150,
    city: "Sandfly",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.9833,
    longitude: 147.1962,
    accuracy: 4
  },
  {
    postalCode: 7150,
    city: "Kaoota",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.0167,
    longitude: 147.1833,
    accuracy: 4
  },
  {
    postalCode: 7151,
    city: "Macquarie Island",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7167,
    longitude: 146.9167,
    accuracy: 3
  },
  {
    postalCode: 7151,
    city: "Macquarie",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7119,
    longitude: 146.9131,
    accuracy: 4
  },
  {
    postalCode: 7151,
    city: "Casey",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7167,
    longitude: 146.9167,
    accuracy: 3
  },
  {
    postalCode: 7151,
    city: "Mawson",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7167,
    longitude: 146.9167,
    accuracy: 3
  },
  {
    postalCode: 7151,
    city: "Davis",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7167,
    longitude: 146.9167,
    accuracy: 3
  },
  {
    postalCode: 7151,
    city: "Heard Island",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7167,
    longitude: 146.9167,
    accuracy: 3
  },
  {
    postalCode: 7151,
    city: "Mcdonald Islands",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7167,
    longitude: 146.9167,
    accuracy: 3
  },
  {
    postalCode: 7155,
    city: "Kettering",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.1262,
    longitude: 147.2464,
    accuracy: 4
  },
  {
    postalCode: 7162,
    city: "Birchs Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.1755,
    longitude: 147.242,
    accuracy: 4
  },
  {
    postalCode: 7162,
    city: "Woodbridge",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.1557,
    longitude: 147.2389,
    accuracy: 4
  },
  {
    postalCode: 7163,
    city: "Flowerpot",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.2336,
    longitude: 147.2198,
    accuracy: 3
  },
  {
    postalCode: 7163,
    city: "Middleton",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.2316,
    longitude: 147.2529,
    accuracy: 4
  },
  {
    postalCode: 7170,
    city: "Seven Mile Beach",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8586,
    longitude: 147.5053,
    accuracy: 4
  },
  {
    postalCode: 7170,
    city: "Roches Beach",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8902,
    longitude: 147.4953,
    accuracy: 4
  },
  {
    postalCode: 7170,
    city: "Cambridge",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8333,
    longitude: 147.45,
    accuracy: 4
  },
  {
    postalCode: 7170,
    city: "Mount Rumney",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8606,
    longitude: 147.4476,
    accuracy: 4
  },
  {
    postalCode: 7170,
    city: "Acton Park",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8793,
    longitude: 147.4846,
    accuracy: 4
  },
  {
    postalCode: 7171,
    city: "Penna",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7776,
    longitude: 147.5228,
    accuracy: 4
  },
  {
    postalCode: 7171,
    city: "Midway Point",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7816,
    longitude: 147.5627,
    accuracy: 4
  },
  {
    postalCode: 7172,
    city: "Orielton",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7333,
    longitude: 147.5333,
    accuracy: 4
  },
  {
    postalCode: 7172,
    city: "Sorell",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7816,
    longitude: 147.5627,
    accuracy: 4
  },
  {
    postalCode: 7172,
    city: "Nugent",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7172,
    longitude: 147.7522,
    accuracy: 4
  },
  {
    postalCode: 7172,
    city: "Pawleena",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7333,
    longitude: 147.6,
    accuracy: 4
  },
  {
    postalCode: 7172,
    city: "Wattle Hill",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7667,
    longitude: 147.65,
    accuracy: 4
  },
  {
    postalCode: 7173,
    city: "Forcett",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8,
    longitude: 147.6333,
    accuracy: 4
  },
  {
    postalCode: 7173,
    city: "Carlton River",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8474,
    longitude: 147.6451,
    accuracy: 3
  },
  {
    postalCode: 7173,
    city: "Primrose Sands",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8858,
    longitude: 147.6695,
    accuracy: 4
  },
  {
    postalCode: 7173,
    city: "Lewisham",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8333,
    longitude: 147.6167,
    accuracy: 4
  },
  {
    postalCode: 7173,
    city: "Dodges Ferry",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8531,
    longitude: 147.6226,
    accuracy: 4
  },
  {
    postalCode: 7173,
    city: "Connellys Marsh",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8222,
    longitude: 147.6703,
    accuracy: 3
  },
  {
    postalCode: 7173,
    city: "Carlton",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.874,
    longitude: 147.6534,
    accuracy: 4
  },
  {
    postalCode: 7174,
    city: "Copping",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8167,
    longitude: 147.8,
    accuracy: 4
  },
  {
    postalCode: 7175,
    city: "Bream Creek",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8133,
    longitude: 147.8342,
    accuracy: 4
  },
  {
    postalCode: 7175,
    city: "Marion Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8133,
    longitude: 147.8342,
    accuracy: 3
  },
  {
    postalCode: 7176,
    city: "Kellevie",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.7785,
    longitude: 147.8153,
    accuracy: 4
  },
  {
    postalCode: 7177,
    city: "Boomer Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8865,
    longitude: 147.8108,
    accuracy: 3
  },
  {
    postalCode: 7177,
    city: "Dunalley",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8865,
    longitude: 147.8108,
    accuracy: 4
  },
  {
    postalCode: 7178,
    city: "Murdunna",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.9473,
    longitude: 147.8705,
    accuracy: 4
  },
  {
    postalCode: 7179,
    city: "Eaglehawk Neck",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.0179,
    longitude: 147.9222,
    accuracy: 4
  },
  {
    postalCode: 7180,
    city: "Taranna",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.0629,
    longitude: 147.863,
    accuracy: 4
  },
  {
    postalCode: 7182,
    city: "Port Arthur",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.1458,
    longitude: 147.8437,
    accuracy: 4
  },
  {
    postalCode: 7182,
    city: "Cape Pillar",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.15,
    longitude: 147.85,
    accuracy: 3
  },
  {
    postalCode: 7182,
    city: "Fortescue",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.15,
    longitude: 147.85,
    accuracy: 3
  },
  {
    postalCode: 7183,
    city: "Highcroft",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.1333,
    longitude: 147.8,
    accuracy: 4
  },
  {
    postalCode: 7184,
    city: "White Beach",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.1249,
    longitude: 147.7212,
    accuracy: 4
  },
  {
    postalCode: 7184,
    city: "Nubeena",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.0971,
    longitude: 147.7433,
    accuracy: 4
  },
  {
    postalCode: 7184,
    city: "Cape Raoul",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.111,
    longitude: 147.7322,
    accuracy: 3
  },
  {
    postalCode: 7184,
    city: "Stormlea",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.1703,
    longitude: 147.7718,
    accuracy: 4
  },
  {
    postalCode: 7185,
    city: "Premaydena",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.0546,
    longitude: 147.7708,
    accuracy: 4
  },
  {
    postalCode: 7186,
    city: "Saltwater River",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.0234,
    longitude: 147.7183,
    accuracy: 4
  },
  {
    postalCode: 7186,
    city: "Sloping Main",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.0167,
    longitude: 147.75,
    accuracy: 3
  },
  {
    postalCode: 7187,
    city: "Koonya",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -43.05,
    longitude: 147.85,
    accuracy: 4
  },
  {
    postalCode: 7190,
    city: "Swansea",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.1228,
    longitude: 148.0743,
    accuracy: 4
  },
  {
    postalCode: 7190,
    city: "Little Swanport",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.3375,
    longitude: 147.9334,
    accuracy: 4
  },
  {
    postalCode: 7190,
    city: "Dolphin Sands",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.4221,
    longitude: 147.8876,
    accuracy: 3
  },
  {
    postalCode: 7190,
    city: "Runnymede",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.6419,
    longitude: 147.5605,
    accuracy: 4
  },
  {
    postalCode: 7190,
    city: "Rheban",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.63,
    longitude: 147.928,
    accuracy: 4
  },
  {
    postalCode: 7190,
    city: "Orford",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.5602,
    longitude: 147.8718,
    accuracy: 4
  },
  {
    postalCode: 7190,
    city: "Cranbrook",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.0062,
    longitude: 148.0689,
    accuracy: 4
  },
  {
    postalCode: 7190,
    city: "Triabunna",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.508,
    longitude: 147.9113,
    accuracy: 4
  },
  {
    postalCode: 7190,
    city: "Spring Beach",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.5841,
    longitude: 147.9041,
    accuracy: 4
  },
  {
    postalCode: 7190,
    city: "Buckland",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.6,
    longitude: 147.7167,
    accuracy: 4
  },
  {
    postalCode: 7190,
    city: "Pontypool",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.4221,
    longitude: 147.8876,
    accuracy: 3
  },
  {
    postalCode: 7190,
    city: "Apslawn",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.9738,
    longitude: 148.1865,
    accuracy: 4
  },
  {
    postalCode: 7190,
    city: "Maria Island",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.3064,
    longitude: 147.9158,
    accuracy: 3
  },
  {
    postalCode: 7190,
    city: "Rocky Hills",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.4221,
    longitude: 147.8876,
    accuracy: 3
  },
  {
    postalCode: 7209,
    city: "Ross",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.0308,
    longitude: 147.4927,
    accuracy: 4
  },
  {
    postalCode: 7209,
    city: "Tooms Lake",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.0308,
    longitude: 147.4927,
    accuracy: 3
  },
  {
    postalCode: 7210,
    city: "Campbell Town",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.9256,
    longitude: 147.4939,
    accuracy: 4
  },
  {
    postalCode: 7210,
    city: "Lake Leake",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.0136,
    longitude: 147.7954,
    accuracy: 4
  },
  {
    postalCode: 7211,
    city: "Cleveland",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.8,
    longitude: 147.4,
    accuracy: 4
  },
  {
    postalCode: 7211,
    city: "Conara",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.8333,
    longitude: 147.4333,
    accuracy: 4
  },
  {
    postalCode: 7211,
    city: "Epping Forest",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.7599,
    longitude: 147.3498,
    accuracy: 4
  },
  {
    postalCode: 7212,
    city: "Evandale",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.5686,
    longitude: 147.2527,
    accuracy: 4
  },
  {
    postalCode: 7212,
    city: "Burns Creek",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4147,
    longitude: 147.5265,
    accuracy: 4
  },
  {
    postalCode: 7212,
    city: "Blessington",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.519,
    longitude: 147.4761,
    accuracy: 4
  },
  {
    postalCode: 7212,
    city: "Upper Blessington",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4591,
    longitude: 147.5922,
    accuracy: 4
  },
  {
    postalCode: 7212,
    city: "Nile",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.6454,
    longitude: 147.3301,
    accuracy: 4
  },
  {
    postalCode: 7212,
    city: "Deddington",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.6024,
    longitude: 147.4272,
    accuracy: 4
  },
  {
    postalCode: 7212,
    city: "Western Junction",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.5543,
    longitude: 147.2282,
    accuracy: 4
  },
  {
    postalCode: 7212,
    city: "Ben Lomond",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.5535,
    longitude: 147.3829,
    accuracy: 3
  },
  {
    postalCode: 7213,
    city: "Royal George",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.8307,
    longitude: 147.8968,
    accuracy: 4
  },
  {
    postalCode: 7213,
    city: "Rossarden",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.667,
    longitude: 147.745,
    accuracy: 4
  },
  {
    postalCode: 7213,
    city: "Avoca",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.7864,
    longitude: 147.7209,
    accuracy: 4
  },
  {
    postalCode: 7214,
    city: "Mangana",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.6081,
    longitude: 147.8854,
    accuracy: 4
  },
  {
    postalCode: 7214,
    city: "Fingal",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.6396,
    longitude: 147.9695,
    accuracy: 4
  },
  {
    postalCode: 7214,
    city: "Upper Esk",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4308,
    longitude: 147.7256,
    accuracy: 4
  },
  {
    postalCode: 7214,
    city: "Mathinna",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4751,
    longitude: 147.89,
    accuracy: 4
  },
  {
    postalCode: 7215,
    city: "Seymour",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.7438,
    longitude: 148.2762,
    accuracy: 4
  },
  {
    postalCode: 7215,
    city: "Scamander",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.456,
    longitude: 148.261,
    accuracy: 4
  },
  {
    postalCode: 7215,
    city: "Douglas River",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.7856,
    longitude: 148.2503,
    accuracy: 4
  },
  {
    postalCode: 7215,
    city: "Douglas-Apsley",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.6675,
    longitude: 148.2438,
    accuracy: 3
  },
  {
    postalCode: 7215,
    city: "Falmouth",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.5058,
    longitude: 148.2709,
    accuracy: 4
  },
  {
    postalCode: 7215,
    city: "St Marys",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.5834,
    longitude: 148.1875,
    accuracy: 4
  },
  {
    postalCode: 7215,
    city: "Coles Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.1264,
    longitude: 148.2887,
    accuracy: 4
  },
  {
    postalCode: 7215,
    city: "Friendly Beaches",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.6675,
    longitude: 148.2438,
    accuracy: 3
  },
  {
    postalCode: 7215,
    city: "Bicheno",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.8743,
    longitude: 148.3024,
    accuracy: 4
  },
  {
    postalCode: 7215,
    city: "Cornwall",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.559,
    longitude: 148.1453,
    accuracy: 4
  },
  {
    postalCode: 7215,
    city: "Four Mile Creek",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.723,
    longitude: 148.1894,
    accuracy: 3
  },
  {
    postalCode: 7215,
    city: "Beaumaris",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4159,
    longitude: 148.2614,
    accuracy: 4
  },
  {
    postalCode: 7215,
    city: "Chain Of Lagoons",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.723,
    longitude: 148.1894,
    accuracy: 3
  },
  {
    postalCode: 7215,
    city: "Gray",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.6287,
    longitude: 148.2284,
    accuracy: 4
  },
  {
    postalCode: 7215,
    city: "Upper Scamander",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.6675,
    longitude: 148.2438,
    accuracy: 3
  },
  {
    postalCode: 7215,
    city: "Freycinet",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.6675,
    longitude: 148.2438,
    accuracy: 3
  },
  {
    postalCode: 7216,
    city: "The Gardens",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2651,
    longitude: 148.1443,
    accuracy: 3
  },
  {
    postalCode: 7216,
    city: "Pyengana",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2918,
    longitude: 148.0127,
    accuracy: 4
  },
  {
    postalCode: 7216,
    city: "Goshen",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2721,
    longitude: 148.1054,
    accuracy: 4
  },
  {
    postalCode: 7216,
    city: "Ansons Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2687,
    longitude: 148.0987,
    accuracy: 3
  },
  {
    postalCode: 7216,
    city: "St Helens",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3203,
    longitude: 148.2389,
    accuracy: 4
  },
  {
    postalCode: 7216,
    city: "Lottah",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2258,
    longitude: 148.0324,
    accuracy: 4
  },
  {
    postalCode: 7216,
    city: "Stieglitz",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3217,
    longitude: 148.3058,
    accuracy: 4
  },
  {
    postalCode: 7216,
    city: "Goulds Country",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2422,
    longitude: 148.056,
    accuracy: 4
  },
  {
    postalCode: 7216,
    city: "Akaroa",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3045,
    longitude: 148.3167,
    accuracy: 3
  },
  {
    postalCode: 7216,
    city: "Binalong Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2511,
    longitude: 148.3117,
    accuracy: 4
  },
  {
    postalCode: 7248,
    city: "Newnham",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3971,
    longitude: 147.1313,
    accuracy: 4
  },
  {
    postalCode: 7248,
    city: "Rocherlea",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3808,
    longitude: 147.1574,
    accuracy: 4
  },
  {
    postalCode: 7248,
    city: "Mowbray",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4024,
    longitude: 147.1506,
    accuracy: 4
  },
  {
    postalCode: 7248,
    city: "Mayfield",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3876,
    longitude: 147.1305,
    accuracy: 4
  },
  {
    postalCode: 7248,
    city: "Invermay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4204,
    longitude: 147.1336,
    accuracy: 4
  },
  {
    postalCode: 7249,
    city: "Youngtown",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4833,
    longitude: 147.1707,
    accuracy: 4
  },
  {
    postalCode: 7249,
    city: "Kings Meadows",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4704,
    longitude: 147.162,
    accuracy: 4
  },
  {
    postalCode: 7249,
    city: "Glen Dhu",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.476,
    longitude: 147.1577,
    accuracy: 3
  },
  {
    postalCode: 7249,
    city: "Punchbowl",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4576,
    longitude: 147.1647,
    accuracy: 4
  },
  {
    postalCode: 7249,
    city: "South Launceston",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4551,
    longitude: 147.1456,
    accuracy: 4
  },
  {
    postalCode: 7250,
    city: "Norwood",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4592,
    longitude: 147.1808,
    accuracy: 4
  },
  {
    postalCode: 7250,
    city: "Prospect",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.481,
    longitude: 147.1041,
    accuracy: 4
  },
  {
    postalCode: 7250,
    city: "Prospect Vale",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.481,
    longitude: 147.1041,
    accuracy: 4
  },
  {
    postalCode: 7250,
    city: "Waverley",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.436,
    longitude: 147.1859,
    accuracy: 4
  },
  {
    postalCode: 7250,
    city: "Trevallyn",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4425,
    longitude: 147.1048,
    accuracy: 4
  },
  {
    postalCode: 7250,
    city: "East Launceston",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4384,
    longitude: 147.151,
    accuracy: 4
  },
  {
    postalCode: 7250,
    city: "Newstead",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4333,
    longitude: 147.1667,
    accuracy: 4
  },
  {
    postalCode: 7250,
    city: "Travellers Rest",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4971,
    longitude: 147.0929,
    accuracy: 4
  },
  {
    postalCode: 7250,
    city: "Launceston",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4388,
    longitude: 147.1347,
    accuracy: 4
  },
  {
    postalCode: 7250,
    city: "Blackstone Heights",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4598,
    longitude: 147.0841,
    accuracy: 4
  },
  {
    postalCode: 7250,
    city: "Summerhill",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4675,
    longitude: 147.128,
    accuracy: 4
  },
  {
    postalCode: 7250,
    city: "West Launceston",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4509,
    longitude: 147.1311,
    accuracy: 4
  },
  {
    postalCode: 7250,
    city: "Riverside",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4211,
    longitude: 147.0509,
    accuracy: 4
  },
  {
    postalCode: 7250,
    city: "Ravenswood",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4159,
    longitude: 147.1825,
    accuracy: 4
  },
  {
    postalCode: 7250,
    city: "St Leonards",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4625,
    longitude: 147.2146,
    accuracy: 4
  },
  {
    postalCode: 7252,
    city: "Swan Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1315,
    longitude: 147.01,
    accuracy: 3
  },
  {
    postalCode: 7252,
    city: "Dilston",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3296,
    longitude: 147.0652,
    accuracy: 4
  },
  {
    postalCode: 7252,
    city: "Pipers River",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0973,
    longitude: 147.0809,
    accuracy: 4
  },
  {
    postalCode: 7252,
    city: "Weymouth",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0145,
    longitude: 147.1517,
    accuracy: 4
  },
  {
    postalCode: 7252,
    city: "Mount Direction",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2464,
    longitude: 147.0132,
    accuracy: 4
  },
  {
    postalCode: 7252,
    city: "Lefroy",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1,
    longitude: 146.9833,
    accuracy: 4
  },
  {
    postalCode: 7252,
    city: "Hillwood",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2442,
    longitude: 146.9842,
    accuracy: 4
  },
  {
    postalCode: 7252,
    city: "Beechford",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1315,
    longitude: 147.01,
    accuracy: 3
  },
  {
    postalCode: 7252,
    city: "Windermere",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3134,
    longitude: 147.0058,
    accuracy: 4
  },
  {
    postalCode: 7252,
    city: "Stony Head",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1659,
    longitude: 147.0475,
    accuracy: 3
  },
  {
    postalCode: 7252,
    city: "Lulworth",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41,
    longitude: 147.07,
    accuracy: 4
  },
  {
    postalCode: 7253,
    city: "George Town",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1056,
    longitude: 146.8261,
    accuracy: 4
  },
  {
    postalCode: 7253,
    city: "Long Reach",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0971,
    longitude: 146.8325,
    accuracy: 3
  },
  {
    postalCode: 7253,
    city: "Low Head",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.08,
    longitude: 146.8075,
    accuracy: 4
  },
  {
    postalCode: 7253,
    city: "Bell Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.13,
    longitude: 146.87,
    accuracy: 4
  },
  {
    postalCode: 7254,
    city: "Golconda",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.167,
    longitude: 147.3094,
    accuracy: 4
  },
  {
    postalCode: 7254,
    city: "Lebrina",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.179,
    longitude: 147.2283,
    accuracy: 4
  },
  {
    postalCode: 7254,
    city: "Tunnel",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1952,
    longitude: 147.193,
    accuracy: 4
  },
  {
    postalCode: 7254,
    city: "Pipers Brook",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0831,
    longitude: 147.1743,
    accuracy: 4
  },
  {
    postalCode: 7254,
    city: "Bellingham",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0164,
    longitude: 147.1688,
    accuracy: 4
  },
  {
    postalCode: 7254,
    city: "Retreat",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1505,
    longitude: 147.173,
    accuracy: 4
  },
  {
    postalCode: 7254,
    city: "Wyena",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.176,
    longitude: 147.2668,
    accuracy: 4
  },
  {
    postalCode: 7255,
    city: "Ranga",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.1522,
    longitude: 148.0673,
    accuracy: 4
  },
  {
    postalCode: 7255,
    city: "Emita",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.0008,
    longitude: 147.9165,
    accuracy: 4
  },
  {
    postalCode: 7255,
    city: "Blue Rocks",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.0571,
    longitude: 147.9555,
    accuracy: 4
  },
  {
    postalCode: 7255,
    city: "Loccota",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.2181,
    longitude: 148.0423,
    accuracy: 4
  },
  {
    postalCode: 7255,
    city: "Leeka",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -39.9005,
    longitude: 147.7989,
    accuracy: 4
  },
  {
    postalCode: 7255,
    city: "Lackrana",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.1194,
    longitude: 148.0978,
    accuracy: 3
  },
  {
    postalCode: 7255,
    city: "Lughrata",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -39.9741,
    longitude: 147.9297,
    accuracy: 4
  },
  {
    postalCode: 7255,
    city: "Strzelecki",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.0066,
    longitude: 147.9897,
    accuracy: 3
  },
  {
    postalCode: 7255,
    city: "Lady Barron",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.21,
    longitude: 148.24,
    accuracy: 4
  },
  {
    postalCode: 7255,
    city: "Wingaroo",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.0066,
    longitude: 147.9897,
    accuracy: 3
  },
  {
    postalCode: 7255,
    city: "Palana",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -39.7667,
    longitude: 147.8833,
    accuracy: 4
  },
  {
    postalCode: 7255,
    city: "Whitemark",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.1222,
    longitude: 148.0164,
    accuracy: 4
  },
  {
    postalCode: 7255,
    city: "Killiecrankie",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -39.8391,
    longitude: 147.834,
    accuracy: 4
  },
  {
    postalCode: 7255,
    city: "Memana",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -39.9789,
    longitude: 148.0914,
    accuracy: 4
  },
  {
    postalCode: 7256,
    city: "Naracoopa",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -39.9208,
    longitude: 144.1194,
    accuracy: 4
  },
  {
    postalCode: 7256,
    city: "Yarra Creek",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -39.8478,
    longitude: 143.9795,
    accuracy: 3
  },
  {
    postalCode: 7256,
    city: "Yambacoona",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -39.7042,
    longitude: 143.9306,
    accuracy: 4
  },
  {
    postalCode: 7256,
    city: "Currie",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -39.9298,
    longitude: 143.8538,
    accuracy: 4
  },
  {
    postalCode: 7256,
    city: "Grassy",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.0492,
    longitude: 144.0561,
    accuracy: 4
  },
  {
    postalCode: 7256,
    city: "Pearshape",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -39.8478,
    longitude: 143.9795,
    accuracy: 3
  },
  {
    postalCode: 7256,
    city: "Pegarah",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -39.9417,
    longitude: 143.9958,
    accuracy: 4
  },
  {
    postalCode: 7256,
    city: "Loorana",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -39.8389,
    longitude: 143.8958,
    accuracy: 4
  },
  {
    postalCode: 7256,
    city: "Sea Elephant",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -39.8286,
    longitude: 144.1111,
    accuracy: 4
  },
  {
    postalCode: 7256,
    city: "Surprise Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -39.8478,
    longitude: 143.9795,
    accuracy: 3
  },
  {
    postalCode: 7256,
    city: "Reekara",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -39.7553,
    longitude: 143.9175,
    accuracy: 4
  },
  {
    postalCode: 7256,
    city: "Nugara",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -39.8478,
    longitude: 143.9795,
    accuracy: 3
  },
  {
    postalCode: 7256,
    city: "Bungaree",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -39.8478,
    longitude: 143.9795,
    accuracy: 3
  },
  {
    postalCode: 7256,
    city: "Lymwood",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -39.8478,
    longitude: 143.9795,
    accuracy: 3
  },
  {
    postalCode: 7256,
    city: "Wickham",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -39.8478,
    longitude: 143.9795,
    accuracy: 3
  },
  {
    postalCode: 7256,
    city: "Egg Lagoon",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -39.6611,
    longitude: 143.9764,
    accuracy: 4
  },
  {
    postalCode: 7257,
    city: "Cape Barren Island",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.3734,
    longitude: 148.027,
    accuracy: 4
  },
  {
    postalCode: 7258,
    city: "Relbia",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.5058,
    longitude: 147.2021,
    accuracy: 3
  },
  {
    postalCode: 7258,
    city: "White Hills",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.5055,
    longitude: 147.2543,
    accuracy: 4
  },
  {
    postalCode: 7258,
    city: "Breadalbane",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.5268,
    longitude: 147.1965,
    accuracy: 4
  },
  {
    postalCode: 7259,
    city: "Patersonia",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3403,
    longitude: 147.303,
    accuracy: 4
  },
  {
    postalCode: 7259,
    city: "Myrtle Bank",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2941,
    longitude: 147.3584,
    accuracy: 4
  },
  {
    postalCode: 7259,
    city: "Targa",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3138,
    longitude: 147.367,
    accuracy: 4
  },
  {
    postalCode: 7259,
    city: "Nunamara",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3896,
    longitude: 147.3067,
    accuracy: 4
  },
  {
    postalCode: 7259,
    city: "Tayene",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3457,
    longitude: 147.4494,
    accuracy: 4
  },
  {
    postalCode: 7260,
    city: "North Scottsdale",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1215,
    longitude: 147.5595,
    accuracy: 4
  },
  {
    postalCode: 7260,
    city: "Blumont",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1681,
    longitude: 147.4846,
    accuracy: 3
  },
  {
    postalCode: 7260,
    city: "Nabowla",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1712,
    longitude: 147.3662,
    accuracy: 4
  },
  {
    postalCode: 7260,
    city: "Jetsonville",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1167,
    longitude: 147.4667,
    accuracy: 4
  },
  {
    postalCode: 7260,
    city: "Scottsdale",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1578,
    longitude: 147.5173,
    accuracy: 4
  },
  {
    postalCode: 7260,
    city: "Cuckoo",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1674,
    longitude: 147.5017,
    accuracy: 3
  },
  {
    postalCode: 7260,
    city: "South Springfield",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2515,
    longitude: 147.5081,
    accuracy: 4
  },
  {
    postalCode: 7260,
    city: "Tonganah",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1862,
    longitude: 147.5881,
    accuracy: 4
  },
  {
    postalCode: 7260,
    city: "Springfield",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2,
    longitude: 147.4833,
    accuracy: 4
  },
  {
    postalCode: 7260,
    city: "Tulendeena",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1681,
    longitude: 147.4846,
    accuracy: 3
  },
  {
    postalCode: 7260,
    city: "Kamona",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1542,
    longitude: 147.6768,
    accuracy: 4
  },
  {
    postalCode: 7260,
    city: "Lietinna",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.15,
    longitude: 147.4667,
    accuracy: 4
  },
  {
    postalCode: 7260,
    city: "Forester",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0848,
    longitude: 147.6633,
    accuracy: 4
  },
  {
    postalCode: 7260,
    city: "West Scottsdale",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1674,
    longitude: 147.5017,
    accuracy: 3
  },
  {
    postalCode: 7260,
    city: "Lisle",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2307,
    longitude: 147.3345,
    accuracy: 4
  },
  {
    postalCode: 7261,
    city: "Branxholm",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1662,
    longitude: 147.7431,
    accuracy: 4
  },
  {
    postalCode: 7261,
    city: "Warrentinna",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1004,
    longitude: 147.7559,
    accuracy: 4
  },
  {
    postalCode: 7262,
    city: "Waterhouse",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.9607,
    longitude: 147.6967,
    accuracy: 3
  },
  {
    postalCode: 7262,
    city: "Tomahawk",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.867,
    longitude: 147.756,
    accuracy: 4
  },
  {
    postalCode: 7262,
    city: "Bridport",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0005,
    longitude: 147.3918,
    accuracy: 4
  },
  {
    postalCode: 7263,
    city: "Trenah",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3106,
    longitude: 147.69,
    accuracy: 4
  },
  {
    postalCode: 7263,
    city: "Talawa",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2521,
    longitude: 147.7302,
    accuracy: 3
  },
  {
    postalCode: 7263,
    city: "Legerwood",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.213,
    longitude: 147.6994,
    accuracy: 4
  },
  {
    postalCode: 7263,
    city: "Ringarooma",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2418,
    longitude: 147.7376,
    accuracy: 4
  },
  {
    postalCode: 7263,
    city: "Alberton",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2679,
    longitude: 147.8003,
    accuracy: 4
  },
  {
    postalCode: 7264,
    city: "Gladstone",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.9593,
    longitude: 148.0094,
    accuracy: 4
  },
  {
    postalCode: 7264,
    city: "South Mount Cameron",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0246,
    longitude: 147.9639,
    accuracy: 4
  },
  {
    postalCode: 7264,
    city: "Boobyalla",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0696,
    longitude: 147.9241,
    accuracy: 3
  },
  {
    postalCode: 7264,
    city: "Mount William",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.9221,
    longitude: 148.2129,
    accuracy: 4
  },
  {
    postalCode: 7264,
    city: "Cape Portland",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0754,
    longitude: 148.0082,
    accuracy: 3
  },
  {
    postalCode: 7264,
    city: "Telita",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1657,
    longitude: 147.7408,
    accuracy: 4
  },
  {
    postalCode: 7264,
    city: "Eddystone",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0696,
    longitude: 147.9241,
    accuracy: 3
  },
  {
    postalCode: 7264,
    city: "Moorina",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1275,
    longitude: 147.8695,
    accuracy: 4
  },
  {
    postalCode: 7264,
    city: "Pioneer",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0754,
    longitude: 148.0082,
    accuracy: 3
  },
  {
    postalCode: 7264,
    city: "Ansons Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0696,
    longitude: 147.9241,
    accuracy: 3
  },
  {
    postalCode: 7264,
    city: "Derby",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1489,
    longitude: 147.8025,
    accuracy: 4
  },
  {
    postalCode: 7264,
    city: "Musselroe Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.8803,
    longitude: 148.1374,
    accuracy: 4
  },
  {
    postalCode: 7264,
    city: "Weldborough",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1938,
    longitude: 147.9067,
    accuracy: 4
  },
  {
    postalCode: 7264,
    city: "Rushy Lagoon",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0696,
    longitude: 147.9241,
    accuracy: 3
  },
  {
    postalCode: 7264,
    city: "Herrick",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1002,
    longitude: 147.8826,
    accuracy: 4
  },
  {
    postalCode: 7265,
    city: "Winnaleah",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0975,
    longitude: 147.8238,
    accuracy: 4
  },
  {
    postalCode: 7265,
    city: "Banca",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0833,
    longitude: 147.8167,
    accuracy: 3
  },
  {
    postalCode: 7267,
    city: "Karoola",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2443,
    longitude: 147.1534,
    accuracy: 4
  },
  {
    postalCode: 7267,
    city: "Bangor",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2184,
    longitude: 147.1411,
    accuracy: 4
  },
  {
    postalCode: 7267,
    city: "Turners Marsh",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2666,
    longitude: 147.1311,
    accuracy: 4
  },
  {
    postalCode: 7267,
    city: "Lalla",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2565,
    longitude: 147.1783,
    accuracy: 4
  },
  {
    postalCode: 7267,
    city: "Lower Turners Marsh",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2085,
    longitude: 147.1126,
    accuracy: 4
  },
  {
    postalCode: 7268,
    city: "Underwood",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.288,
    longitude: 147.2136,
    accuracy: 4
  },
  {
    postalCode: 7268,
    city: "Lilydale",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2503,
    longitude: 147.2176,
    accuracy: 4
  },
  {
    postalCode: 7268,
    city: "North Lilydale",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2257,
    longitude: 147.2404,
    accuracy: 4
  },
  {
    postalCode: 7270,
    city: "Rowella",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2,
    longitude: 146.9,
    accuracy: 4
  },
  {
    postalCode: 7270,
    city: "York Town",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1725,
    longitude: 146.8325,
    accuracy: 3
  },
  {
    postalCode: 7270,
    city: "Sidmouth",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2085,
    longitude: 146.8949,
    accuracy: 4
  },
  {
    postalCode: 7270,
    city: "Kelso",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1049,
    longitude: 146.7929,
    accuracy: 4
  },
  {
    postalCode: 7270,
    city: "Greens Beach",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0848,
    longitude: 146.7504,
    accuracy: 4
  },
  {
    postalCode: 7270,
    city: "Badger Head",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1725,
    longitude: 146.8325,
    accuracy: 3
  },
  {
    postalCode: 7270,
    city: "Kayena",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1889,
    longitude: 146.895,
    accuracy: 4
  },
  {
    postalCode: 7270,
    city: "Flowery Gully",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2582,
    longitude: 146.8159,
    accuracy: 4
  },
  {
    postalCode: 7270,
    city: "Beauty Point",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1622,
    longitude: 146.8215,
    accuracy: 4
  },
  {
    postalCode: 7270,
    city: "Beaconsfield",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2023,
    longitude: 146.8172,
    accuracy: 4
  },
  {
    postalCode: 7270,
    city: "Clarence Point",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1293,
    longitude: 146.7892,
    accuracy: 4
  },
  {
    postalCode: 7275,
    city: "Blackwall",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3021,
    longitude: 146.969,
    accuracy: 4
  },
  {
    postalCode: 7275,
    city: "Swan Point",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2613,
    longitude: 146.9644,
    accuracy: 4
  },
  {
    postalCode: 7275,
    city: "Notley Hills",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3485,
    longitude: 146.9286,
    accuracy: 4
  },
  {
    postalCode: 7275,
    city: "Lanena",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3021,
    longitude: 146.969,
    accuracy: 4
  },
  {
    postalCode: 7275,
    city: "Glengarry",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3488,
    longitude: 146.8655,
    accuracy: 4
  },
  {
    postalCode: 7275,
    city: "Robigana",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2618,
    longitude: 146.9465,
    accuracy: 4
  },
  {
    postalCode: 7275,
    city: "Loira",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.276,
    longitude: 146.923,
    accuracy: 4
  },
  {
    postalCode: 7275,
    city: "Winkleigh",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2933,
    longitude: 146.8358,
    accuracy: 4
  },
  {
    postalCode: 7275,
    city: "Holwell",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2831,
    longitude: 146.7813,
    accuracy: 4
  },
  {
    postalCode: 7275,
    city: "Deviot",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2353,
    longitude: 146.9298,
    accuracy: 4
  },
  {
    postalCode: 7275,
    city: "Exeter",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2975,
    longitude: 146.9505,
    accuracy: 4
  },
  {
    postalCode: 7275,
    city: "Frankford",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3333,
    longitude: 146.7758,
    accuracy: 4
  },
  {
    postalCode: 7276,
    city: "Gravelly Beach",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2863,
    longitude: 146.9752,
    accuracy: 4
  },
  {
    postalCode: 7277,
    city: "Grindelwald",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3515,
    longitude: 147.0052,
    accuracy: 4
  },
  {
    postalCode: 7277,
    city: "Legana",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3657,
    longitude: 147.0458,
    accuracy: 4
  },
  {
    postalCode: 7277,
    city: "Rosevears",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3243,
    longitude: 147.0043,
    accuracy: 4
  },
  {
    postalCode: 7277,
    city: "Bridgenorth",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3839,
    longitude: 146.9757,
    accuracy: 4
  },
  {
    postalCode: 7290,
    city: "Hadspen",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.5006,
    longitude: 147.0736,
    accuracy: 4
  },
  {
    postalCode: 7291,
    city: "Carrick",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.5324,
    longitude: 147.0103,
    accuracy: 4
  },
  {
    postalCode: 7292,
    city: "Quamby Bend",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4667,
    longitude: 146.9111,
    accuracy: 3
  },
  {
    postalCode: 7292,
    city: "Selbourne",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4496,
    longitude: 146.8896,
    accuracy: 4
  },
  {
    postalCode: 7292,
    city: "Westwood",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4859,
    longitude: 146.9817,
    accuracy: 4
  },
  {
    postalCode: 7292,
    city: "Hagley",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.526,
    longitude: 146.9026,
    accuracy: 4
  },
  {
    postalCode: 7292,
    city: "Rosevale",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4167,
    longitude: 146.9333,
    accuracy: 4
  },
  {
    postalCode: 7300,
    city: "Perth",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.5723,
    longitude: 147.171,
    accuracy: 4
  },
  {
    postalCode: 7300,
    city: "Devon Hills",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.5591,
    longitude: 147.1951,
    accuracy: 3
  },
  {
    postalCode: 7300,
    city: "Powranna",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.687,
    longitude: 147.2892,
    accuracy: 4
  },
  {
    postalCode: 7301,
    city: "Blackwood Creek",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.7366,
    longitude: 146.8979,
    accuracy: 4
  },
  {
    postalCode: 7301,
    city: "Longford",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.6051,
    longitude: 147.1189,
    accuracy: 4
  },
  {
    postalCode: 7301,
    city: "Bishopsbourne",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.617,
    longitude: 146.9979,
    accuracy: 4
  },
  {
    postalCode: 7301,
    city: "Liffey",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.6842,
    longitude: 146.8542,
    accuracy: 4
  },
  {
    postalCode: 7301,
    city: "Toiberry",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.6096,
    longitude: 147.0412,
    accuracy: 4
  },
  {
    postalCode: 7302,
    city: "Cressy",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.6856,
    longitude: 147.0779,
    accuracy: 4
  },
  {
    postalCode: 7302,
    city: "Poatina",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.7957,
    longitude: 146.9608,
    accuracy: 4
  },
  {
    postalCode: 7302,
    city: "Bracknell",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.65,
    longitude: 146.9384,
    accuracy: 4
  },
  {
    postalCode: 7303,
    city: "Osmaston",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.5318,
    longitude: 146.8687,
    accuracy: 3
  },
  {
    postalCode: 7303,
    city: "Cluan",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.605,
    longitude: 146.8726,
    accuracy: 4
  },
  {
    postalCode: 7303,
    city: "Birralee",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4096,
    longitude: 146.8172,
    accuracy: 4
  },
  {
    postalCode: 7303,
    city: "Westbury",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.5291,
    longitude: 146.8391,
    accuracy: 4
  },
  {
    postalCode: 7303,
    city: "Exton",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.5209,
    longitude: 146.7421,
    accuracy: 4
  },
  {
    postalCode: 7303,
    city: "Oaks",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.5898,
    longitude: 146.9819,
    accuracy: 4
  },
  {
    postalCode: 7303,
    city: "Whitemore",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.5833,
    longitude: 146.9333,
    accuracy: 4
  },
  {
    postalCode: 7304,
    city: "Weegena",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4881,
    longitude: 146.4819,
    accuracy: 4
  },
  {
    postalCode: 7304,
    city: "Dunorlan",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4834,
    longitude: 146.5449,
    accuracy: 4
  },
  {
    postalCode: 7304,
    city: "Western Creek",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.6889,
    longitude: 146.4032,
    accuracy: 3
  },
  {
    postalCode: 7304,
    city: "Quamby Brook",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.6014,
    longitude: 146.7271,
    accuracy: 4
  },
  {
    postalCode: 7304,
    city: "Dairy Plains",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.6889,
    longitude: 146.4032,
    accuracy: 3
  },
  {
    postalCode: 7304,
    city: "Montana",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.5955,
    longitude: 146.5871,
    accuracy: 4
  },
  {
    postalCode: 7304,
    city: "Reedy Marsh",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4477,
    longitude: 146.7128,
    accuracy: 4
  },
  {
    postalCode: 7304,
    city: "Liena",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.5515,
    longitude: 146.233,
    accuracy: 4
  },
  {
    postalCode: 7304,
    city: "Mersey Forest",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.6889,
    longitude: 146.4032,
    accuracy: 3
  },
  {
    postalCode: 7304,
    city: "Meander",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.653,
    longitude: 146.6296,
    accuracy: 4
  },
  {
    postalCode: 7304,
    city: "Moltema",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4598,
    longitude: 146.5395,
    accuracy: 4
  },
  {
    postalCode: 7304,
    city: "Mayberry",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.5836,
    longitude: 146.3013,
    accuracy: 4
  },
  {
    postalCode: 7304,
    city: "Brandum",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.5465,
    longitude: 146.5541,
    accuracy: 3
  },
  {
    postalCode: 7304,
    city: "Walls Of Jerusalem",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.5465,
    longitude: 146.5541,
    accuracy: 3
  },
  {
    postalCode: 7304,
    city: "Elizabeth Town",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.468,
    longitude: 146.5637,
    accuracy: 4
  },
  {
    postalCode: 7304,
    city: "Red Hills",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.6889,
    longitude: 146.4032,
    accuracy: 3
  },
  {
    postalCode: 7304,
    city: "Jackeys Marsh",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.6865,
    longitude: 146.6787,
    accuracy: 4
  },
  {
    postalCode: 7304,
    city: "Central Plateau",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.5465,
    longitude: 146.5541,
    accuracy: 3
  },
  {
    postalCode: 7304,
    city: "Reynolds Neck",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.5465,
    longitude: 146.5541,
    accuracy: 3
  },
  {
    postalCode: 7304,
    city: "Doctors Point",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.5465,
    longitude: 146.5541,
    accuracy: 3
  },
  {
    postalCode: 7304,
    city: "Golden Valley",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.6308,
    longitude: 146.7212,
    accuracy: 4
  },
  {
    postalCode: 7304,
    city: "Needles",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.5307,
    longitude: 146.5944,
    accuracy: 4
  },
  {
    postalCode: 7304,
    city: "Kimberley",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.417,
    longitude: 146.4923,
    accuracy: 4
  },
  {
    postalCode: 7304,
    city: "Weetah",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4735,
    longitude: 146.6446,
    accuracy: 4
  },
  {
    postalCode: 7304,
    city: "Mole Creek",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.5782,
    longitude: 146.4042,
    accuracy: 4
  },
  {
    postalCode: 7304,
    city: "Deloraine",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.5248,
    longitude: 146.657,
    accuracy: 4
  },
  {
    postalCode: 7304,
    city: "Parkham",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4072,
    longitude: 146.6129,
    accuracy: 4
  },
  {
    postalCode: 7304,
    city: "Chudleigh",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.5759,
    longitude: 146.4728,
    accuracy: 4
  },
  {
    postalCode: 7304,
    city: "Caveside",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.6164,
    longitude: 146.4238,
    accuracy: 4
  },
  {
    postalCode: 7304,
    city: "Breona",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.7822,
    longitude: 146.7043,
    accuracy: 4
  },
  {
    postalCode: 7305,
    city: "Railton",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3457,
    longitude: 146.4236,
    accuracy: 4
  },
  {
    postalCode: 7305,
    city: "Merseylea",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3441,
    longitude: 146.4206,
    accuracy: 3
  },
  {
    postalCode: 7305,
    city: "Sunnyside",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4001,
    longitude: 146.4364,
    accuracy: 4
  },
  {
    postalCode: 7306,
    city: "Staverton",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4594,
    longitude: 146.1829,
    accuracy: 4
  },
  {
    postalCode: 7306,
    city: "Middlesex",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4267,
    longitude: 146.1847,
    accuracy: 3
  },
  {
    postalCode: 7306,
    city: "West Kentish",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4113,
    longitude: 146.2561,
    accuracy: 4
  },
  {
    postalCode: 7306,
    city: "Paradise",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4516,
    longitude: 146.3156,
    accuracy: 4
  },
  {
    postalCode: 7306,
    city: "Claude Road",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.451,
    longitude: 146.2719,
    accuracy: 4
  },
  {
    postalCode: 7306,
    city: "Nowhere Else",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4267,
    longitude: 146.1847,
    accuracy: 3
  },
  {
    postalCode: 7306,
    city: "Sheffield",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3995,
    longitude: 146.339,
    accuracy: 4
  },
  {
    postalCode: 7306,
    city: "Stoodley",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4139,
    longitude: 146.4033,
    accuracy: 4
  },
  {
    postalCode: 7306,
    city: "Lower Beulah",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4808,
    longitude: 146.3917,
    accuracy: 4
  },
  {
    postalCode: 7306,
    city: "Acacia Hills",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4185,
    longitude: 146.3153,
    accuracy: 3
  },
  {
    postalCode: 7306,
    city: "Promised Land",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4322,
    longitude: 146.2088,
    accuracy: 4
  },
  {
    postalCode: 7306,
    city: "Lorinna",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.5577,
    longitude: 146.1308,
    accuracy: 4
  },
  {
    postalCode: 7306,
    city: "Cradle Mountain",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.6416,
    longitude: 145.9432,
    accuracy: 4
  },
  {
    postalCode: 7306,
    city: "Lower Barrington",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3084,
    longitude: 146.2872,
    accuracy: 4
  },
  {
    postalCode: 7306,
    city: "Roland",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4236,
    longitude: 146.2274,
    accuracy: 4
  },
  {
    postalCode: 7306,
    city: "Barrington",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3456,
    longitude: 146.2766,
    accuracy: 4
  },
  {
    postalCode: 7306,
    city: "Cethana",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4918,
    longitude: 146.1539,
    accuracy: 4
  },
  {
    postalCode: 7306,
    city: "Mount Roland",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4267,
    longitude: 146.1847,
    accuracy: 3
  },
  {
    postalCode: 7306,
    city: "Gowrie Park",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4697,
    longitude: 146.2128,
    accuracy: 4
  },
  {
    postalCode: 7306,
    city: "Beulah",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4562,
    longitude: 146.3781,
    accuracy: 4
  },
  {
    postalCode: 7306,
    city: "Nook",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.328,
    longitude: 146.3396,
    accuracy: 4
  },
  {
    postalCode: 7307,
    city: "Sassafras",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2983,
    longitude: 146.4915,
    accuracy: 4
  },
  {
    postalCode: 7307,
    city: "Bakers Beach",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2006,
    longitude: 146.5087,
    accuracy: 3
  },
  {
    postalCode: 7307,
    city: "Harford",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.236,
    longitude: 146.5481,
    accuracy: 4
  },
  {
    postalCode: 7307,
    city: "Shearwater",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1567,
    longitude: 146.5318,
    accuracy: 4
  },
  {
    postalCode: 7307,
    city: "Latrobe",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2464,
    longitude: 146.4246,
    accuracy: 4
  },
  {
    postalCode: 7307,
    city: "Hawley Beach",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.142,
    longitude: 146.5377,
    accuracy: 4
  },
  {
    postalCode: 7307,
    city: "Moriarty",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2351,
    longitude: 146.4566,
    accuracy: 4
  },
  {
    postalCode: 7307,
    city: "Wesley Vale",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2086,
    longitude: 146.4555,
    accuracy: 4
  },
  {
    postalCode: 7307,
    city: "Northdown",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1829,
    longitude: 146.4924,
    accuracy: 4
  },
  {
    postalCode: 7307,
    city: "Thirlstane",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2037,
    longitude: 146.5382,
    accuracy: 4
  },
  {
    postalCode: 7307,
    city: "Port Sorell",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1665,
    longitude: 146.5528,
    accuracy: 4
  },
  {
    postalCode: 7307,
    city: "Squeaking Point",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1887,
    longitude: 146.5567,
    accuracy: 4
  },
  {
    postalCode: 7310,
    city: "Forthside",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2531,
    longitude: 146.2766,
    accuracy: 3
  },
  {
    postalCode: 7310,
    city: "West Devonport",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4311,
    longitude: 146.0939,
    accuracy: 3
  },
  {
    postalCode: 7310,
    city: "Spreyton",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2352,
    longitude: 146.3511,
    accuracy: 4
  },
  {
    postalCode: 7310,
    city: "Stony Rise",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2531,
    longitude: 146.2766,
    accuracy: 3
  },
  {
    postalCode: 7310,
    city: "Devonport",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1769,
    longitude: 146.3515,
    accuracy: 4
  },
  {
    postalCode: 7310,
    city: "Ambleside",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2032,
    longitude: 146.3722,
    accuracy: 4
  },
  {
    postalCode: 7310,
    city: "Erriba",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4643,
    longitude: 146.1053,
    accuracy: 4
  },
  {
    postalCode: 7310,
    city: "Eugenana",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2555,
    longitude: 146.3476,
    accuracy: 4
  },
  {
    postalCode: 7310,
    city: "Lower Wilmot",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3507,
    longitude: 146.1921,
    accuracy: 4
  },
  {
    postalCode: 7310,
    city: "Lillico",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4311,
    longitude: 146.0939,
    accuracy: 3
  },
  {
    postalCode: 7310,
    city: "Quoiba",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2085,
    longitude: 146.3356,
    accuracy: 4
  },
  {
    postalCode: 7310,
    city: "Paloona",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2726,
    longitude: 146.276,
    accuracy: 4
  },
  {
    postalCode: 7310,
    city: "Don",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.175,
    longitude: 146.3188,
    accuracy: 4
  },
  {
    postalCode: 7310,
    city: "East Devonport",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2531,
    longitude: 146.2766,
    accuracy: 3
  },
  {
    postalCode: 7310,
    city: "Aberdeen",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2636,
    longitude: 146.324,
    accuracy: 4
  },
  {
    postalCode: 7310,
    city: "Miandetta",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1955,
    longitude: 146.3532,
    accuracy: 4
  },
  {
    postalCode: 7310,
    city: "Kindred",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2525,
    longitude: 146.2119,
    accuracy: 4
  },
  {
    postalCode: 7310,
    city: "Tugrah",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2531,
    longitude: 146.2766,
    accuracy: 3
  },
  {
    postalCode: 7310,
    city: "Melrose",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2546,
    longitude: 146.2858,
    accuracy: 4
  },
  {
    postalCode: 7310,
    city: "Wilmot",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3976,
    longitude: 146.1754,
    accuracy: 4
  },
  {
    postalCode: 7310,
    city: "Moina",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4979,
    longitude: 146.066,
    accuracy: 4
  },
  {
    postalCode: 7310,
    city: "Tarleton",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2531,
    longitude: 146.2766,
    accuracy: 3
  },
  {
    postalCode: 7310,
    city: "Forth",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2032,
    longitude: 146.2728,
    accuracy: 4
  },
  {
    postalCode: 7310,
    city: "South Spreyton",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2531,
    longitude: 146.2766,
    accuracy: 3
  },
  {
    postalCode: 7315,
    city: "Ulverstone",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1603,
    longitude: 146.1824,
    accuracy: 4
  },
  {
    postalCode: 7315,
    city: "West Ulverstone",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2427,
    longitude: 146.1546,
    accuracy: 3
  },
  {
    postalCode: 7315,
    city: "Nietta",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3811,
    longitude: 146.0634,
    accuracy: 4
  },
  {
    postalCode: 7315,
    city: "Loongana",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2427,
    longitude: 146.1546,
    accuracy: 3
  },
  {
    postalCode: 7315,
    city: "South Preston",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3384,
    longitude: 146.0474,
    accuracy: 4
  },
  {
    postalCode: 7315,
    city: "Castra",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3444,
    longitude: 146.1276,
    accuracy: 4
  },
  {
    postalCode: 7315,
    city: "Gunns Plains",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2887,
    longitude: 146.0292,
    accuracy: 4
  },
  {
    postalCode: 7315,
    city: "North Motton",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2193,
    longitude: 146.1019,
    accuracy: 4
  },
  {
    postalCode: 7315,
    city: "Upper Castra",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3444,
    longitude: 146.1276,
    accuracy: 4
  },
  {
    postalCode: 7315,
    city: "South Nietta",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4183,
    longitude: 146.0736,
    accuracy: 4
  },
  {
    postalCode: 7315,
    city: "Abbotsham",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2265,
    longitude: 146.1732,
    accuracy: 4
  },
  {
    postalCode: 7315,
    city: "Turners Beach",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1606,
    longitude: 146.2319,
    accuracy: 4
  },
  {
    postalCode: 7315,
    city: "Leith",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1576,
    longitude: 146.2589,
    accuracy: 4
  },
  {
    postalCode: 7315,
    city: "Spalford",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2564,
    longitude: 146.1739,
    accuracy: 4
  },
  {
    postalCode: 7315,
    city: "Preston",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3384,
    longitude: 146.0474,
    accuracy: 4
  },
  {
    postalCode: 7315,
    city: "Sprent",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2766,
    longitude: 146.1591,
    accuracy: 4
  },
  {
    postalCode: 7315,
    city: "Gawler",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1938,
    longitude: 146.1569,
    accuracy: 4
  },
  {
    postalCode: 7316,
    city: "West Pine",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1532,
    longitude: 145.9994,
    accuracy: 4
  },
  {
    postalCode: 7316,
    city: "Howth",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0968,
    longitude: 146.0123,
    accuracy: 4
  },
  {
    postalCode: 7316,
    city: "Sulphur Creek",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0947,
    longitude: 146.0235,
    accuracy: 4
  },
  {
    postalCode: 7316,
    city: "Loyetea",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3064,
    longitude: 145.9485,
    accuracy: 4
  },
  {
    postalCode: 7316,
    city: "Camena",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1814,
    longitude: 145.9571,
    accuracy: 4
  },
  {
    postalCode: 7316,
    city: "Penguin",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1226,
    longitude: 146.0732,
    accuracy: 4
  },
  {
    postalCode: 7316,
    city: "Heybridge",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0806,
    longitude: 145.9859,
    accuracy: 4
  },
  {
    postalCode: 7316,
    city: "South Riana",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.244,
    longitude: 145.9823,
    accuracy: 4
  },
  {
    postalCode: 7316,
    city: "Preservation Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2565,
    longitude: 145.9734,
    accuracy: 3
  },
  {
    postalCode: 7316,
    city: "Cuprona",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1398,
    longitude: 145.97,
    accuracy: 4
  },
  {
    postalCode: 7316,
    city: "Riana",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2159,
    longitude: 145.9974,
    accuracy: 4
  },
  {
    postalCode: 7320,
    city: "Camdale",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0499,
    longitude: 145.8516,
    accuracy: 4
  },
  {
    postalCode: 7320,
    city: "Acton",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8793,
    longitude: 147.4846,
    accuracy: 4
  },
  {
    postalCode: 7320,
    city: "Burnie",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0558,
    longitude: 145.9037,
    accuracy: 4
  },
  {
    postalCode: 7320,
    city: "Downlands",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0827,
    longitude: 145.8902,
    accuracy: 4
  },
  {
    postalCode: 7320,
    city: "South Burnie",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0598,
    longitude: 145.9085,
    accuracy: 4
  },
  {
    postalCode: 7320,
    city: "Shorewell Park",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0699,
    longitude: 145.8769,
    accuracy: 4
  },
  {
    postalCode: 7320,
    city: "Upper Burnie",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2444,
    longitude: 145.8987,
    accuracy: 3
  },
  {
    postalCode: 7320,
    city: "Brooklyn",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0722,
    longitude: 145.9073,
    accuracy: 4
  },
  {
    postalCode: 7320,
    city: "Cooee",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0496,
    longitude: 145.8772,
    accuracy: 4
  },
  {
    postalCode: 7320,
    city: "Park Grove",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0548,
    longitude: 145.882,
    accuracy: 4
  },
  {
    postalCode: 7320,
    city: "Wivenhoe",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0745,
    longitude: 145.9472,
    accuracy: 4
  },
  {
    postalCode: 7320,
    city: "Havenview",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0839,
    longitude: 145.9118,
    accuracy: 4
  },
  {
    postalCode: 7320,
    city: "Hillcrest",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0632,
    longitude: 145.8944,
    accuracy: 4
  },
  {
    postalCode: 7320,
    city: "Round Hill",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0827,
    longitude: 145.9006,
    accuracy: 3
  },
  {
    postalCode: 7320,
    city: "Emu Heights",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.076,
    longitude: 145.9204,
    accuracy: 4
  },
  {
    postalCode: 7320,
    city: "Ocean Vista",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0827,
    longitude: 145.9006,
    accuracy: 3
  },
  {
    postalCode: 7320,
    city: "Romaine",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0901,
    longitude: 145.8941,
    accuracy: 3
  },
  {
    postalCode: 7320,
    city: "Parklands",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0827,
    longitude: 145.9006,
    accuracy: 3
  },
  {
    postalCode: 7320,
    city: "Montello",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0576,
    longitude: 145.8963,
    accuracy: 4
  },
  {
    postalCode: 7321,
    city: "Stowport",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.12,
    longitude: 145.938,
    accuracy: 4
  },
  {
    postalCode: 7321,
    city: "Edgcumbe Beach",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1418,
    longitude: 145.6144,
    accuracy: 3
  },
  {
    postalCode: 7321,
    city: "Rocky Cape",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.9252,
    longitude: 145.4786,
    accuracy: 4
  },
  {
    postalCode: 7321,
    city: "East Ridgley",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1418,
    longitude: 145.6144,
    accuracy: 3
  },
  {
    postalCode: 7321,
    city: "Ridgley",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1556,
    longitude: 145.8351,
    accuracy: 4
  },
  {
    postalCode: 7321,
    city: "Crayfish Creek",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1418,
    longitude: 145.6144,
    accuracy: 3
  },
  {
    postalCode: 7321,
    city: "Wiltshire",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.8347,
    longitude: 145.2771,
    accuracy: 4
  },
  {
    postalCode: 7321,
    city: "Parrawe",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3044,
    longitude: 145.5872,
    accuracy: 4
  },
  {
    postalCode: 7321,
    city: "Tullah",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.7321,
    longitude: 145.6225,
    accuracy: 4
  },
  {
    postalCode: 7321,
    city: "Savage River",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3598,
    longitude: 145.4991,
    accuracy: 3
  },
  {
    postalCode: 7321,
    city: "Guildford",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4329,
    longitude: 145.6887,
    accuracy: 4
  },
  {
    postalCode: 7321,
    city: "Waratah",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4437,
    longitude: 145.5329,
    accuracy: 4
  },
  {
    postalCode: 7321,
    city: "Tewkesbury",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2101,
    longitude: 145.7291,
    accuracy: 4
  },
  {
    postalCode: 7321,
    city: "Upper Stowport",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1624,
    longitude: 145.8969,
    accuracy: 4
  },
  {
    postalCode: 7321,
    city: "Mooreville",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0985,
    longitude: 145.8613,
    accuracy: 4
  },
  {
    postalCode: 7321,
    city: "Port Latta",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.8333,
    longitude: 145.3333,
    accuracy: 4
  },
  {
    postalCode: 7321,
    city: "Luina",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1418,
    longitude: 145.6144,
    accuracy: 3
  },
  {
    postalCode: 7321,
    city: "West Mooreville",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1418,
    longitude: 145.6144,
    accuracy: 3
  },
  {
    postalCode: 7321,
    city: "Natone",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1712,
    longitude: 145.9217,
    accuracy: 4
  },
  {
    postalCode: 7321,
    city: "Boat Harbour Beach",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.3598,
    longitude: 145.4991,
    accuracy: 3
  },
  {
    postalCode: 7321,
    city: "Corinna",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.656,
    longitude: 145.0762,
    accuracy: 4
  },
  {
    postalCode: 7321,
    city: "West Ridgley",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1418,
    longitude: 145.6144,
    accuracy: 3
  },
  {
    postalCode: 7321,
    city: "Upper Natone",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2444,
    longitude: 145.8987,
    accuracy: 4
  },
  {
    postalCode: 7321,
    city: "Hellyer",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1418,
    longitude: 145.6144,
    accuracy: 3
  },
  {
    postalCode: 7321,
    city: "Boat Harbour",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.9484,
    longitude: 145.6303,
    accuracy: 4
  },
  {
    postalCode: 7321,
    city: "Chasm Creek",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1418,
    longitude: 145.6144,
    accuracy: 3
  },
  {
    postalCode: 7321,
    city: "Montumana",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.9523,
    longitude: 145.5131,
    accuracy: 4
  },
  {
    postalCode: 7321,
    city: "Mawbanna",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.9569,
    longitude: 145.3758,
    accuracy: 4
  },
  {
    postalCode: 7321,
    city: "Detention",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.9028,
    longitude: 145.486,
    accuracy: 4
  },
  {
    postalCode: 7321,
    city: "Cowrie Point",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1418,
    longitude: 145.6144,
    accuracy: 3
  },
  {
    postalCode: 7321,
    city: "Black River",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.8536,
    longitude: 145.311,
    accuracy: 4
  },
  {
    postalCode: 7321,
    city: "Sisters Beach",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.9197,
    longitude: 145.5597,
    accuracy: 4
  },
  {
    postalCode: 7321,
    city: "Hampshire",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2709,
    longitude: 145.7821,
    accuracy: 4
  },
  {
    postalCode: 7321,
    city: "East Cam",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0594,
    longitude: 145.8514,
    accuracy: 4
  },
  {
    postalCode: 7321,
    city: "Highclere",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2006,
    longitude: 145.8059,
    accuracy: 4
  },
  {
    postalCode: 7322,
    city: "Somerset",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0406,
    longitude: 145.8305,
    accuracy: 4
  },
  {
    postalCode: 7325,
    city: "Takone",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1737,
    longitude: 145.6318,
    accuracy: 4
  },
  {
    postalCode: 7325,
    city: "Sisters Creek",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.9617,
    longitude: 145.569,
    accuracy: 4
  },
  {
    postalCode: 7325,
    city: "Yolla",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1362,
    longitude: 145.7088,
    accuracy: 4
  },
  {
    postalCode: 7325,
    city: "West Takone",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1847,
    longitude: 145.5273,
    accuracy: 4
  },
  {
    postalCode: 7325,
    city: "Lapoinya",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0011,
    longitude: 145.5753,
    accuracy: 4
  },
  {
    postalCode: 7325,
    city: "Henrietta",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1803,
    longitude: 145.6649,
    accuracy: 4
  },
  {
    postalCode: 7325,
    city: "Milabena",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0333,
    longitude: 145.5156,
    accuracy: 4
  },
  {
    postalCode: 7325,
    city: "Preolenna",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0868,
    longitude: 145.5515,
    accuracy: 4
  },
  {
    postalCode: 7325,
    city: "Mount Hicks",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0949,
    longitude: 145.6115,
    accuracy: 3
  },
  {
    postalCode: 7325,
    city: "Wynyard",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.9897,
    longitude: 145.7262,
    accuracy: 4
  },
  {
    postalCode: 7325,
    city: "Oldina",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0833,
    longitude: 145.6833,
    accuracy: 4
  },
  {
    postalCode: 7325,
    city: "Oonah",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2373,
    longitude: 145.6219,
    accuracy: 4
  },
  {
    postalCode: 7325,
    city: "Seabrook",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0949,
    longitude: 145.6115,
    accuracy: 3
  },
  {
    postalCode: 7325,
    city: "Elliott",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1001,
    longitude: 145.7828,
    accuracy: 4
  },
  {
    postalCode: 7325,
    city: "Meunna",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.1021,
    longitude: 145.4883,
    accuracy: 4
  },
  {
    postalCode: 7325,
    city: "Doctors Rocks",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0949,
    longitude: 145.6115,
    accuracy: 3
  },
  {
    postalCode: 7325,
    city: "Moorleah",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.9846,
    longitude: 145.6213,
    accuracy: 4
  },
  {
    postalCode: 7325,
    city: "Table Cape",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0949,
    longitude: 145.6115,
    accuracy: 3
  },
  {
    postalCode: 7325,
    city: "Myalla",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.9812,
    longitude: 145.576,
    accuracy: 4
  },
  {
    postalCode: 7325,
    city: "Calder",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0693,
    longitude: 145.63,
    accuracy: 4
  },
  {
    postalCode: 7325,
    city: "Flowerdale",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.9643,
    longitude: 145.6578,
    accuracy: 4
  },
  {
    postalCode: 7330,
    city: "Trowutta",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0332,
    longitude: 145.0834,
    accuracy: 4
  },
  {
    postalCode: 7330,
    city: "South Forest",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.9351,
    longitude: 145.0327,
    accuracy: 3
  },
  {
    postalCode: 7330,
    city: "Mengha",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.8972,
    longitude: 145.2387,
    accuracy: 4
  },
  {
    postalCode: 7330,
    city: "Edith Creek",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.9653,
    longitude: 145.0981,
    accuracy: 4
  },
  {
    postalCode: 7330,
    city: "Temma",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.2285,
    longitude: 144.6961,
    accuracy: 4
  },
  {
    postalCode: 7330,
    city: "Lileah",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.9631,
    longitude: 145.156,
    accuracy: 4
  },
  {
    postalCode: 7330,
    city: "Roger River",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0042,
    longitude: 145.0613,
    accuracy: 4
  },
  {
    postalCode: 7330,
    city: "Togari",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.9258,
    longitude: 144.8635,
    accuracy: 4
  },
  {
    postalCode: 7330,
    city: "Alcomie",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.9303,
    longitude: 145.1896,
    accuracy: 4
  },
  {
    postalCode: 7330,
    city: "Scopus",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.9351,
    longitude: 145.0327,
    accuracy: 3
  },
  {
    postalCode: 7330,
    city: "Marrawah",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.9128,
    longitude: 144.705,
    accuracy: 4
  },
  {
    postalCode: 7330,
    city: "Christmas Hills",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.901,
    longitude: 145.0165,
    accuracy: 4
  },
  {
    postalCode: 7330,
    city: "Mella",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.8393,
    longitude: 145.0685,
    accuracy: 4
  },
  {
    postalCode: 7330,
    city: "Irishtown",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0924,
    longitude: 144.9667,
    accuracy: 3
  },
  {
    postalCode: 7330,
    city: "Redpa",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.9198,
    longitude: 144.7692,
    accuracy: 4
  },
  {
    postalCode: 7330,
    city: "Forest",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.8582,
    longitude: 145.2432,
    accuracy: 4
  },
  {
    postalCode: 7330,
    city: "Smithton",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.8459,
    longitude: 145.125,
    accuracy: 4
  },
  {
    postalCode: 7330,
    city: "Arthur River",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0924,
    longitude: 144.9667,
    accuracy: 3
  },
  {
    postalCode: 7330,
    city: "Brittons Swamp",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.9319,
    longitude: 144.9694,
    accuracy: 4
  },
  {
    postalCode: 7330,
    city: "Nabageena",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.9907,
    longitude: 145.1252,
    accuracy: 4
  },
  {
    postalCode: 7330,
    city: "Broadmeadows",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.9351,
    longitude: 145.0327,
    accuracy: 3
  },
  {
    postalCode: 7330,
    city: "Three Hummock Island",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0924,
    longitude: 144.9667,
    accuracy: 3
  },
  {
    postalCode: 7330,
    city: "Scotchtown",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.9351,
    longitude: 145.0327,
    accuracy: 3
  },
  {
    postalCode: 7330,
    city: "Woolnorth",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0924,
    longitude: 144.9667,
    accuracy: 3
  },
  {
    postalCode: 7330,
    city: "West Montagu",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.9351,
    longitude: 145.0327,
    accuracy: 3
  },
  {
    postalCode: 7330,
    city: "Couta Rocks",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.9351,
    longitude: 145.0327,
    accuracy: 3
  },
  {
    postalCode: 7330,
    city: "Nelson Bay",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.9351,
    longitude: 145.0327,
    accuracy: 3
  },
  {
    postalCode: 7330,
    city: "Montagu",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.7739,
    longitude: 144.9605,
    accuracy: 4
  },
  {
    postalCode: 7331,
    city: "Stanley",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -40.7606,
    longitude: 145.2955,
    accuracy: 4
  },
  {
    postalCode: 7466,
    city: "Gormanston",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.0749,
    longitude: 145.5968,
    accuracy: 4
  },
  {
    postalCode: 7467,
    city: "Lake Margaret",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.0805,
    longitude: 145.5565,
    accuracy: 3
  },
  {
    postalCode: 7467,
    city: "Queenstown",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.0805,
    longitude: 145.5565,
    accuracy: 4
  },
  {
    postalCode: 7468,
    city: "Macquarie Heads",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.1519,
    longitude: 145.3273,
    accuracy: 3
  },
  {
    postalCode: 7468,
    city: "Strahan",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.1519,
    longitude: 145.3273,
    accuracy: 4
  },
  {
    postalCode: 7469,
    city: "Granville Harbour",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.8417,
    longitude: 145.3764,
    accuracy: 3
  },
  {
    postalCode: 7469,
    city: "Renison Bell",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.7943,
    longitude: 145.4337,
    accuracy: 4
  },
  {
    postalCode: 7469,
    city: "Trial Harbour",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.8417,
    longitude: 145.3764,
    accuracy: 3
  },
  {
    postalCode: 7469,
    city: "Zeehan",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.8834,
    longitude: 145.3362,
    accuracy: 4
  },
  {
    postalCode: 7470,
    city: "Rosebery",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.7794,
    longitude: 145.5383,
    accuracy: 4
  },
  {
    postalCode: 7800,
    city: "Hobart",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8794,
    longitude: 147.3294,
    accuracy: 4
  },
  {
    postalCode: 7802,
    city: "Hobart",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8794,
    longitude: 147.3294,
    accuracy: 4
  },
  {
    postalCode: 7803,
    city: "Hobart",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8794,
    longitude: 147.3294,
    accuracy: 4
  },
  {
    postalCode: 7804,
    city: "Hobart",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8794,
    longitude: 147.3294,
    accuracy: 4
  },
  {
    postalCode: 7805,
    city: "Hobart",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8794,
    longitude: 147.3294,
    accuracy: 4
  },
  {
    postalCode: 7806,
    city: "Hobart",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8794,
    longitude: 147.3294,
    accuracy: 4
  },
  {
    postalCode: 7807,
    city: "Hobart",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8794,
    longitude: 147.3294,
    accuracy: 4
  },
  {
    postalCode: 7808,
    city: "Hobart",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8794,
    longitude: 147.3294,
    accuracy: 4
  },
  {
    postalCode: 7809,
    city: "Hobart",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8794,
    longitude: 147.3294,
    accuracy: 4
  },
  {
    postalCode: 7810,
    city: "Hobart",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8794,
    longitude: 147.3294,
    accuracy: 4
  },
  {
    postalCode: 7811,
    city: "Hobart",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8794,
    longitude: 147.3294,
    accuracy: 4
  },
  {
    postalCode: 7812,
    city: "Hobart",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8794,
    longitude: 147.3294,
    accuracy: 4
  },
  {
    postalCode: 7813,
    city: "Hobart",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8794,
    longitude: 147.3294,
    accuracy: 4
  },
  {
    postalCode: 7814,
    city: "Hobart",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8794,
    longitude: 147.3294,
    accuracy: 4
  },
  {
    postalCode: 7823,
    city: "Hobart",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8794,
    longitude: 147.3294,
    accuracy: 4
  },
  {
    postalCode: 7824,
    city: "Hobart",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8794,
    longitude: 147.3294,
    accuracy: 4
  },
  {
    postalCode: 7827,
    city: "Hobart",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8794,
    longitude: 147.3294,
    accuracy: 4
  },
  {
    postalCode: 7828,
    city: "Hobart",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8794,
    longitude: 147.3294,
    accuracy: 4
  },
  {
    postalCode: 7829,
    city: "Hobart",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8794,
    longitude: 147.3294,
    accuracy: 4
  },
  {
    postalCode: 7845,
    city: "Hobart",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8794,
    longitude: 147.3294,
    accuracy: 4
  },
  {
    postalCode: 7850,
    city: "Hobart",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -42.8794,
    longitude: 147.3294,
    accuracy: 4
  },
  {
    postalCode: 7901,
    city: "Launceston",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4388,
    longitude: 147.1347,
    accuracy: 4
  },
  {
    postalCode: 7902,
    city: "Launceston",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4388,
    longitude: 147.1347,
    accuracy: 4
  },
  {
    postalCode: 7903,
    city: "Launceston",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4388,
    longitude: 147.1347,
    accuracy: 4
  },
  {
    postalCode: 7904,
    city: "Launceston",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4388,
    longitude: 147.1347,
    accuracy: 4
  },
  {
    postalCode: 7905,
    city: "Launceston",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4388,
    longitude: 147.1347,
    accuracy: 4
  },
  {
    postalCode: 7906,
    city: "Launceston",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4388,
    longitude: 147.1347,
    accuracy: 4
  },
  {
    postalCode: 7907,
    city: "Launceston",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4388,
    longitude: 147.1347,
    accuracy: 4
  },
  {
    postalCode: 7908,
    city: "Launceston",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4388,
    longitude: 147.1347,
    accuracy: 4
  },
  {
    postalCode: 7915,
    city: "Burnie",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.0558,
    longitude: 145.9037,
    accuracy: 4
  },
  {
    postalCode: 7916,
    city: "Launceston",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4388,
    longitude: 147.1347,
    accuracy: 4
  },
  {
    postalCode: 7917,
    city: "Launceston",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4388,
    longitude: 147.1347,
    accuracy: 4
  },
  {
    postalCode: 7918,
    city: "Launceston",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4388,
    longitude: 147.1347,
    accuracy: 4
  },
  {
    postalCode: 7919,
    city: "Launceston",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4388,
    longitude: 147.1347,
    accuracy: 4
  },
  {
    postalCode: 7920,
    city: "Launceston",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4388,
    longitude: 147.1347,
    accuracy: 4
  },
  {
    postalCode: 7921,
    city: "Launceston",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4388,
    longitude: 147.1347,
    accuracy: 4
  },
  {
    postalCode: 7922,
    city: "Launceston",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4388,
    longitude: 147.1347,
    accuracy: 4
  },
  {
    postalCode: 7923,
    city: "Launceston",
    state_name: "Tasmania",
    state: "TAS",
    latitude: -41.4388,
    longitude: 147.1347,
    accuracy: 4
  },
  {
    postalCode: 3000,
    city: "Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.814,
    longitude: 144.9633,
    accuracy: 4
  },
  {
    postalCode: 3001,
    city: "Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.814,
    longitude: 144.9633,
    accuracy: 4
  },
  {
    postalCode: 3002,
    city: "East Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8167,
    longitude: 144.9879,
    accuracy: 4
  },
  {
    postalCode: 3003,
    city: "West Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8101,
    longitude: 144.95,
    accuracy: 4
  },
  {
    postalCode: 3004,
    city: "Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.814,
    longitude: 144.9633,
    accuracy: 4
  },
  {
    postalCode: 3004,
    city: "St Kilda Road Central",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.814,
    longitude: 144.9633,
    accuracy: 3
  },
  {
    postalCode: 3004,
    city: "St Kilda Road Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.814,
    longitude: 144.9633,
    accuracy: 3
  },
  {
    postalCode: 3005,
    city: "World Trade Centre",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8152,
    longitude: 144.9632,
    accuracy: 1
  },
  {
    postalCode: 3006,
    city: "South Wharf",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8253,
    longitude: 144.9522,
    accuracy: 4
  },
  {
    postalCode: 3006,
    city: "Southbank",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8228,
    longitude: 144.9643,
    accuracy: 4
  },
  {
    postalCode: 3008,
    city: "Docklands",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8149,
    longitude: 144.9505,
    accuracy: 4
  },
  {
    postalCode: 3010,
    city: "University Of Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7958,
    longitude: 144.9612,
    accuracy: 1
  },
  {
    postalCode: 3011,
    city: "Seddon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8061,
    longitude: 144.8907,
    accuracy: 4
  },
  {
    postalCode: 3011,
    city: "Seddon West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7995,
    longitude: 144.8963,
    accuracy: 3
  },
  {
    postalCode: 3011,
    city: "Footscray",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8,
    longitude: 144.9,
    accuracy: 4
  },
  {
    postalCode: 3012,
    city: "Maidstone",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7803,
    longitude: 144.8735,
    accuracy: 4
  },
  {
    postalCode: 3012,
    city: "Tottenham",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7985,
    longitude: 144.8626,
    accuracy: 4
  },
  {
    postalCode: 3012,
    city: "West Footscray",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7975,
    longitude: 144.8773,
    accuracy: 4
  },
  {
    postalCode: 3012,
    city: "Brooklyn",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8161,
    longitude: 144.8415,
    accuracy: 4
  },
  {
    postalCode: 3012,
    city: "Kingsville",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8082,
    longitude: 144.8791,
    accuracy: 4
  },
  {
    postalCode: 3013,
    city: "Yarraville",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8167,
    longitude: 144.9,
    accuracy: 4
  },
  {
    postalCode: 3013,
    city: "Yarraville West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8249,
    longitude: 144.8708,
    accuracy: 3
  },
  {
    postalCode: 3015,
    city: "Newport",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8443,
    longitude: 144.8848,
    accuracy: 4
  },
  {
    postalCode: 3015,
    city: "Spotswood",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8298,
    longitude: 144.8852,
    accuracy: 4
  },
  {
    postalCode: 3015,
    city: "South Kingsville",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8302,
    longitude: 144.8709,
    accuracy: 4
  },
  {
    postalCode: 3016,
    city: "Williamstown North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8552,
    longitude: 144.8826,
    accuracy: 4
  },
  {
    postalCode: 3016,
    city: "Williamstown",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.857,
    longitude: 144.8977,
    accuracy: 4
  },
  {
    postalCode: 3018,
    city: "Seaholme",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.864,
    longitude: 144.845,
    accuracy: 4
  },
  {
    postalCode: 3018,
    city: "Altona",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8696,
    longitude: 144.8304,
    accuracy: 4
  },
  {
    postalCode: 3019,
    city: "Braybrook",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7867,
    longitude: 144.8548,
    accuracy: 4
  },
  {
    postalCode: 3019,
    city: "Robinson",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7867,
    longitude: 144.8548,
    accuracy: 3
  },
  {
    postalCode: 3020,
    city: "Sunshine West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7912,
    longitude: 144.8164,
    accuracy: 4
  },
  {
    postalCode: 3020,
    city: "Albion",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7667,
    longitude: 144.8333,
    accuracy: 4
  },
  {
    postalCode: 3020,
    city: "Glengala",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.775,
    longitude: 144.8333,
    accuracy: 3
  },
  {
    postalCode: 3020,
    city: "Sunshine North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7699,
    longitude: 144.8279,
    accuracy: 4
  },
  {
    postalCode: 3020,
    city: "Sunshine",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7833,
    longitude: 144.8333,
    accuracy: 4
  },
  {
    postalCode: 3021,
    city: "Albanvale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7461,
    longitude: 144.7686,
    accuracy: 4
  },
  {
    postalCode: 3021,
    city: "St Albans",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.745,
    longitude: 144.8005,
    accuracy: 4
  },
  {
    postalCode: 3021,
    city: "Kealba",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7371,
    longitude: 144.8283,
    accuracy: 4
  },
  {
    postalCode: 3021,
    city: "Kings Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.734,
    longitude: 144.7777,
    accuracy: 4
  },
  {
    postalCode: 3022,
    city: "Deer Park East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7764,
    longitude: 144.8016,
    accuracy: 3
  },
  {
    postalCode: 3022,
    city: "Ardeer",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7759,
    longitude: 144.8014,
    accuracy: 4
  },
  {
    postalCode: 3023,
    city: "Deer Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7667,
    longitude: 144.7833,
    accuracy: 4
  },
  {
    postalCode: 3023,
    city: "Ravenhall",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7655,
    longitude: 144.751,
    accuracy: 4
  },
  {
    postalCode: 3023,
    city: "Deer Park North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7541,
    longitude: 144.7651,
    accuracy: 3
  },
  {
    postalCode: 3023,
    city: "Burnside",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7494,
    longitude: 144.753,
    accuracy: 4
  },
  {
    postalCode: 3023,
    city: "Cairnlea",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7593,
    longitude: 144.7878,
    accuracy: 4
  },
  {
    postalCode: 3023,
    city: "Burnside Heights",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7269,
    longitude: 144.7523,
    accuracy: 4
  },
  {
    postalCode: 3023,
    city: "Caroline Springs",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7412,
    longitude: 144.7363,
    accuracy: 4
  },
  {
    postalCode: 3024,
    city: "Wyndham Vale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8415,
    longitude: 144.541,
    accuracy: 4
  },
  {
    postalCode: 3024,
    city: "Mount Cottrell",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8167,
    longitude: 144.5833,
    accuracy: 4
  },
  {
    postalCode: 3024,
    city: "Mambourin",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8755,
    longitude: 144.5032,
    accuracy: 4
  },
  {
    postalCode: 3025,
    city: "Altona North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8349,
    longitude: 144.8474,
    accuracy: 4
  },
  {
    postalCode: 3025,
    city: "Altona Gate",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8349,
    longitude: 144.8474,
    accuracy: 3
  },
  {
    postalCode: 3025,
    city: "Altona East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8349,
    longitude: 144.8474,
    accuracy: 3
  },
  {
    postalCode: 3026,
    city: "Laverton North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8205,
    longitude: 144.8159,
    accuracy: 4
  },
  {
    postalCode: 3027,
    city: "Williams Landing",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8619,
    longitude: 144.7437,
    accuracy: 4
  },
  {
    postalCode: 3028,
    city: "Altona Meadows",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8841,
    longitude: 144.7837,
    accuracy: 4
  },
  {
    postalCode: 3028,
    city: "Laverton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.862,
    longitude: 144.7698,
    accuracy: 4
  },
  {
    postalCode: 3028,
    city: "Seabrook",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8809,
    longitude: 144.7587,
    accuracy: 4
  },
  {
    postalCode: 3029,
    city: "Truganina",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8167,
    longitude: 144.75,
    accuracy: 4
  },
  {
    postalCode: 3029,
    city: "Hoppers Crossing",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8826,
    longitude: 144.7003,
    accuracy: 4
  },
  {
    postalCode: 3029,
    city: "Tarneit",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8667,
    longitude: 144.6667,
    accuracy: 4
  },
  {
    postalCode: 3030,
    city: "Point Cook",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9148,
    longitude: 144.7509,
    accuracy: 4
  },
  {
    postalCode: 3030,
    city: "Quandong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8139,
    longitude: 144.4951,
    accuracy: 4
  },
  {
    postalCode: 3030,
    city: "Werribee",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9,
    longitude: 144.6667,
    accuracy: 4
  },
  {
    postalCode: 3030,
    city: "Derrimut",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7924,
    longitude: 144.7699,
    accuracy: 4
  },
  {
    postalCode: 3030,
    city: "Cocoroc",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9728,
    longitude: 144.5643,
    accuracy: 4
  },
  {
    postalCode: 3030,
    city: "Werribee South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9475,
    longitude: 144.7167,
    accuracy: 4
  },
  {
    postalCode: 3031,
    city: "Flemington",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7882,
    longitude: 144.93,
    accuracy: 4
  },
  {
    postalCode: 3031,
    city: "Kensington",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7833,
    longitude: 144.9333,
    accuracy: 4
  },
  {
    postalCode: 3032,
    city: "Maribyrnong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7833,
    longitude: 144.8833,
    accuracy: 4
  },
  {
    postalCode: 3032,
    city: "Highpoint City",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7747,
    longitude: 144.8999,
    accuracy: 3
  },
  {
    postalCode: 3032,
    city: "Travancore",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7808,
    longitude: 144.9354,
    accuracy: 4
  },
  {
    postalCode: 3032,
    city: "Ascot Vale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7833,
    longitude: 144.9167,
    accuracy: 4
  },
  {
    postalCode: 3033,
    city: "Keilor East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7326,
    longitude: 144.865,
    accuracy: 4
  },
  {
    postalCode: 3034,
    city: "Avondale Heights",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7616,
    longitude: 144.8626,
    accuracy: 4
  },
  {
    postalCode: 3036,
    city: "Keilor North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6963,
    longitude: 144.8047,
    accuracy: 4
  },
  {
    postalCode: 3036,
    city: "Keilor",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7167,
    longitude: 144.8333,
    accuracy: 4
  },
  {
    postalCode: 3037,
    city: "Hillside",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6905,
    longitude: 144.7417,
    accuracy: 4
  },
  {
    postalCode: 3037,
    city: "Calder Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6798,
    longitude: 144.7611,
    accuracy: 4
  },
  {
    postalCode: 3037,
    city: "Sydenham",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7,
    longitude: 144.7667,
    accuracy: 4
  },
  {
    postalCode: 3037,
    city: "Taylors Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7099,
    longitude: 144.7548,
    accuracy: 4
  },
  {
    postalCode: 3037,
    city: "Delahey",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7198,
    longitude: 144.7773,
    accuracy: 4
  },
  {
    postalCode: 3038,
    city: "Keilor Downs",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7234,
    longitude: 144.8084,
    accuracy: 4
  },
  {
    postalCode: 3038,
    city: "Watergardens",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6986,
    longitude: 144.7863,
    accuracy: 3
  },
  {
    postalCode: 3038,
    city: "Taylors Lakes",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6986,
    longitude: 144.7863,
    accuracy: 4
  },
  {
    postalCode: 3038,
    city: "Keilor Lodge",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7,
    longitude: 144.8033,
    accuracy: 4
  },
  {
    postalCode: 3039,
    city: "Moonee Ponds",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7667,
    longitude: 144.9167,
    accuracy: 4
  },
  {
    postalCode: 3040,
    city: "Essendon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7667,
    longitude: 144.9167,
    accuracy: 4
  },
  {
    postalCode: 3040,
    city: "Aberfeldie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7596,
    longitude: 144.8974,
    accuracy: 4
  },
  {
    postalCode: 3040,
    city: "Essendon West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7576,
    longitude: 144.879,
    accuracy: 4
  },
  {
    postalCode: 3041,
    city: "Strathmore",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6333,
    longitude: 142.4833,
    accuracy: 4
  },
  {
    postalCode: 3041,
    city: "Strathmore Heights",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7133,
    longitude: 144.8969,
    accuracy: 4
  },
  {
    postalCode: 3041,
    city: "Essendon North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7422,
    longitude: 144.9055,
    accuracy: 4
  },
  {
    postalCode: 3041,
    city: "Essendon Fields",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7245,
    longitude: 144.8989,
    accuracy: 4
  },
  {
    postalCode: 3041,
    city: "Cross Keys",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7133,
    longitude: 144.8969,
    accuracy: 3
  },
  {
    postalCode: 3042,
    city: "Keilor Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7203,
    longitude: 144.8542,
    accuracy: 4
  },
  {
    postalCode: 3042,
    city: "Niddrie North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7311,
    longitude: 144.8867,
    accuracy: 3
  },
  {
    postalCode: 3042,
    city: "Airport West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7247,
    longitude: 144.8813,
    accuracy: 4
  },
  {
    postalCode: 3042,
    city: "Niddrie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7375,
    longitude: 144.8921,
    accuracy: 4
  },
  {
    postalCode: 3043,
    city: "Gowanbrae",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7082,
    longitude: 144.8908,
    accuracy: 4
  },
  {
    postalCode: 3043,
    city: "Tullamarine",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7013,
    longitude: 144.881,
    accuracy: 4
  },
  {
    postalCode: 3043,
    city: "Gladstone Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6874,
    longitude: 144.8868,
    accuracy: 4
  },
  {
    postalCode: 3044,
    city: "Pascoe Vale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7333,
    longitude: 144.9333,
    accuracy: 4
  },
  {
    postalCode: 3044,
    city: "Pascoe Vale South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7397,
    longitude: 144.9461,
    accuracy: 4
  },
  {
    postalCode: 3045,
    city: "Melbourne Airport",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6743,
    longitude: 144.8518,
    accuracy: 4
  },
  {
    postalCode: 3046,
    city: "Oak Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7184,
    longitude: 144.9195,
    accuracy: 4
  },
  {
    postalCode: 3046,
    city: "Glenroy",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7,
    longitude: 144.9333,
    accuracy: 4
  },
  {
    postalCode: 3046,
    city: "Hadfield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7073,
    longitude: 144.9416,
    accuracy: 4
  },
  {
    postalCode: 3047,
    city: "Dallas",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6708,
    longitude: 144.9354,
    accuracy: 4
  },
  {
    postalCode: 3047,
    city: "Broadmeadows",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6802,
    longitude: 144.9188,
    accuracy: 4
  },
  {
    postalCode: 3047,
    city: "Jacana",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6878,
    longitude: 144.9111,
    accuracy: 4
  },
  {
    postalCode: 3048,
    city: "Coolaroo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6568,
    longitude: 144.9346,
    accuracy: 4
  },
  {
    postalCode: 3048,
    city: "Meadow Heights",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6512,
    longitude: 144.9186,
    accuracy: 4
  },
  {
    postalCode: 3049,
    city: "Westmeadows",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.676,
    longitude: 144.887,
    accuracy: 4
  },
  {
    postalCode: 3049,
    city: "Attwood",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6696,
    longitude: 144.8868,
    accuracy: 4
  },
  {
    postalCode: 3050,
    city: "Royal Melbourne Hospital",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7981,
    longitude: 144.9555,
    accuracy: 1
  },
  {
    postalCode: 3051,
    city: "North Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8,
    longitude: 144.9667,
    accuracy: 4
  },
  {
    postalCode: 3051,
    city: "Hotham Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7984,
    longitude: 144.9449,
    accuracy: 3
  },
  {
    postalCode: 3052,
    city: "Parkville",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7833,
    longitude: 144.95,
    accuracy: 4
  },
  {
    postalCode: 3052,
    city: "Melbourne University",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7603,
    longitude: 144.9502,
    accuracy: 3
  },
  {
    postalCode: 3053,
    city: "Carlton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8,
    longitude: 144.9667,
    accuracy: 4
  },
  {
    postalCode: 3053,
    city: "Carlton South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8004,
    longitude: 144.9681,
    accuracy: 3
  },
  {
    postalCode: 3054,
    city: "Princes Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7818,
    longitude: 144.9666,
    accuracy: 4
  },
  {
    postalCode: 3054,
    city: "Carlton North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7833,
    longitude: 144.9667,
    accuracy: 4
  },
  {
    postalCode: 3055,
    city: "Brunswick South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7603,
    longitude: 144.9502,
    accuracy: 3
  },
  {
    postalCode: 3055,
    city: "Brunswick West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7646,
    longitude: 144.9438,
    accuracy: 4
  },
  {
    postalCode: 3055,
    city: "Moreland West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7603,
    longitude: 144.9502,
    accuracy: 3
  },
  {
    postalCode: 3055,
    city: "Moonee Vale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7603,
    longitude: 144.9502,
    accuracy: 3
  },
  {
    postalCode: 3056,
    city: "Brunswick",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7667,
    longitude: 144.9667,
    accuracy: 4
  },
  {
    postalCode: 3056,
    city: "Brunswick North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7667,
    longitude: 144.9667,
    accuracy: 3
  },
  {
    postalCode: 3056,
    city: "Brunswick Lower",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7667,
    longitude: 144.9667,
    accuracy: 3
  },
  {
    postalCode: 3057,
    city: "Sumner",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7603,
    longitude: 144.9502,
    accuracy: 3
  },
  {
    postalCode: 3057,
    city: "Brunswick East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7725,
    longitude: 144.9724,
    accuracy: 4
  },
  {
    postalCode: 3058,
    city: "Coburg North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7287,
    longitude: 144.9613,
    accuracy: 4
  },
  {
    postalCode: 3058,
    city: "Moreland",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7603,
    longitude: 144.9502,
    accuracy: 3
  },
  {
    postalCode: 3058,
    city: "Batman",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.75,
    longitude: 144.9667,
    accuracy: 3
  },
  {
    postalCode: 3058,
    city: "Merlynston",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7603,
    longitude: 144.9502,
    accuracy: 3
  },
  {
    postalCode: 3058,
    city: "Coburg",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.75,
    longitude: 144.9667,
    accuracy: 4
  },
  {
    postalCode: 3059,
    city: "Greenvale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6333,
    longitude: 144.8667,
    accuracy: 4
  },
  {
    postalCode: 3060,
    city: "Fawkner",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7167,
    longitude: 144.9667,
    accuracy: 4
  },
  {
    postalCode: 3061,
    city: "Campbellfield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6833,
    longitude: 144.95,
    accuracy: 4
  },
  {
    postalCode: 3062,
    city: "Somerton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.65,
    longitude: 144.9333,
    accuracy: 4
  },
  {
    postalCode: 3063,
    city: "Yuroke",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5911,
    longitude: 144.8782,
    accuracy: 4
  },
  {
    postalCode: 3063,
    city: "Oaklands Junction",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.615,
    longitude: 144.8434,
    accuracy: 4
  },
  {
    postalCode: 3064,
    city: "Kalkallo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5333,
    longitude: 144.95,
    accuracy: 4
  },
  {
    postalCode: 3064,
    city: "Mickleham",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5366,
    longitude: 144.902,
    accuracy: 4
  },
  {
    postalCode: 3064,
    city: "Donnybrook",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5333,
    longitude: 144.9833,
    accuracy: 4
  },
  {
    postalCode: 3064,
    city: "Roxburgh Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6258,
    longitude: 144.9255,
    accuracy: 4
  },
  {
    postalCode: 3064,
    city: "Craigieburn",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6,
    longitude: 144.95,
    accuracy: 4
  },
  {
    postalCode: 3065,
    city: "Fitzroy",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7984,
    longitude: 144.9783,
    accuracy: 4
  },
  {
    postalCode: 3066,
    city: "Collingwood",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8,
    longitude: 144.9833,
    accuracy: 4
  },
  {
    postalCode: 3066,
    city: "Collingwood North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8,
    longitude: 144.9833,
    accuracy: 3
  },
  {
    postalCode: 3067,
    city: "Abbotsford",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8,
    longitude: 145,
    accuracy: 4
  },
  {
    postalCode: 3068,
    city: "Fitzroy North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7886,
    longitude: 144.9788,
    accuracy: 4
  },
  {
    postalCode: 3068,
    city: "Clifton Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7904,
    longitude: 144.9975,
    accuracy: 4
  },
  {
    postalCode: 3070,
    city: "Northcote South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7667,
    longitude: 145,
    accuracy: 3
  },
  {
    postalCode: 3070,
    city: "Northcote",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7667,
    longitude: 145,
    accuracy: 4
  },
  {
    postalCode: 3071,
    city: "Thornbury",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.75,
    longitude: 145,
    accuracy: 4
  },
  {
    postalCode: 3072,
    city: "Preston",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.75,
    longitude: 145.0167,
    accuracy: 4
  },
  {
    postalCode: 3072,
    city: "Regent West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7241,
    longitude: 145.0179,
    accuracy: 3
  },
  {
    postalCode: 3072,
    city: "Gilberton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.75,
    longitude: 145.0167,
    accuracy: 3
  },
  {
    postalCode: 3072,
    city: "Preston South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7241,
    longitude: 145.0179,
    accuracy: 3
  },
  {
    postalCode: 3072,
    city: "Preston West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.75,
    longitude: 145.0167,
    accuracy: 3
  },
  {
    postalCode: 3072,
    city: "Northland Centre",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7241,
    longitude: 145.0179,
    accuracy: 3
  },
  {
    postalCode: 3072,
    city: "Preston Lower",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.75,
    longitude: 145.0167,
    accuracy: 3
  },
  {
    postalCode: 3073,
    city: "Reservoir",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7167,
    longitude: 145,
    accuracy: 4
  },
  {
    postalCode: 3073,
    city: "Keon Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7,
    longitude: 145.0167,
    accuracy: 4
  },
  {
    postalCode: 3074,
    city: "Thomastown",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6833,
    longitude: 145.0167,
    accuracy: 4
  },
  {
    postalCode: 3075,
    city: "Lalor",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6667,
    longitude: 145.0167,
    accuracy: 4
  },
  {
    postalCode: 3076,
    city: "Epping Dc",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6307,
    longitude: 145.006,
    accuracy: 3
  },
  {
    postalCode: 3076,
    city: "Epping",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.65,
    longitude: 145.0333,
    accuracy: 4
  },
  {
    postalCode: 3078,
    city: "Alphington",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7804,
    longitude: 145.0309,
    accuracy: 4
  },
  {
    postalCode: 3078,
    city: "Fairfield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7798,
    longitude: 145.0176,
    accuracy: 4
  },
  {
    postalCode: 3079,
    city: "Ivanhoe",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.769,
    longitude: 145.0431,
    accuracy: 4
  },
  {
    postalCode: 3079,
    city: "Ivanhoe East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7832,
    longitude: 145.0525,
    accuracy: 4
  },
  {
    postalCode: 3079,
    city: "Ivanhoe North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.769,
    longitude: 145.0431,
    accuracy: 3
  },
  {
    postalCode: 3081,
    city: "Heidelberg West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.75,
    longitude: 145.0333,
    accuracy: 4
  },
  {
    postalCode: 3081,
    city: "Heidelberg Rgh",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.743,
    longitude: 145.0464,
    accuracy: 3
  },
  {
    postalCode: 3081,
    city: "Bellfield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7531,
    longitude: 145.0385,
    accuracy: 4
  },
  {
    postalCode: 3081,
    city: "Heidelberg Heights",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7431,
    longitude: 145.057,
    accuracy: 4
  },
  {
    postalCode: 3082,
    city: "Mill Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6667,
    longitude: 145.0667,
    accuracy: 4
  },
  {
    postalCode: 3083,
    city: "Kingsbury",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7141,
    longitude: 145.0351,
    accuracy: 4
  },
  {
    postalCode: 3083,
    city: "Bundoora",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6982,
    longitude: 145.0597,
    accuracy: 4
  },
  {
    postalCode: 3083,
    city: "La Trobe University",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7062,
    longitude: 145.0474,
    accuracy: 3
  },
  {
    postalCode: 3084,
    city: "Viewbank",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7399,
    longitude: 145.0932,
    accuracy: 4
  },
  {
    postalCode: 3084,
    city: "Banyule",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7464,
    longitude: 145.0771,
    accuracy: 3
  },
  {
    postalCode: 3084,
    city: "Rosanna",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7396,
    longitude: 145.0697,
    accuracy: 4
  },
  {
    postalCode: 3084,
    city: "Heidelberg",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.75,
    longitude: 145.0667,
    accuracy: 4
  },
  {
    postalCode: 3084,
    city: "Eaglemont",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7638,
    longitude: 145.0638,
    accuracy: 4
  },
  {
    postalCode: 3085,
    city: "Yallambie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7251,
    longitude: 145.0935,
    accuracy: 4
  },
  {
    postalCode: 3085,
    city: "Macleod West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7228,
    longitude: 145.0817,
    accuracy: 3
  },
  {
    postalCode: 3085,
    city: "Macleod",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7204,
    longitude: 145.0698,
    accuracy: 4
  },
  {
    postalCode: 3086,
    city: "La Trobe University",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7173,
    longitude: 145.0826,
    accuracy: 1
  },
  {
    postalCode: 3087,
    city: "Watsonia North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6998,
    longitude: 145.0847,
    accuracy: 4
  },
  {
    postalCode: 3087,
    city: "Watsonia",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7167,
    longitude: 145.0833,
    accuracy: 4
  },
  {
    postalCode: 3088,
    city: "Saint Helena",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7,
    longitude: 145.1333,
    accuracy: 4
  },
  {
    postalCode: 3088,
    city: "Briar Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7167,
    longitude: 145.1167,
    accuracy: 4
  },
  {
    postalCode: 3088,
    city: "Greensborough",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7046,
    longitude: 145.103,
    accuracy: 4
  },
  {
    postalCode: 3088,
    city: "St Helena",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6895,
    longitude: 145.1296,
    accuracy: 4
  },
  {
    postalCode: 3089,
    city: "Diamond Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6667,
    longitude: 145.15,
    accuracy: 4
  },
  {
    postalCode: 3090,
    city: "Plenty",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6667,
    longitude: 145.1167,
    accuracy: 4
  },
  {
    postalCode: 3091,
    city: "Yarrambat",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6375,
    longitude: 145.1349,
    accuracy: 4
  },
  {
    postalCode: 3093,
    city: "Lower Plenty",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7333,
    longitude: 145.1167,
    accuracy: 4
  },
  {
    postalCode: 3094,
    city: "Montmorency",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7167,
    longitude: 145.1167,
    accuracy: 4
  },
  {
    postalCode: 3095,
    city: "Research",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7,
    longitude: 145.1833,
    accuracy: 4
  },
  {
    postalCode: 3095,
    city: "Eltham",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7333,
    longitude: 145.15,
    accuracy: 4
  },
  {
    postalCode: 3095,
    city: "Eltham North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7,
    longitude: 145.15,
    accuracy: 4
  },
  {
    postalCode: 3096,
    city: "Wattle Glen",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6667,
    longitude: 145.1833,
    accuracy: 4
  },
  {
    postalCode: 3097,
    city: "Bend Of Islands",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7008,
    longitude: 145.2848,
    accuracy: 4
  },
  {
    postalCode: 3097,
    city: "Kangaroo Ground",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6892,
    longitude: 145.2317,
    accuracy: 4
  },
  {
    postalCode: 3097,
    city: "Watsons Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6833,
    longitude: 145.2333,
    accuracy: 4
  },
  {
    postalCode: 3099,
    city: "Strathewen",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.55,
    longitude: 145.2667,
    accuracy: 4
  },
  {
    postalCode: 3099,
    city: "Hurstbridge",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6416,
    longitude: 145.1941,
    accuracy: 4
  },
  {
    postalCode: 3099,
    city: "Arthurs Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5833,
    longitude: 145.2,
    accuracy: 4
  },
  {
    postalCode: 3099,
    city: "Cottles Bridge",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6333,
    longitude: 145.2167,
    accuracy: 4
  },
  {
    postalCode: 3099,
    city: "Nutfield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6167,
    longitude: 145.1833,
    accuracy: 4
  },
  {
    postalCode: 3101,
    city: "Kew",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8064,
    longitude: 145.0309,
    accuracy: 4
  },
  {
    postalCode: 3101,
    city: "Cotham",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8064,
    longitude: 145.0309,
    accuracy: 3
  },
  {
    postalCode: 3102,
    city: "Kew East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7976,
    longitude: 145.0538,
    accuracy: 4
  },
  {
    postalCode: 3103,
    city: "Balwyn",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8117,
    longitude: 145.081,
    accuracy: 4
  },
  {
    postalCode: 3103,
    city: "Stradbroke Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8117,
    longitude: 145.081,
    accuracy: 3
  },
  {
    postalCode: 3103,
    city: "Deepdene",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8167,
    longitude: 145.0667,
    accuracy: 4
  },
  {
    postalCode: 3103,
    city: "Balwyn East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8117,
    longitude: 145.081,
    accuracy: 3
  },
  {
    postalCode: 3104,
    city: "Balwyn North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7909,
    longitude: 145.0939,
    accuracy: 4
  },
  {
    postalCode: 3104,
    city: "Greythorn",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7909,
    longitude: 145.0939,
    accuracy: 3
  },
  {
    postalCode: 3105,
    city: "Bulleen",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7667,
    longitude: 145.0833,
    accuracy: 4
  },
  {
    postalCode: 3106,
    city: "Templestowe",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.75,
    longitude: 145.1167,
    accuracy: 4
  },
  {
    postalCode: 3107,
    city: "Templestowe Lower",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7667,
    longitude: 145.1167,
    accuracy: 4
  },
  {
    postalCode: 3108,
    city: "Doncaster",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7883,
    longitude: 145.1237,
    accuracy: 4
  },
  {
    postalCode: 3109,
    city: "Tunstall Square Po",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7795,
    longitude: 145.1638,
    accuracy: 3
  },
  {
    postalCode: 3109,
    city: "Doncaster East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7876,
    longitude: 145.1489,
    accuracy: 4
  },
  {
    postalCode: 3109,
    city: "Doncaster Heights",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7795,
    longitude: 145.1638,
    accuracy: 3
  },
  {
    postalCode: 3110,
    city: "Nunawading Bc",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7576,
    longitude: 145.2408,
    accuracy: 1
  },
  {
    postalCode: 3111,
    city: "Donvale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7891,
    longitude: 145.1749,
    accuracy: 4
  },
  {
    postalCode: 3113,
    city: "Warrandyte",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.75,
    longitude: 145.2333,
    accuracy: 4
  },
  {
    postalCode: 3113,
    city: "North Warrandyte",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7292,
    longitude: 145.2157,
    accuracy: 4
  },
  {
    postalCode: 3114,
    city: "Park Orchards",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7769,
    longitude: 145.2146,
    accuracy: 4
  },
  {
    postalCode: 3115,
    city: "Wonga Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7333,
    longitude: 145.2667,
    accuracy: 4
  },
  {
    postalCode: 3116,
    city: "Chirnside Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7386,
    longitude: 145.3143,
    accuracy: 4
  },
  {
    postalCode: 3121,
    city: "Burnley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8286,
    longitude: 145.0077,
    accuracy: 4
  },
  {
    postalCode: 3121,
    city: "Cremorne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8333,
    longitude: 145,
    accuracy: 4
  },
  {
    postalCode: 3121,
    city: "Richmond",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8182,
    longitude: 145.0018,
    accuracy: 4
  },
  {
    postalCode: 3121,
    city: "Richmond East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8271,
    longitude: 145.0064,
    accuracy: 3
  },
  {
    postalCode: 3121,
    city: "Burnley North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8271,
    longitude: 145.0064,
    accuracy: 3
  },
  {
    postalCode: 3121,
    city: "Richmond South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8271,
    longitude: 145.0064,
    accuracy: 3
  },
  {
    postalCode: 3121,
    city: "Richmond North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8271,
    longitude: 145.0064,
    accuracy: 3
  },
  {
    postalCode: 3122,
    city: "Glenferrie South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8344,
    longitude: 145.0397,
    accuracy: 3
  },
  {
    postalCode: 3122,
    city: "Auburn South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8333,
    longitude: 145.05,
    accuracy: 4
  },
  {
    postalCode: 3122,
    city: "Hawthorn",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8199,
    longitude: 145.0358,
    accuracy: 4
  },
  {
    postalCode: 3122,
    city: "Hawthorn North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.85,
    longitude: 145.0333,
    accuracy: 3
  },
  {
    postalCode: 3122,
    city: "Hawthorn West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8344,
    longitude: 145.0397,
    accuracy: 3
  },
  {
    postalCode: 3123,
    city: "Auburn",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8167,
    longitude: 145.05,
    accuracy: 4
  },
  {
    postalCode: 3123,
    city: "Hawthorn East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8248,
    longitude: 145.0464,
    accuracy: 4
  },
  {
    postalCode: 3124,
    city: "Camberwell North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8248,
    longitude: 145.0705,
    accuracy: 3
  },
  {
    postalCode: 3124,
    city: "Camberwell",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8421,
    longitude: 145.0694,
    accuracy: 4
  },
  {
    postalCode: 3124,
    city: "Camberwell West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8248,
    longitude: 145.0705,
    accuracy: 3
  },
  {
    postalCode: 3124,
    city: "Camberwell South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8248,
    longitude: 145.0705,
    accuracy: 3
  },
  {
    postalCode: 3124,
    city: "Hartwell",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8421,
    longitude: 145.0694,
    accuracy: 3
  },
  {
    postalCode: 3124,
    city: "Middle Camberwell",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8248,
    longitude: 145.0705,
    accuracy: 3
  },
  {
    postalCode: 3125,
    city: "Burwood",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8505,
    longitude: 145.0949,
    accuracy: 4
  },
  {
    postalCode: 3125,
    city: "Surrey Hills South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8498,
    longitude: 145.119,
    accuracy: 3
  },
  {
    postalCode: 3125,
    city: "Bennettswood",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8495,
    longitude: 145.1114,
    accuracy: 3
  },
  {
    postalCode: 3126,
    city: "Canterbury",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8247,
    longitude: 145.0848,
    accuracy: 4
  },
  {
    postalCode: 3126,
    city: "Camberwell East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8248,
    longitude: 145.0705,
    accuracy: 3
  },
  {
    postalCode: 3127,
    city: "Surrey Hills",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8252,
    longitude: 145.1004,
    accuracy: 4
  },
  {
    postalCode: 3127,
    city: "Surrey Hills North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8128,
    longitude: 145.1043,
    accuracy: 3
  },
  {
    postalCode: 3127,
    city: "Mont Albert",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8167,
    longitude: 145.1,
    accuracy: 4
  },
  {
    postalCode: 3128,
    city: "Box Hill South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8324,
    longitude: 145.121,
    accuracy: 4
  },
  {
    postalCode: 3128,
    city: "Box Hill Central",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8256,
    longitude: 145.1232,
    accuracy: 3
  },
  {
    postalCode: 3128,
    city: "Box Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8189,
    longitude: 145.1254,
    accuracy: 4
  },
  {
    postalCode: 3128,
    city: "Wattle Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.829,
    longitude: 145.1248,
    accuracy: 3
  },
  {
    postalCode: 3128,
    city: "Houston",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.829,
    longitude: 145.1248,
    accuracy: 3
  },
  {
    postalCode: 3129,
    city: "Box Hill North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8027,
    longitude: 145.1266,
    accuracy: 4
  },
  {
    postalCode: 3129,
    city: "Kerrimuir",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8048,
    longitude: 145.1229,
    accuracy: 3
  },
  {
    postalCode: 3129,
    city: "Mont Albert North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8004,
    longitude: 145.1083,
    accuracy: 4
  },
  {
    postalCode: 3130,
    city: "Blackburn North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8093,
    longitude: 145.1518,
    accuracy: 4
  },
  {
    postalCode: 3130,
    city: "Blackburn South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8398,
    longitude: 145.1555,
    accuracy: 4
  },
  {
    postalCode: 3130,
    city: "Blackburn",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.819,
    longitude: 145.1533,
    accuracy: 4
  },
  {
    postalCode: 3130,
    city: "Laburnum",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8232,
    longitude: 145.1511,
    accuracy: 3
  },
  {
    postalCode: 3131,
    city: "Forest Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8333,
    longitude: 145.1833,
    accuracy: 4
  },
  {
    postalCode: 3131,
    city: "Brentford Square",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8275,
    longitude: 145.1739,
    accuracy: 3
  },
  {
    postalCode: 3131,
    city: "Nunawading",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8204,
    longitude: 145.1731,
    accuracy: 4
  },
  {
    postalCode: 3132,
    city: "Mitcham North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8182,
    longitude: 145.199,
    accuracy: 3
  },
  {
    postalCode: 3132,
    city: "Mitcham",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8167,
    longitude: 145.2,
    accuracy: 4
  },
  {
    postalCode: 3132,
    city: "Rangeview",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8186,
    longitude: 145.1987,
    accuracy: 3
  },
  {
    postalCode: 3133,
    city: "Vermont",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8362,
    longitude: 145.1943,
    accuracy: 4
  },
  {
    postalCode: 3133,
    city: "Vermont South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8575,
    longitude: 145.1827,
    accuracy: 4
  },
  {
    postalCode: 3134,
    city: "Warrandyte South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7667,
    longitude: 145.25,
    accuracy: 4
  },
  {
    postalCode: 3134,
    city: "Heathwood",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7944,
    longitude: 145.2389,
    accuracy: 3
  },
  {
    postalCode: 3134,
    city: "Warranwood",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7756,
    longitude: 145.2473,
    accuracy: 4
  },
  {
    postalCode: 3134,
    city: "Ringwood North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8,
    longitude: 145.2333,
    accuracy: 4
  },
  {
    postalCode: 3134,
    city: "Ringwood",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8167,
    longitude: 145.2333,
    accuracy: 4
  },
  {
    postalCode: 3135,
    city: "Bedford Road",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8213,
    longitude: 145.2489,
    accuracy: 3
  },
  {
    postalCode: 3135,
    city: "Ringwood East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8167,
    longitude: 145.25,
    accuracy: 4
  },
  {
    postalCode: 3135,
    city: "Heathmont",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8333,
    longitude: 145.25,
    accuracy: 4
  },
  {
    postalCode: 3136,
    city: "Croydon North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7833,
    longitude: 145.3,
    accuracy: 4
  },
  {
    postalCode: 3136,
    city: "Croydon South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8123,
    longitude: 145.2681,
    accuracy: 4
  },
  {
    postalCode: 3136,
    city: "Croydon Hills",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7765,
    longitude: 145.2636,
    accuracy: 4
  },
  {
    postalCode: 3136,
    city: "Croydon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8,
    longitude: 145.2833,
    accuracy: 4
  },
  {
    postalCode: 3137,
    city: "Kilsyth",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8,
    longitude: 145.3167,
    accuracy: 4
  },
  {
    postalCode: 3137,
    city: "Kilsyth South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8203,
    longitude: 145.316,
    accuracy: 4
  },
  {
    postalCode: 3138,
    city: "Mooroolbark",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7833,
    longitude: 145.3,
    accuracy: 4
  },
  {
    postalCode: 3139,
    city: "Hoddles Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8333,
    longitude: 145.5833,
    accuracy: 4
  },
  {
    postalCode: 3139,
    city: "Beenak",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9,
    longitude: 145.6333,
    accuracy: 4
  },
  {
    postalCode: 3139,
    city: "Don Valley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7364,
    longitude: 145.5923,
    accuracy: 4
  },
  {
    postalCode: 3139,
    city: "Seville",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7667,
    longitude: 145.4667,
    accuracy: 4
  },
  {
    postalCode: 3139,
    city: "Woori Yallock",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7806,
    longitude: 145.5382,
    accuracy: 4
  },
  {
    postalCode: 3139,
    city: "Yellingbo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.846,
    longitude: 145.5291,
    accuracy: 4
  },
  {
    postalCode: 3139,
    city: "Wandin North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7833,
    longitude: 145.4333,
    accuracy: 4
  },
  {
    postalCode: 3139,
    city: "Launching Place",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7806,
    longitude: 145.5683,
    accuracy: 4
  },
  {
    postalCode: 3139,
    city: "Seville East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.775,
    longitude: 145.4973,
    accuracy: 4
  },
  {
    postalCode: 3139,
    city: "Wandin East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8151,
    longitude: 145.458,
    accuracy: 4
  },
  {
    postalCode: 3140,
    city: "Lilydale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.75,
    longitude: 145.35,
    accuracy: 4
  },
  {
    postalCode: 3141,
    city: "South Yarra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8333,
    longitude: 144.9833,
    accuracy: 4
  },
  {
    postalCode: 3142,
    city: "Toorak",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8416,
    longitude: 145.0144,
    accuracy: 4
  },
  {
    postalCode: 3142,
    city: "Hawksburn",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8416,
    longitude: 145.0177,
    accuracy: 3
  },
  {
    postalCode: 3143,
    city: "Armadale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8554,
    longitude: 145.0205,
    accuracy: 4
  },
  {
    postalCode: 3143,
    city: "Armadale North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.85,
    longitude: 145.0333,
    accuracy: 4
  },
  {
    postalCode: 3144,
    city: "Kooyong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8399,
    longitude: 145.0352,
    accuracy: 4
  },
  {
    postalCode: 3144,
    city: "Malvern",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8626,
    longitude: 145.0281,
    accuracy: 4
  },
  {
    postalCode: 3144,
    city: "Malvern North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8512,
    longitude: 145.0317,
    accuracy: 3
  },
  {
    postalCode: 3145,
    city: "Malvern East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.874,
    longitude: 145.0425,
    accuracy: 4
  },
  {
    postalCode: 3145,
    city: "Darling",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8775,
    longitude: 145.0624,
    accuracy: 3
  },
  {
    postalCode: 3145,
    city: "Caulfield East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8833,
    longitude: 145.05,
    accuracy: 4
  },
  {
    postalCode: 3145,
    city: "Central Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8775,
    longitude: 145.0624,
    accuracy: 3
  },
  {
    postalCode: 3145,
    city: "Darling South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.874,
    longitude: 145.0425,
    accuracy: 3
  },
  {
    postalCode: 3145,
    city: "Wattletree Road Po",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.874,
    longitude: 145.0425,
    accuracy: 3
  },
  {
    postalCode: 3146,
    city: "Glen Iris",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8667,
    longitude: 145.0667,
    accuracy: 4
  },
  {
    postalCode: 3146,
    city: "Tooronga",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8599,
    longitude: 145.0549,
    accuracy: 3
  },
  {
    postalCode: 3147,
    city: "Ashwood",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8666,
    longitude: 145.1055,
    accuracy: 4
  },
  {
    postalCode: 3147,
    city: "Ashburton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8626,
    longitude: 145.0794,
    accuracy: 4
  },
  {
    postalCode: 3148,
    city: "Jordanville",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8833,
    longitude: 145.1167,
    accuracy: 3
  },
  {
    postalCode: 3148,
    city: "Holmesglen",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8821,
    longitude: 145.1002,
    accuracy: 3
  },
  {
    postalCode: 3148,
    city: "Chadstone",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8877,
    longitude: 145.0952,
    accuracy: 4
  },
  {
    postalCode: 3148,
    city: "Chadstone Centre",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8855,
    longitude: 145.1059,
    accuracy: 3
  },
  {
    postalCode: 3149,
    city: "Syndal",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8742,
    longitude: 145.1479,
    accuracy: 4
  },
  {
    postalCode: 3149,
    city: "Pinewood",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8756,
    longitude: 145.1387,
    accuracy: 3
  },
  {
    postalCode: 3149,
    city: "Mount Waverley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8771,
    longitude: 145.1294,
    accuracy: 4
  },
  {
    postalCode: 3150,
    city: "Wheelers Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9,
    longitude: 145.1833,
    accuracy: 4
  },
  {
    postalCode: 3150,
    city: "Brandon Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8891,
    longitude: 145.174,
    accuracy: 3
  },
  {
    postalCode: 3150,
    city: "Glen Waverley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8781,
    longitude: 145.1648,
    accuracy: 4
  },
  {
    postalCode: 3151,
    city: "Burwood Heights",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8535,
    longitude: 145.1503,
    accuracy: 3
  },
  {
    postalCode: 3151,
    city: "Burwood East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.85,
    longitude: 145.15,
    accuracy: 4
  },
  {
    postalCode: 3152,
    city: "Wantirna South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8833,
    longitude: 145.2167,
    accuracy: 4
  },
  {
    postalCode: 3152,
    city: "Knox City Centre",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8656,
    longitude: 145.2228,
    accuracy: 3
  },
  {
    postalCode: 3152,
    city: "Wantirna",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.85,
    longitude: 145.2167,
    accuracy: 4
  },
  {
    postalCode: 3152,
    city: "Studfield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8656,
    longitude: 145.2228,
    accuracy: 3
  },
  {
    postalCode: 3153,
    city: "Bayswater North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8261,
    longitude: 145.2983,
    accuracy: 4
  },
  {
    postalCode: 3153,
    city: "Bayswater",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.85,
    longitude: 145.2667,
    accuracy: 4
  },
  {
    postalCode: 3154,
    city: "The Basin",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.85,
    longitude: 145.3167,
    accuracy: 4
  },
  {
    postalCode: 3155,
    city: "Boronia",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8667,
    longitude: 145.2833,
    accuracy: 4
  },
  {
    postalCode: 3156,
    city: "Lysterfield South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9581,
    longitude: 145.2727,
    accuracy: 4
  },
  {
    postalCode: 3156,
    city: "Lysterfield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9333,
    longitude: 145.3,
    accuracy: 4
  },
  {
    postalCode: 3156,
    city: "Mountain Gate",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9136,
    longitude: 145.2823,
    accuracy: 3
  },
  {
    postalCode: 3156,
    city: "Upper Ferntree Gully",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8942,
    longitude: 145.3124,
    accuracy: 4
  },
  {
    postalCode: 3156,
    city: "Ferntree Gully",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8846,
    longitude: 145.2954,
    accuracy: 4
  },
  {
    postalCode: 3158,
    city: "Upwey",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9,
    longitude: 145.3333,
    accuracy: 4
  },
  {
    postalCode: 3159,
    city: "Menzies Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9167,
    longitude: 145.4,
    accuracy: 4
  },
  {
    postalCode: 3159,
    city: "Selby",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9167,
    longitude: 145.3833,
    accuracy: 4
  },
  {
    postalCode: 3160,
    city: "Tecoma",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.903,
    longitude: 145.3447,
    accuracy: 4
  },
  {
    postalCode: 3160,
    city: "Belgrave South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9333,
    longitude: 145.3333,
    accuracy: 4
  },
  {
    postalCode: 3160,
    city: "Belgrave Heights",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9167,
    longitude: 145.35,
    accuracy: 4
  },
  {
    postalCode: 3160,
    city: "Belgrave",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9,
    longitude: 145.35,
    accuracy: 4
  },
  {
    postalCode: 3161,
    city: "Caulfield North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8739,
    longitude: 145.0249,
    accuracy: 4
  },
  {
    postalCode: 3161,
    city: "Caulfield Junction",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.872,
    longitude: 145.0216,
    accuracy: 3
  },
  {
    postalCode: 3162,
    city: "Caulfield South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8956,
    longitude: 145.026,
    accuracy: 4
  },
  {
    postalCode: 3162,
    city: "Hopetoun Gardens",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8914,
    longitude: 145.0254,
    accuracy: 3
  },
  {
    postalCode: 3162,
    city: "Caulfield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8825,
    longitude: 145.0229,
    accuracy: 4
  },
  {
    postalCode: 3163,
    city: "Glen Huntly",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8833,
    longitude: 145.05,
    accuracy: 4
  },
  {
    postalCode: 3163,
    city: "Carnegie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8833,
    longitude: 145.0667,
    accuracy: 4
  },
  {
    postalCode: 3163,
    city: "Booran Road Po",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8895,
    longitude: 145.0581,
    accuracy: 3
  },
  {
    postalCode: 3163,
    city: "Murrumbeena",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8902,
    longitude: 145.0711,
    accuracy: 4
  },
  {
    postalCode: 3164,
    city: "Dandenong South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9833,
    longitude: 145.2,
    accuracy: 4
  },
  {
    postalCode: 3165,
    city: "Coatesville",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9221,
    longitude: 145.0667,
    accuracy: 3
  },
  {
    postalCode: 3165,
    city: "Bentleigh East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9193,
    longitude: 145.053,
    accuracy: 4
  },
  {
    postalCode: 3166,
    city: "Oakleigh East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9,
    longitude: 145.1167,
    accuracy: 4
  },
  {
    postalCode: 3166,
    city: "Oakleigh",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8981,
    longitude: 145.0884,
    accuracy: 4
  },
  {
    postalCode: 3166,
    city: "Huntingdale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9077,
    longitude: 145.1085,
    accuracy: 4
  },
  {
    postalCode: 3166,
    city: "Hughesdale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9,
    longitude: 145.0833,
    accuracy: 4
  },
  {
    postalCode: 3167,
    city: "Oakleigh South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9,
    longitude: 145.1,
    accuracy: 4
  },
  {
    postalCode: 3168,
    city: "Notting Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.905,
    longitude: 145.1427,
    accuracy: 4
  },
  {
    postalCode: 3168,
    city: "Clayton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9173,
    longitude: 145.1304,
    accuracy: 4
  },
  {
    postalCode: 3169,
    city: "Clarinda",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9333,
    longitude: 145.1167,
    accuracy: 4
  },
  {
    postalCode: 3169,
    city: "Clayton South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9333,
    longitude: 145.1167,
    accuracy: 4
  },
  {
    postalCode: 3170,
    city: "Waverley Gardens",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9167,
    longitude: 145.2,
    accuracy: 3
  },
  {
    postalCode: 3170,
    city: "Mulgrave",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9167,
    longitude: 145.2,
    accuracy: 4
  },
  {
    postalCode: 3171,
    city: "Sandown Village",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9457,
    longitude: 145.1581,
    accuracy: 3
  },
  {
    postalCode: 3171,
    city: "Springvale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9485,
    longitude: 145.1527,
    accuracy: 4
  },
  {
    postalCode: 3172,
    city: "Springvale South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9667,
    longitude: 145.15,
    accuracy: 4
  },
  {
    postalCode: 3172,
    city: "Dingley Village",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9827,
    longitude: 145.1342,
    accuracy: 4
  },
  {
    postalCode: 3173,
    city: "Keysborough",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9912,
    longitude: 145.1739,
    accuracy: 4
  },
  {
    postalCode: 3174,
    city: "Noble Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9667,
    longitude: 145.1667,
    accuracy: 4
  },
  {
    postalCode: 3174,
    city: "Noble Park North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9498,
    longitude: 145.1926,
    accuracy: 4
  },
  {
    postalCode: 3175,
    city: "Dandenong East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9833,
    longitude: 145.2,
    accuracy: 3
  },
  {
    postalCode: 3175,
    city: "Dunearn",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9833,
    longitude: 145.2,
    accuracy: 3
  },
  {
    postalCode: 3175,
    city: "Dandenong South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9833,
    longitude: 145.2,
    accuracy: 4
  },
  {
    postalCode: 3175,
    city: "Dandenong North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9665,
    longitude: 145.2081,
    accuracy: 4
  },
  {
    postalCode: 3175,
    city: "Dandenong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9833,
    longitude: 145.2,
    accuracy: 4
  },
  {
    postalCode: 3175,
    city: "Bangholme",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0384,
    longitude: 145.1869,
    accuracy: 4
  },
  {
    postalCode: 3176,
    city: "Scoresby Bc",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9636,
    longitude: 145.1943,
    accuracy: 1
  },
  {
    postalCode: 3177,
    city: "Doveton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9935,
    longitude: 145.2389,
    accuracy: 4
  },
  {
    postalCode: 3177,
    city: "Eumemmerring",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9978,
    longitude: 145.2482,
    accuracy: 4
  },
  {
    postalCode: 3178,
    city: "Rowville",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9333,
    longitude: 145.2333,
    accuracy: 4
  },
  {
    postalCode: 3179,
    city: "Scoresby",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9,
    longitude: 145.2333,
    accuracy: 4
  },
  {
    postalCode: 3180,
    city: "Knoxfield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8898,
    longitude: 145.2496,
    accuracy: 4
  },
  {
    postalCode: 3181,
    city: "Prahran",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8511,
    longitude: 144.9932,
    accuracy: 4
  },
  {
    postalCode: 3181,
    city: "Windsor",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8548,
    longitude: 144.9927,
    accuracy: 4
  },
  {
    postalCode: 3181,
    city: "Prahran East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.853,
    longitude: 144.9929,
    accuracy: 3
  },
  {
    postalCode: 3182,
    city: "St Kilda West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8599,
    longitude: 144.9711,
    accuracy: 4
  },
  {
    postalCode: 3182,
    city: "St Kilda South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8633,
    longitude: 144.9802,
    accuracy: 3
  },
  {
    postalCode: 3182,
    city: "St Kilda",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8633,
    longitude: 144.9802,
    accuracy: 3
  },
  {
    postalCode: 3183,
    city: "St Kilda East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8659,
    longitude: 145.0002,
    accuracy: 4
  },
  {
    postalCode: 3183,
    city: "Balaclava",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8692,
    longitude: 144.9977,
    accuracy: 4
  },
  {
    postalCode: 3184,
    city: "Elwood",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8821,
    longitude: 144.9821,
    accuracy: 4
  },
  {
    postalCode: 3184,
    city: "Brighton Road",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8809,
    longitude: 144.9855,
    accuracy: 3
  },
  {
    postalCode: 3185,
    city: "Elsternwick",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8864,
    longitude: 145.0025,
    accuracy: 4
  },
  {
    postalCode: 3185,
    city: "Gardenvale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8979,
    longitude: 145.0074,
    accuracy: 4
  },
  {
    postalCode: 3185,
    city: "Ripponlea",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8833,
    longitude: 145,
    accuracy: 4
  },
  {
    postalCode: 3186,
    city: "Dendy",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.895,
    longitude: 145.0191,
    accuracy: 3
  },
  {
    postalCode: 3186,
    city: "Brighton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9056,
    longitude: 145.0028,
    accuracy: 4
  },
  {
    postalCode: 3186,
    city: "Brighton North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9069,
    longitude: 145.0053,
    accuracy: 4
  },
  {
    postalCode: 3186,
    city: "Were Street Po",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9057,
    longitude: 145.0067,
    accuracy: 3
  },
  {
    postalCode: 3187,
    city: "North Road",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9667,
    longitude: 145.0167,
    accuracy: 4
  },
  {
    postalCode: 3187,
    city: "Brighton East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9023,
    longitude: 145.0173,
    accuracy: 4
  },
  {
    postalCode: 3188,
    city: "Hampton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9372,
    longitude: 145.0046,
    accuracy: 4
  },
  {
    postalCode: 3188,
    city: "Hampton East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.937,
    longitude: 145.0286,
    accuracy: 4
  },
  {
    postalCode: 3188,
    city: "Hampton North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9374,
    longitude: 145.0151,
    accuracy: 3
  },
  {
    postalCode: 3189,
    city: "Moorabbin",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9367,
    longitude: 145.0342,
    accuracy: 4
  },
  {
    postalCode: 3189,
    city: "Moorabbin East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9367,
    longitude: 145.0342,
    accuracy: 4
  },
  {
    postalCode: 3189,
    city: "Wishart",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9415,
    longitude: 145.0578,
    accuracy: 3
  },
  {
    postalCode: 3190,
    city: "Highett",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.95,
    longitude: 145.05,
    accuracy: 4
  },
  {
    postalCode: 3191,
    city: "Sandringham",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.95,
    longitude: 145,
    accuracy: 4
  },
  {
    postalCode: 3192,
    city: "Cheltenham",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9694,
    longitude: 145.0481,
    accuracy: 4
  },
  {
    postalCode: 3192,
    city: "Cheltenham East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9634,
    longitude: 145.0615,
    accuracy: 3
  },
  {
    postalCode: 3192,
    city: "Southland Centre",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9634,
    longitude: 145.0615,
    accuracy: 3
  },
  {
    postalCode: 3193,
    city: "Beaumaris",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9822,
    longitude: 145.0389,
    accuracy: 4
  },
  {
    postalCode: 3193,
    city: "Black Rock North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9667,
    longitude: 145.0167,
    accuracy: 4
  },
  {
    postalCode: 3193,
    city: "Black Rock",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9736,
    longitude: 145.0164,
    accuracy: 4
  },
  {
    postalCode: 3193,
    city: "Cromer",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9773,
    longitude: 145.0323,
    accuracy: 3
  },
  {
    postalCode: 3194,
    city: "Mentone",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9833,
    longitude: 145.0667,
    accuracy: 4
  },
  {
    postalCode: 3194,
    city: "Mentone East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9833,
    longitude: 145.0667,
    accuracy: 3
  },
  {
    postalCode: 3194,
    city: "Moorabbin Airport",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9799,
    longitude: 145.0815,
    accuracy: 3
  },
  {
    postalCode: 3195,
    city: "Braeside",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9995,
    longitude: 145.1163,
    accuracy: 4
  },
  {
    postalCode: 3195,
    city: "Mordialloc",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38,
    longitude: 145.0833,
    accuracy: 4
  },
  {
    postalCode: 3195,
    city: "Waterways",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0148,
    longitude: 145.1305,
    accuracy: 4
  },
  {
    postalCode: 3195,
    city: "Aspendale Gardens",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0228,
    longitude: 145.118,
    accuracy: 4
  },
  {
    postalCode: 3195,
    city: "Parkdale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9942,
    longitude: 145.0734,
    accuracy: 4
  },
  {
    postalCode: 3195,
    city: "Aspendale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0291,
    longitude: 145.1027,
    accuracy: 4
  },
  {
    postalCode: 3196,
    city: "Chelsea Heights",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0333,
    longitude: 145.1333,
    accuracy: 4
  },
  {
    postalCode: 3196,
    city: "Edithvale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0372,
    longitude: 145.1097,
    accuracy: 4
  },
  {
    postalCode: 3196,
    city: "Bonbeach",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0653,
    longitude: 145.1228,
    accuracy: 4
  },
  {
    postalCode: 3196,
    city: "Chelsea",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.05,
    longitude: 145.1167,
    accuracy: 4
  },
  {
    postalCode: 3197,
    city: "Carrum",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0833,
    longitude: 145.1333,
    accuracy: 4
  },
  {
    postalCode: 3197,
    city: "Patterson Lakes",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0693,
    longitude: 145.1433,
    accuracy: 4
  },
  {
    postalCode: 3198,
    city: "Belvedere Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1049,
    longitude: 145.1382,
    accuracy: 3
  },
  {
    postalCode: 3198,
    city: "Seaford",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1,
    longitude: 145.1333,
    accuracy: 4
  },
  {
    postalCode: 3199,
    city: "Karingal Centre",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1278,
    longitude: 145.15,
    accuracy: 3
  },
  {
    postalCode: 3199,
    city: "Frankston South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.166,
    longitude: 145.1364,
    accuracy: 4
  },
  {
    postalCode: 3199,
    city: "Frankston East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1333,
    longitude: 145.1333,
    accuracy: 4
  },
  {
    postalCode: 3199,
    city: "Frankston",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1446,
    longitude: 145.1229,
    accuracy: 4
  },
  {
    postalCode: 3199,
    city: "Frankston Heights",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1278,
    longitude: 145.15,
    accuracy: 3
  },
  {
    postalCode: 3199,
    city: "Karingal",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1604,
    longitude: 145.1399,
    accuracy: 3
  },
  {
    postalCode: 3200,
    city: "Frankston North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1235,
    longitude: 145.1484,
    accuracy: 4
  },
  {
    postalCode: 3200,
    city: "Pines Forest",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1213,
    longitude: 145.1552,
    accuracy: 3
  },
  {
    postalCode: 3201,
    city: "Carrum Downs",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0997,
    longitude: 145.1725,
    accuracy: 4
  },
  {
    postalCode: 3202,
    city: "Heatherton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.956,
    longitude: 145.0984,
    accuracy: 4
  },
  {
    postalCode: 3204,
    city: "Ormond",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9039,
    longitude: 145.0415,
    accuracy: 4
  },
  {
    postalCode: 3204,
    city: "Patterson",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0693,
    longitude: 145.1433,
    accuracy: 4
  },
  {
    postalCode: 3204,
    city: "Bentleigh",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9181,
    longitude: 145.0354,
    accuracy: 4
  },
  {
    postalCode: 3204,
    city: "Mckinnon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9167,
    longitude: 145.05,
    accuracy: 4
  },
  {
    postalCode: 3205,
    city: "South Melbourne Dc",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8335,
    longitude: 144.9571,
    accuracy: 3
  },
  {
    postalCode: 3205,
    city: "South Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8333,
    longitude: 144.9667,
    accuracy: 4
  },
  {
    postalCode: 3206,
    city: "Albert Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8333,
    longitude: 145,
    accuracy: 4
  },
  {
    postalCode: 3206,
    city: "Middle Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8512,
    longitude: 144.962,
    accuracy: 4
  },
  {
    postalCode: 3207,
    city: "Garden City",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.836,
    longitude: 144.9183,
    accuracy: 4
  },
  {
    postalCode: 3207,
    city: "Port Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8396,
    longitude: 144.9423,
    accuracy: 4
  },
  {
    postalCode: 3211,
    city: "Little River",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9667,
    longitude: 144.5,
    accuracy: 4
  },
  {
    postalCode: 3212,
    city: "Avalon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0239,
    longitude: 144.4062,
    accuracy: 3
  },
  {
    postalCode: 3212,
    city: "Lara",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0239,
    longitude: 144.4062,
    accuracy: 4
  },
  {
    postalCode: 3212,
    city: "Point Wilson",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0239,
    longitude: 144.4062,
    accuracy: 3
  },
  {
    postalCode: 3213,
    city: "Anakie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9167,
    longitude: 144.25,
    accuracy: 4
  },
  {
    postalCode: 3213,
    city: "Moorabool",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0833,
    longitude: 144.3,
    accuracy: 4
  },
  {
    postalCode: 3213,
    city: "Lovely Banks",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0667,
    longitude: 144.3333,
    accuracy: 4
  },
  {
    postalCode: 3213,
    city: "Batesford",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1,
    longitude: 144.2833,
    accuracy: 4
  },
  {
    postalCode: 3214,
    city: "Norlane",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1014,
    longitude: 144.3542,
    accuracy: 4
  },
  {
    postalCode: 3214,
    city: "North Shore",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1,
    longitude: 144.3667,
    accuracy: 4
  },
  {
    postalCode: 3214,
    city: "Corio",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0833,
    longitude: 144.3833,
    accuracy: 4
  },
  {
    postalCode: 3215,
    city: "Geelong North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1,
    longitude: 144.3667,
    accuracy: 3
  },
  {
    postalCode: 3215,
    city: "Bell Post Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0956,
    longitude: 144.3197,
    accuracy: 4
  },
  {
    postalCode: 3215,
    city: "North Geelong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1095,
    longitude: 144.3513,
    accuracy: 4
  },
  {
    postalCode: 3215,
    city: "Rippleside",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1257,
    longitude: 144.355,
    accuracy: 4
  },
  {
    postalCode: 3215,
    city: "Hamlyn Heights",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1211,
    longitude: 144.328,
    accuracy: 4
  },
  {
    postalCode: 3215,
    city: "Drumcondra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1302,
    longitude: 144.3538,
    accuracy: 4
  },
  {
    postalCode: 3215,
    city: "Bell Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1079,
    longitude: 144.3384,
    accuracy: 4
  },
  {
    postalCode: 3216,
    city: "Highton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1706,
    longitude: 144.3114,
    accuracy: 4
  },
  {
    postalCode: 3216,
    city: "Belmont",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1748,
    longitude: 144.3428,
    accuracy: 4
  },
  {
    postalCode: 3216,
    city: "Freshwater Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2667,
    longitude: 144.2833,
    accuracy: 4
  },
  {
    postalCode: 3216,
    city: "Grovedale East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2113,
    longitude: 144.3244,
    accuracy: 3
  },
  {
    postalCode: 3216,
    city: "Mount Duneed",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2409,
    longitude: 144.3375,
    accuracy: 4
  },
  {
    postalCode: 3216,
    city: "Marshall",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2,
    longitude: 144.3667,
    accuracy: 4
  },
  {
    postalCode: 3216,
    city: "Wandana Heights",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1758,
    longitude: 144.3039,
    accuracy: 4
  },
  {
    postalCode: 3216,
    city: "Grovedale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2,
    longitude: 144.35,
    accuracy: 4
  },
  {
    postalCode: 3216,
    city: "Waurn Ponds",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2167,
    longitude: 144.2833,
    accuracy: 4
  },
  {
    postalCode: 3217,
    city: "Deakin University",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1974,
    longitude: 144.3023,
    accuracy: 3
  },
  {
    postalCode: 3217,
    city: "Mount Duneed",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2409,
    longitude: 144.3375,
    accuracy: 4
  },
  {
    postalCode: 3217,
    city: "Freshwater Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2667,
    longitude: 144.2833,
    accuracy: 4
  },
  {
    postalCode: 3217,
    city: "Charlemont",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2187,
    longitude: 144.3677,
    accuracy: 4
  },
  {
    postalCode: 3217,
    city: "Armstrong Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2312,
    longitude: 144.3737,
    accuracy: 4
  },
  {
    postalCode: 3218,
    city: "Fyansford",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1333,
    longitude: 144.3167,
    accuracy: 4
  },
  {
    postalCode: 3218,
    city: "Stonehaven",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1236,
    longitude: 144.2291,
    accuracy: 4
  },
  {
    postalCode: 3218,
    city: "Geelong West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1389,
    longitude: 144.3484,
    accuracy: 4
  },
  {
    postalCode: 3218,
    city: "Manifold Heights",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1376,
    longitude: 144.3337,
    accuracy: 4
  },
  {
    postalCode: 3218,
    city: "Herne Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1343,
    longitude: 144.3241,
    accuracy: 4
  },
  {
    postalCode: 3218,
    city: "Murgheboluc",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0833,
    longitude: 144.1333,
    accuracy: 4
  },
  {
    postalCode: 3219,
    city: "Thomson",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1698,
    longitude: 144.3789,
    accuracy: 4
  },
  {
    postalCode: 3219,
    city: "St Albans Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.188,
    longitude: 144.3921,
    accuracy: 4
  },
  {
    postalCode: 3219,
    city: "Newcomb",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1662,
    longitude: 144.3943,
    accuracy: 4
  },
  {
    postalCode: 3219,
    city: "East Geelong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1557,
    longitude: 144.372,
    accuracy: 4
  },
  {
    postalCode: 3219,
    city: "Whittington",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1808,
    longitude: 144.3932,
    accuracy: 4
  },
  {
    postalCode: 3219,
    city: "Breakwater",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1799,
    longitude: 144.3676,
    accuracy: 4
  },
  {
    postalCode: 3220,
    city: "South Geelong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1619,
    longitude: 144.3556,
    accuracy: 4
  },
  {
    postalCode: 3220,
    city: "Bareena",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1505,
    longitude: 144.3479,
    accuracy: 3
  },
  {
    postalCode: 3220,
    city: "Newtown",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1539,
    longitude: 144.3351,
    accuracy: 4
  },
  {
    postalCode: 3220,
    city: "Geelong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1471,
    longitude: 144.3607,
    accuracy: 4
  },
  {
    postalCode: 3221,
    city: "Murgheboluc",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0833,
    longitude: 144.1333,
    accuracy: 4
  },
  {
    postalCode: 3221,
    city: "Fyansford",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1333,
    longitude: 144.3167,
    accuracy: 4
  },
  {
    postalCode: 3221,
    city: "Stonehaven",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1236,
    longitude: 144.2291,
    accuracy: 4
  },
  {
    postalCode: 3221,
    city: "Batesford",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1,
    longitude: 144.2833,
    accuracy: 4
  },
  {
    postalCode: 3221,
    city: "Gnarwarre",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1667,
    longitude: 144.15,
    accuracy: 4
  },
  {
    postalCode: 3221,
    city: "Moolap",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1833,
    longitude: 144.4333,
    accuracy: 4
  },
  {
    postalCode: 3221,
    city: "Bellarine",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1333,
    longitude: 144.6167,
    accuracy: 4
  },
  {
    postalCode: 3221,
    city: "Geelong Mc",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2043,
    longitude: 144.223,
    accuracy: 3
  },
  {
    postalCode: 3221,
    city: "Ceres",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1667,
    longitude: 144.2667,
    accuracy: 4
  },
  {
    postalCode: 3221,
    city: "Staughton Vale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.85,
    longitude: 144.2833,
    accuracy: 4
  },
  {
    postalCode: 3221,
    city: "Wongarra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.7167,
    longitude: 143.75,
    accuracy: 4
  },
  {
    postalCode: 3221,
    city: "Moorabool",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0833,
    longitude: 144.3,
    accuracy: 4
  },
  {
    postalCode: 3221,
    city: "Anakie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9167,
    longitude: 144.25,
    accuracy: 4
  },
  {
    postalCode: 3221,
    city: "Barrabool",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1667,
    longitude: 144.2263,
    accuracy: 4
  },
  {
    postalCode: 3221,
    city: "Kennett River",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6685,
    longitude: 143.8584,
    accuracy: 4
  },
  {
    postalCode: 3221,
    city: "Wye River",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6333,
    longitude: 143.8833,
    accuracy: 4
  },
  {
    postalCode: 3221,
    city: "Wallington",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2,
    longitude: 144.4833,
    accuracy: 4
  },
  {
    postalCode: 3221,
    city: "Lovely Banks",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0667,
    longitude: 144.3333,
    accuracy: 4
  },
  {
    postalCode: 3222,
    city: "Mannerim",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2167,
    longitude: 144.5833,
    accuracy: 4
  },
  {
    postalCode: 3222,
    city: "Drysdale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1724,
    longitude: 144.5699,
    accuracy: 4
  },
  {
    postalCode: 3222,
    city: "Marcus Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.25,
    longitude: 144.5667,
    accuracy: 4
  },
  {
    postalCode: 3222,
    city: "Clifton Springs",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1567,
    longitude: 144.5551,
    accuracy: 4
  },
  {
    postalCode: 3222,
    city: "Curlewis",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1833,
    longitude: 144.4833,
    accuracy: 4
  },
  {
    postalCode: 3222,
    city: "Wallington",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2,
    longitude: 144.4833,
    accuracy: 4
  },
  {
    postalCode: 3223,
    city: "St Leonards",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1705,
    longitude: 144.718,
    accuracy: 4
  },
  {
    postalCode: 3223,
    city: "Indented Head",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1431,
    longitude: 144.7134,
    accuracy: 4
  },
  {
    postalCode: 3223,
    city: "Bellarine",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1333,
    longitude: 144.6167,
    accuracy: 4
  },
  {
    postalCode: 3223,
    city: "Portarlington",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1154,
    longitude: 144.6556,
    accuracy: 4
  },
  {
    postalCode: 3224,
    city: "Leopold",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.19,
    longitude: 144.4682,
    accuracy: 4
  },
  {
    postalCode: 3224,
    city: "Moolap",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1833,
    longitude: 144.4333,
    accuracy: 4
  },
  {
    postalCode: 3225,
    city: "Point Lonsdale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2817,
    longitude: 144.6105,
    accuracy: 4
  },
  {
    postalCode: 3225,
    city: "Queenscliff",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2679,
    longitude: 144.6619,
    accuracy: 4
  },
  {
    postalCode: 3225,
    city: "Swan Island",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.4034,
    longitude: 143.6912,
    accuracy: 4
  },
  {
    postalCode: 3225,
    city: "Swan Bay",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2756,
    longitude: 144.631,
    accuracy: 3
  },
  {
    postalCode: 3226,
    city: "Ocean Grove",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2653,
    longitude: 144.5147,
    accuracy: 4
  },
  {
    postalCode: 3227,
    city: "Connewarre",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2667,
    longitude: 144.4,
    accuracy: 4
  },
  {
    postalCode: 3227,
    city: "Breamlea",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2597,
    longitude: 144.4509,
    accuracy: 3
  },
  {
    postalCode: 3227,
    city: "Barwon Heads",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2653,
    longitude: 144.5147,
    accuracy: 4
  },
  {
    postalCode: 3228,
    city: "Bellbrae",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3333,
    longitude: 144.2667,
    accuracy: 4
  },
  {
    postalCode: 3228,
    city: "Torquay",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3308,
    longitude: 144.3264,
    accuracy: 4
  },
  {
    postalCode: 3228,
    city: "Bells Beach",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3751,
    longitude: 144.2564,
    accuracy: 4
  },
  {
    postalCode: 3228,
    city: "Jan Juc",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3445,
    longitude: 144.2952,
    accuracy: 4
  },
  {
    postalCode: 3230,
    city: "Anglesea",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4073,
    longitude: 144.1859,
    accuracy: 4
  },
  {
    postalCode: 3231,
    city: "Aireys Inlet",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.464,
    longitude: 144.1039,
    accuracy: 4
  },
  {
    postalCode: 3231,
    city: "Eastern View",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4595,
    longitude: 144.0909,
    accuracy: 3
  },
  {
    postalCode: 3231,
    city: "Fairhaven",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.35,
    longitude: 145.2833,
    accuracy: 4
  },
  {
    postalCode: 3231,
    city: "Big Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.407,
    longitude: 144.6936,
    accuracy: 3
  },
  {
    postalCode: 3231,
    city: "Moggs Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4595,
    longitude: 144.0909,
    accuracy: 3
  },
  {
    postalCode: 3232,
    city: "Lorne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5404,
    longitude: 143.9764,
    accuracy: 4
  },
  {
    postalCode: 3233,
    city: "Apollo Bay",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.7594,
    longitude: 143.6722,
    accuracy: 4
  },
  {
    postalCode: 3233,
    city: "Cape Otway",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.85,
    longitude: 143.5167,
    accuracy: 4
  },
  {
    postalCode: 3233,
    city: "Skenes Creek North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.7803,
    longitude: 143.6403,
    accuracy: 3
  },
  {
    postalCode: 3233,
    city: "Marengo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.7783,
    longitude: 143.6555,
    accuracy: 4
  },
  {
    postalCode: 3233,
    city: "Petticoat Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.7803,
    longitude: 143.6403,
    accuracy: 3
  },
  {
    postalCode: 3233,
    city: "Skenes Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.7333,
    longitude: 143.7167,
    accuracy: 4
  },
  {
    postalCode: 3234,
    city: "Grey River",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6622,
    longitude: 143.8466,
    accuracy: 3
  },
  {
    postalCode: 3234,
    city: "Wye River",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6333,
    longitude: 143.8833,
    accuracy: 4
  },
  {
    postalCode: 3234,
    city: "Wongarra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.7167,
    longitude: 143.75,
    accuracy: 4
  },
  {
    postalCode: 3234,
    city: "Separation Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6304,
    longitude: 143.8945,
    accuracy: 4
  },
  {
    postalCode: 3234,
    city: "Sugarloaf",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6622,
    longitude: 143.8466,
    accuracy: 3
  },
  {
    postalCode: 3234,
    city: "Kennett River",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6685,
    longitude: 143.8584,
    accuracy: 4
  },
  {
    postalCode: 3235,
    city: "Deans Marsh",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4,
    longitude: 143.8667,
    accuracy: 4
  },
  {
    postalCode: 3235,
    city: "Boonah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4167,
    longitude: 143.9333,
    accuracy: 4
  },
  {
    postalCode: 3235,
    city: "Pennyroyal",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4167,
    longitude: 143.85,
    accuracy: 4
  },
  {
    postalCode: 3235,
    city: "Benwerrin",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4111,
    longitude: 143.8833,
    accuracy: 3
  },
  {
    postalCode: 3236,
    city: "Mount Sabine",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6333,
    longitude: 143.7167,
    accuracy: 4
  },
  {
    postalCode: 3236,
    city: "Forrest",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5167,
    longitude: 143.7167,
    accuracy: 4
  },
  {
    postalCode: 3237,
    city: "Beech Forest",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6366,
    longitude: 143.5678,
    accuracy: 4
  },
  {
    postalCode: 3237,
    city: "Wattle Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.7833,
    longitude: 143.25,
    accuracy: 4
  },
  {
    postalCode: 3237,
    city: "Aire Valley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.703,
    longitude: 143.5728,
    accuracy: 4
  },
  {
    postalCode: 3237,
    city: "Wyelangta",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6333,
    longitude: 143.4667,
    accuracy: 4
  },
  {
    postalCode: 3237,
    city: "Ferguson",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.631,
    longitude: 143.5258,
    accuracy: 4
  },
  {
    postalCode: 3237,
    city: "Gellibrand Lower",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.7167,
    longitude: 143.25,
    accuracy: 4
  },
  {
    postalCode: 3237,
    city: "Yuulong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6722,
    longitude: 143.4278,
    accuracy: 3
  },
  {
    postalCode: 3237,
    city: "Weeaproinah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6333,
    longitude: 143.5,
    accuracy: 4
  },
  {
    postalCode: 3238,
    city: "Johanna",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.756,
    longitude: 143.3893,
    accuracy: 4
  },
  {
    postalCode: 3238,
    city: "Lavers Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6667,
    longitude: 143.4,
    accuracy: 4
  },
  {
    postalCode: 3238,
    city: "Hordern Vale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.7782,
    longitude: 143.5004,
    accuracy: 4
  },
  {
    postalCode: 3238,
    city: "Glenaire",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.7333,
    longitude: 143.4278,
    accuracy: 3
  },
  {
    postalCode: 3239,
    city: "Chapple Vale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6333,
    longitude: 143.3167,
    accuracy: 4
  },
  {
    postalCode: 3239,
    city: "Carlisle River",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5667,
    longitude: 143.3833,
    accuracy: 4
  },
  {
    postalCode: 3239,
    city: "Kennedys Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6,
    longitude: 143.25,
    accuracy: 4
  },
  {
    postalCode: 3239,
    city: "Gellibrand",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5167,
    longitude: 143.5333,
    accuracy: 4
  },
  {
    postalCode: 3240,
    city: "Moriac",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2409,
    longitude: 144.1748,
    accuracy: 4
  },
  {
    postalCode: 3240,
    city: "Modewarre",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.25,
    longitude: 144.1333,
    accuracy: 4
  },
  {
    postalCode: 3240,
    city: "Buckley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2333,
    longitude: 144.1,
    accuracy: 4
  },
  {
    postalCode: 3240,
    city: "Mount Moriac",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2167,
    longitude: 144.1833,
    accuracy: 4
  },
  {
    postalCode: 3240,
    city: "Paraparap",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2504,
    longitude: 144.139,
    accuracy: 3
  },
  {
    postalCode: 3240,
    city: "Gherang",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3113,
    longitude: 144.1034,
    accuracy: 4
  },
  {
    postalCode: 3241,
    city: "Wensleydale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.35,
    longitude: 144.0333,
    accuracy: 4
  },
  {
    postalCode: 3241,
    city: "Winchelsea",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2448,
    longitude: 143.9832,
    accuracy: 4
  },
  {
    postalCode: 3241,
    city: "Bambra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3667,
    longitude: 143.9333,
    accuracy: 4
  },
  {
    postalCode: 3241,
    city: "Ombersley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3154,
    longitude: 144,
    accuracy: 3
  },
  {
    postalCode: 3241,
    city: "Winchelsea South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3154,
    longitude: 144,
    accuracy: 3
  },
  {
    postalCode: 3241,
    city: "Wurdiboluc",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3,
    longitude: 144.05,
    accuracy: 4
  },
  {
    postalCode: 3242,
    city: "Birregurra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3368,
    longitude: 143.7847,
    accuracy: 4
  },
  {
    postalCode: 3243,
    city: "Whoorel",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3667,
    longitude: 143.8167,
    accuracy: 4
  },
  {
    postalCode: 3243,
    city: "Murroon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4333,
    longitude: 143.8167,
    accuracy: 4
  },
  {
    postalCode: 3243,
    city: "Gerangamete",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.45,
    longitude: 143.7333,
    accuracy: 4
  },
  {
    postalCode: 3243,
    city: "Barwon Downs",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4667,
    longitude: 143.75,
    accuracy: 4
  },
  {
    postalCode: 3243,
    city: "Warncoort",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3167,
    longitude: 143.7167,
    accuracy: 4
  },
  {
    postalCode: 3249,
    city: "Barongarook",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4167,
    longitude: 143.6,
    accuracy: 4
  },
  {
    postalCode: 3249,
    city: "Swan Marsh",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3667,
    longitude: 143.3833,
    accuracy: 4
  },
  {
    postalCode: 3249,
    city: "Dreeite",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1833,
    longitude: 143.5167,
    accuracy: 4
  },
  {
    postalCode: 3249,
    city: "Barongarook West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.364,
    longitude: 143.5632,
    accuracy: 3
  },
  {
    postalCode: 3249,
    city: "Yeo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4167,
    longitude: 143.7,
    accuracy: 4
  },
  {
    postalCode: 3249,
    city: "Dreeite South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.364,
    longitude: 143.5632,
    accuracy: 3
  },
  {
    postalCode: 3249,
    city: "Larpent",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.35,
    longitude: 143.5,
    accuracy: 4
  },
  {
    postalCode: 3249,
    city: "Coragulac",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2667,
    longitude: 143.5333,
    accuracy: 4
  },
  {
    postalCode: 3249,
    city: "Irrewarra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3167,
    longitude: 143.6333,
    accuracy: 4
  },
  {
    postalCode: 3249,
    city: "Pirron Yallock",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.35,
    longitude: 143.4333,
    accuracy: 4
  },
  {
    postalCode: 3249,
    city: "Tanybryn",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.65,
    longitude: 143.7167,
    accuracy: 4
  },
  {
    postalCode: 3249,
    city: "Pomborneit East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.364,
    longitude: 143.5632,
    accuracy: 3
  },
  {
    postalCode: 3249,
    city: "Yeodene",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4167,
    longitude: 143.7,
    accuracy: 4
  },
  {
    postalCode: 3249,
    city: "Corunnun",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3019,
    longitude: 143.5942,
    accuracy: 3
  },
  {
    postalCode: 3249,
    city: "Warrion",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2333,
    longitude: 143.5667,
    accuracy: 4
  },
  {
    postalCode: 3249,
    city: "Wool Wool",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.25,
    longitude: 143.4167,
    accuracy: 4
  },
  {
    postalCode: 3249,
    city: "Ondit",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.25,
    longitude: 143.6333,
    accuracy: 4
  },
  {
    postalCode: 3249,
    city: "Irrewillipe East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.364,
    longitude: 143.5632,
    accuracy: 3
  },
  {
    postalCode: 3249,
    city: "Gerangamete",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.45,
    longitude: 143.7333,
    accuracy: 4
  },
  {
    postalCode: 3249,
    city: "Balintore",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.364,
    longitude: 143.5632,
    accuracy: 3
  },
  {
    postalCode: 3249,
    city: "Nalangil",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3,
    longitude: 143.45,
    accuracy: 4
  },
  {
    postalCode: 3249,
    city: "Kawarren",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4833,
    longitude: 143.5833,
    accuracy: 4
  },
  {
    postalCode: 3249,
    city: "Irrewillipe",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4,
    longitude: 143.4167,
    accuracy: 4
  },
  {
    postalCode: 3249,
    city: "Barramunga",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5833,
    longitude: 143.6833,
    accuracy: 4
  },
  {
    postalCode: 3249,
    city: "Alvie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2333,
    longitude: 143.5,
    accuracy: 4
  },
  {
    postalCode: 3250,
    city: "Colac West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3445,
    longitude: 143.5841,
    accuracy: 3
  },
  {
    postalCode: 3250,
    city: "Colac East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3445,
    longitude: 143.5841,
    accuracy: 3
  },
  {
    postalCode: 3250,
    city: "Colac",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.339,
    longitude: 143.5849,
    accuracy: 4
  },
  {
    postalCode: 3250,
    city: "Elliminyt",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.35,
    longitude: 143.5833,
    accuracy: 4
  },
  {
    postalCode: 3251,
    city: "Cundare North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1167,
    longitude: 143.5667,
    accuracy: 4
  },
  {
    postalCode: 3251,
    city: "Cundare",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1167,
    longitude: 143.5667,
    accuracy: 4
  },
  {
    postalCode: 3251,
    city: "Weering",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1,
    longitude: 143.6333,
    accuracy: 4
  },
  {
    postalCode: 3251,
    city: "Beeac",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1938,
    longitude: 143.6413,
    accuracy: 4
  },
  {
    postalCode: 3251,
    city: "Eurack",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.15,
    longitude: 143.7,
    accuracy: 4
  },
  {
    postalCode: 3254,
    city: "Cororooke",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2833,
    longitude: 143.5167,
    accuracy: 4
  },
  {
    postalCode: 3260,
    city: "Kariah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1833,
    longitude: 143.2167,
    accuracy: 4
  },
  {
    postalCode: 3260,
    city: "Gnotuk",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2167,
    longitude: 143.1167,
    accuracy: 4
  },
  {
    postalCode: 3260,
    city: "Carpendeit",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3833,
    longitude: 143.2667,
    accuracy: 4
  },
  {
    postalCode: 3260,
    city: "Pomborneit North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2612,
    longitude: 143.2241,
    accuracy: 3
  },
  {
    postalCode: 3260,
    city: "Bostocks Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3,
    longitude: 143.1167,
    accuracy: 4
  },
  {
    postalCode: 3260,
    city: "Pomborneit",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3,
    longitude: 143.3,
    accuracy: 4
  },
  {
    postalCode: 3260,
    city: "Weerite",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.25,
    longitude: 143.25,
    accuracy: 4
  },
  {
    postalCode: 3260,
    city: "Koallah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2612,
    longitude: 143.2241,
    accuracy: 3
  },
  {
    postalCode: 3260,
    city: "Leslie Manor",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1333,
    longitude: 143.3833,
    accuracy: 4
  },
  {
    postalCode: 3260,
    city: "Camperdown",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2339,
    longitude: 143.1498,
    accuracy: 4
  },
  {
    postalCode: 3260,
    city: "Tandarook",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2612,
    longitude: 143.2241,
    accuracy: 3
  },
  {
    postalCode: 3260,
    city: "South Purrumbete",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.35,
    longitude: 143.2167,
    accuracy: 4
  },
  {
    postalCode: 3260,
    city: "Tesbury",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2612,
    longitude: 143.2241,
    accuracy: 3
  },
  {
    postalCode: 3260,
    city: "Skibo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2612,
    longitude: 143.2241,
    accuracy: 3
  },
  {
    postalCode: 3260,
    city: "Chocolyn",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2612,
    longitude: 143.2241,
    accuracy: 3
  },
  {
    postalCode: 3260,
    city: "Bookaar",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2612,
    longitude: 143.2241,
    accuracy: 3
  },
  {
    postalCode: 3260,
    city: "Bungador",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2512,
    longitude: 143.2045,
    accuracy: 3
  },
  {
    postalCode: 3260,
    city: "Stonyford",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2512,
    longitude: 143.2045,
    accuracy: 3
  },
  {
    postalCode: 3264,
    city: "Terang",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2408,
    longitude: 142.9212,
    accuracy: 4
  },
  {
    postalCode: 3265,
    city: "Boorcan",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2167,
    longitude: 143.0167,
    accuracy: 4
  },
  {
    postalCode: 3265,
    city: "Noorat East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2472,
    longitude: 142.8397,
    accuracy: 3
  },
  {
    postalCode: 3265,
    city: "Kolora",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1333,
    longitude: 142.9167,
    accuracy: 4
  },
  {
    postalCode: 3265,
    city: "The Sisters",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2,
    longitude: 142.7833,
    accuracy: 4
  },
  {
    postalCode: 3265,
    city: "Ellerslie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.15,
    longitude: 142.7,
    accuracy: 4
  },
  {
    postalCode: 3265,
    city: "Taroon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2472,
    longitude: 142.8397,
    accuracy: 3
  },
  {
    postalCode: 3265,
    city: "Dixie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3,
    longitude: 142.9333,
    accuracy: 4
  },
  {
    postalCode: 3265,
    city: "Garvoc",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3,
    longitude: 142.8333,
    accuracy: 4
  },
  {
    postalCode: 3265,
    city: "Glenormiston South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1833,
    longitude: 142.9667,
    accuracy: 4
  },
  {
    postalCode: 3265,
    city: "Framlingham East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2,
    longitude: 142.7,
    accuracy: 4
  },
  {
    postalCode: 3265,
    city: "Laang",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3667,
    longitude: 142.8167,
    accuracy: 4
  },
  {
    postalCode: 3265,
    city: "Panmure",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3333,
    longitude: 142.7333,
    accuracy: 4
  },
  {
    postalCode: 3265,
    city: "Cudgee",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.35,
    longitude: 142.65,
    accuracy: 4
  },
  {
    postalCode: 3265,
    city: "Noorat",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1916,
    longitude: 142.9287,
    accuracy: 4
  },
  {
    postalCode: 3265,
    city: "Glenormiston North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.15,
    longitude: 142.9833,
    accuracy: 4
  },
  {
    postalCode: 3265,
    city: "Ecklin South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4,
    longitude: 142.9167,
    accuracy: 4
  },
  {
    postalCode: 3265,
    city: "Framlingham",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2333,
    longitude: 142.7167,
    accuracy: 4
  },
  {
    postalCode: 3266,
    city: "Jancourt East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4143,
    longitude: 143.1039,
    accuracy: 3
  },
  {
    postalCode: 3266,
    city: "Elingamite North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.35,
    longitude: 143.0167,
    accuracy: 4
  },
  {
    postalCode: 3266,
    city: "Elingamite",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3833,
    longitude: 143.0167,
    accuracy: 4
  },
  {
    postalCode: 3266,
    city: "Simpson",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5022,
    longitude: 143.2501,
    accuracy: 4
  },
  {
    postalCode: 3266,
    city: "Bullaharre",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3753,
    longitude: 143.0622,
    accuracy: 3
  },
  {
    postalCode: 3266,
    city: "Jancourt",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3667,
    longitude: 143.1,
    accuracy: 4
  },
  {
    postalCode: 3266,
    city: "Cobrico",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3,
    longitude: 143.0333,
    accuracy: 4
  },
  {
    postalCode: 3266,
    city: "Naroghid",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3753,
    longitude: 143.0622,
    accuracy: 3
  },
  {
    postalCode: 3266,
    city: "Glenfyne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4,
    longitude: 142.9833,
    accuracy: 4
  },
  {
    postalCode: 3266,
    city: "Cobden",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3286,
    longitude: 143.0748,
    accuracy: 4
  },
  {
    postalCode: 3267,
    city: "Scotts Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4333,
    longitude: 143.05,
    accuracy: 4
  },
  {
    postalCode: 3268,
    city: "Nirranda",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5,
    longitude: 142.7833,
    accuracy: 4
  },
  {
    postalCode: 3268,
    city: "Nullawarre",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4667,
    longitude: 142.7667,
    accuracy: 4
  },
  {
    postalCode: 3268,
    city: "Timboon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4843,
    longitude: 142.9803,
    accuracy: 4
  },
  {
    postalCode: 3268,
    city: "Newfield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5667,
    longitude: 143.0167,
    accuracy: 4
  },
  {
    postalCode: 3268,
    city: "Ayrford",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4249,
    longitude: 142.8596,
    accuracy: 4
  },
  {
    postalCode: 3268,
    city: "Brucknell",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.45,
    longitude: 142.9333,
    accuracy: 4
  },
  {
    postalCode: 3268,
    city: "Nirranda South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4987,
    longitude: 142.9281,
    accuracy: 3
  },
  {
    postalCode: 3268,
    city: "Heytesbury Lower",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5667,
    longitude: 142.9333,
    accuracy: 4
  },
  {
    postalCode: 3268,
    city: "Curdie Vale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5167,
    longitude: 142.8333,
    accuracy: 4
  },
  {
    postalCode: 3268,
    city: "The Cove",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4987,
    longitude: 142.9281,
    accuracy: 3
  },
  {
    postalCode: 3268,
    city: "Curdievale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4987,
    longitude: 142.9281,
    accuracy: 3
  },
  {
    postalCode: 3268,
    city: "Cowleys Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5,
    longitude: 143,
    accuracy: 4
  },
  {
    postalCode: 3268,
    city: "Curdies River",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.45,
    longitude: 142.9667,
    accuracy: 4
  },
  {
    postalCode: 3268,
    city: "Cooriemungle",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5597,
    longitude: 143.1363,
    accuracy: 4
  },
  {
    postalCode: 3268,
    city: "Nirranda East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4987,
    longitude: 142.9281,
    accuracy: 3
  },
  {
    postalCode: 3268,
    city: "Nullawarre North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4987,
    longitude: 142.9281,
    accuracy: 3
  },
  {
    postalCode: 3268,
    city: "Timboon West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4987,
    longitude: 142.9281,
    accuracy: 3
  },
  {
    postalCode: 3268,
    city: "Paaratte",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4987,
    longitude: 142.9281,
    accuracy: 3
  },
  {
    postalCode: 3269,
    city: "Princetown",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6833,
    longitude: 143.15,
    accuracy: 4
  },
  {
    postalCode: 3269,
    city: "Port Campbell",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6192,
    longitude: 142.9958,
    accuracy: 4
  },
  {
    postalCode: 3269,
    city: "Waarre",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6513,
    longitude: 143.0729,
    accuracy: 3
  },
  {
    postalCode: 3270,
    city: "Peterborough",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6035,
    longitude: 142.8733,
    accuracy: 4
  },
  {
    postalCode: 3271,
    city: "Dundonnell",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.85,
    longitude: 142.9833,
    accuracy: 4
  },
  {
    postalCode: 3271,
    city: "Darlington",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38,
    longitude: 143.05,
    accuracy: 4
  },
  {
    postalCode: 3271,
    city: "Pura Pura",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8167,
    longitude: 143.0833,
    accuracy: 4
  },
  {
    postalCode: 3272,
    city: "Mortlake",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.081,
    longitude: 142.8083,
    accuracy: 4
  },
  {
    postalCode: 3272,
    city: "Woorndoo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9,
    longitude: 142.8167,
    accuracy: 4
  },
  {
    postalCode: 3273,
    city: "Hexham",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38,
    longitude: 142.7,
    accuracy: 4
  },
  {
    postalCode: 3274,
    city: "Caramut",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.95,
    longitude: 142.5167,
    accuracy: 4
  },
  {
    postalCode: 3275,
    city: "Mailer Flat",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2876,
    longitude: 142.4615,
    accuracy: 3
  },
  {
    postalCode: 3275,
    city: "Mailors Flat",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3,
    longitude: 142.4667,
    accuracy: 4
  },
  {
    postalCode: 3276,
    city: "Minjah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2,
    longitude: 142.4333,
    accuracy: 3
  },
  {
    postalCode: 3276,
    city: "Woolsthorpe",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2,
    longitude: 142.4333,
    accuracy: 4
  },
  {
    postalCode: 3277,
    city: "Mepunga East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.45,
    longitude: 142.7333,
    accuracy: 4
  },
  {
    postalCode: 3277,
    city: "Allansford",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3864,
    longitude: 142.5943,
    accuracy: 4
  },
  {
    postalCode: 3277,
    city: "Naringal East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4216,
    longitude: 142.6902,
    accuracy: 3
  },
  {
    postalCode: 3277,
    city: "Naringal",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4,
    longitude: 142.7,
    accuracy: 4
  },
  {
    postalCode: 3277,
    city: "Mepunga",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.45,
    longitude: 142.7333,
    accuracy: 4
  },
  {
    postalCode: 3277,
    city: "Mepunga West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4216,
    longitude: 142.6902,
    accuracy: 3
  },
  {
    postalCode: 3278,
    city: "Purnim",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2833,
    longitude: 142.6333,
    accuracy: 4
  },
  {
    postalCode: 3278,
    city: "Purnim West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2833,
    longitude: 142.6333,
    accuracy: 3
  },
  {
    postalCode: 3279,
    city: "Wangoom",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3333,
    longitude: 142.5833,
    accuracy: 4
  },
  {
    postalCode: 3279,
    city: "Ballangeich",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2167,
    longitude: 142.6667,
    accuracy: 4
  },
  {
    postalCode: 3280,
    city: "Warrnambool",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3818,
    longitude: 142.488,
    accuracy: 4
  },
  {
    postalCode: 3280,
    city: "Dennington",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3667,
    longitude: 142.45,
    accuracy: 4
  },
  {
    postalCode: 3281,
    city: "Grassmere",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2833,
    longitude: 142.5333,
    accuracy: 4
  },
  {
    postalCode: 3281,
    city: "Woodford",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3167,
    longitude: 142.4667,
    accuracy: 4
  },
  {
    postalCode: 3281,
    city: "Bushfield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3333,
    longitude: 142.5167,
    accuracy: 4
  },
  {
    postalCode: 3281,
    city: "Winslow",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2333,
    longitude: 142.45,
    accuracy: 4
  },
  {
    postalCode: 3282,
    city: "Koroit",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2918,
    longitude: 142.3673,
    accuracy: 4
  },
  {
    postalCode: 3282,
    city: "Illowa",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3333,
    longitude: 142.4167,
    accuracy: 4
  },
  {
    postalCode: 3283,
    city: "Warrong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2333,
    longitude: 142.3667,
    accuracy: 4
  },
  {
    postalCode: 3283,
    city: "Crossley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3,
    longitude: 142.3333,
    accuracy: 4
  },
  {
    postalCode: 3283,
    city: "Tower Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3333,
    longitude: 142.35,
    accuracy: 4
  },
  {
    postalCode: 3283,
    city: "Yangery",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3167,
    longitude: 142.4167,
    accuracy: 4
  },
  {
    postalCode: 3283,
    city: "Southern Cross",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3,
    longitude: 142.4,
    accuracy: 4
  },
  {
    postalCode: 3283,
    city: "Yarpturk",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3,
    longitude: 142.4333,
    accuracy: 4
  },
  {
    postalCode: 3283,
    city: "Killarney",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.35,
    longitude: 142.3333,
    accuracy: 4
  },
  {
    postalCode: 3283,
    city: "Tarrone",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2852,
    longitude: 142.3574,
    accuracy: 3
  },
  {
    postalCode: 3283,
    city: "Kirkstall",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2667,
    longitude: 142.3167,
    accuracy: 4
  },
  {
    postalCode: 3283,
    city: "Willatook",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1667,
    longitude: 142.2667,
    accuracy: 4
  },
  {
    postalCode: 3284,
    city: "Port Fairy",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3853,
    longitude: 142.2371,
    accuracy: 4
  },
  {
    postalCode: 3284,
    city: "Orford",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2035,
    longitude: 142.1009,
    accuracy: 4
  },
  {
    postalCode: 3285,
    city: "Yambuk",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3156,
    longitude: 142.0651,
    accuracy: 4
  },
  {
    postalCode: 3285,
    city: "Codrington",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2667,
    longitude: 141.9667,
    accuracy: 4
  },
  {
    postalCode: 3285,
    city: "Rosebrook",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3536,
    longitude: 142.2545,
    accuracy: 4
  },
  {
    postalCode: 3285,
    city: "St Helens",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2395,
    longitude: 141.9049,
    accuracy: 3
  },
  {
    postalCode: 3285,
    city: "Narrawong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.25,
    longitude: 141.7167,
    accuracy: 4
  },
  {
    postalCode: 3285,
    city: "Toolong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2395,
    longitude: 141.9049,
    accuracy: 3
  },
  {
    postalCode: 3285,
    city: "Tyrendarra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2167,
    longitude: 141.7833,
    accuracy: 4
  },
  {
    postalCode: 3285,
    city: "Tyrendarra East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.25,
    longitude: 141.9,
    accuracy: 4
  },
  {
    postalCode: 3286,
    city: "Warrabkook",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38,
    longitude: 142.0167,
    accuracy: 4
  },
  {
    postalCode: 3286,
    city: "Macarthur",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0339,
    longitude: 142.0018,
    accuracy: 4
  },
  {
    postalCode: 3286,
    city: "Condah Swamp",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0113,
    longitude: 141.9617,
    accuracy: 3
  },
  {
    postalCode: 3286,
    city: "Knebsworth",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38,
    longitude: 141.8667,
    accuracy: 4
  },
  {
    postalCode: 3287,
    city: "Minhamite",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9833,
    longitude: 142.35,
    accuracy: 4
  },
  {
    postalCode: 3287,
    city: "Hawkesdale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1167,
    longitude: 142.3167,
    accuracy: 4
  },
  {
    postalCode: 3289,
    city: "Gazette",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8751,
    longitude: 142.2913,
    accuracy: 3
  },
  {
    postalCode: 3289,
    city: "Tabor",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8333,
    longitude: 142.2,
    accuracy: 4
  },
  {
    postalCode: 3289,
    city: "Gerrigerrup",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8751,
    longitude: 142.2913,
    accuracy: 3
  },
  {
    postalCode: 3289,
    city: "Penshurst",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8753,
    longitude: 142.2907,
    accuracy: 4
  },
  {
    postalCode: 3289,
    city: "Purdeet",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9167,
    longitude: 142.3833,
    accuracy: 4
  },
  {
    postalCode: 3292,
    city: "Nelson",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.05,
    longitude: 141.0167,
    accuracy: 4
  },
  {
    postalCode: 3293,
    city: "Glenthompson",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7187,
    longitude: 142.5402,
    accuracy: 1
  },
  {
    postalCode: 3293,
    city: "Narrapumelap South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7187,
    longitude: 142.5402,
    accuracy: 1
  },
  {
    postalCode: 3293,
    city: "Nareeb",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6555,
    longitude: 142.0879,
    accuracy: 1
  },
  {
    postalCode: 3294,
    city: "Moutajup",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6667,
    longitude: 142.2333,
    accuracy: 4
  },
  {
    postalCode: 3294,
    city: "Victoria Point",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5766,
    longitude: 142.3021,
    accuracy: 3
  },
  {
    postalCode: 3294,
    city: "Mirranatwa",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4167,
    longitude: 142.4167,
    accuracy: 4
  },
  {
    postalCode: 3294,
    city: "Woodhouse",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5766,
    longitude: 142.3021,
    accuracy: 3
  },
  {
    postalCode: 3294,
    city: "Dunkeld",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6499,
    longitude: 142.3439,
    accuracy: 4
  },
  {
    postalCode: 3294,
    city: "Karabeal",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6,
    longitude: 142.1833,
    accuracy: 4
  },
  {
    postalCode: 3294,
    city: "Victoria Valley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.55,
    longitude: 142.3333,
    accuracy: 4
  },
  {
    postalCode: 3300,
    city: "Hamilton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7442,
    longitude: 142.022,
    accuracy: 4
  },
  {
    postalCode: 3300,
    city: "Byaduk North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8928,
    longitude: 141.9553,
    accuracy: 4
  },
  {
    postalCode: 3301,
    city: "Yatchaw",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8167,
    longitude: 142.1,
    accuracy: 4
  },
  {
    postalCode: 3301,
    city: "Wannon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6667,
    longitude: 141.8333,
    accuracy: 4
  },
  {
    postalCode: 3301,
    city: "Croxton East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8,
    longitude: 142.2167,
    accuracy: 4
  },
  {
    postalCode: 3301,
    city: "Mount Napier",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7904,
    longitude: 142.0065,
    accuracy: 3
  },
  {
    postalCode: 3301,
    city: "Bochara",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7,
    longitude: 141.9333,
    accuracy: 4
  },
  {
    postalCode: 3301,
    city: "Tahara",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7333,
    longitude: 141.7,
    accuracy: 4
  },
  {
    postalCode: 3301,
    city: "Tarrington",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7667,
    longitude: 142.1,
    accuracy: 4
  },
  {
    postalCode: 3301,
    city: "Hensley Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7904,
    longitude: 142.0065,
    accuracy: 3
  },
  {
    postalCode: 3301,
    city: "Byaduk",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9523,
    longitude: 141.9552,
    accuracy: 4
  },
  {
    postalCode: 3301,
    city: "Warrayure",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6833,
    longitude: 142.15,
    accuracy: 4
  },
  {
    postalCode: 3301,
    city: "Broadwater",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1253,
    longitude: 142.0497,
    accuracy: 4
  },
  {
    postalCode: 3301,
    city: "Morgiana",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7904,
    longitude: 142.0065,
    accuracy: 3
  },
  {
    postalCode: 3301,
    city: "Strathkellar",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7,
    longitude: 142.1,
    accuracy: 4
  },
  {
    postalCode: 3301,
    city: "Yulecart",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7475,
    longitude: 141.9389,
    accuracy: 4
  },
  {
    postalCode: 3301,
    city: "Buckley Swamp",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7904,
    longitude: 142.0065,
    accuracy: 3
  },
  {
    postalCode: 3302,
    city: "Grassdale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8,
    longitude: 141.65,
    accuracy: 4
  },
  {
    postalCode: 3302,
    city: "Branxholme",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8667,
    longitude: 141.8,
    accuracy: 4
  },
  {
    postalCode: 3303,
    city: "Condah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.95,
    longitude: 141.75,
    accuracy: 4
  },
  {
    postalCode: 3303,
    city: "Wallacedale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9333,
    longitude: 141.8,
    accuracy: 4
  },
  {
    postalCode: 3303,
    city: "Breakaway Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0167,
    longitude: 141.8,
    accuracy: 4
  },
  {
    postalCode: 3303,
    city: "Lake Condah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1167,
    longitude: 141.8,
    accuracy: 4
  },
  {
    postalCode: 3303,
    city: "Hotspur",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9333,
    longitude: 141.5667,
    accuracy: 4
  },
  {
    postalCode: 3304,
    city: "Heywood",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1329,
    longitude: 141.6295,
    accuracy: 4
  },
  {
    postalCode: 3304,
    city: "Drik Drik",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38,
    longitude: 141.3,
    accuracy: 4
  },
  {
    postalCode: 3304,
    city: "Drumborg",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0833,
    longitude: 141.6,
    accuracy: 4
  },
  {
    postalCode: 3304,
    city: "Mumbannar",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9269,
    longitude: 141.1875,
    accuracy: 4
  },
  {
    postalCode: 3304,
    city: "Myamyn",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38,
    longitude: 141.7333,
    accuracy: 4
  },
  {
    postalCode: 3304,
    city: "Lyons",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0167,
    longitude: 141.4667,
    accuracy: 4
  },
  {
    postalCode: 3304,
    city: "Dartmoor",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9222,
    longitude: 141.2749,
    accuracy: 4
  },
  {
    postalCode: 3304,
    city: "Greenwald",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9667,
    longitude: 141.3667,
    accuracy: 4
  },
  {
    postalCode: 3304,
    city: "Winnap",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.95,
    longitude: 141.3167,
    accuracy: 4
  },
  {
    postalCode: 3304,
    city: "Bessiebelle",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.15,
    longitude: 141.9667,
    accuracy: 4
  },
  {
    postalCode: 3304,
    city: "Homerton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1333,
    longitude: 141.7833,
    accuracy: 4
  },
  {
    postalCode: 3304,
    city: "Milltown",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.05,
    longitude: 141.7167,
    accuracy: 4
  },
  {
    postalCode: 3305,
    city: "Mount Richmond",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2019,
    longitude: 141.3416,
    accuracy: 4
  },
  {
    postalCode: 3305,
    city: "Cape Bridgewater",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3705,
    longitude: 141.3995,
    accuracy: 4
  },
  {
    postalCode: 3305,
    city: "Bolwarra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2833,
    longitude: 141.6167,
    accuracy: 4
  },
  {
    postalCode: 3305,
    city: "Portland",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3462,
    longitude: 141.6026,
    accuracy: 4
  },
  {
    postalCode: 3305,
    city: "Gorae",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2333,
    longitude: 141.55,
    accuracy: 4
  },
  {
    postalCode: 3305,
    city: "Allestree",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2833,
    longitude: 141.65,
    accuracy: 4
  },
  {
    postalCode: 3305,
    city: "Gorae West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.25,
    longitude: 141.4833,
    accuracy: 4
  },
  {
    postalCode: 3305,
    city: "Cashmore",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3116,
    longitude: 141.4774,
    accuracy: 4
  },
  {
    postalCode: 3305,
    city: "Portland West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.354,
    longitude: 141.574,
    accuracy: 4
  },
  {
    postalCode: 3305,
    city: "Portland North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2855,
    longitude: 141.5377,
    accuracy: 3
  },
  {
    postalCode: 3305,
    city: "Dutton Way",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2855,
    longitude: 141.5377,
    accuracy: 3
  },
  {
    postalCode: 3305,
    city: "Heathmere",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2167,
    longitude: 141.6167,
    accuracy: 4
  },
  {
    postalCode: 3309,
    city: "Digby",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8,
    longitude: 141.5333,
    accuracy: 4
  },
  {
    postalCode: 3310,
    city: "Merino",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7205,
    longitude: 141.5483,
    accuracy: 4
  },
  {
    postalCode: 3310,
    city: "Tahara West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7205,
    longitude: 141.5483,
    accuracy: 3
  },
  {
    postalCode: 3311,
    city: "Casterton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5849,
    longitude: 141.403,
    accuracy: 4
  },
  {
    postalCode: 3311,
    city: "Corndale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5849,
    longitude: 141.403,
    accuracy: 3
  },
  {
    postalCode: 3312,
    city: "Lindsay",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6333,
    longitude: 140.9667,
    accuracy: 4
  },
  {
    postalCode: 3312,
    city: "Bahgallah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6333,
    longitude: 141.3833,
    accuracy: 4
  },
  {
    postalCode: 3312,
    city: "Lake Mundi",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.55,
    longitude: 141,
    accuracy: 4
  },
  {
    postalCode: 3312,
    city: "Dunrobin",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4799,
    longitude: 141.2923,
    accuracy: 3
  },
  {
    postalCode: 3312,
    city: "Powers Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2,
    longitude: 141.2833,
    accuracy: 4
  },
  {
    postalCode: 3312,
    city: "Henty",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6667,
    longitude: 141.5167,
    accuracy: 4
  },
  {
    postalCode: 3312,
    city: "Wando Vale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5167,
    longitude: 141.45,
    accuracy: 4
  },
  {
    postalCode: 3312,
    city: "Nangeela",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4799,
    longitude: 141.2923,
    accuracy: 3
  },
  {
    postalCode: 3312,
    city: "Carapook",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.55,
    longitude: 141.5333,
    accuracy: 4
  },
  {
    postalCode: 3312,
    city: "Warrock",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4799,
    longitude: 141.2923,
    accuracy: 3
  },
  {
    postalCode: 3312,
    city: "Brimboal",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3833,
    longitude: 141.4,
    accuracy: 4
  },
  {
    postalCode: 3312,
    city: "Killara",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.75,
    longitude: 145.5,
    accuracy: 4
  },
  {
    postalCode: 3312,
    city: "Poolaijelo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2324,
    longitude: 141.0988,
    accuracy: 4
  },
  {
    postalCode: 3312,
    city: "Sandford",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6167,
    longitude: 141.4333,
    accuracy: 4
  },
  {
    postalCode: 3312,
    city: "Strathdownie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7333,
    longitude: 141.1833,
    accuracy: 4
  },
  {
    postalCode: 3312,
    city: "Chetwynd",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2833,
    longitude: 141.4167,
    accuracy: 4
  },
  {
    postalCode: 3312,
    city: "Dorodong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3332,
    longitude: 141.0697,
    accuracy: 4
  },
  {
    postalCode: 3312,
    city: "Dergholm",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3833,
    longitude: 141.2167,
    accuracy: 4
  },
  {
    postalCode: 3312,
    city: "Wando Bridge",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4833,
    longitude: 141.4333,
    accuracy: 4
  },
  {
    postalCode: 3314,
    city: "Mooralla",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4,
    longitude: 142.1333,
    accuracy: 4
  },
  {
    postalCode: 3314,
    city: "Grampians",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0297,
    longitude: 142.4986,
    accuracy: 4
  },
  {
    postalCode: 3314,
    city: "Cavendish",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5167,
    longitude: 142.0333,
    accuracy: 4
  },
  {
    postalCode: 3314,
    city: "Glenisla",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2333,
    longitude: 142.1667,
    accuracy: 4
  },
  {
    postalCode: 3314,
    city: "Bulart",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.55,
    longitude: 141.95,
    accuracy: 4
  },
  {
    postalCode: 3315,
    city: "Nareen",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3833,
    longitude: 141.5667,
    accuracy: 4
  },
  {
    postalCode: 3315,
    city: "Paschendale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6667,
    longitude: 141.6,
    accuracy: 4
  },
  {
    postalCode: 3315,
    city: "Konongwootong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5333,
    longitude: 141.6833,
    accuracy: 4
  },
  {
    postalCode: 3315,
    city: "Tarrenlea",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6833,
    longitude: 141.7333,
    accuracy: 4
  },
  {
    postalCode: 3315,
    city: "Muntham",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5833,
    longitude: 141.5667,
    accuracy: 4
  },
  {
    postalCode: 3315,
    city: "Tahara Bridge",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4943,
    longitude: 141.6909,
    accuracy: 3
  },
  {
    postalCode: 3315,
    city: "Tarrayoukyan",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3167,
    longitude: 141.5833,
    accuracy: 4
  },
  {
    postalCode: 3315,
    city: "Clover Flat",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4943,
    longitude: 141.6909,
    accuracy: 3
  },
  {
    postalCode: 3315,
    city: "Gritjurk",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5833,
    longitude: 141.7667,
    accuracy: 4
  },
  {
    postalCode: 3315,
    city: "Brit Brit",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4333,
    longitude: 141.7667,
    accuracy: 4
  },
  {
    postalCode: 3315,
    city: "Coleraine",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5983,
    longitude: 141.6912,
    accuracy: 4
  },
  {
    postalCode: 3315,
    city: "Coojar",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4943,
    longitude: 141.6909,
    accuracy: 3
  },
  {
    postalCode: 3315,
    city: "Melville Forest",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5,
    longitude: 141.8667,
    accuracy: 4
  },
  {
    postalCode: 3315,
    city: "Gringegalgona",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4167,
    longitude: 141.8167,
    accuracy: 4
  },
  {
    postalCode: 3315,
    city: "Culla",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2333,
    longitude: 141.65,
    accuracy: 4
  },
  {
    postalCode: 3315,
    city: "Hilgay",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4943,
    longitude: 141.6909,
    accuracy: 3
  },
  {
    postalCode: 3315,
    city: "Wootong Vale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4943,
    longitude: 141.6909,
    accuracy: 3
  },
  {
    postalCode: 3317,
    city: "Harrow",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1667,
    longitude: 141.6,
    accuracy: 4
  },
  {
    postalCode: 3318,
    city: "Edenhope",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0365,
    longitude: 141.2966,
    accuracy: 4
  },
  {
    postalCode: 3318,
    city: "Kadnook",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0255,
    longitude: 141.3217,
    accuracy: 3
  },
  {
    postalCode: 3318,
    city: "Connewirricoo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2,
    longitude: 141.4667,
    accuracy: 4
  },
  {
    postalCode: 3318,
    city: "Ullswater",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9667,
    longitude: 141.3833,
    accuracy: 4
  },
  {
    postalCode: 3318,
    city: "Langkoop",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1,
    longitude: 141.0333,
    accuracy: 4
  },
  {
    postalCode: 3318,
    city: "Patyah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9,
    longitude: 141.2333,
    accuracy: 4
  },
  {
    postalCode: 3318,
    city: "Charam",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.95,
    longitude: 141.5167,
    accuracy: 4
  },
  {
    postalCode: 3319,
    city: "Bringalbert",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.85,
    longitude: 141.1667,
    accuracy: 4
  },
  {
    postalCode: 3319,
    city: "Apsley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9667,
    longitude: 141.0833,
    accuracy: 4
  },
  {
    postalCode: 3319,
    city: "Benayeo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9,
    longitude: 141.05,
    accuracy: 4
  },
  {
    postalCode: 3321,
    city: "Hesse",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1009,
    longitude: 144.0575,
    accuracy: 3
  },
  {
    postalCode: 3321,
    city: "Inverleigh",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1018,
    longitude: 144.0513,
    accuracy: 4
  },
  {
    postalCode: 3321,
    city: "Wingeel",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1009,
    longitude: 144.0575,
    accuracy: 3
  },
  {
    postalCode: 3322,
    city: "Cressy",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0333,
    longitude: 143.6333,
    accuracy: 4
  },
  {
    postalCode: 3323,
    city: "Foxhow",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.05,
    longitude: 143.4667,
    accuracy: 4
  },
  {
    postalCode: 3323,
    city: "Duverney",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0167,
    longitude: 143.5667,
    accuracy: 4
  },
  {
    postalCode: 3323,
    city: "Berrybank",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9833,
    longitude: 143.4833,
    accuracy: 4
  },
  {
    postalCode: 3324,
    city: "Lismore",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9527,
    longitude: 143.3378,
    accuracy: 4
  },
  {
    postalCode: 3324,
    city: "Mount Bute",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8667,
    longitude: 143.4167,
    accuracy: 4
  },
  {
    postalCode: 3324,
    city: "Mingay",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8333,
    longitude: 143.3167,
    accuracy: 4
  },
  {
    postalCode: 3325,
    city: "Derrinallum",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9479,
    longitude: 143.2203,
    accuracy: 4
  },
  {
    postalCode: 3325,
    city: "Vite Vite North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7833,
    longitude: 143.2,
    accuracy: 4
  },
  {
    postalCode: 3325,
    city: "Vite Vite",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8833,
    longitude: 143.1667,
    accuracy: 4
  },
  {
    postalCode: 3325,
    city: "Larralea",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8715,
    longitude: 143.1957,
    accuracy: 3
  },
  {
    postalCode: 3328,
    city: "Teesdale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0333,
    longitude: 144.05,
    accuracy: 4
  },
  {
    postalCode: 3329,
    city: "Shelford",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0167,
    longitude: 143.9667,
    accuracy: 4
  },
  {
    postalCode: 3329,
    city: "Barunah Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0167,
    longitude: 143.9667,
    accuracy: 3
  },
  {
    postalCode: 3329,
    city: "Barunah Plains",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0167,
    longitude: 143.9667,
    accuracy: 3
  },
  {
    postalCode: 3330,
    city: "Rokewood",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9,
    longitude: 143.7167,
    accuracy: 4
  },
  {
    postalCode: 3331,
    city: "She Oaks",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9,
    longitude: 144.1333,
    accuracy: 4
  },
  {
    postalCode: 3331,
    city: "Sutherlands Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9176,
    longitude: 144.1721,
    accuracy: 3
  },
  {
    postalCode: 3331,
    city: "Maude",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.95,
    longitude: 144.1667,
    accuracy: 4
  },
  {
    postalCode: 3331,
    city: "Steiglitz",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8833,
    longitude: 144.1833,
    accuracy: 4
  },
  {
    postalCode: 3331,
    city: "Russells Bridge",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0166,
    longitude: 144.1818,
    accuracy: 3
  },
  {
    postalCode: 3331,
    city: "Gheringhap",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0833,
    longitude: 144.2333,
    accuracy: 4
  },
  {
    postalCode: 3331,
    city: "Bannockburn",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0489,
    longitude: 144.1688,
    accuracy: 4
  },
  {
    postalCode: 3332,
    city: "Lethbridge",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9657,
    longitude: 144.1357,
    accuracy: 4
  },
  {
    postalCode: 3333,
    city: "Bamganie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9333,
    longitude: 143.9833,
    accuracy: 4
  },
  {
    postalCode: 3333,
    city: "Meredith",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8454,
    longitude: 144.0774,
    accuracy: 4
  },
  {
    postalCode: 3334,
    city: "Bungal",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7889,
    longitude: 144.0333,
    accuracy: 3
  },
  {
    postalCode: 3334,
    city: "Elaine",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7833,
    longitude: 144.0333,
    accuracy: 4
  },
  {
    postalCode: 3334,
    city: "Mount Doran",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7889,
    longitude: 144.0333,
    accuracy: 3
  },
  {
    postalCode: 3334,
    city: "Morrisons",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7833,
    longitude: 144.1,
    accuracy: 4
  },
  {
    postalCode: 3334,
    city: "Cargerie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8,
    longitude: 143.9667,
    accuracy: 4
  },
  {
    postalCode: 3335,
    city: "Plumpton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.687,
    longitude: 144.6908,
    accuracy: 4
  },
  {
    postalCode: 3335,
    city: "Rockbank",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7335,
    longitude: 144.67,
    accuracy: 4
  },
  {
    postalCode: 3337,
    city: "Melton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6834,
    longitude: 144.5854,
    accuracy: 4
  },
  {
    postalCode: 3337,
    city: "Melton West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6785,
    longitude: 144.5688,
    accuracy: 4
  },
  {
    postalCode: 3337,
    city: "Kurunjang",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6759,
    longitude: 144.5969,
    accuracy: 4
  },
  {
    postalCode: 3337,
    city: "Toolern Vale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6,
    longitude: 144.6,
    accuracy: 4
  },
  {
    postalCode: 3338,
    city: "Brookfield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7008,
    longitude: 144.5603,
    accuracy: 4
  },
  {
    postalCode: 3338,
    city: "Eynesbury",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8004,
    longitude: 144.5746,
    accuracy: 4
  },
  {
    postalCode: 3338,
    city: "Melton South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7077,
    longitude: 144.5749,
    accuracy: 4
  },
  {
    postalCode: 3338,
    city: "Exford",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7259,
    longitude: 144.53,
    accuracy: 4
  },
  {
    postalCode: 3340,
    city: "Staughton Vale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.85,
    longitude: 144.2833,
    accuracy: 4
  },
  {
    postalCode: 3340,
    city: "Balliang East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7833,
    longitude: 144.45,
    accuracy: 4
  },
  {
    postalCode: 3340,
    city: "Hopetoun Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6928,
    longitude: 144.501,
    accuracy: 4
  },
  {
    postalCode: 3340,
    city: "Balliang",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8333,
    longitude: 144.3667,
    accuracy: 4
  },
  {
    postalCode: 3340,
    city: "Bacchus Marsh",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6727,
    longitude: 144.4383,
    accuracy: 4
  },
  {
    postalCode: 3340,
    city: "Merrimu",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6576,
    longitude: 144.4535,
    accuracy: 4
  },
  {
    postalCode: 3340,
    city: "Parwan",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.705,
    longitude: 144.4699,
    accuracy: 4
  },
  {
    postalCode: 3340,
    city: "Maddingley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6852,
    longitude: 144.4324,
    accuracy: 4
  },
  {
    postalCode: 3340,
    city: "Darley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6581,
    longitude: 144.4434,
    accuracy: 4
  },
  {
    postalCode: 3340,
    city: "Coimadai",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6167,
    longitude: 144.4667,
    accuracy: 4
  },
  {
    postalCode: 3340,
    city: "Long Forest",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6727,
    longitude: 144.514,
    accuracy: 4
  },
  {
    postalCode: 3340,
    city: "Glenmore",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7127,
    longitude: 144.3185,
    accuracy: 4
  },
  {
    postalCode: 3340,
    city: "Rowsley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7199,
    longitude: 144.3727,
    accuracy: 4
  },
  {
    postalCode: 3341,
    city: "Korobeit",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5465,
    longitude: 144.313,
    accuracy: 3
  },
  {
    postalCode: 3341,
    city: "Dales Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5226,
    longitude: 144.298,
    accuracy: 4
  },
  {
    postalCode: 3341,
    city: "Myrniong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6167,
    longitude: 144.35,
    accuracy: 4
  },
  {
    postalCode: 3341,
    city: "Pentland Hills",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6632,
    longitude: 144.4085,
    accuracy: 4
  },
  {
    postalCode: 3341,
    city: "Greendale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5603,
    longitude: 144.2968,
    accuracy: 4
  },
  {
    postalCode: 3342,
    city: "Colbrook",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6426,
    longitude: 144.2293,
    accuracy: 3
  },
  {
    postalCode: 3342,
    city: "Beremboke",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7833,
    longitude: 144.25,
    accuracy: 4
  },
  {
    postalCode: 3342,
    city: "Ballan",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5999,
    longitude: 144.2289,
    accuracy: 4
  },
  {
    postalCode: 3342,
    city: "Fiskville",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6819,
    longitude: 144.2264,
    accuracy: 4
  },
  {
    postalCode: 3342,
    city: "Mount Wallace",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.75,
    longitude: 144.2167,
    accuracy: 4
  },
  {
    postalCode: 3342,
    city: "Bunding",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5167,
    longitude: 144.1667,
    accuracy: 4
  },
  {
    postalCode: 3342,
    city: "Durdidwarrah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6426,
    longitude: 144.2293,
    accuracy: 3
  },
  {
    postalCode: 3342,
    city: "Blakeville",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5167,
    longitude: 144.2167,
    accuracy: 4
  },
  {
    postalCode: 3342,
    city: "Ingliston",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.65,
    longitude: 144.3,
    accuracy: 4
  },
  {
    postalCode: 3345,
    city: "Gordon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5823,
    longitude: 144.1093,
    accuracy: 4
  },
  {
    postalCode: 3350,
    city: "Brown Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.55,
    longitude: 143.9,
    accuracy: 4
  },
  {
    postalCode: 3350,
    city: "Black Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.55,
    longitude: 143.8667,
    accuracy: 4
  },
  {
    postalCode: 3350,
    city: "Ballarat",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5662,
    longitude: 143.8496,
    accuracy: 4
  },
  {
    postalCode: 3350,
    city: "Lake Wendouree",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5499,
    longitude: 143.8473,
    accuracy: 4
  },
  {
    postalCode: 3350,
    city: "Bakery Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5635,
    longitude: 143.8658,
    accuracy: 4
  },
  {
    postalCode: 3350,
    city: "Mount Pleasant",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5833,
    longitude: 143.8667,
    accuracy: 4
  },
  {
    postalCode: 3350,
    city: "Ballarat Central",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5621,
    longitude: 143.8508,
    accuracy: 4
  },
  {
    postalCode: 3350,
    city: "Golden Point",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5749,
    longitude: 143.8687,
    accuracy: 4
  },
  {
    postalCode: 3350,
    city: "Mount Helen",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6246,
    longitude: 143.8789,
    accuracy: 4
  },
  {
    postalCode: 3350,
    city: "Nerrina",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.55,
    longitude: 143.8833,
    accuracy: 4
  },
  {
    postalCode: 3350,
    city: "Sovereign Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5677,
    longitude: 143.8786,
    accuracy: 3
  },
  {
    postalCode: 3350,
    city: "Mount Clear",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6,
    longitude: 143.8833,
    accuracy: 4
  },
  {
    postalCode: 3350,
    city: "Canadian",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5761,
    longitude: 143.8774,
    accuracy: 4
  },
  {
    postalCode: 3350,
    city: "Alfredton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5667,
    longitude: 143.8167,
    accuracy: 4
  },
  {
    postalCode: 3350,
    city: "Invermay Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5306,
    longitude: 143.858,
    accuracy: 4
  },
  {
    postalCode: 3350,
    city: "Eureka",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5647,
    longitude: 143.8826,
    accuracy: 4
  },
  {
    postalCode: 3350,
    city: "Ballarat North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5369,
    longitude: 143.8624,
    accuracy: 3
  },
  {
    postalCode: 3350,
    city: "Redan",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5765,
    longitude: 143.8386,
    accuracy: 4
  },
  {
    postalCode: 3350,
    city: "Ballarat West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5677,
    longitude: 143.8786,
    accuracy: 3
  },
  {
    postalCode: 3350,
    city: "Ballarat East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5667,
    longitude: 143.8667,
    accuracy: 4
  },
  {
    postalCode: 3350,
    city: "Soldiers Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5496,
    longitude: 143.8587,
    accuracy: 4
  },
  {
    postalCode: 3350,
    city: "Lucas",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5536,
    longitude: 143.7717,
    accuracy: 4
  },
  {
    postalCode: 3350,
    city: "Newington",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.564,
    longitude: 143.8276,
    accuracy: 4
  },
  {
    postalCode: 3351,
    city: "Chepstowe",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5833,
    longitude: 143.5,
    accuracy: 4
  },
  {
    postalCode: 3351,
    city: "Carngham",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5833,
    longitude: 143.5833,
    accuracy: 4
  },
  {
    postalCode: 3351,
    city: "Springdallah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7667,
    longitude: 143.6333,
    accuracy: 4
  },
  {
    postalCode: 3351,
    city: "Lake Bolac",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7126,
    longitude: 142.8396,
    accuracy: 4
  },
  {
    postalCode: 3351,
    city: "Streatham",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6667,
    longitude: 143.0667,
    accuracy: 4
  },
  {
    postalCode: 3351,
    city: "Cape Clear",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7833,
    longitude: 143.6167,
    accuracy: 4
  },
  {
    postalCode: 3351,
    city: "Ross Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.65,
    longitude: 143.75,
    accuracy: 4
  },
  {
    postalCode: 3351,
    city: "Newtown",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7,
    longitude: 143.65,
    accuracy: 4
  },
  {
    postalCode: 3351,
    city: "Snake Valley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6116,
    longitude: 143.585,
    accuracy: 4
  },
  {
    postalCode: 3351,
    city: "Bo Peep",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6967,
    longitude: 143.5151,
    accuracy: 3
  },
  {
    postalCode: 3351,
    city: "Westmere",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6833,
    longitude: 142.9667,
    accuracy: 4
  },
  {
    postalCode: 3351,
    city: "Smythes Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6,
    longitude: 143.7833,
    accuracy: 4
  },
  {
    postalCode: 3351,
    city: "Illabarook",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8333,
    longitude: 143.6667,
    accuracy: 4
  },
  {
    postalCode: 3351,
    city: "Mount Emu",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6967,
    longitude: 143.5151,
    accuracy: 3
  },
  {
    postalCode: 3351,
    city: "Staffordshire Reef",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.75,
    longitude: 143.7,
    accuracy: 4
  },
  {
    postalCode: 3351,
    city: "Wallinduc",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8667,
    longitude: 143.5167,
    accuracy: 4
  },
  {
    postalCode: 3351,
    city: "Hillcrest",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6167,
    longitude: 143.6333,
    accuracy: 4
  },
  {
    postalCode: 3351,
    city: "Smythesdale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6431,
    longitude: 143.6862,
    accuracy: 4
  },
  {
    postalCode: 3351,
    city: "Nintingbool",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6167,
    longitude: 143.7167,
    accuracy: 4
  },
  {
    postalCode: 3351,
    city: "Scarsdale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.65,
    longitude: 143.6667,
    accuracy: 4
  },
  {
    postalCode: 3351,
    city: "Berringa",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7667,
    longitude: 143.7,
    accuracy: 4
  },
  {
    postalCode: 3351,
    city: "Pitfield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8,
    longitude: 143.6,
    accuracy: 4
  },
  {
    postalCode: 3351,
    city: "Rokewood Junction",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.85,
    longitude: 143.6833,
    accuracy: 4
  },
  {
    postalCode: 3351,
    city: "Mininera",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6,
    longitude: 142.9667,
    accuracy: 4
  },
  {
    postalCode: 3351,
    city: "Piggoreet",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7167,
    longitude: 143.6333,
    accuracy: 4
  },
  {
    postalCode: 3351,
    city: "Haddon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6,
    longitude: 143.7167,
    accuracy: 4
  },
  {
    postalCode: 3351,
    city: "Nerrin Nerrin",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7667,
    longitude: 143.0167,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Mount Rowan",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5,
    longitude: 143.85,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Mount Bolton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.558,
    longitude: 143.8518,
    accuracy: 3
  },
  {
    postalCode: 3352,
    city: "Bunkers Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5716,
    longitude: 143.746,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Weatherboard",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4333,
    longitude: 143.6667,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Waubra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3667,
    longitude: 143.65,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Chapel Flat",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.558,
    longitude: 143.8518,
    accuracy: 3
  },
  {
    postalCode: 3352,
    city: "Blowhard",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4333,
    longitude: 143.8,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Gong Gong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.55,
    longitude: 143.9333,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Dereel",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8167,
    longitude: 143.7667,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Ballarat Roadside Delivery",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.558,
    longitude: 143.8518,
    accuracy: 3
  },
  {
    postalCode: 3352,
    city: "Wattle Flat",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4667,
    longitude: 143.95,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Enfield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7281,
    longitude: 143.7945,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Dean",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.45,
    longitude: 143.9833,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Navigators",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6167,
    longitude: 143.9333,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Bolwarrah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5167,
    longitude: 144.1,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Mount Egerton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6333,
    longitude: 144.1,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Lamplough",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1333,
    longitude: 143.5167,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Langi Kal Kal",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.558,
    longitude: 143.8518,
    accuracy: 3
  },
  {
    postalCode: 3352,
    city: "Clarkes Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4833,
    longitude: 143.9833,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Claretown",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.558,
    longitude: 143.8518,
    accuracy: 3
  },
  {
    postalCode: 3352,
    city: "Bullarook",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5277,
    longitude: 143.9976,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Bungaree",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5667,
    longitude: 144,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Magpie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6167,
    longitude: 143.85,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Lexton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2667,
    longitude: 143.5167,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Bonshaw",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.604,
    longitude: 143.8226,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Ercildoune",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.558,
    longitude: 143.8518,
    accuracy: 3
  },
  {
    postalCode: 3352,
    city: "Clarendon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7,
    longitude: 143.9667,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Millbrook",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5833,
    longitude: 144.05,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Barkstead",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.45,
    longitude: 144.1,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Cardigan",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5333,
    longitude: 143.75,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Yendon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6333,
    longitude: 143.9667,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Miners Rest",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4808,
    longitude: 143.8011,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Garibaldi",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7333,
    longitude: 143.8833,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Glenbrae",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.35,
    longitude: 143.5667,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Addington",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3833,
    longitude: 143.6833,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Wallace",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.55,
    longitude: 144.05,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Lal Lal",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6833,
    longitude: 144.0333,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Mount Mercer",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8167,
    longitude: 143.85,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Durham Lead",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7,
    longitude: 143.8833,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Glen Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.558,
    longitude: 143.8518,
    accuracy: 3
  },
  {
    postalCode: 3352,
    city: "Corindhap",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8833,
    longitude: 143.7333,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Grenville",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7667,
    longitude: 143.8833,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Napoleons",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6667,
    longitude: 143.8333,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Pootilla",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5167,
    longitude: 143.9667,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Burrumbeet",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4667,
    longitude: 143.6667,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Dunnstown",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6,
    longitude: 143.9833,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Sulky",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4667,
    longitude: 143.8667,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Scotchmans Lead",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.558,
    longitude: 143.8518,
    accuracy: 3
  },
  {
    postalCode: 3352,
    city: "Cambrian Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6333,
    longitude: 143.8333,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Werneth",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.95,
    longitude: 143.6167,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Windermere",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4833,
    longitude: 143.7167,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Springbank",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.531,
    longitude: 144.0574,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Brewster",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4833,
    longitude: 143.5167,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Mitchell Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5069,
    longitude: 143.7798,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Warrenheip",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5667,
    longitude: 143.9333,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Invermay",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5164,
    longitude: 143.8818,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Scotsburn",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6667,
    longitude: 143.9333,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Cardigan Village",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5109,
    longitude: 143.7062,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Learmonth",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4188,
    longitude: 143.7122,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Mollongghip",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4833,
    longitude: 144.0333,
    accuracy: 4
  },
  {
    postalCode: 3352,
    city: "Leigh Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5667,
    longitude: 143.9667,
    accuracy: 4
  },
  {
    postalCode: 3353,
    city: "Ballarat",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5662,
    longitude: 143.8496,
    accuracy: 4
  },
  {
    postalCode: 3354,
    city: "Ballarat Mc",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5987,
    longitude: 143.7607,
    accuracy: 3
  },
  {
    postalCode: 3354,
    city: "Bakery Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5635,
    longitude: 143.8658,
    accuracy: 4
  },
  {
    postalCode: 3355,
    city: "Wendouree Village",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5314,
    longitude: 143.8286,
    accuracy: 3
  },
  {
    postalCode: 3355,
    city: "Wendouree",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.55,
    longitude: 143.8333,
    accuracy: 4
  },
  {
    postalCode: 3355,
    city: "Mitchell Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5069,
    longitude: 143.7798,
    accuracy: 4
  },
  {
    postalCode: 3355,
    city: "Lake Gardens",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5463,
    longitude: 143.8165,
    accuracy: 4
  },
  {
    postalCode: 3356,
    city: "Delacombe",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5891,
    longitude: 143.8147,
    accuracy: 4
  },
  {
    postalCode: 3356,
    city: "Sebastopol",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5853,
    longitude: 143.8395,
    accuracy: 4
  },
  {
    postalCode: 3357,
    city: "Buninyong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6502,
    longitude: 143.8839,
    accuracy: 4
  },
  {
    postalCode: 3360,
    city: "Happy Valley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7167,
    longitude: 143.6,
    accuracy: 4
  },
  {
    postalCode: 3360,
    city: "Pittong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6667,
    longitude: 143.4833,
    accuracy: 4
  },
  {
    postalCode: 3360,
    city: "Linton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6863,
    longitude: 143.5629,
    accuracy: 4
  },
  {
    postalCode: 3360,
    city: "Willowvale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8,
    longitude: 143.4667,
    accuracy: 4
  },
  {
    postalCode: 3360,
    city: "Mannibadar",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7667,
    longitude: 143.5,
    accuracy: 4
  },
  {
    postalCode: 3361,
    city: "Carranballac",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7,
    longitude: 143.2167,
    accuracy: 4
  },
  {
    postalCode: 3361,
    city: "Bradvale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7833,
    longitude: 143.4,
    accuracy: 4
  },
  {
    postalCode: 3361,
    city: "Skipton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.686,
    longitude: 143.3647,
    accuracy: 4
  },
  {
    postalCode: 3363,
    city: "Mount Beckworth",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3167,
    longitude: 143.6833,
    accuracy: 4
  },
  {
    postalCode: 3363,
    city: "Creswick North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3781,
    longitude: 143.8123,
    accuracy: 3
  },
  {
    postalCode: 3363,
    city: "Dean",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.45,
    longitude: 143.9833,
    accuracy: 4
  },
  {
    postalCode: 3363,
    city: "Langdons Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3781,
    longitude: 143.8123,
    accuracy: 3
  },
  {
    postalCode: 3363,
    city: "Tourello",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.35,
    longitude: 143.7833,
    accuracy: 4
  },
  {
    postalCode: 3363,
    city: "Creswick",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.424,
    longitude: 143.8947,
    accuracy: 4
  },
  {
    postalCode: 3363,
    city: "Glendaruel",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.35,
    longitude: 143.7167,
    accuracy: 4
  },
  {
    postalCode: 3364,
    city: "Kooroocheang",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2833,
    longitude: 144.0333,
    accuracy: 4
  },
  {
    postalCode: 3364,
    city: "Werona",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.25,
    longitude: 144.0333,
    accuracy: 4
  },
  {
    postalCode: 3364,
    city: "Barkstead",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.45,
    longitude: 144.1,
    accuracy: 4
  },
  {
    postalCode: 3364,
    city: "Mount Prospect",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3317,
    longitude: 143.9508,
    accuracy: 3
  },
  {
    postalCode: 3364,
    city: "Ascot",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4,
    longitude: 143.8,
    accuracy: 4
  },
  {
    postalCode: 3364,
    city: "Broomfield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3867,
    longitude: 143.9119,
    accuracy: 4
  },
  {
    postalCode: 3364,
    city: "Newlyn",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4167,
    longitude: 143.9833,
    accuracy: 4
  },
  {
    postalCode: 3364,
    city: "Glendonald",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3333,
    longitude: 143.8333,
    accuracy: 4
  },
  {
    postalCode: 3364,
    city: "Rocklyn",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4333,
    longitude: 144.05,
    accuracy: 4
  },
  {
    postalCode: 3364,
    city: "Strathlea",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1333,
    longitude: 143.9667,
    accuracy: 4
  },
  {
    postalCode: 3364,
    city: "Allendale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3667,
    longitude: 143.9333,
    accuracy: 4
  },
  {
    postalCode: 3364,
    city: "Cabbage Tree",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6967,
    longitude: 148.7197,
    accuracy: 4
  },
  {
    postalCode: 3364,
    city: "Smeaton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3333,
    longitude: 143.95,
    accuracy: 4
  },
  {
    postalCode: 3364,
    city: "Blampied",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3667,
    longitude: 144.05,
    accuracy: 4
  },
  {
    postalCode: 3364,
    city: "Ullina",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2833,
    longitude: 143.9,
    accuracy: 4
  },
  {
    postalCode: 3364,
    city: "Smokeytown",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3317,
    longitude: 143.9508,
    accuracy: 3
  },
  {
    postalCode: 3364,
    city: "Joyces Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0833,
    longitude: 144.0167,
    accuracy: 4
  },
  {
    postalCode: 3364,
    city: "Newlyn North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4,
    longitude: 144,
    accuracy: 4
  },
  {
    postalCode: 3364,
    city: "Campbelltown",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2,
    longitude: 143.95,
    accuracy: 4
  },
  {
    postalCode: 3364,
    city: "Kingston",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.35,
    longitude: 143.9667,
    accuracy: 4
  },
  {
    postalCode: 3364,
    city: "Coghills Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3833,
    longitude: 143.7667,
    accuracy: 4
  },
  {
    postalCode: 3364,
    city: "Springmount",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4167,
    longitude: 143.9333,
    accuracy: 4
  },
  {
    postalCode: 3364,
    city: "Lawrence",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3167,
    longitude: 143.9,
    accuracy: 4
  },
  {
    postalCode: 3364,
    city: "Bald Hills",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4333,
    longitude: 143.85,
    accuracy: 4
  },
  {
    postalCode: 3370,
    city: "Clunes",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2947,
    longitude: 143.7864,
    accuracy: 4
  },
  {
    postalCode: 3370,
    city: "Mount Cameron",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2649,
    longitude: 143.8566,
    accuracy: 3
  },
  {
    postalCode: 3370,
    city: "Ullina",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2833,
    longitude: 143.9,
    accuracy: 4
  },
  {
    postalCode: 3370,
    city: "Glengower",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2167,
    longitude: 143.8833,
    accuracy: 4
  },
  {
    postalCode: 3371,
    city: "Lillicur",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2037,
    longitude: 143.6586,
    accuracy: 3
  },
  {
    postalCode: 3371,
    city: "Red Lion",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2037,
    longitude: 143.6586,
    accuracy: 3
  },
  {
    postalCode: 3371,
    city: "Evansford",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.25,
    longitude: 143.6333,
    accuracy: 4
  },
  {
    postalCode: 3371,
    city: "Burnbank",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2333,
    longitude: 143.6,
    accuracy: 4
  },
  {
    postalCode: 3371,
    city: "Talbot",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1723,
    longitude: 143.7017,
    accuracy: 4
  },
  {
    postalCode: 3371,
    city: "Amherst",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.15,
    longitude: 143.6667,
    accuracy: 4
  },
  {
    postalCode: 3371,
    city: "Dunach",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2167,
    longitude: 143.7167,
    accuracy: 4
  },
  {
    postalCode: 3371,
    city: "Mount Glasgow",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2037,
    longitude: 143.6586,
    accuracy: 3
  },
  {
    postalCode: 3371,
    city: "Stony Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5833,
    longitude: 146.0333,
    accuracy: 4
  },
  {
    postalCode: 3371,
    city: "Caralulup",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2,
    longitude: 143.6333,
    accuracy: 4
  },
  {
    postalCode: 3373,
    city: "Trawalla",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4333,
    longitude: 143.4667,
    accuracy: 4
  },
  {
    postalCode: 3373,
    city: "Mena Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4293,
    longitude: 143.3908,
    accuracy: 3
  },
  {
    postalCode: 3373,
    city: "Lake Goldsmith",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.55,
    longitude: 143.4,
    accuracy: 4
  },
  {
    postalCode: 3373,
    city: "Nerring",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4667,
    longitude: 143.4333,
    accuracy: 4
  },
  {
    postalCode: 3373,
    city: "Raglan",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.35,
    longitude: 143.35,
    accuracy: 4
  },
  {
    postalCode: 3373,
    city: "Stoneleigh",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4293,
    longitude: 143.3908,
    accuracy: 3
  },
  {
    postalCode: 3373,
    city: "Waterloo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3667,
    longitude: 143.4167,
    accuracy: 4
  },
  {
    postalCode: 3373,
    city: "Chute",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3333,
    longitude: 143.3833,
    accuracy: 4
  },
  {
    postalCode: 3373,
    city: "Main Lead",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3833,
    longitude: 143.3667,
    accuracy: 4
  },
  {
    postalCode: 3373,
    city: "Cross Roads",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4293,
    longitude: 143.3908,
    accuracy: 3
  },
  {
    postalCode: 3373,
    city: "Beaufort",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.43,
    longitude: 143.3835,
    accuracy: 4
  },
  {
    postalCode: 3373,
    city: "Lake Wongan",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4293,
    longitude: 143.3908,
    accuracy: 3
  },
  {
    postalCode: 3373,
    city: "Stockyard Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.55,
    longitude: 143.3167,
    accuracy: 4
  },
  {
    postalCode: 3374,
    city: "Great Western",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.15,
    longitude: 142.85,
    accuracy: 4
  },
  {
    postalCode: 3375,
    city: "Buangor",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3667,
    longitude: 143.1667,
    accuracy: 4
  },
  {
    postalCode: 3375,
    city: "Bayindeen",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3167,
    longitude: 143.1667,
    accuracy: 4
  },
  {
    postalCode: 3375,
    city: "Middle Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4,
    longitude: 143.2333,
    accuracy: 4
  },
  {
    postalCode: 3375,
    city: "Ballyrogan",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4333,
    longitude: 143.1333,
    accuracy: 4
  },
  {
    postalCode: 3377,
    city: "Rocky Point",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2626,
    longitude: 142.9809,
    accuracy: 3
  },
  {
    postalCode: 3377,
    city: "Warrak",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2667,
    longitude: 143.15,
    accuracy: 4
  },
  {
    postalCode: 3377,
    city: "Rhymney",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2667,
    longitude: 142.7833,
    accuracy: 4
  },
  {
    postalCode: 3377,
    city: "Dobie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3167,
    longitude: 143.0333,
    accuracy: 4
  },
  {
    postalCode: 3377,
    city: "Shays Flat",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2626,
    longitude: 142.9809,
    accuracy: 3
  },
  {
    postalCode: 3377,
    city: "Mount Cole",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.25,
    longitude: 143.2,
    accuracy: 4
  },
  {
    postalCode: 3377,
    city: "Crowlands",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.15,
    longitude: 143.1167,
    accuracy: 4
  },
  {
    postalCode: 3377,
    city: "Mount Cole Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2333,
    longitude: 143.1333,
    accuracy: 4
  },
  {
    postalCode: 3377,
    city: "Cathcart",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2626,
    longitude: 142.9809,
    accuracy: 3
  },
  {
    postalCode: 3377,
    city: "Langi Logan",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.35,
    longitude: 142.95,
    accuracy: 4
  },
  {
    postalCode: 3377,
    city: "Denicull Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3333,
    longitude: 142.9,
    accuracy: 4
  },
  {
    postalCode: 3377,
    city: "Eversley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2,
    longitude: 143.1667,
    accuracy: 4
  },
  {
    postalCode: 3377,
    city: "Bulgana",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2626,
    longitude: 142.9809,
    accuracy: 3
  },
  {
    postalCode: 3377,
    city: "Ararat",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2854,
    longitude: 142.9273,
    accuracy: 4
  },
  {
    postalCode: 3377,
    city: "Norval",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2667,
    longitude: 142.8833,
    accuracy: 4
  },
  {
    postalCode: 3377,
    city: "Moyston",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3,
    longitude: 142.7667,
    accuracy: 4
  },
  {
    postalCode: 3377,
    city: "Rossbridge",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2626,
    longitude: 142.9809,
    accuracy: 3
  },
  {
    postalCode: 3377,
    city: "Dunneworthy",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2,
    longitude: 143.0667,
    accuracy: 4
  },
  {
    postalCode: 3377,
    city: "Maroona",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4167,
    longitude: 142.8667,
    accuracy: 4
  },
  {
    postalCode: 3377,
    city: "Great Western",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.15,
    longitude: 142.85,
    accuracy: 4
  },
  {
    postalCode: 3377,
    city: "Armstrong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2167,
    longitude: 142.9,
    accuracy: 4
  },
  {
    postalCode: 3378,
    city: "Yalla-Y-Poora",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5333,
    longitude: 143.0667,
    accuracy: 4
  },
  {
    postalCode: 3378,
    city: "Tatyoon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5167,
    longitude: 142.95,
    accuracy: 4
  },
  {
    postalCode: 3379,
    city: "Chatsworth",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.858,
    longitude: 142.6511,
    accuracy: 4
  },
  {
    postalCode: 3379,
    city: "Bornes Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6717,
    longitude: 142.6812,
    accuracy: 3
  },
  {
    postalCode: 3379,
    city: "Willaura North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6717,
    longitude: 142.6812,
    accuracy: 3
  },
  {
    postalCode: 3379,
    city: "Mafeking",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6717,
    longitude: 142.6812,
    accuracy: 3
  },
  {
    postalCode: 3379,
    city: "Stavely",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6,
    longitude: 142.6167,
    accuracy: 4
  },
  {
    postalCode: 3379,
    city: "Wickliffe",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6833,
    longitude: 142.7167,
    accuracy: 4
  },
  {
    postalCode: 3379,
    city: "Willaura",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5454,
    longitude: 142.7404,
    accuracy: 4
  },
  {
    postalCode: 3380,
    city: "Stawell",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0563,
    longitude: 142.7809,
    accuracy: 4
  },
  {
    postalCode: 3380,
    city: "Stawell West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0563,
    longitude: 142.7809,
    accuracy: 3
  },
  {
    postalCode: 3381,
    city: "Bellellen",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0132,
    longitude: 142.692,
    accuracy: 3
  },
  {
    postalCode: 3381,
    city: "Bellfield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7531,
    longitude: 145.0385,
    accuracy: 4
  },
  {
    postalCode: 3381,
    city: "Lubeck",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7333,
    longitude: 142.5667,
    accuracy: 4
  },
  {
    postalCode: 3381,
    city: "Mount Dryden",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0132,
    longitude: 142.692,
    accuracy: 3
  },
  {
    postalCode: 3381,
    city: "Mokepilly",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0132,
    longitude: 142.692,
    accuracy: 3
  },
  {
    postalCode: 3381,
    city: "Black Range",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0132,
    longitude: 142.692,
    accuracy: 3
  },
  {
    postalCode: 3381,
    city: "Pomonal",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1917,
    longitude: 142.6076,
    accuracy: 4
  },
  {
    postalCode: 3381,
    city: "Lake Lonsdale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0333,
    longitude: 142.5833,
    accuracy: 4
  },
  {
    postalCode: 3381,
    city: "Lake Fyans",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0132,
    longitude: 142.692,
    accuracy: 3
  },
  {
    postalCode: 3381,
    city: "Halls Gap",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1365,
    longitude: 142.5185,
    accuracy: 4
  },
  {
    postalCode: 3381,
    city: "Campbells Bridge",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9333,
    longitude: 142.7833,
    accuracy: 4
  },
  {
    postalCode: 3381,
    city: "Illawarra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0667,
    longitude: 142.7,
    accuracy: 4
  },
  {
    postalCode: 3381,
    city: "Barkly",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9333,
    longitude: 143.2,
    accuracy: 4
  },
  {
    postalCode: 3381,
    city: "Fyans Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0864,
    longitude: 142.5558,
    accuracy: 4
  },
  {
    postalCode: 3384,
    city: "Joel South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1333,
    longitude: 143.0667,
    accuracy: 4
  },
  {
    postalCode: 3384,
    city: "Wattle Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9833,
    longitude: 143.1167,
    accuracy: 4
  },
  {
    postalCode: 3384,
    city: "Landsborough",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0167,
    longitude: 143.15,
    accuracy: 4
  },
  {
    postalCode: 3384,
    city: "Barkly",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9333,
    longitude: 143.2,
    accuracy: 4
  },
  {
    postalCode: 3384,
    city: "Concongella",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9972,
    longitude: 143.1028,
    accuracy: 3
  },
  {
    postalCode: 3384,
    city: "Joel Joel",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0167,
    longitude: 142.9833,
    accuracy: 4
  },
  {
    postalCode: 3384,
    city: "Navarre",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9,
    longitude: 143.1,
    accuracy: 4
  },
  {
    postalCode: 3384,
    city: "Frenchmans",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9972,
    longitude: 143.1028,
    accuracy: 3
  },
  {
    postalCode: 3384,
    city: "Tulkara",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9972,
    longitude: 143.1028,
    accuracy: 3
  },
  {
    postalCode: 3384,
    city: "Landsborough West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9972,
    longitude: 143.1028,
    accuracy: 3
  },
  {
    postalCode: 3385,
    city: "Lubeck",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7333,
    longitude: 142.5667,
    accuracy: 4
  },
  {
    postalCode: 3385,
    city: "Dadswells Bridge",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9,
    longitude: 142.5167,
    accuracy: 4
  },
  {
    postalCode: 3385,
    city: "Roses Gap",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8733,
    longitude: 142.6233,
    accuracy: 3
  },
  {
    postalCode: 3385,
    city: "Riachella",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8733,
    longitude: 142.6233,
    accuracy: 3
  },
  {
    postalCode: 3385,
    city: "Deep Lead",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0167,
    longitude: 142.7333,
    accuracy: 4
  },
  {
    postalCode: 3385,
    city: "Wal Wal",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8167,
    longitude: 142.6167,
    accuracy: 4
  },
  {
    postalCode: 3385,
    city: "Glenorchy",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9,
    longitude: 142.6833,
    accuracy: 4
  },
  {
    postalCode: 3385,
    city: "Ledcourt",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8733,
    longitude: 142.6233,
    accuracy: 3
  },
  {
    postalCode: 3387,
    city: "Morrl Morrl",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.85,
    longitude: 142.9333,
    accuracy: 4
  },
  {
    postalCode: 3387,
    city: "Marnoo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.65,
    longitude: 142.8833,
    accuracy: 4
  },
  {
    postalCode: 3387,
    city: "Callawadda",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8,
    longitude: 142.8,
    accuracy: 4
  },
  {
    postalCode: 3387,
    city: "Wallaloo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7167,
    longitude: 142.8833,
    accuracy: 4
  },
  {
    postalCode: 3387,
    city: "Kanya",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7667,
    longitude: 143,
    accuracy: 4
  },
  {
    postalCode: 3387,
    city: "Wallaloo East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7833,
    longitude: 142.9333,
    accuracy: 4
  },
  {
    postalCode: 3387,
    city: "Bolangum",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8042,
    longitude: 142.8958,
    accuracy: 3
  },
  {
    postalCode: 3387,
    city: "Campbells Bridge",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9333,
    longitude: 142.7833,
    accuracy: 4
  },
  {
    postalCode: 3387,
    city: "Germania",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8042,
    longitude: 142.8958,
    accuracy: 3
  },
  {
    postalCode: 3387,
    city: "Greens Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9333,
    longitude: 142.95,
    accuracy: 4
  },
  {
    postalCode: 3387,
    city: "Marnoo West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8042,
    longitude: 142.8958,
    accuracy: 3
  },
  {
    postalCode: 3388,
    city: "Banyena",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5667,
    longitude: 142.8333,
    accuracy: 4
  },
  {
    postalCode: 3388,
    city: "Rupanyup",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6285,
    longitude: 142.6315,
    accuracy: 4
  },
  {
    postalCode: 3390,
    city: "Kewell",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5,
    longitude: 142.4167,
    accuracy: 4
  },
  {
    postalCode: 3390,
    city: "Murtoa",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6201,
    longitude: 142.4668,
    accuracy: 4
  },
  {
    postalCode: 3391,
    city: "Brim",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0833,
    longitude: 142.4167,
    accuracy: 4
  },
  {
    postalCode: 3392,
    city: "Sheep Hills",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3333,
    longitude: 142.55,
    accuracy: 4
  },
  {
    postalCode: 3392,
    city: "Minyip",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4596,
    longitude: 142.5878,
    accuracy: 4
  },
  {
    postalCode: 3392,
    city: "Boolite",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.35,
    longitude: 142.6667,
    accuracy: 4
  },
  {
    postalCode: 3393,
    city: "Crymelon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2043,
    longitude: 142.3909,
    accuracy: 3
  },
  {
    postalCode: 3393,
    city: "Kellalac",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3808,
    longitude: 142.4012,
    accuracy: 4
  },
  {
    postalCode: 3393,
    city: "Willenabrina",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0667,
    longitude: 142.2,
    accuracy: 4
  },
  {
    postalCode: 3393,
    city: "Wilkur",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0667,
    longitude: 142.6167,
    accuracy: 4
  },
  {
    postalCode: 3393,
    city: "Bangerang",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2,
    longitude: 142.5833,
    accuracy: 4
  },
  {
    postalCode: 3393,
    city: "Warracknabeal",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2533,
    longitude: 142.3928,
    accuracy: 4
  },
  {
    postalCode: 3393,
    city: "Lah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1333,
    longitude: 142.45,
    accuracy: 4
  },
  {
    postalCode: 3393,
    city: "Aubrey",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2333,
    longitude: 142.2333,
    accuracy: 4
  },
  {
    postalCode: 3393,
    city: "Cannum",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3,
    longitude: 142.25,
    accuracy: 4
  },
  {
    postalCode: 3395,
    city: "Kenmare",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.9167,
    longitude: 142.1667,
    accuracy: 4
  },
  {
    postalCode: 3395,
    city: "Beulah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.9378,
    longitude: 142.4222,
    accuracy: 4
  },
  {
    postalCode: 3395,
    city: "Reedy Dam",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.9667,
    longitude: 142.65,
    accuracy: 4
  },
  {
    postalCode: 3395,
    city: "Rosebery",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.8167,
    longitude: 142.4167,
    accuracy: 4
  },
  {
    postalCode: 3396,
    city: "Hopetoun",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.727,
    longitude: 142.3663,
    accuracy: 4
  },
  {
    postalCode: 3400,
    city: "Horsham",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7113,
    longitude: 142.1998,
    accuracy: 4
  },
  {
    postalCode: 3401,
    city: "Kalkee",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5333,
    longitude: 142.2333,
    accuracy: 4
  },
  {
    postalCode: 3401,
    city: "Quantong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7333,
    longitude: 142.0167,
    accuracy: 4
  },
  {
    postalCode: 3401,
    city: "Nurcoung",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7333,
    longitude: 141.6833,
    accuracy: 4
  },
  {
    postalCode: 3401,
    city: "Wallup",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.35,
    longitude: 142.25,
    accuracy: 4
  },
  {
    postalCode: 3401,
    city: "Laharum",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7821,
    longitude: 142.1128,
    accuracy: 3
  },
  {
    postalCode: 3401,
    city: "St Helens Plains",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8,
    longitude: 142.3833,
    accuracy: 4
  },
  {
    postalCode: 3401,
    city: "Dooen",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6667,
    longitude: 142.2833,
    accuracy: 4
  },
  {
    postalCode: 3401,
    city: "Mockinya",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9667,
    longitude: 142.15,
    accuracy: 4
  },
  {
    postalCode: 3401,
    city: "Zumsteins",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7821,
    longitude: 142.1128,
    accuracy: 3
  },
  {
    postalCode: 3401,
    city: "Nurrabiel",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9167,
    longitude: 142.05,
    accuracy: 4
  },
  {
    postalCode: 3401,
    city: "Murra Warra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7821,
    longitude: 142.1128,
    accuracy: 3
  },
  {
    postalCode: 3401,
    city: "Telangatuk East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0833,
    longitude: 141.9667,
    accuracy: 4
  },
  {
    postalCode: 3401,
    city: "Drung",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7167,
    longitude: 142.3333,
    accuracy: 4
  },
  {
    postalCode: 3401,
    city: "Lower Norton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7667,
    longitude: 142.1,
    accuracy: 4
  },
  {
    postalCode: 3401,
    city: "Haven",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7607,
    longitude: 142.1943,
    accuracy: 4
  },
  {
    postalCode: 3401,
    city: "Toolondo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9833,
    longitude: 141.9333,
    accuracy: 4
  },
  {
    postalCode: 3401,
    city: "Kanagulk",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1333,
    longitude: 141.8667,
    accuracy: 4
  },
  {
    postalCode: 3401,
    city: "Longerenong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6667,
    longitude: 142.4,
    accuracy: 4
  },
  {
    postalCode: 3401,
    city: "Rocklands",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7717,
    longitude: 141.9796,
    accuracy: 3
  },
  {
    postalCode: 3401,
    city: "Gymbowen",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7333,
    longitude: 141.6,
    accuracy: 4
  },
  {
    postalCode: 3401,
    city: "Vectis",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7821,
    longitude: 142.1128,
    accuracy: 3
  },
  {
    postalCode: 3401,
    city: "Wartook",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0239,
    longitude: 142.3385,
    accuracy: 4
  },
  {
    postalCode: 3401,
    city: "Riverside",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7717,
    longitude: 141.9796,
    accuracy: 3
  },
  {
    postalCode: 3401,
    city: "Brimpaen",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0333,
    longitude: 142.2,
    accuracy: 4
  },
  {
    postalCode: 3401,
    city: "Cherrypool",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1,
    longitude: 142.1833,
    accuracy: 4
  },
  {
    postalCode: 3401,
    city: "Blackheath",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4667,
    longitude: 142.25,
    accuracy: 4
  },
  {
    postalCode: 3401,
    city: "Wonwondah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7821,
    longitude: 142.1128,
    accuracy: 3
  },
  {
    postalCode: 3401,
    city: "Mckenzie Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8,
    longitude: 142.1833,
    accuracy: 4
  },
  {
    postalCode: 3401,
    city: "Bungalally",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8,
    longitude: 142.25,
    accuracy: 4
  },
  {
    postalCode: 3401,
    city: "Karnak",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8667,
    longitude: 141.5,
    accuracy: 4
  },
  {
    postalCode: 3401,
    city: "Jung",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6167,
    longitude: 142.3667,
    accuracy: 4
  },
  {
    postalCode: 3401,
    city: "Wail",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5,
    longitude: 142.1,
    accuracy: 4
  },
  {
    postalCode: 3401,
    city: "Pimpinio",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5833,
    longitude: 142.1167,
    accuracy: 4
  },
  {
    postalCode: 3402,
    city: "Horsham",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7113,
    longitude: 142.1998,
    accuracy: 4
  },
  {
    postalCode: 3407,
    city: "Englefield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3167,
    longitude: 141.8333,
    accuracy: 4
  },
  {
    postalCode: 3407,
    city: "Vasey",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3667,
    longitude: 141.8833,
    accuracy: 4
  },
  {
    postalCode: 3407,
    city: "Balmoral",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.25,
    longitude: 141.85,
    accuracy: 4
  },
  {
    postalCode: 3407,
    city: "Pigeon Ponds",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3,
    longitude: 141.6833,
    accuracy: 4
  },
  {
    postalCode: 3407,
    city: "Gatum",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4167,
    longitude: 141.9333,
    accuracy: 4
  },
  {
    postalCode: 3409,
    city: "Natimuk",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7403,
    longitude: 141.9452,
    accuracy: 4
  },
  {
    postalCode: 3409,
    city: "Grass Flat",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.86,
    longitude: 141.7958,
    accuracy: 3
  },
  {
    postalCode: 3409,
    city: "Clear Lake",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9333,
    longitude: 141.8667,
    accuracy: 4
  },
  {
    postalCode: 3409,
    city: "Arapiles",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7333,
    longitude: 141.85,
    accuracy: 4
  },
  {
    postalCode: 3409,
    city: "Mitre",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7333,
    longitude: 141.7833,
    accuracy: 4
  },
  {
    postalCode: 3409,
    city: "Duchembegarra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.86,
    longitude: 141.7958,
    accuracy: 3
  },
  {
    postalCode: 3409,
    city: "Noradjuha",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8333,
    longitude: 141.9667,
    accuracy: 4
  },
  {
    postalCode: 3409,
    city: "Douglas",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0333,
    longitude: 141.7333,
    accuracy: 4
  },
  {
    postalCode: 3409,
    city: "Wombelano",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37,
    longitude: 141.6,
    accuracy: 4
  },
  {
    postalCode: 3409,
    city: "Jilpanger",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.86,
    longitude: 141.7958,
    accuracy: 3
  },
  {
    postalCode: 3409,
    city: "Tooan",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8,
    longitude: 141.7833,
    accuracy: 4
  },
  {
    postalCode: 3409,
    city: "Miga Lake",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9333,
    longitude: 141.6333,
    accuracy: 4
  },
  {
    postalCode: 3412,
    city: "Goroke",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7179,
    longitude: 141.4731,
    accuracy: 4
  },
  {
    postalCode: 3413,
    city: "Neuarpurr",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7667,
    longitude: 141.0833,
    accuracy: 4
  },
  {
    postalCode: 3413,
    city: "Ozenkadnook",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.85,
    longitude: 141.3333,
    accuracy: 4
  },
  {
    postalCode: 3413,
    city: "Minimay",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7167,
    longitude: 141.1833,
    accuracy: 4
  },
  {
    postalCode: 3413,
    city: "Peronne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7333,
    longitude: 141.3833,
    accuracy: 4
  },
  {
    postalCode: 3414,
    city: "Antwerp",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3,
    longitude: 142.05,
    accuracy: 4
  },
  {
    postalCode: 3414,
    city: "Dimboola",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4562,
    longitude: 142.0329,
    accuracy: 4
  },
  {
    postalCode: 3414,
    city: "Tarranyurk",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2167,
    longitude: 142.05,
    accuracy: 4
  },
  {
    postalCode: 3415,
    city: "Miram",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3667,
    longitude: 141.35,
    accuracy: 4
  },
  {
    postalCode: 3418,
    city: "Gerang Gerung",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3594,
    longitude: 141.8555,
    accuracy: 4
  },
  {
    postalCode: 3418,
    city: "Nhill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3333,
    longitude: 141.6501,
    accuracy: 4
  },
  {
    postalCode: 3418,
    city: "Kiata",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3667,
    longitude: 141.8,
    accuracy: 4
  },
  {
    postalCode: 3418,
    city: "Lawloit",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4167,
    longitude: 141.4667,
    accuracy: 4
  },
  {
    postalCode: 3418,
    city: "Broughton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1667,
    longitude: 141.35,
    accuracy: 4
  },
  {
    postalCode: 3418,
    city: "Lorquon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1667,
    longitude: 141.75,
    accuracy: 4
  },
  {
    postalCode: 3418,
    city: "Little Desert",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4956,
    longitude: 141.7474,
    accuracy: 4
  },
  {
    postalCode: 3418,
    city: "Yanac",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1333,
    longitude: 141.4333,
    accuracy: 4
  },
  {
    postalCode: 3418,
    city: "Glenlee",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2167,
    longitude: 141.85,
    accuracy: 4
  },
  {
    postalCode: 3418,
    city: "Netherby",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1167,
    longitude: 141.65,
    accuracy: 4
  },
  {
    postalCode: 3419,
    city: "Kaniva",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3786,
    longitude: 141.2422,
    accuracy: 4
  },
  {
    postalCode: 3420,
    city: "Telopea Downs",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.375,
    longitude: 141.0583,
    accuracy: 3
  },
  {
    postalCode: 3420,
    city: "Serviceton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3833,
    longitude: 140.9833,
    accuracy: 4
  },
  {
    postalCode: 3420,
    city: "Lillimur",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3667,
    longitude: 141.1333,
    accuracy: 4
  },
  {
    postalCode: 3423,
    city: "Jeparit",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1425,
    longitude: 141.9882,
    accuracy: 4
  },
  {
    postalCode: 3424,
    city: "Yaapeet",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.7667,
    longitude: 142.05,
    accuracy: 4
  },
  {
    postalCode: 3424,
    city: "Albacutya",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.8167,
    longitude: 142,
    accuracy: 4
  },
  {
    postalCode: 3424,
    city: "Rainbow",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.8958,
    longitude: 141.9979,
    accuracy: 4
  },
  {
    postalCode: 3427,
    city: "Diggers Rest",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.626,
    longitude: 144.7188,
    accuracy: 4
  },
  {
    postalCode: 3428,
    city: "Bulla",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6384,
    longitude: 144.8074,
    accuracy: 4
  },
  {
    postalCode: 3429,
    city: "Sunbury",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5774,
    longitude: 144.7261,
    accuracy: 4
  },
  {
    postalCode: 3429,
    city: "Wildwood",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5735,
    longitude: 144.7881,
    accuracy: 4
  },
  {
    postalCode: 3430,
    city: "Clarkefield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4833,
    longitude: 144.75,
    accuracy: 4
  },
  {
    postalCode: 3431,
    city: "Riddells Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4605,
    longitude: 144.6796,
    accuracy: 4
  },
  {
    postalCode: 3432,
    city: "Bolinda",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4333,
    longitude: 144.75,
    accuracy: 4
  },
  {
    postalCode: 3433,
    city: "Monegeetta",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4167,
    longitude: 144.75,
    accuracy: 4
  },
  {
    postalCode: 3434,
    city: "Romsey",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3507,
    longitude: 144.743,
    accuracy: 4
  },
  {
    postalCode: 3434,
    city: "Cherokee",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.342,
    longitude: 144.7798,
    accuracy: 3
  },
  {
    postalCode: 3434,
    city: "Springfield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3333,
    longitude: 144.8167,
    accuracy: 4
  },
  {
    postalCode: 3434,
    city: "Kerrie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3684,
    longitude: 144.754,
    accuracy: 3
  },
  {
    postalCode: 3435,
    city: "Lancefield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2773,
    longitude: 144.736,
    accuracy: 4
  },
  {
    postalCode: 3435,
    city: "Goldie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.247,
    longitude: 144.718,
    accuracy: 3
  },
  {
    postalCode: 3435,
    city: "Benloch",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2167,
    longitude: 144.7,
    accuracy: 4
  },
  {
    postalCode: 3435,
    city: "Nulla Vale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.247,
    longitude: 144.718,
    accuracy: 3
  },
  {
    postalCode: 3437,
    city: "Bullengarook",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5167,
    longitude: 144.4833,
    accuracy: 4
  },
  {
    postalCode: 3437,
    city: "Gisborne South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5026,
    longitude: 144.5388,
    accuracy: 3
  },
  {
    postalCode: 3437,
    city: "Gisborne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4886,
    longitude: 144.5942,
    accuracy: 4
  },
  {
    postalCode: 3438,
    city: "New Gisborne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4428,
    longitude: 144.6184,
    accuracy: 1
  },
  {
    postalCode: 3440,
    city: "Macedon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4196,
    longitude: 144.5624,
    accuracy: 4
  },
  {
    postalCode: 3441,
    city: "Mount Macedon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4005,
    longitude: 144.5841,
    accuracy: 4
  },
  {
    postalCode: 3442,
    city: "Hesket",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.35,
    longitude: 144.65,
    accuracy: 4
  },
  {
    postalCode: 3442,
    city: "Ashbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3355,
    longitude: 144.5399,
    accuracy: 3
  },
  {
    postalCode: 3442,
    city: "Rochford",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3167,
    longitude: 144.6833,
    accuracy: 4
  },
  {
    postalCode: 3442,
    city: "Carlsruhe",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2833,
    longitude: 144.5,
    accuracy: 4
  },
  {
    postalCode: 3442,
    city: "Woodend",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3547,
    longitude: 144.529,
    accuracy: 4
  },
  {
    postalCode: 3442,
    city: "Cadello",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3174,
    longitude: 144.5993,
    accuracy: 3
  },
  {
    postalCode: 3442,
    city: "Newham",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3333,
    longitude: 144.6,
    accuracy: 4
  },
  {
    postalCode: 3442,
    city: "Cobaw",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2667,
    longitude: 144.6333,
    accuracy: 4
  },
  {
    postalCode: 3442,
    city: "Woodend North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3174,
    longitude: 144.5993,
    accuracy: 3
  },
  {
    postalCode: 3444,
    city: "Barfold",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0833,
    longitude: 144.5167,
    accuracy: 4
  },
  {
    postalCode: 3444,
    city: "Pastoria",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1538,
    longitude: 144.4934,
    accuracy: 3
  },
  {
    postalCode: 3444,
    city: "Lyal",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.95,
    longitude: 144.4833,
    accuracy: 4
  },
  {
    postalCode: 3444,
    city: "Redesdale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0167,
    longitude: 144.5167,
    accuracy: 4
  },
  {
    postalCode: 3444,
    city: "Langley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.15,
    longitude: 144.5,
    accuracy: 4
  },
  {
    postalCode: 3444,
    city: "Tylden South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1538,
    longitude: 144.4934,
    accuracy: 3
  },
  {
    postalCode: 3444,
    city: "Kyneton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2444,
    longitude: 144.4515,
    accuracy: 4
  },
  {
    postalCode: 3444,
    city: "Glenhope",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0833,
    longitude: 144.6,
    accuracy: 4
  },
  {
    postalCode: 3444,
    city: "Tylden",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3258,
    longitude: 144.4062,
    accuracy: 4
  },
  {
    postalCode: 3444,
    city: "Greenhill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1538,
    longitude: 144.4934,
    accuracy: 3
  },
  {
    postalCode: 3444,
    city: "Baynton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1492,
    longitude: 144.6337,
    accuracy: 4
  },
  {
    postalCode: 3444,
    city: "Pipers Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.25,
    longitude: 144.5333,
    accuracy: 4
  },
  {
    postalCode: 3444,
    city: "Mia Mia",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37,
    longitude: 144.5667,
    accuracy: 4
  },
  {
    postalCode: 3444,
    city: "Metcalfe East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1538,
    longitude: 144.4934,
    accuracy: 3
  },
  {
    postalCode: 3444,
    city: "Lauriston",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.25,
    longitude: 144.3833,
    accuracy: 4
  },
  {
    postalCode: 3444,
    city: "Edgecombe",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1833,
    longitude: 144.4333,
    accuracy: 4
  },
  {
    postalCode: 3444,
    city: "Sidonia",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1667,
    longitude: 144.55,
    accuracy: 4
  },
  {
    postalCode: 3444,
    city: "Baynton East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1538,
    longitude: 144.4934,
    accuracy: 3
  },
  {
    postalCode: 3444,
    city: "Spring Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3,
    longitude: 144.3333,
    accuracy: 4
  },
  {
    postalCode: 3444,
    city: "Kyneton South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1538,
    longitude: 144.4934,
    accuracy: 3
  },
  {
    postalCode: 3444,
    city: "Pastoria East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1538,
    longitude: 144.4934,
    accuracy: 3
  },
  {
    postalCode: 3446,
    city: "Malmsbury",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1886,
    longitude: 144.3847,
    accuracy: 4
  },
  {
    postalCode: 3446,
    city: "Drummond North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.189,
    longitude: 144.3822,
    accuracy: 3
  },
  {
    postalCode: 3447,
    city: "Taradale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.15,
    longitude: 144.3667,
    accuracy: 4
  },
  {
    postalCode: 3448,
    city: "Sutton Grange",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9833,
    longitude: 144.3667,
    accuracy: 4
  },
  {
    postalCode: 3448,
    city: "Elphinstone",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1,
    longitude: 144.3333,
    accuracy: 4
  },
  {
    postalCode: 3448,
    city: "Metcalfe",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1,
    longitude: 144.4333,
    accuracy: 4
  },
  {
    postalCode: 3450,
    city: "Moonlight Flat",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0671,
    longitude: 144.2168,
    accuracy: 3
  },
  {
    postalCode: 3450,
    city: "Castlemaine",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0671,
    longitude: 144.2168,
    accuracy: 4
  },
  {
    postalCode: 3451,
    city: "Gower",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1426,
    longitude: 144.1861,
    accuracy: 3
  },
  {
    postalCode: 3451,
    city: "Mckenzie Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1426,
    longitude: 144.1861,
    accuracy: 3
  },
  {
    postalCode: 3451,
    city: "Campbells Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0867,
    longitude: 144.202,
    accuracy: 4
  },
  {
    postalCode: 3451,
    city: "Golden Point",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5749,
    longitude: 143.8687,
    accuracy: 4
  },
  {
    postalCode: 3451,
    city: "Barkers Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0167,
    longitude: 144.25,
    accuracy: 4
  },
  {
    postalCode: 3451,
    city: "Muckleford",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0167,
    longitude: 144.15,
    accuracy: 4
  },
  {
    postalCode: 3451,
    city: "Guildford",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1667,
    longitude: 144.1667,
    accuracy: 4
  },
  {
    postalCode: 3451,
    city: "Yapeen",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1333,
    longitude: 144.1833,
    accuracy: 4
  },
  {
    postalCode: 3451,
    city: "Chewton Bushlands",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1426,
    longitude: 144.1861,
    accuracy: 3
  },
  {
    postalCode: 3451,
    city: "Faraday",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.05,
    longitude: 144.3,
    accuracy: 4
  },
  {
    postalCode: 3451,
    city: "Vaughan",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1426,
    longitude: 144.1861,
    accuracy: 3
  },
  {
    postalCode: 3451,
    city: "Glenluce",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1667,
    longitude: 144.2333,
    accuracy: 4
  },
  {
    postalCode: 3451,
    city: "Chewton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0814,
    longitude: 144.2568,
    accuracy: 4
  },
  {
    postalCode: 3451,
    city: "Fryerstown",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1333,
    longitude: 144.25,
    accuracy: 4
  },
  {
    postalCode: 3451,
    city: "Tarilta",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1426,
    longitude: 144.1861,
    accuracy: 3
  },
  {
    postalCode: 3451,
    city: "Irishtown",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1426,
    longitude: 144.1861,
    accuracy: 3
  },
  {
    postalCode: 3453,
    city: "Ravenswood",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9,
    longitude: 144.2167,
    accuracy: 4
  },
  {
    postalCode: 3453,
    city: "Harcourt North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9521,
    longitude: 144.2382,
    accuracy: 3
  },
  {
    postalCode: 3453,
    city: "Harcourt",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9998,
    longitude: 144.2599,
    accuracy: 4
  },
  {
    postalCode: 3453,
    city: "Ravenswood South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9566,
    longitude: 144.2381,
    accuracy: 4
  },
  {
    postalCode: 3458,
    city: "Newbury",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4167,
    longitude: 144.3167,
    accuracy: 4
  },
  {
    postalCode: 3458,
    city: "Trentham",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3888,
    longitude: 144.3216,
    accuracy: 4
  },
  {
    postalCode: 3458,
    city: "Fern Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3667,
    longitude: 144.4,
    accuracy: 4
  },
  {
    postalCode: 3458,
    city: "Trentham East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3833,
    longitude: 144.3833,
    accuracy: 4
  },
  {
    postalCode: 3458,
    city: "Blackwood",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4722,
    longitude: 144.3034,
    accuracy: 4
  },
  {
    postalCode: 3458,
    city: "Lerderderg",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3823,
    longitude: 144.3389,
    accuracy: 3
  },
  {
    postalCode: 3458,
    city: "Little Hampton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4157,
    longitude: 144.3378,
    accuracy: 3
  },
  {
    postalCode: 3458,
    city: "Barrys Reef",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.454,
    longitude: 144.2964,
    accuracy: 4
  },
  {
    postalCode: 3458,
    city: "North Blackwood",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4157,
    longitude: 144.3378,
    accuracy: 3
  },
  {
    postalCode: 3460,
    city: "Daylesford",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3411,
    longitude: 144.1426,
    accuracy: 4
  },
  {
    postalCode: 3460,
    city: "Basalt",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3411,
    longitude: 144.1426,
    accuracy: 3
  },
  {
    postalCode: 3461,
    city: "Korweinguboora",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.45,
    longitude: 144.1333,
    accuracy: 4
  },
  {
    postalCode: 3461,
    city: "Strangways",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.15,
    longitude: 144.1167,
    accuracy: 4
  },
  {
    postalCode: 3461,
    city: "Hepburn Springs",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3163,
    longitude: 144.1379,
    accuracy: 4
  },
  {
    postalCode: 3461,
    city: "Porcupine Ridge",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3268,
    longitude: 144.1641,
    accuracy: 3
  },
  {
    postalCode: 3461,
    city: "Musk Vale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3833,
    longitude: 144.1333,
    accuracy: 4
  },
  {
    postalCode: 3461,
    city: "Eganstown",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3667,
    longitude: 144.0833,
    accuracy: 4
  },
  {
    postalCode: 3461,
    city: "Yandoit",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2,
    longitude: 144.1,
    accuracy: 4
  },
  {
    postalCode: 3461,
    city: "Elevated Plains",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3268,
    longitude: 144.1641,
    accuracy: 3
  },
  {
    postalCode: 3461,
    city: "Hepburn",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3167,
    longitude: 144.1333,
    accuracy: 4
  },
  {
    postalCode: 3461,
    city: "Leonards Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4333,
    longitude: 144.1167,
    accuracy: 4
  },
  {
    postalCode: 3461,
    city: "Spargo Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4833,
    longitude: 144.15,
    accuracy: 4
  },
  {
    postalCode: 3461,
    city: "Sailors Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3268,
    longitude: 144.1641,
    accuracy: 3
  },
  {
    postalCode: 3461,
    city: "Franklinford",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2333,
    longitude: 144.1,
    accuracy: 4
  },
  {
    postalCode: 3461,
    city: "Yandoit Hills",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3268,
    longitude: 144.1641,
    accuracy: 3
  },
  {
    postalCode: 3461,
    city: "Drummond",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2333,
    longitude: 144.3333,
    accuracy: 4
  },
  {
    postalCode: 3461,
    city: "Bullarto South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3268,
    longitude: 144.1641,
    accuracy: 3
  },
  {
    postalCode: 3461,
    city: "Musk",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3833,
    longitude: 144.1333,
    accuracy: 4
  },
  {
    postalCode: 3461,
    city: "Denver",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2667,
    longitude: 144.3,
    accuracy: 4
  },
  {
    postalCode: 3461,
    city: "Sailors Falls",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4,
    longitude: 144.1333,
    accuracy: 4
  },
  {
    postalCode: 3461,
    city: "Mount Franklin",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3268,
    longitude: 144.1641,
    accuracy: 3
  },
  {
    postalCode: 3461,
    city: "Lyonville",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3833,
    longitude: 144.2667,
    accuracy: 4
  },
  {
    postalCode: 3461,
    city: "Shepherds Flat",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3268,
    longitude: 144.1641,
    accuracy: 3
  },
  {
    postalCode: 3461,
    city: "Glenlyon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3,
    longitude: 144.25,
    accuracy: 4
  },
  {
    postalCode: 3461,
    city: "Dry Diggings",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3268,
    longitude: 144.1641,
    accuracy: 3
  },
  {
    postalCode: 3461,
    city: "Bullarto",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4,
    longitude: 144.2333,
    accuracy: 4
  },
  {
    postalCode: 3461,
    city: "Coomoora",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3268,
    longitude: 144.1641,
    accuracy: 3
  },
  {
    postalCode: 3461,
    city: "Wheatsheaf",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3268,
    longitude: 144.1641,
    accuracy: 3
  },
  {
    postalCode: 3461,
    city: "Clydesdale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1833,
    longitude: 144.1,
    accuracy: 4
  },
  {
    postalCode: 3462,
    city: "Newstead",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.106,
    longitude: 144.0647,
    accuracy: 4
  },
  {
    postalCode: 3462,
    city: "Muckleford South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1,
    longitude: 144.1333,
    accuracy: 4
  },
  {
    postalCode: 3462,
    city: "Sandon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0909,
    longitude: 144.0827,
    accuracy: 3
  },
  {
    postalCode: 3462,
    city: "Welshmans Reef",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0667,
    longitude: 144.05,
    accuracy: 4
  },
  {
    postalCode: 3462,
    city: "Green Gully",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0909,
    longitude: 144.0827,
    accuracy: 3
  },
  {
    postalCode: 3463,
    city: "Maldon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9957,
    longitude: 144.0683,
    accuracy: 4
  },
  {
    postalCode: 3463,
    city: "Laanecoorie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8167,
    longitude: 143.9,
    accuracy: 4
  },
  {
    postalCode: 3463,
    city: "Baringhup",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9833,
    longitude: 143.9667,
    accuracy: 4
  },
  {
    postalCode: 3463,
    city: "Bradford",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.916,
    longitude: 144.0058,
    accuracy: 3
  },
  {
    postalCode: 3463,
    city: "Walmer",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9667,
    longitude: 144.15,
    accuracy: 4
  },
  {
    postalCode: 3463,
    city: "Baringhup West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.916,
    longitude: 144.0058,
    accuracy: 3
  },
  {
    postalCode: 3463,
    city: "Eastville",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.85,
    longitude: 143.9333,
    accuracy: 4
  },
  {
    postalCode: 3463,
    city: "Tarrengower",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.916,
    longitude: 144.0058,
    accuracy: 3
  },
  {
    postalCode: 3463,
    city: "Nuggetty",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.916,
    longitude: 144.0058,
    accuracy: 3
  },
  {
    postalCode: 3463,
    city: "Woodstock West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9317,
    longitude: 144.0176,
    accuracy: 3
  },
  {
    postalCode: 3463,
    city: "Neereman",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.916,
    longitude: 144.0058,
    accuracy: 3
  },
  {
    postalCode: 3463,
    city: "Shelbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8833,
    longitude: 144.0167,
    accuracy: 4
  },
  {
    postalCode: 3464,
    city: "Carisbrook",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0481,
    longitude: 143.8167,
    accuracy: 4
  },
  {
    postalCode: 3465,
    city: "Havelock",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9667,
    longitude: 143.7833,
    accuracy: 4
  },
  {
    postalCode: 3465,
    city: "Maryborough",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0456,
    longitude: 143.7392,
    accuracy: 4
  },
  {
    postalCode: 3465,
    city: "Timor West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9667,
    longitude: 143.7,
    accuracy: 4
  },
  {
    postalCode: 3465,
    city: "Wareek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9833,
    longitude: 143.6167,
    accuracy: 4
  },
  {
    postalCode: 3465,
    city: "Cotswold",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1333,
    longitude: 143.9,
    accuracy: 4
  },
  {
    postalCode: 3465,
    city: "Homebush",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.05,
    longitude: 143.5333,
    accuracy: 4
  },
  {
    postalCode: 3465,
    city: "Moonlight Flat",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0633,
    longitude: 143.6975,
    accuracy: 3
  },
  {
    postalCode: 3465,
    city: "Bung Bong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0667,
    longitude: 143.6167,
    accuracy: 4
  },
  {
    postalCode: 3465,
    city: "Moolort",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0833,
    longitude: 143.9333,
    accuracy: 4
  },
  {
    postalCode: 3465,
    city: "Bowenvale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37,
    longitude: 143.7167,
    accuracy: 4
  },
  {
    postalCode: 3465,
    city: "Rathscar",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9667,
    longitude: 143.5667,
    accuracy: 4
  },
  {
    postalCode: 3465,
    city: "Daisy Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1167,
    longitude: 143.7167,
    accuracy: 4
  },
  {
    postalCode: 3465,
    city: "Natte Yallock",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.95,
    longitude: 143.5,
    accuracy: 4
  },
  {
    postalCode: 3465,
    city: "Timor",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9859,
    longitude: 143.7139,
    accuracy: 4
  },
  {
    postalCode: 3465,
    city: "Simson",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0301,
    longitude: 143.7073,
    accuracy: 3
  },
  {
    postalCode: 3465,
    city: "Alma",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0333,
    longitude: 143.6833,
    accuracy: 4
  },
  {
    postalCode: 3465,
    city: "Majorca",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1167,
    longitude: 143.8,
    accuracy: 4
  },
  {
    postalCode: 3465,
    city: "Adelaide Lead",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0667,
    longitude: 143.6833,
    accuracy: 4
  },
  {
    postalCode: 3465,
    city: "Flagstaff",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0633,
    longitude: 143.6975,
    accuracy: 3
  },
  {
    postalCode: 3465,
    city: "Rathscar West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0333,
    longitude: 143.4833,
    accuracy: 4
  },
  {
    postalCode: 3465,
    city: "Craigie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0301,
    longitude: 143.7073,
    accuracy: 3
  },
  {
    postalCode: 3465,
    city: "Golden Point",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5749,
    longitude: 143.8687,
    accuracy: 4
  },
  {
    postalCode: 3467,
    city: "Avoca",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0904,
    longitude: 143.4736,
    accuracy: 4
  },
  {
    postalCode: 3468,
    city: "Mount Lonarch",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.25,
    longitude: 143.4,
    accuracy: 4
  },
  {
    postalCode: 3468,
    city: "Amphitheatre",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1667,
    longitude: 143.4167,
    accuracy: 4
  },
  {
    postalCode: 3469,
    city: "Nowhere Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1389,
    longitude: 143.2611,
    accuracy: 3
  },
  {
    postalCode: 3469,
    city: "Elmhurst",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1667,
    longitude: 143.25,
    accuracy: 4
  },
  {
    postalCode: 3469,
    city: "Glenlogie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1389,
    longitude: 143.2611,
    accuracy: 3
  },
  {
    postalCode: 3469,
    city: "Glenpatrick",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1333,
    longitude: 143.3167,
    accuracy: 4
  },
  {
    postalCode: 3469,
    city: "Glenlofty",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1167,
    longitude: 143.2167,
    accuracy: 4
  },
  {
    postalCode: 3472,
    city: "Bet Bet",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9167,
    longitude: 143.75,
    accuracy: 4
  },
  {
    postalCode: 3472,
    city: "Eddington",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8833,
    longitude: 143.85,
    accuracy: 4
  },
  {
    postalCode: 3472,
    city: "Bromley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8833,
    longitude: 143.7667,
    accuracy: 4
  },
  {
    postalCode: 3472,
    city: "Betley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9,
    longitude: 143.8,
    accuracy: 4
  },
  {
    postalCode: 3472,
    city: "Moliagul",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.75,
    longitude: 143.6667,
    accuracy: 4
  },
  {
    postalCode: 3472,
    city: "Goldsborough",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8167,
    longitude: 143.6833,
    accuracy: 4
  },
  {
    postalCode: 3472,
    city: "Dunluce",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9,
    longitude: 143.6,
    accuracy: 4
  },
  {
    postalCode: 3472,
    city: "Inkerman",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9148,
    longitude: 143.6487,
    accuracy: 3
  },
  {
    postalCode: 3472,
    city: "Dunolly",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8601,
    longitude: 143.7336,
    accuracy: 4
  },
  {
    postalCode: 3472,
    city: "Mount Hooghly",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9,
    longitude: 143.6667,
    accuracy: 4
  },
  {
    postalCode: 3472,
    city: "Mcintyre",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8678,
    longitude: 143.7241,
    accuracy: 3
  },
  {
    postalCode: 3475,
    city: "Emu",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7333,
    longitude: 143.4667,
    accuracy: 4
  },
  {
    postalCode: 3475,
    city: "Logan",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6167,
    longitude: 143.4667,
    accuracy: 4
  },
  {
    postalCode: 3475,
    city: "Cochranes Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7267,
    longitude: 143.51,
    accuracy: 3
  },
  {
    postalCode: 3475,
    city: "Archdale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8333,
    longitude: 143.5167,
    accuracy: 4
  },
  {
    postalCode: 3475,
    city: "Archdale Junction",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7267,
    longitude: 143.51,
    accuracy: 3
  },
  {
    postalCode: 3475,
    city: "Burkes Flat",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.65,
    longitude: 143.55,
    accuracy: 4
  },
  {
    postalCode: 3475,
    city: "Bealiba",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8,
    longitude: 143.55,
    accuracy: 4
  },
  {
    postalCode: 3477,
    city: "Traynors Lagoon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5833,
    longitude: 143,
    accuracy: 4
  },
  {
    postalCode: 3477,
    city: "Grays Bridge",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6653,
    longitude: 143.2081,
    accuracy: 3
  },
  {
    postalCode: 3477,
    city: "Redbank",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9333,
    longitude: 143.3167,
    accuracy: 4
  },
  {
    postalCode: 3477,
    city: "Rostron",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7667,
    longitude: 143.1833,
    accuracy: 4
  },
  {
    postalCode: 3477,
    city: "Gowar East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.55,
    longitude: 143.4167,
    accuracy: 4
  },
  {
    postalCode: 3477,
    city: "Coonooer West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6653,
    longitude: 143.2081,
    accuracy: 3
  },
  {
    postalCode: 3477,
    city: "Paradise",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8333,
    longitude: 143.1333,
    accuracy: 4
  },
  {
    postalCode: 3477,
    city: "Stuart Mill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8053,
    longitude: 143.2862,
    accuracy: 4
  },
  {
    postalCode: 3477,
    city: "Gre Gre North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5833,
    longitude: 143.0667,
    accuracy: 4
  },
  {
    postalCode: 3477,
    city: "Gre Gre South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6653,
    longitude: 143.2081,
    accuracy: 3
  },
  {
    postalCode: 3477,
    city: "Avon Plains",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.55,
    longitude: 142.9333,
    accuracy: 4
  },
  {
    postalCode: 3477,
    city: "Moyreisk",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9167,
    longitude: 143.3833,
    accuracy: 4
  },
  {
    postalCode: 3477,
    city: "St Arnaud North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6653,
    longitude: 143.2081,
    accuracy: 3
  },
  {
    postalCode: 3477,
    city: "Marnoo East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6653,
    longitude: 143.2081,
    accuracy: 3
  },
  {
    postalCode: 3477,
    city: "Carapooee West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6653,
    longitude: 143.2081,
    accuracy: 3
  },
  {
    postalCode: 3477,
    city: "Beazleys Bridge",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7,
    longitude: 143.1667,
    accuracy: 4
  },
  {
    postalCode: 3477,
    city: "Gre Gre",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6667,
    longitude: 143.0667,
    accuracy: 4
  },
  {
    postalCode: 3477,
    city: "York Plains",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6653,
    longitude: 143.2081,
    accuracy: 3
  },
  {
    postalCode: 3477,
    city: "Carapooee",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7,
    longitude: 143.3333,
    accuracy: 4
  },
  {
    postalCode: 3477,
    city: "Gooroc",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4667,
    longitude: 143.2,
    accuracy: 4
  },
  {
    postalCode: 3477,
    city: "Winjallok",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8167,
    longitude: 143.2,
    accuracy: 4
  },
  {
    postalCode: 3477,
    city: "St Arnaud East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6653,
    longitude: 143.2081,
    accuracy: 3
  },
  {
    postalCode: 3477,
    city: "Coonooer Bridge",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4667,
    longitude: 143.3167,
    accuracy: 4
  },
  {
    postalCode: 3477,
    city: "Moolerr",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6333,
    longitude: 143.2167,
    accuracy: 4
  },
  {
    postalCode: 3477,
    city: "Swanwater",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4833,
    longitude: 143.1333,
    accuracy: 4
  },
  {
    postalCode: 3477,
    city: "Dalyenong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6653,
    longitude: 143.2081,
    accuracy: 3
  },
  {
    postalCode: 3477,
    city: "Sutherland",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.55,
    longitude: 143.2,
    accuracy: 4
  },
  {
    postalCode: 3477,
    city: "Tottington",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7833,
    longitude: 143.1167,
    accuracy: 4
  },
  {
    postalCode: 3477,
    city: "Slaty Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.55,
    longitude: 143.3,
    accuracy: 4
  },
  {
    postalCode: 3477,
    city: "Kooreh",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6333,
    longitude: 143.4,
    accuracy: 4
  },
  {
    postalCode: 3478,
    city: "Redbank",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9333,
    longitude: 143.3167,
    accuracy: 4
  },
  {
    postalCode: 3478,
    city: "Percydale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.05,
    longitude: 143.4,
    accuracy: 4
  },
  {
    postalCode: 3478,
    city: "Stuart Mill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8053,
    longitude: 143.2862,
    accuracy: 4
  },
  {
    postalCode: 3478,
    city: "Warrenmang",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0333,
    longitude: 143.3,
    accuracy: 4
  },
  {
    postalCode: 3478,
    city: "Medlyn",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.827,
    longitude: 143.2969,
    accuracy: 3
  },
  {
    postalCode: 3478,
    city: "Moonambel",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9833,
    longitude: 143.3167,
    accuracy: 4
  },
  {
    postalCode: 3478,
    city: "St Arnaud",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6168,
    longitude: 143.2587,
    accuracy: 4
  },
  {
    postalCode: 3478,
    city: "Yawong Hills",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.827,
    longitude: 143.2969,
    accuracy: 3
  },
  {
    postalCode: 3478,
    city: "Tanwood",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.827,
    longitude: 143.2969,
    accuracy: 3
  },
  {
    postalCode: 3478,
    city: "Dooboobetic",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3667,
    longitude: 143.2,
    accuracy: 4
  },
  {
    postalCode: 3480,
    city: "Carron",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3,
    longitude: 142.7167,
    accuracy: 4
  },
  {
    postalCode: 3480,
    city: "Lawler",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3668,
    longitude: 142.9058,
    accuracy: 3
  },
  {
    postalCode: 3480,
    city: "Areegra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2833,
    longitude: 142.6333,
    accuracy: 4
  },
  {
    postalCode: 3480,
    city: "Corack East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1167,
    longitude: 143.05,
    accuracy: 4
  },
  {
    postalCode: 3480,
    city: "Donald",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3686,
    longitude: 142.9811,
    accuracy: 4
  },
  {
    postalCode: 3480,
    city: "Jeffcott North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3668,
    longitude: 142.9058,
    accuracy: 3
  },
  {
    postalCode: 3480,
    city: "Laen North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4,
    longitude: 142.8167,
    accuracy: 4
  },
  {
    postalCode: 3480,
    city: "Cope Cope",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.45,
    longitude: 143.05,
    accuracy: 4
  },
  {
    postalCode: 3480,
    city: "Corack",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1667,
    longitude: 143.05,
    accuracy: 4
  },
  {
    postalCode: 3480,
    city: "Jeffcott",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.35,
    longitude: 143.1333,
    accuracy: 4
  },
  {
    postalCode: 3480,
    city: "Laen East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3833,
    longitude: 142.8833,
    accuracy: 4
  },
  {
    postalCode: 3480,
    city: "Litchfield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3,
    longitude: 142.8667,
    accuracy: 4
  },
  {
    postalCode: 3480,
    city: "Swanwater West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5333,
    longitude: 143.0167,
    accuracy: 4
  },
  {
    postalCode: 3480,
    city: "Laen",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.45,
    longitude: 142.8167,
    accuracy: 4
  },
  {
    postalCode: 3480,
    city: "Rich Avon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5167,
    longitude: 142.8333,
    accuracy: 4
  },
  {
    postalCode: 3480,
    city: "Rich Avon East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3668,
    longitude: 142.9058,
    accuracy: 3
  },
  {
    postalCode: 3480,
    city: "Rich Avon West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5167,
    longitude: 142.8333,
    accuracy: 4
  },
  {
    postalCode: 3480,
    city: "Gil Gil",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3668,
    longitude: 142.9058,
    accuracy: 3
  },
  {
    postalCode: 3482,
    city: "Warmur",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1167,
    longitude: 142.7833,
    accuracy: 4
  },
  {
    postalCode: 3482,
    city: "Massey",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2167,
    longitude: 142.8667,
    accuracy: 4
  },
  {
    postalCode: 3482,
    city: "Watchem",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.15,
    longitude: 142.85,
    accuracy: 4
  },
  {
    postalCode: 3482,
    city: "Morton Plains",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0833,
    longitude: 142.9,
    accuracy: 4
  },
  {
    postalCode: 3482,
    city: "Watchem West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1417,
    longitude: 142.85,
    accuracy: 3
  },
  {
    postalCode: 3483,
    city: "Narraport",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36,
    longitude: 143.0333,
    accuracy: 4
  },
  {
    postalCode: 3483,
    city: "Birchip",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.9838,
    longitude: 142.9173,
    accuracy: 4
  },
  {
    postalCode: 3483,
    city: "Kinnabulla",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.8833,
    longitude: 142.8,
    accuracy: 4
  },
  {
    postalCode: 3483,
    city: "Karyrie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.9,
    longitude: 142.85,
    accuracy: 4
  },
  {
    postalCode: 3483,
    city: "Birchip West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.9063,
    longitude: 142.8876,
    accuracy: 3
  },
  {
    postalCode: 3483,
    city: "Whirily",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.8667,
    longitude: 142.9667,
    accuracy: 4
  },
  {
    postalCode: 3483,
    city: "Ballapur",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.9667,
    longitude: 142.7667,
    accuracy: 4
  },
  {
    postalCode: 3483,
    city: "Curyo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.8333,
    longitude: 142.8,
    accuracy: 4
  },
  {
    postalCode: 3483,
    city: "Marlbed",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.9063,
    longitude: 142.8876,
    accuracy: 3
  },
  {
    postalCode: 3483,
    city: "Jil Jil",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.8167,
    longitude: 142.9667,
    accuracy: 4
  },
  {
    postalCode: 3485,
    city: "Woomelang",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.6811,
    longitude: 142.6617,
    accuracy: 4
  },
  {
    postalCode: 3485,
    city: "Willangie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.65,
    longitude: 142.85,
    accuracy: 4
  },
  {
    postalCode: 3485,
    city: "Banyan",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.6333,
    longitude: 142.75,
    accuracy: 4
  },
  {
    postalCode: 3485,
    city: "Watchupga",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.75,
    longitude: 142.7167,
    accuracy: 4
  },
  {
    postalCode: 3487,
    city: "Lascelles",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.6167,
    longitude: 142.5833,
    accuracy: 4
  },
  {
    postalCode: 3488,
    city: "Turriff East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.4,
    longitude: 142.5333,
    accuracy: 4
  },
  {
    postalCode: 3488,
    city: "Speed",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.4,
    longitude: 142.4333,
    accuracy: 4
  },
  {
    postalCode: 3488,
    city: "Turriff",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.45,
    longitude: 142.45,
    accuracy: 4
  },
  {
    postalCode: 3489,
    city: "Tempy",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.3333,
    longitude: 142.4167,
    accuracy: 4
  },
  {
    postalCode: 3490,
    city: "Mittyack",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.15,
    longitude: 142.65,
    accuracy: 4
  },
  {
    postalCode: 3490,
    city: "Murray-Sunset",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.751,
    longitude: 141.5034,
    accuracy: 4
  },
  {
    postalCode: 3490,
    city: "Torrita",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.15,
    longitude: 141.9333,
    accuracy: 4
  },
  {
    postalCode: 3490,
    city: "Kulwin",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.0333,
    longitude: 142.6167,
    accuracy: 4
  },
  {
    postalCode: 3490,
    city: "Boinka",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.2,
    longitude: 141.6,
    accuracy: 4
  },
  {
    postalCode: 3490,
    city: "Big Desert",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.0817,
    longitude: 142.0153,
    accuracy: 3
  },
  {
    postalCode: 3490,
    city: "Ouyen",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.0709,
    longitude: 142.3203,
    accuracy: 4
  },
  {
    postalCode: 3490,
    city: "Tutye",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.2167,
    longitude: 141.4833,
    accuracy: 4
  },
  {
    postalCode: 3491,
    city: "Patchewollock",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.3833,
    longitude: 142.2,
    accuracy: 4
  },
  {
    postalCode: 3494,
    city: "Nangiloc",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.5,
    longitude: 142.2916,
    accuracy: 3
  },
  {
    postalCode: 3494,
    city: "Iraak",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.4304,
    longitude: 142.354,
    accuracy: 4
  },
  {
    postalCode: 3494,
    city: "Carwarp",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.4602,
    longitude: 142.199,
    accuracy: 4
  },
  {
    postalCode: 3494,
    city: "Colignan",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.5248,
    longitude: 142.3656,
    accuracy: 4
  },
  {
    postalCode: 3496,
    city: "Sunnycliffs",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.5668,
    longitude: 141.5741,
    accuracy: 3
  },
  {
    postalCode: 3496,
    city: "Cullulleraine",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.278,
    longitude: 141.5994,
    accuracy: 4
  },
  {
    postalCode: 3496,
    city: "Werrimull",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.3887,
    longitude: 141.5993,
    accuracy: 4
  },
  {
    postalCode: 3496,
    city: "Red Cliffs",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.3094,
    longitude: 142.1897,
    accuracy: 4
  },
  {
    postalCode: 3496,
    city: "Merrinee",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.3188,
    longitude: 141.7502,
    accuracy: 3
  },
  {
    postalCode: 3496,
    city: "Cardross",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.3071,
    longitude: 142.1253,
    accuracy: 4
  },
  {
    postalCode: 3496,
    city: "Meringur",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.3886,
    longitude: 141.3343,
    accuracy: 4
  },
  {
    postalCode: 3496,
    city: "Neds Corner",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.1425,
    longitude: 141.3304,
    accuracy: 4
  },
  {
    postalCode: 3496,
    city: "Lindsay Point",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.3188,
    longitude: 141.7502,
    accuracy: 3
  },
  {
    postalCode: 3498,
    city: "Irymple",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.2354,
    longitude: 142.171,
    accuracy: 4
  },
  {
    postalCode: 3500,
    city: "Mildura West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.1631,
    longitude: 142.0026,
    accuracy: 4
  },
  {
    postalCode: 3500,
    city: "Mildura",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.1855,
    longitude: 142.1625,
    accuracy: 4
  },
  {
    postalCode: 3501,
    city: "Mildura Centre Plaza",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.6355,
    longitude: 142.3253,
    accuracy: 3
  },
  {
    postalCode: 3501,
    city: "Nichols Point",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.2121,
    longitude: 142.2144,
    accuracy: 4
  },
  {
    postalCode: 3501,
    city: "Hattah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.7625,
    longitude: 142.2815,
    accuracy: 4
  },
  {
    postalCode: 3501,
    city: "Koorlong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.2776,
    longitude: 142.0874,
    accuracy: 4
  },
  {
    postalCode: 3501,
    city: "Mildura South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.4207,
    longitude: 142.1937,
    accuracy: 3
  },
  {
    postalCode: 3502,
    city: "Mildura",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.1855,
    longitude: 142.1625,
    accuracy: 4
  },
  {
    postalCode: 3505,
    city: "Wargan",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.1853,
    longitude: 142.0476,
    accuracy: 3
  },
  {
    postalCode: 3505,
    city: "Birdwoodton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.2012,
    longitude: 142.0697,
    accuracy: 4
  },
  {
    postalCode: 3505,
    city: "Merbein",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.168,
    longitude: 142.066,
    accuracy: 4
  },
  {
    postalCode: 3505,
    city: "Cabarita",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.1975,
    longitude: 142.0845,
    accuracy: 4
  },
  {
    postalCode: 3505,
    city: "Merbein West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.1631,
    longitude: 142.0026,
    accuracy: 4
  },
  {
    postalCode: 3505,
    city: "Yelta",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.1284,
    longitude: 142.0152,
    accuracy: 4
  },
  {
    postalCode: 3505,
    city: "Merbein South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.2333,
    longitude: 142.0333,
    accuracy: 4
  },
  {
    postalCode: 3506,
    city: "Cowangie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.2333,
    longitude: 141.3667,
    accuracy: 4
  },
  {
    postalCode: 3507,
    city: "Walpeup",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.1333,
    longitude: 142.0333,
    accuracy: 4
  },
  {
    postalCode: 3509,
    city: "Linga",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.1667,
    longitude: 141.7,
    accuracy: 4
  },
  {
    postalCode: 3509,
    city: "Underbool",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.1695,
    longitude: 141.8056,
    accuracy: 4
  },
  {
    postalCode: 3512,
    city: "Carina",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.25,
    longitude: 141.1,
    accuracy: 4
  },
  {
    postalCode: 3512,
    city: "Murrayville",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.2625,
    longitude: 141.1835,
    accuracy: 4
  },
  {
    postalCode: 3512,
    city: "Panitya",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.2333,
    longitude: 141,
    accuracy: 4
  },
  {
    postalCode: 3515,
    city: "Shelbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8833,
    longitude: 144.0167,
    accuracy: 4
  },
  {
    postalCode: 3515,
    city: "Wilsons Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8083,
    longitude: 144.075,
    accuracy: 3
  },
  {
    postalCode: 3515,
    city: "Marong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7333,
    longitude: 144.1333,
    accuracy: 4
  },
  {
    postalCode: 3516,
    city: "Bridgewater On Loddon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6027,
    longitude: 143.9423,
    accuracy: 4
  },
  {
    postalCode: 3516,
    city: "Derby",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.65,
    longitude: 144.0167,
    accuracy: 4
  },
  {
    postalCode: 3516,
    city: "Yarraberb",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6167,
    longitude: 144.0667,
    accuracy: 4
  },
  {
    postalCode: 3516,
    city: "Leichardt",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6833,
    longitude: 144.0667,
    accuracy: 4
  },
  {
    postalCode: 3516,
    city: "Bridgewater",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6027,
    longitude: 143.9423,
    accuracy: 4
  },
  {
    postalCode: 3516,
    city: "Bridgewater North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6311,
    longitude: 144.0069,
    accuracy: 3
  },
  {
    postalCode: 3517,
    city: "Glenalbyn",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5167,
    longitude: 143.7333,
    accuracy: 4
  },
  {
    postalCode: 3517,
    city: "Jarklin",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2667,
    longitude: 143.9667,
    accuracy: 4
  },
  {
    postalCode: 3517,
    city: "Serpentine",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4333,
    longitude: 143.9833,
    accuracy: 4
  },
  {
    postalCode: 3517,
    city: "Kurting",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5333,
    longitude: 143.85,
    accuracy: 4
  },
  {
    postalCode: 3517,
    city: "Powlett Plains",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.45,
    longitude: 143.8667,
    accuracy: 4
  },
  {
    postalCode: 3517,
    city: "Salisbury West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5167,
    longitude: 143.9667,
    accuracy: 4
  },
  {
    postalCode: 3517,
    city: "Inglewood",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.575,
    longitude: 143.8683,
    accuracy: 4
  },
  {
    postalCode: 3517,
    city: "Bears Lagoon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.328,
    longitude: 143.9755,
    accuracy: 4
  },
  {
    postalCode: 3517,
    city: "Rheola",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.65,
    longitude: 143.7,
    accuracy: 4
  },
  {
    postalCode: 3517,
    city: "Brenanah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4886,
    longitude: 143.866,
    accuracy: 3
  },
  {
    postalCode: 3517,
    city: "Kingower",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6167,
    longitude: 143.75,
    accuracy: 4
  },
  {
    postalCode: 3518,
    city: "Richmond Plains",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3833,
    longitude: 143.45,
    accuracy: 4
  },
  {
    postalCode: 3518,
    city: "Skinners Flat",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4161,
    longitude: 143.6325,
    accuracy: 3
  },
  {
    postalCode: 3518,
    city: "Borung",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3,
    longitude: 143.75,
    accuracy: 4
  },
  {
    postalCode: 3518,
    city: "Kurraca West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5,
    longitude: 143.5667,
    accuracy: 4
  },
  {
    postalCode: 3518,
    city: "Fernihurst",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.25,
    longitude: 143.8667,
    accuracy: 4
  },
  {
    postalCode: 3518,
    city: "Woolshed Flat",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4161,
    longitude: 143.6325,
    accuracy: 3
  },
  {
    postalCode: 3518,
    city: "Berrimal",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4833,
    longitude: 143.4833,
    accuracy: 4
  },
  {
    postalCode: 3518,
    city: "Wedderburn Junction",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4167,
    longitude: 143.7,
    accuracy: 4
  },
  {
    postalCode: 3518,
    city: "Mysia",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.25,
    longitude: 143.7667,
    accuracy: 4
  },
  {
    postalCode: 3518,
    city: "Wehla",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7833,
    longitude: 143.6,
    accuracy: 4
  },
  {
    postalCode: 3518,
    city: "Nine Mile",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4333,
    longitude: 143.4833,
    accuracy: 4
  },
  {
    postalCode: 3518,
    city: "Fentons Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5667,
    longitude: 143.5333,
    accuracy: 4
  },
  {
    postalCode: 3518,
    city: "Woosang",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3333,
    longitude: 143.4833,
    accuracy: 4
  },
  {
    postalCode: 3518,
    city: "Kurraca",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5,
    longitude: 143.5667,
    accuracy: 4
  },
  {
    postalCode: 3518,
    city: "Fiery Flat",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4,
    longitude: 143.8,
    accuracy: 4
  },
  {
    postalCode: 3518,
    city: "Wedderburn",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.419,
    longitude: 143.6139,
    accuracy: 4
  },
  {
    postalCode: 3520,
    city: "Korong Vale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3561,
    longitude: 143.7034,
    accuracy: 4
  },
  {
    postalCode: 3520,
    city: "Kinypanial",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.35,
    longitude: 143.8,
    accuracy: 4
  },
  {
    postalCode: 3521,
    city: "Pyalong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1129,
    longitude: 144.8523,
    accuracy: 4
  },
  {
    postalCode: 3522,
    city: "Tooborac",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.05,
    longitude: 144.8333,
    accuracy: 4
  },
  {
    postalCode: 3522,
    city: "Glenhope East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.05,
    longitude: 144.8333,
    accuracy: 3
  },
  {
    postalCode: 3523,
    city: "Costerfield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8667,
    longitude: 144.8,
    accuracy: 4
  },
  {
    postalCode: 3523,
    city: "Derrinal",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8833,
    longitude: 144.6333,
    accuracy: 4
  },
  {
    postalCode: 3523,
    city: "Argyle",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.95,
    longitude: 144.7333,
    accuracy: 4
  },
  {
    postalCode: 3523,
    city: "Moormbool West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8,
    longitude: 144.9,
    accuracy: 4
  },
  {
    postalCode: 3523,
    city: "Redcastle",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7833,
    longitude: 144.7833,
    accuracy: 4
  },
  {
    postalCode: 3523,
    city: "Heathcote",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9221,
    longitude: 144.7084,
    accuracy: 4
  },
  {
    postalCode: 3523,
    city: "Ladys Pass",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8627,
    longitude: 144.7345,
    accuracy: 3
  },
  {
    postalCode: 3523,
    city: "Knowsley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8333,
    longitude: 144.5833,
    accuracy: 4
  },
  {
    postalCode: 3523,
    city: "Heathcote South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8627,
    longitude: 144.7345,
    accuracy: 3
  },
  {
    postalCode: 3523,
    city: "Mount Camel",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8627,
    longitude: 144.7345,
    accuracy: 3
  },
  {
    postalCode: 3525,
    city: "Wychitella North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2726,
    longitude: 143.4353,
    accuracy: 3
  },
  {
    postalCode: 3525,
    city: "Charlton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2644,
    longitude: 143.349,
    accuracy: 4
  },
  {
    postalCode: 3525,
    city: "Buckrabanyule",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.25,
    longitude: 143.5167,
    accuracy: 4
  },
  {
    postalCode: 3525,
    city: "Granite Flat",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2726,
    longitude: 143.4353,
    accuracy: 3
  },
  {
    postalCode: 3525,
    city: "Wooroonook",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.25,
    longitude: 143.2,
    accuracy: 4
  },
  {
    postalCode: 3525,
    city: "Yeungroon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3833,
    longitude: 143.4,
    accuracy: 4
  },
  {
    postalCode: 3525,
    city: "Barrakee",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2667,
    longitude: 143.45,
    accuracy: 4
  },
  {
    postalCode: 3525,
    city: "Terrappee",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2726,
    longitude: 143.4353,
    accuracy: 3
  },
  {
    postalCode: 3525,
    city: "Wychitella",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2833,
    longitude: 143.6167,
    accuracy: 4
  },
  {
    postalCode: 3525,
    city: "Yeungroon East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.35,
    longitude: 143.4333,
    accuracy: 4
  },
  {
    postalCode: 3525,
    city: "Chirrip",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2726,
    longitude: 143.4353,
    accuracy: 3
  },
  {
    postalCode: 3525,
    city: "Lake Marmal",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.132,
    longitude: 143.516,
    accuracy: 4
  },
  {
    postalCode: 3525,
    city: "Nareewillock",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2726,
    longitude: 143.4353,
    accuracy: 3
  },
  {
    postalCode: 3527,
    city: "Jeruk",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.05,
    longitude: 143.3833,
    accuracy: 4
  },
  {
    postalCode: 3527,
    city: "Bunguluke",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0561,
    longitude: 143.3904,
    accuracy: 4
  },
  {
    postalCode: 3527,
    city: "Thalia",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0667,
    longitude: 143.0833,
    accuracy: 4
  },
  {
    postalCode: 3527,
    city: "Ninyeunook",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.9871,
    longitude: 143.4019,
    accuracy: 4
  },
  {
    postalCode: 3527,
    city: "Towaninny South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.9229,
    longitude: 143.3527,
    accuracy: 4
  },
  {
    postalCode: 3527,
    city: "Glenloth",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1451,
    longitude: 143.3388,
    accuracy: 4
  },
  {
    postalCode: 3527,
    city: "Towaninny",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.9229,
    longitude: 143.3527,
    accuracy: 4
  },
  {
    postalCode: 3527,
    city: "Wycheproof South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0563,
    longitude: 143.2848,
    accuracy: 3
  },
  {
    postalCode: 3527,
    city: "Dumosa",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.936,
    longitude: 143.2245,
    accuracy: 4
  },
  {
    postalCode: 3527,
    city: "Teddywaddy West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0563,
    longitude: 143.2848,
    accuracy: 3
  },
  {
    postalCode: 3527,
    city: "Wycheproof",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0776,
    longitude: 143.2271,
    accuracy: 4
  },
  {
    postalCode: 3527,
    city: "Glenloth East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0563,
    longitude: 143.2848,
    accuracy: 3
  },
  {
    postalCode: 3527,
    city: "Teddywaddy",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1937,
    longitude: 143.3374,
    accuracy: 4
  },
  {
    postalCode: 3529,
    city: "Nullawil",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.85,
    longitude: 143.1833,
    accuracy: 4
  },
  {
    postalCode: 3529,
    city: "Kalpienung",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.7826,
    longitude: 143.2558,
    accuracy: 4
  },
  {
    postalCode: 3530,
    city: "Warne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.7808,
    longitude: 143.1242,
    accuracy: 4
  },
  {
    postalCode: 3530,
    city: "Wangie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.725,
    longitude: 143.0417,
    accuracy: 3
  },
  {
    postalCode: 3530,
    city: "Sutton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.7333,
    longitude: 143,
    accuracy: 4
  },
  {
    postalCode: 3530,
    city: "Culgoa",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.7167,
    longitude: 143.0833,
    accuracy: 4
  },
  {
    postalCode: 3531,
    city: "Boigbeat",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.55,
    longitude: 142.9167,
    accuracy: 4
  },
  {
    postalCode: 3531,
    city: "Berriwillock",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.6333,
    longitude: 143,
    accuracy: 4
  },
  {
    postalCode: 3533,
    city: "Sea Lake",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.5039,
    longitude: 142.8498,
    accuracy: 4
  },
  {
    postalCode: 3533,
    city: "Lake Tyrrell",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.4244,
    longitude: 142.9857,
    accuracy: 3
  },
  {
    postalCode: 3533,
    city: "Ninda",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.4667,
    longitude: 142.75,
    accuracy: 4
  },
  {
    postalCode: 3533,
    city: "Nyarrin",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.3833,
    longitude: 142.6833,
    accuracy: 4
  },
  {
    postalCode: 3533,
    city: "Pier Milan",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.4244,
    longitude: 142.9857,
    accuracy: 3
  },
  {
    postalCode: 3533,
    city: "Straten",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.4244,
    longitude: 142.9857,
    accuracy: 3
  },
  {
    postalCode: 3533,
    city: "Nandaly",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.3,
    longitude: 142.7,
    accuracy: 4
  },
  {
    postalCode: 3533,
    city: "Tyenna",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.4244,
    longitude: 142.9857,
    accuracy: 3
  },
  {
    postalCode: 3533,
    city: "Tyrrell",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.3667,
    longitude: 142.9667,
    accuracy: 4
  },
  {
    postalCode: 3533,
    city: "Bimbourie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.4244,
    longitude: 142.9857,
    accuracy: 3
  },
  {
    postalCode: 3533,
    city: "Tyrrell Downs",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.3667,
    longitude: 142.9667,
    accuracy: 4
  },
  {
    postalCode: 3533,
    city: "Myall",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.581,
    longitude: 144.0013,
    accuracy: 4
  },
  {
    postalCode: 3537,
    city: "Canary Island",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.9917,
    longitude: 143.843,
    accuracy: 4
  },
  {
    postalCode: 3537,
    city: "Barraport West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0308,
    longitude: 143.7505,
    accuracy: 3
  },
  {
    postalCode: 3537,
    city: "Gredgwin",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.9694,
    longitude: 143.6191,
    accuracy: 4
  },
  {
    postalCode: 3537,
    city: "Leaghur",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.9637,
    longitude: 143.7847,
    accuracy: 4
  },
  {
    postalCode: 3537,
    city: "Minmindie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0402,
    longitude: 143.7511,
    accuracy: 4
  },
  {
    postalCode: 3537,
    city: "Catumnal",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0308,
    longitude: 143.7505,
    accuracy: 3
  },
  {
    postalCode: 3537,
    city: "Barraport",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0078,
    longitude: 143.6709,
    accuracy: 4
  },
  {
    postalCode: 3537,
    city: "Yando",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0789,
    longitude: 143.8058,
    accuracy: 4
  },
  {
    postalCode: 3537,
    city: "Boort",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1157,
    longitude: 143.7199,
    accuracy: 4
  },
  {
    postalCode: 3540,
    city: "Oakvale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.9109,
    longitude: 143.5635,
    accuracy: 4
  },
  {
    postalCode: 3540,
    city: "Quambatook",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.8524,
    longitude: 143.5207,
    accuracy: 4
  },
  {
    postalCode: 3540,
    city: "Cannie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.754,
    longitude: 143.4485,
    accuracy: 4
  },
  {
    postalCode: 3542,
    city: "Lalbert",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.6672,
    longitude: 143.3779,
    accuracy: 4
  },
  {
    postalCode: 3542,
    city: "Tittybong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.7466,
    longitude: 143.372,
    accuracy: 4
  },
  {
    postalCode: 3542,
    city: "Cokum",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.725,
    longitude: 143.3667,
    accuracy: 3
  },
  {
    postalCode: 3544,
    city: "Gowanford",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.4187,
    longitude: 143.1916,
    accuracy: 4
  },
  {
    postalCode: 3544,
    city: "Ultima East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.4222,
    longitude: 143.1778,
    accuracy: 3
  },
  {
    postalCode: 3544,
    city: "Waitchie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.3667,
    longitude: 143.0833,
    accuracy: 4
  },
  {
    postalCode: 3544,
    city: "Chinangin",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.4222,
    longitude: 143.1778,
    accuracy: 3
  },
  {
    postalCode: 3544,
    city: "Springfield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3333,
    longitude: 144.8167,
    accuracy: 4
  },
  {
    postalCode: 3544,
    city: "Murnungin",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.4222,
    longitude: 143.1778,
    accuracy: 3
  },
  {
    postalCode: 3544,
    city: "Ultima",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.468,
    longitude: 143.2709,
    accuracy: 4
  },
  {
    postalCode: 3546,
    city: "Chinkapook",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.1891,
    longitude: 142.9431,
    accuracy: 4
  },
  {
    postalCode: 3546,
    city: "Gerahmin",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.0977,
    longitude: 142.9331,
    accuracy: 3
  },
  {
    postalCode: 3546,
    city: "Turoar",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.1667,
    longitude: 143.05,
    accuracy: 4
  },
  {
    postalCode: 3546,
    city: "Manangatang",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.0551,
    longitude: 142.8823,
    accuracy: 4
  },
  {
    postalCode: 3546,
    city: "Cocamba",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.116,
    longitude: 142.8978,
    accuracy: 4
  },
  {
    postalCode: 3546,
    city: "Bolton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.9666,
    longitude: 142.8815,
    accuracy: 4
  },
  {
    postalCode: 3546,
    city: "Winnambool",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.0977,
    longitude: 142.9331,
    accuracy: 3
  },
  {
    postalCode: 3549,
    city: "Robinvale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.5836,
    longitude: 142.7723,
    accuracy: 4
  },
  {
    postalCode: 3549,
    city: "Robinvale Irrigation District Section B",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.7137,
    longitude: 142.753,
    accuracy: 3
  },
  {
    postalCode: 3549,
    city: "Annuello",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.85,
    longitude: 142.8333,
    accuracy: 4
  },
  {
    postalCode: 3549,
    city: "Happy Valley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7167,
    longitude: 143.6,
    accuracy: 4
  },
  {
    postalCode: 3549,
    city: "Bannerton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.6992,
    longitude: 142.7883,
    accuracy: 4
  },
  {
    postalCode: 3549,
    city: "Tol Tol",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.6514,
    longitude: 142.8258,
    accuracy: 4
  },
  {
    postalCode: 3549,
    city: "Wemen",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.7887,
    longitude: 142.6301,
    accuracy: 4
  },
  {
    postalCode: 3549,
    city: "Robinvale Irrigation District Section E",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.7137,
    longitude: 142.753,
    accuracy: 3
  },
  {
    postalCode: 3549,
    city: "Wandown",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.7137,
    longitude: 142.753,
    accuracy: 3
  },
  {
    postalCode: 3549,
    city: "Robinvale Irrigation District Section D",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.7137,
    longitude: 142.753,
    accuracy: 3
  },
  {
    postalCode: 3549,
    city: "Liparoo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.7848,
    longitude: 142.5431,
    accuracy: 4
  },
  {
    postalCode: 3549,
    city: "Robinvale Irrigation District Section C",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.7137,
    longitude: 142.753,
    accuracy: 3
  },
  {
    postalCode: 3550,
    city: "Flora Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7812,
    longitude: 144.2956,
    accuracy: 4
  },
  {
    postalCode: 3550,
    city: "East Bendigo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7366,
    longitude: 144.3178,
    accuracy: 3
  },
  {
    postalCode: 3550,
    city: "North Bendigo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.731,
    longitude: 144.2997,
    accuracy: 3
  },
  {
    postalCode: 3550,
    city: "Strathdale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7657,
    longitude: 144.3155,
    accuracy: 4
  },
  {
    postalCode: 3550,
    city: "Kennington",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7833,
    longitude: 144.3,
    accuracy: 4
  },
  {
    postalCode: 3550,
    city: "Spring Gully",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7575,
    longitude: 144.2908,
    accuracy: 3
  },
  {
    postalCode: 3550,
    city: "Long Gully",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7431,
    longitude: 144.2579,
    accuracy: 4
  },
  {
    postalCode: 3550,
    city: "White Hills",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7287,
    longitude: 144.3053,
    accuracy: 4
  },
  {
    postalCode: 3550,
    city: "West Bendigo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4167,
    longitude: 144.5833,
    accuracy: 4
  },
  {
    postalCode: 3550,
    city: "Bendigo South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.85,
    longitude: 144.2833,
    accuracy: 3
  },
  {
    postalCode: 3550,
    city: "Quarry Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7765,
    longitude: 144.2802,
    accuracy: 4
  },
  {
    postalCode: 3550,
    city: "Ironbark",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7548,
    longitude: 144.2638,
    accuracy: 4
  },
  {
    postalCode: 3550,
    city: "Tysons Reef",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7575,
    longitude: 144.2908,
    accuracy: 3
  },
  {
    postalCode: 3550,
    city: "Bendigo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7582,
    longitude: 144.2802,
    accuracy: 4
  },
  {
    postalCode: 3550,
    city: "Sandhurst East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7575,
    longitude: 144.2908,
    accuracy: 3
  },
  {
    postalCode: 3551,
    city: "Toolleen",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7167,
    longitude: 144.7,
    accuracy: 4
  },
  {
    postalCode: 3551,
    city: "Lake Eppalock",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7536,
    longitude: 144.2402,
    accuracy: 3
  },
  {
    postalCode: 3551,
    city: "Wellsford",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6333,
    longitude: 144.4667,
    accuracy: 4
  },
  {
    postalCode: 3551,
    city: "Myrtle Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7536,
    longitude: 144.2402,
    accuracy: 3
  },
  {
    postalCode: 3551,
    city: "Maiden Gully",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7539,
    longitude: 144.2079,
    accuracy: 4
  },
  {
    postalCode: 3551,
    city: "Huntly",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6645,
    longitude: 144.3338,
    accuracy: 4
  },
  {
    postalCode: 3551,
    city: "Arnold West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6667,
    longitude: 143.8,
    accuracy: 4
  },
  {
    postalCode: 3551,
    city: "Huntly North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7536,
    longitude: 144.2402,
    accuracy: 3
  },
  {
    postalCode: 3551,
    city: "Emu Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8333,
    longitude: 144.35,
    accuracy: 4
  },
  {
    postalCode: 3551,
    city: "Tarnagulla",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.75,
    longitude: 143.8333,
    accuracy: 4
  },
  {
    postalCode: 3551,
    city: "Lockwood",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8111,
    longitude: 144.1576,
    accuracy: 4
  },
  {
    postalCode: 3551,
    city: "Painswick",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7519,
    longitude: 144.2656,
    accuracy: 3
  },
  {
    postalCode: 3551,
    city: "Bendigo Forward",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7536,
    longitude: 144.2402,
    accuracy: 3
  },
  {
    postalCode: 3551,
    city: "Myola",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6333,
    longitude: 144.65,
    accuracy: 4
  },
  {
    postalCode: 3551,
    city: "Waanyarra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8,
    longitude: 143.8,
    accuracy: 4
  },
  {
    postalCode: 3551,
    city: "Junortoun",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7711,
    longitude: 144.3631,
    accuracy: 4
  },
  {
    postalCode: 3551,
    city: "Llanelly",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7333,
    longitude: 143.8667,
    accuracy: 4
  },
  {
    postalCode: 3551,
    city: "Longlea",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7833,
    longitude: 144.4333,
    accuracy: 4
  },
  {
    postalCode: 3551,
    city: "Mandurang",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8167,
    longitude: 144.3,
    accuracy: 4
  },
  {
    postalCode: 3551,
    city: "Axedale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8,
    longitude: 144.5167,
    accuracy: 4
  },
  {
    postalCode: 3551,
    city: "Woodstock On Loddon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7833,
    longitude: 144.05,
    accuracy: 4
  },
  {
    postalCode: 3551,
    city: "Bagshot",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.65,
    longitude: 144.4167,
    accuracy: 4
  },
  {
    postalCode: 3551,
    city: "Murphys Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.75,
    longitude: 143.7667,
    accuracy: 4
  },
  {
    postalCode: 3551,
    city: "Bagshot North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7536,
    longitude: 144.2402,
    accuracy: 3
  },
  {
    postalCode: 3551,
    city: "Newbridge",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7333,
    longitude: 143.9167,
    accuracy: 4
  },
  {
    postalCode: 3551,
    city: "Eppalock",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8333,
    longitude: 144.4167,
    accuracy: 4
  },
  {
    postalCode: 3551,
    city: "Arnold",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6833,
    longitude: 143.8667,
    accuracy: 4
  },
  {
    postalCode: 3551,
    city: "Axe Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7536,
    longitude: 144.2402,
    accuracy: 3
  },
  {
    postalCode: 3551,
    city: "Mandurang South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.85,
    longitude: 144.2833,
    accuracy: 4
  },
  {
    postalCode: 3551,
    city: "Kimbolton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7536,
    longitude: 144.2402,
    accuracy: 3
  },
  {
    postalCode: 3551,
    city: "Epsom",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7167,
    longitude: 144.3167,
    accuracy: 4
  },
  {
    postalCode: 3551,
    city: "Cornella",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7,
    longitude: 144.75,
    accuracy: 4
  },
  {
    postalCode: 3551,
    city: "Strathfieldsaye",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8067,
    longitude: 144.3549,
    accuracy: 4
  },
  {
    postalCode: 3551,
    city: "Lockwood South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8436,
    longitude: 144.1584,
    accuracy: 4
  },
  {
    postalCode: 3551,
    city: "Ascot",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7,
    longitude: 144.3333,
    accuracy: 4
  },
  {
    postalCode: 3551,
    city: "Sedgwick",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8833,
    longitude: 144.3167,
    accuracy: 4
  },
  {
    postalCode: 3552,
    city: "Bendigo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7582,
    longitude: 144.2802,
    accuracy: 4
  },
  {
    postalCode: 3554,
    city: "Bendigo Dc",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.731,
    longitude: 144.2997,
    accuracy: 1
  },
  {
    postalCode: 3555,
    city: "Golden Gully",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7,
    longitude: 143.6667,
    accuracy: 4
  },
  {
    postalCode: 3555,
    city: "Golden Square",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7726,
    longitude: 144.2527,
    accuracy: 4
  },
  {
    postalCode: 3555,
    city: "Kangaroo Flat",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8,
    longitude: 144.25,
    accuracy: 4
  },
  {
    postalCode: 3555,
    city: "Lansell Plaza",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0909,
    longitude: 144.0565,
    accuracy: 3
  },
  {
    postalCode: 3555,
    city: "Big Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0909,
    longitude: 144.0565,
    accuracy: 3
  },
  {
    postalCode: 3556,
    city: "Campbells Forest",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6,
    longitude: 144.1333,
    accuracy: 4
  },
  {
    postalCode: 3556,
    city: "Eaglehawk",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7333,
    longitude: 144.25,
    accuracy: 4
  },
  {
    postalCode: 3556,
    city: "Sebastian",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6,
    longitude: 144.2,
    accuracy: 4
  },
  {
    postalCode: 3556,
    city: "Eaglehawk North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6731,
    longitude: 144.221,
    accuracy: 3
  },
  {
    postalCode: 3556,
    city: "California Gully",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7289,
    longitude: 144.2609,
    accuracy: 4
  },
  {
    postalCode: 3556,
    city: "Woodvale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.65,
    longitude: 144.2167,
    accuracy: 4
  },
  {
    postalCode: 3556,
    city: "Comet Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6879,
    longitude: 144.2346,
    accuracy: 3
  },
  {
    postalCode: 3556,
    city: "Jackass Flat",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7159,
    longitude: 144.286,
    accuracy: 4
  },
  {
    postalCode: 3556,
    city: "Myers Flat",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6833,
    longitude: 144.2,
    accuracy: 4
  },
  {
    postalCode: 3556,
    city: "Whipstick",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6731,
    longitude: 144.221,
    accuracy: 3
  },
  {
    postalCode: 3556,
    city: "Sailors Gully",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6731,
    longitude: 144.221,
    accuracy: 3
  },
  {
    postalCode: 3557,
    city: "Goornong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6165,
    longitude: 144.5072,
    accuracy: 4
  },
  {
    postalCode: 3557,
    city: "Barnadown",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.65,
    longitude: 144.55,
    accuracy: 4
  },
  {
    postalCode: 3557,
    city: "Muskerry",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6833,
    longitude: 144.6333,
    accuracy: 4
  },
  {
    postalCode: 3557,
    city: "Fosterville",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7,
    longitude: 144.5,
    accuracy: 4
  },
  {
    postalCode: 3558,
    city: "Elmore",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4946,
    longitude: 144.6105,
    accuracy: 4
  },
  {
    postalCode: 3558,
    city: "Hunter",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.45,
    longitude: 144.5167,
    accuracy: 4
  },
  {
    postalCode: 3558,
    city: "Burnewang",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4723,
    longitude: 144.5636,
    accuracy: 3
  },
  {
    postalCode: 3558,
    city: "Runnymede",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4723,
    longitude: 144.5636,
    accuracy: 3
  },
  {
    postalCode: 3558,
    city: "Corop West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4723,
    longitude: 144.5636,
    accuracy: 3
  },
  {
    postalCode: 3559,
    city: "Avonmore",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5333,
    longitude: 144.5667,
    accuracy: 4
  },
  {
    postalCode: 3559,
    city: "Gobarup",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5333,
    longitude: 144.7278,
    accuracy: 3
  },
  {
    postalCode: 3559,
    city: "Colbinabbin",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6,
    longitude: 144.8167,
    accuracy: 4
  },
  {
    postalCode: 3559,
    city: "Corop",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4667,
    longitude: 144.8,
    accuracy: 4
  },
  {
    postalCode: 3559,
    city: "Burramboot",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5333,
    longitude: 144.7278,
    accuracy: 3
  },
  {
    postalCode: 3561,
    city: "Fairy Dell",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3333,
    longitude: 144.75,
    accuracy: 4
  },
  {
    postalCode: 3561,
    city: "Rochester",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3635,
    longitude: 144.7008,
    accuracy: 4
  },
  {
    postalCode: 3561,
    city: "Ballendella",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3,
    longitude: 144.65,
    accuracy: 4
  },
  {
    postalCode: 3561,
    city: "Bonn",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3305,
    longitude: 144.712,
    accuracy: 3
  },
  {
    postalCode: 3561,
    city: "Timmering",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3667,
    longitude: 144.9167,
    accuracy: 4
  },
  {
    postalCode: 3561,
    city: "Nanneella",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3167,
    longitude: 144.7833,
    accuracy: 4
  },
  {
    postalCode: 3561,
    city: "Bamawm",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2145,
    longitude: 144.6089,
    accuracy: 4
  },
  {
    postalCode: 3561,
    city: "Diggora",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4167,
    longitude: 144.5833,
    accuracy: 4
  },
  {
    postalCode: 3562,
    city: "Torrumbarry",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0231,
    longitude: 144.5533,
    accuracy: 4
  },
  {
    postalCode: 3563,
    city: "Lockington",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2712,
    longitude: 144.5373,
    accuracy: 4
  },
  {
    postalCode: 3564,
    city: "Roslynmead",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1262,
    longitude: 144.6892,
    accuracy: 3
  },
  {
    postalCode: 3564,
    city: "Echuca South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1262,
    longitude: 144.6892,
    accuracy: 3
  },
  {
    postalCode: 3564,
    city: "Wharparilla",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.129,
    longitude: 144.6289,
    accuracy: 4
  },
  {
    postalCode: 3564,
    city: "Simmie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1292,
    longitude: 144.6995,
    accuracy: 3
  },
  {
    postalCode: 3564,
    city: "Echuca",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1406,
    longitude: 144.7518,
    accuracy: 4
  },
  {
    postalCode: 3564,
    city: "Echuca Village",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1333,
    longitude: 144.8167,
    accuracy: 4
  },
  {
    postalCode: 3564,
    city: "Bamawm Extension",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2145,
    longitude: 144.6089,
    accuracy: 4
  },
  {
    postalCode: 3564,
    city: "Kanyapella",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1574,
    longitude: 144.7962,
    accuracy: 4
  },
  {
    postalCode: 3564,
    city: "Echuca West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1262,
    longitude: 144.6892,
    accuracy: 3
  },
  {
    postalCode: 3564,
    city: "Patho",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0087,
    longitude: 144.4304,
    accuracy: 4
  },
  {
    postalCode: 3565,
    city: "Kotta",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2003,
    longitude: 144.5363,
    accuracy: 4
  },
  {
    postalCode: 3566,
    city: "Gunbower",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.9561,
    longitude: 144.3692,
    accuracy: 4
  },
  {
    postalCode: 3567,
    city: "Horfield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.9039,
    longitude: 144.3022,
    accuracy: 3
  },
  {
    postalCode: 3567,
    city: "Leitchville",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.9039,
    longitude: 144.3022,
    accuracy: 4
  },
  {
    postalCode: 3568,
    city: "Mead",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.8147,
    longitude: 144.1738,
    accuracy: 3
  },
  {
    postalCode: 3568,
    city: "Cohuna",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.807,
    longitude: 144.2189,
    accuracy: 4
  },
  {
    postalCode: 3568,
    city: "Gannawarra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.7333,
    longitude: 144.15,
    accuracy: 4
  },
  {
    postalCode: 3568,
    city: "Macorna North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.8391,
    longitude: 144.0922,
    accuracy: 4
  },
  {
    postalCode: 3568,
    city: "Cullen",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.8147,
    longitude: 144.1738,
    accuracy: 3
  },
  {
    postalCode: 3568,
    city: "Keely",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.85,
    longitude: 144.25,
    accuracy: 4
  },
  {
    postalCode: 3568,
    city: "Mincha West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.8147,
    longitude: 144.1738,
    accuracy: 3
  },
  {
    postalCode: 3568,
    city: "Mcmillans",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.8333,
    longitude: 144.15,
    accuracy: 4
  },
  {
    postalCode: 3568,
    city: "Wee Wee Rup",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.8147,
    longitude: 144.1738,
    accuracy: 3
  },
  {
    postalCode: 3568,
    city: "Daltons Bridge",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.8147,
    longitude: 144.1738,
    accuracy: 3
  },
  {
    postalCode: 3568,
    city: "Burkes Bridge",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.8147,
    longitude: 144.1738,
    accuracy: 3
  },
  {
    postalCode: 3570,
    city: "Kamarooka",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4707,
    longitude: 144.3336,
    accuracy: 4
  },
  {
    postalCode: 3570,
    city: "Raywood",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5333,
    longitude: 144.2167,
    accuracy: 4
  },
  {
    postalCode: 3570,
    city: "Drummartin",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.45,
    longitude: 144.4333,
    accuracy: 4
  },
  {
    postalCode: 3570,
    city: "Auchmore",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5972,
    longitude: 144.2121,
    accuracy: 3
  },
  {
    postalCode: 3570,
    city: "Neilborough",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5667,
    longitude: 144.2333,
    accuracy: 4
  },
  {
    postalCode: 3571,
    city: "Kamarooka North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4064,
    longitude: 144.1719,
    accuracy: 3
  },
  {
    postalCode: 3571,
    city: "Dingee",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3667,
    longitude: 144.2167,
    accuracy: 4
  },
  {
    postalCode: 3571,
    city: "Pompapiel",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.35,
    longitude: 144.0833,
    accuracy: 4
  },
  {
    postalCode: 3571,
    city: "Tandarra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4285,
    longitude: 144.2286,
    accuracy: 4
  },
  {
    postalCode: 3572,
    city: "Tennyson",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2833,
    longitude: 144.4333,
    accuracy: 4
  },
  {
    postalCode: 3572,
    city: "Piavella",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3,
    longitude: 144.3444,
    accuracy: 3
  },
  {
    postalCode: 3572,
    city: "Milloo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3167,
    longitude: 144.3667,
    accuracy: 4
  },
  {
    postalCode: 3572,
    city: "Prairie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3,
    longitude: 144.2333,
    accuracy: 4
  },
  {
    postalCode: 3573,
    city: "Pine Grove",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2333,
    longitude: 144.4167,
    accuracy: 4
  },
  {
    postalCode: 3573,
    city: "Calivil",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2667,
    longitude: 144.0667,
    accuracy: 4
  },
  {
    postalCode: 3573,
    city: "Terrick Terrick East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2389,
    longitude: 144.2389,
    accuracy: 3
  },
  {
    postalCode: 3573,
    city: "Mitiamo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2078,
    longitude: 144.2306,
    accuracy: 4
  },
  {
    postalCode: 3575,
    city: "Gladfield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0506,
    longitude: 143.9521,
    accuracy: 4
  },
  {
    postalCode: 3575,
    city: "Mologa",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1437,
    longitude: 144.1791,
    accuracy: 4
  },
  {
    postalCode: 3575,
    city: "Sylvaterre",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.11,
    longitude: 144.2248,
    accuracy: 4
  },
  {
    postalCode: 3575,
    city: "Loddon Vale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3561,
    longitude: 143.7034,
    accuracy: 4
  },
  {
    postalCode: 3575,
    city: "Pyramid Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0558,
    longitude: 144.1147,
    accuracy: 4
  },
  {
    postalCode: 3575,
    city: "Yarrawalla",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1165,
    longitude: 144.0308,
    accuracy: 4
  },
  {
    postalCode: 3575,
    city: "Terrick Terrick",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0843,
    longitude: 144.2808,
    accuracy: 4
  },
  {
    postalCode: 3575,
    city: "Jungaburra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.114,
    longitude: 144.0939,
    accuracy: 3
  },
  {
    postalCode: 3575,
    city: "Mincha",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0022,
    longitude: 144.0757,
    accuracy: 4
  },
  {
    postalCode: 3576,
    city: "Durham Ox",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1259,
    longitude: 143.9199,
    accuracy: 4
  },
  {
    postalCode: 3579,
    city: "Mystic Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.5535,
    longitude: 143.7221,
    accuracy: 4
  },
  {
    postalCode: 3579,
    city: "Murrabit West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.5193,
    longitude: 143.9049,
    accuracy: 4
  },
  {
    postalCode: 3579,
    city: "Teal Point",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.6746,
    longitude: 144.0757,
    accuracy: 4
  },
  {
    postalCode: 3579,
    city: "Kerang East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.7167,
    longitude: 143.8618,
    accuracy: 3
  },
  {
    postalCode: 3579,
    city: "Beauchamp",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.6082,
    longitude: 143.5719,
    accuracy: 4
  },
  {
    postalCode: 3579,
    city: "Westby",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.7167,
    longitude: 143.8618,
    accuracy: 3
  },
  {
    postalCode: 3579,
    city: "Sandhill Lake",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.7248,
    longitude: 143.685,
    accuracy: 4
  },
  {
    postalCode: 3579,
    city: "Koroop",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.7425,
    longitude: 144.0736,
    accuracy: 4
  },
  {
    postalCode: 3579,
    city: "Appin South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.9204,
    longitude: 143.9123,
    accuracy: 4
  },
  {
    postalCode: 3579,
    city: "Wandella",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.7167,
    longitude: 143.8618,
    accuracy: 3
  },
  {
    postalCode: 3579,
    city: "Budgerum East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.7792,
    longitude: 143.6597,
    accuracy: 4
  },
  {
    postalCode: 3579,
    city: "Macorna",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.9177,
    longitude: 144.0305,
    accuracy: 4
  },
  {
    postalCode: 3579,
    city: "Capels Crossing",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.6333,
    longitude: 143.4333,
    accuracy: 4
  },
  {
    postalCode: 3579,
    city: "Meering West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.7249,
    longitude: 143.8763,
    accuracy: 3
  },
  {
    postalCode: 3579,
    city: "Murrabit",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.5322,
    longitude: 143.9524,
    accuracy: 4
  },
  {
    postalCode: 3579,
    city: "Benjeroop",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.4913,
    longitude: 143.8604,
    accuracy: 4
  },
  {
    postalCode: 3579,
    city: "Tragowel",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.8513,
    longitude: 143.9777,
    accuracy: 4
  },
  {
    postalCode: 3579,
    city: "Lake Meran",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.7167,
    longitude: 143.8618,
    accuracy: 3
  },
  {
    postalCode: 3579,
    city: "Myall",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.581,
    longitude: 144.0013,
    accuracy: 4
  },
  {
    postalCode: 3579,
    city: "Gonn Crossing",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.7167,
    longitude: 143.8618,
    accuracy: 3
  },
  {
    postalCode: 3579,
    city: "Normanville",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.8161,
    longitude: 143.7454,
    accuracy: 4
  },
  {
    postalCode: 3579,
    city: "Fairley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.6868,
    longitude: 143.8612,
    accuracy: 4
  },
  {
    postalCode: 3579,
    city: "Milnes Bridge",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.8,
    longitude: 144.0667,
    accuracy: 4
  },
  {
    postalCode: 3579,
    city: "Pine View",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.7167,
    longitude: 143.8618,
    accuracy: 3
  },
  {
    postalCode: 3579,
    city: "Reedy Lake",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.7167,
    longitude: 143.8618,
    accuracy: 3
  },
  {
    postalCode: 3579,
    city: "Kerang",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.7349,
    longitude: 143.9203,
    accuracy: 4
  },
  {
    postalCode: 3579,
    city: "Bael Bael",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.7167,
    longitude: 143.8618,
    accuracy: 3
  },
  {
    postalCode: 3579,
    city: "Appin",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.9065,
    longitude: 143.8691,
    accuracy: 4
  },
  {
    postalCode: 3579,
    city: "Dingwall",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.811,
    longitude: 143.8309,
    accuracy: 4
  },
  {
    postalCode: 3580,
    city: "Koondrook",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.6318,
    longitude: 144.1248,
    accuracy: 4
  },
  {
    postalCode: 3581,
    city: "Lake Charm",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.65,
    longitude: 143.7833,
    accuracy: 4
  },
  {
    postalCode: 3583,
    city: "Tresco",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.5057,
    longitude: 143.6748,
    accuracy: 4
  },
  {
    postalCode: 3584,
    city: "Tresco West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.463,
    longitude: 143.6326,
    accuracy: 3
  },
  {
    postalCode: 3584,
    city: "Lake Boga",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.463,
    longitude: 143.6326,
    accuracy: 4
  },
  {
    postalCode: 3585,
    city: "Kunat",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.5412,
    longitude: 143.4973,
    accuracy: 4
  },
  {
    postalCode: 3585,
    city: "Goschen",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.4833,
    longitude: 143.4667,
    accuracy: 4
  },
  {
    postalCode: 3585,
    city: "Nowie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.2435,
    longitude: 143.3554,
    accuracy: 4
  },
  {
    postalCode: 3585,
    city: "Winlaton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.3964,
    longitude: 143.4089,
    accuracy: 3
  },
  {
    postalCode: 3585,
    city: "Chillingollah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.25,
    longitude: 143.05,
    accuracy: 4
  },
  {
    postalCode: 3585,
    city: "Pira",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.2558,
    longitude: 143.3676,
    accuracy: 4
  },
  {
    postalCode: 3585,
    city: "Meatian",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.5715,
    longitude: 143.3427,
    accuracy: 4
  },
  {
    postalCode: 3585,
    city: "Speewa",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.3964,
    longitude: 143.4089,
    accuracy: 3
  },
  {
    postalCode: 3585,
    city: "Fish Point",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.4354,
    longitude: 143.7268,
    accuracy: 4
  },
  {
    postalCode: 3585,
    city: "Swan Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.3378,
    longitude: 143.5544,
    accuracy: 4
  },
  {
    postalCode: 3585,
    city: "Nyrraby",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.3964,
    longitude: 143.4089,
    accuracy: 3
  },
  {
    postalCode: 3585,
    city: "Castle Donnington",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.3964,
    longitude: 143.4089,
    accuracy: 3
  },
  {
    postalCode: 3585,
    city: "Polisbet",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.3964,
    longitude: 143.4089,
    accuracy: 3
  },
  {
    postalCode: 3585,
    city: "Swan Hill West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.3964,
    longitude: 143.4089,
    accuracy: 3
  },
  {
    postalCode: 3586,
    city: "Murrawee",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.3167,
    longitude: 143.5333,
    accuracy: 4
  },
  {
    postalCode: 3586,
    city: "Pental Island",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.4034,
    longitude: 143.6912,
    accuracy: 4
  },
  {
    postalCode: 3586,
    city: "Tyntynder South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.2788,
    longitude: 143.5356,
    accuracy: 4
  },
  {
    postalCode: 3586,
    city: "Bulga",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.3134,
    longitude: 143.5561,
    accuracy: 3
  },
  {
    postalCode: 3586,
    city: "Tyntynder",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.2333,
    longitude: 143.4667,
    accuracy: 4
  },
  {
    postalCode: 3586,
    city: "Murraydale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.3134,
    longitude: 143.5561,
    accuracy: 3
  },
  {
    postalCode: 3588,
    city: "Woorinen South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.2911,
    longitude: 143.4551,
    accuracy: 1
  },
  {
    postalCode: 3589,
    city: "Woorinen North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.255,
    longitude: 143.4593,
    accuracy: 4
  },
  {
    postalCode: 3589,
    city: "Woorinen",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.2925,
    longitude: 143.4542,
    accuracy: 4
  },
  {
    postalCode: 3590,
    city: "Beverford",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.2238,
    longitude: 143.4727,
    accuracy: 4
  },
  {
    postalCode: 3591,
    city: "Vinifera",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.2393,
    longitude: 143.3195,
    accuracy: 1
  },
  {
    postalCode: 3594,
    city: "Nyah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.1755,
    longitude: 143.3774,
    accuracy: 4
  },
  {
    postalCode: 3595,
    city: "Nyah West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.1854,
    longitude: 143.3508,
    accuracy: 4
  },
  {
    postalCode: 3596,
    city: "Miralie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.1167,
    longitude: 143.2833,
    accuracy: 3
  },
  {
    postalCode: 3596,
    city: "Wood Wood",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.1037,
    longitude: 143.3383,
    accuracy: 4
  },
  {
    postalCode: 3596,
    city: "Towan",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.1167,
    longitude: 143.2333,
    accuracy: 4
  },
  {
    postalCode: 3597,
    city: "Narrung",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.774,
    longitude: 143.2472,
    accuracy: 4
  },
  {
    postalCode: 3597,
    city: "Kooloonong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.8774,
    longitude: 143.1459,
    accuracy: 4
  },
  {
    postalCode: 3597,
    city: "Kenley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.9083,
    longitude: 143.2167,
    accuracy: 3
  },
  {
    postalCode: 3597,
    city: "Natya",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.9567,
    longitude: 143.2252,
    accuracy: 4
  },
  {
    postalCode: 3597,
    city: "Piangil",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.0585,
    longitude: 143.3063,
    accuracy: 4
  },
  {
    postalCode: 3597,
    city: "Lake Powell",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.9083,
    longitude: 143.2167,
    accuracy: 3
  },
  {
    postalCode: 3599,
    city: "Boundary Bend",
    state_name: "Victoria",
    state: "VIC",
    latitude: -34.7213,
    longitude: 143.1648,
    accuracy: 4
  },
  {
    postalCode: 3607,
    city: "Tabilk",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.85,
    longitude: 145.1667,
    accuracy: 4
  },
  {
    postalCode: 3608,
    city: "Kirwans Bridge",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7741,
    longitude: 145.0958,
    accuracy: 3
  },
  {
    postalCode: 3608,
    city: "Bailieston",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7333,
    longitude: 145.05,
    accuracy: 4
  },
  {
    postalCode: 3608,
    city: "Graytown",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8167,
    longitude: 144.95,
    accuracy: 4
  },
  {
    postalCode: 3608,
    city: "Nagambie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7851,
    longitude: 145.1537,
    accuracy: 4
  },
  {
    postalCode: 3608,
    city: "Goulburn Weir",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7167,
    longitude: 145.1833,
    accuracy: 4
  },
  {
    postalCode: 3608,
    city: "Mitchellstown",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.85,
    longitude: 145.0667,
    accuracy: 4
  },
  {
    postalCode: 3608,
    city: "Wahring",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7167,
    longitude: 145.2167,
    accuracy: 4
  },
  {
    postalCode: 3608,
    city: "Wirrate",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8,
    longitude: 145.05,
    accuracy: 4
  },
  {
    postalCode: 3610,
    city: "Murchison North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.596,
    longitude: 145.2493,
    accuracy: 3
  },
  {
    postalCode: 3610,
    city: "Moorilim",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6167,
    longitude: 145.3167,
    accuracy: 4
  },
  {
    postalCode: 3610,
    city: "Dhurringile",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5319,
    longitude: 145.2132,
    accuracy: 4
  },
  {
    postalCode: 3610,
    city: "Murchison",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6189,
    longitude: 145.2172,
    accuracy: 4
  },
  {
    postalCode: 3610,
    city: "Murchison East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6167,
    longitude: 145.25,
    accuracy: 4
  },
  {
    postalCode: 3612,
    city: "Wanalta",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6,
    longitude: 144.8833,
    accuracy: 4
  },
  {
    postalCode: 3612,
    city: "Moora",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6099,
    longitude: 144.9369,
    accuracy: 3
  },
  {
    postalCode: 3612,
    city: "Rushworth",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5867,
    longitude: 145.0175,
    accuracy: 4
  },
  {
    postalCode: 3612,
    city: "Whroo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.65,
    longitude: 145.0167,
    accuracy: 4
  },
  {
    postalCode: 3612,
    city: "Waranga Shores",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6122,
    longitude: 144.9725,
    accuracy: 3
  },
  {
    postalCode: 3614,
    city: "Toolamba",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5,
    longitude: 145.35,
    accuracy: 4
  },
  {
    postalCode: 3614,
    city: "Toolamba West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4333,
    longitude: 145.2833,
    accuracy: 4
  },
  {
    postalCode: 3616,
    city: "Waranga",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6,
    longitude: 145.1167,
    accuracy: 4
  },
  {
    postalCode: 3616,
    city: "Girgarre East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4333,
    longitude: 145.0667,
    accuracy: 4
  },
  {
    postalCode: 3616,
    city: "Tatura",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4396,
    longitude: 145.2299,
    accuracy: 4
  },
  {
    postalCode: 3616,
    city: "Harston",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4667,
    longitude: 145.15,
    accuracy: 4
  },
  {
    postalCode: 3616,
    city: "Tatura East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4455,
    longitude: 145.1411,
    accuracy: 3
  },
  {
    postalCode: 3616,
    city: "Gillieston",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3167,
    longitude: 145.2167,
    accuracy: 4
  },
  {
    postalCode: 3616,
    city: "Cooma",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4167,
    longitude: 145.0667,
    accuracy: 4
  },
  {
    postalCode: 3616,
    city: "Mooroopna North West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4455,
    longitude: 145.1411,
    accuracy: 3
  },
  {
    postalCode: 3617,
    city: "Byrneside",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4167,
    longitude: 145.1833,
    accuracy: 4
  },
  {
    postalCode: 3618,
    city: "Merrigum",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3724,
    longitude: 145.1322,
    accuracy: 4
  },
  {
    postalCode: 3619,
    city: "Kyabram",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3134,
    longitude: 145.0504,
    accuracy: 4
  },
  {
    postalCode: 3620,
    city: "St Germains",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.25,
    longitude: 145.1667,
    accuracy: 4
  },
  {
    postalCode: 3620,
    city: "Wyuna",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1968,
    longitude: 145.0589,
    accuracy: 4
  },
  {
    postalCode: 3620,
    city: "Kyabram South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3048,
    longitude: 145.0719,
    accuracy: 3
  },
  {
    postalCode: 3620,
    city: "Lancaster",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3167,
    longitude: 145.1333,
    accuracy: 4
  },
  {
    postalCode: 3620,
    city: "Wyuna East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1968,
    longitude: 145.0589,
    accuracy: 4
  },
  {
    postalCode: 3620,
    city: "Kyabram",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3134,
    longitude: 145.0504,
    accuracy: 4
  },
  {
    postalCode: 3621,
    city: "Kyvalley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2833,
    longitude: 145,
    accuracy: 4
  },
  {
    postalCode: 3621,
    city: "Koyuga South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.208,
    longitude: 144.9829,
    accuracy: 3
  },
  {
    postalCode: 3621,
    city: "Tongala",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2547,
    longitude: 144.9562,
    accuracy: 4
  },
  {
    postalCode: 3621,
    city: "Yambuna",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1343,
    longitude: 145.036,
    accuracy: 4
  },
  {
    postalCode: 3622,
    city: "Koyuga",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2207,
    longitude: 144.8906,
    accuracy: 4
  },
  {
    postalCode: 3622,
    city: "Strathallan",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.25,
    longitude: 144.75,
    accuracy: 4
  },
  {
    postalCode: 3623,
    city: "Stanhope",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4472,
    longitude: 144.9827,
    accuracy: 4
  },
  {
    postalCode: 3623,
    city: "Carag Carag",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4667,
    longitude: 144.9167,
    accuracy: 4
  },
  {
    postalCode: 3623,
    city: "Stanhope South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.457,
    longitude: 144.9497,
    accuracy: 3
  },
  {
    postalCode: 3624,
    city: "Girgarre",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3999,
    longitude: 144.9496,
    accuracy: 4
  },
  {
    postalCode: 3629,
    city: "Mooroopna North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3333,
    longitude: 145.3,
    accuracy: 4
  },
  {
    postalCode: 3629,
    city: "Mooroopna",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4,
    longitude: 145.35,
    accuracy: 4
  },
  {
    postalCode: 3629,
    city: "Ardmona",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3833,
    longitude: 145.3,
    accuracy: 4
  },
  {
    postalCode: 3629,
    city: "Undera",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2833,
    longitude: 145.2167,
    accuracy: 4
  },
  {
    postalCode: 3629,
    city: "Coomboona",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2833,
    longitude: 145.2484,
    accuracy: 3
  },
  {
    postalCode: 3630,
    city: "Shepparton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3805,
    longitude: 145.3987,
    accuracy: 4
  },
  {
    postalCode: 3630,
    city: "Shepparton South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4283,
    longitude: 145.5142,
    accuracy: 3
  },
  {
    postalCode: 3630,
    city: "Caniambo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4761,
    longitude: 145.6297,
    accuracy: 4
  },
  {
    postalCode: 3630,
    city: "Benarch",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4681,
    longitude: 145.586,
    accuracy: 3
  },
  {
    postalCode: 3630,
    city: "Colliver",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4681,
    longitude: 145.586,
    accuracy: 3
  },
  {
    postalCode: 3630,
    city: "Branditt",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4681,
    longitude: 145.586,
    accuracy: 3
  },
  {
    postalCode: 3630,
    city: "Dunkirk",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4681,
    longitude: 145.586,
    accuracy: 3
  },
  {
    postalCode: 3631,
    city: "Kialla East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.45,
    longitude: 145.5333,
    accuracy: 4
  },
  {
    postalCode: 3631,
    city: "Kialla",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4473,
    longitude: 145.4142,
    accuracy: 4
  },
  {
    postalCode: 3631,
    city: "Orrvale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4167,
    longitude: 145.45,
    accuracy: 4
  },
  {
    postalCode: 3631,
    city: "Arcadia South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4425,
    longitude: 145.4837,
    accuracy: 3
  },
  {
    postalCode: 3631,
    city: "Pine Lodge",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4167,
    longitude: 145.5,
    accuracy: 4
  },
  {
    postalCode: 3631,
    city: "Karramomus",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5333,
    longitude: 145.4833,
    accuracy: 4
  },
  {
    postalCode: 3631,
    city: "Lemnos",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.35,
    longitude: 145.4667,
    accuracy: 4
  },
  {
    postalCode: 3631,
    city: "Tamleugh West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5667,
    longitude: 145.5333,
    accuracy: 4
  },
  {
    postalCode: 3631,
    city: "Grahamvale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3484,
    longitude: 145.4362,
    accuracy: 4
  },
  {
    postalCode: 3631,
    city: "Kialla West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4645,
    longitude: 145.3878,
    accuracy: 4
  },
  {
    postalCode: 3631,
    city: "Arcadia",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5654,
    longitude: 145.3319,
    accuracy: 4
  },
  {
    postalCode: 3631,
    city: "Shepparton North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4425,
    longitude: 145.4837,
    accuracy: 3
  },
  {
    postalCode: 3631,
    city: "Cosgrove",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.35,
    longitude: 145.6667,
    accuracy: 4
  },
  {
    postalCode: 3631,
    city: "Cosgrove South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4,
    longitude: 145.6167,
    accuracy: 4
  },
  {
    postalCode: 3631,
    city: "Shepparton East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4293,
    longitude: 145.4749,
    accuracy: 3
  },
  {
    postalCode: 3632,
    city: "Shepparton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3805,
    longitude: 145.3987,
    accuracy: 4
  },
  {
    postalCode: 3633,
    city: "Congupna",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3,
    longitude: 145.4333,
    accuracy: 4
  },
  {
    postalCode: 3634,
    city: "Invergordon South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2456,
    longitude: 145.4686,
    accuracy: 3
  },
  {
    postalCode: 3634,
    city: "Tallygaroopna",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.25,
    longitude: 145.4333,
    accuracy: 4
  },
  {
    postalCode: 3634,
    city: "Bunbartha",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2167,
    longitude: 145.3167,
    accuracy: 4
  },
  {
    postalCode: 3634,
    city: "Katandra West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2241,
    longitude: 145.5583,
    accuracy: 4
  },
  {
    postalCode: 3634,
    city: "Zeerust",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2248,
    longitude: 145.4883,
    accuracy: 3
  },
  {
    postalCode: 3634,
    city: "Katandra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2333,
    longitude: 145.6167,
    accuracy: 4
  },
  {
    postalCode: 3634,
    city: "Marionvale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2248,
    longitude: 145.4883,
    accuracy: 3
  },
  {
    postalCode: 3634,
    city: "Marungi",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1969,
    longitude: 145.536,
    accuracy: 4
  },
  {
    postalCode: 3635,
    city: "Wunghnu",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1526,
    longitude: 145.431,
    accuracy: 4
  },
  {
    postalCode: 3635,
    city: "Kaarimba",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1333,
    longitude: 145.25,
    accuracy: 4
  },
  {
    postalCode: 3635,
    city: "Mundoona",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1545,
    longitude: 145.3298,
    accuracy: 4
  },
  {
    postalCode: 3636,
    city: "Naring",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1295,
    longitude: 145.5085,
    accuracy: 3
  },
  {
    postalCode: 3636,
    city: "Numurkah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0885,
    longitude: 145.4422,
    accuracy: 4
  },
  {
    postalCode: 3636,
    city: "Drumanure",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1312,
    longitude: 145.5057,
    accuracy: 4
  },
  {
    postalCode: 3636,
    city: "Invergordon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1667,
    longitude: 145.5833,
    accuracy: 4
  },
  {
    postalCode: 3637,
    city: "Yalca",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.9833,
    longitude: 145.3167,
    accuracy: 4
  },
  {
    postalCode: 3637,
    city: "Waaia",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0475,
    longitude: 145.3334,
    accuracy: 4
  },
  {
    postalCode: 3638,
    city: "Nathalia",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0577,
    longitude: 145.2041,
    accuracy: 4
  },
  {
    postalCode: 3638,
    city: "Yielima",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.9333,
    longitude: 145.2167,
    accuracy: 3
  },
  {
    postalCode: 3638,
    city: "Kotupna",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1475,
    longitude: 145.1337,
    accuracy: 4
  },
  {
    postalCode: 3639,
    city: "Barmah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0159,
    longitude: 144.9628,
    accuracy: 4
  },
  {
    postalCode: 3639,
    city: "Picola West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0333,
    longitude: 145.0278,
    accuracy: 3
  },
  {
    postalCode: 3639,
    city: "Lower Moira",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0855,
    longitude: 144.9763,
    accuracy: 4
  },
  {
    postalCode: 3639,
    city: "Picola",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.9969,
    longitude: 145.1193,
    accuracy: 4
  },
  {
    postalCode: 3640,
    city: "Katunga",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0133,
    longitude: 145.4695,
    accuracy: 4
  },
  {
    postalCode: 3641,
    city: "Bearii",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.8857,
    longitude: 145.3453,
    accuracy: 4
  },
  {
    postalCode: 3641,
    city: "Strathmerton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.9253,
    longitude: 145.4787,
    accuracy: 4
  },
  {
    postalCode: 3641,
    city: "Ulupna",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.8833,
    longitude: 145.4,
    accuracy: 4
  },
  {
    postalCode: 3641,
    city: "Mywee",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.8566,
    longitude: 145.4976,
    accuracy: 4
  },
  {
    postalCode: 3643,
    city: "Cobram",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.9207,
    longitude: 145.6407,
    accuracy: 4
  },
  {
    postalCode: 3644,
    city: "Koonoomoo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.9503,
    longitude: 145.6546,
    accuracy: 3
  },
  {
    postalCode: 3644,
    city: "Cobram",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.9207,
    longitude: 145.6407,
    accuracy: 4
  },
  {
    postalCode: 3644,
    city: "Muckatah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0198,
    longitude: 145.6478,
    accuracy: 4
  },
  {
    postalCode: 3644,
    city: "Yarroweyah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.9241,
    longitude: 145.5572,
    accuracy: 4
  },
  {
    postalCode: 3644,
    city: "Cobram East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.9746,
    longitude: 145.7364,
    accuracy: 4
  },
  {
    postalCode: 3646,
    city: "Nalinga",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4167,
    longitude: 145.7167,
    accuracy: 4
  },
  {
    postalCode: 3646,
    city: "Dookie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3273,
    longitude: 145.6897,
    accuracy: 4
  },
  {
    postalCode: 3646,
    city: "Mount Major",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3606,
    longitude: 145.6914,
    accuracy: 4
  },
  {
    postalCode: 3646,
    city: "Yabba South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2755,
    longitude: 145.7146,
    accuracy: 3
  },
  {
    postalCode: 3646,
    city: "Waggarandall",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.25,
    longitude: 145.8,
    accuracy: 4
  },
  {
    postalCode: 3646,
    city: "Youanmite",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1625,
    longitude: 145.6899,
    accuracy: 4
  },
  {
    postalCode: 3646,
    city: "Yabba North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2167,
    longitude: 145.6833,
    accuracy: 4
  },
  {
    postalCode: 3647,
    city: "Dookie College",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3957,
    longitude: 145.7047,
    accuracy: 4
  },
  {
    postalCode: 3649,
    city: "Katamatite East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0759,
    longitude: 145.6872,
    accuracy: 3
  },
  {
    postalCode: 3649,
    city: "Katamatite",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0759,
    longitude: 145.6872,
    accuracy: 4
  },
  {
    postalCode: 3658,
    city: "Waterford Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3002,
    longitude: 145.0668,
    accuracy: 4
  },
  {
    postalCode: 3658,
    city: "Clonbinane",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.292,
    longitude: 145.1406,
    accuracy: 3
  },
  {
    postalCode: 3658,
    city: "Tyaak",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2167,
    longitude: 145.1333,
    accuracy: 4
  },
  {
    postalCode: 3658,
    city: "Strath Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2333,
    longitude: 145.2167,
    accuracy: 4
  },
  {
    postalCode: 3658,
    city: "Broadford",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2028,
    longitude: 145.0484,
    accuracy: 4
  },
  {
    postalCode: 3658,
    city: "Sugarloaf Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2602,
    longitude: 145.1482,
    accuracy: 3
  },
  {
    postalCode: 3658,
    city: "Reedy Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2667,
    longitude: 145.1333,
    accuracy: 4
  },
  {
    postalCode: 3658,
    city: "Sunday Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2602,
    longitude: 145.1482,
    accuracy: 3
  },
  {
    postalCode: 3658,
    city: "Hazeldene",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3413,
    longitude: 145.2908,
    accuracy: 4
  },
  {
    postalCode: 3659,
    city: "Tallarook",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0937,
    longitude: 145.1,
    accuracy: 4
  },
  {
    postalCode: 3660,
    city: "Northwood",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9667,
    longitude: 145.1167,
    accuracy: 4
  },
  {
    postalCode: 3660,
    city: "Dropmore",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0605,
    longitude: 145.2132,
    accuracy: 3
  },
  {
    postalCode: 3660,
    city: "Seymour South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0605,
    longitude: 145.2132,
    accuracy: 3
  },
  {
    postalCode: 3660,
    city: "Seymour",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0266,
    longitude: 145.1392,
    accuracy: 4
  },
  {
    postalCode: 3660,
    city: "Whiteheads Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0468,
    longitude: 145.2864,
    accuracy: 4
  },
  {
    postalCode: 3660,
    city: "Trawool",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1,
    longitude: 145.2167,
    accuracy: 4
  },
  {
    postalCode: 3660,
    city: "Caveat",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0605,
    longitude: 145.2132,
    accuracy: 3
  },
  {
    postalCode: 3660,
    city: "Kerrisdale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.15,
    longitude: 145.2667,
    accuracy: 4
  },
  {
    postalCode: 3660,
    city: "Highlands",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1,
    longitude: 145.4,
    accuracy: 4
  },
  {
    postalCode: 3660,
    city: "Hilldene",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0333,
    longitude: 145.0667,
    accuracy: 4
  },
  {
    postalCode: 3661,
    city: "Seymour",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0266,
    longitude: 145.1392,
    accuracy: 4
  },
  {
    postalCode: 3662,
    city: "Puckapunyal Milpo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9604,
    longitude: 145.0527,
    accuracy: 3
  },
  {
    postalCode: 3662,
    city: "Puckapunyal",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9949,
    longitude: 145.0401,
    accuracy: 4
  },
  {
    postalCode: 3663,
    city: "Mangalore",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9333,
    longitude: 145.1833,
    accuracy: 4
  },
  {
    postalCode: 3664,
    city: "Upton Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9009,
    longitude: 145.2337,
    accuracy: 3
  },
  {
    postalCode: 3664,
    city: "Avenel",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9009,
    longitude: 145.2337,
    accuracy: 4
  },
  {
    postalCode: 3665,
    city: "Longwood",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8,
    longitude: 145.4167,
    accuracy: 4
  },
  {
    postalCode: 3665,
    city: "Locksley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8333,
    longitude: 145.3333,
    accuracy: 4
  },
  {
    postalCode: 3666,
    city: "Miepoll",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6167,
    longitude: 145.4667,
    accuracy: 4
  },
  {
    postalCode: 3666,
    city: "Strathbogie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.85,
    longitude: 145.75,
    accuracy: 4
  },
  {
    postalCode: 3666,
    city: "Creightons Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7804,
    longitude: 145.5403,
    accuracy: 3
  },
  {
    postalCode: 3666,
    city: "Gooram",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9,
    longitude: 145.5833,
    accuracy: 4
  },
  {
    postalCode: 3666,
    city: "Kelvin View",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8167,
    longitude: 145.6667,
    accuracy: 4
  },
  {
    postalCode: 3666,
    city: "Ruffy",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9833,
    longitude: 145.5,
    accuracy: 4
  },
  {
    postalCode: 3666,
    city: "Kithbrook",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7574,
    longitude: 145.5632,
    accuracy: 3
  },
  {
    postalCode: 3666,
    city: "Creighton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7833,
    longitude: 145.5,
    accuracy: 4
  },
  {
    postalCode: 3666,
    city: "Balmattum",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7,
    longitude: 145.65,
    accuracy: 4
  },
  {
    postalCode: 3666,
    city: "Pranjip",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7333,
    longitude: 145.3667,
    accuracy: 4
  },
  {
    postalCode: 3666,
    city: "Euroa",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7555,
    longitude: 145.5708,
    accuracy: 4
  },
  {
    postalCode: 3666,
    city: "Moglonemby",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.65,
    longitude: 145.5333,
    accuracy: 4
  },
  {
    postalCode: 3666,
    city: "Molka",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6833,
    longitude: 145.45,
    accuracy: 4
  },
  {
    postalCode: 3666,
    city: "Tarcombe",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9833,
    longitude: 145.4,
    accuracy: 4
  },
  {
    postalCode: 3666,
    city: "Longwood East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8167,
    longitude: 145.45,
    accuracy: 4
  },
  {
    postalCode: 3666,
    city: "Riggs Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.65,
    longitude: 145.5667,
    accuracy: 4
  },
  {
    postalCode: 3666,
    city: "Sheans Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7833,
    longitude: 145.65,
    accuracy: 4
  },
  {
    postalCode: 3669,
    city: "Earlston",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.55,
    longitude: 145.6667,
    accuracy: 4
  },
  {
    postalCode: 3669,
    city: "Boho",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7167,
    longitude: 145.8333,
    accuracy: 4
  },
  {
    postalCode: 3669,
    city: "Tamleugh North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5,
    longitude: 145.55,
    accuracy: 4
  },
  {
    postalCode: 3669,
    city: "Koonda",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5,
    longitude: 145.7333,
    accuracy: 4
  },
  {
    postalCode: 3669,
    city: "Marraweeney",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.75,
    longitude: 145.75,
    accuracy: 4
  },
  {
    postalCode: 3669,
    city: "Violet Town",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6361,
    longitude: 145.7151,
    accuracy: 4
  },
  {
    postalCode: 3669,
    city: "Upotipotpon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4833,
    longitude: 145.8167,
    accuracy: 4
  },
  {
    postalCode: 3669,
    city: "Boho South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7833,
    longitude: 145.8,
    accuracy: 4
  },
  {
    postalCode: 3669,
    city: "Gowangardie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4833,
    longitude: 145.7,
    accuracy: 4
  },
  {
    postalCode: 3669,
    city: "Tamleugh",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6,
    longitude: 145.6333,
    accuracy: 4
  },
  {
    postalCode: 3669,
    city: "Creek Junction",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.25,
    longitude: 147.7167,
    accuracy: 4
  },
  {
    postalCode: 3670,
    city: "Tarnook",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6333,
    longitude: 145.8667,
    accuracy: 3
  },
  {
    postalCode: 3670,
    city: "Warrenbayne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6833,
    longitude: 145.8667,
    accuracy: 4
  },
  {
    postalCode: 3670,
    city: "Baddaginnie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5833,
    longitude: 145.8667,
    accuracy: 4
  },
  {
    postalCode: 3671,
    city: "Benalla",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5511,
    longitude: 145.9843,
    accuracy: 4
  },
  {
    postalCode: 3672,
    city: "Benalla",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5511,
    longitude: 145.9843,
    accuracy: 4
  },
  {
    postalCode: 3673,
    city: "Goomalibee",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4833,
    longitude: 145.9167,
    accuracy: 4
  },
  {
    postalCode: 3673,
    city: "Upper Ryans Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6418,
    longitude: 146.0718,
    accuracy: 3
  },
  {
    postalCode: 3673,
    city: "Tatong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7333,
    longitude: 146.1,
    accuracy: 4
  },
  {
    postalCode: 3673,
    city: "Swanpool",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7667,
    longitude: 146.0167,
    accuracy: 4
  },
  {
    postalCode: 3673,
    city: "Samaria",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8,
    longitude: 146.0833,
    accuracy: 4
  },
  {
    postalCode: 3673,
    city: "Upper Lurg",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5833,
    longitude: 146.1833,
    accuracy: 4
  },
  {
    postalCode: 3673,
    city: "Moorngag",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.75,
    longitude: 146.0667,
    accuracy: 4
  },
  {
    postalCode: 3673,
    city: "Winton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5167,
    longitude: 146.0833,
    accuracy: 4
  },
  {
    postalCode: 3673,
    city: "Benalla",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5511,
    longitude: 145.9843,
    accuracy: 4
  },
  {
    postalCode: 3673,
    city: "Broken Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6418,
    longitude: 146.0718,
    accuracy: 3
  },
  {
    postalCode: 3673,
    city: "Molyullah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.65,
    longitude: 146.15,
    accuracy: 4
  },
  {
    postalCode: 3673,
    city: "Winton North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6418,
    longitude: 146.0718,
    accuracy: 3
  },
  {
    postalCode: 3673,
    city: "Lurg",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5833,
    longitude: 146.1333,
    accuracy: 4
  },
  {
    postalCode: 3673,
    city: "Lima East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6418,
    longitude: 146.0718,
    accuracy: 3
  },
  {
    postalCode: 3673,
    city: "Lima",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.702,
    longitude: 146.0416,
    accuracy: 3
  },
  {
    postalCode: 3673,
    city: "Lima South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6418,
    longitude: 146.0718,
    accuracy: 3
  },
  {
    postalCode: 3675,
    city: "Boweya",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2667,
    longitude: 146.1333,
    accuracy: 4
  },
  {
    postalCode: 3675,
    city: "Greta",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5833,
    longitude: 146.2833,
    accuracy: 4
  },
  {
    postalCode: 3675,
    city: "Taminick",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4167,
    longitude: 146.1667,
    accuracy: 4
  },
  {
    postalCode: 3675,
    city: "Mount Bruno",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.46,
    longitude: 146.2072,
    accuracy: 3
  },
  {
    postalCode: 3675,
    city: "Greta West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5333,
    longitude: 146.2167,
    accuracy: 4
  },
  {
    postalCode: 3675,
    city: "Glenrowan",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4635,
    longitude: 146.2245,
    accuracy: 4
  },
  {
    postalCode: 3675,
    city: "Glenrowan West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.46,
    longitude: 146.2072,
    accuracy: 3
  },
  {
    postalCode: 3675,
    city: "Boweya North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2047,
    longitude: 146.0685,
    accuracy: 4
  },
  {
    postalCode: 3675,
    city: "Greta South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6167,
    longitude: 146.25,
    accuracy: 4
  },
  {
    postalCode: 3675,
    city: "Hansonville",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6,
    longitude: 146.3,
    accuracy: 4
  },
  {
    postalCode: 3676,
    city: "Wangaratta",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3585,
    longitude: 146.3206,
    accuracy: 4
  },
  {
    postalCode: 3677,
    city: "Yarrunga",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3639,
    longitude: 146.3103,
    accuracy: 3
  },
  {
    postalCode: 3677,
    city: "Wangaratta",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3585,
    longitude: 146.3206,
    accuracy: 4
  },
  {
    postalCode: 3677,
    city: "Appin Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3639,
    longitude: 146.3103,
    accuracy: 3
  },
  {
    postalCode: 3678,
    city: "Oxley Flats",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3954,
    longitude: 146.3852,
    accuracy: 4
  },
  {
    postalCode: 3678,
    city: "Rose River",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4375,
    longitude: 146.3894,
    accuracy: 3
  },
  {
    postalCode: 3678,
    city: "Edi",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.65,
    longitude: 146.4071,
    accuracy: 4
  },
  {
    postalCode: 3678,
    city: "Meadow Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4375,
    longitude: 146.3894,
    accuracy: 3
  },
  {
    postalCode: 3678,
    city: "Waldara",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3199,
    longitude: 146.2844,
    accuracy: 4
  },
  {
    postalCode: 3678,
    city: "Everton Upper",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4375,
    longitude: 146.3894,
    accuracy: 3
  },
  {
    postalCode: 3678,
    city: "Tarrawingee",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4,
    longitude: 146.4667,
    accuracy: 4
  },
  {
    postalCode: 3678,
    city: "Boorhaman",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2333,
    longitude: 146.3,
    accuracy: 4
  },
  {
    postalCode: 3678,
    city: "Killawarra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.25,
    longitude: 146.25,
    accuracy: 4
  },
  {
    postalCode: 3678,
    city: "Wangaratta Forward",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4375,
    longitude: 146.3894,
    accuracy: 3
  },
  {
    postalCode: 3678,
    city: "Peechelba",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1947,
    longitude: 146.2299,
    accuracy: 4
  },
  {
    postalCode: 3678,
    city: "Wangandary",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4375,
    longitude: 146.3894,
    accuracy: 3
  },
  {
    postalCode: 3678,
    city: "Bobinawarrah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5167,
    longitude: 146.5,
    accuracy: 4
  },
  {
    postalCode: 3678,
    city: "Wangaratta South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4375,
    longitude: 146.3894,
    accuracy: 3
  },
  {
    postalCode: 3678,
    city: "North Wangaratta",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4375,
    longitude: 146.3894,
    accuracy: 3
  },
  {
    postalCode: 3678,
    city: "King Valley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7,
    longitude: 146.4333,
    accuracy: 4
  },
  {
    postalCode: 3678,
    city: "Edi Upper",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7,
    longitude: 146.45,
    accuracy: 4
  },
  {
    postalCode: 3678,
    city: "Boorhaman East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4375,
    longitude: 146.3894,
    accuracy: 3
  },
  {
    postalCode: 3678,
    city: "Docker",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5167,
    longitude: 146.3833,
    accuracy: 4
  },
  {
    postalCode: 3678,
    city: "Peechelba East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1692,
    longitude: 146.2544,
    accuracy: 4
  },
  {
    postalCode: 3678,
    city: "Markwood",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.473,
    longitude: 146.5088,
    accuracy: 4
  },
  {
    postalCode: 3678,
    city: "Dockers Plains",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4375,
    longitude: 146.3894,
    accuracy: 3
  },
  {
    postalCode: 3678,
    city: "Oxley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.45,
    longitude: 146.3667,
    accuracy: 4
  },
  {
    postalCode: 3678,
    city: "Wabonga",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4375,
    longitude: 146.3894,
    accuracy: 3
  },
  {
    postalCode: 3678,
    city: "Byawatha",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4375,
    longitude: 146.3894,
    accuracy: 3
  },
  {
    postalCode: 3678,
    city: "Cheshunt South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4375,
    longitude: 146.3894,
    accuracy: 3
  },
  {
    postalCode: 3678,
    city: "Londrigan",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3333,
    longitude: 146.4167,
    accuracy: 4
  },
  {
    postalCode: 3678,
    city: "Bowser",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4375,
    longitude: 146.3894,
    accuracy: 3
  },
  {
    postalCode: 3678,
    city: "Everton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4167,
    longitude: 146.55,
    accuracy: 4
  },
  {
    postalCode: 3678,
    city: "Whitlands",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4375,
    longitude: 146.3894,
    accuracy: 3
  },
  {
    postalCode: 3678,
    city: "Cheshunt",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8,
    longitude: 146.4333,
    accuracy: 4
  },
  {
    postalCode: 3678,
    city: "East Wangaratta",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1692,
    longitude: 146.2544,
    accuracy: 4
  },
  {
    postalCode: 3678,
    city: "Laceby",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4333,
    longitude: 146.3,
    accuracy: 4
  },
  {
    postalCode: 3678,
    city: "Carboor",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6333,
    longitude: 146.55,
    accuracy: 4
  },
  {
    postalCode: 3678,
    city: "Milawa",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4333,
    longitude: 146.4333,
    accuracy: 4
  },
  {
    postalCode: 3682,
    city: "Norong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1167,
    longitude: 146.4,
    accuracy: 4
  },
  {
    postalCode: 3682,
    city: "Boralma",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2167,
    longitude: 146.4167,
    accuracy: 4
  },
  {
    postalCode: 3682,
    city: "Springhurst",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2,
    longitude: 146.5,
    accuracy: 4
  },
  {
    postalCode: 3682,
    city: "Lilliput",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1131,
    longitude: 146.4751,
    accuracy: 4
  },
  {
    postalCode: 3683,
    city: "Chiltern Valley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1399,
    longitude: 146.5408,
    accuracy: 4
  },
  {
    postalCode: 3683,
    city: "Cornishtown",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1419,
    longitude: 146.5709,
    accuracy: 3
  },
  {
    postalCode: 3683,
    city: "Chiltern",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1504,
    longitude: 146.6084,
    accuracy: 4
  },
  {
    postalCode: 3685,
    city: "Prentice North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0333,
    longitude: 146.5,
    accuracy: 4
  },
  {
    postalCode: 3685,
    city: "Boorhaman North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.045,
    longitude: 146.5117,
    accuracy: 3
  },
  {
    postalCode: 3685,
    city: "Browns Plains",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0472,
    longitude: 146.6387,
    accuracy: 4
  },
  {
    postalCode: 3685,
    city: "Brimin",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0513,
    longitude: 146.2249,
    accuracy: 4
  },
  {
    postalCode: 3685,
    city: "Rutherglen",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0543,
    longitude: 146.4621,
    accuracy: 4
  },
  {
    postalCode: 3685,
    city: "Gooramadda",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36,
    longitude: 146.55,
    accuracy: 4
  },
  {
    postalCode: 3685,
    city: "Great Southern",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0667,
    longitude: 146.4833,
    accuracy: 4
  },
  {
    postalCode: 3685,
    city: "Carlyle",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0427,
    longitude: 146.4824,
    accuracy: 3
  },
  {
    postalCode: 3687,
    city: "Wahgunyah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0118,
    longitude: 146.3971,
    accuracy: 4
  },
  {
    postalCode: 3688,
    city: "Indigo Valley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1399,
    longitude: 146.5408,
    accuracy: 4
  },
  {
    postalCode: 3688,
    city: "Barnawartha",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1041,
    longitude: 146.6761,
    accuracy: 4
  },
  {
    postalCode: 3689,
    city: "Wodonga",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1218,
    longitude: 146.8881,
    accuracy: 4
  },
  {
    postalCode: 3690,
    city: "Wodonga",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1218,
    longitude: 146.8881,
    accuracy: 4
  },
  {
    postalCode: 3690,
    city: "Wodonga Plaza",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0997,
    longitude: 146.802,
    accuracy: 3
  },
  {
    postalCode: 3690,
    city: "West Wodonga",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1218,
    longitude: 146.8881,
    accuracy: 3
  },
  {
    postalCode: 3691,
    city: "Killara",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1396,
    longitude: 146.9514,
    accuracy: 4
  },
  {
    postalCode: 3691,
    city: "Castle Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2843,
    longitude: 147.0692,
    accuracy: 3
  },
  {
    postalCode: 3691,
    city: "Upper Gundowring",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4833,
    longitude: 147.0667,
    accuracy: 4
  },
  {
    postalCode: 3691,
    city: "Bandiana",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1479,
    longitude: 146.9262,
    accuracy: 4
  },
  {
    postalCode: 3691,
    city: "Bethanga",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1167,
    longitude: 147.1,
    accuracy: 4
  },
  {
    postalCode: 3691,
    city: "Baranduda",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1911,
    longitude: 146.9538,
    accuracy: 4
  },
  {
    postalCode: 3691,
    city: "Allans Flat",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2667,
    longitude: 146.9,
    accuracy: 4
  },
  {
    postalCode: 3691,
    city: "Mount Alfred",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2959,
    longitude: 147.0534,
    accuracy: 3
  },
  {
    postalCode: 3691,
    city: "Bellbridge",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0974,
    longitude: 147.0617,
    accuracy: 4
  },
  {
    postalCode: 3691,
    city: "Kergunyah South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2843,
    longitude: 147.0692,
    accuracy: 3
  },
  {
    postalCode: 3691,
    city: "Berringama",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2167,
    longitude: 147.65,
    accuracy: 4
  },
  {
    postalCode: 3691,
    city: "Coral Bank",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2843,
    longitude: 147.0692,
    accuracy: 3
  },
  {
    postalCode: 3691,
    city: "Talgarno",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0833,
    longitude: 147.1667,
    accuracy: 4
  },
  {
    postalCode: 3691,
    city: "Kergunyah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3833,
    longitude: 147.05,
    accuracy: 4
  },
  {
    postalCode: 3691,
    city: "Gundowring",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4333,
    longitude: 147.05,
    accuracy: 4
  },
  {
    postalCode: 3691,
    city: "Lone Pine",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2959,
    longitude: 147.0534,
    accuracy: 3
  },
  {
    postalCode: 3691,
    city: "Glen Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.45,
    longitude: 146.95,
    accuracy: 4
  },
  {
    postalCode: 3691,
    city: "Tangambalanga",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2522,
    longitude: 147.0286,
    accuracy: 4
  },
  {
    postalCode: 3691,
    city: "Dederang",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4833,
    longitude: 147.0167,
    accuracy: 4
  },
  {
    postalCode: 3691,
    city: "Wodonga Forward",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2843,
    longitude: 147.0692,
    accuracy: 3
  },
  {
    postalCode: 3691,
    city: "Hume Weir",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1022,
    longitude: 147.0373,
    accuracy: 4
  },
  {
    postalCode: 3691,
    city: "Bonegilla",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1403,
    longitude: 147.0062,
    accuracy: 4
  },
  {
    postalCode: 3691,
    city: "Kancoona",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5833,
    longitude: 146.9833,
    accuracy: 4
  },
  {
    postalCode: 3691,
    city: "Thologolong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2843,
    longitude: 147.0692,
    accuracy: 3
  },
  {
    postalCode: 3691,
    city: "Running Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6167,
    longitude: 146.9167,
    accuracy: 4
  },
  {
    postalCode: 3691,
    city: "Kiewa",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2667,
    longitude: 147.0167,
    accuracy: 4
  },
  {
    postalCode: 3691,
    city: "Bungil",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0667,
    longitude: 147.35,
    accuracy: 4
  },
  {
    postalCode: 3691,
    city: "Gateway Island",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2843,
    longitude: 147.0692,
    accuracy: 3
  },
  {
    postalCode: 3691,
    city: "Lucyvale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2833,
    longitude: 147.6167,
    accuracy: 4
  },
  {
    postalCode: 3691,
    city: "Osbornes Flat",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3167,
    longitude: 146.8833,
    accuracy: 4
  },
  {
    postalCode: 3691,
    city: "Leneva",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2167,
    longitude: 146.9,
    accuracy: 4
  },
  {
    postalCode: 3691,
    city: "Barnawartha North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2843,
    longitude: 147.0692,
    accuracy: 3
  },
  {
    postalCode: 3691,
    city: "Mongans Bridge",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6,
    longitude: 147.1,
    accuracy: 4
  },
  {
    postalCode: 3691,
    city: "Huon Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2843,
    longitude: 147.0692,
    accuracy: 3
  },
  {
    postalCode: 3691,
    city: "Staghorn Flat",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2522,
    longitude: 146.9228,
    accuracy: 3
  },
  {
    postalCode: 3691,
    city: "Ebden",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.153,
    longitude: 147.0252,
    accuracy: 4
  },
  {
    postalCode: 3694,
    city: "Bandiana Milpo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1454,
    longitude: 146.9188,
    accuracy: 1
  },
  {
    postalCode: 3695,
    city: "Huon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2333,
    longitude: 147.0667,
    accuracy: 4
  },
  {
    postalCode: 3695,
    city: "Charleroi",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.332,
    longitude: 147.1146,
    accuracy: 3
  },
  {
    postalCode: 3695,
    city: "Sandy Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3,
    longitude: 147.1,
    accuracy: 4
  },
  {
    postalCode: 3695,
    city: "Red Bluff",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2667,
    longitude: 147.1,
    accuracy: 4
  },
  {
    postalCode: 3697,
    city: "Tawonga",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6895,
    longitude: 147.1421,
    accuracy: 4
  },
  {
    postalCode: 3698,
    city: "Tawonga South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7359,
    longitude: 147.1521,
    accuracy: 1
  },
  {
    postalCode: 3699,
    city: "Mount Beauty",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7363,
    longitude: 147.1753,
    accuracy: 4
  },
  {
    postalCode: 3699,
    city: "Nelse",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8005,
    longitude: 147.2233,
    accuracy: 3
  },
  {
    postalCode: 3699,
    city: "Falls Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8653,
    longitude: 147.2778,
    accuracy: 4
  },
  {
    postalCode: 3699,
    city: "Bogong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8047,
    longitude: 147.2237,
    accuracy: 4
  },
  {
    postalCode: 3700,
    city: "Georges Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1833,
    longitude: 147.2833,
    accuracy: 4
  },
  {
    postalCode: 3700,
    city: "Tallangatta",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2179,
    longitude: 147.177,
    accuracy: 4
  },
  {
    postalCode: 3700,
    city: "Jarvis Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2004,
    longitude: 147.2646,
    accuracy: 3
  },
  {
    postalCode: 3700,
    city: "Bullioh",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2,
    longitude: 147.3333,
    accuracy: 4
  },
  {
    postalCode: 3700,
    city: "Tallangatta East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2004,
    longitude: 147.2646,
    accuracy: 3
  },
  {
    postalCode: 3701,
    city: "Tallandoon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.45,
    longitude: 147.2,
    accuracy: 4
  },
  {
    postalCode: 3701,
    city: "Shelley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4158,
    longitude: 147.4436,
    accuracy: 3
  },
  {
    postalCode: 3701,
    city: "Old Tallangatta",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1929,
    longitude: 147.2521,
    accuracy: 4
  },
  {
    postalCode: 3701,
    city: "Tallangatta South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3737,
    longitude: 147.3266,
    accuracy: 3
  },
  {
    postalCode: 3701,
    city: "Mitta Mitta",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.55,
    longitude: 147.3833,
    accuracy: 4
  },
  {
    postalCode: 3701,
    city: "Eskdale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4667,
    longitude: 147.2333,
    accuracy: 4
  },
  {
    postalCode: 3701,
    city: "Tallangatta Valley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2936,
    longitude: 147.389,
    accuracy: 4
  },
  {
    postalCode: 3701,
    city: "Dartmouth",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5462,
    longitude: 147.5116,
    accuracy: 4
  },
  {
    postalCode: 3701,
    city: "Granya",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1167,
    longitude: 147.3167,
    accuracy: 4
  },
  {
    postalCode: 3704,
    city: "Koetong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.15,
    longitude: 147.5,
    accuracy: 4
  },
  {
    postalCode: 3705,
    city: "Nariel Valley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3112,
    longitude: 147.726,
    accuracy: 3
  },
  {
    postalCode: 3705,
    city: "Cudgewa",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2,
    longitude: 147.75,
    accuracy: 4
  },
  {
    postalCode: 3707,
    city: "Biggara",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2667,
    longitude: 148.0333,
    accuracy: 4
  },
  {
    postalCode: 3707,
    city: "Tom Groggin",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5192,
    longitude: 148.127,
    accuracy: 4
  },
  {
    postalCode: 3707,
    city: "Towong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1333,
    longitude: 147.9833,
    accuracy: 4
  },
  {
    postalCode: 3707,
    city: "Corryong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.197,
    longitude: 147.9026,
    accuracy: 4
  },
  {
    postalCode: 3707,
    city: "Thowgla Valley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4104,
    longitude: 147.9589,
    accuracy: 3
  },
  {
    postalCode: 3707,
    city: "Colac Colac",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4104,
    longitude: 147.9589,
    accuracy: 3
  },
  {
    postalCode: 3707,
    city: "Towong Upper",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2167,
    longitude: 148.0333,
    accuracy: 4
  },
  {
    postalCode: 3707,
    city: "Nariel Valley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2034,
    longitude: 147.9881,
    accuracy: 3
  },
  {
    postalCode: 3708,
    city: "Tintaldra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.05,
    longitude: 147.9333,
    accuracy: 4
  },
  {
    postalCode: 3709,
    city: "Walwa",
    state_name: "Victoria",
    state: "VIC",
    latitude: -35.9667,
    longitude: 147.7333,
    accuracy: 4
  },
  {
    postalCode: 3709,
    city: "Mount Alfred",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0222,
    longitude: 147.6444,
    accuracy: 3
  },
  {
    postalCode: 3709,
    city: "Burrowye",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0333,
    longitude: 147.55,
    accuracy: 4
  },
  {
    postalCode: 3709,
    city: "Guys Forest",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0667,
    longitude: 147.65,
    accuracy: 4
  },
  {
    postalCode: 3709,
    city: "Pine Mountain",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0222,
    longitude: 147.6444,
    accuracy: 3
  },
  {
    postalCode: 3711,
    city: "Buxton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4167,
    longitude: 145.7167,
    accuracy: 4
  },
  {
    postalCode: 3712,
    city: "Thornton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2558,
    longitude: 145.7964,
    accuracy: 4
  },
  {
    postalCode: 3712,
    city: "Rubicon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.256,
    longitude: 145.7977,
    accuracy: 3
  },
  {
    postalCode: 3713,
    city: "Eildon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2324,
    longitude: 145.9126,
    accuracy: 4
  },
  {
    postalCode: 3713,
    city: "Lake Eildon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2324,
    longitude: 145.9126,
    accuracy: 3
  },
  {
    postalCode: 3713,
    city: "Taylor Bay",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2324,
    longitude: 145.9126,
    accuracy: 3
  },
  {
    postalCode: 3714,
    city: "Alexandra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1913,
    longitude: 145.7112,
    accuracy: 4
  },
  {
    postalCode: 3714,
    city: "Acheron",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.25,
    longitude: 145.7,
    accuracy: 4
  },
  {
    postalCode: 3714,
    city: "Cathkin",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.15,
    longitude: 145.5833,
    accuracy: 4
  },
  {
    postalCode: 3714,
    city: "Maintongoon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2041,
    longitude: 145.6741,
    accuracy: 3
  },
  {
    postalCode: 3714,
    city: "Koriella",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1667,
    longitude: 145.65,
    accuracy: 4
  },
  {
    postalCode: 3714,
    city: "Whanregarwen",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2041,
    longitude: 145.6741,
    accuracy: 3
  },
  {
    postalCode: 3714,
    city: "Fawcett",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1333,
    longitude: 145.6833,
    accuracy: 4
  },
  {
    postalCode: 3714,
    city: "Crystal Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2041,
    longitude: 145.6741,
    accuracy: 3
  },
  {
    postalCode: 3714,
    city: "Taggerty",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3333,
    longitude: 145.7167,
    accuracy: 4
  },
  {
    postalCode: 3714,
    city: "Devils River",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2041,
    longitude: 145.6741,
    accuracy: 3
  },
  {
    postalCode: 3715,
    city: "Merton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9768,
    longitude: 145.7108,
    accuracy: 4
  },
  {
    postalCode: 3715,
    city: "Ancona",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9833,
    longitude: 145.8167,
    accuracy: 4
  },
  {
    postalCode: 3715,
    city: "Woodfield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0167,
    longitude: 145.8,
    accuracy: 4
  },
  {
    postalCode: 3717,
    city: "Flowerdale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3333,
    longitude: 145.3333,
    accuracy: 4
  },
  {
    postalCode: 3717,
    city: "Homewood",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2,
    longitude: 145.3333,
    accuracy: 4
  },
  {
    postalCode: 3717,
    city: "Killingworth",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2962,
    longitude: 145.424,
    accuracy: 3
  },
  {
    postalCode: 3717,
    city: "Yea",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2107,
    longitude: 145.4276,
    accuracy: 4
  },
  {
    postalCode: 3717,
    city: "Limestone",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.25,
    longitude: 145.5,
    accuracy: 4
  },
  {
    postalCode: 3717,
    city: "Murrindindi",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3667,
    longitude: 145.5333,
    accuracy: 4
  },
  {
    postalCode: 3717,
    city: "Ghin Ghin",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2962,
    longitude: 145.424,
    accuracy: 3
  },
  {
    postalCode: 3717,
    city: "Glenburn",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4167,
    longitude: 145.4167,
    accuracy: 4
  },
  {
    postalCode: 3718,
    city: "Molesworth",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1667,
    longitude: 145.5333,
    accuracy: 4
  },
  {
    postalCode: 3719,
    city: "Yarck",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1,
    longitude: 145.6167,
    accuracy: 4
  },
  {
    postalCode: 3719,
    city: "Gobur",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0167,
    longitude: 145.6,
    accuracy: 4
  },
  {
    postalCode: 3719,
    city: "Terip Terip",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37,
    longitude: 145.5667,
    accuracy: 4
  },
  {
    postalCode: 3719,
    city: "Kanumbra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.05,
    longitude: 145.6667,
    accuracy: 4
  },
  {
    postalCode: 3720,
    city: "Bonnie Doon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0167,
    longitude: 145.8667,
    accuracy: 4
  },
  {
    postalCode: 3722,
    city: "Barwite",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37,
    longitude: 146.1667,
    accuracy: 4
  },
  {
    postalCode: 3722,
    city: "Mirimbah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1103,
    longitude: 146.3985,
    accuracy: 4
  },
  {
    postalCode: 3722,
    city: "Mansfield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.052,
    longitude: 146.0885,
    accuracy: 4
  },
  {
    postalCode: 3723,
    city: "Howes Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1667,
    longitude: 146,
    accuracy: 4
  },
  {
    postalCode: 3723,
    city: "Howqua Inlet",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.251,
    longitude: 146.1822,
    accuracy: 3
  },
  {
    postalCode: 3723,
    city: "Gaffneys Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4667,
    longitude: 146.1833,
    accuracy: 4
  },
  {
    postalCode: 3723,
    city: "Enochs Point",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4167,
    longitude: 146.1,
    accuracy: 4
  },
  {
    postalCode: 3723,
    city: "Archerton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8833,
    longitude: 146.2,
    accuracy: 4
  },
  {
    postalCode: 3723,
    city: "Sawmill Settlement",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.251,
    longitude: 146.1822,
    accuracy: 3
  },
  {
    postalCode: 3723,
    city: "Knockwood",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.45,
    longitude: 146.2333,
    accuracy: 4
  },
  {
    postalCode: 3723,
    city: "Howqua",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2333,
    longitude: 146.1167,
    accuracy: 4
  },
  {
    postalCode: 3723,
    city: "Mount Buller",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.146,
    longitude: 146.4369,
    accuracy: 4
  },
  {
    postalCode: 3723,
    city: "Mountain Bay",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.251,
    longitude: 146.1822,
    accuracy: 3
  },
  {
    postalCode: 3723,
    city: "Goughs Bay",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1767,
    longitude: 146.0635,
    accuracy: 3
  },
  {
    postalCode: 3723,
    city: "Howqua Hills",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2598,
    longitude: 146.4295,
    accuracy: 4
  },
  {
    postalCode: 3723,
    city: "Delatite",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.15,
    longitude: 146.1333,
    accuracy: 4
  },
  {
    postalCode: 3723,
    city: "Kevington",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3667,
    longitude: 146.15,
    accuracy: 4
  },
  {
    postalCode: 3723,
    city: "Piries",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2,
    longitude: 146.1333,
    accuracy: 4
  },
  {
    postalCode: 3723,
    city: "Matlock",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6,
    longitude: 146.2167,
    accuracy: 4
  },
  {
    postalCode: 3723,
    city: "Merrijig",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1,
    longitude: 146.25,
    accuracy: 4
  },
  {
    postalCode: 3723,
    city: "Barjarg",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.251,
    longitude: 146.1822,
    accuracy: 3
  },
  {
    postalCode: 3723,
    city: "Maindample",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0333,
    longitude: 145.9333,
    accuracy: 4
  },
  {
    postalCode: 3723,
    city: "Boorolite",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.251,
    longitude: 146.1822,
    accuracy: 3
  },
  {
    postalCode: 3723,
    city: "Woods Point",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5833,
    longitude: 146.25,
    accuracy: 4
  },
  {
    postalCode: 3723,
    city: "Bridge Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.251,
    longitude: 146.1822,
    accuracy: 3
  },
  {
    postalCode: 3723,
    city: "Macs Cove",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2125,
    longitude: 146.1464,
    accuracy: 4
  },
  {
    postalCode: 3723,
    city: "Jamieson",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3167,
    longitude: 146.1333,
    accuracy: 4
  },
  {
    postalCode: 3723,
    city: "Tolmie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9333,
    longitude: 146.2333,
    accuracy: 4
  },
  {
    postalCode: 3724,
    city: "Mansfield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.052,
    longitude: 146.0885,
    accuracy: 4
  },
  {
    postalCode: 3725,
    city: "Goorambat",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4167,
    longitude: 145.9167,
    accuracy: 4
  },
  {
    postalCode: 3725,
    city: "Chesney Vale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3833,
    longitude: 145.8292,
    accuracy: 3
  },
  {
    postalCode: 3725,
    city: "Boxwood",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3167,
    longitude: 145.8,
    accuracy: 4
  },
  {
    postalCode: 3725,
    city: "Major Plains",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3667,
    longitude: 145.8,
    accuracy: 4
  },
  {
    postalCode: 3725,
    city: "Stewarton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4333,
    longitude: 145.8,
    accuracy: 4
  },
  {
    postalCode: 3726,
    city: "Bungeet",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3,
    longitude: 146.05,
    accuracy: 4
  },
  {
    postalCode: 3726,
    city: "Bungeet West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3167,
    longitude: 146.0056,
    accuracy: 3
  },
  {
    postalCode: 3726,
    city: "Thoona",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3167,
    longitude: 146.0667,
    accuracy: 4
  },
  {
    postalCode: 3726,
    city: "Devenish",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3333,
    longitude: 145.9,
    accuracy: 4
  },
  {
    postalCode: 3727,
    city: "Yundool",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2667,
    longitude: 145.8333,
    accuracy: 4
  },
  {
    postalCode: 3727,
    city: "Almonds",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2,
    longitude: 145.9667,
    accuracy: 4
  },
  {
    postalCode: 3727,
    city: "Lake Rowan",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2667,
    longitude: 145.9667,
    accuracy: 4
  },
  {
    postalCode: 3727,
    city: "Pelluebla",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.25,
    longitude: 145.9167,
    accuracy: 3
  },
  {
    postalCode: 3727,
    city: "St James",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2667,
    longitude: 145.9,
    accuracy: 4
  },
  {
    postalCode: 3728,
    city: "Tungamah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.161,
    longitude: 145.8768,
    accuracy: 4
  },
  {
    postalCode: 3728,
    city: "Boomahnoomoonah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1265,
    longitude: 146.1321,
    accuracy: 4
  },
  {
    postalCode: 3728,
    city: "Wilby",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1574,
    longitude: 146.022,
    accuracy: 4
  },
  {
    postalCode: 3728,
    city: "Youarang",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.1767,
    longitude: 145.791,
    accuracy: 4
  },
  {
    postalCode: 3730,
    city: "Burramine",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0639,
    longitude: 145.854,
    accuracy: 4
  },
  {
    postalCode: 3730,
    city: "Yarrawonga",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0192,
    longitude: 145.9997,
    accuracy: 4
  },
  {
    postalCode: 3730,
    city: "Esmond",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0797,
    longitude: 146.1833,
    accuracy: 4
  },
  {
    postalCode: 3730,
    city: "Boosey",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.05,
    longitude: 145.7833,
    accuracy: 4
  },
  {
    postalCode: 3730,
    city: "Bathumi",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0367,
    longitude: 146.0793,
    accuracy: 4
  },
  {
    postalCode: 3730,
    city: "Bundalong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0298,
    longitude: 146.1581,
    accuracy: 4
  },
  {
    postalCode: 3730,
    city: "Yarrawonga South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0521,
    longitude: 146.0092,
    accuracy: 3
  },
  {
    postalCode: 3730,
    city: "Telford",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0966,
    longitude: 145.9337,
    accuracy: 4
  },
  {
    postalCode: 3730,
    city: "Burramine South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0639,
    longitude: 145.854,
    accuracy: 4
  },
  {
    postalCode: 3730,
    city: "Bundalong South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.0955,
    longitude: 146.1876,
    accuracy: 4
  },
  {
    postalCode: 3732,
    city: "Moyhu",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.578,
    longitude: 146.3784,
    accuracy: 4
  },
  {
    postalCode: 3732,
    city: "Myrrhee",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.75,
    longitude: 146.3167,
    accuracy: 4
  },
  {
    postalCode: 3733,
    city: "Whitfield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7833,
    longitude: 146.4167,
    accuracy: 4
  },
  {
    postalCode: 3735,
    city: "Whorouly South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.55,
    longitude: 146.5833,
    accuracy: 4
  },
  {
    postalCode: 3735,
    city: "Whorouly",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5167,
    longitude: 146.6,
    accuracy: 4
  },
  {
    postalCode: 3735,
    city: "Bowmans Forest",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5706,
    longitude: 146.5783,
    accuracy: 3
  },
  {
    postalCode: 3735,
    city: "Whorouly East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5333,
    longitude: 146.5917,
    accuracy: 3
  },
  {
    postalCode: 3736,
    city: "Myrtleford",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.561,
    longitude: 146.7237,
    accuracy: 4
  },
  {
    postalCode: 3737,
    city: "Buffalo River",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6333,
    longitude: 146.6833,
    accuracy: 4
  },
  {
    postalCode: 3737,
    city: "Abbeyard",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6267,
    longitude: 146.7254,
    accuracy: 3
  },
  {
    postalCode: 3737,
    city: "Myrtleford",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.561,
    longitude: 146.7237,
    accuracy: 4
  },
  {
    postalCode: 3737,
    city: "Gapsted",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5167,
    longitude: 146.6833,
    accuracy: 4
  },
  {
    postalCode: 3737,
    city: "Mudgegonga",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4897,
    longitude: 146.8658,
    accuracy: 3
  },
  {
    postalCode: 3737,
    city: "Nug Nug",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6656,
    longitude: 146.7178,
    accuracy: 4
  },
  {
    postalCode: 3737,
    city: "Merriang South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6267,
    longitude: 146.7254,
    accuracy: 3
  },
  {
    postalCode: 3737,
    city: "Havilah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6267,
    longitude: 146.7254,
    accuracy: 3
  },
  {
    postalCode: 3737,
    city: "Wonnangatta",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6267,
    longitude: 146.7254,
    accuracy: 3
  },
  {
    postalCode: 3737,
    city: "Rosewhite",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5833,
    longitude: 146.8773,
    accuracy: 4
  },
  {
    postalCode: 3737,
    city: "Merriang",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6267,
    longitude: 146.7254,
    accuracy: 3
  },
  {
    postalCode: 3737,
    city: "Barwidgee",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6267,
    longitude: 146.7254,
    accuracy: 3
  },
  {
    postalCode: 3737,
    city: "Selwyn",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6267,
    longitude: 146.7254,
    accuracy: 3
  },
  {
    postalCode: 3737,
    city: "Dandongadale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8,
    longitude: 146.6667,
    accuracy: 4
  },
  {
    postalCode: 3738,
    city: "Ovens",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.5874,
    longitude: 146.7593,
    accuracy: 4
  },
  {
    postalCode: 3739,
    city: "Eurobin",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6352,
    longitude: 146.8596,
    accuracy: 4
  },
  {
    postalCode: 3740,
    city: "Mount Buffalo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7829,
    longitude: 146.8699,
    accuracy: 3
  },
  {
    postalCode: 3740,
    city: "Porepunkah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.6961,
    longitude: 146.9104,
    accuracy: 4
  },
  {
    postalCode: 3740,
    city: "Buckland",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8833,
    longitude: 146.85,
    accuracy: 4
  },
  {
    postalCode: 3741,
    city: "Smoko",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8202,
    longitude: 147.0642,
    accuracy: 4
  },
  {
    postalCode: 3741,
    city: "Mount Hotham",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0712,
    longitude: 147.0949,
    accuracy: 3
  },
  {
    postalCode: 3741,
    city: "Bright",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.73,
    longitude: 146.9598,
    accuracy: 4
  },
  {
    postalCode: 3741,
    city: "Germantown",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7427,
    longitude: 147.0153,
    accuracy: 4
  },
  {
    postalCode: 3741,
    city: "Hotham Heights",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.993,
    longitude: 147.1523,
    accuracy: 4
  },
  {
    postalCode: 3741,
    city: "Harrietville",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8915,
    longitude: 147.0619,
    accuracy: 4
  },
  {
    postalCode: 3741,
    city: "Freeburgh",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7599,
    longitude: 147.0263,
    accuracy: 4
  },
  {
    postalCode: 3744,
    city: "Wandiligong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.7833,
    longitude: 146.9833,
    accuracy: 4
  },
  {
    postalCode: 3746,
    city: "Eldorado",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3,
    longitude: 146.5167,
    accuracy: 4
  },
  {
    postalCode: 3747,
    city: "Wooragee",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.2833,
    longitude: 146.7833,
    accuracy: 4
  },
  {
    postalCode: 3747,
    city: "Baarmutha",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4167,
    longitude: 146.6833,
    accuracy: 4
  },
  {
    postalCode: 3747,
    city: "Murmungee",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.45,
    longitude: 146.6833,
    accuracy: 4
  },
  {
    postalCode: 3747,
    city: "Stanley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4167,
    longitude: 146.75,
    accuracy: 4
  },
  {
    postalCode: 3747,
    city: "Beechworth",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3583,
    longitude: 146.6858,
    accuracy: 4
  },
  {
    postalCode: 3749,
    city: "Bruarong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.4167,
    longitude: 146.85,
    accuracy: 4
  },
  {
    postalCode: 3749,
    city: "Yackandandah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3137,
    longitude: 146.8396,
    accuracy: 4
  },
  {
    postalCode: 3750,
    city: "Wollert",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5833,
    longitude: 145.0333,
    accuracy: 4
  },
  {
    postalCode: 3751,
    city: "Woodstock",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.55,
    longitude: 145.0333,
    accuracy: 4
  },
  {
    postalCode: 3752,
    city: "South Morang",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.65,
    longitude: 145.1,
    accuracy: 4
  },
  {
    postalCode: 3753,
    city: "Beveridge",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4833,
    longitude: 144.9833,
    accuracy: 4
  },
  {
    postalCode: 3754,
    city: "Mernda",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6007,
    longitude: 145.0956,
    accuracy: 4
  },
  {
    postalCode: 3754,
    city: "Doreen",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6,
    longitude: 145.15,
    accuracy: 4
  },
  {
    postalCode: 3755,
    city: "Yan Yean",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5667,
    longitude: 145.1,
    accuracy: 4
  },
  {
    postalCode: 3756,
    city: "Hidden Valley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4369,
    longitude: 144.8946,
    accuracy: 3
  },
  {
    postalCode: 3756,
    city: "Upper Plenty",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4197,
    longitude: 145.0547,
    accuracy: 4
  },
  {
    postalCode: 3756,
    city: "Chintin",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.418,
    longitude: 145.0166,
    accuracy: 3
  },
  {
    postalCode: 3756,
    city: "Wallan",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4162,
    longitude: 144.9786,
    accuracy: 4
  },
  {
    postalCode: 3756,
    city: "Darraweit Guim",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4369,
    longitude: 144.8946,
    accuracy: 3
  },
  {
    postalCode: 3757,
    city: "Kinglake Central",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5,
    longitude: 145.3,
    accuracy: 4
  },
  {
    postalCode: 3757,
    city: "Pheasant Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4833,
    longitude: 145.2833,
    accuracy: 4
  },
  {
    postalCode: 3757,
    city: "Humevale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5,
    longitude: 145.1667,
    accuracy: 4
  },
  {
    postalCode: 3757,
    city: "Kinglake West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4667,
    longitude: 145.2333,
    accuracy: 4
  },
  {
    postalCode: 3757,
    city: "Whittlesea",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5115,
    longitude: 145.1184,
    accuracy: 4
  },
  {
    postalCode: 3757,
    city: "Eden Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4833,
    longitude: 145.0833,
    accuracy: 4
  },
  {
    postalCode: 3758,
    city: "Wandong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3719,
    longitude: 145.0321,
    accuracy: 4
  },
  {
    postalCode: 3758,
    city: "Heathcote Junction",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3719,
    longitude: 145.0321,
    accuracy: 4
  },
  {
    postalCode: 3759,
    city: "Panton Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6408,
    longitude: 145.2399,
    accuracy: 4
  },
  {
    postalCode: 3760,
    city: "Smiths Gully",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6202,
    longitude: 145.2603,
    accuracy: 4
  },
  {
    postalCode: 3761,
    city: "St Andrews",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5782,
    longitude: 145.3074,
    accuracy: 1
  },
  {
    postalCode: 3762,
    city: "Bylands",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.35,
    longitude: 144.9667,
    accuracy: 4
  },
  {
    postalCode: 3763,
    city: "Kinglake",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5329,
    longitude: 145.3396,
    accuracy: 4
  },
  {
    postalCode: 3764,
    city: "Tantaraboo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4658,
    longitude: 145.0672,
    accuracy: 3
  },
  {
    postalCode: 3764,
    city: "Kilmore",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2958,
    longitude: 144.9525,
    accuracy: 4
  },
  {
    postalCode: 3764,
    city: "High Camp",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1833,
    longitude: 144.9,
    accuracy: 4
  },
  {
    postalCode: 3764,
    city: "Kilmore East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3,
    longitude: 144.9833,
    accuracy: 4
  },
  {
    postalCode: 3764,
    city: "Moranding",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4658,
    longitude: 145.0672,
    accuracy: 3
  },
  {
    postalCode: 3764,
    city: "Forbes",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.45,
    longitude: 145.5333,
    accuracy: 4
  },
  {
    postalCode: 3764,
    city: "Glenaroua",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1,
    longitude: 144.9667,
    accuracy: 4
  },
  {
    postalCode: 3764,
    city: "Willowmavin",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4658,
    longitude: 145.0672,
    accuracy: 3
  },
  {
    postalCode: 3765,
    city: "Montrose",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8167,
    longitude: 145.35,
    accuracy: 4
  },
  {
    postalCode: 3766,
    city: "Kalorama",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8167,
    longitude: 145.3667,
    accuracy: 4
  },
  {
    postalCode: 3767,
    city: "Mount Dandenong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8333,
    longitude: 145.3667,
    accuracy: 4
  },
  {
    postalCode: 3770,
    city: "Coldstream",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7249,
    longitude: 145.378,
    accuracy: 4
  },
  {
    postalCode: 3770,
    city: "Gruyere",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7333,
    longitude: 145.45,
    accuracy: 4
  },
  {
    postalCode: 3770,
    city: "Yering",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7,
    longitude: 145.3667,
    accuracy: 4
  },
  {
    postalCode: 3775,
    city: "Dixons Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6,
    longitude: 145.4167,
    accuracy: 4
  },
  {
    postalCode: 3775,
    city: "Yarra Glen",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6579,
    longitude: 145.3742,
    accuracy: 4
  },
  {
    postalCode: 3775,
    city: "Christmas Hills",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.65,
    longitude: 145.3333,
    accuracy: 4
  },
  {
    postalCode: 3775,
    city: "Steels Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5833,
    longitude: 145.3833,
    accuracy: 4
  },
  {
    postalCode: 3775,
    city: "Tarrawarra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.65,
    longitude: 145.4333,
    accuracy: 4
  },
  {
    postalCode: 3777,
    city: "Healesville",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.654,
    longitude: 145.5172,
    accuracy: 4
  },
  {
    postalCode: 3777,
    city: "Chum Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6051,
    longitude: 145.4874,
    accuracy: 4
  },
  {
    postalCode: 3777,
    city: "Healesville Main Street",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6018,
    longitude: 145.4842,
    accuracy: 3
  },
  {
    postalCode: 3777,
    city: "Badger Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7,
    longitude: 145.5167,
    accuracy: 4
  },
  {
    postalCode: 3777,
    city: "Toolangi",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5333,
    longitude: 145.4667,
    accuracy: 4
  },
  {
    postalCode: 3777,
    city: "Castella",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5167,
    longitude: 145.4333,
    accuracy: 4
  },
  {
    postalCode: 3777,
    city: "Mount Toolebewong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6984,
    longitude: 145.5625,
    accuracy: 4
  },
  {
    postalCode: 3778,
    city: "Narbethong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5639,
    longitude: 145.6557,
    accuracy: 4
  },
  {
    postalCode: 3778,
    city: "Fernshaw",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6,
    longitude: 145.6333,
    accuracy: 4
  },
  {
    postalCode: 3779,
    city: "Cambarville",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5588,
    longitude: 145.8906,
    accuracy: 4
  },
  {
    postalCode: 3779,
    city: "Marysville",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5098,
    longitude: 145.7481,
    accuracy: 4
  },
  {
    postalCode: 3781,
    city: "Mount Burnett",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9833,
    longitude: 145.5,
    accuracy: 4
  },
  {
    postalCode: 3781,
    city: "Nangana",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8667,
    longitude: 145.5333,
    accuracy: 4
  },
  {
    postalCode: 3781,
    city: "Cockatoo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9368,
    longitude: 145.4938,
    accuracy: 4
  },
  {
    postalCode: 3782,
    city: "Avonsleigh",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9333,
    longitude: 145.4667,
    accuracy: 4
  },
  {
    postalCode: 3782,
    city: "Macclesfield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8833,
    longitude: 145.4833,
    accuracy: 4
  },
  {
    postalCode: 3782,
    city: "Clematis",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9333,
    longitude: 145.4167,
    accuracy: 4
  },
  {
    postalCode: 3782,
    city: "Emerald",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9317,
    longitude: 145.4409,
    accuracy: 4
  },
  {
    postalCode: 3783,
    city: "Gembrook",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9532,
    longitude: 145.5554,
    accuracy: 4
  },
  {
    postalCode: 3785,
    city: "Tremont",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9,
    longitude: 145.3333,
    accuracy: 4
  },
  {
    postalCode: 3786,
    city: "Ferny Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8833,
    longitude: 145.3333,
    accuracy: 4
  },
  {
    postalCode: 3787,
    city: "Sassafras Gully",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8667,
    longitude: 145.35,
    accuracy: 3
  },
  {
    postalCode: 3787,
    city: "Sassafras",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8667,
    longitude: 145.35,
    accuracy: 4
  },
  {
    postalCode: 3788,
    city: "Olinda",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.85,
    longitude: 145.3667,
    accuracy: 4
  },
  {
    postalCode: 3789,
    city: "Sherbrooke",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8833,
    longitude: 145.35,
    accuracy: 4
  },
  {
    postalCode: 3791,
    city: "Kallista",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8833,
    longitude: 145.3667,
    accuracy: 4
  },
  {
    postalCode: 3792,
    city: "The Patch",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9,
    longitude: 145.3833,
    accuracy: 4
  },
  {
    postalCode: 3793,
    city: "Monbulk",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8833,
    longitude: 145.4,
    accuracy: 4
  },
  {
    postalCode: 3795,
    city: "Silvan",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8167,
    longitude: 145.4167,
    accuracy: 4
  },
  {
    postalCode: 3796,
    city: "Mount Evelyn",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7833,
    longitude: 145.3833,
    accuracy: 4
  },
  {
    postalCode: 3797,
    city: "Gladysdale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8,
    longitude: 145.65,
    accuracy: 4
  },
  {
    postalCode: 3797,
    city: "Powelltown",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8667,
    longitude: 145.75,
    accuracy: 4
  },
  {
    postalCode: 3797,
    city: "Three Bridges",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8454,
    longitude: 145.6845,
    accuracy: 4
  },
  {
    postalCode: 3797,
    city: "Gilderoy",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8667,
    longitude: 145.7167,
    accuracy: 4
  },
  {
    postalCode: 3797,
    city: "Yarra Junction",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7819,
    longitude: 145.6143,
    accuracy: 4
  },
  {
    postalCode: 3799,
    city: "Big Pats Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7833,
    longitude: 145.75,
    accuracy: 4
  },
  {
    postalCode: 3799,
    city: "Mcmahons Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7167,
    longitude: 145.8333,
    accuracy: 4
  },
  {
    postalCode: 3799,
    city: "Warburton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7537,
    longitude: 145.6904,
    accuracy: 4
  },
  {
    postalCode: 3799,
    city: "Reefton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.752,
    longitude: 145.7172,
    accuracy: 3
  },
  {
    postalCode: 3799,
    city: "East Warburton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7364,
    longitude: 145.7429,
    accuracy: 4
  },
  {
    postalCode: 3799,
    city: "Millgrove",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7553,
    longitude: 145.6535,
    accuracy: 4
  },
  {
    postalCode: 3799,
    city: "Wesburn",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7667,
    longitude: 145.6333,
    accuracy: 4
  },
  {
    postalCode: 3800,
    city: "Monash University",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9106,
    longitude: 145.1348,
    accuracy: 1
  },
  {
    postalCode: 3802,
    city: "Endeavour Hills",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.977,
    longitude: 145.2587,
    accuracy: 4
  },
  {
    postalCode: 3803,
    city: "Hallam",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0167,
    longitude: 145.2667,
    accuracy: 4
  },
  {
    postalCode: 3804,
    city: "Narre Warren North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9833,
    longitude: 145.3167,
    accuracy: 4
  },
  {
    postalCode: 3804,
    city: "Narre Warren East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9639,
    longitude: 145.3629,
    accuracy: 4
  },
  {
    postalCode: 3805,
    city: "Narre Warren",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0333,
    longitude: 145.3,
    accuracy: 4
  },
  {
    postalCode: 3805,
    city: "Fountain Gate",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0263,
    longitude: 145.3069,
    accuracy: 4
  },
  {
    postalCode: 3805,
    city: "Narre Warren South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0437,
    longitude: 145.2923,
    accuracy: 4
  },
  {
    postalCode: 3806,
    city: "Harkaway",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38,
    longitude: 145.35,
    accuracy: 4
  },
  {
    postalCode: 3806,
    city: "Berwick",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0333,
    longitude: 145.35,
    accuracy: 4
  },
  {
    postalCode: 3807,
    city: "Guys Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0161,
    longitude: 145.3871,
    accuracy: 4
  },
  {
    postalCode: 3807,
    city: "Beaconsfield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.05,
    longitude: 145.3667,
    accuracy: 4
  },
  {
    postalCode: 3808,
    city: "Dewhurst",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9801,
    longitude: 145.4669,
    accuracy: 4
  },
  {
    postalCode: 3808,
    city: "Beaconsfield Upper",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9941,
    longitude: 145.4142,
    accuracy: 4
  },
  {
    postalCode: 3809,
    city: "Officer",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0592,
    longitude: 145.4095,
    accuracy: 4
  },
  {
    postalCode: 3809,
    city: "Officer South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0863,
    longitude: 145.4021,
    accuracy: 4
  },
  {
    postalCode: 3810,
    city: "Rythdale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1333,
    longitude: 145.4333,
    accuracy: 4
  },
  {
    postalCode: 3810,
    city: "Pakenham South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1333,
    longitude: 145.5167,
    accuracy: 4
  },
  {
    postalCode: 3810,
    city: "Pakenham",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0702,
    longitude: 145.4741,
    accuracy: 4
  },
  {
    postalCode: 3810,
    city: "Pakenham Upper",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0167,
    longitude: 145.5167,
    accuracy: 4
  },
  {
    postalCode: 3812,
    city: "Maryknoll",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.036,
    longitude: 145.5948,
    accuracy: 4
  },
  {
    postalCode: 3812,
    city: "Nar Nar Goon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0825,
    longitude: 145.5701,
    accuracy: 4
  },
  {
    postalCode: 3812,
    city: "Nar Nar Goon North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0167,
    longitude: 145.5667,
    accuracy: 4
  },
  {
    postalCode: 3813,
    city: "Tynong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0834,
    longitude: 145.6246,
    accuracy: 4
  },
  {
    postalCode: 3813,
    city: "Tynong North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0667,
    longitude: 145.6167,
    accuracy: 4
  },
  {
    postalCode: 3814,
    city: "Cora Lynn",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.15,
    longitude: 145.6,
    accuracy: 4
  },
  {
    postalCode: 3814,
    city: "Garfield North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0333,
    longitude: 145.6833,
    accuracy: 4
  },
  {
    postalCode: 3814,
    city: "Garfield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0899,
    longitude: 145.675,
    accuracy: 4
  },
  {
    postalCode: 3814,
    city: "Vervale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1333,
    longitude: 145.6667,
    accuracy: 4
  },
  {
    postalCode: 3815,
    city: "Tonimbuk",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0167,
    longitude: 145.7333,
    accuracy: 4
  },
  {
    postalCode: 3815,
    city: "Bunyip",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0979,
    longitude: 145.7161,
    accuracy: 4
  },
  {
    postalCode: 3815,
    city: "Bunyip North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0634,
    longitude: 145.7206,
    accuracy: 4
  },
  {
    postalCode: 3815,
    city: "Iona",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1333,
    longitude: 145.6833,
    accuracy: 4
  },
  {
    postalCode: 3816,
    city: "Labertouche",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.05,
    longitude: 145.8,
    accuracy: 4
  },
  {
    postalCode: 3816,
    city: "Longwarry North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0833,
    longitude: 145.7667,
    accuracy: 4
  },
  {
    postalCode: 3816,
    city: "Longwarry",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1128,
    longitude: 145.7685,
    accuracy: 4
  },
  {
    postalCode: 3816,
    city: "Modella",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1833,
    longitude: 145.7167,
    accuracy: 4
  },
  {
    postalCode: 3818,
    city: "Drouin West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1,
    longitude: 145.8667,
    accuracy: 4
  },
  {
    postalCode: 3818,
    city: "Ripplebrook",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2001,
    longitude: 145.7725,
    accuracy: 3
  },
  {
    postalCode: 3818,
    city: "Drouin South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1667,
    longitude: 145.8333,
    accuracy: 4
  },
  {
    postalCode: 3818,
    city: "Drouin East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1561,
    longitude: 145.8431,
    accuracy: 3
  },
  {
    postalCode: 3818,
    city: "Hallora",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2667,
    longitude: 145.8333,
    accuracy: 4
  },
  {
    postalCode: 3818,
    city: "Athlone",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2333,
    longitude: 145.7667,
    accuracy: 4
  },
  {
    postalCode: 3818,
    city: "Drouin",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1366,
    longitude: 145.8584,
    accuracy: 4
  },
  {
    postalCode: 3818,
    city: "Jindivick",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0333,
    longitude: 145.9,
    accuracy: 4
  },
  {
    postalCode: 3820,
    city: "Warragul",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1591,
    longitude: 145.9312,
    accuracy: 4
  },
  {
    postalCode: 3820,
    city: "Bona Vista",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1462,
    longitude: 145.9406,
    accuracy: 3
  },
  {
    postalCode: 3820,
    city: "Lillico",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1333,
    longitude: 145.95,
    accuracy: 4
  },
  {
    postalCode: 3821,
    city: "Brandy Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1,
    longitude: 145.9,
    accuracy: 4
  },
  {
    postalCode: 3821,
    city: "Lardner",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2,
    longitude: 145.8667,
    accuracy: 4
  },
  {
    postalCode: 3821,
    city: "Seaview",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1382,
    longitude: 145.9483,
    accuracy: 3
  },
  {
    postalCode: 3821,
    city: "Crossover",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.05,
    longitude: 145.9667,
    accuracy: 4
  },
  {
    postalCode: 3821,
    city: "Nilma North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.15,
    longitude: 145.9833,
    accuracy: 4
  },
  {
    postalCode: 3821,
    city: "Rokeby",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0667,
    longitude: 145.9333,
    accuracy: 4
  },
  {
    postalCode: 3821,
    city: "Neerim North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1952,
    longitude: 145.9567,
    accuracy: 3
  },
  {
    postalCode: 3821,
    city: "Buln Buln East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0833,
    longitude: 146,
    accuracy: 4
  },
  {
    postalCode: 3821,
    city: "Nilma",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1833,
    longitude: 145.9667,
    accuracy: 4
  },
  {
    postalCode: 3821,
    city: "Neerim Junction",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9296,
    longitude: 145.9612,
    accuracy: 4
  },
  {
    postalCode: 3821,
    city: "Torwood",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1382,
    longitude: 145.9483,
    accuracy: 3
  },
  {
    postalCode: 3821,
    city: "Shady Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1167,
    longitude: 146.05,
    accuracy: 4
  },
  {
    postalCode: 3821,
    city: "Bravington",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1382,
    longitude: 145.9483,
    accuracy: 3
  },
  {
    postalCode: 3821,
    city: "Tetoora Road",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2667,
    longitude: 145.9,
    accuracy: 4
  },
  {
    postalCode: 3821,
    city: "Ferndale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3167,
    longitude: 145.9333,
    accuracy: 4
  },
  {
    postalCode: 3821,
    city: "Ellinbank",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2333,
    longitude: 145.9333,
    accuracy: 4
  },
  {
    postalCode: 3821,
    city: "Warragul South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1382,
    longitude: 145.9483,
    accuracy: 3
  },
  {
    postalCode: 3821,
    city: "Warragul West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1382,
    longitude: 145.9483,
    accuracy: 3
  },
  {
    postalCode: 3821,
    city: "Buln Buln",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1,
    longitude: 145.9333,
    accuracy: 4
  },
  {
    postalCode: 3822,
    city: "Gainsborough",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2333,
    longitude: 145.9667,
    accuracy: 4
  },
  {
    postalCode: 3822,
    city: "Cloverlea",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2333,
    longitude: 146,
    accuracy: 4
  },
  {
    postalCode: 3822,
    city: "Darnum",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1885,
    longitude: 146.0053,
    accuracy: 4
  },
  {
    postalCode: 3823,
    city: "Yarragon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2052,
    longitude: 146.0608,
    accuracy: 4
  },
  {
    postalCode: 3823,
    city: "Yarragon South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.236,
    longitude: 146.0471,
    accuracy: 3
  },
  {
    postalCode: 3823,
    city: "Allambee",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2667,
    longitude: 146.0333,
    accuracy: 4
  },
  {
    postalCode: 3824,
    city: "Trafalgar South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2667,
    longitude: 146.15,
    accuracy: 4
  },
  {
    postalCode: 3824,
    city: "Trafalgar",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2091,
    longitude: 146.1535,
    accuracy: 4
  },
  {
    postalCode: 3824,
    city: "Thorpdale South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3,
    longitude: 146.1667,
    accuracy: 4
  },
  {
    postalCode: 3824,
    city: "Childers",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2993,
    longitude: 146.1139,
    accuracy: 4
  },
  {
    postalCode: 3824,
    city: "Trafalgar East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1833,
    longitude: 146.1833,
    accuracy: 4
  },
  {
    postalCode: 3824,
    city: "Narracan",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.25,
    longitude: 146.2333,
    accuracy: 4
  },
  {
    postalCode: 3825,
    city: "Yallourn",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1783,
    longitude: 146.261,
    accuracy: 4
  },
  {
    postalCode: 3825,
    city: "Jacob Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0481,
    longitude: 146.1801,
    accuracy: 3
  },
  {
    postalCode: 3825,
    city: "Hernes Oak",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1956,
    longitude: 146.3258,
    accuracy: 3
  },
  {
    postalCode: 3825,
    city: "Walhalla East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0481,
    longitude: 146.1801,
    accuracy: 3
  },
  {
    postalCode: 3825,
    city: "Aberfeldy",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6833,
    longitude: 146.3667,
    accuracy: 4
  },
  {
    postalCode: 3825,
    city: "Jericho",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0481,
    longitude: 146.1801,
    accuracy: 3
  },
  {
    postalCode: 3825,
    city: "Rawson",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9546,
    longitude: 146.3993,
    accuracy: 4
  },
  {
    postalCode: 3825,
    city: "Tanjil South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1167,
    longitude: 146.25,
    accuracy: 4
  },
  {
    postalCode: 3825,
    city: "Willow Grove",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0833,
    longitude: 146.2,
    accuracy: 4
  },
  {
    postalCode: 3825,
    city: "Amor",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0481,
    longitude: 146.1801,
    accuracy: 3
  },
  {
    postalCode: 3825,
    city: "Yallourn North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1605,
    longitude: 146.3645,
    accuracy: 4
  },
  {
    postalCode: 3825,
    city: "Thomson",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1698,
    longitude: 144.3789,
    accuracy: 4
  },
  {
    postalCode: 3825,
    city: "Fumina",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8833,
    longitude: 146.1,
    accuracy: 4
  },
  {
    postalCode: 3825,
    city: "Coalville",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.25,
    longitude: 146.2667,
    accuracy: 4
  },
  {
    postalCode: 3825,
    city: "Moe",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1783,
    longitude: 146.261,
    accuracy: 4
  },
  {
    postalCode: 3825,
    city: "Moondarra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0167,
    longitude: 146.3667,
    accuracy: 4
  },
  {
    postalCode: 3825,
    city: "Coopers Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9833,
    longitude: 146.4333,
    accuracy: 4
  },
  {
    postalCode: 3825,
    city: "Caringal",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0481,
    longitude: 146.1801,
    accuracy: 3
  },
  {
    postalCode: 3825,
    city: "Fumina South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.95,
    longitude: 146.1167,
    accuracy: 4
  },
  {
    postalCode: 3825,
    city: "Westbury",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1363,
    longitude: 146.2175,
    accuracy: 4
  },
  {
    postalCode: 3825,
    city: "Boola",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0481,
    longitude: 146.1801,
    accuracy: 3
  },
  {
    postalCode: 3825,
    city: "Hill End",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0167,
    longitude: 146.15,
    accuracy: 4
  },
  {
    postalCode: 3825,
    city: "Thalloo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0481,
    longitude: 146.1801,
    accuracy: 3
  },
  {
    postalCode: 3825,
    city: "Erica",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9833,
    longitude: 146.3667,
    accuracy: 4
  },
  {
    postalCode: 3825,
    city: "Tanjil",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0481,
    longitude: 146.1801,
    accuracy: 3
  },
  {
    postalCode: 3825,
    city: "Walhalla",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.95,
    longitude: 146.45,
    accuracy: 4
  },
  {
    postalCode: 3825,
    city: "Moe South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0481,
    longitude: 146.1801,
    accuracy: 3
  },
  {
    postalCode: 3825,
    city: "Toombon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0481,
    longitude: 146.1801,
    accuracy: 3
  },
  {
    postalCode: 3825,
    city: "Newborough",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1717,
    longitude: 146.2926,
    accuracy: 4
  },
  {
    postalCode: 3831,
    city: "Neerim East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9833,
    longitude: 146,
    accuracy: 4
  },
  {
    postalCode: 3831,
    city: "Neerim",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9667,
    longitude: 145.95,
    accuracy: 4
  },
  {
    postalCode: 3831,
    city: "Neerim South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0168,
    longitude: 145.9545,
    accuracy: 4
  },
  {
    postalCode: 3832,
    city: "Neerim Junction",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9296,
    longitude: 145.9612,
    accuracy: 4
  },
  {
    postalCode: 3832,
    city: "Neerim North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9315,
    longitude: 145.9556,
    accuracy: 3
  },
  {
    postalCode: 3832,
    city: "Nayook",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9333,
    longitude: 145.95,
    accuracy: 4
  },
  {
    postalCode: 3833,
    city: "Toorongo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8728,
    longitude: 146.1029,
    accuracy: 3
  },
  {
    postalCode: 3833,
    city: "Icy Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8728,
    longitude: 146.1029,
    accuracy: 3
  },
  {
    postalCode: 3833,
    city: "Vesper",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9167,
    longitude: 146.0833,
    accuracy: 4
  },
  {
    postalCode: 3833,
    city: "Gentle Annie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.938,
    longitude: 145.8359,
    accuracy: 4
  },
  {
    postalCode: 3833,
    city: "Loch Valley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8333,
    longitude: 146,
    accuracy: 4
  },
  {
    postalCode: 3833,
    city: "Ada",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8728,
    longitude: 146.1029,
    accuracy: 3
  },
  {
    postalCode: 3833,
    city: "Baw Baw Village",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8378,
    longitude: 146.2499,
    accuracy: 4
  },
  {
    postalCode: 3833,
    city: "Noojee",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9167,
    longitude: 146,
    accuracy: 4
  },
  {
    postalCode: 3833,
    city: "Piedmont",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8728,
    longitude: 146.1029,
    accuracy: 3
  },
  {
    postalCode: 3833,
    city: "Tanjil Bren",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9222,
    longitude: 146.2121,
    accuracy: 4
  },
  {
    postalCode: 3833,
    city: "Baw Baw",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7412,
    longitude: 146.331,
    accuracy: 4
  },
  {
    postalCode: 3835,
    city: "Thorpdale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2833,
    longitude: 146.1833,
    accuracy: 4
  },
  {
    postalCode: 3840,
    city: "Hazelwood",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2833,
    longitude: 146.35,
    accuracy: 4
  },
  {
    postalCode: 3840,
    city: "Driffield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3137,
    longitude: 146.4182,
    accuracy: 3
  },
  {
    postalCode: 3840,
    city: "Hazelwood South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.317,
    longitude: 146.4626,
    accuracy: 4
  },
  {
    postalCode: 3840,
    city: "Morwell",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2348,
    longitude: 146.395,
    accuracy: 4
  },
  {
    postalCode: 3840,
    city: "Maryvale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3137,
    longitude: 146.4182,
    accuracy: 3
  },
  {
    postalCode: 3840,
    city: "Mid Valley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2994,
    longitude: 146.483,
    accuracy: 3
  },
  {
    postalCode: 3840,
    city: "Jeeralang",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4038,
    longitude: 146.4753,
    accuracy: 4
  },
  {
    postalCode: 3840,
    city: "Hazelwood North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3137,
    longitude: 146.4182,
    accuracy: 3
  },
  {
    postalCode: 3840,
    city: "Jeeralang Junction",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3333,
    longitude: 146.4167,
    accuracy: 4
  },
  {
    postalCode: 3841,
    city: "Gippsland Mc",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2458,
    longitude: 146.6306,
    accuracy: 1
  },
  {
    postalCode: 3842,
    city: "Churchill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3078,
    longitude: 146.4137,
    accuracy: 4
  },
  {
    postalCode: 3844,
    city: "Mount Tassie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3008,
    longitude: 146.6242,
    accuracy: 3
  },
  {
    postalCode: 3844,
    city: "Callignee",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3333,
    longitude: 146.5833,
    accuracy: 4
  },
  {
    postalCode: 3844,
    city: "Tyers",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1489,
    longitude: 146.4804,
    accuracy: 4
  },
  {
    postalCode: 3844,
    city: "Flynn",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1667,
    longitude: 146.6833,
    accuracy: 4
  },
  {
    postalCode: 3844,
    city: "Carrajung Lower",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4,
    longitude: 146.7333,
    accuracy: 4
  },
  {
    postalCode: 3844,
    city: "Traralgon South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2667,
    longitude: 146.55,
    accuracy: 4
  },
  {
    postalCode: 3844,
    city: "Blackwarry",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4,
    longitude: 146.65,
    accuracy: 4
  },
  {
    postalCode: 3844,
    city: "Carrajung South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3833,
    longitude: 146.7333,
    accuracy: 4
  },
  {
    postalCode: 3844,
    city: "Koornalla",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3167,
    longitude: 146.5333,
    accuracy: 4
  },
  {
    postalCode: 3844,
    city: "Callignee South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3833,
    longitude: 146.6167,
    accuracy: 4
  },
  {
    postalCode: 3844,
    city: "Flynns Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3008,
    longitude: 146.6242,
    accuracy: 3
  },
  {
    postalCode: 3844,
    city: "Willung South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.35,
    longitude: 146.7333,
    accuracy: 4
  },
  {
    postalCode: 3844,
    city: "Traralgon East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3008,
    longitude: 146.6242,
    accuracy: 3
  },
  {
    postalCode: 3844,
    city: "Carrajung",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3667,
    longitude: 146.6833,
    accuracy: 4
  },
  {
    postalCode: 3844,
    city: "Traralgon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1953,
    longitude: 146.5415,
    accuracy: 4
  },
  {
    postalCode: 3844,
    city: "Callignee North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3167,
    longitude: 146.6,
    accuracy: 4
  },
  {
    postalCode: 3844,
    city: "Loy Yang",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1833,
    longitude: 146.6167,
    accuracy: 4
  },
  {
    postalCode: 3847,
    city: "Rosedale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1545,
    longitude: 146.7886,
    accuracy: 4
  },
  {
    postalCode: 3847,
    city: "Willung South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.35,
    longitude: 146.7333,
    accuracy: 4
  },
  {
    postalCode: 3847,
    city: "Willung",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.25,
    longitude: 146.8167,
    accuracy: 4
  },
  {
    postalCode: 3847,
    city: "Hiamdale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2011,
    longitude: 146.8055,
    accuracy: 3
  },
  {
    postalCode: 3847,
    city: "Nambrok",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.05,
    longitude: 146.8833,
    accuracy: 4
  },
  {
    postalCode: 3850,
    city: "Wurruk",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1167,
    longitude: 147.0333,
    accuracy: 4
  },
  {
    postalCode: 3850,
    city: "Guthridge",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.106,
    longitude: 147.0608,
    accuracy: 3
  },
  {
    postalCode: 3850,
    city: "Sale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.111,
    longitude: 147.068,
    accuracy: 4
  },
  {
    postalCode: 3851,
    city: "Fulham",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1,
    longitude: 146.9833,
    accuracy: 4
  },
  {
    postalCode: 3851,
    city: "Seaspray",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3761,
    longitude: 147.1906,
    accuracy: 4
  },
  {
    postalCode: 3851,
    city: "Seacombe",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1167,
    longitude: 147.4333,
    accuracy: 4
  },
  {
    postalCode: 3851,
    city: "Darriman",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.45,
    longitude: 146.9333,
    accuracy: 4
  },
  {
    postalCode: 3851,
    city: "The Heart",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1167,
    longitude: 147.1667,
    accuracy: 4
  },
  {
    postalCode: 3851,
    city: "Kilmany",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1,
    longitude: 146.9,
    accuracy: 4
  },
  {
    postalCode: 3851,
    city: "Montgomery",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0333,
    longitude: 147.0667,
    accuracy: 4
  },
  {
    postalCode: 3851,
    city: "Golden Beach",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2109,
    longitude: 147.3987,
    accuracy: 4
  },
  {
    postalCode: 3851,
    city: "Giffard",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4167,
    longitude: 147.0833,
    accuracy: 4
  },
  {
    postalCode: 3851,
    city: "Airly",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0333,
    longitude: 147.1167,
    accuracy: 4
  },
  {
    postalCode: 3851,
    city: "The Honeysuckles",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1661,
    longitude: 147.1648,
    accuracy: 3
  },
  {
    postalCode: 3851,
    city: "Dutson",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1833,
    longitude: 147.1833,
    accuracy: 4
  },
  {
    postalCode: 3851,
    city: "Cobains",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0833,
    longitude: 147.15,
    accuracy: 4
  },
  {
    postalCode: 3851,
    city: "Paradise Beach",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1962,
    longitude: 147.4152,
    accuracy: 4
  },
  {
    postalCode: 3851,
    city: "Glomar Beach",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1661,
    longitude: 147.1648,
    accuracy: 3
  },
  {
    postalCode: 3851,
    city: "Loch Sport",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0401,
    longitude: 147.5918,
    accuracy: 4
  },
  {
    postalCode: 3851,
    city: "Bundalaguah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0333,
    longitude: 147.0167,
    accuracy: 4
  },
  {
    postalCode: 3851,
    city: "Longford",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1624,
    longitude: 147.0859,
    accuracy: 4
  },
  {
    postalCode: 3851,
    city: "Clydebank",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.05,
    longitude: 147.2,
    accuracy: 4
  },
  {
    postalCode: 3851,
    city: "Myrtlebank",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1588,
    longitude: 147.1833,
    accuracy: 3
  },
  {
    postalCode: 3851,
    city: "Stradbroke",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3,
    longitude: 147.0333,
    accuracy: 4
  },
  {
    postalCode: 3851,
    city: "Flamingo Beach",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1661,
    longitude: 147.1648,
    accuracy: 3
  },
  {
    postalCode: 3851,
    city: "Giffard West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1661,
    longitude: 147.1648,
    accuracy: 3
  },
  {
    postalCode: 3851,
    city: "Dutson Downs",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1661,
    longitude: 147.1648,
    accuracy: 3
  },
  {
    postalCode: 3851,
    city: "Pearsondale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1661,
    longitude: 147.1648,
    accuracy: 3
  },
  {
    postalCode: 3851,
    city: "Lake Wellington",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1661,
    longitude: 147.1648,
    accuracy: 3
  },
  {
    postalCode: 3851,
    city: "Somerton Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1661,
    longitude: 147.1648,
    accuracy: 3
  },
  {
    postalCode: 3852,
    city: "East Sale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1035,
    longitude: 147.127,
    accuracy: 4
  },
  {
    postalCode: 3852,
    city: "East Sale Raaf",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.104,
    longitude: 147.1424,
    accuracy: 3
  },
  {
    postalCode: 3852,
    city: "Sale East Raaf",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1035,
    longitude: 147.127,
    accuracy: 3
  },
  {
    postalCode: 3853,
    city: "Sale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.111,
    longitude: 147.068,
    accuracy: 4
  },
  {
    postalCode: 3854,
    city: "Glengarry",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1167,
    longitude: 146.5667,
    accuracy: 4
  },
  {
    postalCode: 3854,
    city: "Glengarry West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.15,
    longitude: 146.5167,
    accuracy: 4
  },
  {
    postalCode: 3854,
    city: "Glengarry North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1333,
    longitude: 146.5417,
    accuracy: 3
  },
  {
    postalCode: 3856,
    city: "Toongabbie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.05,
    longitude: 146.6167,
    accuracy: 4
  },
  {
    postalCode: 3857,
    city: "Cowwarr",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0167,
    longitude: 146.6833,
    accuracy: 4
  },
  {
    postalCode: 3858,
    city: "Dawson",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9833,
    longitude: 146.7333,
    accuracy: 4
  },
  {
    postalCode: 3858,
    city: "Heyfield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9813,
    longitude: 146.7856,
    accuracy: 4
  },
  {
    postalCode: 3858,
    city: "Licola",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6333,
    longitude: 146.6167,
    accuracy: 4
  },
  {
    postalCode: 3858,
    city: "Denison",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0333,
    longitude: 146.8833,
    accuracy: 4
  },
  {
    postalCode: 3858,
    city: "Arbuckle",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9307,
    longitude: 146.7432,
    accuracy: 3
  },
  {
    postalCode: 3858,
    city: "Gillum",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9307,
    longitude: 146.7432,
    accuracy: 3
  },
  {
    postalCode: 3858,
    city: "Yangoura",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9307,
    longitude: 146.7432,
    accuracy: 3
  },
  {
    postalCode: 3858,
    city: "Billabong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9307,
    longitude: 146.7432,
    accuracy: 3
  },
  {
    postalCode: 3858,
    city: "Tamboritha",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9307,
    longitude: 146.7432,
    accuracy: 3
  },
  {
    postalCode: 3858,
    city: "Reynard",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9307,
    longitude: 146.7432,
    accuracy: 3
  },
  {
    postalCode: 3858,
    city: "Worrowing",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9307,
    longitude: 146.7432,
    accuracy: 3
  },
  {
    postalCode: 3858,
    city: "Seaton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9333,
    longitude: 146.6667,
    accuracy: 4
  },
  {
    postalCode: 3858,
    city: "Crookayan",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9307,
    longitude: 146.7432,
    accuracy: 3
  },
  {
    postalCode: 3858,
    city: "Winnindoo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.05,
    longitude: 146.7667,
    accuracy: 4
  },
  {
    postalCode: 3858,
    city: "Glenmaggie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9,
    longitude: 146.75,
    accuracy: 4
  },
  {
    postalCode: 3858,
    city: "Sargood",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9307,
    longitude: 146.7432,
    accuracy: 3
  },
  {
    postalCode: 3858,
    city: "Buragwonduc",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9307,
    longitude: 146.7432,
    accuracy: 3
  },
  {
    postalCode: 3858,
    city: "Glenfalloch",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9307,
    longitude: 146.7432,
    accuracy: 3
  },
  {
    postalCode: 3858,
    city: "Howitt Plains",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9307,
    longitude: 146.7432,
    accuracy: 3
  },
  {
    postalCode: 3858,
    city: "Licola North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9307,
    longitude: 146.7432,
    accuracy: 3
  },
  {
    postalCode: 3859,
    city: "Newry",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9167,
    longitude: 146.8833,
    accuracy: 4
  },
  {
    postalCode: 3859,
    city: "Tinamba West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9264,
    longitude: 146.8749,
    accuracy: 3
  },
  {
    postalCode: 3859,
    city: "Maffra West Upper",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9,
    longitude: 146.85,
    accuracy: 4
  },
  {
    postalCode: 3859,
    city: "Tinamba",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9625,
    longitude: 146.8914,
    accuracy: 4
  },
  {
    postalCode: 3860,
    city: "Riverslea",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38,
    longitude: 146.95,
    accuracy: 4
  },
  {
    postalCode: 3860,
    city: "Woolenook",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8985,
    longitude: 146.9703,
    accuracy: 3
  },
  {
    postalCode: 3860,
    city: "Coongulla",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8913,
    longitude: 146.786,
    accuracy: 4
  },
  {
    postalCode: 3860,
    city: "Nap Nap Marra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8985,
    longitude: 146.9703,
    accuracy: 3
  },
  {
    postalCode: 3860,
    city: "Wrathung",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8985,
    longitude: 146.9703,
    accuracy: 3
  },
  {
    postalCode: 3860,
    city: "Bushy Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8667,
    longitude: 147.0333,
    accuracy: 4
  },
  {
    postalCode: 3860,
    city: "Wrixon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8985,
    longitude: 146.9703,
    accuracy: 3
  },
  {
    postalCode: 3860,
    city: "Koorool",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8985,
    longitude: 146.9703,
    accuracy: 3
  },
  {
    postalCode: 3860,
    city: "Toolome",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8985,
    longitude: 146.9703,
    accuracy: 3
  },
  {
    postalCode: 3860,
    city: "Briagolong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8436,
    longitude: 147.0727,
    accuracy: 4
  },
  {
    postalCode: 3860,
    city: "Maffra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9713,
    longitude: 146.9837,
    accuracy: 4
  },
  {
    postalCode: 3860,
    city: "Boisdale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8833,
    longitude: 146.9833,
    accuracy: 4
  },
  {
    postalCode: 3860,
    city: "Moroka",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8985,
    longitude: 146.9703,
    accuracy: 3
  },
  {
    postalCode: 3860,
    city: "Monomak",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8985,
    longitude: 146.9703,
    accuracy: 3
  },
  {
    postalCode: 3860,
    city: "Valencia Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8333,
    longitude: 146.9833,
    accuracy: 4
  },
  {
    postalCode: 3862,
    city: "Llowalong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9333,
    longitude: 147.0667,
    accuracy: 4
  },
  {
    postalCode: 3862,
    city: "Budgee Budgee",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8052,
    longitude: 147.2018,
    accuracy: 3
  },
  {
    postalCode: 3862,
    city: "Dargo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4833,
    longitude: 147.2667,
    accuracy: 4
  },
  {
    postalCode: 3862,
    city: "Meerlieu",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38,
    longitude: 147.4,
    accuracy: 4
  },
  {
    postalCode: 3862,
    city: "Munro",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9167,
    longitude: 147.1833,
    accuracy: 4
  },
  {
    postalCode: 3862,
    city: "Hollands Landing",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8052,
    longitude: 147.2018,
    accuracy: 3
  },
  {
    postalCode: 3862,
    city: "Stockdale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8,
    longitude: 147.1667,
    accuracy: 4
  },
  {
    postalCode: 3862,
    city: "Cobbannah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6333,
    longitude: 147.1833,
    accuracy: 4
  },
  {
    postalCode: 3862,
    city: "Perry Bridge",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38,
    longitude: 147.2667,
    accuracy: 4
  },
  {
    postalCode: 3862,
    city: "Crooked River",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8052,
    longitude: 147.2018,
    accuracy: 3
  },
  {
    postalCode: 3862,
    city: "Stratford",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9634,
    longitude: 147.0826,
    accuracy: 4
  },
  {
    postalCode: 3862,
    city: "Hawkhurst",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8052,
    longitude: 147.2018,
    accuracy: 3
  },
  {
    postalCode: 3862,
    city: "Waterford",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5167,
    longitude: 147.2,
    accuracy: 4
  },
  {
    postalCode: 3862,
    city: "Miowera",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8052,
    longitude: 147.2018,
    accuracy: 3
  },
  {
    postalCode: 3862,
    city: "Wongungarra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8052,
    longitude: 147.2018,
    accuracy: 3
  },
  {
    postalCode: 3862,
    city: "Cowa",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8052,
    longitude: 147.2018,
    accuracy: 3
  },
  {
    postalCode: 3862,
    city: "Moornapa",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8052,
    longitude: 147.2018,
    accuracy: 3
  },
  {
    postalCode: 3864,
    city: "Glenaladale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7833,
    longitude: 147.35,
    accuracy: 4
  },
  {
    postalCode: 3864,
    city: "Fernbank",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8667,
    longitude: 147.3167,
    accuracy: 4
  },
  {
    postalCode: 3865,
    city: "Lindenow",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8005,
    longitude: 147.4598,
    accuracy: 4
  },
  {
    postalCode: 3869,
    city: "Yinnar",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3225,
    longitude: 146.3292,
    accuracy: 4
  },
  {
    postalCode: 3869,
    city: "Yinnar South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3833,
    longitude: 146.3833,
    accuracy: 4
  },
  {
    postalCode: 3869,
    city: "Jumbuk",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4,
    longitude: 146.4278,
    accuracy: 4
  },
  {
    postalCode: 3870,
    city: "Budgeree",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4167,
    longitude: 146.3333,
    accuracy: 4
  },
  {
    postalCode: 3870,
    city: "Johnstones Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4153,
    longitude: 146.2973,
    accuracy: 3
  },
  {
    postalCode: 3870,
    city: "Boolarra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3794,
    longitude: 146.2753,
    accuracy: 4
  },
  {
    postalCode: 3870,
    city: "Grand Ridge",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4153,
    longitude: 146.2973,
    accuracy: 3
  },
  {
    postalCode: 3870,
    city: "Boolarra South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.45,
    longitude: 146.2833,
    accuracy: 4
  },
  {
    postalCode: 3871,
    city: "Mirboo North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.401,
    longitude: 146.1613,
    accuracy: 4
  },
  {
    postalCode: 3871,
    city: "Dollar",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5667,
    longitude: 146.1667,
    accuracy: 4
  },
  {
    postalCode: 3871,
    city: "Allambee Reserve",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4141,
    longitude: 146.1797,
    accuracy: 3
  },
  {
    postalCode: 3871,
    city: "Darlimurla",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3667,
    longitude: 146.2167,
    accuracy: 4
  },
  {
    postalCode: 3871,
    city: "Allambee South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.35,
    longitude: 146.1,
    accuracy: 4
  },
  {
    postalCode: 3871,
    city: "Baromi",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4141,
    longitude: 146.1797,
    accuracy: 3
  },
  {
    postalCode: 3871,
    city: "Mirboo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4667,
    longitude: 146.2,
    accuracy: 4
  },
  {
    postalCode: 3871,
    city: "Delburn",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3333,
    longitude: 146.2333,
    accuracy: 4
  },
  {
    postalCode: 3873,
    city: "Gormandale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2833,
    longitude: 146.7,
    accuracy: 4
  },
  {
    postalCode: 3874,
    city: "Woodside",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5238,
    longitude: 146.8751,
    accuracy: 4
  },
  {
    postalCode: 3874,
    city: "Mcloughlins Beach",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4536,
    longitude: 146.8042,
    accuracy: 3
  },
  {
    postalCode: 3874,
    city: "Woodside North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4536,
    longitude: 146.8042,
    accuracy: 3
  },
  {
    postalCode: 3874,
    city: "Carrajung South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3833,
    longitude: 146.7333,
    accuracy: 4
  },
  {
    postalCode: 3874,
    city: "Woodside Beach",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4536,
    longitude: 146.8042,
    accuracy: 3
  },
  {
    postalCode: 3875,
    city: "Bairnsdale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8229,
    longitude: 147.6104,
    accuracy: 4
  },
  {
    postalCode: 3875,
    city: "Granite Rock",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7569,
    longitude: 147.672,
    accuracy: 4
  },
  {
    postalCode: 3875,
    city: "Lucknow",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8167,
    longitude: 147.65,
    accuracy: 4
  },
  {
    postalCode: 3875,
    city: "Merrijig",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1,
    longitude: 146.25,
    accuracy: 4
  },
  {
    postalCode: 3875,
    city: "Hillside",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8333,
    longitude: 147.5,
    accuracy: 4
  },
  {
    postalCode: 3875,
    city: "Goon Nure",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.95,
    longitude: 147.65,
    accuracy: 4
  },
  {
    postalCode: 3875,
    city: "Walpa",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8,
    longitude: 147.45,
    accuracy: 4
  },
  {
    postalCode: 3875,
    city: "Deptford",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5833,
    longitude: 147.7,
    accuracy: 4
  },
  {
    postalCode: 3875,
    city: "Eastwood",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7479,
    longitude: 147.4935,
    accuracy: 3
  },
  {
    postalCode: 3875,
    city: "Lindenow South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8167,
    longitude: 147.4333,
    accuracy: 4
  },
  {
    postalCode: 3875,
    city: "Woodglen",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.75,
    longitude: 147.4833,
    accuracy: 4
  },
  {
    postalCode: 3875,
    city: "Wentworth",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7479,
    longitude: 147.4935,
    accuracy: 3
  },
  {
    postalCode: 3875,
    city: "Forge Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9,
    longitude: 147.6333,
    accuracy: 4
  },
  {
    postalCode: 3875,
    city: "Tabberabbera",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5833,
    longitude: 147.3833,
    accuracy: 4
  },
  {
    postalCode: 3875,
    city: "Calulu",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8,
    longitude: 147.5167,
    accuracy: 4
  },
  {
    postalCode: 3875,
    city: "Waterholes",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7479,
    longitude: 147.4935,
    accuracy: 3
  },
  {
    postalCode: 3875,
    city: "Clifton Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7078,
    longitude: 147.6658,
    accuracy: 4
  },
  {
    postalCode: 3875,
    city: "Marthavale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7479,
    longitude: 147.4935,
    accuracy: 3
  },
  {
    postalCode: 3875,
    city: "Bullumwaal",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6333,
    longitude: 147.5333,
    accuracy: 4
  },
  {
    postalCode: 3875,
    city: "Broadlands",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7479,
    longitude: 147.4935,
    accuracy: 3
  },
  {
    postalCode: 3875,
    city: "Wy Yung",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8,
    longitude: 147.5833,
    accuracy: 4
  },
  {
    postalCode: 3875,
    city: "Banksia Peninsula",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7479,
    longitude: 147.4935,
    accuracy: 3
  },
  {
    postalCode: 3875,
    city: "Newlands Arm",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9241,
    longitude: 147.698,
    accuracy: 3
  },
  {
    postalCode: 3875,
    city: "Ellaswood",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7479,
    longitude: 147.4935,
    accuracy: 3
  },
  {
    postalCode: 3875,
    city: "East Bairnsdale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8229,
    longitude: 147.6104,
    accuracy: 4
  },
  {
    postalCode: 3875,
    city: "Iguana Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7333,
    longitude: 147.3167,
    accuracy: 4
  },
  {
    postalCode: 3875,
    city: "Wuk Wuk",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7667,
    longitude: 147.4333,
    accuracy: 4
  },
  {
    postalCode: 3875,
    city: "Mount Taylor",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7437,
    longitude: 147.5994,
    accuracy: 4
  },
  {
    postalCode: 3875,
    city: "Fairy Dell",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.3333,
    longitude: 144.75,
    accuracy: 4
  },
  {
    postalCode: 3875,
    city: "Melwood",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7479,
    longitude: 147.4935,
    accuracy: 3
  },
  {
    postalCode: 3875,
    city: "Ryans",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7479,
    longitude: 147.4935,
    accuracy: 3
  },
  {
    postalCode: 3875,
    city: "Flaggy Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7479,
    longitude: 147.4935,
    accuracy: 3
  },
  {
    postalCode: 3875,
    city: "Sarsfield",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.75,
    longitude: 147.7167,
    accuracy: 4
  },
  {
    postalCode: 3875,
    city: "Bengworden",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9833,
    longitude: 147.4667,
    accuracy: 4
  },
  {
    postalCode: 3878,
    city: "Eagle Point",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9,
    longitude: 147.6833,
    accuracy: 4
  },
  {
    postalCode: 3880,
    city: "Paynesville",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9189,
    longitude: 147.7194,
    accuracy: 4
  },
  {
    postalCode: 3880,
    city: "Boole Poole",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9178,
    longitude: 147.7264,
    accuracy: 3
  },
  {
    postalCode: 3880,
    city: "Ocean Grange",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9178,
    longitude: 147.7264,
    accuracy: 3
  },
  {
    postalCode: 3880,
    city: "Raymond Island",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.9167,
    longitude: 147.7333,
    accuracy: 4
  },
  {
    postalCode: 3882,
    city: "Nicholson",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8167,
    longitude: 147.7333,
    accuracy: 4
  },
  {
    postalCode: 3885,
    city: "Wulgulmerang",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0833,
    longitude: 148.2833,
    accuracy: 4
  },
  {
    postalCode: 3885,
    city: "Wulgulmerang East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0833,
    longitude: 148.2833,
    accuracy: 4
  },
  {
    postalCode: 3885,
    city: "Buchan South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5667,
    longitude: 148.1167,
    accuracy: 4
  },
  {
    postalCode: 3885,
    city: "Suggan Buggan",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9556,
    longitude: 148.3276,
    accuracy: 4
  },
  {
    postalCode: 3885,
    city: "W Tree",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2648,
    longitude: 148.1466,
    accuracy: 3
  },
  {
    postalCode: 3885,
    city: "Butchers Ridge",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2583,
    longitude: 148.2443,
    accuracy: 4
  },
  {
    postalCode: 3885,
    city: "Yalmy",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4142,
    longitude: 148.1025,
    accuracy: 3
  },
  {
    postalCode: 3885,
    city: "Gelantipy",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1833,
    longitude: 148.2833,
    accuracy: 4
  },
  {
    postalCode: 3885,
    city: "Wiseleigh",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7117,
    longitude: 147.8056,
    accuracy: 4
  },
  {
    postalCode: 3885,
    city: "Buchan",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5,
    longitude: 148.1833,
    accuracy: 4
  },
  {
    postalCode: 3885,
    city: "Brumby",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4142,
    longitude: 148.1025,
    accuracy: 3
  },
  {
    postalCode: 3885,
    city: "Bruthen",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7067,
    longitude: 147.831,
    accuracy: 4
  },
  {
    postalCode: 3885,
    city: "Wulgulmerang West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4142,
    longitude: 148.1025,
    accuracy: 3
  },
  {
    postalCode: 3885,
    city: "Mossiface",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7415,
    longitude: 147.8159,
    accuracy: 4
  },
  {
    postalCode: 3885,
    city: "Murrindal",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4167,
    longitude: 148.2,
    accuracy: 4
  },
  {
    postalCode: 3885,
    city: "Tambo Upper",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.767,
    longitude: 147.843,
    accuracy: 4
  },
  {
    postalCode: 3885,
    city: "Timbarra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4142,
    longitude: 148.1025,
    accuracy: 3
  },
  {
    postalCode: 3886,
    city: "Newmerella",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7333,
    longitude: 148.45,
    accuracy: 4
  },
  {
    postalCode: 3887,
    city: "Nowa Nowa",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7167,
    longitude: 148.1,
    accuracy: 4
  },
  {
    postalCode: 3887,
    city: "Lake Tyers",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.85,
    longitude: 148.0667,
    accuracy: 4
  },
  {
    postalCode: 3887,
    city: "Wairewa",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6892,
    longitude: 148.1693,
    accuracy: 4
  },
  {
    postalCode: 3888,
    city: "Tostaree",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.75,
    longitude: 148.1667,
    accuracy: 4
  },
  {
    postalCode: 3888,
    city: "Brodribb River",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7,
    longitude: 148.5667,
    accuracy: 4
  },
  {
    postalCode: 3888,
    city: "Bete Bolong North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5266,
    longitude: 148.543,
    accuracy: 3
  },
  {
    postalCode: 3888,
    city: "Goongerah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3321,
    longitude: 148.6943,
    accuracy: 4
  },
  {
    postalCode: 3888,
    city: "Marlo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7962,
    longitude: 148.5319,
    accuracy: 4
  },
  {
    postalCode: 3888,
    city: "Waygara",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7333,
    longitude: 148.3167,
    accuracy: 4
  },
  {
    postalCode: 3888,
    city: "Bendoc",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1333,
    longitude: 148.9,
    accuracy: 4
  },
  {
    postalCode: 3888,
    city: "Jarrahmond",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6984,
    longitude: 148.4064,
    accuracy: 4
  },
  {
    postalCode: 3888,
    city: "Wombat Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5266,
    longitude: 148.543,
    accuracy: 3
  },
  {
    postalCode: 3888,
    city: "Bete Bolong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6858,
    longitude: 148.3833,
    accuracy: 4
  },
  {
    postalCode: 3888,
    city: "Haydens Bog",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5266,
    longitude: 148.543,
    accuracy: 3
  },
  {
    postalCode: 3888,
    city: "Delegate River",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0667,
    longitude: 148.8,
    accuracy: 4
  },
  {
    postalCode: 3888,
    city: "Simpsons Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5266,
    longitude: 148.543,
    accuracy: 3
  },
  {
    postalCode: 3888,
    city: "Nurran",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5266,
    longitude: 148.543,
    accuracy: 3
  },
  {
    postalCode: 3888,
    city: "Bonang",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2,
    longitude: 148.75,
    accuracy: 4
  },
  {
    postalCode: 3888,
    city: "Orbost",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6964,
    longitude: 148.457,
    accuracy: 4
  },
  {
    postalCode: 3888,
    city: "Tubbut",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3755,
    longitude: 148.5993,
    accuracy: 3
  },
  {
    postalCode: 3888,
    city: "Corringle",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5266,
    longitude: 148.543,
    accuracy: 3
  },
  {
    postalCode: 3888,
    city: "Cape Conran",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5266,
    longitude: 148.543,
    accuracy: 3
  },
  {
    postalCode: 3888,
    city: "Deddick Valley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5266,
    longitude: 148.543,
    accuracy: 3
  },
  {
    postalCode: 3889,
    city: "Cabbage Tree Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6967,
    longitude: 148.7197,
    accuracy: 4
  },
  {
    postalCode: 3889,
    city: "Bemm River",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7582,
    longitude: 148.9692,
    accuracy: 4
  },
  {
    postalCode: 3889,
    city: "Errinundra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3831,
    longitude: 148.8937,
    accuracy: 4
  },
  {
    postalCode: 3889,
    city: "Bellbird Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5481,
    longitude: 148.8764,
    accuracy: 3
  },
  {
    postalCode: 3889,
    city: "Manorina",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.6756,
    longitude: 148.7948,
    accuracy: 4
  },
  {
    postalCode: 3889,
    city: "Club Terrace",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5333,
    longitude: 148.95,
    accuracy: 4
  },
  {
    postalCode: 3889,
    city: "Combienbar",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3833,
    longitude: 149.0167,
    accuracy: 4
  },
  {
    postalCode: 3890,
    city: "Buldah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2655,
    longitude: 149.1431,
    accuracy: 4
  },
  {
    postalCode: 3890,
    city: "Noorinbee North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4986,
    longitude: 149.1425,
    accuracy: 3
  },
  {
    postalCode: 3890,
    city: "Cann River",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5658,
    longitude: 149.151,
    accuracy: 4
  },
  {
    postalCode: 3890,
    city: "Chandlers Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3385,
    longitude: 149.1951,
    accuracy: 4
  },
  {
    postalCode: 3890,
    city: "Noorinbee",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5167,
    longitude: 149.1667,
    accuracy: 4
  },
  {
    postalCode: 3890,
    city: "Tonghi Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5638,
    longitude: 149.0588,
    accuracy: 4
  },
  {
    postalCode: 3890,
    city: "Tamboon",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7393,
    longitude: 149.1419,
    accuracy: 4
  },
  {
    postalCode: 3891,
    city: "Wangarabell",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.475,
    longitude: 149.6333,
    accuracy: 3
  },
  {
    postalCode: 3891,
    city: "Genoa",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4833,
    longitude: 149.5833,
    accuracy: 4
  },
  {
    postalCode: 3891,
    city: "Gipsy Point",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4667,
    longitude: 149.6833,
    accuracy: 4
  },
  {
    postalCode: 3891,
    city: "Wallagaraugh",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.475,
    longitude: 149.6333,
    accuracy: 3
  },
  {
    postalCode: 3891,
    city: "Wroxham",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.475,
    longitude: 149.6333,
    accuracy: 3
  },
  {
    postalCode: 3891,
    city: "Wingan River",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.475,
    longitude: 149.6333,
    accuracy: 3
  },
  {
    postalCode: 3891,
    city: "Maramingo Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.475,
    longitude: 149.6333,
    accuracy: 3
  },
  {
    postalCode: 3892,
    city: "Mallacoota",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.559,
    longitude: 149.7541,
    accuracy: 4
  },
  {
    postalCode: 3893,
    city: "Double Bridges",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4667,
    longitude: 147.7917,
    accuracy: 3
  },
  {
    postalCode: 3893,
    city: "Stirling",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4333,
    longitude: 147.75,
    accuracy: 4
  },
  {
    postalCode: 3893,
    city: "Tambo Crossing",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.5,
    longitude: 147.8333,
    accuracy: 4
  },
  {
    postalCode: 3895,
    city: "Ensay",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3833,
    longitude: 147.8333,
    accuracy: 4
  },
  {
    postalCode: 3895,
    city: "Reedy Flat",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.4,
    longitude: 147.9,
    accuracy: 4
  },
  {
    postalCode: 3895,
    city: "Doctors Flat",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3,
    longitude: 147.75,
    accuracy: 4
  },
  {
    postalCode: 3895,
    city: "Ensay North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3611,
    longitude: 147.8278,
    accuracy: 3
  },
  {
    postalCode: 3896,
    city: "Swifts Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.25,
    longitude: 147.7167,
    accuracy: 4
  },
  {
    postalCode: 3896,
    city: "Brookville",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.3333,
    longitude: 147.6167,
    accuracy: 4
  },
  {
    postalCode: 3896,
    city: "Nunniong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2208,
    longitude: 147.725,
    accuracy: 3
  },
  {
    postalCode: 3896,
    city: "Tongio",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1833,
    longitude: 147.7333,
    accuracy: 4
  },
  {
    postalCode: 3896,
    city: "Bindi",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1167,
    longitude: 147.8333,
    accuracy: 4
  },
  {
    postalCode: 3898,
    city: "Hinnomunjie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0167,
    longitude: 147.65,
    accuracy: 4
  },
  {
    postalCode: 3898,
    city: "Glen Wills",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.85,
    longitude: 147.5167,
    accuracy: 4
  },
  {
    postalCode: 3898,
    city: "Omeo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0961,
    longitude: 147.5949,
    accuracy: 4
  },
  {
    postalCode: 3898,
    city: "Cobungra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.1,
    longitude: 147.4167,
    accuracy: 4
  },
  {
    postalCode: 3898,
    city: "Dinner Plain",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0236,
    longitude: 147.2412,
    accuracy: 4
  },
  {
    postalCode: 3898,
    city: "Bingo Munjie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0204,
    longitude: 147.4992,
    accuracy: 3
  },
  {
    postalCode: 3898,
    city: "Cassilis",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.2167,
    longitude: 147.6,
    accuracy: 4
  },
  {
    postalCode: 3898,
    city: "Omeo Valley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0204,
    longitude: 147.4992,
    accuracy: 3
  },
  {
    postalCode: 3898,
    city: "Anglers Rest",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.9935,
    longitude: 147.4905,
    accuracy: 4
  },
  {
    postalCode: 3898,
    city: "Bundara",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0204,
    longitude: 147.4992,
    accuracy: 3
  },
  {
    postalCode: 3898,
    city: "Shannonvale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.0204,
    longitude: 147.4992,
    accuracy: 3
  },
  {
    postalCode: 3898,
    city: "Glen Valley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.8667,
    longitude: 147.4833,
    accuracy: 4
  },
  {
    postalCode: 3900,
    city: "Benambra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.95,
    longitude: 147.7167,
    accuracy: 4
  },
  {
    postalCode: 3900,
    city: "Cobberas",
    state_name: "Victoria",
    state: "VIC",
    latitude: -36.95,
    longitude: 147.7167,
    accuracy: 3
  },
  {
    postalCode: 3902,
    city: "Johnsonville",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8167,
    longitude: 147.8,
    accuracy: 4
  },
  {
    postalCode: 3902,
    city: "Bumberrah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8,
    longitude: 147.8333,
    accuracy: 4
  },
  {
    postalCode: 3903,
    city: "Swan Reach",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8333,
    longitude: 147.8667,
    accuracy: 4
  },
  {
    postalCode: 3904,
    city: "Metung",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8915,
    longitude: 147.853,
    accuracy: 4
  },
  {
    postalCode: 3909,
    city: "Lakes Entrance",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8812,
    longitude: 147.981,
    accuracy: 4
  },
  {
    postalCode: 3909,
    city: "Nungurner",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8819,
    longitude: 147.8858,
    accuracy: 4
  },
  {
    postalCode: 3909,
    city: "Lake Tyers Beach",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.859,
    longitude: 148.0868,
    accuracy: 3
  },
  {
    postalCode: 3909,
    city: "Toorloo Arm",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8758,
    longitude: 147.9423,
    accuracy: 3
  },
  {
    postalCode: 3909,
    city: "Kalimna West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8568,
    longitude: 147.9522,
    accuracy: 4
  },
  {
    postalCode: 3909,
    city: "Lake Bunga",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8758,
    longitude: 147.9423,
    accuracy: 3
  },
  {
    postalCode: 3909,
    city: "Nyerimilang",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8758,
    longitude: 147.9423,
    accuracy: 3
  },
  {
    postalCode: 3909,
    city: "Kalimna",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8833,
    longitude: 147.95,
    accuracy: 4
  },
  {
    postalCode: 3910,
    city: "Langwarrin",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1667,
    longitude: 145.1667,
    accuracy: 4
  },
  {
    postalCode: 3911,
    city: "Langwarrin South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1987,
    longitude: 145.1807,
    accuracy: 4
  },
  {
    postalCode: 3911,
    city: "Baxter",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2,
    longitude: 145.15,
    accuracy: 4
  },
  {
    postalCode: 3912,
    city: "Somerville",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2167,
    longitude: 145.1667,
    accuracy: 4
  },
  {
    postalCode: 3912,
    city: "Pearcedale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.203,
    longitude: 145.2349,
    accuracy: 4
  },
  {
    postalCode: 3913,
    city: "Tyabb",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.25,
    longitude: 145.1833,
    accuracy: 4
  },
  {
    postalCode: 3915,
    city: "Tuerong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2987,
    longitude: 145.0967,
    accuracy: 4
  },
  {
    postalCode: 3915,
    city: "Hastings",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3,
    longitude: 145.1833,
    accuracy: 4
  },
  {
    postalCode: 3916,
    city: "Shoreham",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4263,
    longitude: 145.0469,
    accuracy: 4
  },
  {
    postalCode: 3916,
    city: "Merricks",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3833,
    longitude: 145.0833,
    accuracy: 4
  },
  {
    postalCode: 3916,
    city: "Point Leo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.415,
    longitude: 145.0694,
    accuracy: 4
  },
  {
    postalCode: 3918,
    city: "Bittern",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3333,
    longitude: 145.1667,
    accuracy: 4
  },
  {
    postalCode: 3919,
    city: "Crib Point",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.35,
    longitude: 145.2,
    accuracy: 4
  },
  {
    postalCode: 3920,
    city: "Hmas Cerberus",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3649,
    longitude: 145.2004,
    accuracy: 4
  },
  {
    postalCode: 3921,
    city: "French Island",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3406,
    longitude: 145.341,
    accuracy: 4
  },
  {
    postalCode: 3921,
    city: "Elizabeth Island",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3667,
    longitude: 145.3241,
    accuracy: 3
  },
  {
    postalCode: 3921,
    city: "Tankerton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3868,
    longitude: 145.2896,
    accuracy: 4
  },
  {
    postalCode: 3922,
    city: "Sunset Strip",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4922,
    longitude: 145.2627,
    accuracy: 4
  },
  {
    postalCode: 3922,
    city: "Sunderland Bay",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4568,
    longitude: 145.0754,
    accuracy: 3
  },
  {
    postalCode: 3922,
    city: "Ventnor",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4627,
    longitude: 145.195,
    accuracy: 4
  },
  {
    postalCode: 3922,
    city: "Cowes",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4523,
    longitude: 145.2386,
    accuracy: 4
  },
  {
    postalCode: 3922,
    city: "Summerlands",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4568,
    longitude: 145.0754,
    accuracy: 3
  },
  {
    postalCode: 3922,
    city: "Wimbledon Heights",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4568,
    longitude: 145.0754,
    accuracy: 3
  },
  {
    postalCode: 3922,
    city: "Silverleaves",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4539,
    longitude: 145.2727,
    accuracy: 4
  },
  {
    postalCode: 3922,
    city: "Surf Beach",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3751,
    longitude: 144.2564,
    accuracy: 4
  },
  {
    postalCode: 3922,
    city: "Smiths Beach",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5007,
    longitude: 145.2552,
    accuracy: 4
  },
  {
    postalCode: 3923,
    city: "Rhyll",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4642,
    longitude: 145.2995,
    accuracy: 4
  },
  {
    postalCode: 3925,
    city: "Churchill Island",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5262,
    longitude: 145.3584,
    accuracy: 3
  },
  {
    postalCode: 3925,
    city: "San Remo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5204,
    longitude: 145.37,
    accuracy: 4
  },
  {
    postalCode: 3925,
    city: "Newhaven",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5121,
    longitude: 145.3558,
    accuracy: 4
  },
  {
    postalCode: 3925,
    city: "Cape Woolamai",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5428,
    longitude: 145.3441,
    accuracy: 4
  },
  {
    postalCode: 3926,
    city: "Merricks North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.35,
    longitude: 145.0833,
    accuracy: 4
  },
  {
    postalCode: 3926,
    city: "Balnarring Beach",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4,
    longitude: 145.1167,
    accuracy: 4
  },
  {
    postalCode: 3926,
    city: "Balnarring",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3667,
    longitude: 145.1333,
    accuracy: 4
  },
  {
    postalCode: 3926,
    city: "Merricks Beach",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3988,
    longitude: 145.106,
    accuracy: 4
  },
  {
    postalCode: 3927,
    city: "Somers",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4,
    longitude: 145.1667,
    accuracy: 4
  },
  {
    postalCode: 3928,
    city: "Main Ridge",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3973,
    longitude: 144.9724,
    accuracy: 4
  },
  {
    postalCode: 3929,
    city: "Flinders",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4739,
    longitude: 145.019,
    accuracy: 4
  },
  {
    postalCode: 3930,
    city: "Mount Eliza",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1833,
    longitude: 145.0833,
    accuracy: 4
  },
  {
    postalCode: 3930,
    city: "Kunyung",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1943,
    longitude: 145.0926,
    accuracy: 3
  },
  {
    postalCode: 3931,
    city: "Mornington",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2179,
    longitude: 145.0388,
    accuracy: 4
  },
  {
    postalCode: 3933,
    city: "Moorooduc",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2167,
    longitude: 145.1167,
    accuracy: 4
  },
  {
    postalCode: 3934,
    city: "Mount Martha",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2667,
    longitude: 145.0167,
    accuracy: 4
  },
  {
    postalCode: 3936,
    city: "Dromana",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3338,
    longitude: 144.9646,
    accuracy: 4
  },
  {
    postalCode: 3936,
    city: "Safety Beach",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3153,
    longitude: 145.0003,
    accuracy: 4
  },
  {
    postalCode: 3936,
    city: "Arthurs Seat",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3632,
    longitude: 144.9598,
    accuracy: 4
  },
  {
    postalCode: 3937,
    city: "Red Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.35,
    longitude: 145.0167,
    accuracy: 4
  },
  {
    postalCode: 3937,
    city: "Red Hill South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3833,
    longitude: 145.0333,
    accuracy: 4
  },
  {
    postalCode: 3938,
    city: "Mccrae",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3497,
    longitude: 144.9281,
    accuracy: 4
  },
  {
    postalCode: 3939,
    city: "Boneo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4167,
    longitude: 144.8833,
    accuracy: 4
  },
  {
    postalCode: 3939,
    city: "Rosebud Plaza",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4106,
    longitude: 144.8837,
    accuracy: 3
  },
  {
    postalCode: 3939,
    city: "Rosebud",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3554,
    longitude: 144.9068,
    accuracy: 4
  },
  {
    postalCode: 3939,
    city: "Fingal",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.414,
    longitude: 144.8499,
    accuracy: 4
  },
  {
    postalCode: 3939,
    city: "Cape Schanck",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4616,
    longitude: 144.9014,
    accuracy: 4
  },
  {
    postalCode: 3940,
    city: "Rosebud West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3644,
    longitude: 144.8775,
    accuracy: 4
  },
  {
    postalCode: 3941,
    city: "Rye",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3667,
    longitude: 144.8167,
    accuracy: 4
  },
  {
    postalCode: 3941,
    city: "Tootgarook",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3777,
    longitude: 144.8502,
    accuracy: 4
  },
  {
    postalCode: 3941,
    city: "St Andrews Beach",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4141,
    longitude: 144.8244,
    accuracy: 3
  },
  {
    postalCode: 3942,
    city: "Blairgowrie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3613,
    longitude: 144.7795,
    accuracy: 4
  },
  {
    postalCode: 3943,
    city: "Sorrento",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3396,
    longitude: 144.7413,
    accuracy: 4
  },
  {
    postalCode: 3944,
    city: "Portsea",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3167,
    longitude: 144.7167,
    accuracy: 4
  },
  {
    postalCode: 3945,
    city: "Krowera",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4333,
    longitude: 145.6667,
    accuracy: 4
  },
  {
    postalCode: 3945,
    city: "Jeetho",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3833,
    longitude: 145.7167,
    accuracy: 4
  },
  {
    postalCode: 3945,
    city: "Woodleigh",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4,
    longitude: 145.6333,
    accuracy: 4
  },
  {
    postalCode: 3945,
    city: "Loch",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3691,
    longitude: 145.7081,
    accuracy: 4
  },
  {
    postalCode: 3946,
    city: "Bena",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4167,
    longitude: 145.7667,
    accuracy: 4
  },
  {
    postalCode: 3950,
    city: "Strzelecki",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3333,
    longitude: 145.9,
    accuracy: 4
  },
  {
    postalCode: 3950,
    city: "Whitelaw",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4167,
    longitude: 145.7833,
    accuracy: 4
  },
  {
    postalCode: 3950,
    city: "Kardella South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.45,
    longitude: 145.8833,
    accuracy: 4
  },
  {
    postalCode: 3950,
    city: "Korumburra South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4667,
    longitude: 145.85,
    accuracy: 4
  },
  {
    postalCode: 3950,
    city: "Korumburra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4319,
    longitude: 145.8235,
    accuracy: 4
  },
  {
    postalCode: 3951,
    city: "Arawata",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4,
    longitude: 145.8667,
    accuracy: 4
  },
  {
    postalCode: 3951,
    city: "Fairbank",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.45,
    longitude: 145.7929,
    accuracy: 3
  },
  {
    postalCode: 3951,
    city: "Ranceby",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3833,
    longitude: 145.85,
    accuracy: 4
  },
  {
    postalCode: 3951,
    city: "Kardella",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4167,
    longitude: 145.8667,
    accuracy: 4
  },
  {
    postalCode: 3951,
    city: "Moyarra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4833,
    longitude: 145.7333,
    accuracy: 4
  },
  {
    postalCode: 3951,
    city: "Outtrim",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4833,
    longitude: 145.7667,
    accuracy: 4
  },
  {
    postalCode: 3951,
    city: "Jumbunna",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4667,
    longitude: 145.7667,
    accuracy: 4
  },
  {
    postalCode: 3951,
    city: "Kongwak",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5167,
    longitude: 145.7,
    accuracy: 4
  },
  {
    postalCode: 3953,
    city: "Ruby",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.45,
    longitude: 145.9167,
    accuracy: 4
  },
  {
    postalCode: 3953,
    city: "Leongatha North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4236,
    longitude: 146.0027,
    accuracy: 3
  },
  {
    postalCode: 3953,
    city: "Hallston",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3667,
    longitude: 146.0333,
    accuracy: 4
  },
  {
    postalCode: 3953,
    city: "Mount Eccles South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3667,
    longitude: 145.9833,
    accuracy: 4
  },
  {
    postalCode: 3953,
    city: "Mount Eccles",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3667,
    longitude: 145.9833,
    accuracy: 4
  },
  {
    postalCode: 3953,
    city: "Koorooman",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4236,
    longitude: 146.0027,
    accuracy: 3
  },
  {
    postalCode: 3953,
    city: "Berrys Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4167,
    longitude: 146.0667,
    accuracy: 4
  },
  {
    postalCode: 3953,
    city: "Mardan",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.45,
    longitude: 146.1333,
    accuracy: 4
  },
  {
    postalCode: 3953,
    city: "Leongatha",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4761,
    longitude: 145.9469,
    accuracy: 4
  },
  {
    postalCode: 3953,
    city: "Boorool",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4236,
    longitude: 146.0027,
    accuracy: 3
  },
  {
    postalCode: 3953,
    city: "Leongatha South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5333,
    longitude: 145.8833,
    accuracy: 4
  },
  {
    postalCode: 3953,
    city: "Wild Dog Valley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4236,
    longitude: 146.0027,
    accuracy: 3
  },
  {
    postalCode: 3953,
    city: "Nerrena",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5167,
    longitude: 146.0833,
    accuracy: 4
  },
  {
    postalCode: 3953,
    city: "Wooreen",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4,
    longitude: 146.0333,
    accuracy: 4
  },
  {
    postalCode: 3953,
    city: "Trida",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3167,
    longitude: 145.9667,
    accuracy: 4
  },
  {
    postalCode: 3954,
    city: "Koonwarra",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.55,
    longitude: 145.95,
    accuracy: 4
  },
  {
    postalCode: 3956,
    city: "Venus Bay",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.7004,
    longitude: 145.8224,
    accuracy: 4
  },
  {
    postalCode: 3956,
    city: "Tarwin",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5833,
    longitude: 145.9833,
    accuracy: 4
  },
  {
    postalCode: 3956,
    city: "Dumbalk",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5333,
    longitude: 146.0833,
    accuracy: 4
  },
  {
    postalCode: 3956,
    city: "Walkerville North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6678,
    longitude: 145.9843,
    accuracy: 3
  },
  {
    postalCode: 3956,
    city: "Meeniyan",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5769,
    longitude: 146.0193,
    accuracy: 4
  },
  {
    postalCode: 3956,
    city: "Walkerville",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6777,
    longitude: 146.0009,
    accuracy: 3
  },
  {
    postalCode: 3956,
    city: "Walkerville South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.8599,
    longitude: 145.9933,
    accuracy: 4
  },
  {
    postalCode: 3956,
    city: "Middle Tarwin",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6667,
    longitude: 145.9333,
    accuracy: 4
  },
  {
    postalCode: 3956,
    city: "Tarwin Lower",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.7,
    longitude: 145.85,
    accuracy: 4
  },
  {
    postalCode: 3956,
    city: "Dumbalk North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5167,
    longitude: 146.1667,
    accuracy: 4
  },
  {
    postalCode: 3957,
    city: "Stony Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5833,
    longitude: 146.0333,
    accuracy: 4
  },
  {
    postalCode: 3958,
    city: "Buffalo",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.65,
    longitude: 146.0333,
    accuracy: 4
  },
  {
    postalCode: 3959,
    city: "Sandy Point",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.8199,
    longitude: 146.1174,
    accuracy: 4
  },
  {
    postalCode: 3959,
    city: "Fish Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6833,
    longitude: 146.0833,
    accuracy: 4
  },
  {
    postalCode: 3959,
    city: "Waratah Bay",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.7697,
    longitude: 146.0757,
    accuracy: 3
  },
  {
    postalCode: 3960,
    city: "Gunyah",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5333,
    longitude: 146.3167,
    accuracy: 4
  },
  {
    postalCode: 3960,
    city: "Boolarong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5667,
    longitude: 146.25,
    accuracy: 4
  },
  {
    postalCode: 3960,
    city: "Woorarra West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5638,
    longitude: 146.1564,
    accuracy: 3
  },
  {
    postalCode: 3960,
    city: "Bennison",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6667,
    longitude: 146.25,
    accuracy: 4
  },
  {
    postalCode: 3960,
    city: "Shallow Inlet",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5638,
    longitude: 146.1564,
    accuracy: 3
  },
  {
    postalCode: 3960,
    city: "Turtons Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.55,
    longitude: 146.25,
    accuracy: 4
  },
  {
    postalCode: 3960,
    city: "Tidal River",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.8342,
    longitude: 146.2888,
    accuracy: 3
  },
  {
    postalCode: 3960,
    city: "Yanakie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.8114,
    longitude: 146.2057,
    accuracy: 4
  },
  {
    postalCode: 3960,
    city: "Foster North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5638,
    longitude: 146.1564,
    accuracy: 3
  },
  {
    postalCode: 3960,
    city: "Wilsons Promontory",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.9602,
    longitude: 146.3677,
    accuracy: 4
  },
  {
    postalCode: 3960,
    city: "Wonga",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.7333,
    longitude: 145.2667,
    accuracy: 4
  },
  {
    postalCode: 3960,
    city: "Mount Best",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6,
    longitude: 146.3,
    accuracy: 4
  },
  {
    postalCode: 3960,
    city: "Foster",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6527,
    longitude: 146.2007,
    accuracy: 4
  },
  {
    postalCode: 3962,
    city: "Woorarra East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6167,
    longitude: 146.3833,
    accuracy: 4
  },
  {
    postalCode: 3962,
    city: "Toora",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6629,
    longitude: 146.3279,
    accuracy: 4
  },
  {
    postalCode: 3962,
    city: "Wonyip",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5622,
    longitude: 146.3924,
    accuracy: 4
  },
  {
    postalCode: 3962,
    city: "Toora North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.633,
    longitude: 146.3711,
    accuracy: 3
  },
  {
    postalCode: 3962,
    city: "Agnes",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6857,
    longitude: 146.3898,
    accuracy: 4
  },
  {
    postalCode: 3964,
    city: "Port Franklin",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6833,
    longitude: 146.2667,
    accuracy: 4
  },
  {
    postalCode: 3965,
    city: "Port Welshpool",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6992,
    longitude: 146.4531,
    accuracy: 4
  },
  {
    postalCode: 3966,
    city: "Binginwarri",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5833,
    longitude: 146.45,
    accuracy: 4
  },
  {
    postalCode: 3966,
    city: "Welshpool",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6667,
    longitude: 146.4333,
    accuracy: 4
  },
  {
    postalCode: 3966,
    city: "Hazel Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6333,
    longitude: 146.3833,
    accuracy: 4
  },
  {
    postalCode: 3967,
    city: "Hedley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6333,
    longitude: 146.5,
    accuracy: 4
  },
  {
    postalCode: 3971,
    city: "Gelliondale",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6194,
    longitude: 146.6036,
    accuracy: 4
  },
  {
    postalCode: 3971,
    city: "Yarram",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5648,
    longitude: 146.6756,
    accuracy: 4
  },
  {
    postalCode: 3971,
    city: "Balook",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4333,
    longitude: 146.5667,
    accuracy: 4
  },
  {
    postalCode: 3971,
    city: "Manns Beach",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5398,
    longitude: 146.6065,
    accuracy: 3
  },
  {
    postalCode: 3971,
    city: "Tarraville",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6333,
    longitude: 146.7167,
    accuracy: 4
  },
  {
    postalCode: 3971,
    city: "Madalya",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5,
    longitude: 146.4667,
    accuracy: 4
  },
  {
    postalCode: 3971,
    city: "Langsborough",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6551,
    longitude: 146.678,
    accuracy: 4
  },
  {
    postalCode: 3971,
    city: "Hunterston",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5398,
    longitude: 146.6065,
    accuracy: 3
  },
  {
    postalCode: 3971,
    city: "Alberton",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6167,
    longitude: 146.6667,
    accuracy: 4
  },
  {
    postalCode: 3971,
    city: "Won Wron",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4667,
    longitude: 146.7167,
    accuracy: 4
  },
  {
    postalCode: 3971,
    city: "Hiawatha",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5167,
    longitude: 146.4667,
    accuracy: 4
  },
  {
    postalCode: 3971,
    city: "Robertsons Beach",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5398,
    longitude: 146.6065,
    accuracy: 3
  },
  {
    postalCode: 3971,
    city: "Devon North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.505,
    longitude: 146.6497,
    accuracy: 3
  },
  {
    postalCode: 3971,
    city: "Jack River",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.55,
    longitude: 146.5667,
    accuracy: 4
  },
  {
    postalCode: 3971,
    city: "Tarra Valley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4333,
    longitude: 146.5333,
    accuracy: 4
  },
  {
    postalCode: 3971,
    city: "Snake Island",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5398,
    longitude: 146.6065,
    accuracy: 3
  },
  {
    postalCode: 3971,
    city: "Macks Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4667,
    longitude: 146.6333,
    accuracy: 4
  },
  {
    postalCode: 3971,
    city: "Alberton West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6,
    longitude: 146.6,
    accuracy: 4
  },
  {
    postalCode: 3971,
    city: "Staceys Bridge",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.55,
    longitude: 146.5333,
    accuracy: 4
  },
  {
    postalCode: 3971,
    city: "Calrossie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4833,
    longitude: 146.6667,
    accuracy: 4
  },
  {
    postalCode: 3971,
    city: "Port Albert",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6654,
    longitude: 146.6885,
    accuracy: 4
  },
  {
    postalCode: 3975,
    city: "Lyndhurst",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.05,
    longitude: 145.25,
    accuracy: 4
  },
  {
    postalCode: 3975,
    city: "Lynbrook",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0559,
    longitude: 145.2562,
    accuracy: 4
  },
  {
    postalCode: 3976,
    city: "Hampton Park",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0333,
    longitude: 145.25,
    accuracy: 4
  },
  {
    postalCode: 3977,
    city: "Botanic Ridge",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1392,
    longitude: 145.2684,
    accuracy: 4
  },
  {
    postalCode: 3977,
    city: "Skye",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1051,
    longitude: 145.2163,
    accuracy: 4
  },
  {
    postalCode: 3977,
    city: "Cannons Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2122,
    longitude: 145.3153,
    accuracy: 4
  },
  {
    postalCode: 3977,
    city: "Devon Meadows",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1667,
    longitude: 145.3,
    accuracy: 4
  },
  {
    postalCode: 3977,
    city: "Cranbourne West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0965,
    longitude: 145.2671,
    accuracy: 4
  },
  {
    postalCode: 3977,
    city: "Cranbourne South",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.135,
    longitude: 145.2396,
    accuracy: 4
  },
  {
    postalCode: 3977,
    city: "Cranbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1134,
    longitude: 145.2833,
    accuracy: 4
  },
  {
    postalCode: 3977,
    city: "Junction Village",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1364,
    longitude: 145.2968,
    accuracy: 4
  },
  {
    postalCode: 3977,
    city: "Cranbourne East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1153,
    longitude: 145.2981,
    accuracy: 4
  },
  {
    postalCode: 3977,
    city: "Five Ways",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1667,
    longitude: 145.3167,
    accuracy: 4
  },
  {
    postalCode: 3977,
    city: "Sandhurst",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.081,
    longitude: 145.2077,
    accuracy: 4
  },
  {
    postalCode: 3977,
    city: "Cranbourne North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.0829,
    longitude: 145.2781,
    accuracy: 4
  },
  {
    postalCode: 3978,
    city: "Clyde North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1167,
    longitude: 145.3333,
    accuracy: 4
  },
  {
    postalCode: 3978,
    city: "Cardinia",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.15,
    longitude: 145.4167,
    accuracy: 4
  },
  {
    postalCode: 3978,
    city: "Clyde",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1333,
    longitude: 145.3333,
    accuracy: 4
  },
  {
    postalCode: 3979,
    city: "Glen Alvie",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5167,
    longitude: 145.7,
    accuracy: 4
  },
  {
    postalCode: 3979,
    city: "Kernot",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4333,
    longitude: 145.6,
    accuracy: 4
  },
  {
    postalCode: 3979,
    city: "Almurta",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4667,
    longitude: 145.5833,
    accuracy: 4
  },
  {
    postalCode: 3980,
    city: "Blind Bight",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2143,
    longitude: 145.3377,
    accuracy: 4
  },
  {
    postalCode: 3980,
    city: "Warneet",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2253,
    longitude: 145.3101,
    accuracy: 4
  },
  {
    postalCode: 3980,
    city: "Tooradin",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2147,
    longitude: 145.3833,
    accuracy: 4
  },
  {
    postalCode: 3981,
    city: "Koo Wee Rup North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1667,
    longitude: 145.5333,
    accuracy: 4
  },
  {
    postalCode: 3981,
    city: "Heath Hill",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.25,
    longitude: 145.7,
    accuracy: 4
  },
  {
    postalCode: 3981,
    city: "Koo Wee Rup",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1994,
    longitude: 145.4908,
    accuracy: 3
  },
  {
    postalCode: 3981,
    city: "Yannathan",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2333,
    longitude: 145.65,
    accuracy: 4
  },
  {
    postalCode: 3981,
    city: "Bayles",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1833,
    longitude: 145.5667,
    accuracy: 4
  },
  {
    postalCode: 3981,
    city: "Dalmore",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.1833,
    longitude: 145.4167,
    accuracy: 4
  },
  {
    postalCode: 3981,
    city: "Catani",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2,
    longitude: 145.6333,
    accuracy: 4
  },
  {
    postalCode: 3984,
    city: "The Gurdies",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3151,
    longitude: 145.5606,
    accuracy: 3
  },
  {
    postalCode: 3984,
    city: "Tenby Point",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.441,
    longitude: 145.5107,
    accuracy: 3
  },
  {
    postalCode: 3984,
    city: "Pioneer Bay",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3807,
    longitude: 145.5495,
    accuracy: 4
  },
  {
    postalCode: 3984,
    city: "Coronet Bay",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4391,
    longitude: 145.4457,
    accuracy: 4
  },
  {
    postalCode: 3984,
    city: "Adams Estate",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3488,
    longitude: 145.5081,
    accuracy: 3
  },
  {
    postalCode: 3984,
    city: "Lang Lang",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.266,
    longitude: 145.5621,
    accuracy: 4
  },
  {
    postalCode: 3984,
    city: "Queensferry",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4167,
    longitude: 145.5,
    accuracy: 4
  },
  {
    postalCode: 3984,
    city: "Grantville",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.407,
    longitude: 145.5301,
    accuracy: 4
  },
  {
    postalCode: 3984,
    city: "Monomeith",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2167,
    longitude: 145.5167,
    accuracy: 4
  },
  {
    postalCode: 3984,
    city: "Jam Jerrup",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3151,
    longitude: 145.5606,
    accuracy: 3
  },
  {
    postalCode: 3984,
    city: "Corinella",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4141,
    longitude: 145.4276,
    accuracy: 4
  },
  {
    postalCode: 3984,
    city: "Lang Lang East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3488,
    longitude: 145.5081,
    accuracy: 3
  },
  {
    postalCode: 3984,
    city: "Caldermeade",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.25,
    longitude: 145.5333,
    accuracy: 4
  },
  {
    postalCode: 3987,
    city: "Nyora",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3336,
    longitude: 145.6725,
    accuracy: 4
  },
  {
    postalCode: 3988,
    city: "Poowong",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3428,
    longitude: 145.7638,
    accuracy: 4
  },
  {
    postalCode: 3988,
    city: "Poowong East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3,
    longitude: 145.8333,
    accuracy: 4
  },
  {
    postalCode: 3988,
    city: "Mountain View",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.2667,
    longitude: 145.8667,
    accuracy: 4
  },
  {
    postalCode: 3988,
    city: "Poowong North",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.3,
    longitude: 145.8,
    accuracy: 4
  },
  {
    postalCode: 3990,
    city: "Glen Forbes",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.45,
    longitude: 145.5333,
    accuracy: 4
  },
  {
    postalCode: 3991,
    city: "Bass",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.4833,
    longitude: 145.45,
    accuracy: 4
  },
  {
    postalCode: 3992,
    city: "Ryanston",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5333,
    longitude: 145.5833,
    accuracy: 4
  },
  {
    postalCode: 3992,
    city: "West Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5333,
    longitude: 145.5833,
    accuracy: 3
  },
  {
    postalCode: 3992,
    city: "Dalyston",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5667,
    longitude: 145.55,
    accuracy: 4
  },
  {
    postalCode: 3992,
    city: "Blackwood Forest",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5,
    longitude: 145.6167,
    accuracy: 4
  },
  {
    postalCode: 3995,
    city: "Wattle Bank",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5667,
    longitude: 145.7,
    accuracy: 4
  },
  {
    postalCode: 3995,
    city: "Lance Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5752,
    longitude: 145.5665,
    accuracy: 3
  },
  {
    postalCode: 3995,
    city: "North Wonthaggi",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6,
    longitude: 145.6,
    accuracy: 4
  },
  {
    postalCode: 3995,
    city: "Anderson",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5333,
    longitude: 145.45,
    accuracy: 4
  },
  {
    postalCode: 3995,
    city: "Kilcunda",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.55,
    longitude: 145.4833,
    accuracy: 4
  },
  {
    postalCode: 3995,
    city: "Harmers Haven",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5752,
    longitude: 145.5665,
    accuracy: 3
  },
  {
    postalCode: 3995,
    city: "Archies Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.55,
    longitude: 145.5667,
    accuracy: 4
  },
  {
    postalCode: 3995,
    city: "Woolamai",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5,
    longitude: 145.5,
    accuracy: 4
  },
  {
    postalCode: 3995,
    city: "South Dudley",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6,
    longitude: 145.5833,
    accuracy: 4
  },
  {
    postalCode: 3995,
    city: "St Clair",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.5752,
    longitude: 145.5665,
    accuracy: 3
  },
  {
    postalCode: 3995,
    city: "Wonthaggi",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6059,
    longitude: 145.5936,
    accuracy: 4
  },
  {
    postalCode: 3995,
    city: "Cape Paterson",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6709,
    longitude: 145.6213,
    accuracy: 4
  },
  {
    postalCode: 3996,
    city: "Pound Creek",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6333,
    longitude: 145.8,
    accuracy: 4
  },
  {
    postalCode: 3996,
    city: "Inverloch",
    state_name: "Victoria",
    state: "VIC",
    latitude: -38.6266,
    longitude: 145.7226,
    accuracy: 4
  },
  {
    postalCode: 8001,
    city: "Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.814,
    longitude: 144.9633,
    accuracy: 4
  },
  {
    postalCode: 8002,
    city: "East Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8167,
    longitude: 144.9879,
    accuracy: 4
  },
  {
    postalCode: 8003,
    city: "Collins Street East",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8153,
    longitude: 144.9756,
    accuracy: 1
  },
  {
    postalCode: 8004,
    city: "St Kilda Road",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8153,
    longitude: 144.9756,
    accuracy: 1
  },
  {
    postalCode: 8005,
    city: "World Trade Centre",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8153,
    longitude: 144.9756,
    accuracy: 1
  },
  {
    postalCode: 8006,
    city: "Abeckett Street",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8153,
    longitude: 144.9756,
    accuracy: 1
  },
  {
    postalCode: 8007,
    city: "Collins Street West",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8153,
    longitude: 144.9756,
    accuracy: 1
  },
  {
    postalCode: 8008,
    city: "St Kilda Road Central",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8153,
    longitude: 144.9756,
    accuracy: 1
  },
  {
    postalCode: 8009,
    city: "Flinders Lane",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8153,
    longitude: 144.9756,
    accuracy: 1
  },
  {
    postalCode: 8010,
    city: "Law Courts",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8149,
    longitude: 144.9505,
    accuracy: 1
  },
  {
    postalCode: 8011,
    city: "Little Lonsdale Street",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8149,
    longitude: 144.9505,
    accuracy: 1
  },
  {
    postalCode: 8012,
    city: "Docklands",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8149,
    longitude: 144.9505,
    accuracy: 4
  },
  {
    postalCode: 8045,
    city: "Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.814,
    longitude: 144.9633,
    accuracy: 4
  },
  {
    postalCode: 8051,
    city: "Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.814,
    longitude: 144.9633,
    accuracy: 4
  },
  {
    postalCode: 8060,
    city: "Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.814,
    longitude: 144.9633,
    accuracy: 4
  },
  {
    postalCode: 8061,
    city: "Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.814,
    longitude: 144.9633,
    accuracy: 4
  },
  {
    postalCode: 8066,
    city: "Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.814,
    longitude: 144.9633,
    accuracy: 4
  },
  {
    postalCode: 8069,
    city: "Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.814,
    longitude: 144.9633,
    accuracy: 4
  },
  {
    postalCode: 8070,
    city: "Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.814,
    longitude: 144.9633,
    accuracy: 4
  },
  {
    postalCode: 8071,
    city: "Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.814,
    longitude: 144.9633,
    accuracy: 4
  },
  {
    postalCode: 8102,
    city: "Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.814,
    longitude: 144.9633,
    accuracy: 4
  },
  {
    postalCode: 8103,
    city: "Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.814,
    longitude: 144.9633,
    accuracy: 4
  },
  {
    postalCode: 8107,
    city: "Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.814,
    longitude: 144.9633,
    accuracy: 4
  },
  {
    postalCode: 8108,
    city: "Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.814,
    longitude: 144.9633,
    accuracy: 4
  },
  {
    postalCode: 8111,
    city: "Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.814,
    longitude: 144.9633,
    accuracy: 4
  },
  {
    postalCode: 8120,
    city: "Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.814,
    longitude: 144.9633,
    accuracy: 4
  },
  {
    postalCode: 8205,
    city: "Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.814,
    longitude: 144.9633,
    accuracy: 4
  },
  {
    postalCode: 8383,
    city: "Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.814,
    longitude: 144.9633,
    accuracy: 4
  },
  {
    postalCode: 8386,
    city: "Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.814,
    longitude: 144.9633,
    accuracy: 4
  },
  {
    postalCode: 8388,
    city: "Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.814,
    longitude: 144.9633,
    accuracy: 4
  },
  {
    postalCode: 8390,
    city: "Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.814,
    longitude: 144.9633,
    accuracy: 4
  },
  {
    postalCode: 8393,
    city: "Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.814,
    longitude: 144.9633,
    accuracy: 4
  },
  {
    postalCode: 8394,
    city: "Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.814,
    longitude: 144.9633,
    accuracy: 4
  },
  {
    postalCode: 8396,
    city: "Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.814,
    longitude: 144.9633,
    accuracy: 4
  },
  {
    postalCode: 8399,
    city: "Melbourne",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.814,
    longitude: 144.9633,
    accuracy: 4
  },
  {
    postalCode: 8627,
    city: "Camberwell",
    state_name: "Victoria",
    state: "VIC",
    latitude: -37.8421,
    longitude: 145.0694,
    accuracy: 4
  },
  {
    postalCode: 872,
    city: "Ngaanyatjarra-Giles",
    state_name: "Western Australia",
    state: "WA",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Gibson Desert North",
    state_name: "Western Australia",
    state: "WA",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Tjirrkarli",
    state_name: "Western Australia",
    state: "WA",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Wannan",
    state_name: "Western Australia",
    state: "WA",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Gibson Desert South",
    state_name: "Western Australia",
    state: "WA",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Patjarr",
    state_name: "Western Australia",
    state: "WA",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Wingellina",
    state_name: "Western Australia",
    state: "WA",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Kiwirrkurra",
    state_name: "Western Australia",
    state: "WA",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 872,
    city: "Tjukurla",
    state_name: "Western Australia",
    state: "WA",
    latitude: -23.3256,
    longitude: 133.0557,
    accuracy: 3
  },
  {
    postalCode: 6000,
    city: "Perth",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9522,
    longitude: 115.8614,
    accuracy: 4
  },
  {
    postalCode: 6000,
    city: "Perth GPO",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9522,
    longitude: 115.8614,
    accuracy: 3
  },
  {
    postalCode: 6000,
    city: "City Delivery Centre",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9522,
    longitude: 115.8614,
    accuracy: 3
  },
  {
    postalCode: 6001,
    city: "Perth",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9522,
    longitude: 115.8614,
    accuracy: 4
  },
  {
    postalCode: 6003,
    city: "Northbridge",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9478,
    longitude: 115.8588,
    accuracy: 4
  },
  {
    postalCode: 6003,
    city: "Highgate",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9397,
    longitude: 115.8701,
    accuracy: 4
  },
  {
    postalCode: 6004,
    city: "East Perth",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9587,
    longitude: 115.8711,
    accuracy: 4
  },
  {
    postalCode: 6005,
    city: "West Perth",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.949,
    longitude: 115.842,
    accuracy: 4
  },
  {
    postalCode: 6005,
    city: "Kings Park",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.955,
    longitude: 115.8359,
    accuracy: 3
  },
  {
    postalCode: 6006,
    city: "North Perth",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9272,
    longitude: 115.8528,
    accuracy: 4
  },
  {
    postalCode: 6007,
    city: "Leederville",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9363,
    longitude: 115.8419,
    accuracy: 4
  },
  {
    postalCode: 6007,
    city: "West Leederville",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9414,
    longitude: 115.8312,
    accuracy: 4
  },
  {
    postalCode: 6008,
    city: "Shenton Park",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9583,
    longitude: 115.7972,
    accuracy: 4
  },
  {
    postalCode: 6008,
    city: "Daglish",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9483,
    longitude: 115.819,
    accuracy: 4
  },
  {
    postalCode: 6008,
    city: "Subiaco",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9485,
    longitude: 115.8268,
    accuracy: 4
  },
  {
    postalCode: 6008,
    city: "Subiaco East",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9542,
    longitude: 115.7986,
    accuracy: 3
  },
  {
    postalCode: 6009,
    city: "Nedlands",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9818,
    longitude: 115.8073,
    accuracy: 4
  },
  {
    postalCode: 6009,
    city: "Broadway Nedlands",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9853,
    longitude: 115.8052,
    accuracy: 3
  },
  {
    postalCode: 6009,
    city: "Dalkeith",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9952,
    longitude: 115.7998,
    accuracy: 4
  },
  {
    postalCode: 6009,
    city: "Nedlands DC",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9875,
    longitude: 115.8014,
    accuracy: 3
  },
  {
    postalCode: 6009,
    city: "Crawley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9842,
    longitude: 115.816,
    accuracy: 4
  },
  {
    postalCode: 6010,
    city: "Karrakatta",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9676,
    longitude: 115.798,
    accuracy: 4
  },
  {
    postalCode: 6010,
    city: "Claremont",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9796,
    longitude: 115.7823,
    accuracy: 4
  },
  {
    postalCode: 6010,
    city: "Mount Claremont",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.97,
    longitude: 115.7775,
    accuracy: 3
  },
  {
    postalCode: 6010,
    city: "Swanbourne",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9688,
    longitude: 115.7673,
    accuracy: 4
  },
  {
    postalCode: 6010,
    city: "Claremont North",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.97,
    longitude: 115.7775,
    accuracy: 3
  },
  {
    postalCode: 6011,
    city: "Peppermint Grove",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9988,
    longitude: 115.7682,
    accuracy: 4
  },
  {
    postalCode: 6011,
    city: "Cottesloe",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32,
    longitude: 115.7667,
    accuracy: 4
  },
  {
    postalCode: 6012,
    city: "Mosman Park",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0054,
    longitude: 115.7638,
    accuracy: 4
  },
  {
    postalCode: 6014,
    city: "Wembley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9333,
    longitude: 115.8,
    accuracy: 4
  },
  {
    postalCode: 6014,
    city: "Floreat",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9386,
    longitude: 115.7921,
    accuracy: 4
  },
  {
    postalCode: 6014,
    city: "Jolimont",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9456,
    longitude: 115.8095,
    accuracy: 4
  },
  {
    postalCode: 6015,
    city: "City Beach",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9344,
    longitude: 115.7617,
    accuracy: 4
  },
  {
    postalCode: 6016,
    city: "Mount Hawthorn",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.92,
    longitude: 115.8351,
    accuracy: 4
  },
  {
    postalCode: 6016,
    city: "Glendalough",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9199,
    longitude: 115.8194,
    accuracy: 4
  },
  {
    postalCode: 6017,
    city: "Herdsman",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9106,
    longitude: 115.8055,
    accuracy: 4
  },
  {
    postalCode: 6017,
    city: "Osborne Park DC",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9007,
    longitude: 115.8108,
    accuracy: 3
  },
  {
    postalCode: 6017,
    city: "Osborne Park",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9007,
    longitude: 115.8108,
    accuracy: 4
  },
  {
    postalCode: 6018,
    city: "Churchlands",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9214,
    longitude: 115.7932,
    accuracy: 4
  },
  {
    postalCode: 6018,
    city: "Woodlands",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8873,
    longitude: 115.7865,
    accuracy: 3
  },
  {
    postalCode: 6018,
    city: "Gwelup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8716,
    longitude: 115.7948,
    accuracy: 4
  },
  {
    postalCode: 6018,
    city: "Innaloo",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8927,
    longitude: 115.7951,
    accuracy: 4
  },
  {
    postalCode: 6018,
    city: "Doubleview",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8963,
    longitude: 115.7816,
    accuracy: 4
  },
  {
    postalCode: 6018,
    city: "Gwelup DC",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8909,
    longitude: 115.7883,
    accuracy: 3
  },
  {
    postalCode: 6018,
    city: "Karrinyup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8723,
    longitude: 115.7768,
    accuracy: 4
  },
  {
    postalCode: 6019,
    city: "Wembley Downs",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9117,
    longitude: 115.7736,
    accuracy: 4
  },
  {
    postalCode: 6019,
    city: "Scarborough",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8958,
    longitude: 115.7643,
    accuracy: 4
  },
  {
    postalCode: 6020,
    city: "North Beach",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.863,
    longitude: 115.7562,
    accuracy: 4
  },
  {
    postalCode: 6020,
    city: "Marmion",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8416,
    longitude: 115.7569,
    accuracy: 4
  },
  {
    postalCode: 6020,
    city: "Watermans Bay",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8492,
    longitude: 115.7559,
    accuracy: 4
  },
  {
    postalCode: 6020,
    city: "Sorrento",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8253,
    longitude: 115.7525,
    accuracy: 4
  },
  {
    postalCode: 6020,
    city: "Carine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8523,
    longitude: 115.7826,
    accuracy: 4
  },
  {
    postalCode: 6021,
    city: "Stirling",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8834,
    longitude: 115.8099,
    accuracy: 4
  },
  {
    postalCode: 6021,
    city: "Balcatta",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.875,
    longitude: 115.8284,
    accuracy: 4
  },
  {
    postalCode: 6022,
    city: "Hamersley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.849,
    longitude: 115.8076,
    accuracy: 4
  },
  {
    postalCode: 6023,
    city: "Duncraig",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8329,
    longitude: 115.7759,
    accuracy: 4
  },
  {
    postalCode: 6024,
    city: "Warwick",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8397,
    longitude: 115.8086,
    accuracy: 4
  },
  {
    postalCode: 6024,
    city: "Greenwood",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8272,
    longitude: 115.8025,
    accuracy: 4
  },
  {
    postalCode: 6025,
    city: "Hillarys",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.807,
    longitude: 115.7405,
    accuracy: 4
  },
  {
    postalCode: 6025,
    city: "Craigie",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7873,
    longitude: 115.7699,
    accuracy: 4
  },
  {
    postalCode: 6025,
    city: "Kallaroo",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.791,
    longitude: 115.753,
    accuracy: 4
  },
  {
    postalCode: 6025,
    city: "Padbury",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8064,
    longitude: 115.7688,
    accuracy: 4
  },
  {
    postalCode: 6026,
    city: "Kingsley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8104,
    longitude: 115.8008,
    accuracy: 4
  },
  {
    postalCode: 6026,
    city: "Woodvale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7893,
    longitude: 115.7968,
    accuracy: 4
  },
  {
    postalCode: 6027,
    city: "Ocean Reef",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7587,
    longitude: 115.736,
    accuracy: 4
  },
  {
    postalCode: 6027,
    city: "Beldon",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7747,
    longitude: 115.7627,
    accuracy: 4
  },
  {
    postalCode: 6027,
    city: "Joondalup DC",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7619,
    longitude: 115.7565,
    accuracy: 3
  },
  {
    postalCode: 6027,
    city: "Connolly",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7486,
    longitude: 115.7505,
    accuracy: 4
  },
  {
    postalCode: 6027,
    city: "Heathridge",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7624,
    longitude: 115.7589,
    accuracy: 4
  },
  {
    postalCode: 6027,
    city: "Edgewater",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7655,
    longitude: 115.7822,
    accuracy: 4
  },
  {
    postalCode: 6027,
    city: "Mullaloo",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.779,
    longitude: 115.7368,
    accuracy: 4
  },
  {
    postalCode: 6027,
    city: "Joondalup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7444,
    longitude: 115.7683,
    accuracy: 4
  },
  {
    postalCode: 6028,
    city: "Iluka",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7355,
    longitude: 115.7306,
    accuracy: 4
  },
  {
    postalCode: 6028,
    city: "Currambine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7331,
    longitude: 115.7477,
    accuracy: 4
  },
  {
    postalCode: 6028,
    city: "Kinross",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7187,
    longitude: 115.7384,
    accuracy: 4
  },
  {
    postalCode: 6028,
    city: "Burns Beach",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7206,
    longitude: 115.7205,
    accuracy: 4
  },
  {
    postalCode: 6029,
    city: "Trigg",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8694,
    longitude: 115.7571,
    accuracy: 4
  },
  {
    postalCode: 6030,
    city: "Merriwa",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.6649,
    longitude: 115.7127,
    accuracy: 4
  },
  {
    postalCode: 6030,
    city: "Tamala Park",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7061,
    longitude: 115.7201,
    accuracy: 4
  },
  {
    postalCode: 6030,
    city: "Clarkson",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.6828,
    longitude: 115.7247,
    accuracy: 4
  },
  {
    postalCode: 6030,
    city: "Quinns Rocks",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.6738,
    longitude: 115.7037,
    accuracy: 4
  },
  {
    postalCode: 6030,
    city: "Ridgewood",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.6615,
    longitude: 115.7226,
    accuracy: 4
  },
  {
    postalCode: 6030,
    city: "Mindarie",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.6893,
    longitude: 115.707,
    accuracy: 4
  },
  {
    postalCode: 6031,
    city: "Neerabup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.6734,
    longitude: 115.7517,
    accuracy: 4
  },
  {
    postalCode: 6031,
    city: "Banksia Grove",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.6962,
    longitude: 115.805,
    accuracy: 4
  },
  {
    postalCode: 6031,
    city: "Carramar",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.6902,
    longitude: 115.7716,
    accuracy: 4
  },
  {
    postalCode: 6032,
    city: "Nowergup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.6371,
    longitude: 115.7625,
    accuracy: 4
  },
  {
    postalCode: 6033,
    city: "Carabooda",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.6058,
    longitude: 115.7144,
    accuracy: 4
  },
  {
    postalCode: 6034,
    city: "Eglinton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.5868,
    longitude: 115.6888,
    accuracy: 4
  },
  {
    postalCode: 6035,
    city: "Yanchep",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.5468,
    longitude: 115.6317,
    accuracy: 4
  },
  {
    postalCode: 6036,
    city: "Butler",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.643,
    longitude: 115.7043,
    accuracy: 4
  },
  {
    postalCode: 6036,
    city: "Jindalee",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.6494,
    longitude: 115.695,
    accuracy: 4
  },
  {
    postalCode: 6037,
    city: "Two Rocks",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.4998,
    longitude: 115.5874,
    accuracy: 4
  },
  {
    postalCode: 6038,
    city: "Alkimos",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.6304,
    longitude: 115.6864,
    accuracy: 4
  },
  {
    postalCode: 6041,
    city: "Wilbinga",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.3591,
    longitude: 115.5608,
    accuracy: 3
  },
  {
    postalCode: 6041,
    city: "Gabbadah",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.292,
    longitude: 115.5059,
    accuracy: 4
  },
  {
    postalCode: 6041,
    city: "Caraban",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.3591,
    longitude: 115.5608,
    accuracy: 3
  },
  {
    postalCode: 6041,
    city: "Woodridge",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.3338,
    longitude: 115.5959,
    accuracy: 4
  },
  {
    postalCode: 6041,
    city: "Guilderton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.3451,
    longitude: 115.499,
    accuracy: 4
  },
  {
    postalCode: 6042,
    city: "Seabird",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.2772,
    longitude: 115.4439,
    accuracy: 4
  },
  {
    postalCode: 6043,
    city: "Ledge Point",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.1002,
    longitude: 115.3909,
    accuracy: 4
  },
  {
    postalCode: 6043,
    city: "Breton Bay",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.1025,
    longitude: 115.3766,
    accuracy: 3
  },
  {
    postalCode: 6044,
    city: "Lancelin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.0225,
    longitude: 115.3365,
    accuracy: 4
  },
  {
    postalCode: 6044,
    city: "Wedge Island",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.8531,
    longitude: 115.3072,
    accuracy: 3
  },
  {
    postalCode: 6044,
    city: "Karakin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.9704,
    longitude: 115.3976,
    accuracy: 3
  },
  {
    postalCode: 6044,
    city: "Nilgen",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.9704,
    longitude: 115.3976,
    accuracy: 3
  },
  {
    postalCode: 6050,
    city: "Menora",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9189,
    longitude: 115.8621,
    accuracy: 4
  },
  {
    postalCode: 6050,
    city: "Coolbinia",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9147,
    longitude: 115.8489,
    accuracy: 4
  },
  {
    postalCode: 6050,
    city: "Mount Lawley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9344,
    longitude: 115.8716,
    accuracy: 4
  },
  {
    postalCode: 6051,
    city: "Maylands",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.931,
    longitude: 115.8949,
    accuracy: 4
  },
  {
    postalCode: 6052,
    city: "Inglewood",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9166,
    longitude: 115.8798,
    accuracy: 4
  },
  {
    postalCode: 6052,
    city: "Bedford",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9113,
    longitude: 115.8892,
    accuracy: 4
  },
  {
    postalCode: 6053,
    city: "Bayswater",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9169,
    longitude: 115.9178,
    accuracy: 4
  },
  {
    postalCode: 6054,
    city: "Ashfield",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9172,
    longitude: 115.938,
    accuracy: 4
  },
  {
    postalCode: 6054,
    city: "Bassendean",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9091,
    longitude: 115.9437,
    accuracy: 4
  },
  {
    postalCode: 6054,
    city: "Eden Hill",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8891,
    longitude: 115.9467,
    accuracy: 4
  },
  {
    postalCode: 6054,
    city: "Lockridge",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8817,
    longitude: 115.9503,
    accuracy: 4
  },
  {
    postalCode: 6054,
    city: "Kiara",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8816,
    longitude: 115.9389,
    accuracy: 4
  },
  {
    postalCode: 6055,
    city: "Hazelmere",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9174,
    longitude: 116.0118,
    accuracy: 4
  },
  {
    postalCode: 6055,
    city: "Henley Brook",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8139,
    longitude: 115.9881,
    accuracy: 4
  },
  {
    postalCode: 6055,
    city: "West Swan",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8476,
    longitude: 115.9799,
    accuracy: 3
  },
  {
    postalCode: 6055,
    city: "Brabham",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8273,
    longitude: 115.9742,
    accuracy: 4
  },
  {
    postalCode: 6055,
    city: "Caversham",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8833,
    longitude: 115.9667,
    accuracy: 4
  },
  {
    postalCode: 6055,
    city: "South Guildford",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9122,
    longitude: 115.9682,
    accuracy: 4
  },
  {
    postalCode: 6055,
    city: "Guildford",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9,
    longitude: 115.9667,
    accuracy: 4
  },
  {
    postalCode: 6055,
    city: "Dayton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8525,
    longitude: 115.9749,
    accuracy: 4
  },
  {
    postalCode: 6056,
    city: "Koongamia",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9066,
    longitude: 116.0422,
    accuracy: 4
  },
  {
    postalCode: 6056,
    city: "Viveash",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8777,
    longitude: 115.9975,
    accuracy: 4
  },
  {
    postalCode: 6056,
    city: "Jane Brook",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8637,
    longitude: 116.0504,
    accuracy: 4
  },
  {
    postalCode: 6056,
    city: "Midvale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8888,
    longitude: 116.0329,
    accuracy: 4
  },
  {
    postalCode: 6056,
    city: "Boya",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9333,
    longitude: 116.05,
    accuracy: 4
  },
  {
    postalCode: 6056,
    city: "Woodbridge",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8869,
    longitude: 115.992,
    accuracy: 4
  },
  {
    postalCode: 6056,
    city: "Greenmount",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9007,
    longitude: 116.0495,
    accuracy: 4
  },
  {
    postalCode: 6056,
    city: "Red Hill",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.849,
    longitude: 116.0584,
    accuracy: 4
  },
  {
    postalCode: 6056,
    city: "Helena Valley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9194,
    longitude: 116.0398,
    accuracy: 4
  },
  {
    postalCode: 6056,
    city: "Midland",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9,
    longitude: 116,
    accuracy: 4
  },
  {
    postalCode: 6056,
    city: "Baskerville",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7978,
    longitude: 116.0436,
    accuracy: 4
  },
  {
    postalCode: 6056,
    city: "Bellevue",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9,
    longitude: 116.0167,
    accuracy: 4
  },
  {
    postalCode: 6056,
    city: "Middle Swan",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.85,
    longitude: 116.0167,
    accuracy: 4
  },
  {
    postalCode: 6056,
    city: "Millendon",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8167,
    longitude: 116.0333,
    accuracy: 4
  },
  {
    postalCode: 6056,
    city: "Stratton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8683,
    longitude: 116.0407,
    accuracy: 4
  },
  {
    postalCode: 6056,
    city: "Swan View",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8833,
    longitude: 116.05,
    accuracy: 4
  },
  {
    postalCode: 6056,
    city: "Herne Hill",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8255,
    longitude: 116.0227,
    accuracy: 4
  },
  {
    postalCode: 6057,
    city: "High Wycombe",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9444,
    longitude: 116.0034,
    accuracy: 4
  },
  {
    postalCode: 6057,
    city: "Maida Vale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9519,
    longitude: 116.0276,
    accuracy: 4
  },
  {
    postalCode: 6058,
    city: "Forrestfield",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9828,
    longitude: 116.0067,
    accuracy: 4
  },
  {
    postalCode: 6059,
    city: "Dianella",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8882,
    longitude: 115.8719,
    accuracy: 4
  },
  {
    postalCode: 6060,
    city: "Joondanna",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9077,
    longitude: 115.8423,
    accuracy: 4
  },
  {
    postalCode: 6060,
    city: "Dog Swamp",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.902,
    longitude: 115.8455,
    accuracy: 3
  },
  {
    postalCode: 6060,
    city: "Tuart Hill",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8981,
    longitude: 115.8349,
    accuracy: 4
  },
  {
    postalCode: 6060,
    city: "Yokine South",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8996,
    longitude: 115.8441,
    accuracy: 3
  },
  {
    postalCode: 6060,
    city: "Yokine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9011,
    longitude: 115.8532,
    accuracy: 4
  },
  {
    postalCode: 6061,
    city: "Westminster",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8674,
    longitude: 115.8392,
    accuracy: 4
  },
  {
    postalCode: 6061,
    city: "Balga",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.855,
    longitude: 115.8399,
    accuracy: 4
  },
  {
    postalCode: 6061,
    city: "Mirrabooka",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8596,
    longitude: 115.8659,
    accuracy: 4
  },
  {
    postalCode: 6061,
    city: "Nollamara",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8802,
    longitude: 115.8454,
    accuracy: 4
  },
  {
    postalCode: 6062,
    city: "Embleton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9035,
    longitude: 115.909,
    accuracy: 4
  },
  {
    postalCode: 6062,
    city: "Morley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8877,
    longitude: 115.9099,
    accuracy: 4
  },
  {
    postalCode: 6062,
    city: "Noranda",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8733,
    longitude: 115.899,
    accuracy: 4
  },
  {
    postalCode: 6063,
    city: "Beechboro",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8651,
    longitude: 115.9366,
    accuracy: 4
  },
  {
    postalCode: 6063,
    city: "Bennett Springs",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8651,
    longitude: 115.9366,
    accuracy: 3
  },
  {
    postalCode: 6064,
    city: "Girrawheen",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.841,
    longitude: 115.8398,
    accuracy: 4
  },
  {
    postalCode: 6064,
    city: "Alexander Heights",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8276,
    longitude: 115.865,
    accuracy: 4
  },
  {
    postalCode: 6064,
    city: "Marangaroo",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8271,
    longitude: 115.8384,
    accuracy: 4
  },
  {
    postalCode: 6064,
    city: "Koondoola",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8415,
    longitude: 115.8665,
    accuracy: 4
  },
  {
    postalCode: 6065,
    city: "Madeley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8111,
    longitude: 115.8281,
    accuracy: 4
  },
  {
    postalCode: 6065,
    city: "Gnangara",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7761,
    longitude: 115.8662,
    accuracy: 4
  },
  {
    postalCode: 6065,
    city: "Sinagra",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7426,
    longitude: 115.8063,
    accuracy: 4
  },
  {
    postalCode: 6065,
    city: "Hocking",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7701,
    longitude: 115.8183,
    accuracy: 4
  },
  {
    postalCode: 6065,
    city: "Darch",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8125,
    longitude: 115.8458,
    accuracy: 4
  },
  {
    postalCode: 6065,
    city: "Wangara DC",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7671,
    longitude: 115.8255,
    accuracy: 3
  },
  {
    postalCode: 6065,
    city: "Pearsall",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7812,
    longitude: 115.8182,
    accuracy: 4
  },
  {
    postalCode: 6065,
    city: "Tapping",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7195,
    longitude: 115.7956,
    accuracy: 4
  },
  {
    postalCode: 6065,
    city: "Wanneroo",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.75,
    longitude: 115.8,
    accuracy: 4
  },
  {
    postalCode: 6065,
    city: "Kingsway",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.6923,
    longitude: 115.8437,
    accuracy: 3
  },
  {
    postalCode: 6065,
    city: "Wangara",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7914,
    longitude: 115.8203,
    accuracy: 4
  },
  {
    postalCode: 6065,
    city: "Landsdale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8075,
    longitude: 115.866,
    accuracy: 4
  },
  {
    postalCode: 6065,
    city: "Lexia",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7934,
    longitude: 115.9215,
    accuracy: 4
  },
  {
    postalCode: 6065,
    city: "Mariginiup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7111,
    longitude: 115.8432,
    accuracy: 4
  },
  {
    postalCode: 6065,
    city: "Ashby",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7325,
    longitude: 115.7977,
    accuracy: 4
  },
  {
    postalCode: 6065,
    city: "Jandabup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.755,
    longitude: 115.8607,
    accuracy: 4
  },
  {
    postalCode: 6065,
    city: "Pinjar",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.6936,
    longitude: 115.8431,
    accuracy: 4
  },
  {
    postalCode: 6065,
    city: "Melaleuca",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7745,
    longitude: 115.9176,
    accuracy: 4
  },
  {
    postalCode: 6066,
    city: "Ballajura",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8406,
    longitude: 115.8955,
    accuracy: 4
  },
  {
    postalCode: 6067,
    city: "Cullacabardee",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8194,
    longitude: 115.9055,
    accuracy: 4
  },
  {
    postalCode: 6068,
    city: "Whiteman",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8245,
    longitude: 115.9416,
    accuracy: 4
  },
  {
    postalCode: 6069,
    city: "Aveley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7813,
    longitude: 115.9896,
    accuracy: 4
  },
  {
    postalCode: 6069,
    city: "Upper Swan",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7695,
    longitude: 116.0273,
    accuracy: 4
  },
  {
    postalCode: 6069,
    city: "The Vines",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7549,
    longitude: 116.0024,
    accuracy: 4
  },
  {
    postalCode: 6069,
    city: "Ellenbrook East",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7673,
    longitude: 116.0259,
    accuracy: 3
  },
  {
    postalCode: 6069,
    city: "Belhus",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7816,
    longitude: 116.0095,
    accuracy: 4
  },
  {
    postalCode: 6069,
    city: "Ellenbrook",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7674,
    longitude: 115.9694,
    accuracy: 4
  },
  {
    postalCode: 6069,
    city: "Brigadoon",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7726,
    longitude: 116.0727,
    accuracy: 4
  },
  {
    postalCode: 6070,
    city: "Darlington",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9191,
    longitude: 116.0812,
    accuracy: 4
  },
  {
    postalCode: 6071,
    city: "Hovea",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8833,
    longitude: 116.1,
    accuracy: 4
  },
  {
    postalCode: 6071,
    city: "Glen Forrest",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9193,
    longitude: 116.1073,
    accuracy: 4
  },
  {
    postalCode: 6072,
    city: "Mahogany Creek",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9095,
    longitude: 116.1043,
    accuracy: 4
  },
  {
    postalCode: 6073,
    city: "Mundaring DC",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9021,
    longitude: 116.1676,
    accuracy: 3
  },
  {
    postalCode: 6073,
    city: "Mundaring",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9021,
    longitude: 116.1676,
    accuracy: 4
  },
  {
    postalCode: 6074,
    city: "Sawyers Valley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9023,
    longitude: 116.2007,
    accuracy: 4
  },
  {
    postalCode: 6076,
    city: "Bickley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32,
    longitude: 116.0833,
    accuracy: 4
  },
  {
    postalCode: 6076,
    city: "Paulls Valley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9692,
    longitude: 116.1094,
    accuracy: 4
  },
  {
    postalCode: 6076,
    city: "Reservoir",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9647,
    longitude: 116.166,
    accuracy: 4
  },
  {
    postalCode: 6076,
    city: "Carmel",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0167,
    longitude: 116.1,
    accuracy: 4
  },
  {
    postalCode: 6076,
    city: "Lesmurdie",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.002,
    longitude: 116.0482,
    accuracy: 4
  },
  {
    postalCode: 6076,
    city: "Hacketts Gully",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9774,
    longitude: 116.0928,
    accuracy: 4
  },
  {
    postalCode: 6076,
    city: "Kalamunda",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9868,
    longitude: 116.0704,
    accuracy: 3
  },
  {
    postalCode: 6076,
    city: "Piesse Brook",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.972,
    longitude: 116.0779,
    accuracy: 4
  },
  {
    postalCode: 6076,
    city: "Gooseberry Hill",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9544,
    longitude: 116.0492,
    accuracy: 4
  },
  {
    postalCode: 6076,
    city: "Pickering Brook",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0333,
    longitude: 116.1,
    accuracy: 4
  },
  {
    postalCode: 6076,
    city: "Walliston",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9968,
    longitude: 116.0743,
    accuracy: 4
  },
  {
    postalCode: 6077,
    city: "Gnangara",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7761,
    longitude: 115.8662,
    accuracy: 4
  },
  {
    postalCode: 6077,
    city: "Jandabup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.755,
    longitude: 115.8607,
    accuracy: 4
  },
  {
    postalCode: 6078,
    city: "Pinjar",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.6936,
    longitude: 115.8431,
    accuracy: 4
  },
  {
    postalCode: 6078,
    city: "Mariginiup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7111,
    longitude: 115.8432,
    accuracy: 4
  },
  {
    postalCode: 6079,
    city: "Melaleuca",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7745,
    longitude: 115.9176,
    accuracy: 4
  },
  {
    postalCode: 6079,
    city: "Lexia",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7934,
    longitude: 115.9215,
    accuracy: 4
  },
  {
    postalCode: 6081,
    city: "Stoneville",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8783,
    longitude: 116.1707,
    accuracy: 4
  },
  {
    postalCode: 6081,
    city: "Parkerville",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8747,
    longitude: 116.138,
    accuracy: 4
  },
  {
    postalCode: 6082,
    city: "Mount Helena",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8761,
    longitude: 116.2103,
    accuracy: 4
  },
  {
    postalCode: 6082,
    city: "Bailup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7392,
    longitude: 116.3102,
    accuracy: 4
  },
  {
    postalCode: 6083,
    city: "Morangup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.599,
    longitude: 116.3541,
    accuracy: 3
  },
  {
    postalCode: 6083,
    city: "Gidgegannup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7544,
    longitude: 116.1875,
    accuracy: 4
  },
  {
    postalCode: 6084,
    city: "Chittering",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.4677,
    longitude: 116.0801,
    accuracy: 4
  },
  {
    postalCode: 6084,
    city: "Lower Chittering",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.5833,
    longitude: 116.1167,
    accuracy: 4
  },
  {
    postalCode: 6084,
    city: "Bullsbrook",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.669,
    longitude: 115.9999,
    accuracy: 4
  },
  {
    postalCode: 6084,
    city: "Walyunga National Park",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.5924,
    longitude: 116.1014,
    accuracy: 3
  },
  {
    postalCode: 6084,
    city: "Avon Valley National Park",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.6361,
    longitude: 116.1887,
    accuracy: 4
  },
  {
    postalCode: 6090,
    city: "Malaga",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8526,
    longitude: 115.881,
    accuracy: 4
  },
  {
    postalCode: 6100,
    city: "Burswood",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9587,
    longitude: 115.904,
    accuracy: 4
  },
  {
    postalCode: 6100,
    city: "Lathlain",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9676,
    longitude: 115.9063,
    accuracy: 4
  },
  {
    postalCode: 6100,
    city: "Victoria Park",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9762,
    longitude: 115.9052,
    accuracy: 4
  },
  {
    postalCode: 6101,
    city: "Carlisle South",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9842,
    longitude: 115.911,
    accuracy: 3
  },
  {
    postalCode: 6101,
    city: "Carlisle",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9795,
    longitude: 115.9181,
    accuracy: 4
  },
  {
    postalCode: 6101,
    city: "East Victoria Park",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9889,
    longitude: 115.9039,
    accuracy: 4
  },
  {
    postalCode: 6101,
    city: "Carlisle North",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9842,
    longitude: 115.911,
    accuracy: 3
  },
  {
    postalCode: 6102,
    city: "Bentley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32,
    longitude: 115.9167,
    accuracy: 4
  },
  {
    postalCode: 6102,
    city: "St James",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32,
    longitude: 115.9098,
    accuracy: 4
  },
  {
    postalCode: 6102,
    city: "Bentley DC",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32,
    longitude: 115.9132,
    accuracy: 3
  },
  {
    postalCode: 6102,
    city: "Bentley South",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32,
    longitude: 115.9132,
    accuracy: 3
  },
  {
    postalCode: 6103,
    city: "Rivervale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9555,
    longitude: 115.9131,
    accuracy: 4
  },
  {
    postalCode: 6104,
    city: "Redcliffe",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9384,
    longitude: 115.9464,
    accuracy: 4
  },
  {
    postalCode: 6104,
    city: "Belmont",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9435,
    longitude: 115.9255,
    accuracy: 4
  },
  {
    postalCode: 6104,
    city: "Ascot",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9382,
    longitude: 115.9226,
    accuracy: 4
  },
  {
    postalCode: 6105,
    city: "Perth Airport",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9321,
    longitude: 115.9564,
    accuracy: 4
  },
  {
    postalCode: 6105,
    city: "Kewdale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9789,
    longitude: 115.9516,
    accuracy: 4
  },
  {
    postalCode: 6105,
    city: "Cloverdale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9628,
    longitude: 115.9443,
    accuracy: 4
  },
  {
    postalCode: 6106,
    city: "Welshpool",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9944,
    longitude: 115.9222,
    accuracy: 4
  },
  {
    postalCode: 6107,
    city: "Wattle Grove",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0067,
    longitude: 116.0005,
    accuracy: 4
  },
  {
    postalCode: 6107,
    city: "Queens Park",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0031,
    longitude: 115.9462,
    accuracy: 4
  },
  {
    postalCode: 6107,
    city: "Kenwick",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0333,
    longitude: 115.9667,
    accuracy: 4
  },
  {
    postalCode: 6107,
    city: "Beckenham",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0248,
    longitude: 115.9599,
    accuracy: 4
  },
  {
    postalCode: 6107,
    city: "East Cannington",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0098,
    longitude: 115.955,
    accuracy: 4
  },
  {
    postalCode: 6107,
    city: "Wilson",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0206,
    longitude: 115.9118,
    accuracy: 4
  },
  {
    postalCode: 6107,
    city: "Cannington",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0167,
    longitude: 115.95,
    accuracy: 4
  },
  {
    postalCode: 6108,
    city: "Thornlie",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.06,
    longitude: 115.955,
    accuracy: 4
  },
  {
    postalCode: 6109,
    city: "Maddington",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.05,
    longitude: 115.9833,
    accuracy: 4
  },
  {
    postalCode: 6109,
    city: "Orange Grove",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0293,
    longitude: 116.0057,
    accuracy: 4
  },
  {
    postalCode: 6110,
    city: "Gosnells",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.081,
    longitude: 116.0054,
    accuracy: 4
  },
  {
    postalCode: 6110,
    city: "Huntingdale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0832,
    longitude: 115.9661,
    accuracy: 4
  },
  {
    postalCode: 6110,
    city: "Southern River",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1066,
    longitude: 115.959,
    accuracy: 4
  },
  {
    postalCode: 6110,
    city: "Martin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0755,
    longitude: 116.0454,
    accuracy: 4
  },
  {
    postalCode: 6111,
    city: "Champion Lakes",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1191,
    longitude: 115.9862,
    accuracy: 4
  },
  {
    postalCode: 6111,
    city: "Ashendon",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1831,
    longitude: 116.1341,
    accuracy: 4
  },
  {
    postalCode: 6111,
    city: "Kelmscott",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1243,
    longitude: 116.0259,
    accuracy: 4
  },
  {
    postalCode: 6111,
    city: "Camillo",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1129,
    longitude: 116.0021,
    accuracy: 4
  },
  {
    postalCode: 6111,
    city: "Roleystone",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1146,
    longitude: 116.0706,
    accuracy: 4
  },
  {
    postalCode: 6111,
    city: "Karragullen",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1,
    longitude: 116.1333,
    accuracy: 4
  },
  {
    postalCode: 6111,
    city: "Canning Mills",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0804,
    longitude: 116.1047,
    accuracy: 4
  },
  {
    postalCode: 6111,
    city: "Lesley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.185,
    longitude: 116.2075,
    accuracy: 4
  },
  {
    postalCode: 6111,
    city: "Kelmscott DC",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1286,
    longitude: 116.0542,
    accuracy: 3
  },
  {
    postalCode: 6111,
    city: "Westfield",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.15,
    longitude: 115.9667,
    accuracy: 4
  },
  {
    postalCode: 6112,
    city: "Mount Nasura",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1378,
    longitude: 116.0247,
    accuracy: 4
  },
  {
    postalCode: 6112,
    city: "Piara Waters",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1334,
    longitude: 115.9163,
    accuracy: 4
  },
  {
    postalCode: 6112,
    city: "Wungong",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1802,
    longitude: 116.0095,
    accuracy: 4
  },
  {
    postalCode: 6112,
    city: "Forrestdale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1552,
    longitude: 115.9342,
    accuracy: 4
  },
  {
    postalCode: 6112,
    city: "Hilbert",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1782,
    longitude: 115.9849,
    accuracy: 4
  },
  {
    postalCode: 6112,
    city: "Harrisdale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1108,
    longitude: 115.9356,
    accuracy: 4
  },
  {
    postalCode: 6112,
    city: "Mount Richon",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1735,
    longitude: 116.0214,
    accuracy: 4
  },
  {
    postalCode: 6112,
    city: "Brookdale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.167,
    longitude: 116.0019,
    accuracy: 4
  },
  {
    postalCode: 6112,
    city: "Haynes",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.162,
    longitude: 115.9815,
    accuracy: 4
  },
  {
    postalCode: 6112,
    city: "Bedfordale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1741,
    longitude: 116.0504,
    accuracy: 4
  },
  {
    postalCode: 6112,
    city: "Armadale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1461,
    longitude: 116.0093,
    accuracy: 4
  },
  {
    postalCode: 6112,
    city: "Seville Grove",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1364,
    longitude: 115.989,
    accuracy: 4
  },
  {
    postalCode: 6121,
    city: "Oldbury",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2657,
    longitude: 115.9183,
    accuracy: 4
  },
  {
    postalCode: 6121,
    city: "Oakford",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2009,
    longitude: 115.9339,
    accuracy: 4
  },
  {
    postalCode: 6122,
    city: "Byford",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.221,
    longitude: 116.009,
    accuracy: 4
  },
  {
    postalCode: 6122,
    city: "Karrakup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2233,
    longitude: 116.035,
    accuracy: 4
  },
  {
    postalCode: 6122,
    city: "Cardup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.25,
    longitude: 116,
    accuracy: 4
  },
  {
    postalCode: 6122,
    city: "Darling Downs",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1944,
    longitude: 115.9919,
    accuracy: 4
  },
  {
    postalCode: 6123,
    city: "Whitby",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.292,
    longitude: 116.0124,
    accuracy: 4
  },
  {
    postalCode: 6123,
    city: "Mundijong",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2922,
    longitude: 115.9856,
    accuracy: 4
  },
  {
    postalCode: 6124,
    city: "Jarrahdale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.3358,
    longitude: 116.0595,
    accuracy: 4
  },
  {
    postalCode: 6125,
    city: "Serpentine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.3605,
    longitude: 115.9772,
    accuracy: 4
  },
  {
    postalCode: 6125,
    city: "Hopeland",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.3816,
    longitude: 115.8873,
    accuracy: 4
  },
  {
    postalCode: 6125,
    city: "Mardella",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.3333,
    longitude: 115.9833,
    accuracy: 4
  },
  {
    postalCode: 6126,
    city: "Keysbrook",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.4333,
    longitude: 115.9667,
    accuracy: 4
  },
  {
    postalCode: 6147,
    city: "Lynwood",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0401,
    longitude: 115.9289,
    accuracy: 4
  },
  {
    postalCode: 6147,
    city: "Langford",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0409,
    longitude: 115.9416,
    accuracy: 4
  },
  {
    postalCode: 6147,
    city: "Parkwood",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0491,
    longitude: 115.9184,
    accuracy: 4
  },
  {
    postalCode: 6148,
    city: "Shelley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0296,
    longitude: 115.8866,
    accuracy: 4
  },
  {
    postalCode: 6148,
    city: "Rossmoyne",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0397,
    longitude: 115.8678,
    accuracy: 4
  },
  {
    postalCode: 6148,
    city: "Ferndale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0349,
    longitude: 115.9223,
    accuracy: 4
  },
  {
    postalCode: 6148,
    city: "Riverton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0347,
    longitude: 115.8986,
    accuracy: 4
  },
  {
    postalCode: 6149,
    city: "Bull Creek",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0563,
    longitude: 115.8624,
    accuracy: 4
  },
  {
    postalCode: 6149,
    city: "Leeming",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0751,
    longitude: 115.8661,
    accuracy: 4
  },
  {
    postalCode: 6150,
    city: "Murdoch",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0699,
    longitude: 115.8376,
    accuracy: 4
  },
  {
    postalCode: 6150,
    city: "Bateman",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0555,
    longitude: 115.8474,
    accuracy: 4
  },
  {
    postalCode: 6150,
    city: "Winthrop",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0522,
    longitude: 115.8297,
    accuracy: 4
  },
  {
    postalCode: 6151,
    city: "South Perth Angelo St",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9833,
    longitude: 115.8667,
    accuracy: 3
  },
  {
    postalCode: 6151,
    city: "South Perth",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9833,
    longitude: 115.8667,
    accuracy: 4
  },
  {
    postalCode: 6151,
    city: "Kensington",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.981,
    longitude: 115.8696,
    accuracy: 3
  },
  {
    postalCode: 6152,
    city: "Waterford",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0157,
    longitude: 115.8866,
    accuracy: 4
  },
  {
    postalCode: 6152,
    city: "Como",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9912,
    longitude: 115.8634,
    accuracy: 4
  },
  {
    postalCode: 6152,
    city: "Karawara",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0086,
    longitude: 115.8811,
    accuracy: 4
  },
  {
    postalCode: 6152,
    city: "Manning",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0159,
    longitude: 115.8671,
    accuracy: 4
  },
  {
    postalCode: 6152,
    city: "Salter Point",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0238,
    longitude: 115.8658,
    accuracy: 4
  },
  {
    postalCode: 6153,
    city: "Mount Pleasant",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0279,
    longitude: 115.8489,
    accuracy: 4
  },
  {
    postalCode: 6153,
    city: "Ardross",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.027,
    longitude: 115.8355,
    accuracy: 4
  },
  {
    postalCode: 6153,
    city: "Applecross North",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0323,
    longitude: 115.8367,
    accuracy: 3
  },
  {
    postalCode: 6153,
    city: "Brentwood",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0435,
    longitude: 115.8525,
    accuracy: 4
  },
  {
    postalCode: 6153,
    city: "Canning Bridge Applecross",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0323,
    longitude: 115.8367,
    accuracy: 3
  },
  {
    postalCode: 6153,
    city: "Applecross",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0167,
    longitude: 115.8333,
    accuracy: 4
  },
  {
    postalCode: 6154,
    city: "Myaree",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.04,
    longitude: 115.8176,
    accuracy: 4
  },
  {
    postalCode: 6154,
    city: "Booragoon",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0395,
    longitude: 115.8337,
    accuracy: 4
  },
  {
    postalCode: 6154,
    city: "Alfred Cove",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0332,
    longitude: 115.8126,
    accuracy: 4
  },
  {
    postalCode: 6155,
    city: "Canning Vale East",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0552,
    longitude: 115.903,
    accuracy: 3
  },
  {
    postalCode: 6155,
    city: "Willetton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0525,
    longitude: 115.8878,
    accuracy: 4
  },
  {
    postalCode: 6155,
    city: "Canning Vale DC",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0552,
    longitude: 115.903,
    accuracy: 3
  },
  {
    postalCode: 6155,
    city: "Canning Vale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.058,
    longitude: 115.9181,
    accuracy: 4
  },
  {
    postalCode: 6155,
    city: "Canning Vale South",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.074,
    longitude: 115.9095,
    accuracy: 3
  },
  {
    postalCode: 6156,
    city: "Melville",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0404,
    longitude: 115.8012,
    accuracy: 4
  },
  {
    postalCode: 6156,
    city: "Willagee Central",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0373,
    longitude: 115.8033,
    accuracy: 3
  },
  {
    postalCode: 6156,
    city: "Attadale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0249,
    longitude: 115.802,
    accuracy: 4
  },
  {
    postalCode: 6156,
    city: "Willagee",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.052,
    longitude: 115.8053,
    accuracy: 4
  },
  {
    postalCode: 6157,
    city: "Palmyra",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.045,
    longitude: 115.7859,
    accuracy: 4
  },
  {
    postalCode: 6157,
    city: "Palmyra DC",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0364,
    longitude: 115.7846,
    accuracy: 3
  },
  {
    postalCode: 6157,
    city: "Bicton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0278,
    longitude: 115.7833,
    accuracy: 4
  },
  {
    postalCode: 6158,
    city: "East Fremantle",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0382,
    longitude: 115.7676,
    accuracy: 4
  },
  {
    postalCode: 6159,
    city: "North Fremantle",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0333,
    longitude: 115.75,
    accuracy: 4
  },
  {
    postalCode: 6160,
    city: "Fremantle",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.05,
    longitude: 115.7667,
    accuracy: 4
  },
  {
    postalCode: 6161,
    city: "Rottnest Island",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9952,
    longitude: 115.5404,
    accuracy: 4
  },
  {
    postalCode: 6162,
    city: "White Gum Valley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0603,
    longitude: 115.7706,
    accuracy: 4
  },
  {
    postalCode: 6162,
    city: "South Fremantle",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0691,
    longitude: 115.7545,
    accuracy: 4
  },
  {
    postalCode: 6162,
    city: "Beaconsfield",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0675,
    longitude: 115.764,
    accuracy: 4
  },
  {
    postalCode: 6163,
    city: "Bibra Lake",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0976,
    longitude: 115.8192,
    accuracy: 4
  },
  {
    postalCode: 6163,
    city: "Hamilton Hill",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0845,
    longitude: 115.7795,
    accuracy: 4
  },
  {
    postalCode: 6163,
    city: "Spearwood",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1053,
    longitude: 115.778,
    accuracy: 4
  },
  {
    postalCode: 6163,
    city: "North Lake",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0819,
    longitude: 115.8357,
    accuracy: 4
  },
  {
    postalCode: 6163,
    city: "O'Connor",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0581,
    longitude: 115.7973,
    accuracy: 4
  },
  {
    postalCode: 6163,
    city: "Hilton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0621,
    longitude: 115.7805,
    accuracy: 4
  },
  {
    postalCode: 6163,
    city: "Kardinya",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0656,
    longitude: 115.8148,
    accuracy: 4
  },
  {
    postalCode: 6163,
    city: "Bibra Lake DC",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0799,
    longitude: 115.8042,
    accuracy: 3
  },
  {
    postalCode: 6163,
    city: "Samson",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.07,
    longitude: 115.7977,
    accuracy: 4
  },
  {
    postalCode: 6163,
    city: "Coolbellup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0812,
    longitude: 115.8061,
    accuracy: 4
  },
  {
    postalCode: 6163,
    city: "North Coogee",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0799,
    longitude: 115.8042,
    accuracy: 3
  },
  {
    postalCode: 6164,
    city: "Atwell",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1435,
    longitude: 115.8653,
    accuracy: 4
  },
  {
    postalCode: 6164,
    city: "Banjup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1418,
    longitude: 115.8867,
    accuracy: 4
  },
  {
    postalCode: 6164,
    city: "Success",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1428,
    longitude: 115.85,
    accuracy: 4
  },
  {
    postalCode: 6164,
    city: "Beeliar",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1334,
    longitude: 115.8064,
    accuracy: 4
  },
  {
    postalCode: 6164,
    city: "Hammond Park",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1685,
    longitude: 115.8504,
    accuracy: 4
  },
  {
    postalCode: 6164,
    city: "Yangebup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1206,
    longitude: 115.8162,
    accuracy: 4
  },
  {
    postalCode: 6164,
    city: "Aubin Grove",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1671,
    longitude: 115.8626,
    accuracy: 4
  },
  {
    postalCode: 6164,
    city: "South Lake",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1112,
    longitude: 115.8387,
    accuracy: 4
  },
  {
    postalCode: 6164,
    city: "Jandakot",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1016,
    longitude: 115.8708,
    accuracy: 4
  },
  {
    postalCode: 6164,
    city: "Cockburn Central",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1213,
    longitude: 115.8478,
    accuracy: 4
  },
  {
    postalCode: 6165,
    city: "Hope Valley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2045,
    longitude: 115.81,
    accuracy: 4
  },
  {
    postalCode: 6165,
    city: "Naval Base",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.191,
    longitude: 115.7777,
    accuracy: 4
  },
  {
    postalCode: 6166,
    city: "Wattleup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1696,
    longitude: 115.824,
    accuracy: 4
  },
  {
    postalCode: 6166,
    city: "Munster",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1365,
    longitude: 115.783,
    accuracy: 4
  },
  {
    postalCode: 6166,
    city: "Coogee",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1193,
    longitude: 115.7665,
    accuracy: 4
  },
  {
    postalCode: 6166,
    city: "Henderson",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1764,
    longitude: 115.7746,
    accuracy: 4
  },
  {
    postalCode: 6167,
    city: "Wandi",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1943,
    longitude: 115.8763,
    accuracy: 4
  },
  {
    postalCode: 6167,
    city: "Parmelia",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2578,
    longitude: 115.8221,
    accuracy: 4
  },
  {
    postalCode: 6167,
    city: "Casuarina",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2414,
    longitude: 115.8698,
    accuracy: 4
  },
  {
    postalCode: 6167,
    city: "Medina",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2333,
    longitude: 115.7833,
    accuracy: 4
  },
  {
    postalCode: 6167,
    city: "Anketell",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2186,
    longitude: 115.8656,
    accuracy: 4
  },
  {
    postalCode: 6167,
    city: "Kwinana Beach",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2484,
    longitude: 115.7619,
    accuracy: 4
  },
  {
    postalCode: 6167,
    city: "Bertram",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2437,
    longitude: 115.8457,
    accuracy: 4
  },
  {
    postalCode: 6167,
    city: "Postans",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2247,
    longitude: 115.8158,
    accuracy: 4
  },
  {
    postalCode: 6167,
    city: "Calista",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.241,
    longitude: 115.7976,
    accuracy: 4
  },
  {
    postalCode: 6167,
    city: "Kwinana Town Centre",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2444,
    longitude: 115.8161,
    accuracy: 4
  },
  {
    postalCode: 6167,
    city: "Mandogalup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1929,
    longitude: 115.8435,
    accuracy: 4
  },
  {
    postalCode: 6167,
    city: "The Spectacles",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2202,
    longitude: 115.8387,
    accuracy: 4
  },
  {
    postalCode: 6167,
    city: "Orelia",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2333,
    longitude: 115.8223,
    accuracy: 4
  },
  {
    postalCode: 6168,
    city: "Hillman",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2833,
    longitude: 115.7636,
    accuracy: 4
  },
  {
    postalCode: 6168,
    city: "Rockingham",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2768,
    longitude: 115.7298,
    accuracy: 4
  },
  {
    postalCode: 6168,
    city: "Peron",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2766,
    longitude: 115.7005,
    accuracy: 4
  },
  {
    postalCode: 6168,
    city: "Garden Island",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2426,
    longitude: 115.695,
    accuracy: 4
  },
  {
    postalCode: 6168,
    city: "Rockingham DC",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2879,
    longitude: 115.7429,
    accuracy: 3
  },
  {
    postalCode: 6168,
    city: "Cooloongup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.3151,
    longitude: 115.7777,
    accuracy: 4
  },
  {
    postalCode: 6168,
    city: "Rockingham Beach",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2879,
    longitude: 115.7429,
    accuracy: 3
  },
  {
    postalCode: 6168,
    city: "East Rockingham",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2623,
    longitude: 115.7489,
    accuracy: 4
  },
  {
    postalCode: 6169,
    city: "Safety Bay",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.3046,
    longitude: 115.7421,
    accuracy: 4
  },
  {
    postalCode: 6169,
    city: "Shoalwater",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2909,
    longitude: 115.711,
    accuracy: 4
  },
  {
    postalCode: 6169,
    city: "Waikiki",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.3161,
    longitude: 115.7546,
    accuracy: 4
  },
  {
    postalCode: 6169,
    city: "Warnbro",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.3402,
    longitude: 115.7473,
    accuracy: 4
  },
  {
    postalCode: 6170,
    city: "Leda",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2677,
    longitude: 115.7993,
    accuracy: 4
  },
  {
    postalCode: 6170,
    city: "Wellard",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2667,
    longitude: 115.8333,
    accuracy: 4
  },
  {
    postalCode: 6171,
    city: "Baldivis",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.3289,
    longitude: 115.8305,
    accuracy: 4
  },
  {
    postalCode: 6172,
    city: "Port Kennedy",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.3734,
    longitude: 115.7515,
    accuracy: 4
  },
  {
    postalCode: 6173,
    city: "Secret Harbour",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.4059,
    longitude: 115.7585,
    accuracy: 4
  },
  {
    postalCode: 6174,
    city: "Golden Bay",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.425,
    longitude: 115.761,
    accuracy: 4
  },
  {
    postalCode: 6175,
    city: "Singleton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.444,
    longitude: 115.7572,
    accuracy: 4
  },
  {
    postalCode: 6176,
    city: "Karnup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.3667,
    longitude: 115.8167,
    accuracy: 4
  },
  {
    postalCode: 6180,
    city: "Parklands",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.4956,
    longitude: 115.773,
    accuracy: 4
  },
  {
    postalCode: 6180,
    city: "Lakelands",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.4775,
    longitude: 115.7557,
    accuracy: 4
  },
  {
    postalCode: 6181,
    city: "Stake Hill",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.4778,
    longitude: 115.7942,
    accuracy: 4
  },
  {
    postalCode: 6182,
    city: "Keralup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.4299,
    longitude: 115.8314,
    accuracy: 4
  },
  {
    postalCode: 6207,
    city: "Solus",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.5627,
    longitude: 116.1411,
    accuracy: 3
  },
  {
    postalCode: 6207,
    city: "Nambeelup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.5318,
    longitude: 115.8317,
    accuracy: 4
  },
  {
    postalCode: 6207,
    city: "Whittaker",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.5627,
    longitude: 116.1411,
    accuracy: 3
  },
  {
    postalCode: 6207,
    city: "North Dandalup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.5168,
    longitude: 115.9719,
    accuracy: 4
  },
  {
    postalCode: 6207,
    city: "Myara",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.5627,
    longitude: 116.1411,
    accuracy: 3
  },
  {
    postalCode: 6208,
    city: "Ravenswood",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.5824,
    longitude: 115.8315,
    accuracy: 4
  },
  {
    postalCode: 6208,
    city: "Pinjarra",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.6298,
    longitude: 115.8735,
    accuracy: 4
  },
  {
    postalCode: 6208,
    city: "Meelon",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.7,
    longitude: 115.9333,
    accuracy: 4
  },
  {
    postalCode: 6208,
    city: "West Pinjarra",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.6428,
    longitude: 115.8124,
    accuracy: 3
  },
  {
    postalCode: 6208,
    city: "North Yunderup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.578,
    longitude: 115.7943,
    accuracy: 4
  },
  {
    postalCode: 6208,
    city: "Point Grey",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.6606,
    longitude: 115.9613,
    accuracy: 3
  },
  {
    postalCode: 6208,
    city: "South Yunderup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.5851,
    longitude: 115.7802,
    accuracy: 4
  },
  {
    postalCode: 6208,
    city: "Blythewood",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.6606,
    longitude: 115.9613,
    accuracy: 3
  },
  {
    postalCode: 6208,
    city: "Fairbridge",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.6606,
    longitude: 115.9613,
    accuracy: 3
  },
  {
    postalCode: 6208,
    city: "Nirimba",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.6606,
    longitude: 115.9613,
    accuracy: 3
  },
  {
    postalCode: 6208,
    city: "Oakley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.6606,
    longitude: 115.9613,
    accuracy: 3
  },
  {
    postalCode: 6209,
    city: "Furnissdale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.5585,
    longitude: 115.7604,
    accuracy: 4
  },
  {
    postalCode: 6209,
    city: "Barragup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.5498,
    longitude: 115.7796,
    accuracy: 4
  },
  {
    postalCode: 6210,
    city: "Mandurah",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.5269,
    longitude: 115.7217,
    accuracy: 4
  },
  {
    postalCode: 6210,
    city: "Parklands",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.4956,
    longitude: 115.773,
    accuracy: 4
  },
  {
    postalCode: 6210,
    city: "Bouvard",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.7189,
    longitude: 115.6389,
    accuracy: 4
  },
  {
    postalCode: 6210,
    city: "Greenfields",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.5243,
    longitude: 115.7631,
    accuracy: 4
  },
  {
    postalCode: 6210,
    city: "Wannanup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.5995,
    longitude: 115.6449,
    accuracy: 4
  },
  {
    postalCode: 6210,
    city: "Mandurah DC",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.5582,
    longitude: 115.719,
    accuracy: 3
  },
  {
    postalCode: 6210,
    city: "Dudley Park",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.5522,
    longitude: 115.731,
    accuracy: 4
  },
  {
    postalCode: 6210,
    city: "Clifton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.7699,
    longitude: 115.6321,
    accuracy: 4
  },
  {
    postalCode: 6210,
    city: "Meadow Springs",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.4972,
    longitude: 115.7533,
    accuracy: 4
  },
  {
    postalCode: 6210,
    city: "Mandurah East",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.5733,
    longitude: 115.7613,
    accuracy: 3
  },
  {
    postalCode: 6210,
    city: "Silver Sands",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.5086,
    longitude: 115.736,
    accuracy: 4
  },
  {
    postalCode: 6210,
    city: "Lakelands",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.4775,
    longitude: 115.7557,
    accuracy: 4
  },
  {
    postalCode: 6210,
    city: "Furnissdale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.5585,
    longitude: 115.7604,
    accuracy: 4
  },
  {
    postalCode: 6210,
    city: "Mandurah North",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.5733,
    longitude: 115.7613,
    accuracy: 3
  },
  {
    postalCode: 6210,
    city: "San Remo",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.4899,
    longitude: 115.7447,
    accuracy: 4
  },
  {
    postalCode: 6210,
    city: "Coodanup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.5519,
    longitude: 115.7535,
    accuracy: 4
  },
  {
    postalCode: 6210,
    city: "Herron",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.7552,
    longitude: 115.674,
    accuracy: 4
  },
  {
    postalCode: 6210,
    city: "Falcon",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.5824,
    longitude: 115.662,
    accuracy: 4
  },
  {
    postalCode: 6210,
    city: "Dawesville",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.6323,
    longitude: 115.629,
    accuracy: 4
  },
  {
    postalCode: 6210,
    city: "Barragup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.5498,
    longitude: 115.7796,
    accuracy: 4
  },
  {
    postalCode: 6210,
    city: "Stake Hill",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.4778,
    longitude: 115.7942,
    accuracy: 4
  },
  {
    postalCode: 6210,
    city: "Halls Head",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.5431,
    longitude: 115.6966,
    accuracy: 4
  },
  {
    postalCode: 6210,
    city: "Erskine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.5572,
    longitude: 115.7066,
    accuracy: 4
  },
  {
    postalCode: 6210,
    city: "Madora Bay",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.4695,
    longitude: 115.7526,
    accuracy: 4
  },
  {
    postalCode: 6211,
    city: "Dawesville",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.6323,
    longitude: 115.629,
    accuracy: 4
  },
  {
    postalCode: 6211,
    city: "Bouvard",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.7189,
    longitude: 115.6389,
    accuracy: 4
  },
  {
    postalCode: 6211,
    city: "Clifton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.7699,
    longitude: 115.6321,
    accuracy: 4
  },
  {
    postalCode: 6211,
    city: "Herron",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.7552,
    longitude: 115.674,
    accuracy: 4
  },
  {
    postalCode: 6213,
    city: "Marrinup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.7,
    longitude: 116.0167,
    accuracy: 4
  },
  {
    postalCode: 6213,
    city: "Dwellingup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.7144,
    longitude: 116.0622,
    accuracy: 4
  },
  {
    postalCode: 6213,
    city: "Etmilyn",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.7126,
    longitude: 116.061,
    accuracy: 3
  },
  {
    postalCode: 6213,
    city: "Inglehope",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.7667,
    longitude: 116.1667,
    accuracy: 4
  },
  {
    postalCode: 6213,
    city: "Banksiadale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.65,
    longitude: 116.0833,
    accuracy: 4
  },
  {
    postalCode: 6213,
    city: "Teesdale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.7126,
    longitude: 116.061,
    accuracy: 3
  },
  {
    postalCode: 6213,
    city: "Holyoake",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.7167,
    longitude: 116.0833,
    accuracy: 4
  },
  {
    postalCode: 6214,
    city: "West Coolup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.75,
    longitude: 115.8667,
    accuracy: 4
  },
  {
    postalCode: 6214,
    city: "Coolup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.75,
    longitude: 115.8667,
    accuracy: 4
  },
  {
    postalCode: 6214,
    city: "Birchmont",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.7289,
    longitude: 115.7752,
    accuracy: 3
  },
  {
    postalCode: 6215,
    city: "Waroona",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.8432,
    longitude: 115.922,
    accuracy: 4
  },
  {
    postalCode: 6215,
    city: "Hamel",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.8741,
    longitude: 115.927,
    accuracy: 4
  },
  {
    postalCode: 6215,
    city: "Lake Clifton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.8134,
    longitude: 115.6856,
    accuracy: 4
  },
  {
    postalCode: 6215,
    city: "Nanga Brook",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.8167,
    longitude: 116.0667,
    accuracy: 4
  },
  {
    postalCode: 6215,
    city: "Wagerup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.9102,
    longitude: 115.8915,
    accuracy: 4
  },
  {
    postalCode: 6215,
    city: "Preston Beach",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.8668,
    longitude: 115.6703,
    accuracy: 4
  },
  {
    postalCode: 6218,
    city: "Yarloop",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.9537,
    longitude: 115.8969,
    accuracy: 4
  },
  {
    postalCode: 6220,
    city: "Hoffman",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.0367,
    longitude: 115.9527,
    accuracy: 3
  },
  {
    postalCode: 6220,
    city: "Myalup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.1021,
    longitude: 115.692,
    accuracy: 4
  },
  {
    postalCode: 6220,
    city: "Cookernup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.9833,
    longitude: 115.8833,
    accuracy: 4
  },
  {
    postalCode: 6220,
    city: "Harvey",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.0799,
    longitude: 115.8945,
    accuracy: 4
  },
  {
    postalCode: 6220,
    city: "Warawarrup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.0367,
    longitude: 115.9527,
    accuracy: 3
  },
  {
    postalCode: 6220,
    city: "Uduc",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.0493,
    longitude: 115.8101,
    accuracy: 4
  },
  {
    postalCode: 6221,
    city: "Mornington",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.15,
    longitude: 115.9333,
    accuracy: 4
  },
  {
    postalCode: 6221,
    city: "Wokalup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.1167,
    longitude: 115.8667,
    accuracy: 4
  },
  {
    postalCode: 6223,
    city: "Benger",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.1667,
    longitude: 115.85,
    accuracy: 4
  },
  {
    postalCode: 6224,
    city: "Beela",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.1965,
    longitude: 115.9656,
    accuracy: 3
  },
  {
    postalCode: 6224,
    city: "Brunswick",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.2324,
    longitude: 115.8628,
    accuracy: 4
  },
  {
    postalCode: 6225,
    city: "Allanson",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.3359,
    longitude: 116.0994,
    accuracy: 4
  },
  {
    postalCode: 6225,
    city: "Mumballup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.5286,
    longitude: 116.1133,
    accuracy: 4
  },
  {
    postalCode: 6225,
    city: "Palmer",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.4062,
    longitude: 119.6815,
    accuracy: 4
  },
  {
    postalCode: 6225,
    city: "Mcalinden",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.578,
    longitude: 116.2985,
    accuracy: 4
  },
  {
    postalCode: 6225,
    city: "Cardiff",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.4292,
    longitude: 116.2078,
    accuracy: 4
  },
  {
    postalCode: 6225,
    city: "Shotts",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.3833,
    longitude: 116.2667,
    accuracy: 4
  },
  {
    postalCode: 6225,
    city: "Lyalls Mill",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.2836,
    longitude: 116.2116,
    accuracy: 3
  },
  {
    postalCode: 6225,
    city: "Bowelling",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.4167,
    longitude: 116.5,
    accuracy: 4
  },
  {
    postalCode: 6225,
    city: "Noggerup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.5833,
    longitude: 116.1667,
    accuracy: 4
  },
  {
    postalCode: 6225,
    city: "Muja",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.2836,
    longitude: 116.2116,
    accuracy: 3
  },
  {
    postalCode: 6225,
    city: "Buckingham",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.4,
    longitude: 116.3333,
    accuracy: 4
  },
  {
    postalCode: 6225,
    city: "Collie",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.3621,
    longitude: 116.1562,
    accuracy: 4
  },
  {
    postalCode: 6225,
    city: "Collie Burn",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.4,
    longitude: 116.1833,
    accuracy: 4
  },
  {
    postalCode: 6225,
    city: "Mungalup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.2836,
    longitude: 116.2116,
    accuracy: 3
  },
  {
    postalCode: 6225,
    city: "Worsley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.3069,
    longitude: 116.0067,
    accuracy: 4
  },
  {
    postalCode: 6225,
    city: "Preston Settlement",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.4129,
    longitude: 116.1578,
    accuracy: 3
  },
  {
    postalCode: 6225,
    city: "Yourdamung Lake",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.2072,
    longitude: 116.2349,
    accuracy: 3
  },
  {
    postalCode: 6225,
    city: "Harris River",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.2836,
    longitude: 116.2116,
    accuracy: 3
  },
  {
    postalCode: 6226,
    city: "Roelands",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.2833,
    longitude: 115.8167,
    accuracy: 4
  },
  {
    postalCode: 6227,
    city: "Burekup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.3071,
    longitude: 115.8137,
    accuracy: 4
  },
  {
    postalCode: 6228,
    city: "Waterloo",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.3186,
    longitude: 115.7567,
    accuracy: 1
  },
  {
    postalCode: 6229,
    city: "Picton East",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.3471,
    longitude: 115.7016,
    accuracy: 3
  },
  {
    postalCode: 6229,
    city: "Picton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.35,
    longitude: 115.7,
    accuracy: 4
  },
  {
    postalCode: 6230,
    city: "Withers",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.3681,
    longitude: 115.6305,
    accuracy: 4
  },
  {
    postalCode: 6230,
    city: "Dalyellup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.4084,
    longitude: 115.6151,
    accuracy: 4
  },
  {
    postalCode: 6230,
    city: "Gelorup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.4051,
    longitude: 115.6344,
    accuracy: 4
  },
  {
    postalCode: 6230,
    city: "Vittoria",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.3305,
    longitude: 115.6659,
    accuracy: 4
  },
  {
    postalCode: 6230,
    city: "Glen Iris",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.3371,
    longitude: 115.6743,
    accuracy: 4
  },
  {
    postalCode: 6230,
    city: "South Bunbury",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.3361,
    longitude: 115.6403,
    accuracy: 3
  },
  {
    postalCode: 6230,
    city: "Pelican Point",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.3183,
    longitude: 115.6929,
    accuracy: 4
  },
  {
    postalCode: 6230,
    city: "Bunbury",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.3271,
    longitude: 115.6414,
    accuracy: 4
  },
  {
    postalCode: 6230,
    city: "East Bunbury",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.3363,
    longitude: 115.6566,
    accuracy: 4
  },
  {
    postalCode: 6230,
    city: "College Grove",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.3759,
    longitude: 115.6591,
    accuracy: 4
  },
  {
    postalCode: 6230,
    city: "Davenport",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.374,
    longitude: 115.6852,
    accuracy: 4
  },
  {
    postalCode: 6230,
    city: "Carey Park",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.3488,
    longitude: 115.6493,
    accuracy: 4
  },
  {
    postalCode: 6230,
    city: "Usher",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.3798,
    longitude: 115.6292,
    accuracy: 4
  },
  {
    postalCode: 6231,
    city: "Bunbury",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.3271,
    longitude: 115.6414,
    accuracy: 4
  },
  {
    postalCode: 6232,
    city: "Eaton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.3166,
    longitude: 115.705,
    accuracy: 4
  },
  {
    postalCode: 6232,
    city: "Millbridge",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.3062,
    longitude: 115.735,
    accuracy: 4
  },
  {
    postalCode: 6233,
    city: "Parkfield",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.2139,
    longitude: 115.7196,
    accuracy: 3
  },
  {
    postalCode: 6233,
    city: "Australind",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.2792,
    longitude: 115.715,
    accuracy: 4
  },
  {
    postalCode: 6233,
    city: "Wellesley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.2343,
    longitude: 115.7526,
    accuracy: 4
  },
  {
    postalCode: 6233,
    city: "Leschenault",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.2452,
    longitude: 115.7251,
    accuracy: 4
  },
  {
    postalCode: 6233,
    city: "Binningup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.1483,
    longitude: 115.6952,
    accuracy: 4
  },
  {
    postalCode: 6236,
    city: "Wellington Mill",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.4667,
    longitude: 115.9,
    accuracy: 4
  },
  {
    postalCode: 6236,
    city: "Paradise",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.4403,
    longitude: 115.8631,
    accuracy: 3
  },
  {
    postalCode: 6236,
    city: "Dardanup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.3983,
    longitude: 115.7518,
    accuracy: 4
  },
  {
    postalCode: 6236,
    city: "Wellington Forest",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.4403,
    longitude: 115.8631,
    accuracy: 3
  },
  {
    postalCode: 6236,
    city: "Ferguson",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.4403,
    longitude: 115.8631,
    accuracy: 3
  },
  {
    postalCode: 6236,
    city: "Dardanup West",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.3819,
    longitude: 115.7017,
    accuracy: 3
  },
  {
    postalCode: 6236,
    city: "Crooked Brook",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.4403,
    longitude: 115.8631,
    accuracy: 3
  },
  {
    postalCode: 6236,
    city: "Henty",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.4403,
    longitude: 115.8631,
    accuracy: 3
  },
  {
    postalCode: 6237,
    city: "Stratham",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.4632,
    longitude: 115.5862,
    accuracy: 4
  },
  {
    postalCode: 6237,
    city: "Elgin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.5068,
    longitude: 115.68,
    accuracy: 3
  },
  {
    postalCode: 6237,
    city: "Boyanup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.4829,
    longitude: 115.7284,
    accuracy: 4
  },
  {
    postalCode: 6237,
    city: "North Boyanup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.4311,
    longitude: 115.6889,
    accuracy: 3
  },
  {
    postalCode: 6237,
    city: "Gwindinup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.5068,
    longitude: 115.68,
    accuracy: 3
  },
  {
    postalCode: 6237,
    city: "The Plains",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.5068,
    longitude: 115.68,
    accuracy: 3
  },
  {
    postalCode: 6239,
    city: "Beelerup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.5756,
    longitude: 115.8506,
    accuracy: 4
  },
  {
    postalCode: 6239,
    city: "Donnybrook",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.5713,
    longitude: 115.8245,
    accuracy: 4
  },
  {
    postalCode: 6239,
    city: "Argyle",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.5458,
    longitude: 115.7707,
    accuracy: 4
  },
  {
    postalCode: 6239,
    city: "Upper Capel",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6486,
    longitude: 115.8189,
    accuracy: 3
  },
  {
    postalCode: 6239,
    city: "Yabberup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.5386,
    longitude: 116.0125,
    accuracy: 3
  },
  {
    postalCode: 6239,
    city: "Thomson Brook",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6087,
    longitude: 115.9784,
    accuracy: 3
  },
  {
    postalCode: 6239,
    city: "Paynedale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6087,
    longitude: 115.9784,
    accuracy: 3
  },
  {
    postalCode: 6239,
    city: "Queenwood",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6087,
    longitude: 115.9784,
    accuracy: 3
  },
  {
    postalCode: 6239,
    city: "Brookhampton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6087,
    longitude: 115.9784,
    accuracy: 3
  },
  {
    postalCode: 6239,
    city: "Charley Creek",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6087,
    longitude: 115.9784,
    accuracy: 3
  },
  {
    postalCode: 6239,
    city: "Glen Mervyn",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6087,
    longitude: 115.9784,
    accuracy: 3
  },
  {
    postalCode: 6240,
    city: "Lowden",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.5344,
    longitude: 115.9756,
    accuracy: 4
  },
  {
    postalCode: 6243,
    city: "Wilga West",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6833,
    longitude: 116.2333,
    accuracy: 4
  },
  {
    postalCode: 6243,
    city: "Wilga",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6833,
    longitude: 116.2333,
    accuracy: 4
  },
  {
    postalCode: 6244,
    city: "Mayanup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.9355,
    longitude: 116.4529,
    accuracy: 4
  },
  {
    postalCode: 6244,
    city: "Chowerup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.0849,
    longitude: 116.6746,
    accuracy: 4
  },
  {
    postalCode: 6244,
    city: "Boyup Brook",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8343,
    longitude: 116.3878,
    accuracy: 4
  },
  {
    postalCode: 6244,
    city: "Tonebridge",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8918,
    longitude: 116.524,
    accuracy: 3
  },
  {
    postalCode: 6244,
    city: "Dinninup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8141,
    longitude: 116.5368,
    accuracy: 4
  },
  {
    postalCode: 6244,
    city: "Kulikup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8263,
    longitude: 116.6771,
    accuracy: 4
  },
  {
    postalCode: 6244,
    city: "Trigwell",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.9035,
    longitude: 116.5476,
    accuracy: 3
  },
  {
    postalCode: 6244,
    city: "Scotts Brook",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8918,
    longitude: 116.524,
    accuracy: 3
  },
  {
    postalCode: 6251,
    city: "Newlands",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6667,
    longitude: 115.8667,
    accuracy: 4
  },
  {
    postalCode: 6251,
    city: "Kirup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7,
    longitude: 115.9,
    accuracy: 4
  },
  {
    postalCode: 6251,
    city: "Brazier",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7636,
    longitude: 115.8561,
    accuracy: 3
  },
  {
    postalCode: 6252,
    city: "Mullalyup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7333,
    longitude: 115.9333,
    accuracy: 4
  },
  {
    postalCode: 6253,
    city: "Balingup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8,
    longitude: 115.9667,
    accuracy: 4
  },
  {
    postalCode: 6253,
    city: "Southampton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7948,
    longitude: 116.0503,
    accuracy: 3
  },
  {
    postalCode: 6253,
    city: "Grimwade",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7948,
    longitude: 116.0503,
    accuracy: 3
  },
  {
    postalCode: 6254,
    city: "Greenbushes",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8497,
    longitude: 116.0582,
    accuracy: 4
  },
  {
    postalCode: 6254,
    city: "North Greenbushes",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8484,
    longitude: 116.0569,
    accuracy: 3
  },
  {
    postalCode: 6255,
    city: "Benjinup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7667,
    longitude: 116.3167,
    accuracy: 4
  },
  {
    postalCode: 6255,
    city: "Hester",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.9,
    longitude: 116.15,
    accuracy: 4
  },
  {
    postalCode: 6255,
    city: "Bridgetown",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.9624,
    longitude: 116.136,
    accuracy: 4
  },
  {
    postalCode: 6255,
    city: "Kangaroo Gully",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.9619,
    longitude: 116.1986,
    accuracy: 3
  },
  {
    postalCode: 6255,
    city: "Catterick",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.9057,
    longitude: 116.1308,
    accuracy: 3
  },
  {
    postalCode: 6255,
    city: "Winnejup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.9057,
    longitude: 116.1308,
    accuracy: 3
  },
  {
    postalCode: 6255,
    city: "Hester Brook",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.9057,
    longitude: 116.1308,
    accuracy: 3
  },
  {
    postalCode: 6256,
    city: "Yornup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.05,
    longitude: 116.1667,
    accuracy: 4
  },
  {
    postalCode: 6256,
    city: "Sunnyside",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.0777,
    longitude: 116.2364,
    accuracy: 3
  },
  {
    postalCode: 6256,
    city: "Glenlynn",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.0063,
    longitude: 116.1535,
    accuracy: 4
  },
  {
    postalCode: 6256,
    city: "Maranup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.0777,
    longitude: 116.2364,
    accuracy: 3
  },
  {
    postalCode: 6256,
    city: "Wandillup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.0777,
    longitude: 116.2364,
    accuracy: 3
  },
  {
    postalCode: 6256,
    city: "Kingston",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.0777,
    longitude: 116.2364,
    accuracy: 3
  },
  {
    postalCode: 6258,
    city: "Yanmah",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.1833,
    longitude: 116.0167,
    accuracy: 4
  },
  {
    postalCode: 6258,
    city: "Wilgarrup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.352,
    longitude: 116.3659,
    accuracy: 3
  },
  {
    postalCode: 6258,
    city: "Palgarup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.1625,
    longitude: 116.1845,
    accuracy: 4
  },
  {
    postalCode: 6258,
    city: "Diamond Tree",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.352,
    longitude: 116.3659,
    accuracy: 3
  },
  {
    postalCode: 6258,
    city: "Jardee",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.285,
    longitude: 116.12,
    accuracy: 4
  },
  {
    postalCode: 6258,
    city: "Ringbark",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.352,
    longitude: 116.3659,
    accuracy: 3
  },
  {
    postalCode: 6258,
    city: "Manjimup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.2412,
    longitude: 116.1456,
    accuracy: 4
  },
  {
    postalCode: 6258,
    city: "Linfarne",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.352,
    longitude: 116.3659,
    accuracy: 3
  },
  {
    postalCode: 6258,
    city: "Balbarrup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.2292,
    longitude: 116.2017,
    accuracy: 4
  },
  {
    postalCode: 6258,
    city: "Smith Brook",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.352,
    longitude: 116.3659,
    accuracy: 3
  },
  {
    postalCode: 6258,
    city: "Lake Muir",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.352,
    longitude: 116.3659,
    accuracy: 3
  },
  {
    postalCode: 6258,
    city: "Dixvale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.352,
    longitude: 116.3659,
    accuracy: 3
  },
  {
    postalCode: 6258,
    city: "Quinninup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.4355,
    longitude: 116.2498,
    accuracy: 4
  },
  {
    postalCode: 6258,
    city: "Shannon River Mill",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.352,
    longitude: 116.3659,
    accuracy: 3
  },
  {
    postalCode: 6258,
    city: "Deanmill",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.2647,
    longitude: 116.0742,
    accuracy: 4
  },
  {
    postalCode: 6258,
    city: "Crowea",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.352,
    longitude: 116.3659,
    accuracy: 3
  },
  {
    postalCode: 6258,
    city: "Upper Warren",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.352,
    longitude: 116.3659,
    accuracy: 3
  },
  {
    postalCode: 6258,
    city: "Glenoran",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.352,
    longitude: 116.3659,
    accuracy: 3
  },
  {
    postalCode: 6258,
    city: "Donnelly River",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.352,
    longitude: 116.3659,
    accuracy: 3
  },
  {
    postalCode: 6258,
    city: "Middlesex",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.352,
    longitude: 116.3659,
    accuracy: 3
  },
  {
    postalCode: 6258,
    city: "Mordalup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.352,
    longitude: 116.3659,
    accuracy: 3
  },
  {
    postalCode: 6258,
    city: "Dingup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.2584,
    longitude: 116.1878,
    accuracy: 3
  },
  {
    postalCode: 6258,
    city: "Nyamup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.352,
    longitude: 116.3659,
    accuracy: 3
  },
  {
    postalCode: 6258,
    city: "Perup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.352,
    longitude: 116.3659,
    accuracy: 3
  },
  {
    postalCode: 6260,
    city: "Eastbrook",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.4,
    longitude: 116.1,
    accuracy: 4
  },
  {
    postalCode: 6260,
    city: "Pemberton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.4431,
    longitude: 116.0369,
    accuracy: 4
  },
  {
    postalCode: 6260,
    city: "Yeagarup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.4216,
    longitude: 116.0684,
    accuracy: 3
  },
  {
    postalCode: 6260,
    city: "Collins",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.4216,
    longitude: 116.0684,
    accuracy: 3
  },
  {
    postalCode: 6260,
    city: "Biddelia",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.4447,
    longitude: 115.9282,
    accuracy: 3
  },
  {
    postalCode: 6260,
    city: "Channybearup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.4216,
    longitude: 116.0684,
    accuracy: 3
  },
  {
    postalCode: 6260,
    city: "Callcup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.4216,
    longitude: 116.0684,
    accuracy: 3
  },
  {
    postalCode: 6260,
    city: "Beedelup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.4216,
    longitude: 116.0684,
    accuracy: 3
  },
  {
    postalCode: 6260,
    city: "Lake Jasper",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.4447,
    longitude: 115.9282,
    accuracy: 3
  },
  {
    postalCode: 6260,
    city: "Peerabeelup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.4447,
    longitude: 115.9282,
    accuracy: 3
  },
  {
    postalCode: 6262,
    city: "Crowea",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.7331,
    longitude: 116.0778,
    accuracy: 3
  },
  {
    postalCode: 6262,
    city: "Windy Harbour",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.8333,
    longitude: 116.0333,
    accuracy: 4
  },
  {
    postalCode: 6262,
    city: "Northcliffe",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.6329,
    longitude: 116.1224,
    accuracy: 4
  },
  {
    postalCode: 6262,
    city: "Boorara Brook",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.7331,
    longitude: 116.0778,
    accuracy: 3
  },
  {
    postalCode: 6262,
    city: "Meerup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.7331,
    longitude: 116.0778,
    accuracy: 3
  },
  {
    postalCode: 6262,
    city: "Shannon",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.7331,
    longitude: 116.0778,
    accuracy: 3
  },
  {
    postalCode: 6271,
    city: "Peppermint Grove Beach",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.5271,
    longitude: 115.5065,
    accuracy: 4
  },
  {
    postalCode: 6271,
    city: "Capel",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.5581,
    longitude: 115.5628,
    accuracy: 4
  },
  {
    postalCode: 6271,
    city: "Forrest Beach",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.5746,
    longitude: 115.5801,
    accuracy: 3
  },
  {
    postalCode: 6271,
    city: "Capel River",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.5746,
    longitude: 115.5801,
    accuracy: 3
  },
  {
    postalCode: 6271,
    city: "Stirling Estate",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.5746,
    longitude: 115.5801,
    accuracy: 3
  },
  {
    postalCode: 6275,
    city: "Nannup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.9787,
    longitude: 115.7646,
    accuracy: 4
  },
  {
    postalCode: 6275,
    city: "Jarrahwood",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8,
    longitude: 115.6667,
    accuracy: 4
  },
  {
    postalCode: 6275,
    city: "Darradup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.1358,
    longitude: 115.6706,
    accuracy: 3
  },
  {
    postalCode: 6275,
    city: "Barrabup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.1358,
    longitude: 115.6706,
    accuracy: 3
  },
  {
    postalCode: 6275,
    city: "Carlotta",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.1358,
    longitude: 115.6706,
    accuracy: 3
  },
  {
    postalCode: 6275,
    city: "Cundinup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.1358,
    longitude: 115.6706,
    accuracy: 3
  },
  {
    postalCode: 6275,
    city: "Scott River East",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.1358,
    longitude: 115.6706,
    accuracy: 3
  },
  {
    postalCode: 6275,
    city: "Yoganup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.1358,
    longitude: 115.6706,
    accuracy: 3
  },
  {
    postalCode: 6275,
    city: "East Nannup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.1358,
    longitude: 115.6706,
    accuracy: 3
  },
  {
    postalCode: 6275,
    city: "Jalbarragup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.1358,
    longitude: 115.6706,
    accuracy: 3
  },
  {
    postalCode: 6280,
    city: "Carbunup River",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7,
    longitude: 115.1833,
    accuracy: 4
  },
  {
    postalCode: 6280,
    city: "Bovell",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6801,
    longitude: 115.361,
    accuracy: 4
  },
  {
    postalCode: 6280,
    city: "Busselton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6525,
    longitude: 115.3455,
    accuracy: 4
  },
  {
    postalCode: 6280,
    city: "Broadwater",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.663,
    longitude: 115.2842,
    accuracy: 4
  },
  {
    postalCode: 6280,
    city: "Yelverton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7505,
    longitude: 115.1196,
    accuracy: 4
  },
  {
    postalCode: 6280,
    city: "Yoongarillup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7152,
    longitude: 115.4268,
    accuracy: 4
  },
  {
    postalCode: 6280,
    city: "Ludlow",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6,
    longitude: 115.4667,
    accuracy: 4
  },
  {
    postalCode: 6280,
    city: "Kaloorup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7296,
    longitude: 115.4072,
    accuracy: 3
  },
  {
    postalCode: 6280,
    city: "Vasse",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6667,
    longitude: 115.25,
    accuracy: 4
  },
  {
    postalCode: 6280,
    city: "Abbey",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6636,
    longitude: 115.2564,
    accuracy: 4
  },
  {
    postalCode: 6280,
    city: "Metricup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7755,
    longitude: 115.1329,
    accuracy: 4
  },
  {
    postalCode: 6280,
    city: "Ruabon",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7296,
    longitude: 115.4072,
    accuracy: 3
  },
  {
    postalCode: 6280,
    city: "Ambergate",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7373,
    longitude: 115.3262,
    accuracy: 4
  },
  {
    postalCode: 6280,
    city: "Reinscourt",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6535,
    longitude: 115.4079,
    accuracy: 4
  },
  {
    postalCode: 6280,
    city: "Wonnerup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6333,
    longitude: 115.4333,
    accuracy: 4
  },
  {
    postalCode: 6280,
    city: "West Busselton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6559,
    longitude: 115.3227,
    accuracy: 3
  },
  {
    postalCode: 6280,
    city: "Yalyalup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.675,
    longitude: 115.4145,
    accuracy: 4
  },
  {
    postalCode: 6280,
    city: "Kealy",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7296,
    longitude: 115.4072,
    accuracy: 3
  },
  {
    postalCode: 6280,
    city: "Siesta Park",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7296,
    longitude: 115.4072,
    accuracy: 3
  },
  {
    postalCode: 6280,
    city: "Tutunup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7296,
    longitude: 115.4072,
    accuracy: 3
  },
  {
    postalCode: 6280,
    city: "Anniebrook",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6591,
    longitude: 115.1726,
    accuracy: 4
  },
  {
    postalCode: 6280,
    city: "Kalgup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7296,
    longitude: 115.4072,
    accuracy: 3
  },
  {
    postalCode: 6280,
    city: "North Jindong",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7296,
    longitude: 115.4072,
    accuracy: 3
  },
  {
    postalCode: 6280,
    city: "Hithergreen",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7296,
    longitude: 115.4072,
    accuracy: 3
  },
  {
    postalCode: 6280,
    city: "Walsall",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7296,
    longitude: 115.4072,
    accuracy: 3
  },
  {
    postalCode: 6280,
    city: "Jindong",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7296,
    longitude: 115.4072,
    accuracy: 3
  },
  {
    postalCode: 6280,
    city: "Sabina River",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7296,
    longitude: 115.4072,
    accuracy: 3
  },
  {
    postalCode: 6280,
    city: "Chapman Hill",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7783,
    longitude: 115.3272,
    accuracy: 3
  },
  {
    postalCode: 6280,
    city: "Boallia",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7296,
    longitude: 115.4072,
    accuracy: 3
  },
  {
    postalCode: 6280,
    city: "Wilyabrup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7956,
    longitude: 115.0461,
    accuracy: 3
  },
  {
    postalCode: 6280,
    city: "Marybrook",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6594,
    longitude: 115.2,
    accuracy: 3
  },
  {
    postalCode: 6280,
    city: "Abba River",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7296,
    longitude: 115.4072,
    accuracy: 3
  },
  {
    postalCode: 6280,
    city: "Geographe",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6397,
    longitude: 115.3836,
    accuracy: 4
  },
  {
    postalCode: 6280,
    city: "Acton Park",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7296,
    longitude: 115.4072,
    accuracy: 3
  },
  {
    postalCode: 6281,
    city: "Quindalup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6356,
    longitude: 115.149,
    accuracy: 4
  },
  {
    postalCode: 6281,
    city: "Dunsborough",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6151,
    longitude: 115.1056,
    accuracy: 4
  },
  {
    postalCode: 6281,
    city: "Eagle Bay",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6164,
    longitude: 115.0811,
    accuracy: 3
  },
  {
    postalCode: 6281,
    city: "Quedjinup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6206,
    longitude: 115.0917,
    accuracy: 4
  },
  {
    postalCode: 6281,
    city: "Naturaliste",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6164,
    longitude: 115.0811,
    accuracy: 3
  },
  {
    postalCode: 6282,
    city: "Yallingup Siding",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.683,
    longitude: 115.0977,
    accuracy: 4
  },
  {
    postalCode: 6282,
    city: "Yallingup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7,
    longitude: 115.1,
    accuracy: 4
  },
  {
    postalCode: 6284,
    city: "Baudin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.865,
    longitude: 115.4242,
    accuracy: 3
  },
  {
    postalCode: 6284,
    city: "Cowaramup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8504,
    longitude: 115.1038,
    accuracy: 4
  },
  {
    postalCode: 6284,
    city: "Gracetown",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8673,
    longitude: 114.9859,
    accuracy: 3
  },
  {
    postalCode: 6284,
    city: "Treeton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.875,
    longitude: 115.102,
    accuracy: 3
  },
  {
    postalCode: 6285,
    city: "Prevelly",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.9791,
    longitude: 114.9943,
    accuracy: 4
  },
  {
    postalCode: 6285,
    city: "Rosa Glen",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.0152,
    longitude: 115.2033,
    accuracy: 4
  },
  {
    postalCode: 6285,
    city: "Margaret River",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.9536,
    longitude: 115.0739,
    accuracy: 4
  },
  {
    postalCode: 6285,
    city: "Osmington",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.921,
    longitude: 115.206,
    accuracy: 3
  },
  {
    postalCode: 6285,
    city: "Bramley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.9194,
    longitude: 115.1135,
    accuracy: 4
  },
  {
    postalCode: 6285,
    city: "Schroeder",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.9504,
    longitude: 115.3202,
    accuracy: 3
  },
  {
    postalCode: 6285,
    city: "Burnside",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.9369,
    longitude: 115.0181,
    accuracy: 4
  },
  {
    postalCode: 6285,
    city: "Rosa Brook",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.95,
    longitude: 115.1833,
    accuracy: 4
  },
  {
    postalCode: 6285,
    city: "Gnarabup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.9919,
    longitude: 114.9943,
    accuracy: 4
  },
  {
    postalCode: 6286,
    city: "Forest Grove",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.0667,
    longitude: 115.0833,
    accuracy: 4
  },
  {
    postalCode: 6286,
    city: "Witchcliffe",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.0333,
    longitude: 115.1,
    accuracy: 4
  },
  {
    postalCode: 6286,
    city: "Redgate",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.1242,
    longitude: 115.0573,
    accuracy: 3
  },
  {
    postalCode: 6286,
    city: "Boranup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.1242,
    longitude: 115.0573,
    accuracy: 3
  },
  {
    postalCode: 6288,
    city: "Karridale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.2167,
    longitude: 115.0833,
    accuracy: 4
  },
  {
    postalCode: 6288,
    city: "Scott River",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.1742,
    longitude: 115.2399,
    accuracy: 3
  },
  {
    postalCode: 6288,
    city: "Hamelin Bay",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.2264,
    longitude: 115.0571,
    accuracy: 4
  },
  {
    postalCode: 6288,
    city: "Nillup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.1742,
    longitude: 115.2399,
    accuracy: 3
  },
  {
    postalCode: 6288,
    city: "Warner Glen",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.1742,
    longitude: 115.2399,
    accuracy: 3
  },
  {
    postalCode: 6288,
    city: "Alexandra Bridge",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.1742,
    longitude: 115.2399,
    accuracy: 3
  },
  {
    postalCode: 6288,
    city: "Courtenay",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.1742,
    longitude: 115.2399,
    accuracy: 3
  },
  {
    postalCode: 6290,
    city: "Leeuwin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.3455,
    longitude: 115.1365,
    accuracy: 4
  },
  {
    postalCode: 6290,
    city: "Kudardup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.2833,
    longitude: 115.1,
    accuracy: 4
  },
  {
    postalCode: 6290,
    city: "East Augusta",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.0202,
    longitude: 115.1211,
    accuracy: 4
  },
  {
    postalCode: 6290,
    city: "Molloy Island",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.2684,
    longitude: 115.2097,
    accuracy: 3
  },
  {
    postalCode: 6290,
    city: "Augusta",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.3157,
    longitude: 115.1592,
    accuracy: 4
  },
  {
    postalCode: 6290,
    city: "Deepdene",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.2528,
    longitude: 115.1632,
    accuracy: 3
  },
  {
    postalCode: 6302,
    city: "Talbot West",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0333,
    longitude: 116.6833,
    accuracy: 4
  },
  {
    postalCode: 6302,
    city: "Gwambygine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9757,
    longitude: 116.8063,
    accuracy: 4
  },
  {
    postalCode: 6302,
    city: "Burges",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8167,
    longitude: 116.7833,
    accuracy: 4
  },
  {
    postalCode: 6302,
    city: "St Ronans",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9264,
    longitude: 116.7354,
    accuracy: 3
  },
  {
    postalCode: 6302,
    city: "York",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8881,
    longitude: 116.7678,
    accuracy: 4
  },
  {
    postalCode: 6302,
    city: "Mount Observation",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9264,
    longitude: 116.7354,
    accuracy: 3
  },
  {
    postalCode: 6302,
    city: "Mount Hardey",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9,
    longitude: 116.8667,
    accuracy: 4
  },
  {
    postalCode: 6302,
    city: "Cold Harbour",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9264,
    longitude: 116.7354,
    accuracy: 3
  },
  {
    postalCode: 6302,
    city: "Malebelling",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9264,
    longitude: 116.7354,
    accuracy: 3
  },
  {
    postalCode: 6302,
    city: "Narraloggan",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9264,
    longitude: 116.7354,
    accuracy: 3
  },
  {
    postalCode: 6302,
    city: "Gilgering",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0243,
    longitude: 116.7984,
    accuracy: 3
  },
  {
    postalCode: 6302,
    city: "Wilberforce",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9264,
    longitude: 116.7354,
    accuracy: 3
  },
  {
    postalCode: 6302,
    city: "Flint",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9264,
    longitude: 116.7354,
    accuracy: 3
  },
  {
    postalCode: 6302,
    city: "Caljie",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9264,
    longitude: 116.7354,
    accuracy: 3
  },
  {
    postalCode: 6302,
    city: "Talbot",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0333,
    longitude: 116.6833,
    accuracy: 4
  },
  {
    postalCode: 6302,
    city: "Balladong",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9264,
    longitude: 116.7354,
    accuracy: 3
  },
  {
    postalCode: 6302,
    city: "Greenhills",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9208,
    longitude: 116.9643,
    accuracy: 4
  },
  {
    postalCode: 6302,
    city: "Daliak",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9264,
    longitude: 116.7354,
    accuracy: 3
  },
  {
    postalCode: 6302,
    city: "Inkpen",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9264,
    longitude: 116.7354,
    accuracy: 3
  },
  {
    postalCode: 6302,
    city: "Quellington",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9264,
    longitude: 116.7354,
    accuracy: 3
  },
  {
    postalCode: 6302,
    city: "Flynn",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9264,
    longitude: 116.7354,
    accuracy: 3
  },
  {
    postalCode: 6302,
    city: "Badgin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9264,
    longitude: 116.7354,
    accuracy: 3
  },
  {
    postalCode: 6302,
    city: "Kauring",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9264,
    longitude: 116.7354,
    accuracy: 3
  },
  {
    postalCode: 6304,
    city: "Westdale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.3134,
    longitude: 116.6088,
    accuracy: 4
  },
  {
    postalCode: 6304,
    city: "Kokeby",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2102,
    longitude: 116.9712,
    accuracy: 4
  },
  {
    postalCode: 6304,
    city: "Bally Bally",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1667,
    longitude: 117.1,
    accuracy: 4
  },
  {
    postalCode: 6304,
    city: "Beverley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1084,
    longitude: 116.9274,
    accuracy: 4
  },
  {
    postalCode: 6304,
    city: "East Beverley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0333,
    longitude: 117.0167,
    accuracy: 4
  },
  {
    postalCode: 6304,
    city: "Morbinning",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1,
    longitude: 117.15,
    accuracy: 4
  },
  {
    postalCode: 6304,
    city: "Dale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0796,
    longitude: 116.8083,
    accuracy: 4
  },
  {
    postalCode: 6306,
    city: "Brookton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.3723,
    longitude: 117.0105,
    accuracy: 4
  },
  {
    postalCode: 6306,
    city: "Jelcobine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.362,
    longitude: 117.0031,
    accuracy: 3
  },
  {
    postalCode: 6306,
    city: "Kweda",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.3667,
    longitude: 117.4333,
    accuracy: 4
  },
  {
    postalCode: 6306,
    city: "Aldersyde",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.3747,
    longitude: 117.2834,
    accuracy: 4
  },
  {
    postalCode: 6306,
    city: "Bulyee",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.3667,
    longitude: 117.5167,
    accuracy: 4
  },
  {
    postalCode: 6308,
    city: "Springs",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.5363,
    longitude: 116.8413,
    accuracy: 3
  },
  {
    postalCode: 6308,
    city: "Hastings",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.5363,
    longitude: 116.8413,
    accuracy: 3
  },
  {
    postalCode: 6308,
    city: "Pingelly",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.5325,
    longitude: 117.0824,
    accuracy: 4
  },
  {
    postalCode: 6308,
    city: "Dwarda",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.7667,
    longitude: 116.6667,
    accuracy: 4
  },
  {
    postalCode: 6308,
    city: "East Pingelly",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.5103,
    longitude: 117.1464,
    accuracy: 3
  },
  {
    postalCode: 6308,
    city: "Gillimanning",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.5363,
    longitude: 116.8413,
    accuracy: 3
  },
  {
    postalCode: 6308,
    city: "West Pingelly",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.5363,
    longitude: 116.8413,
    accuracy: 3
  },
  {
    postalCode: 6308,
    city: "Wandering",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.6833,
    longitude: 116.6667,
    accuracy: 4
  },
  {
    postalCode: 6308,
    city: "Codjatotine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.5363,
    longitude: 116.8413,
    accuracy: 3
  },
  {
    postalCode: 6308,
    city: "Pumphreys Bridge",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.5363,
    longitude: 116.8413,
    accuracy: 3
  },
  {
    postalCode: 6309,
    city: "Popanyinning",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.6667,
    longitude: 117.1333,
    accuracy: 4
  },
  {
    postalCode: 6309,
    city: "Stratherne",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.6618,
    longitude: 117.1292,
    accuracy: 3
  },
  {
    postalCode: 6309,
    city: "East Popanyinning",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.6329,
    longitude: 117.2604,
    accuracy: 4
  },
  {
    postalCode: 6309,
    city: "West Popanyinning",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.6618,
    longitude: 117.1292,
    accuracy: 3
  },
  {
    postalCode: 6311,
    city: "Yornaning",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.7333,
    longitude: 117.15,
    accuracy: 4
  },
  {
    postalCode: 6311,
    city: "Contine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.8667,
    longitude: 116.9667,
    accuracy: 4
  },
  {
    postalCode: 6311,
    city: "Dryandra",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.7667,
    longitude: 116.9667,
    accuracy: 4
  },
  {
    postalCode: 6311,
    city: "Wardering",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.7358,
    longitude: 117.1593,
    accuracy: 3
  },
  {
    postalCode: 6311,
    city: "Cuballing",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.8196,
    longitude: 117.1758,
    accuracy: 4
  },
  {
    postalCode: 6311,
    city: "Commodine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.7358,
    longitude: 117.1593,
    accuracy: 3
  },
  {
    postalCode: 6311,
    city: "Lol Gray",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.7358,
    longitude: 117.1593,
    accuracy: 3
  },
  {
    postalCode: 6311,
    city: "Townsendale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.7358,
    longitude: 117.1593,
    accuracy: 3
  },
  {
    postalCode: 6312,
    city: "Yilliminning",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.8994,
    longitude: 117.3744,
    accuracy: 4
  },
  {
    postalCode: 6312,
    city: "Narrogin Valley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.9953,
    longitude: 117.2623,
    accuracy: 3
  },
  {
    postalCode: 6312,
    city: "Nomans Lake",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.9256,
    longitude: 117.5194,
    accuracy: 4
  },
  {
    postalCode: 6312,
    city: "Hillside",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.9953,
    longitude: 117.2623,
    accuracy: 3
  },
  {
    postalCode: 6312,
    city: "Dumberning",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.0042,
    longitude: 117.101,
    accuracy: 4
  },
  {
    postalCode: 6312,
    city: "Minigin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.9953,
    longitude: 117.2623,
    accuracy: 3
  },
  {
    postalCode: 6312,
    city: "Narrogin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.9328,
    longitude: 117.1776,
    accuracy: 4
  },
  {
    postalCode: 6312,
    city: "Boundain",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.95,
    longitude: 117.3167,
    accuracy: 4
  },
  {
    postalCode: 6312,
    city: "Toolibin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.946,
    longitude: 117.6225,
    accuracy: 4
  },
  {
    postalCode: 6313,
    city: "Highbury",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.0667,
    longitude: 117.25,
    accuracy: 4
  },
  {
    postalCode: 6315,
    city: "Piesseville",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.1909,
    longitude: 117.2901,
    accuracy: 4
  },
  {
    postalCode: 6315,
    city: "Gundaring",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.3398,
    longitude: 117.1803,
    accuracy: 3
  },
  {
    postalCode: 6315,
    city: "Jaloran",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.15,
    longitude: 117.4333,
    accuracy: 4
  },
  {
    postalCode: 6315,
    city: "Dongolocking",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.1333,
    longitude: 117.8167,
    accuracy: 4
  },
  {
    postalCode: 6315,
    city: "Lime Lake",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.3398,
    longitude: 117.1803,
    accuracy: 3
  },
  {
    postalCode: 6315,
    city: "Ballaying",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.3064,
    longitude: 117.5525,
    accuracy: 4
  },
  {
    postalCode: 6315,
    city: "Minding",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.3398,
    longitude: 117.1803,
    accuracy: 3
  },
  {
    postalCode: 6315,
    city: "Collanilling",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.2667,
    longitude: 117.5,
    accuracy: 4
  },
  {
    postalCode: 6315,
    city: "Wedgecarrup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.3398,
    longitude: 117.1803,
    accuracy: 3
  },
  {
    postalCode: 6315,
    city: "Wagin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.3089,
    longitude: 117.3433,
    accuracy: 4
  },
  {
    postalCode: 6315,
    city: "Arthur River",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.351,
    longitude: 117.0318,
    accuracy: 4
  },
  {
    postalCode: 6315,
    city: "Cancanning",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.1333,
    longitude: 117.5667,
    accuracy: 4
  },
  {
    postalCode: 6316,
    city: "Woodanilling",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.5667,
    longitude: 117.4333,
    accuracy: 4
  },
  {
    postalCode: 6316,
    city: "Boyerine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.5336,
    longitude: 117.3382,
    accuracy: 3
  },
  {
    postalCode: 6316,
    city: "Cartmeticup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.47,
    longitude: 117.5175,
    accuracy: 4
  },
  {
    postalCode: 6316,
    city: "Glencoe",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.5336,
    longitude: 117.3382,
    accuracy: 3
  },
  {
    postalCode: 6316,
    city: "Kenmare",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.5336,
    longitude: 117.3382,
    accuracy: 3
  },
  {
    postalCode: 6316,
    city: "Westwood",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.5336,
    longitude: 117.3382,
    accuracy: 3
  },
  {
    postalCode: 6317,
    city: "Badgebup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6333,
    longitude: 117.9,
    accuracy: 4
  },
  {
    postalCode: 6317,
    city: "Datatine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.4667,
    longitude: 117.9167,
    accuracy: 4
  },
  {
    postalCode: 6317,
    city: "Ewlyamartup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7055,
    longitude: 117.7372,
    accuracy: 4
  },
  {
    postalCode: 6317,
    city: "Moojebing",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6483,
    longitude: 117.6843,
    accuracy: 3
  },
  {
    postalCode: 6317,
    city: "Murdong",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7577,
    longitude: 117.5995,
    accuracy: 4
  },
  {
    postalCode: 6317,
    city: "Katanning",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6879,
    longitude: 117.5584,
    accuracy: 4
  },
  {
    postalCode: 6317,
    city: "Coyrecup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6781,
    longitude: 117.83,
    accuracy: 4
  },
  {
    postalCode: 6317,
    city: "Pinwernying",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6483,
    longitude: 117.6843,
    accuracy: 3
  },
  {
    postalCode: 6317,
    city: "Marracoonda",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.65,
    longitude: 117.4167,
    accuracy: 4
  },
  {
    postalCode: 6317,
    city: "Coblinine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6483,
    longitude: 117.6843,
    accuracy: 3
  },
  {
    postalCode: 6317,
    city: "Carrolup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7435,
    longitude: 117.3999,
    accuracy: 4
  },
  {
    postalCode: 6317,
    city: "South Datatine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6483,
    longitude: 117.6843,
    accuracy: 3
  },
  {
    postalCode: 6317,
    city: "Bullock Hills",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6483,
    longitude: 117.6843,
    accuracy: 3
  },
  {
    postalCode: 6317,
    city: "South Glencoe",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6483,
    longitude: 117.6843,
    accuracy: 3
  },
  {
    postalCode: 6318,
    city: "Broomehill",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.843,
    longitude: 117.6401,
    accuracy: 4
  },
  {
    postalCode: 6318,
    city: "Broomehill West",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8785,
    longitude: 117.6161,
    accuracy: 3
  },
  {
    postalCode: 6318,
    city: "Broomehill East",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8785,
    longitude: 117.6161,
    accuracy: 3
  },
  {
    postalCode: 6318,
    city: "Broomehill Village",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8785,
    longitude: 117.6161,
    accuracy: 3
  },
  {
    postalCode: 6320,
    city: "Tambellup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.0433,
    longitude: 117.6414,
    accuracy: 4
  },
  {
    postalCode: 6320,
    city: "Moonies Hill",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.0833,
    longitude: 117.5167,
    accuracy: 4
  },
  {
    postalCode: 6320,
    city: "Wansbrough",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.1432,
    longitude: 117.6715,
    accuracy: 4
  },
  {
    postalCode: 6320,
    city: "Lake Toolbrunup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.1035,
    longitude: 117.6981,
    accuracy: 3
  },
  {
    postalCode: 6320,
    city: "Bobalong",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.1035,
    longitude: 117.6981,
    accuracy: 3
  },
  {
    postalCode: 6320,
    city: "Borderdale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.1035,
    longitude: 117.6981,
    accuracy: 3
  },
  {
    postalCode: 6320,
    city: "Dartnall",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.1035,
    longitude: 117.6981,
    accuracy: 3
  },
  {
    postalCode: 6321,
    city: "Cranbrook",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.2976,
    longitude: 117.5518,
    accuracy: 4
  },
  {
    postalCode: 6322,
    city: "Tenterden",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.362,
    longitude: 117.5549,
    accuracy: 4
  },
  {
    postalCode: 6323,
    city: "Kendenup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.4821,
    longitude: 117.6253,
    accuracy: 4
  },
  {
    postalCode: 6324,
    city: "Takalarup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.4793,
    longitude: 117.8964,
    accuracy: 3
  },
  {
    postalCode: 6324,
    city: "Porongurup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.65,
    longitude: 117.9,
    accuracy: 4
  },
  {
    postalCode: 6324,
    city: "Denbarker",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.4793,
    longitude: 117.8964,
    accuracy: 3
  },
  {
    postalCode: 6324,
    city: "Woogenellup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.5167,
    longitude: 117.8333,
    accuracy: 4
  },
  {
    postalCode: 6324,
    city: "Perillup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.4793,
    longitude: 117.8964,
    accuracy: 3
  },
  {
    postalCode: 6324,
    city: "Mount Barker",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.6308,
    longitude: 117.6661,
    accuracy: 4
  },
  {
    postalCode: 6324,
    city: "Forest Hill",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.4793,
    longitude: 117.8964,
    accuracy: 3
  },
  {
    postalCode: 6324,
    city: "South Stirling",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.4793,
    longitude: 117.8964,
    accuracy: 3
  },
  {
    postalCode: 6326,
    city: "Narrikup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.7723,
    longitude: 117.7042,
    accuracy: 4
  },
  {
    postalCode: 6327,
    city: "Redmond",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.8667,
    longitude: 117.6833,
    accuracy: 4
  },
  {
    postalCode: 6327,
    city: "Redmond West",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.8667,
    longitude: 117.6833,
    accuracy: 4
  },
  {
    postalCode: 6328,
    city: "Mettler",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.8333,
    longitude: 118.1667,
    accuracy: 3
  },
  {
    postalCode: 6328,
    city: "Manypeaks",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.8381,
    longitude: 118.1698,
    accuracy: 4
  },
  {
    postalCode: 6328,
    city: "Palmdale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.6048,
    longitude: 118.4088,
    accuracy: 3
  },
  {
    postalCode: 6328,
    city: "Cape Riche",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.6048,
    longitude: 118.4088,
    accuracy: 3
  },
  {
    postalCode: 6328,
    city: "Gnowellen",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.6048,
    longitude: 118.4088,
    accuracy: 3
  },
  {
    postalCode: 6328,
    city: "Cheynes",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.6048,
    longitude: 118.4088,
    accuracy: 3
  },
  {
    postalCode: 6328,
    city: "Green Range",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.6048,
    longitude: 118.4088,
    accuracy: 3
  },
  {
    postalCode: 6328,
    city: "Wellstead",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.4952,
    longitude: 118.6014,
    accuracy: 3
  },
  {
    postalCode: 6328,
    city: "Kojaneerup South",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.6048,
    longitude: 118.4088,
    accuracy: 3
  },
  {
    postalCode: 6330,
    city: "Kalgan",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.8847,
    longitude: 118.0131,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Napier",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.8333,
    longitude: 118,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Mount Clarence",
    state_name: "Western Australia",
    state: "WA",
    latitude: -35.0253,
    longitude: 117.9023,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Green Valley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.9448,
    longitude: 117.8359,
    accuracy: 3
  },
  {
    postalCode: 6330,
    city: "Torbay",
    state_name: "Western Australia",
    state: "WA",
    latitude: -35.0233,
    longitude: 117.6606,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Milpara",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.9889,
    longitude: 117.8707,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Lower King",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.9578,
    longitude: 117.9383,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Lowlands",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.9448,
    longitude: 117.8359,
    accuracy: 3
  },
  {
    postalCode: 6330,
    city: "Willyung",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.9433,
    longitude: 117.8795,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Mckail",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.9853,
    longitude: 117.8301,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Mount Elphinstone",
    state_name: "Western Australia",
    state: "WA",
    latitude: -35.0194,
    longitude: 117.8518,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Collingwood Park",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.9448,
    longitude: 117.8359,
    accuracy: 3
  },
  {
    postalCode: 6330,
    city: "Marbelup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.9675,
    longitude: 117.7333,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Orana",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.996,
    longitude: 117.8592,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Yakamia",
    state_name: "Western Australia",
    state: "WA",
    latitude: -35.0013,
    longitude: 117.8751,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Millbrook",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.9068,
    longitude: 117.8726,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Frenchman Bay",
    state_name: "Western Australia",
    state: "WA",
    latitude: -35.0935,
    longitude: 117.9491,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Bornholm",
    state_name: "Western Australia",
    state: "WA",
    latitude: -35.0606,
    longitude: 117.5769,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Seppings",
    state_name: "Western Australia",
    state: "WA",
    latitude: -35.0099,
    longitude: 117.9087,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Nanarup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.9448,
    longitude: 117.8359,
    accuracy: 3
  },
  {
    postalCode: 6330,
    city: "Mira Mar",
    state_name: "Western Australia",
    state: "WA",
    latitude: -35.0152,
    longitude: 117.901,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Albany",
    state_name: "Western Australia",
    state: "WA",
    latitude: -35.0031,
    longitude: 117.866,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "West Cape Howe",
    state_name: "Western Australia",
    state: "WA",
    latitude: -35.0827,
    longitude: 117.6255,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Nullaki",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.9448,
    longitude: 117.8359,
    accuracy: 3
  },
  {
    postalCode: 6330,
    city: "Centennial Park",
    state_name: "Western Australia",
    state: "WA",
    latitude: -35.0153,
    longitude: 117.8805,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Youngs Siding",
    state_name: "Western Australia",
    state: "WA",
    latitude: -35.0167,
    longitude: 117.5167,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Big Grove",
    state_name: "Western Australia",
    state: "WA",
    latitude: -35.0808,
    longitude: 117.879,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Sandpatch",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.9448,
    longitude: 117.8359,
    accuracy: 3
  },
  {
    postalCode: 6330,
    city: "Lange",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.9914,
    longitude: 117.8817,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Cuthbert",
    state_name: "Western Australia",
    state: "WA",
    latitude: -35.0158,
    longitude: 117.7983,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "King River",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.9344,
    longitude: 117.9119,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Vancouver Peninsula",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.9448,
    longitude: 117.8359,
    accuracy: 3
  },
  {
    postalCode: 6330,
    city: "Gledhow",
    state_name: "Western Australia",
    state: "WA",
    latitude: -35.0063,
    longitude: 117.8269,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Collingwood Heights",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.9927,
    longitude: 117.9207,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Lockyer",
    state_name: "Western Australia",
    state: "WA",
    latitude: -35.0057,
    longitude: 117.8588,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Port Albany",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.9448,
    longitude: 117.8359,
    accuracy: 3
  },
  {
    postalCode: 6330,
    city: "Mount Melville",
    state_name: "Western Australia",
    state: "WA",
    latitude: -35.0148,
    longitude: 117.8689,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Bayonet Head",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.973,
    longitude: 117.9345,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Emu Point",
    state_name: "Western Australia",
    state: "WA",
    latitude: -35,
    longitude: 117.9381,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Little Grove",
    state_name: "Western Australia",
    state: "WA",
    latitude: -35.068,
    longitude: 117.872,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Warrenup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.9755,
    longitude: 117.8472,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Spencer Park",
    state_name: "Western Australia",
    state: "WA",
    latitude: -35.0052,
    longitude: 117.9001,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Elleker",
    state_name: "Western Australia",
    state: "WA",
    latitude: -35.0092,
    longitude: 117.7303,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Robinson",
    state_name: "Western Australia",
    state: "WA",
    latitude: -35.0316,
    longitude: 117.8408,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Kronkup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -35.0506,
    longitude: 117.6186,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Middleton Beach",
    state_name: "Western Australia",
    state: "WA",
    latitude: -35.0237,
    longitude: 117.911,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Goode Beach",
    state_name: "Western Australia",
    state: "WA",
    latitude: -35.0887,
    longitude: 117.9358,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Drome",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.9572,
    longitude: 117.8109,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Walmsley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.9739,
    longitude: 117.903,
    accuracy: 4
  },
  {
    postalCode: 6330,
    city: "Torndirrup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -35.0941,
    longitude: 117.906,
    accuracy: 4
  },
  {
    postalCode: 6331,
    city: "Albany Dc",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.6956,
    longitude: 117.882,
    accuracy: 1
  },
  {
    postalCode: 6332,
    city: "Albany",
    state_name: "Western Australia",
    state: "WA",
    latitude: -35.0031,
    longitude: 117.866,
    accuracy: 4
  },
  {
    postalCode: 6332,
    city: "Albany Po",
    state_name: "Western Australia",
    state: "WA",
    latitude: -35.0031,
    longitude: 117.866,
    accuracy: 3
  },
  {
    postalCode: 6333,
    city: "Kentdale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.9,
    longitude: 117.05,
    accuracy: 4
  },
  {
    postalCode: 6333,
    city: "Hay",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.8905,
    longitude: 117.1188,
    accuracy: 3
  },
  {
    postalCode: 6333,
    city: "Parryville",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.9833,
    longitude: 117.1833,
    accuracy: 4
  },
  {
    postalCode: 6333,
    city: "Denmark",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.9607,
    longitude: 117.3532,
    accuracy: 4
  },
  {
    postalCode: 6333,
    city: "Nornalup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.9917,
    longitude: 116.8202,
    accuracy: 4
  },
  {
    postalCode: 6333,
    city: "Shadforth",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.9638,
    longitude: 117.2692,
    accuracy: 4
  },
  {
    postalCode: 6333,
    city: "William Bay",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.8905,
    longitude: 117.1188,
    accuracy: 3
  },
  {
    postalCode: 6333,
    city: "Mount Romance",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.8119,
    longitude: 117.1347,
    accuracy: 3
  },
  {
    postalCode: 6333,
    city: "Ocean Beach",
    state_name: "Western Australia",
    state: "WA",
    latitude: -35.0202,
    longitude: 117.3263,
    accuracy: 3
  },
  {
    postalCode: 6333,
    city: "Trent",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.9131,
    longitude: 116.9396,
    accuracy: 3
  },
  {
    postalCode: 6333,
    city: "Tingledale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.8905,
    longitude: 117.1188,
    accuracy: 3
  },
  {
    postalCode: 6333,
    city: "Peaceful Bay",
    state_name: "Western Australia",
    state: "WA",
    latitude: -35.0225,
    longitude: 116.9165,
    accuracy: 4
  },
  {
    postalCode: 6333,
    city: "Hazelvale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.8905,
    longitude: 117.1188,
    accuracy: 3
  },
  {
    postalCode: 6333,
    city: "Bow Bridge",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.8905,
    longitude: 117.1188,
    accuracy: 3
  },
  {
    postalCode: 6333,
    city: "Mount Lindesay",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.8905,
    longitude: 117.1188,
    accuracy: 3
  },
  {
    postalCode: 6333,
    city: "Kordabup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.929,
    longitude: 117.1486,
    accuracy: 4
  },
  {
    postalCode: 6333,
    city: "Scotsdale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.9081,
    longitude: 117.2825,
    accuracy: 3
  },
  {
    postalCode: 6335,
    city: "Kebaringup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.0333,
    longitude: 118.15,
    accuracy: 4
  },
  {
    postalCode: 6335,
    city: "Gnowangerup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.937,
    longitude: 118.009,
    accuracy: 4
  },
  {
    postalCode: 6335,
    city: "Pallinup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8664,
    longitude: 118.1111,
    accuracy: 3
  },
  {
    postalCode: 6335,
    city: "Jackitup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8664,
    longitude: 118.1111,
    accuracy: 3
  },
  {
    postalCode: 6336,
    city: "Needilup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.95,
    longitude: 118.8167,
    accuracy: 4
  },
  {
    postalCode: 6336,
    city: "Toompup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.0133,
    longitude: 118.4278,
    accuracy: 4
  },
  {
    postalCode: 6336,
    city: "Ongerup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.9656,
    longitude: 118.4869,
    accuracy: 4
  },
  {
    postalCode: 6336,
    city: "Mindarabin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8753,
    longitude: 118.5061,
    accuracy: 3
  },
  {
    postalCode: 6336,
    city: "Mills Lake",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8753,
    longitude: 118.5061,
    accuracy: 3
  },
  {
    postalCode: 6336,
    city: "Cowalellup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8753,
    longitude: 118.5061,
    accuracy: 3
  },
  {
    postalCode: 6337,
    city: "Jerramungup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.9422,
    longitude: 118.9173,
    accuracy: 4
  },
  {
    postalCode: 6337,
    city: "West Fitzgerald",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.9438,
    longitude: 119.2324,
    accuracy: 3
  },
  {
    postalCode: 6337,
    city: "Jacup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8167,
    longitude: 119.2667,
    accuracy: 4
  },
  {
    postalCode: 6337,
    city: "Gairdner",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.9438,
    longitude: 119.2324,
    accuracy: 3
  },
  {
    postalCode: 6337,
    city: "Fitzgerald",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.9438,
    longitude: 119.2324,
    accuracy: 3
  },
  {
    postalCode: 6338,
    city: "Bremer Bay",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.3925,
    longitude: 119.3798,
    accuracy: 4
  },
  {
    postalCode: 6338,
    city: "Borden",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.0724,
    longitude: 118.2721,
    accuracy: 4
  },
  {
    postalCode: 6338,
    city: "Nalyerlup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.1703,
    longitude: 118.7076,
    accuracy: 3
  },
  {
    postalCode: 6338,
    city: "North Stirlings",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.1703,
    longitude: 118.7076,
    accuracy: 3
  },
  {
    postalCode: 6338,
    city: "Monjebup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.1703,
    longitude: 118.7076,
    accuracy: 3
  },
  {
    postalCode: 6338,
    city: "Boxwood Hill",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.3617,
    longitude: 118.7467,
    accuracy: 4
  },
  {
    postalCode: 6338,
    city: "Magitup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.1703,
    longitude: 118.7076,
    accuracy: 3
  },
  {
    postalCode: 6338,
    city: "Stirling Range National Park",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.4044,
    longitude: 118.0419,
    accuracy: 3
  },
  {
    postalCode: 6338,
    city: "Amelup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.2385,
    longitude: 118.2209,
    accuracy: 3
  },
  {
    postalCode: 6341,
    city: "Nyabing",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.5413,
    longitude: 118.146,
    accuracy: 4
  },
  {
    postalCode: 6343,
    city: "Pingrup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.5378,
    longitude: 118.5122,
    accuracy: 4
  },
  {
    postalCode: 6346,
    city: "Ravensthorpe",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.583,
    longitude: 120.0469,
    accuracy: 4
  },
  {
    postalCode: 6346,
    city: "Fitzgerald River National Park",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.0016,
    longitude: 119.598,
    accuracy: 4
  },
  {
    postalCode: 6346,
    city: "Jerdacuttup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8964,
    longitude: 120.213,
    accuracy: 4
  },
  {
    postalCode: 6346,
    city: "West River",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.4166,
    longitude: 120.1755,
    accuracy: 3
  },
  {
    postalCode: 6348,
    city: "Hopetoun",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.9506,
    longitude: 120.1264,
    accuracy: 4
  },
  {
    postalCode: 6350,
    city: "Nippering",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.295,
    longitude: 117.638,
    accuracy: 4
  },
  {
    postalCode: 6350,
    city: "Dumbleyung",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.3126,
    longitude: 117.7393,
    accuracy: 4
  },
  {
    postalCode: 6350,
    city: "Nairibin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.2563,
    longitude: 117.7554,
    accuracy: 3
  },
  {
    postalCode: 6351,
    city: "Moulyinning",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.2254,
    longitude: 117.9269,
    accuracy: 4
  },
  {
    postalCode: 6351,
    city: "North Moulyinning",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.25,
    longitude: 117.9333,
    accuracy: 3
  },
  {
    postalCode: 6352,
    city: "Kukerin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.1833,
    longitude: 118.0833,
    accuracy: 4
  },
  {
    postalCode: 6352,
    city: "Merilup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.2667,
    longitude: 118.1667,
    accuracy: 4
  },
  {
    postalCode: 6352,
    city: "North Kukerin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.2087,
    longitude: 118.0664,
    accuracy: 3
  },
  {
    postalCode: 6352,
    city: "South Kukerin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.2087,
    longitude: 118.0664,
    accuracy: 3
  },
  {
    postalCode: 6353,
    city: "Beenong",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.045,
    longitude: 118.5853,
    accuracy: 4
  },
  {
    postalCode: 6353,
    city: "Kuender",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.95,
    longitude: 118.5333,
    accuracy: 4
  },
  {
    postalCode: 6353,
    city: "North Lake Grace",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.95,
    longitude: 118.4667,
    accuracy: 4
  },
  {
    postalCode: 6353,
    city: "Mallee Hill",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.9592,
    longitude: 118.4872,
    accuracy: 3
  },
  {
    postalCode: 6353,
    city: "Lake Grace",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.1032,
    longitude: 118.4646,
    accuracy: 4
  },
  {
    postalCode: 6353,
    city: "Neendaling",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.1167,
    longitude: 118.3333,
    accuracy: 4
  },
  {
    postalCode: 6353,
    city: "Tarin Rock",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.1075,
    longitude: 118.2308,
    accuracy: 4
  },
  {
    postalCode: 6353,
    city: "North Burngup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.9592,
    longitude: 118.4872,
    accuracy: 3
  },
  {
    postalCode: 6353,
    city: "Buniche",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.0039,
    longitude: 118.766,
    accuracy: 4
  },
  {
    postalCode: 6353,
    city: "South Lake Grace",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.8333,
    longitude: 119.5333,
    accuracy: 4
  },
  {
    postalCode: 6355,
    city: "Lake Biddy",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.0019,
    longitude: 118.9292,
    accuracy: 4
  },
  {
    postalCode: 6355,
    city: "Lake Camm",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.9833,
    longitude: 119.5833,
    accuracy: 4
  },
  {
    postalCode: 6355,
    city: "Varley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.7667,
    longitude: 119.45,
    accuracy: 4
  },
  {
    postalCode: 6355,
    city: "South Newdegate",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.0865,
    longitude: 118.9698,
    accuracy: 3
  },
  {
    postalCode: 6355,
    city: "Newdegate",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.0939,
    longitude: 119.0339,
    accuracy: 4
  },
  {
    postalCode: 6355,
    city: "Holt Rock",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.6722,
    longitude: 119.406,
    accuracy: 4
  },
  {
    postalCode: 6355,
    city: "Mount Sheridan",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.0865,
    longitude: 118.9698,
    accuracy: 3
  },
  {
    postalCode: 6355,
    city: "East Newdegate",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.0865,
    longitude: 118.9698,
    accuracy: 3
  },
  {
    postalCode: 6355,
    city: "Magenta",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.0865,
    longitude: 118.9698,
    accuracy: 3
  },
  {
    postalCode: 6355,
    city: "Dunn Rock",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.0865,
    longitude: 118.9698,
    accuracy: 3
  },
  {
    postalCode: 6355,
    city: "Little Italy",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.0865,
    longitude: 118.9698,
    accuracy: 3
  },
  {
    postalCode: 6356,
    city: "Lake King",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.0859,
    longitude: 119.6755,
    accuracy: 4
  },
  {
    postalCode: 6356,
    city: "Mount Madden",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.2667,
    longitude: 119.7833,
    accuracy: 4
  },
  {
    postalCode: 6356,
    city: "Hatter Hill",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.175,
    longitude: 119.725,
    accuracy: 3
  },
  {
    postalCode: 6357,
    city: "Pingaring",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.7546,
    longitude: 118.6278,
    accuracy: 4
  },
  {
    postalCode: 6358,
    city: "Karlgarin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.4971,
    longitude: 118.7098,
    accuracy: 4
  },
  {
    postalCode: 6359,
    city: "Hyden",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.45,
    longitude: 118.8833,
    accuracy: 4
  },
  {
    postalCode: 6359,
    city: "Forrestania",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.4947,
    longitude: 119.4469,
    accuracy: 3
  },
  {
    postalCode: 6361,
    city: "Tincurrin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.9768,
    longitude: 117.7739,
    accuracy: 4
  },
  {
    postalCode: 6361,
    city: "Harrismith",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.9357,
    longitude: 117.8609,
    accuracy: 4
  },
  {
    postalCode: 6363,
    city: "Dudinin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.8762,
    longitude: 117.9053,
    accuracy: 4
  },
  {
    postalCode: 6363,
    city: "Walyurin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.8483,
    longitude: 117.9961,
    accuracy: 3
  },
  {
    postalCode: 6365,
    city: "Jilakin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.6667,
    longitude: 118.3333,
    accuracy: 4
  },
  {
    postalCode: 6365,
    city: "Kulin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.6668,
    longitude: 118.158,
    accuracy: 4
  },
  {
    postalCode: 6365,
    city: "Jitarning",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.7869,
    longitude: 118.0047,
    accuracy: 4
  },
  {
    postalCode: 6365,
    city: "Kulin West",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.7164,
    longitude: 118.2755,
    accuracy: 3
  },
  {
    postalCode: 6367,
    city: "Kondinin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.4986,
    longitude: 118.2653,
    accuracy: 4
  },
  {
    postalCode: 6368,
    city: "South Kumminin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2,
    longitude: 118.3333,
    accuracy: 4
  },
  {
    postalCode: 6369,
    city: "Mount Walker",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0823,
    longitude: 118.7442,
    accuracy: 3
  },
  {
    postalCode: 6369,
    city: "Wadderin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.994,
    longitude: 118.4505,
    accuracy: 4
  },
  {
    postalCode: 6369,
    city: "West Holleton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.95,
    longitude: 119.0333,
    accuracy: 4
  },
  {
    postalCode: 6369,
    city: "Woolocutty",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0823,
    longitude: 118.7442,
    accuracy: 3
  },
  {
    postalCode: 6369,
    city: "Narembeen",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0637,
    longitude: 118.3957,
    accuracy: 4
  },
  {
    postalCode: 6370,
    city: "Wickepin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.7816,
    longitude: 117.503,
    accuracy: 4
  },
  {
    postalCode: 6370,
    city: "Kirk Rock",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.767,
    longitude: 117.7208,
    accuracy: 3
  },
  {
    postalCode: 6370,
    city: "East Wickepin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.7833,
    longitude: 117.65,
    accuracy: 4
  },
  {
    postalCode: 6370,
    city: "Malyalling",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.7,
    longitude: 117.5333,
    accuracy: 4
  },
  {
    postalCode: 6370,
    city: "Wogolin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.767,
    longitude: 117.7208,
    accuracy: 3
  },
  {
    postalCode: 6372,
    city: "Yealering",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.5921,
    longitude: 117.6273,
    accuracy: 4
  },
  {
    postalCode: 6373,
    city: "Bullaring",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.4964,
    longitude: 117.7453,
    accuracy: 4
  },
  {
    postalCode: 6375,
    city: "Bilbarin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2061,
    longitude: 117.9529,
    accuracy: 4
  },
  {
    postalCode: 6375,
    city: "Corrigin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.3338,
    longitude: 117.8718,
    accuracy: 4
  },
  {
    postalCode: 6375,
    city: "Kurrenkutten",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.25,
    longitude: 118.2167,
    accuracy: 4
  },
  {
    postalCode: 6375,
    city: "Gorge Rock",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.4567,
    longitude: 117.9978,
    accuracy: 4
  },
  {
    postalCode: 6375,
    city: "Kunjin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.3554,
    longitude: 117.7709,
    accuracy: 4
  },
  {
    postalCode: 6375,
    city: "Adamsvale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.3416,
    longitude: 117.8368,
    accuracy: 3
  },
  {
    postalCode: 6383,
    city: "South Quairading",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1667,
    longitude: 117.4667,
    accuracy: 4
  },
  {
    postalCode: 6383,
    city: "Mount Stirling",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0292,
    longitude: 117.3523,
    accuracy: 3
  },
  {
    postalCode: 6383,
    city: "Balkuling",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9812,
    longitude: 117.1139,
    accuracy: 4
  },
  {
    postalCode: 6383,
    city: "Cubbine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0292,
    longitude: 117.3523,
    accuracy: 3
  },
  {
    postalCode: 6383,
    city: "Doodenanning",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8667,
    longitude: 117.15,
    accuracy: 4
  },
  {
    postalCode: 6383,
    city: "Mawson",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0292,
    longitude: 117.3523,
    accuracy: 3
  },
  {
    postalCode: 6383,
    city: "Quairading",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.012,
    longitude: 117.3955,
    accuracy: 4
  },
  {
    postalCode: 6383,
    city: "Dulbelling",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.05,
    longitude: 117.2667,
    accuracy: 4
  },
  {
    postalCode: 6383,
    city: "Wamenusking",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1258,
    longitude: 117.5997,
    accuracy: 4
  },
  {
    postalCode: 6383,
    city: "Badjaling",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9972,
    longitude: 117.4989,
    accuracy: 4
  },
  {
    postalCode: 6383,
    city: "Yoting",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9602,
    longitude: 117.5914,
    accuracy: 4
  },
  {
    postalCode: 6383,
    city: "Dangin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.05,
    longitude: 117.3167,
    accuracy: 4
  },
  {
    postalCode: 6384,
    city: "Pantapin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9525,
    longitude: 117.6572,
    accuracy: 4
  },
  {
    postalCode: 6385,
    city: "Kwolyin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9295,
    longitude: 117.7501,
    accuracy: 4
  },
  {
    postalCode: 6386,
    city: "Shackleton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9325,
    longitude: 117.8313,
    accuracy: 4
  },
  {
    postalCode: 6390,
    city: "Ranford",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.8,
    longitude: 116.5,
    accuracy: 4
  },
  {
    postalCode: 6390,
    city: "Boddington",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.8007,
    longitude: 116.4752,
    accuracy: 4
  },
  {
    postalCode: 6390,
    city: "Crossman",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.7833,
    longitude: 116.6,
    accuracy: 4
  },
  {
    postalCode: 6390,
    city: "North Bannister",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.5833,
    longitude: 116.4333,
    accuracy: 4
  },
  {
    postalCode: 6390,
    city: "Bannister",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.5833,
    longitude: 116.4333,
    accuracy: 4
  },
  {
    postalCode: 6390,
    city: "Marradong",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.8631,
    longitude: 116.4508,
    accuracy: 4
  },
  {
    postalCode: 6390,
    city: "Wuraming",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.8,
    longitude: 116.2833,
    accuracy: 4
  },
  {
    postalCode: 6390,
    city: "Lower Hotham",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.817,
    longitude: 116.4003,
    accuracy: 3
  },
  {
    postalCode: 6390,
    city: "Mount Wells",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.817,
    longitude: 116.4003,
    accuracy: 3
  },
  {
    postalCode: 6390,
    city: "Upper Murray",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.817,
    longitude: 116.4003,
    accuracy: 3
  },
  {
    postalCode: 6390,
    city: "Mount Cooke",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.817,
    longitude: 116.4003,
    accuracy: 3
  },
  {
    postalCode: 6391,
    city: "Williams",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.028,
    longitude: 116.8792,
    accuracy: 4
  },
  {
    postalCode: 6391,
    city: "Narrakine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.0714,
    longitude: 116.7281,
    accuracy: 3
  },
  {
    postalCode: 6391,
    city: "Congelin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.8402,
    longitude: 116.8854,
    accuracy: 4
  },
  {
    postalCode: 6391,
    city: "Tarwonga",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.0714,
    longitude: 116.7281,
    accuracy: 3
  },
  {
    postalCode: 6391,
    city: "Quindanning",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.0466,
    longitude: 116.5698,
    accuracy: 4
  },
  {
    postalCode: 6391,
    city: "Culbin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.0714,
    longitude: 116.7281,
    accuracy: 3
  },
  {
    postalCode: 6391,
    city: "Hillman River",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2833,
    longitude: 115.7636,
    accuracy: 4
  },
  {
    postalCode: 6391,
    city: "Boraning",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.0714,
    longitude: 116.7281,
    accuracy: 3
  },
  {
    postalCode: 6392,
    city: "Meeking",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.3563,
    longitude: 116.8259,
    accuracy: 3
  },
  {
    postalCode: 6392,
    city: "Bokal",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.4814,
    longitude: 116.9005,
    accuracy: 4
  },
  {
    postalCode: 6392,
    city: "Boolading",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.4836,
    longitude: 116.5773,
    accuracy: 3
  },
  {
    postalCode: 6392,
    city: "Darkan",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.3357,
    longitude: 116.7443,
    accuracy: 4
  },
  {
    postalCode: 6392,
    city: "Dardadine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.2333,
    longitude: 116.8333,
    accuracy: 4
  },
  {
    postalCode: 6393,
    city: "Duranillin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.5159,
    longitude: 116.8072,
    accuracy: 4
  },
  {
    postalCode: 6393,
    city: "Moodiarrup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.5167,
    longitude: 116.725,
    accuracy: 3
  },
  {
    postalCode: 6393,
    city: "Cordering",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.4971,
    longitude: 116.6572,
    accuracy: 4
  },
  {
    postalCode: 6393,
    city: "Trigwell",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.5167,
    longitude: 116.725,
    accuracy: 3
  },
  {
    postalCode: 6394,
    city: "Muradup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8333,
    longitude: 116.9833,
    accuracy: 4
  },
  {
    postalCode: 6394,
    city: "Orchid Valley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7898,
    longitude: 116.8998,
    accuracy: 3
  },
  {
    postalCode: 6394,
    city: "Boscabel",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6667,
    longitude: 117.05,
    accuracy: 4
  },
  {
    postalCode: 6394,
    city: "Beaufort River",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7898,
    longitude: 116.8998,
    accuracy: 3
  },
  {
    postalCode: 6394,
    city: "Boilup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7898,
    longitude: 116.8998,
    accuracy: 3
  },
  {
    postalCode: 6394,
    city: "Mokup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7778,
    longitude: 116.9444,
    accuracy: 3
  },
  {
    postalCode: 6394,
    city: "Qualeup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8333,
    longitude: 116.8,
    accuracy: 4
  },
  {
    postalCode: 6394,
    city: "Changerup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7898,
    longitude: 116.8998,
    accuracy: 3
  },
  {
    postalCode: 6395,
    city: "Kojonup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8305,
    longitude: 117.1595,
    accuracy: 4
  },
  {
    postalCode: 6395,
    city: "Mobrup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.1257,
    longitude: 116.9282,
    accuracy: 4
  },
  {
    postalCode: 6395,
    city: "Ryansbrook",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.0305,
    longitude: 117.0231,
    accuracy: 3
  },
  {
    postalCode: 6395,
    city: "Jingalup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.9667,
    longitude: 117.0333,
    accuracy: 4
  },
  {
    postalCode: 6395,
    city: "Lumeah",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.9833,
    longitude: 117.2333,
    accuracy: 4
  },
  {
    postalCode: 6395,
    city: "Cherry Tree Pool",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.75,
    longitude: 117.2833,
    accuracy: 4
  },
  {
    postalCode: 6396,
    city: "Frankland",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.3667,
    longitude: 117.0667,
    accuracy: 4
  },
  {
    postalCode: 6396,
    city: "Frankland River",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.3667,
    longitude: 117.0667,
    accuracy: 4
  },
  {
    postalCode: 6397,
    city: "Rocky Gully",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.5105,
    longitude: 117.0106,
    accuracy: 4
  },
  {
    postalCode: 6398,
    city: "Broke",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.796,
    longitude: 116.5997,
    accuracy: 3
  },
  {
    postalCode: 6398,
    city: "North Walpole",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.7234,
    longitude: 116.6612,
    accuracy: 4
  },
  {
    postalCode: 6398,
    city: "Walpole",
    state_name: "Western Australia",
    state: "WA",
    latitude: -34.976,
    longitude: 116.7302,
    accuracy: 4
  },
  {
    postalCode: 6401,
    city: "Southern Brook",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.5451,
    longitude: 116.8231,
    accuracy: 4
  },
  {
    postalCode: 6401,
    city: "Cunjardine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.5588,
    longitude: 116.7519,
    accuracy: 3
  },
  {
    postalCode: 6401,
    city: "Northam",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.6493,
    longitude: 116.6742,
    accuracy: 4
  },
  {
    postalCode: 6401,
    city: "Spencers Brook",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7366,
    longitude: 116.6306,
    accuracy: 4
  },
  {
    postalCode: 6401,
    city: "Jennapullin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.5329,
    longitude: 116.7201,
    accuracy: 4
  },
  {
    postalCode: 6401,
    city: "Muluckine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.6363,
    longitude: 116.7491,
    accuracy: 3
  },
  {
    postalCode: 6401,
    city: "Rossmore",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.5588,
    longitude: 116.7519,
    accuracy: 3
  },
  {
    postalCode: 6401,
    city: "Burlong",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.5588,
    longitude: 116.7519,
    accuracy: 3
  },
  {
    postalCode: 6401,
    city: "Muresk",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.75,
    longitude: 116.6667,
    accuracy: 4
  },
  {
    postalCode: 6401,
    city: "Irishtown",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.5588,
    longitude: 116.7519,
    accuracy: 3
  },
  {
    postalCode: 6401,
    city: "Mokine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7441,
    longitude: 116.5727,
    accuracy: 3
  },
  {
    postalCode: 6401,
    city: "Buckland",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.5588,
    longitude: 116.7519,
    accuracy: 3
  },
  {
    postalCode: 6401,
    city: "Malabaine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.5588,
    longitude: 116.7519,
    accuracy: 3
  },
  {
    postalCode: 6401,
    city: "Meenaar",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.5588,
    longitude: 116.7519,
    accuracy: 3
  },
  {
    postalCode: 6401,
    city: "Throssell",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.5588,
    longitude: 116.7519,
    accuracy: 3
  },
  {
    postalCode: 6401,
    city: "Jennacubbine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.4402,
    longitude: 116.7247,
    accuracy: 4
  },
  {
    postalCode: 6401,
    city: "Wongamine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.476,
    longitude: 116.617,
    accuracy: 4
  },
  {
    postalCode: 6401,
    city: "Mumberkine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.5588,
    longitude: 116.7519,
    accuracy: 3
  },
  {
    postalCode: 6403,
    city: "Grass Valley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.6373,
    longitude: 116.7976,
    accuracy: 4
  },
  {
    postalCode: 6405,
    city: "Warding East",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.6254,
    longitude: 117.0059,
    accuracy: 3
  },
  {
    postalCode: 6405,
    city: "Meckering",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.6277,
    longitude: 117.0114,
    accuracy: 4
  },
  {
    postalCode: 6405,
    city: "Quelagetting",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.6254,
    longitude: 117.0059,
    accuracy: 3
  },
  {
    postalCode: 6405,
    city: "Greenwoods Valley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.6254,
    longitude: 117.0059,
    accuracy: 3
  },
  {
    postalCode: 6407,
    city: "Youndegin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7885,
    longitude: 117.3287,
    accuracy: 4
  },
  {
    postalCode: 6407,
    city: "Wyola West",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.5995,
    longitude: 117.1561,
    accuracy: 3
  },
  {
    postalCode: 6407,
    city: "Cunderdin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.654,
    longitude: 117.2337,
    accuracy: 4
  },
  {
    postalCode: 6407,
    city: "Wyola",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.5995,
    longitude: 117.1561,
    accuracy: 3
  },
  {
    postalCode: 6407,
    city: "Watercarrin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.5995,
    longitude: 117.1561,
    accuracy: 3
  },
  {
    postalCode: 6407,
    city: "Waeel",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.5995,
    longitude: 117.1561,
    accuracy: 3
  },
  {
    postalCode: 6409,
    city: "South Tammin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8099,
    longitude: 117.5363,
    accuracy: 4
  },
  {
    postalCode: 6409,
    city: "North Tammin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.6167,
    longitude: 117.5389,
    accuracy: 3
  },
  {
    postalCode: 6409,
    city: "Tammin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.6667,
    longitude: 117.5,
    accuracy: 4
  },
  {
    postalCode: 6409,
    city: "Doongin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.6067,
    longitude: 117.495,
    accuracy: 3
  },
  {
    postalCode: 6409,
    city: "Yorkrakine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.3679,
    longitude: 117.5858,
    accuracy: 4
  },
  {
    postalCode: 6410,
    city: "Mount Caroline",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9586,
    longitude: 117.5524,
    accuracy: 3
  },
  {
    postalCode: 6410,
    city: "Daadenning Creek",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7667,
    longitude: 117.7833,
    accuracy: 4
  },
  {
    postalCode: 6410,
    city: "North Kellerberrin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.5,
    longitude: 117.6833,
    accuracy: 4
  },
  {
    postalCode: 6410,
    city: "Bungulla",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.6238,
    longitude: 117.5898,
    accuracy: 4
  },
  {
    postalCode: 6410,
    city: "Kellerberrin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.6318,
    longitude: 117.7198,
    accuracy: 4
  },
  {
    postalCode: 6411,
    city: "South Doodlakine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.5822,
    longitude: 117.8148,
    accuracy: 3
  },
  {
    postalCode: 6411,
    city: "Doodlakine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.6092,
    longitude: 117.8722,
    accuracy: 4
  },
  {
    postalCode: 6412,
    city: "Baandee",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.5832,
    longitude: 117.9536,
    accuracy: 4
  },
  {
    postalCode: 6412,
    city: "North Baandee",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.5833,
    longitude: 117.9667,
    accuracy: 3
  },
  {
    postalCode: 6413,
    city: "Hines Hill",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.5342,
    longitude: 118.0748,
    accuracy: 4
  },
  {
    postalCode: 6414,
    city: "Nangeenan",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.5333,
    longitude: 118.1667,
    accuracy: 4
  },
  {
    postalCode: 6415,
    city: "Merredin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.4809,
    longitude: 118.2745,
    accuracy: 4
  },
  {
    postalCode: 6415,
    city: "Goomarin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.2444,
    longitude: 118.4358,
    accuracy: 4
  },
  {
    postalCode: 6415,
    city: "Tandegin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.4231,
    longitude: 118.2344,
    accuracy: 3
  },
  {
    postalCode: 6415,
    city: "Norpa",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.584,
    longitude: 118.4238,
    accuracy: 4
  },
  {
    postalCode: 6415,
    city: "Nokaning",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.3733,
    longitude: 118.2183,
    accuracy: 4
  },
  {
    postalCode: 6415,
    city: "Korbel",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.6602,
    longitude: 118.1489,
    accuracy: 4
  },
  {
    postalCode: 6418,
    city: "Yarding",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9276,
    longitude: 117.9851,
    accuracy: 4
  },
  {
    postalCode: 6418,
    city: "Bruce Rock",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8805,
    longitude: 118.1475,
    accuracy: 4
  },
  {
    postalCode: 6419,
    city: "Ardath",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0325,
    longitude: 118.0952,
    accuracy: 4
  },
  {
    postalCode: 6420,
    city: "Cramphorne",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.805,
    longitude: 118.5601,
    accuracy: 4
  },
  {
    postalCode: 6420,
    city: "Muntadgin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7578,
    longitude: 118.5619,
    accuracy: 4
  },
  {
    postalCode: 6421,
    city: "Burracoppin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.3975,
    longitude: 118.4815,
    accuracy: 4
  },
  {
    postalCode: 6421,
    city: "South Burracoppin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.5667,
    longitude: 118.1167,
    accuracy: 4
  },
  {
    postalCode: 6421,
    city: "Warralakin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.0167,
    longitude: 118.6051,
    accuracy: 4
  },
  {
    postalCode: 6422,
    city: "Walgoolan",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.3833,
    longitude: 118.5667,
    accuracy: 4
  },
  {
    postalCode: 6423,
    city: "Warrachuppin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.9683,
    longitude: 118.6569,
    accuracy: 3
  },
  {
    postalCode: 6423,
    city: "Carrabin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.3936,
    longitude: 118.6719,
    accuracy: 4
  },
  {
    postalCode: 6423,
    city: "Westonia",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.3029,
    longitude: 118.6962,
    accuracy: 4
  },
  {
    postalCode: 6423,
    city: "Boodarockin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.0127,
    longitude: 118.8046,
    accuracy: 4
  },
  {
    postalCode: 6424,
    city: "Bodallin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.3766,
    longitude: 118.8761,
    accuracy: 4
  },
  {
    postalCode: 6424,
    city: "South Bodallin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.3667,
    longitude: 118.8667,
    accuracy: 3
  },
  {
    postalCode: 6424,
    city: "North Bodallin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.3667,
    longitude: 118.8667,
    accuracy: 3
  },
  {
    postalCode: 6425,
    city: "Moorine Rock",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.3208,
    longitude: 119.1267,
    accuracy: 4
  },
  {
    postalCode: 6425,
    city: "Dulyalbin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.6054,
    longitude: 119.034,
    accuracy: 3
  },
  {
    postalCode: 6426,
    city: "Parker Range",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.6333,
    longitude: 119.5833,
    accuracy: 4
  },
  {
    postalCode: 6426,
    city: "Ghooli",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.2618,
    longitude: 119.4568,
    accuracy: 4
  },
  {
    postalCode: 6426,
    city: "Holleton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.95,
    longitude: 119.0333,
    accuracy: 4
  },
  {
    postalCode: 6426,
    city: "Turkey Hill",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7573,
    longitude: 119.6086,
    accuracy: 3
  },
  {
    postalCode: 6426,
    city: "Marvel Loch",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.4678,
    longitude: 119.4873,
    accuracy: 4
  },
  {
    postalCode: 6426,
    city: "Mount Hampton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7573,
    longitude: 119.6086,
    accuracy: 3
  },
  {
    postalCode: 6426,
    city: "Southern Cross",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.2268,
    longitude: 119.3238,
    accuracy: 4
  },
  {
    postalCode: 6426,
    city: "Mount Holland",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7573,
    longitude: 119.6086,
    accuracy: 3
  },
  {
    postalCode: 6426,
    city: "Yellowdine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.2927,
    longitude: 119.6532,
    accuracy: 4
  },
  {
    postalCode: 6426,
    city: "Corinthia",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.1171,
    longitude: 119.234,
    accuracy: 4
  },
  {
    postalCode: 6426,
    city: "Mount Palmer",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.4062,
    longitude: 119.6815,
    accuracy: 4
  },
  {
    postalCode: 6426,
    city: "Mount Jackson",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7573,
    longitude: 119.6086,
    accuracy: 3
  },
  {
    postalCode: 6426,
    city: "Skeleton Rock",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7573,
    longitude: 119.6086,
    accuracy: 3
  },
  {
    postalCode: 6426,
    city: "South Yilgarn",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7573,
    longitude: 119.6086,
    accuracy: 3
  },
  {
    postalCode: 6427,
    city: "Koolyanobbing",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.8212,
    longitude: 119.5214,
    accuracy: 4
  },
  {
    postalCode: 6428,
    city: "Babakin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1264,
    longitude: 118.0241,
    accuracy: 4
  },
  {
    postalCode: 6429,
    city: "Mount Burges",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.852,
    longitude: 121.117,
    accuracy: 4
  },
  {
    postalCode: 6429,
    city: "Wallaroo",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.8763,
    longitude: 120.5734,
    accuracy: 4
  },
  {
    postalCode: 6429,
    city: "Karramindie",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.4493,
    longitude: 120.7804,
    accuracy: 3
  },
  {
    postalCode: 6429,
    city: "Londonderry",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.074,
    longitude: 121.1228,
    accuracy: 4
  },
  {
    postalCode: 6429,
    city: "Victoria Rock",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.4493,
    longitude: 120.7804,
    accuracy: 3
  },
  {
    postalCode: 6429,
    city: "Boorabbin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.214,
    longitude: 120.3101,
    accuracy: 4
  },
  {
    postalCode: 6429,
    city: "Coolgardie",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.9536,
    longitude: 121.166,
    accuracy: 4
  },
  {
    postalCode: 6429,
    city: "Bullabulling",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.0135,
    longitude: 120.871,
    accuracy: 4
  },
  {
    postalCode: 6430,
    city: "Kalgoorlie",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7461,
    longitude: 121.4742,
    accuracy: 4
  },
  {
    postalCode: 6430,
    city: "Karlkurla",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.8326,
    longitude: 121.49,
    accuracy: 3
  },
  {
    postalCode: 6430,
    city: "West Lamington",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7342,
    longitude: 121.4616,
    accuracy: 4
  },
  {
    postalCode: 6430,
    city: "Binduli",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.8326,
    longitude: 121.49,
    accuracy: 3
  },
  {
    postalCode: 6430,
    city: "Mullingar",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7168,
    longitude: 121.4746,
    accuracy: 4
  },
  {
    postalCode: 6430,
    city: "South Kalgoorlie",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.764,
    longitude: 121.48,
    accuracy: 3
  },
  {
    postalCode: 6430,
    city: "Somerville",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7698,
    longitude: 121.4544,
    accuracy: 4
  },
  {
    postalCode: 6430,
    city: "West Kalgoorlie",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.8326,
    longitude: 121.49,
    accuracy: 3
  },
  {
    postalCode: 6430,
    city: "Lamington",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7342,
    longitude: 121.4616,
    accuracy: 4
  },
  {
    postalCode: 6430,
    city: "Broadwood",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7903,
    longitude: 121.4549,
    accuracy: 4
  },
  {
    postalCode: 6430,
    city: "Hannans",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7191,
    longitude: 121.4548,
    accuracy: 4
  },
  {
    postalCode: 6430,
    city: "Yilkari",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.8326,
    longitude: 121.49,
    accuracy: 3
  },
  {
    postalCode: 6430,
    city: "Piccadilly",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7428,
    longitude: 121.4642,
    accuracy: 4
  },
  {
    postalCode: 6430,
    city: "Williamstown",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.75,
    longitude: 121.4833,
    accuracy: 4
  },
  {
    postalCode: 6431,
    city: "Kanowna",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.6117,
    longitude: 121.6074,
    accuracy: 4
  },
  {
    postalCode: 6431,
    city: "Feysville",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7126,
    longitude: 123.8117,
    accuracy: 3
  },
  {
    postalCode: 6431,
    city: "Ora Banda",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.377,
    longitude: 121.0619,
    accuracy: 4
  },
  {
    postalCode: 6431,
    city: "Boorara",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.8167,
    longitude: 121.6333,
    accuracy: 4
  },
  {
    postalCode: 6431,
    city: "Kookynie",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.3317,
    longitude: 121.4925,
    accuracy: 4
  },
  {
    postalCode: 6431,
    city: "Emu Flat",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7126,
    longitude: 123.8117,
    accuracy: 3
  },
  {
    postalCode: 6431,
    city: "Kurnalpi",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.5367,
    longitude: 122.2306,
    accuracy: 4
  },
  {
    postalCode: 6431,
    city: "Lakewood",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.8,
    longitude: 121.5333,
    accuracy: 4
  },
  {
    postalCode: 6431,
    city: "Trafalgar",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7769,
    longitude: 121.5122,
    accuracy: 4
  },
  {
    postalCode: 6431,
    city: "Plumridge Lakes",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7126,
    longitude: 123.8117,
    accuracy: 3
  },
  {
    postalCode: 6431,
    city: "Bulong",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7484,
    longitude: 121.7945,
    accuracy: 4
  },
  {
    postalCode: 6431,
    city: "Brown Hill",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7667,
    longitude: 121.5,
    accuracy: 4
  },
  {
    postalCode: 6431,
    city: "Warburton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.5278,
    longitude: 121.5963,
    accuracy: 3
  },
  {
    postalCode: 6432,
    city: "Boulder",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.782,
    longitude: 121.4912,
    accuracy: 4
  },
  {
    postalCode: 6432,
    city: "Victory Heights",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7788,
    longitude: 121.4726,
    accuracy: 4
  },
  {
    postalCode: 6432,
    city: "Fimiston",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7765,
    longitude: 121.5119,
    accuracy: 3
  },
  {
    postalCode: 6432,
    city: "South Boulder",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7917,
    longitude: 121.4887,
    accuracy: 3
  },
  {
    postalCode: 6433,
    city: "Kalgoorlie",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7461,
    longitude: 121.4742,
    accuracy: 4
  },
  {
    postalCode: 6433,
    city: "Hannans",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7191,
    longitude: 121.4548,
    accuracy: 4
  },
  {
    postalCode: 6433,
    city: "Kalgoorlie Po",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7326,
    longitude: 121.4645,
    accuracy: 3
  },
  {
    postalCode: 6433,
    city: "Kalgoorlie DC",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7326,
    longitude: 121.4645,
    accuracy: 3
  },
  {
    postalCode: 6433,
    city: "Hannans Po",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7326,
    longitude: 121.4645,
    accuracy: 3
  },
  {
    postalCode: 6434,
    city: "Cundeelee",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.0505,
    longitude: 123.2116,
    accuracy: 4
  },
  {
    postalCode: 6434,
    city: "Rawlinna",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.0115,
    longitude: 125.3302,
    accuracy: 4
  },
  {
    postalCode: 6434,
    city: "Parkeston",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.8136,
    longitude: 127.0639,
    accuracy: 3
  },
  {
    postalCode: 6434,
    city: "Forrest",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.851,
    longitude: 128.1,
    accuracy: 4
  },
  {
    postalCode: 6434,
    city: "Zanthus",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.0351,
    longitude: 123.5775,
    accuracy: 4
  },
  {
    postalCode: 6436,
    city: "Ularring",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.5567,
    longitude: 124.3118,
    accuracy: 3
  },
  {
    postalCode: 6436,
    city: "Menzies",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.6939,
    longitude: 121.0285,
    accuracy: 4
  },
  {
    postalCode: 6437,
    city: "Leinster",
    state_name: "Western Australia",
    state: "WA",
    latitude: -27.9203,
    longitude: 120.6967,
    accuracy: 4
  },
  {
    postalCode: 6437,
    city: "Sir Samuel",
    state_name: "Western Australia",
    state: "WA",
    latitude: -27.9168,
    longitude: 120.6938,
    accuracy: 3
  },
  {
    postalCode: 6438,
    city: "Leonora",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.8851,
    longitude: 121.3307,
    accuracy: 4
  },
  {
    postalCode: 6438,
    city: "Lake Darlot",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.1845,
    longitude: 121.8832,
    accuracy: 3
  },
  {
    postalCode: 6440,
    city: "Burtville",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.7706,
    longitude: 122.6428,
    accuracy: 4
  },
  {
    postalCode: 6440,
    city: "Neale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -26.5861,
    longitude: 126.0718,
    accuracy: 3
  },
  {
    postalCode: 6440,
    city: "Laverton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.6253,
    longitude: 122.3994,
    accuracy: 4
  },
  {
    postalCode: 6440,
    city: "Bandya",
    state_name: "Western Australia",
    state: "WA",
    latitude: -26.5861,
    longitude: 126.0718,
    accuracy: 3
  },
  {
    postalCode: 6440,
    city: "Beadell",
    state_name: "Western Australia",
    state: "WA",
    latitude: -26.5861,
    longitude: 126.0718,
    accuracy: 3
  },
  {
    postalCode: 6440,
    city: "Lake Wells",
    state_name: "Western Australia",
    state: "WA",
    latitude: -26.5861,
    longitude: 126.0718,
    accuracy: 3
  },
  {
    postalCode: 6440,
    city: "Cosmo Newbery",
    state_name: "Western Australia",
    state: "WA",
    latitude: -27.9962,
    longitude: 122.8953,
    accuracy: 4
  },
  {
    postalCode: 6442,
    city: "Kambalda West",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.2017,
    longitude: 121.6306,
    accuracy: 4
  },
  {
    postalCode: 6442,
    city: "Kambalda East",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.2017,
    longitude: 121.6507,
    accuracy: 3
  },
  {
    postalCode: 6442,
    city: "Kambalda",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.2017,
    longitude: 121.6708,
    accuracy: 4
  },
  {
    postalCode: 6443,
    city: "Higginsville",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.75,
    longitude: 121.7167,
    accuracy: 4
  },
  {
    postalCode: 6443,
    city: "Norseman",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1977,
    longitude: 121.7787,
    accuracy: 4
  },
  {
    postalCode: 6443,
    city: "Fraser Range",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0134,
    longitude: 124.3774,
    accuracy: 3
  },
  {
    postalCode: 6443,
    city: "Widgiemooltha",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.4959,
    longitude: 121.5787,
    accuracy: 4
  },
  {
    postalCode: 6443,
    city: "Balladonia",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.3458,
    longitude: 123.62,
    accuracy: 4
  },
  {
    postalCode: 6443,
    city: "Madura",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8995,
    longitude: 127.0197,
    accuracy: 4
  },
  {
    postalCode: 6443,
    city: "Dundas",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.3872,
    longitude: 121.7733,
    accuracy: 4
  },
  {
    postalCode: 6443,
    city: "Caiguna",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2734,
    longitude: 125.4939,
    accuracy: 4
  },
  {
    postalCode: 6443,
    city: "Cocklebiddy",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.037,
    longitude: 126.091,
    accuracy: 4
  },
  {
    postalCode: 6443,
    city: "Mundrabilla",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.815,
    longitude: 128.2273,
    accuracy: 4
  },
  {
    postalCode: 6443,
    city: "Eucla",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0134,
    longitude: 124.3774,
    accuracy: 3
  },
  {
    postalCode: 6445,
    city: "North Cascade",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.9695,
    longitude: 121.2179,
    accuracy: 3
  },
  {
    postalCode: 6445,
    city: "Salmon Gums",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.9833,
    longitude: 121.6333,
    accuracy: 4
  },
  {
    postalCode: 6446,
    city: "Grass Patch",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.2317,
    longitude: 121.7222,
    accuracy: 4
  },
  {
    postalCode: 6447,
    city: "Lort River",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.45,
    longitude: 121.7167,
    accuracy: 3
  },
  {
    postalCode: 6447,
    city: "Scaddan",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.4445,
    longitude: 121.731,
    accuracy: 4
  },
  {
    postalCode: 6447,
    city: "Wittenoom Hills",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.45,
    longitude: 121.7167,
    accuracy: 3
  },
  {
    postalCode: 6447,
    city: "Mount Ney",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.45,
    longitude: 121.7167,
    accuracy: 3
  },
  {
    postalCode: 6448,
    city: "Gibson",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.6442,
    longitude: 121.8157,
    accuracy: 4
  },
  {
    postalCode: 6450,
    city: "Chadwick",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8394,
    longitude: 121.8856,
    accuracy: 4
  },
  {
    postalCode: 6450,
    city: "Condingup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7564,
    longitude: 122.5259,
    accuracy: 4
  },
  {
    postalCode: 6450,
    city: "Nulsen",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.857,
    longitude: 121.875,
    accuracy: 4
  },
  {
    postalCode: 6450,
    city: "Coomalbidgup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7194,
    longitude: 121.3606,
    accuracy: 4
  },
  {
    postalCode: 6450,
    city: "Neridup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.2828,
    longitude: 122.5813,
    accuracy: 3
  },
  {
    postalCode: 6450,
    city: "Dalyup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7191,
    longitude: 121.598,
    accuracy: 4
  },
  {
    postalCode: 6450,
    city: "Monjingup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7532,
    longitude: 121.7408,
    accuracy: 3
  },
  {
    postalCode: 6450,
    city: "Merivale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.2828,
    longitude: 122.5813,
    accuracy: 3
  },
  {
    postalCode: 6450,
    city: "Pink Lake",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8516,
    longitude: 121.8593,
    accuracy: 4
  },
  {
    postalCode: 6450,
    city: "Munglinup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.2828,
    longitude: 122.5813,
    accuracy: 3
  },
  {
    postalCode: 6450,
    city: "Windabout",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8192,
    longitude: 121.9204,
    accuracy: 3
  },
  {
    postalCode: 6450,
    city: "Esperance",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8592,
    longitude: 121.8916,
    accuracy: 4
  },
  {
    postalCode: 6450,
    city: "Castletown",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8324,
    longitude: 121.9156,
    accuracy: 4
  },
  {
    postalCode: 6450,
    city: "Bandy Creek",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8278,
    longitude: 121.9281,
    accuracy: 4
  },
  {
    postalCode: 6450,
    city: "West Beach",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8746,
    longitude: 121.8901,
    accuracy: 4
  },
  {
    postalCode: 6450,
    city: "Myrup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.7911,
    longitude: 121.9242,
    accuracy: 3
  },
  {
    postalCode: 6450,
    city: "Cascade",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.2828,
    longitude: 122.5813,
    accuracy: 3
  },
  {
    postalCode: 6450,
    city: "Cape Le Grand",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.2828,
    longitude: 122.5813,
    accuracy: 3
  },
  {
    postalCode: 6450,
    city: "Boyatup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.2828,
    longitude: 122.5813,
    accuracy: 3
  },
  {
    postalCode: 6450,
    city: "Beaumont",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.2828,
    longitude: 122.5813,
    accuracy: 3
  },
  {
    postalCode: 6450,
    city: "Howick",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.2828,
    longitude: 122.5813,
    accuracy: 3
  },
  {
    postalCode: 6450,
    city: "Sinclair",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8623,
    longitude: 121.8723,
    accuracy: 3
  },
  {
    postalCode: 6450,
    city: "East Munglinup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.2828,
    longitude: 122.5813,
    accuracy: 3
  },
  {
    postalCode: 6452,
    city: "Cape Arid",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8667,
    longitude: 121.9,
    accuracy: 1
  },
  {
    postalCode: 6452,
    city: "Israelite Bay",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8667,
    longitude: 121.9,
    accuracy: 1
  },
  {
    postalCode: 6452,
    city: "Buraminya",
    state_name: "Western Australia",
    state: "WA",
    latitude: -33.8667,
    longitude: 121.9,
    accuracy: 1
  },
  {
    postalCode: 6460,
    city: "Ucarty West",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.215,
    longitude: 116.7035,
    accuracy: 3
  },
  {
    postalCode: 6460,
    city: "Goomalling",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.3016,
    longitude: 116.8253,
    accuracy: 4
  },
  {
    postalCode: 6460,
    city: "Karranadgin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.2333,
    longitude: 116.75,
    accuracy: 4
  },
  {
    postalCode: 6460,
    city: "Walyormouring",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.215,
    longitude: 116.7035,
    accuracy: 3
  },
  {
    postalCode: 6460,
    city: "Hulongine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.215,
    longitude: 116.7035,
    accuracy: 3
  },
  {
    postalCode: 6461,
    city: "Dowerin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.1937,
    longitude: 117.0396,
    accuracy: 4
  },
  {
    postalCode: 6461,
    city: "Koomberkine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.1,
    longitude: 117.0333,
    accuracy: 4
  },
  {
    postalCode: 6462,
    city: "Minnivale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.1383,
    longitude: 117.1809,
    accuracy: 4
  },
  {
    postalCode: 6462,
    city: "Ucarty",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.9957,
    longitude: 117.1834,
    accuracy: 3
  },
  {
    postalCode: 6462,
    city: "Hindmarsh",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.9957,
    longitude: 117.1834,
    accuracy: 3
  },
  {
    postalCode: 6463,
    city: "Benjaberring",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.1471,
    longitude: 117.4098,
    accuracy: 1
  },
  {
    postalCode: 6465,
    city: "Manmanning",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.8486,
    longitude: 117.0977,
    accuracy: 4
  },
  {
    postalCode: 6466,
    city: "Cadoux",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7694,
    longitude: 117.1328,
    accuracy: 4
  },
  {
    postalCode: 6467,
    city: "Burakin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.5246,
    longitude: 117.1769,
    accuracy: 4
  },
  {
    postalCode: 6468,
    city: "Petrudor",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.0614,
    longitude: 117.2011,
    accuracy: 3
  },
  {
    postalCode: 6468,
    city: "Kalannie",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.3625,
    longitude: 117.1181,
    accuracy: 4
  },
  {
    postalCode: 6468,
    city: "Goodlands",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.0614,
    longitude: 117.2011,
    accuracy: 3
  },
  {
    postalCode: 6470,
    city: "Kulja",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.4854,
    longitude: 117.2775,
    accuracy: 4
  },
  {
    postalCode: 6472,
    city: "Tampu",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.4333,
    longitude: 117.7417,
    accuracy: 3
  },
  {
    postalCode: 6472,
    city: "Remlap",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.0362,
    longitude: 117.9778,
    accuracy: 3
  },
  {
    postalCode: 6472,
    city: "Cleary",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.4364,
    longitude: 117.6438,
    accuracy: 4
  },
  {
    postalCode: 6472,
    city: "Karroun Hill",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.0362,
    longitude: 117.9778,
    accuracy: 3
  },
  {
    postalCode: 6472,
    city: "Mouroubra",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.8015,
    longitude: 117.7043,
    accuracy: 4
  },
  {
    postalCode: 6472,
    city: "Bimbijy",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.0362,
    longitude: 117.9778,
    accuracy: 3
  },
  {
    postalCode: 6472,
    city: "Beacon",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.4485,
    longitude: 117.863,
    accuracy: 4
  },
  {
    postalCode: 6473,
    city: "North Wialki",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.5744,
    longitude: 118.0118,
    accuracy: 3
  },
  {
    postalCode: 6473,
    city: "Wialki",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.478,
    longitude: 118.12,
    accuracy: 4
  },
  {
    postalCode: 6475,
    city: "Koorda",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.8256,
    longitude: 117.4879,
    accuracy: 4
  },
  {
    postalCode: 6475,
    city: "Badgerin Rock",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.4589,
    longitude: 117.4554,
    accuracy: 3
  },
  {
    postalCode: 6475,
    city: "Mollerin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.455,
    longitude: 117.5256,
    accuracy: 4
  },
  {
    postalCode: 6475,
    city: "Booralaming",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.4589,
    longitude: 117.4554,
    accuracy: 3
  },
  {
    postalCode: 6475,
    city: "Dukin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.9404,
    longitude: 117.4303,
    accuracy: 4
  },
  {
    postalCode: 6475,
    city: "Newcarlbeon",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.4589,
    longitude: 117.4554,
    accuracy: 3
  },
  {
    postalCode: 6475,
    city: "Lake Margarette",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.4589,
    longitude: 117.4554,
    accuracy: 3
  },
  {
    postalCode: 6476,
    city: "Gabbin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.8011,
    longitude: 117.6788,
    accuracy: 4
  },
  {
    postalCode: 6477,
    city: "Bencubbin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.8161,
    longitude: 117.8614,
    accuracy: 4
  },
  {
    postalCode: 6477,
    city: "Welbungin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.8285,
    longitude: 117.9886,
    accuracy: 4
  },
  {
    postalCode: 6479,
    city: "Lake Brown",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.95,
    longitude: 118.3333,
    accuracy: 4
  },
  {
    postalCode: 6479,
    city: "Dandanning",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7281,
    longitude: 118.3019,
    accuracy: 3
  },
  {
    postalCode: 6479,
    city: "Barbalin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7281,
    longitude: 118.3019,
    accuracy: 3
  },
  {
    postalCode: 6479,
    city: "Mukinbudin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.9141,
    longitude: 118.2078,
    accuracy: 4
  },
  {
    postalCode: 6479,
    city: "Karloning",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7281,
    longitude: 118.3019,
    accuracy: 3
  },
  {
    postalCode: 6479,
    city: "Wattoning",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7281,
    longitude: 118.3019,
    accuracy: 3
  },
  {
    postalCode: 6479,
    city: "Elachbutting",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7281,
    longitude: 118.3019,
    accuracy: 3
  },
  {
    postalCode: 6479,
    city: "Bonnie Rock",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.5408,
    longitude: 118.3649,
    accuracy: 4
  },
  {
    postalCode: 6479,
    city: "Wilgoyne",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7281,
    longitude: 118.3019,
    accuracy: 3
  },
  {
    postalCode: 6480,
    city: "Nukarni",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.2833,
    longitude: 118.2,
    accuracy: 4
  },
  {
    postalCode: 6484,
    city: "Ennuin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.9847,
    longitude: 119.1143,
    accuracy: 3
  },
  {
    postalCode: 6484,
    city: "Bullfinch",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.9842,
    longitude: 119.1085,
    accuracy: 4
  },
  {
    postalCode: 6484,
    city: "Lake Deborah",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.9847,
    longitude: 119.1143,
    accuracy: 3
  },
  {
    postalCode: 6485,
    city: "Korrelocking",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.2037,
    longitude: 117.4709,
    accuracy: 4
  },
  {
    postalCode: 6485,
    city: "Wyalkatchem",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.1806,
    longitude: 117.3836,
    accuracy: 4
  },
  {
    postalCode: 6485,
    city: "Cowcowing",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.9983,
    longitude: 117.4497,
    accuracy: 4
  },
  {
    postalCode: 6485,
    city: "Nalkain",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.0504,
    longitude: 117.4197,
    accuracy: 4
  },
  {
    postalCode: 6485,
    city: "Nembudding",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.1949,
    longitude: 117.5737,
    accuracy: 4
  },
  {
    postalCode: 6487,
    city: "Yelbeni",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.1703,
    longitude: 117.6607,
    accuracy: 4
  },
  {
    postalCode: 6487,
    city: "South Yelbeni",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.2399,
    longitude: 117.7926,
    accuracy: 3
  },
  {
    postalCode: 6487,
    city: "North Yelbeni",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.2399,
    longitude: 117.7926,
    accuracy: 3
  },
  {
    postalCode: 6488,
    city: "Trayning",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.1169,
    longitude: 117.7935,
    accuracy: 4
  },
  {
    postalCode: 6488,
    city: "South Trayning",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.2328,
    longitude: 117.7928,
    accuracy: 4
  },
  {
    postalCode: 6488,
    city: "North Trayning",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.1117,
    longitude: 117.7921,
    accuracy: 3
  },
  {
    postalCode: 6489,
    city: "North Kununoppin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.043,
    longitude: 117.8218,
    accuracy: 3
  },
  {
    postalCode: 6489,
    city: "South Kununoppin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.043,
    longitude: 117.8218,
    accuracy: 3
  },
  {
    postalCode: 6489,
    city: "Kununoppin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.1117,
    longitude: 117.9179,
    accuracy: 4
  },
  {
    postalCode: 6490,
    city: "Elabbin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.2312,
    longitude: 118.1443,
    accuracy: 4
  },
  {
    postalCode: 6490,
    city: "Nungarin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.1864,
    longitude: 118.104,
    accuracy: 4
  },
  {
    postalCode: 6490,
    city: "Chandler",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.253,
    longitude: 118.0448,
    accuracy: 3
  },
  {
    postalCode: 6490,
    city: "Burran Rock",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.2553,
    longitude: 117.9989,
    accuracy: 4
  },
  {
    postalCode: 6490,
    city: "Kwelkan",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.1447,
    longitude: 117.9956,
    accuracy: 4
  },
  {
    postalCode: 6490,
    city: "Talgomine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.253,
    longitude: 118.0448,
    accuracy: 3
  },
  {
    postalCode: 6501,
    city: "Muchea",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.5821,
    longitude: 115.9716,
    accuracy: 4
  },
  {
    postalCode: 6502,
    city: "Bindoon",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.3866,
    longitude: 116.0966,
    accuracy: 4
  },
  {
    postalCode: 6502,
    city: "Bindoon Training Area",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.3894,
    longitude: 116.0789,
    accuracy: 3
  },
  {
    postalCode: 6503,
    city: "Cullalla",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.2044,
    longitude: 115.7501,
    accuracy: 3
  },
  {
    postalCode: 6503,
    city: "Gingin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.3472,
    longitude: 115.9043,
    accuracy: 4
  },
  {
    postalCode: 6503,
    city: "Wanerie",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.1985,
    longitude: 115.4117,
    accuracy: 4
  },
  {
    postalCode: 6503,
    city: "Coonabidgee",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.2044,
    longitude: 115.7501,
    accuracy: 3
  },
  {
    postalCode: 6503,
    city: "Yeal",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.2044,
    longitude: 115.7501,
    accuracy: 3
  },
  {
    postalCode: 6503,
    city: "Granville",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.2044,
    longitude: 115.7501,
    accuracy: 3
  },
  {
    postalCode: 6503,
    city: "Orange Springs",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.2044,
    longitude: 115.7501,
    accuracy: 3
  },
  {
    postalCode: 6503,
    city: "Cowalla",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.2044,
    longitude: 115.7501,
    accuracy: 3
  },
  {
    postalCode: 6503,
    city: "Bambun",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.2044,
    longitude: 115.7501,
    accuracy: 3
  },
  {
    postalCode: 6503,
    city: "Breera",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.2044,
    longitude: 115.7501,
    accuracy: 3
  },
  {
    postalCode: 6503,
    city: "Moondah",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.2044,
    longitude: 115.7501,
    accuracy: 3
  },
  {
    postalCode: 6503,
    city: "Moore River National Park",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.2044,
    longitude: 115.7501,
    accuracy: 3
  },
  {
    postalCode: 6503,
    city: "Mindarra",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.2044,
    longitude: 115.7501,
    accuracy: 3
  },
  {
    postalCode: 6503,
    city: "Boonanarring",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.2044,
    longitude: 115.7501,
    accuracy: 3
  },
  {
    postalCode: 6503,
    city: "Red Gully",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.2044,
    longitude: 115.7501,
    accuracy: 3
  },
  {
    postalCode: 6503,
    city: "Beermullah",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.2044,
    longitude: 115.7501,
    accuracy: 3
  },
  {
    postalCode: 6503,
    city: "Ginginup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.3178,
    longitude: 115.9083,
    accuracy: 3
  },
  {
    postalCode: 6503,
    city: "Muckenburra",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.3347,
    longitude: 115.7819,
    accuracy: 3
  },
  {
    postalCode: 6503,
    city: "Neergabby",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.2995,
    longitude: 115.6374,
    accuracy: 3
  },
  {
    postalCode: 6503,
    city: "Lennard Brook",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.2044,
    longitude: 115.7501,
    accuracy: 3
  },
  {
    postalCode: 6504,
    city: "Mooliabeenee",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.3303,
    longitude: 116.0212,
    accuracy: 4
  },
  {
    postalCode: 6505,
    city: "Wannamal",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.1597,
    longitude: 116.056,
    accuracy: 4
  },
  {
    postalCode: 6506,
    city: "Mogumber",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.0403,
    longitude: 116.0425,
    accuracy: 4
  },
  {
    postalCode: 6507,
    city: "Dandaragan",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.6762,
    longitude: 115.7029,
    accuracy: 4
  },
  {
    postalCode: 6507,
    city: "Cooljarloo",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7317,
    longitude: 115.5874,
    accuracy: 3
  },
  {
    postalCode: 6507,
    city: "Cataby",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7317,
    longitude: 115.5874,
    accuracy: 3
  },
  {
    postalCode: 6507,
    city: "Yathroo",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7317,
    longitude: 115.5874,
    accuracy: 3
  },
  {
    postalCode: 6507,
    city: "Mimegarra",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7317,
    longitude: 115.5874,
    accuracy: 3
  },
  {
    postalCode: 6507,
    city: "Regans Ford",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7317,
    longitude: 115.5874,
    accuracy: 3
  },
  {
    postalCode: 6509,
    city: "New Norcia",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.9706,
    longitude: 116.2125,
    accuracy: 4
  },
  {
    postalCode: 6509,
    city: "Waddington",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.85,
    longitude: 116.25,
    accuracy: 4
  },
  {
    postalCode: 6509,
    city: "Yarawindah",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.9083,
    longitude: 116.2333,
    accuracy: 3
  },
  {
    postalCode: 6509,
    city: "Glentromie",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.9083,
    longitude: 116.2333,
    accuracy: 3
  },
  {
    postalCode: 6510,
    city: "Gillingarra",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.9378,
    longitude: 116.0495,
    accuracy: 4
  },
  {
    postalCode: 6510,
    city: "Barberton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7274,
    longitude: 116.0258,
    accuracy: 4
  },
  {
    postalCode: 6510,
    city: "Moora",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.64,
    longitude: 116.0036,
    accuracy: 4
  },
  {
    postalCode: 6510,
    city: "Berkshire Valley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.55,
    longitude: 116.1667,
    accuracy: 4
  },
  {
    postalCode: 6510,
    city: "Koojan",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.805,
    longitude: 116.0283,
    accuracy: 4
  },
  {
    postalCode: 6510,
    city: "Walebing",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.6945,
    longitude: 116.2148,
    accuracy: 4
  },
  {
    postalCode: 6511,
    city: "Cervantes",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.4961,
    longitude: 115.0672,
    accuracy: 4
  },
  {
    postalCode: 6512,
    city: "Coomberdale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.4633,
    longitude: 116.0393,
    accuracy: 4
  },
  {
    postalCode: 6512,
    city: "Namban",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.3803,
    longitude: 116.046,
    accuracy: 4
  },
  {
    postalCode: 6513,
    city: "Gunyidi",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.3585,
    longitude: 116.02,
    accuracy: 3
  },
  {
    postalCode: 6513,
    city: "Watheroo",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.2976,
    longitude: 116.0572,
    accuracy: 4
  },
  {
    postalCode: 6514,
    city: "Green Head",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.0677,
    longitude: 114.968,
    accuracy: 4
  },
  {
    postalCode: 6514,
    city: "Leeman",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.9494,
    longitude: 114.9821,
    accuracy: 4
  },
  {
    postalCode: 6515,
    city: "Waddy Forest",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.0217,
    longitude: 115.7621,
    accuracy: 3
  },
  {
    postalCode: 6515,
    city: "Coorow",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.8819,
    longitude: 116.0226,
    accuracy: 4
  },
  {
    postalCode: 6515,
    city: "Marchagee",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.0543,
    longitude: 116.074,
    accuracy: 4
  },
  {
    postalCode: 6515,
    city: "Eganu",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.0217,
    longitude: 115.7621,
    accuracy: 3
  },
  {
    postalCode: 6516,
    city: "Jurien Bay",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.3059,
    longitude: 115.0383,
    accuracy: 4
  },
  {
    postalCode: 6517,
    city: "Winchester",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.7737,
    longitude: 115.9273,
    accuracy: 4
  },
  {
    postalCode: 6517,
    city: "Carnamah",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.6887,
    longitude: 115.8859,
    accuracy: 4
  },
  {
    postalCode: 6518,
    city: "Warradarge",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.8242,
    longitude: 115.2604,
    accuracy: 3
  },
  {
    postalCode: 6518,
    city: "Eneabba",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.8196,
    longitude: 115.2659,
    accuracy: 4
  },
  {
    postalCode: 6519,
    city: "Three Springs",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.5336,
    longitude: 115.7605,
    accuracy: 4
  },
  {
    postalCode: 6519,
    city: "Arrino",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.4435,
    longitude: 115.63,
    accuracy: 4
  },
  {
    postalCode: 6519,
    city: "Womarden",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.5254,
    longitude: 115.5772,
    accuracy: 3
  },
  {
    postalCode: 6519,
    city: "Arrowsmith East",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.5254,
    longitude: 115.5772,
    accuracy: 3
  },
  {
    postalCode: 6519,
    city: "Kadathinni",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.5254,
    longitude: 115.5772,
    accuracy: 3
  },
  {
    postalCode: 6519,
    city: "Dudawa",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.3861,
    longitude: 115.7353,
    accuracy: 4
  },
  {
    postalCode: 6521,
    city: "Nambung",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.3427,
    longitude: 115.662,
    accuracy: 1
  },
  {
    postalCode: 6521,
    city: "Badgingarra",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.3427,
    longitude: 115.662,
    accuracy: 1
  },
  {
    postalCode: 6521,
    city: "Boothendarra",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.3427,
    longitude: 115.662,
    accuracy: 1
  },
  {
    postalCode: 6521,
    city: "Grey",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.3427,
    longitude: 115.662,
    accuracy: 1
  },
  {
    postalCode: 6521,
    city: "Hill River",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.3427,
    longitude: 115.662,
    accuracy: 1
  },
  {
    postalCode: 6522,
    city: "Yandanooka",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.3121,
    longitude: 115.5686,
    accuracy: 4
  },
  {
    postalCode: 6522,
    city: "Bundanoon",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.1579,
    longitude: 115.4843,
    accuracy: 3
  },
  {
    postalCode: 6522,
    city: "Mingenew",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.1908,
    longitude: 115.4416,
    accuracy: 4
  },
  {
    postalCode: 6522,
    city: "Holmwood",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.1579,
    longitude: 115.4843,
    accuracy: 3
  },
  {
    postalCode: 6522,
    city: "Yarragadee",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.1579,
    longitude: 115.4843,
    accuracy: 3
  },
  {
    postalCode: 6522,
    city: "Lockier",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.1579,
    longitude: 115.4843,
    accuracy: 3
  },
  {
    postalCode: 6522,
    city: "Nangetty",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.1579,
    longitude: 115.4843,
    accuracy: 3
  },
  {
    postalCode: 6522,
    city: "Mooriary",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.1579,
    longitude: 115.4843,
    accuracy: 3
  },
  {
    postalCode: 6522,
    city: "Mount Budd",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.1579,
    longitude: 115.4843,
    accuracy: 3
  },
  {
    postalCode: 6522,
    city: "Ikewa",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.1579,
    longitude: 115.4843,
    accuracy: 3
  },
  {
    postalCode: 6525,
    city: "Irwin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.2204,
    longitude: 115.0801,
    accuracy: 4
  },
  {
    postalCode: 6525,
    city: "Port Denison",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.2833,
    longitude: 114.9167,
    accuracy: 4
  },
  {
    postalCode: 6525,
    city: "Dongara",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.2582,
    longitude: 114.9328,
    accuracy: 4
  },
  {
    postalCode: 6525,
    city: "Allanooka",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.3265,
    longitude: 115.0917,
    accuracy: 3
  },
  {
    postalCode: 6525,
    city: "Mount Adams",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.3265,
    longitude: 115.0917,
    accuracy: 3
  },
  {
    postalCode: 6525,
    city: "Milo",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.3265,
    longitude: 115.0917,
    accuracy: 3
  },
  {
    postalCode: 6525,
    city: "Bookara",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.3265,
    longitude: 115.0917,
    accuracy: 3
  },
  {
    postalCode: 6525,
    city: "Yardarino",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.3265,
    longitude: 115.0917,
    accuracy: 3
  },
  {
    postalCode: 6525,
    city: "Arrowsmith",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.3265,
    longitude: 115.0917,
    accuracy: 3
  },
  {
    postalCode: 6525,
    city: "Mount Horner",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.3265,
    longitude: 115.0917,
    accuracy: 3
  },
  {
    postalCode: 6525,
    city: "Springfield",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.3265,
    longitude: 115.0917,
    accuracy: 3
  },
  {
    postalCode: 6525,
    city: "Bonniefield",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.2058,
    longitude: 114.9392,
    accuracy: 3
  },
  {
    postalCode: 6528,
    city: "South Greenough",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.9269,
    longitude: 114.8997,
    accuracy: 3
  },
  {
    postalCode: 6528,
    city: "Walkaway",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.9412,
    longitude: 114.8031,
    accuracy: 4
  },
  {
    postalCode: 6528,
    city: "Mount Hill",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.9269,
    longitude: 114.8997,
    accuracy: 3
  },
  {
    postalCode: 6530,
    city: "Tarcoola Beach",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.81,
    longitude: 114.6224,
    accuracy: 4
  },
  {
    postalCode: 6530,
    city: "Strathalbyn",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.7517,
    longitude: 114.6458,
    accuracy: 4
  },
  {
    postalCode: 6530,
    city: "Woorree",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.7668,
    longitude: 114.6581,
    accuracy: 4
  },
  {
    postalCode: 6530,
    city: "Wandina",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.8194,
    longitude: 114.6346,
    accuracy: 4
  },
  {
    postalCode: 6530,
    city: "Rangeway",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.7866,
    longitude: 114.6306,
    accuracy: 4
  },
  {
    postalCode: 6530,
    city: "Waggrakine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.7188,
    longitude: 114.6392,
    accuracy: 4
  },
  {
    postalCode: 6530,
    city: "Karloo",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.791,
    longitude: 114.6411,
    accuracy: 4
  },
  {
    postalCode: 6530,
    city: "Beresford",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.7575,
    longitude: 114.6196,
    accuracy: 4
  },
  {
    postalCode: 6530,
    city: "Utakarra",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.7833,
    longitude: 114.65,
    accuracy: 4
  },
  {
    postalCode: 6530,
    city: "Sunset Beach",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.7191,
    longitude: 114.623,
    accuracy: 4
  },
  {
    postalCode: 6530,
    city: "Webberton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.7524,
    longitude: 114.6322,
    accuracy: 4
  },
  {
    postalCode: 6530,
    city: "West End",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.7817,
    longitude: 114.5793,
    accuracy: 4
  },
  {
    postalCode: 6530,
    city: "Beachlands",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.7857,
    longitude: 114.6019,
    accuracy: 4
  },
  {
    postalCode: 6530,
    city: "Spalding",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.7352,
    longitude: 114.6365,
    accuracy: 4
  },
  {
    postalCode: 6530,
    city: "Houtman Abrolhos",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.5586,
    longitude: 113.7584,
    accuracy: 4
  },
  {
    postalCode: 6530,
    city: "Bluff Point",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.7374,
    longitude: 114.6228,
    accuracy: 4
  },
  {
    postalCode: 6530,
    city: "Meru",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.8033,
    longitude: 114.6864,
    accuracy: 4
  },
  {
    postalCode: 6530,
    city: "Moresby",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.7352,
    longitude: 114.6724,
    accuracy: 4
  },
  {
    postalCode: 6530,
    city: "Wonthella",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.7669,
    longitude: 114.6334,
    accuracy: 4
  },
  {
    postalCode: 6530,
    city: "Mahomets Flats",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.792,
    longitude: 114.6133,
    accuracy: 4
  },
  {
    postalCode: 6530,
    city: "Mount Tarcoola",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.7986,
    longitude: 114.6253,
    accuracy: 4
  },
  {
    postalCode: 6530,
    city: "Geraldton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.779,
    longitude: 114.6146,
    accuracy: 4
  },
  {
    postalCode: 6531,
    city: "Geraldton Po",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.779,
    longitude: 114.6146,
    accuracy: 3
  },
  {
    postalCode: 6531,
    city: "Geraldton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.779,
    longitude: 114.6146,
    accuracy: 4
  },
  {
    postalCode: 6532,
    city: "Meadow",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.4972,
    longitude: 115.7533,
    accuracy: 4
  },
  {
    postalCode: 6532,
    city: "Ajana",
    state_name: "Western Australia",
    state: "WA",
    latitude: -27.9558,
    longitude: 114.6302,
    accuracy: 4
  },
  {
    postalCode: 6532,
    city: "Wandana",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.3989,
    longitude: 115.0313,
    accuracy: 3
  },
  {
    postalCode: 6532,
    city: "Drummond Cove",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.6738,
    longitude: 114.6128,
    accuracy: 4
  },
  {
    postalCode: 6532,
    city: "Eradu South",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.3989,
    longitude: 115.0313,
    accuracy: 3
  },
  {
    postalCode: 6532,
    city: "Rudds Gully",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.8355,
    longitude: 114.6416,
    accuracy: 4
  },
  {
    postalCode: 6532,
    city: "Yuna",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.3333,
    longitude: 115,
    accuracy: 4
  },
  {
    postalCode: 6532,
    city: "Yetna",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.6102,
    longitude: 114.6989,
    accuracy: 4
  },
  {
    postalCode: 6532,
    city: "Coburn",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.5613,
    longitude: 114.747,
    accuracy: 3
  },
  {
    postalCode: 6532,
    city: "Moonyoonooka",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.781,
    longitude: 114.727,
    accuracy: 4
  },
  {
    postalCode: 6532,
    city: "Deepdale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.7864,
    longitude: 114.6951,
    accuracy: 4
  },
  {
    postalCode: 6532,
    city: "Tamala",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7061,
    longitude: 115.7201,
    accuracy: 4
  },
  {
    postalCode: 6532,
    city: "Sandsprings",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.3989,
    longitude: 115.0313,
    accuracy: 3
  },
  {
    postalCode: 6532,
    city: "Glenfield",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.6925,
    longitude: 114.6214,
    accuracy: 4
  },
  {
    postalCode: 6532,
    city: "Northern Gully",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.7138,
    longitude: 114.9087,
    accuracy: 4
  },
  {
    postalCode: 6532,
    city: "Nabawa",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.4995,
    longitude: 114.7968,
    accuracy: 4
  },
  {
    postalCode: 6532,
    city: "Rockwell",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.346,
    longitude: 114.925,
    accuracy: 4
  },
  {
    postalCode: 6532,
    city: "Narngulu",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.8205,
    longitude: 114.6925,
    accuracy: 4
  },
  {
    postalCode: 6532,
    city: "Nerren Nerren",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.5613,
    longitude: 114.747,
    accuracy: 3
  },
  {
    postalCode: 6532,
    city: "Kojarena",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.7224,
    longitude: 114.8656,
    accuracy: 4
  },
  {
    postalCode: 6532,
    city: "Durawah",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.3989,
    longitude: 115.0313,
    accuracy: 3
  },
  {
    postalCode: 6532,
    city: "Oakajee",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.5697,
    longitude: 114.631,
    accuracy: 4
  },
  {
    postalCode: 6532,
    city: "Nolba",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.3667,
    longitude: 114.8667,
    accuracy: 4
  },
  {
    postalCode: 6532,
    city: "Georgina",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.8775,
    longitude: 114.7536,
    accuracy: 4
  },
  {
    postalCode: 6532,
    city: "Narra Tarra",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.7,
    longitude: 114.7167,
    accuracy: 4
  },
  {
    postalCode: 6532,
    city: "Bootenal",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.8558,
    longitude: 114.7275,
    accuracy: 4
  },
  {
    postalCode: 6532,
    city: "Toolonga",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.5613,
    longitude: 114.747,
    accuracy: 3
  },
  {
    postalCode: 6532,
    city: "Dindiloa",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.4307,
    longitude: 114.7895,
    accuracy: 4
  },
  {
    postalCode: 6532,
    city: "Binnu",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.0424,
    longitude: 114.678,
    accuracy: 4
  },
  {
    postalCode: 6532,
    city: "Naraling",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.4,
    longitude: 114.8333,
    accuracy: 4
  },
  {
    postalCode: 6532,
    city: "Howatharra",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.5333,
    longitude: 114.6167,
    accuracy: 4
  },
  {
    postalCode: 6532,
    city: "Cape Burney",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.8675,
    longitude: 114.6489,
    accuracy: 4
  },
  {
    postalCode: 6532,
    city: "Coolcalalaya",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.3989,
    longitude: 115.0313,
    accuracy: 3
  },
  {
    postalCode: 6532,
    city: "Greenough",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.95,
    longitude: 114.7333,
    accuracy: 4
  },
  {
    postalCode: 6532,
    city: "Bringo",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.7491,
    longitude: 114.8439,
    accuracy: 4
  },
  {
    postalCode: 6532,
    city: "Wicherina",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.7178,
    longitude: 115.0144,
    accuracy: 4
  },
  {
    postalCode: 6532,
    city: "Mount Erin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.3989,
    longitude: 115.0313,
    accuracy: 3
  },
  {
    postalCode: 6532,
    city: "Nanson",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.5788,
    longitude: 114.7545,
    accuracy: 4
  },
  {
    postalCode: 6532,
    city: "Wicherina South",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.3989,
    longitude: 115.0313,
    accuracy: 3
  },
  {
    postalCode: 6532,
    city: "West Binnu",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.0424,
    longitude: 114.678,
    accuracy: 4
  },
  {
    postalCode: 6532,
    city: "South Yuna",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.3989,
    longitude: 115.0313,
    accuracy: 3
  },
  {
    postalCode: 6532,
    city: "North Eradu",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.3989,
    longitude: 115.0313,
    accuracy: 3
  },
  {
    postalCode: 6532,
    city: "Carrarang",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.5613,
    longitude: 114.747,
    accuracy: 3
  },
  {
    postalCode: 6532,
    city: "Valentine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.3989,
    longitude: 115.0313,
    accuracy: 3
  },
  {
    postalCode: 6532,
    city: "Dartmoor",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.3989,
    longitude: 115.0313,
    accuracy: 3
  },
  {
    postalCode: 6532,
    city: "Ellendale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.3989,
    longitude: 115.0313,
    accuracy: 3
  },
  {
    postalCode: 6532,
    city: "East Chapman",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.3989,
    longitude: 115.0313,
    accuracy: 3
  },
  {
    postalCode: 6532,
    city: "White Peak",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.6359,
    longitude: 114.6434,
    accuracy: 3
  },
  {
    postalCode: 6532,
    city: "Eradu",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.3989,
    longitude: 115.0313,
    accuracy: 3
  },
  {
    postalCode: 6532,
    city: "Hickety",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.3989,
    longitude: 115.0313,
    accuracy: 3
  },
  {
    postalCode: 6532,
    city: "Minnenooka",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.8244,
    longitude: 114.9003,
    accuracy: 3
  },
  {
    postalCode: 6532,
    city: "Hamelin Pool",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.3989,
    longitude: 115.0313,
    accuracy: 3
  },
  {
    postalCode: 6532,
    city: "Marrah",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.3989,
    longitude: 115.0313,
    accuracy: 3
  },
  {
    postalCode: 6532,
    city: "Eurardy",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.3989,
    longitude: 115.0313,
    accuracy: 3
  },
  {
    postalCode: 6532,
    city: "Burma Road",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.3989,
    longitude: 115.0313,
    accuracy: 3
  },
  {
    postalCode: 6532,
    city: "Tibradden",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.3989,
    longitude: 115.0313,
    accuracy: 3
  },
  {
    postalCode: 6532,
    city: "East Yuna",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.3989,
    longitude: 115.0313,
    accuracy: 3
  },
  {
    postalCode: 6532,
    city: "Buller",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.3989,
    longitude: 115.0313,
    accuracy: 3
  },
  {
    postalCode: 6532,
    city: "East Nabawa",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.3989,
    longitude: 115.0313,
    accuracy: 3
  },
  {
    postalCode: 6535,
    city: "Ogilvie",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.15,
    longitude: 114.6333,
    accuracy: 4
  },
  {
    postalCode: 6535,
    city: "Horrocks",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.3861,
    longitude: 114.43,
    accuracy: 4
  },
  {
    postalCode: 6535,
    city: "Isseka",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.4333,
    longitude: 114.6333,
    accuracy: 4
  },
  {
    postalCode: 6535,
    city: "Yallabatharra",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.1311,
    longitude: 114.3442,
    accuracy: 3
  },
  {
    postalCode: 6535,
    city: "Gregory",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.1865,
    longitude: 114.2533,
    accuracy: 4
  },
  {
    postalCode: 6535,
    city: "Bowes",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.3833,
    longitude: 114.6667,
    accuracy: 4
  },
  {
    postalCode: 6535,
    city: "Northampton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.3499,
    longitude: 114.6382,
    accuracy: 4
  },
  {
    postalCode: 6535,
    city: "Alma",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.0013,
    longitude: 114.8555,
    accuracy: 3
  },
  {
    postalCode: 6535,
    city: "East Bowes",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.0013,
    longitude: 114.8555,
    accuracy: 3
  },
  {
    postalCode: 6535,
    city: "Sandy Gully",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.0013,
    longitude: 114.8555,
    accuracy: 3
  },
  {
    postalCode: 6536,
    city: "Zuytdorp",
    state_name: "Western Australia",
    state: "WA",
    latitude: -27.6034,
    longitude: 114.5223,
    accuracy: 3
  },
  {
    postalCode: 6536,
    city: "Kalbarri",
    state_name: "Western Australia",
    state: "WA",
    latitude: -27.7105,
    longitude: 114.165,
    accuracy: 4
  },
  {
    postalCode: 6536,
    city: "Kalbarri National Park",
    state_name: "Western Australia",
    state: "WA",
    latitude: -27.6034,
    longitude: 114.5223,
    accuracy: 3
  },
  {
    postalCode: 6537,
    city: "Denham",
    state_name: "Western Australia",
    state: "WA",
    latitude: -25.9287,
    longitude: 113.5355,
    accuracy: 4
  },
  {
    postalCode: 6537,
    city: "Monkey Mia",
    state_name: "Western Australia",
    state: "WA",
    latitude: -25.794,
    longitude: 113.718,
    accuracy: 4
  },
  {
    postalCode: 6537,
    city: "Francois Peron National Park",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.8167,
    longitude: 116.0667,
    accuracy: 3
  },
  {
    postalCode: 6537,
    city: "Dirk Hartog Island",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.8167,
    longitude: 116.0667,
    accuracy: 3
  },
  {
    postalCode: 6537,
    city: "Nanga",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.8167,
    longitude: 116.0667,
    accuracy: 3
  },
  {
    postalCode: 6537,
    city: "Shark Bay",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.8167,
    longitude: 116.0667,
    accuracy: 3
  },
  {
    postalCode: 6537,
    city: "Useless Loop",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.8167,
    longitude: 116.0667,
    accuracy: 3
  },
  {
    postalCode: 6556,
    city: "Beechina",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.85,
    longitude: 116.3167,
    accuracy: 4
  },
  {
    postalCode: 6556,
    city: "The Lakes",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8745,
    longitude: 116.3359,
    accuracy: 4
  },
  {
    postalCode: 6556,
    city: "Chidlow",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8609,
    longitude: 116.2724,
    accuracy: 4
  },
  {
    postalCode: 6556,
    city: "Malmalling",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8473,
    longitude: 116.3095,
    accuracy: 3
  },
  {
    postalCode: 6556,
    city: "Gorrie",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8473,
    longitude: 116.3095,
    accuracy: 3
  },
  {
    postalCode: 6558,
    city: "Wooroloo",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8038,
    longitude: 116.3131,
    accuracy: 4
  },
  {
    postalCode: 6560,
    city: "Wundowie",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7616,
    longitude: 116.3799,
    accuracy: 4
  },
  {
    postalCode: 6562,
    city: "Copley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.835,
    longitude: 116.4467,
    accuracy: 3
  },
  {
    postalCode: 6562,
    city: "Bakers Hill",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7469,
    longitude: 116.4587,
    accuracy: 4
  },
  {
    postalCode: 6562,
    city: "Woottating",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.835,
    longitude: 116.4467,
    accuracy: 3
  },
  {
    postalCode: 6564,
    city: "Clackline",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.7333,
    longitude: 116.5333,
    accuracy: 4
  },
  {
    postalCode: 6566,
    city: "Carani",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.9925,
    longitude: 116.4053,
    accuracy: 4
  },
  {
    postalCode: 6566,
    city: "Culham",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.4167,
    longitude: 116.4667,
    accuracy: 4
  },
  {
    postalCode: 6566,
    city: "West Toodyay",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.5333,
    longitude: 116.4167,
    accuracy: 4
  },
  {
    postalCode: 6566,
    city: "Coondle",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.4818,
    longitude: 116.4276,
    accuracy: 4
  },
  {
    postalCode: 6566,
    city: "Nunile",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.4304,
    longitude: 116.4453,
    accuracy: 3
  },
  {
    postalCode: 6566,
    city: "Toodyay",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.5498,
    longitude: 116.4674,
    accuracy: 4
  },
  {
    postalCode: 6566,
    city: "Katrine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.4304,
    longitude: 116.4453,
    accuracy: 3
  },
  {
    postalCode: 6566,
    city: "Bejoording",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.4,
    longitude: 116.5,
    accuracy: 4
  },
  {
    postalCode: 6566,
    city: "Hoddys Well",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.4304,
    longitude: 116.4453,
    accuracy: 3
  },
  {
    postalCode: 6566,
    city: "Dumbarton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.5682,
    longitude: 116.523,
    accuracy: 3
  },
  {
    postalCode: 6567,
    city: "Julimar",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.4779,
    longitude: 116.2483,
    accuracy: 4
  },
  {
    postalCode: 6567,
    city: "Dewars Pool",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.4833,
    longitude: 116.4333,
    accuracy: 4
  },
  {
    postalCode: 6567,
    city: "Moondyne",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.4812,
    longitude: 116.2698,
    accuracy: 3
  },
  {
    postalCode: 6568,
    city: "Wattening",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.3333,
    longitude: 116.5167,
    accuracy: 4
  },
  {
    postalCode: 6568,
    city: "Wyening",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.1887,
    longitude: 116.4857,
    accuracy: 4
  },
  {
    postalCode: 6568,
    city: "Bolgart",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.2667,
    longitude: 116.5,
    accuracy: 4
  },
  {
    postalCode: 6569,
    city: "Old Plains",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.0885,
    longitude: 116.4488,
    accuracy: 3
  },
  {
    postalCode: 6569,
    city: "Calingiri",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.0916,
    longitude: 116.4478,
    accuracy: 4
  },
  {
    postalCode: 6571,
    city: "Yerecoin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.675,
    longitude: 116.3667,
    accuracy: 1
  },
  {
    postalCode: 6572,
    city: "Piawaning",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.841,
    longitude: 116.3884,
    accuracy: 4
  },
  {
    postalCode: 6574,
    city: "Gabalong",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7214,
    longitude: 116.389,
    accuracy: 4
  },
  {
    postalCode: 6574,
    city: "Bindi Bindi",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.6352,
    longitude: 116.3587,
    accuracy: 4
  },
  {
    postalCode: 6575,
    city: "Miling",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.4897,
    longitude: 116.3624,
    accuracy: 4
  },
  {
    postalCode: 6603,
    city: "Konnongorring",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.0833,
    longitude: 116.7833,
    accuracy: 4
  },
  {
    postalCode: 6603,
    city: "Lake Hinds",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7635,
    longitude: 116.846,
    accuracy: 3
  },
  {
    postalCode: 6603,
    city: "Wongan Hills",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.8929,
    longitude: 116.7193,
    accuracy: 4
  },
  {
    postalCode: 6603,
    city: "Lake Ninan",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7635,
    longitude: 116.846,
    accuracy: 3
  },
  {
    postalCode: 6603,
    city: "Mocardy",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7635,
    longitude: 116.846,
    accuracy: 3
  },
  {
    postalCode: 6605,
    city: "Kondut",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.7109,
    longitude: 116.7732,
    accuracy: 4
  },
  {
    postalCode: 6606,
    city: "West Ballidu",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.5917,
    longitude: 116.7691,
    accuracy: 3
  },
  {
    postalCode: 6606,
    city: "East Ballidu",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.6833,
    longitude: 116.9,
    accuracy: 4
  },
  {
    postalCode: 6606,
    city: "Ballidu",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.5984,
    longitude: 116.7703,
    accuracy: 4
  },
  {
    postalCode: 6608,
    city: "Pithara",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.3919,
    longitude: 116.6688,
    accuracy: 4
  },
  {
    postalCode: 6608,
    city: "Marne",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.2704,
    longitude: 116.643,
    accuracy: 3
  },
  {
    postalCode: 6608,
    city: "East Damboring",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.2704,
    longitude: 116.643,
    accuracy: 3
  },
  {
    postalCode: 6609,
    city: "Dalwallinu",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.2805,
    longitude: 116.6601,
    accuracy: 4
  },
  {
    postalCode: 6609,
    city: "Xantippe",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.0333,
    longitude: 117.0333,
    accuracy: 4
  },
  {
    postalCode: 6609,
    city: "Nugadong",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.2039,
    longitude: 116.6636,
    accuracy: 4
  },
  {
    postalCode: 6612,
    city: "Wubin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -30.1065,
    longitude: 116.6332,
    accuracy: 4
  },
  {
    postalCode: 6612,
    city: "Miamoon",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.1266,
    longitude: 117.3905,
    accuracy: 3
  },
  {
    postalCode: 6612,
    city: "Paynes Find",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.2592,
    longitude: 117.6893,
    accuracy: 4
  },
  {
    postalCode: 6612,
    city: "Jibberding",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.1266,
    longitude: 117.3905,
    accuracy: 3
  },
  {
    postalCode: 6613,
    city: "Buntine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.987,
    longitude: 116.5713,
    accuracy: 4
  },
  {
    postalCode: 6614,
    city: "Maya",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.8849,
    longitude: 116.5044,
    accuracy: 4
  },
  {
    postalCode: 6616,
    city: "Latham",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.7587,
    longitude: 116.4457,
    accuracy: 4
  },
  {
    postalCode: 6620,
    city: "Rothsay",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.2833,
    longitude: 116.8833,
    accuracy: 4
  },
  {
    postalCode: 6620,
    city: "Perenjori",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.4361,
    longitude: 116.2856,
    accuracy: 4
  },
  {
    postalCode: 6623,
    city: "Pintharuka",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.094,
    longitude: 115.982,
    accuracy: 4
  },
  {
    postalCode: 6623,
    city: "Koolanooka",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.271,
    longitude: 116.0747,
    accuracy: 4
  },
  {
    postalCode: 6623,
    city: "Morawa",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.2134,
    longitude: 116.0079,
    accuracy: 4
  },
  {
    postalCode: 6623,
    city: "Bunjil",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.653,
    longitude: 116.3664,
    accuracy: 4
  },
  {
    postalCode: 6623,
    city: "Bowgada",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.3349,
    longitude: 116.1743,
    accuracy: 4
  },
  {
    postalCode: 6623,
    city: "Gutha",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.994,
    longitude: 115.946,
    accuracy: 4
  },
  {
    postalCode: 6625,
    city: "Merkanooka",
    state_name: "Western Australia",
    state: "WA",
    latitude: -29.1963,
    longitude: 116.1275,
    accuracy: 1
  },
  {
    postalCode: 6627,
    city: "Canna",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.9002,
    longitude: 115.8621,
    accuracy: 4
  },
  {
    postalCode: 6628,
    city: "Tardun",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.7937,
    longitude: 115.7478,
    accuracy: 4
  },
  {
    postalCode: 6630,
    city: "Nerramyne",
    state_name: "Western Australia",
    state: "WA",
    latitude: -27.2164,
    longitude: 115.966,
    accuracy: 3
  },
  {
    postalCode: 6630,
    city: "Murchison",
    state_name: "Western Australia",
    state: "WA",
    latitude: -26.8949,
    longitude: 115.9575,
    accuracy: 4
  },
  {
    postalCode: 6630,
    city: "Woolgorong",
    state_name: "Western Australia",
    state: "WA",
    latitude: -27.2164,
    longitude: 115.966,
    accuracy: 3
  },
  {
    postalCode: 6630,
    city: "Mullewa",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.5395,
    longitude: 115.5117,
    accuracy: 4
  },
  {
    postalCode: 6630,
    city: "Nunierra",
    state_name: "Western Australia",
    state: "WA",
    latitude: -27.2164,
    longitude: 115.966,
    accuracy: 3
  },
  {
    postalCode: 6630,
    city: "Wongoondy",
    state_name: "Western Australia",
    state: "WA",
    latitude: -27.2164,
    longitude: 115.966,
    accuracy: 3
  },
  {
    postalCode: 6630,
    city: "Devils Creek",
    state_name: "Western Australia",
    state: "WA",
    latitude: -27.2164,
    longitude: 115.966,
    accuracy: 3
  },
  {
    postalCode: 6630,
    city: "West Casuarinas",
    state_name: "Western Australia",
    state: "WA",
    latitude: -27.2164,
    longitude: 115.966,
    accuracy: 3
  },
  {
    postalCode: 6631,
    city: "Pindar",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.4804,
    longitude: 115.793,
    accuracy: 4
  },
  {
    postalCode: 6632,
    city: "Tenindewa",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.6178,
    longitude: 115.3625,
    accuracy: 4
  },
  {
    postalCode: 6632,
    city: "Ambania",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.6965,
    longitude: 115.1016,
    accuracy: 4
  },
  {
    postalCode: 6635,
    city: "Yalgoo",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.3436,
    longitude: 116.6825,
    accuracy: 4
  },
  {
    postalCode: 6635,
    city: "South Murchison",
    state_name: "Western Australia",
    state: "WA",
    latitude: -27.3163,
    longitude: 116.5712,
    accuracy: 3
  },
  {
    postalCode: 6638,
    city: "Mount Magnet",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.0648,
    longitude: 117.849,
    accuracy: 4
  },
  {
    postalCode: 6638,
    city: "Paynesville",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.3061,
    longitude: 118.822,
    accuracy: 3
  },
  {
    postalCode: 6638,
    city: "Daggar Hills",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.3061,
    longitude: 118.822,
    accuracy: 3
  },
  {
    postalCode: 6638,
    city: "Cooladar Hill",
    state_name: "Western Australia",
    state: "WA",
    latitude: -28.4825,
    longitude: 118.1683,
    accuracy: 3
  },
  {
    postalCode: 6639,
    city: "Sandstone",
    state_name: "Western Australia",
    state: "WA",
    latitude: -27.9868,
    longitude: 119.2973,
    accuracy: 4
  },
  {
    postalCode: 6640,
    city: "Cue",
    state_name: "Western Australia",
    state: "WA",
    latitude: -27.424,
    longitude: 117.8974,
    accuracy: 4
  },
  {
    postalCode: 6640,
    city: "East Murchison",
    state_name: "Western Australia",
    state: "WA",
    latitude: -26.8712,
    longitude: 117.4493,
    accuracy: 3
  },
  {
    postalCode: 6640,
    city: "Weld Range",
    state_name: "Western Australia",
    state: "WA",
    latitude: -26.8712,
    longitude: 117.4493,
    accuracy: 3
  },
  {
    postalCode: 6640,
    city: "Reedy",
    state_name: "Western Australia",
    state: "WA",
    latitude: -27.15,
    longitude: 118.2667,
    accuracy: 4
  },
  {
    postalCode: 6640,
    city: "Lake Austin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -26.8712,
    longitude: 117.4493,
    accuracy: 3
  },
  {
    postalCode: 6642,
    city: "Peak Hill",
    state_name: "Western Australia",
    state: "WA",
    latitude: -25.6375,
    longitude: 118.7244,
    accuracy: 4
  },
  {
    postalCode: 6642,
    city: "Capricorn",
    state_name: "Western Australia",
    state: "WA",
    latitude: -25.1448,
    longitude: 118.5342,
    accuracy: 3
  },
  {
    postalCode: 6642,
    city: "Meekatharra",
    state_name: "Western Australia",
    state: "WA",
    latitude: -26.5952,
    longitude: 118.4939,
    accuracy: 4
  },
  {
    postalCode: 6642,
    city: "Angelo River",
    state_name: "Western Australia",
    state: "WA",
    latitude: -25.1448,
    longitude: 118.5342,
    accuracy: 3
  },
  {
    postalCode: 6642,
    city: "Karalundi",
    state_name: "Western Australia",
    state: "WA",
    latitude: -26.5952,
    longitude: 118.4939,
    accuracy: 3
  },
  {
    postalCode: 6642,
    city: "Kumarina",
    state_name: "Western Australia",
    state: "WA",
    latitude: -25.1448,
    longitude: 118.5342,
    accuracy: 3
  },
  {
    postalCode: 6646,
    city: "Wiluna",
    state_name: "Western Australia",
    state: "WA",
    latitude: -26.5921,
    longitude: 120.224,
    accuracy: 4
  },
  {
    postalCode: 6646,
    city: "Lake Carnegie",
    state_name: "Western Australia",
    state: "WA",
    latitude: -25.3077,
    longitude: 122.2496,
    accuracy: 3
  },
  {
    postalCode: 6646,
    city: "Little Sandy Desert",
    state_name: "Western Australia",
    state: "WA",
    latitude: -25.3077,
    longitude: 122.2496,
    accuracy: 3
  },
  {
    postalCode: 6701,
    city: "Lyndon",
    state_name: "Western Australia",
    state: "WA",
    latitude: -24.161,
    longitude: 114.4806,
    accuracy: 3
  },
  {
    postalCode: 6701,
    city: "Kingsford",
    state_name: "Western Australia",
    state: "WA",
    latitude: -24.8639,
    longitude: 113.6955,
    accuracy: 4
  },
  {
    postalCode: 6701,
    city: "Gilroyd",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.5828,
    longitude: 119.1891,
    accuracy: 3
  },
  {
    postalCode: 6701,
    city: "Talisker",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.5828,
    longitude: 119.1891,
    accuracy: 3
  },
  {
    postalCode: 6701,
    city: "Wooramel",
    state_name: "Western Australia",
    state: "WA",
    latitude: -24.161,
    longitude: 114.4806,
    accuracy: 3
  },
  {
    postalCode: 6701,
    city: "Coral Bay",
    state_name: "Western Australia",
    state: "WA",
    latitude: -23.1408,
    longitude: 113.7763,
    accuracy: 4
  },
  {
    postalCode: 6701,
    city: "Yandoo Creek",
    state_name: "Western Australia",
    state: "WA",
    latitude: -24.161,
    longitude: 114.4806,
    accuracy: 3
  },
  {
    postalCode: 6701,
    city: "Woodleigh",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.5828,
    longitude: 119.1891,
    accuracy: 3
  },
  {
    postalCode: 6701,
    city: "South Plantations",
    state_name: "Western Australia",
    state: "WA",
    latitude: -24.8423,
    longitude: 113.7632,
    accuracy: 3
  },
  {
    postalCode: 6701,
    city: "Morgantown",
    state_name: "Western Australia",
    state: "WA",
    latitude: -24.8765,
    longitude: 113.6589,
    accuracy: 4
  },
  {
    postalCode: 6701,
    city: "Brown Range",
    state_name: "Western Australia",
    state: "WA",
    latitude: -24.8916,
    longitude: 113.6985,
    accuracy: 4
  },
  {
    postalCode: 6701,
    city: "Bernier Island",
    state_name: "Western Australia",
    state: "WA",
    latitude: -24.161,
    longitude: 114.4806,
    accuracy: 3
  },
  {
    postalCode: 6701,
    city: "South Carnarvon",
    state_name: "Western Australia",
    state: "WA",
    latitude: -24.8569,
    longitude: 113.7148,
    accuracy: 4
  },
  {
    postalCode: 6701,
    city: "East Carnarvon",
    state_name: "Western Australia",
    state: "WA",
    latitude: -24.864,
    longitude: 113.6777,
    accuracy: 4
  },
  {
    postalCode: 6701,
    city: "Carbla",
    state_name: "Western Australia",
    state: "WA",
    latitude: -26.1976,
    longitude: 114.3872,
    accuracy: 4
  },
  {
    postalCode: 6701,
    city: "Inggarda",
    state_name: "Western Australia",
    state: "WA",
    latitude: -24.161,
    longitude: 114.4806,
    accuracy: 3
  },
  {
    postalCode: 6701,
    city: "North Plantations",
    state_name: "Western Australia",
    state: "WA",
    latitude: -24.8447,
    longitude: 113.7088,
    accuracy: 4
  },
  {
    postalCode: 6701,
    city: "Kennedy Range",
    state_name: "Western Australia",
    state: "WA",
    latitude: -24.161,
    longitude: 114.4806,
    accuracy: 3
  },
  {
    postalCode: 6701,
    city: "Ningaloo",
    state_name: "Western Australia",
    state: "WA",
    latitude: -22.8361,
    longitude: 113.8012,
    accuracy: 4
  },
  {
    postalCode: 6701,
    city: "Babbage Island",
    state_name: "Western Australia",
    state: "WA",
    latitude: -24.161,
    longitude: 114.4806,
    accuracy: 3
  },
  {
    postalCode: 6701,
    city: "Brockman",
    state_name: "Western Australia",
    state: "WA",
    latitude: -24.8813,
    longitude: 113.6536,
    accuracy: 4
  },
  {
    postalCode: 6701,
    city: "Yalardy",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.5828,
    longitude: 119.1891,
    accuracy: 3
  },
  {
    postalCode: 6701,
    city: "Massey Bay",
    state_name: "Western Australia",
    state: "WA",
    latitude: -24.161,
    longitude: 114.4806,
    accuracy: 3
  },
  {
    postalCode: 6701,
    city: "Mauds Landing",
    state_name: "Western Australia",
    state: "WA",
    latitude: -24.161,
    longitude: 114.4806,
    accuracy: 3
  },
  {
    postalCode: 6701,
    city: "Macleod",
    state_name: "Western Australia",
    state: "WA",
    latitude: -24.161,
    longitude: 114.4806,
    accuracy: 3
  },
  {
    postalCode: 6701,
    city: "Carnarvon",
    state_name: "Western Australia",
    state: "WA",
    latitude: -24.8826,
    longitude: 113.6571,
    accuracy: 4
  },
  {
    postalCode: 6701,
    city: "Greys Plain",
    state_name: "Western Australia",
    state: "WA",
    latitude: -24.883,
    longitude: 113.7018,
    accuracy: 3
  },
  {
    postalCode: 6701,
    city: "Dorre Island",
    state_name: "Western Australia",
    state: "WA",
    latitude: -24.161,
    longitude: 114.4806,
    accuracy: 3
  },
  {
    postalCode: 6701,
    city: "Minilya",
    state_name: "Western Australia",
    state: "WA",
    latitude: -24.161,
    longitude: 114.4806,
    accuracy: 3
  },
  {
    postalCode: 6705,
    city: "Gascoyne Junction",
    state_name: "Western Australia",
    state: "WA",
    latitude: -25.0499,
    longitude: 115.2091,
    accuracy: 4
  },
  {
    postalCode: 6705,
    city: "East Lyons River",
    state_name: "Western Australia",
    state: "WA",
    latitude: -24.7255,
    longitude: 116.3552,
    accuracy: 3
  },
  {
    postalCode: 6705,
    city: "West Lyons River",
    state_name: "Western Australia",
    state: "WA",
    latitude: -24.7255,
    longitude: 116.3552,
    accuracy: 3
  },
  {
    postalCode: 6705,
    city: "Gascoyne River",
    state_name: "Western Australia",
    state: "WA",
    latitude: -25.0499,
    longitude: 115.2091,
    accuracy: 4
  },
  {
    postalCode: 6707,
    city: "Exmouth",
    state_name: "Western Australia",
    state: "WA",
    latitude: -21.9306,
    longitude: 114.1209,
    accuracy: 4
  },
  {
    postalCode: 6707,
    city: "Learmonth",
    state_name: "Western Australia",
    state: "WA",
    latitude: -22.25,
    longitude: 114.0833,
    accuracy: 4
  },
  {
    postalCode: 6707,
    city: "Cape Range National Park",
    state_name: "Western Australia",
    state: "WA",
    latitude: -22.2143,
    longitude: 113.9896,
    accuracy: 3
  },
  {
    postalCode: 6707,
    city: "North West Cape",
    state_name: "Western Australia",
    state: "WA",
    latitude: -21.882,
    longitude: 114.1325,
    accuracy: 4
  },
  {
    postalCode: 6707,
    city: "Exmouth Gulf",
    state_name: "Western Australia",
    state: "WA",
    latitude: -22.2143,
    longitude: 113.9896,
    accuracy: 3
  },
  {
    postalCode: 6710,
    city: "Onslow",
    state_name: "Western Australia",
    state: "WA",
    latitude: -21.6376,
    longitude: 115.1122,
    accuracy: 4
  },
  {
    postalCode: 6710,
    city: "Talandji",
    state_name: "Western Australia",
    state: "WA",
    latitude: -22.5027,
    longitude: 116.2032,
    accuracy: 3
  },
  {
    postalCode: 6710,
    city: "Peedamulla",
    state_name: "Western Australia",
    state: "WA",
    latitude: -22.5027,
    longitude: 116.2032,
    accuracy: 3
  },
  {
    postalCode: 6710,
    city: "Yannarie",
    state_name: "Western Australia",
    state: "WA",
    latitude: -22.5027,
    longitude: 116.2032,
    accuracy: 3
  },
  {
    postalCode: 6710,
    city: "Cane",
    state_name: "Western Australia",
    state: "WA",
    latitude: -22.5027,
    longitude: 116.2032,
    accuracy: 3
  },
  {
    postalCode: 6711,
    city: "Thevenard Island",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.9833,
    longitude: 116.6917,
    accuracy: 1
  },
  {
    postalCode: 6712,
    city: "Barrow Island",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.9833,
    longitude: 116.6917,
    accuracy: 1
  },
  {
    postalCode: 6713,
    city: "Dampier",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.6627,
    longitude: 116.7126,
    accuracy: 4
  },
  {
    postalCode: 6713,
    city: "Dampier Archipelago",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.668,
    longitude: 116.7191,
    accuracy: 3
  },
  {
    postalCode: 6714,
    city: "Mulataga",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.7395,
    longitude: 116.8774,
    accuracy: 4
  },
  {
    postalCode: 6714,
    city: "Karratha",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.7377,
    longitude: 116.8463,
    accuracy: 4
  },
  {
    postalCode: 6714,
    city: "Baynton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.7516,
    longitude: 116.8014,
    accuracy: 4
  },
  {
    postalCode: 6714,
    city: "Karratha Industrial Estate",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.7678,
    longitude: 116.8708,
    accuracy: 3
  },
  {
    postalCode: 6714,
    city: "Millars Well",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.7417,
    longitude: 116.8173,
    accuracy: 4
  },
  {
    postalCode: 6714,
    city: "Pegs Creek",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.7383,
    longitude: 116.8328,
    accuracy: 4
  },
  {
    postalCode: 6714,
    city: "Balla Balla",
    state_name: "Western Australia",
    state: "WA",
    latitude: -21.0631,
    longitude: 116.4802,
    accuracy: 3
  },
  {
    postalCode: 6714,
    city: "Bulgarra",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.7258,
    longitude: 116.8567,
    accuracy: 4
  },
  {
    postalCode: 6714,
    city: "Antonymyre",
    state_name: "Western Australia",
    state: "WA",
    latitude: -21.0631,
    longitude: 116.4802,
    accuracy: 3
  },
  {
    postalCode: 6714,
    city: "Cleaverville",
    state_name: "Western Australia",
    state: "WA",
    latitude: -21.0631,
    longitude: 116.4802,
    accuracy: 3
  },
  {
    postalCode: 6714,
    city: "Stove Hill",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.7574,
    longitude: 116.8495,
    accuracy: 3
  },
  {
    postalCode: 6714,
    city: "Nickol",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.7456,
    longitude: 116.7954,
    accuracy: 4
  },
  {
    postalCode: 6714,
    city: "Mount Anketell",
    state_name: "Western Australia",
    state: "WA",
    latitude: -21.0631,
    longitude: 116.4802,
    accuracy: 3
  },
  {
    postalCode: 6714,
    city: "Sherlock",
    state_name: "Western Australia",
    state: "WA",
    latitude: -21.0631,
    longitude: 116.4802,
    accuracy: 3
  },
  {
    postalCode: 6714,
    city: "Burrup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.5901,
    longitude: 116.796,
    accuracy: 4
  },
  {
    postalCode: 6714,
    city: "Cooya Pooya",
    state_name: "Western Australia",
    state: "WA",
    latitude: -21.0631,
    longitude: 116.4802,
    accuracy: 3
  },
  {
    postalCode: 6714,
    city: "Gap Ridge",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.7461,
    longitude: 116.7856,
    accuracy: 3
  },
  {
    postalCode: 6714,
    city: "Mardie",
    state_name: "Western Australia",
    state: "WA",
    latitude: -21.0631,
    longitude: 116.4802,
    accuracy: 3
  },
  {
    postalCode: 6714,
    city: "Maitland",
    state_name: "Western Australia",
    state: "WA",
    latitude: -21.0631,
    longitude: 116.4802,
    accuracy: 3
  },
  {
    postalCode: 6714,
    city: "Gnoorea",
    state_name: "Western Australia",
    state: "WA",
    latitude: -21.0631,
    longitude: 116.4802,
    accuracy: 3
  },
  {
    postalCode: 6716,
    city: "Pannawonica",
    state_name: "Western Australia",
    state: "WA",
    latitude: -21.6392,
    longitude: 116.3222,
    accuracy: 4
  },
  {
    postalCode: 6716,
    city: "Millstream",
    state_name: "Western Australia",
    state: "WA",
    latitude: -21.6374,
    longitude: 116.3258,
    accuracy: 3
  },
  {
    postalCode: 6716,
    city: "Hamersley Range",
    state_name: "Western Australia",
    state: "WA",
    latitude: -21.6374,
    longitude: 116.3258,
    accuracy: 3
  },
  {
    postalCode: 6716,
    city: "Fortescue",
    state_name: "Western Australia",
    state: "WA",
    latitude: -21.6374,
    longitude: 116.3258,
    accuracy: 3
  },
  {
    postalCode: 6718,
    city: "Roebourne",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.7723,
    longitude: 117.1465,
    accuracy: 4
  },
  {
    postalCode: 6718,
    city: "Whim Creek",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.8386,
    longitude: 117.8314,
    accuracy: 4
  },
  {
    postalCode: 6720,
    city: "Wickham",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.6747,
    longitude: 117.1378,
    accuracy: 4
  },
  {
    postalCode: 6720,
    city: "Cossack",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.7,
    longitude: 117.2,
    accuracy: 4
  },
  {
    postalCode: 6720,
    city: "Point Samson",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.6289,
    longitude: 117.1927,
    accuracy: 4
  },
  {
    postalCode: 6721,
    city: "Mundabullangana",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.929,
    longitude: 118.6739,
    accuracy: 3
  },
  {
    postalCode: 6721,
    city: "Wedgefield",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.3609,
    longitude: 118.5958,
    accuracy: 4
  },
  {
    postalCode: 6721,
    city: "Port Hedland",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.3121,
    longitude: 118.6106,
    accuracy: 4
  },
  {
    postalCode: 6721,
    city: "Strelley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -21.1167,
    longitude: 119.05,
    accuracy: 4
  },
  {
    postalCode: 6721,
    city: "Indee",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.929,
    longitude: 118.6739,
    accuracy: 3
  },
  {
    postalCode: 6721,
    city: "Redbank",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.3452,
    longitude: 118.6296,
    accuracy: 4
  },
  {
    postalCode: 6721,
    city: "Pardoo",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.1086,
    longitude: 119.5798,
    accuracy: 3
  },
  {
    postalCode: 6721,
    city: "Wallareenya",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.929,
    longitude: 118.6739,
    accuracy: 3
  },
  {
    postalCode: 6722,
    city: "Boodarie",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.3675,
    longitude: 118.5586,
    accuracy: 4
  },
  {
    postalCode: 6722,
    city: "Finucane",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.2977,
    longitude: 118.569,
    accuracy: 4
  },
  {
    postalCode: 6722,
    city: "De Grey",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.4091,
    longitude: 118.6091,
    accuracy: 3
  },
  {
    postalCode: 6722,
    city: "Pippingarra",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.4091,
    longitude: 118.6091,
    accuracy: 3
  },
  {
    postalCode: 6722,
    city: "South Hedland",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.4066,
    longitude: 118.6007,
    accuracy: 4
  },
  {
    postalCode: 6723,
    city: "Goldsworthy",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.35,
    longitude: 119.5333,
    accuracy: 4
  },
  {
    postalCode: 6725,
    city: "Roebuck",
    state_name: "Western Australia",
    state: "WA",
    latitude: -18.1713,
    longitude: 122.5012,
    accuracy: 4
  },
  {
    postalCode: 6725,
    city: "Minyirr",
    state_name: "Western Australia",
    state: "WA",
    latitude: -17.9813,
    longitude: 122.2097,
    accuracy: 4
  },
  {
    postalCode: 6725,
    city: "Dampier Peninsula",
    state_name: "Western Australia",
    state: "WA",
    latitude: -16.9324,
    longitude: 122.8656,
    accuracy: 4
  },
  {
    postalCode: 6725,
    city: "Lagrange",
    state_name: "Western Australia",
    state: "WA",
    latitude: -18.7056,
    longitude: 121.9933,
    accuracy: 3
  },
  {
    postalCode: 6725,
    city: "Broome",
    state_name: "Western Australia",
    state: "WA",
    latitude: -17.9554,
    longitude: 122.2392,
    accuracy: 4
  },
  {
    postalCode: 6725,
    city: "Gingerah",
    state_name: "Western Australia",
    state: "WA",
    latitude: -18.6605,
    longitude: 122.4748,
    accuracy: 3
  },
  {
    postalCode: 6725,
    city: "Bilingurr",
    state_name: "Western Australia",
    state: "WA",
    latitude: -17.9091,
    longitude: 122.2292,
    accuracy: 4
  },
  {
    postalCode: 6725,
    city: "Waterbank",
    state_name: "Western Australia",
    state: "WA",
    latitude: -17.4547,
    longitude: 122.6775,
    accuracy: 3
  },
  {
    postalCode: 6725,
    city: "Djugun",
    state_name: "Western Australia",
    state: "WA",
    latitude: -17.9539,
    longitude: 122.2279,
    accuracy: 4
  },
  {
    postalCode: 6725,
    city: "Eighty Mile Beach",
    state_name: "Western Australia",
    state: "WA",
    latitude: -19.2407,
    longitude: 121.6133,
    accuracy: 4
  },
  {
    postalCode: 6726,
    city: "Cable Beach",
    state_name: "Western Australia",
    state: "WA",
    latitude: -17.961,
    longitude: 122.2127,
    accuracy: 4
  },
  {
    postalCode: 6728,
    city: "Camballin",
    state_name: "Western Australia",
    state: "WA",
    latitude: -18.209,
    longitude: 123.9018,
    accuracy: 4
  },
  {
    postalCode: 6728,
    city: "Kimbolton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.4159,
    longitude: 118.7072,
    accuracy: 3
  },
  {
    postalCode: 6728,
    city: "King Leopold Ranges",
    state_name: "Western Australia",
    state: "WA",
    latitude: -17.1099,
    longitude: 125.4806,
    accuracy: 4
  },
  {
    postalCode: 6728,
    city: "Geegully Creek",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.4159,
    longitude: 118.7072,
    accuracy: 3
  },
  {
    postalCode: 6728,
    city: "Derby",
    state_name: "Western Australia",
    state: "WA",
    latitude: -17.3029,
    longitude: 123.6286,
    accuracy: 4
  },
  {
    postalCode: 6728,
    city: "Willare",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.4159,
    longitude: 118.7072,
    accuracy: 3
  },
  {
    postalCode: 6728,
    city: "Meda",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.4159,
    longitude: 118.7072,
    accuracy: 3
  },
  {
    postalCode: 6728,
    city: "St George Ranges",
    state_name: "Western Australia",
    state: "WA",
    latitude: -18.982,
    longitude: 125.0087,
    accuracy: 4
  },
  {
    postalCode: 6731,
    city: "Cockatoo Island",
    state_name: "Western Australia",
    state: "WA",
    latitude: -20.5828,
    longitude: 119.1891,
    accuracy: 1
  },
  {
    postalCode: 6733,
    city: "Koolan Island",
    state_name: "Western Australia",
    state: "WA",
    latitude: -21.0454,
    longitude: 118.4324,
    accuracy: 1
  },
  {
    postalCode: 6740,
    city: "Prince Regent River",
    state_name: "Western Australia",
    state: "WA",
    latitude: -15.9162,
    longitude: 126.8148,
    accuracy: 1
  },
  {
    postalCode: 6740,
    city: "Kalumburu",
    state_name: "Western Australia",
    state: "WA",
    latitude: -14.2872,
    longitude: 126.6345,
    accuracy: 1
  },
  {
    postalCode: 6740,
    city: "Mitchell Plateau",
    state_name: "Western Australia",
    state: "WA",
    latitude: -15.9162,
    longitude: 126.8148,
    accuracy: 1
  },
  {
    postalCode: 6740,
    city: "Oombulgurri",
    state_name: "Western Australia",
    state: "WA",
    latitude: -15.9162,
    longitude: 126.8148,
    accuracy: 1
  },
  {
    postalCode: 6740,
    city: "Wyndham",
    state_name: "Western Australia",
    state: "WA",
    latitude: -15.4869,
    longitude: 128.1243,
    accuracy: 4
  },
  {
    postalCode: 6740,
    city: "Drysdale River",
    state_name: "Western Australia",
    state: "WA",
    latitude: -15.9162,
    longitude: 126.8148,
    accuracy: 1
  },
  {
    postalCode: 6743,
    city: "Lake Argyle",
    state_name: "Western Australia",
    state: "WA",
    latitude: -16.1088,
    longitude: 128.7443,
    accuracy: 1
  },
  {
    postalCode: 6743,
    city: "Kununurra",
    state_name: "Western Australia",
    state: "WA",
    latitude: -15.7739,
    longitude: 128.739,
    accuracy: 1
  },
  {
    postalCode: 6743,
    city: "Gibb",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0844,
    longitude: 119.0982,
    accuracy: 1
  },
  {
    postalCode: 6743,
    city: "Warmun",
    state_name: "Western Australia",
    state: "WA",
    latitude: -17.0338,
    longitude: 128.2236,
    accuracy: 1
  },
  {
    postalCode: 6743,
    city: "Cambridge Gulf",
    state_name: "Western Australia",
    state: "WA",
    latitude: -17.4122,
    longitude: 129.6861,
    accuracy: 1
  },
  {
    postalCode: 6743,
    city: "Durack",
    state_name: "Western Australia",
    state: "WA",
    latitude: -17.4122,
    longitude: 129.6861,
    accuracy: 1
  },
  {
    postalCode: 6751,
    city: "Rocklea",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.8696,
    longitude: 118.4233,
    accuracy: 3
  },
  {
    postalCode: 6751,
    city: "Tom Price",
    state_name: "Western Australia",
    state: "WA",
    latitude: -22.6939,
    longitude: 117.7931,
    accuracy: 4
  },
  {
    postalCode: 6751,
    city: "Chichester",
    state_name: "Western Australia",
    state: "WA",
    latitude: -22.6856,
    longitude: 117.7906,
    accuracy: 3
  },
  {
    postalCode: 6751,
    city: "Wittenoom",
    state_name: "Western Australia",
    state: "WA",
    latitude: -22.2404,
    longitude: 118.3355,
    accuracy: 4
  },
  {
    postalCode: 6751,
    city: "Mulga Downs",
    state_name: "Western Australia",
    state: "WA",
    latitude: -22.6856,
    longitude: 117.7906,
    accuracy: 3
  },
  {
    postalCode: 6751,
    city: "Nanutarra",
    state_name: "Western Australia",
    state: "WA",
    latitude: -22.6856,
    longitude: 117.7906,
    accuracy: 3
  },
  {
    postalCode: 6751,
    city: "Innawanga",
    state_name: "Western Australia",
    state: "WA",
    latitude: -22.6856,
    longitude: 117.7906,
    accuracy: 3
  },
  {
    postalCode: 6751,
    city: "Mount Sheila",
    state_name: "Western Australia",
    state: "WA",
    latitude: -22.6856,
    longitude: 117.7906,
    accuracy: 3
  },
  {
    postalCode: 6751,
    city: "Karijini",
    state_name: "Western Australia",
    state: "WA",
    latitude: -22.6856,
    longitude: 117.7906,
    accuracy: 3
  },
  {
    postalCode: 6751,
    city: "Juna Downs",
    state_name: "Western Australia",
    state: "WA",
    latitude: -22.6856,
    longitude: 117.7906,
    accuracy: 3
  },
  {
    postalCode: 6753,
    city: "Newman",
    state_name: "Western Australia",
    state: "WA",
    latitude: -23.3564,
    longitude: 119.7355,
    accuracy: 4
  },
  {
    postalCode: 6754,
    city: "Paraburdoo",
    state_name: "Western Australia",
    state: "WA",
    latitude: -23.2042,
    longitude: 117.6697,
    accuracy: 4
  },
  {
    postalCode: 6758,
    city: "Nullagine",
    state_name: "Western Australia",
    state: "WA",
    latitude: -21.8897,
    longitude: 120.1114,
    accuracy: 4
  },
  {
    postalCode: 6760,
    city: "Marble Bar",
    state_name: "Western Australia",
    state: "WA",
    latitude: -21.1707,
    longitude: 119.7444,
    accuracy: 4
  },
  {
    postalCode: 6761,
    city: "Shay Gap",
    state_name: "Western Australia",
    state: "WA",
    latitude: -21.1707,
    longitude: 119.7444,
    accuracy: 1
  },
  {
    postalCode: 6762,
    city: "Telfer",
    state_name: "Western Australia",
    state: "WA",
    latitude: -21.2117,
    longitude: 123.2617,
    accuracy: 4
  },
  {
    postalCode: 6765,
    city: "Mount Hardman",
    state_name: "Western Australia",
    state: "WA",
    latitude: -21.1707,
    longitude: 119.7444,
    accuracy: 3
  },
  {
    postalCode: 6765,
    city: "Fitzroy Crossing",
    state_name: "Western Australia",
    state: "WA",
    latitude: -18.1971,
    longitude: 125.5666,
    accuracy: 4
  },
  {
    postalCode: 6770,
    city: "Sturt Creek",
    state_name: "Western Australia",
    state: "WA",
    latitude: -18.8386,
    longitude: 128.1783,
    accuracy: 3
  },
  {
    postalCode: 6770,
    city: "Mueller Ranges",
    state_name: "Western Australia",
    state: "WA",
    latitude: -18.3983,
    longitude: 126.8562,
    accuracy: 4
  },
  {
    postalCode: 6770,
    city: "Mcbeath",
    state_name: "Western Australia",
    state: "WA",
    latitude: -19.3668,
    longitude: 127.5678,
    accuracy: 3
  },
  {
    postalCode: 6770,
    city: "Purnululu",
    state_name: "Western Australia",
    state: "WA",
    latitude: -19.3668,
    longitude: 127.5678,
    accuracy: 3
  },
  {
    postalCode: 6770,
    city: "Tanami",
    state_name: "Western Australia",
    state: "WA",
    latitude: -19.3668,
    longitude: 127.5678,
    accuracy: 3
  },
  {
    postalCode: 6770,
    city: "Halls Creek",
    state_name: "Western Australia",
    state: "WA",
    latitude: -19.3668,
    longitude: 127.5678,
    accuracy: 3
  },
  {
    postalCode: 6770,
    city: "Ord River",
    state_name: "Western Australia",
    state: "WA",
    latitude: -17.3857,
    longitude: 128.9207,
    accuracy: 3
  },
  {
    postalCode: 6798,
    city: "Christmas Island",
    state_name: "Western Australia",
    state: "WA",
    latitude: -10.4854,
    longitude: 105.6365,
    accuracy: 1
  },
  {
    postalCode: 6799,
    city: "Home Island Cocos (Keeling) Islands",
    state_name: "Western Australia",
    state: "WA",
    latitude: -12.1352,
    longitude: 96.8628,
    accuracy: 1
  },
  {
    postalCode: 6799,
    city: "West Island Cocos (Keeling) Islands",
    state_name: "Western Australia",
    state: "WA",
    latitude: -12.1352,
    longitude: 96.8628,
    accuracy: 1
  },
  {
    postalCode: 6800,
    city: "Perth",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9522,
    longitude: 115.8614,
    accuracy: 4
  },
  {
    postalCode: 6803,
    city: "Northbridge",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9478,
    longitude: 115.8588,
    accuracy: 4
  },
  {
    postalCode: 6809,
    city: "Perth",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9522,
    longitude: 115.8614,
    accuracy: 4
  },
  {
    postalCode: 6817,
    city: "Perth",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9522,
    longitude: 115.8614,
    accuracy: 4
  },
  {
    postalCode: 6820,
    city: "Perth",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9522,
    longitude: 115.8614,
    accuracy: 4
  },
  {
    postalCode: 6827,
    city: "Perth",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9522,
    longitude: 115.8614,
    accuracy: 4
  },
  {
    postalCode: 6830,
    city: "Perth",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9522,
    longitude: 115.8614,
    accuracy: 4
  },
  {
    postalCode: 6831,
    city: "Perth St Georges Tce",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9333,
    longitude: 115.8333,
    accuracy: 1
  },
  {
    postalCode: 6832,
    city: "Perth Adelaide Tce",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9522,
    longitude: 115.8614,
    accuracy: 1
  },
  {
    postalCode: 6832,
    city: "Perth East St Georges Tce",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9333,
    longitude: 115.8333,
    accuracy: 1
  },
  {
    postalCode: 6837,
    city: "Perth",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9522,
    longitude: 115.8614,
    accuracy: 4
  },
  {
    postalCode: 6838,
    city: "Perth",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9522,
    longitude: 115.8614,
    accuracy: 4
  },
  {
    postalCode: 6839,
    city: "Perth",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9522,
    longitude: 115.8614,
    accuracy: 4
  },
  {
    postalCode: 6840,
    city: "Perth",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9522,
    longitude: 115.8614,
    accuracy: 4
  },
  {
    postalCode: 6841,
    city: "Perth",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9522,
    longitude: 115.8614,
    accuracy: 4
  },
  {
    postalCode: 6842,
    city: "Perth",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9522,
    longitude: 115.8614,
    accuracy: 4
  },
  {
    postalCode: 6843,
    city: "Perth",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9522,
    longitude: 115.8614,
    accuracy: 4
  },
  {
    postalCode: 6844,
    city: "Perth",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9522,
    longitude: 115.8614,
    accuracy: 4
  },
  {
    postalCode: 6845,
    city: "Perth",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9522,
    longitude: 115.8614,
    accuracy: 4
  },
  {
    postalCode: 6846,
    city: "Perth",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9522,
    longitude: 115.8614,
    accuracy: 4
  },
  {
    postalCode: 6847,
    city: "Perth",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9522,
    longitude: 115.8614,
    accuracy: 4
  },
  {
    postalCode: 6848,
    city: "Perth",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9522,
    longitude: 115.8614,
    accuracy: 4
  },
  {
    postalCode: 6849,
    city: "Perth Bc",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9333,
    longitude: 115.8333,
    accuracy: 1
  },
  {
    postalCode: 6850,
    city: "Cloisters Square Po",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.952,
    longitude: 115.8607,
    accuracy: 1
  },
  {
    postalCode: 6850,
    city: "Cloisters Square",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9333,
    longitude: 115.8333,
    accuracy: 1
  },
  {
    postalCode: 6865,
    city: "Northbridge",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9478,
    longitude: 115.8588,
    accuracy: 4
  },
  {
    postalCode: 6872,
    city: "West Perth",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.949,
    longitude: 115.842,
    accuracy: 4
  },
  {
    postalCode: 6892,
    city: "East Perth",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9587,
    longitude: 115.8711,
    accuracy: 4
  },
  {
    postalCode: 6900,
    city: "Leederville",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9363,
    longitude: 115.8419,
    accuracy: 4
  },
  {
    postalCode: 6901,
    city: "West Leederville",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9414,
    longitude: 115.8312,
    accuracy: 4
  },
  {
    postalCode: 6902,
    city: "Leederville",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9363,
    longitude: 115.8419,
    accuracy: 4
  },
  {
    postalCode: 6903,
    city: "Leederville",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9363,
    longitude: 115.8419,
    accuracy: 4
  },
  {
    postalCode: 6904,
    city: "Subiaco",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9485,
    longitude: 115.8268,
    accuracy: 4
  },
  {
    postalCode: 6904,
    city: "Subiaco Po",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.95,
    longitude: 115.8,
    accuracy: 3
  },
  {
    postalCode: 6905,
    city: "Northlands",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9722,
    longitude: 115.8,
    accuracy: 1
  },
  {
    postalCode: 6905,
    city: "Northlands Po",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9486,
    longitude: 115.8275,
    accuracy: 1
  },
  {
    postalCode: 6906,
    city: "North Perth",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9272,
    longitude: 115.8528,
    accuracy: 4
  },
  {
    postalCode: 6907,
    city: "Nedlands",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9818,
    longitude: 115.8073,
    accuracy: 4
  },
  {
    postalCode: 6909,
    city: "Nedlands",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9818,
    longitude: 115.8073,
    accuracy: 4
  },
  {
    postalCode: 6910,
    city: "Claremont",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9796,
    longitude: 115.7823,
    accuracy: 4
  },
  {
    postalCode: 6911,
    city: "Cottesloe",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32,
    longitude: 115.7667,
    accuracy: 4
  },
  {
    postalCode: 6912,
    city: "Mosman Park",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0054,
    longitude: 115.7638,
    accuracy: 4
  },
  {
    postalCode: 6913,
    city: "Wembley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9333,
    longitude: 115.8,
    accuracy: 4
  },
  {
    postalCode: 6914,
    city: "Balcatta",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.875,
    longitude: 115.8284,
    accuracy: 4
  },
  {
    postalCode: 6915,
    city: "Mount Hawthorn",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.92,
    longitude: 115.8351,
    accuracy: 4
  },
  {
    postalCode: 6916,
    city: "Osborne Park Dc",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9802,
    longitude: 115.7757,
    accuracy: 3
  },
  {
    postalCode: 6916,
    city: "Osborne Park",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9007,
    longitude: 115.8108,
    accuracy: 4
  },
  {
    postalCode: 6917,
    city: "Osborne Park",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9007,
    longitude: 115.8108,
    accuracy: 4
  },
  {
    postalCode: 6918,
    city: "Innaloo",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8927,
    longitude: 115.7951,
    accuracy: 4
  },
  {
    postalCode: 6919,
    city: "Joondalup Dc",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9802,
    longitude: 115.7757,
    accuracy: 1
  },
  {
    postalCode: 6920,
    city: "North Beach",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.863,
    longitude: 115.7562,
    accuracy: 4
  },
  {
    postalCode: 6921,
    city: "Karrinyup",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8723,
    longitude: 115.7768,
    accuracy: 4
  },
  {
    postalCode: 6922,
    city: "Scarborough",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8958,
    longitude: 115.7643,
    accuracy: 4
  },
  {
    postalCode: 6923,
    city: "Hillarys",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.807,
    longitude: 115.7405,
    accuracy: 4
  },
  {
    postalCode: 6924,
    city: "Greenwood",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8272,
    longitude: 115.8025,
    accuracy: 4
  },
  {
    postalCode: 6925,
    city: "Walliston Dc",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9167,
    longitude: 115.8556,
    accuracy: 1
  },
  {
    postalCode: 6926,
    city: "Kalamunda",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9868,
    longitude: 116.0704,
    accuracy: 1
  },
  {
    postalCode: 6929,
    city: "Mount Lawley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9344,
    longitude: 115.8716,
    accuracy: 4
  },
  {
    postalCode: 6931,
    city: "Maylands",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.931,
    longitude: 115.8949,
    accuracy: 4
  },
  {
    postalCode: 6932,
    city: "Inglewood",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9166,
    longitude: 115.8798,
    accuracy: 4
  },
  {
    postalCode: 6933,
    city: "Bayswater",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9169,
    longitude: 115.9178,
    accuracy: 4
  },
  {
    postalCode: 6934,
    city: "Bassendean",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9091,
    longitude: 115.9437,
    accuracy: 4
  },
  {
    postalCode: 6935,
    city: "Guildford",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9,
    longitude: 115.9667,
    accuracy: 4
  },
  {
    postalCode: 6936,
    city: "Midland Dc",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9111,
    longitude: 115.9333,
    accuracy: 1
  },
  {
    postalCode: 6937,
    city: "Tuart Hill",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8981,
    longitude: 115.8349,
    accuracy: 4
  },
  {
    postalCode: 6938,
    city: "Tuart Hill",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8981,
    longitude: 115.8349,
    accuracy: 4
  },
  {
    postalCode: 6939,
    city: "Tuart Hill",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8981,
    longitude: 115.8349,
    accuracy: 4
  },
  {
    postalCode: 6940,
    city: "Tuart Hill",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8981,
    longitude: 115.8349,
    accuracy: 4
  },
  {
    postalCode: 6941,
    city: "Mirrabooka",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8596,
    longitude: 115.8659,
    accuracy: 4
  },
  {
    postalCode: 6942,
    city: "Bassendean Dc",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.75,
    longitude: 115.8,
    accuracy: 1
  },
  {
    postalCode: 6943,
    city: "Morley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8877,
    longitude: 115.9099,
    accuracy: 4
  },
  {
    postalCode: 6944,
    city: "Malaga",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.8526,
    longitude: 115.881,
    accuracy: 4
  },
  {
    postalCode: 6945,
    city: "Malaga Dc",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.75,
    longitude: 115.8,
    accuracy: 1
  },
  {
    postalCode: 6946,
    city: "Wanneroo",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.75,
    longitude: 115.8,
    accuracy: 4
  },
  {
    postalCode: 6947,
    city: "Wangara Dc",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.75,
    longitude: 115.8,
    accuracy: 1
  },
  {
    postalCode: 6951,
    city: "South Perth",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9833,
    longitude: 115.8667,
    accuracy: 4
  },
  {
    postalCode: 6952,
    city: "Como",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9912,
    longitude: 115.8634,
    accuracy: 4
  },
  {
    postalCode: 6953,
    city: "Applecross",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0167,
    longitude: 115.8333,
    accuracy: 4
  },
  {
    postalCode: 6954,
    city: "Booragoon",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0395,
    longitude: 115.8337,
    accuracy: 4
  },
  {
    postalCode: 6955,
    city: "Willetton",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0525,
    longitude: 115.8878,
    accuracy: 4
  },
  {
    postalCode: 6956,
    city: "Melville",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0404,
    longitude: 115.8012,
    accuracy: 4
  },
  {
    postalCode: 6957,
    city: "Palmyra",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.045,
    longitude: 115.7859,
    accuracy: 4
  },
  {
    postalCode: 6958,
    city: "Royal Australian Navy Warships",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.05,
    longitude: 115.7667,
    accuracy: 1
  },
  {
    postalCode: 6959,
    city: "Fremantle",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.05,
    longitude: 115.7667,
    accuracy: 4
  },
  {
    postalCode: 6960,
    city: "Myaree Bc",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2833,
    longitude: 115.7167,
    accuracy: 1
  },
  {
    postalCode: 6961,
    city: "Palmyra Dc",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2833,
    longitude: 115.7167,
    accuracy: 1
  },
  {
    postalCode: 6963,
    city: "Hamilton Hill",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0845,
    longitude: 115.7795,
    accuracy: 4
  },
  {
    postalCode: 6964,
    city: "Success",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1428,
    longitude: 115.85,
    accuracy: 4
  },
  {
    postalCode: 6965,
    city: "Bibra Lake Dc",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2833,
    longitude: 115.7167,
    accuracy: 1
  },
  {
    postalCode: 6966,
    city: "Kwinana",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2301,
    longitude: 115.7813,
    accuracy: 4
  },
  {
    postalCode: 6967,
    city: "Rockingham Dc",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2833,
    longitude: 115.7167,
    accuracy: 1
  },
  {
    postalCode: 6968,
    city: "Rockingham",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2768,
    longitude: 115.7298,
    accuracy: 4
  },
  {
    postalCode: 6969,
    city: "Rockingham Beach",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.2833,
    longitude: 115.7167,
    accuracy: 1
  },
  {
    postalCode: 6970,
    city: "Canning Vale Dc",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9919,
    longitude: 115.8645,
    accuracy: 1
  },
  {
    postalCode: 6979,
    city: "Victoria Park",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9762,
    longitude: 115.9052,
    accuracy: 4
  },
  {
    postalCode: 6980,
    city: "Cannington",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0167,
    longitude: 115.95,
    accuracy: 4
  },
  {
    postalCode: 6981,
    city: "East Victoria Park",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9889,
    longitude: 115.9039,
    accuracy: 4
  },
  {
    postalCode: 6982,
    city: "Bentley",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32,
    longitude: 115.9167,
    accuracy: 4
  },
  {
    postalCode: 6983,
    city: "Bentley Dc",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0048,
    longitude: 115.9411,
    accuracy: 1
  },
  {
    postalCode: 6984,
    city: "Belmont",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9435,
    longitude: 115.9255,
    accuracy: 4
  },
  {
    postalCode: 6985,
    city: "Cloverdale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -31.9628,
    longitude: 115.9443,
    accuracy: 4
  },
  {
    postalCode: 6986,
    city: "Welshpool Dc",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0048,
    longitude: 115.9411,
    accuracy: 1
  },
  {
    postalCode: 6987,
    city: "Cannington",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.0167,
    longitude: 115.95,
    accuracy: 4
  },
  {
    postalCode: 6988,
    city: "Thornlie",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.06,
    longitude: 115.955,
    accuracy: 4
  },
  {
    postalCode: 6989,
    city: "Maddington",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.05,
    longitude: 115.9833,
    accuracy: 4
  },
  {
    postalCode: 6990,
    city: "Gosnells",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.081,
    longitude: 116.0054,
    accuracy: 4
  },
  {
    postalCode: 6991,
    city: "Kelmscott",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1243,
    longitude: 116.0259,
    accuracy: 4
  },
  {
    postalCode: 6992,
    city: "Armadale",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1461,
    longitude: 116.0093,
    accuracy: 4
  },
  {
    postalCode: 6997,
    city: "Kelmscott Dc",
    state_name: "Western Australia",
    state: "WA",
    latitude: -32.1167,
    longitude: 116.0056,
    accuracy: 1
  }
        ];          
    }
};